(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree24f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree24f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("033rz", function(module, exports) {
$parcel$extendImportMap({
    "ez9Wz": "atkinson-hyperlegible-next-latin-400-normal.61627e05.woff2",
    "favaH": "atkinson-hyperlegible-next-latin-400-normal.74b3a7cf.woff",
    "KWWxJ": "atkinson-hyperlegible-next-latin-ext-400-normal.ca516a01.woff2",
    "eh3vC": "atkinson-hyperlegible-next-latin-ext-400-normal.94c8c42a.woff"
});

});

parcelRegister("iJKv7", function(module, exports) {
// The Panoramax viewer bundles its own Font Awesome and ships its styles in its shadow DOM:
// the <style> auto-injected in <head> is useless and blocked by our CSP (no nonce).
// Must run before the viewer is imported, as Font Awesome reads this global at load time.
window.FontAwesomeConfig = {
    autoAddCss: false
};

});

parcelRegister("9YUWX", function(module, exports) {
// Shared behaviour for the Panoramax bundles (panoramax.js and panoramaxPhoto.js).
// Must be imported after the viewer so its custom elements are defined.
// The viewer's CJS build declares its Atkinson Hyperlegible @font-face (adopted by the
// document) with absolute /fonts/ URLs, which we don't serve. Point them to the copies
// bundled by Parcel.




function $7445e4b9cacd04d8$var$fixPanoramaxFontUrls() {
    const PANORAMAX_FONTS = {
        'atkinson-hyperlegible-next-latin-400-normal.woff2': new URL((parcelRequire("ennuU"))),
        'atkinson-hyperlegible-next-latin-400-normal.woff': new URL((parcelRequire("eQsaR"))),
        'atkinson-hyperlegible-next-latin-ext-400-normal.woff2': new URL((parcelRequire("Tnrg7"))),
        'atkinson-hyperlegible-next-latin-ext-400-normal.woff': new URL((parcelRequire("1ntUo")))
    };
    document.adoptedStyleSheets.forEach((sheet)=>{
        Array.from(sheet.cssRules).forEach((rule, index)=>{
            if (!(rule instanceof CSSFontFaceRule) || !rule.cssText.includes('/fonts/')) return;
            const cssText = rule.cssText.replace(/url\("?\/fonts\/([^")]+)"?\)/g, (match, file)=>PANORAMAX_FONTS[file] ? `url("${PANORAMAX_FONTS[file]}")` : match);
            sheet.deleteRule(index);
            sheet.insertRule(cssText, index);
        });
    });
}
// Parcel only registers its asset URL manifest after the entry module has run, so the
// URLs above can't be resolved synchronously here. A microtask still runs before any
// rendering, so the browser never requests /fonts/.
queueMicrotask($7445e4b9cacd04d8$var$fixPanoramaxFontUrls);
document.addEventListener('DOMContentLoaded', ()=>{
    const browser = document.querySelector('pnx-viewer');
    const xyzField = document.getElementById('xyz-coords');
    const imageId = document.getElementById('image-id');
    // Panoramax 5.3.1 bug: with widgets="false" the viewer never creates its legend but
    // still reads this.legend.parentNode when focusing the picture, which aborts its init
    // and leaves the loader over the photo. Give it a detached placeholder legend.
    if (browser?.getAttribute('widgets') === 'false') browser.legend ??= document.createElement('span');
    if (browser && xyzField) {
        const updateXYZandImageID = (event)=>{
            const { x: x, y: y, z: z } = event.detail;
            const xyz = `${x}/${y}/${z}`;
            xyzField.value = xyz;
            imageId.value = browser.getAttribute('picture');
        };
        browser.addEventListener('psv:view-rotated', updateXYZandImageID);
        browser.addEventListener('psv:position-changed', updateXYZandImageID);
    }
    const viewer = document.querySelector('pnx-photo-viewer');
    if (viewer) {
        const xyz = viewer.getAttribute('xyz');
        viewer.addEventListener('psv:picture-loaded', ()=>{
            if (xyz) {
                const [x, y, z] = xyz.split('/').map(Number);
                viewer.psv.setXYZ(x, y, z);
            }
        });
    }
    $7445e4b9cacd04d8$var$enableKeyboardOnFocus();
    $7445e4b9cacd04d8$var$enhancePanoramaxLegendA11y();
});
// RGAA 12.x: the Panoramax viewer reacts to keyboard shortcuts via a window-level
// keydown listener gated by psv.state.keyboardEnabled. The component only flips
// that flag on mouse click / character keypress, so a keyboard-only user can
// never reach it. Make the host focusable and enable the shortcuts while it
// holds focus, disabling them on blur so they don't fire from elsewhere.
function $7445e4b9cacd04d8$var$enableKeyboardOnFocus() {
    // Keys the viewer consumes for navigation; prevent them from also scrolling
    // the page while the viewer holds focus.
    const SCROLL_KEYS = [
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'PageUp',
        'PageDown',
        'Home',
        'End',
        ' ',
        'Spacebar'
    ];
    document.querySelectorAll('pnx-photo-viewer, pnx-viewer').forEach((host)=>{
        host.setAttribute('tabindex', '0');
        host.addEventListener('focus', ()=>host.psv?.startKeyboardControl?.());
        host.addEventListener('blur', ()=>host.psv?.stopKeyboardControl?.());
        host.addEventListener('keydown', (event)=>{
            if (event.target !== host || !SCROLL_KEYS.includes(event.key)) return;
            host.psv?.startKeyboardControl?.();
            event.preventDefault();
        });
    });
}
// RGAA 6.1: the Panoramax legend (shadow DOM, third-party component) ships
// non-explicit links. Make their accessible names explicit and signal that
// they open in a new window. Re-applied on every Lit re-render via observers.
function $7445e4b9cacd04d8$var$enhancePanoramaxLegendA11y() {
    const legend = document.querySelector('pnx-widget-legend');
    if (!legend) return;
    // Lit re-renders the legend on every picture change, overwriting the title and
    // wiping any icon we appended. So enhancement must be idempotent and re-run
    // after each render. We watch with observers and mask our own writes (disconnect
    // while writing) to avoid a feedback loop, since setAttribute fires the observer
    // even when the value is unchanged.
    const rootObserver = new MutationObserver(()=>enhance());
    const pictureObserver = new MutationObserver(()=>enhance());
    const setExternalLink = (link, label, visibleText)=>{
        if (!link) return;
        link.setAttribute('title', `${label} - ${gettext("nouvelle fen\xeatre")}`);
        link.setAttribute('rel', 'noopener');
        // Replace the on-screen text when it isn't self-explanatory (e.g. the photo
        // link only shows the author name). The descriptive label stays in title.
        if (visibleText && link.firstChild?.textContent !== visibleText) link.textContent = visibleText;
        // Append the new-window indicator once; Lit drops it on re-render so we
        // re-add it whenever it is missing. The legend lives in a shadow root that
        // can't reach the DSFR icon font, so we reproduce DSFR's external-link icon
        // (remixicon external-link-line) as an inline SVG mask tinted to the link
        // colour — same box-with-arrow as fr-link[target="_blank"].
        if (!link.querySelector('[data-a11y-icon]')) {
            const svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L18.585 5H13V3h8z'/></svg>";
            const mask = `url("data:image/svg+xml,${encodeURIComponent(svg)}") no-repeat center / contain`;
            const icon = document.createElement('span');
            icon.setAttribute('aria-hidden', 'true');
            icon.setAttribute('data-a11y-icon', '');
            icon.style.cssText = [
                'display:inline-block',
                'width:1em',
                'height:1em',
                'margin-left:0.25em',
                'vertical-align:middle',
                'background-color:currentColor',
                `-webkit-mask:${mask}`,
                `mask:${mask}`
            ].join(';');
            link.appendChild(icon);
        }
    };
    const enhance = ()=>{
        const root = legend.shadowRoot;
        if (!root) return;
        rootObserver.disconnect();
        pictureObserver.disconnect();
        setExternalLink(root.querySelector('.presentation a[target="_blank"]'), gettext('Panoramax'));
        const pictureRoot = root.querySelector('pnx-picture-legend')?.shadowRoot;
        if (pictureRoot) {
            pictureRoot.querySelectorAll('a[target="_blank"]').forEach((link)=>{
                if (link.href.includes('/?pic=')) {
                    // Visible text becomes the author name; cache it on first pass so the
                    // descriptive title survives our own text replacement and re-renders.
                    const author = link.dataset.a11yAuthor || (link.dataset.a11yAuthor = link.textContent.trim());
                    setExternalLink(link, 'Voir sur Panoramax', gettext('Voir sur Panoramax'));
                } else {
                    const licence = link.textContent.replace("\u2197", '').trim();
                    setExternalLink(link, licence);
                }
            });
            pictureObserver.observe(pictureRoot, {
                childList: true,
                subtree: true
            });
        }
        rootObserver.observe(root, {
            childList: true,
            subtree: true
        });
    };
    const start = ()=>{
        if (!legend.shadowRoot) {
            requestAnimationFrame(start);
            return;
        }
        enhance();
    };
    start();
}

});
parcelRegister("ennuU", function(module, exports) {
module.exports = $parcel$resolve("ez9Wz");

});

parcelRegister("eQsaR", function(module, exports) {
module.exports = $parcel$resolve("favaH");

});

parcelRegister("Tnrg7", function(module, exports) {
module.exports = $parcel$resolve("KWWxJ");

});

parcelRegister("1ntUo", function(module, exports) {
module.exports = $parcel$resolve("eh3vC");

});


// Lightweight Panoramax build (<pnx-photo-viewer> and widgets, no map): used by the ERP page.
parcelRequire("iJKv7");
var $a42f1354f0348298$export$fe59e85e16b5f4fb;
var $a42f1354f0348298$export$9b5ac10f59f76296;
var $a42f1354f0348298$export$eab97d15b1788b8d;
"use strict";
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a42f1354f0348298$var$e = globalThis, $a42f1354f0348298$var$t = $a42f1354f0348298$var$e.ShadowRoot && (void 0 === $a42f1354f0348298$var$e.ShadyCSS || $a42f1354f0348298$var$e.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $a42f1354f0348298$var$i = Symbol(), $a42f1354f0348298$var$n = new WeakMap;
let $a42f1354f0348298$var$a = class {
    constructor(e, t, n){
        if (this._$cssResult$ = !0, n !== $a42f1354f0348298$var$i) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = e, this.t = t;
    }
    get styleSheet() {
        let e = this.o;
        const i = this.t;
        if ($a42f1354f0348298$var$t && void 0 === e) {
            const t = void 0 !== i && 1 === i.length;
            t && (e = $a42f1354f0348298$var$n.get(i)), void 0 === e && ((this.o = e = new CSSStyleSheet).replaceSync(this.cssText), t && $a42f1354f0348298$var$n.set(i, e));
        }
        return e;
    }
    toString() {
        return this.cssText;
    }
};
const $a42f1354f0348298$var$r = (e)=>new $a42f1354f0348298$var$a("string" == typeof e ? e : e + "", void 0, $a42f1354f0348298$var$i), $a42f1354f0348298$var$s = (e, ...t)=>{
    const n = 1 === e.length ? e[0] : t.reduce((t, i, n)=>t + ((e)=>{
            if (!0 === e._$cssResult$) return e.cssText;
            if ("number" == typeof e) return e;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + e + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(i) + e[n + 1], e[0]);
    return new $a42f1354f0348298$var$a(n, e, $a42f1354f0348298$var$i);
}, $a42f1354f0348298$var$o = $a42f1354f0348298$var$t ? (e)=>e : (e)=>e instanceof CSSStyleSheet ? ((e)=>{
        let t = "";
        for (const i of e.cssRules)t += i.cssText;
        return $a42f1354f0348298$var$r(t);
    })(e) : e, { is: $a42f1354f0348298$var$l, defineProperty: $a42f1354f0348298$var$c, getOwnPropertyDescriptor: $a42f1354f0348298$var$d, getOwnPropertyNames: $a42f1354f0348298$var$u, getOwnPropertySymbols: $a42f1354f0348298$var$h, getPrototypeOf: $a42f1354f0348298$var$p } = Object, $a42f1354f0348298$var$A = globalThis, $a42f1354f0348298$var$m = $a42f1354f0348298$var$A.trustedTypes, $a42f1354f0348298$var$g = $a42f1354f0348298$var$m ? $a42f1354f0348298$var$m.emptyScript : "", $a42f1354f0348298$var$f = $a42f1354f0348298$var$A.reactiveElementPolyfillSupport, $a42f1354f0348298$var$_ = (e, t)=>e, $a42f1354f0348298$var$v = {
    toAttribute (e, t) {
        switch(t){
            case Boolean:
                e = e ? $a42f1354f0348298$var$g : null;
                break;
            case Object:
            case Array:
                e = null == e ? e : JSON.stringify(e);
        }
        return e;
    },
    fromAttribute (e, t) {
        let i = e;
        switch(t){
            case Boolean:
                i = null !== e;
                break;
            case Number:
                i = null === e ? null : Number(e);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(e);
                } catch (e) {
                    i = null;
                }
        }
        return i;
    }
}, $a42f1354f0348298$var$E = (e, t)=>!$a42f1354f0348298$var$l(e, t), $a42f1354f0348298$var$y = {
    attribute: !0,
    type: String,
    converter: $a42f1354f0348298$var$v,
    reflect: !1,
    useDefault: !1,
    hasChanged: $a42f1354f0348298$var$E
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ Symbol.metadata ??= Symbol("metadata"), $a42f1354f0348298$var$A.litPropertyMetadata ??= new WeakMap;
let $a42f1354f0348298$var$b = class extends HTMLElement {
    static addInitializer(e) {
        this._$Ei(), (this.l ??= []).push(e);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(e, t = $a42f1354f0348298$var$y) {
        if (t.state && (t.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(e) && ((t = Object.create(t)).wrapped = !0), this.elementProperties.set(e, t), !t.noAccessor) {
            const i = Symbol(), n = this.getPropertyDescriptor(e, i, t);
            void 0 !== n && $a42f1354f0348298$var$c(this.prototype, e, n);
        }
    }
    static getPropertyDescriptor(e, t, i) {
        const { get: n, set: a } = $a42f1354f0348298$var$d(this.prototype, e) ?? {
            get () {
                return this[t];
            },
            set (e) {
                this[t] = e;
            }
        };
        return {
            get: n,
            set (t) {
                const r = n?.call(this);
                a?.call(this, t), this.requestUpdate(e, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(e) {
        return this.elementProperties.get(e) ?? $a42f1354f0348298$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($a42f1354f0348298$var$_("elementProperties"))) return;
        const e = $a42f1354f0348298$var$p(this);
        e.finalize(), void 0 !== e.l && (this.l = [
            ...e.l
        ]), this.elementProperties = new Map(e.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($a42f1354f0348298$var$_("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($a42f1354f0348298$var$_("properties"))) {
            const e = this.properties, t = [
                ...$a42f1354f0348298$var$u(e),
                ...$a42f1354f0348298$var$h(e)
            ];
            for (const i of t)this.createProperty(i, e[i]);
        }
        const e = this[Symbol.metadata];
        if (null !== e) {
            const t = litPropertyMetadata.get(e);
            if (void 0 !== t) for (const [e, i] of t)this.elementProperties.set(e, i);
        }
        this._$Eh = new Map;
        for (const [e, t] of this.elementProperties){
            const i = this._$Eu(e, t);
            void 0 !== i && this._$Eh.set(i, e);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(e) {
        const t = [];
        if (Array.isArray(e)) {
            const i = new Set(e.flat(1 / 0).reverse());
            for (const e of i)t.unshift($a42f1354f0348298$var$o(e));
        } else void 0 !== e && t.push($a42f1354f0348298$var$o(e));
        return t;
    }
    static _$Eu(e, t) {
        const i = t.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof e ? e.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((e)=>this.enableUpdating = e), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((e)=>e(this));
    }
    addController(e) {
        (this._$EO ??= new Set).add(e), void 0 !== this.renderRoot && this.isConnected && e.hostConnected?.();
    }
    removeController(e) {
        this._$EO?.delete(e);
    }
    _$E_() {
        const e = new Map, t = this.constructor.elementProperties;
        for (const i of t.keys())this.hasOwnProperty(i) && (e.set(i, this[i]), delete this[i]);
        e.size > 0 && (this._$Ep = e);
    }
    createRenderRoot() {
        const i = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return ((i, n)=>{
            if ($a42f1354f0348298$var$t) i.adoptedStyleSheets = n.map((e)=>e instanceof CSSStyleSheet ? e : e.styleSheet);
            else for (const t of n){
                const n = document.createElement("style"), a = $a42f1354f0348298$var$e.litNonce;
                void 0 !== a && n.setAttribute("nonce", a), n.textContent = t.cssText, i.appendChild(n);
            }
        })(i, this.constructor.elementStyles), i;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((e)=>e.hostConnected?.());
    }
    enableUpdating(e) {}
    disconnectedCallback() {
        this._$EO?.forEach((e)=>e.hostDisconnected?.());
    }
    attributeChangedCallback(e, t, i) {
        this._$AK(e, i);
    }
    _$ET(e, t) {
        const i = this.constructor.elementProperties.get(e), n = this.constructor._$Eu(e, i);
        if (void 0 !== n && !0 === i.reflect) {
            const a = (void 0 !== i.converter?.toAttribute ? i.converter : $a42f1354f0348298$var$v).toAttribute(t, i.type);
            this._$Em = e, null == a ? this.removeAttribute(n) : this.setAttribute(n, a), this._$Em = null;
        }
    }
    _$AK(e, t) {
        const i = this.constructor, n = i._$Eh.get(e);
        if (void 0 !== n && this._$Em !== n) {
            const e = i.getPropertyOptions(n), a = "function" == typeof e.converter ? {
                fromAttribute: e.converter
            } : void 0 !== e.converter?.fromAttribute ? e.converter : $a42f1354f0348298$var$v;
            this._$Em = n;
            const r = a.fromAttribute(t, e.type);
            this[n] = r ?? this._$Ej?.get(n) ?? r, this._$Em = null;
        }
    }
    requestUpdate(e, t, i, n = !1, a) {
        if (void 0 !== e) {
            const r = this.constructor;
            if (!1 === n && (a = this[e]), i ??= r.getPropertyOptions(e), !((i.hasChanged ?? $a42f1354f0348298$var$E)(a, t) || i.useDefault && i.reflect && a === this._$Ej?.get(e) && !this.hasAttribute(r._$Eu(e, i)))) return;
            this.C(e, t, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(e, t, { useDefault: i, reflect: n, wrapped: a }, r) {
        i && !(this._$Ej ??= new Map).has(e) && (this._$Ej.set(e, r ?? t ?? this[e]), !0 !== a || void 0 !== r) || (this._$AL.has(e) || (this.hasUpdated || i || (t = void 0), this._$AL.set(e, t)), !0 === n && this._$Em !== e && (this._$Eq ??= new Set).add(e));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (e) {
            Promise.reject(e);
        }
        const e = this.scheduleUpdate();
        return null != e && await e, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [e, t] of this._$Ep)this[e] = t;
                this._$Ep = void 0;
            }
            const e = this.constructor.elementProperties;
            if (e.size > 0) for (const [t, i] of e){
                const { wrapped: e } = i, n = this[t];
                !0 !== e || this._$AL.has(t) || void 0 === n || this.C(t, void 0, i, n);
            }
        }
        let e = !1;
        const t = this._$AL;
        try {
            e = this.shouldUpdate(t), e ? (this.willUpdate(t), this._$EO?.forEach((e)=>e.hostUpdate?.()), this.update(t)) : this._$EM();
        } catch (t) {
            throw e = !1, this._$EM(), t;
        }
        e && this._$AE(t);
    }
    willUpdate(e) {}
    _$AE(e) {
        this._$EO?.forEach((e)=>e.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(e) {
        return !0;
    }
    update(e) {
        this._$Eq &&= this._$Eq.forEach((e)=>this._$ET(e, this[e])), this._$EM();
    }
    updated(e) {}
    firstUpdated(e) {}
};
$a42f1354f0348298$var$b.elementStyles = [], $a42f1354f0348298$var$b.shadowRootOptions = {
    mode: "open"
}, $a42f1354f0348298$var$b[$a42f1354f0348298$var$_("elementProperties")] = new Map, $a42f1354f0348298$var$b[$a42f1354f0348298$var$_("finalized")] = new Map, $a42f1354f0348298$var$f?.({
    ReactiveElement: $a42f1354f0348298$var$b
}), ($a42f1354f0348298$var$A.reactiveElementVersions ??= []).push("2.1.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a42f1354f0348298$var$k = globalThis, $a42f1354f0348298$var$x = (e)=>e, $a42f1354f0348298$var$w = $a42f1354f0348298$var$k.trustedTypes, $a42f1354f0348298$var$M = $a42f1354f0348298$var$w ? $a42f1354f0348298$var$w.createPolicy("lit-html", {
    createHTML: (e)=>e
}) : void 0, $a42f1354f0348298$var$S = "$lit$", $a42f1354f0348298$var$C = `lit$${Math.random().toFixed(9).slice(2)}$`, $a42f1354f0348298$var$T = "?" + $a42f1354f0348298$var$C, $a42f1354f0348298$var$D = `<${$a42f1354f0348298$var$T}>`, $a42f1354f0348298$var$P = document, $a42f1354f0348298$var$I = ()=>$a42f1354f0348298$var$P.createComment(""), $a42f1354f0348298$var$L = (e)=>null === e || "object" != typeof e && "function" != typeof e, $a42f1354f0348298$var$R = Array.isArray, $a42f1354f0348298$var$z = "[ \t\n\f\r]", $a42f1354f0348298$var$F = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $a42f1354f0348298$var$U = /-->/g, $a42f1354f0348298$var$N = />/g, $a42f1354f0348298$var$B = RegExp(`>|${$a42f1354f0348298$var$z}(?:([^\\s"'>=/]+)(${$a42f1354f0348298$var$z}*=${$a42f1354f0348298$var$z}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $a42f1354f0348298$var$O = /'/g, $a42f1354f0348298$var$j = /"/g, $a42f1354f0348298$var$G = /^(?:script|style|textarea|title)$/i, $a42f1354f0348298$var$V = ((e)=>(t, ...i)=>({
            _$litType$: e,
            strings: t,
            values: i
        }))(1), $a42f1354f0348298$var$H = Symbol.for("lit-noChange"), $a42f1354f0348298$var$q = Symbol.for("lit-nothing"), $a42f1354f0348298$var$K = new WeakMap, $a42f1354f0348298$var$W = $a42f1354f0348298$var$P.createTreeWalker($a42f1354f0348298$var$P, 129);
function $a42f1354f0348298$var$X(e, t) {
    if (!$a42f1354f0348298$var$R(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $a42f1354f0348298$var$M ? $a42f1354f0348298$var$M.createHTML(t) : t;
}
const $a42f1354f0348298$var$Q = (e, t)=>{
    const i = e.length - 1, n = [];
    let a, r = 2 === t ? "<svg>" : 3 === t ? "<math>" : "", s = $a42f1354f0348298$var$F;
    for(let t = 0; t < i; t++){
        const i = e[t];
        let o, l, c = -1, d = 0;
        for(; d < i.length && (s.lastIndex = d, l = s.exec(i), null !== l);)d = s.lastIndex, s === $a42f1354f0348298$var$F ? "!--" === l[1] ? s = $a42f1354f0348298$var$U : void 0 !== l[1] ? s = $a42f1354f0348298$var$N : void 0 !== l[2] ? ($a42f1354f0348298$var$G.test(l[2]) && (a = RegExp("</" + l[2], "g")), s = $a42f1354f0348298$var$B) : void 0 !== l[3] && (s = $a42f1354f0348298$var$B) : s === $a42f1354f0348298$var$B ? ">" === l[0] ? (s = a ?? $a42f1354f0348298$var$F, c = -1) : void 0 === l[1] ? c = -2 : (c = s.lastIndex - l[2].length, o = l[1], s = void 0 === l[3] ? $a42f1354f0348298$var$B : '"' === l[3] ? $a42f1354f0348298$var$j : $a42f1354f0348298$var$O) : s === $a42f1354f0348298$var$j || s === $a42f1354f0348298$var$O ? s = $a42f1354f0348298$var$B : s === $a42f1354f0348298$var$U || s === $a42f1354f0348298$var$N ? s = $a42f1354f0348298$var$F : (s = $a42f1354f0348298$var$B, a = void 0);
        const u = s === $a42f1354f0348298$var$B && e[t + 1].startsWith("/>") ? " " : "";
        r += s === $a42f1354f0348298$var$F ? i + $a42f1354f0348298$var$D : c >= 0 ? (n.push(o), i.slice(0, c) + $a42f1354f0348298$var$S + i.slice(c) + $a42f1354f0348298$var$C + u) : i + $a42f1354f0348298$var$C + (-2 === c ? t : u);
    }
    return [
        $a42f1354f0348298$var$X(e, r + (e[i] || "<?>") + (2 === t ? "</svg>" : 3 === t ? "</math>" : "")),
        n
    ];
};
let $a42f1354f0348298$var$Z = class e {
    constructor({ strings: t, _$litType$: i }, n){
        let a;
        this.parts = [];
        let r = 0, s = 0;
        const o = t.length - 1, l = this.parts, [c, d] = $a42f1354f0348298$var$Q(t, i);
        if (this.el = e.createElement(c, n), $a42f1354f0348298$var$W.currentNode = this.el.content, 2 === i || 3 === i) {
            const e = this.el.content.firstChild;
            e.replaceWith(...e.childNodes);
        }
        for(; null !== (a = $a42f1354f0348298$var$W.nextNode()) && l.length < o;){
            if (1 === a.nodeType) {
                if (a.hasAttributes()) for (const e of a.getAttributeNames())if (e.endsWith($a42f1354f0348298$var$S)) {
                    const t = d[s++], i = a.getAttribute(e).split($a42f1354f0348298$var$C), n = /([.?@])?(.*)/.exec(t);
                    l.push({
                        type: 1,
                        index: r,
                        name: n[2],
                        strings: i,
                        ctor: "." === n[1] ? $a42f1354f0348298$var$te : "?" === n[1] ? $a42f1354f0348298$var$ie : "@" === n[1] ? $a42f1354f0348298$var$ne : $a42f1354f0348298$var$ee
                    }), a.removeAttribute(e);
                } else e.startsWith($a42f1354f0348298$var$C) && (l.push({
                    type: 6,
                    index: r
                }), a.removeAttribute(e));
                if ($a42f1354f0348298$var$G.test(a.tagName)) {
                    const e = a.textContent.split($a42f1354f0348298$var$C), t = e.length - 1;
                    if (t > 0) {
                        a.textContent = $a42f1354f0348298$var$w ? $a42f1354f0348298$var$w.emptyScript : "";
                        for(let i = 0; i < t; i++)a.append(e[i], $a42f1354f0348298$var$I()), $a42f1354f0348298$var$W.nextNode(), l.push({
                            type: 2,
                            index: ++r
                        });
                        a.append(e[t], $a42f1354f0348298$var$I());
                    }
                }
            } else if (8 === a.nodeType) {
                if (a.data === $a42f1354f0348298$var$T) l.push({
                    type: 2,
                    index: r
                });
                else {
                    let e = -1;
                    for(; -1 !== (e = a.data.indexOf($a42f1354f0348298$var$C, e + 1));)l.push({
                        type: 7,
                        index: r
                    }), e += $a42f1354f0348298$var$C.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(e, t) {
        const i = $a42f1354f0348298$var$P.createElement("template");
        return i.innerHTML = e, i;
    }
};
function $a42f1354f0348298$var$Y(e, t, i = e, n) {
    if (t === $a42f1354f0348298$var$H) return t;
    let a = void 0 !== n ? i._$Co?.[n] : i._$Cl;
    const r = $a42f1354f0348298$var$L(t) ? void 0 : t._$litDirective$;
    return a?.constructor !== r && (a?._$AO?.(!1), void 0 === r ? a = void 0 : (a = new r(e), a._$AT(e, i, n)), void 0 !== n ? (i._$Co ??= [])[n] = a : i._$Cl = a), void 0 !== a && (t = $a42f1354f0348298$var$Y(e, a._$AS(e, t.values), a, n)), t;
}
class $a42f1354f0348298$var$J {
    constructor(e, t){
        this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(e) {
        const { el: { content: t }, parts: i } = this._$AD, n = (e?.creationScope ?? $a42f1354f0348298$var$P).importNode(t, !0);
        $a42f1354f0348298$var$W.currentNode = n;
        let a = $a42f1354f0348298$var$W.nextNode(), r = 0, s = 0, o = i[0];
        for(; void 0 !== o;){
            if (r === o.index) {
                let t;
                2 === o.type ? t = new $a42f1354f0348298$var$$(a, a.nextSibling, this, e) : 1 === o.type ? t = new o.ctor(a, o.name, o.strings, this, e) : 6 === o.type && (t = new $a42f1354f0348298$var$ae(a, this, e)), this._$AV.push(t), o = i[++s];
            }
            r !== o?.index && (a = $a42f1354f0348298$var$W.nextNode(), r++);
        }
        return $a42f1354f0348298$var$W.currentNode = $a42f1354f0348298$var$P, n;
    }
    p(e) {
        let t = 0;
        for (const i of this._$AV)void 0 !== i && (void 0 !== i.strings ? (i._$AI(e, i, t), t += i.strings.length - 2) : i._$AI(e[t])), t++;
    }
}
class $a42f1354f0348298$var$$ {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(e, t, i, n){
        this.type = 2, this._$AH = $a42f1354f0348298$var$q, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = i, this.options = n, this._$Cv = n?.isConnected ?? !0;
    }
    get parentNode() {
        let e = this._$AA.parentNode;
        const t = this._$AM;
        return void 0 !== t && 11 === e?.nodeType && (e = t.parentNode), e;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(e, t = this) {
        e = $a42f1354f0348298$var$Y(this, e, t), $a42f1354f0348298$var$L(e) ? e === $a42f1354f0348298$var$q || null == e || "" === e ? (this._$AH !== $a42f1354f0348298$var$q && this._$AR(), this._$AH = $a42f1354f0348298$var$q) : e !== this._$AH && e !== $a42f1354f0348298$var$H && this._(e) : void 0 !== e._$litType$ ? this.$(e) : void 0 !== e.nodeType ? this.T(e) : ((e)=>$a42f1354f0348298$var$R(e) || "function" == typeof e?.[Symbol.iterator])(e) ? this.k(e) : this._(e);
    }
    O(e) {
        return this._$AA.parentNode.insertBefore(e, this._$AB);
    }
    T(e) {
        this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
    }
    _(e) {
        this._$AH !== $a42f1354f0348298$var$q && $a42f1354f0348298$var$L(this._$AH) ? this._$AA.nextSibling.data = e : this.T($a42f1354f0348298$var$P.createTextNode(e)), this._$AH = e;
    }
    $(e) {
        const { values: t, _$litType$: i } = e, n = "number" == typeof i ? this._$AC(e) : (void 0 === i.el && (i.el = $a42f1354f0348298$var$Z.createElement($a42f1354f0348298$var$X(i.h, i.h[0]), this.options)), i);
        if (this._$AH?._$AD === n) this._$AH.p(t);
        else {
            const e = new $a42f1354f0348298$var$J(n, this), i = e.u(this.options);
            e.p(t), this.T(i), this._$AH = e;
        }
    }
    _$AC(e) {
        let t = $a42f1354f0348298$var$K.get(e.strings);
        return void 0 === t && $a42f1354f0348298$var$K.set(e.strings, t = new $a42f1354f0348298$var$Z(e)), t;
    }
    k(e) {
        $a42f1354f0348298$var$R(this._$AH) || (this._$AH = [], this._$AR());
        const t = this._$AH;
        let i, n = 0;
        for (const a of e)n === t.length ? t.push(i = new $a42f1354f0348298$var$$(this.O($a42f1354f0348298$var$I()), this.O($a42f1354f0348298$var$I()), this, this.options)) : i = t[n], i._$AI(a), n++;
        n < t.length && (this._$AR(i && i._$AB.nextSibling, n), t.length = n);
    }
    _$AR(e = this._$AA.nextSibling, t) {
        for(this._$AP?.(!1, !0, t); e !== this._$AB;){
            const t = $a42f1354f0348298$var$x(e).nextSibling;
            $a42f1354f0348298$var$x(e).remove(), e = t;
        }
    }
    setConnected(e) {
        void 0 === this._$AM && (this._$Cv = e, this._$AP?.(e));
    }
}
class $a42f1354f0348298$var$ee {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(e, t, i, n, a){
        this.type = 1, this._$AH = $a42f1354f0348298$var$q, this._$AN = void 0, this.element = e, this.name = t, this._$AM = n, this.options = a, i.length > 2 || "" !== i[0] || "" !== i[1] ? (this._$AH = Array(i.length - 1).fill(new String), this.strings = i) : this._$AH = $a42f1354f0348298$var$q;
    }
    _$AI(e, t = this, i, n) {
        const a = this.strings;
        let r = !1;
        if (void 0 === a) e = $a42f1354f0348298$var$Y(this, e, t, 0), r = !$a42f1354f0348298$var$L(e) || e !== this._$AH && e !== $a42f1354f0348298$var$H, r && (this._$AH = e);
        else {
            const n = e;
            let s, o;
            for(e = a[0], s = 0; s < a.length - 1; s++)o = $a42f1354f0348298$var$Y(this, n[i + s], t, s), o === $a42f1354f0348298$var$H && (o = this._$AH[s]), r ||= !$a42f1354f0348298$var$L(o) || o !== this._$AH[s], o === $a42f1354f0348298$var$q ? e = $a42f1354f0348298$var$q : e !== $a42f1354f0348298$var$q && (e += (o ?? "") + a[s + 1]), this._$AH[s] = o;
        }
        r && !n && this.j(e);
    }
    j(e) {
        e === $a42f1354f0348298$var$q ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
    }
}
class $a42f1354f0348298$var$te extends $a42f1354f0348298$var$ee {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(e) {
        this.element[this.name] = e === $a42f1354f0348298$var$q ? void 0 : e;
    }
}
let $a42f1354f0348298$var$ie = class extends $a42f1354f0348298$var$ee {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(e) {
        this.element.toggleAttribute(this.name, !!e && e !== $a42f1354f0348298$var$q);
    }
};
class $a42f1354f0348298$var$ne extends $a42f1354f0348298$var$ee {
    constructor(e, t, i, n, a){
        super(e, t, i, n, a), this.type = 5;
    }
    _$AI(e, t = this) {
        if ((e = $a42f1354f0348298$var$Y(this, e, t, 0) ?? $a42f1354f0348298$var$q) === $a42f1354f0348298$var$H) return;
        const i = this._$AH, n = e === $a42f1354f0348298$var$q && i !== $a42f1354f0348298$var$q || e.capture !== i.capture || e.once !== i.once || e.passive !== i.passive, a = e !== $a42f1354f0348298$var$q && (i === $a42f1354f0348298$var$q || n);
        n && this.element.removeEventListener(this.name, this, i), a && this.element.addEventListener(this.name, this, e), this._$AH = e;
    }
    handleEvent(e) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, e) : this._$AH.handleEvent(e);
    }
}
class $a42f1354f0348298$var$ae {
    constructor(e, t, i){
        this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = i;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(e) {
        $a42f1354f0348298$var$Y(this, e);
    }
}
const $a42f1354f0348298$var$re = $a42f1354f0348298$var$k.litHtmlPolyfillSupport;
$a42f1354f0348298$var$re?.($a42f1354f0348298$var$Z, $a42f1354f0348298$var$$), ($a42f1354f0348298$var$k.litHtmlVersions ??= []).push("3.3.3");
const $a42f1354f0348298$var$se = (e, t, i)=>{
    const n = i?.renderBefore ?? t;
    let a = n._$litPart$;
    if (void 0 === a) {
        const e = i?.renderBefore ?? null;
        n._$litPart$ = a = new $a42f1354f0348298$var$$(t.insertBefore($a42f1354f0348298$var$I(), e), e, void 0, i ?? {});
    }
    return a._$AI(e), a;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ }, $a42f1354f0348298$var$oe = globalThis;
let $a42f1354f0348298$var$le = class extends $a42f1354f0348298$var$b {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const e = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= e.firstChild, e;
    }
    update(e) {
        const t = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = $a42f1354f0348298$var$se(t, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return $a42f1354f0348298$var$H;
    }
};
$a42f1354f0348298$var$le._$litElement$ = !0, $a42f1354f0348298$var$le.finalized = !0, $a42f1354f0348298$var$oe.litElementHydrateSupport?.({
    LitElement: $a42f1354f0348298$var$le
});
const $a42f1354f0348298$var$ce = $a42f1354f0348298$var$oe.litElementPolyfillSupport;
$a42f1354f0348298$var$ce?.({
    LitElement: $a42f1354f0348298$var$le
}), ($a42f1354f0348298$var$oe.litElementVersions ??= []).push("4.2.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a42f1354f0348298$var$de = 1;
class $a42f1354f0348298$var$ue {
    constructor(e){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(e, t, i) {
        this._$Ct = e, this._$AM = t, this._$Ci = i;
    }
    _$AS(e, t) {
        return this.update(e, t);
    }
    update(e, t) {
        return this.render(...t);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a42f1354f0348298$var$he = ((e)=>(...t)=>({
            _$litDirective$: e,
            values: t
        }))(class extends $a42f1354f0348298$var$ue {
    constructor(e){
        if (super(e), e.type !== $a42f1354f0348298$var$de || "class" !== e.name || e.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(e) {
        return " " + Object.keys(e).filter((t)=>e[t]).join(" ") + " ";
    }
    update(e, [t]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== e.strings && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((e)=>"" !== e)));
            for(const e in t)t[e] && !this.nt?.has(e) && this.st.add(e);
            return this.render(t);
        }
        const i = e.element.classList;
        for (const e of this.st)e in t || (i.remove(e), this.st.delete(e));
        for(const e in t){
            const n = !!t[e];
            n === this.st.has(e) || this.nt?.has(e) || (n ? (i.add(e), this.st.add(e)) : (i.remove(e), this.st.delete(e)));
        }
        return $a42f1354f0348298$var$H;
    }
});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function $a42f1354f0348298$var$pe(e, t, i) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
                var n = i.call(e, t);
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = i, e;
}
function $a42f1354f0348298$var$Ae(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), i.push.apply(i, n);
    }
    return i;
}
function $a42f1354f0348298$var$me(e) {
    for(var t = 1; t < arguments.length; t++){
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $a42f1354f0348298$var$Ae(Object(i), !0).forEach(function(t) {
            $a42f1354f0348298$var$pe(e, t, i[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : $a42f1354f0348298$var$Ae(Object(i)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
        });
    }
    return e;
}
const $a42f1354f0348298$var$ge = ()=>{};
let $a42f1354f0348298$var$fe = {}, $a42f1354f0348298$var$_e = {}, $a42f1354f0348298$var$ve = null, $a42f1354f0348298$var$Ee = {
    mark: $a42f1354f0348298$var$ge,
    measure: $a42f1354f0348298$var$ge
};
try {
    "undefined" != typeof window && ($a42f1354f0348298$var$fe = window), "undefined" != typeof document && ($a42f1354f0348298$var$_e = document), "undefined" != typeof MutationObserver && ($a42f1354f0348298$var$ve = MutationObserver), "undefined" != typeof performance && ($a42f1354f0348298$var$Ee = performance);
} catch (he) {}
const { userAgent: $a42f1354f0348298$var$ye = "" } = $a42f1354f0348298$var$fe.navigator || {}, $a42f1354f0348298$var$be = $a42f1354f0348298$var$fe, $a42f1354f0348298$var$ke = $a42f1354f0348298$var$_e, $a42f1354f0348298$var$xe = $a42f1354f0348298$var$ve, $a42f1354f0348298$var$we = $a42f1354f0348298$var$Ee;
$a42f1354f0348298$var$be.document;
const $a42f1354f0348298$var$Me = !!$a42f1354f0348298$var$ke.documentElement && !!$a42f1354f0348298$var$ke.head && "function" == typeof $a42f1354f0348298$var$ke.addEventListener && "function" == typeof $a42f1354f0348298$var$ke.createElement, $a42f1354f0348298$var$Se = ~$a42f1354f0348298$var$ye.indexOf("MSIE") || ~$a42f1354f0348298$var$ye.indexOf("Trident/");
var $a42f1354f0348298$var$Ce = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    }
}, $a42f1354f0348298$var$Te = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
], $a42f1354f0348298$var$De = "classic", $a42f1354f0348298$var$Pe = "duotone", $a42f1354f0348298$var$Ie = [
    $a42f1354f0348298$var$De,
    $a42f1354f0348298$var$Pe,
    "sharp",
    "sharp-duotone"
], $a42f1354f0348298$var$Le = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ]
]), $a42f1354f0348298$var$Re = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $a42f1354f0348298$var$ze = {
    fak: "kit",
    "fa-kit": "kit"
}, $a42f1354f0348298$var$Fe = {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
}, $a42f1354f0348298$var$Ue = [
    "fak",
    "fakd"
], $a42f1354f0348298$var$Ne = {
    kit: "fak"
}, $a42f1354f0348298$var$Be = {
    "kit-duotone": "fakd"
}, $a42f1354f0348298$var$Oe = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $a42f1354f0348298$var$je = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $a42f1354f0348298$var$Ge = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    }
}, $a42f1354f0348298$var$Ve = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands"
], $a42f1354f0348298$var$He = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $a42f1354f0348298$var$qe = $a42f1354f0348298$var$He.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $a42f1354f0348298$var$Ke = [
    ...Object.keys({
        classic: [
            "fas",
            "far",
            "fal",
            "fat",
            "fad"
        ],
        duotone: [
            "fadr",
            "fadl",
            "fadt"
        ],
        sharp: [
            "fass",
            "fasr",
            "fasl",
            "fast"
        ],
        "sharp-duotone": [
            "fasds",
            "fasdr",
            "fasdl",
            "fasdt"
        ]
    }),
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands",
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $a42f1354f0348298$var$Oe.GROUP,
    $a42f1354f0348298$var$Oe.SWAP_OPACITY,
    $a42f1354f0348298$var$Oe.PRIMARY,
    $a42f1354f0348298$var$Oe.SECONDARY
].concat($a42f1354f0348298$var$He.map((e)=>"".concat(e, "x"))).concat($a42f1354f0348298$var$qe.map((e)=>"w-".concat(e)));
const $a42f1354f0348298$var$We = "___FONT_AWESOME___", $a42f1354f0348298$var$Xe = 16, $a42f1354f0348298$var$Qe = "svg-inline--fa", $a42f1354f0348298$var$Ze = "data-fa-i2svg", $a42f1354f0348298$var$Ye = "data-fa-pseudo-element", $a42f1354f0348298$var$Je = "data-prefix", $a42f1354f0348298$var$$e = "data-icon", $a42f1354f0348298$var$et = "fontawesome-i2svg", $a42f1354f0348298$var$tt = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
], $a42f1354f0348298$var$it = (()=>{
    try {
        return true;
    } catch (e) {
        return !1;
    }
})();
function $a42f1354f0348298$var$nt(e) {
    return new Proxy(e, {
        get: (e, t)=>t in e ? e[t] : e[$a42f1354f0348298$var$De]
    });
}
const $a42f1354f0348298$var$at = $a42f1354f0348298$var$me({}, $a42f1354f0348298$var$Ce);
$a42f1354f0348298$var$at[$a42f1354f0348298$var$De] = $a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, {
    "fa-duotone": "duotone"
}), $a42f1354f0348298$var$Ce[$a42f1354f0348298$var$De]), $a42f1354f0348298$var$ze), $a42f1354f0348298$var$Fe);
const $a42f1354f0348298$var$rt = $a42f1354f0348298$var$nt($a42f1354f0348298$var$at), $a42f1354f0348298$var$st = $a42f1354f0348298$var$me({}, {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
    },
    duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
    }
});
$a42f1354f0348298$var$st[$a42f1354f0348298$var$De] = $a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, {
    duotone: "fad"
}), $a42f1354f0348298$var$st[$a42f1354f0348298$var$De]), $a42f1354f0348298$var$Ne), $a42f1354f0348298$var$Be);
const $a42f1354f0348298$var$ot = $a42f1354f0348298$var$nt($a42f1354f0348298$var$st), $a42f1354f0348298$var$lt = $a42f1354f0348298$var$me({}, $a42f1354f0348298$var$Ge);
$a42f1354f0348298$var$lt[$a42f1354f0348298$var$De] = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$lt[$a42f1354f0348298$var$De]), {
    fak: "fa-kit"
});
const $a42f1354f0348298$var$ct = $a42f1354f0348298$var$nt($a42f1354f0348298$var$lt), $a42f1354f0348298$var$dt = $a42f1354f0348298$var$me({}, {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    }
});
$a42f1354f0348298$var$dt[$a42f1354f0348298$var$De] = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$dt[$a42f1354f0348298$var$De]), {
    "fa-kit": "fak"
}), $a42f1354f0348298$var$nt($a42f1354f0348298$var$dt);
const $a42f1354f0348298$var$ut = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $a42f1354f0348298$var$ht = "fa-layers-text", $a42f1354f0348298$var$pt = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
$a42f1354f0348298$var$nt($a42f1354f0348298$var$me({}, {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
}));
const $a42f1354f0348298$var$At = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
], $a42f1354f0348298$var$mt = {
    GROUP: "duotone-group",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $a42f1354f0348298$var$gt = [
    "kit",
    ...$a42f1354f0348298$var$Ke
], $a42f1354f0348298$var$ft = $a42f1354f0348298$var$be.FontAwesomeConfig || {};
if ($a42f1354f0348298$var$ke && "function" == typeof $a42f1354f0348298$var$ke.querySelector) [
    [
        "data-family-prefix",
        "familyPrefix"
    ],
    [
        "data-css-prefix",
        "cssPrefix"
    ],
    [
        "data-family-default",
        "familyDefault"
    ],
    [
        "data-style-default",
        "styleDefault"
    ],
    [
        "data-replacement-class",
        "replacementClass"
    ],
    [
        "data-auto-replace-svg",
        "autoReplaceSvg"
    ],
    [
        "data-auto-add-css",
        "autoAddCss"
    ],
    [
        "data-auto-a11y",
        "autoA11y"
    ],
    [
        "data-search-pseudo-elements",
        "searchPseudoElements"
    ],
    [
        "data-observe-mutations",
        "observeMutations"
    ],
    [
        "data-mutate-approach",
        "mutateApproach"
    ],
    [
        "data-keep-original-source",
        "keepOriginalSource"
    ],
    [
        "data-measure-performance",
        "measurePerformance"
    ],
    [
        "data-show-missing-icons",
        "showMissingIcons"
    ]
].forEach((e)=>{
    let [t, i] = e;
    const n = function(e) {
        return "" === e || "false" !== e && ("true" === e || e);
    }(function(e) {
        var t = $a42f1354f0348298$var$ke.querySelector("script[" + e + "]");
        if (t) return t.getAttribute(e);
    }(t));
    null != n && ($a42f1354f0348298$var$ft[i] = n);
});
const $a42f1354f0348298$var$_t = {
    styleDefault: "solid",
    familyDefault: $a42f1354f0348298$var$De,
    cssPrefix: "fa",
    replacementClass: $a42f1354f0348298$var$Qe,
    autoReplaceSvg: !0,
    autoAddCss: !0,
    autoA11y: !0,
    searchPseudoElements: !1,
    observeMutations: !0,
    mutateApproach: "async",
    keepOriginalSource: !0,
    measurePerformance: !1,
    showMissingIcons: !0
};
$a42f1354f0348298$var$ft.familyPrefix && ($a42f1354f0348298$var$ft.cssPrefix = $a42f1354f0348298$var$ft.familyPrefix);
const $a42f1354f0348298$var$vt = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$_t), $a42f1354f0348298$var$ft);
$a42f1354f0348298$var$vt.autoReplaceSvg || ($a42f1354f0348298$var$vt.observeMutations = !1);
const $a42f1354f0348298$var$Et = {};
Object.keys($a42f1354f0348298$var$_t).forEach((e)=>{
    Object.defineProperty($a42f1354f0348298$var$Et, e, {
        enumerable: !0,
        set: function(t) {
            $a42f1354f0348298$var$vt[e] = t, $a42f1354f0348298$var$yt.forEach((e)=>e($a42f1354f0348298$var$Et));
        },
        get: function() {
            return $a42f1354f0348298$var$vt[e];
        }
    });
}), Object.defineProperty($a42f1354f0348298$var$Et, "familyPrefix", {
    enumerable: !0,
    set: function(e) {
        $a42f1354f0348298$var$vt.cssPrefix = e, $a42f1354f0348298$var$yt.forEach((e)=>e($a42f1354f0348298$var$Et));
    },
    get: function() {
        return $a42f1354f0348298$var$vt.cssPrefix;
    }
}), $a42f1354f0348298$var$be.FontAwesomeConfig = $a42f1354f0348298$var$Et;
const $a42f1354f0348298$var$yt = [];
const $a42f1354f0348298$var$bt = $a42f1354f0348298$var$Xe, $a42f1354f0348298$var$kt = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: !1,
    flipY: !1
};
function $a42f1354f0348298$var$xt() {
    let e = 12, t = "";
    for(; e-- > 0;)t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
    return t;
}
function $a42f1354f0348298$var$wt(e) {
    const t = [];
    for(let i = (e || []).length >>> 0; i--;)t[i] = e[i];
    return t;
}
function $a42f1354f0348298$var$Mt(e) {
    return e.classList ? $a42f1354f0348298$var$wt(e.classList) : (e.getAttribute("class") || "").split(" ").filter((e)=>e);
}
function $a42f1354f0348298$var$St(e) {
    return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $a42f1354f0348298$var$Ct(e) {
    return Object.keys(e || {}).reduce((t, i)=>t + "".concat(i, ": ").concat(e[i].trim(), ";"), "");
}
function $a42f1354f0348298$var$Tt(e) {
    return e.size !== $a42f1354f0348298$var$kt.size || e.x !== $a42f1354f0348298$var$kt.x || e.y !== $a42f1354f0348298$var$kt.y || e.rotate !== $a42f1354f0348298$var$kt.rotate || e.flipX || e.flipY;
}
function $a42f1354f0348298$var$Dt() {
    const e = "fa", t = $a42f1354f0348298$var$Qe, i = $a42f1354f0348298$var$Et.cssPrefix, n = $a42f1354f0348298$var$Et.replacementClass;
    let a = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}';
    if (i !== e || n !== t) {
        const r = new RegExp("\\.".concat(e, "\\-"), "g"), s = new RegExp("\\--".concat(e, "\\-"), "g"), o = new RegExp("\\.".concat(t), "g");
        a = a.replace(r, ".".concat(i, "-")).replace(s, "--".concat(i, "-")).replace(o, ".".concat(n));
    }
    return a;
}
let $a42f1354f0348298$var$Pt = !1;
function $a42f1354f0348298$var$It() {
    $a42f1354f0348298$var$Et.autoAddCss && !$a42f1354f0348298$var$Pt && (!function(e) {
        if (!e || !$a42f1354f0348298$var$Me) return;
        const t = $a42f1354f0348298$var$ke.createElement("style");
        t.setAttribute("type", "text/css"), t.innerHTML = e;
        const i = $a42f1354f0348298$var$ke.head.childNodes;
        let n = null;
        for(let e = i.length - 1; e > -1; e--){
            const t = i[e], a = (t.tagName || "").toUpperCase();
            [
                "STYLE",
                "LINK"
            ].indexOf(a) > -1 && (n = t);
        }
        $a42f1354f0348298$var$ke.head.insertBefore(t, n);
    }($a42f1354f0348298$var$Dt()), $a42f1354f0348298$var$Pt = !0);
}
var $a42f1354f0348298$var$Lt = {
    mixout: ()=>({
            dom: {
                css: $a42f1354f0348298$var$Dt,
                insertCss: $a42f1354f0348298$var$It
            }
        }),
    hooks: ()=>({
            beforeDOMElementCreation () {
                $a42f1354f0348298$var$It();
            },
            beforeI2svg () {
                $a42f1354f0348298$var$It();
            }
        })
};
const $a42f1354f0348298$var$Rt = $a42f1354f0348298$var$be || {};
$a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We] || ($a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We] = {}), $a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We].styles || ($a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We].styles = {}), $a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We].hooks || ($a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We].hooks = {}), $a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We].shims || ($a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We].shims = []);
var $a42f1354f0348298$var$zt = $a42f1354f0348298$var$Rt[$a42f1354f0348298$var$We];
const $a42f1354f0348298$var$Ft = [], $a42f1354f0348298$var$Ut = function() {
    $a42f1354f0348298$var$ke.removeEventListener("DOMContentLoaded", $a42f1354f0348298$var$Ut), $a42f1354f0348298$var$Nt = 1, $a42f1354f0348298$var$Ft.map((e)=>e());
};
let $a42f1354f0348298$var$Nt = !1;
function $a42f1354f0348298$var$Bt(e) {
    const { tag: t, attributes: i = {}, children: n = [] } = e;
    return "string" == typeof e ? $a42f1354f0348298$var$St(e) : "<".concat(t, " ").concat(function(e) {
        return Object.keys(e || {}).reduce((t, i)=>t + "".concat(i, '="').concat($a42f1354f0348298$var$St(e[i]), '" '), "").trim();
    }(i), ">").concat(n.map($a42f1354f0348298$var$Bt).join(""), "</").concat(t, ">");
}
function $a42f1354f0348298$var$Ot(e, t, i) {
    if (e && e[t] && e[t][i]) return {
        prefix: t,
        iconName: i,
        icon: e[t][i]
    };
}
$a42f1354f0348298$var$Me && ($a42f1354f0348298$var$Nt = ($a42f1354f0348298$var$ke.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($a42f1354f0348298$var$ke.readyState), $a42f1354f0348298$var$Nt || $a42f1354f0348298$var$ke.addEventListener("DOMContentLoaded", $a42f1354f0348298$var$Ut));
var $a42f1354f0348298$var$jt = function(e, t, i, n) {
    var a, r, s, o = Object.keys(e), l = o.length, c = t;
    for(void 0 === i ? (a = 1, s = e[o[0]]) : (a = 0, s = i); a < l; a++)s = c(s, e[r = o[a]], r, e);
    return s;
};
function $a42f1354f0348298$var$Gt(e) {
    const t = function(e) {
        const t = [];
        let i = 0;
        const n = e.length;
        for(; i < n;){
            const a = e.charCodeAt(i++);
            if (a >= 55296 && a <= 56319 && i < n) {
                const n = e.charCodeAt(i++);
                56320 == (64512 & n) ? t.push(((1023 & a) << 10) + (1023 & n) + 65536) : (t.push(a), i--);
            } else t.push(a);
        }
        return t;
    }(e);
    return 1 === t.length ? t[0].toString(16) : null;
}
function $a42f1354f0348298$var$Vt(e) {
    return Object.keys(e).reduce((t, i)=>{
        const n = e[i];
        return !!n.icon ? t[n.iconName] = n.icon : t[i] = n, t;
    }, {});
}
function $a42f1354f0348298$var$Ht(e, t) {
    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    const { skipHooks: n = !1 } = i, a = $a42f1354f0348298$var$Vt(t);
    "function" != typeof $a42f1354f0348298$var$zt.hooks.addPack || n ? $a42f1354f0348298$var$zt.styles[e] = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$zt.styles[e] || {}), a) : $a42f1354f0348298$var$zt.hooks.addPack(e, $a42f1354f0348298$var$Vt(t)), "fas" === e && $a42f1354f0348298$var$Ht("fa", t);
}
const { styles: $a42f1354f0348298$var$qt, shims: $a42f1354f0348298$var$Kt } = $a42f1354f0348298$var$zt, $a42f1354f0348298$var$Wt = Object.keys($a42f1354f0348298$var$ct), $a42f1354f0348298$var$Xt = $a42f1354f0348298$var$Wt.reduce((e, t)=>(e[t] = Object.keys($a42f1354f0348298$var$ct[t]), e), {});
let $a42f1354f0348298$var$Qt = null, $a42f1354f0348298$var$Zt = {}, $a42f1354f0348298$var$Yt = {}, $a42f1354f0348298$var$Jt = {}, $a42f1354f0348298$var$$t = {}, $a42f1354f0348298$var$ei = {};
function $a42f1354f0348298$var$ti(e, t) {
    const i = t.split("-"), n = i[0], a = i.slice(1).join("-");
    var r;
    return n !== e || "" === a || (r = a, ~$a42f1354f0348298$var$gt.indexOf(r)) ? null : a;
}
const $a42f1354f0348298$var$ii = ()=>{
    const e = (e)=>$a42f1354f0348298$var$jt($a42f1354f0348298$var$qt, (t, i, n)=>(t[n] = $a42f1354f0348298$var$jt(i, e, {}), t), {});
    $a42f1354f0348298$var$Zt = e((e, t, i)=>{
        if (t[3] && (e[t[3]] = i), t[2]) t[2].filter((e)=>"number" == typeof e).forEach((t)=>{
            e[t.toString(16)] = i;
        });
        return e;
    }), $a42f1354f0348298$var$Yt = e((e, t, i)=>{
        if (e[i] = i, t[2]) t[2].filter((e)=>"string" == typeof e).forEach((t)=>{
            e[t] = i;
        });
        return e;
    }), $a42f1354f0348298$var$ei = e((e, t, i)=>{
        const n = t[2];
        return e[i] = i, n.forEach((t)=>{
            e[t] = i;
        }), e;
    });
    const t = "far" in $a42f1354f0348298$var$qt || $a42f1354f0348298$var$Et.autoFetchSvg, i = $a42f1354f0348298$var$jt($a42f1354f0348298$var$Kt, (e, i)=>{
        const n = i[0];
        let a = i[1];
        const r = i[2];
        return "far" !== a || t || (a = "fas"), "string" == typeof n && (e.names[n] = {
            prefix: a,
            iconName: r
        }), "number" == typeof n && (e.unicodes[n.toString(16)] = {
            prefix: a,
            iconName: r
        }), e;
    }, {
        names: {},
        unicodes: {}
    });
    $a42f1354f0348298$var$Jt = i.names, $a42f1354f0348298$var$$t = i.unicodes, $a42f1354f0348298$var$Qt = $a42f1354f0348298$var$li($a42f1354f0348298$var$Et.styleDefault, {
        family: $a42f1354f0348298$var$Et.familyDefault
    });
};
var $a42f1354f0348298$var$ni;
function $a42f1354f0348298$var$ai(e, t) {
    return ($a42f1354f0348298$var$Zt[e] || {})[t];
}
function $a42f1354f0348298$var$ri(e, t) {
    return ($a42f1354f0348298$var$ei[e] || {})[t];
}
function $a42f1354f0348298$var$si(e) {
    return $a42f1354f0348298$var$Jt[e] || {
        prefix: null,
        iconName: null
    };
}
function $a42f1354f0348298$var$oi() {
    return $a42f1354f0348298$var$Qt;
}
$a42f1354f0348298$var$ni = (e)=>{
    $a42f1354f0348298$var$Qt = $a42f1354f0348298$var$li(e.styleDefault, {
        family: $a42f1354f0348298$var$Et.familyDefault
    });
}, $a42f1354f0348298$var$yt.push($a42f1354f0348298$var$ni), $a42f1354f0348298$var$ii();
function $a42f1354f0348298$var$li(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { family: i = $a42f1354f0348298$var$De } = t, n = $a42f1354f0348298$var$rt[i][e];
    if (i === $a42f1354f0348298$var$Pe && !e) return "fad";
    const a = $a42f1354f0348298$var$ot[i][e] || $a42f1354f0348298$var$ot[i][n], r = e in $a42f1354f0348298$var$zt.styles ? e : null;
    return a || r || null;
}
function $a42f1354f0348298$var$ci(e) {
    return e.sort().filter((e, t, i)=>i.indexOf(e) === t);
}
function $a42f1354f0348298$var$di(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { skipLookups: i = !1 } = t;
    let n = null;
    const a = $a42f1354f0348298$var$Ve.concat($a42f1354f0348298$var$je), r = $a42f1354f0348298$var$ci(e.filter((e)=>a.includes(e))), s = $a42f1354f0348298$var$ci(e.filter((e)=>!$a42f1354f0348298$var$Ve.includes(e))), o = r.filter((e)=>(n = e, !$a42f1354f0348298$var$Te.includes(e))), [l = null] = o, c = function(e) {
        let t = $a42f1354f0348298$var$De;
        const i = $a42f1354f0348298$var$Wt.reduce((e, t)=>(e[t] = "".concat($a42f1354f0348298$var$Et.cssPrefix, "-").concat(t), e), {});
        return $a42f1354f0348298$var$Ie.forEach((n)=>{
            (e.includes(i[n]) || e.some((e)=>$a42f1354f0348298$var$Xt[n].includes(e))) && (t = n);
        }), t;
    }(r), d = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, function(e) {
        let t = [], i = null;
        return e.forEach((e)=>{
            const n = $a42f1354f0348298$var$ti($a42f1354f0348298$var$Et.cssPrefix, e);
            n ? i = n : e && t.push(e);
        }), {
            iconName: i,
            rest: t
        };
    }(s)), {}, {
        prefix: $a42f1354f0348298$var$li(l, {
            family: c
        })
    });
    return $a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, d), function(e) {
        const { values: t, family: i, canonical: n, givenPrefix: a = "", styles: r = {}, config: s = {} } = e, o = i === $a42f1354f0348298$var$Pe, l = t.includes("fa-duotone") || t.includes("fad"), c = "duotone" === s.familyDefault, d = "fad" === n.prefix || "fa-duotone" === n.prefix;
        !o && (l || c || d) && (n.prefix = "fad");
        (t.includes("fa-brands") || t.includes("fab")) && (n.prefix = "fab");
        if (!n.prefix && $a42f1354f0348298$var$ui.includes(i)) {
            const e = Object.keys(r).find((e)=>$a42f1354f0348298$var$hi.includes(e));
            if (e || s.autoFetchSvg) {
                const e = $a42f1354f0348298$var$Le.get(i).defaultShortPrefixId;
                n.prefix = e, n.iconName = $a42f1354f0348298$var$ri(n.prefix, n.iconName) || n.iconName;
            }
        }
        "fa" !== n.prefix && "fa" !== a || (n.prefix = $a42f1354f0348298$var$oi() || "fas");
        return n;
    }({
        values: e,
        family: c,
        styles: $a42f1354f0348298$var$qt,
        config: $a42f1354f0348298$var$Et,
        canonical: d,
        givenPrefix: n
    })), function(e, t, i) {
        let { prefix: n, iconName: a } = i;
        if (e || !n || !a) return {
            prefix: n,
            iconName: a
        };
        const r = "fa" === t ? $a42f1354f0348298$var$si(a) : {}, s = $a42f1354f0348298$var$ri(n, a);
        a = r.iconName || s || a, n = r.prefix || n, "far" !== n || $a42f1354f0348298$var$qt.far || !$a42f1354f0348298$var$qt.fas || $a42f1354f0348298$var$Et.autoFetchSvg || (n = "fas");
        return {
            prefix: n,
            iconName: a
        };
    }(i, n, d));
}
const $a42f1354f0348298$var$ui = $a42f1354f0348298$var$Ie.filter((e)=>e !== $a42f1354f0348298$var$De || e !== $a42f1354f0348298$var$Pe), $a42f1354f0348298$var$hi = Object.keys($a42f1354f0348298$var$Ge).filter((e)=>e !== $a42f1354f0348298$var$De).map((e)=>Object.keys($a42f1354f0348298$var$Ge[e])).flat();
let $a42f1354f0348298$var$pi = [], $a42f1354f0348298$var$Ai = {};
const $a42f1354f0348298$var$mi = {}, $a42f1354f0348298$var$gi = Object.keys($a42f1354f0348298$var$mi);
function $a42f1354f0348298$var$fi(e, t) {
    for(var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), a = 2; a < i; a++)n[a - 2] = arguments[a];
    return ($a42f1354f0348298$var$Ai[e] || []).forEach((e)=>{
        t = e.apply(null, [
            t,
            ...n
        ]);
    }), t;
}
function $a42f1354f0348298$var$_i(e) {
    for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)i[n - 1] = arguments[n];
    ($a42f1354f0348298$var$Ai[e] || []).forEach((e)=>{
        e.apply(null, i);
    });
}
function $a42f1354f0348298$var$vi() {
    const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
    return $a42f1354f0348298$var$mi[e] ? $a42f1354f0348298$var$mi[e].apply(null, t) : void 0;
}
function $a42f1354f0348298$var$Ei(e) {
    "fa" === e.prefix && (e.prefix = "fas");
    let { iconName: t } = e;
    const i = e.prefix || $a42f1354f0348298$var$oi();
    if (t) return t = $a42f1354f0348298$var$ri(i, t) || t, $a42f1354f0348298$var$Ot($a42f1354f0348298$var$yi.definitions, i, t) || $a42f1354f0348298$var$Ot($a42f1354f0348298$var$zt.styles, i, t);
}
const $a42f1354f0348298$var$yi = new class {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i];
        const n = t.reduce(this._pullDefinitions, {});
        Object.keys(n).forEach((e)=>{
            this.definitions[e] = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, this.definitions[e] || {}), n[e]), $a42f1354f0348298$var$Ht(e, n[e]);
            const t = $a42f1354f0348298$var$ct[$a42f1354f0348298$var$De][e];
            t && $a42f1354f0348298$var$Ht(t, n[e]), $a42f1354f0348298$var$ii();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(e, t) {
        const i = t.prefix && t.iconName && t.icon ? {
            0: t
        } : t;
        return Object.keys(i).map((t)=>{
            const { prefix: n, iconName: a, icon: r } = i[t], s = r[2];
            e[n] || (e[n] = {}), s.length > 0 && s.forEach((t)=>{
                "string" == typeof t && (e[n][t] = r);
            }), e[n][a] = r;
        }), e;
    }
}, $a42f1354f0348298$var$bi = {
    i2svg: function() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return $a42f1354f0348298$var$Me ? ($a42f1354f0348298$var$_i("beforeI2svg", e), $a42f1354f0348298$var$vi("pseudoElements2svg", e), $a42f1354f0348298$var$vi("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
    },
    watch: function() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const { autoReplaceSvgRoot: t } = e;
        var i;
        !1 === $a42f1354f0348298$var$Et.autoReplaceSvg && ($a42f1354f0348298$var$Et.autoReplaceSvg = !0), $a42f1354f0348298$var$Et.observeMutations = !0, i = ()=>{
            $a42f1354f0348298$var$wi({
                autoReplaceSvgRoot: t
            }), $a42f1354f0348298$var$_i("watch", e);
        }, $a42f1354f0348298$var$Me && ($a42f1354f0348298$var$Nt ? setTimeout(i, 0) : $a42f1354f0348298$var$Ft.push(i));
    }
}, $a42f1354f0348298$var$ki = {
    icon: (e)=>{
        if (null === e) return null;
        if ("object" == typeof e && e.prefix && e.iconName) return {
            prefix: e.prefix,
            iconName: $a42f1354f0348298$var$ri(e.prefix, e.iconName) || e.iconName
        };
        if (Array.isArray(e) && 2 === e.length) {
            const t = 0 === e[1].indexOf("fa-") ? e[1].slice(3) : e[1], i = $a42f1354f0348298$var$li(e[0]);
            return {
                prefix: i,
                iconName: $a42f1354f0348298$var$ri(i, t) || t
            };
        }
        if ("string" == typeof e && (e.indexOf("".concat($a42f1354f0348298$var$Et.cssPrefix, "-")) > -1 || e.match($a42f1354f0348298$var$ut))) {
            const t = $a42f1354f0348298$var$di(e.split(" "), {
                skipLookups: !0
            });
            return {
                prefix: t.prefix || $a42f1354f0348298$var$oi(),
                iconName: $a42f1354f0348298$var$ri(t.prefix, t.iconName) || t.iconName
            };
        }
        if ("string" == typeof e) {
            const t = $a42f1354f0348298$var$oi();
            return {
                prefix: t,
                iconName: $a42f1354f0348298$var$ri(t, e) || e
            };
        }
    }
}, $a42f1354f0348298$var$xi = {
    noAuto: ()=>{
        $a42f1354f0348298$var$Et.autoReplaceSvg = !1, $a42f1354f0348298$var$Et.observeMutations = !1, $a42f1354f0348298$var$_i("noAuto");
    },
    config: $a42f1354f0348298$var$Et,
    dom: $a42f1354f0348298$var$bi,
    parse: $a42f1354f0348298$var$ki,
    library: $a42f1354f0348298$var$yi,
    findIconDefinition: $a42f1354f0348298$var$Ei,
    toHtml: $a42f1354f0348298$var$Bt
}, $a42f1354f0348298$var$wi = function() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const { autoReplaceSvgRoot: t = $a42f1354f0348298$var$ke } = e;
    (Object.keys($a42f1354f0348298$var$zt.styles).length > 0 || $a42f1354f0348298$var$Et.autoFetchSvg) && $a42f1354f0348298$var$Me && $a42f1354f0348298$var$Et.autoReplaceSvg && $a42f1354f0348298$var$xi.dom.i2svg({
        node: t
    });
};
function $a42f1354f0348298$var$Mi(e, t) {
    return Object.defineProperty(e, "abstract", {
        get: t
    }), Object.defineProperty(e, "html", {
        get: function() {
            return e.abstract.map((e)=>$a42f1354f0348298$var$Bt(e));
        }
    }), Object.defineProperty(e, "node", {
        get: function() {
            if (!$a42f1354f0348298$var$Me) return;
            const t = $a42f1354f0348298$var$ke.createElement("div");
            return t.innerHTML = e.html, t.children;
        }
    }), e;
}
function $a42f1354f0348298$var$Si(e) {
    const { icons: { main: t, mask: i }, prefix: n, iconName: a, transform: r, symbol: s, title: o, maskId: l, titleId: c, extra: d, watchable: u = !1 } = e, { width: h, height: p } = i.found ? i : t, A = $a42f1354f0348298$var$Ue.includes(n), m = [
        $a42f1354f0348298$var$Et.replacementClass,
        a ? "".concat($a42f1354f0348298$var$Et.cssPrefix, "-").concat(a) : ""
    ].filter((e)=>-1 === d.classes.indexOf(e)).filter((e)=>"" !== e || !!e).concat(d.classes).join(" ");
    let g = {
        children: [],
        attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, d.attributes), {}, {
            "data-prefix": n,
            "data-icon": a,
            class: m,
            role: d.attributes.role || "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 ".concat(h, " ").concat(p)
        })
    };
    const f = A && !~d.classes.indexOf("fa-fw") ? {
        width: "".concat(h / p * 1, "em")
    } : {};
    u && (g.attributes[$a42f1354f0348298$var$Ze] = ""), o && (g.children.push({
        tag: "title",
        attributes: {
            id: g.attributes["aria-labelledby"] || "title-".concat(c || $a42f1354f0348298$var$xt())
        },
        children: [
            o
        ]
    }), delete g.attributes.title);
    const _ = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, g), {}, {
        prefix: n,
        iconName: a,
        main: t,
        mask: i,
        maskId: l,
        transform: r,
        symbol: s,
        styles: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, f), d.styles)
    }), { children: v, attributes: E } = i.found && t.found ? $a42f1354f0348298$var$vi("generateAbstractMask", _) || {
        children: [],
        attributes: {}
    } : $a42f1354f0348298$var$vi("generateAbstractIcon", _) || {
        children: [],
        attributes: {}
    };
    return _.children = v, _.attributes = E, s ? function(e) {
        let { prefix: t, iconName: i, children: n, attributes: a, symbol: r } = e;
        const s = !0 === r ? "".concat(t, "-").concat($a42f1354f0348298$var$Et.cssPrefix, "-").concat(i) : r;
        return [
            {
                tag: "svg",
                attributes: {
                    style: "display: none;"
                },
                children: [
                    {
                        tag: "symbol",
                        attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, a), {}, {
                            id: s
                        }),
                        children: n
                    }
                ]
            }
        ];
    }(_) : function(e) {
        let { children: t, main: i, mask: n, attributes: a, styles: r, transform: s } = e;
        if ($a42f1354f0348298$var$Tt(s) && i.found && !n.found) {
            const { width: e, height: t } = i, n = {
                x: e / t / 2,
                y: .5
            };
            a.style = $a42f1354f0348298$var$Ct($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, r), {}, {
                "transform-origin": "".concat(n.x + s.x / 16, "em ").concat(n.y + s.y / 16, "em")
            }));
        }
        return [
            {
                tag: "svg",
                attributes: a,
                children: t
            }
        ];
    }(_);
}
function $a42f1354f0348298$var$Ci(e) {
    const { content: t, width: i, height: n, transform: a, title: r, extra: s, watchable: o = !1 } = e, l = $a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, s.attributes), r ? {
        title: r
    } : {}), {}, {
        class: s.classes.join(" ")
    });
    o && (l[$a42f1354f0348298$var$Ze] = "");
    const c = $a42f1354f0348298$var$me({}, s.styles);
    $a42f1354f0348298$var$Tt(a) && (c.transform = function(e) {
        let { transform: t, width: i = $a42f1354f0348298$var$Xe, height: n = $a42f1354f0348298$var$Xe, startCentered: a = !1 } = e, r = "";
        return r += a && $a42f1354f0348298$var$Se ? "translate(".concat(t.x / $a42f1354f0348298$var$bt - i / 2, "em, ").concat(t.y / $a42f1354f0348298$var$bt - n / 2, "em) ") : a ? "translate(calc(-50% + ".concat(t.x / $a42f1354f0348298$var$bt, "em), calc(-50% + ").concat(t.y / $a42f1354f0348298$var$bt, "em)) ") : "translate(".concat(t.x / $a42f1354f0348298$var$bt, "em, ").concat(t.y / $a42f1354f0348298$var$bt, "em) "), r += "scale(".concat(t.size / $a42f1354f0348298$var$bt * (t.flipX ? -1 : 1), ", ").concat(t.size / $a42f1354f0348298$var$bt * (t.flipY ? -1 : 1), ") "), r += "rotate(".concat(t.rotate, "deg) "), r;
    }({
        transform: a,
        startCentered: !0,
        width: i,
        height: n
    }), c["-webkit-transform"] = c.transform);
    const d = $a42f1354f0348298$var$Ct(c);
    d.length > 0 && (l.style = d);
    const u = [];
    return u.push({
        tag: "span",
        attributes: l,
        children: [
            t
        ]
    }), r && u.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            r
        ]
    }), u;
}
const { styles: $a42f1354f0348298$var$Ti } = $a42f1354f0348298$var$zt;
function $a42f1354f0348298$var$Di(e) {
    const t = e[0], i = e[1], [n] = e.slice(4);
    let a = null;
    return a = Array.isArray(n) ? {
        tag: "g",
        attributes: {
            class: "".concat($a42f1354f0348298$var$Et.cssPrefix, "-").concat($a42f1354f0348298$var$mt.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($a42f1354f0348298$var$Et.cssPrefix, "-").concat($a42f1354f0348298$var$mt.SECONDARY),
                    fill: "currentColor",
                    d: n[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($a42f1354f0348298$var$Et.cssPrefix, "-").concat($a42f1354f0348298$var$mt.PRIMARY),
                    fill: "currentColor",
                    d: n[1]
                }
            }
        ]
    } : {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: n
        }
    }, {
        found: !0,
        width: t,
        height: i,
        icon: a
    };
}
const $a42f1354f0348298$var$Pi = {
    found: !1,
    width: 512,
    height: 512
};
function $a42f1354f0348298$var$Ii(e, t) {
    let i = t;
    return "fa" === t && null !== $a42f1354f0348298$var$Et.styleDefault && (t = $a42f1354f0348298$var$oi()), new Promise((n, a)=>{
        if ("fa" === i) {
            const i = $a42f1354f0348298$var$si(e) || {};
            e = i.iconName || e, t = i.prefix || t;
        }
        if (e && t && $a42f1354f0348298$var$Ti[t] && $a42f1354f0348298$var$Ti[t][e]) return n($a42f1354f0348298$var$Di($a42f1354f0348298$var$Ti[t][e]));
        !function(e, t) {
            $a42f1354f0348298$var$it || $a42f1354f0348298$var$Et.showMissingIcons || !e || console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
        }(e, t), n($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$Pi), {}, {
            icon: $a42f1354f0348298$var$Et.showMissingIcons && e && $a42f1354f0348298$var$vi("missingIconAbstract") || {}
        }));
    });
}
const $a42f1354f0348298$var$Li = ()=>{}, $a42f1354f0348298$var$Ri = $a42f1354f0348298$var$Et.measurePerformance && $a42f1354f0348298$var$we && $a42f1354f0348298$var$we.mark && $a42f1354f0348298$var$we.measure ? $a42f1354f0348298$var$we : {
    mark: $a42f1354f0348298$var$Li,
    measure: $a42f1354f0348298$var$Li
}, $a42f1354f0348298$var$zi = 'FA "6.7.2"', $a42f1354f0348298$var$Fi = (e)=>{
    $a42f1354f0348298$var$Ri.mark("".concat($a42f1354f0348298$var$zi, " ").concat(e, " ends")), $a42f1354f0348298$var$Ri.measure("".concat($a42f1354f0348298$var$zi, " ").concat(e), "".concat($a42f1354f0348298$var$zi, " ").concat(e, " begins"), "".concat($a42f1354f0348298$var$zi, " ").concat(e, " ends"));
};
var $a42f1354f0348298$var$Ui = (e)=>($a42f1354f0348298$var$Ri.mark("".concat($a42f1354f0348298$var$zi, " ").concat(e, " begins")), ()=>$a42f1354f0348298$var$Fi(e));
const $a42f1354f0348298$var$Ni = ()=>{};
function $a42f1354f0348298$var$Bi(e) {
    return "string" == typeof (e.getAttribute ? e.getAttribute($a42f1354f0348298$var$Ze) : null);
}
function $a42f1354f0348298$var$Oi(e) {
    return $a42f1354f0348298$var$ke.createElementNS("http://www.w3.org/2000/svg", e);
}
function $a42f1354f0348298$var$ji(e) {
    return $a42f1354f0348298$var$ke.createElement(e);
}
function $a42f1354f0348298$var$Gi(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { ceFn: i = "svg" === e.tag ? $a42f1354f0348298$var$Oi : $a42f1354f0348298$var$ji } = t;
    if ("string" == typeof e) return $a42f1354f0348298$var$ke.createTextNode(e);
    const n = i(e.tag);
    Object.keys(e.attributes || []).forEach(function(t) {
        n.setAttribute(t, e.attributes[t]);
    });
    return (e.children || []).forEach(function(e) {
        n.appendChild($a42f1354f0348298$var$Gi(e, {
            ceFn: i
        }));
    }), n;
}
const $a42f1354f0348298$var$Vi = {
    replace: function(e) {
        const t = e[0];
        if (t.parentNode) {
            if (e[1].forEach((e)=>{
                t.parentNode.insertBefore($a42f1354f0348298$var$Gi(e), t);
            }), null === t.getAttribute($a42f1354f0348298$var$Ze) && $a42f1354f0348298$var$Et.keepOriginalSource) {
                let e = $a42f1354f0348298$var$ke.createComment(function(e) {
                    let t = " ".concat(e.outerHTML, " ");
                    return t = "".concat(t, "Font Awesome fontawesome.com "), t;
                }(t));
                t.parentNode.replaceChild(e, t);
            } else t.remove();
        }
    },
    nest: function(e) {
        const t = e[0], i = e[1];
        if (~$a42f1354f0348298$var$Mt(t).indexOf($a42f1354f0348298$var$Et.replacementClass)) return $a42f1354f0348298$var$Vi.replace(e);
        const n = new RegExp("".concat($a42f1354f0348298$var$Et.cssPrefix, "-.*"));
        if (delete i[0].attributes.id, i[0].attributes.class) {
            const e = i[0].attributes.class.split(" ").reduce((e, t)=>(t === $a42f1354f0348298$var$Et.replacementClass || t.match(n) ? e.toSvg.push(t) : e.toNode.push(t), e), {
                toNode: [],
                toSvg: []
            });
            i[0].attributes.class = e.toSvg.join(" "), 0 === e.toNode.length ? t.removeAttribute("class") : t.setAttribute("class", e.toNode.join(" "));
        }
        const a = i.map((e)=>$a42f1354f0348298$var$Bt(e)).join("\n");
        t.setAttribute($a42f1354f0348298$var$Ze, ""), t.innerHTML = a;
    }
};
function $a42f1354f0348298$var$Hi(e) {
    e();
}
function $a42f1354f0348298$var$qi(e, t) {
    const i = "function" == typeof t ? t : $a42f1354f0348298$var$Ni;
    if (0 === e.length) i();
    else {
        let t = $a42f1354f0348298$var$Hi;
        "async" === $a42f1354f0348298$var$Et.mutateApproach && (t = $a42f1354f0348298$var$be.requestAnimationFrame || $a42f1354f0348298$var$Hi), t(()=>{
            const t = !0 === $a42f1354f0348298$var$Et.autoReplaceSvg ? $a42f1354f0348298$var$Vi.replace : $a42f1354f0348298$var$Vi[$a42f1354f0348298$var$Et.autoReplaceSvg] || $a42f1354f0348298$var$Vi.replace, n = $a42f1354f0348298$var$Ui("mutate");
            e.map(t), n(), i();
        });
    }
}
let $a42f1354f0348298$var$Ki = !1;
function $a42f1354f0348298$var$Wi() {
    $a42f1354f0348298$var$Ki = !0;
}
function $a42f1354f0348298$var$Xi() {
    $a42f1354f0348298$var$Ki = !1;
}
let $a42f1354f0348298$var$Qi = null;
function $a42f1354f0348298$var$Zi(e) {
    if (!$a42f1354f0348298$var$xe) return;
    if (!$a42f1354f0348298$var$Et.observeMutations) return;
    const { treeCallback: t = $a42f1354f0348298$var$Ni, nodeCallback: i = $a42f1354f0348298$var$Ni, pseudoElementsCallback: n = $a42f1354f0348298$var$Ni, observeMutationsRoot: a = $a42f1354f0348298$var$ke } = e;
    $a42f1354f0348298$var$Qi = new $a42f1354f0348298$var$xe((e)=>{
        if ($a42f1354f0348298$var$Ki) return;
        const a = $a42f1354f0348298$var$oi();
        $a42f1354f0348298$var$wt(e).forEach((e)=>{
            if ("childList" === e.type && e.addedNodes.length > 0 && !$a42f1354f0348298$var$Bi(e.addedNodes[0]) && ($a42f1354f0348298$var$Et.searchPseudoElements && n(e.target), t(e.target)), "attributes" === e.type && e.target.parentNode && $a42f1354f0348298$var$Et.searchPseudoElements && n(e.target.parentNode), "attributes" === e.type && $a42f1354f0348298$var$Bi(e.target) && ~$a42f1354f0348298$var$At.indexOf(e.attributeName)) {
                if ("class" === e.attributeName && function(e) {
                    const t = e.getAttribute ? e.getAttribute($a42f1354f0348298$var$Je) : null, i = e.getAttribute ? e.getAttribute($a42f1354f0348298$var$$e) : null;
                    return t && i;
                }(e.target)) {
                    const { prefix: t, iconName: i } = $a42f1354f0348298$var$di($a42f1354f0348298$var$Mt(e.target));
                    e.target.setAttribute($a42f1354f0348298$var$Je, t || a), i && e.target.setAttribute($a42f1354f0348298$var$$e, i);
                } else (r = e.target) && r.classList && r.classList.contains && r.classList.contains($a42f1354f0348298$var$Et.replacementClass) && i(e.target);
            }
            var r;
        });
    }), $a42f1354f0348298$var$Me && $a42f1354f0348298$var$Qi.observe(a, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
    });
}
function $a42f1354f0348298$var$Yi(e) {
    const t = e.getAttribute("data-prefix"), i = e.getAttribute("data-icon"), n = void 0 !== e.innerText ? e.innerText.trim() : "";
    let a = $a42f1354f0348298$var$di($a42f1354f0348298$var$Mt(e));
    var r, s;
    return a.prefix || (a.prefix = $a42f1354f0348298$var$oi()), t && i && (a.prefix = t, a.iconName = i), a.iconName && a.prefix || (a.prefix && n.length > 0 && (a.iconName = (r = a.prefix, s = e.innerText, ($a42f1354f0348298$var$Yt[r] || {})[s] || $a42f1354f0348298$var$ai(a.prefix, $a42f1354f0348298$var$Gt(e.innerText)))), !a.iconName && $a42f1354f0348298$var$Et.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
}
function $a42f1354f0348298$var$Ji(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        styleParser: !0
    };
    const { iconName: i, prefix: n, rest: a } = $a42f1354f0348298$var$Yi(e), r = function(e) {
        const t = $a42f1354f0348298$var$wt(e.attributes).reduce((e, t)=>("class" !== e.name && "style" !== e.name && (e[t.name] = t.value), e), {}), i = e.getAttribute("title"), n = e.getAttribute("data-fa-title-id");
        return $a42f1354f0348298$var$Et.autoA11y && (i ? t["aria-labelledby"] = "".concat($a42f1354f0348298$var$Et.replacementClass, "-title-").concat(n || $a42f1354f0348298$var$xt()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
    }(e), s = $a42f1354f0348298$var$fi("parseNodeAttributes", {}, e);
    let o = t.styleParser ? function(e) {
        const t = e.getAttribute("style");
        let i = [];
        return t && (i = t.split(";").reduce((e, t)=>{
            const i = t.split(":"), n = i[0], a = i.slice(1);
            return n && a.length > 0 && (e[n] = a.join(":").trim()), e;
        }, {})), i;
    }(e) : [];
    return $a42f1354f0348298$var$me({
        iconName: i,
        title: e.getAttribute("title"),
        titleId: e.getAttribute("data-fa-title-id"),
        prefix: n,
        transform: $a42f1354f0348298$var$kt,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: !1,
        extra: {
            classes: a,
            styles: o,
            attributes: r
        }
    }, s);
}
const { styles: $a42f1354f0348298$var$$i } = $a42f1354f0348298$var$zt;
function $a42f1354f0348298$var$en(e) {
    const t = "nest" === $a42f1354f0348298$var$Et.autoReplaceSvg ? $a42f1354f0348298$var$Ji(e, {
        styleParser: !1
    }) : $a42f1354f0348298$var$Ji(e);
    return ~t.extra.classes.indexOf($a42f1354f0348298$var$ht) ? $a42f1354f0348298$var$vi("generateLayersText", e, t) : $a42f1354f0348298$var$vi("generateSvgReplacementMutation", e, t);
}
function $a42f1354f0348298$var$tn(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    if (!$a42f1354f0348298$var$Me) return Promise.resolve();
    const i = $a42f1354f0348298$var$ke.documentElement.classList, n = (e)=>i.add("".concat($a42f1354f0348298$var$et, "-").concat(e)), a = (e)=>i.remove("".concat($a42f1354f0348298$var$et, "-").concat(e)), r = $a42f1354f0348298$var$Et.autoFetchSvg ? [
        ...$a42f1354f0348298$var$Re,
        ...$a42f1354f0348298$var$Ve
    ] : $a42f1354f0348298$var$Te.concat(Object.keys($a42f1354f0348298$var$$i));
    r.includes("fa") || r.push("fa");
    const s = [
        ".".concat($a42f1354f0348298$var$ht, ":not([").concat($a42f1354f0348298$var$Ze, "])")
    ].concat(r.map((e)=>".".concat(e, ":not([").concat($a42f1354f0348298$var$Ze, "])"))).join(", ");
    if (0 === s.length) return Promise.resolve();
    let o = [];
    try {
        o = $a42f1354f0348298$var$wt(e.querySelectorAll(s));
    } catch (e) {}
    if (!(o.length > 0)) return Promise.resolve();
    n("pending"), a("complete");
    const l = $a42f1354f0348298$var$Ui("onTree"), c = o.reduce((e, t)=>{
        try {
            const i = $a42f1354f0348298$var$en(t);
            i && e.push(i);
        } catch (e) {
            $a42f1354f0348298$var$it || "MissingIcon" === e.name && console.error(e);
        }
        return e;
    }, []);
    return new Promise((e, i)=>{
        Promise.all(c).then((i)=>{
            $a42f1354f0348298$var$qi(i, ()=>{
                n("active"), n("complete"), a("pending"), "function" == typeof t && t(), l(), e();
            });
        }).catch((e)=>{
            l(), i(e);
        });
    });
}
function $a42f1354f0348298$var$nn(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    $a42f1354f0348298$var$en(e).then((e)=>{
        e && $a42f1354f0348298$var$qi([
            e
        ], t);
    });
}
const $a42f1354f0348298$var$an = function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { transform: i = $a42f1354f0348298$var$kt, symbol: n = !1, mask: a = null, maskId: r = null, title: s = null, titleId: o = null, classes: l = [], attributes: c = {}, styles: d = {} } = t;
    if (!e) return;
    const { prefix: u, iconName: h, icon: p } = e;
    return $a42f1354f0348298$var$Mi($a42f1354f0348298$var$me({
        type: "icon"
    }, e), ()=>($a42f1354f0348298$var$_i("beforeDOMElementCreation", {
            iconDefinition: e,
            params: t
        }), $a42f1354f0348298$var$Et.autoA11y && (s ? c["aria-labelledby"] = "".concat($a42f1354f0348298$var$Et.replacementClass, "-title-").concat(o || $a42f1354f0348298$var$xt()) : (c["aria-hidden"] = "true", c.focusable = "false")), $a42f1354f0348298$var$Si({
            icons: {
                main: $a42f1354f0348298$var$Di(p),
                mask: a ? $a42f1354f0348298$var$Di(a.icon) : {
                    found: !1,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: u,
            iconName: h,
            transform: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$kt), i),
            symbol: n,
            title: s,
            maskId: r,
            titleId: o,
            extra: {
                attributes: c,
                styles: d,
                classes: l
            }
        })));
};
var $a42f1354f0348298$var$rn = {
    mixout () {
        var e;
        return {
            icon: (e = $a42f1354f0348298$var$an, function(t) {
                let i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const n = (t || {}).icon ? t : $a42f1354f0348298$var$Ei(t || {});
                let { mask: a } = i;
                return a && (a = (a || {}).icon ? a : $a42f1354f0348298$var$Ei(a || {})), e(n, $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, i), {}, {
                    mask: a
                }));
            })
        };
    },
    hooks: ()=>({
            mutationObserverCallbacks: (e)=>(e.treeCallback = $a42f1354f0348298$var$tn, e.nodeCallback = $a42f1354f0348298$var$nn, e)
        }),
    provides (e) {
        e.i2svg = function(e) {
            const { node: t = $a42f1354f0348298$var$ke, callback: i = ()=>{} } = e;
            return $a42f1354f0348298$var$tn(t, i);
        }, e.generateSvgReplacementMutation = function(e, t) {
            const { iconName: i, title: n, titleId: a, prefix: r, transform: s, symbol: o, mask: l, maskId: c, extra: d } = t;
            return new Promise((t, u)=>{
                Promise.all([
                    $a42f1354f0348298$var$Ii(i, r),
                    l.iconName ? $a42f1354f0348298$var$Ii(l.iconName, l.prefix) : Promise.resolve({
                        found: !1,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((l)=>{
                    let [u, h] = l;
                    t([
                        e,
                        $a42f1354f0348298$var$Si({
                            icons: {
                                main: u,
                                mask: h
                            },
                            prefix: r,
                            iconName: i,
                            transform: s,
                            symbol: o,
                            maskId: c,
                            title: n,
                            titleId: a,
                            extra: d,
                            watchable: !0
                        })
                    ]);
                }).catch(u);
            });
        }, e.generateAbstractIcon = function(e) {
            let { children: t, attributes: i, main: n, transform: a, styles: r } = e;
            const s = $a42f1354f0348298$var$Ct(r);
            let o;
            return s.length > 0 && (i.style = s), $a42f1354f0348298$var$Tt(a) && (o = $a42f1354f0348298$var$vi("generateAbstractTransformGrouping", {
                main: n,
                transform: a,
                containerWidth: n.width,
                iconWidth: n.width
            })), t.push(o || n.icon), {
                children: t,
                attributes: i
            };
        };
    }
}, $a42f1354f0348298$var$sn = {
    mixout: ()=>({
            layer (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const { classes: i = [] } = t;
                return $a42f1354f0348298$var$Mi({
                    type: "layer"
                }, ()=>{
                    $a42f1354f0348298$var$_i("beforeDOMElementCreation", {
                        assembler: e,
                        params: t
                    });
                    let n = [];
                    return e((e)=>{
                        Array.isArray(e) ? e.map((e)=>{
                            n = n.concat(e.abstract);
                        }) : n = n.concat(e.abstract);
                    }), [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($a42f1354f0348298$var$Et.cssPrefix, "-layers"),
                                    ...i
                                ].join(" ")
                            },
                            children: n
                        }
                    ];
                });
            }
        })
}, $a42f1354f0348298$var$on = {
    mixout: ()=>({
            counter (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const { title: i = null, classes: n = [], attributes: a = {}, styles: r = {} } = t;
                return $a42f1354f0348298$var$Mi({
                    type: "counter",
                    content: e
                }, ()=>($a42f1354f0348298$var$_i("beforeDOMElementCreation", {
                        content: e,
                        params: t
                    }), function(e) {
                        const { content: t, title: i, extra: n } = e, a = $a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, n.attributes), i ? {
                            title: i
                        } : {}), {}, {
                            class: n.classes.join(" ")
                        }), r = $a42f1354f0348298$var$Ct(n.styles);
                        r.length > 0 && (a.style = r);
                        const s = [];
                        return s.push({
                            tag: "span",
                            attributes: a,
                            children: [
                                t
                            ]
                        }), i && s.push({
                            tag: "span",
                            attributes: {
                                class: "sr-only"
                            },
                            children: [
                                i
                            ]
                        }), s;
                    }({
                        content: e.toString(),
                        title: i,
                        extra: {
                            attributes: a,
                            styles: r,
                            classes: [
                                "".concat($a42f1354f0348298$var$Et.cssPrefix, "-layers-counter"),
                                ...n
                            ]
                        }
                    })));
            }
        })
}, $a42f1354f0348298$var$ln = {
    mixout: ()=>({
            text (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const { transform: i = $a42f1354f0348298$var$kt, title: n = null, classes: a = [], attributes: r = {}, styles: s = {} } = t;
                return $a42f1354f0348298$var$Mi({
                    type: "text",
                    content: e
                }, ()=>($a42f1354f0348298$var$_i("beforeDOMElementCreation", {
                        content: e,
                        params: t
                    }), $a42f1354f0348298$var$Ci({
                        content: e,
                        transform: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$kt), i),
                        title: n,
                        extra: {
                            attributes: r,
                            styles: s,
                            classes: [
                                "".concat($a42f1354f0348298$var$Et.cssPrefix, "-layers-text"),
                                ...a
                            ]
                        }
                    })));
            }
        }),
    provides (e) {
        e.generateLayersText = function(e, t) {
            const { title: i, transform: n, extra: a } = t;
            let r = null, s = null;
            if ($a42f1354f0348298$var$Se) {
                const t = parseInt(getComputedStyle(e).fontSize, 10), i = e.getBoundingClientRect();
                r = i.width / t, s = i.height / t;
            }
            return $a42f1354f0348298$var$Et.autoA11y && !i && (a.attributes["aria-hidden"] = "true"), Promise.resolve([
                e,
                $a42f1354f0348298$var$Ci({
                    content: e.innerHTML,
                    width: r,
                    height: s,
                    transform: n,
                    title: i,
                    extra: a,
                    watchable: !0
                })
            ]);
        };
    }
};
const $a42f1354f0348298$var$cn = new RegExp('"', "ug"), $a42f1354f0348298$var$dn = [
    1105920,
    1112319
], $a42f1354f0348298$var$un = $a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, {
    FontAwesome: {
        normal: "fas",
        400: "fas"
    }
}), {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
}), {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
}), {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}), $a42f1354f0348298$var$hn = Object.keys($a42f1354f0348298$var$un).reduce((e, t)=>(e[t.toLowerCase()] = $a42f1354f0348298$var$un[t], e), {}), $a42f1354f0348298$var$pn = Object.keys($a42f1354f0348298$var$hn).reduce((e, t)=>{
    const i = $a42f1354f0348298$var$hn[t];
    return e[t] = i[900] || [
        ...Object.entries(i)
    ][0][1], e;
}, {});
function $a42f1354f0348298$var$An(e, t) {
    const i = "".concat("data-fa-pseudo-element-pending").concat(t.replace(":", "-"));
    return new Promise((n, a)=>{
        if (null !== e.getAttribute(i)) return n();
        const r = $a42f1354f0348298$var$wt(e.children).filter((e)=>e.getAttribute($a42f1354f0348298$var$Ye) === t)[0], s = $a42f1354f0348298$var$be.getComputedStyle(e, t), o = s.getPropertyValue("font-family"), l = o.match($a42f1354f0348298$var$pt), c = s.getPropertyValue("font-weight"), d = s.getPropertyValue("content");
        if (r && !l) return e.removeChild(r), n();
        if (l && "none" !== d && "" !== d) {
            const d = s.getPropertyValue("content");
            let u = function(e, t) {
                const i = e.replace(/^['"]|['"]$/g, "").toLowerCase(), n = parseInt(t), a = isNaN(n) ? "normal" : n;
                return ($a42f1354f0348298$var$hn[i] || {})[a] || $a42f1354f0348298$var$pn[i];
            }(o, c);
            const { value: h, isSecondary: p } = function(e) {
                const t = e.replace($a42f1354f0348298$var$cn, ""), i = function(e, t) {
                    const i = e.length;
                    let n, a = e.charCodeAt(t);
                    return a >= 55296 && a <= 56319 && i > t + 1 && (n = e.charCodeAt(t + 1), n >= 56320 && n <= 57343) ? 1024 * (a - 55296) + n - 56320 + 65536 : a;
                }(t, 0), n = i >= $a42f1354f0348298$var$dn[0] && i <= $a42f1354f0348298$var$dn[1], a = 2 === t.length && t[0] === t[1];
                return {
                    value: $a42f1354f0348298$var$Gt(a ? t[0] : t),
                    isSecondary: n || a
                };
            }(d), A = l[0].startsWith("FontAwesome");
            let m = $a42f1354f0348298$var$ai(u, h), g = m;
            if (A) {
                const e = function(e) {
                    const t = $a42f1354f0348298$var$$t[e], i = $a42f1354f0348298$var$ai("fas", e);
                    return t || (i ? {
                        prefix: "fas",
                        iconName: i
                    } : null) || {
                        prefix: null,
                        iconName: null
                    };
                }(h);
                e.iconName && e.prefix && (m = e.iconName, u = e.prefix);
            }
            if (!m || p || r && r.getAttribute($a42f1354f0348298$var$Je) === u && r.getAttribute($a42f1354f0348298$var$$e) === g) n();
            else {
                e.setAttribute(i, g), r && e.removeChild(r);
                const s = {
                    iconName: null,
                    title: null,
                    titleId: null,
                    prefix: null,
                    transform: $a42f1354f0348298$var$kt,
                    symbol: !1,
                    mask: {
                        iconName: null,
                        prefix: null,
                        rest: []
                    },
                    maskId: null,
                    extra: {
                        classes: [],
                        styles: {},
                        attributes: {}
                    }
                }, { extra: o } = s;
                o.attributes[$a42f1354f0348298$var$Ye] = t, $a42f1354f0348298$var$Ii(m, u).then((a)=>{
                    const r = $a42f1354f0348298$var$Si($a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, s), {}, {
                        icons: {
                            main: a,
                            mask: {
                                prefix: null,
                                iconName: null,
                                rest: []
                            }
                        },
                        prefix: u,
                        iconName: g,
                        extra: o,
                        watchable: !0
                    })), l = $a42f1354f0348298$var$ke.createElementNS("http://www.w3.org/2000/svg", "svg");
                    "::before" === t ? e.insertBefore(l, e.firstChild) : e.appendChild(l), l.outerHTML = r.map((e)=>$a42f1354f0348298$var$Bt(e)).join("\n"), e.removeAttribute(i), n();
                }).catch(a);
            }
        } else n();
    });
}
function $a42f1354f0348298$var$mn(e) {
    return Promise.all([
        $a42f1354f0348298$var$An(e, "::before"),
        $a42f1354f0348298$var$An(e, "::after")
    ]);
}
function $a42f1354f0348298$var$gn(e) {
    return !(e.parentNode === document.head || ~$a42f1354f0348298$var$tt.indexOf(e.tagName.toUpperCase()) || e.getAttribute($a42f1354f0348298$var$Ye) || e.parentNode && "svg" === e.parentNode.tagName);
}
function $a42f1354f0348298$var$fn(e) {
    if ($a42f1354f0348298$var$Me) return new Promise((t, i)=>{
        const n = $a42f1354f0348298$var$wt(e.querySelectorAll("*")).filter($a42f1354f0348298$var$gn).map($a42f1354f0348298$var$mn), a = $a42f1354f0348298$var$Ui("searchPseudoElements");
        $a42f1354f0348298$var$Wi(), Promise.all(n).then(()=>{
            a(), $a42f1354f0348298$var$Xi(), t();
        }).catch(()=>{
            a(), $a42f1354f0348298$var$Xi(), i();
        });
    });
}
var $a42f1354f0348298$var$_n = {
    hooks: ()=>({
            mutationObserverCallbacks: (e)=>(e.pseudoElementsCallback = $a42f1354f0348298$var$fn, e)
        }),
    provides (e) {
        e.pseudoElements2svg = function(e) {
            const { node: t = $a42f1354f0348298$var$ke } = e;
            $a42f1354f0348298$var$Et.searchPseudoElements && $a42f1354f0348298$var$fn(t);
        };
    }
};
let $a42f1354f0348298$var$vn = !1;
var $a42f1354f0348298$var$En = {
    mixout: ()=>({
            dom: {
                unwatch () {
                    $a42f1354f0348298$var$Wi(), $a42f1354f0348298$var$vn = !0;
                }
            }
        }),
    hooks: ()=>({
            bootstrap () {
                $a42f1354f0348298$var$Zi($a42f1354f0348298$var$fi("mutationObserverCallbacks", {}));
            },
            noAuto () {
                $a42f1354f0348298$var$Qi && $a42f1354f0348298$var$Qi.disconnect();
            },
            watch (e) {
                const { observeMutationsRoot: t } = e;
                $a42f1354f0348298$var$vn ? $a42f1354f0348298$var$Xi() : $a42f1354f0348298$var$Zi($a42f1354f0348298$var$fi("mutationObserverCallbacks", {
                    observeMutationsRoot: t
                }));
            }
        })
};
const $a42f1354f0348298$var$yn = (e)=>e.toLowerCase().split(" ").reduce((e, t)=>{
        const i = t.toLowerCase().split("-"), n = i[0];
        let a = i.slice(1).join("-");
        if (n && "h" === a) return e.flipX = !0, e;
        if (n && "v" === a) return e.flipY = !0, e;
        if (a = parseFloat(a), isNaN(a)) return e;
        switch(n){
            case "grow":
                e.size = e.size + a;
                break;
            case "shrink":
                e.size = e.size - a;
                break;
            case "left":
                e.x = e.x - a;
                break;
            case "right":
                e.x = e.x + a;
                break;
            case "up":
                e.y = e.y - a;
                break;
            case "down":
                e.y = e.y + a;
                break;
            case "rotate":
                e.rotate = e.rotate + a;
        }
        return e;
    }, {
        size: 16,
        x: 0,
        y: 0,
        flipX: !1,
        flipY: !1,
        rotate: 0
    });
var $a42f1354f0348298$var$bn = {
    mixout: ()=>({
            parse: {
                transform: (e)=>$a42f1354f0348298$var$yn(e)
            }
        }),
    hooks: ()=>({
            parseNodeAttributes (e, t) {
                const i = t.getAttribute("data-fa-transform");
                return i && (e.transform = $a42f1354f0348298$var$yn(i)), e;
            }
        }),
    provides (e) {
        e.generateAbstractTransformGrouping = function(e) {
            let { main: t, transform: i, containerWidth: n, iconWidth: a } = e;
            const r = {
                transform: "translate(".concat(n / 2, " 256)")
            }, s = "translate(".concat(32 * i.x, ", ").concat(32 * i.y, ") "), o = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), l = "rotate(".concat(i.rotate, " 0 0)"), c = {
                outer: r,
                inner: {
                    transform: "".concat(s, " ").concat(o, " ").concat(l)
                },
                path: {
                    transform: "translate(".concat(a / 2 * -1, " -256)")
                }
            };
            return {
                tag: "g",
                attributes: $a42f1354f0348298$var$me({}, c.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $a42f1354f0348298$var$me({}, c.inner),
                        children: [
                            {
                                tag: t.icon.tag,
                                children: t.icon.children,
                                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, t.icon.attributes), c.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $a42f1354f0348298$var$kn = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $a42f1354f0348298$var$xn(e) {
    let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
var $a42f1354f0348298$var$wn = {
    hooks: ()=>({
            parseNodeAttributes (e, t) {
                const i = t.getAttribute("data-fa-mask"), n = i ? $a42f1354f0348298$var$di(i.split(" ").map((e)=>e.trim())) : {
                    prefix: null,
                    iconName: null,
                    rest: []
                };
                return n.prefix || (n.prefix = $a42f1354f0348298$var$oi()), e.mask = n, e.maskId = t.getAttribute("data-fa-mask-id"), e;
            }
        }),
    provides (e) {
        e.generateAbstractMask = function(e) {
            let { children: t, attributes: i, main: n, mask: a, maskId: r, transform: s } = e;
            const { width: o, icon: l } = n, { width: c, icon: d } = a, u = function(e) {
                let { transform: t, containerWidth: i, iconWidth: n } = e;
                const a = {
                    transform: "translate(".concat(i / 2, " 256)")
                }, r = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "), s = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), o = "rotate(".concat(t.rotate, " 0 0)");
                return {
                    outer: a,
                    inner: {
                        transform: "".concat(r, " ").concat(s, " ").concat(o)
                    },
                    path: {
                        transform: "translate(".concat(n / 2 * -1, " -256)")
                    }
                };
            }({
                transform: s,
                containerWidth: c,
                iconWidth: o
            }), h = {
                tag: "rect",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$kn), {}, {
                    fill: "white"
                })
            }, p = l.children ? {
                children: l.children.map($a42f1354f0348298$var$xn)
            } : {}, A = {
                tag: "g",
                attributes: $a42f1354f0348298$var$me({}, u.inner),
                children: [
                    $a42f1354f0348298$var$xn($a42f1354f0348298$var$me({
                        tag: l.tag,
                        attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, l.attributes), u.path)
                    }, p))
                ]
            }, m = {
                tag: "g",
                attributes: $a42f1354f0348298$var$me({}, u.outer),
                children: [
                    A
                ]
            }, g = "mask-".concat(r || $a42f1354f0348298$var$xt()), f = "clip-".concat(r || $a42f1354f0348298$var$xt()), _ = {
                tag: "mask",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, $a42f1354f0348298$var$kn), {}, {
                    id: g,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    h,
                    m
                ]
            }, v = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: f
                        },
                        children: (E = d, "g" === E.tag ? E.children : [
                            E
                        ])
                    },
                    _
                ]
            };
            var E;
            return t.push(v, {
                tag: "rect",
                attributes: $a42f1354f0348298$var$me({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(f, ")"),
                    mask: "url(#".concat(g, ")")
                }, $a42f1354f0348298$var$kn)
            }), {
                children: t,
                attributes: i
            };
        };
    }
}, $a42f1354f0348298$var$Mn = {
    provides (e) {
        let t = !1;
        $a42f1354f0348298$var$be.matchMedia && (t = $a42f1354f0348298$var$be.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
            const e = [], i = {
                fill: "currentColor"
            }, n = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            };
            e.push({
                tag: "path",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, i), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            const a = $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, n), {}, {
                attributeName: "opacity"
            }), r = {
                tag: "circle",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, i), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            return t || r.children.push({
                tag: "animate",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, n), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, a), {}, {
                    values: "1;0;1;1;0;1;"
                })
            }), e.push(r), e.push({
                tag: "path",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, i), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: t ? [] : [
                    {
                        tag: "animate",
                        attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, a), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            }), t || e.push({
                tag: "path",
                attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, i), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $a42f1354f0348298$var$me($a42f1354f0348298$var$me({}, a), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            }), {
                tag: "g",
                attributes: {
                    class: "missing"
                },
                children: e
            };
        };
    }
};
!function(e, t) {
    let { mixoutsTo: i } = t;
    $a42f1354f0348298$var$pi = e, $a42f1354f0348298$var$Ai = {}, Object.keys($a42f1354f0348298$var$mi).forEach((e)=>{
        -1 === $a42f1354f0348298$var$gi.indexOf(e) && delete $a42f1354f0348298$var$mi[e];
    }), $a42f1354f0348298$var$pi.forEach((e)=>{
        const t = e.mixout ? e.mixout() : {};
        if (Object.keys(t).forEach((e)=>{
            "function" == typeof t[e] && (i[e] = t[e]), "object" == typeof t[e] && Object.keys(t[e]).forEach((n)=>{
                i[e] || (i[e] = {}), i[e][n] = t[e][n];
            });
        }), e.hooks) {
            const t = e.hooks();
            Object.keys(t).forEach((e)=>{
                $a42f1354f0348298$var$Ai[e] || ($a42f1354f0348298$var$Ai[e] = []), $a42f1354f0348298$var$Ai[e].push(t[e]);
            });
        }
        e.provides && e.provides($a42f1354f0348298$var$mi);
    });
}([
    $a42f1354f0348298$var$Lt,
    $a42f1354f0348298$var$rn,
    $a42f1354f0348298$var$sn,
    $a42f1354f0348298$var$on,
    $a42f1354f0348298$var$ln,
    $a42f1354f0348298$var$_n,
    $a42f1354f0348298$var$En,
    $a42f1354f0348298$var$bn,
    $a42f1354f0348298$var$wn,
    $a42f1354f0348298$var$Mn,
    {
        hooks: ()=>({
                parseNodeAttributes (e, t) {
                    const i = t.getAttribute("data-fa-symbol"), n = null !== i && ("" === i || i);
                    return e.symbol = n, e;
                }
            })
    }
], {
    mixoutsTo: $a42f1354f0348298$var$xi
});
const $a42f1354f0348298$var$Sn = $a42f1354f0348298$var$xi.icon, $a42f1354f0348298$var$Cn = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
}), $a42f1354f0348298$var$Tn = Object.freeze({
    rotate: 0,
    vFlip: !1,
    hFlip: !1
}), $a42f1354f0348298$var$Dn = Object.freeze({
    ...$a42f1354f0348298$var$Cn,
    ...$a42f1354f0348298$var$Tn
}), $a42f1354f0348298$var$Pn = Object.freeze({
    ...$a42f1354f0348298$var$Dn,
    body: "",
    hidden: !1
}), $a42f1354f0348298$var$In = Object.freeze({
    width: null,
    height: null
}), $a42f1354f0348298$var$Ln = Object.freeze({
    ...$a42f1354f0348298$var$In,
    ...$a42f1354f0348298$var$Tn
});
const $a42f1354f0348298$var$Rn = /[\s,]+/;
const $a42f1354f0348298$var$zn = {
    ...$a42f1354f0348298$var$Ln,
    preserveAspectRatio: ""
};
function $a42f1354f0348298$var$Fn(e) {
    const t = {
        ...$a42f1354f0348298$var$zn
    }, i = (t, i)=>e.getAttribute(t) || i;
    var n;
    return t.width = i("width", null), t.height = i("height", null), t.rotate = function(e, t = 0) {
        const i = e.replace(/^-?[0-9.]*/, "");
        function n(e) {
            for(; e < 0;)e += 4;
            return e % 4;
        }
        if ("" === i) {
            const t = parseInt(e);
            return isNaN(t) ? 0 : n(t);
        }
        if (i !== e) {
            let t = 0;
            switch(i){
                case "%":
                    t = 25;
                    break;
                case "deg":
                    t = 90;
            }
            if (t) {
                let a = parseFloat(e.slice(0, e.length - i.length));
                return isNaN(a) ? 0 : (a /= t, a % 1 == 0 ? n(a) : 0);
            }
        }
        return t;
    }(i("rotate", "")), n = t, i("flip", "").split($a42f1354f0348298$var$Rn).forEach((e)=>{
        switch(e.trim()){
            case "horizontal":
                n.hFlip = !0;
                break;
            case "vertical":
                n.vFlip = !0;
        }
    }), t.preserveAspectRatio = i("preserveAspectRatio", i("preserveaspectratio", "")), t;
}
const $a42f1354f0348298$var$Un = /^[a-z0-9]+(-[a-z0-9]+)*$/, $a42f1354f0348298$var$Nn = (e, t, i, n = "")=>{
    const a = e.split(":");
    if ("@" === e.slice(0, 1)) {
        if (a.length < 2 || a.length > 3) return null;
        n = a.shift().slice(1);
    }
    if (a.length > 3 || !a.length) return null;
    if (a.length > 1) {
        const e = a.pop(), i = a.pop(), r = {
            provider: a.length > 0 ? a[0] : n,
            prefix: i,
            name: e
        };
        return t && !$a42f1354f0348298$var$Bn(r) ? null : r;
    }
    const r = a[0], s = r.split("-");
    if (s.length > 1) {
        const e = {
            provider: n,
            prefix: s.shift(),
            name: s.join("-")
        };
        return t && !$a42f1354f0348298$var$Bn(e) ? null : e;
    }
    if (i && "" === n) {
        const e = {
            provider: n,
            prefix: "",
            name: r
        };
        return t && !$a42f1354f0348298$var$Bn(e, i) ? null : e;
    }
    return null;
}, $a42f1354f0348298$var$Bn = (e, t)=>!!e && !(!(t && "" === e.prefix || e.prefix) || !e.name);
function $a42f1354f0348298$var$On(e, t) {
    const i = function(e, t) {
        const i = {};
        !e.hFlip != !t.hFlip && (i.hFlip = !0), !e.vFlip != !t.vFlip && (i.vFlip = !0);
        const n = ((e.rotate || 0) + (t.rotate || 0)) % 4;
        return n && (i.rotate = n), i;
    }(e, t);
    for(const n in $a42f1354f0348298$var$Pn)n in $a42f1354f0348298$var$Tn ? n in e && !(n in i) && (i[n] = $a42f1354f0348298$var$Tn[n]) : n in t ? i[n] = t[n] : n in e && (i[n] = e[n]);
    return i;
}
function $a42f1354f0348298$var$jn(e, t, i) {
    const n = e.icons, a = e.aliases || Object.create(null);
    let r = {};
    function s(e) {
        r = $a42f1354f0348298$var$On(n[e] || a[e], r);
    }
    return s(t), i.forEach(s), $a42f1354f0348298$var$On(e, r);
}
function $a42f1354f0348298$var$Gn(e, t) {
    const i = [];
    if ("object" != typeof e || "object" != typeof e.icons) return i;
    e.not_found instanceof Array && e.not_found.forEach((e)=>{
        t(e, null), i.push(e);
    });
    const n = function(e) {
        const t = e.icons, i = e.aliases || Object.create(null), n = Object.create(null);
        return Object.keys(t).concat(Object.keys(i)).forEach(function e(a) {
            if (t[a]) return n[a] = [];
            if (!(a in n)) {
                n[a] = null;
                const t = i[a] && i[a].parent, r = t && e(t);
                r && (n[a] = [
                    t
                ].concat(r));
            }
            return n[a];
        }), n;
    }(e);
    for(const a in n){
        const r = n[a];
        r && (t(a, $a42f1354f0348298$var$jn(e, a, r)), i.push(a));
    }
    return i;
}
const $a42f1354f0348298$var$Vn = {
    provider: "",
    aliases: {},
    not_found: {},
    ...$a42f1354f0348298$var$Cn
};
function $a42f1354f0348298$var$Hn(e, t) {
    for(const i in t)if (i in e && typeof e[i] != typeof t[i]) return !1;
    return !0;
}
function $a42f1354f0348298$var$qn(e) {
    if ("object" != typeof e || null === e) return null;
    const t = e;
    if ("string" != typeof t.prefix || !e.icons || "object" != typeof e.icons) return null;
    if (!$a42f1354f0348298$var$Hn(e, $a42f1354f0348298$var$Vn)) return null;
    const i = t.icons;
    for(const e in i){
        const t = i[e];
        if (!e || "string" != typeof t.body || !$a42f1354f0348298$var$Hn(t, $a42f1354f0348298$var$Pn)) return null;
    }
    const n = t.aliases || Object.create(null);
    for(const e in n){
        const t = n[e], a = t.parent;
        if (!e || "string" != typeof a || !i[a] && !n[a] || !$a42f1354f0348298$var$Hn(t, $a42f1354f0348298$var$Pn)) return null;
    }
    return t;
}
const $a42f1354f0348298$var$Kn = Object.create(null);
function $a42f1354f0348298$var$Wn(e, t) {
    const i = $a42f1354f0348298$var$Kn[e] || ($a42f1354f0348298$var$Kn[e] = Object.create(null));
    return i[t] || (i[t] = function(e, t) {
        return {
            provider: e,
            prefix: t,
            icons: Object.create(null),
            missing: new Set
        };
    }(e, t));
}
function $a42f1354f0348298$var$Xn(e, t) {
    return $a42f1354f0348298$var$qn(t) ? $a42f1354f0348298$var$Gn(t, (t, i)=>{
        i ? e.icons[t] = i : e.missing.add(t);
    }) : [];
}
function $a42f1354f0348298$var$Qn(e, t) {
    let i = [];
    return ("string" == typeof e ? [
        e
    ] : Object.keys($a42f1354f0348298$var$Kn)).forEach((e)=>{
        ("string" == typeof e && "string" == typeof t ? [
            t
        ] : Object.keys($a42f1354f0348298$var$Kn[e] || {})).forEach((t)=>{
            const n = $a42f1354f0348298$var$Wn(e, t);
            i = i.concat(Object.keys(n.icons).map((i)=>("" !== e ? "@" + e + ":" : "") + t + ":" + i));
        });
    }), i;
}
let $a42f1354f0348298$var$Zn = !1;
function $a42f1354f0348298$var$Yn(e) {
    return "boolean" == typeof e && ($a42f1354f0348298$var$Zn = e), $a42f1354f0348298$var$Zn;
}
function $a42f1354f0348298$var$Jn(e) {
    const t = "string" == typeof e ? $a42f1354f0348298$var$Nn(e, !0, $a42f1354f0348298$var$Zn) : e;
    if (t) {
        const e = $a42f1354f0348298$var$Wn(t.provider, t.prefix), i = t.name;
        return e.icons[i] || (e.missing.has(i) ? null : void 0);
    }
}
function $a42f1354f0348298$var$$n(e, t) {
    const i = $a42f1354f0348298$var$Nn(e, !0, $a42f1354f0348298$var$Zn);
    if (!i) return !1;
    const n = $a42f1354f0348298$var$Wn(i.provider, i.prefix);
    return t ? function(e, t, i) {
        try {
            if ("string" == typeof i.body) return e.icons[t] = {
                ...i
            }, !0;
        } catch (e) {}
        return !1;
    }(n, i.name, t) : (n.missing.add(i.name), !0);
}
function $a42f1354f0348298$var$ea(e, t) {
    if ("object" != typeof e) return !1;
    if ("string" != typeof t && (t = e.provider || ""), $a42f1354f0348298$var$Zn && !t && !e.prefix) {
        let t = !1;
        return $a42f1354f0348298$var$qn(e) && (e.prefix = "", $a42f1354f0348298$var$Gn(e, (e, i)=>{
            $a42f1354f0348298$var$$n(e, i) && (t = !0);
        })), t;
    }
    const i = e.prefix;
    return !!$a42f1354f0348298$var$Bn({
        prefix: i,
        name: "a"
    }) && !!$a42f1354f0348298$var$Xn($a42f1354f0348298$var$Wn(t, i), e);
}
function $a42f1354f0348298$var$ta(e) {
    return !!$a42f1354f0348298$var$Jn(e);
}
function $a42f1354f0348298$var$ia(e) {
    const t = $a42f1354f0348298$var$Jn(e);
    return t ? {
        ...$a42f1354f0348298$var$Dn,
        ...t
    } : t;
}
function $a42f1354f0348298$var$na(e, t) {
    e.forEach((e)=>{
        const i = e.loaderCallbacks;
        i && (e.loaderCallbacks = i.filter((e)=>e.id !== t));
    });
}
let $a42f1354f0348298$var$aa = 0;
const $a42f1354f0348298$var$ra = Object.create(null);
function $a42f1354f0348298$var$sa(e, t) {
    $a42f1354f0348298$var$ra[e] = t;
}
function $a42f1354f0348298$var$oa(e) {
    return $a42f1354f0348298$var$ra[e] || $a42f1354f0348298$var$ra[""];
}
function $a42f1354f0348298$var$la(e) {
    let t;
    if ("string" == typeof e.resources) t = [
        e.resources
    ];
    else if (t = e.resources, !(t instanceof Array && t.length)) return null;
    return {
        resources: t,
        path: e.path || "/",
        maxURL: e.maxURL || 500,
        rotate: e.rotate || 750,
        timeout: e.timeout || 5e3,
        random: !0 === e.random,
        index: e.index || 0,
        dataAfterTimeout: !1 !== e.dataAfterTimeout
    };
}
const $a42f1354f0348298$var$ca = Object.create(null), $a42f1354f0348298$var$da = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
], $a42f1354f0348298$var$ua = [];
for(; $a42f1354f0348298$var$da.length > 0;)1 === $a42f1354f0348298$var$da.length || Math.random() > .5 ? $a42f1354f0348298$var$ua.push($a42f1354f0348298$var$da.shift()) : $a42f1354f0348298$var$ua.push($a42f1354f0348298$var$da.pop());
function $a42f1354f0348298$var$ha(e, t) {
    const i = $a42f1354f0348298$var$la(t);
    return null !== i && ($a42f1354f0348298$var$ca[e] = i, !0);
}
function $a42f1354f0348298$var$pa(e) {
    return $a42f1354f0348298$var$ca[e];
}
function $a42f1354f0348298$var$Aa() {
    return Object.keys($a42f1354f0348298$var$ca);
}
$a42f1354f0348298$var$ca[""] = $a42f1354f0348298$var$la({
    resources: [
        "https://api.iconify.design"
    ].concat($a42f1354f0348298$var$ua)
});
const $a42f1354f0348298$var$ma = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: !1,
    dataAfterTimeout: !1
};
function $a42f1354f0348298$var$ga(e, t, i, n) {
    const a = e.resources.length, r = e.random ? Math.floor(Math.random() * a) : e.index;
    let s;
    if (e.random) {
        let t = e.resources.slice(0);
        for(s = []; t.length > 1;){
            const e = Math.floor(Math.random() * t.length);
            s.push(t[e]), t = t.slice(0, e).concat(t.slice(e + 1));
        }
        s = s.concat(t);
    } else s = e.resources.slice(r).concat(e.resources.slice(0, r));
    const o = Date.now();
    let l, c = "pending", d = 0, u = null, h = [], p = [];
    function A() {
        u && (clearTimeout(u), u = null);
    }
    function m() {
        "pending" === c && (c = "aborted"), A(), h.forEach((e)=>{
            "pending" === e.status && (e.status = "aborted");
        }), h = [];
    }
    function g(e, t) {
        t && (p = []), "function" == typeof e && p.push(e);
    }
    function f() {
        c = "failed", p.forEach((e)=>{
            e(void 0, l);
        });
    }
    function _() {
        h.forEach((e)=>{
            "pending" === e.status && (e.status = "aborted");
        }), h = [];
    }
    function v() {
        if ("pending" !== c) return;
        A();
        const n = s.shift();
        if (void 0 === n) return h.length ? void (u = setTimeout(()=>{
            A(), "pending" === c && (_(), f());
        }, e.timeout)) : void f();
        const a = {
            status: "pending",
            resource: n,
            callback: (t, i)=>{
                !function(t, i, n) {
                    const a = "success" !== i;
                    switch(h = h.filter((e)=>e !== t), c){
                        case "pending":
                            break;
                        case "failed":
                            if (a || !e.dataAfterTimeout) return;
                            break;
                        default:
                            return;
                    }
                    if ("abort" === i) return l = n, void f();
                    if (a) return l = n, void (h.length || (s.length ? v() : f()));
                    if (A(), _(), !e.random) {
                        const i = e.resources.indexOf(t.resource);
                        -1 !== i && i !== e.index && (e.index = i);
                    }
                    c = "completed", p.forEach((e)=>{
                        e(n);
                    });
                }(a, t, i);
            }
        };
        h.push(a), d++, u = setTimeout(v, e.rotate), i(n, t, a.callback);
    }
    return "function" == typeof n && p.push(n), setTimeout(v), function() {
        return {
            startTime: o,
            payload: t,
            status: c,
            queriesSent: d,
            queriesPending: h.length,
            subscribe: g,
            abort: m
        };
    };
}
function $a42f1354f0348298$var$fa(e) {
    const t = {
        ...$a42f1354f0348298$var$ma,
        ...e
    };
    let i = [];
    function n() {
        i = i.filter((e)=>"pending" === e().status);
    }
    return {
        query: function(e, a, r) {
            const s = $a42f1354f0348298$var$ga(t, e, a, (e, t)=>{
                n(), r && r(e, t);
            });
            return i.push(s), s;
        },
        find: function(e) {
            return i.find((t)=>e(t)) || null;
        },
        setIndex: (e)=>{
            t.index = e;
        },
        getIndex: ()=>t.index,
        cleanup: n
    };
}
function $a42f1354f0348298$var$_a() {}
const $a42f1354f0348298$var$va = Object.create(null);
function $a42f1354f0348298$var$Ea(e, t, i) {
    let n, a;
    if ("string" == typeof e) {
        const t = $a42f1354f0348298$var$oa(e);
        if (!t) return i(void 0, 424), $a42f1354f0348298$var$_a;
        a = t.send;
        const r = function(e) {
            if (!$a42f1354f0348298$var$va[e]) {
                const t = $a42f1354f0348298$var$pa(e);
                if (!t) return;
                $a42f1354f0348298$var$va[e] = {
                    config: t,
                    redundancy: $a42f1354f0348298$var$fa(t)
                };
            }
            return $a42f1354f0348298$var$va[e];
        }(e);
        r && (n = r.redundancy);
    } else {
        const t = $a42f1354f0348298$var$la(e);
        if (t) {
            n = $a42f1354f0348298$var$fa(t);
            const i = $a42f1354f0348298$var$oa(e.resources ? e.resources[0] : "");
            i && (a = i.send);
        }
    }
    return n && a ? n.query(t, a, i)().abort : (i(void 0, 424), $a42f1354f0348298$var$_a);
}
function $a42f1354f0348298$var$ya() {}
function $a42f1354f0348298$var$ba(e) {
    e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(()=>{
        e.iconsLoaderFlag = !1, function(e) {
            e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(()=>{
                e.pendingCallbacksFlag = !1;
                const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
                if (!t.length) return;
                let i = !1;
                const n = e.provider, a = e.prefix;
                t.forEach((t)=>{
                    const r = t.icons, s = r.pending.length;
                    r.pending = r.pending.filter((t)=>{
                        if (t.prefix !== a) return !0;
                        const s = t.name;
                        if (e.icons[s]) r.loaded.push({
                            provider: n,
                            prefix: a,
                            name: s
                        });
                        else {
                            if (!e.missing.has(s)) return i = !0, !0;
                            r.missing.push({
                                provider: n,
                                prefix: a,
                                name: s
                            });
                        }
                        return !1;
                    }), r.pending.length !== s && (i || $a42f1354f0348298$var$na([
                        e
                    ], t.id), t.callback(r.loaded.slice(0), r.missing.slice(0), r.pending.slice(0), t.abort));
                });
            }));
        }(e);
    }));
}
function $a42f1354f0348298$var$ka(e, t, i) {
    function n() {
        const i = e.pendingIcons;
        t.forEach((t)=>{
            i && i.delete(t), e.icons[t] || e.missing.add(t);
        });
    }
    if (i && "object" == typeof i) try {
        if (!$a42f1354f0348298$var$Xn(e, i).length) return void n();
    } catch (e) {
        console.error(e);
    }
    n(), $a42f1354f0348298$var$ba(e);
}
function $a42f1354f0348298$var$xa(e, t) {
    e instanceof Promise ? e.then((e)=>{
        t(e);
    }).catch(()=>{
        t(null);
    }) : t(e);
}
function $a42f1354f0348298$var$wa(e, t) {
    e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(()=>{
        e.iconsQueueFlag = !1;
        const { provider: t, prefix: i } = e, n = e.iconsToLoad;
        if (delete e.iconsToLoad, !n || !n.length) return;
        const a = e.loadIcon;
        if (e.loadIcons && (n.length > 1 || !a)) return void $a42f1354f0348298$var$xa(e.loadIcons(n, i, t), (t)=>{
            $a42f1354f0348298$var$ka(e, n, t);
        });
        if (a) return void n.forEach((n)=>{
            $a42f1354f0348298$var$xa(a(n, i, t), (t)=>{
                $a42f1354f0348298$var$ka(e, [
                    n
                ], t ? {
                    prefix: i,
                    icons: {
                        [n]: t
                    }
                } : null);
            });
        });
        const { valid: r, invalid: s } = function(e) {
            const t = [], i = [];
            return e.forEach((e)=>{
                (e.match($a42f1354f0348298$var$Un) ? t : i).push(e);
            }), {
                valid: t,
                invalid: i
            };
        }(n);
        if (s.length && $a42f1354f0348298$var$ka(e, s, null), !r.length) return;
        const o = i.match($a42f1354f0348298$var$Un) ? $a42f1354f0348298$var$oa(t) : null;
        o ? o.prepare(t, i, r).forEach((i)=>{
            $a42f1354f0348298$var$Ea(t, i, (t)=>{
                $a42f1354f0348298$var$ka(e, i.icons, t);
            });
        }) : $a42f1354f0348298$var$ka(e, r, null);
    }));
}
const $a42f1354f0348298$var$Ma = (e, t)=>{
    const i = function(e) {
        const t = {
            loaded: [],
            missing: [],
            pending: []
        }, i = Object.create(null);
        e.sort((e, t)=>e.provider !== t.provider ? e.provider.localeCompare(t.provider) : e.prefix !== t.prefix ? e.prefix.localeCompare(t.prefix) : e.name.localeCompare(t.name));
        let n = {
            provider: "",
            prefix: "",
            name: ""
        };
        return e.forEach((e)=>{
            if (n.name === e.name && n.prefix === e.prefix && n.provider === e.provider) return;
            n = e;
            const a = e.provider, r = e.prefix, s = e.name, o = i[a] || (i[a] = Object.create(null)), l = o[r] || (o[r] = $a42f1354f0348298$var$Wn(a, r));
            let c;
            c = s in l.icons ? t.loaded : "" === r || l.missing.has(s) ? t.missing : t.pending;
            const d = {
                provider: a,
                prefix: r,
                name: s
            };
            c.push(d);
        }), t;
    }(function(e, t = !0, i = !1) {
        const n = [];
        return e.forEach((e)=>{
            const a = "string" == typeof e ? $a42f1354f0348298$var$Nn(e, t, i) : e;
            a && n.push(a);
        }), n;
    }(e, !0, $a42f1354f0348298$var$Yn()));
    if (!i.pending.length) {
        let e = !0;
        return t && setTimeout(()=>{
            e && t(i.loaded, i.missing, i.pending, $a42f1354f0348298$var$ya);
        }), ()=>{
            e = !1;
        };
    }
    const n = Object.create(null), a = [];
    let r, s;
    return i.pending.forEach((e)=>{
        const { provider: t, prefix: i } = e;
        if (i === s && t === r) return;
        r = t, s = i, a.push($a42f1354f0348298$var$Wn(t, i));
        const o = n[t] || (n[t] = Object.create(null));
        o[i] || (o[i] = []);
    }), i.pending.forEach((e)=>{
        const { provider: t, prefix: i, name: a } = e, r = $a42f1354f0348298$var$Wn(t, i), s = r.pendingIcons || (r.pendingIcons = new Set);
        s.has(a) || (s.add(a), n[t][i].push(a));
    }), a.forEach((e)=>{
        const t = n[e.provider][e.prefix];
        t.length && $a42f1354f0348298$var$wa(e, t);
    }), t ? function(e, t, i) {
        const n = $a42f1354f0348298$var$aa++, a = $a42f1354f0348298$var$na.bind(null, i, n);
        if (!t.pending.length) return a;
        const r = {
            id: n,
            icons: t,
            callback: e,
            abort: a
        };
        return i.forEach((e)=>{
            (e.loaderCallbacks || (e.loaderCallbacks = [])).push(r);
        }), a;
    }(t, i, a) : $a42f1354f0348298$var$ya;
}, $a42f1354f0348298$var$Sa = (e)=>new Promise((t, i)=>{
        const n = "string" == typeof e ? $a42f1354f0348298$var$Nn(e, !0) : e;
        n ? $a42f1354f0348298$var$Ma([
            n || e
        ], (a)=>{
            if (a.length && n) {
                const e = $a42f1354f0348298$var$Jn(n);
                if (e) return void t({
                    ...$a42f1354f0348298$var$Dn,
                    ...e
                });
            }
            i(e);
        }) : i(e);
    });
function $a42f1354f0348298$var$Ca(e) {
    try {
        const t = "string" == typeof e ? JSON.parse(e) : e;
        if ("string" == typeof t.body) return {
            ...t
        };
    } catch (e) {}
}
let $a42f1354f0348298$var$Ta = !1;
try {
    $a42f1354f0348298$var$Ta = 0 === navigator.vendor.indexOf("Apple");
} catch (e) {}
const $a42f1354f0348298$var$Da = /(-?[0-9.]*[0-9]+[0-9.]*)/g, $a42f1354f0348298$var$Pa = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $a42f1354f0348298$var$Ia(e, t, i) {
    if (1 === t) return e;
    if (i = i || 100, "number" == typeof e) return Math.ceil(e * t * i) / i;
    if ("string" != typeof e) return e;
    const n = e.split($a42f1354f0348298$var$Da);
    if (null === n || !n.length) return e;
    const a = [];
    let r = n.shift(), s = $a42f1354f0348298$var$Pa.test(r);
    for(;;){
        if (s) {
            const e = parseFloat(r);
            isNaN(e) ? a.push(r) : a.push(Math.ceil(e * t * i) / i);
        } else a.push(r);
        if (r = n.shift(), void 0 === r) return a.join("");
        s = !s;
    }
}
function $a42f1354f0348298$var$La(e, t) {
    const i = {
        ...$a42f1354f0348298$var$Dn,
        ...e
    }, n = {
        ...$a42f1354f0348298$var$Ln,
        ...t
    }, a = {
        left: i.left,
        top: i.top,
        width: i.width,
        height: i.height
    };
    let r = i.body;
    [
        i,
        n
    ].forEach((e)=>{
        const t = [], i = e.hFlip, n = e.vFlip;
        let s, o = e.rotate;
        switch(i ? n ? o += 2 : (t.push("translate(" + (a.width + a.left).toString() + " " + (0 - a.top).toString() + ")"), t.push("scale(-1 1)"), a.top = a.left = 0) : n && (t.push("translate(" + (0 - a.left).toString() + " " + (a.height + a.top).toString() + ")"), t.push("scale(1 -1)"), a.top = a.left = 0), o < 0 && (o -= 4 * Math.floor(o / 4)), o %= 4, o){
            case 1:
                s = a.height / 2 + a.top, t.unshift("rotate(90 " + s.toString() + " " + s.toString() + ")");
                break;
            case 2:
                t.unshift("rotate(180 " + (a.width / 2 + a.left).toString() + " " + (a.height / 2 + a.top).toString() + ")");
                break;
            case 3:
                s = a.width / 2 + a.left, t.unshift("rotate(-90 " + s.toString() + " " + s.toString() + ")");
        }
        o % 2 == 1 && (a.left !== a.top && (s = a.left, a.left = a.top, a.top = s), a.width !== a.height && (s = a.width, a.width = a.height, a.height = s)), t.length && (r = function(e, t, i) {
            const n = function(e, t = "defs") {
                let i = "";
                const n = e.indexOf("<" + t);
                for(; n >= 0;){
                    const a = e.indexOf(">", n), r = e.indexOf("</" + t);
                    if (-1 === a || -1 === r) break;
                    const s = e.indexOf(">", r);
                    if (-1 === s) break;
                    i += e.slice(a + 1, r).trim(), e = e.slice(0, n).trim() + e.slice(s + 1);
                }
                return {
                    defs: i,
                    content: e
                };
            }(e);
            var a, r;
            return a = n.defs, r = t + n.content + i, a ? "<defs>" + a + "</defs>" + r : r;
        }(r, '<g transform="' + t.join(" ") + '">', "</g>"));
    });
    const s = n.width, o = n.height, l = a.width, c = a.height;
    let d, u;
    null === s ? (u = null === o ? "1em" : "auto" === o ? c : o, d = $a42f1354f0348298$var$Ia(u, l / c)) : (d = "auto" === s ? l : s, u = null === o ? $a42f1354f0348298$var$Ia(d, c / l) : "auto" === o ? c : o);
    const h = {}, p = (e, t)=>{
        ((e)=>"unset" === e || "undefined" === e || "none" === e)(t) || (h[e] = t.toString());
    };
    p("width", d), p("height", u);
    const A = [
        a.left,
        a.top,
        l,
        c
    ];
    return h.viewBox = A.join(" "), {
        attributes: h,
        viewBox: A,
        body: r
    };
}
function $a42f1354f0348298$var$Ra(e, t) {
    let i = -1 === e.indexOf("xlink:") ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const e in t)i += " " + e + '="' + t[e] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + i + ">" + e + "</svg>";
}
function $a42f1354f0348298$var$za(e) {
    return 'url("' + function(e) {
        return "data:image/svg+xml," + function(e) {
            return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
        }(e);
    }(e) + '")';
}
let $a42f1354f0348298$var$Fa = (()=>{
    let e;
    try {
        if (e = fetch, "function" == typeof e) return e;
    } catch (e) {}
})();
function $a42f1354f0348298$var$Ua(e) {
    $a42f1354f0348298$var$Fa = e;
}
function $a42f1354f0348298$var$Na() {
    return $a42f1354f0348298$var$Fa;
}
const $a42f1354f0348298$var$Ba = {
    prepare: (e, t, i)=>{
        const n = [], a = function(e, t) {
            const i = $a42f1354f0348298$var$pa(e);
            if (!i) return 0;
            let n;
            if (i.maxURL) {
                let e = 0;
                i.resources.forEach((t)=>{
                    const i = t;
                    e = Math.max(e, i.length);
                });
                const a = t + ".json?icons=";
                n = i.maxURL - e - i.path.length - a.length;
            } else n = 0;
            return n;
        }(e, t), r = "icons";
        let s = {
            type: r,
            provider: e,
            prefix: t,
            icons: []
        }, o = 0;
        return i.forEach((i, l)=>{
            o += i.length + 1, o >= a && l > 0 && (n.push(s), s = {
                type: r,
                provider: e,
                prefix: t,
                icons: []
            }, o = i.length), s.icons.push(i);
        }), n.push(s), n;
    },
    send: (e, t, i)=>{
        if (!$a42f1354f0348298$var$Fa) return void i("abort", 424);
        let n = function(e) {
            if ("string" == typeof e) {
                const t = $a42f1354f0348298$var$pa(e);
                if (t) return t.path;
            }
            return "/";
        }(t.provider);
        switch(t.type){
            case "icons":
                {
                    const e = t.prefix, i = t.icons.join(",");
                    n += e + ".json?" + new URLSearchParams({
                        icons: i
                    }).toString();
                    break;
                }
            case "custom":
                {
                    const e = t.uri;
                    n += "/" === e.slice(0, 1) ? e.slice(1) : e;
                    break;
                }
            default:
                return void i("abort", 400);
        }
        let a = 503;
        $a42f1354f0348298$var$Fa(e + n).then((e)=>{
            const t = e.status;
            if (200 === t) return a = 501, e.json();
            setTimeout(()=>{
                i(function(e) {
                    return 404 === e;
                }(t) ? "abort" : "next", t);
            });
        }).then((e)=>{
            "object" == typeof e && null !== e ? setTimeout(()=>{
                i("success", e);
            }) : setTimeout(()=>{
                404 === e ? i("abort", e) : i("next", a);
            });
        }).catch(()=>{
            i("next", a);
        });
    }
};
function $a42f1354f0348298$var$Oa(e, t, i) {
    $a42f1354f0348298$var$Wn(i || "", t).loadIcons = e;
}
function $a42f1354f0348298$var$ja(e, t, i) {
    $a42f1354f0348298$var$Wn(i || "", t).loadIcon = e;
}
const $a42f1354f0348298$var$Ga = "data-style";
let $a42f1354f0348298$var$Va = "";
function $a42f1354f0348298$var$Ha(e) {
    $a42f1354f0348298$var$Va = e;
}
function $a42f1354f0348298$var$qa(e, t) {
    let i = Array.from(e.childNodes).find((e)=>e.hasAttribute && e.hasAttribute($a42f1354f0348298$var$Ga));
    i || (i = document.createElement("style"), i.setAttribute($a42f1354f0348298$var$Ga, $a42f1354f0348298$var$Ga), e.appendChild(i)), i.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block;margin:auto}" + $a42f1354f0348298$var$Va;
}
function $a42f1354f0348298$var$Ka() {
    let e;
    $a42f1354f0348298$var$sa("", $a42f1354f0348298$var$Ba), $a42f1354f0348298$var$Yn(!0);
    try {
        e = window;
    } catch (e) {}
    if (e) {
        if (void 0 !== e.IconifyPreload) {
            const t = e.IconifyPreload, i = "Invalid IconifyPreload syntax.";
            "object" == typeof t && null !== t && (t instanceof Array ? t : [
                t
            ]).forEach((e)=>{
                try {
                    ("object" != typeof e || null === e || e instanceof Array || "object" != typeof e.icons || "string" != typeof e.prefix || !$a42f1354f0348298$var$ea(e)) && console.error(i);
                } catch (e) {
                    console.error(i);
                }
            });
        }
        if (void 0 !== e.IconifyProviders) {
            const t = e.IconifyProviders;
            if ("object" == typeof t && null !== t) for(const e in t){
                const i = "IconifyProviders[" + e + "] is invalid.";
                try {
                    const n = t[e];
                    if ("object" != typeof n || !n || void 0 === n.resources) continue;
                    $a42f1354f0348298$var$ha(e, n) || console.error(i);
                } catch (e) {
                    console.error(i);
                }
            }
        }
    }
    return {
        iconLoaded: $a42f1354f0348298$var$ta,
        getIcon: $a42f1354f0348298$var$ia,
        listIcons: $a42f1354f0348298$var$Qn,
        addIcon: $a42f1354f0348298$var$$n,
        addCollection: $a42f1354f0348298$var$ea,
        calculateSize: $a42f1354f0348298$var$Ia,
        buildIcon: $a42f1354f0348298$var$La,
        iconToHTML: $a42f1354f0348298$var$Ra,
        svgToURL: $a42f1354f0348298$var$za,
        loadIcons: $a42f1354f0348298$var$Ma,
        loadIcon: $a42f1354f0348298$var$Sa,
        addAPIProvider: $a42f1354f0348298$var$ha,
        setCustomIconLoader: $a42f1354f0348298$var$ja,
        setCustomIconsLoader: $a42f1354f0348298$var$Oa,
        appendCustomStyle: $a42f1354f0348298$var$Ha,
        _api: {
            getAPIConfig: $a42f1354f0348298$var$pa,
            setAPIModule: $a42f1354f0348298$var$sa,
            sendAPIQuery: $a42f1354f0348298$var$Ea,
            setFetch: $a42f1354f0348298$var$Ua,
            getFetch: $a42f1354f0348298$var$Na,
            listAPIProviders: $a42f1354f0348298$var$Aa
        }
    };
}
const $a42f1354f0348298$var$Wa = {
    "background-color": "currentColor"
}, $a42f1354f0348298$var$Xa = {
    "background-color": "transparent"
}, $a42f1354f0348298$var$Qa = {
    image: "var(--svg)",
    repeat: "no-repeat",
    size: "100% 100%"
}, $a42f1354f0348298$var$Za = {
    "-webkit-mask": $a42f1354f0348298$var$Wa,
    mask: $a42f1354f0348298$var$Wa,
    background: $a42f1354f0348298$var$Xa
};
for(const e in $a42f1354f0348298$var$Za){
    const t = $a42f1354f0348298$var$Za[e];
    for(const i in $a42f1354f0348298$var$Qa)t[e + "-" + i] = $a42f1354f0348298$var$Qa[i];
}
function $a42f1354f0348298$var$Ya(e) {
    return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
let $a42f1354f0348298$var$Ja;
function $a42f1354f0348298$var$$a(e) {
    return void 0 === $a42f1354f0348298$var$Ja && function() {
        try {
            $a42f1354f0348298$var$Ja = window.trustedTypes.createPolicy("iconify", {
                createHTML: (e)=>e
            });
        } catch (e) {
            $a42f1354f0348298$var$Ja = null;
        }
    }(), $a42f1354f0348298$var$Ja ? $a42f1354f0348298$var$Ja.createHTML(e) : e;
}
function $a42f1354f0348298$var$er(e) {
    return Array.from(e.childNodes).find((e)=>{
        const t = e.tagName && e.tagName.toUpperCase();
        return "SPAN" === t || "SVG" === t;
    });
}
function $a42f1354f0348298$var$tr(e, t) {
    const i = t.icon.data, n = t.customisations, a = $a42f1354f0348298$var$La(i, n);
    n.preserveAspectRatio && (a.attributes.preserveAspectRatio = n.preserveAspectRatio);
    const r = t.renderedMode;
    let s;
    if ("svg" === r) s = function(e) {
        const t = document.createElement("span"), i = e.attributes;
        let n = "";
        i.width || (n = "width: inherit;"), i.height || (n += "height: inherit;"), n && (i.style = n);
        const a = $a42f1354f0348298$var$Ra(e.body, i);
        return t.innerHTML = $a42f1354f0348298$var$$a(a), t.firstChild;
    }(a);
    else s = function(e, t, i) {
        const n = document.createElement("span");
        let a = e.body;
        -1 !== a.indexOf("<a") && (a += "\x3c!-- " + Date.now() + " --\x3e");
        const r = e.attributes, s = $a42f1354f0348298$var$za($a42f1354f0348298$var$Ra(a, {
            ...r,
            width: t.width + "",
            height: t.height + ""
        })), o = n.style, l = {
            "--svg": s,
            width: $a42f1354f0348298$var$Ya(r.width),
            height: $a42f1354f0348298$var$Ya(r.height),
            ...i ? $a42f1354f0348298$var$Wa : $a42f1354f0348298$var$Xa
        };
        for(const e in l)o.setProperty(e, l[e]);
        return n;
    }(a, {
        ...$a42f1354f0348298$var$Dn,
        ...i
    }, "mask" === r);
    const o = $a42f1354f0348298$var$er(e);
    o ? "SPAN" === s.tagName && o.tagName === s.tagName ? o.setAttribute("style", s.getAttribute("style")) : e.replaceChild(s, o) : e.appendChild(s);
}
function $a42f1354f0348298$var$ir(e, t, i) {
    return {
        rendered: !1,
        inline: t,
        icon: e,
        lastRender: i && (i.rendered ? i : i.lastRender)
    };
}
const $a42f1354f0348298$var$nr = function(e = "iconify-icon") {
    let t, i;
    try {
        t = window.customElements, i = window.HTMLElement;
    } catch (e) {
        return;
    }
    if (!t || !i) return;
    const n = t.get(e);
    if (n) return n;
    const a = [
        "icon",
        "mode",
        "inline",
        "noobserver",
        "width",
        "height",
        "rotate",
        "flip"
    ], r = class extends i {
        _shadowRoot;
        _initialised = !1;
        _state;
        _checkQueued = !1;
        _connected = !1;
        _observer = null;
        _visible = !0;
        constructor(){
            super();
            const e = this._shadowRoot = this.attachShadow({
                mode: "open"
            }), t = this.hasAttribute("inline");
            $a42f1354f0348298$var$qa(e, t), this._state = $a42f1354f0348298$var$ir({
                value: ""
            }, t), this._queueCheck();
        }
        connectedCallback() {
            this._connected = !0, this.startObserver();
        }
        disconnectedCallback() {
            this._connected = !1, this.stopObserver();
        }
        static get observedAttributes() {
            return a.slice(0);
        }
        attributeChangedCallback(e) {
            switch(e){
                case "inline":
                    {
                        const e = this.hasAttribute("inline"), t = this._state;
                        e !== t.inline && (t.inline = e, $a42f1354f0348298$var$qa(this._shadowRoot, e));
                        break;
                    }
                case "noobserver":
                    this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
                    break;
                default:
                    this._queueCheck();
            }
        }
        get icon() {
            const e = this.getAttribute("icon");
            if (e && "{" === e.slice(0, 1)) try {
                return JSON.parse(e);
            } catch (e) {}
            return e;
        }
        set icon(e) {
            "object" == typeof e && (e = JSON.stringify(e)), this.setAttribute("icon", e);
        }
        get inline() {
            return this.hasAttribute("inline");
        }
        set inline(e) {
            e ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
        }
        get observer() {
            return this.hasAttribute("observer");
        }
        set observer(e) {
            e ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
        }
        restartAnimation() {
            const e = this._state;
            if (e.rendered) {
                const t = this._shadowRoot;
                if ("svg" === e.renderedMode) try {
                    return void t.lastChild.setCurrentTime(0);
                } catch (e) {}
                $a42f1354f0348298$var$tr(t, e);
            }
        }
        get status() {
            const e = this._state;
            return e.rendered ? "rendered" : null === e.icon.data ? "failed" : "loading";
        }
        _queueCheck() {
            this._checkQueued || (this._checkQueued = !0, setTimeout(()=>{
                this._check();
            }));
        }
        _check() {
            if (!this._checkQueued) return;
            this._checkQueued = !1;
            const e = this._state, t = this.getAttribute("icon");
            if (t !== e.icon.value) return void this._iconChanged(t);
            if (!e.rendered || !this._visible) return;
            const i = this.getAttribute("mode"), n = $a42f1354f0348298$var$Fn(this);
            e.attrMode === i && !function(e, t) {
                for(const i in $a42f1354f0348298$var$zn)if (e[i] !== t[i]) return !0;
                return !1;
            }(e.customisations, n) && $a42f1354f0348298$var$er(this._shadowRoot) || this._renderIcon(e.icon, n, i);
        }
        _iconChanged(e) {
            const t = function(e, t) {
                if ("object" == typeof e) return {
                    data: $a42f1354f0348298$var$Ca(e),
                    value: e
                };
                if ("string" != typeof e) return {
                    value: e
                };
                if (e.includes("{")) {
                    const t = $a42f1354f0348298$var$Ca(e);
                    if (t) return {
                        data: t,
                        value: e
                    };
                }
                const i = $a42f1354f0348298$var$Nn(e, !0, !0);
                if (!i) return {
                    value: e
                };
                const n = $a42f1354f0348298$var$Jn(i);
                if (void 0 !== n || !i.prefix) return {
                    value: e,
                    name: i,
                    data: n
                };
                const a = $a42f1354f0348298$var$Ma([
                    i
                ], ()=>t(e, i, $a42f1354f0348298$var$Jn(i)));
                return {
                    value: e,
                    name: i,
                    loading: a
                };
            }(e, (e, t, i)=>{
                const n = this._state;
                if (n.rendered || this.getAttribute("icon") !== e) return;
                const a = {
                    value: e,
                    name: t,
                    data: i
                };
                a.data ? this._gotIconData(a) : n.icon = a;
            });
            t.data ? this._gotIconData(t) : this._state = $a42f1354f0348298$var$ir(t, this._state.inline, this._state);
        }
        _forceRender() {
            if (!this._visible) {
                const e = $a42f1354f0348298$var$er(this._shadowRoot);
                return void (e && this._shadowRoot.removeChild(e));
            }
            this._queueCheck();
        }
        _gotIconData(e) {
            this._checkQueued = !1, this._renderIcon(e, $a42f1354f0348298$var$Fn(this), this.getAttribute("mode"));
        }
        _renderIcon(e, t, i) {
            const n = function(e, t) {
                switch(t){
                    case "svg":
                    case "bg":
                    case "mask":
                        return t;
                }
                return "style" === t || !$a42f1354f0348298$var$Ta && -1 !== e.indexOf("<a") ? -1 === e.indexOf("currentColor") ? "bg" : "mask" : "svg";
            }(e.data.body, i), a = this._state.inline;
            $a42f1354f0348298$var$tr(this._shadowRoot, this._state = {
                rendered: !0,
                icon: e,
                inline: a,
                customisations: t,
                attrMode: i,
                renderedMode: n
            });
        }
        startObserver() {
            if (!this._observer && !this.hasAttribute("noobserver")) try {
                this._observer = new IntersectionObserver((e)=>{
                    const t = e.some((e)=>e.isIntersecting);
                    t !== this._visible && (this._visible = t, this._forceRender());
                }), this._observer.observe(this);
            } catch (e) {
                if (this._observer) {
                    try {
                        this._observer.disconnect();
                    } catch (e) {}
                    this._observer = null;
                }
            }
        }
        stopObserver() {
            this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
        }
    };
    a.forEach((e)=>{
        e in r.prototype || Object.defineProperty(r.prototype, e, {
            get: function() {
                return this.getAttribute(e);
            },
            set: function(t) {
                null !== t ? this.setAttribute(e, t) : this.removeAttribute(e);
            }
        });
    });
    const s = $a42f1354f0348298$var$Ka();
    for(const e in s)r[e] = r.prototype[e] = s[e];
    return t.define(e, r), r;
}() || $a42f1354f0348298$var$Ka(), { iconLoaded: $a42f1354f0348298$var$ar, getIcon: $a42f1354f0348298$var$rr, listIcons: $a42f1354f0348298$var$sr, addIcon: $a42f1354f0348298$var$or, addCollection: $a42f1354f0348298$var$lr, calculateSize: $a42f1354f0348298$var$cr, buildIcon: $a42f1354f0348298$var$dr, iconToHTML: $a42f1354f0348298$var$ur, svgToURL: $a42f1354f0348298$var$hr, loadIcons: $a42f1354f0348298$var$pr, loadIcon: $a42f1354f0348298$var$Ar, setCustomIconLoader: $a42f1354f0348298$var$mr, setCustomIconsLoader: $a42f1354f0348298$var$gr, addAPIProvider: $a42f1354f0348298$var$fr, _api: $a42f1354f0348298$var$_r } = $a42f1354f0348298$var$nr;
function $a42f1354f0348298$var$vr() {
    return "https://panoramax.fr";
}
function $a42f1354f0348298$var$Er() {
    return "https://presets.panoramax.fr";
}
function $a42f1354f0348298$var$yr() {
    return "https://explore.panoramax.fr";
}
function $a42f1354f0348298$var$br(e) {
    return `https://raw.githubusercontent.com/rapideditor/temaki/refs/heads/main/icons/${e}.svg`;
}
function $a42f1354f0348298$var$kr() {
    return "https://www.wikidata.org/wiki";
}
function $a42f1354f0348298$var$xr() {
    return "https://www.wikidata.org/w/rest.php/wikibase/v1";
}
function $a42f1354f0348298$var$wr() {
    return "https://www.openstreetmap.org/edit?editor=id";
}
function $a42f1354f0348298$var$Mr() {
    return "https://wiki.openstreetmap.org/wiki";
}
function $a42f1354f0348298$var$Sr() {
    return "https://openstreetmap.org";
}
function $a42f1354f0348298$var$Cr() {
    return 10;
}
function $a42f1354f0348298$var$Tr() {
    return "https://panoramax.openstreetmap.fr/images/05/ca/2c/98/0111-4baf-b6f3-587bb8847d2e.jpg";
}
function $a42f1354f0348298$var$Dr() {
    return "https://nominatim.openstreetmap.org";
}
var $a42f1354f0348298$var$Pr = Object.freeze({
    __proto__: null,
    AdresseDataGouvBaseURL: function() {
        return "https://data.geopf.fr/geocodage/search";
    },
    IdEditorURL: $a42f1354f0348298$var$wr,
    IndoorEqualSpritesURL: function() {
        return "https://files.pavie.info/depot/remote/indoorequal/indoorequal";
    },
    InternetFastTestFile: $a42f1354f0348298$var$Tr,
    InternetFastThreshold: $a42f1354f0348298$var$Cr,
    MapTiles: function() {
        return "https://panoramax.openstreetmap.fr/pmtiles/basic.json";
    },
    NominatimBaseUrl: $a42f1354f0348298$var$Dr,
    OSMURL: $a42f1354f0348298$var$Sr,
    OSMWikiURL: $a42f1354f0348298$var$Mr,
    PanoramaxMetaCatalogURL: $a42f1354f0348298$var$yr,
    PanoramaxPresetsURL: $a42f1354f0348298$var$Er,
    PanoramaxWebsiteURL: $a42f1354f0348298$var$vr,
    TemakiIconURL: $a42f1354f0348298$var$br,
    WikidataAPIURL: $a42f1354f0348298$var$xr,
    WikidataURL: $a42f1354f0348298$var$kr
});
function $a42f1354f0348298$var$Ir(e, t) {
    return $a42f1354f0348298$var$Sn(e, t).node[0];
}
function $a42f1354f0348298$var$Lr() {
    $a42f1354f0348298$var$mr(async (e)=>{
        const t = await fetch($a42f1354f0348298$var$br(e));
        return t.ok ? {
            body: await t.text()
        } : null;
    }, "temaki");
}
function $a42f1354f0348298$var$Rr(e, t = {}) {
    const i = document.createElement(e);
    return Object.entries(t).forEach(([e, t])=>{
        e.startsWith("_") ? i[e] = t : e.startsWith("fn") ? i[e.substring(2)] = t : e.startsWith("on") ? i.addEventListener(e.substring(2), t) : t && i.setAttribute(e, t);
    }), i;
}
function $a42f1354f0348298$var$zr(e, t) {
    e._parent?.addEventListener("menu-opened", (i)=>{
        i.detail.menu !== e && t();
    }), e._parent?.onceMapReady?.().then(()=>{
        e._parent.map?.on?.("click", ()=>t());
    }), e._parent?.oncePSVReady?.().then(()=>{
        e._parent.psv.addEventListener("click", ()=>t());
    }), e._parent?.onceReady?.().then(()=>{
        e._parent.legend?.addEventListener("click", ()=>t());
    });
}
function $a42f1354f0348298$var$Fr(e) {
    return e._parent ? e._parent : e === document.body ? null : e.parentNode ? $a42f1354f0348298$var$Fr(e.parentNode) : e.host ? $a42f1354f0348298$var$Fr(e.host) : void 0;
}
function $a42f1354f0348298$var$Ur(e) {
    return e._parent ? Promise.resolve(e._parent) : new Promise((t)=>{
        const i = setInterval(()=>{
            const n = $a42f1354f0348298$var$Fr(e);
            n && (e._parent = n, clearInterval(i), t(e._parent));
        }, 100);
    });
}
var $a42f1354f0348298$var$Nr = Object.freeze({
    __proto__: null,
    createWebComp: $a42f1354f0348298$var$Rr,
    fa: $a42f1354f0348298$var$Ir,
    listenForMenuClosure: $a42f1354f0348298$var$zr,
    moreIcons: $a42f1354f0348298$var$Lr,
    onceParentAvailable: $a42f1354f0348298$var$Ur
});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const $a42f1354f0348298$var$Br = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
}, $a42f1354f0348298$var$Or = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
}, $a42f1354f0348298$var$jr = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3l0 41.7 0 41.7L459.5 440.6zM256 352l0-96 0-128 0-32c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-64z"
    ]
}, $a42f1354f0348298$var$Gr = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
}, $a42f1354f0348298$var$Vr = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
}, $a42f1354f0348298$var$Hr = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
}, $a42f1354f0348298$var$qr = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
}, $a42f1354f0348298$var$Kr = $a42f1354f0348298$var$qr, $a42f1354f0348298$var$Wr = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
}, $a42f1354f0348298$var$Xr = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
    ]
}, $a42f1354f0348298$var$Qr = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
}, $a42f1354f0348298$var$Zr = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
}, $a42f1354f0348298$var$Yr = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
}, $a42f1354f0348298$var$Jr = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80l0 48c0 17.7 14.3 32 32 32l16 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-5.3c0-32.4 26.3-58.7 58.7-58.7L480 320l0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16l-245.3 0c-14.7 0-26.7 11.9-26.7 26.7l0 5.3c0 53-43 96-96 96l176 0 96 0z"
    ]
}, $a42f1354f0348298$var$$r = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"
    ]
}, $a42f1354f0348298$var$es = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80l32 0 0 32-32 0 0-32zM352 32c-17.7 0-32 14.3-32 32L128 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-192c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM96 160c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l-192 0c0-17.7-14.3-32-32-32l0-192zM48 400l32 0 0 32-32 0 0-32zm320 32l0-32 32 0 0 32-32 0zM48 112l0-32 32 0 0 32-32 0z"
    ]
}, $a42f1354f0348298$var$ts = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
}, $a42f1354f0348298$var$is = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
}, $a42f1354f0348298$var$ns = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
}, $a42f1354f0348298$var$as = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
}, $a42f1354f0348298$var$rs = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
}, $a42f1354f0348298$var$ss = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
}, $a42f1354f0348298$var$os = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
}, $a42f1354f0348298$var$ls = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
}, $a42f1354f0348298$var$cs = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
    ]
}, $a42f1354f0348298$var$ds = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
}, $a42f1354f0348298$var$us = $a42f1354f0348298$var$ds, $a42f1354f0348298$var$hs = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
}, $a42f1354f0348298$var$ps = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
}, $a42f1354f0348298$var$As = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
}, $a42f1354f0348298$var$ms = $a42f1354f0348298$var$As, $a42f1354f0348298$var$gs = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"
    ]
}, $a42f1354f0348298$var$fs = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
}, $a42f1354f0348298$var$_s = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z"
    ]
}, $a42f1354f0348298$var$vs = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
}, $a42f1354f0348298$var$Es = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
}, $a42f1354f0348298$var$ys = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
}, $a42f1354f0348298$var$bs = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
}, $a42f1354f0348298$var$ks = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
}, $a42f1354f0348298$var$xs = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
}, $a42f1354f0348298$var$ws = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
}, $a42f1354f0348298$var$Ms = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
}, $a42f1354f0348298$var$Ss = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"
    ]
}, $a42f1354f0348298$var$Cs = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
    ]
}, $a42f1354f0348298$var$Ts = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
}, $a42f1354f0348298$var$Ds = $a42f1354f0348298$var$Ts, $a42f1354f0348298$var$Ps = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
}, $a42f1354f0348298$var$Is = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
}, $a42f1354f0348298$var$Ls = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
}, $a42f1354f0348298$var$Rs = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
}, $a42f1354f0348298$var$zs = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
}, $a42f1354f0348298$var$Fs = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
}, $a42f1354f0348298$var$Us = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
}, $a42f1354f0348298$var$Ns = {
    opened: 0,
    "half-opened": .7,
    closed: 1,
    hidden: 1
};
class $a42f1354f0348298$var$Bs extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		:host {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			z-index: 130;
			pointer-events: none;
			touch-action: none;
		}

		.drawer {
			background: var(--widget-bg);
			border-top-left-radius: 16px;
			border-top-right-radius: 16px;
			box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
			display: flex;
			flex-direction: column;
			transition: transform 0.3s ease;
			will-change: transform;
			touch-action: auto;
			pointer-events: auto;
		}

		.drawer.dragging { transition: none; }
		.drawer.closed { transform: translateY(calc(100% - 30px)); }
		.drawer.half-opened { transform: translateY(70%); }
		.drawer.half-opened .content { overflow-y: hidden; }
		.drawer.opened { transform: translateY(0%); }
		.drawer.hidden { display: none; }

		.drawer.autoadjust.opened {
			transform: unset;
			height: max-content !important;
		}

		.handle {
			height: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		.handle.autoclose {
			align-items: end;
			justify-content: end;
			padding: 0 15px;
		}

		.handle-bar {
			width: 40px;
			height: 5px;
			background: var(--grey-pale);
			border-radius: 3px;
		}

		.content {
			overflow: auto;
			flex: 1;
		}
	`;
    static properties = {
        _fingerY: {
            state: !0
        },
        _deltaFingerY: {
            state: !0
        },
        _drawerY: {
            state: !0
        },
        _isDragging: {
            state: !0
        },
        _drawerHeight: {
            state: !0
        },
        openness: {
            type: String,
            reflect: !0
        },
        autoclose: {
            type: Boolean
        },
        autoadjust: {
            type: Boolean
        }
    };
    constructor(){
        super(), this._isDragging = !1, this.openness = "half-opened", this.autoclose = !1, this.autoadjust = !1;
    }
    firstUpdated() {
        super.firstUpdated(), this._boundTouchMove = this._onTouchMove.bind(this), this._boundTouchEnd = this._onTouchEnd.bind(this), this._drawerHeight = window.innerHeight - 30;
        const e = this._getDrawer();
        e && (e.style.height = `${this._drawerHeight}px`, e.style.maxHeight = `${this._drawerHeight}px`, $a42f1354f0348298$var$Ur(this).then(()=>this._parent.onceReady()).then(()=>{
            const e = ()=>{
                [
                    "hidden",
                    "closed",
                    null
                ].includes(this.openness) || (this.openness = this.autoclose ? "hidden" : "closed");
            };
            this._parent.map?.addEventListener("click", e), this._parent.psv?.addEventListener("click", (t)=>{
                this._parent.psv?._clickAndGo?._couldGoSomewhere || e();
            });
        }));
    }
    attributeChangedCallback(e, t, i) {
        if (super.attributeChangedCallback(e, t, i), "openness" === e) {
            if ([
                "hidden",
                "closed",
                null
            ].includes(t) && i?.includes("open") ? this._parent?.dispatchEvent(new CustomEvent("menu-opened", {
                detail: {
                    menu: this
                }
            })) : t?.includes("open") && [
                "hidden",
                "closed",
                null
            ].includes(i) && this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
                detail: {
                    menu: this
                }
            })), "opened" !== i) {
                const e = this.shadowRoot?.querySelector(".content");
                e && (e.scrollTop = 0);
            }
            const e = this._getDrawer();
            e && (e.style.transform = null);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._cleanupTouchListeners();
    }
    setContent(e) {
        const t = this.shadowRoot?.querySelector(".content slot");
        t && (t.innerHTML = e);
    }
    clearContent() {
        const e = this.shadowRoot?.querySelector(".content slot")?.assignedElements();
        e && e.length > 0 && e.forEach((e)=>e.parentNode.removeChild(e));
    }
    _getDrawer() {
        return this.shadowRoot?.querySelector(".drawer");
    }
    _onHandleClick() {
        "opened" === this.openness ? this.openness = this.autoclose ? "hidden" : "closed" : "half-opened" === this.openness ? this.openness = this.autoclose ? "hidden" : "opened" : "closed" === this.openness && (this.openness = "half-opened");
    }
    _onTouchStart(e) {
        this._isDragging = !0, this._startFingerY = e.touches[0].clientY, this._deltaFingerY = 0, this._drawerY = this._drawerHeight * $a42f1354f0348298$var$Ns[this.openness], window.addEventListener("touchmove", this._boundTouchMove, {
            passive: !0
        }), window.addEventListener("touchend", this._boundTouchEnd), window.addEventListener("touchcancel", this._boundTouchEnd);
    }
    _onTouchMove(e) {
        if (!this._isDragging) return;
        const t = this.shadowRoot.querySelector(".content");
        t.scrollHeight > t.offsetHeight && t.scrollTop > 0 ? this._updateDrawerTransform(0) : (this._deltaFingerY = e.touches[0].clientY - this._startFingerY, this._updateDrawerTransform(this._drawerY + this._deltaFingerY));
    }
    _onTouchEnd(e) {
        (this._isDragging && !(Math.abs(this._deltaFingerY) < 30) || e.target.closest(".handle")) && (e.preventDefault(), this._isDragging = !1, 0 === this._deltaFingerY && "closed" === this.openness ? this.openness = "half-opened" : this._updateDrawerTransform(this._drawerY + this._deltaFingerY, !0), this._cleanupTouchListeners(), this._startFingerY = null, this._deltaFingerY = null);
    }
    _cleanupTouchListeners() {
        window.removeEventListener("touchmove", this._boundTouchMove), window.removeEventListener("touchend", this._boundTouchEnd), window.removeEventListener("touchcancel", this._boundTouchCancel);
    }
    _updateDrawerTransform(e, t = !1) {
        const i = this._getDrawer();
        i && (e = Math.max(0, Math.min(e, this._drawerHeight - 30)), t && (this._deltaFingerY < 0 ? "closed" === this.openness ? Math.abs(this._deltaFingerY) > this._drawerHeight * (1 - $a42f1354f0348298$var$Ns["half-opened"]) ? this.openness = "opened" : this.openness = "half-opened" : this.openness = "opened" : this.openness = this.autoclose ? "hidden" : "closed", this._drawerY = null, e = Math.max(0, Math.min($a42f1354f0348298$var$Ns[this.openness] * this._drawerHeight, this._drawerHeight - 30))), i.style.transform = `translateY(${e}px)`);
    }
    render() {
        const e = {
            drawer: !0,
            [this.openness]: !0,
            dragging: this._isDragging,
            autoadjust: this.autoadjust
        };
        return $a42f1354f0348298$var$V`
			<div
				class=${$a42f1354f0348298$var$he(e)}
				@touchstart="${this._onTouchStart}"
				@touchmove="${this._onTouchMove}"
				@touchend="${this._onTouchEnd}"
			>
				<div
					class=${$a42f1354f0348298$var$he({
            handle: !0,
            autoclose: this.autoclose
        })}
					@click=${this._onHandleClick}
				>
					${this.autoclose ? $a42f1354f0348298$var$V`
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ds, {
            styles: {
                height: "20px"
            }
        })}
					` : $a42f1354f0348298$var$V`
						<div class="handle-bar"></div>
					`}
				</div>
				<div class="content">
					<slot></slot>
				</div>
			</div>
		`;
    }
}
customElements.define("pnx-bottom-drawer", $a42f1354f0348298$var$Bs);
class $a42f1354f0348298$var$Os extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		:host {
			position: relative;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 5px;
			flex-wrap: no-wrap;
		}

		.bg {
			position: absolute;
			inset: 0;
			z-index: 0;
		}

		.row {
			display: flex;
			flex-direction: row;
			flex: 1 1 50%;
			pointer-events: none;
		}

		.row.bottom { align-items: flex-end; }

		.row.top.toggled { margin: -100% 0 200% 0; }
		.row.bottom.toggled { margin: 200% 0 -100% 0; }
		@media screen and (min-width: 576px) {
			.row.top.toggled { margin: -50% 0 100% 0; }
			.row.bottom.toggled { margin: 100% 0 -50% 0; }
		}

		.corner {
			position: relative;
			flex: 1 1 33%;
			display: flex;
			gap: 10px;
			height: min-content;
		}

		.corner slot {
			pointer-events: auto;
			position: relative;
			z-index: 120;
		}

		.row.bottom .corner:not(.middle) { flex-direction: column; }
		.row.bottom .corner.left { flex-direction: column-reverse; justify-content: flex-start; align-items: flex-start; width: 33%; }
		.row.bottom .corner.middle { justify-content: center; align-items: flex-end; width: 33%; }
		.row.bottom .corner.right { justify-content: flex-end; align-items: flex-end; width: 33%; }

		.row.top .corner { flex-direction: row; }
		.row.top .corner.left { justify-content: flex-start; align-items: flex-start; }
		.row.top .corner.middle { justify-content: center; }
		.row.top .corner.right { justify-content: flex-end; align-items: flex-start; }
	`;
    static properties = {
        _hidden: {
            state: !0
        }
    };
    constructor(){
        super(), this._hidden = !1;
    }
    toggleAway(e) {
        return this._hidden = null == e ? !this._hidden : !e, this._hidden;
    }
    render() {
        return this.renderRoot.host.className = this._hidden ? "toggled" : "", $a42f1354f0348298$var$V`
			<div class="bg">
				<slot name="bg"></slot>
			</div>
			<div class=${$a42f1354f0348298$var$he({
            row: !0,
            top: !0,
            toggled: this._hidden
        })}>
				<div class="corner left" part="corner-top-left">
					<slot name="top-left"></slot>
				</div>
				<div class="corner middle" part="corner-top">
					<slot name="top"></slot>
				</div>
				<div class="corner right" part="corner-top-right">
					<slot name="top-right"></slot>
				</div>
			</div>
			<div class=${$a42f1354f0348298$var$he({
            row: !0,
            bottom: !0,
            toggled: this._hidden
        })}>
				<div class="corner left" part="corner-bottom-left">
					<slot name="bottom-left"></slot>
				</div>
				<div class="corner middle" part="corner-bottom">
					<slot name="bottom"></slot>
				</div>
				<div class="corner right" part="corner-bottom-right">
					<slot name="bottom-right"></slot>
				</div>
			</div>
		`;
    }
}
customElements.define("pnx-cornered-grid", $a42f1354f0348298$var$Os);
const $a42f1354f0348298$var$js = "pnx-disable-annotations", $a42f1354f0348298$var$Gs = "geovisio-fake-id-0", $a42f1354f0348298$var$Vs = {
    BASE: "#54278f",
    SELECTED: "#F4511E",
    HIDDEN: "#34495E",
    NEXT: "#ffab40",
    QUALI_1: "#00695C",
    QUALI_2: "#fd8d3c",
    PALETTE_0: "#FFF59D",
    PALETTE_1: "#FF8A65",
    PALETTE_2: "#C2185B",
    PALETTE_3: "#311B92",
    PALETTE_4: "#000000"
}, $a42f1354f0348298$var$Hs = Object.fromEntries(Object.entries($a42f1354f0348298$var$Vs).map((e)=>(e[1] = parseInt(e[1].slice(1), 16), e))), $a42f1354f0348298$var$qs = [
    {
        color: "#007f4e",
        label: "A"
    },
    {
        color: "#72b043",
        label: "B"
    },
    {
        color: "#b5be2f",
        label: "C"
    },
    {
        color: "#f8cc1b",
        label: "D"
    },
    {
        color: "#f6a020",
        label: "E"
    }
], $a42f1354f0348298$var$Ks = [
    1,
    10,
    2,
    15,
    3,
    30,
    4
], $a42f1354f0348298$var$Ws = [
    3,
    15,
    4,
    30,
    5
], $a42f1354f0348298$var$Xs = [
    5,
    .5,
    4,
    2.01,
    3,
    5.01,
    2,
    10.01,
    1
], $a42f1354f0348298$var$Qs = [
    {
        score: $a42f1354f0348298$var$Xs[0],
        color: $a42f1354f0348298$var$Vs.PALETTE_4,
        label: `- ${$a42f1354f0348298$var$Xs[1]} m`
    },
    {
        score: $a42f1354f0348298$var$Xs[2],
        color: $a42f1354f0348298$var$Vs.PALETTE_3,
        label: `${$a42f1354f0348298$var$Xs[1]} - ${Math.round($a42f1354f0348298$var$Xs[3])} m`
    },
    {
        score: $a42f1354f0348298$var$Xs[4],
        color: $a42f1354f0348298$var$Vs.PALETTE_2,
        label: `${Math.round($a42f1354f0348298$var$Xs[3])} - ${Math.round($a42f1354f0348298$var$Xs[5])} m`
    },
    {
        score: $a42f1354f0348298$var$Xs[6],
        color: $a42f1354f0348298$var$Vs.PALETTE_1,
        label: `+ ${Math.round($a42f1354f0348298$var$Xs[5])} m`
    }
];
function $a42f1354f0348298$var$Zs(e) {
    return [
        null,
        void 0,
        "",
        $a42f1354f0348298$var$Gs
    ].includes(e);
}
function $a42f1354f0348298$var$Ys(e, t) {
    if (null == t || "" === t) return null;
    for(let i = 0; i < e.length; i += 2){
        const n = e[i];
        if (t < e[i + 1]) return n;
    }
    return e[e.length - 1];
}
function $a42f1354f0348298$var$Js(e, t) {
    const i = e[0] - t[0], n = e[1] - t[1];
    return Math.sqrt(i * i + n * n);
}
function $a42f1354f0348298$var$$s(e, t = null) {
    return "HTMLImageElement" === e.constructor.name ? (t && (e.width = t.width, e.height = t.height, e.onload = t.onload), e) : "string" == typeof e ? (t || ((t = new Image).alt = ""), e.startsWith("<?xml") && (e = URL.createObjectURL(new Blob([
        e
    ], {
        type: "image/svg+xml"
    }))), t.src = e, t) : void 0;
}
function $a42f1354f0348298$var$eo(e, t) {
    try {
        if (e.startsWith("data:image/svg+xml,") && (e = decodeURIComponent(e.replace("data:image/svg+xml,", ""))), !e.startsWith("<svg")) throw new Error;
        const i = (new DOMParser).parseFromString(e, "image/svg+xml").childNodes[0], n = document.createElement("button");
        return n.appendChild(i), n.classList.add("pnx-psv-tour-arrows", "pnx-print-hidden"), n.style.color = t, n;
    } catch (t) {
        return $a42f1354f0348298$var$$s(e);
    }
}
function $a42f1354f0348298$var$to(e) {
    const t = e.cloneNode(!0);
    return t.addEventListener("pointerup", ()=>t.classList.add("pnx-clicked")), t;
}
function $a42f1354f0348298$var$io(e, t) {
    return ($a42f1354f0348298$var$_o(Math.atan2(t[0] - e[0], t[1] - e[1])) + 360) % 360;
}
function $a42f1354f0348298$var$no(e, t) {
    const i = Math.abs(e - t) % 360;
    return i > 180 ? 360 - i : i;
}
function $a42f1354f0348298$var$ao(e) {
    if (!e) return 0;
    let t, i;
    if (e?.sequence?.prevPic) {
        const i = e?.links?.find((t)=>t.nodeId === e.sequence.prevPic);
        i && (t = $a42f1354f0348298$var$io(i.gps, e.gps));
    }
    if (e?.sequence?.nextPic) {
        const t = e?.links?.find((t)=>t.nodeId === e.sequence.nextPic);
        t && (i = $a42f1354f0348298$var$io(e.gps, t.gps));
    }
    return void 0 !== t && void 0 !== i ? (t + i) / 2 % 360 : void 0 !== t ? t : void 0 !== i ? i : 0;
}
function $a42f1354f0348298$var$ro(e) {
    if (!e) throw new Error("No picture selected");
    let t, i;
    const n = e.properties["view:azimuth"];
    if (e?.sequence?.prevPic) {
        const i = e?.links?.find((t)=>t.nodeId === e.sequence.prevPic);
        i && (t = (n - $a42f1354f0348298$var$io(i.gps, e.gps) + 180) % 360 - 180);
    }
    if (e?.sequence?.nextPic) {
        const t = e?.links?.find((t)=>t.nodeId === e.sequence.nextPic);
        t && (i = (n - $a42f1354f0348298$var$io(e.gps, t.gps) + 180) % 360 - 180);
    }
    return void 0 !== t ? t : void 0 !== i ? i : 0;
}
function $a42f1354f0348298$var$so(e, t) {
    const i = $a42f1354f0348298$var$_o(Math.atan2(t[0] - e[0], t[1] - e[1]));
    return Math.abs(i) < 30 ? "N" : i >= 30 && i < 90 ? "ENE" : i >= 90 && i < 150 ? "ESE" : Math.abs(i) >= 150 ? "S" : i <= -30 && i > -90 ? "WNW" : i <= -90 && i > -150 ? "WSW" : void 0;
}
function $a42f1354f0348298$var$oo(e, t) {
    const i = {
        x: $a42f1354f0348298$var$_o(e.yaw),
        y: $a42f1354f0348298$var$_o(e.pitch)
    };
    return void 0 !== t && (i.z = t), i;
}
function $a42f1354f0348298$var$lo(e, t, i) {
    return {
        yaw: $a42f1354f0348298$var$vo(e),
        pitch: $a42f1354f0348298$var$vo(t),
        zoom: i
    };
}
function $a42f1354f0348298$var$co(e) {
    const t = e < 0 ? Math.ceil(e) : Math.floor(e), i = 60 * Math.abs(e - t), n = Math.floor(i);
    return {
        d: t,
        m: n,
        s: parseFloat((60 * (i - n)).toFixed(3))
    };
}
function $a42f1354f0348298$var$uo(e) {
    if (e) {
        const t = e.gps, i = e?.properties?.["view:azimuth"], n = 2e-4, a = {
            left: t[0] - (null === i || i >= 180 ? n : 0),
            right: t[0] + (null === i || i <= 180 ? n : 0),
            top: t[1] + (null === i || i <= 90 || i >= 270 ? n : 0),
            bottom: t[1] - (null === i || i >= 90 && i <= 270 ? n : 0),
            changeset_source: "Panoramax"
        };
        return Object.entries(a).map((e)=>e.join("=")).join("&");
    }
    return null;
}
function $a42f1354f0348298$var$ho() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return !0;
    }
}
const $a42f1354f0348298$var$po = "pnx-internet-fast";
function $a42f1354f0348298$var$Ao() {
    try {
        const e = navigator.connection.downlink;
        return Promise.resolve(e >= 10);
    } catch (e) {
        try {
            const e = sessionStorage.getItem($a42f1354f0348298$var$po);
            if ([
                "true",
                "false"
            ].includes(e)) return Promise.resolve("true" === e);
            const t = (new Date).getTime();
            return fetch(`https://panoramax.openstreetmap.fr/images/05/ca/2c/98/0111-4baf-b6f3-587bb8847d2e.jpg?nocache=${t}`).then(async (e)=>[
                    e,
                    await e.blob()
                ]).then(([e, i])=>{
                const n = 8 * parseInt(e.headers.get("Content-Length") || i.size) / 1024 / 1024 / (((new Date).getTime() - t) / 1e3) >= 10;
                return sessionStorage.setItem($a42f1354f0348298$var$po, n ? "true" : "false"), n;
            }).catch((e)=>(console.warn("Failed to run speedtest", e), !1));
        } catch (e) {
            return Promise.resolve(!1);
        }
    }
}
function $a42f1354f0348298$var$mo(e) {
    const t = document.cookie?.split(";")?.find((t)=>t.trimStart().startsWith(`${e}=`))?.split("=");
    if (t) return t.shift(), t.join("=");
}
function $a42f1354f0348298$var$go() {
    const e = $a42f1354f0348298$var$mo("session"), t = $a42f1354f0348298$var$mo("user_id"), i = $a42f1354f0348298$var$mo("user_name");
    return e && t && i ? {
        id: t,
        name: i
    } : null;
}
function $a42f1354f0348298$var$fo(e, t) {
    const i = new Uint32Array(1);
    crypto.getRandomValues(i);
    let n = i[0] / 4294967296;
    return e = Math.ceil(e), t = Math.floor(t), Math.floor(n * (t - e + 1)) + e;
}
function $a42f1354f0348298$var$_o(e) {
    return 180 * e / Math.PI;
}
function $a42f1354f0348298$var$vo(e) {
    return e * (Math.PI / 180);
}
var $a42f1354f0348298$var$Eo = Object.freeze({
    __proto__: null,
    BASE_PANORAMA_ID: $a42f1354f0348298$var$Gs,
    COLORS: $a42f1354f0348298$var$Vs,
    COLORS_HEX: $a42f1354f0348298$var$Hs,
    DISABLE_ANNOTATIONS_PARAM: $a42f1354f0348298$var$js,
    GPS_VALUES: $a42f1354f0348298$var$Qs,
    QUALITYSCORE_GPS_VALUES: $a42f1354f0348298$var$Xs,
    QUALITYSCORE_POND_GPS: .2,
    QUALITYSCORE_POND_RES: .8,
    QUALITYSCORE_RES_360_VALUES: $a42f1354f0348298$var$Ws,
    QUALITYSCORE_RES_FLAT_VALUES: $a42f1354f0348298$var$Ks,
    QUALITYSCORE_VALUES: $a42f1354f0348298$var$qs,
    deg2rad: $a42f1354f0348298$var$vo,
    degToDms: $a42f1354f0348298$var$co,
    getAngularDiff: $a42f1354f0348298$var$no,
    getArrow: $a42f1354f0348298$var$to,
    getAzimuth: $a42f1354f0348298$var$io,
    getCookie: $a42f1354f0348298$var$mo,
    getDistance: $a42f1354f0348298$var$Js,
    getGrade: $a42f1354f0348298$var$Ys,
    getRelativeHeading: $a42f1354f0348298$var$ro,
    getRoadAbsoluteHeading: $a42f1354f0348298$var$ao,
    getSimplifiedAngle: $a42f1354f0348298$var$so,
    getUserAccount: $a42f1354f0348298$var$go,
    inRangeRandom: $a42f1354f0348298$var$fo,
    isInIframe: $a42f1354f0348298$var$ho,
    isInternetFast: $a42f1354f0348298$var$Ao,
    isNullId: $a42f1354f0348298$var$Zs,
    josmBboxParameters: $a42f1354f0348298$var$uo,
    positionToXYZ: $a42f1354f0348298$var$oo,
    rad2deg: $a42f1354f0348298$var$_o,
    svgToImg: $a42f1354f0348298$var$$s,
    svgToPSVLink: $a42f1354f0348298$var$eo,
    xyzToPosition: $a42f1354f0348298$var$lo
});
const $a42f1354f0348298$var$yo = $a42f1354f0348298$var$$s("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg version='1.1' x='0px' y='0px' viewBox='0 0 90.455002 90.452003' id='svg10' width='90.455002' height='90.452003' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cpath d='m 2.512%2c90.45 h 8.012 12.834 c 0.008%2c0 0.014%2c0.002 0.02%2c0.002 h 15.423 c 0.008%2c0 0.014%2c-0.002 0.02%2c-0.002 h 1.164 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 52.813 l 27.52%2c-27.516 v 19.109 c 0%2c1.386 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.126 2.512%2c-2.512 V 19.233 c 0%2c-1.387 -1.125%2c-2.514 -2.512%2c-2.514 H 47.356 c -1.389%2c0 -2.514%2c1.127 -2.514%2c2.514 0%2c1.387 1.125%2c2.512 2.514%2c2.512 H 66.463 L 40.226%2c47.977 c -0.08%2c-0.008 -0.16%2c-0.023 -0.242%2c-0.023 H 2.512 C 1.125%2c47.954 0%2c49.079 0%2c50.466 v 1.188 15.424 12.854 8.008 c 0%2c1.385 1.125%2c2.51 2.512%2c2.51 z M 5.025%2c79.93 V 67.077 52.977 H 37.471 V 85.424 H 10.523 5.025 Z' id='path1' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 67.078%2c90.452 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.514 0%2c-1.387 -1.125%2c-2.512 -2.514%2c-2.512 H 51.655 c -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.389 1.125%2c2.514 2.512%2c2.514 z' id='path2' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 90.455%2c79.93 c 0%2c-1.387 -1.125%2c-2.512 -2.514%2c-2.512 -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 v 5.496 h -5.496 c -1.389%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.389 1.123%2c2.514 2.512%2c2.514 h 8.008 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.514 z' id='path3' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 87.942%2c41.311 c 1.387%2c0 2.512%2c-1.127 2.512%2c-2.514 V 23.373 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 v 15.424 c 0%2c1.387 1.125%2c2.514 2.514%2c2.514 z' id='path4' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 85.428%2c67.075 c 0%2c1.387 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 51.651 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 z' id='path5' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 87.942%2c0 h -8.008 c -1.389%2c0 -2.512%2c1.127 -2.512%2c2.514 0%2c1.387 1.123%2c2.512 2.512%2c2.512 h 5.494 v 5.496 c 0%2c1.387 1.125%2c2.514 2.514%2c2.514 1.387%2c0 2.512%2c-1.127 2.512%2c-2.514 V 2.514 C 90.453%2c1.127 89.328%2c0 87.942%2c0 Z' id='path6' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 23.377%2c5.024 h 15.422 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 C 41.313%2c1.125 40.188%2c0 38.799%2c0 H 23.377 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.387 1.125%2c2.512 2.514%2c2.512 z' id='path7' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 51.653%2c5.024 h 15.424 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 C 69.591%2c1.125 68.466%2c0 67.077%2c0 H 51.653 c -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.387 1.125%2c2.512 2.512%2c2.512 z' id='path8' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 2.512%2c13.033 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.514 V 5.024 h 5.498 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 C 13.036%2c1.125 11.911%2c0 10.524%2c0 H 2.512 C 1.125%2c0 0%2c1.125 0%2c2.512 v 8.008 c 0%2c1.388 1.125%2c2.513 2.512%2c2.513 z' id='path9' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 2.512%2c41.311 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 V 23.375 C 5.026%2c21.988 3.901%2c20.863 2.512%2c20.863 1.125%2c20.863 0%2c21.988 0%2c23.375 v 15.424 c 0%2c1.387 1.125%2c2.512 2.512%2c2.512 z' id='path10' style='fill:%232954e9%3bfill-opacity:1' /%3e%3c/svg%3e"), $a42f1354f0348298$var$bo = $a42f1354f0348298$var$$s("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg version='1.1' x='0px' y='0px' viewBox='0 0 90.169998 90.171997' enable-background='new 0 0 91 91' id='svg12' width='90.169998' height='90.171997' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cpath d='m 45.832%2c18.039 c -1.388%2c0 -2.513%2c1.125 -2.513%2c2.512 V 45.64 c 0%2c1.39 1.125%2c2.515 2.513%2c2.515 h 25.089 c 1.389%2c0 2.512%2c-1.125 2.512%2c-2.515 0%2c-1.386 -1.123%2c-2.511 -2.512%2c-2.511 H 51.894 L 79.386%2c15.635 c 0.982%2c-0.98 0.982%2c-2.57 0%2c-3.553 -0.98%2c-0.98 -2.572%2c-0.98 -3.553%2c0 L 48.343%2c39.576 V 20.551 c 0%2c-1.387 -1.125%2c-2.512 -2.511%2c-2.512 z' id='path1' /%3e %3cpath d='m 2.512%2c90.171 h 0.002 7.982 12.808 15.372 1.182 c 1.388%2c0 2.514%2c-1.125 2.514%2c-2.514 v -37.35 c 0%2c-1.387 -1.126%2c-2.512 -2.514%2c-2.512 H 2.514 c -1.389%2c0 -2.513%2c1.125 -2.513%2c2.512 v 1.17 C 0.001%2c51.481 0%2c51.487 0%2c51.491 v 15.373 c 0%2c0.006 0.001%2c0.01 0.001%2c0.016 V 79.661 C 0.001%2c79.665 0%2c79.671 0%2c79.675 v 7.982 c 0%2c1.389 1.124%2c2.514 2.512%2c2.514 z M 5.026%2c52.819 H 37.345 V 85.145 H 23.304 10.497 5.026 Z' id='path2' /%3e %3cpath d='m 51.487%2c85.145 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.389 1.125%2c2.514 2.514%2c2.514 H 66.86 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.514 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 z' id='path3' /%3e %3cpath d='m 87.657%2c77.163 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 v 5.471 h -5.469 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.389 1.125%2c2.514 2.514%2c2.514 h 7.983 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.514 v -7.982 c 0%2c-1.388 -1.125%2c-2.513 -2.512%2c-2.513 z' id='path4' /%3e %3cpath d='m 87.657%2c48.979 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 v 15.373 c 0%2c1.387 1.125%2c2.514 2.514%2c2.514 1.387%2c0 2.512%2c-1.127 2.512%2c-2.514 V 51.491 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 z' id='path5' /%3e %3cpath d='m 87.657%2c20.795 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 V 38.68 c 0%2c1.387 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 23.307 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 z' id='path6' /%3e %3cpath d='m 87.657%2c0.002 h -7.982 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.387 1.125%2c2.512 2.514%2c2.512 h 5.469 v 5.471 c 0%2c1.387 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 2.514 C 90.169%2c1.127 89.044%2c0.002 87.657%2c0.002 Z' id='path7' /%3e %3cpath d='m 38.678%2c5.024 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 C 41.191%2c1.125 40.067%2c0 38.678%2c0 H 23.305 c -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.387 1.125%2c2.512 2.512%2c2.512 z' id='path8' /%3e %3cpath d='m 66.86%2c5.024 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 C 69.374%2c1.125 68.249%2c0 66.86%2c0 H 51.489 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.387 1.125%2c2.512 2.514%2c2.512 z' id='path9' /%3e %3cpath d='m 2.512%2c13.006 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 v -5.47 h 5.468 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 C 13.006%2c1.125 11.882%2c0 10.493%2c0 H 2.513 C 1.125%2c0 10e-4%2c1.125 10e-4%2c2.512 v 7.982 C 0%2c11.881 1.124%2c13.006 2.512%2c13.006 Z' id='path10' /%3e %3cpath d='m 2.512%2c41.192 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 V 23.307 C 5.025%2c21.92 3.901%2c20.795 2.512%2c20.795 1.124%2c20.795 0%2c21.92 0%2c23.307 V 38.68 c 0%2c1.387 1.124%2c2.512 2.512%2c2.512 z' id='path11' /%3e%3c/svg%3e");
class $a42f1354f0348298$var$ko extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		:host {
			display: block;
			position: absolute;
			inset: 0;
			pointer-events: none;
		}

		slot {
			z-index: 120;
			pointer-events: auto;
		}

		pnx-button {
			z-index: 121;
			position: absolute;
			pointer-events: auto;
		}

		pnx-button img {
			height: 20px;
		}

		pnx-button:not([size="xxl"])::part(btn) {
			border-top-left-radius: 0;
			border-bottom-right-radius: 0;
		}
	`;
    static properties = {
        icon: {
            type: String
        },
        collapsed: {
            type: Boolean,
            reflect: !0
        }
    };
    constructor(){
        super(), this.collapsed = !1, this.icon = null;
    }
    render() {
        const e = this._parent?.isWidthSmall() || this._parent?.isWidthMedium() || this._parent?.isHeightSmall(), t = ()=>this.dispatchEvent(new Event("expand", {
                bubbles: !0,
                composed: !0
            }));
        if (this.collapsed || e) return $a42f1354f0348298$var$V`<pnx-button
				kind="flat"
				size="xxl"
				style="bottom: 0"
				@click=${e ? t : ()=>this.collapsed = !1}
			>${this.icon}</pnx-button>`;
        return $a42f1354f0348298$var$V`
				<slot></slot>

				<pnx-button
					kind="superflat"
					title=${this._parent?._t.pnx.expand_info}
					style="top: 0; right: 0"
					@click=${t}
				>
					${$a42f1354f0348298$var$yo}
					${this._parent?._t.pnx.expand}
				</pnx-button>

				<pnx-button
					kind="flat"
					title=${this._parent?._t.pnx.minimize}
					style="bottom: 0; left: 0"
					@click=${()=>this.collapsed = !0}
				>
					${$a42f1354f0348298$var$bo}
				</pnx-button>
			`;
    }
}
customElements.define("pnx-mini", $a42f1354f0348298$var$ko);
class $a42f1354f0348298$var$xo extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		/* Tabs */
		nav {
			display: flex;
			gap: 5px;
			align-items: stretch;
			overflow-x: auto;
			touch-action: pan-x;
			position: sticky;
			top: 0;
			background: white;
			z-index: 125;
		}
		nav ::slotted(*) {
			color: var(--grey-dark);
			border-bottom: 2px solid rgba(0,0,0,0);
			cursor: pointer;
			transition: all 0.1s;
			flex: 1;
		}
		nav ::slotted(*:hover:not(.active)) { background-color: var(--blue-pale); }
		nav ::slotted(*.active) {
			color: var(--blue-dark);
			border-bottom: 2px solid var(--blue-dark);
		}

		/* Content */
		.contents ::slotted(div) { display: none !important; }
		.contents ::slotted(.active) { display: block !important; }
	`;
    static properties = {
        activeTabIndex: {
            type: Number,
            reflect: !0
        },
        hideNav: {
            type: Boolean
        }
    };
    constructor(){
        super(), this.activeTabIndex = 0, this.hideNav = !1;
    }
    _getTabs() {
        return this.shadowRoot.querySelector("slot[name='title']")?.assignedNodes() || [];
    }
    _getContents() {
        return this.shadowRoot.querySelector("slot[name='content']")?.assignedNodes() || [];
    }
    _changeTab(e, t) {
        const i = this._getTabs(), n = this._getContents();
        void 0 === e && void 0 === t || (e && (t = i.findIndex((t)=>t === e || t === e.parentNode)), !isNaN(t) && t >= 0 && t < i.length && i.forEach((e, i)=>{
            i == t ? (this.activeTabIndex = i, n[i].classList.add("active"), e.classList.add("active")) : (n[i].classList.remove("active"), e.classList.remove("active"));
        }));
    }
    _handleTabClick(e) {
        this._changeTab(e.target);
    }
    updated(e) {
        e.has("activeTabIndex") && this._changeTab(void 0, this.activeTabIndex);
    }
    render() {
        return $a42f1354f0348298$var$V`
			${this.hideNav ? $a42f1354f0348298$var$q : $a42f1354f0348298$var$V`<nav @click="${this._handleTabClick}">
				<slot name="title" @slotchange=${()=>this.activeTabIndex = 0}></slot>
			</nav>`}
			<div class="contents">
				<slot name="content"></slot>
			</div>
		`;
    }
}
customElements.define("pnx-tabs", $a42f1354f0348298$var$xo);
var $a42f1354f0348298$var$wo = Object.freeze({
    __proto__: null,
    BottomDrawer: $a42f1354f0348298$var$Bs,
    CorneredGrid: $a42f1354f0348298$var$Os,
    Mini: $a42f1354f0348298$var$ko,
    Tabs: $a42f1354f0348298$var$xo
});
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a42f1354f0348298$var$Mo = Symbol.for(""), $a42f1354f0348298$var$So = (e)=>{
    if (e?.r === $a42f1354f0348298$var$Mo) return e?._$litStatic$;
}, $a42f1354f0348298$var$Co = (e)=>({
        _$litStatic$: e,
        r: $a42f1354f0348298$var$Mo
    }), $a42f1354f0348298$var$To = new Map, $a42f1354f0348298$var$Do = ((e)=>(t, ...i)=>{
        const n = i.length;
        let a, r;
        const s = [], o = [];
        let l, c = 0, d = !1;
        for(; c < n;){
            for(l = t[c]; c < n && void 0 !== (r = i[c], a = $a42f1354f0348298$var$So(r));)l += a + t[++c], d = !0;
            c !== n && o.push(r), s.push(l), c++;
        }
        if (c === n && s.push(t[n]), d) {
            const e = s.join("$$lit$$");
            void 0 === (t = $a42f1354f0348298$var$To.get(e)) && (s.raw = s, $a42f1354f0348298$var$To.set(e, t = s)), i = o;
        }
        return e(t, ...i);
    })($a42f1354f0348298$var$V), $a42f1354f0348298$var$Po = $a42f1354f0348298$var$s`
	.pnx-panel {
		position: absolute;
		transition: opacity 0.2s 0.1s;
		border-radius: 20px;
		border: 1px solid var(--widget-border-div);
		background-color: var(--widget-bg);
		color: var(--widget-font);
		min-width: 250px;
		box-sizing: border-box;
		font-family: var(--font-family);
	}

	.pnx-panel.pnx-hidden {
		opacity: 0;
		display: block !important;
		pointer-events: none;
	}

	.pnx-panel.pnx-padded {
		padding: 15px;
	}
`, $a42f1354f0348298$var$Io = $a42f1354f0348298$var$s`
	.pnx-hidden { display: none !important; }
`, $a42f1354f0348298$var$Lo = $a42f1354f0348298$var$s`
	.svg-inline--fa {
		display: var(--fa-display, inline-block);
		height: 1em;
		overflow: visible;
		vertical-align: -0.125em;
	}
	svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
		overflow: visible;
		box-sizing: content-box;
	}
	@keyframes fa-spin {
		from {transform:rotate(0deg);}
		to {transform:rotate(360deg);}
	}
	.fa-spin {
		animation: fa-spin 2s infinite linear;
	}
`, $a42f1354f0348298$var$Ro = $a42f1354f0348298$var$s`
	textarea {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 10px;
		padding: 5px;
		width: 100%;
		box-sizing: border-box;
		font-family: var(--font-family);
		resize: vertical;
	}
`, $a42f1354f0348298$var$zo = $a42f1354f0348298$var$s`
	select {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	select[disabled] {
		background-color: var(--widget-bg-inactive);
	}

	select.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, $a42f1354f0348298$var$Fo = $a42f1354f0348298$var$s`
	input {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	input.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, $a42f1354f0348298$var$Uo = $a42f1354f0348298$var$s`
	:host {
		display: inline-flex;
	}
	
	/* Common properties */
	.pnx-btn {
		white-space: nowrap;
		font-size: 1em;
		font-family: var(--font-family);
		flex-grow: 1;
		flex-shrink: 1;
		text-align: center;
		padding: 5px;
		font-weight: 600;
		flex-basis: 30%;
		line-height: 18px;
		justify-content: center;
		border-radius: 8px;
		cursor: pointer;
		text-decoration: none;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		position: relative;
		width: 100%;
		height: 100%;
		min-width: 26px;
	}

	.pnx-btn:disabled { color: var(--widget-bg-inactive); }

	.pnx-btn.pnx-btn-active,
	.pnx-btn.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-full.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-outline.pnx-btn-active:hover {
		background-color: var(--widget-bg-active);
		border-color: var(--widget-bg-active);
		color: var(--widget-font-active);
	}

	.pnx-btn .svg-inline--fa,
	.pnx-btn ::slotted(.svg-inline--fa),
	.pnx-btn slot .svg-inline--fa {
		height: 16px;
		pointer-events: none;
	}

	/* Sizing */
	.pnx-btn-sm {
		border-radius: 6px;
		line-height: 12px;
		font-size: 12px;
		min-width: unset;
	}

	.pnx-btn.pnx-btn-sm .svg-inline--fa,
	.pnx-btn.pnx-btn-sm ::slotted(.svg-inline--fa) {
		height: 12px;
	}

	.pnx-btn-l {
		border-radius: 12px;
		height: 24px;
		line-height: 24px;
		font-size: 20px;
		min-width: 24px;
	}

	.pnx-btn-xl {
		border-radius: 20px;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		min-width: 40px;
		padding: 0 10px;
		gap: 8px;
	}

	.pnx-btn.pnx-btn-xl .svg-inline--fa,
	.pnx-btn.pnx-btn-xl ::slotted(.svg-inline--fa) {
		height: 16px;
	}

	.pnx-btn-xxl {
		border-radius: 28px;
		height: 56px;
		line-height: 56px;
		font-size: 24px;
		min-width: 56px;
	}

	.pnx-btn.pnx-btn-xxl .svg-inline--fa,
	.pnx-btn.pnx-btn-xxl ::slotted(.svg-inline--fa) {
		height: 24px;
	}

	/* Fully-filled style */
	.pnx-btn-full {
		background-color: var(--widget-bg-primary);
		color: var(--widget-font-direct);
		border: none;
	}

	.pnx-btn-full:not(:disabled):hover {
		background-color: var(--widget-bg-primary-hover);
	}

	/* Fully-filled warning style */
	.pnx-btn-fullwarn {
		background-color: var(--widget-bg-warn);
		color: var(--widget-font-warn);
		border: none;
	}

	.pnx-btn-fullwarn:not(:disabled):hover {
		background-color: var(--widget-bg-warn);
	}

	/* Fully-filled danger style */
	.pnx-btn-fulldanger {
		background-color: var(--widget-bg-danger);
		color: var(--widget-font-danger);
		border: none;
	}

	.pnx-btn-fulldanger:not(:disabled):hover {
		background-color: var(--widget-bg-danger);
	}

	/* Fully-filled success style */
	.pnx-btn-fullsuccess {
		background-color: var(--widget-bg-success);
		color: var(--widget-font-success);
		border: none;
	}

	.pnx-btn-fullsuccess:not(:disabled):hover {
		background-color: var(--widget-bg-success);
	}

	/* Outline style */
	.pnx-btn-outline {
		border: 1px solid var(--widget-border-btn);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-outline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Flat style */
	.pnx-btn-flat,
	.pnx-btn-flat.pnx-btn-active,
	.pnx-btn-flat.pnx-btn-active:hover,
	.pnx-btn-flat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font);
		background-color: var(--widget-bg);
	}

	.pnx-btn-flat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superflat style */
	.pnx-btn-superflat,
	.pnx-btn-superflat.pnx-btn-active,
	.pnx-btn-superflat.pnx-btn-active:hover,
	.pnx-btn-superflat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-superflat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Inline style */
	.pnx-btn-inline,
	.pnx-btn-inline.pnx-btn-active,
	.pnx-btn-inline.pnx-btn-active:hover,
	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		border: none;
		color: var(--widget-font);
		background: none;
	}

	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superinline style */
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		color: var(--widget-font-direct);
	}
`, $a42f1354f0348298$var$No = $a42f1354f0348298$var$s`
	pnx-button-group > pnx-button {
		display: inline-flex;
	}

	pnx-button-group > pnx-button::part(btn) {
		height: unset;
	}

	/* Togglable in group */
	pnx-button-group > pnx-togglable-group > pnx-button {
		width: 100%;
		height: 100%;
	}

	/* Row */
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-left: none;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :first-child::part(btn),
	pnx-button-group[dir="row"] > :first-child > ::part(btn) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :last-child::part(btn),
	pnx-button-group[dir="row"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: none;
	}

	/* Column */
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-top: none;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :first-child::part(btn),
	pnx-button-group[dir="column"] > :first-child > ::part(btn) {
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :last-child::part(btn),
	pnx-button-group[dir="column"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-top: none;
	}
`, $a42f1354f0348298$var$Bo = $a42f1354f0348298$var$s`
	h1, h2, h3, h4, h5, h6 {
		font-family: var(--font-family);
	}
	
	h3 {
		font-size: 1.1em;
		line-height: 1.1em;
		font-weight: 500;
		margin: 10px 0 10px 0;
	}

	h4 {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
	}

	h4:first-of-type { margin-top: 0; }

	h4 > svg.svg-inline--fa {
		height: 18px;
	}

	h4[slot="title"] {
		margin: 0;
		justify-content: center;
		font-size: 0.8em;
		line-height: 2em;
		padding: 0.5em 0;
	}
	h4[slot="title"] svg.svg-inline--fa {
		height: 14px;
	}
`;
$a42f1354f0348298$var$s`
	.pnx-active-icon {
		box-sizing: border-box;
		background-color: var(--orange);
		border: 3px solid #fff;
		border-radius: 8px;
		height: 15px;
		left: 20px;
		position: absolute;
		top: 5px;
		width: 15px;
	}
`;
const $a42f1354f0348298$var$Oo = $a42f1354f0348298$var$s`
	.pnx-badge-count {
		box-sizing: border-box;
		background-color: var(--grey-pale);
		border-radius: 8px;
		right: -6px;
		position: absolute;
		top: -6px;
		width: 12px;
		height: 12px;
		font-size: 10px;
		text-align: center;
		line-height: 12px;
		font-weight: 800;
	}
`, $a42f1354f0348298$var$jo = $a42f1354f0348298$var$s`
	@keyframes animatedBackground {
		from {
			background-position: 0 0;
		}
		to {
			background-position: 1000px 0;
		}
	}

	.pnx-placeholder-loading {
		width: 100px;
		height: 100px;
		background-image: linear-gradient(
			90deg,
			#e4e4e4 0%,
			#f1f1f1 40%,
			#ededed 60%,
			#e4e4e4 100%
		);
		background-position: 0px 0px;
		background-repeat: repeat;
		animation: animatedBackground 5s linear infinite;
	}
`;
$a42f1354f0348298$var$s`
	details summary {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		cursor: pointer;
	}

	details summary svg {
		height: 18px;
		vertical-align: sub;
		margin-right: 2px;
	}
`;
const $a42f1354f0348298$var$Go = $a42f1354f0348298$var$s`
	@media print {
		.pnx-print-hidden { display: none !important; }
	}
`, $a42f1354f0348298$var$Vo = $a42f1354f0348298$var$s`
	table {
		border-collapse: collapse;
		font-size: 0.9rem;
		width: 100%;
		max-width: 100%;
		font-family: var(--font-family);
		background: var(--white);
	}

	th, td {
		padding: 10px;
		text-align: left;
		border-bottom: 1px solid #ddd;
	}

	th { font-weight: 600; }
`, $a42f1354f0348298$var$Ho = $a42f1354f0348298$var$s`
	iconify-icon {
		display: inline-block;
		width: 1em;
		height: 1em;
	}
`, $a42f1354f0348298$var$qo = $a42f1354f0348298$var$s`
	.data-block {
		display: inline-block;
		margin: 8px 0;
		box-sizing: border-box;
		vertical-align: top;
	}
	.data-block h5 {
		font-size: 0.8em;
		font-weight: 400;
		color: var(--blue-dark);
		margin: 0 0 5px 0;
		display: flex;
		align-items: center;
		gap: 5px;
	}
	.data-block h5 pnx-button { vertical-align: middle; }
	.data-block h5 svg.svg-inline--fa { height: 14px; }
	.data-block div {
		font-size: 0.8em;
	}
`, $a42f1354f0348298$var$Ko = $a42f1354f0348298$var$s`
	h4 {
		font-size: 1.3em;
		font-weight: 600;
		border-bottom: 3px solid var(--grey-pale);
		padding-bottom: 10px;
  		padding-top: 5px;
	}
`;
class $a42f1354f0348298$var$Wo extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$jo,
        $a42f1354f0348298$var$Po,
        $a42f1354f0348298$var$Io,
        $a42f1354f0348298$var$s`
		:host {
			display: flex;
			flex-direction: column;
			margin: 0;
			font-family: var(--font-family);
			flex-wrap: nowrap;
		}

		@media screen and (min-width: 576px) {
			:host {
				max-height: 70vh;
			}
		}

		/* Top bar */
		.headline {
			display: flex;
			gap: 10px;
			align-items: center;
			margin: 10px 10px 5px 10px;
			justify-content: space-between;
			flex: 1;
		}

		.headline-buttons {
			display: flex;
			gap: 5px;
			align-items: center;
		}

		/* Address line */
		#pic-legend-addr {
			line-height: 1.2em;
			font-size: 1em;
			margin-bottom: 2px;
			flex-grow: 5;
			font-weight: 800;
			text-overflow: ellipsis;
			overflow: hidden;
  			white-space: nowrap;
		}

		#pic-legend-addr span {
			display: inline-block;
			height: 100%;
			width: 100%;
		}

		/* Visibility badge */
		.visibility-badge {
			cursor: help;
			background: var(--blue);
			color: var(--white);
			border-radius: 10px;
			height: 20px;
			display: inline-flex;
			font-size: 0.8em;
			padding: 0 5px;
  			gap: 3px;
			font-size: 0.7em;
  			align-items: center;
		}

		.visibility-badge svg {
			height: 1em;
		}

		/* Minimal info block */
		#pic-legend-info {
			margin: 10px;
			display: flex;
			gap: 10px;
			justify-content: space-around;
		}
		.info-block {
			display: flex;
			flex-shrink: 1;
			gap: 5px;
			font-weight: 600;
			font-size: 0.85em;
			align-items: center;
		}
		.info-block svg { height: 18px; }

		/* Expand button */
		#pic-legend-expand {
			display: block;
			margin-top: 5px;
			max-width: 100%;
			flex: 1;
		}
		#pic-legend-expand::part(btn) {
			border-radius: 10px;
			border-top-right-radius: 0;
			border-top-left-radius: 0;
		}

		/* Details block */
		pnx-picture-metadata {
			margin: 5px 10px;
			display: block;
			box-sizing: border-box;
			flex: 1;
			overflow-y: auto;
		}

		/* Details actions */
		#pic-legend-cta {
			display: flex;
			margin: 5px 10px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			gap: 5px;
			flex-wrap: wrap;
			flex: 1;
		}

		/* More options menu */
		#pnx-legend-opts { min-width: unset; }

		/* Editors */
		#pic-legend-editors { margin: 0 10px; }

		/* Light version */
		.pnx-picture-legend-light {
			width: max-content;
			font-size: 10px;
		}
	`
    ];
    static properties = {
        light: {
            type: Boolean
        },
        _caption: {
            state: !0
        },
        _addr: {
            state: !0
        },
        _expanded: {
            state: !0
        },
        _blockOnEditor: {
            state: !0
        },
        _visibility: {
            state: !0
        },
        collapsable: {
            type: Boolean
        }
    };
    constructor(){
        super(), this._expanded = !0, this.collapsable = !1, this.light = !1;
    }
    connectedCallback() {
        super.connectedCallback(), this._expanded = !this.collapsable, this._prevSearches = {}, $a42f1354f0348298$var$Ur(this).then(()=>this._parent.onceReady()).then(()=>{
            this._onPicChange(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                this._onPicChange(this._parent.psv.getPictureMetadata());
            }), this._parent.psv.addEventListener("sequence-stopped", ()=>{
                this._onPicChange(this._parent.psv.getPictureMetadata());
            }), this._parent.psv.addEventListener("annotation-focused", ()=>{
                this._expanded = !0;
            }), this._parent._initParams.getParentPostInit().skipTagsMenuOpening || this._parent.psv.addEventListener("annotations-toggled", (e)=>{
                e.detail.visible && (this._expanded = !0);
            }), this._parent.psv.getSelectedAnnotations().length > 0 && (this._expanded = !0);
        });
    }
    _onPicChange(e) {
        if (clearTimeout(this._addrTimer1), this._caption = e?.caption, e) {
            this._visibility = e.properties?.["geovisio:visibility"] || null, "anyone" === this._visibility && (this._visibility = null);
            const t = `${e.gps[0].toFixed(4)}/${e.gps[1].toFixed(4)}`;
            this._prevSearches[t] ? this._addr = this._prevSearches[t] : this._parent.psv._sequencePlaying || (this._addr = "", this._addrTimer1 = setTimeout(()=>{
                var i, n;
                (i = e.gps[1], n = e.gps[0], fetch(`https://nominatim.openstreetmap.org/reverse?lat=${i}&lon=${n}&zoom=18&format=geocodejson`).then((e)=>e.json()).then((e)=>(function(e) {
                        if (!e || "object" != typeof e) return "";
                        let t = e.name, i = [], n = [];
                        switch(e.type){
                            case "hamlet":
                            case "croft":
                            case "isolated_dwelling":
                            case "neighbourhood":
                            case "allotments":
                            case "quarter":
                            case "farm":
                            case "farmyard":
                            case "industrial":
                            case "commercial":
                            case "retail":
                            case "city_block":
                            case "residential":
                            case "locality":
                            case "district":
                                n.push(e.city), n.push(e.county), n.push(e.state), n.push(e.country);
                                break;
                            case "city":
                            case "region":
                                n.push(e.county), n.push(e.state), n.push(e.country);
                                break;
                            case "country":
                                break;
                            case "house":
                            case "housenumber":
                                i.push(e.housenumber), i.push(e.street), i.push(e.locality), i.push(e.district), n.push(e.city), n.push(e.county), n.push(e.state), n.push(e.country);
                                break;
                            default:
                                i.push(e.street), i.push(e.locality), i.push(e.district), n.push(e.city), n.push(e.county), n.push(e.state), n.push(e.country);
                        }
                        i = i.filter((e)=>e), i = i.filter((e, n)=>e !== t && (0 === n || i[n - 1] !== e)), i = i.length > 0 ? e.housenumber ? i.slice(0, 2).join(" ") : i.shift() : null, i === t && (i = null), n = n.filter((e)=>e), n = n.filter((e, a)=>!(e === t || i && i.includes(e) || 0 !== a && n[a - 1] === e));
                        let a = [
                            t,
                            i,
                            n.shift()
                        ].filter((e)=>e);
                        return a.join(", ");
                    })(e?.features?.shift()?.properties?.geocoding))).then((e)=>{
                    clearTimeout(this._addrTimer2), this._addr = e, this._prevSearches[t] = e;
                });
            }, 500));
        } else this._visibility = null, this._addr = "";
    }
    _onBackClick() {
        this._parent.isWidthSmall() && "map" === this._parent.focus ? this._parent.select() : this._parent._setFocus?.("map");
    }
    _onDeleteClick() {
        if (confirm(this._parent?._t.pnx.delete_picture_warn)) {
            const e = this._parent.psv.getPictureMetadata(), t = e.sequence.nextPic || e.sequence.prevPic || null;
            this._parent.api.deletePicture(e.sequence.id, e.id).then(()=>{
                this._parent.psv.clearPictureMetadataCache(), this._parent.map?.reloadVectorTiles(), alert(this._parent?._t.pnx.delete_picture_ok), t ? this._parent.select(e.sequence.id, t) : this._parent.select(null, null);
            }).catch((e)=>alert(this._parent?._t.pnx.delete_picture_error.replace("{e}", e)));
        }
    }
    blockOnEditing(e) {
        this._blockOnEditor = e;
    }
    render() {
        if (!this._caption) return $a42f1354f0348298$var$q;
        const e = this._parent?.lang || window.navigator.language, t = $a42f1354f0348298$var$he({
            "pnx-hidden": this._expanded
        }), i = $a42f1354f0348298$var$he({
            "pnx-hidden": !this._expanded
        });
        return this.light ? $a42f1354f0348298$var$Do`<div class="pnx-picture-legend-light">
				${this._caption.producer?.length > 0 ? $a42f1354f0348298$var$Do`
					<a
						href=${"https://explore.panoramax.fr/?pic=" + this._parent.psv.getPictureMetadata().id}
						target="_blank"
						title=${this._parent?._t.pnx.share_page}
					>${this._caption.producer[this._caption.producer.length - 1]}</a>
				</div>` : $a42f1354f0348298$var$q}

				${this._caption.producer?.length > 0 && this._caption.date ? "-" : ""}

				${this._caption.date ? new Intl.DateTimeFormat(e, {
            timeZone: this._caption.tz,
            dateStyle: "short"
        }).format(this._caption.date) : $a42f1354f0348298$var$q}

				${(this._caption.producer?.length > 0 || this._caption.date) && this._caption?.license ? "|" : ""}

				${this._caption?.license ? $a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Co(this._caption.license)}` : $a42f1354f0348298$var$q}
			` : $a42f1354f0348298$var$Do`
			<div class=${$a42f1354f0348298$var$he({
            headline: !0,
            "pnx-hidden": this._blockOnEditor
        })}>
				${this._parent._setFocus ? $a42f1354f0348298$var$Do`
					<pnx-button
						kind="superinline"
						@click=${this._onBackClick}
					>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ls)}
					</pnx-button>
				` : $a42f1354f0348298$var$q}

				<div id="pic-legend-addr" title=${this._addr || ""}>
					${this._addr?.length > 0 ? this._addr : $a42f1354f0348298$var$Do`<span class="pnx-placeholder-loading">&nbsp;</span>`}
				</div>

				<div class="headline-buttons">
					${this._visibility ? $a42f1354f0348298$var$Do`
						<div
							class="visibility-badge"
							title=${this._parent?._t.pnx["visibility_title_" + this._visibility]}
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$vs, {
            transform: {
                size: 16
            }
        })}
							${this._parent?._t.pnx["visibility_" + this._visibility]}
						</div>
					` : $a42f1354f0348298$var$q}

					<pnx-button
						size="sm"
						class=${t}
						title=${this._parent?._t.pnx.share}
						@click=${()=>this._parent._showShareOptions()}
					>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$qr)}
					</pnx-button>

					<pnx-picture-legend-actions
						@click=${(e)=>e.stopPropagation()}
						._parent=${this._parent}
						?full=${this._expanded}
					></pnx-picture-legend-actions>
				</div>
			</div>

			<div id="pic-legend-info" class=${t}>
				${this._caption.producer?.length > 0 ? $a42f1354f0348298$var$Do`<div class="info-block">
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Xr)}
					${this._caption.producer[this._caption.producer.length - 1]}
				</div>` : $a42f1354f0348298$var$q}

				${this._caption.date ? $a42f1354f0348298$var$Do`<div class="info-block">
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Or)}
					${this._caption.date.toLocaleDateString(this._parent?.lang || window.navigator.language, {
            year: "numeric",
            month: "long",
            day: "numeric"
        })}				</div>` : $a42f1354f0348298$var$q}
			</div>

			<div id="pic-legend-cta" class=${$a42f1354f0348298$var$he({
            "pnx-hidden": !this._expanded || this._blockOnEditor
        })}>
				<pnx-button size="sm" @click=${()=>this._parent._showShareOptions()}>
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$qr)} ${this._parent?._t.pnx.share}
				</pnx-button>

				${this._parent.psv.getPictureMetadata().permissions.delete_picture ? $a42f1354f0348298$var$Do`
					<pnx-button kind="fulldanger" size="sm" @click=${this._onDeleteClick.bind(this)}>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$os)} ${this._parent?._t.pnx.delete_picture}
					</pnx-button>` : this._parent.getAPI()._endpoints.report ? $a42f1354f0348298$var$Do`
					<pnx-button kind="fullwarn" size="sm" @click=${()=>this._parent._showReportForm()}>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Fs)} ${this._parent?._t.pnx.report}
					</pnx-button>
				` : $a42f1354f0348298$var$q}

				<slot name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</div>

			<pnx-picture-metadata
				class=${i}
				.block-editor=${this._blockOnEditor}
				._parent=${this._parent}
			></pnx-picture-metadata>

			${this.collapsable && !this._blockOnEditor ? $a42f1354f0348298$var$Do`<pnx-button
				kind="inline"
				size="sm"
				id="pic-legend-expand"
				@click=${()=>this._expanded = !this._expanded}
			>${this._expanded ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Wr) : $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ms)}</pnx-button>` : $a42f1354f0348298$var$q}
		`;
    }
}
customElements.define("pnx-picture-legend", $a42f1354f0348298$var$Wo);
const $a42f1354f0348298$var$Xo = $a42f1354f0348298$var$eo("data:image/svg+xml,%3csvg viewBox='0 0 64 64' width='64' height='64' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cpath d='M 27.359486%2c12.65513 1.4316349%2c43.49917 c -3.2999082%2c3.906014 -0.53876046%2c9.96707 4.6468097%2c9.96707 H 57.934146 c 5.118225%2c0 7.946718%2c-5.993711 4.64681%2c-9.96707 L 36.653105%2c12.65513 c -2.424422%2c-2.8284931 -6.869197%2c-2.8284931 -9.293619%2c0 z' style='fill: currentColor%3bfill-opacity:1%3bstroke-width:0.673451' /%3e%3c/svg%3e", "white"), $a42f1354f0348298$var$Qo = $a42f1354f0348298$var$eo("data:image/svg+xml,%3csvg viewBox='0 0 64 192' width='64' height='192' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3ccircle cx='32' cy='32' r='29.897806' style='fill: currentColor%3bfill-opacity:1%3bstroke:white%3bstroke-width:4.20439%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1' /%3e%3cpath d='m 34.279873%2c20.262171 6.711442%2c6.714294 c 0.891465%2c0.891465 2.339986%2c0.891465 3.231451%2c0 0.891466%2c-0.891465 0.891466%2c-2.339985 0%2c-3.23145 -9.662902%2c-9.665829 -3.794285%2c-3.794286 -8.180297%2c-8.180298 -1.071396%2c-1.074322 -2.525696%2c-1.677165 -4.039972%2c-1.677165 -1.517129%2c0 -2.968576%2c0.602858 -4.042825%2c1.677165 l -8.180298%2c8.180298 c -0.894317%2c0.891465 -0.894317%2c2.339986 0%2c3.23145 0.891466%2c0.891465 2.339987%2c0.891465 3.231452%2c0 l 6.697106%2c-6.694253 v 27.703943 c 0%2c0 -0.109706%2c2.126292 2.285971%2c2.126292 2.395676%2c0 2.28597%2c-2.126292 2.28597%2c-2.126292 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke-width:0.731429' /%3e%3c/svg%3e", $a42f1354f0348298$var$Vs.NEXT);
function $a42f1354f0348298$var$Zo(e) {
    if (!([
        null,
        void 0,
        ""
    ].includes(e) || "string" == typeof e && "" === e.trim())) {
        if ("number" == typeof e) return e;
        if ("string" != typeof e) ;
        else {
            if (/^-?\d+(\.\d+)?\/-?\d+(\.\d+)?$/.test(e)) {
                const t = e.split("/").map((e)=>parseFloat(e));
                return t[0] / t[1];
            }
            try {
                return parseFloat(e);
            } catch (e) {}
        }
    }
}
function $a42f1354f0348298$var$Yo(e) {
    let t = null;
    const i = e?.properties?.["quality:horizontal_accuracy"] || $a42f1354f0348298$var$Zo(e?.properties?.exif?.["Exif.GPSInfo.GPSHPositioningError"]), n = $a42f1354f0348298$var$Zo(e?.properties?.exif?.["Exif.GPSInfo.GPSDOP"]);
    return void 0 !== i ? t = `${i} m` : void 0 !== n && (t = n < 1 ? "ideal" : n < 2 ? "excellent" : n < 5 ? "good" : n < 10 ? "moderate" : n < 20 ? "fair" : "poor"), t;
}
function $a42f1354f0348298$var$Jo(e) {
    let t = e.properties?.["view:azimuth"];
    if (void 0 === t) {
        const i = $a42f1354f0348298$var$Zo(e.properties?.exif?.["Exif.GPSInfo.GPSImgDirection"]);
        void 0 !== i && (t = i);
    }
    t = t || 0;
    let i = e.properties?.["pers:yaw"], n = [
        "Xmp.GPano.PoseHeadingDegrees",
        "Xmp.Camera.Yaw",
        "Exif.MpfInfo.MPFYawAngle"
    ];
    if (void 0 === i) for (let t of n){
        const n = $a42f1354f0348298$var$Zo(e.properties?.exif?.[t]);
        if (void 0 !== n) {
            i = n;
            break;
        }
    }
    i = i || 0, Math.round(t) === Math.round(i) && i > 0 && console.warn("Picture with UUID", e.id, "has same GPS Image direction and Yaw, could cause rendering issues");
    let a = e.properties?.["pers:pitch"];
    if (n = [
        "Xmp.GPano.PosePitchDegrees",
        "Xmp.Camera.Pitch",
        "Exif.MpfInfo.MPFPitchAngle"
    ], void 0 === a) for (let t of n){
        const i = $a42f1354f0348298$var$Zo(e.properties?.exif?.[t]);
        if (void 0 !== i) {
            a = i;
            break;
        }
    }
    a = a || 0;
    let r = e.properties?.["pers:roll"];
    if (n = [
        "Xmp.GPano.PoseRollDegrees",
        "Xmp.Camera.Roll",
        "Exif.MpfInfo.MPFRollAngle"
    ], void 0 === r) for (let t of n){
        const i = $a42f1354f0348298$var$Zo(e.properties?.exif?.[t]);
        if (void 0 !== i) {
            r = i;
            break;
        }
    }
    r = r || 0;
    return !(360 === e.properties?.["pers:interior_orientation"]?.field_of_view) && (0 !== a || 0 !== r) || 0 !== a && 0 !== r ? {
        pan: $a42f1354f0348298$var$vo(i),
        tilt: $a42f1354f0348298$var$vo(-a),
        roll: $a42f1354f0348298$var$vo(r)
    } : {};
}
function $a42f1354f0348298$var$$o(e, t) {
    let i;
    if (e.properties?.["pers:interior_orientation"] && e.properties["pers:interior_orientation"]?.visible_area && e.properties["pers:interior_orientation"]?.sensor_array_dimensions) {
        const t = e.properties["pers:interior_orientation"].visible_area, n = e.properties["pers:interior_orientation"].sensor_array_dimensions;
        try {
            i = {
                fullWidth: parseInt(n[0]),
                fullHeight: parseInt(n[1]),
                croppedX: parseInt(t[0]),
                croppedY: parseInt(t[1]),
                croppedWidth: parseInt(n[0]) - parseInt(t[2]) - parseInt(t[0]),
                croppedHeight: parseInt(n[1]) - parseInt(t[3]) - parseInt(t[1])
            };
        } catch (t) {
            console.warn("Invalid pers:interior_orientation values for cropped panorama " + e.id);
        }
    }
    if (!i && e.properties?.exif) try {
        i = {
            fullWidth: parseInt(e.properties.exif?.["Xmp.GPano.FullPanoWidthPixels"]),
            fullHeight: parseInt(e.properties.exif?.["Xmp.GPano.FullPanoHeightPixels"]),
            croppedX: parseInt(e.properties.exif?.["Xmp.GPano.CroppedAreaLeftPixels"]),
            croppedY: parseInt(e.properties.exif?.["Xmp.GPano.CroppedAreaTopPixels"]),
            croppedWidth: parseInt(e.properties.exif?.["Xmp.GPano.CroppedAreaImageWidthPixels"]),
            croppedHeight: parseInt(e.properties.exif?.["Xmp.GPano.CroppedAreaImageHeightPixels"])
        }, i.croppedWidth > i.fullWidth && (i.fullWidth = i.croppedWidth), i.croppedHeight > i.fullHeight && (i.fullHeight = i.croppedHeight);
    } catch (t) {
        console.warn("Invalid XMP.GPano values for cropped panorama " + e.id);
    }
    if (i && (i = Object.fromEntries(Object.entries(i || {}).filter((e)=>!isNaN(e[1]))), (!i.fullWidth && !i.croppedWidth && i.fullHeight && !i.croppedHeight || i.fullWidth && !i.croppedWidth && !i.fullHeight && !i.croppedHeight || i.fullWidth && !i.croppedWidth && i.fullHeight && !i.croppedHeight || i.fullWidth == i.croppedWidth && i.fullHeight == i.croppedHeight) && (i = {})), i?.fullWidth && t?.width) {
        let e = t.width / (i?.croppedWidth || i.fullWidth);
        i = {
            fullWidth: void 0 !== i.fullWidth ? Math.floor(i.fullWidth * e) : void 0,
            fullHeight: void 0 !== i.fullHeight ? Math.floor(i.fullHeight * e) : void 0,
            croppedWidth: void 0 !== i.croppedWidth ? Math.floor(i.croppedWidth * e) : void 0,
            croppedHeight: void 0 !== i.croppedHeight ? Math.floor(i.croppedHeight * e) : void 0,
            croppedX: void 0 !== i.croppedX ? Math.floor(i.croppedX * e) : void 0,
            croppedY: void 0 !== i.croppedY ? Math.floor(i.croppedY * e) : void 0
        };
    }
    return i || {};
}
function $a42f1354f0348298$var$el(e) {
    return (t, i)=>"related" !== t.rel && "related" !== i.rel ? 0 : "related" !== t.rel ? -1 : "related" !== i.rel ? 1 : t.date === i.date ? $a42f1354f0348298$var$Js(e, t.geometry.coordinates) - $a42f1354f0348298$var$Js(e, i.geometry.coordinates) : i.date.localeCompare(t.date);
}
function $a42f1354f0348298$var$tl(e, t) {
    return e.is360 !== t.is360 ? e.is360 : e.density !== t.density ? e.density > t.density : e.dist < t.dist;
}
function $a42f1354f0348298$var$il(e, t) {
    const i = {};
    if (e?.properties?.datetimetz) {
        i.date = new Date(e.properties.datetimetz);
        const t = e.properties.datetimetz.match(/([+-]\d{2}):(\d{2})$|Z$/);
        t && ("Z" === t[0] ? i.tz = "UTC" : i.tz = t[0]);
    } else e?.properties?.datetime && (i.date = new Date(e.properties.datetime));
    const n = e?.providers || e?.properties?.providers;
    if (n) {
        let e = n.filter((e)=>e?.roles?.includes("producer"));
        if (0 === e?.length && (e = n.filter((e)=>e?.roles?.includes("host"))), e?.length >= 0) {
            const t = {};
            e.map((e)=>e.name).forEach((e)=>{
                const i = e.toLowerCase().replace(/\s/g, "");
                t[i] ? t[i].push(e) : t[i] = [
                    e
                ];
            }), i.producer = [], Object.values(t).forEach((e)=>{
                const t = e[0], n = e.find((e)=>e.toLowerCase() !== e);
                i.producer.push(n || t);
            });
        }
    }
    if (e?.properties?.license && (i.license = e.properties.license, e?.links)) {
        const n = e.links.find((e)=>"license" === e?.rel);
        n && (i.license = `<a href="${n.href}" title="${t.pnx.metadata_general_license_link}" target="_blank">${i.license}</a>`);
    }
    return i;
}
function $a42f1354f0348298$var$nl(e, t, i = !1, n = null, a = (e)=>e) {
    const r = null != e.properties?.["pers:interior_orientation"]?.field_of_view;
    let s = r ? parseInt(e.properties["pers:interior_orientation"].field_of_view) : 70;
    const o = 360 === s, l = a((Object.values(e.assets).find((e)=>e?.roles?.includes("data")) || {}).href), c = e?.properties?.["tiles:tile_matrix_sets"]?.geovisio, d = e.links?.find?.((e)=>"prev" === e?.rel && "application/geo+json" === e?.type), u = e.links?.find?.((e)=>"next" === e?.rel && "application/geo+json" === e?.type), h = Object.values(e.assets).find((e)=>e.roles?.includes("visual") && "image/webp" === e.type), p = Object.values(e.assets).find((e)=>e.roles?.includes("visual") && "image/jpeg" === e.type), A = a((h || p).href), m = a(Object.values(e.assets).find((e)=>e.roles?.includes("thumbnail") && "image/jpeg" === e.type)?.href), g = e?.asset_templates?.tiles_webp || e?.asset_templates?.tiles, f = $a42f1354f0348298$var$$o(e), _ = e.links?.find?.((e)=>"via" === e?.rel && "application/json" === e?.type), v = e.properties?.["pers:interior_orientation"]?.sensor_array_dimensions;
    let E;
    if (Object.keys(f).length > 0) E = {
        baseUrl: i ? l : A,
        origBaseUrl: i ? l : A,
        hdUrl: l,
        thumbUrl: m,
        basePanoData: i ? f : (t)=>$a42f1354f0348298$var$$o(e, t),
        cropData: f,
        width: f.fullWidth,
        cols: 2,
        rows: 1,
        tileUrl: ()=>null
    };
    else if (o && c) E = {
        baseUrl: A,
        origBaseUrl: A,
        basePanoData: (e)=>({
                fullWidth: e.width,
                fullHeight: e.height
            }),
        hdUrl: l,
        thumbUrl: m,
        cols: c && c.tileMatrix[0].matrixWidth,
        rows: c && c.tileMatrix[0].matrixHeight,
        width: c && c.tileMatrix[0].matrixWidth * c.tileMatrix[0].tileWidth,
        tileUrl: c && ((e, t)=>a(g.href.replace(/\{TileCol\}/g, e).replace(/\{TileRow\}/g, t)))
    };
    else {
        const e = (e)=>{
            e.width < e.height && !r && (s = 35);
            const t = s * e.height / e.width, i = 360 * e.width / s, n = 180 * e.height / t;
            return {
                fullWidth: Math.floor(i),
                fullHeight: Math.floor(n),
                croppedWidth: e.width,
                croppedHeight: e.height,
                croppedX: Math.floor((i - e.width) / 2),
                croppedY: Math.floor((n - e.height) / 2)
            };
        };
        let t = v ? e({
            width: v[0],
            height: v[1]
        }) : null;
        E = {
            baseUrl: i ? l : A,
            origBaseUrl: i ? l : A,
            hdUrl: l,
            thumbUrl: m,
            basePanoData: e,
            cropData: t,
            width: t?.fullWidth || 2,
            cols: 2,
            rows: 1,
            tileUrl: ()=>null
        };
    }
    e.properties?.semantics && (e.properties.semantics = e.properties.semantics.filter((e)=>Object.keys(e).length > 0));
    return {
        id: e.id,
        caption: $a42f1354f0348298$var$il(e, t),
        panorama: E,
        links: $a42f1354f0348298$var$al(e, n),
        origLinks: e.links,
        gps: e.geometry.coordinates,
        sequence: {
            id: e.collection,
            nextPic: u ? u.id : void 0,
            prevPic: d ? d.id : void 0
        },
        sphereCorrection: $a42f1354f0348298$var$Jo(e),
        horizontalFov: s,
        origInstance: _,
        properties: e.properties,
        permissions: $a42f1354f0348298$var$rl(e)
    };
}
function $a42f1354f0348298$var$al(e, t = null) {
    const i = e.links.filter((e)=>[
            "next",
            "prev",
            "related"
        ].includes(e?.rel) && "application/geo+json" === e?.type).filter((e)=>!t || t(e)).map((e)=>(e.datetime && (e.date = e.datetime.split("T")[0]), e)), n = e.geometry.coordinates, a = [], r = {
        N: [],
        ENE: [],
        ESE: [],
        S: [],
        WSW: [],
        WNW: []
    };
    for (let e of i)r[$a42f1354f0348298$var$so(n, e.geometry.coordinates)].push(e);
    for(let e in r){
        const t = r[e];
        0 !== t.length && (t.sort($a42f1354f0348298$var$el(n)), a.push(t.shift()));
    }
    let s = (e)=>"related" === e.rel ? {
            element: $a42f1354f0348298$var$to($a42f1354f0348298$var$Qo),
            size: {
                width: 128 / 3,
                height: 128
            }
        } : {
            element: $a42f1354f0348298$var$to($a42f1354f0348298$var$Xo),
            size: {
                width: 75,
                height: 75
            }
        };
    const o = -$a42f1354f0348298$var$vo(e.properties?.["view:azimuth"] || 0);
    return a.map((e)=>({
            nodeId: e.id,
            gps: e.geometry.coordinates,
            arrowStyle: s(e),
            linkOffset: {
                yaw: o
            }
        }));
}
function $a42f1354f0348298$var$rl(e) {
    let t = !1, i = !1;
    return e.links.find((e)=>"PATCH" === e.method && e.attributes.includes("semantics")) && e.links.find((e)=>"POST" === e.method && "add_annotation" === e.rel) && (t = !0), e.links.find((e)=>"DELETE" === e.method && "delete" === e.rel) && (i = !0), {
        edit_semantics: t,
        delete_picture: i
    };
}
function $a42f1354f0348298$var$sl(e) {
    return e?.properties?.annotations?.length > 0;
}
var $a42f1354f0348298$var$ol = Object.freeze({
    __proto__: null,
    apiFeatureToPSVNode: $a42f1354f0348298$var$nl,
    filterRelatedPicsLinks: $a42f1354f0348298$var$al,
    getCroppedPanoData: $a42f1354f0348298$var$$o,
    getExifFloat: $a42f1354f0348298$var$Zo,
    getGPSPrecision: $a42f1354f0348298$var$Yo,
    getHashTags: function(e) {
        if (!e?.properties?.semantics) return [];
        const t = e.properties.semantics.filter((e)=>"hashtags" === e.key), i = [];
        return t.forEach((e)=>e.value.split(";").forEach((e)=>i.push(e.trim()))), i;
    },
    getNodeCaption: $a42f1354f0348298$var$il,
    getPermissions: $a42f1354f0348298$var$rl,
    getSphereCorrection: $a42f1354f0348298$var$Jo,
    hasAnnotations: $a42f1354f0348298$var$sl,
    pickBestPerMonth: function(e, t) {
        const i = new Map;
        for (const n of e || []){
            if (!n?.date || !n?.coords) continue;
            const e = n.date.slice(0, 7), a = {
                month: e,
                date: n.date,
                id: n.id,
                seqId: n.seqId,
                coords: n.coords,
                is360: !!n.is360,
                density: n.density || 0,
                thumb: n.thumb || null,
                heading: n.heading ?? null,
                dist: $a42f1354f0348298$var$Js(t, n.coords)
            }, r = i.get(e);
            r && !$a42f1354f0348298$var$tl(a, r) || i.set(e, a);
        }
        return [
            ...i.values()
        ].map(({ month: e, date: t, id: i, seqId: n, coords: a, is360: r, density: s, thumb: o, heading: l })=>({
                month: e,
                date: t,
                id: i,
                seqId: n,
                coords: a,
                is360: r,
                density: s,
                thumb: o,
                heading: l
            })).sort((e, t)=>t.month.localeCompare(e.month));
    },
    sortPicturesInDirection: $a42f1354f0348298$var$el
});
const $a42f1354f0348298$var$ll = ()=>$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ts, {
        styles: {
            height: "16px"
        }
    });
class $a42f1354f0348298$var$cl extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$Bo,
        $a42f1354f0348298$var$Ro,
        $a42f1354f0348298$var$Io,
        $a42f1354f0348298$var$qo,
        $a42f1354f0348298$var$s`
		div[slot="content"] {
			padding: 5px 10px;
			background-color: #ededed;
		}

		.data-block {
			min-width: 50%;
		}

		pnx-semantics-table {
			overflow-x: auto;
  			display: block;
		}
	`
    ];
    static properties = {
        _meta: {
            state: !0
        },
        "block-editor": {
            type: Boolean
        }
    };
    connectedCallback() {
        super.connectedCallback();
        const e = ()=>{
            const e = this.shadowRoot.querySelector("pnx-tabs");
            e && e.setAttribute("activeTabIndex", 4);
        };
        window.navigation?.addEventListener("navigate", ()=>{
            this.requestUpdate();
        }), $a42f1354f0348298$var$Ur(this).then(()=>{
            this._meta = this._parent?.psv?.getPictureMetadata(), this._parent?.oncePSVReady?.().then(()=>{
                this._parent.psv.addEventListener("picture-loaded", ()=>{
                    this._meta = this._parent.psv.getPictureMetadata();
                }), this._parent._initParams.getParentPostInit().skipTagsMenuOpening || (this._parent.psv.addEventListener("annotation-focused", e), this._parent.psv.addEventListener("annotations-toggled", (t)=>{
                    t.detail.visible && setTimeout(e, 250);
                }), this._parent.psv.getSelectedAnnotations().length > 0 && e());
            });
        });
    }
    _onQualityScoreClick() {
        const e = this.shadowRoot.querySelector("pnx-tabs");
        e && e.setAttribute("activeTabIndex", 3);
    }
    _onCaptureDateClick() {
        const e = this.shadowRoot.querySelector("pnx-tabs");
        e && e.setAttribute("activeTabIndex", 1);
    }
    _toTab(e, t) {
        return $a42f1354f0348298$var$Do`
			<h4 slot="title">${e}</h4>
			<div slot="content" class="data-blocks">
				${t.filter((e)=>e).map((e)=>$a42f1354f0348298$var$Do`<div class="data-block" style=${e.style}>
					<h5>${e.title}</h5>
					<div style=${e.content_style} @click=${e.click}>${e.content}</div>
				</div>`)}
			</div>
		`;
    }
    render() {
        if (!this._meta) return $a42f1354f0348298$var$q;
        const e = this._parent?.lang || window.navigator.language, t = this._meta?.properties?.["pers:interior_orientation"], i = [
            t.camera_manufacturer,
            t.camera_model
        ].filter((e)=>e).join(" "), n = t?.focal_length ? `${t?.focal_length} mm` : $a42f1354f0348298$var$ll();
        let a = t?.sensor_array_dimensions;
        a && (a = `${a[0]} x ${a[1]} px (${Math.floor(a[0] * a[1] / 1e6)} Mpx)`);
        let r = this._parent?._t.pnx.picture_flat, s = this._parent?._t.pnx.picture_flat_long, o = t?.field_of_view;
        null != o && (360 === o ? (r = this._parent?._t.pnx.picture_360, s = this._parent?._t.pnx.picture_360_long) : r += ` (${o}\xb0)`);
        const l = [
            {
                title: this._parent?._t.pnx.metadata_camera_make,
                content: t?.camera_manufacturer || $a42f1354f0348298$var$ll()
            },
            {
                title: this._parent?._t.pnx.metadata_camera_model,
                content: t?.camera_model || $a42f1354f0348298$var$ll()
            },
            {
                title: this._parent?._t.pnx.metadata_camera_type,
                content: r
            },
            {
                title: this._parent?._t.pnx.metadata_camera_resolution,
                content: a || $a42f1354f0348298$var$ll()
            },
            {
                title: this._parent?._t.pnx.metadata_camera_focal_length,
                content: n
            },
            this._meta?.caption?.date && {
                title: this._parent?._t.pnx.metadata_general_date,
                content: $a42f1354f0348298$var$Do`
					<strong>${new Intl.DateTimeFormat(e, {
                    timeZone: this._meta.caption.tz,
                    dateStyle: "short"
                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(e, {
                    timeZone: this._meta.caption.tz,
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    fractionalSecondDigits: 3,
                    timeZoneName: "longOffset"
                }).format(this._meta.caption.date)}
				`
            }
        ], c = void 0 !== this._meta?.properties?.["view:azimuth"] && `${this._meta.properties["view:azimuth"]}\xb0`, d = [
            {
                title: this._parent?._t.pnx.metadata_location_coordinates,
                content: $a42f1354f0348298$var$Do`
					${this._meta.gps[0].toFixed(5)}, ${this._meta.gps[1].toFixed(5)}
					<pnx-copy-coordinates
						._parent=${this._parent}
						.gps=${this._meta.gps}
						style="margin-left: 10px"
					></pnx-copy-coordinates>
				`,
                style: "width: 100%"
            },
            {
                title: this._parent?._t.pnx.metadata_location_orientation,
                content: c || $a42f1354f0348298$var$ll()
            },
            {
                title: this._parent?._t.pnx.metadata_location_precision,
                content: $a42f1354f0348298$var$Yo(this._meta) || $a42f1354f0348298$var$ll()
            }
        ], u = this._parent?.map?._hasQualityScore?.() || this._meta?.properties?.["quality:horizontal_accuracy"] || this._meta?.properties?.["panoramax:horizontal_pixel_density"];
        let h, p;
        if (u) {
            const e = $a42f1354f0348298$var$Ys($a42f1354f0348298$var$Xs, this._meta?.properties?.["quality:horizontal_accuracy"]), t = $a42f1354f0348298$var$Ys(360 === this._meta?.horizontalFov ? $a42f1354f0348298$var$Ws : $a42f1354f0348298$var$Ks, this._meta?.properties?.["panoramax:horizontal_pixel_density"]);
            p = Math.round(.8 * (t || 1) + .2 * (e || 1)), h = [
                {
                    title: $a42f1354f0348298$var$Do`
						${this._parent?._t.pnx.metadata_quality_score}
						<pnx-button
							title="${this._parent?._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>this._parent?._showQualityScoreDoc()}
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$us)}
						</pnx-button>
					`,
                    content: $a42f1354f0348298$var$Do`<pnx-quality-score grade=${p} style="font-size: 16px"></pnx-quality-score>`,
                    style: "width: 100%"
                },
                {
                    title: this._parent?._t.pnx.metadata_quality_gps_score,
                    content: $a42f1354f0348298$var$Rr("pnx-grade", {
                        stars: e,
                        _t: this._parent?._t
                    })
                },
                {
                    title: this._parent?._t.pnx.metadata_quality_resolution_score,
                    content: $a42f1354f0348298$var$Rr("pnx-grade", {
                        stars: t,
                        _t: this._parent?._t
                    })
                }
            ];
        }
        const A = Object.entries(this._meta?.properties?.exif || {}).sort().filter(([, e])=>e).map(([e, t])=>(JSON.stringify(t).includes("\\u") && (t = JSON.stringify(t).replace(/\\u[0-9A-Fa-f]{4}/g, (e)=>" 0x" + parseInt(e.slice(2), 16).toString(16).toUpperCase().padStart(4, "0")).slice(1, -1).trim()), {
                title: e,
                content: t.length > 30 ? $a42f1354f0348298$var$Do`<textarea readonly .value=${t}></textarea>` : t,
                style: t.length > 30 ? "width: 100%" : void 0
            }));
        A.unshift({
            content: $a42f1354f0348298$var$Do`
				<pnx-link-button
					size="sm"
					target="_blank"
					href="https://exiv2.org/metadata.html"
					title=${this._parent?._t.pnx.metadata_exif_doc_title}
				>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$us)} ${this._parent?._t.pnx.metadata_exif_doc}</pnx-link-button>
			`,
            style: "width: 100%"
        });
        const m = [
            this._meta.properties.title?.length > 0 && {
                title: this._parent?._t.pnx.metadata_general_title,
                content: this._meta.properties.title
            },
            this._meta?.caption?.producer?.length > 0 && {
                title: this._parent?._t.pnx.metadata_general_author,
                content: $a42f1354f0348298$var$Do`
					<strong>${this._meta.caption.producer[this._meta.caption.producer.length - 1]}</strong>
					${this._meta.caption.producer.length > 1 ? $a42f1354f0348298$var$Do`<br />${this._meta.caption.producer.slice(0, -1).join(", ")}` : $a42f1354f0348298$var$q}
				`
            },
            this._meta?.caption?.date && {
                title: this._parent?._t.pnx.metadata_general_date,
                click: this._onCaptureDateClick,
                content_style: "cursor: pointer",
                content: $a42f1354f0348298$var$Do`
					<strong>${new Intl.DateTimeFormat(e, {
                    timeZone: this._meta.caption.tz,
                    dateStyle: "long"
                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(e, {
                    timeZone: this._meta.caption.tz,
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric"
                }).format(this._meta.caption.date)}
				`
            },
            t && {
                title: this._parent?._t.pnx.metadata_camera,
                content: $a42f1354f0348298$var$Do`
					<strong>${i.length > 0 ? i : $a42f1354f0348298$var$ll()}</strong>
					<br />${s}
				`
            },
            this._meta?.caption?.license && {
                title: this._parent?._t.pnx.metadata_general_license,
                content: $a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Co(this._meta.caption.license)}`
            },
            u && {
                title: this._parent?._t.pnx.metadata_quality,
                click: this._onQualityScoreClick,
                content: $a42f1354f0348298$var$Do`<pnx-quality-score
					grade=${p}
					style="font-size: 14px; cursor: pointer"
				/>`
            },
            {
                title: this._parent?._t.pnx.metadata_general_copy_id,
                content_style: "display: flex; gap: 5px;",
                content: $a42f1354f0348298$var$Do`
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${this._parent?._t}
						text=${this._meta.id}
						title=${this._meta.id}
						style="flex: 1"
					>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Yr)} ${this._parent?._t.pnx.metadata_general_picid}
					</pnx-copy-button>
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${this._parent?._t}
						text=${this._meta.sequence.id}
						title=${this._meta.sequence.id}
						style="flex: 1"
					>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$gs)} ${this._parent?._t.pnx.metadata_general_seqid}
					</pnx-copy-button>
				`
            },
            this._meta?.origInstance && {
                title: this._parent?._t.pnx.metadata_general_instance,
                content: $a42f1354f0348298$var$Do`<strong>
					<a href=${this._meta.origInstance.href + window.location.search} target="_blank" style="text-decoration: none">
						<img
							src=${"https://explore.panoramax.fr/api/instances/" + this._meta.origInstance.instance_name + "/logo"}
							style="height: 30px; max-width: 150px; vertical-align: middle"
							alt=""
						/>
						<span style="text-decoration: underline">
							${this._meta.origInstance.instance_name || this._meta.origInstance.href.replace(/^http.?:\/\//, "")}
						</span>
					</a>
				</strong>`
            }
        ];
        return $a42f1354f0348298$var$Do`<pnx-tabs .hideNav=${this["block-editor"]}>
			${this._toTab($a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Yr)} ${this._parent?._t.pnx.metadata_summary}`, m)}

			${this._toTab($a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$hs)} ${this._parent?._t.pnx.metadata_camera}`, l)}

			${this._toTab($a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ys)} ${this._parent?._t.pnx.metadata_location}`, d)}

			${u ? this._toTab($a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Es)} ${this._parent?._t.pnx.metadata_quality}`, h) : $a42f1354f0348298$var$q}

			<h4 slot="title">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ns)} ${this._parent?._t.pnx.semantics_title}</h4>
			<div slot="content" class="data-blocks">
				<pnx-semantics-metadata ._parent=${this._parent}></pnx-semantics-metadata>
			</div>

			${this._meta.properties?.exif ? this._toTab($a42f1354f0348298$var$Do`${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Jr)} ${this._parent?._t.pnx.metadata_exif}`, A) : $a42f1354f0348298$var$q}
		</pnx-tabs>`;
    }
}
customElements.define("pnx-picture-metadata", $a42f1354f0348298$var$cl);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const $a42f1354f0348298$var$dl = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"
    ]
}, $a42f1354f0348298$var$ul = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
var $a42f1354f0348298$var$hl = "data:image/png;base64,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", $a42f1354f0348298$var$pl = "data:image/png;base64,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";
const $a42f1354f0348298$var$Al = 125, $a42f1354f0348298$var$ml = 50, $a42f1354f0348298$var$gl = -45, $a42f1354f0348298$var$fl = 1e-4;
class $a42f1354f0348298$var$_l {
    constructor(e, t = !0){
        this.psv = e, this.isDesktop = t, this.isDesktop && (this._cursor = document.createElement("img"), this._cursor.src = $a42f1354f0348298$var$hl, this.psv.container.appendChild(this._cursor), this._cursor.style.width = "125px", this._cursor.style.height = "125px", this._cursor.style.position = "absolute", this._cursor.style.zIndex = 10, this._cursor.style.pointerEvents = "none", this._cursor.style.display = "none", this._hideCursor = !1), this._couldGoSomewhere = !1, this._mapPreviewPic = null, this.psv.container.addEventListener("mousemove", this._onPointerMove.bind(this)), this.psv.container.addEventListener("mouseleave", this._onPointerLeave.bind(this)), this.psv._myMarkers.addEventListener("enter-marker", this._onHoverOtherStuff.bind(this)), this.psv._myMarkers.addEventListener("leave-marker", this._onLeaveOtherStuff.bind(this)), this.psv._myVTour.addEventListener("enter-arrow", this._onHoverOtherStuff.bind(this)), this.psv._myVTour.addEventListener("leave-arrow", this._onLeaveOtherStuff.bind(this)), this.psv.addEventListener("sequence-playing", this._onHoverOtherStuff.bind(this)), this.psv.addEventListener("sequence-stopped", this._onLeaveOtherStuff.bind(this)), this.psv.addEventListener("sequence-playing", this._onHoverOtherStuff.bind(this)), this.psv.addEventListener("pictures-navigation-changed", this._onPSVPicNavChanged.bind(this)), this.psv.addEventListener("click", this._onClick.bind(this));
    }
    async _onClick(e) {
        if (this.psv._sequencePlaying || "pic" === this.psv.getPicturesNavigation() || this.psv._myVTour.state.loadingNode || this.psv.getSelectedAnnotations().length > 0 || this.psv._parent.map && this.psv._parent.isMapWide?.()) return;
        if (e.stopPropagation(), this._mapPreviewPic) return this.psv._keepSameAngle = !0, this.psv._parent.select(this._mapPreviewPic.collection, this._mapPreviewPic.id), void (this._mapPreviewPic = null);
        const t = this.psv.getPictureMetadata();
        if (!t) return;
        let i = Math.min(this._pitchDegToProjectedDistance($a42f1354f0348298$var$_o(e.data.pitch), $a42f1354f0348298$var$vl(t)), $a42f1354f0348298$var$ml);
        if (i > 0) {
            this._couldGoSomewhere = !0;
            const n = ($a42f1354f0348298$var$_o(e.data.yaw) + this.psv.getPictureOriginalHeading()) % 360, a = $a42f1354f0348298$var$El(t.gps, i, n);
            let r;
            this.psv._parent.map && (r = this._getMapNearbyPictures(a)), r && 0 !== r?.length || (r = (await this.psv._parent.api.getPicturesAroundCoordinates(a[1], a[0], $a42f1354f0348298$var$fl, 50))?.features);
            const s = this._bestPicAround(t, a, n, r);
            s ? (this.psv._keepSameAngle = !0, this.psv._parent.select(s.collection, s.id)) : this.isDesktop && (this._cursor.src = $a42f1354f0348298$var$pl, setTimeout(()=>this._cursor.src = $a42f1354f0348298$var$hl, 1500));
        } else this._couldGoSomewhere = !1;
    }
    _onPointerMove(e) {
        this._couldGoSomewhere = !1;
        const t = this.psv.getPositionFromEvent(e);
        if (!t || "pic" === this.psv.getPicturesNavigation() || this.psv.getSelectedAnnotations().length > 0 || this.psv._parent.map && this.psv._parent.isMapWide?.()) return;
        const i = this.psv._parent?.map, n = this.psv.getPictureMetadata();
        if (!n) return;
        let a = Math.min(this._pitchDegToProjectedDistance($a42f1354f0348298$var$_o(t.pitch), $a42f1354f0348298$var$vl(n)), $a42f1354f0348298$var$ml);
        if (!this._hideCursor && a > 0) {
            if (this._couldGoSomewhere = !0, this.isDesktop) {
                const r = function(e) {
                    const t = ((e = Math.max(Math.min(e, 0), $a42f1354f0348298$var$gl)) - $a42f1354f0348298$var$gl) / 45, i = .2;
                    return Math.max(1 - Math.exp(-Math.pow(t - 1, 2) / (2 * i * i)), .4);
                }($a42f1354f0348298$var$_o(t.pitch)), s = 50 * r, o = $a42f1354f0348298$var$Al * r;
                this._cursor.style.top = e.layerY - 3 * s / 5 + "px", this._cursor.style.left = e.layerX - o / 2 + "px", this._cursor.style.height = `${s}px`, this._cursor.style.width = `${o}px`, this._cursor.style.display = "block", clearTimeout(this._throttledBestPicMap), this._throttledBestPicMap = setTimeout(()=>{
                    const e = ($a42f1354f0348298$var$_o(t.yaw) + this.psv.getPictureOriginalHeading()) % 360, r = $a42f1354f0348298$var$El(n.gps, a, e), s = this._getMapNearbyPictures(r);
                    if (s?.length > 0) {
                        const e = ($a42f1354f0348298$var$_o(t.yaw) + this.psv.getPictureOriginalHeading()) % 360, r = $a42f1354f0348298$var$El(n.gps, a, e), o = this._bestPicAround(n, r, e, s);
                        o ? (this._cursor.src = $a42f1354f0348298$var$hl, this._mapPreviewPic = o, i._picMarkerPreview.setLngLat(o.geometry.coordinates).setRotation(360 === o.properties?.["pers:interior_orientation"]?.field_of_view ? this.psv.getXYZ().x || 0 : o.properties?.["view:azimuth"] || 0).addTo(i)) : (this._cursor.src = $a42f1354f0348298$var$pl, i._picMarkerPreview?.remove(), this._mapPreviewPic = null);
                    } else this._cursor.src = $a42f1354f0348298$var$hl, this._mapPreviewPic = null, i && (this._isMapShowingPictures() || 0 === this._getMapNearbySequences(r).length) ? (this._cursor.src = $a42f1354f0348298$var$pl, i?._picMarkerPreview?.remove()) : (this._cursor.src = $a42f1354f0348298$var$hl, i?._picMarkerPreview.setLngLat(r).setRotation(e).addTo(i));
                }, 10);
            }
        } else this.isDesktop && (this._cursor.style.display = "none", this._mapPreviewPic = null, this._hideCursor || i?._picMarkerPreview?.remove());
    }
    _onPointerLeave() {
        this.isDesktop && (this._cursor.style.display = "none"), this._couldGoSomewhere = !1;
    }
    _onHoverOtherStuff() {
        this._hideCursor = !0, this._onPointerLeave();
    }
    _onLeaveOtherStuff() {
        this._hideCursor = !1;
    }
    _onPSVPicNavChanged(e) {
        if ("pic" === e?.detail?.value) this._onHoverOtherStuff();
        else this._onLeaveOtherStuff();
    }
    _pitchDegToProjectedDistance(e, t) {
        return t ? this.isDesktop ? e >= 30 ? 0 : e >= -2.5 ? $a42f1354f0348298$var$ml : e >= -6 ? 25 : e >= -15 ? 12.5 : e >= $a42f1354f0348298$var$gl ? 6.25 : 0 : e >= 20 ? 0 : e >= 4 ? $a42f1354f0348298$var$ml / 3 : e >= -4 ? $a42f1354f0348298$var$ml / 1.5 : e >= -20 ? $a42f1354f0348298$var$ml / 3 : 0 : $a42f1354f0348298$var$ml / 3;
    }
    _isMapShowingPictures() {
        if (this.psv._parent.map) {
            const e = this.psv._parent.map;
            let t = e.getLayersOrder().find((e)=>e.endsWith("pictures"));
            if (t) return e.queryRenderedFeatures({
                layers: [
                    t
                ]
            }).length > 0;
        }
        return !1;
    }
    _getMapNearbyPictures(e) {
        const t = this.psv._parent.map;
        if (t) {
            const i = this.psv._parent?.mapStyleComposer;
            if (i) {
                const n = Object.keys(i.layerRanges.panoramax[i.panoramax].sources)[0];
                if (n) return t.querySourceFeatures(n, {
                    sourceLayer: "pictures",
                    filter: [
                        "within",
                        {
                            type: "Polygon",
                            coordinates: [
                                [
                                    [
                                        e[0] - $a42f1354f0348298$var$fl,
                                        e[1] - $a42f1354f0348298$var$fl
                                    ],
                                    [
                                        e[0] + $a42f1354f0348298$var$fl,
                                        e[1] - $a42f1354f0348298$var$fl
                                    ],
                                    [
                                        e[0] + $a42f1354f0348298$var$fl,
                                        e[1] + $a42f1354f0348298$var$fl
                                    ],
                                    [
                                        e[0] - $a42f1354f0348298$var$fl,
                                        e[1] + $a42f1354f0348298$var$fl
                                    ],
                                    [
                                        e[0] - $a42f1354f0348298$var$fl,
                                        e[1] - $a42f1354f0348298$var$fl
                                    ]
                                ]
                            ]
                        }
                    ]
                }).map((e)=>({
                        id: e.properties.id,
                        collection: e.properties.first_sequence || e.properties?.sequences?.[0],
                        geometry: e.geometry,
                        properties: {
                            datetime: e.properties.datetime || e.properties.ts,
                            "view:azimuth": e.properties?.["view:azimuth"] || e.properties.heading,
                            "pers:interior_orientation": e.properties?.["pers:interior_orientation"] || {
                                field_of_view: "equirectangular" === e.properties.type ? 360 : void 0
                            }
                        }
                    }));
            }
        }
        return null;
    }
    _getMapNearbySequences(e) {
        const t = this.psv._parent.map;
        if (t) {
            const i = t.getLayersOrder().find((e)=>e.endsWith("sequences"));
            if (i) {
                const n = 25e-6, a = [
                    t.project([
                        e[0] - n,
                        e[1] - n
                    ]),
                    t.project([
                        e[0] + n,
                        e[1] + n
                    ])
                ];
                return t.queryRenderedFeatures(a, {
                    layers: [
                        i
                    ]
                });
            }
        }
        return [];
    }
    _bestPicAround(e, t, i, n) {
        if (!Array.isArray(n) || !n.length) return null;
        const a = new Date(e.properties?.datetime), r = n.filter((t)=>t.id !== e.id).map((n)=>{
            const r = 360 === n.properties?.["pers:interior_orientation"]?.field_of_view, s = $a42f1354f0348298$var$Js(t, n.geometry.coordinates), o = n.collection === e.sequence?.id || "any" === this.psv.getPicturesNavigation(), l = n.properties?.["view:azimuth"], c = r || "number" == typeof l && $a42f1354f0348298$var$no(i, l) <= 45, d = Math.abs((i - $a42f1354f0348298$var$io(e.gps, n.geometry.coordinates)) % 360) <= 45, u = new Date(n.properties?.datetime), h = a.toDateString() === u.toDateString(), p = Math.abs((a - u) / 864e5);
            let A = !0;
            if (this.psv._parent.map) {
                const e = this.psv._parent.map;
                e.indoorEqual && "-1000" !== e.indoorEqual.level && (A = e._indoorFeaturesIDs.pictures[e.indoorEqual.level]?.has(n.id), A || "0" !== e.indoorEqual.level || (A = !0, Object.entries(e._indoorFeaturesIDs.pictures).forEach(([e, t])=>{
                    A && "0" !== e && (A = !t.has(n.id));
                })));
            }
            let m = 1 / 0;
            return o && d && A && (h && r ? m = 1 : r && p <= 30 ? m = 2 : c && p <= 30 ? m = 3 : r ? m = 4 : c && (m = 5)), {
                p: n,
                category: m,
                dist: s,
                daysDiff: p,
                headingMatch: c,
                sameDay: h,
                is360: r
            };
        });
        if (!r.length) return null;
        r.sort((e, t)=>e.category !== t.category ? e.category - t.category : e.dist !== t.dist ? e.dist - t.dist : e.daysDiff !== t.daysDiff ? e.daysDiff - t.daysDiff : 0);
        const s = r[0];
        return s.category < 1 / 0 ? s.p : null;
    }
}
function $a42f1354f0348298$var$vl(e) {
    return 360 === e.properties?.["pers:interior_orientation"]?.field_of_view || void 0 !== e?.properties?.["pers:roll"] || void 0 !== e?.properties?.["pers:pitch"];
}
function $a42f1354f0348298$var$El(e, t, i) {
    const [n, a] = e, r = $a42f1354f0348298$var$vo(a), s = $a42f1354f0348298$var$vo(n), o = $a42f1354f0348298$var$vo(i), l = t / 6378137, c = Math.sin(r), d = Math.cos(r), u = Math.sin(l), h = Math.cos(l), p = Math.sin(o), A = c * h + d * u * Math.cos(o), m = Math.asin(A), g = p * u * d, f = h - c * A;
    return [
        $a42f1354f0348298$var$_o(s + Math.atan2(g, f)),
        $a42f1354f0348298$var$_o(m)
    ];
}
const $a42f1354f0348298$var$yl = "185", $a42f1354f0348298$var$bl = 1, $a42f1354f0348298$var$kl = 3, $a42f1354f0348298$var$xl = 0, $a42f1354f0348298$var$wl = 1, $a42f1354f0348298$var$Ml = 2, $a42f1354f0348298$var$Sl = 100, $a42f1354f0348298$var$Cl = 101, $a42f1354f0348298$var$Tl = 102, $a42f1354f0348298$var$Dl = 200, $a42f1354f0348298$var$Pl = 201, $a42f1354f0348298$var$Il = 202, $a42f1354f0348298$var$Ll = 203, $a42f1354f0348298$var$Rl = 204, $a42f1354f0348298$var$zl = 205, $a42f1354f0348298$var$Fl = 206, $a42f1354f0348298$var$Ul = 207, $a42f1354f0348298$var$Nl = 208, $a42f1354f0348298$var$Bl = 209, $a42f1354f0348298$var$Ol = 210, $a42f1354f0348298$var$jl = 211, $a42f1354f0348298$var$Gl = 212, $a42f1354f0348298$var$Vl = 213, $a42f1354f0348298$var$Hl = 214, $a42f1354f0348298$var$ql = 0, $a42f1354f0348298$var$Kl = 1, $a42f1354f0348298$var$Wl = 2, $a42f1354f0348298$var$Xl = 3, $a42f1354f0348298$var$Ql = 4, $a42f1354f0348298$var$Zl = 5, $a42f1354f0348298$var$Yl = 6, $a42f1354f0348298$var$Jl = 7, $a42f1354f0348298$var$$l = 0, $a42f1354f0348298$var$ec = 1, $a42f1354f0348298$var$tc = 2, $a42f1354f0348298$var$ic = 1, $a42f1354f0348298$var$nc = 2, $a42f1354f0348298$var$ac = 3, $a42f1354f0348298$var$rc = 4, $a42f1354f0348298$var$sc = 5, $a42f1354f0348298$var$oc = 6, $a42f1354f0348298$var$lc = 7, $a42f1354f0348298$var$cc = 301, $a42f1354f0348298$var$dc = 302, $a42f1354f0348298$var$uc = 303, $a42f1354f0348298$var$hc = 304, $a42f1354f0348298$var$pc = 306, $a42f1354f0348298$var$Ac = 1e3, $a42f1354f0348298$var$mc = 1001, $a42f1354f0348298$var$gc = 1002, $a42f1354f0348298$var$fc = 1003, $a42f1354f0348298$var$_c = 1004, $a42f1354f0348298$var$vc = 1005, $a42f1354f0348298$var$Ec = 1006, $a42f1354f0348298$var$yc = 1007, $a42f1354f0348298$var$bc = 1008, $a42f1354f0348298$var$kc = 1009, $a42f1354f0348298$var$xc = 1010, $a42f1354f0348298$var$wc = 1011, $a42f1354f0348298$var$Mc = 1012, $a42f1354f0348298$var$Sc = 1013, $a42f1354f0348298$var$Cc = 1014, $a42f1354f0348298$var$Tc = 1015, $a42f1354f0348298$var$Dc = 1016, $a42f1354f0348298$var$Pc = 1017, $a42f1354f0348298$var$Ic = 1018, $a42f1354f0348298$var$Lc = 1020, $a42f1354f0348298$var$Rc = 35902, $a42f1354f0348298$var$zc = 35899, $a42f1354f0348298$var$Fc = 1023, $a42f1354f0348298$var$Uc = 1026, $a42f1354f0348298$var$Nc = 1027, $a42f1354f0348298$var$Bc = 1029, $a42f1354f0348298$var$Oc = 1030, $a42f1354f0348298$var$jc = 1031, $a42f1354f0348298$var$Gc = 1033, $a42f1354f0348298$var$Vc = 33776, $a42f1354f0348298$var$Hc = 33777, $a42f1354f0348298$var$qc = 33778, $a42f1354f0348298$var$Kc = 33779, $a42f1354f0348298$var$Wc = 35840, $a42f1354f0348298$var$Xc = 35841, $a42f1354f0348298$var$Qc = 35842, $a42f1354f0348298$var$Zc = 35843, $a42f1354f0348298$var$Yc = 36196, $a42f1354f0348298$var$Jc = 37492, $a42f1354f0348298$var$$c = 37496, $a42f1354f0348298$var$ed = 37488, $a42f1354f0348298$var$td = 37489, $a42f1354f0348298$var$id = 37490, $a42f1354f0348298$var$nd = 37491, $a42f1354f0348298$var$ad = 37808, $a42f1354f0348298$var$rd = 37809, $a42f1354f0348298$var$sd = 37810, $a42f1354f0348298$var$od = 37811, $a42f1354f0348298$var$ld = 37812, $a42f1354f0348298$var$cd = 37813, $a42f1354f0348298$var$dd = 37814, $a42f1354f0348298$var$ud = 37815, $a42f1354f0348298$var$hd = 37816, $a42f1354f0348298$var$pd = 37817, $a42f1354f0348298$var$Ad = 37818, $a42f1354f0348298$var$md = 37819, $a42f1354f0348298$var$gd = 37820, $a42f1354f0348298$var$fd = 37821, $a42f1354f0348298$var$_d = 36492, $a42f1354f0348298$var$vd = 36494, $a42f1354f0348298$var$Ed = 36495, $a42f1354f0348298$var$yd = 36283, $a42f1354f0348298$var$bd = 36284, $a42f1354f0348298$var$kd = 36285, $a42f1354f0348298$var$xd = 36286, $a42f1354f0348298$var$wd = "", $a42f1354f0348298$var$Md = "srgb", $a42f1354f0348298$var$Sd = "srgb-linear", $a42f1354f0348298$var$Cd = "linear", $a42f1354f0348298$var$Td = "srgb", $a42f1354f0348298$var$Dd = 7680, $a42f1354f0348298$var$Pd = 512, $a42f1354f0348298$var$Id = 513, $a42f1354f0348298$var$Ld = 514, $a42f1354f0348298$var$Rd = 515, $a42f1354f0348298$var$zd = 516, $a42f1354f0348298$var$Fd = 517, $a42f1354f0348298$var$Ud = 518, $a42f1354f0348298$var$Nd = 519, $a42f1354f0348298$var$Bd = "300 es", $a42f1354f0348298$var$Od = 2e3, $a42f1354f0348298$var$jd = 2001;
function $a42f1354f0348298$var$Gd(e) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", e);
}
function $a42f1354f0348298$var$Vd() {
    const e = $a42f1354f0348298$var$Gd("canvas");
    return e.style.display = "block", e;
}
const $a42f1354f0348298$var$Hd = {};
function $a42f1354f0348298$var$qd(...e) {
    const t = "THREE." + e.shift();
    console.log(t, ...e);
}
function $a42f1354f0348298$var$Kd(e) {
    const t = e[0];
    if ("string" == typeof t && t.startsWith("TSL:")) {
        const t = e[1];
        t && t.isStackTrace ? e[0] += " " + t.getLocation() : e[1] = 'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.';
    }
    return e;
}
function $a42f1354f0348298$var$Wd(...e) {
    const t = "THREE." + (e = $a42f1354f0348298$var$Kd(e)).shift();
    {
        const i = e[0];
        i && i.isStackTrace ? console.warn(i.getError(t)) : console.warn(t, ...e);
    }
}
function $a42f1354f0348298$var$Xd(...e) {
    const t = "THREE." + (e = $a42f1354f0348298$var$Kd(e)).shift();
    {
        const i = e[0];
        i && i.isStackTrace ? console.error(i.getError(t)) : console.error(t, ...e);
    }
}
function $a42f1354f0348298$var$Qd(...e) {
    const t = e.join(" ");
    t in $a42f1354f0348298$var$Hd || ($a42f1354f0348298$var$Hd[t] = !0, $a42f1354f0348298$var$Wd(...e));
}
const $a42f1354f0348298$var$Zd = {
    [$a42f1354f0348298$var$ql]: 1,
    [$a42f1354f0348298$var$Wl]: 6,
    [$a42f1354f0348298$var$Ql]: 7,
    [$a42f1354f0348298$var$Xl]: 5,
    [$a42f1354f0348298$var$Kl]: 0,
    [$a42f1354f0348298$var$Yl]: 2,
    [$a42f1354f0348298$var$Jl]: 4,
    [$a42f1354f0348298$var$Zl]: 3
};
class $a42f1354f0348298$var$Yd {
    addEventListener(e, t) {
        void 0 === this._listeners && (this._listeners = {});
        const i = this._listeners;
        void 0 === i[e] && (i[e] = []), -1 === i[e].indexOf(t) && i[e].push(t);
    }
    hasEventListener(e, t) {
        const i = this._listeners;
        return void 0 !== i && void 0 !== i[e] && -1 !== i[e].indexOf(t);
    }
    removeEventListener(e, t) {
        const i = this._listeners;
        if (void 0 === i) return;
        const n = i[e];
        if (void 0 !== n) {
            const e = n.indexOf(t);
            -1 !== e && n.splice(e, 1);
        }
    }
    dispatchEvent(e) {
        const t = this._listeners;
        if (void 0 === t) return;
        const i = t[e.type];
        if (void 0 !== i) {
            e.target = this;
            const t = i.slice(0);
            for(let i = 0, n = t.length; i < n; i++)t[i].call(this, e);
            e.target = null;
        }
    }
}
const $a42f1354f0348298$var$Jd = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $a42f1354f0348298$var$$d = 1234567;
const $a42f1354f0348298$var$eu = Math.PI / 180, $a42f1354f0348298$var$tu = 180 / Math.PI;
function $a42f1354f0348298$var$iu() {
    const e = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0;
    return ($a42f1354f0348298$var$Jd[255 & e] + $a42f1354f0348298$var$Jd[e >> 8 & 255] + $a42f1354f0348298$var$Jd[e >> 16 & 255] + $a42f1354f0348298$var$Jd[e >> 24 & 255] + "-" + $a42f1354f0348298$var$Jd[255 & t] + $a42f1354f0348298$var$Jd[t >> 8 & 255] + "-" + $a42f1354f0348298$var$Jd[t >> 16 & 15 | 64] + $a42f1354f0348298$var$Jd[t >> 24 & 255] + "-" + $a42f1354f0348298$var$Jd[63 & i | 128] + $a42f1354f0348298$var$Jd[i >> 8 & 255] + "-" + $a42f1354f0348298$var$Jd[i >> 16 & 255] + $a42f1354f0348298$var$Jd[i >> 24 & 255] + $a42f1354f0348298$var$Jd[255 & n] + $a42f1354f0348298$var$Jd[n >> 8 & 255] + $a42f1354f0348298$var$Jd[n >> 16 & 255] + $a42f1354f0348298$var$Jd[n >> 24 & 255]).toLowerCase();
}
function $a42f1354f0348298$var$nu(e, t, i) {
    return Math.max(t, Math.min(i, e));
}
function $a42f1354f0348298$var$au(e, t) {
    return (e % t + t) % t;
}
function $a42f1354f0348298$var$ru(e, t, i) {
    return (1 - i) * e + i * t;
}
function $a42f1354f0348298$var$su(e, t) {
    switch(t.constructor){
        case Float32Array:
            return e;
        case Uint32Array:
            return e / 4294967295;
        case Uint16Array:
            return e / 65535;
        case Uint8Array:
            return e / 255;
        case Int32Array:
            return Math.max(e / 2147483647, -1);
        case Int16Array:
            return Math.max(e / 32767, -1);
        case Int8Array:
            return Math.max(e / 127, -1);
        default:
            throw new Error("THREE.MathUtils: Invalid component type.");
    }
}
function $a42f1354f0348298$var$ou(e, t) {
    switch(t.constructor){
        case Float32Array:
            return e;
        case Uint32Array:
            return Math.round(4294967295 * e);
        case Uint16Array:
            return Math.round(65535 * e);
        case Uint8Array:
            return Math.round(255 * e);
        case Int32Array:
            return Math.round(2147483647 * e);
        case Int16Array:
            return Math.round(32767 * e);
        case Int8Array:
            return Math.round(127 * e);
        default:
            throw new Error("THREE.MathUtils: Invalid component type.");
    }
}
const $a42f1354f0348298$var$lu = {
    DEG2RAD: $a42f1354f0348298$var$eu,
    RAD2DEG: $a42f1354f0348298$var$tu,
    generateUUID: $a42f1354f0348298$var$iu,
    clamp: $a42f1354f0348298$var$nu,
    euclideanModulo: $a42f1354f0348298$var$au,
    mapLinear: function(e, t, i, n, a) {
        return n + (e - t) * (a - n) / (i - t);
    },
    inverseLerp: function(e, t, i) {
        return e !== t ? (i - e) / (t - e) : 0;
    },
    lerp: $a42f1354f0348298$var$ru,
    damp: function(e, t, i, n) {
        return $a42f1354f0348298$var$ru(e, t, 1 - Math.exp(-i * n));
    },
    pingpong: function(e, t = 1) {
        return t - Math.abs($a42f1354f0348298$var$au(e, 2 * t) - t);
    },
    smoothstep: function(e, t, i) {
        return e <= t ? 0 : e >= i ? 1 : (e = (e - t) / (i - t)) * e * (3 - 2 * e);
    },
    smootherstep: function(e, t, i) {
        return e <= t ? 0 : e >= i ? 1 : (e = (e - t) / (i - t)) * e * e * (e * (6 * e - 15) + 10);
    },
    randInt: function(e, t) {
        return e + Math.floor(Math.random() * (t - e + 1));
    },
    randFloat: function(e, t) {
        return e + Math.random() * (t - e);
    },
    randFloatSpread: function(e) {
        return e * (.5 - Math.random());
    },
    seededRandom: function(e) {
        void 0 !== e && ($a42f1354f0348298$var$$d = e);
        let t = $a42f1354f0348298$var$$d += 1831565813;
        return t = Math.imul(t ^ t >>> 15, 1 | t), t ^= t + Math.imul(t ^ t >>> 7, 61 | t), ((t ^ t >>> 14) >>> 0) / 4294967296;
    },
    degToRad: function(e) {
        return e * $a42f1354f0348298$var$eu;
    },
    radToDeg: function(e) {
        return e * $a42f1354f0348298$var$tu;
    },
    isPowerOfTwo: function(e) {
        return !(e & e - 1) && 0 !== e;
    },
    ceilPowerOfTwo: function(e) {
        return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
    },
    floorPowerOfTwo: function(e) {
        return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
    },
    setQuaternionFromProperEuler: function(e, t, i, n, a) {
        const r = Math.cos, s = Math.sin, o = r(i / 2), l = s(i / 2), c = r((t + n) / 2), d = s((t + n) / 2), u = r((t - n) / 2), h = s((t - n) / 2), p = r((n - t) / 2), A = s((n - t) / 2);
        switch(a){
            case "XYX":
                e.set(o * d, l * u, l * h, o * c);
                break;
            case "YZY":
                e.set(l * h, o * d, l * u, o * c);
                break;
            case "ZXZ":
                e.set(l * u, l * h, o * d, o * c);
                break;
            case "XZX":
                e.set(o * d, l * A, l * p, o * c);
                break;
            case "YXY":
                e.set(l * p, o * d, l * A, o * c);
                break;
            case "ZYZ":
                e.set(l * A, l * p, o * d, o * c);
                break;
            default:
                $a42f1354f0348298$var$Wd("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + a);
        }
    },
    normalize: $a42f1354f0348298$var$ou,
    denormalize: $a42f1354f0348298$var$su
};
class $a42f1354f0348298$var$cu {
    static{
        $a42f1354f0348298$var$cu.prototype.isVector2 = !0;
    }
    constructor(e = 0, t = 0){
        this.x = e, this.y = t;
    }
    get width() {
        return this.x;
    }
    set width(e) {
        this.x = e;
    }
    get height() {
        return this.y;
    }
    set height(e) {
        this.y = e;
    }
    set(e, t) {
        return this.x = e, this.y = t, this;
    }
    setScalar(e) {
        return this.x = e, this.y = e, this;
    }
    setX(e) {
        return this.x = e, this;
    }
    setY(e) {
        return this.y = e, this;
    }
    setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            default:
                throw new Error("THREE.Vector2: index is out of range: " + e);
        }
        return this;
    }
    getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("THREE.Vector2: index is out of range: " + e);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(e) {
        return this.x = e.x, this.y = e.y, this;
    }
    add(e) {
        return this.x += e.x, this.y += e.y, this;
    }
    addScalar(e) {
        return this.x += e, this.y += e, this;
    }
    addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this;
    }
    addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this;
    }
    sub(e) {
        return this.x -= e.x, this.y -= e.y, this;
    }
    subScalar(e) {
        return this.x -= e, this.y -= e, this;
    }
    subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this;
    }
    multiply(e) {
        return this.x *= e.x, this.y *= e.y, this;
    }
    multiplyScalar(e) {
        return this.x *= e, this.y *= e, this;
    }
    divide(e) {
        return this.x /= e.x, this.y /= e.y, this;
    }
    divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    applyMatrix3(e) {
        const t = this.x, i = this.y, n = e.elements;
        return this.x = n[0] * t + n[3] * i + n[6], this.y = n[1] * t + n[4] * i + n[7], this;
    }
    min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
    }
    max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
    }
    clamp(e, t) {
        return this.x = $a42f1354f0348298$var$nu(this.x, e.x, t.x), this.y = $a42f1354f0348298$var$nu(this.y, e.y, t.y), this;
    }
    clampScalar(e, t) {
        return this.x = $a42f1354f0348298$var$nu(this.x, e, t), this.y = $a42f1354f0348298$var$nu(this.y, e, t), this;
    }
    clampLength(e, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($a42f1354f0348298$var$nu(i, e, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(e) {
        return this.x * e.x + this.y * e.y;
    }
    cross(e) {
        return this.x * e.y - this.y * e.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    angleTo(e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (0 === t) return Math.PI / 2;
        const i = this.dot(e) / t;
        return Math.acos($a42f1354f0348298$var$nu(i, -1, 1));
    }
    distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
    }
    distanceToSquared(e) {
        const t = this.x - e.x, i = this.y - e.y;
        return t * t + i * i;
    }
    manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
    }
    setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
    }
    lerpVectors(e, t, i) {
        return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this;
    }
    equals(e) {
        return e.x === this.x && e.y === this.y;
    }
    fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e;
    }
    fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this;
    }
    rotateAround(e, t) {
        const i = Math.cos(t), n = Math.sin(t), a = this.x - e.x, r = this.y - e.y;
        return this.x = a * i - r * n + e.x, this.y = a * n + r * i + e.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}
class $a42f1354f0348298$var$du {
    constructor(e = 0, t = 0, i = 0, n = 1){
        this.isQuaternion = !0, this._x = e, this._y = t, this._z = i, this._w = n;
    }
    static slerpFlat(e, t, i, n, a, r, s) {
        let o = i[n + 0], l = i[n + 1], c = i[n + 2], d = i[n + 3], u = a[r + 0], h = a[r + 1], p = a[r + 2], A = a[r + 3];
        if (d !== A || o !== u || l !== h || c !== p) {
            let e = o * u + l * h + c * p + d * A;
            e < 0 && (u = -u, h = -h, p = -p, A = -A, e = -e);
            let t = 1 - s;
            if (e < .9995) {
                const i = Math.acos(e), n = Math.sin(i);
                t = Math.sin(t * i) / n, o = o * t + u * (s = Math.sin(s * i) / n), l = l * t + h * s, c = c * t + p * s, d = d * t + A * s;
            } else {
                o = o * t + u * s, l = l * t + h * s, c = c * t + p * s, d = d * t + A * s;
                const e = 1 / Math.sqrt(o * o + l * l + c * c + d * d);
                o *= e, l *= e, c *= e, d *= e;
            }
        }
        e[t] = o, e[t + 1] = l, e[t + 2] = c, e[t + 3] = d;
    }
    static multiplyQuaternionsFlat(e, t, i, n, a, r) {
        const s = i[n], o = i[n + 1], l = i[n + 2], c = i[n + 3], d = a[r], u = a[r + 1], h = a[r + 2], p = a[r + 3];
        return e[t] = s * p + c * d + o * h - l * u, e[t + 1] = o * p + c * u + l * d - s * h, e[t + 2] = l * p + c * h + s * u - o * d, e[t + 3] = c * p - s * d - o * u - l * h, e;
    }
    get x() {
        return this._x;
    }
    set x(e) {
        this._x = e, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(e) {
        this._y = e, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(e) {
        this._z = e, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(e) {
        this._w = e, this._onChangeCallback();
    }
    set(e, t, i, n) {
        return this._x = e, this._y = t, this._z = i, this._w = n, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(e) {
        return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
    }
    setFromEuler(e, t = !0) {
        const i = e._x, n = e._y, a = e._z, r = e._order, s = Math.cos, o = Math.sin, l = s(i / 2), c = s(n / 2), d = s(a / 2), u = o(i / 2), h = o(n / 2), p = o(a / 2);
        switch(r){
            case "XYZ":
                this._x = u * c * d + l * h * p, this._y = l * h * d - u * c * p, this._z = l * c * p + u * h * d, this._w = l * c * d - u * h * p;
                break;
            case "YXZ":
                this._x = u * c * d + l * h * p, this._y = l * h * d - u * c * p, this._z = l * c * p - u * h * d, this._w = l * c * d + u * h * p;
                break;
            case "ZXY":
                this._x = u * c * d - l * h * p, this._y = l * h * d + u * c * p, this._z = l * c * p + u * h * d, this._w = l * c * d - u * h * p;
                break;
            case "ZYX":
                this._x = u * c * d - l * h * p, this._y = l * h * d + u * c * p, this._z = l * c * p - u * h * d, this._w = l * c * d + u * h * p;
                break;
            case "YZX":
                this._x = u * c * d + l * h * p, this._y = l * h * d + u * c * p, this._z = l * c * p - u * h * d, this._w = l * c * d - u * h * p;
                break;
            case "XZY":
                this._x = u * c * d - l * h * p, this._y = l * h * d - u * c * p, this._z = l * c * p + u * h * d, this._w = l * c * d + u * h * p;
                break;
            default:
                $a42f1354f0348298$var$Wd("Quaternion: .setFromEuler() encountered an unknown order: " + r);
        }
        return !0 === t && this._onChangeCallback(), this;
    }
    setFromAxisAngle(e, t) {
        const i = t / 2, n = Math.sin(i);
        return this._x = e.x * n, this._y = e.y * n, this._z = e.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(e) {
        const t = e.elements, i = t[0], n = t[4], a = t[8], r = t[1], s = t[5], o = t[9], l = t[2], c = t[6], d = t[10], u = i + s + d;
        if (u > 0) {
            const e = .5 / Math.sqrt(u + 1);
            this._w = .25 / e, this._x = (c - o) * e, this._y = (a - l) * e, this._z = (r - n) * e;
        } else if (i > s && i > d) {
            const e = 2 * Math.sqrt(1 + i - s - d);
            this._w = (c - o) / e, this._x = .25 * e, this._y = (n + r) / e, this._z = (a + l) / e;
        } else if (s > d) {
            const e = 2 * Math.sqrt(1 + s - i - d);
            this._w = (a - l) / e, this._x = (n + r) / e, this._y = .25 * e, this._z = (o + c) / e;
        } else {
            const e = 2 * Math.sqrt(1 + d - i - s);
            this._w = (r - n) / e, this._x = (a + l) / e, this._y = (o + c) / e, this._z = .25 * e;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(e, t) {
        let i = e.dot(t) + 1;
        return i < 1e-8 ? (i = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = i)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = i), this.normalize();
    }
    angleTo(e) {
        return 2 * Math.acos(Math.abs($a42f1354f0348298$var$nu(this.dot(e), -1, 1)));
    }
    rotateTowards(e, t) {
        const i = this.angleTo(e);
        if (0 === i) return this;
        const n = Math.min(1, t / i);
        return this.slerp(e, n), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(e) {
        return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let e = this.length();
        return 0 === e ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
    }
    multiply(e) {
        return this.multiplyQuaternions(this, e);
    }
    premultiply(e) {
        return this.multiplyQuaternions(e, this);
    }
    multiplyQuaternions(e, t) {
        const i = e._x, n = e._y, a = e._z, r = e._w, s = t._x, o = t._y, l = t._z, c = t._w;
        return this._x = i * c + r * s + n * l - a * o, this._y = n * c + r * o + a * s - i * l, this._z = a * c + r * l + i * o - n * s, this._w = r * c - i * s - n * o - a * l, this._onChangeCallback(), this;
    }
    slerp(e, t) {
        let i = e._x, n = e._y, a = e._z, r = e._w, s = this.dot(e);
        s < 0 && (i = -i, n = -n, a = -a, r = -r, s = -s);
        let o = 1 - t;
        if (s < .9995) {
            const e = Math.acos(s), l = Math.sin(e);
            o = Math.sin(o * e) / l, t = Math.sin(t * e) / l, this._x = this._x * o + i * t, this._y = this._y * o + n * t, this._z = this._z * o + a * t, this._w = this._w * o + r * t, this._onChangeCallback();
        } else this._x = this._x * o + i * t, this._y = this._y * o + n * t, this._z = this._z * o + a * t, this._w = this._w * o + r * t, this.normalize();
        return this;
    }
    slerpQuaternions(e, t, i) {
        return this.copy(e).slerp(t, i);
    }
    random() {
        const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), i = Math.random(), n = Math.sqrt(1 - i), a = Math.sqrt(i);
        return this.set(n * Math.sin(e), n * Math.cos(e), a * Math.sin(t), a * Math.cos(t));
    }
    equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
    }
    fromArray(e, t = 0) {
        return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
    }
    fromBufferAttribute(e, t) {
        return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(e) {
        return this._onChangeCallback = e, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}
class $a42f1354f0348298$var$uu {
    static{
        $a42f1354f0348298$var$uu.prototype.isVector3 = !0;
    }
    constructor(e = 0, t = 0, i = 0){
        this.x = e, this.y = t, this.z = i;
    }
    set(e, t, i) {
        return void 0 === i && (i = this.z), this.x = e, this.y = t, this.z = i, this;
    }
    setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this;
    }
    setX(e) {
        return this.x = e, this;
    }
    setY(e) {
        return this.y = e, this;
    }
    setZ(e) {
        return this.z = e, this;
    }
    setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            default:
                throw new Error("THREE.Vector3: index is out of range: " + e);
        }
        return this;
    }
    getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("THREE.Vector3: index is out of range: " + e);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this;
    }
    add(e) {
        return this.x += e.x, this.y += e.y, this.z += e.z, this;
    }
    addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this;
    }
    addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
    }
    addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
    }
    sub(e) {
        return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
    }
    subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this;
    }
    subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
    }
    multiply(e) {
        return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
    }
    multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this;
    }
    multiplyVectors(e, t) {
        return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
    }
    applyEuler(e) {
        return this.applyQuaternion($a42f1354f0348298$var$pu.setFromEuler(e));
    }
    applyAxisAngle(e, t) {
        return this.applyQuaternion($a42f1354f0348298$var$pu.setFromAxisAngle(e, t));
    }
    applyMatrix3(e) {
        const t = this.x, i = this.y, n = this.z, a = e.elements;
        return this.x = a[0] * t + a[3] * i + a[6] * n, this.y = a[1] * t + a[4] * i + a[7] * n, this.z = a[2] * t + a[5] * i + a[8] * n, this;
    }
    applyNormalMatrix(e) {
        return this.applyMatrix3(e).normalize();
    }
    applyMatrix4(e) {
        const t = this.x, i = this.y, n = this.z, a = e.elements, r = 1 / (a[3] * t + a[7] * i + a[11] * n + a[15]);
        return this.x = (a[0] * t + a[4] * i + a[8] * n + a[12]) * r, this.y = (a[1] * t + a[5] * i + a[9] * n + a[13]) * r, this.z = (a[2] * t + a[6] * i + a[10] * n + a[14]) * r, this;
    }
    applyQuaternion(e) {
        const t = this.x, i = this.y, n = this.z, a = e.x, r = e.y, s = e.z, o = e.w, l = 2 * (r * n - s * i), c = 2 * (s * t - a * n), d = 2 * (a * i - r * t);
        return this.x = t + o * l + r * d - s * c, this.y = i + o * c + s * l - a * d, this.z = n + o * d + a * c - r * l, this;
    }
    project(e) {
        return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
    }
    unproject(e) {
        return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
    }
    transformDirection(e) {
        const t = this.x, i = this.y, n = this.z, a = e.elements;
        return this.x = a[0] * t + a[4] * i + a[8] * n, this.y = a[1] * t + a[5] * i + a[9] * n, this.z = a[2] * t + a[6] * i + a[10] * n, this.normalize();
    }
    divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
    }
    divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
    }
    max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
    }
    clamp(e, t) {
        return this.x = $a42f1354f0348298$var$nu(this.x, e.x, t.x), this.y = $a42f1354f0348298$var$nu(this.y, e.y, t.y), this.z = $a42f1354f0348298$var$nu(this.z, e.z, t.z), this;
    }
    clampScalar(e, t) {
        return this.x = $a42f1354f0348298$var$nu(this.x, e, t), this.y = $a42f1354f0348298$var$nu(this.y, e, t), this.z = $a42f1354f0348298$var$nu(this.z, e, t), this;
    }
    clampLength(e, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($a42f1354f0348298$var$nu(i, e, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
    }
    lerpVectors(e, t, i) {
        return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this.z = e.z + (t.z - e.z) * i, this;
    }
    cross(e) {
        return this.crossVectors(this, e);
    }
    crossVectors(e, t) {
        const i = e.x, n = e.y, a = e.z, r = t.x, s = t.y, o = t.z;
        return this.x = n * o - a * s, this.y = a * r - i * o, this.z = i * s - n * r, this;
    }
    projectOnVector(e) {
        const t = e.lengthSq();
        if (0 === t) return this.set(0, 0, 0);
        const i = e.dot(this) / t;
        return this.copy(e).multiplyScalar(i);
    }
    projectOnPlane(e) {
        return $a42f1354f0348298$var$hu.copy(this).projectOnVector(e), this.sub($a42f1354f0348298$var$hu);
    }
    reflect(e) {
        return this.sub($a42f1354f0348298$var$hu.copy(e).multiplyScalar(2 * this.dot(e)));
    }
    angleTo(e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (0 === t) return Math.PI / 2;
        const i = this.dot(e) / t;
        return Math.acos($a42f1354f0348298$var$nu(i, -1, 1));
    }
    distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
    }
    distanceToSquared(e) {
        const t = this.x - e.x, i = this.y - e.y, n = this.z - e.z;
        return t * t + i * i + n * n;
    }
    manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
    }
    setFromSpherical(e) {
        return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
    }
    setFromSphericalCoords(e, t, i) {
        const n = Math.sin(t) * e;
        return this.x = n * Math.sin(i), this.y = Math.cos(t) * e, this.z = n * Math.cos(i), this;
    }
    setFromCylindrical(e) {
        return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
    }
    setFromCylindricalCoords(e, t, i) {
        return this.x = e * Math.sin(t), this.y = i, this.z = e * Math.cos(t), this;
    }
    setFromMatrixPosition(e) {
        const t = e.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this;
    }
    setFromMatrixScale(e) {
        const t = this.setFromMatrixColumn(e, 0).length(), i = this.setFromMatrixColumn(e, 1).length(), n = this.setFromMatrixColumn(e, 2).length();
        return this.x = t, this.y = i, this.z = n, this;
    }
    setFromMatrixColumn(e, t) {
        return this.fromArray(e.elements, 4 * t);
    }
    setFromMatrix3Column(e, t) {
        return this.fromArray(e.elements, 3 * t);
    }
    setFromEuler(e) {
        return this.x = e._x, this.y = e._y, this.z = e._z, this;
    }
    setFromColor(e) {
        return this.x = e.r, this.y = e.g, this.z = e.b, this;
    }
    equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z;
    }
    fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
    }
    fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        const e = Math.random() * Math.PI * 2, t = 2 * Math.random() - 1, i = Math.sqrt(1 - t * t);
        return this.x = i * Math.cos(e), this.y = t, this.z = i * Math.sin(e), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}
const $a42f1354f0348298$var$hu = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$pu = new $a42f1354f0348298$var$du;
class $a42f1354f0348298$var$Au {
    static{
        $a42f1354f0348298$var$Au.prototype.isMatrix3 = !0;
    }
    constructor(e, t, i, n, a, r, s, o, l){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], void 0 !== e && this.set(e, t, i, n, a, r, s, o, l);
    }
    set(e, t, i, n, a, r, s, o, l) {
        const c = this.elements;
        return c[0] = e, c[1] = n, c[2] = s, c[3] = t, c[4] = a, c[5] = o, c[6] = i, c[7] = r, c[8] = l, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(e) {
        const t = this.elements, i = e.elements;
        return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], this;
    }
    extractBasis(e, t, i) {
        return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(e) {
        const t = e.elements;
        return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
    }
    multiply(e) {
        return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
        return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
        const i = e.elements, n = t.elements, a = this.elements, r = i[0], s = i[3], o = i[6], l = i[1], c = i[4], d = i[7], u = i[2], h = i[5], p = i[8], A = n[0], m = n[3], g = n[6], f = n[1], _ = n[4], v = n[7], E = n[2], y = n[5], b = n[8];
        return a[0] = r * A + s * f + o * E, a[3] = r * m + s * _ + o * y, a[6] = r * g + s * v + o * b, a[1] = l * A + c * f + d * E, a[4] = l * m + c * _ + d * y, a[7] = l * g + c * v + d * b, a[2] = u * A + h * f + p * E, a[5] = u * m + h * _ + p * y, a[8] = u * g + h * v + p * b, this;
    }
    multiplyScalar(e) {
        const t = this.elements;
        return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
    }
    determinant() {
        const e = this.elements, t = e[0], i = e[1], n = e[2], a = e[3], r = e[4], s = e[5], o = e[6], l = e[7], c = e[8];
        return t * r * c - t * s * l - i * a * c + i * s * o + n * a * l - n * r * o;
    }
    invert() {
        const e = this.elements, t = e[0], i = e[1], n = e[2], a = e[3], r = e[4], s = e[5], o = e[6], l = e[7], c = e[8], d = c * r - s * l, u = s * o - c * a, h = l * a - r * o, p = t * d + i * u + n * h;
        if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const A = 1 / p;
        return e[0] = d * A, e[1] = (n * l - c * i) * A, e[2] = (s * i - n * r) * A, e[3] = u * A, e[4] = (c * t - n * o) * A, e[5] = (n * a - s * t) * A, e[6] = h * A, e[7] = (i * o - l * t) * A, e[8] = (r * t - i * a) * A, this;
    }
    transpose() {
        let e;
        const t = this.elements;
        return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
    }
    getNormalMatrix(e) {
        return this.setFromMatrix4(e).invert().transpose();
    }
    transposeIntoArray(e) {
        const t = this.elements;
        return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
    }
    setUvTransform(e, t, i, n, a, r, s) {
        const o = Math.cos(a), l = Math.sin(a);
        return this.set(i * o, i * l, -i * (o * r + l * s) + r + e, -n * l, n * o, -n * (-l * r + o * s) + s + t, 0, 0, 1), this;
    }
    scale(e, t) {
        return $a42f1354f0348298$var$Qd("Matrix3: .scale() is deprecated. Use .makeScale() instead."), this.premultiply($a42f1354f0348298$var$mu.makeScale(e, t)), this;
    }
    rotate(e) {
        return $a42f1354f0348298$var$Qd("Matrix3: .rotate() is deprecated. Use .makeRotation() instead."), this.premultiply($a42f1354f0348298$var$mu.makeRotation(-e)), this;
    }
    translate(e, t) {
        return $a42f1354f0348298$var$Qd("Matrix3: .translate() is deprecated. Use .makeTranslation() instead."), this.premultiply($a42f1354f0348298$var$mu.makeTranslation(e, t)), this;
    }
    makeTranslation(e, t) {
        return e.isVector2 ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1) : this.set(1, 0, e, 0, 1, t, 0, 0, 1), this;
    }
    makeRotation(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(t, -i, 0, i, t, 0, 0, 0, 1), this;
    }
    makeScale(e, t) {
        return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this;
    }
    equals(e) {
        const t = this.elements, i = e.elements;
        for(let e = 0; e < 9; e++)if (t[e] !== i[e]) return !1;
        return !0;
    }
    fromArray(e, t = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = e[i + t];
        return this;
    }
    toArray(e = [], t = 0) {
        const i = this.elements;
        return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e;
    }
    clone() {
        return (new this.constructor).fromArray(this.elements);
    }
}
const $a42f1354f0348298$var$mu = new $a42f1354f0348298$var$Au, $a42f1354f0348298$var$gu = (new $a42f1354f0348298$var$Au).set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), $a42f1354f0348298$var$fu = (new $a42f1354f0348298$var$Au).set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, .0415551, .0556301, -0.203977, 1.0569715);
function $a42f1354f0348298$var$_u() {
    const e = {
        enabled: !0,
        workingColorSpace: $a42f1354f0348298$var$Sd,
        spaces: {},
        convert: function(e, t, i) {
            return !1 !== this.enabled && t !== i && t && i ? (this.spaces[t].transfer === $a42f1354f0348298$var$Td && (e.r = $a42f1354f0348298$var$Eu(e.r), e.g = $a42f1354f0348298$var$Eu(e.g), e.b = $a42f1354f0348298$var$Eu(e.b)), this.spaces[t].primaries !== this.spaces[i].primaries && (e.applyMatrix3(this.spaces[t].toXYZ), e.applyMatrix3(this.spaces[i].fromXYZ)), this.spaces[i].transfer === $a42f1354f0348298$var$Td && (e.r = $a42f1354f0348298$var$yu(e.r), e.g = $a42f1354f0348298$var$yu(e.g), e.b = $a42f1354f0348298$var$yu(e.b)), e) : e;
        },
        workingToColorSpace: function(e, t) {
            return this.convert(e, this.workingColorSpace, t);
        },
        colorSpaceToWorking: function(e, t) {
            return this.convert(e, t, this.workingColorSpace);
        },
        getPrimaries: function(e) {
            return this.spaces[e].primaries;
        },
        getTransfer: function(e) {
            return e === $a42f1354f0348298$var$wd ? $a42f1354f0348298$var$Cd : this.spaces[e].transfer;
        },
        getToneMappingMode: function(e) {
            return this.spaces[e].outputColorSpaceConfig.toneMappingMode || "standard";
        },
        getLuminanceCoefficients: function(e, t = this.workingColorSpace) {
            return e.fromArray(this.spaces[t].luminanceCoefficients);
        },
        define: function(e) {
            Object.assign(this.spaces, e);
        },
        _getMatrix: function(e, t, i) {
            return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[i].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(e) {
            return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(e = this.workingColorSpace) {
            return this.spaces[e].workingColorSpaceConfig.unpackColorSpace;
        },
        fromWorkingColorSpace: function(t, i) {
            return $a42f1354f0348298$var$Qd("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), e.workingToColorSpace(t, i);
        },
        toWorkingColorSpace: function(t, i) {
            return $a42f1354f0348298$var$Qd("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), e.colorSpaceToWorking(t, i);
        }
    }, t = [
        .64,
        .33,
        .3,
        .6,
        .15,
        .06
    ], i = [
        .2126,
        .7152,
        .0722
    ], n = [
        .3127,
        .329
    ];
    return e.define({
        [$a42f1354f0348298$var$Sd]: {
            primaries: t,
            whitePoint: n,
            transfer: $a42f1354f0348298$var$Cd,
            toXYZ: $a42f1354f0348298$var$gu,
            fromXYZ: $a42f1354f0348298$var$fu,
            luminanceCoefficients: i,
            workingColorSpaceConfig: {
                unpackColorSpace: $a42f1354f0348298$var$Md
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $a42f1354f0348298$var$Md
            }
        },
        [$a42f1354f0348298$var$Md]: {
            primaries: t,
            whitePoint: n,
            transfer: $a42f1354f0348298$var$Td,
            toXYZ: $a42f1354f0348298$var$gu,
            fromXYZ: $a42f1354f0348298$var$fu,
            luminanceCoefficients: i,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $a42f1354f0348298$var$Md
            }
        }
    }), e;
}
const $a42f1354f0348298$var$vu = $a42f1354f0348298$var$_u();
function $a42f1354f0348298$var$Eu(e) {
    return e < .04045 ? .0773993808 * e : Math.pow(.9478672986 * e + .0521327014, 2.4);
}
function $a42f1354f0348298$var$yu(e) {
    return e < .0031308 ? 12.92 * e : 1.055 * Math.pow(e, .41666) - .055;
}
let $a42f1354f0348298$var$bu;
class $a42f1354f0348298$var$ku {
    static getDataURL(e, t = "image/png") {
        if (/^data:/i.test(e.src)) return e.src;
        if ("undefined" == typeof HTMLCanvasElement) return e.src;
        let i;
        if (e instanceof HTMLCanvasElement) i = e;
        else {
            void 0 === $a42f1354f0348298$var$bu && ($a42f1354f0348298$var$bu = $a42f1354f0348298$var$Gd("canvas")), $a42f1354f0348298$var$bu.width = e.width, $a42f1354f0348298$var$bu.height = e.height;
            const t = $a42f1354f0348298$var$bu.getContext("2d");
            e instanceof ImageData ? t.putImageData(e, 0, 0) : t.drawImage(e, 0, 0, e.width, e.height), i = $a42f1354f0348298$var$bu;
        }
        return i.toDataURL(t);
    }
    static sRGBToLinear(e) {
        if ("undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e instanceof ImageBitmap) {
            const t = $a42f1354f0348298$var$Gd("canvas");
            t.width = e.width, t.height = e.height;
            const i = t.getContext("2d");
            i.drawImage(e, 0, 0, e.width, e.height);
            const n = i.getImageData(0, 0, e.width, e.height), a = n.data;
            for(let e = 0; e < a.length; e++)a[e] = 255 * $a42f1354f0348298$var$Eu(a[e] / 255);
            return i.putImageData(n, 0, 0), t;
        }
        if (e.data) {
            const t = e.data.slice(0);
            for(let e = 0; e < t.length; e++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e] = Math.floor(255 * $a42f1354f0348298$var$Eu(t[e] / 255)) : t[e] = $a42f1354f0348298$var$Eu(t[e]);
            return {
                data: t,
                width: e.width,
                height: e.height
            };
        }
        return $a42f1354f0348298$var$Wd("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
    }
}
let $a42f1354f0348298$var$xu = 0;
class $a42f1354f0348298$var$wu {
    constructor(e = null){
        this.isSource = !0, Object.defineProperty(this, "id", {
            value: $a42f1354f0348298$var$xu++
        }), this.uuid = $a42f1354f0348298$var$iu(), this.data = e, this.dataReady = !0, this.version = 0;
    }
    getSize(e) {
        const t = this.data;
        return "undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : "undefined" != typeof VideoFrame && t instanceof VideoFrame ? e.set(t.displayWidth, t.displayHeight, 0) : null !== t ? e.set(t.width, t.height, t.depth || 0) : e.set(0, 0, 0), e;
    }
    set needsUpdate(e) {
        !0 === e && this.version++;
    }
    toJSON(e) {
        const t = void 0 === e || "string" == typeof e;
        if (!t && void 0 !== e.images[this.uuid]) return e.images[this.uuid];
        const i = {
            uuid: this.uuid,
            url: ""
        }, n = this.data;
        if (null !== n) {
            let e;
            if (Array.isArray(n)) {
                e = [];
                for(let t = 0, i = n.length; t < i; t++)n[t].isDataTexture ? e.push($a42f1354f0348298$var$Mu(n[t].image)) : e.push($a42f1354f0348298$var$Mu(n[t]));
            } else e = $a42f1354f0348298$var$Mu(n);
            i.url = e;
        }
        return t || (e.images[this.uuid] = i), i;
    }
}
function $a42f1354f0348298$var$Mu(e) {
    return "undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e instanceof ImageBitmap ? $a42f1354f0348298$var$ku.getDataURL(e) : e.data ? {
        data: Array.from(e.data),
        width: e.width,
        height: e.height,
        type: e.data.constructor.name
    } : ($a42f1354f0348298$var$Wd("Texture: Unable to serialize Texture."), {});
}
let $a42f1354f0348298$var$Su = 0;
const $a42f1354f0348298$var$Cu = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$Tu extends $a42f1354f0348298$var$Yd {
    constructor(e = $a42f1354f0348298$var$Tu.DEFAULT_IMAGE, t = $a42f1354f0348298$var$Tu.DEFAULT_MAPPING, i = 1001, n = 1001, a = 1006, r = 1008, s = 1023, o = $a42f1354f0348298$var$kc, l = $a42f1354f0348298$var$Tu.DEFAULT_ANISOTROPY, c = ""){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: $a42f1354f0348298$var$Su++
        }), this.uuid = $a42f1354f0348298$var$iu(), this.name = "", this.source = new $a42f1354f0348298$var$wu(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = a, this.minFilter = r, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new $a42f1354f0348298$var$cu(0, 0), this.repeat = new $a42f1354f0348298$var$cu(1, 1), this.center = new $a42f1354f0348298$var$cu(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $a42f1354f0348298$var$Au, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = c, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0, this.normalized = !1;
    }
    get width() {
        return this.source.getSize($a42f1354f0348298$var$Cu).x;
    }
    get height() {
        return this.source.getSize($a42f1354f0348298$var$Cu).y;
    }
    get depth() {
        return this.source.getSize($a42f1354f0348298$var$Cu).z;
    }
    get image() {
        return this.source.data;
    }
    set image(e) {
        this.source.data = e;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e) {
        return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.normalized = e.normalized, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
    }
    setValues(e) {
        for(const t in e){
            const i = e[t];
            if (void 0 === i) {
                $a42f1354f0348298$var$Wd(`Texture.setValues(): parameter '${t}' has value of undefined.`);
                continue;
            }
            const n = this[t];
            void 0 !== n ? n && i && n.isVector2 && i.isVector2 || n && i && n.isVector3 && i.isVector3 || n && i && n.isMatrix3 && i.isMatrix3 ? n.copy(i) : this[t] = i : $a42f1354f0348298$var$Wd(`Texture.setValues(): property '${t}' does not exist.`);
        }
    }
    toJSON(e) {
        const t = void 0 === e || "string" == typeof e;
        if (!t && void 0 !== e.textures[this.uuid]) return e.textures[this.uuid];
        const i = {
            metadata: {
                version: 4.7,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(e).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            normalized: this.normalized,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (i.userData = this.userData), t || (e.textures[this.uuid] = i), i;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(e) {
        if (300 !== this.mapping) return e;
        if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1) switch(this.wrapS){
            case $a42f1354f0348298$var$Ac:
                e.x = e.x - Math.floor(e.x);
                break;
            case $a42f1354f0348298$var$mc:
                e.x = e.x < 0 ? 0 : 1;
                break;
            case $a42f1354f0348298$var$gc:
                1 === Math.abs(Math.floor(e.x) % 2) ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
        }
        if (e.y < 0 || e.y > 1) switch(this.wrapT){
            case $a42f1354f0348298$var$Ac:
                e.y = e.y - Math.floor(e.y);
                break;
            case $a42f1354f0348298$var$mc:
                e.y = e.y < 0 ? 0 : 1;
                break;
            case $a42f1354f0348298$var$gc:
                1 === Math.abs(Math.floor(e.y) % 2) ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
        }
        return this.flipY && (e.y = 1 - e.y), e;
    }
    set needsUpdate(e) {
        !0 === e && (this.version++, this.source.needsUpdate = !0);
    }
    set needsPMREMUpdate(e) {
        !0 === e && this.pmremVersion++;
    }
}
$a42f1354f0348298$var$Tu.DEFAULT_IMAGE = null, $a42f1354f0348298$var$Tu.DEFAULT_MAPPING = 300, $a42f1354f0348298$var$Tu.DEFAULT_ANISOTROPY = 1;
class $a42f1354f0348298$var$Du {
    static{
        $a42f1354f0348298$var$Du.prototype.isVector4 = !0;
    }
    constructor(e = 0, t = 0, i = 0, n = 1){
        this.x = e, this.y = t, this.z = i, this.w = n;
    }
    get width() {
        return this.z;
    }
    set width(e) {
        this.z = e;
    }
    get height() {
        return this.w;
    }
    set height(e) {
        this.w = e;
    }
    set(e, t, i, n) {
        return this.x = e, this.y = t, this.z = i, this.w = n, this;
    }
    setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this.w = e, this;
    }
    setX(e) {
        return this.x = e, this;
    }
    setY(e) {
        return this.y = e, this;
    }
    setZ(e) {
        return this.z = e, this;
    }
    setW(e) {
        return this.w = e, this;
    }
    setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            case 3:
                this.w = t;
                break;
            default:
                throw new Error("THREE.Vector4: index is out of range: " + e);
        }
        return this;
    }
    getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("THREE.Vector4: index is out of range: " + e);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this.w = void 0 !== e.w ? e.w : 1, this;
    }
    add(e) {
        return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
    }
    addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this.w += e, this;
    }
    addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
    }
    addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
    }
    sub(e) {
        return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
    }
    subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
    }
    subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
    }
    multiply(e) {
        return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
    }
    multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
    }
    applyMatrix4(e) {
        const t = this.x, i = this.y, n = this.z, a = this.w, r = e.elements;
        return this.x = r[0] * t + r[4] * i + r[8] * n + r[12] * a, this.y = r[1] * t + r[5] * i + r[9] * n + r[13] * a, this.z = r[2] * t + r[6] * i + r[10] * n + r[14] * a, this.w = r[3] * t + r[7] * i + r[11] * n + r[15] * a, this;
    }
    divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
    }
    divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    setAxisAngleFromQuaternion(e) {
        this.w = 2 * Math.acos(e.w);
        const t = Math.sqrt(1 - e.w * e.w);
        return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
    }
    setAxisAngleFromRotationMatrix(e) {
        let t, i, n, a;
        const r = .01, s = .1, o = e.elements, l = o[0], c = o[4], d = o[8], u = o[1], h = o[5], p = o[9], A = o[2], m = o[6], g = o[10];
        if (Math.abs(c - u) < r && Math.abs(d - A) < r && Math.abs(p - m) < r) {
            if (Math.abs(c + u) < s && Math.abs(d + A) < s && Math.abs(p + m) < s && Math.abs(l + h + g - 3) < s) return this.set(1, 0, 0, 0), this;
            t = Math.PI;
            const e = (l + 1) / 2, o = (h + 1) / 2, f = (g + 1) / 2, _ = (c + u) / 4, v = (d + A) / 4, E = (p + m) / 4;
            return e > o && e > f ? e < r ? (i = 0, n = .707106781, a = .707106781) : (i = Math.sqrt(e), n = _ / i, a = v / i) : o > f ? o < r ? (i = .707106781, n = 0, a = .707106781) : (n = Math.sqrt(o), i = _ / n, a = E / n) : f < r ? (i = .707106781, n = .707106781, a = 0) : (a = Math.sqrt(f), i = v / a, n = E / a), this.set(i, n, a, t), this;
        }
        let f = Math.sqrt((m - p) * (m - p) + (d - A) * (d - A) + (u - c) * (u - c));
        return Math.abs(f) < .001 && (f = 1), this.x = (m - p) / f, this.y = (d - A) / f, this.z = (u - c) / f, this.w = Math.acos((l + h + g - 1) / 2), this;
    }
    setFromMatrixPosition(e) {
        const t = e.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
    }
    min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
    }
    max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
    }
    clamp(e, t) {
        return this.x = $a42f1354f0348298$var$nu(this.x, e.x, t.x), this.y = $a42f1354f0348298$var$nu(this.y, e.y, t.y), this.z = $a42f1354f0348298$var$nu(this.z, e.z, t.z), this.w = $a42f1354f0348298$var$nu(this.w, e.w, t.w), this;
    }
    clampScalar(e, t) {
        return this.x = $a42f1354f0348298$var$nu(this.x, e, t), this.y = $a42f1354f0348298$var$nu(this.y, e, t), this.z = $a42f1354f0348298$var$nu(this.z, e, t), this.w = $a42f1354f0348298$var$nu(this.w, e, t), this;
    }
    clampLength(e, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($a42f1354f0348298$var$nu(i, e, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
    }
    lerpVectors(e, t, i) {
        return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this.z = e.z + (t.z - e.z) * i, this.w = e.w + (t.w - e.w) * i, this;
    }
    equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
    }
    fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
    }
    fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}
class $a42f1354f0348298$var$Pu extends $a42f1354f0348298$var$Yd {
    constructor(e = 1, t = 1, i = {}){
        super(), i = Object.assign({
            generateMipmaps: !1,
            internalFormat: null,
            minFilter: $a42f1354f0348298$var$Ec,
            depthBuffer: !0,
            stencilBuffer: !1,
            resolveDepthBuffer: !0,
            resolveStencilBuffer: !0,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: !1,
            useArrayDepthTexture: !1
        }, i), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = i.depth, this.scissor = new $a42f1354f0348298$var$Du(0, 0, e, t), this.scissorTest = !1, this.viewport = new $a42f1354f0348298$var$Du(0, 0, e, t), this.textures = [];
        const n = {
            width: e,
            height: t,
            depth: i.depth
        }, a = new $a42f1354f0348298$var$Tu(n), r = i.count;
        for(let e = 0; e < r; e++)this.textures[e] = a.clone(), this.textures[e].isRenderTargetTexture = !0, this.textures[e].renderTarget = this;
        this._setTextureOptions(i), this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.resolveDepthBuffer = i.resolveDepthBuffer, this.resolveStencilBuffer = i.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = i.depthTexture, this.samples = i.samples, this.multiview = i.multiview, this.useArrayDepthTexture = i.useArrayDepthTexture;
    }
    _setTextureOptions(e = {}) {
        const t = {
            minFilter: $a42f1354f0348298$var$Ec,
            generateMipmaps: !1,
            flipY: !1,
            internalFormat: null
        };
        void 0 !== e.mapping && (t.mapping = e.mapping), void 0 !== e.wrapS && (t.wrapS = e.wrapS), void 0 !== e.wrapT && (t.wrapT = e.wrapT), void 0 !== e.wrapR && (t.wrapR = e.wrapR), void 0 !== e.magFilter && (t.magFilter = e.magFilter), void 0 !== e.minFilter && (t.minFilter = e.minFilter), void 0 !== e.format && (t.format = e.format), void 0 !== e.type && (t.type = e.type), void 0 !== e.anisotropy && (t.anisotropy = e.anisotropy), void 0 !== e.colorSpace && (t.colorSpace = e.colorSpace), void 0 !== e.flipY && (t.flipY = e.flipY), void 0 !== e.generateMipmaps && (t.generateMipmaps = e.generateMipmaps), void 0 !== e.internalFormat && (t.internalFormat = e.internalFormat);
        for(let e = 0; e < this.textures.length; e++)this.textures[e].setValues(t);
    }
    get texture() {
        return this.textures[0];
    }
    set texture(e) {
        this.textures[0] = e;
    }
    set depthTexture(e) {
        null !== this._depthTexture && (this._depthTexture.renderTarget = null), null !== e && (e.renderTarget = this), this._depthTexture = e;
    }
    get depthTexture() {
        return this._depthTexture;
    }
    setSize(e, t, i = 1) {
        if (this.width !== e || this.height !== t || this.depth !== i) {
            this.width = e, this.height = t, this.depth = i;
            for(let n = 0, a = this.textures.length; n < a; n++)this.textures[n].image.width = e, this.textures[n].image.height = t, this.textures[n].image.depth = i, !0 !== this.textures[n].isData3DTexture && (this.textures[n].isArrayTexture = this.textures[n].image.depth > 1);
            this.dispose();
        }
        this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e) {
        this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
        for(let t = 0, i = e.textures.length; t < i; t++){
            this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
            const i = Object.assign({}, e.textures[t].image);
            this.textures[t].source = new $a42f1354f0348298$var$wu(i);
        }
        return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, null !== e.depthTexture && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this.multiview = e.multiview, this.useArrayDepthTexture = e.useArrayDepthTexture, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $a42f1354f0348298$var$Iu extends $a42f1354f0348298$var$Pu {
    constructor(e = 1, t = 1, i = {}){
        super(e, t, i), this.isWebGLRenderTarget = !0;
    }
}
class $a42f1354f0348298$var$Lu extends $a42f1354f0348298$var$Tu {
    constructor(e = null, t = 1, i = 1, n = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: e,
            width: t,
            height: i,
            depth: n
        }, this.magFilter = $a42f1354f0348298$var$fc, this.minFilter = $a42f1354f0348298$var$fc, this.wrapR = $a42f1354f0348298$var$mc, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = new Set;
    }
    addLayerUpdate(e) {
        this.layerUpdates.add(e);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $a42f1354f0348298$var$Ru extends $a42f1354f0348298$var$Tu {
    constructor(e = null, t = 1, i = 1, n = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: e,
            width: t,
            height: i,
            depth: n
        }, this.magFilter = $a42f1354f0348298$var$fc, this.minFilter = $a42f1354f0348298$var$fc, this.wrapR = $a42f1354f0348298$var$mc, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
class $a42f1354f0348298$var$zu {
    static{
        $a42f1354f0348298$var$zu.prototype.isMatrix4 = !0;
    }
    constructor(e, t, i, n, a, r, s, o, l, c, d, u, h, p, A, m){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ], void 0 !== e && this.set(e, t, i, n, a, r, s, o, l, c, d, u, h, p, A, m);
    }
    set(e, t, i, n, a, r, s, o, l, c, d, u, h, p, A, m) {
        const g = this.elements;
        return g[0] = e, g[4] = t, g[8] = i, g[12] = n, g[1] = a, g[5] = r, g[9] = s, g[13] = o, g[2] = l, g[6] = c, g[10] = d, g[14] = u, g[3] = h, g[7] = p, g[11] = A, g[15] = m, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return (new $a42f1354f0348298$var$zu).fromArray(this.elements);
    }
    copy(e) {
        const t = this.elements, i = e.elements;
        return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], t[9] = i[9], t[10] = i[10], t[11] = i[11], t[12] = i[12], t[13] = i[13], t[14] = i[14], t[15] = i[15], this;
    }
    copyPosition(e) {
        const t = this.elements, i = e.elements;
        return t[12] = i[12], t[13] = i[13], t[14] = i[14], this;
    }
    setFromMatrix3(e) {
        const t = e.elements;
        return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(e, t, i) {
        return 0 === this.determinantAffine() ? (e.set(1, 0, 0), t.set(0, 1, 0), i.set(0, 0, 1), this) : (e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this);
    }
    makeBasis(e, t, i) {
        return this.set(e.x, t.x, i.x, 0, e.y, t.y, i.y, 0, e.z, t.z, i.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(e) {
        if (0 === e.determinantAffine()) return this.identity();
        const t = this.elements, i = e.elements, n = 1 / $a42f1354f0348298$var$Fu.setFromMatrixColumn(e, 0).length(), a = 1 / $a42f1354f0348298$var$Fu.setFromMatrixColumn(e, 1).length(), r = 1 / $a42f1354f0348298$var$Fu.setFromMatrixColumn(e, 2).length();
        return t[0] = i[0] * n, t[1] = i[1] * n, t[2] = i[2] * n, t[3] = 0, t[4] = i[4] * a, t[5] = i[5] * a, t[6] = i[6] * a, t[7] = 0, t[8] = i[8] * r, t[9] = i[9] * r, t[10] = i[10] * r, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    makeRotationFromEuler(e) {
        const t = this.elements, i = e.x, n = e.y, a = e.z, r = Math.cos(i), s = Math.sin(i), o = Math.cos(n), l = Math.sin(n), c = Math.cos(a), d = Math.sin(a);
        if ("XYZ" === e.order) {
            const e = r * c, i = r * d, n = s * c, a = s * d;
            t[0] = o * c, t[4] = -o * d, t[8] = l, t[1] = i + n * l, t[5] = e - a * l, t[9] = -s * o, t[2] = a - e * l, t[6] = n + i * l, t[10] = r * o;
        } else if ("YXZ" === e.order) {
            const e = o * c, i = o * d, n = l * c, a = l * d;
            t[0] = e + a * s, t[4] = n * s - i, t[8] = r * l, t[1] = r * d, t[5] = r * c, t[9] = -s, t[2] = i * s - n, t[6] = a + e * s, t[10] = r * o;
        } else if ("ZXY" === e.order) {
            const e = o * c, i = o * d, n = l * c, a = l * d;
            t[0] = e - a * s, t[4] = -r * d, t[8] = n + i * s, t[1] = i + n * s, t[5] = r * c, t[9] = a - e * s, t[2] = -r * l, t[6] = s, t[10] = r * o;
        } else if ("ZYX" === e.order) {
            const e = r * c, i = r * d, n = s * c, a = s * d;
            t[0] = o * c, t[4] = n * l - i, t[8] = e * l + a, t[1] = o * d, t[5] = a * l + e, t[9] = i * l - n, t[2] = -l, t[6] = s * o, t[10] = r * o;
        } else if ("YZX" === e.order) {
            const e = r * o, i = r * l, n = s * o, a = s * l;
            t[0] = o * c, t[4] = a - e * d, t[8] = n * d + i, t[1] = d, t[5] = r * c, t[9] = -s * c, t[2] = -l * c, t[6] = i * d + n, t[10] = e - a * d;
        } else if ("XZY" === e.order) {
            const e = r * o, i = r * l, n = s * o, a = s * l;
            t[0] = o * c, t[4] = -d, t[8] = l * c, t[1] = e * d + a, t[5] = r * c, t[9] = i * d - n, t[2] = n * d - i, t[6] = s * c, t[10] = a * d + e;
        }
        return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    makeRotationFromQuaternion(e) {
        return this.compose($a42f1354f0348298$var$Nu, e, $a42f1354f0348298$var$Bu);
    }
    lookAt(e, t, i) {
        const n = this.elements;
        return $a42f1354f0348298$var$Gu.subVectors(e, t), 0 === $a42f1354f0348298$var$Gu.lengthSq() && ($a42f1354f0348298$var$Gu.z = 1), $a42f1354f0348298$var$Gu.normalize(), $a42f1354f0348298$var$Ou.crossVectors(i, $a42f1354f0348298$var$Gu), 0 === $a42f1354f0348298$var$Ou.lengthSq() && (1 === Math.abs(i.z) ? $a42f1354f0348298$var$Gu.x += 1e-4 : $a42f1354f0348298$var$Gu.z += 1e-4, $a42f1354f0348298$var$Gu.normalize(), $a42f1354f0348298$var$Ou.crossVectors(i, $a42f1354f0348298$var$Gu)), $a42f1354f0348298$var$Ou.normalize(), $a42f1354f0348298$var$ju.crossVectors($a42f1354f0348298$var$Gu, $a42f1354f0348298$var$Ou), n[0] = $a42f1354f0348298$var$Ou.x, n[4] = $a42f1354f0348298$var$ju.x, n[8] = $a42f1354f0348298$var$Gu.x, n[1] = $a42f1354f0348298$var$Ou.y, n[5] = $a42f1354f0348298$var$ju.y, n[9] = $a42f1354f0348298$var$Gu.y, n[2] = $a42f1354f0348298$var$Ou.z, n[6] = $a42f1354f0348298$var$ju.z, n[10] = $a42f1354f0348298$var$Gu.z, this;
    }
    multiply(e) {
        return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
        return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
        const i = e.elements, n = t.elements, a = this.elements, r = i[0], s = i[4], o = i[8], l = i[12], c = i[1], d = i[5], u = i[9], h = i[13], p = i[2], A = i[6], m = i[10], g = i[14], f = i[3], _ = i[7], v = i[11], E = i[15], y = n[0], b = n[4], k = n[8], x = n[12], w = n[1], M = n[5], S = n[9], C = n[13], T = n[2], D = n[6], P = n[10], I = n[14], L = n[3], R = n[7], z = n[11], F = n[15];
        return a[0] = r * y + s * w + o * T + l * L, a[4] = r * b + s * M + o * D + l * R, a[8] = r * k + s * S + o * P + l * z, a[12] = r * x + s * C + o * I + l * F, a[1] = c * y + d * w + u * T + h * L, a[5] = c * b + d * M + u * D + h * R, a[9] = c * k + d * S + u * P + h * z, a[13] = c * x + d * C + u * I + h * F, a[2] = p * y + A * w + m * T + g * L, a[6] = p * b + A * M + m * D + g * R, a[10] = p * k + A * S + m * P + g * z, a[14] = p * x + A * C + m * I + g * F, a[3] = f * y + _ * w + v * T + E * L, a[7] = f * b + _ * M + v * D + E * R, a[11] = f * k + _ * S + v * P + E * z, a[15] = f * x + _ * C + v * I + E * F, this;
    }
    multiplyScalar(e) {
        const t = this.elements;
        return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
    }
    determinant() {
        const e = this.elements, t = e[0], i = e[4], n = e[8], a = e[12], r = e[1], s = e[5], o = e[9], l = e[13], c = e[2], d = e[6], u = e[10], h = e[14], p = e[3], A = e[7], m = e[11], g = e[15], f = o * h - l * u, _ = s * h - l * d, v = s * u - o * d, E = r * h - l * c, y = r * u - o * c, b = r * d - s * c;
        return t * (A * f - m * _ + g * v) - i * (p * f - m * E + g * y) + n * (p * _ - A * E + g * b) - a * (p * v - A * y + m * b);
    }
    determinantAffine() {
        const e = this.elements, t = e[0], i = e[4], n = e[8], a = e[1], r = e[5], s = e[9], o = e[2], l = e[6], c = e[10];
        return t * (r * c - s * l) - i * (a * c - s * o) + n * (a * l - r * o);
    }
    transpose() {
        const e = this.elements;
        let t;
        return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
    }
    setPosition(e, t, i) {
        const n = this.elements;
        return e.isVector3 ? (n[12] = e.x, n[13] = e.y, n[14] = e.z) : (n[12] = e, n[13] = t, n[14] = i), this;
    }
    invert() {
        const e = this.elements, t = e[0], i = e[1], n = e[2], a = e[3], r = e[4], s = e[5], o = e[6], l = e[7], c = e[8], d = e[9], u = e[10], h = e[11], p = e[12], A = e[13], m = e[14], g = e[15], f = t * s - i * r, _ = t * o - n * r, v = t * l - a * r, E = i * o - n * s, y = i * l - a * s, b = n * l - a * o, k = c * A - d * p, x = c * m - u * p, w = c * g - h * p, M = d * m - u * A, S = d * g - h * A, C = u * g - h * m, T = f * C - _ * S + v * M + E * w - y * x + b * k;
        if (0 === T) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const D = 1 / T;
        return e[0] = (s * C - o * S + l * M) * D, e[1] = (n * S - i * C - a * M) * D, e[2] = (A * b - m * y + g * E) * D, e[3] = (u * y - d * b - h * E) * D, e[4] = (o * w - r * C - l * x) * D, e[5] = (t * C - n * w + a * x) * D, e[6] = (m * v - p * b - g * _) * D, e[7] = (c * b - u * v + h * _) * D, e[8] = (r * S - s * w + l * k) * D, e[9] = (i * w - t * S - a * k) * D, e[10] = (p * y - A * v + g * f) * D, e[11] = (d * v - c * y - h * f) * D, e[12] = (s * x - r * M - o * k) * D, e[13] = (t * M - i * x + n * k) * D, e[14] = (A * _ - p * E - m * f) * D, e[15] = (c * E - d * _ + u * f) * D, this;
    }
    scale(e) {
        const t = this.elements, i = e.x, n = e.y, a = e.z;
        return t[0] *= i, t[4] *= n, t[8] *= a, t[1] *= i, t[5] *= n, t[9] *= a, t[2] *= i, t[6] *= n, t[10] *= a, t[3] *= i, t[7] *= n, t[11] *= a, this;
    }
    getMaxScaleOnAxis() {
        const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], i = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], n = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
        return Math.sqrt(Math.max(t, i, n));
    }
    makeTranslation(e, t, i) {
        return e.isVector3 ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1) : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, i, 0, 0, 0, 1), this;
    }
    makeRotationX(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(1, 0, 0, 0, 0, t, -i, 0, 0, i, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(t, 0, i, 0, 0, 1, 0, 0, -i, 0, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(e) {
        const t = Math.cos(e), i = Math.sin(e);
        return this.set(t, -i, 0, 0, i, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(e, t) {
        const i = Math.cos(t), n = Math.sin(t), a = 1 - i, r = e.x, s = e.y, o = e.z, l = a * r, c = a * s;
        return this.set(l * r + i, l * s - n * o, l * o + n * s, 0, l * s + n * o, c * s + i, c * o - n * r, 0, l * o - n * s, c * o + n * r, a * o * o + i, 0, 0, 0, 0, 1), this;
    }
    makeScale(e, t, i) {
        return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
    }
    makeShear(e, t, i, n, a, r) {
        return this.set(1, i, a, 0, e, 1, r, 0, t, n, 1, 0, 0, 0, 0, 1), this;
    }
    compose(e, t, i) {
        const n = this.elements, a = t._x, r = t._y, s = t._z, o = t._w, l = a + a, c = r + r, d = s + s, u = a * l, h = a * c, p = a * d, A = r * c, m = r * d, g = s * d, f = o * l, _ = o * c, v = o * d, E = i.x, y = i.y, b = i.z;
        return n[0] = (1 - (A + g)) * E, n[1] = (h + v) * E, n[2] = (p - _) * E, n[3] = 0, n[4] = (h - v) * y, n[5] = (1 - (u + g)) * y, n[6] = (m + f) * y, n[7] = 0, n[8] = (p + _) * b, n[9] = (m - f) * b, n[10] = (1 - (u + A)) * b, n[11] = 0, n[12] = e.x, n[13] = e.y, n[14] = e.z, n[15] = 1, this;
    }
    decompose(e, t, i) {
        const n = this.elements;
        e.x = n[12], e.y = n[13], e.z = n[14];
        const a = this.determinantAffine();
        if (0 === a) return i.set(1, 1, 1), t.identity(), this;
        let r = $a42f1354f0348298$var$Fu.set(n[0], n[1], n[2]).length();
        const s = $a42f1354f0348298$var$Fu.set(n[4], n[5], n[6]).length(), o = $a42f1354f0348298$var$Fu.set(n[8], n[9], n[10]).length();
        a < 0 && (r = -r), $a42f1354f0348298$var$Uu.copy(this);
        const l = 1 / r, c = 1 / s, d = 1 / o;
        return $a42f1354f0348298$var$Uu.elements[0] *= l, $a42f1354f0348298$var$Uu.elements[1] *= l, $a42f1354f0348298$var$Uu.elements[2] *= l, $a42f1354f0348298$var$Uu.elements[4] *= c, $a42f1354f0348298$var$Uu.elements[5] *= c, $a42f1354f0348298$var$Uu.elements[6] *= c, $a42f1354f0348298$var$Uu.elements[8] *= d, $a42f1354f0348298$var$Uu.elements[9] *= d, $a42f1354f0348298$var$Uu.elements[10] *= d, t.setFromRotationMatrix($a42f1354f0348298$var$Uu), i.x = r, i.y = s, i.z = o, this;
    }
    makePerspective(e, t, i, n, a, r, s = 2e3, o = !1) {
        const l = this.elements, c = 2 * a / (t - e), d = 2 * a / (i - n), u = (t + e) / (t - e), h = (i + n) / (i - n);
        let p, A;
        if (o) p = a / (r - a), A = r * a / (r - a);
        else if (s === $a42f1354f0348298$var$Od) p = -(r + a) / (r - a), A = -2 * r * a / (r - a);
        else {
            if (s !== $a42f1354f0348298$var$jd) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
            p = -r / (r - a), A = -r * a / (r - a);
        }
        return l[0] = c, l[4] = 0, l[8] = u, l[12] = 0, l[1] = 0, l[5] = d, l[9] = h, l[13] = 0, l[2] = 0, l[6] = 0, l[10] = p, l[14] = A, l[3] = 0, l[7] = 0, l[11] = -1, l[15] = 0, this;
    }
    makeOrthographic(e, t, i, n, a, r, s = 2e3, o = !1) {
        const l = this.elements, c = 2 / (t - e), d = 2 / (i - n), u = -(t + e) / (t - e), h = -(i + n) / (i - n);
        let p, A;
        if (o) p = 1 / (r - a), A = r / (r - a);
        else if (s === $a42f1354f0348298$var$Od) p = -2 / (r - a), A = -(r + a) / (r - a);
        else {
            if (s !== $a42f1354f0348298$var$jd) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
            p = -1 / (r - a), A = -a / (r - a);
        }
        return l[0] = c, l[4] = 0, l[8] = 0, l[12] = u, l[1] = 0, l[5] = d, l[9] = 0, l[13] = h, l[2] = 0, l[6] = 0, l[10] = p, l[14] = A, l[3] = 0, l[7] = 0, l[11] = 0, l[15] = 1, this;
    }
    equals(e) {
        const t = this.elements, i = e.elements;
        for(let e = 0; e < 16; e++)if (t[e] !== i[e]) return !1;
        return !0;
    }
    fromArray(e, t = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = e[i + t];
        return this;
    }
    toArray(e = [], t = 0) {
        const i = this.elements;
        return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e[t + 9] = i[9], e[t + 10] = i[10], e[t + 11] = i[11], e[t + 12] = i[12], e[t + 13] = i[13], e[t + 14] = i[14], e[t + 15] = i[15], e;
    }
}
const $a42f1354f0348298$var$Fu = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Uu = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Nu = new $a42f1354f0348298$var$uu(0, 0, 0), $a42f1354f0348298$var$Bu = new $a42f1354f0348298$var$uu(1, 1, 1), $a42f1354f0348298$var$Ou = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$ju = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Gu = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Vu = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Hu = new $a42f1354f0348298$var$du;
class $a42f1354f0348298$var$qu {
    constructor(e = 0, t = 0, i = 0, n = $a42f1354f0348298$var$qu.DEFAULT_ORDER){
        this.isEuler = !0, this._x = e, this._y = t, this._z = i, this._order = n;
    }
    get x() {
        return this._x;
    }
    set x(e) {
        this._x = e, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(e) {
        this._y = e, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(e) {
        this._z = e, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(e) {
        this._order = e, this._onChangeCallback();
    }
    set(e, t, i, n = this._order) {
        return this._x = e, this._y = t, this._z = i, this._order = n, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(e) {
        return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(e, t = this._order, i = !0) {
        const n = e.elements, a = n[0], r = n[4], s = n[8], o = n[1], l = n[5], c = n[9], d = n[2], u = n[6], h = n[10];
        switch(t){
            case "XYZ":
                this._y = Math.asin($a42f1354f0348298$var$nu(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, h), this._z = Math.atan2(-r, a)) : (this._x = Math.atan2(u, l), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-$a42f1354f0348298$var$nu(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, h), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-d, a), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin($a42f1354f0348298$var$nu(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(-d, h), this._z = Math.atan2(-r, l)) : (this._y = 0, this._z = Math.atan2(o, a));
                break;
            case "ZYX":
                this._y = Math.asin(-$a42f1354f0348298$var$nu(d, -1, 1)), Math.abs(d) < .9999999 ? (this._x = Math.atan2(u, h), this._z = Math.atan2(o, a)) : (this._x = 0, this._z = Math.atan2(-r, l));
                break;
            case "YZX":
                this._z = Math.asin($a42f1354f0348298$var$nu(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-d, a)) : (this._x = 0, this._y = Math.atan2(s, h));
                break;
            case "XZY":
                this._z = Math.asin(-$a42f1354f0348298$var$nu(r, -1, 1)), Math.abs(r) < .9999999 ? (this._x = Math.atan2(u, l), this._y = Math.atan2(s, a)) : (this._x = Math.atan2(-c, h), this._y = 0);
                break;
            default:
                $a42f1354f0348298$var$Wd("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
        }
        return this._order = t, !0 === i && this._onChangeCallback(), this;
    }
    setFromQuaternion(e, t, i) {
        return $a42f1354f0348298$var$Vu.makeRotationFromQuaternion(e), this.setFromRotationMatrix($a42f1354f0348298$var$Vu, t, i);
    }
    setFromVector3(e, t = this._order) {
        return this.set(e.x, e.y, e.z, t);
    }
    reorder(e) {
        return $a42f1354f0348298$var$Hu.setFromEuler(this), this.setFromQuaternion($a42f1354f0348298$var$Hu, e);
    }
    equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
    }
    fromArray(e) {
        return this._x = e[0], this._y = e[1], this._z = e[2], void 0 !== e[3] && (this._order = e[3]), this._onChangeCallback(), this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
    }
    _onChange(e) {
        return this._onChangeCallback = e, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
}
$a42f1354f0348298$var$qu.DEFAULT_ORDER = "XYZ";
class $a42f1354f0348298$var$Ku {
    constructor(){
        this.mask = 1;
    }
    set(e) {
        this.mask = 1 << e >>> 0;
    }
    enable(e) {
        this.mask |= 1 << e;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(e) {
        this.mask ^= 1 << e;
    }
    disable(e) {
        this.mask &= ~(1 << e);
    }
    disableAll() {
        this.mask = 0;
    }
    test(e) {
        return 0 !== (this.mask & e.mask);
    }
    isEnabled(e) {
        return !!(this.mask & 1 << e);
    }
}
let $a42f1354f0348298$var$Wu = 0;
const $a42f1354f0348298$var$Xu = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Qu = new $a42f1354f0348298$var$du, $a42f1354f0348298$var$Zu = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Yu = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Ju = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$$u = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$eh = new $a42f1354f0348298$var$du, $a42f1354f0348298$var$th = new $a42f1354f0348298$var$uu(1, 0, 0), $a42f1354f0348298$var$ih = new $a42f1354f0348298$var$uu(0, 1, 0), $a42f1354f0348298$var$nh = new $a42f1354f0348298$var$uu(0, 0, 1), $a42f1354f0348298$var$ah = {
    type: "added"
}, $a42f1354f0348298$var$rh = {
    type: "removed"
}, $a42f1354f0348298$var$sh = {
    type: "childadded",
    child: null
}, $a42f1354f0348298$var$oh = {
    type: "childremoved",
    child: null
};
class $a42f1354f0348298$var$lh extends $a42f1354f0348298$var$Yd {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: $a42f1354f0348298$var$Wu++
        }), this.uuid = $a42f1354f0348298$var$iu(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = $a42f1354f0348298$var$lh.DEFAULT_UP.clone();
        const e = new $a42f1354f0348298$var$uu, t = new $a42f1354f0348298$var$qu, i = new $a42f1354f0348298$var$du, n = new $a42f1354f0348298$var$uu(1, 1, 1);
        t._onChange(function() {
            i.setFromEuler(t, !1);
        }), i._onChange(function() {
            t.setFromQuaternion(i, void 0, !1);
        }), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: n
            },
            modelViewMatrix: {
                value: new $a42f1354f0348298$var$zu
            },
            normalMatrix: {
                value: new $a42f1354f0348298$var$Au
            }
        }), this.matrix = new $a42f1354f0348298$var$zu, this.matrixWorld = new $a42f1354f0348298$var$zu, this.matrixAutoUpdate = $a42f1354f0348298$var$lh.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = $a42f1354f0348298$var$lh.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new $a42f1354f0348298$var$Ku, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.static = !1, this.userData = {}, this.pivot = null;
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(e) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(e) {
        return this.quaternion.premultiply(e), this;
    }
    setRotationFromAxisAngle(e, t) {
        this.quaternion.setFromAxisAngle(e, t);
    }
    setRotationFromEuler(e) {
        this.quaternion.setFromEuler(e, !0);
    }
    setRotationFromMatrix(e) {
        this.quaternion.setFromRotationMatrix(e);
    }
    setRotationFromQuaternion(e) {
        this.quaternion.copy(e);
    }
    rotateOnAxis(e, t) {
        return $a42f1354f0348298$var$Qu.setFromAxisAngle(e, t), this.quaternion.multiply($a42f1354f0348298$var$Qu), this;
    }
    rotateOnWorldAxis(e, t) {
        return $a42f1354f0348298$var$Qu.setFromAxisAngle(e, t), this.quaternion.premultiply($a42f1354f0348298$var$Qu), this;
    }
    rotateX(e) {
        return this.rotateOnAxis($a42f1354f0348298$var$th, e);
    }
    rotateY(e) {
        return this.rotateOnAxis($a42f1354f0348298$var$ih, e);
    }
    rotateZ(e) {
        return this.rotateOnAxis($a42f1354f0348298$var$nh, e);
    }
    translateOnAxis(e, t) {
        return $a42f1354f0348298$var$Xu.copy(e).applyQuaternion(this.quaternion), this.position.add($a42f1354f0348298$var$Xu.multiplyScalar(t)), this;
    }
    translateX(e) {
        return this.translateOnAxis($a42f1354f0348298$var$th, e);
    }
    translateY(e) {
        return this.translateOnAxis($a42f1354f0348298$var$ih, e);
    }
    translateZ(e) {
        return this.translateOnAxis($a42f1354f0348298$var$nh, e);
    }
    localToWorld(e) {
        return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(e) {
        return this.updateWorldMatrix(!0, !1), e.applyMatrix4($a42f1354f0348298$var$Zu.copy(this.matrixWorld).invert());
    }
    lookAt(e, t, i) {
        e.isVector3 ? $a42f1354f0348298$var$Yu.copy(e) : $a42f1354f0348298$var$Yu.set(e, t, i);
        const n = this.parent;
        this.updateWorldMatrix(!0, !1), $a42f1354f0348298$var$Ju.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $a42f1354f0348298$var$Zu.lookAt($a42f1354f0348298$var$Ju, $a42f1354f0348298$var$Yu, this.up) : $a42f1354f0348298$var$Zu.lookAt($a42f1354f0348298$var$Yu, $a42f1354f0348298$var$Ju, this.up), this.quaternion.setFromRotationMatrix($a42f1354f0348298$var$Zu), n && ($a42f1354f0348298$var$Zu.extractRotation(n.matrixWorld), $a42f1354f0348298$var$Qu.setFromRotationMatrix($a42f1354f0348298$var$Zu), this.quaternion.premultiply($a42f1354f0348298$var$Qu.invert()));
    }
    add(e) {
        if (arguments.length > 1) {
            for(let e = 0; e < arguments.length; e++)this.add(arguments[e]);
            return this;
        }
        return e === this ? ($a42f1354f0348298$var$Xd("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent($a42f1354f0348298$var$ah), $a42f1354f0348298$var$sh.child = e, this.dispatchEvent($a42f1354f0348298$var$sh), $a42f1354f0348298$var$sh.child = null) : $a42f1354f0348298$var$Xd("Object3D.add: object not an instance of THREE.Object3D.", e), this);
    }
    remove(e) {
        if (arguments.length > 1) {
            for(let e = 0; e < arguments.length; e++)this.remove(arguments[e]);
            return this;
        }
        const t = this.children.indexOf(e);
        return -1 !== t && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent($a42f1354f0348298$var$rh), $a42f1354f0348298$var$oh.child = e, this.dispatchEvent($a42f1354f0348298$var$oh), $a42f1354f0348298$var$oh.child = null), this;
    }
    removeFromParent() {
        const e = this.parent;
        return null !== e && e.remove(this), this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(e) {
        return this.updateWorldMatrix(!0, !1), $a42f1354f0348298$var$Zu.copy(this.matrixWorld).invert(), null !== e.parent && (e.parent.updateWorldMatrix(!0, !1), $a42f1354f0348298$var$Zu.multiply(e.parent.matrixWorld)), e.applyMatrix4($a42f1354f0348298$var$Zu), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent($a42f1354f0348298$var$ah), $a42f1354f0348298$var$sh.child = e, this.dispatchEvent($a42f1354f0348298$var$sh), $a42f1354f0348298$var$sh.child = null, this;
    }
    getObjectById(e) {
        return this.getObjectByProperty("id", e);
    }
    getObjectByName(e) {
        return this.getObjectByProperty("name", e);
    }
    getObjectByProperty(e, t) {
        if (this[e] === t) return this;
        for(let i = 0, n = this.children.length; i < n; i++){
            const n = this.children[i].getObjectByProperty(e, t);
            if (void 0 !== n) return n;
        }
    }
    getObjectsByProperty(e, t, i = []) {
        this[e] === t && i.push(this);
        const n = this.children;
        for(let a = 0, r = n.length; a < r; a++)n[a].getObjectsByProperty(e, t, i);
        return i;
    }
    getWorldPosition(e) {
        return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(e) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($a42f1354f0348298$var$Ju, e, $a42f1354f0348298$var$$u), e;
    }
    getWorldScale(e) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($a42f1354f0348298$var$Ju, $a42f1354f0348298$var$eh, e), e;
    }
    getWorldDirection(e) {
        this.updateWorldMatrix(!0, !1);
        const t = this.matrixWorld.elements;
        return e.set(t[8], t[9], t[10]).normalize();
    }
    raycast() {}
    traverse(e) {
        e(this);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].traverse(e);
    }
    traverseVisible(e) {
        if (!1 === this.visible) return;
        e(this);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].traverseVisible(e);
    }
    traverseAncestors(e) {
        const t = this.parent;
        null !== t && (e(t), t.traverseAncestors(e));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        const e = this.pivot;
        if (null !== e) {
            const t = e.x, i = e.y, n = e.z, a = this.matrix.elements;
            a[12] += t - a[0] * t - a[4] * i - a[8] * n, a[13] += i - a[1] * t - a[5] * i - a[9] * n, a[14] += n - a[2] * t - a[6] * i - a[10] * n;
        }
        this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(e) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].updateMatrixWorld(e);
    }
    updateWorldMatrix(e, t, i = !1) {
        const n = this.parent;
        if (!0 === e && null !== n && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || i) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, i = !0), !0 === t) {
            const e = this.children;
            for(let t = 0, n = e.length; t < n; t++)e[t].updateWorldMatrix(!1, !0, i);
        }
    }
    toJSON(e) {
        const t = void 0 === e || "string" == typeof e, i = {};
        t && (e = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, i.metadata = {
            version: 4.7,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        const n = {};
        function a(t, i) {
            return void 0 === t[i.uuid] && (t[i.uuid] = i.toJSON(e)), i.uuid;
        }
        if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), !0 === this.castShadow && (n.castShadow = !0), !0 === this.receiveShadow && (n.receiveShadow = !0), !1 === this.visible && (n.visible = !1), !1 === this.frustumCulled && (n.frustumCulled = !1), 0 !== this.renderOrder && (n.renderOrder = this.renderOrder), !1 !== this.static && (n.static = this.static), Object.keys(this.userData).length > 0 && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), n.up = this.up.toArray(), null !== this.pivot && (n.pivot = this.pivot.toArray()), !1 === this.matrixAutoUpdate && (n.matrixAutoUpdate = !1), void 0 !== this.morphTargetDictionary && (n.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary)), void 0 !== this.morphTargetInfluences && (n.morphTargetInfluences = this.morphTargetInfluences.slice()), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (n.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (n.type = "BatchedMesh", n.perObjectFrustumCulled = this.perObjectFrustumCulled, n.sortObjects = this.sortObjects, n.drawRanges = this._drawRanges, n.reservedRanges = this._reservedRanges, n.geometryInfo = this._geometryInfo.map((e)=>({
                ...e,
                boundingBox: e.boundingBox ? e.boundingBox.toJSON() : void 0,
                boundingSphere: e.boundingSphere ? e.boundingSphere.toJSON() : void 0
            })), n.instanceInfo = this._instanceInfo.map((e)=>({
                ...e
            })), n.availableInstanceIds = this._availableInstanceIds.slice(), n.availableGeometryIds = this._availableGeometryIds.slice(), n.nextIndexStart = this._nextIndexStart, n.nextVertexStart = this._nextVertexStart, n.geometryCount = this._geometryCount, n.maxInstanceCount = this._maxInstanceCount, n.maxVertexCount = this._maxVertexCount, n.maxIndexCount = this._maxIndexCount, n.geometryInitialized = this._geometryInitialized, n.matricesTexture = this._matricesTexture.toJSON(e), n.indirectTexture = this._indirectTexture.toJSON(e), null !== this._colorsTexture && (n.colorsTexture = this._colorsTexture.toJSON(e)), null !== this.boundingSphere && (n.boundingSphere = this.boundingSphere.toJSON()), null !== this.boundingBox && (n.boundingBox = this.boundingBox.toJSON())), this.isScene) this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (n.environment = this.environment.toJSON(e).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            n.geometry = a(e.geometries, this.geometry);
            const t = this.geometry.parameters;
            if (void 0 !== t && void 0 !== t.shapes) {
                const i = t.shapes;
                if (Array.isArray(i)) for(let t = 0, n = i.length; t < n; t++){
                    const n = i[t];
                    a(e.shapes, n);
                }
                else a(e.shapes, i);
            }
        }
        if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (a(e.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
            if (Array.isArray(this.material)) {
                const t = [];
                for(let i = 0, n = this.material.length; i < n; i++)t.push(a(e.materials, this.material[i]));
                n.material = t;
            } else n.material = a(e.materials, this.material);
        }
        if (this.children.length > 0) {
            n.children = [];
            for(let t = 0; t < this.children.length; t++)n.children.push(this.children[t].toJSON(e).object);
        }
        if (this.animations.length > 0) {
            n.animations = [];
            for(let t = 0; t < this.animations.length; t++){
                const i = this.animations[t];
                n.animations.push(a(e.animations, i));
            }
        }
        if (t) {
            const t = r(e.geometries), n = r(e.materials), a = r(e.textures), s = r(e.images), o = r(e.shapes), l = r(e.skeletons), c = r(e.animations), d = r(e.nodes);
            t.length > 0 && (i.geometries = t), n.length > 0 && (i.materials = n), a.length > 0 && (i.textures = a), s.length > 0 && (i.images = s), o.length > 0 && (i.shapes = o), l.length > 0 && (i.skeletons = l), c.length > 0 && (i.animations = c), d.length > 0 && (i.nodes = d);
        }
        return i.object = n, i;
        function r(e) {
            const t = [];
            for(const i in e){
                const n = e[i];
                delete n.metadata, t.push(n);
            }
            return t;
        }
    }
    clone(e) {
        return (new this.constructor).copy(this, e);
    }
    copy(e, t = !0) {
        if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.pivot = null !== e.pivot ? e.pivot.clone() : null, this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.static = e.static, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), !0 === t) for(let t = 0; t < e.children.length; t++){
            const i = e.children[t];
            this.add(i.clone());
        }
        return this;
    }
}
$a42f1354f0348298$var$lh.DEFAULT_UP = new $a42f1354f0348298$var$uu(0, 1, 0), $a42f1354f0348298$var$lh.DEFAULT_MATRIX_AUTO_UPDATE = !0, $a42f1354f0348298$var$lh.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
class $a42f1354f0348298$var$ch extends $a42f1354f0348298$var$lh {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}
const $a42f1354f0348298$var$dh = {
    type: "move"
};
class $a42f1354f0348298$var$uh {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return null === this._hand && (this._hand = new $a42f1354f0348298$var$ch, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return null === this._targetRay && (this._targetRay = new $a42f1354f0348298$var$ch, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new $a42f1354f0348298$var$uu, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new $a42f1354f0348298$var$uu), this._targetRay;
    }
    getGripSpace() {
        return null === this._grip && (this._grip = new $a42f1354f0348298$var$ch, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new $a42f1354f0348298$var$uu, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new $a42f1354f0348298$var$uu, this._grip.eventsEnabled = !1), this._grip;
    }
    dispatchEvent(e) {
        return null !== this._targetRay && this._targetRay.dispatchEvent(e), null !== this._grip && this._grip.dispatchEvent(e), null !== this._hand && this._hand.dispatchEvent(e), this;
    }
    connect(e) {
        if (e && e.hand) {
            const t = this._hand;
            if (t) for (const i of e.hand.values())this._getHandJoint(t, i);
        }
        return this.dispatchEvent({
            type: "connected",
            data: e
        }), this;
    }
    disconnect(e) {
        return this.dispatchEvent({
            type: "disconnected",
            data: e
        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
    update(e, t, i) {
        let n = null, a = null, r = null;
        const s = this._targetRay, o = this._grip, l = this._hand;
        if (e && "visible-blurred" !== t.session.visibilityState) {
            if (l && e.hand) {
                r = !0;
                for (const n of e.hand.values()){
                    const e = t.getJointPose(n, i), a = this._getHandJoint(l, n);
                    null !== e && (a.matrix.fromArray(e.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), a.matrixWorldNeedsUpdate = !0, a.jointRadius = e.radius), a.visible = null !== e;
                }
                const n = l.joints["index-finger-tip"], a = l.joints["thumb-tip"], s = n.position.distanceTo(a.position), o = .02, c = .005;
                l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: e.handedness,
                    target: this
                })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: e.handedness,
                    target: this
                }));
            } else null !== o && e.gripSpace && (a = t.getPose(e.gripSpace, i), null !== a && (o.matrix.fromArray(a.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, a.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(a.linearVelocity)) : o.hasLinearVelocity = !1, a.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(a.angularVelocity)) : o.hasAngularVelocity = !1, o.eventsEnabled && o.dispatchEvent({
                type: "gripUpdated",
                data: e,
                target: this
            })));
            null !== s && (n = t.getPose(e.targetRaySpace, i), null === n && null !== a && (n = a), null !== n && (s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, n.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(n.linearVelocity)) : s.hasLinearVelocity = !1, n.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(n.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent($a42f1354f0348298$var$dh)));
        }
        return null !== s && (s.visible = null !== n), null !== o && (o.visible = null !== a), null !== l && (l.visible = null !== r), this;
    }
    _getHandJoint(e, t) {
        if (void 0 === e.joints[t.jointName]) {
            const i = new $a42f1354f0348298$var$ch;
            i.matrixAutoUpdate = !1, i.visible = !1, e.joints[t.jointName] = i, e.add(i);
        }
        return e.joints[t.jointName];
    }
}
const $a42f1354f0348298$var$hh = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, $a42f1354f0348298$var$ph = {
    h: 0,
    s: 0,
    l: 0
}, $a42f1354f0348298$var$Ah = {
    h: 0,
    s: 0,
    l: 0
};
function $a42f1354f0348298$var$mh(e, t, i) {
    return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + 6 * (t - e) * i : i < .5 ? t : i < 2 / 3 ? e + 6 * (t - e) * (2 / 3 - i) : e;
}
class $a42f1354f0348298$var$gh {
    constructor(e, t, i){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, i);
    }
    set(e, t, i) {
        if (void 0 === t && void 0 === i) {
            const t = e;
            t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t);
        } else this.setRGB(e, t, i);
        return this;
    }
    setScalar(e) {
        return this.r = e, this.g = e, this.b = e, this;
    }
    setHex(e, t = $a42f1354f0348298$var$Md) {
        return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (255 & e) / 255, $a42f1354f0348298$var$vu.colorSpaceToWorking(this, t), this;
    }
    setRGB(e, t, i, n = $a42f1354f0348298$var$vu.workingColorSpace) {
        return this.r = e, this.g = t, this.b = i, $a42f1354f0348298$var$vu.colorSpaceToWorking(this, n), this;
    }
    setHSL(e, t, i, n = $a42f1354f0348298$var$vu.workingColorSpace) {
        if (e = $a42f1354f0348298$var$au(e, 1), t = $a42f1354f0348298$var$nu(t, 0, 1), i = $a42f1354f0348298$var$nu(i, 0, 1), 0 === t) this.r = this.g = this.b = i;
        else {
            const n = i <= .5 ? i * (1 + t) : i + t - i * t, a = 2 * i - n;
            this.r = $a42f1354f0348298$var$mh(a, n, e + 1 / 3), this.g = $a42f1354f0348298$var$mh(a, n, e), this.b = $a42f1354f0348298$var$mh(a, n, e - 1 / 3);
        }
        return $a42f1354f0348298$var$vu.colorSpaceToWorking(this, n), this;
    }
    setStyle(e, t = $a42f1354f0348298$var$Md) {
        function i(t) {
            void 0 !== t && parseFloat(t) < 1 && $a42f1354f0348298$var$Wd("Color: Alpha component of " + e + " will be ignored.");
        }
        let n;
        if (n = /^(\w+)\(([^\)]*)\)/.exec(e)) {
            let a;
            const r = n[1], s = n[2];
            switch(r){
                case "rgb":
                case "rgba":
                    if (a = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(a[4]), this.setRGB(Math.min(255, parseInt(a[1], 10)) / 255, Math.min(255, parseInt(a[2], 10)) / 255, Math.min(255, parseInt(a[3], 10)) / 255, t);
                    if (a = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(a[4]), this.setRGB(Math.min(100, parseInt(a[1], 10)) / 100, Math.min(100, parseInt(a[2], 10)) / 100, Math.min(100, parseInt(a[3], 10)) / 100, t);
                    break;
                case "hsl":
                case "hsla":
                    if (a = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(a[4]), this.setHSL(parseFloat(a[1]) / 360, parseFloat(a[2]) / 100, parseFloat(a[3]) / 100, t);
                    break;
                default:
                    $a42f1354f0348298$var$Wd("Color: Unknown color model " + e);
            }
        } else if (n = /^\#([A-Fa-f\d]+)$/.exec(e)) {
            const i = n[1], a = i.length;
            if (3 === a) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, t);
            if (6 === a) return this.setHex(parseInt(i, 16), t);
            $a42f1354f0348298$var$Wd("Color: Invalid hex color " + e);
        } else if (e && e.length > 0) return this.setColorName(e, t);
        return this;
    }
    setColorName(e, t = $a42f1354f0348298$var$Md) {
        const i = $a42f1354f0348298$var$hh[e.toLowerCase()];
        return void 0 !== i ? this.setHex(i, t) : $a42f1354f0348298$var$Wd("Color: Unknown color " + e), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(e) {
        return this.r = e.r, this.g = e.g, this.b = e.b, this;
    }
    copySRGBToLinear(e) {
        return this.r = $a42f1354f0348298$var$Eu(e.r), this.g = $a42f1354f0348298$var$Eu(e.g), this.b = $a42f1354f0348298$var$Eu(e.b), this;
    }
    copyLinearToSRGB(e) {
        return this.r = $a42f1354f0348298$var$yu(e.r), this.g = $a42f1354f0348298$var$yu(e.g), this.b = $a42f1354f0348298$var$yu(e.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(e = $a42f1354f0348298$var$Md) {
        return $a42f1354f0348298$var$vu.workingToColorSpace($a42f1354f0348298$var$fh.copy(this), e), 65536 * Math.round($a42f1354f0348298$var$nu(255 * $a42f1354f0348298$var$fh.r, 0, 255)) + 256 * Math.round($a42f1354f0348298$var$nu(255 * $a42f1354f0348298$var$fh.g, 0, 255)) + Math.round($a42f1354f0348298$var$nu(255 * $a42f1354f0348298$var$fh.b, 0, 255));
    }
    getHexString(e = $a42f1354f0348298$var$Md) {
        return ("000000" + this.getHex(e).toString(16)).slice(-6);
    }
    getHSL(e, t = $a42f1354f0348298$var$vu.workingColorSpace) {
        $a42f1354f0348298$var$vu.workingToColorSpace($a42f1354f0348298$var$fh.copy(this), t);
        const i = $a42f1354f0348298$var$fh.r, n = $a42f1354f0348298$var$fh.g, a = $a42f1354f0348298$var$fh.b, r = Math.max(i, n, a), s = Math.min(i, n, a);
        let o, l;
        const c = (s + r) / 2;
        if (s === r) o = 0, l = 0;
        else {
            const e = r - s;
            switch(l = c <= .5 ? e / (r + s) : e / (2 - r - s), r){
                case i:
                    o = (n - a) / e + (n < a ? 6 : 0);
                    break;
                case n:
                    o = (a - i) / e + 2;
                    break;
                case a:
                    o = (i - n) / e + 4;
            }
            o /= 6;
        }
        return e.h = o, e.s = l, e.l = c, e;
    }
    getRGB(e, t = $a42f1354f0348298$var$vu.workingColorSpace) {
        return $a42f1354f0348298$var$vu.workingToColorSpace($a42f1354f0348298$var$fh.copy(this), t), e.r = $a42f1354f0348298$var$fh.r, e.g = $a42f1354f0348298$var$fh.g, e.b = $a42f1354f0348298$var$fh.b, e;
    }
    getStyle(e = $a42f1354f0348298$var$Md) {
        $a42f1354f0348298$var$vu.workingToColorSpace($a42f1354f0348298$var$fh.copy(this), e);
        const t = $a42f1354f0348298$var$fh.r, i = $a42f1354f0348298$var$fh.g, n = $a42f1354f0348298$var$fh.b;
        return e !== $a42f1354f0348298$var$Md ? `color(${e} ${t.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})` : `rgb(${Math.round(255 * t)},${Math.round(255 * i)},${Math.round(255 * n)})`;
    }
    offsetHSL(e, t, i) {
        return this.getHSL($a42f1354f0348298$var$ph), this.setHSL($a42f1354f0348298$var$ph.h + e, $a42f1354f0348298$var$ph.s + t, $a42f1354f0348298$var$ph.l + i);
    }
    add(e) {
        return this.r += e.r, this.g += e.g, this.b += e.b, this;
    }
    addColors(e, t) {
        return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
    }
    addScalar(e) {
        return this.r += e, this.g += e, this.b += e, this;
    }
    sub(e) {
        return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
    }
    multiply(e) {
        return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
    }
    multiplyScalar(e) {
        return this.r *= e, this.g *= e, this.b *= e, this;
    }
    lerp(e, t) {
        return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
    }
    lerpColors(e, t, i) {
        return this.r = e.r + (t.r - e.r) * i, this.g = e.g + (t.g - e.g) * i, this.b = e.b + (t.b - e.b) * i, this;
    }
    lerpHSL(e, t) {
        this.getHSL($a42f1354f0348298$var$ph), e.getHSL($a42f1354f0348298$var$Ah);
        const i = $a42f1354f0348298$var$ru($a42f1354f0348298$var$ph.h, $a42f1354f0348298$var$Ah.h, t), n = $a42f1354f0348298$var$ru($a42f1354f0348298$var$ph.s, $a42f1354f0348298$var$Ah.s, t), a = $a42f1354f0348298$var$ru($a42f1354f0348298$var$ph.l, $a42f1354f0348298$var$Ah.l, t);
        return this.setHSL(i, n, a), this;
    }
    setFromVector3(e) {
        return this.r = e.x, this.g = e.y, this.b = e.z, this;
    }
    applyMatrix3(e) {
        const t = this.r, i = this.g, n = this.b, a = e.elements;
        return this.r = a[0] * t + a[3] * i + a[6] * n, this.g = a[1] * t + a[4] * i + a[7] * n, this.b = a[2] * t + a[5] * i + a[8] * n, this;
    }
    equals(e) {
        return e.r === this.r && e.g === this.g && e.b === this.b;
    }
    fromArray(e, t = 0) {
        return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
    }
    fromBufferAttribute(e, t) {
        return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
}
const $a42f1354f0348298$var$fh = new $a42f1354f0348298$var$gh;
$a42f1354f0348298$var$gh.NAMES = $a42f1354f0348298$var$hh;
class $a42f1354f0348298$var$_h extends $a42f1354f0348298$var$lh {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new $a42f1354f0348298$var$qu, this.environmentIntensity = 1, this.environmentRotation = new $a42f1354f0348298$var$qu, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(e, t) {
        return super.copy(e, t), null !== e.background && (this.background = e.background.clone()), null !== e.environment && (this.environment = e.environment.clone()), null !== e.fog && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), null !== e.overrideMaterial && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return null !== this.fog && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), 1 !== this.environmentIntensity && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
    }
}
const $a42f1354f0348298$var$vh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Eh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$yh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$bh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$kh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$xh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$wh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Mh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Sh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Ch = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Th = new $a42f1354f0348298$var$Du, $a42f1354f0348298$var$Dh = new $a42f1354f0348298$var$Du, $a42f1354f0348298$var$Ph = new $a42f1354f0348298$var$Du;
class $a42f1354f0348298$var$Ih {
    constructor(e = new $a42f1354f0348298$var$uu, t = new $a42f1354f0348298$var$uu, i = new $a42f1354f0348298$var$uu){
        this.a = e, this.b = t, this.c = i;
    }
    static getNormal(e, t, i, n) {
        n.subVectors(i, t), $a42f1354f0348298$var$vh.subVectors(e, t), n.cross($a42f1354f0348298$var$vh);
        const a = n.lengthSq();
        return a > 0 ? n.multiplyScalar(1 / Math.sqrt(a)) : n.set(0, 0, 0);
    }
    static getBarycoord(e, t, i, n, a) {
        $a42f1354f0348298$var$vh.subVectors(n, t), $a42f1354f0348298$var$Eh.subVectors(i, t), $a42f1354f0348298$var$yh.subVectors(e, t);
        const r = $a42f1354f0348298$var$vh.dot($a42f1354f0348298$var$vh), s = $a42f1354f0348298$var$vh.dot($a42f1354f0348298$var$Eh), o = $a42f1354f0348298$var$vh.dot($a42f1354f0348298$var$yh), l = $a42f1354f0348298$var$Eh.dot($a42f1354f0348298$var$Eh), c = $a42f1354f0348298$var$Eh.dot($a42f1354f0348298$var$yh), d = r * l - s * s;
        if (0 === d) return a.set(0, 0, 0), null;
        const u = 1 / d, h = (l * o - s * c) * u, p = (r * c - s * o) * u;
        return a.set(1 - h - p, p, h);
    }
    static containsPoint(e, t, i, n) {
        return null !== this.getBarycoord(e, t, i, n, $a42f1354f0348298$var$bh) && $a42f1354f0348298$var$bh.x >= 0 && $a42f1354f0348298$var$bh.y >= 0 && $a42f1354f0348298$var$bh.x + $a42f1354f0348298$var$bh.y <= 1;
    }
    static getInterpolation(e, t, i, n, a, r, s, o) {
        return null === this.getBarycoord(e, t, i, n, $a42f1354f0348298$var$bh) ? (o.x = 0, o.y = 0, "z" in o && (o.z = 0), "w" in o && (o.w = 0), null) : (o.setScalar(0), o.addScaledVector(a, $a42f1354f0348298$var$bh.x), o.addScaledVector(r, $a42f1354f0348298$var$bh.y), o.addScaledVector(s, $a42f1354f0348298$var$bh.z), o);
    }
    static getInterpolatedAttribute(e, t, i, n, a, r) {
        return $a42f1354f0348298$var$Th.setScalar(0), $a42f1354f0348298$var$Dh.setScalar(0), $a42f1354f0348298$var$Ph.setScalar(0), $a42f1354f0348298$var$Th.fromBufferAttribute(e, t), $a42f1354f0348298$var$Dh.fromBufferAttribute(e, i), $a42f1354f0348298$var$Ph.fromBufferAttribute(e, n), r.setScalar(0), r.addScaledVector($a42f1354f0348298$var$Th, a.x), r.addScaledVector($a42f1354f0348298$var$Dh, a.y), r.addScaledVector($a42f1354f0348298$var$Ph, a.z), r;
    }
    static isFrontFacing(e, t, i, n) {
        return $a42f1354f0348298$var$vh.subVectors(i, t), $a42f1354f0348298$var$Eh.subVectors(e, t), $a42f1354f0348298$var$vh.cross($a42f1354f0348298$var$Eh).dot(n) < 0;
    }
    set(e, t, i) {
        return this.a.copy(e), this.b.copy(t), this.c.copy(i), this;
    }
    setFromPointsAndIndices(e, t, i, n) {
        return this.a.copy(e[t]), this.b.copy(e[i]), this.c.copy(e[n]), this;
    }
    setFromAttributeAndIndices(e, t, i, n) {
        return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, i), this.c.fromBufferAttribute(e, n), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e) {
        return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
    }
    getArea() {
        return $a42f1354f0348298$var$vh.subVectors(this.c, this.b), $a42f1354f0348298$var$Eh.subVectors(this.a, this.b), .5 * $a42f1354f0348298$var$vh.cross($a42f1354f0348298$var$Eh).length();
    }
    getMidpoint(e) {
        return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(e) {
        return $a42f1354f0348298$var$Ih.getNormal(this.a, this.b, this.c, e);
    }
    getPlane(e) {
        return e.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(e, t) {
        return $a42f1354f0348298$var$Ih.getBarycoord(e, this.a, this.b, this.c, t);
    }
    getInterpolation(e, t, i, n, a) {
        return $a42f1354f0348298$var$Ih.getInterpolation(e, this.a, this.b, this.c, t, i, n, a);
    }
    containsPoint(e) {
        return $a42f1354f0348298$var$Ih.containsPoint(e, this.a, this.b, this.c);
    }
    isFrontFacing(e) {
        return $a42f1354f0348298$var$Ih.isFrontFacing(this.a, this.b, this.c, e);
    }
    intersectsBox(e) {
        return e.intersectsTriangle(this);
    }
    closestPointToPoint(e, t) {
        const i = this.a, n = this.b, a = this.c;
        let r, s;
        $a42f1354f0348298$var$kh.subVectors(n, i), $a42f1354f0348298$var$xh.subVectors(a, i), $a42f1354f0348298$var$Mh.subVectors(e, i);
        const o = $a42f1354f0348298$var$kh.dot($a42f1354f0348298$var$Mh), l = $a42f1354f0348298$var$xh.dot($a42f1354f0348298$var$Mh);
        if (o <= 0 && l <= 0) return t.copy(i);
        $a42f1354f0348298$var$Sh.subVectors(e, n);
        const c = $a42f1354f0348298$var$kh.dot($a42f1354f0348298$var$Sh), d = $a42f1354f0348298$var$xh.dot($a42f1354f0348298$var$Sh);
        if (c >= 0 && d <= c) return t.copy(n);
        const u = o * d - c * l;
        if (u <= 0 && o >= 0 && c <= 0) return r = o / (o - c), t.copy(i).addScaledVector($a42f1354f0348298$var$kh, r);
        $a42f1354f0348298$var$Ch.subVectors(e, a);
        const h = $a42f1354f0348298$var$kh.dot($a42f1354f0348298$var$Ch), p = $a42f1354f0348298$var$xh.dot($a42f1354f0348298$var$Ch);
        if (p >= 0 && h <= p) return t.copy(a);
        const A = h * l - o * p;
        if (A <= 0 && l >= 0 && p <= 0) return s = l / (l - p), t.copy(i).addScaledVector($a42f1354f0348298$var$xh, s);
        const m = c * p - h * d;
        if (m <= 0 && d - c >= 0 && h - p >= 0) return $a42f1354f0348298$var$wh.subVectors(a, n), s = (d - c) / (d - c + (h - p)), t.copy(n).addScaledVector($a42f1354f0348298$var$wh, s);
        const g = 1 / (m + A + u);
        return r = A * g, s = u * g, t.copy(i).addScaledVector($a42f1354f0348298$var$kh, r).addScaledVector($a42f1354f0348298$var$xh, s);
    }
    equals(e) {
        return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
    }
}
class $a42f1354f0348298$var$Lh {
    constructor(e = new $a42f1354f0348298$var$uu(1 / 0, 1 / 0, 1 / 0), t = new $a42f1354f0348298$var$uu(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = e, this.max = t;
    }
    set(e, t) {
        return this.min.copy(e), this.max.copy(t), this;
    }
    setFromArray(e) {
        this.makeEmpty();
        for(let t = 0, i = e.length; t < i; t += 3)this.expandByPoint($a42f1354f0348298$var$zh.fromArray(e, t));
        return this;
    }
    setFromBufferAttribute(e) {
        this.makeEmpty();
        for(let t = 0, i = e.count; t < i; t++)this.expandByPoint($a42f1354f0348298$var$zh.fromBufferAttribute(e, t));
        return this;
    }
    setFromPoints(e) {
        this.makeEmpty();
        for(let t = 0, i = e.length; t < i; t++)this.expandByPoint(e[t]);
        return this;
    }
    setFromCenterAndSize(e, t) {
        const i = $a42f1354f0348298$var$zh.copy(t).multiplyScalar(.5);
        return this.min.copy(e).sub(i), this.max.copy(e).add(i), this;
    }
    setFromObject(e, t = !1) {
        return this.makeEmpty(), this.expandByObject(e, t);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e) {
        return this.min.copy(e.min), this.max.copy(e.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(e) {
        return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(e) {
        return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
    }
    expandByPoint(e) {
        return this.min.min(e), this.max.max(e), this;
    }
    expandByVector(e) {
        return this.min.sub(e), this.max.add(e), this;
    }
    expandByScalar(e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this;
    }
    expandByObject(e, t = !1) {
        e.updateWorldMatrix(!1, !1);
        const i = e.geometry;
        if (void 0 !== i) {
            const n = i.getAttribute("position");
            if (!0 === t && void 0 !== n && !0 !== e.isInstancedMesh) for(let t = 0, i = n.count; t < i; t++)!0 === e.isMesh ? e.getVertexPosition(t, $a42f1354f0348298$var$zh) : $a42f1354f0348298$var$zh.fromBufferAttribute(n, t), $a42f1354f0348298$var$zh.applyMatrix4(e.matrixWorld), this.expandByPoint($a42f1354f0348298$var$zh);
            else void 0 !== e.boundingBox ? (null === e.boundingBox && e.computeBoundingBox(), $a42f1354f0348298$var$Fh.copy(e.boundingBox)) : (null === i.boundingBox && i.computeBoundingBox(), $a42f1354f0348298$var$Fh.copy(i.boundingBox)), $a42f1354f0348298$var$Fh.applyMatrix4(e.matrixWorld), this.union($a42f1354f0348298$var$Fh);
        }
        const n = e.children;
        for(let e = 0, i = n.length; e < i; e++)this.expandByObject(n[e], t);
        return this;
    }
    containsPoint(e) {
        return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
    }
    containsBox(e) {
        return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
    }
    getParameter(e, t) {
        return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(e) {
        return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
    }
    intersectsSphere(e) {
        return this.clampPoint(e.center, $a42f1354f0348298$var$zh), $a42f1354f0348298$var$zh.distanceToSquared(e.center) <= e.radius * e.radius;
    }
    intersectsPlane(e) {
        let t, i;
        return e.normal.x > 0 ? (t = e.normal.x * this.min.x, i = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, i = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, i += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, i += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, i += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, i += e.normal.z * this.min.z), t <= -e.constant && i >= -e.constant;
    }
    intersectsTriangle(e) {
        if (this.isEmpty()) return !1;
        this.getCenter($a42f1354f0348298$var$Vh), $a42f1354f0348298$var$Hh.subVectors(this.max, $a42f1354f0348298$var$Vh), $a42f1354f0348298$var$Uh.subVectors(e.a, $a42f1354f0348298$var$Vh), $a42f1354f0348298$var$Nh.subVectors(e.b, $a42f1354f0348298$var$Vh), $a42f1354f0348298$var$Bh.subVectors(e.c, $a42f1354f0348298$var$Vh), $a42f1354f0348298$var$Oh.subVectors($a42f1354f0348298$var$Nh, $a42f1354f0348298$var$Uh), $a42f1354f0348298$var$jh.subVectors($a42f1354f0348298$var$Bh, $a42f1354f0348298$var$Nh), $a42f1354f0348298$var$Gh.subVectors($a42f1354f0348298$var$Uh, $a42f1354f0348298$var$Bh);
        let t = [
            0,
            -$a42f1354f0348298$var$Oh.z,
            $a42f1354f0348298$var$Oh.y,
            0,
            -$a42f1354f0348298$var$jh.z,
            $a42f1354f0348298$var$jh.y,
            0,
            -$a42f1354f0348298$var$Gh.z,
            $a42f1354f0348298$var$Gh.y,
            $a42f1354f0348298$var$Oh.z,
            0,
            -$a42f1354f0348298$var$Oh.x,
            $a42f1354f0348298$var$jh.z,
            0,
            -$a42f1354f0348298$var$jh.x,
            $a42f1354f0348298$var$Gh.z,
            0,
            -$a42f1354f0348298$var$Gh.x,
            -$a42f1354f0348298$var$Oh.y,
            $a42f1354f0348298$var$Oh.x,
            0,
            -$a42f1354f0348298$var$jh.y,
            $a42f1354f0348298$var$jh.x,
            0,
            -$a42f1354f0348298$var$Gh.y,
            $a42f1354f0348298$var$Gh.x,
            0
        ];
        return !!$a42f1354f0348298$var$Wh(t, $a42f1354f0348298$var$Uh, $a42f1354f0348298$var$Nh, $a42f1354f0348298$var$Bh, $a42f1354f0348298$var$Hh) && (t = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !!$a42f1354f0348298$var$Wh(t, $a42f1354f0348298$var$Uh, $a42f1354f0348298$var$Nh, $a42f1354f0348298$var$Bh, $a42f1354f0348298$var$Hh) && ($a42f1354f0348298$var$qh.crossVectors($a42f1354f0348298$var$Oh, $a42f1354f0348298$var$jh), t = [
            $a42f1354f0348298$var$qh.x,
            $a42f1354f0348298$var$qh.y,
            $a42f1354f0348298$var$qh.z
        ], $a42f1354f0348298$var$Wh(t, $a42f1354f0348298$var$Uh, $a42f1354f0348298$var$Nh, $a42f1354f0348298$var$Bh, $a42f1354f0348298$var$Hh)));
    }
    clampPoint(e, t) {
        return t.copy(e).clamp(this.min, this.max);
    }
    distanceToPoint(e) {
        return this.clampPoint(e, $a42f1354f0348298$var$zh).distanceTo(e);
    }
    getBoundingSphere(e) {
        return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = .5 * this.getSize($a42f1354f0348298$var$zh).length()), e;
    }
    intersect(e) {
        return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(e) {
        return this.min.min(e.min), this.max.max(e.max), this;
    }
    applyMatrix4(e) {
        return this.isEmpty() || ($a42f1354f0348298$var$Rh[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), $a42f1354f0348298$var$Rh[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints($a42f1354f0348298$var$Rh)), this;
    }
    translate(e) {
        return this.min.add(e), this.max.add(e), this;
    }
    equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
    }
    toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    fromJSON(e) {
        return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
    }
}
const $a42f1354f0348298$var$Rh = [
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu,
    new $a42f1354f0348298$var$uu
], $a42f1354f0348298$var$zh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Fh = new $a42f1354f0348298$var$Lh, $a42f1354f0348298$var$Uh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Nh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Bh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Oh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$jh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Gh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Vh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Hh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$qh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Kh = new $a42f1354f0348298$var$uu;
function $a42f1354f0348298$var$Wh(e, t, i, n, a) {
    for(let r = 0, s = e.length - 3; r <= s; r += 3){
        $a42f1354f0348298$var$Kh.fromArray(e, r);
        const s = a.x * Math.abs($a42f1354f0348298$var$Kh.x) + a.y * Math.abs($a42f1354f0348298$var$Kh.y) + a.z * Math.abs($a42f1354f0348298$var$Kh.z), o = t.dot($a42f1354f0348298$var$Kh), l = i.dot($a42f1354f0348298$var$Kh), c = n.dot($a42f1354f0348298$var$Kh);
        if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
    }
    return !0;
}
const $a42f1354f0348298$var$Xh = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Qh = new $a42f1354f0348298$var$cu;
let $a42f1354f0348298$var$Zh = 0;
class $a42f1354f0348298$var$Yh extends $a42f1354f0348298$var$Yd {
    constructor(e, t, i = !1){
        if (super(), Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
            value: $a42f1354f0348298$var$Zh++
        }), this.name = "", this.array = e, this.itemSize = t, this.count = void 0 !== e ? e.length / t : 0, this.normalized = i, this.usage = 35044, this.updateRanges = [], this.gpuType = $a42f1354f0348298$var$Tc, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(e) {
        !0 === e && this.version++;
    }
    setUsage(e) {
        return this.usage = e, this;
    }
    addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(e) {
        return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
    }
    copyAt(e, t, i) {
        e *= this.itemSize, i *= t.itemSize;
        for(let n = 0, a = this.itemSize; n < a; n++)this.array[e + n] = t.array[i + n];
        return this;
    }
    copyArray(e) {
        return this.array.set(e), this;
    }
    applyMatrix3(e) {
        if (2 === this.itemSize) for(let t = 0, i = this.count; t < i; t++)$a42f1354f0348298$var$Qh.fromBufferAttribute(this, t), $a42f1354f0348298$var$Qh.applyMatrix3(e), this.setXY(t, $a42f1354f0348298$var$Qh.x, $a42f1354f0348298$var$Qh.y);
        else if (3 === this.itemSize) for(let t = 0, i = this.count; t < i; t++)$a42f1354f0348298$var$Xh.fromBufferAttribute(this, t), $a42f1354f0348298$var$Xh.applyMatrix3(e), this.setXYZ(t, $a42f1354f0348298$var$Xh.x, $a42f1354f0348298$var$Xh.y, $a42f1354f0348298$var$Xh.z);
        return this;
    }
    applyMatrix4(e) {
        for(let t = 0, i = this.count; t < i; t++)$a42f1354f0348298$var$Xh.fromBufferAttribute(this, t), $a42f1354f0348298$var$Xh.applyMatrix4(e), this.setXYZ(t, $a42f1354f0348298$var$Xh.x, $a42f1354f0348298$var$Xh.y, $a42f1354f0348298$var$Xh.z);
        return this;
    }
    applyNormalMatrix(e) {
        for(let t = 0, i = this.count; t < i; t++)$a42f1354f0348298$var$Xh.fromBufferAttribute(this, t), $a42f1354f0348298$var$Xh.applyNormalMatrix(e), this.setXYZ(t, $a42f1354f0348298$var$Xh.x, $a42f1354f0348298$var$Xh.y, $a42f1354f0348298$var$Xh.z);
        return this;
    }
    transformDirection(e) {
        for(let t = 0, i = this.count; t < i; t++)$a42f1354f0348298$var$Xh.fromBufferAttribute(this, t), $a42f1354f0348298$var$Xh.transformDirection(e), this.setXYZ(t, $a42f1354f0348298$var$Xh.x, $a42f1354f0348298$var$Xh.y, $a42f1354f0348298$var$Xh.z);
        return this;
    }
    set(e, t = 0) {
        return this.array.set(e, t), this;
    }
    getComponent(e, t) {
        let i = this.array[e * this.itemSize + t];
        return this.normalized && (i = $a42f1354f0348298$var$su(i, this.array)), i;
    }
    setComponent(e, t, i) {
        return this.normalized && (i = $a42f1354f0348298$var$ou(i, this.array)), this.array[e * this.itemSize + t] = i, this;
    }
    getX(e) {
        let t = this.array[e * this.itemSize];
        return this.normalized && (t = $a42f1354f0348298$var$su(t, this.array)), t;
    }
    setX(e, t) {
        return this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array)), this.array[e * this.itemSize] = t, this;
    }
    getY(e) {
        let t = this.array[e * this.itemSize + 1];
        return this.normalized && (t = $a42f1354f0348298$var$su(t, this.array)), t;
    }
    setY(e, t) {
        return this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
    }
    getZ(e) {
        let t = this.array[e * this.itemSize + 2];
        return this.normalized && (t = $a42f1354f0348298$var$su(t, this.array)), t;
    }
    setZ(e, t) {
        return this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
    }
    getW(e) {
        let t = this.array[e * this.itemSize + 3];
        return this.normalized && (t = $a42f1354f0348298$var$su(t, this.array)), t;
    }
    setW(e, t) {
        return this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
    }
    setXY(e, t, i) {
        return e *= this.itemSize, this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array), i = $a42f1354f0348298$var$ou(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this;
    }
    setXYZ(e, t, i, n) {
        return e *= this.itemSize, this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array), i = $a42f1354f0348298$var$ou(i, this.array), n = $a42f1354f0348298$var$ou(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this.array[e + 2] = n, this;
    }
    setXYZW(e, t, i, n, a) {
        return e *= this.itemSize, this.normalized && (t = $a42f1354f0348298$var$ou(t, this.array), i = $a42f1354f0348298$var$ou(i, this.array), n = $a42f1354f0348298$var$ou(n, this.array), a = $a42f1354f0348298$var$ou(a, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this.array[e + 2] = n, this.array[e + 3] = a, this;
    }
    onUpload(e) {
        return this.onUploadCallback = e, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const e = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return "" !== this.name && (e.name = this.name), 35044 !== this.usage && (e.usage = this.usage), e;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $a42f1354f0348298$var$Jh extends $a42f1354f0348298$var$Yh {
    constructor(e, t, i){
        super(new Uint16Array(e), t, i);
    }
}
class $a42f1354f0348298$var$$h extends $a42f1354f0348298$var$Yh {
    constructor(e, t, i){
        super(new Uint32Array(e), t, i);
    }
}
class $a42f1354f0348298$var$ep extends $a42f1354f0348298$var$Yh {
    constructor(e, t, i){
        super(new Float32Array(e), t, i);
    }
}
const $a42f1354f0348298$var$tp = new $a42f1354f0348298$var$Lh, $a42f1354f0348298$var$ip = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$np = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$ap {
    constructor(e = new $a42f1354f0348298$var$uu, t = -1){
        this.isSphere = !0, this.center = e, this.radius = t;
    }
    set(e, t) {
        return this.center.copy(e), this.radius = t, this;
    }
    setFromPoints(e, t) {
        const i = this.center;
        void 0 !== t ? i.copy(t) : $a42f1354f0348298$var$tp.setFromPoints(e).getCenter(i);
        let n = 0;
        for(let t = 0, a = e.length; t < a; t++)n = Math.max(n, i.distanceToSquared(e[t]));
        return this.radius = Math.sqrt(n), this;
    }
    copy(e) {
        return this.center.copy(e.center), this.radius = e.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(e) {
        return e.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(e) {
        return e.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(e) {
        const t = this.radius + e.radius;
        return e.center.distanceToSquared(this.center) <= t * t;
    }
    intersectsBox(e) {
        return e.intersectsSphere(this);
    }
    intersectsPlane(e) {
        return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(e, t) {
        const i = this.center.distanceToSquared(e);
        return t.copy(e), i > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
    }
    getBoundingBox(e) {
        return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
    }
    applyMatrix4(e) {
        return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
    }
    translate(e) {
        return this.center.add(e), this;
    }
    expandByPoint(e) {
        if (this.isEmpty()) return this.center.copy(e), this.radius = 0, this;
        $a42f1354f0348298$var$ip.subVectors(e, this.center);
        const t = $a42f1354f0348298$var$ip.lengthSq();
        if (t > this.radius * this.radius) {
            const e = Math.sqrt(t), i = .5 * (e - this.radius);
            this.center.addScaledVector($a42f1354f0348298$var$ip, i / e), this.radius += i;
        }
        return this;
    }
    union(e) {
        return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (!0 === this.center.equals(e.center) ? this.radius = Math.max(this.radius, e.radius) : ($a42f1354f0348298$var$np.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint($a42f1354f0348298$var$ip.copy(e.center).add($a42f1354f0348298$var$np)), this.expandByPoint($a42f1354f0348298$var$ip.copy(e.center).sub($a42f1354f0348298$var$np))), this);
    }
    equals(e) {
        return e.center.equals(this.center) && e.radius === this.radius;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    fromJSON(e) {
        return this.radius = e.radius, this.center.fromArray(e.center), this;
    }
}
let $a42f1354f0348298$var$rp = 0;
const $a42f1354f0348298$var$sp = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$op = new $a42f1354f0348298$var$lh, $a42f1354f0348298$var$lp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$cp = new $a42f1354f0348298$var$Lh, $a42f1354f0348298$var$dp = new $a42f1354f0348298$var$Lh, $a42f1354f0348298$var$up = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$hp extends $a42f1354f0348298$var$Yd {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: $a42f1354f0348298$var$rp++
        }), this.uuid = $a42f1354f0348298$var$iu(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {}, this._transformed = !1;
    }
    getIndex() {
        return this.index;
    }
    setIndex(e) {
        return Array.isArray(e) ? this.index = new ((function(e) {
            for(let t = e.length - 1; t >= 0; --t)if (e[t] >= 65535) return !0;
            return !1;
        }(e)) ? $a42f1354f0348298$var$$h : $a42f1354f0348298$var$Jh)(e, 1) : this.index = e, this;
    }
    setIndirect(e, t = 0) {
        return this.indirect = e, this.indirectOffset = t, this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(e) {
        return this.attributes[e];
    }
    setAttribute(e, t) {
        return this.attributes[e] = t, this;
    }
    deleteAttribute(e) {
        return delete this.attributes[e], this;
    }
    hasAttribute(e) {
        return void 0 !== this.attributes[e];
    }
    addGroup(e, t, i = 0) {
        this.groups.push({
            start: e,
            count: t,
            materialIndex: i
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(e, t) {
        this.drawRange.start = e, this.drawRange.count = t;
    }
    applyMatrix4(e) {
        const t = this.attributes.position;
        void 0 !== t && (t.applyMatrix4(e), t.needsUpdate = !0);
        const i = this.attributes.normal;
        if (void 0 !== i) {
            const t = (new $a42f1354f0348298$var$Au).getNormalMatrix(e);
            i.applyNormalMatrix(t), i.needsUpdate = !0;
        }
        const n = this.attributes.tangent;
        return void 0 !== n && (n.transformDirection(e), n.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this._transformed = !0, this;
    }
    applyQuaternion(e) {
        return $a42f1354f0348298$var$sp.makeRotationFromQuaternion(e), this.applyMatrix4($a42f1354f0348298$var$sp), this;
    }
    rotateX(e) {
        return $a42f1354f0348298$var$sp.makeRotationX(e), this.applyMatrix4($a42f1354f0348298$var$sp), this;
    }
    rotateY(e) {
        return $a42f1354f0348298$var$sp.makeRotationY(e), this.applyMatrix4($a42f1354f0348298$var$sp), this;
    }
    rotateZ(e) {
        return $a42f1354f0348298$var$sp.makeRotationZ(e), this.applyMatrix4($a42f1354f0348298$var$sp), this;
    }
    translate(e, t, i) {
        return $a42f1354f0348298$var$sp.makeTranslation(e, t, i), this.applyMatrix4($a42f1354f0348298$var$sp), this;
    }
    scale(e, t, i) {
        return $a42f1354f0348298$var$sp.makeScale(e, t, i), this.applyMatrix4($a42f1354f0348298$var$sp), this;
    }
    lookAt(e) {
        return $a42f1354f0348298$var$op.lookAt(e), $a42f1354f0348298$var$op.updateMatrix(), this.applyMatrix4($a42f1354f0348298$var$op.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter($a42f1354f0348298$var$lp).negate(), this.translate($a42f1354f0348298$var$lp.x, $a42f1354f0348298$var$lp.y, $a42f1354f0348298$var$lp.z), this;
    }
    setFromPoints(e) {
        const t = this.getAttribute("position");
        if (void 0 === t) {
            const t = [];
            for(let i = 0, n = e.length; i < n; i++){
                const n = e[i];
                t.push(n.x, n.y, n.z || 0);
            }
            this.setAttribute("position", new $a42f1354f0348298$var$ep(t, 3));
        } else {
            const i = Math.min(e.length, t.count);
            for(let n = 0; n < i; n++){
                const i = e[n];
                t.setXYZ(n, i.x, i.y, i.z || 0);
            }
            e.length > t.count && $a42f1354f0348298$var$Wd("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
        }
        return this;
    }
    computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new $a42f1354f0348298$var$Lh);
        const e = this.attributes.position, t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) return $a42f1354f0348298$var$Xd("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), void this.boundingBox.set(new $a42f1354f0348298$var$uu(-1 / 0, -1 / 0, -1 / 0), new $a42f1354f0348298$var$uu(1 / 0, 1 / 0, 1 / 0));
        if (void 0 !== e) {
            if (this.boundingBox.setFromBufferAttribute(e), t) for(let e = 0, i = t.length; e < i; e++){
                const i = t[e];
                $a42f1354f0348298$var$cp.setFromBufferAttribute(i), this.morphTargetsRelative ? ($a42f1354f0348298$var$up.addVectors(this.boundingBox.min, $a42f1354f0348298$var$cp.min), this.boundingBox.expandByPoint($a42f1354f0348298$var$up), $a42f1354f0348298$var$up.addVectors(this.boundingBox.max, $a42f1354f0348298$var$cp.max), this.boundingBox.expandByPoint($a42f1354f0348298$var$up)) : (this.boundingBox.expandByPoint($a42f1354f0348298$var$cp.min), this.boundingBox.expandByPoint($a42f1354f0348298$var$cp.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && $a42f1354f0348298$var$Xd('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new $a42f1354f0348298$var$ap);
        const e = this.attributes.position, t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) return $a42f1354f0348298$var$Xd("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), void this.boundingSphere.set(new $a42f1354f0348298$var$uu, 1 / 0);
        if (e) {
            const i = this.boundingSphere.center;
            if ($a42f1354f0348298$var$cp.setFromBufferAttribute(e), t) for(let e = 0, i = t.length; e < i; e++){
                const i = t[e];
                $a42f1354f0348298$var$dp.setFromBufferAttribute(i), this.morphTargetsRelative ? ($a42f1354f0348298$var$up.addVectors($a42f1354f0348298$var$cp.min, $a42f1354f0348298$var$dp.min), $a42f1354f0348298$var$cp.expandByPoint($a42f1354f0348298$var$up), $a42f1354f0348298$var$up.addVectors($a42f1354f0348298$var$cp.max, $a42f1354f0348298$var$dp.max), $a42f1354f0348298$var$cp.expandByPoint($a42f1354f0348298$var$up)) : ($a42f1354f0348298$var$cp.expandByPoint($a42f1354f0348298$var$dp.min), $a42f1354f0348298$var$cp.expandByPoint($a42f1354f0348298$var$dp.max));
            }
            $a42f1354f0348298$var$cp.getCenter(i);
            let n = 0;
            for(let t = 0, a = e.count; t < a; t++)$a42f1354f0348298$var$up.fromBufferAttribute(e, t), n = Math.max(n, i.distanceToSquared($a42f1354f0348298$var$up));
            if (t) for(let a = 0, r = t.length; a < r; a++){
                const r = t[a], s = this.morphTargetsRelative;
                for(let t = 0, a = r.count; t < a; t++)$a42f1354f0348298$var$up.fromBufferAttribute(r, t), s && ($a42f1354f0348298$var$lp.fromBufferAttribute(e, t), $a42f1354f0348298$var$up.add($a42f1354f0348298$var$lp)), n = Math.max(n, i.distanceToSquared($a42f1354f0348298$var$up));
            }
            this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && $a42f1354f0348298$var$Xd('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const e = this.index, t = this.attributes;
        if (null === e || void 0 === t.position || void 0 === t.normal || void 0 === t.uv) return void $a42f1354f0348298$var$Xd("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        const i = t.position, n = t.normal, a = t.uv;
        let r = this.getAttribute("tangent");
        void 0 !== r && r.count === i.count || (r = new $a42f1354f0348298$var$Yh(new Float32Array(4 * i.count), 4), this.setAttribute("tangent", r));
        const s = [], o = [];
        for(let e = 0; e < i.count; e++)s[e] = new $a42f1354f0348298$var$uu, o[e] = new $a42f1354f0348298$var$uu;
        const l = new $a42f1354f0348298$var$uu, c = new $a42f1354f0348298$var$uu, d = new $a42f1354f0348298$var$uu, u = new $a42f1354f0348298$var$cu, h = new $a42f1354f0348298$var$cu, p = new $a42f1354f0348298$var$cu, A = new $a42f1354f0348298$var$uu, m = new $a42f1354f0348298$var$uu;
        function g(e, t, n) {
            l.fromBufferAttribute(i, e), c.fromBufferAttribute(i, t), d.fromBufferAttribute(i, n), u.fromBufferAttribute(a, e), h.fromBufferAttribute(a, t), p.fromBufferAttribute(a, n), c.sub(l), d.sub(l), h.sub(u), p.sub(u);
            const r = 1 / (h.x * p.y - p.x * h.y);
            isFinite(r) && (A.copy(c).multiplyScalar(p.y).addScaledVector(d, -h.y).multiplyScalar(r), m.copy(d).multiplyScalar(h.x).addScaledVector(c, -p.x).multiplyScalar(r), s[e].add(A), s[t].add(A), s[n].add(A), o[e].add(m), o[t].add(m), o[n].add(m));
        }
        let f = this.groups;
        0 === f.length && (f = [
            {
                start: 0,
                count: e.count
            }
        ]);
        for(let t = 0, i = f.length; t < i; ++t){
            const i = f[t], n = i.start;
            for(let t = n, a = n + i.count; t < a; t += 3)g(e.getX(t + 0), e.getX(t + 1), e.getX(t + 2));
        }
        const _ = new $a42f1354f0348298$var$uu, v = new $a42f1354f0348298$var$uu, E = new $a42f1354f0348298$var$uu, y = new $a42f1354f0348298$var$uu;
        function b(e) {
            E.fromBufferAttribute(n, e), y.copy(E);
            const t = s[e];
            _.copy(t), _.sub(E.multiplyScalar(E.dot(t))).normalize(), v.crossVectors(y, t);
            const i = v.dot(o[e]) < 0 ? -1 : 1;
            r.setXYZW(e, _.x, _.y, _.z, i);
        }
        for(let t = 0, i = f.length; t < i; ++t){
            const i = f[t], n = i.start;
            for(let t = n, a = n + i.count; t < a; t += 3)b(e.getX(t + 0)), b(e.getX(t + 1)), b(e.getX(t + 2));
        }
        this._transformed = !0;
    }
    computeVertexNormals() {
        const e = this.index, t = this.getAttribute("position");
        if (void 0 !== t) {
            let i = this.getAttribute("normal");
            if (void 0 === i || i.count !== t.count) i = new $a42f1354f0348298$var$Yh(new Float32Array(3 * t.count), 3), this.setAttribute("normal", i);
            else for(let e = 0, t = i.count; e < t; e++)i.setXYZ(e, 0, 0, 0);
            const n = new $a42f1354f0348298$var$uu, a = new $a42f1354f0348298$var$uu, r = new $a42f1354f0348298$var$uu, s = new $a42f1354f0348298$var$uu, o = new $a42f1354f0348298$var$uu, l = new $a42f1354f0348298$var$uu, c = new $a42f1354f0348298$var$uu, d = new $a42f1354f0348298$var$uu;
            if (e) for(let u = 0, h = e.count; u < h; u += 3){
                const h = e.getX(u + 0), p = e.getX(u + 1), A = e.getX(u + 2);
                n.fromBufferAttribute(t, h), a.fromBufferAttribute(t, p), r.fromBufferAttribute(t, A), c.subVectors(r, a), d.subVectors(n, a), c.cross(d), s.fromBufferAttribute(i, h), o.fromBufferAttribute(i, p), l.fromBufferAttribute(i, A), s.add(c), o.add(c), l.add(c), i.setXYZ(h, s.x, s.y, s.z), i.setXYZ(p, o.x, o.y, o.z), i.setXYZ(A, l.x, l.y, l.z);
            }
            else for(let e = 0, s = t.count; e < s; e += 3)n.fromBufferAttribute(t, e + 0), a.fromBufferAttribute(t, e + 1), r.fromBufferAttribute(t, e + 2), c.subVectors(r, a), d.subVectors(n, a), c.cross(d), i.setXYZ(e + 0, c.x, c.y, c.z), i.setXYZ(e + 1, c.x, c.y, c.z), i.setXYZ(e + 2, c.x, c.y, c.z);
            this.normalizeNormals(), i.needsUpdate = !0;
        }
    }
    normalizeNormals() {
        const e = this.attributes.normal;
        for(let t = 0, i = e.count; t < i; t++)$a42f1354f0348298$var$up.fromBufferAttribute(e, t), $a42f1354f0348298$var$up.normalize(), e.setXYZ(t, $a42f1354f0348298$var$up.x, $a42f1354f0348298$var$up.y, $a42f1354f0348298$var$up.z);
    }
    toNonIndexed() {
        function e(e, t) {
            const i = e.array, n = e.itemSize, a = e.normalized, r = new i.constructor(t.length * n);
            let s = 0, o = 0;
            for(let a = 0, l = t.length; a < l; a++){
                s = e.isInterleavedBufferAttribute ? t[a] * e.data.stride + e.offset : t[a] * n;
                for(let e = 0; e < n; e++)r[o++] = i[s++];
            }
            return new $a42f1354f0348298$var$Yh(r, n, a);
        }
        if (null === this.index) return $a42f1354f0348298$var$Wd("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        const t = new $a42f1354f0348298$var$hp, i = this.index.array, n = this.attributes;
        for(const a in n){
            const r = e(n[a], i);
            t.setAttribute(a, r);
        }
        const a = this.morphAttributes;
        for(const n in a){
            const r = [], s = a[n];
            for(let t = 0, n = s.length; t < n; t++){
                const n = e(s[t], i);
                r.push(n);
            }
            t.morphAttributes[n] = r;
        }
        t.morphTargetsRelative = this.morphTargetsRelative;
        const r = this.groups;
        for(let e = 0, i = r.length; e < i; e++){
            const i = r[e];
            t.addGroup(i.start, i.count, i.materialIndex);
        }
        return t;
    }
    toJSON() {
        const e = {
            metadata: {
                version: 4.7,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (e.uuid = this.uuid, e.type = void 0 !== this.parameters && !0 === this._transformed ? "BufferGeometry" : this.type, "" !== this.name && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), void 0 !== this.parameters && !0 !== this._transformed) {
            const t = this.parameters;
            for(const i in t)void 0 !== t[i] && (e[i] = t[i]);
            return e;
        }
        e.data = {
            attributes: {}
        };
        const t = this.index;
        null !== t && (e.data.index = {
            type: t.array.constructor.name,
            array: Array.prototype.slice.call(t.array)
        });
        const i = this.attributes;
        for(const t in i){
            const n = i[t];
            e.data.attributes[t] = n.toJSON(e.data);
        }
        const n = {};
        let a = !1;
        for(const t in this.morphAttributes){
            const i = this.morphAttributes[t], r = [];
            for(let t = 0, n = i.length; t < n; t++){
                const n = i[t];
                r.push(n.toJSON(e.data));
            }
            r.length > 0 && (n[t] = r, a = !0);
        }
        a && (e.data.morphAttributes = n, e.data.morphTargetsRelative = this.morphTargetsRelative);
        const r = this.groups;
        r.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(r)));
        const s = this.boundingSphere;
        return null !== s && (e.data.boundingSphere = s.toJSON()), e;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        const t = {};
        this.name = e.name;
        const i = e.index;
        null !== i && this.setIndex(i.clone());
        const n = e.attributes;
        for(const e in n){
            const i = n[e];
            this.setAttribute(e, i.clone(t));
        }
        const a = e.morphAttributes;
        for(const e in a){
            const i = [], n = a[e];
            for(let e = 0, a = n.length; e < a; e++)i.push(n[e].clone(t));
            this.morphAttributes[e] = i;
        }
        this.morphTargetsRelative = e.morphTargetsRelative;
        const r = e.groups;
        for(let e = 0, t = r.length; e < t; e++){
            const t = r[e];
            this.addGroup(t.start, t.count, t.materialIndex);
        }
        const s = e.boundingBox;
        null !== s && (this.boundingBox = s.clone());
        const o = e.boundingSphere;
        return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this._transformed = e._transformed, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
let $a42f1354f0348298$var$pp = 0;
class $a42f1354f0348298$var$Ap extends $a42f1354f0348298$var$Yd {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: $a42f1354f0348298$var$pp++
        }), this.uuid = $a42f1354f0348298$var$iu(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = $a42f1354f0348298$var$Sl, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new $a42f1354f0348298$var$gh(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = $a42f1354f0348298$var$Dd, this.stencilZFail = $a42f1354f0348298$var$Dd, this.stencilZPass = $a42f1354f0348298$var$Dd, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(e) {
        this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
    }
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(e) {
        if (void 0 !== e) for(const t in e){
            const i = e[t];
            if (void 0 === i) {
                $a42f1354f0348298$var$Wd(`Material: parameter '${t}' has value of undefined.`);
                continue;
            }
            const n = this[t];
            void 0 !== n ? n && n.isColor ? n.set(i) : n && n.isVector2 && i && i.isVector2 || n && n.isEuler && i && i.isEuler || n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[t] = i : $a42f1354f0348298$var$Wd(`Material: '${t}' is not a property of THREE.${this.type}.`);
        }
    }
    toJSON(e) {
        const t = void 0 === e || "string" == typeof e;
        t && (e = {
            textures: {},
            images: {}
        });
        const i = {
            metadata: {
                version: 4.7,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        function n(e) {
            const t = [];
            for(const i in e){
                const n = e[i];
                delete n.metadata, t.push(n);
            }
            return t;
        }
        if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), void 0 !== this.roughness && (i.roughness = this.roughness), void 0 !== this.metalness && (i.metalness = this.metalness), void 0 !== this.sheen && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), void 0 !== this.emissiveIntensity && 1 !== this.emissiveIntensity && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (i.shininess = this.shininess), void 0 !== this.clearcoat && (i.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (i.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (i.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), void 0 !== this.dispersion && (i.dispersion = this.dispersion), void 0 !== this.iridescence && (i.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (i.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), void 0 !== this.anisotropy && (i.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(e).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(e).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(e).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(e).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(e).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(e).uuid, void 0 !== this.combine && (i.combine = this.combine)), void 0 !== this.envMapRotation && (i.envMapRotation = this.envMapRotation.toArray()), void 0 !== this.envMapIntensity && (i.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (i.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(e).uuid), void 0 !== this.transmission && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(e).uuid), void 0 !== this.thickness && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(e).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (i.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (i.size = this.size), null !== this.shadowSide && (i.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (i.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (i.blending = this.blending), 0 !== this.side && (i.side = this.side), !0 === this.vertexColors && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), !0 === this.transparent && (i.transparent = !0), 204 !== this.blendSrc && (i.blendSrc = this.blendSrc), 205 !== this.blendDst && (i.blendDst = this.blendDst), this.blendEquation !== $a42f1354f0348298$var$Sl && (i.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (i.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (i.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (i.blendAlpha = this.blendAlpha), 3 !== this.depthFunc && (i.depthFunc = this.depthFunc), !1 === this.depthTest && (i.depthTest = this.depthTest), !1 === this.depthWrite && (i.depthWrite = this.depthWrite), !1 === this.colorWrite && (i.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (i.stencilWriteMask = this.stencilWriteMask), 519 !== this.stencilFunc && (i.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (i.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== $a42f1354f0348298$var$Dd && (i.stencilFail = this.stencilFail), this.stencilZFail !== $a42f1354f0348298$var$Dd && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== $a42f1354f0348298$var$Dd && (i.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (i.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (i.rotation = this.rotation), !0 === this.polygonOffset && (i.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (i.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (i.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (i.linewidth = this.linewidth), void 0 !== this.dashSize && (i.dashSize = this.dashSize), void 0 !== this.gapSize && (i.gapSize = this.gapSize), void 0 !== this.scale && (i.scale = this.scale), !0 === this.dithering && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), !0 === this.alphaHash && (i.alphaHash = !0), !0 === this.alphaToCoverage && (i.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (i.premultipliedAlpha = !0), !0 === this.forceSinglePass && (i.forceSinglePass = !0), !1 === this.allowOverride && (i.allowOverride = !1), !0 === this.wireframe && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (i.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (i.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (i.flatShading = !0), !1 === this.visible && (i.visible = !1), !1 === this.toneMapped && (i.toneMapped = !1), !1 === this.fog && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData), t) {
            const t = n(e.textures), a = n(e.images);
            t.length > 0 && (i.textures = t), a.length > 0 && (i.images = a);
        }
        return i;
    }
    fromJSON(e, t) {
        if (void 0 !== e.uuid && (this.uuid = e.uuid), void 0 !== e.name && (this.name = e.name), void 0 !== e.color && void 0 !== this.color && this.color.setHex(e.color), void 0 !== e.roughness && (this.roughness = e.roughness), void 0 !== e.metalness && (this.metalness = e.metalness), void 0 !== e.sheen && (this.sheen = e.sheen), void 0 !== e.sheenColor && (this.sheenColor = (new $a42f1354f0348298$var$gh).setHex(e.sheenColor)), void 0 !== e.sheenRoughness && (this.sheenRoughness = e.sheenRoughness), void 0 !== e.emissive && void 0 !== this.emissive && this.emissive.setHex(e.emissive), void 0 !== e.specular && void 0 !== this.specular && this.specular.setHex(e.specular), void 0 !== e.specularIntensity && (this.specularIntensity = e.specularIntensity), void 0 !== e.specularColor && void 0 !== this.specularColor && this.specularColor.setHex(e.specularColor), void 0 !== e.shininess && (this.shininess = e.shininess), void 0 !== e.clearcoat && (this.clearcoat = e.clearcoat), void 0 !== e.clearcoatRoughness && (this.clearcoatRoughness = e.clearcoatRoughness), void 0 !== e.dispersion && (this.dispersion = e.dispersion), void 0 !== e.iridescence && (this.iridescence = e.iridescence), void 0 !== e.iridescenceIOR && (this.iridescenceIOR = e.iridescenceIOR), void 0 !== e.iridescenceThicknessRange && (this.iridescenceThicknessRange = e.iridescenceThicknessRange), void 0 !== e.transmission && (this.transmission = e.transmission), void 0 !== e.thickness && (this.thickness = e.thickness), void 0 !== e.attenuationDistance && (this.attenuationDistance = e.attenuationDistance), void 0 !== e.attenuationColor && void 0 !== this.attenuationColor && this.attenuationColor.setHex(e.attenuationColor), void 0 !== e.anisotropy && (this.anisotropy = e.anisotropy), void 0 !== e.anisotropyRotation && (this.anisotropyRotation = e.anisotropyRotation), void 0 !== e.fog && (this.fog = e.fog), void 0 !== e.flatShading && (this.flatShading = e.flatShading), void 0 !== e.blending && (this.blending = e.blending), void 0 !== e.combine && (this.combine = e.combine), void 0 !== e.side && (this.side = e.side), void 0 !== e.shadowSide && (this.shadowSide = e.shadowSide), void 0 !== e.opacity && (this.opacity = e.opacity), void 0 !== e.transparent && (this.transparent = e.transparent), void 0 !== e.alphaTest && (this.alphaTest = e.alphaTest), void 0 !== e.alphaHash && (this.alphaHash = e.alphaHash), void 0 !== e.depthFunc && (this.depthFunc = e.depthFunc), void 0 !== e.depthTest && (this.depthTest = e.depthTest), void 0 !== e.depthWrite && (this.depthWrite = e.depthWrite), void 0 !== e.colorWrite && (this.colorWrite = e.colorWrite), void 0 !== e.blendSrc && (this.blendSrc = e.blendSrc), void 0 !== e.blendDst && (this.blendDst = e.blendDst), void 0 !== e.blendEquation && (this.blendEquation = e.blendEquation), void 0 !== e.blendSrcAlpha && (this.blendSrcAlpha = e.blendSrcAlpha), void 0 !== e.blendDstAlpha && (this.blendDstAlpha = e.blendDstAlpha), void 0 !== e.blendEquationAlpha && (this.blendEquationAlpha = e.blendEquationAlpha), void 0 !== e.blendColor && void 0 !== this.blendColor && this.blendColor.setHex(e.blendColor), void 0 !== e.blendAlpha && (this.blendAlpha = e.blendAlpha), void 0 !== e.stencilWriteMask && (this.stencilWriteMask = e.stencilWriteMask), void 0 !== e.stencilFunc && (this.stencilFunc = e.stencilFunc), void 0 !== e.stencilRef && (this.stencilRef = e.stencilRef), void 0 !== e.stencilFuncMask && (this.stencilFuncMask = e.stencilFuncMask), void 0 !== e.stencilFail && (this.stencilFail = e.stencilFail), void 0 !== e.stencilZFail && (this.stencilZFail = e.stencilZFail), void 0 !== e.stencilZPass && (this.stencilZPass = e.stencilZPass), void 0 !== e.stencilWrite && (this.stencilWrite = e.stencilWrite), void 0 !== e.wireframe && (this.wireframe = e.wireframe), void 0 !== e.wireframeLinewidth && (this.wireframeLinewidth = e.wireframeLinewidth), void 0 !== e.wireframeLinecap && (this.wireframeLinecap = e.wireframeLinecap), void 0 !== e.wireframeLinejoin && (this.wireframeLinejoin = e.wireframeLinejoin), void 0 !== e.rotation && (this.rotation = e.rotation), void 0 !== e.linewidth && (this.linewidth = e.linewidth), void 0 !== e.dashSize && (this.dashSize = e.dashSize), void 0 !== e.gapSize && (this.gapSize = e.gapSize), void 0 !== e.scale && (this.scale = e.scale), void 0 !== e.polygonOffset && (this.polygonOffset = e.polygonOffset), void 0 !== e.polygonOffsetFactor && (this.polygonOffsetFactor = e.polygonOffsetFactor), void 0 !== e.polygonOffsetUnits && (this.polygonOffsetUnits = e.polygonOffsetUnits), void 0 !== e.dithering && (this.dithering = e.dithering), void 0 !== e.alphaToCoverage && (this.alphaToCoverage = e.alphaToCoverage), void 0 !== e.premultipliedAlpha && (this.premultipliedAlpha = e.premultipliedAlpha), void 0 !== e.forceSinglePass && (this.forceSinglePass = e.forceSinglePass), void 0 !== e.allowOverride && (this.allowOverride = e.allowOverride), void 0 !== e.visible && (this.visible = e.visible), void 0 !== e.toneMapped && (this.toneMapped = e.toneMapped), void 0 !== e.userData && (this.userData = e.userData), void 0 !== e.vertexColors && ("number" == typeof e.vertexColors ? this.vertexColors = e.vertexColors > 0 : this.vertexColors = e.vertexColors), void 0 !== e.size && (this.size = e.size), void 0 !== e.sizeAttenuation && (this.sizeAttenuation = e.sizeAttenuation), void 0 !== e.map && (this.map = t[e.map] || null), void 0 !== e.matcap && (this.matcap = t[e.matcap] || null), void 0 !== e.alphaMap && (this.alphaMap = t[e.alphaMap] || null), void 0 !== e.bumpMap && (this.bumpMap = t[e.bumpMap] || null), void 0 !== e.bumpScale && (this.bumpScale = e.bumpScale), void 0 !== e.normalMap && (this.normalMap = t[e.normalMap] || null), void 0 !== e.normalMapType && (this.normalMapType = e.normalMapType), void 0 !== e.normalScale) {
            let t = e.normalScale;
            !1 === Array.isArray(t) && (t = [
                t,
                t
            ]), this.normalScale = (new $a42f1354f0348298$var$cu).fromArray(t);
        }
        return void 0 !== e.displacementMap && (this.displacementMap = t[e.displacementMap] || null), void 0 !== e.displacementScale && (this.displacementScale = e.displacementScale), void 0 !== e.displacementBias && (this.displacementBias = e.displacementBias), void 0 !== e.roughnessMap && (this.roughnessMap = t[e.roughnessMap] || null), void 0 !== e.metalnessMap && (this.metalnessMap = t[e.metalnessMap] || null), void 0 !== e.emissiveMap && (this.emissiveMap = t[e.emissiveMap] || null), void 0 !== e.emissiveIntensity && (this.emissiveIntensity = e.emissiveIntensity), void 0 !== e.specularMap && (this.specularMap = t[e.specularMap] || null), void 0 !== e.specularIntensityMap && (this.specularIntensityMap = t[e.specularIntensityMap] || null), void 0 !== e.specularColorMap && (this.specularColorMap = t[e.specularColorMap] || null), void 0 !== e.envMap && (this.envMap = t[e.envMap] || null), void 0 !== e.envMapRotation && this.envMapRotation.fromArray(e.envMapRotation), void 0 !== e.envMapIntensity && (this.envMapIntensity = e.envMapIntensity), void 0 !== e.reflectivity && (this.reflectivity = e.reflectivity), void 0 !== e.refractionRatio && (this.refractionRatio = e.refractionRatio), void 0 !== e.lightMap && (this.lightMap = t[e.lightMap] || null), void 0 !== e.lightMapIntensity && (this.lightMapIntensity = e.lightMapIntensity), void 0 !== e.aoMap && (this.aoMap = t[e.aoMap] || null), void 0 !== e.aoMapIntensity && (this.aoMapIntensity = e.aoMapIntensity), void 0 !== e.gradientMap && (this.gradientMap = t[e.gradientMap] || null), void 0 !== e.clearcoatMap && (this.clearcoatMap = t[e.clearcoatMap] || null), void 0 !== e.clearcoatRoughnessMap && (this.clearcoatRoughnessMap = t[e.clearcoatRoughnessMap] || null), void 0 !== e.clearcoatNormalMap && (this.clearcoatNormalMap = t[e.clearcoatNormalMap] || null), void 0 !== e.clearcoatNormalScale && (this.clearcoatNormalScale = (new $a42f1354f0348298$var$cu).fromArray(e.clearcoatNormalScale)), void 0 !== e.iridescenceMap && (this.iridescenceMap = t[e.iridescenceMap] || null), void 0 !== e.iridescenceThicknessMap && (this.iridescenceThicknessMap = t[e.iridescenceThicknessMap] || null), void 0 !== e.transmissionMap && (this.transmissionMap = t[e.transmissionMap] || null), void 0 !== e.thicknessMap && (this.thicknessMap = t[e.thicknessMap] || null), void 0 !== e.anisotropyMap && (this.anisotropyMap = t[e.anisotropyMap] || null), void 0 !== e.sheenColorMap && (this.sheenColorMap = t[e.sheenColorMap] || null), void 0 !== e.sheenRoughnessMap && (this.sheenRoughnessMap = t[e.sheenRoughnessMap] || null), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e) {
        this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
        const t = e.clippingPlanes;
        let i = null;
        if (null !== t) {
            const e = t.length;
            i = new Array(e);
            for(let n = 0; n !== e; ++n)i[n] = t[n].clone();
        }
        return this.clippingPlanes = i, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.allowOverride = e.allowOverride, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(e) {
        !0 === e && this.version++;
    }
}
const $a42f1354f0348298$var$mp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$gp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$fp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$_p = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$vp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Ep = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$yp = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$bp {
    constructor(e = new $a42f1354f0348298$var$uu, t = new $a42f1354f0348298$var$uu(0, 0, -1)){
        this.origin = e, this.direction = t;
    }
    set(e, t) {
        return this.origin.copy(e), this.direction.copy(t), this;
    }
    copy(e) {
        return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
    }
    at(e, t) {
        return t.copy(this.origin).addScaledVector(this.direction, e);
    }
    lookAt(e) {
        return this.direction.copy(e).sub(this.origin).normalize(), this;
    }
    recast(e) {
        return this.origin.copy(this.at(e, $a42f1354f0348298$var$mp)), this;
    }
    closestPointToPoint(e, t) {
        t.subVectors(e, this.origin);
        const i = t.dot(this.direction);
        return i < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, i);
    }
    distanceToPoint(e) {
        return Math.sqrt(this.distanceSqToPoint(e));
    }
    distanceSqToPoint(e) {
        const t = $a42f1354f0348298$var$mp.subVectors(e, this.origin).dot(this.direction);
        return t < 0 ? this.origin.distanceToSquared(e) : ($a42f1354f0348298$var$mp.copy(this.origin).addScaledVector(this.direction, t), $a42f1354f0348298$var$mp.distanceToSquared(e));
    }
    distanceSqToSegment(e, t, i, n) {
        $a42f1354f0348298$var$gp.copy(e).add(t).multiplyScalar(.5), $a42f1354f0348298$var$fp.copy(t).sub(e).normalize(), $a42f1354f0348298$var$_p.copy(this.origin).sub($a42f1354f0348298$var$gp);
        const a = .5 * e.distanceTo(t), r = -this.direction.dot($a42f1354f0348298$var$fp), s = $a42f1354f0348298$var$_p.dot(this.direction), o = -$a42f1354f0348298$var$_p.dot($a42f1354f0348298$var$fp), l = $a42f1354f0348298$var$_p.lengthSq(), c = Math.abs(1 - r * r);
        let d, u, h, p;
        if (c > 0) {
            if (d = r * o - s, u = r * s - o, p = a * c, d >= 0) {
                if (u >= -p) {
                    if (u <= p) {
                        const e = 1 / c;
                        d *= e, u *= e, h = d * (d + r * u + 2 * s) + u * (r * d + u + 2 * o) + l;
                    } else u = a, d = Math.max(0, -(r * u + s)), h = -d * d + u * (u + 2 * o) + l;
                } else u = -a, d = Math.max(0, -(r * u + s)), h = -d * d + u * (u + 2 * o) + l;
            } else u <= -p ? (d = Math.max(0, -(-r * a + s)), u = d > 0 ? -a : Math.min(Math.max(-a, -o), a), h = -d * d + u * (u + 2 * o) + l) : u <= p ? (d = 0, u = Math.min(Math.max(-a, -o), a), h = u * (u + 2 * o) + l) : (d = Math.max(0, -(r * a + s)), u = d > 0 ? a : Math.min(Math.max(-a, -o), a), h = -d * d + u * (u + 2 * o) + l);
        } else u = r > 0 ? -a : a, d = Math.max(0, -(r * u + s)), h = -d * d + u * (u + 2 * o) + l;
        return i && i.copy(this.origin).addScaledVector(this.direction, d), n && n.copy($a42f1354f0348298$var$gp).addScaledVector($a42f1354f0348298$var$fp, u), h;
    }
    intersectSphere(e, t) {
        $a42f1354f0348298$var$mp.subVectors(e.center, this.origin);
        const i = $a42f1354f0348298$var$mp.dot(this.direction), n = $a42f1354f0348298$var$mp.dot($a42f1354f0348298$var$mp) - i * i, a = e.radius * e.radius;
        if (n > a) return null;
        const r = Math.sqrt(a - n), s = i - r, o = i + r;
        return o < 0 ? null : s < 0 ? this.at(o, t) : this.at(s, t);
    }
    intersectsSphere(e) {
        return !(e.radius < 0) && this.distanceSqToPoint(e.center) <= e.radius * e.radius;
    }
    distanceToPlane(e) {
        const t = e.normal.dot(this.direction);
        if (0 === t) return 0 === e.distanceToPoint(this.origin) ? 0 : null;
        const i = -(this.origin.dot(e.normal) + e.constant) / t;
        return i >= 0 ? i : null;
    }
    intersectPlane(e, t) {
        const i = this.distanceToPlane(e);
        return null === i ? null : this.at(i, t);
    }
    intersectsPlane(e) {
        const t = e.distanceToPoint(this.origin);
        if (0 === t) return !0;
        return e.normal.dot(this.direction) * t < 0;
    }
    intersectBox(e, t) {
        let i, n, a, r, s, o;
        const l = 1 / this.direction.x, c = 1 / this.direction.y, d = 1 / this.direction.z, u = this.origin;
        return l >= 0 ? (i = (e.min.x - u.x) * l, n = (e.max.x - u.x) * l) : (i = (e.max.x - u.x) * l, n = (e.min.x - u.x) * l), c >= 0 ? (a = (e.min.y - u.y) * c, r = (e.max.y - u.y) * c) : (a = (e.max.y - u.y) * c, r = (e.min.y - u.y) * c), i > r || a > n ? null : ((a > i || isNaN(i)) && (i = a), (r < n || isNaN(n)) && (n = r), d >= 0 ? (s = (e.min.z - u.z) * d, o = (e.max.z - u.z) * d) : (s = (e.max.z - u.z) * d, o = (e.min.z - u.z) * d), i > o || s > n ? null : ((s > i || i != i) && (i = s), (o < n || n != n) && (n = o), n < 0 ? null : this.at(i >= 0 ? i : n, t)));
    }
    intersectsBox(e) {
        return null !== this.intersectBox(e, $a42f1354f0348298$var$mp);
    }
    intersectTriangle(e, t, i, n, a) {
        $a42f1354f0348298$var$vp.subVectors(t, e), $a42f1354f0348298$var$Ep.subVectors(i, e), $a42f1354f0348298$var$yp.crossVectors($a42f1354f0348298$var$vp, $a42f1354f0348298$var$Ep);
        let r, s = this.direction.dot($a42f1354f0348298$var$yp);
        if (s > 0) {
            if (n) return null;
            r = 1;
        } else {
            if (!(s < 0)) return null;
            r = -1, s = -s;
        }
        $a42f1354f0348298$var$_p.subVectors(this.origin, e);
        const o = r * this.direction.dot($a42f1354f0348298$var$Ep.crossVectors($a42f1354f0348298$var$_p, $a42f1354f0348298$var$Ep));
        if (o < 0) return null;
        const l = r * this.direction.dot($a42f1354f0348298$var$vp.cross($a42f1354f0348298$var$_p));
        if (l < 0) return null;
        if (o + l > s) return null;
        const c = -r * $a42f1354f0348298$var$_p.dot($a42f1354f0348298$var$yp);
        return c < 0 ? null : this.at(c / s, a);
    }
    applyMatrix4(e) {
        return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
    }
    equals(e) {
        return e.origin.equals(this.origin) && e.direction.equals(this.direction);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $a42f1354f0348298$var$kp extends $a42f1354f0348298$var$Ap {
    constructor(e){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new $a42f1354f0348298$var$gh(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $a42f1354f0348298$var$qu, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
    }
}
const $a42f1354f0348298$var$xp = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$wp = new $a42f1354f0348298$var$bp, $a42f1354f0348298$var$Mp = new $a42f1354f0348298$var$ap, $a42f1354f0348298$var$Sp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Cp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Tp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Dp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Pp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Ip = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Lp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Rp = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$zp extends $a42f1354f0348298$var$lh {
    constructor(e = new $a42f1354f0348298$var$hp, t = new $a42f1354f0348298$var$kp){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
    }
    copy(e, t) {
        return super.copy(e, t), void 0 !== e.morphTargetInfluences && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), void 0 !== e.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
    }
    updateMorphTargets() {
        const e = this.geometry.morphAttributes, t = Object.keys(e);
        if (t.length > 0) {
            const i = e[t[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let e = 0, t = i.length; e < t; e++){
                    const t = i[e].name || String(e);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e;
                }
            }
        }
    }
    getVertexPosition(e, t) {
        const i = this.geometry, n = i.attributes.position, a = i.morphAttributes.position, r = i.morphTargetsRelative;
        t.fromBufferAttribute(n, e);
        const s = this.morphTargetInfluences;
        if (a && s) {
            $a42f1354f0348298$var$Ip.set(0, 0, 0);
            for(let i = 0, n = a.length; i < n; i++){
                const n = s[i], o = a[i];
                0 !== n && ($a42f1354f0348298$var$Pp.fromBufferAttribute(o, e), r ? $a42f1354f0348298$var$Ip.addScaledVector($a42f1354f0348298$var$Pp, n) : $a42f1354f0348298$var$Ip.addScaledVector($a42f1354f0348298$var$Pp.sub(t), n));
            }
            t.add($a42f1354f0348298$var$Ip);
        }
        return t;
    }
    raycast(e, t) {
        const i = this.geometry, n = this.material, a = this.matrixWorld;
        if (void 0 !== n) {
            if (null === i.boundingSphere && i.computeBoundingSphere(), $a42f1354f0348298$var$Mp.copy(i.boundingSphere), $a42f1354f0348298$var$Mp.applyMatrix4(a), $a42f1354f0348298$var$wp.copy(e.ray).recast(e.near), !1 === $a42f1354f0348298$var$Mp.containsPoint($a42f1354f0348298$var$wp.origin)) {
                if (null === $a42f1354f0348298$var$wp.intersectSphere($a42f1354f0348298$var$Mp, $a42f1354f0348298$var$Sp)) return;
                if ($a42f1354f0348298$var$wp.origin.distanceToSquared($a42f1354f0348298$var$Sp) > (e.far - e.near) ** 2) return;
            }
            $a42f1354f0348298$var$xp.copy(a).invert(), $a42f1354f0348298$var$wp.copy(e.ray).applyMatrix4($a42f1354f0348298$var$xp), null !== i.boundingBox && !1 === $a42f1354f0348298$var$wp.intersectsBox(i.boundingBox) || this._computeIntersections(e, t, $a42f1354f0348298$var$wp);
        }
    }
    _computeIntersections(e, t, i) {
        let n;
        const a = this.geometry, r = this.material, s = a.index, o = a.attributes.position, l = a.attributes.uv, c = a.attributes.uv1, d = a.attributes.normal, u = a.groups, h = a.drawRange;
        if (null !== s) {
            if (Array.isArray(r)) for(let a = 0, o = u.length; a < o; a++){
                const o = u[a], p = r[o.materialIndex];
                for(let a = Math.max(o.start, h.start), r = Math.min(s.count, Math.min(o.start + o.count, h.start + h.count)); a < r; a += 3)n = $a42f1354f0348298$var$Fp(this, p, e, i, l, c, d, s.getX(a), s.getX(a + 1), s.getX(a + 2)), n && (n.faceIndex = Math.floor(a / 3), n.face.materialIndex = o.materialIndex, t.push(n));
            }
            else for(let a = Math.max(0, h.start), o = Math.min(s.count, h.start + h.count); a < o; a += 3)n = $a42f1354f0348298$var$Fp(this, r, e, i, l, c, d, s.getX(a), s.getX(a + 1), s.getX(a + 2)), n && (n.faceIndex = Math.floor(a / 3), t.push(n));
        } else if (void 0 !== o) {
            if (Array.isArray(r)) for(let a = 0, s = u.length; a < s; a++){
                const s = u[a], p = r[s.materialIndex];
                for(let a = Math.max(s.start, h.start), r = Math.min(o.count, Math.min(s.start + s.count, h.start + h.count)); a < r; a += 3)n = $a42f1354f0348298$var$Fp(this, p, e, i, l, c, d, a, a + 1, a + 2), n && (n.faceIndex = Math.floor(a / 3), n.face.materialIndex = s.materialIndex, t.push(n));
            }
            else for(let a = Math.max(0, h.start), s = Math.min(o.count, h.start + h.count); a < s; a += 3)n = $a42f1354f0348298$var$Fp(this, r, e, i, l, c, d, a, a + 1, a + 2), n && (n.faceIndex = Math.floor(a / 3), t.push(n));
        }
    }
}
function $a42f1354f0348298$var$Fp(e, t, i, n, a, r, s, o, l, c) {
    e.getVertexPosition(o, $a42f1354f0348298$var$Cp), e.getVertexPosition(l, $a42f1354f0348298$var$Tp), e.getVertexPosition(c, $a42f1354f0348298$var$Dp);
    const d = function(e, t, i, n, a, r, s, o) {
        let l;
        if (l = 1 === t.side ? n.intersectTriangle(s, r, a, !0, o) : n.intersectTriangle(a, r, s, 0 === t.side, o), null === l) return null;
        $a42f1354f0348298$var$Rp.copy(o), $a42f1354f0348298$var$Rp.applyMatrix4(e.matrixWorld);
        const c = i.ray.origin.distanceTo($a42f1354f0348298$var$Rp);
        return c < i.near || c > i.far ? null : {
            distance: c,
            point: $a42f1354f0348298$var$Rp.clone(),
            object: e
        };
    }(e, t, i, n, $a42f1354f0348298$var$Cp, $a42f1354f0348298$var$Tp, $a42f1354f0348298$var$Dp, $a42f1354f0348298$var$Lp);
    if (d) {
        const e = new $a42f1354f0348298$var$uu;
        $a42f1354f0348298$var$Ih.getBarycoord($a42f1354f0348298$var$Lp, $a42f1354f0348298$var$Cp, $a42f1354f0348298$var$Tp, $a42f1354f0348298$var$Dp, e), a && (d.uv = $a42f1354f0348298$var$Ih.getInterpolatedAttribute(a, o, l, c, e, new $a42f1354f0348298$var$cu)), r && (d.uv1 = $a42f1354f0348298$var$Ih.getInterpolatedAttribute(r, o, l, c, e, new $a42f1354f0348298$var$cu)), s && (d.normal = $a42f1354f0348298$var$Ih.getInterpolatedAttribute(s, o, l, c, e, new $a42f1354f0348298$var$uu), d.normal.dot(n.direction) > 0 && d.normal.multiplyScalar(-1));
        const t = {
            a: o,
            b: l,
            c: c,
            normal: new $a42f1354f0348298$var$uu,
            materialIndex: 0
        };
        $a42f1354f0348298$var$Ih.getNormal($a42f1354f0348298$var$Cp, $a42f1354f0348298$var$Tp, $a42f1354f0348298$var$Dp, t.normal), d.face = t, d.barycoord = e;
    }
    return d;
}
class $a42f1354f0348298$var$Up extends $a42f1354f0348298$var$Tu {
    constructor(e = null, t = 1, i = 1, n, a, r, s, o, l = 1003, c = 1003, d, u){
        super(null, r, s, o, l, c, n, a, d, u), this.isDataTexture = !0, this.image = {
            data: e,
            width: t,
            height: i
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
const $a42f1354f0348298$var$Np = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Bp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Op = new $a42f1354f0348298$var$Au;
class $a42f1354f0348298$var$jp {
    constructor(e = new $a42f1354f0348298$var$uu(1, 0, 0), t = 0){
        this.isPlane = !0, this.normal = e, this.constant = t;
    }
    set(e, t) {
        return this.normal.copy(e), this.constant = t, this;
    }
    setComponents(e, t, i, n) {
        return this.normal.set(e, t, i), this.constant = n, this;
    }
    setFromNormalAndCoplanarPoint(e, t) {
        return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
    }
    setFromCoplanarPoints(e, t, i) {
        const n = $a42f1354f0348298$var$Np.subVectors(i, t).cross($a42f1354f0348298$var$Bp.subVectors(e, t)).normalize();
        return this.setFromNormalAndCoplanarPoint(n, e), this;
    }
    copy(e) {
        return this.normal.copy(e.normal), this.constant = e.constant, this;
    }
    normalize() {
        const e = 1 / this.normal.length();
        return this.normal.multiplyScalar(e), this.constant *= e, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(e) {
        return this.normal.dot(e) + this.constant;
    }
    distanceToSphere(e) {
        return this.distanceToPoint(e.center) - e.radius;
    }
    projectPoint(e, t) {
        return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
    }
    intersectLine(e, t, i = !0) {
        const n = e.delta($a42f1354f0348298$var$Np), a = this.normal.dot(n);
        if (0 === a) return 0 === this.distanceToPoint(e.start) ? t.copy(e.start) : null;
        const r = -(e.start.dot(this.normal) + this.constant) / a;
        return !0 === i && (r < 0 || r > 1) ? null : t.copy(e.start).addScaledVector(n, r);
    }
    intersectsLine(e) {
        const t = this.distanceToPoint(e.start), i = this.distanceToPoint(e.end);
        return t < 0 && i > 0 || i < 0 && t > 0;
    }
    intersectsBox(e) {
        return e.intersectsPlane(this);
    }
    intersectsSphere(e) {
        return e.intersectsPlane(this);
    }
    coplanarPoint(e) {
        return e.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(e, t) {
        const i = t || $a42f1354f0348298$var$Op.getNormalMatrix(e), n = this.coplanarPoint($a42f1354f0348298$var$Np).applyMatrix4(e), a = this.normal.applyMatrix3(i).normalize();
        return this.constant = -n.dot(a), this;
    }
    translate(e) {
        return this.constant -= e.dot(this.normal), this;
    }
    equals(e) {
        return e.normal.equals(this.normal) && e.constant === this.constant;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $a42f1354f0348298$var$Gp = new $a42f1354f0348298$var$ap, $a42f1354f0348298$var$Vp = new $a42f1354f0348298$var$cu(.5, .5), $a42f1354f0348298$var$Hp = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$qp {
    constructor(e = new $a42f1354f0348298$var$jp, t = new $a42f1354f0348298$var$jp, i = new $a42f1354f0348298$var$jp, n = new $a42f1354f0348298$var$jp, a = new $a42f1354f0348298$var$jp, r = new $a42f1354f0348298$var$jp){
        this.planes = [
            e,
            t,
            i,
            n,
            a,
            r
        ];
    }
    set(e, t, i, n, a, r) {
        const s = this.planes;
        return s[0].copy(e), s[1].copy(t), s[2].copy(i), s[3].copy(n), s[4].copy(a), s[5].copy(r), this;
    }
    copy(e) {
        const t = this.planes;
        for(let i = 0; i < 6; i++)t[i].copy(e.planes[i]);
        return this;
    }
    setFromProjectionMatrix(e, t = 2e3, i = !1) {
        const n = this.planes, a = e.elements, r = a[0], s = a[1], o = a[2], l = a[3], c = a[4], d = a[5], u = a[6], h = a[7], p = a[8], A = a[9], m = a[10], g = a[11], f = a[12], _ = a[13], v = a[14], E = a[15];
        if (n[0].setComponents(l - r, h - c, g - p, E - f).normalize(), n[1].setComponents(l + r, h + c, g + p, E + f).normalize(), n[2].setComponents(l + s, h + d, g + A, E + _).normalize(), n[3].setComponents(l - s, h - d, g - A, E - _).normalize(), i) n[4].setComponents(o, u, m, v).normalize(), n[5].setComponents(l - o, h - u, g - m, E - v).normalize();
        else if (n[4].setComponents(l - o, h - u, g - m, E - v).normalize(), t === $a42f1354f0348298$var$Od) n[5].setComponents(l + o, h + u, g + m, E + v).normalize();
        else {
            if (t !== $a42f1354f0348298$var$jd) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
            n[5].setComponents(o, u, m, v).normalize();
        }
        return this;
    }
    intersectsObject(e) {
        if (void 0 !== e.boundingSphere) null === e.boundingSphere && e.computeBoundingSphere(), $a42f1354f0348298$var$Gp.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
        else {
            const t = e.geometry;
            null === t.boundingSphere && t.computeBoundingSphere(), $a42f1354f0348298$var$Gp.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
        }
        return this.intersectsSphere($a42f1354f0348298$var$Gp);
    }
    intersectsSprite(e) {
        $a42f1354f0348298$var$Gp.center.set(0, 0, 0);
        const t = $a42f1354f0348298$var$Vp.distanceTo(e.center);
        return $a42f1354f0348298$var$Gp.radius = .7071067811865476 + t, $a42f1354f0348298$var$Gp.applyMatrix4(e.matrixWorld), this.intersectsSphere($a42f1354f0348298$var$Gp);
    }
    intersectsSphere(e) {
        const t = this.planes, i = e.center, n = -e.radius;
        for(let e = 0; e < 6; e++){
            if (t[e].distanceToPoint(i) < n) return !1;
        }
        return !0;
    }
    intersectsBox(e) {
        const t = this.planes;
        for(let i = 0; i < 6; i++){
            const n = t[i];
            if ($a42f1354f0348298$var$Hp.x = n.normal.x > 0 ? e.max.x : e.min.x, $a42f1354f0348298$var$Hp.y = n.normal.y > 0 ? e.max.y : e.min.y, $a42f1354f0348298$var$Hp.z = n.normal.z > 0 ? e.max.z : e.min.z, n.distanceToPoint($a42f1354f0348298$var$Hp) < 0) return !1;
        }
        return !0;
    }
    containsPoint(e) {
        const t = this.planes;
        for(let i = 0; i < 6; i++)if (t[i].distanceToPoint(e) < 0) return !1;
        return !0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $a42f1354f0348298$var$Kp extends $a42f1354f0348298$var$Ap {
    constructor(e){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new $a42f1354f0348298$var$gh(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
    }
}
const $a42f1354f0348298$var$Wp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Xp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Qp = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Zp = new $a42f1354f0348298$var$bp, $a42f1354f0348298$var$Yp = new $a42f1354f0348298$var$ap, $a42f1354f0348298$var$Jp = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$$p = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$eA extends $a42f1354f0348298$var$lh {
    constructor(e = new $a42f1354f0348298$var$hp, t = new $a42f1354f0348298$var$Kp){
        super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
    }
    copy(e, t) {
        return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
    }
    computeLineDistances() {
        const e = this.geometry;
        if (null === e.index) {
            const t = e.attributes.position, i = [
                0
            ];
            for(let e = 1, n = t.count; e < n; e++)$a42f1354f0348298$var$Wp.fromBufferAttribute(t, e - 1), $a42f1354f0348298$var$Xp.fromBufferAttribute(t, e), i[e] = i[e - 1], i[e] += $a42f1354f0348298$var$Wp.distanceTo($a42f1354f0348298$var$Xp);
            e.setAttribute("lineDistance", new $a42f1354f0348298$var$ep(i, 1));
        } else $a42f1354f0348298$var$Wd("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(e, t) {
        const i = this.geometry, n = this.matrixWorld, a = e.params.Line.threshold, r = i.drawRange;
        if (null === i.boundingSphere && i.computeBoundingSphere(), $a42f1354f0348298$var$Yp.copy(i.boundingSphere), $a42f1354f0348298$var$Yp.applyMatrix4(n), $a42f1354f0348298$var$Yp.radius += a, !1 === e.ray.intersectsSphere($a42f1354f0348298$var$Yp)) return;
        $a42f1354f0348298$var$Qp.copy(n).invert(), $a42f1354f0348298$var$Zp.copy(e.ray).applyMatrix4($a42f1354f0348298$var$Qp);
        const s = a / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = this.isLineSegments ? 2 : 1, c = i.index, d = i.attributes.position;
        if (null !== c) {
            const i = Math.max(0, r.start), n = Math.min(c.count, r.start + r.count);
            for(let a = i, r = n - 1; a < r; a += l){
                const i = c.getX(a), n = c.getX(a + 1), r = $a42f1354f0348298$var$tA(this, e, $a42f1354f0348298$var$Zp, o, i, n, a);
                r && t.push(r);
            }
            if (this.isLineLoop) {
                const a = c.getX(n - 1), r = c.getX(i), s = $a42f1354f0348298$var$tA(this, e, $a42f1354f0348298$var$Zp, o, a, r, n - 1);
                s && t.push(s);
            }
        } else {
            const i = Math.max(0, r.start), n = Math.min(d.count, r.start + r.count);
            for(let a = i, r = n - 1; a < r; a += l){
                const i = $a42f1354f0348298$var$tA(this, e, $a42f1354f0348298$var$Zp, o, a, a + 1, a);
                i && t.push(i);
            }
            if (this.isLineLoop) {
                const a = $a42f1354f0348298$var$tA(this, e, $a42f1354f0348298$var$Zp, o, n - 1, i, n - 1);
                a && t.push(a);
            }
        }
    }
    updateMorphTargets() {
        const e = this.geometry.morphAttributes, t = Object.keys(e);
        if (t.length > 0) {
            const i = e[t[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let e = 0, t = i.length; e < t; e++){
                    const t = i[e].name || String(e);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e;
                }
            }
        }
    }
}
function $a42f1354f0348298$var$tA(e, t, i, n, a, r, s) {
    const o = e.geometry.attributes.position;
    $a42f1354f0348298$var$Wp.fromBufferAttribute(o, a), $a42f1354f0348298$var$Xp.fromBufferAttribute(o, r);
    if (i.distanceSqToSegment($a42f1354f0348298$var$Wp, $a42f1354f0348298$var$Xp, $a42f1354f0348298$var$Jp, $a42f1354f0348298$var$$p) > n) return;
    $a42f1354f0348298$var$Jp.applyMatrix4(e.matrixWorld);
    const l = t.ray.origin.distanceTo($a42f1354f0348298$var$Jp);
    return l < t.near || l > t.far ? void 0 : {
        distance: l,
        point: $a42f1354f0348298$var$$p.clone().applyMatrix4(e.matrixWorld),
        index: s,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: e
    };
}
const $a42f1354f0348298$var$iA = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$nA = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$aA extends $a42f1354f0348298$var$eA {
    constructor(e, t){
        super(e, t), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        const e = this.geometry;
        if (null === e.index) {
            const t = e.attributes.position, i = [];
            for(let e = 0, n = t.count; e < n; e += 2)$a42f1354f0348298$var$iA.fromBufferAttribute(t, e), $a42f1354f0348298$var$nA.fromBufferAttribute(t, e + 1), i[e] = 0 === e ? 0 : i[e - 1], i[e + 1] = i[e] + $a42f1354f0348298$var$iA.distanceTo($a42f1354f0348298$var$nA);
            e.setAttribute("lineDistance", new $a42f1354f0348298$var$ep(i, 1));
        } else $a42f1354f0348298$var$Wd("LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $a42f1354f0348298$var$rA extends $a42f1354f0348298$var$Tu {
    constructor(e, t, i, n, a = 1006, r = 1006, s, o, l){
        super(e, t, i, n, a, r, s, o, l), this.isVideoTexture = !0, this.generateMipmaps = !1, this._requestVideoFrameCallbackId = 0;
        const c = this;
        "requestVideoFrameCallback" in e && (this._requestVideoFrameCallbackId = e.requestVideoFrameCallback(function t() {
            c.needsUpdate = !0, c._requestVideoFrameCallbackId = e.requestVideoFrameCallback(t);
        }));
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const e = this.image;
        !1 === "requestVideoFrameCallback" in e && e.readyState >= e.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
    dispose() {
        0 !== this._requestVideoFrameCallbackId && (this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId), this._requestVideoFrameCallbackId = 0), super.dispose();
    }
}
class $a42f1354f0348298$var$sA extends $a42f1354f0348298$var$Tu {
    constructor(e = [], t = 301, i, n, a, r, s, o, l, c){
        super(e, t, i, n, a, r, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(e) {
        this.image = e;
    }
}
class $a42f1354f0348298$var$oA extends $a42f1354f0348298$var$Tu {
    constructor(e, t, i = 1014, n, a, r, s = 1003, o = 1003, l, c = 1026, d = 1){
        if (c !== $a42f1354f0348298$var$Uc && c !== $a42f1354f0348298$var$Nc) throw new Error("THREE.DepthTexture: format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        super({
            width: e,
            height: t,
            depth: d
        }, n, a, r, s, o, c, i, l), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
    }
    copy(e) {
        return super.copy(e), this.source = new $a42f1354f0348298$var$wu(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return null !== this.compareFunction && (t.compareFunction = this.compareFunction), t;
    }
}
class $a42f1354f0348298$var$lA extends $a42f1354f0348298$var$oA {
    constructor(e, t = 1014, i = 301, n, a, r = 1003, s = 1003, o, l = 1026){
        const c = {
            width: e,
            height: e,
            depth: 1
        }, d = [
            c,
            c,
            c,
            c,
            c,
            c
        ];
        super(e, e, t, i, n, a, r, s, o, l), this.image = d, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
    }
    get images() {
        return this.image;
    }
    set images(e) {
        this.image = e;
    }
}
class $a42f1354f0348298$var$cA extends $a42f1354f0348298$var$Tu {
    constructor(e = null){
        super(), this.sourceTexture = e, this.isExternalTexture = !0;
    }
    copy(e) {
        return super.copy(e), this.sourceTexture = e.sourceTexture, this;
    }
}
class $a42f1354f0348298$var$dA extends $a42f1354f0348298$var$hp {
    constructor(e = 1, t = 1, i = 1, n = 1, a = 1, r = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: e,
            height: t,
            depth: i,
            widthSegments: n,
            heightSegments: a,
            depthSegments: r
        };
        const s = this;
        n = Math.floor(n), a = Math.floor(a), r = Math.floor(r);
        const o = [], l = [], c = [], d = [];
        let u = 0, h = 0;
        function p(e, t, i, n, a, r, p, A, m, g, f) {
            const _ = r / m, v = p / g, E = r / 2, y = p / 2, b = A / 2, k = m + 1, x = g + 1;
            let w = 0, M = 0;
            const S = new $a42f1354f0348298$var$uu;
            for(let r = 0; r < x; r++){
                const s = r * v - y;
                for(let o = 0; o < k; o++){
                    const u = o * _ - E;
                    S[e] = u * n, S[t] = s * a, S[i] = b, l.push(S.x, S.y, S.z), S[e] = 0, S[t] = 0, S[i] = A > 0 ? 1 : -1, c.push(S.x, S.y, S.z), d.push(o / m), d.push(1 - r / g), w += 1;
                }
            }
            for(let e = 0; e < g; e++)for(let t = 0; t < m; t++){
                const i = u + t + k * e, n = u + t + k * (e + 1), a = u + (t + 1) + k * (e + 1), r = u + (t + 1) + k * e;
                o.push(i, n, r), o.push(n, a, r), M += 6;
            }
            s.addGroup(h, M, f), h += M, u += w;
        }
        p("z", "y", "x", -1, -1, i, t, e, r, a, 0), p("z", "y", "x", 1, -1, i, t, -e, r, a, 1), p("x", "z", "y", 1, 1, e, i, t, n, r, 2), p("x", "z", "y", 1, -1, e, i, -t, n, r, 3), p("x", "y", "z", 1, -1, e, t, i, n, a, 4), p("x", "y", "z", -1, -1, e, t, -i, n, a, 5), this.setIndex(o), this.setAttribute("position", new $a42f1354f0348298$var$ep(l, 3)), this.setAttribute("normal", new $a42f1354f0348298$var$ep(c, 3)), this.setAttribute("uv", new $a42f1354f0348298$var$ep(d, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $a42f1354f0348298$var$dA(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
    }
}
class $a42f1354f0348298$var$uA extends $a42f1354f0348298$var$hp {
    constructor(e = 1, t = 1, i = 1, n = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: e,
            height: t,
            widthSegments: i,
            heightSegments: n
        };
        const a = e / 2, r = t / 2, s = Math.floor(i), o = Math.floor(n), l = s + 1, c = o + 1, d = e / s, u = t / o, h = [], p = [], A = [], m = [];
        for(let e = 0; e < c; e++){
            const t = e * u - r;
            for(let i = 0; i < l; i++){
                const n = i * d - a;
                p.push(n, -t, 0), A.push(0, 0, 1), m.push(i / s), m.push(1 - e / o);
            }
        }
        for(let e = 0; e < o; e++)for(let t = 0; t < s; t++){
            const i = t + l * e, n = t + l * (e + 1), a = t + 1 + l * (e + 1), r = t + 1 + l * e;
            h.push(i, n, r), h.push(n, a, r);
        }
        this.setIndex(h), this.setAttribute("position", new $a42f1354f0348298$var$ep(p, 3)), this.setAttribute("normal", new $a42f1354f0348298$var$ep(A, 3)), this.setAttribute("uv", new $a42f1354f0348298$var$ep(m, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $a42f1354f0348298$var$uA(e.width, e.height, e.widthSegments, e.heightSegments);
    }
}
class $a42f1354f0348298$var$hA extends $a42f1354f0348298$var$hp {
    constructor(e = 1, t = 32, i = 16, n = 0, a = 2 * Math.PI, r = 0, s = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: e,
            widthSegments: t,
            heightSegments: i,
            phiStart: n,
            phiLength: a,
            thetaStart: r,
            thetaLength: s
        }, t = Math.max(3, Math.floor(t)), i = Math.max(2, Math.floor(i));
        const o = Math.min(r + s, Math.PI);
        let l = 0;
        const c = [], d = new $a42f1354f0348298$var$uu, u = new $a42f1354f0348298$var$uu, h = [], p = [], A = [], m = [];
        for(let h = 0; h <= i; h++){
            const g = [], f = h / i, _ = r + f * s, v = e * Math.cos(_), E = Math.sqrt(e * e - v * v);
            let y = 0;
            0 === h && 0 === r ? y = .5 / t : h === i && o === Math.PI && (y = -0.5 / t);
            for(let e = 0; e <= t; e++){
                const i = e / t, r = n + i * a;
                d.x = -E * Math.cos(r), d.y = v, d.z = E * Math.sin(r), p.push(d.x, d.y, d.z), u.copy(d).normalize(), A.push(u.x, u.y, u.z), m.push(i + y, 1 - f), g.push(l++);
            }
            c.push(g);
        }
        for(let e = 0; e < i; e++)for(let n = 0; n < t; n++){
            const t = c[e][n + 1], a = c[e][n], s = c[e + 1][n], l = c[e + 1][n + 1];
            (0 !== e || r > 0) && h.push(t, a, l), (e !== i - 1 || o < Math.PI) && h.push(a, s, l);
        }
        this.setIndex(h), this.setAttribute("position", new $a42f1354f0348298$var$ep(p, 3)), this.setAttribute("normal", new $a42f1354f0348298$var$ep(A, 3)), this.setAttribute("uv", new $a42f1354f0348298$var$ep(m, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $a42f1354f0348298$var$hA(e.radius, e.widthSegments, e.heightSegments, e.phiStart, e.phiLength, e.thetaStart, e.thetaLength);
    }
}
class $a42f1354f0348298$var$pA extends $a42f1354f0348298$var$hp {
    constructor(e = null){
        if (super(), this.type = "WireframeGeometry", this.parameters = {
            geometry: e
        }, null !== e) {
            const t = [], i = new Set, n = new $a42f1354f0348298$var$uu, a = new $a42f1354f0348298$var$uu;
            if (null !== e.index) {
                const r = e.attributes.position, s = e.index;
                let o = e.groups;
                0 === o.length && (o = [
                    {
                        start: 0,
                        count: s.count,
                        materialIndex: 0
                    }
                ]);
                for(let e = 0, l = o.length; e < l; ++e){
                    const l = o[e], c = l.start;
                    for(let e = c, o = c + l.count; e < o; e += 3)for(let o = 0; o < 3; o++){
                        const l = s.getX(e + o), c = s.getX(e + (o + 1) % 3);
                        n.fromBufferAttribute(r, l), a.fromBufferAttribute(r, c), !0 === $a42f1354f0348298$var$AA(n, a, i) && (t.push(n.x, n.y, n.z), t.push(a.x, a.y, a.z));
                    }
                }
            } else {
                const r = e.attributes.position;
                for(let e = 0, s = r.count / 3; e < s; e++)for(let s = 0; s < 3; s++){
                    const o = 3 * e + s, l = 3 * e + (s + 1) % 3;
                    n.fromBufferAttribute(r, o), a.fromBufferAttribute(r, l), !0 === $a42f1354f0348298$var$AA(n, a, i) && (t.push(n.x, n.y, n.z), t.push(a.x, a.y, a.z));
                }
            }
            this.setAttribute("position", new $a42f1354f0348298$var$ep(t, 3));
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
}
function $a42f1354f0348298$var$AA(e, t, i) {
    const n = `${e.x},${e.y},${e.z}-${t.x},${t.y},${t.z}`, a = `${t.x},${t.y},${t.z}-${e.x},${e.y},${e.z}`;
    return !0 !== i.has(n) && !0 !== i.has(a) && (i.add(n), i.add(a), !0);
}
function $a42f1354f0348298$var$mA(e) {
    const t = {};
    for(const i in e){
        t[i] = {};
        for(const n in e[i]){
            const a = e[i][n];
            if ($a42f1354f0348298$var$fA(a)) a.isRenderTargetTexture ? ($a42f1354f0348298$var$Wd("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[i][n] = null) : t[i][n] = a.clone();
            else if (Array.isArray(a)) {
                if ($a42f1354f0348298$var$fA(a[0])) {
                    const e = [];
                    for(let t = 0, i = a.length; t < i; t++)e[t] = a[t].clone();
                    t[i][n] = e;
                } else t[i][n] = a.slice();
            } else t[i][n] = a;
        }
    }
    return t;
}
function $a42f1354f0348298$var$gA(e) {
    const t = {};
    for(let i = 0; i < e.length; i++){
        const n = $a42f1354f0348298$var$mA(e[i]);
        for(const e in n)t[e] = n[e];
    }
    return t;
}
function $a42f1354f0348298$var$fA(e) {
    return e && (e.isColor || e.isMatrix3 || e.isMatrix4 || e.isVector2 || e.isVector3 || e.isVector4 || e.isTexture || e.isQuaternion);
}
function $a42f1354f0348298$var$_A(e) {
    const t = e.getRenderTarget();
    return null === t ? e.outputColorSpace : !0 === t.isXRRenderTarget ? t.texture.colorSpace : $a42f1354f0348298$var$vu.workingColorSpace;
}
const $a42f1354f0348298$var$vA = {
    clone: $a42f1354f0348298$var$mA,
    merge: $a42f1354f0348298$var$gA
};
class $a42f1354f0348298$var$EA extends $a42f1354f0348298$var$Ap {
    constructor(e){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
            clipCullDistance: !1,
            multiDraw: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv1: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== e && this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = $a42f1354f0348298$var$mA(e.uniforms), this.uniformsGroups = function(e) {
            const t = [];
            for(let i = 0; i < e.length; i++)t.push(e[i].clone());
            return t;
        }(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this.defaultAttributeValues = Object.assign({}, e.defaultAttributeValues), this.index0AttributeName = e.index0AttributeName, this.uniformsNeedUpdate = e.uniformsNeedUpdate, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        t.glslVersion = this.glslVersion, t.uniforms = {};
        for(const i in this.uniforms){
            const n = this.uniforms[i].value;
            n && n.isTexture ? t.uniforms[i] = {
                type: "t",
                value: n.toJSON(e).uuid
            } : n && n.isColor ? t.uniforms[i] = {
                type: "c",
                value: n.getHex()
            } : n && n.isVector2 ? t.uniforms[i] = {
                type: "v2",
                value: n.toArray()
            } : n && n.isVector3 ? t.uniforms[i] = {
                type: "v3",
                value: n.toArray()
            } : n && n.isVector4 ? t.uniforms[i] = {
                type: "v4",
                value: n.toArray()
            } : n && n.isMatrix3 ? t.uniforms[i] = {
                type: "m3",
                value: n.toArray()
            } : n && n.isMatrix4 ? t.uniforms[i] = {
                type: "m4",
                value: n.toArray()
            } : t.uniforms[i] = {
                value: n
            };
        }
        Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
        const i = {};
        for(const e in this.extensions)!0 === this.extensions[e] && (i[e] = !0);
        return Object.keys(i).length > 0 && (t.extensions = i), t;
    }
    fromJSON(e, t) {
        if (super.fromJSON(e, t), void 0 !== e.uniforms) for(const i in e.uniforms){
            const n = e.uniforms[i];
            switch(this.uniforms[i] = {}, n.type){
                case "t":
                    this.uniforms[i].value = t[n.value] || null;
                    break;
                case "c":
                    this.uniforms[i].value = (new $a42f1354f0348298$var$gh).setHex(n.value);
                    break;
                case "v2":
                    this.uniforms[i].value = (new $a42f1354f0348298$var$cu).fromArray(n.value);
                    break;
                case "v3":
                    this.uniforms[i].value = (new $a42f1354f0348298$var$uu).fromArray(n.value);
                    break;
                case "v4":
                    this.uniforms[i].value = (new $a42f1354f0348298$var$Du).fromArray(n.value);
                    break;
                case "m3":
                    this.uniforms[i].value = (new $a42f1354f0348298$var$Au).fromArray(n.value);
                    break;
                case "m4":
                    this.uniforms[i].value = (new $a42f1354f0348298$var$zu).fromArray(n.value);
                    break;
                default:
                    this.uniforms[i].value = n.value;
            }
        }
        if (void 0 !== e.defines && (this.defines = e.defines), void 0 !== e.vertexShader && (this.vertexShader = e.vertexShader), void 0 !== e.fragmentShader && (this.fragmentShader = e.fragmentShader), void 0 !== e.glslVersion && (this.glslVersion = e.glslVersion), void 0 !== e.extensions) for(const t in e.extensions)this.extensions[t] = e.extensions[t];
        return void 0 !== e.lights && (this.lights = e.lights), void 0 !== e.clipping && (this.clipping = e.clipping), this;
    }
}
class $a42f1354f0348298$var$yA extends $a42f1354f0348298$var$EA {
    constructor(e){
        super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
    }
}
class $a42f1354f0348298$var$bA extends $a42f1354f0348298$var$Ap {
    constructor(e){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
    }
}
class $a42f1354f0348298$var$kA extends $a42f1354f0348298$var$Ap {
    constructor(e){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
    }
}
const $a42f1354f0348298$var$xA = {
    enabled: !1,
    files: {},
    add: function(e, t) {
        !1 !== this.enabled && ($a42f1354f0348298$var$wA(e) || (this.files[e] = t));
    },
    get: function(e) {
        if (!1 !== this.enabled && !$a42f1354f0348298$var$wA(e)) return this.files[e];
    },
    remove: function(e) {
        delete this.files[e];
    },
    clear: function() {
        this.files = {};
    }
};
function $a42f1354f0348298$var$wA(e) {
    try {
        const t = e.slice(e.indexOf(":") + 1);
        return "blob:" === new URL(t).protocol;
    } catch (e) {
        return !1;
    }
}
class $a42f1354f0348298$var$MA {
    constructor(e, t, i){
        const n = this;
        let a, r = !1, s = 0, o = 0;
        const l = [];
        this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = i, this._abortController = null, this.itemStart = function(e) {
            o++, !1 === r && void 0 !== n.onStart && n.onStart(e, s, o), r = !0;
        }, this.itemEnd = function(e) {
            s++, void 0 !== n.onProgress && n.onProgress(e, s, o), s === o && (r = !1, void 0 !== n.onLoad && n.onLoad());
        }, this.itemError = function(e) {
            void 0 !== n.onError && n.onError(e);
        }, this.resolveURL = function(e) {
            return e = e.normalize("NFC"), a ? a(e) : e;
        }, this.setURLModifier = function(e) {
            return a = e, this;
        }, this.addHandler = function(e, t) {
            return l.push(e, t), this;
        }, this.removeHandler = function(e) {
            const t = l.indexOf(e);
            return -1 !== t && l.splice(t, 2), this;
        }, this.getHandler = function(e) {
            for(let t = 0, i = l.length; t < i; t += 2){
                const i = l[t], n = l[t + 1];
                if (i.global && (i.lastIndex = 0), i.test(e)) return n;
            }
            return null;
        }, this.abort = function() {
            return this.abortController.abort(), this._abortController = null, this;
        };
    }
    get abortController() {
        return this._abortController || (this._abortController = new AbortController), this._abortController;
    }
}
const $a42f1354f0348298$var$SA = new $a42f1354f0348298$var$MA;
let $a42f1354f0348298$var$CA = class {
    constructor(e){
        this.manager = void 0 !== e ? e : $a42f1354f0348298$var$SA, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {}, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    load() {}
    loadAsync(e, t) {
        const i = this;
        return new Promise(function(n, a) {
            i.load(e, n, t, a);
        });
    }
    parse() {}
    setCrossOrigin(e) {
        return this.crossOrigin = e, this;
    }
    setWithCredentials(e) {
        return this.withCredentials = e, this;
    }
    setPath(e) {
        return this.path = e, this;
    }
    setResourcePath(e) {
        return this.resourcePath = e, this;
    }
    setRequestHeader(e) {
        return this.requestHeader = e, this;
    }
    abort() {
        return this;
    }
};
$a42f1354f0348298$var$CA.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $a42f1354f0348298$var$TA = {};
class $a42f1354f0348298$var$DA extends Error {
    constructor(e, t){
        super(e), this.response = t;
    }
}
class $a42f1354f0348298$var$PA extends $a42f1354f0348298$var$CA {
    constructor(e){
        super(e), this.mimeType = "", this.responseType = "", this._abortController = new AbortController;
    }
    load(e, t, i, n) {
        void 0 === e && (e = ""), void 0 !== this.path && (e = this.path + e), e = this.manager.resolveURL(e);
        const a = $a42f1354f0348298$var$xA.get(`file:${e}`);
        if (void 0 !== a) return this.manager.itemStart(e), void setTimeout(()=>{
            t && t(a), this.manager.itemEnd(e);
        }, 0);
        if (void 0 !== $a42f1354f0348298$var$TA[e]) return void $a42f1354f0348298$var$TA[e].push({
            onLoad: t,
            onProgress: i,
            onError: n
        });
        $a42f1354f0348298$var$TA[e] = [], $a42f1354f0348298$var$TA[e].push({
            onLoad: t,
            onProgress: i,
            onError: n
        });
        const r = new Request(e, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin",
            signal: "function" == typeof AbortSignal.any ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        }), s = this.mimeType, o = this.responseType;
        fetch(r).then((t)=>{
            if (200 === t.status || 0 === t.status) {
                if (0 === t.status && $a42f1354f0348298$var$Wd("FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === t.body || void 0 === t.body.getReader) return t;
                const i = $a42f1354f0348298$var$TA[e], n = t.body.getReader(), a = t.headers.get("X-File-Size") || t.headers.get("Content-Length"), r = a ? parseInt(a) : 0, s = 0 !== r;
                let o = 0;
                const l = new ReadableStream({
                    start (e) {
                        !function t() {
                            n.read().then(({ done: n, value: a })=>{
                                if (n) e.close();
                                else {
                                    o += a.byteLength;
                                    const n = new ProgressEvent("progress", {
                                        lengthComputable: s,
                                        loaded: o,
                                        total: r
                                    });
                                    for(let e = 0, t = i.length; e < t; e++){
                                        const t = i[e];
                                        t.onProgress && t.onProgress(n);
                                    }
                                    e.enqueue(a), t();
                                }
                            }, (t)=>{
                                e.error(t);
                            });
                        }();
                    }
                });
                return new Response(l);
            }
            throw new $a42f1354f0348298$var$DA(`fetch for "${t.url}" responded with ${t.status}: ${t.statusText}`, t);
        }).then((e)=>{
            switch(o){
                case "arraybuffer":
                    return e.arrayBuffer();
                case "blob":
                    return e.blob();
                case "document":
                    return e.text().then((e)=>(new DOMParser).parseFromString(e, s));
                case "json":
                    return e.json();
                default:
                    if ("" === s) return e.text();
                    {
                        const t = /charset="?([^;"\s]*)"?/i.exec(s), i = t && t[1] ? t[1].toLowerCase() : void 0, n = new TextDecoder(i);
                        return e.arrayBuffer().then((e)=>n.decode(e));
                    }
            }
        }).then((t)=>{
            $a42f1354f0348298$var$xA.add(`file:${e}`, t);
            const i = $a42f1354f0348298$var$TA[e];
            delete $a42f1354f0348298$var$TA[e];
            for(let e = 0, n = i.length; e < n; e++){
                const n = i[e];
                n.onLoad && n.onLoad(t);
            }
        }).catch((t)=>{
            const i = $a42f1354f0348298$var$TA[e];
            if (void 0 === i) throw this.manager.itemError(e), t;
            delete $a42f1354f0348298$var$TA[e];
            for(let e = 0, n = i.length; e < n; e++){
                const n = i[e];
                n.onError && n.onError(t);
            }
            this.manager.itemError(e);
        }).finally(()=>{
            this.manager.itemEnd(e);
        }), this.manager.itemStart(e);
    }
    setResponseType(e) {
        return this.responseType = e, this;
    }
    setMimeType(e) {
        return this.mimeType = e, this;
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
}
const $a42f1354f0348298$var$IA = new WeakMap;
class $a42f1354f0348298$var$LA extends $a42f1354f0348298$var$CA {
    constructor(e){
        super(e);
    }
    load(e, t, i, n) {
        void 0 !== this.path && (e = this.path + e), e = this.manager.resolveURL(e);
        const a = this, r = $a42f1354f0348298$var$xA.get(`image:${e}`);
        if (void 0 !== r) {
            if (!0 === r.complete) a.manager.itemStart(e), setTimeout(function() {
                t && t(r), a.manager.itemEnd(e);
            }, 0);
            else {
                let e = $a42f1354f0348298$var$IA.get(r);
                void 0 === e && (e = [], $a42f1354f0348298$var$IA.set(r, e)), e.push({
                    onLoad: t,
                    onError: n
                });
            }
            return r;
        }
        const s = $a42f1354f0348298$var$Gd("img");
        function o() {
            c(), t && t(this);
            const i = $a42f1354f0348298$var$IA.get(this) || [];
            for(let e = 0; e < i.length; e++){
                const t = i[e];
                t.onLoad && t.onLoad(this);
            }
            $a42f1354f0348298$var$IA.delete(this), a.manager.itemEnd(e);
        }
        function l(t) {
            c(), n && n(t), $a42f1354f0348298$var$xA.remove(`image:${e}`);
            const i = $a42f1354f0348298$var$IA.get(this) || [];
            for(let e = 0; e < i.length; e++){
                const n = i[e];
                n.onError && n.onError(t);
            }
            $a42f1354f0348298$var$IA.delete(this), a.manager.itemError(e), a.manager.itemEnd(e);
        }
        function c() {
            s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
        }
        return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== e.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), $a42f1354f0348298$var$xA.add(`image:${e}`, s), a.manager.itemStart(e), s.src = e, s;
    }
}
const $a42f1354f0348298$var$RA = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$zA = new $a42f1354f0348298$var$du, $a42f1354f0348298$var$FA = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$UA extends $a42f1354f0348298$var$lh {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new $a42f1354f0348298$var$zu, this.projectionMatrix = new $a42f1354f0348298$var$zu, this.projectionMatrixInverse = new $a42f1354f0348298$var$zu, this.coordinateSystem = $a42f1354f0348298$var$Od, this._reversedDepth = !1;
    }
    get reversedDepth() {
        return this._reversedDepth;
    }
    copy(e, t) {
        return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
    }
    getWorldDirection(e) {
        return super.getWorldDirection(e).negate();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorld.decompose($a42f1354f0348298$var$RA, $a42f1354f0348298$var$zA, $a42f1354f0348298$var$FA), 1 === $a42f1354f0348298$var$FA.x && 1 === $a42f1354f0348298$var$FA.y && 1 === $a42f1354f0348298$var$FA.z ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose($a42f1354f0348298$var$RA, $a42f1354f0348298$var$zA, $a42f1354f0348298$var$FA.set(1, 1, 1)).invert();
    }
    updateWorldMatrix(e, t, i = !1) {
        super.updateWorldMatrix(e, t, i), this.matrixWorld.decompose($a42f1354f0348298$var$RA, $a42f1354f0348298$var$zA, $a42f1354f0348298$var$FA), 1 === $a42f1354f0348298$var$FA.x && 1 === $a42f1354f0348298$var$FA.y && 1 === $a42f1354f0348298$var$FA.z ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose($a42f1354f0348298$var$RA, $a42f1354f0348298$var$zA, $a42f1354f0348298$var$FA.set(1, 1, 1)).invert();
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $a42f1354f0348298$var$NA = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$BA = new $a42f1354f0348298$var$cu, $a42f1354f0348298$var$OA = new $a42f1354f0348298$var$cu;
class $a42f1354f0348298$var$jA extends $a42f1354f0348298$var$UA {
    constructor(e = 50, t = 1, i = .1, n = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = i, this.far = n, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(e, t) {
        return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = null === e.view ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
    }
    setFocalLength(e) {
        const t = .5 * this.getFilmHeight() / e;
        this.fov = 2 * $a42f1354f0348298$var$tu * Math.atan(t), this.updateProjectionMatrix();
    }
    getFocalLength() {
        const e = Math.tan(.5 * $a42f1354f0348298$var$eu * this.fov);
        return .5 * this.getFilmHeight() / e;
    }
    getEffectiveFOV() {
        return 2 * $a42f1354f0348298$var$tu * Math.atan(Math.tan(.5 * $a42f1354f0348298$var$eu * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    getViewBounds(e, t, i) {
        $a42f1354f0348298$var$NA.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), t.set($a42f1354f0348298$var$NA.x, $a42f1354f0348298$var$NA.y).multiplyScalar(-e / $a42f1354f0348298$var$NA.z), $a42f1354f0348298$var$NA.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), i.set($a42f1354f0348298$var$NA.x, $a42f1354f0348298$var$NA.y).multiplyScalar(-e / $a42f1354f0348298$var$NA.z);
    }
    getViewSize(e, t) {
        return this.getViewBounds(e, $a42f1354f0348298$var$BA, $a42f1354f0348298$var$OA), t.subVectors($a42f1354f0348298$var$OA, $a42f1354f0348298$var$BA);
    }
    setViewOffset(e, t, i, n, a, r) {
        this.aspect = e / t, null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = a, this.view.height = r, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const e = this.near;
        let t = e * Math.tan(.5 * $a42f1354f0348298$var$eu * this.fov) / this.zoom, i = 2 * t, n = this.aspect * i, a = -0.5 * n;
        const r = this.view;
        if (null !== this.view && this.view.enabled) {
            const e = r.fullWidth, s = r.fullHeight;
            a += r.offsetX * n / e, t -= r.offsetY * i / s, n *= r.width / e, i *= r.height / s;
        }
        const s = this.filmOffset;
        0 !== s && (a += e * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(a, a + n, t, t - i, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, null !== this.view && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
    }
}
class $a42f1354f0348298$var$GA extends $a42f1354f0348298$var$UA {
    constructor(e = -1, t = 1, i = 1, n = -1, a = .1, r = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = i, this.bottom = n, this.near = a, this.far = r, this.updateProjectionMatrix();
    }
    copy(e, t) {
        return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = null === e.view ? null : Object.assign({}, e.view), this;
    }
    setViewOffset(e, t, i, n, a, r) {
        null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = a, this.view.height = r, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
        let a = i - e, r = i + e, s = n + t, o = n - t;
        if (null !== this.view && this.view.enabled) {
            const e = (this.right - this.left) / this.view.fullWidth / this.zoom, t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            a += e * this.view.offsetX, r = a + e * this.view.width, s -= t * this.view.offsetY, o = s - t * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(a, r, s, o, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, null !== this.view && (t.object.view = Object.assign({}, this.view)), t;
    }
}
const $a42f1354f0348298$var$VA = -90;
class $a42f1354f0348298$var$HA extends $a42f1354f0348298$var$lh {
    constructor(e, t, i){
        super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
        const n = new $a42f1354f0348298$var$jA($a42f1354f0348298$var$VA, 1, e, t);
        n.layers = this.layers, this.add(n);
        const a = new $a42f1354f0348298$var$jA($a42f1354f0348298$var$VA, 1, e, t);
        a.layers = this.layers, this.add(a);
        const r = new $a42f1354f0348298$var$jA($a42f1354f0348298$var$VA, 1, e, t);
        r.layers = this.layers, this.add(r);
        const s = new $a42f1354f0348298$var$jA($a42f1354f0348298$var$VA, 1, e, t);
        s.layers = this.layers, this.add(s);
        const o = new $a42f1354f0348298$var$jA($a42f1354f0348298$var$VA, 1, e, t);
        o.layers = this.layers, this.add(o);
        const l = new $a42f1354f0348298$var$jA($a42f1354f0348298$var$VA, 1, e, t);
        l.layers = this.layers, this.add(l);
    }
    updateCoordinateSystem() {
        const e = this.coordinateSystem, t = this.children.concat(), [i, n, a, r, s, o] = t;
        for (const e of t)this.remove(e);
        if (e === $a42f1354f0348298$var$Od) i.up.set(0, 1, 0), i.lookAt(1, 0, 0), n.up.set(0, 1, 0), n.lookAt(-1, 0, 0), a.up.set(0, 0, -1), a.lookAt(0, 1, 0), r.up.set(0, 0, 1), r.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
        else {
            if (e !== $a42f1354f0348298$var$jd) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
            i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), n.up.set(0, -1, 0), n.lookAt(1, 0, 0), a.up.set(0, 0, 1), a.lookAt(0, 1, 0), r.up.set(0, 0, -1), r.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
        }
        for (const e of t)this.add(e), e.updateMatrixWorld();
    }
    update(e, t) {
        null === this.parent && this.updateMatrixWorld();
        const { renderTarget: i, activeMipmapLevel: n } = this;
        this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
        const [a, r, s, o, l, c] = this.children, d = e.getRenderTarget(), u = e.getActiveCubeFace(), h = e.getActiveMipmapLevel(), p = e.xr.enabled;
        e.xr.enabled = !1;
        const A = i.texture.generateMipmaps;
        i.texture.generateMipmaps = !1;
        let m = !1;
        m = !0 === e.isWebGLRenderer ? e.state.buffers.depth.getReversed() : e.reversedDepthBuffer, e.setRenderTarget(i, 0, n), m && !1 === e.autoClear && e.clearDepth(), e.render(t, a), e.setRenderTarget(i, 1, n), m && !1 === e.autoClear && e.clearDepth(), e.render(t, r), e.setRenderTarget(i, 2, n), m && !1 === e.autoClear && e.clearDepth(), e.render(t, s), e.setRenderTarget(i, 3, n), m && !1 === e.autoClear && e.clearDepth(), e.render(t, o), e.setRenderTarget(i, 4, n), m && !1 === e.autoClear && e.clearDepth(), e.render(t, l), i.texture.generateMipmaps = A, e.setRenderTarget(i, 5, n), m && !1 === e.autoClear && e.clearDepth(), e.render(t, c), e.setRenderTarget(d, u, h), e.xr.enabled = p, i.texture.needsPMREMUpdate = !0;
    }
}
class $a42f1354f0348298$var$qA extends $a42f1354f0348298$var$jA {
    constructor(e = []){
        super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
    }
}
const $a42f1354f0348298$var$KA = new $a42f1354f0348298$var$zu;
class $a42f1354f0348298$var$WA {
    constructor(e, t, i = 0, n = 1 / 0){
        this.ray = new $a42f1354f0348298$var$bp(e, t), this.near = i, this.far = n, this.camera = null, this.layers = new $a42f1354f0348298$var$Ku, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(e, t) {
        this.ray.set(e, t);
    }
    setFromCamera(e, t) {
        t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e.x, e.y, .5).unproject(t).sub(this.ray.origin).normalize(), this.camera = t) : t.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, t.projectionMatrix.elements[14]).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld), this.camera = t) : $a42f1354f0348298$var$Xd("Raycaster: Unsupported camera type: " + t.type);
    }
    setFromXRController(e) {
        return $a42f1354f0348298$var$KA.identity().extractRotation(e.matrixWorld), this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4($a42f1354f0348298$var$KA), this;
    }
    intersectObject(e, t = !0, i = []) {
        return $a42f1354f0348298$var$QA(e, this, i, t), i.sort($a42f1354f0348298$var$XA), i;
    }
    intersectObjects(e, t = !0, i = []) {
        for(let n = 0, a = e.length; n < a; n++)$a42f1354f0348298$var$QA(e[n], this, i, t);
        return i.sort($a42f1354f0348298$var$XA), i;
    }
}
function $a42f1354f0348298$var$XA(e, t) {
    return e.distance - t.distance;
}
function $a42f1354f0348298$var$QA(e, t, i, n) {
    let a = !0;
    if (e.layers.test(t.layers)) !1 === e.raycast(t, i) && (a = !1);
    if (!0 === a && !0 === n) {
        const n = e.children;
        for(let e = 0, a = n.length; e < a; e++)$a42f1354f0348298$var$QA(n[e], t, i, !0);
    }
}
class $a42f1354f0348298$var$ZA {
    static{
        $a42f1354f0348298$var$ZA.prototype.isMatrix2 = !0;
    }
    constructor(e, t, i, n){
        this.elements = [
            1,
            0,
            0,
            1
        ], void 0 !== e && this.set(e, t, i, n);
    }
    identity() {
        return this.set(1, 0, 0, 1), this;
    }
    fromArray(e, t = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = e[i + t];
        return this;
    }
    set(e, t, i, n) {
        const a = this.elements;
        return a[0] = e, a[2] = t, a[1] = i, a[3] = n, this;
    }
}
function $a42f1354f0348298$var$YA(e, t, i, n) {
    const a = function(e) {
        switch(e){
            case $a42f1354f0348298$var$kc:
            case $a42f1354f0348298$var$xc:
                return {
                    byteLength: 1,
                    components: 1
                };
            case $a42f1354f0348298$var$Mc:
            case $a42f1354f0348298$var$wc:
            case $a42f1354f0348298$var$Dc:
                return {
                    byteLength: 2,
                    components: 1
                };
            case $a42f1354f0348298$var$Pc:
            case $a42f1354f0348298$var$Ic:
                return {
                    byteLength: 2,
                    components: 4
                };
            case $a42f1354f0348298$var$Cc:
            case $a42f1354f0348298$var$Sc:
            case $a42f1354f0348298$var$Tc:
                return {
                    byteLength: 4,
                    components: 1
                };
            case $a42f1354f0348298$var$Rc:
            case $a42f1354f0348298$var$zc:
                return {
                    byteLength: 4,
                    components: 3
                };
        }
        throw new Error(`THREE.TextureUtils: Unknown texture type ${e}.`);
    }(n);
    switch(i){
        case 1021:
            return e * t;
        case 1028:
        case $a42f1354f0348298$var$Bc:
            return e * t / a.components * a.byteLength;
        case $a42f1354f0348298$var$Oc:
        case $a42f1354f0348298$var$jc:
            return e * t * 2 / a.components * a.byteLength;
        case 1022:
            return e * t * 3 / a.components * a.byteLength;
        case $a42f1354f0348298$var$Fc:
        case $a42f1354f0348298$var$Gc:
            return e * t * 4 / a.components * a.byteLength;
        case $a42f1354f0348298$var$Vc:
        case $a42f1354f0348298$var$Hc:
            return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
        case $a42f1354f0348298$var$qc:
        case $a42f1354f0348298$var$Kc:
            return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
        case $a42f1354f0348298$var$Xc:
        case $a42f1354f0348298$var$Zc:
            return Math.max(e, 16) * Math.max(t, 8) / 4;
        case $a42f1354f0348298$var$Wc:
        case $a42f1354f0348298$var$Qc:
            return Math.max(e, 8) * Math.max(t, 8) / 2;
        case $a42f1354f0348298$var$Yc:
        case $a42f1354f0348298$var$Jc:
        case $a42f1354f0348298$var$ed:
        case $a42f1354f0348298$var$td:
            return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
        case $a42f1354f0348298$var$$c:
        case $a42f1354f0348298$var$id:
        case $a42f1354f0348298$var$nd:
        case $a42f1354f0348298$var$ad:
            return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
        case $a42f1354f0348298$var$rd:
            return Math.floor((e + 4) / 5) * Math.floor((t + 3) / 4) * 16;
        case $a42f1354f0348298$var$sd:
            return Math.floor((e + 4) / 5) * Math.floor((t + 4) / 5) * 16;
        case $a42f1354f0348298$var$od:
            return Math.floor((e + 5) / 6) * Math.floor((t + 4) / 5) * 16;
        case $a42f1354f0348298$var$ld:
            return Math.floor((e + 5) / 6) * Math.floor((t + 5) / 6) * 16;
        case $a42f1354f0348298$var$cd:
            return Math.floor((e + 7) / 8) * Math.floor((t + 4) / 5) * 16;
        case $a42f1354f0348298$var$dd:
            return Math.floor((e + 7) / 8) * Math.floor((t + 5) / 6) * 16;
        case $a42f1354f0348298$var$ud:
            return Math.floor((e + 7) / 8) * Math.floor((t + 7) / 8) * 16;
        case $a42f1354f0348298$var$hd:
            return Math.floor((e + 9) / 10) * Math.floor((t + 4) / 5) * 16;
        case $a42f1354f0348298$var$pd:
            return Math.floor((e + 9) / 10) * Math.floor((t + 5) / 6) * 16;
        case $a42f1354f0348298$var$Ad:
            return Math.floor((e + 9) / 10) * Math.floor((t + 7) / 8) * 16;
        case $a42f1354f0348298$var$md:
            return Math.floor((e + 9) / 10) * Math.floor((t + 9) / 10) * 16;
        case $a42f1354f0348298$var$gd:
            return Math.floor((e + 11) / 12) * Math.floor((t + 9) / 10) * 16;
        case $a42f1354f0348298$var$fd:
            return Math.floor((e + 11) / 12) * Math.floor((t + 11) / 12) * 16;
        case $a42f1354f0348298$var$_d:
        case $a42f1354f0348298$var$vd:
        case $a42f1354f0348298$var$Ed:
            return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
        case $a42f1354f0348298$var$yd:
        case $a42f1354f0348298$var$bd:
            return Math.ceil(e / 4) * Math.ceil(t / 4) * 8;
        case $a42f1354f0348298$var$kd:
        case $a42f1354f0348298$var$xd:
            return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${i} format.`);
}
/**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ function $a42f1354f0348298$var$JA() {
    let e = null, t = !1, i = null, n = null;
    function a(t, r) {
        i(t, r), n = e.requestAnimationFrame(a);
    }
    return {
        start: function() {
            !0 !== t && null !== i && null !== e && (n = e.requestAnimationFrame(a), t = !0);
        },
        stop: function() {
            null !== e && e.cancelAnimationFrame(n), t = !1;
        },
        setAnimationLoop: function(e) {
            i = e;
        },
        setContext: function(t) {
            e = t;
        }
    };
}
function $a42f1354f0348298$var$$A(e) {
    const t = new WeakMap;
    return {
        get: function(e) {
            return e.isInterleavedBufferAttribute && (e = e.data), t.get(e);
        },
        remove: function(i) {
            i.isInterleavedBufferAttribute && (i = i.data);
            const n = t.get(i);
            n && (e.deleteBuffer(n.buffer), t.delete(i));
        },
        update: function(i, n) {
            if (i.isInterleavedBufferAttribute && (i = i.data), i.isGLBufferAttribute) {
                const e = t.get(i);
                return void ((!e || e.version < i.version) && t.set(i, {
                    buffer: i.buffer,
                    type: i.type,
                    bytesPerElement: i.elementSize,
                    version: i.version
                }));
            }
            const a = t.get(i);
            if (void 0 === a) t.set(i, function(t, i) {
                const n = t.array, a = t.usage, r = n.byteLength, s = e.createBuffer();
                let o;
                if (e.bindBuffer(i, s), e.bufferData(i, n, a), t.onUploadCallback(), n instanceof Float32Array) o = e.FLOAT;
                else if ("undefined" != typeof Float16Array && n instanceof Float16Array) o = e.HALF_FLOAT;
                else if (n instanceof Uint16Array) o = t.isFloat16BufferAttribute ? e.HALF_FLOAT : e.UNSIGNED_SHORT;
                else if (n instanceof Int16Array) o = e.SHORT;
                else if (n instanceof Uint32Array) o = e.UNSIGNED_INT;
                else if (n instanceof Int32Array) o = e.INT;
                else if (n instanceof Int8Array) o = e.BYTE;
                else if (n instanceof Uint8Array) o = e.UNSIGNED_BYTE;
                else {
                    if (!(n instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + n);
                    o = e.UNSIGNED_BYTE;
                }
                return {
                    buffer: s,
                    type: o,
                    bytesPerElement: n.BYTES_PER_ELEMENT,
                    version: t.version,
                    size: r
                };
            }(i, n));
            else if (a.version < i.version) {
                if (a.size !== i.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
                !function(t, i, n) {
                    const a = i.array, r = i.updateRanges;
                    if (e.bindBuffer(n, t), 0 === r.length) e.bufferSubData(n, 0, a);
                    else {
                        r.sort((e, t)=>e.start - t.start);
                        let t = 0;
                        for(let e = 1; e < r.length; e++){
                            const i = r[t], n = r[e];
                            n.start <= i.start + i.count + 1 ? i.count = Math.max(i.count, n.start + n.count - i.start) : (++t, r[t] = n);
                        }
                        r.length = t + 1;
                        for(let t = 0, i = r.length; t < i; t++){
                            const i = r[t];
                            e.bufferSubData(n, i.start * a.BYTES_PER_ELEMENT, a, i.start, i.count);
                        }
                        i.clearUpdateRanges();
                    }
                    i.onUploadCallback();
                }(a.buffer, i, n), a.version = i.version;
            }
        }
    };
}
"undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $a42f1354f0348298$var$yl
    }
})), "undefined" != typeof window && (window.__THREE__ ? $a42f1354f0348298$var$Wd("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = $a42f1354f0348298$var$yl);
const $a42f1354f0348298$var$em = {
    alphahash_fragment: "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
    alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif",
    alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    alphatest_fragment: "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif",
    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
    aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
    aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
    batching_pars_vertex: "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec4 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 );\n\t}\n#endif",
    batching_vertex: "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
    begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif",
    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
    bsdfs: "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated",
    iridescence_fragment: "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif",
    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif",
    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
    color_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#endif",
    color_pars_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#endif",
    color_pars_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec4 vColor;\n#endif",
    color_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec4( 1.0 );\n#endif\n#ifdef USE_COLOR_ALPHA\n\tvColor *= color;\n#elif defined( USE_COLOR )\n\tvColor.rgb *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.rgb *= instanceColor.rgb;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );\n#endif",
    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\n#define inverseTransformDirection transformDirectionByInverseViewMatrix\nvec3 transformNormalByInverseViewMatrix( in vec3 normal, in mat4 viewMatrix ) {\n\treturn normalize( ( vec4( normal, 0.0 ) * viewMatrix ).xyz );\n}\nvec3 transformDirectionByInverseViewMatrix( in vec3 dir, in mat4 viewMatrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * viewMatrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n#endif",
    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
    colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
    colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
    envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * reflectVec );\n\t\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t\t#endif\n\t#endif\n#endif",
    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif",
    envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
    envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
    envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = transformDirectionByInverseViewMatrix( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif",
    envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
    fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
    fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
    fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
    fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}",
    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
    lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
    lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert",
    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif\n#include <lightprobes_pars_fragment>",
    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon",
    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong",
    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = vec3( 0.04 );\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
    lights_physical_pars_fragment: "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tvec3 diffuseContribution;\n\tvec3 specularColor;\n\tvec3 specularColorBlended;\n\tfloat roughness;\n\tfloat metalness;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t\tvec3 iridescenceFresnelDielectric;\n\t\tvec3 iridescenceFresnelMetallic;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\treturn 0.5 / max( gv + gl, EPSILON );\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColorBlended;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat rInv = 1.0 / ( roughness + 0.1 );\n\tfloat a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n\tfloat b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n\tfloat DG = exp( a * dotNV + b );\n\treturn saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n\tvec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n\tvec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t\t#ifdef USE_CLEARCOAT\n\t\t\tvec3 Ncc = geometryClearcoatNormal;\n\t\t\tvec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );\n\t\t\tvec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );\n\t\t\tvec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );\n\t\t\tmat3 mInvClearcoat = mat3(\n\t\t\t\tvec3( t1Clearcoat.x, 0, t1Clearcoat.y ),\n\t\t\t\tvec3(             0, 1,             0 ),\n\t\t\t\tvec3( t1Clearcoat.z, 0, t1Clearcoat.w )\n\t\t\t);\n\t\t\tvec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;\n\t\t\tclearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );\n\t\t#endif\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n \n \t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n \t\tfloat sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n \t\tfloat sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n \t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n \t\tirradiance *= sheenEnergyComp;\n \n \t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tdiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n \t#endif\n\tvec3 singleScatteringDielectric = vec3( 0.0 );\n\tvec3 multiScatteringDielectric = vec3( 0.0 );\n\tvec3 singleScatteringMetallic = vec3( 0.0 );\n\tvec3 multiScatteringMetallic = vec3( 0.0 );\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#endif\n\tvec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n\tvec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n\tvec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n\tvec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tvec3 indirectSpecular = radiance * singleScattering;\n\tindirectSpecular += multiScattering * cosineWeightedIrradiance;\n\tvec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tindirectSpecular *= sheenEnergyComp;\n\t\tindirectDiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectSpecular += indirectSpecular;\n\treflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
    lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n\t\tmaterial.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#ifdef USE_LIGHT_PROBES_GRID\n\t\tvec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;\n\t\tvec3 probeWorldNormal = transformNormalByInverseViewMatrix( geometryNormal, viewMatrix );\n\t\tirradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\t#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )\n\t\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t\t#endif\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\t#if defined( LAMBERT ) || defined( PHONG )\n\t\tirradiance += iblIrradiance;\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
    lightprobes_pars_fragment: "#ifdef USE_LIGHT_PROBES_GRID\nuniform highp sampler3D probesSH;\nuniform vec3 probesMin;\nuniform vec3 probesMax;\nuniform vec3 probesResolution;\nvec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {\n\tvec3 res = probesResolution;\n\tvec3 gridRange = probesMax - probesMin;\n\tvec3 resMinusOne = res - 1.0;\n\tvec3 probeSpacing = gridRange / resMinusOne;\n\tvec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;\n\tvec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );\n\tuvw = uvw * resMinusOne / res + 0.5 / res;\n\tfloat nz          = res.z;\n\tfloat paddedSlices = nz + 2.0;\n\tfloat atlasDepth  = 7.0 * paddedSlices;\n\tfloat uvZBase     = uvw.z * nz + 1.0;\n\tvec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );\n\tvec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );\n\tvec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );\n\tvec3 c0 = s0.xyz;\n\tvec3 c1 = vec3( s0.w, s1.xy );\n\tvec3 c2 = vec3( s1.zw, s2.x );\n\tvec3 c3 = s2.yzw;\n\tvec3 c4 = s3.xyz;\n\tvec3 c5 = vec3( s3.w, s4.xy );\n\tvec3 c6 = vec3( s4.zw, s5.x );\n\tvec3 c7 = s5.yzw;\n\tvec3 c8 = s6.xyz;\n\tfloat x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;\n\tvec3 result = c0 * 0.886227;\n\tresult += c1 * 2.0 * 0.511664 * y;\n\tresult += c2 * 2.0 * 0.511664 * z;\n\tresult += c3 * 2.0 * 0.511664 * x;\n\tresult += c4 * 2.0 * 0.429043 * x * y;\n\tresult += c5 * 2.0 * 0.429043 * y * z;\n\tresult += c6 * ( 0.743125 * z * z - 0.247708 );\n\tresult += c7 * 2.0 * 0.429043 * x * z;\n\tresult += c8 * 0.429043 * ( x * x - y * y );\n\treturn max( result, vec3( 0.0 ) );\n}\n#endif",
    logdepthbuf_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
    logdepthbuf_pars_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_pars_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
    map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
    map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
    map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
    morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif",
    morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif",
    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
    normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#if defined( USE_PACKED_NORMALMAP )\n\t\tmapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );\n\t#endif\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
    normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t\t#ifdef FLIP_SIDED\n\t\t\tvBitangent = - vBitangent;\n\t\t#endif\n\t#endif\n#endif",
    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif",
    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif",
    iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif",
    opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\n\t\treturn depth * ( far - near ) - far;\n\t#else\n\t\treturn depth * ( near - far ) - near;\n\t#endif\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\treturn ( near * far ) / ( ( near - far ) * depth - near );\n\t#else\n\t\treturn ( near * far ) / ( ( far - near ) * depth - far );\n\t#endif\n}",
    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
    dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
    dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
    shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\t\t\tuniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat interleavedGradientNoise( vec2 position ) {\n\t\t\treturn fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n\t\t}\n\t\tvec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n\t\t\tconst float goldenAngle = 2.399963229728653;\n\t\t\tfloat r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n\t\t\tfloat theta = float( sampleIndex ) * goldenAngle + phi;\n\t\t\treturn vec2( cos( theta ), sin( theta ) ) * r;\n\t\t}\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\t\tfloat radius = shadowRadius * texelSize.x;\n\t\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n\t\t\t\t) * 0.2;\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n\t\t\t\tfloat mean = distribution.x;\n\t\t\t\tfloat variance = distribution.y * distribution.y;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tfloat hard_shadow = step( mean, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tfloat hard_shadow = step( shadowCoord.z, mean );\n\t\t\t\t#endif\n\t\t\t\t\n\t\t\t\tif ( hard_shadow == 1.0 ) {\n\t\t\t\t\tshadow = 1.0;\n\t\t\t\t} else {\n\t\t\t\t\tvariance = max( variance, 0.0000001 );\n\t\t\t\t\tfloat d = shadowCoord.z - mean;\n\t\t\t\t\tfloat p_max = variance / ( variance + d * d );\n\t\t\t\t\tp_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n\t\t\t\t\tshadow = max( hard_shadow, p_max );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#else\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tfloat depth = texture2D( shadowMap, shadowCoord.xy ).r;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tshadow = step( depth, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tshadow = step( shadowCoord.z, depth );\n\t\t\t\t#endif\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\tfloat getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tfloat dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp -= shadowBias;\n\t\t\t#else\n\t\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp += shadowBias;\n\t\t\t#endif\n\t\t\tfloat texelSize = shadowRadius / shadowMapSize.x;\n\t\t\tvec3 absDir = abs( bd3D );\n\t\t\tvec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n\t\t\ttangent = normalize( cross( bd3D, tangent ) );\n\t\t\tvec3 bitangent = cross( bd3D, tangent );\n\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\tvec2 sample0 = vogelDiskSample( 0, 5, phi );\n\t\t\tvec2 sample1 = vogelDiskSample( 1, 5, phi );\n\t\t\tvec2 sample2 = vogelDiskSample( 2, 5, phi );\n\t\t\tvec2 sample3 = vogelDiskSample( 3, 5, phi );\n\t\t\tvec2 sample4 = vogelDiskSample( 4, 5, phi );\n\t\t\tshadow = (\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )\n\t\t\t) * 0.2;\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\tfloat getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tfloat depth = textureCube( shadowMap, bd3D ).r;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tdepth = 1.0 - depth;\n\t\t\t#endif\n\t\t\tshadow = step( dp, depth );\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#endif\n\t#endif\n#endif",
    shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
    shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\t#ifdef HAS_NORMAL\n\t\tvec3 shadowWorldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n\t#else\n\t\tvec3 shadowWorldNormal = vec3( 0.0 );\n\t#endif\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif",
    shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
    skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
    skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif",
    skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
    skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
    tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
    transmission_fragment: "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif",
    uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
    uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
    uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
    background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
    depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}",
    distance_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
    distance_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}",
    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n \n\t\toutgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n \t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}"
}, $a42f1354f0348298$var$tm = {
    common: {
        diffuse: {
            value: new $a42f1354f0348298$var$gh(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: new $a42f1354f0348298$var$Au
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        },
        dfgLUT: {
            value: null
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        normalScale: {
            value: new $a42f1354f0348298$var$cu(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new $a42f1354f0348298$var$gh(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        },
        probesSH: {
            value: null
        },
        probesMin: {
            value: new $a42f1354f0348298$var$uu
        },
        probesMax: {
            value: new $a42f1354f0348298$var$uu
        },
        probesResolution: {
            value: new $a42f1354f0348298$var$uu
        }
    },
    points: {
        diffuse: {
            value: new $a42f1354f0348298$var$gh(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $a42f1354f0348298$var$Au
        }
    },
    sprite: {
        diffuse: {
            value: new $a42f1354f0348298$var$gh(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new $a42f1354f0348298$var$cu(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $a42f1354f0348298$var$Au
        },
        alphaTest: {
            value: 0
        }
    }
}, $a42f1354f0348298$var$im = {
    basic: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.specularmap,
            $a42f1354f0348298$var$tm.envmap,
            $a42f1354f0348298$var$tm.aomap,
            $a42f1354f0348298$var$tm.lightmap,
            $a42f1354f0348298$var$tm.fog
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshbasic_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshbasic_frag
    },
    lambert: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.specularmap,
            $a42f1354f0348298$var$tm.envmap,
            $a42f1354f0348298$var$tm.aomap,
            $a42f1354f0348298$var$tm.lightmap,
            $a42f1354f0348298$var$tm.emissivemap,
            $a42f1354f0348298$var$tm.bumpmap,
            $a42f1354f0348298$var$tm.normalmap,
            $a42f1354f0348298$var$tm.displacementmap,
            $a42f1354f0348298$var$tm.fog,
            $a42f1354f0348298$var$tm.lights,
            {
                emissive: {
                    value: new $a42f1354f0348298$var$gh(0)
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshlambert_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshlambert_frag
    },
    phong: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.specularmap,
            $a42f1354f0348298$var$tm.envmap,
            $a42f1354f0348298$var$tm.aomap,
            $a42f1354f0348298$var$tm.lightmap,
            $a42f1354f0348298$var$tm.emissivemap,
            $a42f1354f0348298$var$tm.bumpmap,
            $a42f1354f0348298$var$tm.normalmap,
            $a42f1354f0348298$var$tm.displacementmap,
            $a42f1354f0348298$var$tm.fog,
            $a42f1354f0348298$var$tm.lights,
            {
                emissive: {
                    value: new $a42f1354f0348298$var$gh(0)
                },
                specular: {
                    value: new $a42f1354f0348298$var$gh(1118481)
                },
                shininess: {
                    value: 30
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshphong_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshphong_frag
    },
    standard: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.envmap,
            $a42f1354f0348298$var$tm.aomap,
            $a42f1354f0348298$var$tm.lightmap,
            $a42f1354f0348298$var$tm.emissivemap,
            $a42f1354f0348298$var$tm.bumpmap,
            $a42f1354f0348298$var$tm.normalmap,
            $a42f1354f0348298$var$tm.displacementmap,
            $a42f1354f0348298$var$tm.roughnessmap,
            $a42f1354f0348298$var$tm.metalnessmap,
            $a42f1354f0348298$var$tm.fog,
            $a42f1354f0348298$var$tm.lights,
            {
                emissive: {
                    value: new $a42f1354f0348298$var$gh(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshphysical_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshphysical_frag
    },
    toon: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.aomap,
            $a42f1354f0348298$var$tm.lightmap,
            $a42f1354f0348298$var$tm.emissivemap,
            $a42f1354f0348298$var$tm.bumpmap,
            $a42f1354f0348298$var$tm.normalmap,
            $a42f1354f0348298$var$tm.displacementmap,
            $a42f1354f0348298$var$tm.gradientmap,
            $a42f1354f0348298$var$tm.fog,
            $a42f1354f0348298$var$tm.lights,
            {
                emissive: {
                    value: new $a42f1354f0348298$var$gh(0)
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshtoon_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshtoon_frag
    },
    matcap: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.bumpmap,
            $a42f1354f0348298$var$tm.normalmap,
            $a42f1354f0348298$var$tm.displacementmap,
            $a42f1354f0348298$var$tm.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshmatcap_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshmatcap_frag
    },
    points: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.points,
            $a42f1354f0348298$var$tm.fog
        ]),
        vertexShader: $a42f1354f0348298$var$em.points_vert,
        fragmentShader: $a42f1354f0348298$var$em.points_frag
    },
    dashed: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.linedashed_vert,
        fragmentShader: $a42f1354f0348298$var$em.linedashed_frag
    },
    depth: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.displacementmap
        ]),
        vertexShader: $a42f1354f0348298$var$em.depth_vert,
        fragmentShader: $a42f1354f0348298$var$em.depth_frag
    },
    normal: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.bumpmap,
            $a42f1354f0348298$var$tm.normalmap,
            $a42f1354f0348298$var$tm.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.meshnormal_vert,
        fragmentShader: $a42f1354f0348298$var$em.meshnormal_frag
    },
    sprite: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.sprite,
            $a42f1354f0348298$var$tm.fog
        ]),
        vertexShader: $a42f1354f0348298$var$em.sprite_vert,
        fragmentShader: $a42f1354f0348298$var$em.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $a42f1354f0348298$var$em.background_vert,
        fragmentShader: $a42f1354f0348298$var$em.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: new $a42f1354f0348298$var$Au
            }
        },
        vertexShader: $a42f1354f0348298$var$em.backgroundCube_vert,
        fragmentShader: $a42f1354f0348298$var$em.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: $a42f1354f0348298$var$em.cube_vert,
        fragmentShader: $a42f1354f0348298$var$em.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $a42f1354f0348298$var$em.equirect_vert,
        fragmentShader: $a42f1354f0348298$var$em.equirect_frag
    },
    distance: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.common,
            $a42f1354f0348298$var$tm.displacementmap,
            {
                referencePosition: {
                    value: new $a42f1354f0348298$var$uu
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.distance_vert,
        fragmentShader: $a42f1354f0348298$var$em.distance_frag
    },
    shadow: {
        uniforms: $a42f1354f0348298$var$gA([
            $a42f1354f0348298$var$tm.lights,
            $a42f1354f0348298$var$tm.fog,
            {
                color: {
                    value: new $a42f1354f0348298$var$gh(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $a42f1354f0348298$var$em.shadow_vert,
        fragmentShader: $a42f1354f0348298$var$em.shadow_frag
    }
};
$a42f1354f0348298$var$im.physical = {
    uniforms: $a42f1354f0348298$var$gA([
        $a42f1354f0348298$var$im.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            clearcoatNormalScale: {
                value: new $a42f1354f0348298$var$cu(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new $a42f1354f0348298$var$gh(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            transmissionSamplerSize: {
                value: new $a42f1354f0348298$var$cu
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $a42f1354f0348298$var$gh(0)
            },
            specularColor: {
                value: new $a42f1354f0348298$var$gh(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: new $a42f1354f0348298$var$Au
            },
            anisotropyVector: {
                value: new $a42f1354f0348298$var$cu
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: new $a42f1354f0348298$var$Au
            }
        }
    ]),
    vertexShader: $a42f1354f0348298$var$em.meshphysical_vert,
    fragmentShader: $a42f1354f0348298$var$em.meshphysical_frag
};
const $a42f1354f0348298$var$nm = {
    r: 0,
    b: 0,
    g: 0
}, $a42f1354f0348298$var$am = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$rm = new $a42f1354f0348298$var$Au;
function $a42f1354f0348298$var$sm(e, t, i, n, a, r) {
    const s = new $a42f1354f0348298$var$gh(0);
    let o, l, c = !0 === a ? 0 : 1, d = null, u = 0, h = null;
    function p(e) {
        let i = !0 === e.isScene ? e.background : null;
        if (i && i.isTexture) {
            const n = e.backgroundBlurriness > 0;
            i = t.get(i, n);
        }
        return i;
    }
    function A(t, n) {
        t.getRGB($a42f1354f0348298$var$nm, $a42f1354f0348298$var$_A(e)), i.buffers.color.setClear($a42f1354f0348298$var$nm.r, $a42f1354f0348298$var$nm.g, $a42f1354f0348298$var$nm.b, n, r);
    }
    return {
        getClearColor: function() {
            return s;
        },
        setClearColor: function(e, t = 1) {
            s.set(e), c = t, A(s, c);
        },
        getClearAlpha: function() {
            return c;
        },
        setClearAlpha: function(e) {
            c = e, A(s, c);
        },
        render: function(t) {
            let n = !1;
            const a = p(t);
            null === a ? A(s, c) : a && a.isColor && (A(a, 1), n = !0);
            const o = e.xr.getEnvironmentBlendMode();
            "additive" === o ? i.buffers.color.setClear(0, 0, 0, 1, r) : "alpha-blend" === o && i.buffers.color.setClear(0, 0, 0, 0, r), (e.autoClear || n) && (i.buffers.depth.setTest(!0), i.buffers.depth.setMask(!0), i.buffers.color.setMask(!0), e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil));
        },
        addToRenderList: function(t, i) {
            const a = p(i);
            a && (a.isCubeTexture || a.mapping === $a42f1354f0348298$var$pc) ? (void 0 === l && (l = new $a42f1354f0348298$var$zp(new $a42f1354f0348298$var$dA(1, 1, 1), new $a42f1354f0348298$var$EA({
                name: "BackgroundCubeMaterial",
                uniforms: $a42f1354f0348298$var$mA($a42f1354f0348298$var$im.backgroundCube.uniforms),
                vertexShader: $a42f1354f0348298$var$im.backgroundCube.vertexShader,
                fragmentShader: $a42f1354f0348298$var$im.backgroundCube.fragmentShader,
                side: 1,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
            })), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function(e, t, i) {
                this.matrixWorld.copyPosition(i.matrixWorld);
            }, Object.defineProperty(l.material, "envMap", {
                get: function() {
                    return this.uniforms.envMap.value;
                }
            }), n.update(l)), l.material.uniforms.envMap.value = a, l.material.uniforms.backgroundBlurriness.value = i.backgroundBlurriness, l.material.uniforms.backgroundIntensity.value = i.backgroundIntensity, l.material.uniforms.backgroundRotation.value.setFromMatrix4($a42f1354f0348298$var$am.makeRotationFromEuler(i.backgroundRotation)).transpose(), a.isCubeTexture && !1 === a.isRenderTargetTexture && l.material.uniforms.backgroundRotation.value.premultiply($a42f1354f0348298$var$rm), l.material.toneMapped = $a42f1354f0348298$var$vu.getTransfer(a.colorSpace) !== $a42f1354f0348298$var$Td, d === a && u === a.version && h === e.toneMapping || (l.material.needsUpdate = !0, d = a, u = a.version, h = e.toneMapping), l.layers.enableAll(), t.unshift(l, l.geometry, l.material, 0, 0, null)) : a && a.isTexture && (void 0 === o && (o = new $a42f1354f0348298$var$zp(new $a42f1354f0348298$var$uA(2, 2), new $a42f1354f0348298$var$EA({
                name: "BackgroundMaterial",
                uniforms: $a42f1354f0348298$var$mA($a42f1354f0348298$var$im.background.uniforms),
                vertexShader: $a42f1354f0348298$var$im.background.vertexShader,
                fragmentShader: $a42f1354f0348298$var$im.background.fragmentShader,
                side: 0,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
            })), o.geometry.deleteAttribute("normal"), Object.defineProperty(o.material, "map", {
                get: function() {
                    return this.uniforms.t2D.value;
                }
            }), n.update(o)), o.material.uniforms.t2D.value = a, o.material.uniforms.backgroundIntensity.value = i.backgroundIntensity, o.material.toneMapped = $a42f1354f0348298$var$vu.getTransfer(a.colorSpace) !== $a42f1354f0348298$var$Td, !0 === a.matrixAutoUpdate && a.updateMatrix(), o.material.uniforms.uvTransform.value.copy(a.matrix), d === a && u === a.version && h === e.toneMapping || (o.material.needsUpdate = !0, d = a, u = a.version, h = e.toneMapping), o.layers.enableAll(), t.unshift(o, o.geometry, o.material, 0, 0, null));
        },
        dispose: function() {
            void 0 !== l && (l.geometry.dispose(), l.material.dispose(), l = void 0), void 0 !== o && (o.geometry.dispose(), o.material.dispose(), o = void 0);
        }
    };
}
function $a42f1354f0348298$var$om(e, t) {
    const i = e.getParameter(e.MAX_VERTEX_ATTRIBS), n = {}, a = c(null);
    let r = a, s = !1;
    function o(t) {
        return e.bindVertexArray(t);
    }
    function l(t) {
        return e.deleteVertexArray(t);
    }
    function c(e) {
        const t = [], n = [], a = [];
        for(let e = 0; e < i; e++)t[e] = 0, n[e] = 0, a[e] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: t,
            enabledAttributes: n,
            attributeDivisors: a,
            object: e,
            attributes: {},
            index: null
        };
    }
    function d() {
        const e = r.newAttributes;
        for(let t = 0, i = e.length; t < i; t++)e[t] = 0;
    }
    function u(e) {
        h(e, 0);
    }
    function h(t, i) {
        const n = r.newAttributes, a = r.enabledAttributes, s = r.attributeDivisors;
        n[t] = 1, 0 === a[t] && (e.enableVertexAttribArray(t), a[t] = 1), s[t] !== i && (e.vertexAttribDivisor(t, i), s[t] = i);
    }
    function p() {
        const t = r.newAttributes, i = r.enabledAttributes;
        for(let n = 0, a = i.length; n < a; n++)i[n] !== t[n] && (e.disableVertexAttribArray(n), i[n] = 0);
    }
    function A(t, i, n, a, r, s, o) {
        !0 === o ? e.vertexAttribIPointer(t, i, n, r, s) : e.vertexAttribPointer(t, i, n, a, r, s);
    }
    function m() {
        g(), s = !0, r !== a && (r = a, o(r.object));
    }
    function g() {
        a.geometry = null, a.program = null, a.wireframe = !1;
    }
    return {
        setup: function(i, a, l, m, g) {
            let f = !1;
            const _ = function(t, i, a, r) {
                const s = !0 === r.wireframe;
                let o = n[i.id];
                void 0 === o && (o = {}, n[i.id] = o);
                const l = !0 === t.isInstancedMesh ? t.id : 0;
                let d = o[l];
                void 0 === d && (d = {}, o[l] = d);
                let u = d[a.id];
                void 0 === u && (u = {}, d[a.id] = u);
                let h = u[s];
                void 0 === h && (h = c(e.createVertexArray()), u[s] = h);
                return h;
            }(i, m, l, a);
            r !== _ && (r = _, o(r.object)), f = function(e, t, i, n) {
                const a = r.attributes, s = t.attributes;
                let o = 0;
                const l = i.getAttributes();
                for(const t in l)if (l[t].location >= 0) {
                    const i = a[t];
                    let n = s[t];
                    if (void 0 === n && ("instanceMatrix" === t && e.instanceMatrix && (n = e.instanceMatrix), "instanceColor" === t && e.instanceColor && (n = e.instanceColor)), void 0 === i) return !0;
                    if (i.attribute !== n) return !0;
                    if (n && i.data !== n.data) return !0;
                    o++;
                }
                return r.attributesNum !== o || r.index !== n;
            }(i, m, l, g), f && function(e, t, i, n) {
                const a = {}, s = t.attributes;
                let o = 0;
                const l = i.getAttributes();
                for(const t in l)if (l[t].location >= 0) {
                    let i = s[t];
                    void 0 === i && ("instanceMatrix" === t && e.instanceMatrix && (i = e.instanceMatrix), "instanceColor" === t && e.instanceColor && (i = e.instanceColor));
                    const n = {};
                    n.attribute = i, i && i.data && (n.data = i.data), a[t] = n, o++;
                }
                r.attributes = a, r.attributesNum = o, r.index = n;
            }(i, m, l, g), null !== g && t.update(g, e.ELEMENT_ARRAY_BUFFER), (f || s) && (s = !1, function(i, n, a, r) {
                d();
                const s = r.attributes, o = a.getAttributes(), l = n.defaultAttributeValues;
                for(const n in o){
                    const a = o[n];
                    if (a.location >= 0) {
                        let o = s[n];
                        if (void 0 === o && ("instanceMatrix" === n && i.instanceMatrix && (o = i.instanceMatrix), "instanceColor" === n && i.instanceColor && (o = i.instanceColor)), void 0 !== o) {
                            const n = o.normalized, s = o.itemSize, l = t.get(o);
                            if (void 0 === l) continue;
                            const c = l.buffer, d = l.type, p = l.bytesPerElement, m = d === e.INT || d === e.UNSIGNED_INT || o.gpuType === $a42f1354f0348298$var$Sc;
                            if (o.isInterleavedBufferAttribute) {
                                const t = o.data, l = t.stride, g = o.offset;
                                if (t.isInstancedInterleavedBuffer) {
                                    for(let e = 0; e < a.locationSize; e++)h(a.location + e, t.meshPerAttribute);
                                    !0 !== i.isInstancedMesh && void 0 === r._maxInstanceCount && (r._maxInstanceCount = t.meshPerAttribute * t.count);
                                } else for(let e = 0; e < a.locationSize; e++)u(a.location + e);
                                e.bindBuffer(e.ARRAY_BUFFER, c);
                                for(let e = 0; e < a.locationSize; e++)A(a.location + e, s / a.locationSize, d, n, l * p, (g + s / a.locationSize * e) * p, m);
                            } else {
                                if (o.isInstancedBufferAttribute) {
                                    for(let e = 0; e < a.locationSize; e++)h(a.location + e, o.meshPerAttribute);
                                    !0 !== i.isInstancedMesh && void 0 === r._maxInstanceCount && (r._maxInstanceCount = o.meshPerAttribute * o.count);
                                } else for(let e = 0; e < a.locationSize; e++)u(a.location + e);
                                e.bindBuffer(e.ARRAY_BUFFER, c);
                                for(let e = 0; e < a.locationSize; e++)A(a.location + e, s / a.locationSize, d, n, s * p, s / a.locationSize * e * p, m);
                            }
                        } else if (void 0 !== l) {
                            const t = l[n];
                            if (void 0 !== t) switch(t.length){
                                case 2:
                                    e.vertexAttrib2fv(a.location, t);
                                    break;
                                case 3:
                                    e.vertexAttrib3fv(a.location, t);
                                    break;
                                case 4:
                                    e.vertexAttrib4fv(a.location, t);
                                    break;
                                default:
                                    e.vertexAttrib1fv(a.location, t);
                            }
                        }
                    }
                }
                p();
            }(i, a, l, m), null !== g && e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t.get(g).buffer));
        },
        reset: m,
        resetDefaultState: g,
        dispose: function() {
            m();
            for(const e in n){
                const t = n[e];
                for(const e in t){
                    const i = t[e];
                    for(const e in i){
                        const t = i[e];
                        for(const e in t)l(t[e].object), delete t[e];
                        delete i[e];
                    }
                }
                delete n[e];
            }
        },
        releaseStatesOfGeometry: function(e) {
            if (void 0 === n[e.id]) return;
            const t = n[e.id];
            for(const e in t){
                const i = t[e];
                for(const e in i){
                    const t = i[e];
                    for(const e in t)l(t[e].object), delete t[e];
                    delete i[e];
                }
            }
            delete n[e.id];
        },
        releaseStatesOfObject: function(e) {
            for(const t in n){
                const i = n[t], a = !0 === e.isInstancedMesh ? e.id : 0, r = i[a];
                if (void 0 !== r) {
                    for(const e in r){
                        const t = r[e];
                        for(const e in t)l(t[e].object), delete t[e];
                        delete r[e];
                    }
                    delete i[a], 0 === Object.keys(i).length && delete n[t];
                }
            }
        },
        releaseStatesOfProgram: function(e) {
            for(const t in n){
                const i = n[t];
                for(const t in i){
                    const n = i[t];
                    if (void 0 === n[e.id]) continue;
                    const a = n[e.id];
                    for(const e in a)l(a[e].object), delete a[e];
                    delete n[e.id];
                }
            }
        },
        initAttributes: d,
        enableAttribute: u,
        disableUnusedAttributes: p
    };
}
function $a42f1354f0348298$var$lm(e, t, i) {
    let n;
    this.setMode = function(e) {
        n = e;
    }, this.render = function(t, a) {
        e.drawArrays(n, t, a), i.update(a, n, 1);
    }, this.renderInstances = function(t, a, r) {
        0 !== r && (e.drawArraysInstanced(n, t, a, r), i.update(a, n, r));
    }, this.renderMultiDraw = function(e, a, r) {
        if (0 === r) return;
        t.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, e, 0, a, 0, r);
        let s = 0;
        for(let e = 0; e < r; e++)s += a[e];
        i.update(s, n, 1);
    };
}
function $a42f1354f0348298$var$cm(e, t, i, n) {
    let a;
    function r(t) {
        if ("highp" === t) {
            if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0) return "highp";
            t = "mediump";
        }
        return "mediump" === t && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
    }
    let s = void 0 !== i.precision ? i.precision : "highp";
    const o = r(s);
    o !== s && ($a42f1354f0348298$var$Wd("WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
    const l = !0 === i.logarithmicDepthBuffer, c = !0 === i.reversedDepthBuffer && t.has("EXT_clip_control");
    !0 === i.reversedDepthBuffer && !1 === c && $a42f1354f0348298$var$Wd("WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.");
    return {
        isWebGL2: !0,
        getMaxAnisotropy: function() {
            if (void 0 !== a) return a;
            if (!0 === t.has("EXT_texture_filter_anisotropic")) {
                const i = t.get("EXT_texture_filter_anisotropic");
                a = e.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            } else a = 0;
            return a;
        },
        getMaxPrecision: r,
        textureFormatReadable: function(t) {
            return t === $a42f1354f0348298$var$Fc || n.convert(t) === e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT);
        },
        textureTypeReadable: function(i) {
            const a = i === $a42f1354f0348298$var$Dc && (t.has("EXT_color_buffer_half_float") || t.has("EXT_color_buffer_float"));
            return !(i !== $a42f1354f0348298$var$kc && n.convert(i) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE) && i !== $a42f1354f0348298$var$Tc && !a);
        },
        precision: s,
        logarithmicDepthBuffer: l,
        reversedDepthBuffer: c,
        maxTextures: e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),
        maxVertexTextures: e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        maxTextureSize: e.getParameter(e.MAX_TEXTURE_SIZE),
        maxCubemapSize: e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),
        maxAttributes: e.getParameter(e.MAX_VERTEX_ATTRIBS),
        maxVertexUniforms: e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),
        maxVaryings: e.getParameter(e.MAX_VARYING_VECTORS),
        maxFragmentUniforms: e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),
        maxSamples: e.getParameter(e.MAX_SAMPLES),
        samples: e.getParameter(e.SAMPLES)
    };
}
function $a42f1354f0348298$var$dm(e) {
    const t = this;
    let i = null, n = 0, a = !1, r = !1;
    const s = new $a42f1354f0348298$var$jp, o = new $a42f1354f0348298$var$Au, l = {
        value: null,
        needsUpdate: !1
    };
    function c(e, i, n, a) {
        const r = null !== e ? e.length : 0;
        let c = null;
        if (0 !== r) {
            if (c = l.value, !0 !== a || null === c) {
                const t = n + 4 * r, a = i.matrixWorldInverse;
                o.getNormalMatrix(a), (null === c || c.length < t) && (c = new Float32Array(t));
                for(let t = 0, i = n; t !== r; ++t, i += 4)s.copy(e[t]).applyMatrix4(a, o), s.normal.toArray(c, i), c[i + 3] = s.constant;
            }
            l.value = c, l.needsUpdate = !0;
        }
        return t.numPlanes = r, t.numIntersection = 0, c;
    }
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e, t) {
        const i = 0 !== e.length || t || 0 !== n || a;
        return a = t, n = e.length, i;
    }, this.beginShadows = function() {
        r = !0, c(null);
    }, this.endShadows = function() {
        r = !1;
    }, this.setGlobalState = function(e, t) {
        i = c(e, t, 0);
    }, this.setState = function(s, o, d) {
        const u = s.clippingPlanes, h = s.clipIntersection, p = s.clipShadows, A = e.get(s);
        if (!a || null === u || 0 === u.length || r && !p) r ? c(null) : function() {
            l.value !== i && (l.value = i, l.needsUpdate = n > 0);
            t.numPlanes = n, t.numIntersection = 0;
        }();
        else {
            const e = r ? 0 : n, t = 4 * e;
            let a = A.clippingState || null;
            l.value = a, a = c(u, o, t, d);
            for(let e = 0; e !== t; ++e)a[e] = i[e];
            A.clippingState = a, this.numIntersection = h ? this.numPlanes : 0, this.numPlanes += e;
        }
    };
}
$a42f1354f0348298$var$rm.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
const $a42f1354f0348298$var$um = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], $a42f1354f0348298$var$hm = 20, $a42f1354f0348298$var$pm = new $a42f1354f0348298$var$GA, $a42f1354f0348298$var$Am = new $a42f1354f0348298$var$gh;
let $a42f1354f0348298$var$mm = null, $a42f1354f0348298$var$gm = 0, $a42f1354f0348298$var$fm = 0, $a42f1354f0348298$var$_m = !1;
const $a42f1354f0348298$var$vm = new $a42f1354f0348298$var$uu;
class $a42f1354f0348298$var$Em {
    constructor(e){
        this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
    }
    fromScene(e, t = 0, i = .1, n = 100, a = {}) {
        const { size: r = 256, position: s = $a42f1354f0348298$var$vm } = a;
        $a42f1354f0348298$var$mm = this._renderer.getRenderTarget(), $a42f1354f0348298$var$gm = this._renderer.getActiveCubeFace(), $a42f1354f0348298$var$fm = this._renderer.getActiveMipmapLevel(), $a42f1354f0348298$var$_m = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(r);
        const o = this._allocateTargets();
        return o.depthBuffer = !0, this._sceneToCubeUV(e, i, n, o, s), t > 0 && this._blur(o, 0, 0, t), this._applyPMREM(o), this._cleanup(o), o;
    }
    fromEquirectangular(e, t = null) {
        return this._fromTexture(e, t);
    }
    fromCubemap(e, t = null) {
        return this._fromTexture(e, t);
    }
    compileCubemapShader() {
        null === this._cubemapMaterial && (this._cubemapMaterial = $a42f1354f0348298$var$xm(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        null === this._equirectMaterial && (this._equirectMaterial = $a42f1354f0348298$var$km(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose(), null !== this._backgroundBox && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
    }
    _setSize(e) {
        this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._ggxMaterial && this._ggxMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
        for(let e = 0; e < this._lodMeshes.length; e++)this._lodMeshes[e].geometry.dispose();
    }
    _cleanup(e) {
        this._renderer.setRenderTarget($a42f1354f0348298$var$mm, $a42f1354f0348298$var$gm, $a42f1354f0348298$var$fm), this._renderer.xr.enabled = $a42f1354f0348298$var$_m, e.scissorTest = !1, $a42f1354f0348298$var$bm(e, 0, 0, e.width, e.height);
    }
    _fromTexture(e, t) {
        e.mapping === $a42f1354f0348298$var$cc || e.mapping === $a42f1354f0348298$var$dc ? this._setSize(0 === e.image.length ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), $a42f1354f0348298$var$mm = this._renderer.getRenderTarget(), $a42f1354f0348298$var$gm = this._renderer.getActiveCubeFace(), $a42f1354f0348298$var$fm = this._renderer.getActiveMipmapLevel(), $a42f1354f0348298$var$_m = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
        const i = t || this._allocateTargets();
        return this._textureToCubeUV(e, i), this._applyPMREM(i), this._cleanup(i), i;
    }
    _allocateTargets() {
        const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, i = {
            magFilter: $a42f1354f0348298$var$Ec,
            minFilter: $a42f1354f0348298$var$Ec,
            generateMipmaps: !1,
            type: $a42f1354f0348298$var$Dc,
            format: $a42f1354f0348298$var$Fc,
            colorSpace: $a42f1354f0348298$var$Sd,
            depthBuffer: !1
        }, n = $a42f1354f0348298$var$ym(e, t, i);
        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
            null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = $a42f1354f0348298$var$ym(e, t, i);
            const { _lodMax: n } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = function(e) {
                const t = [], i = [], n = [];
                let a = e;
                const r = e - 4 + 1 + $a42f1354f0348298$var$um.length;
                for(let s = 0; s < r; s++){
                    const r = Math.pow(2, a);
                    t.push(r);
                    let o = 1 / r;
                    s > e - 4 ? o = $a42f1354f0348298$var$um[s - e + 4 - 1] : 0 === s && (o = 0), i.push(o);
                    const l = 1 / (r - 2), c = -l, d = 1 + l, u = [
                        c,
                        c,
                        d,
                        c,
                        d,
                        d,
                        c,
                        c,
                        d,
                        d,
                        c,
                        d
                    ], h = 6, p = 6, A = 3, m = 2, g = 1, f = new Float32Array(A * p * h), _ = new Float32Array(m * p * h), v = new Float32Array(g * p * h);
                    for(let e = 0; e < h; e++){
                        const t = e % 3 * 2 / 3 - 1, i = e > 2 ? 0 : -1, n = [
                            t,
                            i,
                            0,
                            t + 2 / 3,
                            i,
                            0,
                            t + 2 / 3,
                            i + 1,
                            0,
                            t,
                            i,
                            0,
                            t + 2 / 3,
                            i + 1,
                            0,
                            t,
                            i + 1,
                            0
                        ];
                        f.set(n, A * p * e), _.set(u, m * p * e);
                        const a = [
                            e,
                            e,
                            e,
                            e,
                            e,
                            e
                        ];
                        v.set(a, g * p * e);
                    }
                    const E = new $a42f1354f0348298$var$hp;
                    E.setAttribute("position", new $a42f1354f0348298$var$Yh(f, A)), E.setAttribute("uv", new $a42f1354f0348298$var$Yh(_, m)), E.setAttribute("faceIndex", new $a42f1354f0348298$var$Yh(v, g)), n.push(new $a42f1354f0348298$var$zp(E, null)), a > 4 && a--;
                }
                return {
                    lodMeshes: n,
                    sizeLods: t,
                    sigmas: i
                };
            }(n)), this._blurMaterial = function(e, t, i) {
                const n = new Float32Array($a42f1354f0348298$var$hm), a = new $a42f1354f0348298$var$uu(0, 1, 0), r = new $a42f1354f0348298$var$EA({
                    name: "SphericalGaussianBlur",
                    defines: {
                        n: $a42f1354f0348298$var$hm,
                        CUBEUV_TEXEL_WIDTH: 1 / t,
                        CUBEUV_TEXEL_HEIGHT: 1 / i,
                        CUBEUV_MAX_MIP: `${e}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        samples: {
                            value: 1
                        },
                        weights: {
                            value: n
                        },
                        latitudinal: {
                            value: !1
                        },
                        dTheta: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        },
                        poleAxis: {
                            value: a
                        }
                    },
                    vertexShader: $a42f1354f0348298$var$wm(),
                    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
                    blending: 0,
                    depthTest: !1,
                    depthWrite: !1
                });
                return r;
            }(n, e, t), this._ggxMaterial = function(e, t, i) {
                const n = new $a42f1354f0348298$var$EA({
                    name: "PMREMGGXConvolution",
                    defines: {
                        GGX_SAMPLES: 256,
                        CUBEUV_TEXEL_WIDTH: 1 / t,
                        CUBEUV_TEXEL_HEIGHT: 1 / i,
                        CUBEUV_MAX_MIP: `${e}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        roughness: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        }
                    },
                    vertexShader: $a42f1354f0348298$var$wm(),
                    fragmentShader: '\n\n\t\t\tprecision highp float;\n\t\t\tprecision highp int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform float roughness;\n\t\t\tuniform float mipInt;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\t#define PI 3.14159265359\n\n\t\t\t// Van der Corput radical inverse\n\t\t\tfloat radicalInverse_VdC(uint bits) {\n\t\t\t\tbits = (bits << 16u) | (bits >> 16u);\n\t\t\t\tbits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);\n\t\t\t\tbits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);\n\t\t\t\tbits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);\n\t\t\t\tbits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);\n\t\t\t\treturn float(bits) * 2.3283064365386963e-10; // / 0x100000000\n\t\t\t}\n\n\t\t\t// Hammersley sequence\n\t\t\tvec2 hammersley(uint i, uint N) {\n\t\t\t\treturn vec2(float(i) / float(N), radicalInverse_VdC(i));\n\t\t\t}\n\n\t\t\t// GGX VNDF importance sampling (Eric Heitz 2018)\n\t\t\t// "Sampling the GGX Distribution of Visible Normals"\n\t\t\t// https://jcgt.org/published/0007/04/01/\n\t\t\tvec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {\n\t\t\t\tfloat alpha = roughness * roughness;\n\n\t\t\t\t// Section 4.1: Orthonormal basis\n\t\t\t\tvec3 T1 = vec3(1.0, 0.0, 0.0);\n\t\t\t\tvec3 T2 = cross(V, T1);\n\n\t\t\t\t// Section 4.2: Parameterization of projected area\n\t\t\t\tfloat r = sqrt(Xi.x);\n\t\t\t\tfloat phi = 2.0 * PI * Xi.y;\n\t\t\t\tfloat t1 = r * cos(phi);\n\t\t\t\tfloat t2 = r * sin(phi);\n\t\t\t\tfloat s = 0.5 * (1.0 + V.z);\n\t\t\t\tt2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;\n\n\t\t\t\t// Section 4.3: Reprojection onto hemisphere\n\t\t\t\tvec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;\n\n\t\t\t\t// Section 3.4: Transform back to ellipsoid configuration\n\t\t\t\treturn normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));\n\t\t\t}\n\n\t\t\tvoid main() {\n\t\t\t\tvec3 N = normalize(vOutputDirection);\n\t\t\t\tvec3 V = N; // Assume view direction equals normal for pre-filtering\n\n\t\t\t\tvec3 prefilteredColor = vec3(0.0);\n\t\t\t\tfloat totalWeight = 0.0;\n\n\t\t\t\t// For very low roughness, just sample the environment directly\n\t\t\t\tif (roughness < 0.001) {\n\t\t\t\t\tgl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\t// Tangent space basis for VNDF sampling\n\t\t\t\tvec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\n\t\t\t\tvec3 tangent = normalize(cross(up, N));\n\t\t\t\tvec3 bitangent = cross(N, tangent);\n\n\t\t\t\tfor(uint i = 0u; i < uint(GGX_SAMPLES); i++) {\n\t\t\t\t\tvec2 Xi = hammersley(i, uint(GGX_SAMPLES));\n\n\t\t\t\t\t// For PMREM, V = N, so in tangent space V is always (0, 0, 1)\n\t\t\t\t\tvec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);\n\n\t\t\t\t\t// Transform H back to world space\n\t\t\t\t\tvec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);\n\t\t\t\t\tvec3 L = normalize(2.0 * dot(V, H) * H - V);\n\n\t\t\t\t\tfloat NdotL = max(dot(N, L), 0.0);\n\n\t\t\t\t\tif(NdotL > 0.0) {\n\t\t\t\t\t\t// Sample environment at fixed mip level\n\t\t\t\t\t\t// VNDF importance sampling handles the distribution filtering\n\t\t\t\t\t\tvec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);\n\n\t\t\t\t\t\t// Weight by NdotL for the split-sum approximation\n\t\t\t\t\t\t// VNDF PDF naturally accounts for the visible microfacet distribution\n\t\t\t\t\t\tprefilteredColor += sampleColor * NdotL;\n\t\t\t\t\t\ttotalWeight += NdotL;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif (totalWeight > 0.0) {\n\t\t\t\t\tprefilteredColor = prefilteredColor / totalWeight;\n\t\t\t\t}\n\n\t\t\t\tgl_FragColor = vec4(prefilteredColor, 1.0);\n\t\t\t}\n\t\t',
                    blending: 0,
                    depthTest: !1,
                    depthWrite: !1
                });
                return n;
            }(n, e, t);
        }
        return n;
    }
    _compileMaterial(e) {
        const t = new $a42f1354f0348298$var$zp(new $a42f1354f0348298$var$hp, e);
        this._renderer.compile(t, $a42f1354f0348298$var$pm);
    }
    _sceneToCubeUV(e, t, i, n, a) {
        const r = new $a42f1354f0348298$var$jA(90, 1, t, i), s = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], o = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], l = this._renderer, c = l.autoClear, d = l.toneMapping;
        l.getClearColor($a42f1354f0348298$var$Am), l.toneMapping = 0, l.autoClear = !1;
        l.state.buffers.depth.getReversed() && (l.setRenderTarget(n), l.clearDepth(), l.setRenderTarget(null)), null === this._backgroundBox && (this._backgroundBox = new $a42f1354f0348298$var$zp(new $a42f1354f0348298$var$dA, new $a42f1354f0348298$var$kp({
            name: "PMREM.Background",
            side: 1,
            depthWrite: !1,
            depthTest: !1
        })));
        const u = this._backgroundBox, h = u.material;
        let p = !1;
        const A = e.background;
        A ? A.isColor && (h.color.copy(A), e.background = null, p = !0) : (h.color.copy($a42f1354f0348298$var$Am), p = !0);
        for(let t = 0; t < 6; t++){
            const i = t % 3;
            0 === i ? (r.up.set(0, s[t], 0), r.position.set(a.x, a.y, a.z), r.lookAt(a.x + o[t], a.y, a.z)) : 1 === i ? (r.up.set(0, 0, s[t]), r.position.set(a.x, a.y, a.z), r.lookAt(a.x, a.y + o[t], a.z)) : (r.up.set(0, s[t], 0), r.position.set(a.x, a.y, a.z), r.lookAt(a.x, a.y, a.z + o[t]));
            const c = this._cubeSize;
            $a42f1354f0348298$var$bm(n, i * c, t > 2 ? c : 0, c, c), l.setRenderTarget(n), p && l.render(u, r), l.render(e, r);
        }
        l.toneMapping = d, l.autoClear = c, e.background = A;
    }
    _textureToCubeUV(e, t) {
        const i = this._renderer, n = e.mapping === $a42f1354f0348298$var$cc || e.mapping === $a42f1354f0348298$var$dc;
        n ? (null === this._cubemapMaterial && (this._cubemapMaterial = $a42f1354f0348298$var$xm()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === e.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = $a42f1354f0348298$var$km());
        const a = n ? this._cubemapMaterial : this._equirectMaterial, r = this._lodMeshes[0];
        r.material = a;
        a.uniforms.envMap.value = e;
        const s = this._cubeSize;
        $a42f1354f0348298$var$bm(t, 0, 0, 3 * s, 2 * s), i.setRenderTarget(t), i.render(r, $a42f1354f0348298$var$pm);
    }
    _applyPMREM(e) {
        const t = this._renderer, i = t.autoClear;
        t.autoClear = !1;
        const n = this._lodMeshes.length;
        for(let t = 1; t < n; t++)this._applyGGXFilter(e, t - 1, t);
        t.autoClear = i;
    }
    _applyGGXFilter(e, t, i) {
        const n = this._renderer, a = this._pingPongRenderTarget, r = this._ggxMaterial, s = this._lodMeshes[i];
        s.material = r;
        const o = r.uniforms, l = i / (this._lodMeshes.length - 1), c = t / (this._lodMeshes.length - 1), d = Math.sqrt(l * l - c * c) * (0 + 1.25 * l), { _lodMax: u } = this, h = this._sizeLods[i], p = 3 * h * (i > u - 4 ? i - u + 4 : 0), A = 4 * (this._cubeSize - h);
        o.envMap.value = e.texture, o.roughness.value = d, o.mipInt.value = u - t, $a42f1354f0348298$var$bm(a, p, A, 3 * h, 2 * h), n.setRenderTarget(a), n.render(s, $a42f1354f0348298$var$pm), o.envMap.value = a.texture, o.roughness.value = 0, o.mipInt.value = u - i, $a42f1354f0348298$var$bm(e, p, A, 3 * h, 2 * h), n.setRenderTarget(e), n.render(s, $a42f1354f0348298$var$pm);
    }
    _blur(e, t, i, n, a) {
        const r = this._pingPongRenderTarget;
        this._halfBlur(e, r, t, i, n, "latitudinal", a), this._halfBlur(r, e, i, i, n, "longitudinal", a);
    }
    _halfBlur(e, t, i, n, a, r, s) {
        const o = this._renderer, l = this._blurMaterial;
        "latitudinal" !== r && "longitudinal" !== r && $a42f1354f0348298$var$Xd("blur direction must be either latitudinal or longitudinal!");
        const c = this._lodMeshes[n];
        c.material = l;
        const d = l.uniforms, u = this._sizeLods[i] - 1, h = isFinite(a) ? Math.PI / (2 * u) : 2 * Math.PI / 39, p = a / h, A = isFinite(a) ? 1 + Math.floor(3 * p) : $a42f1354f0348298$var$hm;
        A > $a42f1354f0348298$var$hm && $a42f1354f0348298$var$Wd(`sigmaRadians, ${a}, is too large and will clip, as it requested ${A} samples when the maximum is set to 20`);
        const m = [];
        let g = 0;
        for(let e = 0; e < $a42f1354f0348298$var$hm; ++e){
            const t = e / p, i = Math.exp(-t * t / 2);
            m.push(i), 0 === e ? g += i : e < A && (g += 2 * i);
        }
        for(let e = 0; e < m.length; e++)m[e] = m[e] / g;
        d.envMap.value = e.texture, d.samples.value = A, d.weights.value = m, d.latitudinal.value = "latitudinal" === r, s && (d.poleAxis.value = s);
        const { _lodMax: f } = this;
        d.dTheta.value = h, d.mipInt.value = f - i;
        const _ = this._sizeLods[n];
        $a42f1354f0348298$var$bm(t, 3 * _ * (n > f - 4 ? n - f + 4 : 0), 4 * (this._cubeSize - _), 3 * _, 2 * _), o.setRenderTarget(t), o.render(c, $a42f1354f0348298$var$pm);
    }
}
function $a42f1354f0348298$var$ym(e, t, i) {
    const n = new $a42f1354f0348298$var$Iu(e, t, i);
    return n.texture.mapping = $a42f1354f0348298$var$pc, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function $a42f1354f0348298$var$bm(e, t, i, n, a) {
    e.viewport.set(t, i, n, a), e.scissor.set(t, i, n, a);
}
function $a42f1354f0348298$var$km() {
    return new $a42f1354f0348298$var$EA({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: $a42f1354f0348298$var$wm(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
        blending: 0,
        depthTest: !1,
        depthWrite: !1
    });
}
function $a42f1354f0348298$var$xm() {
    return new $a42f1354f0348298$var$EA({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: $a42f1354f0348298$var$wm(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
        blending: 0,
        depthTest: !1,
        depthWrite: !1
    });
}
function $a42f1354f0348298$var$wm() {
    return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}
class $a42f1354f0348298$var$Mm extends $a42f1354f0348298$var$Iu {
    constructor(e = 1, t = {}){
        super(e, e, t), this.isWebGLCubeRenderTarget = !0;
        const i = {
            width: e,
            height: e,
            depth: 1
        }, n = [
            i,
            i,
            i,
            i,
            i,
            i
        ];
        this.texture = new $a42f1354f0348298$var$sA(n), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
    }
    fromEquirectangularTexture(e, t) {
        this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
        const i = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
            fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
        }, n = new $a42f1354f0348298$var$dA(5, 5, 5), a = new $a42f1354f0348298$var$EA({
            name: "CubemapFromEquirect",
            uniforms: $a42f1354f0348298$var$mA(i.uniforms),
            vertexShader: i.vertexShader,
            fragmentShader: i.fragmentShader,
            side: 1,
            blending: 0
        });
        a.uniforms.tEquirect.value = t;
        const r = new $a42f1354f0348298$var$zp(n, a), s = t.minFilter;
        t.minFilter === $a42f1354f0348298$var$bc && (t.minFilter = $a42f1354f0348298$var$Ec);
        return new $a42f1354f0348298$var$HA(1, 10, this).update(e, r), t.minFilter = s, r.geometry.dispose(), r.material.dispose(), this;
    }
    clear(e, t = !0, i = !0, n = !0) {
        const a = e.getRenderTarget();
        for(let a = 0; a < 6; a++)e.setRenderTarget(this, a), e.clear(t, i, n);
        e.setRenderTarget(a);
    }
}
function $a42f1354f0348298$var$Sm(e) {
    let t = new WeakMap, i = new WeakMap, n = null;
    function a(e, t) {
        return t === $a42f1354f0348298$var$uc ? e.mapping = $a42f1354f0348298$var$cc : t === $a42f1354f0348298$var$hc && (e.mapping = $a42f1354f0348298$var$dc), e;
    }
    function r(e) {
        const i = e.target;
        i.removeEventListener("dispose", r);
        const n = t.get(i);
        void 0 !== n && (t.delete(i), n.dispose());
    }
    function s(e) {
        const t = e.target;
        t.removeEventListener("dispose", s);
        const n = i.get(t);
        void 0 !== n && (i.delete(t), n.dispose());
    }
    return {
        get: function(o, l = !1) {
            return null == o ? null : l ? function(t) {
                if (t && t.isTexture) {
                    const a = t.mapping, r = a === $a42f1354f0348298$var$uc || a === $a42f1354f0348298$var$hc, o = a === $a42f1354f0348298$var$cc || a === $a42f1354f0348298$var$dc;
                    if (r || o) {
                        let a = i.get(t);
                        const l = void 0 !== a ? a.texture.pmremVersion : 0;
                        if (t.isRenderTargetTexture && t.pmremVersion !== l) return null === n && (n = new $a42f1354f0348298$var$Em(e)), a = r ? n.fromEquirectangular(t, a) : n.fromCubemap(t, a), a.texture.pmremVersion = t.pmremVersion, i.set(t, a), a.texture;
                        if (void 0 !== a) return a.texture;
                        {
                            const l = t.image;
                            return r && l && l.height > 0 || o && l && function(e) {
                                let t = 0;
                                const i = 6;
                                for(let n = 0; n < i; n++)void 0 !== e[n] && t++;
                                return t === i;
                            }(l) ? (null === n && (n = new $a42f1354f0348298$var$Em(e)), a = r ? n.fromEquirectangular(t) : n.fromCubemap(t), a.texture.pmremVersion = t.pmremVersion, i.set(t, a), t.addEventListener("dispose", s), a.texture) : null;
                        }
                    }
                }
                return t;
            }(o) : function(i) {
                if (i && i.isTexture) {
                    const n = i.mapping;
                    if (n === $a42f1354f0348298$var$uc || n === $a42f1354f0348298$var$hc) {
                        if (t.has(i)) return a(t.get(i).texture, i.mapping);
                        {
                            const n = i.image;
                            if (n && n.height > 0) {
                                const s = new $a42f1354f0348298$var$Mm(n.height);
                                return s.fromEquirectangularTexture(e, i), t.set(i, s), i.addEventListener("dispose", r), a(s.texture, i.mapping);
                            }
                            return null;
                        }
                    }
                }
                return i;
            }(o);
        },
        dispose: function() {
            t = new WeakMap, i = new WeakMap, null !== n && (n.dispose(), n = null);
        }
    };
}
function $a42f1354f0348298$var$Cm(e) {
    const t = {};
    function i(i) {
        if (void 0 !== t[i]) return t[i];
        const n = e.getExtension(i);
        return t[i] = n, n;
    }
    return {
        has: function(e) {
            return null !== i(e);
        },
        init: function() {
            i("EXT_color_buffer_float"), i("WEBGL_clip_cull_distance"), i("OES_texture_float_linear"), i("EXT_color_buffer_half_float"), i("WEBGL_multisampled_render_to_texture"), i("WEBGL_render_shared_exponent");
        },
        get: function(e) {
            const t = i(e);
            return null === t && $a42f1354f0348298$var$Qd("WebGLRenderer: " + e + " extension not supported."), t;
        }
    };
}
function $a42f1354f0348298$var$Tm(e, t, i, n) {
    const a = {}, r = new WeakMap;
    function s(e) {
        const o = e.target;
        null !== o.index && t.remove(o.index);
        for(const e in o.attributes)t.remove(o.attributes[e]);
        o.removeEventListener("dispose", s), delete a[o.id];
        const l = r.get(o);
        l && (t.remove(l), r.delete(o)), n.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, i.memory.geometries--;
    }
    function o(e) {
        const i = [], n = e.index, a = e.attributes.position;
        let s = 0;
        if (void 0 === a) return;
        if (null !== n) {
            const e = n.array;
            s = n.version;
            for(let t = 0, n = e.length; t < n; t += 3){
                const n = e[t + 0], a = e[t + 1], r = e[t + 2];
                i.push(n, a, a, r, r, n);
            }
        } else {
            const e = a.array;
            s = a.version;
            for(let t = 0, n = e.length / 3 - 1; t < n; t += 3){
                const e = t + 0, n = t + 1, a = t + 2;
                i.push(e, n, n, a, a, e);
            }
        }
        const o = new (a.count >= 65535 ? $a42f1354f0348298$var$$h : $a42f1354f0348298$var$Jh)(i, 1);
        o.version = s;
        const l = r.get(e);
        l && t.remove(l), r.set(e, o);
    }
    return {
        get: function(e, t) {
            return !0 === a[t.id] || (t.addEventListener("dispose", s), a[t.id] = !0, i.memory.geometries++), t;
        },
        update: function(i) {
            const n = i.attributes;
            for(const i in n)t.update(n[i], e.ARRAY_BUFFER);
        },
        getWireframeAttribute: function(e) {
            const t = r.get(e);
            if (t) {
                const i = e.index;
                null !== i && t.version < i.version && o(e);
            } else o(e);
            return r.get(e);
        }
    };
}
function $a42f1354f0348298$var$Dm(e, t, i) {
    let n, a, r;
    this.setMode = function(e) {
        n = e;
    }, this.setIndex = function(e) {
        a = e.type, r = e.bytesPerElement;
    }, this.render = function(t, s) {
        e.drawElements(n, s, a, t * r), i.update(s, n, 1);
    }, this.renderInstances = function(t, s, o) {
        0 !== o && (e.drawElementsInstanced(n, s, a, t * r, o), i.update(s, n, o));
    }, this.renderMultiDraw = function(e, r, s) {
        if (0 === s) return;
        t.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, r, 0, a, e, 0, s);
        let o = 0;
        for(let e = 0; e < s; e++)o += r[e];
        i.update(o, n, 1);
    };
}
function $a42f1354f0348298$var$Pm(e) {
    const t = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    return {
        memory: {
            geometries: 0,
            textures: 0
        },
        render: t,
        programs: null,
        autoReset: !0,
        reset: function() {
            t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
        },
        update: function(i, n, a) {
            switch(t.calls++, n){
                case e.TRIANGLES:
                    t.triangles += a * (i / 3);
                    break;
                case e.LINES:
                    t.lines += a * (i / 2);
                    break;
                case e.LINE_STRIP:
                    t.lines += a * (i - 1);
                    break;
                case e.LINE_LOOP:
                    t.lines += a * i;
                    break;
                case e.POINTS:
                    t.points += a * i;
                    break;
                default:
                    $a42f1354f0348298$var$Xd("WebGLInfo: Unknown draw mode:", n);
            }
        }
    };
}
function $a42f1354f0348298$var$Im(e, t, i) {
    const n = new WeakMap, a = new $a42f1354f0348298$var$Du;
    return {
        update: function(r, s, o) {
            const l = r.morphTargetInfluences, c = s.morphAttributes.position || s.morphAttributes.normal || s.morphAttributes.color, d = void 0 !== c ? c.length : 0;
            let u = n.get(s);
            if (void 0 === u || u.count !== d) {
                void 0 !== u && u.texture.dispose();
                const h = void 0 !== s.morphAttributes.position, p = void 0 !== s.morphAttributes.normal, A = void 0 !== s.morphAttributes.color, m = s.morphAttributes.position || [], g = s.morphAttributes.normal || [], f = s.morphAttributes.color || [];
                let _ = 0;
                !0 === h && (_ = 1), !0 === p && (_ = 2), !0 === A && (_ = 3);
                let v = s.attributes.position.count * _, E = 1;
                v > t.maxTextureSize && (E = Math.ceil(v / t.maxTextureSize), v = t.maxTextureSize);
                const y = new Float32Array(v * E * 4 * d), b = new $a42f1354f0348298$var$Lu(y, v, E, d);
                b.type = $a42f1354f0348298$var$Tc, b.needsUpdate = !0;
                const k = 4 * _;
                for(let w = 0; w < d; w++){
                    const M = m[w], S = g[w], C = f[w], T = v * E * 4 * w;
                    for(let D = 0; D < M.count; D++){
                        const P = D * k;
                        !0 === h && (a.fromBufferAttribute(M, D), y[T + P + 0] = a.x, y[T + P + 1] = a.y, y[T + P + 2] = a.z, y[T + P + 3] = 0), !0 === p && (a.fromBufferAttribute(S, D), y[T + P + 4] = a.x, y[T + P + 5] = a.y, y[T + P + 6] = a.z, y[T + P + 7] = 0), !0 === A && (a.fromBufferAttribute(C, D), y[T + P + 8] = a.x, y[T + P + 9] = a.y, y[T + P + 10] = a.z, y[T + P + 11] = 4 === C.itemSize ? a.w : 1);
                    }
                }
                function x() {
                    b.dispose(), n.delete(s), s.removeEventListener("dispose", x);
                }
                u = {
                    count: d,
                    texture: b,
                    size: new $a42f1354f0348298$var$cu(v, E)
                }, n.set(s, u), s.addEventListener("dispose", x);
            }
            if (!0 === r.isInstancedMesh && null !== r.morphTexture) o.getUniforms().setValue(e, "morphTexture", r.morphTexture, i);
            else {
                let I = 0;
                for(let R = 0; R < l.length; R++)I += l[R];
                const L = s.morphTargetsRelative ? 1 : 1 - I;
                o.getUniforms().setValue(e, "morphTargetBaseInfluence", L), o.getUniforms().setValue(e, "morphTargetInfluences", l);
            }
            o.getUniforms().setValue(e, "morphTargetsTexture", u.texture, i), o.getUniforms().setValue(e, "morphTargetsTextureSize", u.size);
        }
    };
}
function $a42f1354f0348298$var$Lm(e, t, i, n, a) {
    let r = new WeakMap;
    function s(e) {
        const t = e.target;
        t.removeEventListener("dispose", s), n.releaseStatesOfObject(t), i.remove(t.instanceMatrix), null !== t.instanceColor && i.remove(t.instanceColor);
    }
    return {
        update: function(n) {
            const o = a.render.frame, l = n.geometry, c = t.get(n, l);
            if (r.get(c) !== o && (t.update(c), r.set(c, o)), n.isInstancedMesh && (!1 === n.hasEventListener("dispose", s) && n.addEventListener("dispose", s), r.get(n) !== o && (i.update(n.instanceMatrix, e.ARRAY_BUFFER), null !== n.instanceColor && i.update(n.instanceColor, e.ARRAY_BUFFER), r.set(n, o))), n.isSkinnedMesh) {
                const e = n.skeleton;
                r.get(e) !== o && (e.update(), r.set(e, o));
            }
            return c;
        },
        dispose: function() {
            r = new WeakMap;
        }
    };
}
const $a42f1354f0348298$var$Rm = {
    [$a42f1354f0348298$var$ic]: "LINEAR_TONE_MAPPING",
    [$a42f1354f0348298$var$nc]: "REINHARD_TONE_MAPPING",
    [$a42f1354f0348298$var$ac]: "CINEON_TONE_MAPPING",
    [$a42f1354f0348298$var$rc]: "ACES_FILMIC_TONE_MAPPING",
    [$a42f1354f0348298$var$oc]: "AGX_TONE_MAPPING",
    [$a42f1354f0348298$var$lc]: "NEUTRAL_TONE_MAPPING",
    [$a42f1354f0348298$var$sc]: "CUSTOM_TONE_MAPPING"
};
function $a42f1354f0348298$var$zm(e, t, i, n, a, r) {
    const s = new $a42f1354f0348298$var$Iu(t, i, {
        type: e,
        depthBuffer: a,
        stencilBuffer: r,
        samples: n ? 4 : 0,
        depthTexture: a ? new $a42f1354f0348298$var$oA(t, i) : void 0
    }), o = new $a42f1354f0348298$var$Iu(t, i, {
        type: $a42f1354f0348298$var$Dc,
        depthBuffer: !1,
        stencilBuffer: !1
    }), l = new $a42f1354f0348298$var$hp;
    l.setAttribute("position", new $a42f1354f0348298$var$ep([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3)), l.setAttribute("uv", new $a42f1354f0348298$var$ep([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    const c = new $a42f1354f0348298$var$yA({
        uniforms: {
            tDiffuse: {
                value: null
            }
        },
        vertexShader: "\n\t\t\tprecision highp float;\n\n\t\t\tuniform mat4 modelViewMatrix;\n\t\t\tuniform mat4 projectionMatrix;\n\n\t\t\tattribute vec3 position;\n\t\t\tattribute vec2 uv;\n\n\t\t\tvarying vec2 vUv;\n\n\t\t\tvoid main() {\n\t\t\t\tvUv = uv;\n\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t}",
        fragmentShader: "\n\t\t\tprecision highp float;\n\n\t\t\tuniform sampler2D tDiffuse;\n\n\t\t\tvarying vec2 vUv;\n\n\t\t\t#include <tonemapping_pars_fragment>\n\t\t\t#include <colorspace_pars_fragment>\n\n\t\t\tvoid main() {\n\t\t\t\tgl_FragColor = texture2D( tDiffuse, vUv );\n\n\t\t\t\t#ifdef LINEAR_TONE_MAPPING\n\t\t\t\t\tgl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( REINHARD_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( CINEON_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( ACES_FILMIC_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( AGX_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( NEUTRAL_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( CUSTOM_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );\n\t\t\t\t#endif\n\n\t\t\t\t#ifdef SRGB_TRANSFER\n\t\t\t\t\tgl_FragColor = sRGBTransferOETF( gl_FragColor );\n\t\t\t\t#endif\n\t\t\t}",
        depthTest: !1,
        depthWrite: !1
    }), d = new $a42f1354f0348298$var$zp(l, c), u = new $a42f1354f0348298$var$GA(-1, 1, 1, -1, 0, 1);
    let h, p = null, A = null, m = !1, g = null, f = [], _ = !1;
    this.setSize = function(e, t) {
        s.setSize(e, t), o.setSize(e, t);
        for(let i = 0; i < f.length; i++){
            const n = f[i];
            n.setSize && n.setSize(e, t);
        }
    }, this.setEffects = function(e) {
        f = e, _ = f.length > 0 && !0 === f[0].isRenderPass;
        const t = s.width, i = s.height;
        for(let e = 0; e < f.length; e++){
            const n = f[e];
            n.setSize && n.setSize(t, i);
        }
    }, this.begin = function(e, t) {
        if (m) return !1;
        if (0 === e.toneMapping && 0 === f.length) return !1;
        if (g = t, null !== t) {
            const e = t.width, i = t.height;
            s.width === e && s.height === i || this.setSize(e, i);
        }
        return !1 === _ && e.setRenderTarget(s), h = e.toneMapping, e.toneMapping = 0, !0;
    }, this.hasRenderPass = function() {
        return _;
    }, this.end = function(e, t) {
        e.toneMapping = h, m = !0;
        let i = s, n = o;
        for(let a = 0; a < f.length; a++){
            const r = f[a];
            if (!1 !== r.enabled && (r.render(e, n, i, t), !1 !== r.needsSwap)) {
                const e = i;
                i = n, n = e;
            }
        }
        if (p !== e.outputColorSpace || A !== e.toneMapping) {
            p = e.outputColorSpace, A = e.toneMapping, c.defines = {}, $a42f1354f0348298$var$vu.getTransfer(p) === $a42f1354f0348298$var$Td && (c.defines.SRGB_TRANSFER = "");
            const t = $a42f1354f0348298$var$Rm[A];
            t && (c.defines[t] = ""), c.needsUpdate = !0;
        }
        c.uniforms.tDiffuse.value = i.texture, e.setRenderTarget(g), e.render(d, u), g = null, m = !1;
    }, this.isCompositing = function() {
        return m;
    }, this.dispose = function() {
        s.depthTexture && s.depthTexture.dispose(), s.dispose(), o.dispose(), l.dispose(), c.dispose();
    };
}
const $a42f1354f0348298$var$Fm = new $a42f1354f0348298$var$Tu, $a42f1354f0348298$var$Um = new $a42f1354f0348298$var$oA(1, 1), $a42f1354f0348298$var$Nm = new $a42f1354f0348298$var$Lu, $a42f1354f0348298$var$Bm = new $a42f1354f0348298$var$Ru, $a42f1354f0348298$var$Om = new $a42f1354f0348298$var$sA, $a42f1354f0348298$var$jm = [], $a42f1354f0348298$var$Gm = [], $a42f1354f0348298$var$Vm = new Float32Array(16), $a42f1354f0348298$var$Hm = new Float32Array(9), $a42f1354f0348298$var$qm = new Float32Array(4);
function $a42f1354f0348298$var$Km(e, t, i) {
    const n = e[0];
    if (n <= 0 || n > 0) return e;
    const a = t * i;
    let r = $a42f1354f0348298$var$jm[a];
    if (void 0 === r && (r = new Float32Array(a), $a42f1354f0348298$var$jm[a] = r), 0 !== t) {
        n.toArray(r, 0);
        for(let n = 1, a = 0; n !== t; ++n)a += i, e[n].toArray(r, a);
    }
    return r;
}
function $a42f1354f0348298$var$Wm(e, t) {
    if (e.length !== t.length) return !1;
    for(let i = 0, n = e.length; i < n; i++)if (e[i] !== t[i]) return !1;
    return !0;
}
function $a42f1354f0348298$var$Xm(e, t) {
    for(let i = 0, n = t.length; i < n; i++)e[i] = t[i];
}
function $a42f1354f0348298$var$Qm(e, t) {
    let i = $a42f1354f0348298$var$Gm[t];
    void 0 === i && (i = new Int32Array(t), $a42f1354f0348298$var$Gm[t] = i);
    for(let n = 0; n !== t; ++n)i[n] = e.allocateTextureUnit();
    return i;
}
function $a42f1354f0348298$var$Zm(e, t) {
    const i = this.cache;
    i[0] !== t && (e.uniform1f(this.addr, t), i[0] = t);
}
function $a42f1354f0348298$var$Ym(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y || (e.uniform2f(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform2fv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$Jm(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z || (e.uniform3f(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
    else if (void 0 !== t.r) i[0] === t.r && i[1] === t.g && i[2] === t.b || (e.uniform3f(this.addr, t.r, t.g, t.b), i[0] = t.r, i[1] = t.g, i[2] = t.b);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform3fv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$$m(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z && i[3] === t.w || (e.uniform4f(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform4fv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$eg(e, t) {
    const i = this.cache, n = t.elements;
    if (void 0 === n) {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniformMatrix2fv(this.addr, !1, t), $a42f1354f0348298$var$Xm(i, t);
    } else {
        if ($a42f1354f0348298$var$Wm(i, n)) return;
        $a42f1354f0348298$var$qm.set(n), e.uniformMatrix2fv(this.addr, !1, $a42f1354f0348298$var$qm), $a42f1354f0348298$var$Xm(i, n);
    }
}
function $a42f1354f0348298$var$tg(e, t) {
    const i = this.cache, n = t.elements;
    if (void 0 === n) {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniformMatrix3fv(this.addr, !1, t), $a42f1354f0348298$var$Xm(i, t);
    } else {
        if ($a42f1354f0348298$var$Wm(i, n)) return;
        $a42f1354f0348298$var$Hm.set(n), e.uniformMatrix3fv(this.addr, !1, $a42f1354f0348298$var$Hm), $a42f1354f0348298$var$Xm(i, n);
    }
}
function $a42f1354f0348298$var$ig(e, t) {
    const i = this.cache, n = t.elements;
    if (void 0 === n) {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniformMatrix4fv(this.addr, !1, t), $a42f1354f0348298$var$Xm(i, t);
    } else {
        if ($a42f1354f0348298$var$Wm(i, n)) return;
        $a42f1354f0348298$var$Vm.set(n), e.uniformMatrix4fv(this.addr, !1, $a42f1354f0348298$var$Vm), $a42f1354f0348298$var$Xm(i, n);
    }
}
function $a42f1354f0348298$var$ng(e, t) {
    const i = this.cache;
    i[0] !== t && (e.uniform1i(this.addr, t), i[0] = t);
}
function $a42f1354f0348298$var$ag(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y || (e.uniform2i(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform2iv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$rg(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z || (e.uniform3i(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform3iv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$sg(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z && i[3] === t.w || (e.uniform4i(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform4iv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$og(e, t) {
    const i = this.cache;
    i[0] !== t && (e.uniform1ui(this.addr, t), i[0] = t);
}
function $a42f1354f0348298$var$lg(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y || (e.uniform2ui(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform2uiv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$cg(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z || (e.uniform3ui(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform3uiv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$dg(e, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z && i[3] === t.w || (e.uniform4ui(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
    else {
        if ($a42f1354f0348298$var$Wm(i, t)) return;
        e.uniform4uiv(this.addr, t), $a42f1354f0348298$var$Xm(i, t);
    }
}
function $a42f1354f0348298$var$ug(e, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    let r;
    n[0] !== a && (e.uniform1i(this.addr, a), n[0] = a), this.type === e.SAMPLER_2D_SHADOW ? ($a42f1354f0348298$var$Um.compareFunction = i.isReversedDepthBuffer() ? 518 : 515, r = $a42f1354f0348298$var$Um) : r = $a42f1354f0348298$var$Fm, i.setTexture2D(t || r, a);
}
function $a42f1354f0348298$var$hg(e, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    n[0] !== a && (e.uniform1i(this.addr, a), n[0] = a), i.setTexture3D(t || $a42f1354f0348298$var$Bm, a);
}
function $a42f1354f0348298$var$pg(e, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    n[0] !== a && (e.uniform1i(this.addr, a), n[0] = a), i.setTextureCube(t || $a42f1354f0348298$var$Om, a);
}
function $a42f1354f0348298$var$Ag(e, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    n[0] !== a && (e.uniform1i(this.addr, a), n[0] = a), i.setTexture2DArray(t || $a42f1354f0348298$var$Nm, a);
}
function $a42f1354f0348298$var$mg(e, t) {
    e.uniform1fv(this.addr, t);
}
function $a42f1354f0348298$var$gg(e, t) {
    const i = $a42f1354f0348298$var$Km(t, this.size, 2);
    e.uniform2fv(this.addr, i);
}
function $a42f1354f0348298$var$fg(e, t) {
    const i = $a42f1354f0348298$var$Km(t, this.size, 3);
    e.uniform3fv(this.addr, i);
}
function $a42f1354f0348298$var$_g(e, t) {
    const i = $a42f1354f0348298$var$Km(t, this.size, 4);
    e.uniform4fv(this.addr, i);
}
function $a42f1354f0348298$var$vg(e, t) {
    const i = $a42f1354f0348298$var$Km(t, this.size, 4);
    e.uniformMatrix2fv(this.addr, !1, i);
}
function $a42f1354f0348298$var$Eg(e, t) {
    const i = $a42f1354f0348298$var$Km(t, this.size, 9);
    e.uniformMatrix3fv(this.addr, !1, i);
}
function $a42f1354f0348298$var$yg(e, t) {
    const i = $a42f1354f0348298$var$Km(t, this.size, 16);
    e.uniformMatrix4fv(this.addr, !1, i);
}
function $a42f1354f0348298$var$bg(e, t) {
    e.uniform1iv(this.addr, t);
}
function $a42f1354f0348298$var$kg(e, t) {
    e.uniform2iv(this.addr, t);
}
function $a42f1354f0348298$var$xg(e, t) {
    e.uniform3iv(this.addr, t);
}
function $a42f1354f0348298$var$wg(e, t) {
    e.uniform4iv(this.addr, t);
}
function $a42f1354f0348298$var$Mg(e, t) {
    e.uniform1uiv(this.addr, t);
}
function $a42f1354f0348298$var$Sg(e, t) {
    e.uniform2uiv(this.addr, t);
}
function $a42f1354f0348298$var$Cg(e, t) {
    e.uniform3uiv(this.addr, t);
}
function $a42f1354f0348298$var$Tg(e, t) {
    e.uniform4uiv(this.addr, t);
}
function $a42f1354f0348298$var$Dg(e, t, i) {
    const n = this.cache, a = t.length, r = $a42f1354f0348298$var$Qm(i, a);
    let s;
    $a42f1354f0348298$var$Wm(n, r) || (e.uniform1iv(this.addr, r), $a42f1354f0348298$var$Xm(n, r)), s = this.type === e.SAMPLER_2D_SHADOW ? $a42f1354f0348298$var$Um : $a42f1354f0348298$var$Fm;
    for(let e = 0; e !== a; ++e)i.setTexture2D(t[e] || s, r[e]);
}
function $a42f1354f0348298$var$Pg(e, t, i) {
    const n = this.cache, a = t.length, r = $a42f1354f0348298$var$Qm(i, a);
    $a42f1354f0348298$var$Wm(n, r) || (e.uniform1iv(this.addr, r), $a42f1354f0348298$var$Xm(n, r));
    for(let e = 0; e !== a; ++e)i.setTexture3D(t[e] || $a42f1354f0348298$var$Bm, r[e]);
}
function $a42f1354f0348298$var$Ig(e, t, i) {
    const n = this.cache, a = t.length, r = $a42f1354f0348298$var$Qm(i, a);
    $a42f1354f0348298$var$Wm(n, r) || (e.uniform1iv(this.addr, r), $a42f1354f0348298$var$Xm(n, r));
    for(let e = 0; e !== a; ++e)i.setTextureCube(t[e] || $a42f1354f0348298$var$Om, r[e]);
}
function $a42f1354f0348298$var$Lg(e, t, i) {
    const n = this.cache, a = t.length, r = $a42f1354f0348298$var$Qm(i, a);
    $a42f1354f0348298$var$Wm(n, r) || (e.uniform1iv(this.addr, r), $a42f1354f0348298$var$Xm(n, r));
    for(let e = 0; e !== a; ++e)i.setTexture2DArray(t[e] || $a42f1354f0348298$var$Nm, r[e]);
}
class $a42f1354f0348298$var$Rg {
    constructor(e, t, i){
        this.id = e, this.addr = i, this.cache = [], this.type = t.type, this.setValue = function(e) {
            switch(e){
                case 5126:
                    return $a42f1354f0348298$var$Zm;
                case 35664:
                    return $a42f1354f0348298$var$Ym;
                case 35665:
                    return $a42f1354f0348298$var$Jm;
                case 35666:
                    return $a42f1354f0348298$var$$m;
                case 35674:
                    return $a42f1354f0348298$var$eg;
                case 35675:
                    return $a42f1354f0348298$var$tg;
                case 35676:
                    return $a42f1354f0348298$var$ig;
                case 5124:
                case 35670:
                    return $a42f1354f0348298$var$ng;
                case 35667:
                case 35671:
                    return $a42f1354f0348298$var$ag;
                case 35668:
                case 35672:
                    return $a42f1354f0348298$var$rg;
                case 35669:
                case 35673:
                    return $a42f1354f0348298$var$sg;
                case 5125:
                    return $a42f1354f0348298$var$og;
                case 36294:
                    return $a42f1354f0348298$var$lg;
                case 36295:
                    return $a42f1354f0348298$var$cg;
                case 36296:
                    return $a42f1354f0348298$var$dg;
                case 35678:
                case 36198:
                case 36298:
                case 36306:
                case 35682:
                    return $a42f1354f0348298$var$ug;
                case 35679:
                case 36299:
                case 36307:
                    return $a42f1354f0348298$var$hg;
                case 35680:
                case 36300:
                case 36308:
                case 36293:
                    return $a42f1354f0348298$var$pg;
                case 36289:
                case 36303:
                case 36311:
                case 36292:
                    return $a42f1354f0348298$var$Ag;
            }
        }(t.type);
    }
}
class $a42f1354f0348298$var$zg {
    constructor(e, t, i){
        this.id = e, this.addr = i, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = function(e) {
            switch(e){
                case 5126:
                    return $a42f1354f0348298$var$mg;
                case 35664:
                    return $a42f1354f0348298$var$gg;
                case 35665:
                    return $a42f1354f0348298$var$fg;
                case 35666:
                    return $a42f1354f0348298$var$_g;
                case 35674:
                    return $a42f1354f0348298$var$vg;
                case 35675:
                    return $a42f1354f0348298$var$Eg;
                case 35676:
                    return $a42f1354f0348298$var$yg;
                case 5124:
                case 35670:
                    return $a42f1354f0348298$var$bg;
                case 35667:
                case 35671:
                    return $a42f1354f0348298$var$kg;
                case 35668:
                case 35672:
                    return $a42f1354f0348298$var$xg;
                case 35669:
                case 35673:
                    return $a42f1354f0348298$var$wg;
                case 5125:
                    return $a42f1354f0348298$var$Mg;
                case 36294:
                    return $a42f1354f0348298$var$Sg;
                case 36295:
                    return $a42f1354f0348298$var$Cg;
                case 36296:
                    return $a42f1354f0348298$var$Tg;
                case 35678:
                case 36198:
                case 36298:
                case 36306:
                case 35682:
                    return $a42f1354f0348298$var$Dg;
                case 35679:
                case 36299:
                case 36307:
                    return $a42f1354f0348298$var$Pg;
                case 35680:
                case 36300:
                case 36308:
                case 36293:
                    return $a42f1354f0348298$var$Ig;
                case 36289:
                case 36303:
                case 36311:
                case 36292:
                    return $a42f1354f0348298$var$Lg;
            }
        }(t.type);
    }
}
class $a42f1354f0348298$var$Fg {
    constructor(e){
        this.id = e, this.seq = [], this.map = {};
    }
    setValue(e, t, i) {
        const n = this.seq;
        for(let a = 0, r = n.length; a !== r; ++a){
            const r = n[a];
            r.setValue(e, t[r.id], i);
        }
    }
}
const $a42f1354f0348298$var$Ug = /(\w+)(\])?(\[|\.)?/g;
function $a42f1354f0348298$var$Ng(e, t) {
    e.seq.push(t), e.map[t.id] = t;
}
function $a42f1354f0348298$var$Bg(e, t, i) {
    const n = e.name, a = n.length;
    for($a42f1354f0348298$var$Ug.lastIndex = 0;;){
        const r = $a42f1354f0348298$var$Ug.exec(n), s = $a42f1354f0348298$var$Ug.lastIndex;
        let o = r[1];
        const l = "]" === r[2], c = r[3];
        if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === a) {
            $a42f1354f0348298$var$Ng(i, void 0 === c ? new $a42f1354f0348298$var$Rg(o, e, t) : new $a42f1354f0348298$var$zg(o, e, t));
            break;
        }
        {
            let e = i.map[o];
            void 0 === e && (e = new $a42f1354f0348298$var$Fg(o), $a42f1354f0348298$var$Ng(i, e)), i = e;
        }
    }
}
class $a42f1354f0348298$var$Og {
    constructor(e, t){
        this.seq = [], this.map = {};
        const i = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
        for(let n = 0; n < i; ++n){
            const i = e.getActiveUniform(t, n);
            $a42f1354f0348298$var$Bg(i, e.getUniformLocation(t, i.name), this);
        }
        const n = [], a = [];
        for (const t of this.seq)t.type === e.SAMPLER_2D_SHADOW || t.type === e.SAMPLER_CUBE_SHADOW || t.type === e.SAMPLER_2D_ARRAY_SHADOW ? n.push(t) : a.push(t);
        n.length > 0 && (this.seq = n.concat(a));
    }
    setValue(e, t, i, n) {
        const a = this.map[t];
        void 0 !== a && a.setValue(e, i, n);
    }
    setOptional(e, t, i) {
        const n = t[i];
        void 0 !== n && this.setValue(e, i, n);
    }
    static upload(e, t, i, n) {
        for(let a = 0, r = t.length; a !== r; ++a){
            const r = t[a], s = i[r.id];
            !1 !== s.needsUpdate && r.setValue(e, s.value, n);
        }
    }
    static seqWithValue(e, t) {
        const i = [];
        for(let n = 0, a = e.length; n !== a; ++n){
            const a = e[n];
            a.id in t && i.push(a);
        }
        return i;
    }
}
function $a42f1354f0348298$var$jg(e, t, i) {
    const n = e.createShader(t);
    return e.shaderSource(n, i), e.compileShader(n), n;
}
let $a42f1354f0348298$var$Gg = 0;
const $a42f1354f0348298$var$Vg = new $a42f1354f0348298$var$Au;
function $a42f1354f0348298$var$Hg(e, t, i) {
    const n = e.getShaderParameter(t, e.COMPILE_STATUS), a = (e.getShaderInfoLog(t) || "").trim();
    if (n && "" === a) return "";
    const r = /ERROR: 0:(\d+)/.exec(a);
    if (r) {
        const n = parseInt(r[1]);
        return i.toUpperCase() + "\n\n" + a + "\n\n" + function(e, t) {
            const i = e.split("\n"), n = [], a = Math.max(t - 6, 0), r = Math.min(t + 6, i.length);
            for(let e = a; e < r; e++){
                const a = e + 1;
                n.push(`${a === t ? ">" : " "} ${a}: ${i[e]}`);
            }
            return n.join("\n");
        }(e.getShaderSource(t), n);
    }
    return a;
}
function $a42f1354f0348298$var$qg(e, t) {
    const i = function(e) {
        $a42f1354f0348298$var$vu._getMatrix($a42f1354f0348298$var$Vg, $a42f1354f0348298$var$vu.workingColorSpace, e);
        const t = `mat3( ${$a42f1354f0348298$var$Vg.elements.map((e)=>e.toFixed(4))} )`;
        switch($a42f1354f0348298$var$vu.getTransfer(e)){
            case $a42f1354f0348298$var$Cd:
                return [
                    t,
                    "LinearTransferOETF"
                ];
            case $a42f1354f0348298$var$Td:
                return [
                    t,
                    "sRGBTransferOETF"
                ];
            default:
                return $a42f1354f0348298$var$Wd("WebGLProgram: Unsupported color space: ", e), [
                    t,
                    "LinearTransferOETF"
                ];
        }
    }(t);
    return [
        `vec4 ${e}( vec4 value ) {`,
        `\treturn ${i[1]}( vec4( value.rgb * ${i[0]}, value.a ) );`,
        "}"
    ].join("\n");
}
const $a42f1354f0348298$var$Kg = {
    [$a42f1354f0348298$var$ic]: "Linear",
    [$a42f1354f0348298$var$nc]: "Reinhard",
    [$a42f1354f0348298$var$ac]: "Cineon",
    [$a42f1354f0348298$var$rc]: "ACESFilmic",
    [$a42f1354f0348298$var$oc]: "AgX",
    [$a42f1354f0348298$var$lc]: "Neutral",
    [$a42f1354f0348298$var$sc]: "Custom"
};
function $a42f1354f0348298$var$Wg(e, t) {
    const i = $a42f1354f0348298$var$Kg[t];
    return void 0 === i ? ($a42f1354f0348298$var$Wd("WebGLProgram: Unsupported toneMapping:", t), "vec3 " + e + "( vec3 color ) { return LinearToneMapping( color ); }") : "vec3 " + e + "( vec3 color ) { return " + i + "ToneMapping( color ); }";
}
const $a42f1354f0348298$var$Xg = new $a42f1354f0348298$var$uu;
function $a42f1354f0348298$var$Qg() {
    $a42f1354f0348298$var$vu.getLuminanceCoefficients($a42f1354f0348298$var$Xg);
    return [
        "float luminance( const in vec3 rgb ) {",
        `\tconst vec3 weights = vec3( ${$a42f1354f0348298$var$Xg.x.toFixed(4)}, ${$a42f1354f0348298$var$Xg.y.toFixed(4)}, ${$a42f1354f0348298$var$Xg.z.toFixed(4)} );`,
        "\treturn dot( weights, rgb );",
        "}"
    ].join("\n");
}
function $a42f1354f0348298$var$Zg(e) {
    return "" !== e;
}
function $a42f1354f0348298$var$Yg(e, t) {
    const i = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, i).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function $a42f1354f0348298$var$Jg(e, t) {
    return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
const $a42f1354f0348298$var$$g = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $a42f1354f0348298$var$ef(e) {
    return e.replace($a42f1354f0348298$var$$g, $a42f1354f0348298$var$nf);
}
const $a42f1354f0348298$var$tf = new Map;
function $a42f1354f0348298$var$nf(e, t) {
    let i = $a42f1354f0348298$var$em[t];
    if (void 0 === i) {
        const e = $a42f1354f0348298$var$tf.get(t);
        if (void 0 === e) throw new Error("THREE.WebGLProgram: Can not resolve #include <" + t + ">");
        i = $a42f1354f0348298$var$em[e], $a42f1354f0348298$var$Wd('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', t, e);
    }
    return $a42f1354f0348298$var$ef(i);
}
const $a42f1354f0348298$var$af = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $a42f1354f0348298$var$rf(e) {
    return e.replace($a42f1354f0348298$var$af, $a42f1354f0348298$var$sf);
}
function $a42f1354f0348298$var$sf(e, t, i, n) {
    let a = "";
    for(let e = parseInt(t); e < parseInt(i); e++)a += n.replace(/\[\s*i\s*\]/g, "[ " + e + " ]").replace(/UNROLLED_LOOP_INDEX/g, e);
    return a;
}
function $a42f1354f0348298$var$of(e) {
    let t = `precision ${e.precision} float;\n\tprecision ${e.precision} int;\n\tprecision ${e.precision} sampler2D;\n\tprecision ${e.precision} samplerCube;\n\tprecision ${e.precision} sampler3D;\n\tprecision ${e.precision} sampler2DArray;\n\tprecision ${e.precision} sampler2DShadow;\n\tprecision ${e.precision} samplerCubeShadow;\n\tprecision ${e.precision} sampler2DArrayShadow;\n\tprecision ${e.precision} isampler2D;\n\tprecision ${e.precision} isampler3D;\n\tprecision ${e.precision} isamplerCube;\n\tprecision ${e.precision} isampler2DArray;\n\tprecision ${e.precision} usampler2D;\n\tprecision ${e.precision} usampler3D;\n\tprecision ${e.precision} usamplerCube;\n\tprecision ${e.precision} usampler2DArray;\n\t`;
    return "highp" === e.precision ? t += "\n#define HIGH_PRECISION" : "mediump" === e.precision ? t += "\n#define MEDIUM_PRECISION" : "lowp" === e.precision && (t += "\n#define LOW_PRECISION"), t;
}
const $a42f1354f0348298$var$lf = {
    [$a42f1354f0348298$var$bl]: "SHADOWMAP_TYPE_PCF",
    [$a42f1354f0348298$var$kl]: "SHADOWMAP_TYPE_VSM"
};
const $a42f1354f0348298$var$cf = {
    [$a42f1354f0348298$var$cc]: "ENVMAP_TYPE_CUBE",
    [$a42f1354f0348298$var$dc]: "ENVMAP_TYPE_CUBE",
    [$a42f1354f0348298$var$pc]: "ENVMAP_TYPE_CUBE_UV"
};
const $a42f1354f0348298$var$df = {
    [$a42f1354f0348298$var$dc]: "ENVMAP_MODE_REFRACTION"
};
const $a42f1354f0348298$var$uf = {
    [$a42f1354f0348298$var$$l]: "ENVMAP_BLENDING_MULTIPLY",
    [$a42f1354f0348298$var$ec]: "ENVMAP_BLENDING_MIX",
    [$a42f1354f0348298$var$tc]: "ENVMAP_BLENDING_ADD"
};
function $a42f1354f0348298$var$hf(e, t, i, n) {
    const a = e.getContext(), r = i.defines;
    let s = i.vertexShader, o = i.fragmentShader;
    const l = function(e) {
        return $a42f1354f0348298$var$lf[e.shadowMapType] || "SHADOWMAP_TYPE_BASIC";
    }(i), c = function(e) {
        return !1 === e.envMap ? "ENVMAP_TYPE_CUBE" : $a42f1354f0348298$var$cf[e.envMapMode] || "ENVMAP_TYPE_CUBE";
    }(i), d = function(e) {
        return !1 === e.envMap ? "ENVMAP_MODE_REFLECTION" : $a42f1354f0348298$var$df[e.envMapMode] || "ENVMAP_MODE_REFLECTION";
    }(i), u = function(e) {
        return !1 === e.envMap ? "ENVMAP_BLENDING_NONE" : $a42f1354f0348298$var$uf[e.combine] || "ENVMAP_BLENDING_NONE";
    }(i), h = function(e) {
        const t = e.envMapCubeUVHeight;
        if (null === t) return null;
        const i = Math.log2(t) - 2, n = 1 / t;
        return {
            texelWidth: 1 / (3 * Math.max(Math.pow(2, i), 112)),
            texelHeight: n,
            maxMip: i
        };
    }(i), p = function(e) {
        return [
            e.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
            e.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
        ].filter($a42f1354f0348298$var$Zg).join("\n");
    }(i), A = function(e) {
        const t = [];
        for(const i in e){
            const n = e[i];
            !1 !== n && t.push("#define " + i + " " + n);
        }
        return t.join("\n");
    }(r), m = a.createProgram();
    let g, f, _ = i.glslVersion ? "#version " + i.glslVersion + "\n" : "";
    i.isRawShaderMaterial ? (g = [
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        A
    ].filter($a42f1354f0348298$var$Zg).join("\n"), g.length > 0 && (g += "\n"), f = [
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        A
    ].filter($a42f1354f0348298$var$Zg).join("\n"), f.length > 0 && (f += "\n")) : (g = [
        $a42f1354f0348298$var$of(i),
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        A,
        i.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        i.batching ? "#define USE_BATCHING" : "",
        i.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        i.instancing ? "#define USE_INSTANCING" : "",
        i.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        i.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        i.useFog && i.fog ? "#define USE_FOG" : "",
        i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
        i.map ? "#define USE_MAP" : "",
        i.envMap ? "#define USE_ENVMAP" : "",
        i.envMap ? "#define " + d : "",
        i.lightMap ? "#define USE_LIGHTMAP" : "",
        i.aoMap ? "#define USE_AOMAP" : "",
        i.bumpMap ? "#define USE_BUMPMAP" : "",
        i.normalMap ? "#define USE_NORMALMAP" : "",
        i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        i.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        i.anisotropy ? "#define USE_ANISOTROPY" : "",
        i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        i.specularMap ? "#define USE_SPECULARMAP" : "",
        i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        i.metalnessMap ? "#define USE_METALNESSMAP" : "",
        i.alphaMap ? "#define USE_ALPHAMAP" : "",
        i.alphaHash ? "#define USE_ALPHAHASH" : "",
        i.transmission ? "#define USE_TRANSMISSION" : "",
        i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        i.mapUv ? "#define MAP_UV " + i.mapUv : "",
        i.alphaMapUv ? "#define ALPHAMAP_UV " + i.alphaMapUv : "",
        i.lightMapUv ? "#define LIGHTMAP_UV " + i.lightMapUv : "",
        i.aoMapUv ? "#define AOMAP_UV " + i.aoMapUv : "",
        i.emissiveMapUv ? "#define EMISSIVEMAP_UV " + i.emissiveMapUv : "",
        i.bumpMapUv ? "#define BUMPMAP_UV " + i.bumpMapUv : "",
        i.normalMapUv ? "#define NORMALMAP_UV " + i.normalMapUv : "",
        i.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + i.displacementMapUv : "",
        i.metalnessMapUv ? "#define METALNESSMAP_UV " + i.metalnessMapUv : "",
        i.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + i.roughnessMapUv : "",
        i.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + i.anisotropyMapUv : "",
        i.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + i.clearcoatMapUv : "",
        i.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + i.clearcoatNormalMapUv : "",
        i.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + i.clearcoatRoughnessMapUv : "",
        i.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + i.iridescenceMapUv : "",
        i.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + i.iridescenceThicknessMapUv : "",
        i.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + i.sheenColorMapUv : "",
        i.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + i.sheenRoughnessMapUv : "",
        i.specularMapUv ? "#define SPECULARMAP_UV " + i.specularMapUv : "",
        i.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + i.specularColorMapUv : "",
        i.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + i.specularIntensityMapUv : "",
        i.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + i.transmissionMapUv : "",
        i.thicknessMapUv ? "#define THICKNESSMAP_UV " + i.thicknessMapUv : "",
        i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
        i.vertexNormals ? "#define HAS_NORMAL" : "",
        i.vertexColors ? "#define USE_COLOR" : "",
        i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        i.vertexUv1s ? "#define USE_UV1" : "",
        i.vertexUv2s ? "#define USE_UV2" : "",
        i.vertexUv3s ? "#define USE_UV3" : "",
        i.pointsUvs ? "#define USE_POINTS_UV" : "",
        i.flatShading ? "#define FLAT_SHADED" : "",
        i.skinning ? "#define USE_SKINNING" : "",
        i.morphTargets ? "#define USE_MORPHTARGETS" : "",
        i.morphNormals && !1 === i.flatShading ? "#define USE_MORPHNORMALS" : "",
        i.morphColors ? "#define USE_MORPHCOLORS" : "",
        i.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + i.morphTextureStride : "",
        i.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + i.morphTargetsCount : "",
        i.doubleSided ? "#define DOUBLE_SIDED" : "",
        i.flipSided ? "#define FLIP_SIDED" : "",
        i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        i.shadowMapEnabled ? "#define " + l : "",
        i.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        i.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        i.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "\tattribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "\tattribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "\tuniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "\tattribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "\tattribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "\tattribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "\tattribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "\tattribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "\tattribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "\tattribute vec4 skinIndex;",
        "\tattribute vec4 skinWeight;",
        "#endif",
        "\n"
    ].filter($a42f1354f0348298$var$Zg).join("\n"), f = [
        $a42f1354f0348298$var$of(i),
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        A,
        i.useFog && i.fog ? "#define USE_FOG" : "",
        i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
        i.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        i.map ? "#define USE_MAP" : "",
        i.matcap ? "#define USE_MATCAP" : "",
        i.envMap ? "#define USE_ENVMAP" : "",
        i.envMap ? "#define " + c : "",
        i.envMap ? "#define " + d : "",
        i.envMap ? "#define " + u : "",
        h ? "#define CUBEUV_TEXEL_WIDTH " + h.texelWidth : "",
        h ? "#define CUBEUV_TEXEL_HEIGHT " + h.texelHeight : "",
        h ? "#define CUBEUV_MAX_MIP " + h.maxMip + ".0" : "",
        i.lightMap ? "#define USE_LIGHTMAP" : "",
        i.aoMap ? "#define USE_AOMAP" : "",
        i.bumpMap ? "#define USE_BUMPMAP" : "",
        i.normalMap ? "#define USE_NORMALMAP" : "",
        i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        i.packedNormalMap ? "#define USE_PACKED_NORMALMAP" : "",
        i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        i.anisotropy ? "#define USE_ANISOTROPY" : "",
        i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        i.clearcoat ? "#define USE_CLEARCOAT" : "",
        i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        i.dispersion ? "#define USE_DISPERSION" : "",
        i.iridescence ? "#define USE_IRIDESCENCE" : "",
        i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        i.specularMap ? "#define USE_SPECULARMAP" : "",
        i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        i.metalnessMap ? "#define USE_METALNESSMAP" : "",
        i.alphaMap ? "#define USE_ALPHAMAP" : "",
        i.alphaTest ? "#define USE_ALPHATEST" : "",
        i.alphaHash ? "#define USE_ALPHAHASH" : "",
        i.sheen ? "#define USE_SHEEN" : "",
        i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        i.transmission ? "#define USE_TRANSMISSION" : "",
        i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
        i.vertexColors || i.instancingColor ? "#define USE_COLOR" : "",
        i.vertexAlphas || i.batchingColor ? "#define USE_COLOR_ALPHA" : "",
        i.vertexUv1s ? "#define USE_UV1" : "",
        i.vertexUv2s ? "#define USE_UV2" : "",
        i.vertexUv3s ? "#define USE_UV3" : "",
        i.pointsUvs ? "#define USE_POINTS_UV" : "",
        i.gradientMap ? "#define USE_GRADIENTMAP" : "",
        i.flatShading ? "#define FLAT_SHADED" : "",
        i.doubleSided ? "#define DOUBLE_SIDED" : "",
        i.flipSided ? "#define FLIP_SIDED" : "",
        i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        i.shadowMapEnabled ? "#define " + l : "",
        i.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        i.numLightProbeGrids > 0 ? "#define USE_LIGHT_PROBES_GRID" : "",
        i.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        i.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        i.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        i.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        0 !== i.toneMapping ? "#define TONE_MAPPING" : "",
        0 !== i.toneMapping ? $a42f1354f0348298$var$em.tonemapping_pars_fragment : "",
        0 !== i.toneMapping ? $a42f1354f0348298$var$Wg("toneMapping", i.toneMapping) : "",
        i.dithering ? "#define DITHERING" : "",
        i.opaque ? "#define OPAQUE" : "",
        $a42f1354f0348298$var$em.colorspace_pars_fragment,
        $a42f1354f0348298$var$qg("linearToOutputTexel", i.outputColorSpace),
        $a42f1354f0348298$var$Qg(),
        i.useDepthPacking ? "#define DEPTH_PACKING " + i.depthPacking : "",
        "\n"
    ].filter($a42f1354f0348298$var$Zg).join("\n")), s = $a42f1354f0348298$var$ef(s), s = $a42f1354f0348298$var$Yg(s, i), s = $a42f1354f0348298$var$Jg(s, i), o = $a42f1354f0348298$var$ef(o), o = $a42f1354f0348298$var$Yg(o, i), o = $a42f1354f0348298$var$Jg(o, i), s = $a42f1354f0348298$var$rf(s), o = $a42f1354f0348298$var$rf(o), !0 !== i.isRawShaderMaterial && (_ = "#version 300 es\n", g = [
        p,
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join("\n") + "\n" + g, f = [
        "#define varying in",
        i.glslVersion === $a42f1354f0348298$var$Bd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        i.glslVersion === $a42f1354f0348298$var$Bd ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + f);
    const v = _ + g + s, E = _ + f + o, y = $a42f1354f0348298$var$jg(a, a.VERTEX_SHADER, v), b = $a42f1354f0348298$var$jg(a, a.FRAGMENT_SHADER, E);
    function k(t) {
        if (e.debug.checkShaderErrors) {
            const i = a.getProgramInfoLog(m) || "", n = a.getShaderInfoLog(y) || "", r = a.getShaderInfoLog(b) || "", s = i.trim(), o = n.trim(), l = r.trim();
            let c = !0, d = !0;
            if (!1 === a.getProgramParameter(m, a.LINK_STATUS)) {
                if (c = !1, "function" == typeof e.debug.onShaderError) e.debug.onShaderError(a, m, y, b);
                else {
                    const e = $a42f1354f0348298$var$Hg(a, y, "vertex"), i = $a42f1354f0348298$var$Hg(a, b, "fragment");
                    $a42f1354f0348298$var$Xd("WebGLProgram: Shader Error " + a.getError() + " - VALIDATE_STATUS " + a.getProgramParameter(m, a.VALIDATE_STATUS) + "\n\nMaterial Name: " + t.name + "\nMaterial Type: " + t.type + "\n\nProgram Info Log: " + s + "\n" + e + "\n" + i);
                }
            } else "" !== s ? $a42f1354f0348298$var$Wd("WebGLProgram: Program Info Log:", s) : "" !== o && "" !== l || (d = !1);
            d && (t.diagnostics = {
                runnable: c,
                programLog: s,
                vertexShader: {
                    log: o,
                    prefix: g
                },
                fragmentShader: {
                    log: l,
                    prefix: f
                }
            });
        }
        a.deleteShader(y), a.deleteShader(b), x = new $a42f1354f0348298$var$Og(a, m), w = function(e, t) {
            const i = {}, n = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
            for(let a = 0; a < n; a++){
                const n = e.getActiveAttrib(t, a), r = n.name;
                let s = 1;
                n.type === e.FLOAT_MAT2 && (s = 2), n.type === e.FLOAT_MAT3 && (s = 3), n.type === e.FLOAT_MAT4 && (s = 4), i[r] = {
                    type: n.type,
                    location: e.getAttribLocation(t, r),
                    locationSize: s
                };
            }
            return i;
        }(a, m);
    }
    let x, w;
    a.attachShader(m, y), a.attachShader(m, b), void 0 !== i.index0AttributeName ? a.bindAttribLocation(m, 0, i.index0AttributeName) : !0 === i.hasPositionAttribute && a.bindAttribLocation(m, 0, "position"), a.linkProgram(m), this.getUniforms = function() {
        return void 0 === x && k(this), x;
    }, this.getAttributes = function() {
        return void 0 === w && k(this), w;
    };
    let M = !1 === i.rendererExtensionParallelShaderCompile;
    return this.isReady = function() {
        return !1 === M && (M = a.getProgramParameter(m, 37297)), M;
    }, this.destroy = function() {
        n.releaseStatesOfProgram(this), a.deleteProgram(m), this.program = void 0;
    }, this.type = i.shaderType, this.name = i.shaderName, this.id = $a42f1354f0348298$var$Gg++, this.cacheKey = t, this.usedTimes = 1, this.program = m, this.vertexShader = y, this.fragmentShader = b, this;
}
let $a42f1354f0348298$var$pf = 0;
class $a42f1354f0348298$var$Af {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(e, t, i) {
        const n = this._getShaderCacheForMaterial(e);
        return !1 === n.has(t) && (n.add(t), t.usedTimes++), !1 === n.has(i) && (n.add(i), i.usedTimes++), this;
    }
    remove(e) {
        const t = this.materialCache.get(e);
        for (const e of t)e.usedTimes--, 0 === e.usedTimes && this.shaderCache.delete(e.code);
        return this.materialCache.delete(e), this;
    }
    getVertexShaderStage(e) {
        return this._getShaderStage(e.vertexShader);
    }
    getFragmentShaderStage(e) {
        return this._getShaderStage(e.fragmentShader);
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(e) {
        const t = this.materialCache;
        let i = t.get(e);
        return void 0 === i && (i = new Set, t.set(e, i)), i;
    }
    _getShaderStage(e) {
        const t = this.shaderCache;
        let i = t.get(e);
        return void 0 === i && (i = new $a42f1354f0348298$var$mf(e), t.set(e, i)), i;
    }
}
class $a42f1354f0348298$var$mf {
    constructor(e){
        this.id = $a42f1354f0348298$var$pf++, this.code = e, this.usedTimes = 0;
    }
}
function $a42f1354f0348298$var$gf(e, t, i, n, a, r) {
    const s = new $a42f1354f0348298$var$Ku, o = new $a42f1354f0348298$var$Af, l = new Set, c = [], d = new Map, u = n.logarithmicDepthBuffer;
    let h = n.precision;
    const p = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distance",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function A(e) {
        return l.add(e), 0 === e ? "uv" : `uv${e}`;
    }
    return {
        getParameters: function(a, s, c, d, m, g) {
            const f = d.fog, _ = m.geometry, v = a.isMeshStandardMaterial || a.isMeshLambertMaterial || a.isMeshPhongMaterial ? d.environment : null, E = a.isMeshStandardMaterial || a.isMeshLambertMaterial && !a.envMap || a.isMeshPhongMaterial && !a.envMap, y = t.get(a.envMap || v, E), b = y && y.mapping === $a42f1354f0348298$var$pc ? y.image.height : null, k = p[a.type];
            null !== a.precision && (h = n.getMaxPrecision(a.precision), h !== a.precision && $a42f1354f0348298$var$Wd("WebGLProgram.getParameters:", a.precision, "not supported, using", h, "instead."));
            const x = _.morphAttributes.position || _.morphAttributes.normal || _.morphAttributes.color, w = void 0 !== x ? x.length : 0;
            let M, S, C, T, D = 0;
            if (void 0 !== _.morphAttributes.position && (D = 1), void 0 !== _.morphAttributes.normal && (D = 2), void 0 !== _.morphAttributes.color && (D = 3), k) {
                const e = $a42f1354f0348298$var$im[k];
                M = e.vertexShader, S = e.fragmentShader;
            } else {
                M = a.vertexShader, S = a.fragmentShader;
                const e = o.getVertexShaderStage(a), t = o.getFragmentShaderStage(a);
                o.update(a, e, t), C = e.id, T = t.id;
            }
            const P = e.getRenderTarget(), I = e.state.buffers.depth.getReversed(), L = !0 === m.isInstancedMesh, R = !0 === m.isBatchedMesh, z = !!a.map, F = !!a.matcap, U = !!y, N = !!a.aoMap, B = !!a.lightMap, O = !!a.bumpMap && !1 === a.wireframe, j = !!a.normalMap, G = !!a.displacementMap, V = !!a.emissiveMap, H = !!a.metalnessMap, q = !!a.roughnessMap, K = a.anisotropy > 0, W = a.clearcoat > 0, X = a.dispersion > 0, Q = a.iridescence > 0, Z = a.sheen > 0, Y = a.transmission > 0, J = K && !!a.anisotropyMap, $ = W && !!a.clearcoatMap, ee = W && !!a.clearcoatNormalMap, te = W && !!a.clearcoatRoughnessMap, ie = Q && !!a.iridescenceMap, ne = Q && !!a.iridescenceThicknessMap, ae = Z && !!a.sheenColorMap, re = Z && !!a.sheenRoughnessMap, se = !!a.specularMap, oe = !!a.specularColorMap, le = !!a.specularIntensityMap, ce = Y && !!a.transmissionMap, de = Y && !!a.thicknessMap, ue = !!a.gradientMap, he = !!a.alphaMap, pe = a.alphaTest > 0, Ae = !!a.alphaHash, me = !!a.extensions;
            let ge = 0;
            a.toneMapped && (null !== P && !0 !== P.isXRRenderTarget || (ge = e.toneMapping));
            const fe = {
                shaderID: k,
                shaderType: a.type,
                shaderName: a.name,
                vertexShader: M,
                fragmentShader: S,
                defines: a.defines,
                customVertexShaderID: C,
                customFragmentShaderID: T,
                isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                glslVersion: a.glslVersion,
                precision: h,
                batching: R,
                batchingColor: R && null !== m._colorsTexture,
                instancing: L,
                instancingColor: L && null !== m.instanceColor,
                instancingMorph: L && null !== m.morphTexture,
                outputColorSpace: null === P ? e.outputColorSpace : !0 === P.isXRRenderTarget ? P.texture.colorSpace : $a42f1354f0348298$var$vu.workingColorSpace,
                alphaToCoverage: !!a.alphaToCoverage,
                map: z,
                matcap: F,
                envMap: U,
                envMapMode: U && y.mapping,
                envMapCubeUVHeight: b,
                aoMap: N,
                lightMap: B,
                bumpMap: O,
                normalMap: j,
                displacementMap: G,
                emissiveMap: V,
                normalMapObjectSpace: j && 1 === a.normalMapType,
                normalMapTangentSpace: j && 0 === a.normalMapType,
                packedNormalMap: j && 0 === a.normalMapType && (_e = a.normalMap.format, _e === $a42f1354f0348298$var$Oc || _e === $a42f1354f0348298$var$id || _e === $a42f1354f0348298$var$kd),
                metalnessMap: H,
                roughnessMap: q,
                anisotropy: K,
                anisotropyMap: J,
                clearcoat: W,
                clearcoatMap: $,
                clearcoatNormalMap: ee,
                clearcoatRoughnessMap: te,
                dispersion: X,
                iridescence: Q,
                iridescenceMap: ie,
                iridescenceThicknessMap: ne,
                sheen: Z,
                sheenColorMap: ae,
                sheenRoughnessMap: re,
                specularMap: se,
                specularColorMap: oe,
                specularIntensityMap: le,
                transmission: Y,
                transmissionMap: ce,
                thicknessMap: de,
                gradientMap: ue,
                opaque: !1 === a.transparent && 1 === a.blending && !1 === a.alphaToCoverage,
                alphaMap: he,
                alphaTest: pe,
                alphaHash: Ae,
                combine: a.combine,
                mapUv: z && A(a.map.channel),
                aoMapUv: N && A(a.aoMap.channel),
                lightMapUv: B && A(a.lightMap.channel),
                bumpMapUv: O && A(a.bumpMap.channel),
                normalMapUv: j && A(a.normalMap.channel),
                displacementMapUv: G && A(a.displacementMap.channel),
                emissiveMapUv: V && A(a.emissiveMap.channel),
                metalnessMapUv: H && A(a.metalnessMap.channel),
                roughnessMapUv: q && A(a.roughnessMap.channel),
                anisotropyMapUv: J && A(a.anisotropyMap.channel),
                clearcoatMapUv: $ && A(a.clearcoatMap.channel),
                clearcoatNormalMapUv: ee && A(a.clearcoatNormalMap.channel),
                clearcoatRoughnessMapUv: te && A(a.clearcoatRoughnessMap.channel),
                iridescenceMapUv: ie && A(a.iridescenceMap.channel),
                iridescenceThicknessMapUv: ne && A(a.iridescenceThicknessMap.channel),
                sheenColorMapUv: ae && A(a.sheenColorMap.channel),
                sheenRoughnessMapUv: re && A(a.sheenRoughnessMap.channel),
                specularMapUv: se && A(a.specularMap.channel),
                specularColorMapUv: oe && A(a.specularColorMap.channel),
                specularIntensityMapUv: le && A(a.specularIntensityMap.channel),
                transmissionMapUv: ce && A(a.transmissionMap.channel),
                thicknessMapUv: de && A(a.thicknessMap.channel),
                alphaMapUv: he && A(a.alphaMap.channel),
                vertexTangents: !!_.attributes.tangent && (j || K),
                vertexNormals: !!_.attributes.normal,
                vertexColors: a.vertexColors,
                vertexAlphas: !0 === a.vertexColors && !!_.attributes.color && 4 === _.attributes.color.itemSize,
                pointsUvs: !0 === m.isPoints && !!_.attributes.uv && (z || he),
                fog: !!f,
                useFog: !0 === a.fog,
                fogExp2: !!f && f.isFogExp2,
                flatShading: !1 === a.wireframe && (!0 === a.flatShading || void 0 === _.attributes.normal && !1 === j && (a.isMeshLambertMaterial || a.isMeshPhongMaterial || a.isMeshStandardMaterial || a.isMeshPhysicalMaterial)),
                sizeAttenuation: !0 === a.sizeAttenuation,
                logarithmicDepthBuffer: u,
                reversedDepthBuffer: I,
                skinning: !0 === m.isSkinnedMesh,
                hasPositionAttribute: void 0 !== _.attributes.position,
                morphTargets: void 0 !== _.morphAttributes.position,
                morphNormals: void 0 !== _.morphAttributes.normal,
                morphColors: void 0 !== _.morphAttributes.color,
                morphTargetsCount: w,
                morphTextureStride: D,
                numDirLights: s.directional.length,
                numPointLights: s.point.length,
                numSpotLights: s.spot.length,
                numSpotLightMaps: s.spotLightMap.length,
                numRectAreaLights: s.rectArea.length,
                numHemiLights: s.hemi.length,
                numDirLightShadows: s.directionalShadowMap.length,
                numPointLightShadows: s.pointShadowMap.length,
                numSpotLightShadows: s.spotShadowMap.length,
                numSpotLightShadowsWithMaps: s.numSpotLightShadowsWithMaps,
                numLightProbes: s.numLightProbes,
                numLightProbeGrids: g.length,
                numClippingPlanes: r.numPlanes,
                numClipIntersection: r.numIntersection,
                dithering: a.dithering,
                shadowMapEnabled: e.shadowMap.enabled && c.length > 0,
                shadowMapType: e.shadowMap.type,
                toneMapping: ge,
                decodeVideoTexture: z && !0 === a.map.isVideoTexture && $a42f1354f0348298$var$vu.getTransfer(a.map.colorSpace) === $a42f1354f0348298$var$Td,
                decodeVideoTextureEmissive: V && !0 === a.emissiveMap.isVideoTexture && $a42f1354f0348298$var$vu.getTransfer(a.emissiveMap.colorSpace) === $a42f1354f0348298$var$Td,
                premultipliedAlpha: a.premultipliedAlpha,
                doubleSided: 2 === a.side,
                flipSided: 1 === a.side,
                useDepthPacking: a.depthPacking >= 0,
                depthPacking: a.depthPacking || 0,
                index0AttributeName: a.index0AttributeName,
                extensionClipCullDistance: me && !0 === a.extensions.clipCullDistance && i.has("WEBGL_clip_cull_distance"),
                extensionMultiDraw: (me && !0 === a.extensions.multiDraw || R) && i.has("WEBGL_multi_draw"),
                rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
                customProgramCacheKey: a.customProgramCacheKey()
            };
            var _e;
            return fe.vertexUv1s = l.has(1), fe.vertexUv2s = l.has(2), fe.vertexUv3s = l.has(3), l.clear(), fe;
        },
        getProgramCacheKey: function(t) {
            const i = [];
            if (t.shaderID ? i.push(t.shaderID) : (i.push(t.customVertexShaderID), i.push(t.customFragmentShaderID)), void 0 !== t.defines) for(const e in t.defines)i.push(e), i.push(t.defines[e]);
            return !1 === t.isRawShaderMaterial && (!function(e, t) {
                e.push(t.precision), e.push(t.outputColorSpace), e.push(t.envMapMode), e.push(t.envMapCubeUVHeight), e.push(t.mapUv), e.push(t.alphaMapUv), e.push(t.lightMapUv), e.push(t.aoMapUv), e.push(t.bumpMapUv), e.push(t.normalMapUv), e.push(t.displacementMapUv), e.push(t.emissiveMapUv), e.push(t.metalnessMapUv), e.push(t.roughnessMapUv), e.push(t.anisotropyMapUv), e.push(t.clearcoatMapUv), e.push(t.clearcoatNormalMapUv), e.push(t.clearcoatRoughnessMapUv), e.push(t.iridescenceMapUv), e.push(t.iridescenceThicknessMapUv), e.push(t.sheenColorMapUv), e.push(t.sheenRoughnessMapUv), e.push(t.specularMapUv), e.push(t.specularColorMapUv), e.push(t.specularIntensityMapUv), e.push(t.transmissionMapUv), e.push(t.thicknessMapUv), e.push(t.combine), e.push(t.fogExp2), e.push(t.sizeAttenuation), e.push(t.morphTargetsCount), e.push(t.morphAttributeCount), e.push(t.numDirLights), e.push(t.numPointLights), e.push(t.numSpotLights), e.push(t.numSpotLightMaps), e.push(t.numHemiLights), e.push(t.numRectAreaLights), e.push(t.numDirLightShadows), e.push(t.numPointLightShadows), e.push(t.numSpotLightShadows), e.push(t.numSpotLightShadowsWithMaps), e.push(t.numLightProbes), e.push(t.shadowMapType), e.push(t.toneMapping), e.push(t.numClippingPlanes), e.push(t.numClipIntersection), e.push(t.depthPacking);
            }(i, t), function(e, t) {
                s.disableAll(), t.instancing && s.enable(0);
                t.instancingColor && s.enable(1);
                t.instancingMorph && s.enable(2);
                t.matcap && s.enable(3);
                t.envMap && s.enable(4);
                t.normalMapObjectSpace && s.enable(5);
                t.normalMapTangentSpace && s.enable(6);
                t.clearcoat && s.enable(7);
                t.iridescence && s.enable(8);
                t.alphaTest && s.enable(9);
                t.vertexColors && s.enable(10);
                t.vertexAlphas && s.enable(11);
                t.vertexUv1s && s.enable(12);
                t.vertexUv2s && s.enable(13);
                t.vertexUv3s && s.enable(14);
                t.vertexTangents && s.enable(15);
                t.anisotropy && s.enable(16);
                t.alphaHash && s.enable(17);
                t.batching && s.enable(18);
                t.dispersion && s.enable(19);
                t.batchingColor && s.enable(20);
                t.gradientMap && s.enable(21);
                t.packedNormalMap && s.enable(22);
                t.vertexNormals && s.enable(23);
                e.push(s.mask), s.disableAll(), t.fog && s.enable(0);
                t.useFog && s.enable(1);
                t.flatShading && s.enable(2);
                t.logarithmicDepthBuffer && s.enable(3);
                t.reversedDepthBuffer && s.enable(4);
                t.skinning && s.enable(5);
                t.morphTargets && s.enable(6);
                t.morphNormals && s.enable(7);
                t.morphColors && s.enable(8);
                t.premultipliedAlpha && s.enable(9);
                t.shadowMapEnabled && s.enable(10);
                t.doubleSided && s.enable(11);
                t.flipSided && s.enable(12);
                t.useDepthPacking && s.enable(13);
                t.dithering && s.enable(14);
                t.transmission && s.enable(15);
                t.sheen && s.enable(16);
                t.opaque && s.enable(17);
                t.pointsUvs && s.enable(18);
                t.decodeVideoTexture && s.enable(19);
                t.decodeVideoTextureEmissive && s.enable(20);
                t.alphaToCoverage && s.enable(21);
                t.numLightProbeGrids > 0 && s.enable(22);
                t.hasPositionAttribute && s.enable(23);
                e.push(s.mask);
            }(i, t), i.push(e.outputColorSpace)), i.push(t.customProgramCacheKey), i.join();
        },
        getUniforms: function(e) {
            const t = p[e.type];
            let i;
            if (t) {
                const e = $a42f1354f0348298$var$im[t];
                i = $a42f1354f0348298$var$vA.clone(e.uniforms);
            } else i = e.uniforms;
            return i;
        },
        acquireProgram: function(t, i) {
            let n = d.get(i);
            return void 0 !== n ? ++n.usedTimes : (n = new $a42f1354f0348298$var$hf(e, i, t, a), c.push(n), d.set(i, n)), n;
        },
        releaseProgram: function(e) {
            if (0 === --e.usedTimes) {
                const t = c.indexOf(e);
                c[t] = c[c.length - 1], c.pop(), d.delete(e.cacheKey), e.destroy();
            }
        },
        releaseShaderCache: function(e) {
            o.remove(e);
        },
        programs: c,
        dispose: function() {
            o.dispose();
        }
    };
}
function $a42f1354f0348298$var$ff() {
    let e = new WeakMap;
    return {
        has: function(t) {
            return e.has(t);
        },
        get: function(t) {
            let i = e.get(t);
            return void 0 === i && (i = {}, e.set(t, i)), i;
        },
        remove: function(t) {
            e.delete(t);
        },
        update: function(t, i, n) {
            e.get(t)[i] = n;
        },
        dispose: function() {
            e = new WeakMap;
        }
    };
}
function $a42f1354f0348298$var$_f(e, t) {
    return e.groupOrder !== t.groupOrder ? e.groupOrder - t.groupOrder : e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.material.id !== t.material.id ? e.material.id - t.material.id : e.materialVariant !== t.materialVariant ? e.materialVariant - t.materialVariant : e.z !== t.z ? e.z - t.z : e.id - t.id;
}
function $a42f1354f0348298$var$vf(e, t) {
    return e.groupOrder !== t.groupOrder ? e.groupOrder - t.groupOrder : e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.z !== t.z ? t.z - e.z : e.id - t.id;
}
function $a42f1354f0348298$var$Ef() {
    const e = [];
    let t = 0;
    const i = [], n = [], a = [];
    function r(e) {
        let t = 0;
        return e.isInstancedMesh && (t += 2), e.isSkinnedMesh && (t += 1), t;
    }
    function s(i, n, a, s, o, l) {
        let c = e[t];
        return void 0 === c ? (c = {
            id: i.id,
            object: i,
            geometry: n,
            material: a,
            materialVariant: r(i),
            groupOrder: s,
            renderOrder: i.renderOrder,
            z: o,
            group: l
        }, e[t] = c) : (c.id = i.id, c.object = i, c.geometry = n, c.material = a, c.materialVariant = r(i), c.groupOrder = s, c.renderOrder = i.renderOrder, c.z = o, c.group = l), t++, c;
    }
    return {
        opaque: i,
        transmissive: n,
        transparent: a,
        init: function() {
            t = 0, i.length = 0, n.length = 0, a.length = 0;
        },
        push: function(e, t, r, o, l, c) {
            const d = s(e, t, r, o, l, c);
            r.transmission > 0 ? n.push(d) : !0 === r.transparent ? a.push(d) : i.push(d);
        },
        unshift: function(e, t, r, o, l, c) {
            const d = s(e, t, r, o, l, c);
            r.transmission > 0 ? n.unshift(d) : !0 === r.transparent ? a.unshift(d) : i.unshift(d);
        },
        finish: function() {
            for(let i = t, n = e.length; i < n; i++){
                const t = e[i];
                if (null === t.id) break;
                t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
            }
        },
        sort: function(e, t, r) {
            i.length > 1 && i.sort(e || $a42f1354f0348298$var$_f), n.length > 1 && n.sort(t || $a42f1354f0348298$var$vf), a.length > 1 && a.sort(t || $a42f1354f0348298$var$vf), r && (i.reverse(), n.reverse(), a.reverse());
        }
    };
}
function $a42f1354f0348298$var$yf() {
    let e = new WeakMap;
    return {
        get: function(t, i) {
            const n = e.get(t);
            let a;
            return void 0 === n ? (a = new $a42f1354f0348298$var$Ef, e.set(t, [
                a
            ])) : i >= n.length ? (a = new $a42f1354f0348298$var$Ef, n.push(a)) : a = n[i], a;
        },
        dispose: function() {
            e = new WeakMap;
        }
    };
}
function $a42f1354f0348298$var$bf() {
    const e = {};
    return {
        get: function(t) {
            if (void 0 !== e[t.id]) return e[t.id];
            let i;
            switch(t.type){
                case "DirectionalLight":
                    i = {
                        direction: new $a42f1354f0348298$var$uu,
                        color: new $a42f1354f0348298$var$gh
                    };
                    break;
                case "SpotLight":
                    i = {
                        position: new $a42f1354f0348298$var$uu,
                        direction: new $a42f1354f0348298$var$uu,
                        color: new $a42f1354f0348298$var$gh,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    i = {
                        position: new $a42f1354f0348298$var$uu,
                        color: new $a42f1354f0348298$var$gh,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    i = {
                        direction: new $a42f1354f0348298$var$uu,
                        skyColor: new $a42f1354f0348298$var$gh,
                        groundColor: new $a42f1354f0348298$var$gh
                    };
                    break;
                case "RectAreaLight":
                    i = {
                        color: new $a42f1354f0348298$var$gh,
                        position: new $a42f1354f0348298$var$uu,
                        halfWidth: new $a42f1354f0348298$var$uu,
                        halfHeight: new $a42f1354f0348298$var$uu
                    };
            }
            return e[t.id] = i, i;
        }
    };
}
let $a42f1354f0348298$var$kf = 0;
function $a42f1354f0348298$var$xf(e, t) {
    return (t.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (e.map ? 1 : 0);
}
function $a42f1354f0348298$var$wf(e) {
    const t = new $a42f1354f0348298$var$bf, i = function() {
        const e = {};
        return {
            get: function(t) {
                if (void 0 !== e[t.id]) return e[t.id];
                let i;
                switch(t.type){
                    case "DirectionalLight":
                    case "SpotLight":
                        i = {
                            shadowIntensity: 1,
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new $a42f1354f0348298$var$cu
                        };
                        break;
                    case "PointLight":
                        i = {
                            shadowIntensity: 1,
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new $a42f1354f0348298$var$cu,
                            shadowCameraNear: 1,
                            shadowCameraFar: 1e3
                        };
                }
                return e[t.id] = i, i;
            }
        };
    }(), n = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let e = 0; e < 9; e++)n.probe.push(new $a42f1354f0348298$var$uu);
    const a = new $a42f1354f0348298$var$uu, r = new $a42f1354f0348298$var$zu, s = new $a42f1354f0348298$var$zu;
    return {
        setup: function(a) {
            let r = 0, s = 0, o = 0;
            for(let e = 0; e < 9; e++)n.probe[e].set(0, 0, 0);
            let l = 0, c = 0, d = 0, u = 0, h = 0, p = 0, A = 0, m = 0, g = 0, f = 0, _ = 0;
            a.sort($a42f1354f0348298$var$xf);
            for(let e = 0, v = a.length; e < v; e++){
                const v = a[e], E = v.color, y = v.intensity, b = v.distance;
                let k = null;
                if (v.shadow && v.shadow.map && (k = v.shadow.map.texture.format === $a42f1354f0348298$var$Oc ? v.shadow.map.texture : v.shadow.map.depthTexture || v.shadow.map.texture), v.isAmbientLight) r += E.r * y, s += E.g * y, o += E.b * y;
                else if (v.isLightProbe) {
                    for(let e = 0; e < 9; e++)n.probe[e].addScaledVector(v.sh.coefficients[e], y);
                    _++;
                } else if (v.isDirectionalLight) {
                    const e = t.get(v);
                    if (e.color.copy(v.color).multiplyScalar(v.intensity), v.castShadow) {
                        const e = v.shadow, t = i.get(v);
                        t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, n.directionalShadow[l] = t, n.directionalShadowMap[l] = k, n.directionalShadowMatrix[l] = v.shadow.matrix, p++;
                    }
                    n.directional[l] = e, l++;
                } else if (v.isSpotLight) {
                    const e = t.get(v);
                    e.position.setFromMatrixPosition(v.matrixWorld), e.color.copy(E).multiplyScalar(y), e.distance = b, e.coneCos = Math.cos(v.angle), e.penumbraCos = Math.cos(v.angle * (1 - v.penumbra)), e.decay = v.decay, n.spot[d] = e;
                    const a = v.shadow;
                    if (v.map && (n.spotLightMap[g] = v.map, g++, a.updateMatrices(v), v.castShadow && f++), n.spotLightMatrix[d] = a.matrix, v.castShadow) {
                        const e = i.get(v);
                        e.shadowIntensity = a.intensity, e.shadowBias = a.bias, e.shadowNormalBias = a.normalBias, e.shadowRadius = a.radius, e.shadowMapSize = a.mapSize, n.spotShadow[d] = e, n.spotShadowMap[d] = k, m++;
                    }
                    d++;
                } else if (v.isRectAreaLight) {
                    const e = t.get(v);
                    e.color.copy(E).multiplyScalar(y), e.halfWidth.set(.5 * v.width, 0, 0), e.halfHeight.set(0, .5 * v.height, 0), n.rectArea[u] = e, u++;
                } else if (v.isPointLight) {
                    const e = t.get(v);
                    if (e.color.copy(v.color).multiplyScalar(v.intensity), e.distance = v.distance, e.decay = v.decay, v.castShadow) {
                        const e = v.shadow, t = i.get(v);
                        t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, t.shadowCameraNear = e.camera.near, t.shadowCameraFar = e.camera.far, n.pointShadow[c] = t, n.pointShadowMap[c] = k, n.pointShadowMatrix[c] = v.shadow.matrix, A++;
                    }
                    n.point[c] = e, c++;
                } else if (v.isHemisphereLight) {
                    const e = t.get(v);
                    e.skyColor.copy(v.color).multiplyScalar(y), e.groundColor.copy(v.groundColor).multiplyScalar(y), n.hemi[h] = e, h++;
                }
            }
            u > 0 && (!0 === e.has("OES_texture_float_linear") ? (n.rectAreaLTC1 = $a42f1354f0348298$var$tm.LTC_FLOAT_1, n.rectAreaLTC2 = $a42f1354f0348298$var$tm.LTC_FLOAT_2) : (n.rectAreaLTC1 = $a42f1354f0348298$var$tm.LTC_HALF_1, n.rectAreaLTC2 = $a42f1354f0348298$var$tm.LTC_HALF_2)), n.ambient[0] = r, n.ambient[1] = s, n.ambient[2] = o;
            const v = n.hash;
            v.directionalLength === l && v.pointLength === c && v.spotLength === d && v.rectAreaLength === u && v.hemiLength === h && v.numDirectionalShadows === p && v.numPointShadows === A && v.numSpotShadows === m && v.numSpotMaps === g && v.numLightProbes === _ || (n.directional.length = l, n.spot.length = d, n.rectArea.length = u, n.point.length = c, n.hemi.length = h, n.directionalShadow.length = p, n.directionalShadowMap.length = p, n.pointShadow.length = A, n.pointShadowMap.length = A, n.spotShadow.length = m, n.spotShadowMap.length = m, n.directionalShadowMatrix.length = p, n.pointShadowMatrix.length = A, n.spotLightMatrix.length = m + g - f, n.spotLightMap.length = g, n.numSpotLightShadowsWithMaps = f, n.numLightProbes = _, v.directionalLength = l, v.pointLength = c, v.spotLength = d, v.rectAreaLength = u, v.hemiLength = h, v.numDirectionalShadows = p, v.numPointShadows = A, v.numSpotShadows = m, v.numSpotMaps = g, v.numLightProbes = _, n.version = $a42f1354f0348298$var$kf++);
        },
        setupView: function(e, t) {
            let i = 0, o = 0, l = 0, c = 0, d = 0;
            const u = t.matrixWorldInverse;
            for(let t = 0, h = e.length; t < h; t++){
                const h = e[t];
                if (h.isDirectionalLight) {
                    const e = n.directional[i];
                    e.direction.setFromMatrixPosition(h.matrixWorld), a.setFromMatrixPosition(h.target.matrixWorld), e.direction.sub(a), e.direction.transformDirection(u), i++;
                } else if (h.isSpotLight) {
                    const e = n.spot[l];
                    e.position.setFromMatrixPosition(h.matrixWorld), e.position.applyMatrix4(u), e.direction.setFromMatrixPosition(h.matrixWorld), a.setFromMatrixPosition(h.target.matrixWorld), e.direction.sub(a), e.direction.transformDirection(u), l++;
                } else if (h.isRectAreaLight) {
                    const e = n.rectArea[c];
                    e.position.setFromMatrixPosition(h.matrixWorld), e.position.applyMatrix4(u), s.identity(), r.copy(h.matrixWorld), r.premultiply(u), s.extractRotation(r), e.halfWidth.set(.5 * h.width, 0, 0), e.halfHeight.set(0, .5 * h.height, 0), e.halfWidth.applyMatrix4(s), e.halfHeight.applyMatrix4(s), c++;
                } else if (h.isPointLight) {
                    const e = n.point[o];
                    e.position.setFromMatrixPosition(h.matrixWorld), e.position.applyMatrix4(u), o++;
                } else if (h.isHemisphereLight) {
                    const e = n.hemi[d];
                    e.direction.setFromMatrixPosition(h.matrixWorld), e.direction.transformDirection(u), d++;
                }
            }
        },
        state: n
    };
}
function $a42f1354f0348298$var$Mf(e) {
    const t = new $a42f1354f0348298$var$wf(e), i = [], n = [], a = [];
    const r = {
        lightsArray: i,
        shadowsArray: n,
        lightProbeGridArray: a,
        camera: null,
        lights: t,
        transmissionRenderTarget: {},
        textureUnits: 0
    };
    return {
        init: function(e) {
            r.camera = e, i.length = 0, n.length = 0, a.length = 0;
        },
        state: r,
        setupLights: function() {
            t.setup(i);
        },
        setupLightsView: function(e) {
            t.setupView(i, e);
        },
        pushLight: function(e) {
            i.push(e);
        },
        pushShadow: function(e) {
            n.push(e);
        },
        pushLightProbeGrid: function(e) {
            a.push(e);
        }
    };
}
function $a42f1354f0348298$var$Sf(e) {
    let t = new WeakMap;
    return {
        get: function(i, n = 0) {
            const a = t.get(i);
            let r;
            return void 0 === a ? (r = new $a42f1354f0348298$var$Mf(e), t.set(i, [
                r
            ])) : n >= a.length ? (r = new $a42f1354f0348298$var$Mf(e), a.push(r)) : r = a[n], r;
        },
        dispose: function() {
            t = new WeakMap;
        }
    };
}
const $a42f1354f0348298$var$Cf = [
    new $a42f1354f0348298$var$uu(1, 0, 0),
    new $a42f1354f0348298$var$uu(-1, 0, 0),
    new $a42f1354f0348298$var$uu(0, 1, 0),
    new $a42f1354f0348298$var$uu(0, -1, 0),
    new $a42f1354f0348298$var$uu(0, 0, 1),
    new $a42f1354f0348298$var$uu(0, 0, -1)
], $a42f1354f0348298$var$Tf = [
    new $a42f1354f0348298$var$uu(0, -1, 0),
    new $a42f1354f0348298$var$uu(0, -1, 0),
    new $a42f1354f0348298$var$uu(0, 0, 1),
    new $a42f1354f0348298$var$uu(0, 0, -1),
    new $a42f1354f0348298$var$uu(0, -1, 0),
    new $a42f1354f0348298$var$uu(0, -1, 0)
], $a42f1354f0348298$var$Df = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Pf = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$If = new $a42f1354f0348298$var$uu;
function $a42f1354f0348298$var$Lf(e, t, i) {
    let n = new $a42f1354f0348298$var$qp;
    const a = new $a42f1354f0348298$var$cu, r = new $a42f1354f0348298$var$cu, s = new $a42f1354f0348298$var$Du, o = new $a42f1354f0348298$var$bA, l = new $a42f1354f0348298$var$kA, c = {}, d = i.maxTextureSize, u = {
        [$a42f1354f0348298$var$xl]: 1,
        [$a42f1354f0348298$var$wl]: 0,
        [$a42f1354f0348298$var$Ml]: 2
    }, h = new $a42f1354f0348298$var$EA({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $a42f1354f0348298$var$cu
            },
            radius: {
                value: 4
            }
        },
        vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
        fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n\tgl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}"
    }), p = h.clone();
    p.defines.HORIZONTAL_PASS = 1;
    const A = new $a42f1354f0348298$var$hp;
    A.setAttribute("position", new $a42f1354f0348298$var$Yh(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    const m = new $a42f1354f0348298$var$zp(A, h), g = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1;
    let f = this.type;
    function _(i, n) {
        const r = t.update(m);
        h.defines.VSM_SAMPLES !== i.blurSamples && (h.defines.VSM_SAMPLES = i.blurSamples, p.defines.VSM_SAMPLES = i.blurSamples, h.needsUpdate = !0, p.needsUpdate = !0), null === i.mapPass && (i.mapPass = new $a42f1354f0348298$var$Iu(a.x, a.y, {
            format: $a42f1354f0348298$var$Oc,
            type: $a42f1354f0348298$var$Dc
        })), h.uniforms.shadow_pass.value = i.map.depthTexture, h.uniforms.resolution.value = i.mapSize, h.uniforms.radius.value = i.radius, e.setRenderTarget(i.mapPass), e.clear(), e.renderBufferDirect(n, null, r, h, m, null), p.uniforms.shadow_pass.value = i.mapPass.texture, p.uniforms.resolution.value = i.mapSize, p.uniforms.radius.value = i.radius, e.setRenderTarget(i.map), e.clear(), e.renderBufferDirect(n, null, r, p, m, null);
    }
    function v(t, i, n, a) {
        let r = null;
        const s = !0 === n.isPointLight ? t.customDistanceMaterial : t.customDepthMaterial;
        if (void 0 !== s) r = s;
        else if (r = !0 === n.isPointLight ? l : o, e.localClippingEnabled && !0 === i.clipShadows && Array.isArray(i.clippingPlanes) && 0 !== i.clippingPlanes.length || i.displacementMap && 0 !== i.displacementScale || i.alphaMap && i.alphaTest > 0 || i.map && i.alphaTest > 0 || !0 === i.alphaToCoverage) {
            const e = r.uuid, t = i.uuid;
            let n = c[e];
            void 0 === n && (n = {}, c[e] = n);
            let a = n[t];
            void 0 === a && (a = r.clone(), n[t] = a, i.addEventListener("dispose", y)), r = a;
        }
        if (r.visible = i.visible, r.wireframe = i.wireframe, r.side = 3 === a ? null !== i.shadowSide ? i.shadowSide : i.side : null !== i.shadowSide ? i.shadowSide : u[i.side], r.alphaMap = i.alphaMap, r.alphaTest = !0 === i.alphaToCoverage ? .5 : i.alphaTest, r.map = i.map, r.clipShadows = i.clipShadows, r.clippingPlanes = i.clippingPlanes, r.clipIntersection = i.clipIntersection, r.displacementMap = i.displacementMap, r.displacementScale = i.displacementScale, r.displacementBias = i.displacementBias, r.wireframeLinewidth = i.wireframeLinewidth, r.linewidth = i.linewidth, !0 === n.isPointLight && !0 === r.isMeshDistanceMaterial) e.properties.get(r).light = n;
        return r;
    }
    function E(i, a, r, s, o) {
        if (!1 === i.visible) return;
        if (i.layers.test(a.layers) && (i.isMesh || i.isLine || i.isPoints) && (i.castShadow || i.receiveShadow && 3 === o) && (!i.frustumCulled || n.intersectsObject(i))) {
            i.modelViewMatrix.multiplyMatrices(r.matrixWorldInverse, i.matrixWorld);
            const n = t.update(i), l = i.material;
            if (Array.isArray(l)) {
                const t = n.groups;
                for(let c = 0, d = t.length; c < d; c++){
                    const d = t[c], u = l[d.materialIndex];
                    if (u && u.visible) {
                        const t = v(i, u, s, o);
                        i.onBeforeShadow(e, i, a, r, n, t, d), e.renderBufferDirect(r, null, n, t, i, d), i.onAfterShadow(e, i, a, r, n, t, d);
                    }
                }
            } else if (l.visible) {
                const t = v(i, l, s, o);
                i.onBeforeShadow(e, i, a, r, n, t, null), e.renderBufferDirect(r, null, n, t, i, null), i.onAfterShadow(e, i, a, r, n, t, null);
            }
        }
        const l = i.children;
        for(let e = 0, t = l.length; e < t; e++)E(l[e], a, r, s, o);
    }
    function y(e) {
        e.target.removeEventListener("dispose", y);
        for(const t in c){
            const i = c[t], n = e.target.uuid;
            if (n in i) i[n].dispose(), delete i[n];
        }
    }
    this.render = function(t, i, o) {
        if (!1 === g.enabled) return;
        if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
        if (0 === t.length) return;
        2 === this.type && ($a42f1354f0348298$var$Wd("WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead."), this.type = 1);
        const l = e.getRenderTarget(), c = e.getActiveCubeFace(), u = e.getActiveMipmapLevel(), h = e.state;
        h.setBlending(0), !0 === h.buffers.depth.getReversed() ? h.buffers.color.setClear(0, 0, 0, 0) : h.buffers.color.setClear(1, 1, 1, 1), h.buffers.depth.setTest(!0), h.setScissorTest(!1);
        const p = f !== this.type;
        p && i.traverse(function(e) {
            e.material && (Array.isArray(e.material) ? e.material.forEach((e)=>e.needsUpdate = !0) : e.material.needsUpdate = !0);
        });
        for(let l = 0, c = t.length; l < c; l++){
            const c = t[l], u = c.shadow;
            if (void 0 === u) {
                $a42f1354f0348298$var$Wd("WebGLShadowMap:", c, "has no shadow.");
                continue;
            }
            if (!1 === u.autoUpdate && !1 === u.needsUpdate) continue;
            a.copy(u.mapSize);
            const A = u.getFrameExtents();
            a.multiply(A), r.copy(u.mapSize), (a.x > d || a.y > d) && (a.x > d && (r.x = Math.floor(d / A.x), a.x = r.x * A.x, u.mapSize.x = r.x), a.y > d && (r.y = Math.floor(d / A.y), a.y = r.y * A.y, u.mapSize.y = r.y));
            const m = e.state.buffers.depth.getReversed();
            if (u.camera._reversedDepth = m, null === u.map || !0 === p) {
                if (null !== u.map && (null !== u.map.depthTexture && (u.map.depthTexture.dispose(), u.map.depthTexture = null), u.map.dispose()), 3 === this.type) {
                    if (c.isPointLight) {
                        $a42f1354f0348298$var$Wd("WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.");
                        continue;
                    }
                    u.map = new $a42f1354f0348298$var$Iu(a.x, a.y, {
                        format: $a42f1354f0348298$var$Oc,
                        type: $a42f1354f0348298$var$Dc,
                        minFilter: $a42f1354f0348298$var$Ec,
                        magFilter: $a42f1354f0348298$var$Ec,
                        generateMipmaps: !1
                    }), u.map.texture.name = c.name + ".shadowMap", u.map.depthTexture = new $a42f1354f0348298$var$oA(a.x, a.y, $a42f1354f0348298$var$Tc), u.map.depthTexture.name = c.name + ".shadowMapDepth", u.map.depthTexture.format = $a42f1354f0348298$var$Uc, u.map.depthTexture.compareFunction = null, u.map.depthTexture.minFilter = $a42f1354f0348298$var$fc, u.map.depthTexture.magFilter = $a42f1354f0348298$var$fc;
                } else c.isPointLight ? (u.map = new $a42f1354f0348298$var$Mm(a.x), u.map.depthTexture = new $a42f1354f0348298$var$lA(a.x, $a42f1354f0348298$var$Cc)) : (u.map = new $a42f1354f0348298$var$Iu(a.x, a.y), u.map.depthTexture = new $a42f1354f0348298$var$oA(a.x, a.y, $a42f1354f0348298$var$Cc)), u.map.depthTexture.name = c.name + ".shadowMap", u.map.depthTexture.format = $a42f1354f0348298$var$Uc, 1 === this.type ? (u.map.depthTexture.compareFunction = m ? 518 : 515, u.map.depthTexture.minFilter = $a42f1354f0348298$var$Ec, u.map.depthTexture.magFilter = $a42f1354f0348298$var$Ec) : (u.map.depthTexture.compareFunction = null, u.map.depthTexture.minFilter = $a42f1354f0348298$var$fc, u.map.depthTexture.magFilter = $a42f1354f0348298$var$fc);
                u.camera.updateProjectionMatrix();
            }
            const g = u.map.isWebGLCubeRenderTarget ? 6 : 1;
            for(let t = 0; t < g; t++){
                if (u.map.isWebGLCubeRenderTarget) e.setRenderTarget(u.map, t), e.clear();
                else {
                    0 === t && (e.setRenderTarget(u.map), e.clear());
                    const i = u.getViewport(t);
                    s.set(r.x * i.x, r.y * i.y, r.x * i.z, r.y * i.w), h.viewport(s);
                }
                if (c.isPointLight) {
                    const e = u.camera, i = u.matrix, n = c.distance || e.far;
                    n !== e.far && (e.far = n, e.updateProjectionMatrix()), $a42f1354f0348298$var$Pf.setFromMatrixPosition(c.matrixWorld), e.position.copy($a42f1354f0348298$var$Pf), $a42f1354f0348298$var$If.copy(e.position), $a42f1354f0348298$var$If.add($a42f1354f0348298$var$Cf[t]), e.up.copy($a42f1354f0348298$var$Tf[t]), e.lookAt($a42f1354f0348298$var$If), e.updateMatrixWorld(), i.makeTranslation(-$a42f1354f0348298$var$Pf.x, -$a42f1354f0348298$var$Pf.y, -$a42f1354f0348298$var$Pf.z), $a42f1354f0348298$var$Df.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), u._frustum.setFromProjectionMatrix($a42f1354f0348298$var$Df, e.coordinateSystem, e.reversedDepth);
                } else u.updateMatrices(c);
                n = u.getFrustum(), E(i, o, u.camera, c, this.type);
            }
            !0 !== u.isPointLightShadow && 3 === this.type && _(u, o), u.needsUpdate = !1;
        }
        f = this.type, g.needsUpdate = !1, e.setRenderTarget(l, c, u);
    };
}
function $a42f1354f0348298$var$Rf(e, t) {
    const i = new function() {
        let t = !1;
        const i = new $a42f1354f0348298$var$Du;
        let n = null;
        const a = new $a42f1354f0348298$var$Du(0, 0, 0, 0);
        return {
            setMask: function(i) {
                n === i || t || (e.colorMask(i, i, i, i), n = i);
            },
            setLocked: function(e) {
                t = e;
            },
            setClear: function(t, n, r, s, o) {
                !0 === o && (t *= s, n *= s, r *= s), i.set(t, n, r, s), !1 === a.equals(i) && (e.clearColor(t, n, r, s), a.copy(i));
            },
            reset: function() {
                t = !1, n = null, a.set(-1, 0, 0, 0);
            }
        };
    }, n = new function() {
        let i = !1, n = !1, a = null, r = null, s = null;
        return {
            setReversed: function(e) {
                if (n !== e) {
                    const i = t.get("EXT_clip_control");
                    e ? i.clipControlEXT(i.LOWER_LEFT_EXT, i.ZERO_TO_ONE_EXT) : i.clipControlEXT(i.LOWER_LEFT_EXT, i.NEGATIVE_ONE_TO_ONE_EXT), n = e;
                    const a = s;
                    s = null, this.setClear(a);
                }
            },
            getReversed: function() {
                return n;
            },
            setTest: function(t) {
                t ? j(e.DEPTH_TEST) : G(e.DEPTH_TEST);
            },
            setMask: function(t) {
                a === t || i || (e.depthMask(t), a = t);
            },
            setFunc: function(t) {
                if (n && (t = $a42f1354f0348298$var$Zd[t]), r !== t) {
                    switch(t){
                        case 0:
                            e.depthFunc(e.NEVER);
                            break;
                        case 1:
                            e.depthFunc(e.ALWAYS);
                            break;
                        case 2:
                            e.depthFunc(e.LESS);
                            break;
                        case 3:
                        default:
                            e.depthFunc(e.LEQUAL);
                            break;
                        case 4:
                            e.depthFunc(e.EQUAL);
                            break;
                        case 5:
                            e.depthFunc(e.GEQUAL);
                            break;
                        case 6:
                            e.depthFunc(e.GREATER);
                            break;
                        case 7:
                            e.depthFunc(e.NOTEQUAL);
                    }
                    r = t;
                }
            },
            setLocked: function(e) {
                i = e;
            },
            setClear: function(t) {
                s !== t && (s = t, n && (t = 1 - t), e.clearDepth(t));
            },
            reset: function() {
                i = !1, a = null, r = null, s = null, n = !1;
            }
        };
    }, a = new function() {
        let t = !1, i = null, n = null, a = null, r = null, s = null, o = null, l = null, c = null;
        return {
            setTest: function(i) {
                t || (i ? j(e.STENCIL_TEST) : G(e.STENCIL_TEST));
            },
            setMask: function(n) {
                i === n || t || (e.stencilMask(n), i = n);
            },
            setFunc: function(t, i, s) {
                n === t && a === i && r === s || (e.stencilFunc(t, i, s), n = t, a = i, r = s);
            },
            setOp: function(t, i, n) {
                s === t && o === i && l === n || (e.stencilOp(t, i, n), s = t, o = i, l = n);
            },
            setLocked: function(e) {
                t = e;
            },
            setClear: function(t) {
                c !== t && (e.clearStencil(t), c = t);
            },
            reset: function() {
                t = !1, i = null, n = null, a = null, r = null, s = null, o = null, l = null, c = null;
            }
        };
    }, r = new WeakMap, s = new WeakMap;
    let o = {}, l = {}, c = {}, d = new WeakMap, u = [], h = null, p = !1, A = null, m = null, g = null, f = null, _ = null, v = null, E = null, y = new $a42f1354f0348298$var$gh(0, 0, 0), b = 0, k = !1, x = null, w = null, M = null, S = null, C = null;
    const T = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let D = !1, P = 0;
    const I = e.getParameter(e.VERSION);
    -1 !== I.indexOf("WebGL") ? (P = parseFloat(/^WebGL (\d)/.exec(I)[1]), D = P >= 1) : -1 !== I.indexOf("OpenGL ES") && (P = parseFloat(/^OpenGL ES (\d)/.exec(I)[1]), D = P >= 2);
    let L = null, R = {};
    const z = e.getParameter(e.SCISSOR_BOX), F = e.getParameter(e.VIEWPORT), U = (new $a42f1354f0348298$var$Du).fromArray(z), N = (new $a42f1354f0348298$var$Du).fromArray(F);
    function B(t, i, n, a) {
        const r = new Uint8Array(4), s = e.createTexture();
        e.bindTexture(t, s), e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
        for(let s = 0; s < n; s++)t === e.TEXTURE_3D || t === e.TEXTURE_2D_ARRAY ? e.texImage3D(i, 0, e.RGBA, 1, 1, a, 0, e.RGBA, e.UNSIGNED_BYTE, r) : e.texImage2D(i + s, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, r);
        return s;
    }
    const O = {};
    function j(t) {
        !0 !== o[t] && (e.enable(t), o[t] = !0);
    }
    function G(t) {
        !1 !== o[t] && (e.disable(t), o[t] = !1);
    }
    O[e.TEXTURE_2D] = B(e.TEXTURE_2D, e.TEXTURE_2D, 1), O[e.TEXTURE_CUBE_MAP] = B(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), O[e.TEXTURE_2D_ARRAY] = B(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1), O[e.TEXTURE_3D] = B(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1), i.setClear(0, 0, 0, 1), n.setClear(1), a.setClear(0), j(e.DEPTH_TEST), n.setFunc(3), K(!1), W(1), j(e.CULL_FACE), q(0);
    const V = {
        [$a42f1354f0348298$var$Sl]: e.FUNC_ADD,
        [$a42f1354f0348298$var$Cl]: e.FUNC_SUBTRACT,
        [$a42f1354f0348298$var$Tl]: e.FUNC_REVERSE_SUBTRACT
    };
    V[103] = e.MIN, V[104] = e.MAX;
    const H = {
        [$a42f1354f0348298$var$Dl]: e.ZERO,
        [$a42f1354f0348298$var$Pl]: e.ONE,
        [$a42f1354f0348298$var$Il]: e.SRC_COLOR,
        [$a42f1354f0348298$var$Rl]: e.SRC_ALPHA,
        [$a42f1354f0348298$var$Ol]: e.SRC_ALPHA_SATURATE,
        [$a42f1354f0348298$var$Nl]: e.DST_COLOR,
        [$a42f1354f0348298$var$Fl]: e.DST_ALPHA,
        [$a42f1354f0348298$var$Ll]: e.ONE_MINUS_SRC_COLOR,
        [$a42f1354f0348298$var$zl]: e.ONE_MINUS_SRC_ALPHA,
        [$a42f1354f0348298$var$Bl]: e.ONE_MINUS_DST_COLOR,
        [$a42f1354f0348298$var$Ul]: e.ONE_MINUS_DST_ALPHA,
        [$a42f1354f0348298$var$jl]: e.CONSTANT_COLOR,
        [$a42f1354f0348298$var$Gl]: e.ONE_MINUS_CONSTANT_COLOR,
        [$a42f1354f0348298$var$Vl]: e.CONSTANT_ALPHA,
        [$a42f1354f0348298$var$Hl]: e.ONE_MINUS_CONSTANT_ALPHA
    };
    function q(t, i, n, a, r, s, o, l, c, d) {
        if (0 !== t) {
            if (!1 === p && (j(e.BLEND), p = !0), 5 === t) r = r || i, s = s || n, o = o || a, i === m && r === _ || (e.blendEquationSeparate(V[i], V[r]), m = i, _ = r), n === g && a === f && s === v && o === E || (e.blendFuncSeparate(H[n], H[a], H[s], H[o]), g = n, f = a, v = s, E = o), !1 !== l.equals(y) && c === b || (e.blendColor(l.r, l.g, l.b, c), y.copy(l), b = c), A = t, k = !1;
            else if (t !== A || d !== k) {
                if (m === $a42f1354f0348298$var$Sl && _ === $a42f1354f0348298$var$Sl || (e.blendEquation(e.FUNC_ADD), m = $a42f1354f0348298$var$Sl, _ = $a42f1354f0348298$var$Sl), d) switch(t){
                    case 1:
                        e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 2:
                        e.blendFunc(e.ONE, e.ONE);
                        break;
                    case 3:
                        e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE);
                        break;
                    case 4:
                        e.blendFuncSeparate(e.DST_COLOR, e.ONE_MINUS_SRC_ALPHA, e.ZERO, e.ONE);
                        break;
                    default:
                        $a42f1354f0348298$var$Xd("WebGLState: Invalid blending: ", t);
                }
                else switch(t){
                    case 1:
                        e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 2:
                        e.blendFuncSeparate(e.SRC_ALPHA, e.ONE, e.ONE, e.ONE);
                        break;
                    case 3:
                        $a42f1354f0348298$var$Xd("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                        break;
                    case 4:
                        $a42f1354f0348298$var$Xd("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                        break;
                    default:
                        $a42f1354f0348298$var$Xd("WebGLState: Invalid blending: ", t);
                }
                g = null, f = null, v = null, E = null, y.set(0, 0, 0), b = 0, A = t, k = d;
            }
        } else !0 === p && (G(e.BLEND), p = !1);
    }
    function K(t) {
        x !== t && (t ? e.frontFace(e.CW) : e.frontFace(e.CCW), x = t);
    }
    function W(t) {
        0 !== t ? (j(e.CULL_FACE), t !== w && (1 === t ? e.cullFace(e.BACK) : 2 === t ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))) : G(e.CULL_FACE), w = t;
    }
    function X(t, i, a) {
        t ? (j(e.POLYGON_OFFSET_FILL), S === i && C === a || (S = i, C = a, n.getReversed() && (i = -i), e.polygonOffset(i, a))) : G(e.POLYGON_OFFSET_FILL);
    }
    return {
        buffers: {
            color: i,
            depth: n,
            stencil: a
        },
        enable: j,
        disable: G,
        bindFramebuffer: function(t, i) {
            return c[t] !== i && (e.bindFramebuffer(t, i), c[t] = i, t === e.DRAW_FRAMEBUFFER && (c[e.FRAMEBUFFER] = i), t === e.FRAMEBUFFER && (c[e.DRAW_FRAMEBUFFER] = i), !0);
        },
        drawBuffers: function(t, i) {
            let n = u, a = !1;
            if (t) {
                n = d.get(i), void 0 === n && (n = [], d.set(i, n));
                const r = t.textures;
                if (n.length !== r.length || n[0] !== e.COLOR_ATTACHMENT0) {
                    for(let t = 0, i = r.length; t < i; t++)n[t] = e.COLOR_ATTACHMENT0 + t;
                    n.length = r.length, a = !0;
                }
            } else n[0] !== e.BACK && (n[0] = e.BACK, a = !0);
            a && e.drawBuffers(n);
        },
        useProgram: function(t) {
            return h !== t && (e.useProgram(t), h = t, !0);
        },
        setBlending: q,
        setMaterial: function(t, r) {
            2 === t.side ? G(e.CULL_FACE) : j(e.CULL_FACE);
            let s = 1 === t.side;
            r && (s = !s), K(s), 1 === t.blending && !1 === t.transparent ? q(0) : q(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), n.setFunc(t.depthFunc), n.setTest(t.depthTest), n.setMask(t.depthWrite), i.setMask(t.colorWrite);
            const o = t.stencilWrite;
            a.setTest(o), o && (a.setMask(t.stencilWriteMask), a.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), a.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), X(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? j(e.SAMPLE_ALPHA_TO_COVERAGE) : G(e.SAMPLE_ALPHA_TO_COVERAGE);
        },
        setFlipSided: K,
        setCullFace: W,
        setLineWidth: function(t) {
            t !== M && (D && e.lineWidth(t), M = t);
        },
        setPolygonOffset: X,
        setScissorTest: function(t) {
            t ? j(e.SCISSOR_TEST) : G(e.SCISSOR_TEST);
        },
        activeTexture: function(t) {
            void 0 === t && (t = e.TEXTURE0 + T - 1), L !== t && (e.activeTexture(t), L = t);
        },
        bindTexture: function(t, i, n) {
            void 0 === n && (n = null === L ? e.TEXTURE0 + T - 1 : L);
            let a = R[n];
            void 0 === a && (a = {
                type: void 0,
                texture: void 0
            }, R[n] = a), a.type === t && a.texture === i || (L !== n && (e.activeTexture(n), L = n), e.bindTexture(t, i || O[t]), a.type = t, a.texture = i);
        },
        unbindTexture: function() {
            const t = R[L];
            void 0 !== t && void 0 !== t.type && (e.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
        },
        compressedTexImage2D: function() {
            try {
                e.compressedTexImage2D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        compressedTexImage3D: function() {
            try {
                e.compressedTexImage3D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        texImage2D: function() {
            try {
                e.texImage2D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        texImage3D: function() {
            try {
                e.texImage3D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        pixelStorei: function(t, i) {
            l[t] !== i && (e.pixelStorei(t, i), l[t] = i);
        },
        getParameter: function(t) {
            return void 0 !== l[t] ? l[t] : e.getParameter(t);
        },
        updateUBOMapping: function(t, i) {
            let n = s.get(i);
            void 0 === n && (n = new WeakMap, s.set(i, n));
            let a = n.get(t);
            void 0 === a && (a = e.getUniformBlockIndex(i, t.name), n.set(t, a));
        },
        uniformBlockBinding: function(t, i) {
            const n = s.get(i).get(t);
            r.get(i) !== n && (e.uniformBlockBinding(i, n, t.__bindingPointIndex), r.set(i, n));
        },
        texStorage2D: function() {
            try {
                e.texStorage2D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        texStorage3D: function() {
            try {
                e.texStorage3D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        texSubImage2D: function() {
            try {
                e.texSubImage2D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        texSubImage3D: function() {
            try {
                e.texSubImage3D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        compressedTexSubImage2D: function() {
            try {
                e.compressedTexSubImage2D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        compressedTexSubImage3D: function() {
            try {
                e.compressedTexSubImage3D(...arguments);
            } catch (e) {
                $a42f1354f0348298$var$Xd("WebGLState:", e);
            }
        },
        scissor: function(t) {
            !1 === U.equals(t) && (e.scissor(t.x, t.y, t.z, t.w), U.copy(t));
        },
        viewport: function(t) {
            !1 === N.equals(t) && (e.viewport(t.x, t.y, t.z, t.w), N.copy(t));
        },
        reset: function() {
            e.disable(e.BLEND), e.disable(e.CULL_FACE), e.disable(e.DEPTH_TEST), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SCISSOR_TEST), e.disable(e.STENCIL_TEST), e.disable(e.SAMPLE_ALPHA_TO_COVERAGE), e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ONE, e.ZERO), e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO), e.blendColor(0, 0, 0, 0), e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 0), e.depthMask(!0), e.depthFunc(e.LESS), n.setReversed(!1), e.clearDepth(1), e.stencilMask(4294967295), e.stencilFunc(e.ALWAYS, 0, 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP), e.clearStencil(0), e.cullFace(e.BACK), e.frontFace(e.CCW), e.polygonOffset(0, 0), e.activeTexture(e.TEXTURE0), e.bindFramebuffer(e.FRAMEBUFFER, null), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), e.bindFramebuffer(e.READ_FRAMEBUFFER, null), e.useProgram(null), e.lineWidth(1), e.scissor(0, 0, e.canvas.width, e.canvas.height), e.viewport(0, 0, e.canvas.width, e.canvas.height), e.pixelStorei(e.PACK_ALIGNMENT, 4), e.pixelStorei(e.UNPACK_ALIGNMENT, 4), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !1), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.BROWSER_DEFAULT_WEBGL), e.pixelStorei(e.PACK_ROW_LENGTH, 0), e.pixelStorei(e.PACK_SKIP_PIXELS, 0), e.pixelStorei(e.PACK_SKIP_ROWS, 0), e.pixelStorei(e.UNPACK_ROW_LENGTH, 0), e.pixelStorei(e.UNPACK_IMAGE_HEIGHT, 0), e.pixelStorei(e.UNPACK_SKIP_PIXELS, 0), e.pixelStorei(e.UNPACK_SKIP_ROWS, 0), e.pixelStorei(e.UNPACK_SKIP_IMAGES, 0), o = {}, l = {}, L = null, R = {}, c = {}, d = new WeakMap, u = [], h = null, p = !1, A = null, m = null, g = null, f = null, _ = null, v = null, E = null, y = new $a42f1354f0348298$var$gh(0, 0, 0), b = 0, k = !1, x = null, w = null, M = null, S = null, C = null, U.set(0, 0, e.canvas.width, e.canvas.height), N.set(0, 0, e.canvas.width, e.canvas.height), i.reset(), n.reset(), a.reset();
        }
    };
}
function $a42f1354f0348298$var$zf(e, t, i, n, a, r, s) {
    const o = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, l = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), c = new $a42f1354f0348298$var$cu, d = new WeakMap, u = new Set;
    let h;
    const p = new WeakMap;
    let A = !1;
    try {
        A = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
    } catch (e) {}
    function m(e, t) {
        return A ? new OffscreenCanvas(e, t) : $a42f1354f0348298$var$Gd("canvas");
    }
    function g(e, t, i) {
        let n = 1;
        const a = H(e);
        if ((a.width > i || a.height > i) && (n = i / Math.max(a.width, a.height)), n < 1) {
            if ("undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e instanceof ImageBitmap || "undefined" != typeof VideoFrame && e instanceof VideoFrame) {
                const i = Math.floor(n * a.width), r = Math.floor(n * a.height);
                void 0 === h && (h = m(i, r));
                const s = t ? m(i, r) : h;
                s.width = i, s.height = r;
                return s.getContext("2d").drawImage(e, 0, 0, i, r), $a42f1354f0348298$var$Wd("WebGLRenderer: Texture has been resized from (" + a.width + "x" + a.height + ") to (" + i + "x" + r + ")."), s;
            }
            return "data" in e && $a42f1354f0348298$var$Wd("WebGLRenderer: Image in DataTexture is too big (" + a.width + "x" + a.height + ")."), e;
        }
        return e;
    }
    function f(e) {
        return e.generateMipmaps;
    }
    function _(t) {
        e.generateMipmap(t);
    }
    function v(t) {
        return t.isWebGLCubeRenderTarget ? e.TEXTURE_CUBE_MAP : t.isWebGL3DRenderTarget ? e.TEXTURE_3D : t.isWebGLArrayRenderTarget || t.isCompressedArrayTexture ? e.TEXTURE_2D_ARRAY : e.TEXTURE_2D;
    }
    function E(i, n, a, r, s, o = !1) {
        if (null !== i) {
            if (void 0 !== e[i]) return e[i];
            $a42f1354f0348298$var$Wd("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + i + "'");
        }
        let l;
        r && (l = t.get("EXT_texture_norm16"), l || $a42f1354f0348298$var$Wd("WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension"));
        let c = n;
        if (n === e.RED && (a === e.FLOAT && (c = e.R32F), a === e.HALF_FLOAT && (c = e.R16F), a === e.UNSIGNED_BYTE && (c = e.R8), a === e.UNSIGNED_SHORT && l && (c = l.R16_EXT), a === e.SHORT && l && (c = l.R16_SNORM_EXT)), n === e.RED_INTEGER && (a === e.UNSIGNED_BYTE && (c = e.R8UI), a === e.UNSIGNED_SHORT && (c = e.R16UI), a === e.UNSIGNED_INT && (c = e.R32UI), a === e.BYTE && (c = e.R8I), a === e.SHORT && (c = e.R16I), a === e.INT && (c = e.R32I)), n === e.RG && (a === e.FLOAT && (c = e.RG32F), a === e.HALF_FLOAT && (c = e.RG16F), a === e.UNSIGNED_BYTE && (c = e.RG8), a === e.UNSIGNED_SHORT && l && (c = l.RG16_EXT), a === e.SHORT && l && (c = l.RG16_SNORM_EXT)), n === e.RG_INTEGER && (a === e.UNSIGNED_BYTE && (c = e.RG8UI), a === e.UNSIGNED_SHORT && (c = e.RG16UI), a === e.UNSIGNED_INT && (c = e.RG32UI), a === e.BYTE && (c = e.RG8I), a === e.SHORT && (c = e.RG16I), a === e.INT && (c = e.RG32I)), n === e.RGB_INTEGER && (a === e.UNSIGNED_BYTE && (c = e.RGB8UI), a === e.UNSIGNED_SHORT && (c = e.RGB16UI), a === e.UNSIGNED_INT && (c = e.RGB32UI), a === e.BYTE && (c = e.RGB8I), a === e.SHORT && (c = e.RGB16I), a === e.INT && (c = e.RGB32I)), n === e.RGBA_INTEGER && (a === e.UNSIGNED_BYTE && (c = e.RGBA8UI), a === e.UNSIGNED_SHORT && (c = e.RGBA16UI), a === e.UNSIGNED_INT && (c = e.RGBA32UI), a === e.BYTE && (c = e.RGBA8I), a === e.SHORT && (c = e.RGBA16I), a === e.INT && (c = e.RGBA32I)), n === e.RGB && (a === e.UNSIGNED_SHORT && l && (c = l.RGB16_EXT), a === e.SHORT && l && (c = l.RGB16_SNORM_EXT), a === e.UNSIGNED_INT_5_9_9_9_REV && (c = e.RGB9_E5), a === e.UNSIGNED_INT_10F_11F_11F_REV && (c = e.R11F_G11F_B10F)), n === e.RGBA) {
            const t = o ? $a42f1354f0348298$var$Cd : $a42f1354f0348298$var$vu.getTransfer(s);
            a === e.FLOAT && (c = e.RGBA32F), a === e.HALF_FLOAT && (c = e.RGBA16F), a === e.UNSIGNED_BYTE && (c = t === $a42f1354f0348298$var$Td ? e.SRGB8_ALPHA8 : e.RGBA8), a === e.UNSIGNED_SHORT && l && (c = l.RGBA16_EXT), a === e.SHORT && l && (c = l.RGBA16_SNORM_EXT), a === e.UNSIGNED_SHORT_4_4_4_4 && (c = e.RGBA4), a === e.UNSIGNED_SHORT_5_5_5_1 && (c = e.RGB5_A1);
        }
        return c !== e.R16F && c !== e.R32F && c !== e.RG16F && c !== e.RG32F && c !== e.RGBA16F && c !== e.RGBA32F || t.get("EXT_color_buffer_float"), c;
    }
    function y(t, i) {
        let n;
        return t ? null === i || i === $a42f1354f0348298$var$Cc || i === $a42f1354f0348298$var$Lc ? n = e.DEPTH24_STENCIL8 : i === $a42f1354f0348298$var$Tc ? n = e.DEPTH32F_STENCIL8 : i === $a42f1354f0348298$var$Mc && (n = e.DEPTH24_STENCIL8, $a42f1354f0348298$var$Wd("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : null === i || i === $a42f1354f0348298$var$Cc || i === $a42f1354f0348298$var$Lc ? n = e.DEPTH_COMPONENT24 : i === $a42f1354f0348298$var$Tc ? n = e.DEPTH_COMPONENT32F : i === $a42f1354f0348298$var$Mc && (n = e.DEPTH_COMPONENT16), n;
    }
    function b(e, t) {
        return !0 === f(e) || e.isFramebufferTexture && e.minFilter !== $a42f1354f0348298$var$fc && e.minFilter !== $a42f1354f0348298$var$Ec ? Math.log2(Math.max(t.width, t.height)) + 1 : void 0 !== e.mipmaps && e.mipmaps.length > 0 ? e.mipmaps.length : e.isCompressedTexture && Array.isArray(e.image) ? t.mipmaps.length : 1;
    }
    function k(e) {
        const t = e.target;
        t.removeEventListener("dispose", k), function(e) {
            const t = n.get(e);
            if (void 0 === t.__webglInit) return;
            const i = e.source, a = p.get(i);
            if (a) {
                const n = a[t.__cacheKey];
                n.usedTimes--, 0 === n.usedTimes && w(e), 0 === Object.keys(a).length && p.delete(i);
            }
            n.remove(e);
        }(t), t.isVideoTexture && d.delete(t), t.isHTMLTexture && u.delete(t);
    }
    function x(t) {
        const i = t.target;
        i.removeEventListener("dispose", x), function(t) {
            const i = n.get(t);
            t.depthTexture && (t.depthTexture.dispose(), n.remove(t.depthTexture));
            if (t.isWebGLCubeRenderTarget) for(let t = 0; t < 6; t++){
                if (Array.isArray(i.__webglFramebuffer[t])) for(let n = 0; n < i.__webglFramebuffer[t].length; n++)e.deleteFramebuffer(i.__webglFramebuffer[t][n]);
                else e.deleteFramebuffer(i.__webglFramebuffer[t]);
                i.__webglDepthbuffer && e.deleteRenderbuffer(i.__webglDepthbuffer[t]);
            }
            else {
                if (Array.isArray(i.__webglFramebuffer)) for(let t = 0; t < i.__webglFramebuffer.length; t++)e.deleteFramebuffer(i.__webglFramebuffer[t]);
                else e.deleteFramebuffer(i.__webglFramebuffer);
                if (i.__webglDepthbuffer && e.deleteRenderbuffer(i.__webglDepthbuffer), i.__webglMultisampledFramebuffer && e.deleteFramebuffer(i.__webglMultisampledFramebuffer), i.__webglColorRenderbuffer) for(let t = 0; t < i.__webglColorRenderbuffer.length; t++)i.__webglColorRenderbuffer[t] && e.deleteRenderbuffer(i.__webglColorRenderbuffer[t]);
                i.__webglDepthRenderbuffer && e.deleteRenderbuffer(i.__webglDepthRenderbuffer);
            }
            const a = t.textures;
            for(let t = 0, i = a.length; t < i; t++){
                const i = n.get(a[t]);
                i.__webglTexture && (e.deleteTexture(i.__webglTexture), s.memory.textures--), n.remove(a[t]);
            }
            n.remove(t);
        }(i);
    }
    function w(t) {
        const i = n.get(t);
        e.deleteTexture(i.__webglTexture);
        const a = t.source;
        delete p.get(a)[i.__cacheKey], s.memory.textures--;
    }
    let M = 0;
    function S(t, a) {
        const r = n.get(t);
        if (t.isVideoTexture && function(e) {
            const t = s.render.frame;
            d.get(e) !== t && (d.set(e, t), e.update());
        }(t), !1 === t.isRenderTargetTexture && !0 !== t.isExternalTexture && t.version > 0 && r.__version !== t.version) {
            const e = t.image;
            if (null === e) $a42f1354f0348298$var$Wd("WebGLRenderer: Texture marked for update but no image data found.");
            else {
                if (!1 !== e.complete) return void R(r, t, a);
                $a42f1354f0348298$var$Wd("WebGLRenderer: Texture marked for update but image is incomplete");
            }
        } else t.isExternalTexture && (r.__webglTexture = t.sourceTexture ? t.sourceTexture : null);
        i.bindTexture(e.TEXTURE_2D, r.__webglTexture, e.TEXTURE0 + a);
    }
    const C = {
        [$a42f1354f0348298$var$Ac]: e.REPEAT,
        [$a42f1354f0348298$var$mc]: e.CLAMP_TO_EDGE,
        [$a42f1354f0348298$var$gc]: e.MIRRORED_REPEAT
    }, T = {
        [$a42f1354f0348298$var$fc]: e.NEAREST,
        [$a42f1354f0348298$var$_c]: e.NEAREST_MIPMAP_NEAREST,
        [$a42f1354f0348298$var$vc]: e.NEAREST_MIPMAP_LINEAR,
        [$a42f1354f0348298$var$Ec]: e.LINEAR,
        [$a42f1354f0348298$var$yc]: e.LINEAR_MIPMAP_NEAREST,
        [$a42f1354f0348298$var$bc]: e.LINEAR_MIPMAP_LINEAR
    }, D = {
        [$a42f1354f0348298$var$Pd]: e.NEVER,
        [$a42f1354f0348298$var$Nd]: e.ALWAYS,
        [$a42f1354f0348298$var$Id]: e.LESS,
        [$a42f1354f0348298$var$Rd]: e.LEQUAL,
        [$a42f1354f0348298$var$Ld]: e.EQUAL,
        [$a42f1354f0348298$var$Ud]: e.GEQUAL,
        [$a42f1354f0348298$var$zd]: e.GREATER,
        [$a42f1354f0348298$var$Fd]: e.NOTEQUAL
    };
    function P(i, r) {
        if (r.type !== $a42f1354f0348298$var$Tc || !1 !== t.has("OES_texture_float_linear") || r.magFilter !== $a42f1354f0348298$var$Ec && r.magFilter !== $a42f1354f0348298$var$yc && r.magFilter !== $a42f1354f0348298$var$vc && r.magFilter !== $a42f1354f0348298$var$bc && r.minFilter !== $a42f1354f0348298$var$Ec && r.minFilter !== $a42f1354f0348298$var$yc && r.minFilter !== $a42f1354f0348298$var$vc && r.minFilter !== $a42f1354f0348298$var$bc || $a42f1354f0348298$var$Wd("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), e.texParameteri(i, e.TEXTURE_WRAP_S, C[r.wrapS]), e.texParameteri(i, e.TEXTURE_WRAP_T, C[r.wrapT]), i !== e.TEXTURE_3D && i !== e.TEXTURE_2D_ARRAY || e.texParameteri(i, e.TEXTURE_WRAP_R, C[r.wrapR]), e.texParameteri(i, e.TEXTURE_MAG_FILTER, T[r.magFilter]), e.texParameteri(i, e.TEXTURE_MIN_FILTER, T[r.minFilter]), r.compareFunction && (e.texParameteri(i, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE), e.texParameteri(i, e.TEXTURE_COMPARE_FUNC, D[r.compareFunction])), !0 === t.has("EXT_texture_filter_anisotropic")) {
            if (r.magFilter === $a42f1354f0348298$var$fc) return;
            if (r.minFilter !== $a42f1354f0348298$var$vc && r.minFilter !== $a42f1354f0348298$var$bc) return;
            if (r.type === $a42f1354f0348298$var$Tc && !1 === t.has("OES_texture_float_linear")) return;
            if (r.anisotropy > 1 || n.get(r).__currentAnisotropy) {
                const s = t.get("EXT_texture_filter_anisotropic");
                e.texParameterf(i, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(r.anisotropy, a.getMaxAnisotropy())), n.get(r).__currentAnisotropy = r.anisotropy;
            }
        }
    }
    function I(t, i) {
        let n = !1;
        void 0 === t.__webglInit && (t.__webglInit = !0, i.addEventListener("dispose", k));
        const a = i.source;
        let r = p.get(a);
        void 0 === r && (r = {}, p.set(a, r));
        const o = function(e) {
            const t = [];
            return t.push(e.wrapS), t.push(e.wrapT), t.push(e.wrapR || 0), t.push(e.magFilter), t.push(e.minFilter), t.push(e.anisotropy), t.push(e.internalFormat), t.push(e.format), t.push(e.type), t.push(e.generateMipmaps), t.push(e.premultiplyAlpha), t.push(e.flipY), t.push(e.unpackAlignment), t.push(e.colorSpace), t.join();
        }(i);
        if (o !== t.__cacheKey) {
            void 0 === r[o] && (r[o] = {
                texture: e.createTexture(),
                usedTimes: 0
            }, s.memory.textures++, n = !0), r[o].usedTimes++;
            const a = r[t.__cacheKey];
            void 0 !== a && (r[t.__cacheKey].usedTimes--, 0 === a.usedTimes && w(i)), t.__cacheKey = o, t.__webglTexture = r[o].texture;
        }
        return n;
    }
    function L(e, t, i) {
        return Math.floor(Math.floor(e / i) / t);
    }
    function R(t, s, o) {
        let l = e.TEXTURE_2D;
        (s.isDataArrayTexture || s.isCompressedArrayTexture) && (l = e.TEXTURE_2D_ARRAY), s.isData3DTexture && (l = e.TEXTURE_3D);
        const c = I(t, s), d = s.source;
        i.bindTexture(l, t.__webglTexture, e.TEXTURE0 + o);
        const h = n.get(d);
        if (d.version !== h.__version || !0 === c) {
            i.activeTexture(e.TEXTURE0 + o);
            if (!1 === ("undefined" != typeof ImageBitmap && s.image instanceof ImageBitmap)) {
                const t = $a42f1354f0348298$var$vu.getPrimaries($a42f1354f0348298$var$vu.workingColorSpace), n = s.colorSpace === $a42f1354f0348298$var$wd ? null : $a42f1354f0348298$var$vu.getPrimaries(s.colorSpace), a = s.colorSpace === $a42f1354f0348298$var$wd || t === n ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
                i.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, s.flipY), i.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s.premultiplyAlpha), i.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, a);
            }
            i.pixelStorei(e.UNPACK_ALIGNMENT, s.unpackAlignment);
            let t = g(s.image, !1, a.maxTextureSize);
            t = V(s, t);
            const n = r.convert(s.format, s.colorSpace), p = r.convert(s.type);
            let A, m = E(s.internalFormat, n, p, s.normalized, s.colorSpace, s.isVideoTexture);
            P(l, s);
            const v = s.mipmaps, k = !0 !== s.isVideoTexture, x = void 0 === h.__version || !0 === c, w = d.dataReady, M = b(s, t);
            if (s.isDepthTexture) m = y(s.format === $a42f1354f0348298$var$Nc, s.type), x && (k ? i.texStorage2D(e.TEXTURE_2D, 1, m, t.width, t.height) : i.texImage2D(e.TEXTURE_2D, 0, m, t.width, t.height, 0, n, p, null));
            else if (s.isDataTexture) {
                if (v.length > 0) {
                    k && x && i.texStorage2D(e.TEXTURE_2D, M, m, v[0].width, v[0].height);
                    for(let t = 0, a = v.length; t < a; t++)A = v[t], k ? w && i.texSubImage2D(e.TEXTURE_2D, t, 0, 0, A.width, A.height, n, p, A.data) : i.texImage2D(e.TEXTURE_2D, t, m, A.width, A.height, 0, n, p, A.data);
                    s.generateMipmaps = !1;
                } else k ? (x && i.texStorage2D(e.TEXTURE_2D, M, m, t.width, t.height), w && function(t, n, a, r) {
                    const s = t.updateRanges;
                    if (0 === s.length) i.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, n.width, n.height, a, r, n.data);
                    else {
                        s.sort((e, t)=>e.start - t.start);
                        let o = 0;
                        for(let e = 1; e < s.length; e++){
                            const t = s[o], i = s[e], a = t.start + t.count, r = L(i.start, n.width, 4), l = L(t.start, n.width, 4);
                            i.start <= a + 1 && r === l && L(i.start + i.count - 1, n.width, 4) === r ? t.count = Math.max(t.count, i.start + i.count - t.start) : (++o, s[o] = i);
                        }
                        s.length = o + 1;
                        const l = i.getParameter(e.UNPACK_ROW_LENGTH), c = i.getParameter(e.UNPACK_SKIP_PIXELS), d = i.getParameter(e.UNPACK_SKIP_ROWS);
                        i.pixelStorei(e.UNPACK_ROW_LENGTH, n.width);
                        for(let t = 0, o = s.length; t < o; t++){
                            const o = s[t], l = Math.floor(o.start / 4), c = Math.ceil(o.count / 4), d = l % n.width, u = Math.floor(l / n.width), h = c, p = 1;
                            i.pixelStorei(e.UNPACK_SKIP_PIXELS, d), i.pixelStorei(e.UNPACK_SKIP_ROWS, u), i.texSubImage2D(e.TEXTURE_2D, 0, d, u, h, p, a, r, n.data);
                        }
                        t.clearUpdateRanges(), i.pixelStorei(e.UNPACK_ROW_LENGTH, l), i.pixelStorei(e.UNPACK_SKIP_PIXELS, c), i.pixelStorei(e.UNPACK_SKIP_ROWS, d);
                    }
                }(s, t, n, p)) : i.texImage2D(e.TEXTURE_2D, 0, m, t.width, t.height, 0, n, p, t.data);
            } else if (s.isCompressedTexture) {
                if (s.isCompressedArrayTexture) {
                    k && x && i.texStorage3D(e.TEXTURE_2D_ARRAY, M, m, v[0].width, v[0].height, t.depth);
                    for(let a = 0, r = v.length; a < r; a++)if (A = v[a], s.format !== $a42f1354f0348298$var$Fc) {
                        if (null !== n) {
                            if (k) {
                                if (w) {
                                    if (s.layerUpdates.size > 0) {
                                        const t = $a42f1354f0348298$var$YA(A.width, A.height, s.format, s.type);
                                        for (const r of s.layerUpdates){
                                            const s = A.data.subarray(r * t / A.data.BYTES_PER_ELEMENT, (r + 1) * t / A.data.BYTES_PER_ELEMENT);
                                            i.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, a, 0, 0, r, A.width, A.height, 1, n, s);
                                        }
                                        s.clearLayerUpdates();
                                    } else i.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, a, 0, 0, 0, A.width, A.height, t.depth, n, A.data);
                                }
                            } else i.compressedTexImage3D(e.TEXTURE_2D_ARRAY, a, m, A.width, A.height, t.depth, 0, A.data, 0, 0);
                        } else $a42f1354f0348298$var$Wd("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                    } else k ? w && i.texSubImage3D(e.TEXTURE_2D_ARRAY, a, 0, 0, 0, A.width, A.height, t.depth, n, p, A.data) : i.texImage3D(e.TEXTURE_2D_ARRAY, a, m, A.width, A.height, t.depth, 0, n, p, A.data);
                } else {
                    k && x && i.texStorage2D(e.TEXTURE_2D, M, m, v[0].width, v[0].height);
                    for(let t = 0, a = v.length; t < a; t++)A = v[t], s.format !== $a42f1354f0348298$var$Fc ? null !== n ? k ? w && i.compressedTexSubImage2D(e.TEXTURE_2D, t, 0, 0, A.width, A.height, n, A.data) : i.compressedTexImage2D(e.TEXTURE_2D, t, m, A.width, A.height, 0, A.data) : $a42f1354f0348298$var$Wd("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : k ? w && i.texSubImage2D(e.TEXTURE_2D, t, 0, 0, A.width, A.height, n, p, A.data) : i.texImage2D(e.TEXTURE_2D, t, m, A.width, A.height, 0, n, p, A.data);
                }
            } else if (s.isDataArrayTexture) {
                if (k) {
                    if (x && i.texStorage3D(e.TEXTURE_2D_ARRAY, M, m, t.width, t.height, t.depth), w) {
                        if (s.layerUpdates.size > 0) {
                            const a = $a42f1354f0348298$var$YA(t.width, t.height, s.format, s.type);
                            for (const r of s.layerUpdates){
                                const s = t.data.subarray(r * a / t.data.BYTES_PER_ELEMENT, (r + 1) * a / t.data.BYTES_PER_ELEMENT);
                                i.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, r, t.width, t.height, 1, n, p, s);
                            }
                            s.clearLayerUpdates();
                        } else i.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, 0, t.width, t.height, t.depth, n, p, t.data);
                    }
                } else i.texImage3D(e.TEXTURE_2D_ARRAY, 0, m, t.width, t.height, t.depth, 0, n, p, t.data);
            } else if (s.isData3DTexture) k ? (x && i.texStorage3D(e.TEXTURE_3D, M, m, t.width, t.height, t.depth), w && i.texSubImage3D(e.TEXTURE_3D, 0, 0, 0, 0, t.width, t.height, t.depth, n, p, t.data)) : i.texImage3D(e.TEXTURE_3D, 0, m, t.width, t.height, t.depth, 0, n, p, t.data);
            else if (s.isFramebufferTexture) {
                if (x) {
                    if (k) i.texStorage2D(e.TEXTURE_2D, M, m, t.width, t.height);
                    else {
                        let a = t.width, r = t.height;
                        for(let t = 0; t < M; t++)i.texImage2D(e.TEXTURE_2D, t, m, a, r, 0, n, p, null), a >>= 1, r >>= 1;
                    }
                }
            } else if (s.isHTMLTexture) {
                if ("texElementImage2D" in e) {
                    const i = e.canvas;
                    if (i.hasAttribute("layoutsubtree") || i.setAttribute("layoutsubtree", "true"), t.parentNode !== i) return i.appendChild(t), u.add(s), i.onpaint = (e)=>{
                        const t = e.changedElements;
                        for (const e of u)t.includes(e.image) && (e.needsUpdate = !0);
                    }, void i.requestPaint();
                    if (3 === e.texElementImage2D.length) e.texElementImage2D(e.TEXTURE_2D, e.RGBA8, t);
                    else {
                        const i = 0, n = e.RGBA, a = e.RGBA, r = e.UNSIGNED_BYTE;
                        e.texElementImage2D(e.TEXTURE_2D, i, n, a, r, t);
                    }
                    e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
                }
            } else if (v.length > 0) {
                if (k && x) {
                    const t = H(v[0]);
                    i.texStorage2D(e.TEXTURE_2D, M, m, t.width, t.height);
                }
                for(let t = 0, a = v.length; t < a; t++)A = v[t], k ? w && i.texSubImage2D(e.TEXTURE_2D, t, 0, 0, n, p, A) : i.texImage2D(e.TEXTURE_2D, t, m, n, p, A);
                s.generateMipmaps = !1;
            } else if (k) {
                if (x) {
                    const n = H(t);
                    i.texStorage2D(e.TEXTURE_2D, M, m, n.width, n.height);
                }
                w && i.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, n, p, t);
            } else i.texImage2D(e.TEXTURE_2D, 0, m, n, p, t);
            f(s) && _(l), h.__version = d.version, s.onUpdate && s.onUpdate(s);
        }
        t.__version = s.version;
    }
    function z(t, a, s, l, c, d) {
        const u = r.convert(s.format, s.colorSpace), h = r.convert(s.type), p = E(s.internalFormat, u, h, s.normalized, s.colorSpace), A = n.get(a), m = n.get(s);
        if (m.__renderTarget = a, !A.__hasExternalTextures) {
            const t = Math.max(1, a.width >> d), n = Math.max(1, a.height >> d);
            c === e.TEXTURE_3D || c === e.TEXTURE_2D_ARRAY ? i.texImage3D(c, d, p, t, n, a.depth, 0, u, h, null) : i.texImage2D(c, d, p, t, n, 0, u, h, null);
        }
        i.bindFramebuffer(e.FRAMEBUFFER, t), G(a) ? o.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, l, c, m.__webglTexture, 0, j(a)) : (c === e.TEXTURE_2D || c >= e.TEXTURE_CUBE_MAP_POSITIVE_X && c <= e.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e.framebufferTexture2D(e.FRAMEBUFFER, l, c, m.__webglTexture, d), i.bindFramebuffer(e.FRAMEBUFFER, null);
    }
    function F(t, i, n) {
        if (e.bindRenderbuffer(e.RENDERBUFFER, t), i.depthBuffer) {
            const a = i.depthTexture, r = a && a.isDepthTexture ? a.type : null, s = y(i.stencilBuffer, r), l = i.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
            G(i) ? o.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, j(i), s, i.width, i.height) : n ? e.renderbufferStorageMultisample(e.RENDERBUFFER, j(i), s, i.width, i.height) : e.renderbufferStorage(e.RENDERBUFFER, s, i.width, i.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, l, e.RENDERBUFFER, t);
        } else {
            const t = i.textures;
            for(let a = 0; a < t.length; a++){
                const s = t[a], l = r.convert(s.format, s.colorSpace), c = r.convert(s.type), d = E(s.internalFormat, l, c, s.normalized, s.colorSpace);
                G(i) ? o.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, j(i), d, i.width, i.height) : n ? e.renderbufferStorageMultisample(e.RENDERBUFFER, j(i), d, i.width, i.height) : e.renderbufferStorage(e.RENDERBUFFER, d, i.width, i.height);
            }
        }
        e.bindRenderbuffer(e.RENDERBUFFER, null);
    }
    function U(t, a, s) {
        const l = !0 === a.isWebGLCubeRenderTarget;
        if (i.bindFramebuffer(e.FRAMEBUFFER, t), !a.depthTexture || !a.depthTexture.isDepthTexture) throw new Error("THREE.WebGLTextures: renderTarget.depthTexture must be an instance of THREE.DepthTexture.");
        const c = n.get(a.depthTexture);
        if (c.__renderTarget = a, c.__webglTexture && a.depthTexture.image.width === a.width && a.depthTexture.image.height === a.height || (a.depthTexture.image.width = a.width, a.depthTexture.image.height = a.height, a.depthTexture.needsUpdate = !0), l) {
            if (void 0 === c.__webglInit && (c.__webglInit = !0, a.depthTexture.addEventListener("dispose", k)), void 0 === c.__webglTexture) {
                c.__webglTexture = e.createTexture(), i.bindTexture(e.TEXTURE_CUBE_MAP, c.__webglTexture), P(e.TEXTURE_CUBE_MAP, a.depthTexture);
                const t = r.convert(a.depthTexture.format), n = r.convert(a.depthTexture.type);
                let s;
                a.depthTexture.format === $a42f1354f0348298$var$Uc ? s = e.DEPTH_COMPONENT24 : a.depthTexture.format === $a42f1354f0348298$var$Nc && (s = e.DEPTH24_STENCIL8);
                for(let i = 0; i < 6; i++)e.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, s, a.width, a.height, 0, t, n, null);
            }
        } else S(a.depthTexture, 0);
        const d = c.__webglTexture, u = j(a), h = l ? e.TEXTURE_CUBE_MAP_POSITIVE_X + s : e.TEXTURE_2D, p = a.depthTexture.format === $a42f1354f0348298$var$Nc ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
        if (a.depthTexture.format === $a42f1354f0348298$var$Uc) G(a) ? o.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, p, h, d, 0, u) : e.framebufferTexture2D(e.FRAMEBUFFER, p, h, d, 0);
        else {
            if (a.depthTexture.format !== $a42f1354f0348298$var$Nc) throw new Error("THREE.WebGLTextures: Unknown depthTexture format.");
            G(a) ? o.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, p, h, d, 0, u) : e.framebufferTexture2D(e.FRAMEBUFFER, p, h, d, 0);
        }
    }
    function N(t) {
        const a = n.get(t), r = !0 === t.isWebGLCubeRenderTarget;
        if (a.__boundDepthTexture !== t.depthTexture) {
            const e = t.depthTexture;
            if (a.__depthDisposeCallback && a.__depthDisposeCallback(), e) {
                const t = ()=>{
                    delete a.__boundDepthTexture, delete a.__depthDisposeCallback, e.removeEventListener("dispose", t);
                };
                e.addEventListener("dispose", t), a.__depthDisposeCallback = t;
            }
            a.__boundDepthTexture = e;
        }
        if (t.depthTexture && !a.__autoAllocateDepthBuffer) {
            if (r) for(let e = 0; e < 6; e++)U(a.__webglFramebuffer[e], t, e);
            else {
                const e = t.texture.mipmaps;
                e && e.length > 0 ? U(a.__webglFramebuffer[0], t, 0) : U(a.__webglFramebuffer, t, 0);
            }
        } else if (r) {
            a.__webglDepthbuffer = [];
            for(let n = 0; n < 6; n++)if (i.bindFramebuffer(e.FRAMEBUFFER, a.__webglFramebuffer[n]), void 0 === a.__webglDepthbuffer[n]) a.__webglDepthbuffer[n] = e.createRenderbuffer(), F(a.__webglDepthbuffer[n], t, !1);
            else {
                const i = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, r = a.__webglDepthbuffer[n];
                e.bindRenderbuffer(e.RENDERBUFFER, r), e.framebufferRenderbuffer(e.FRAMEBUFFER, i, e.RENDERBUFFER, r);
            }
        } else {
            const n = t.texture.mipmaps;
            if (n && n.length > 0 ? i.bindFramebuffer(e.FRAMEBUFFER, a.__webglFramebuffer[0]) : i.bindFramebuffer(e.FRAMEBUFFER, a.__webglFramebuffer), void 0 === a.__webglDepthbuffer) a.__webglDepthbuffer = e.createRenderbuffer(), F(a.__webglDepthbuffer, t, !1);
            else {
                const i = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, n = a.__webglDepthbuffer;
                e.bindRenderbuffer(e.RENDERBUFFER, n), e.framebufferRenderbuffer(e.FRAMEBUFFER, i, e.RENDERBUFFER, n);
            }
        }
        i.bindFramebuffer(e.FRAMEBUFFER, null);
    }
    const B = [], O = [];
    function j(e) {
        return Math.min(a.maxSamples, e.samples);
    }
    function G(e) {
        const i = n.get(e);
        return e.samples > 0 && !0 === t.has("WEBGL_multisampled_render_to_texture") && !1 !== i.__useRenderToTexture;
    }
    function V(e, t) {
        const i = e.colorSpace, n = e.format, a = e.type;
        return !0 === e.isCompressedTexture || !0 === e.isVideoTexture || i !== $a42f1354f0348298$var$Sd && i !== $a42f1354f0348298$var$wd && ($a42f1354f0348298$var$vu.getTransfer(i) === $a42f1354f0348298$var$Td ? n === $a42f1354f0348298$var$Fc && a === $a42f1354f0348298$var$kc || $a42f1354f0348298$var$Wd("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : $a42f1354f0348298$var$Xd("WebGLTextures: Unsupported texture color space:", i)), t;
    }
    function H(e) {
        return "undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement ? (c.width = e.naturalWidth || e.width, c.height = e.naturalHeight || e.height) : "undefined" != typeof VideoFrame && e instanceof VideoFrame ? (c.width = e.displayWidth, c.height = e.displayHeight) : (c.width = e.width, c.height = e.height), c;
    }
    this.allocateTextureUnit = function() {
        const e = M;
        return e >= a.maxTextures && $a42f1354f0348298$var$Wd("WebGLTextures: Trying to use " + e + " texture units while this GPU supports only " + a.maxTextures), M += 1, e;
    }, this.resetTextureUnits = function() {
        M = 0;
    }, this.getTextureUnits = function() {
        return M;
    }, this.setTextureUnits = function(e) {
        M = e;
    }, this.setTexture2D = S, this.setTexture2DArray = function(t, a) {
        const r = n.get(t);
        !1 === t.isRenderTargetTexture && t.version > 0 && r.__version !== t.version ? R(r, t, a) : (t.isExternalTexture && (r.__webglTexture = t.sourceTexture ? t.sourceTexture : null), i.bindTexture(e.TEXTURE_2D_ARRAY, r.__webglTexture, e.TEXTURE0 + a));
    }, this.setTexture3D = function(t, a) {
        const r = n.get(t);
        !1 === t.isRenderTargetTexture && t.version > 0 && r.__version !== t.version ? R(r, t, a) : i.bindTexture(e.TEXTURE_3D, r.__webglTexture, e.TEXTURE0 + a);
    }, this.setTextureCube = function(t, s) {
        const o = n.get(t);
        !0 !== t.isCubeDepthTexture && t.version > 0 && o.__version !== t.version ? function(t, s, o) {
            if (6 !== s.image.length) return;
            const l = I(t, s), c = s.source;
            i.bindTexture(e.TEXTURE_CUBE_MAP, t.__webglTexture, e.TEXTURE0 + o);
            const d = n.get(c);
            if (c.version !== d.__version || !0 === l) {
                i.activeTexture(e.TEXTURE0 + o);
                const t = $a42f1354f0348298$var$vu.getPrimaries($a42f1354f0348298$var$vu.workingColorSpace), n = s.colorSpace === $a42f1354f0348298$var$wd ? null : $a42f1354f0348298$var$vu.getPrimaries(s.colorSpace), u = s.colorSpace === $a42f1354f0348298$var$wd || t === n ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
                i.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, s.flipY), i.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s.premultiplyAlpha), i.pixelStorei(e.UNPACK_ALIGNMENT, s.unpackAlignment), i.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, u);
                const h = s.isCompressedTexture || s.image[0].isCompressedTexture, p = s.image[0] && s.image[0].isDataTexture, A = [];
                for(let e = 0; e < 6; e++)A[e] = h || p ? p ? s.image[e].image : s.image[e] : g(s.image[e], !0, a.maxCubemapSize), A[e] = V(s, A[e]);
                const m = A[0], v = r.convert(s.format, s.colorSpace), y = r.convert(s.type), k = E(s.internalFormat, v, y, s.normalized, s.colorSpace), x = !0 !== s.isVideoTexture, w = void 0 === d.__version || !0 === l, M = c.dataReady;
                let S, C = b(s, m);
                if (P(e.TEXTURE_CUBE_MAP, s), h) {
                    x && w && i.texStorage2D(e.TEXTURE_CUBE_MAP, C, k, m.width, m.height);
                    for(let t = 0; t < 6; t++){
                        S = A[t].mipmaps;
                        for(let n = 0; n < S.length; n++){
                            const a = S[n];
                            s.format !== $a42f1354f0348298$var$Fc ? null !== v ? x ? M && i.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, 0, 0, a.width, a.height, v, a.data) : i.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, k, a.width, a.height, 0, a.data) : $a42f1354f0348298$var$Wd("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : x ? M && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, 0, 0, a.width, a.height, v, y, a.data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, k, a.width, a.height, 0, v, y, a.data);
                        }
                    }
                } else {
                    if (S = s.mipmaps, x && w) {
                        S.length > 0 && C++;
                        const t = H(A[0]);
                        i.texStorage2D(e.TEXTURE_CUBE_MAP, C, k, t.width, t.height);
                    }
                    for(let t = 0; t < 6; t++)if (p) {
                        x ? M && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, A[t].width, A[t].height, v, y, A[t].data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, k, A[t].width, A[t].height, 0, v, y, A[t].data);
                        for(let n = 0; n < S.length; n++){
                            const a = S[n].image[t].image;
                            x ? M && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, 0, 0, a.width, a.height, v, y, a.data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, k, a.width, a.height, 0, v, y, a.data);
                        }
                    } else {
                        x ? M && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, v, y, A[t]) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, k, v, y, A[t]);
                        for(let n = 0; n < S.length; n++){
                            const a = S[n];
                            x ? M && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, 0, 0, v, y, a.image[t]) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, k, v, y, a.image[t]);
                        }
                    }
                }
                f(s) && _(e.TEXTURE_CUBE_MAP), d.__version = c.version, s.onUpdate && s.onUpdate(s);
            }
            t.__version = s.version;
        }(o, t, s) : i.bindTexture(e.TEXTURE_CUBE_MAP, o.__webglTexture, e.TEXTURE0 + s);
    }, this.rebindTextures = function(t, i, a) {
        const r = n.get(t);
        void 0 !== i && z(r.__webglFramebuffer, t, t.texture, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, 0), void 0 !== a && N(t);
    }, this.setupRenderTarget = function(t) {
        const a = t.texture, o = n.get(t), l = n.get(a);
        t.addEventListener("dispose", x);
        const c = t.textures, d = !0 === t.isWebGLCubeRenderTarget, u = c.length > 1;
        if (u || (void 0 === l.__webglTexture && (l.__webglTexture = e.createTexture()), l.__version = a.version, s.memory.textures++), d) {
            o.__webglFramebuffer = [];
            for(let t = 0; t < 6; t++)if (a.mipmaps && a.mipmaps.length > 0) {
                o.__webglFramebuffer[t] = [];
                for(let i = 0; i < a.mipmaps.length; i++)o.__webglFramebuffer[t][i] = e.createFramebuffer();
            } else o.__webglFramebuffer[t] = e.createFramebuffer();
        } else {
            if (a.mipmaps && a.mipmaps.length > 0) {
                o.__webglFramebuffer = [];
                for(let t = 0; t < a.mipmaps.length; t++)o.__webglFramebuffer[t] = e.createFramebuffer();
            } else o.__webglFramebuffer = e.createFramebuffer();
            if (u) for(let t = 0, i = c.length; t < i; t++){
                const i = n.get(c[t]);
                void 0 === i.__webglTexture && (i.__webglTexture = e.createTexture(), s.memory.textures++);
            }
            if (t.samples > 0 && !1 === G(t)) {
                o.__webglMultisampledFramebuffer = e.createFramebuffer(), o.__webglColorRenderbuffer = [], i.bindFramebuffer(e.FRAMEBUFFER, o.__webglMultisampledFramebuffer);
                for(let i = 0; i < c.length; i++){
                    const n = c[i];
                    o.__webglColorRenderbuffer[i] = e.createRenderbuffer(), e.bindRenderbuffer(e.RENDERBUFFER, o.__webglColorRenderbuffer[i]);
                    const a = r.convert(n.format, n.colorSpace), s = r.convert(n.type), l = E(n.internalFormat, a, s, n.normalized, n.colorSpace, !0 === t.isXRRenderTarget), d = j(t);
                    e.renderbufferStorageMultisample(e.RENDERBUFFER, d, l, t.width, t.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + i, e.RENDERBUFFER, o.__webglColorRenderbuffer[i]);
                }
                e.bindRenderbuffer(e.RENDERBUFFER, null), t.depthBuffer && (o.__webglDepthRenderbuffer = e.createRenderbuffer(), F(o.__webglDepthRenderbuffer, t, !0)), i.bindFramebuffer(e.FRAMEBUFFER, null);
            }
        }
        if (d) {
            i.bindTexture(e.TEXTURE_CUBE_MAP, l.__webglTexture), P(e.TEXTURE_CUBE_MAP, a);
            for(let i = 0; i < 6; i++)if (a.mipmaps && a.mipmaps.length > 0) for(let n = 0; n < a.mipmaps.length; n++)z(o.__webglFramebuffer[i][n], t, a, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + i, n);
            else z(o.__webglFramebuffer[i], t, a, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            f(a) && _(e.TEXTURE_CUBE_MAP), i.unbindTexture();
        } else if (u) {
            for(let a = 0, r = c.length; a < r; a++){
                const r = c[a], s = n.get(r);
                let l = e.TEXTURE_2D;
                (t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (l = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), i.bindTexture(l, s.__webglTexture), P(l, r), z(o.__webglFramebuffer, t, r, e.COLOR_ATTACHMENT0 + a, l, 0), f(r) && _(l);
            }
            i.unbindTexture();
        } else {
            let n = e.TEXTURE_2D;
            if ((t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (n = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), i.bindTexture(n, l.__webglTexture), P(n, a), a.mipmaps && a.mipmaps.length > 0) for(let i = 0; i < a.mipmaps.length; i++)z(o.__webglFramebuffer[i], t, a, e.COLOR_ATTACHMENT0, n, i);
            else z(o.__webglFramebuffer, t, a, e.COLOR_ATTACHMENT0, n, 0);
            f(a) && _(n), i.unbindTexture();
        }
        t.depthBuffer && N(t);
    }, this.updateRenderTargetMipmap = function(e) {
        const t = e.textures;
        for(let a = 0, r = t.length; a < r; a++){
            const r = t[a];
            if (f(r)) {
                const t = v(e), a = n.get(r).__webglTexture;
                i.bindTexture(t, a), _(t), i.unbindTexture();
            }
        }
    }, this.updateMultisampleRenderTarget = function(t) {
        if (t.samples > 0) {
            if (!1 === G(t)) {
                const a = t.textures, r = t.width, s = t.height;
                let o = e.COLOR_BUFFER_BIT;
                const c = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, d = n.get(t), u = a.length > 1;
                if (u) for(let t = 0; t < a.length; t++)i.bindFramebuffer(e.FRAMEBUFFER, d.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, null), i.bindFramebuffer(e.FRAMEBUFFER, d.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, null, 0);
                i.bindFramebuffer(e.READ_FRAMEBUFFER, d.__webglMultisampledFramebuffer);
                const h = t.texture.mipmaps;
                h && h.length > 0 ? i.bindFramebuffer(e.DRAW_FRAMEBUFFER, d.__webglFramebuffer[0]) : i.bindFramebuffer(e.DRAW_FRAMEBUFFER, d.__webglFramebuffer);
                for(let i = 0; i < a.length; i++){
                    if (t.resolveDepthBuffer && (t.depthBuffer && (o |= e.DEPTH_BUFFER_BIT), t.stencilBuffer && t.resolveStencilBuffer && (o |= e.STENCIL_BUFFER_BIT)), u) {
                        e.framebufferRenderbuffer(e.READ_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.RENDERBUFFER, d.__webglColorRenderbuffer[i]);
                        const t = n.get(a[i]).__webglTexture;
                        e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
                    }
                    e.blitFramebuffer(0, 0, r, s, 0, 0, r, s, o, e.NEAREST), !0 === l && (B.length = 0, O.length = 0, B.push(e.COLOR_ATTACHMENT0 + i), t.depthBuffer && !1 === t.resolveDepthBuffer && (B.push(c), O.push(c), e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, O)), e.invalidateFramebuffer(e.READ_FRAMEBUFFER, B));
                }
                if (i.bindFramebuffer(e.READ_FRAMEBUFFER, null), i.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), u) for(let t = 0; t < a.length; t++){
                    i.bindFramebuffer(e.FRAMEBUFFER, d.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, d.__webglColorRenderbuffer[t]);
                    const r = n.get(a[t]).__webglTexture;
                    i.bindFramebuffer(e.FRAMEBUFFER, d.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, r, 0);
                }
                i.bindFramebuffer(e.DRAW_FRAMEBUFFER, d.__webglMultisampledFramebuffer);
            } else if (t.depthBuffer && !1 === t.resolveDepthBuffer && l) {
                const i = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
                e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, [
                    i
                ]);
            }
        }
    }, this.setupDepthRenderbuffer = N, this.setupFrameBufferTexture = z, this.useMultisampledRTT = G, this.isReversedDepthBuffer = function() {
        return i.buffers.depth.getReversed();
    };
}
function $a42f1354f0348298$var$Ff(e, t) {
    return {
        convert: function(i, n = "") {
            let a;
            const r = $a42f1354f0348298$var$vu.getTransfer(n);
            if (i === $a42f1354f0348298$var$kc) return e.UNSIGNED_BYTE;
            if (i === $a42f1354f0348298$var$Pc) return e.UNSIGNED_SHORT_4_4_4_4;
            if (i === $a42f1354f0348298$var$Ic) return e.UNSIGNED_SHORT_5_5_5_1;
            if (i === $a42f1354f0348298$var$Rc) return e.UNSIGNED_INT_5_9_9_9_REV;
            if (i === $a42f1354f0348298$var$zc) return e.UNSIGNED_INT_10F_11F_11F_REV;
            if (i === $a42f1354f0348298$var$xc) return e.BYTE;
            if (i === $a42f1354f0348298$var$wc) return e.SHORT;
            if (i === $a42f1354f0348298$var$Mc) return e.UNSIGNED_SHORT;
            if (i === $a42f1354f0348298$var$Sc) return e.INT;
            if (i === $a42f1354f0348298$var$Cc) return e.UNSIGNED_INT;
            if (i === $a42f1354f0348298$var$Tc) return e.FLOAT;
            if (i === $a42f1354f0348298$var$Dc) return e.HALF_FLOAT;
            if (1021 === i) return e.ALPHA;
            if (1022 === i) return e.RGB;
            if (i === $a42f1354f0348298$var$Fc) return e.RGBA;
            if (i === $a42f1354f0348298$var$Uc) return e.DEPTH_COMPONENT;
            if (i === $a42f1354f0348298$var$Nc) return e.DEPTH_STENCIL;
            if (1028 === i) return e.RED;
            if (i === $a42f1354f0348298$var$Bc) return e.RED_INTEGER;
            if (i === $a42f1354f0348298$var$Oc) return e.RG;
            if (i === $a42f1354f0348298$var$jc) return e.RG_INTEGER;
            if (i === $a42f1354f0348298$var$Gc) return e.RGBA_INTEGER;
            if (i === $a42f1354f0348298$var$Vc || i === $a42f1354f0348298$var$Hc || i === $a42f1354f0348298$var$qc || i === $a42f1354f0348298$var$Kc) {
                if (r === $a42f1354f0348298$var$Td) {
                    if (a = t.get("WEBGL_compressed_texture_s3tc_srgb"), null === a) return null;
                    if (i === $a42f1354f0348298$var$Vc) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (i === $a42f1354f0348298$var$Hc) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (i === $a42f1354f0348298$var$qc) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (i === $a42f1354f0348298$var$Kc) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else {
                    if (a = t.get("WEBGL_compressed_texture_s3tc"), null === a) return null;
                    if (i === $a42f1354f0348298$var$Vc) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (i === $a42f1354f0348298$var$Hc) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (i === $a42f1354f0348298$var$qc) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (i === $a42f1354f0348298$var$Kc) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                }
            }
            if (i === $a42f1354f0348298$var$Wc || i === $a42f1354f0348298$var$Xc || i === $a42f1354f0348298$var$Qc || i === $a42f1354f0348298$var$Zc) {
                if (a = t.get("WEBGL_compressed_texture_pvrtc"), null === a) return null;
                if (i === $a42f1354f0348298$var$Wc) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (i === $a42f1354f0348298$var$Xc) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (i === $a42f1354f0348298$var$Qc) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (i === $a42f1354f0348298$var$Zc) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            }
            if (i === $a42f1354f0348298$var$Yc || i === $a42f1354f0348298$var$Jc || i === $a42f1354f0348298$var$$c || i === $a42f1354f0348298$var$ed || i === $a42f1354f0348298$var$td || i === $a42f1354f0348298$var$id || i === $a42f1354f0348298$var$nd) {
                if (a = t.get("WEBGL_compressed_texture_etc"), null === a) return null;
                if (i === $a42f1354f0348298$var$Yc || i === $a42f1354f0348298$var$Jc) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                if (i === $a42f1354f0348298$var$$c) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
                if (i === $a42f1354f0348298$var$ed) return a.COMPRESSED_R11_EAC;
                if (i === $a42f1354f0348298$var$td) return a.COMPRESSED_SIGNED_R11_EAC;
                if (i === $a42f1354f0348298$var$id) return a.COMPRESSED_RG11_EAC;
                if (i === $a42f1354f0348298$var$nd) return a.COMPRESSED_SIGNED_RG11_EAC;
            }
            if (i === $a42f1354f0348298$var$ad || i === $a42f1354f0348298$var$rd || i === $a42f1354f0348298$var$sd || i === $a42f1354f0348298$var$od || i === $a42f1354f0348298$var$ld || i === $a42f1354f0348298$var$cd || i === $a42f1354f0348298$var$dd || i === $a42f1354f0348298$var$ud || i === $a42f1354f0348298$var$hd || i === $a42f1354f0348298$var$pd || i === $a42f1354f0348298$var$Ad || i === $a42f1354f0348298$var$md || i === $a42f1354f0348298$var$gd || i === $a42f1354f0348298$var$fd) {
                if (a = t.get("WEBGL_compressed_texture_astc"), null === a) return null;
                if (i === $a42f1354f0348298$var$ad) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (i === $a42f1354f0348298$var$rd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (i === $a42f1354f0348298$var$sd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (i === $a42f1354f0348298$var$od) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (i === $a42f1354f0348298$var$ld) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (i === $a42f1354f0348298$var$cd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (i === $a42f1354f0348298$var$dd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (i === $a42f1354f0348298$var$ud) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (i === $a42f1354f0348298$var$hd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (i === $a42f1354f0348298$var$pd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (i === $a42f1354f0348298$var$Ad) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (i === $a42f1354f0348298$var$md) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (i === $a42f1354f0348298$var$gd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (i === $a42f1354f0348298$var$fd) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
            }
            if (i === $a42f1354f0348298$var$_d || i === $a42f1354f0348298$var$vd || i === $a42f1354f0348298$var$Ed) {
                if (a = t.get("EXT_texture_compression_bptc"), null === a) return null;
                if (i === $a42f1354f0348298$var$_d) return r === $a42f1354f0348298$var$Td ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (i === $a42f1354f0348298$var$vd) return a.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (i === $a42f1354f0348298$var$Ed) return a.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            }
            if (i === $a42f1354f0348298$var$yd || i === $a42f1354f0348298$var$bd || i === $a42f1354f0348298$var$kd || i === $a42f1354f0348298$var$xd) {
                if (a = t.get("EXT_texture_compression_rgtc"), null === a) return null;
                if (i === $a42f1354f0348298$var$yd) return a.COMPRESSED_RED_RGTC1_EXT;
                if (i === $a42f1354f0348298$var$bd) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (i === $a42f1354f0348298$var$kd) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (i === $a42f1354f0348298$var$xd) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            }
            return i === $a42f1354f0348298$var$Lc ? e.UNSIGNED_INT_24_8 : void 0 !== e[i] ? e[i] : null;
        }
    };
}
class $a42f1354f0348298$var$Uf {
    constructor(){
        this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
    }
    init(e, t) {
        if (null === this.texture) {
            const i = new $a42f1354f0348298$var$cA(e.texture);
            e.depthNear === t.depthNear && e.depthFar === t.depthFar || (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = i;
        }
    }
    getMesh(e) {
        if (null !== this.texture && null === this.mesh) {
            const t = e.cameras[0].viewport, i = new $a42f1354f0348298$var$EA({
                vertexShader: "\nvoid main() {\n\n\tgl_Position = vec4( position, 1.0 );\n\n}",
                fragmentShader: "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n\tvec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n\tif ( coord.x >= 1.0 ) {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n\t} else {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n\t}\n\n}",
                uniforms: {
                    depthColor: {
                        value: this.texture
                    },
                    depthWidth: {
                        value: t.z
                    },
                    depthHeight: {
                        value: t.w
                    }
                }
            });
            this.mesh = new $a42f1354f0348298$var$zp(new $a42f1354f0348298$var$uA(20, 20), i);
        }
        return this.mesh;
    }
    reset() {
        this.texture = null, this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $a42f1354f0348298$var$Nf extends $a42f1354f0348298$var$Yd {
    constructor(e, t){
        super();
        const i = this;
        let n = null, a = 1, r = null, s = "local-floor", o = 1, l = null, c = null, d = null, u = null, h = null, p = null;
        const A = "undefined" != typeof XRWebGLBinding, m = new $a42f1354f0348298$var$Uf, g = {}, f = t.getContextAttributes();
        let _ = null, v = null;
        const E = [], y = [], b = new $a42f1354f0348298$var$cu;
        let k = null;
        const x = new $a42f1354f0348298$var$jA;
        x.viewport = new $a42f1354f0348298$var$Du;
        const w = new $a42f1354f0348298$var$jA;
        w.viewport = new $a42f1354f0348298$var$Du;
        const M = [
            x,
            w
        ], S = new $a42f1354f0348298$var$qA;
        let C = null, T = null;
        function D(e) {
            const t = y.indexOf(e.inputSource);
            if (-1 === t) return;
            const i = E[t];
            void 0 !== i && (i.update(e.inputSource, e.frame, l || r), i.dispatchEvent({
                type: e.type,
                data: e.inputSource
            }));
        }
        function P() {
            n.removeEventListener("select", D), n.removeEventListener("selectstart", D), n.removeEventListener("selectend", D), n.removeEventListener("squeeze", D), n.removeEventListener("squeezestart", D), n.removeEventListener("squeezeend", D), n.removeEventListener("end", P), n.removeEventListener("inputsourceschange", I);
            for(let e = 0; e < E.length; e++){
                const t = y[e];
                null !== t && (y[e] = null, E[e].disconnect(t));
            }
            C = null, T = null, m.reset();
            for(const e in g)delete g[e];
            e.setRenderTarget(_), h = null, u = null, d = null, n = null, v = null, U.stop(), i.isPresenting = !1, e.setPixelRatio(k), e.setSize(b.width, b.height, !1), i.dispatchEvent({
                type: "sessionend"
            });
        }
        function I(e) {
            for(let t = 0; t < e.removed.length; t++){
                const i = e.removed[t], n = y.indexOf(i);
                n >= 0 && (y[n] = null, E[n].disconnect(i));
            }
            for(let t = 0; t < e.added.length; t++){
                const i = e.added[t];
                let n = y.indexOf(i);
                if (-1 === n) {
                    for(let e = 0; e < E.length; e++){
                        if (e >= y.length) {
                            y.push(i), n = e;
                            break;
                        }
                        if (null === y[e]) {
                            y[e] = i, n = e;
                            break;
                        }
                    }
                    if (-1 === n) break;
                }
                const a = E[n];
                a && a.connect(i);
            }
        }
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e) {
            let t = E[e];
            return void 0 === t && (t = new $a42f1354f0348298$var$uh, E[e] = t), t.getTargetRaySpace();
        }, this.getControllerGrip = function(e) {
            let t = E[e];
            return void 0 === t && (t = new $a42f1354f0348298$var$uh, E[e] = t), t.getGripSpace();
        }, this.getHand = function(e) {
            let t = E[e];
            return void 0 === t && (t = new $a42f1354f0348298$var$uh, E[e] = t), t.getHandSpace();
        }, this.setFramebufferScaleFactor = function(e) {
            a = e, !0 === i.isPresenting && $a42f1354f0348298$var$Wd("WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(e) {
            s = e, !0 === i.isPresenting && $a42f1354f0348298$var$Wd("WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return l || r;
        }, this.setReferenceSpace = function(e) {
            l = e;
        }, this.getBaseLayer = function() {
            return null !== u ? u : h;
        }, this.getBinding = function() {
            return null === d && A && (d = new XRWebGLBinding(n, t)), d;
        }, this.getFrame = function() {
            return p;
        }, this.getSession = function() {
            return n;
        }, this.setSession = async function(c) {
            if (n = c, null !== n) {
                _ = e.getRenderTarget(), n.addEventListener("select", D), n.addEventListener("selectstart", D), n.addEventListener("selectend", D), n.addEventListener("squeeze", D), n.addEventListener("squeezestart", D), n.addEventListener("squeezeend", D), n.addEventListener("end", P), n.addEventListener("inputsourceschange", I), !0 !== f.xrCompatible && await t.makeXRCompatible(), k = e.getPixelRatio(), e.getSize(b);
                if (A && "createProjectionLayer" in XRWebGLBinding.prototype) {
                    let i = null, r = null, s = null;
                    f.depth && (s = f.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, i = f.stencil ? $a42f1354f0348298$var$Nc : $a42f1354f0348298$var$Uc, r = f.stencil ? $a42f1354f0348298$var$Lc : $a42f1354f0348298$var$Cc);
                    const o = {
                        colorFormat: t.RGBA8,
                        depthFormat: s,
                        scaleFactor: a
                    };
                    d = this.getBinding(), u = d.createProjectionLayer(o), n.updateRenderState({
                        layers: [
                            u
                        ]
                    }), e.setPixelRatio(1), e.setSize(u.textureWidth, u.textureHeight, !1), v = new $a42f1354f0348298$var$Iu(u.textureWidth, u.textureHeight, {
                        format: $a42f1354f0348298$var$Fc,
                        type: $a42f1354f0348298$var$kc,
                        depthTexture: new $a42f1354f0348298$var$oA(u.textureWidth, u.textureHeight, r, void 0, void 0, void 0, void 0, void 0, void 0, i),
                        stencilBuffer: f.stencil,
                        colorSpace: e.outputColorSpace,
                        samples: f.antialias ? 4 : 0,
                        resolveDepthBuffer: !1 === u.ignoreDepthValues,
                        resolveStencilBuffer: !1 === u.ignoreDepthValues
                    });
                } else {
                    const i = {
                        antialias: f.antialias,
                        alpha: !0,
                        depth: f.depth,
                        stencil: f.stencil,
                        framebufferScaleFactor: a
                    };
                    h = new XRWebGLLayer(n, t, i), n.updateRenderState({
                        baseLayer: h
                    }), e.setPixelRatio(1), e.setSize(h.framebufferWidth, h.framebufferHeight, !1), v = new $a42f1354f0348298$var$Iu(h.framebufferWidth, h.framebufferHeight, {
                        format: $a42f1354f0348298$var$Fc,
                        type: $a42f1354f0348298$var$kc,
                        colorSpace: e.outputColorSpace,
                        stencilBuffer: f.stencil,
                        resolveDepthBuffer: !1 === h.ignoreDepthValues,
                        resolveStencilBuffer: !1 === h.ignoreDepthValues
                    });
                }
                v.isXRRenderTarget = !0, this.setFoveation(o), l = null, r = await n.requestReferenceSpace(s), U.setContext(n), U.start(), i.isPresenting = !0, i.dispatchEvent({
                    type: "sessionstart"
                });
            }
        }, this.getEnvironmentBlendMode = function() {
            if (null !== n) return n.environmentBlendMode;
        }, this.getDepthTexture = function() {
            return m.getDepthTexture();
        };
        const L = new $a42f1354f0348298$var$uu, R = new $a42f1354f0348298$var$uu;
        function z(e, t) {
            null === t ? e.matrixWorld.copy(e.matrix) : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix), e.matrixWorldInverse.copy(e.matrixWorld).invert();
        }
        this.updateCamera = function(e) {
            if (null === n) return;
            let t = e.near, i = e.far;
            null !== m.texture && (m.depthNear > 0 && (t = m.depthNear), m.depthFar > 0 && (i = m.depthFar)), S.near = w.near = x.near = t, S.far = w.far = x.far = i, C === S.near && T === S.far || (n.updateRenderState({
                depthNear: S.near,
                depthFar: S.far
            }), C = S.near, T = S.far), S.layers.mask = 6 | e.layers.mask, x.layers.mask = -5 & S.layers.mask, w.layers.mask = -3 & S.layers.mask;
            const a = e.parent, r = S.cameras;
            z(S, a);
            for(let e = 0; e < r.length; e++)z(r[e], a);
            2 === r.length ? function(e, t, i) {
                L.setFromMatrixPosition(t.matrixWorld), R.setFromMatrixPosition(i.matrixWorld);
                const n = L.distanceTo(R), a = t.projectionMatrix.elements, r = i.projectionMatrix.elements, s = a[14] / (a[10] - 1), o = a[14] / (a[10] + 1), l = (a[9] + 1) / a[5], c = (a[9] - 1) / a[5], d = (a[8] - 1) / a[0], u = (r[8] + 1) / r[0], h = s * d, p = s * u, A = n / (-d + u), m = A * -d;
                if (t.matrixWorld.decompose(e.position, e.quaternion, e.scale), e.translateX(m), e.translateZ(A), e.matrixWorld.compose(e.position, e.quaternion, e.scale), e.matrixWorldInverse.copy(e.matrixWorld).invert(), -1 === a[10]) e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse);
                else {
                    const t = s + A, i = o + A, a = h - m, r = p + (n - m), d = l * o / i * t, u = c * o / i * t;
                    e.projectionMatrix.makePerspective(a, r, d, u, t, i), e.projectionMatrixInverse.copy(e.projectionMatrix).invert();
                }
            }(S, x, w) : S.projectionMatrix.copy(x.projectionMatrix), function(e, t, i) {
                null === i ? e.matrix.copy(t.matrixWorld) : (e.matrix.copy(i.matrixWorld), e.matrix.invert(), e.matrix.multiply(t.matrixWorld));
                e.matrix.decompose(e.position, e.quaternion, e.scale), e.updateMatrixWorld(!0), e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse), e.isPerspectiveCamera && (e.fov = 2 * $a42f1354f0348298$var$tu * Math.atan(1 / e.projectionMatrix.elements[5]), e.zoom = 1);
            }(e, S, a);
        }, this.getCamera = function() {
            return S;
        }, this.getFoveation = function() {
            if (null !== u || null !== h) return o;
        }, this.setFoveation = function(e) {
            o = e, null !== u && (u.fixedFoveation = e), null !== h && void 0 !== h.fixedFoveation && (h.fixedFoveation = e);
        }, this.hasDepthSensing = function() {
            return null !== m.texture;
        }, this.getDepthSensingMesh = function() {
            return m.getMesh(S);
        }, this.getCameraTexture = function(e) {
            return g[e];
        };
        let F = null;
        const U = new $a42f1354f0348298$var$JA;
        U.setAnimationLoop(function(t, a) {
            if (c = a.getViewerPose(l || r), p = a, null !== c) {
                const t = c.views;
                null !== h && (e.setRenderTargetFramebuffer(v, h.framebuffer), e.setRenderTarget(v));
                let a = !1;
                t.length !== S.cameras.length && (S.cameras.length = 0, a = !0);
                for(let i = 0; i < t.length; i++){
                    const n = t[i];
                    let r = null;
                    if (null !== h) r = h.getViewport(n);
                    else {
                        const t = d.getViewSubImage(u, n);
                        r = t.viewport, 0 === i && (e.setRenderTargetTextures(v, t.colorTexture, t.depthStencilTexture), e.setRenderTarget(v));
                    }
                    let s = M[i];
                    void 0 === s && (s = new $a42f1354f0348298$var$jA, s.layers.enable(i), s.viewport = new $a42f1354f0348298$var$Du, M[i] = s), s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(n.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(r.x, r.y, r.width, r.height), 0 === i && (S.matrix.copy(s.matrix), S.matrix.decompose(S.position, S.quaternion, S.scale)), !0 === a && S.cameras.push(s);
                }
                const r = n.enabledFeatures;
                if (r && r.includes("depth-sensing") && "gpu-optimized" == n.depthUsage && A) {
                    d = i.getBinding();
                    const e = d.getDepthInformation(t[0]);
                    e && e.isValid && e.texture && m.init(e, n.renderState);
                }
                if (r && r.includes("camera-access") && A) {
                    e.state.unbindTexture(), d = i.getBinding();
                    for(let e = 0; e < t.length; e++){
                        const i = t[e].camera;
                        if (i) {
                            let e = g[i];
                            e || (e = new $a42f1354f0348298$var$cA, g[i] = e);
                            const t = d.getCameraImage(i);
                            e.sourceTexture = t;
                        }
                    }
                }
            }
            for(let e = 0; e < E.length; e++){
                const t = y[e], i = E[e];
                null !== t && void 0 !== i && i.update(t, a, l || r);
            }
            F && F(t, a), a.detectedPlanes && i.dispatchEvent({
                type: "planesdetected",
                data: a
            }), p = null;
        }), this.setAnimationLoop = function(e) {
            F = e;
        }, this.dispose = function() {};
    }
}
const $a42f1354f0348298$var$Bf = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Of = new $a42f1354f0348298$var$Au;
function $a42f1354f0348298$var$jf(e, t) {
    function i(e, t) {
        !0 === e.matrixAutoUpdate && e.updateMatrix(), t.value.copy(e.matrix);
    }
    function n(e, n) {
        e.opacity.value = n.opacity, n.color && e.diffuse.value.copy(n.color), n.emissive && e.emissive.value.copy(n.emissive).multiplyScalar(n.emissiveIntensity), n.map && (e.map.value = n.map, i(n.map, e.mapTransform)), n.alphaMap && (e.alphaMap.value = n.alphaMap, i(n.alphaMap, e.alphaMapTransform)), n.bumpMap && (e.bumpMap.value = n.bumpMap, i(n.bumpMap, e.bumpMapTransform), e.bumpScale.value = n.bumpScale, 1 === n.side && (e.bumpScale.value *= -1)), n.normalMap && (e.normalMap.value = n.normalMap, i(n.normalMap, e.normalMapTransform), e.normalScale.value.copy(n.normalScale), 1 === n.side && e.normalScale.value.negate()), n.displacementMap && (e.displacementMap.value = n.displacementMap, i(n.displacementMap, e.displacementMapTransform), e.displacementScale.value = n.displacementScale, e.displacementBias.value = n.displacementBias), n.emissiveMap && (e.emissiveMap.value = n.emissiveMap, i(n.emissiveMap, e.emissiveMapTransform)), n.specularMap && (e.specularMap.value = n.specularMap, i(n.specularMap, e.specularMapTransform)), n.alphaTest > 0 && (e.alphaTest.value = n.alphaTest);
        const a = t.get(n), r = a.envMap, s = a.envMapRotation;
        r && (e.envMap.value = r, e.envMapRotation.value.setFromMatrix4($a42f1354f0348298$var$Bf.makeRotationFromEuler(s)).transpose(), r.isCubeTexture && !1 === r.isRenderTargetTexture && e.envMapRotation.value.premultiply($a42f1354f0348298$var$Of), e.reflectivity.value = n.reflectivity, e.ior.value = n.ior, e.refractionRatio.value = n.refractionRatio), n.lightMap && (e.lightMap.value = n.lightMap, e.lightMapIntensity.value = n.lightMapIntensity, i(n.lightMap, e.lightMapTransform)), n.aoMap && (e.aoMap.value = n.aoMap, e.aoMapIntensity.value = n.aoMapIntensity, i(n.aoMap, e.aoMapTransform));
    }
    return {
        refreshFogUniforms: function(t, i) {
            i.color.getRGB(t.fogColor.value, $a42f1354f0348298$var$_A(e)), i.isFog ? (t.fogNear.value = i.near, t.fogFar.value = i.far) : i.isFogExp2 && (t.fogDensity.value = i.density);
        },
        refreshMaterialUniforms: function(e, a, r, s, o) {
            a.isNodeMaterial ? a.uniformsNeedUpdate = !1 : a.isMeshBasicMaterial ? n(e, a) : a.isMeshLambertMaterial ? (n(e, a), a.envMap && (e.envMapIntensity.value = a.envMapIntensity)) : a.isMeshToonMaterial ? (n(e, a), function(e, t) {
                t.gradientMap && (e.gradientMap.value = t.gradientMap);
            }(e, a)) : a.isMeshPhongMaterial ? (n(e, a), function(e, t) {
                e.specular.value.copy(t.specular), e.shininess.value = Math.max(t.shininess, 1e-4);
            }(e, a), a.envMap && (e.envMapIntensity.value = a.envMapIntensity)) : a.isMeshStandardMaterial ? (n(e, a), function(e, t) {
                e.metalness.value = t.metalness, t.metalnessMap && (e.metalnessMap.value = t.metalnessMap, i(t.metalnessMap, e.metalnessMapTransform));
                e.roughness.value = t.roughness, t.roughnessMap && (e.roughnessMap.value = t.roughnessMap, i(t.roughnessMap, e.roughnessMapTransform));
                t.envMap && (e.envMapIntensity.value = t.envMapIntensity);
            }(e, a), a.isMeshPhysicalMaterial && function(e, t, n) {
                e.ior.value = t.ior, t.sheen > 0 && (e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e.sheenColorMap.value = t.sheenColorMap, i(t.sheenColorMap, e.sheenColorMapTransform)), t.sheenRoughnessMap && (e.sheenRoughnessMap.value = t.sheenRoughnessMap, i(t.sheenRoughnessMap, e.sheenRoughnessMapTransform)));
                t.clearcoat > 0 && (e.clearcoat.value = t.clearcoat, e.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e.clearcoatMap.value = t.clearcoatMap, i(t.clearcoatMap, e.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, i(t.clearcoatRoughnessMap, e.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e.clearcoatNormalMap.value = t.clearcoatNormalMap, i(t.clearcoatNormalMap, e.clearcoatNormalMapTransform), e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), 1 === t.side && e.clearcoatNormalScale.value.negate()));
                t.dispersion > 0 && (e.dispersion.value = t.dispersion);
                t.iridescence > 0 && (e.iridescence.value = t.iridescence, e.iridescenceIOR.value = t.iridescenceIOR, e.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e.iridescenceMap.value = t.iridescenceMap, i(t.iridescenceMap, e.iridescenceMapTransform)), t.iridescenceThicknessMap && (e.iridescenceThicknessMap.value = t.iridescenceThicknessMap, i(t.iridescenceThicknessMap, e.iridescenceThicknessMapTransform)));
                t.transmission > 0 && (e.transmission.value = t.transmission, e.transmissionSamplerMap.value = n.texture, e.transmissionSamplerSize.value.set(n.width, n.height), t.transmissionMap && (e.transmissionMap.value = t.transmissionMap, i(t.transmissionMap, e.transmissionMapTransform)), e.thickness.value = t.thickness, t.thicknessMap && (e.thicknessMap.value = t.thicknessMap, i(t.thicknessMap, e.thicknessMapTransform)), e.attenuationDistance.value = t.attenuationDistance, e.attenuationColor.value.copy(t.attenuationColor));
                t.anisotropy > 0 && (e.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e.anisotropyMap.value = t.anisotropyMap, i(t.anisotropyMap, e.anisotropyMapTransform)));
                e.specularIntensity.value = t.specularIntensity, e.specularColor.value.copy(t.specularColor), t.specularColorMap && (e.specularColorMap.value = t.specularColorMap, i(t.specularColorMap, e.specularColorMapTransform));
                t.specularIntensityMap && (e.specularIntensityMap.value = t.specularIntensityMap, i(t.specularIntensityMap, e.specularIntensityMapTransform));
            }(e, a, o)) : a.isMeshMatcapMaterial ? (n(e, a), function(e, t) {
                t.matcap && (e.matcap.value = t.matcap);
            }(e, a)) : a.isMeshDepthMaterial ? n(e, a) : a.isMeshDistanceMaterial ? (n(e, a), function(e, i) {
                const n = t.get(i).light;
                e.referencePosition.value.setFromMatrixPosition(n.matrixWorld), e.nearDistance.value = n.shadow.camera.near, e.farDistance.value = n.shadow.camera.far;
            }(e, a)) : a.isMeshNormalMaterial ? n(e, a) : a.isLineBasicMaterial ? (function(e, t) {
                e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, t.map && (e.map.value = t.map, i(t.map, e.mapTransform));
            }(e, a), a.isLineDashedMaterial && function(e, t) {
                e.dashSize.value = t.dashSize, e.totalSize.value = t.dashSize + t.gapSize, e.scale.value = t.scale;
            }(e, a)) : a.isPointsMaterial ? function(e, t, n, a) {
                e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.size.value = t.size * n, e.scale.value = .5 * a, t.map && (e.map.value = t.map, i(t.map, e.uvTransform));
                t.alphaMap && (e.alphaMap.value = t.alphaMap, i(t.alphaMap, e.alphaMapTransform));
                t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
            }(e, a, r, s) : a.isSpriteMaterial ? function(e, t) {
                e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.rotation.value = t.rotation, t.map && (e.map.value = t.map, i(t.map, e.mapTransform));
                t.alphaMap && (e.alphaMap.value = t.alphaMap, i(t.alphaMap, e.alphaMapTransform));
                t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
            }(e, a) : a.isShadowMaterial ? (e.color.value.copy(a.color), e.opacity.value = a.opacity) : a.isShaderMaterial && (a.uniformsNeedUpdate = !1);
        }
    };
}
function $a42f1354f0348298$var$Gf(e, t, i, n) {
    let a = {}, r = {}, s = [];
    const o = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS);
    function l(t, i, n, a) {
        if (!0 === function(e, t, i, n) {
            const a = e.value, r = t + "_" + i;
            if (void 0 === n[r]) return "number" == typeof a || "boolean" == typeof a ? n[r] = a : ArrayBuffer.isView(a) ? n[r] = a.slice() : n[r] = a.clone(), !0;
            {
                const e = n[r];
                if ("number" == typeof a || "boolean" == typeof a) {
                    if (e !== a) return n[r] = a, !0;
                } else {
                    if (ArrayBuffer.isView(a)) return !0;
                    if (!1 === e.equals(a)) return e.copy(a), !0;
                }
            }
            return !1;
        }(t, i, n, a)) {
            const i = t.__offset, n = t.value;
            if (Array.isArray(n)) {
                let e = 0;
                for(let i = 0; i < n.length; i++){
                    const a = n[i], r = d(a);
                    c(a, t.__data, e), "number" == typeof a || "boolean" == typeof a || a.isMatrix3 || ArrayBuffer.isView(a) || (e += r.storage / Float32Array.BYTES_PER_ELEMENT);
                }
            } else c(n, t.__data, 0);
            e.bufferSubData(e.UNIFORM_BUFFER, i, t.__data);
        }
    }
    function c(e, t, i) {
        "number" == typeof e || "boolean" == typeof e ? t[0] = e : e.isMatrix3 ? (t[0] = e.elements[0], t[1] = e.elements[1], t[2] = e.elements[2], t[3] = 0, t[4] = e.elements[3], t[5] = e.elements[4], t[6] = e.elements[5], t[7] = 0, t[8] = e.elements[6], t[9] = e.elements[7], t[10] = e.elements[8], t[11] = 0) : ArrayBuffer.isView(e) ? t.set(new e.constructor(e.buffer, e.byteOffset, t.length)) : e.toArray(t, i);
    }
    function d(e) {
        const t = {
            boundary: 0,
            storage: 0
        };
        return "number" == typeof e || "boolean" == typeof e ? (t.boundary = 4, t.storage = 4) : e.isVector2 ? (t.boundary = 8, t.storage = 8) : e.isVector3 || e.isColor ? (t.boundary = 16, t.storage = 12) : e.isVector4 ? (t.boundary = 16, t.storage = 16) : e.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e.isTexture ? $a42f1354f0348298$var$Wd("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : ArrayBuffer.isView(e) ? (t.boundary = 16, t.storage = e.byteLength) : $a42f1354f0348298$var$Wd("WebGLRenderer: Unsupported uniform value type.", e), t;
    }
    function u(t) {
        const i = t.target;
        i.removeEventListener("dispose", u);
        const n = s.indexOf(i.__bindingPointIndex);
        s.splice(n, 1), e.deleteBuffer(a[i.id]), delete a[i.id], delete r[i.id];
    }
    return {
        bind: function(e, t) {
            const i = t.program;
            n.uniformBlockBinding(e, i);
        },
        update: function(i, c) {
            let h = a[i.id];
            void 0 === h && (!function(e) {
                const t = e.uniforms;
                let i = 0;
                const n = 16;
                for(let e = 0, a = t.length; e < a; e++){
                    const a = Array.isArray(t[e]) ? t[e] : [
                        t[e]
                    ];
                    for(let e = 0, t = a.length; e < t; e++){
                        const t = a[e], r = Array.isArray(t.value) ? t.value : [
                            t.value
                        ];
                        for(let e = 0, a = r.length; e < a; e++){
                            const a = d(r[e]), s = i % n, o = s % a.boundary, l = s + o;
                            i += o, 0 !== l && n - l < a.storage && (i += n - l), t.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), t.__offset = i, i += a.storage;
                        }
                    }
                }
                const a = i % n;
                a > 0 && (i += n - a);
                e.__size = i, e.__cache = {};
            }(i), h = function(t) {
                const i = function() {
                    for(let e = 0; e < o; e++)if (-1 === s.indexOf(e)) return s.push(e), e;
                    return $a42f1354f0348298$var$Xd("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                }();
                t.__bindingPointIndex = i;
                const n = e.createBuffer(), a = t.__size, r = t.usage;
                return e.bindBuffer(e.UNIFORM_BUFFER, n), e.bufferData(e.UNIFORM_BUFFER, a, r), e.bindBuffer(e.UNIFORM_BUFFER, null), e.bindBufferBase(e.UNIFORM_BUFFER, i, n), n;
            }(i), a[i.id] = h, i.addEventListener("dispose", u));
            const p = c.program;
            n.updateUBOMapping(i, p);
            const A = t.render.frame;
            r[i.id] !== A && (!function(t) {
                const i = a[t.id], n = t.uniforms, r = t.__cache;
                e.bindBuffer(e.UNIFORM_BUFFER, i);
                for(let e = 0, t = n.length; e < t; e++){
                    const t = n[e];
                    if (Array.isArray(t)) for(let i = 0, n = t.length; i < n; i++)l(t[i], e, i, r);
                    else l(t, e, 0, r);
                }
                e.bindBuffer(e.UNIFORM_BUFFER, null);
            }(i), r[i.id] = A);
        },
        dispose: function() {
            for(const t in a)e.deleteBuffer(a[t]);
            s = [], a = {}, r = {};
        }
    };
}
$a42f1354f0348298$var$Of.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
const $a42f1354f0348298$var$Vf = new Uint16Array([
    12469,
    15057,
    12620,
    14925,
    13266,
    14620,
    13807,
    14376,
    14323,
    13990,
    14545,
    13625,
    14713,
    13328,
    14840,
    12882,
    14931,
    12528,
    14996,
    12233,
    15039,
    11829,
    15066,
    11525,
    15080,
    11295,
    15085,
    10976,
    15082,
    10705,
    15073,
    10495,
    13880,
    14564,
    13898,
    14542,
    13977,
    14430,
    14158,
    14124,
    14393,
    13732,
    14556,
    13410,
    14702,
    12996,
    14814,
    12596,
    14891,
    12291,
    14937,
    11834,
    14957,
    11489,
    14958,
    11194,
    14943,
    10803,
    14921,
    10506,
    14893,
    10278,
    14858,
    9960,
    14484,
    14039,
    14487,
    14025,
    14499,
    13941,
    14524,
    13740,
    14574,
    13468,
    14654,
    13106,
    14743,
    12678,
    14818,
    12344,
    14867,
    11893,
    14889,
    11509,
    14893,
    11180,
    14881,
    10751,
    14852,
    10428,
    14812,
    10128,
    14765,
    9754,
    14712,
    9466,
    14764,
    13480,
    14764,
    13475,
    14766,
    13440,
    14766,
    13347,
    14769,
    13070,
    14786,
    12713,
    14816,
    12387,
    14844,
    11957,
    14860,
    11549,
    14868,
    11215,
    14855,
    10751,
    14825,
    10403,
    14782,
    10044,
    14729,
    9651,
    14666,
    9352,
    14599,
    9029,
    14967,
    12835,
    14966,
    12831,
    14963,
    12804,
    14954,
    12723,
    14936,
    12564,
    14917,
    12347,
    14900,
    11958,
    14886,
    11569,
    14878,
    11247,
    14859,
    10765,
    14828,
    10401,
    14784,
    10011,
    14727,
    9600,
    14660,
    9289,
    14586,
    8893,
    14508,
    8533,
    15111,
    12234,
    15110,
    12234,
    15104,
    12216,
    15092,
    12156,
    15067,
    12010,
    15028,
    11776,
    14981,
    11500,
    14942,
    11205,
    14902,
    10752,
    14861,
    10393,
    14812,
    9991,
    14752,
    9570,
    14682,
    9252,
    14603,
    8808,
    14519,
    8445,
    14431,
    8145,
    15209,
    11449,
    15208,
    11451,
    15202,
    11451,
    15190,
    11438,
    15163,
    11384,
    15117,
    11274,
    15055,
    10979,
    14994,
    10648,
    14932,
    10343,
    14871,
    9936,
    14803,
    9532,
    14729,
    9218,
    14645,
    8742,
    14556,
    8381,
    14461,
    8020,
    14365,
    7603,
    15273,
    10603,
    15272,
    10607,
    15267,
    10619,
    15256,
    10631,
    15231,
    10614,
    15182,
    10535,
    15118,
    10389,
    15042,
    10167,
    14963,
    9787,
    14883,
    9447,
    14800,
    9115,
    14710,
    8665,
    14615,
    8318,
    14514,
    7911,
    14411,
    7507,
    14279,
    7198,
    15314,
    9675,
    15313,
    9683,
    15309,
    9712,
    15298,
    9759,
    15277,
    9797,
    15229,
    9773,
    15166,
    9668,
    15084,
    9487,
    14995,
    9274,
    14898,
    8910,
    14800,
    8539,
    14697,
    8234,
    14590,
    7790,
    14479,
    7409,
    14367,
    7067,
    14178,
    6621,
    15337,
    8619,
    15337,
    8631,
    15333,
    8677,
    15325,
    8769,
    15305,
    8871,
    15264,
    8940,
    15202,
    8909,
    15119,
    8775,
    15022,
    8565,
    14916,
    8328,
    14804,
    8009,
    14688,
    7614,
    14569,
    7287,
    14448,
    6888,
    14321,
    6483,
    14088,
    6171,
    15350,
    7402,
    15350,
    7419,
    15347,
    7480,
    15340,
    7613,
    15322,
    7804,
    15287,
    7973,
    15229,
    8057,
    15148,
    8012,
    15046,
    7846,
    14933,
    7611,
    14810,
    7357,
    14682,
    7069,
    14552,
    6656,
    14421,
    6316,
    14251,
    5948,
    14007,
    5528,
    15356,
    5942,
    15356,
    5977,
    15353,
    6119,
    15348,
    6294,
    15332,
    6551,
    15302,
    6824,
    15249,
    7044,
    15171,
    7122,
    15070,
    7050,
    14949,
    6861,
    14818,
    6611,
    14679,
    6349,
    14538,
    6067,
    14398,
    5651,
    14189,
    5311,
    13935,
    4958,
    15359,
    4123,
    15359,
    4153,
    15356,
    4296,
    15353,
    4646,
    15338,
    5160,
    15311,
    5508,
    15263,
    5829,
    15188,
    6042,
    15088,
    6094,
    14966,
    6001,
    14826,
    5796,
    14678,
    5543,
    14527,
    5287,
    14377,
    4985,
    14133,
    4586,
    13869,
    4257,
    15360,
    1563,
    15360,
    1642,
    15358,
    2076,
    15354,
    2636,
    15341,
    3350,
    15317,
    4019,
    15273,
    4429,
    15203,
    4732,
    15105,
    4911,
    14981,
    4932,
    14836,
    4818,
    14679,
    4621,
    14517,
    4386,
    14359,
    4156,
    14083,
    3795,
    13808,
    3437,
    15360,
    122,
    15360,
    137,
    15358,
    285,
    15355,
    636,
    15344,
    1274,
    15322,
    2177,
    15281,
    2765,
    15215,
    3223,
    15120,
    3451,
    14995,
    3569,
    14846,
    3567,
    14681,
    3466,
    14511,
    3305,
    14344,
    3121,
    14037,
    2800,
    13753,
    2467,
    15360,
    0,
    15360,
    1,
    15359,
    21,
    15355,
    89,
    15346,
    253,
    15325,
    479,
    15287,
    796,
    15225,
    1148,
    15133,
    1492,
    15008,
    1749,
    14856,
    1882,
    14685,
    1886,
    14506,
    1783,
    14324,
    1608,
    13996,
    1398,
    13702,
    1183
]);
let $a42f1354f0348298$var$Hf = null;
class $a42f1354f0348298$var$qf {
    constructor(e = {}){
        const { canvas: t = $a42f1354f0348298$var$Vd(), context: i = null, depth: n = !0, stencil: a = !1, alpha: r = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: d = !1, reversedDepthBuffer: u = !1, outputBufferType: h = $a42f1354f0348298$var$kc } = e;
        let p;
        if (this.isWebGLRenderer = !0, null !== i) {
            if ("undefined" != typeof WebGLRenderingContext && i instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
            p = i.getContextAttributes().alpha;
        } else p = r;
        const A = h, m = new Set([
            $a42f1354f0348298$var$Gc,
            $a42f1354f0348298$var$jc,
            $a42f1354f0348298$var$Bc
        ]), g = new Set([
            $a42f1354f0348298$var$kc,
            $a42f1354f0348298$var$Cc,
            $a42f1354f0348298$var$Mc,
            $a42f1354f0348298$var$Lc,
            $a42f1354f0348298$var$Pc,
            $a42f1354f0348298$var$Ic
        ]), f = new Uint32Array(4), _ = new Int32Array(4), v = new $a42f1354f0348298$var$uu;
        let E = null, y = null;
        const b = [], k = [];
        let x = null;
        this.domElement = t, this.debug = {
            checkShaderErrors: !0,
            onShaderError: null
        }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = 0, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
        const w = this;
        let M = !1, S = null, C = null, T = null, D = null;
        this._outputColorSpace = $a42f1354f0348298$var$Md;
        let P = 0, I = 0, L = null, R = -1, z = null;
        const F = new $a42f1354f0348298$var$Du, U = new $a42f1354f0348298$var$Du;
        let N = null;
        const B = new $a42f1354f0348298$var$gh(0);
        let O = 0, j = t.width, G = t.height, V = 1, H = null, q = null;
        const K = new $a42f1354f0348298$var$Du(0, 0, j, G), W = new $a42f1354f0348298$var$Du(0, 0, j, G);
        let X = !1;
        const Q = new $a42f1354f0348298$var$qp;
        let Z = !1, Y = !1;
        const J = new $a42f1354f0348298$var$zu, $ = new $a42f1354f0348298$var$uu, ee = new $a42f1354f0348298$var$Du, te = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: !0
        };
        let ie = !1;
        function ne() {
            return null === L ? V : 1;
        }
        let ae, re, se, oe, le, ce, de, ue, he, pe, Ae, me, ge, fe, _e, ve, Ee, ye, be, ke, xe, we, Me, Se = i;
        function Ce(e, i) {
            return t.getContext(e, i);
        }
        try {
            const e = {
                alpha: !0,
                depth: n,
                stencil: a,
                antialias: s,
                premultipliedAlpha: o,
                preserveDrawingBuffer: l,
                powerPreference: c,
                failIfMajorPerformanceCaveat: d
            };
            if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${$a42f1354f0348298$var$yl}`), t.addEventListener("webglcontextlost", Pe, !1), t.addEventListener("webglcontextrestored", Ie, !1), t.addEventListener("webglcontextcreationerror", Le, !1), null === Se) {
                const t = "webgl2";
                if (Se = Ce(t, e), null === Se) throw Ce(t) ? new Error("THREE.WebGLRenderer: Error creating WebGL context with your selected attributes.") : new Error("THREE.WebGLRenderer: Error creating WebGL context.");
            }
        } catch (e) {
            throw $a42f1354f0348298$var$Xd("WebGLRenderer: " + e.message), e;
        }
        function Te() {
            ae = new $a42f1354f0348298$var$Cm(Se), ae.init(), xe = new $a42f1354f0348298$var$Ff(Se, ae), re = new $a42f1354f0348298$var$cm(Se, ae, e, xe), se = new $a42f1354f0348298$var$Rf(Se, ae), re.reversedDepthBuffer && u && se.buffers.depth.setReversed(!0), C = Se.createFramebuffer(), T = Se.createFramebuffer(), D = Se.createFramebuffer(), oe = new $a42f1354f0348298$var$Pm(Se), le = new $a42f1354f0348298$var$ff, ce = new $a42f1354f0348298$var$zf(Se, ae, se, le, re, xe, oe), de = new $a42f1354f0348298$var$Sm(w), ue = new $a42f1354f0348298$var$$A(Se), we = new $a42f1354f0348298$var$om(Se, ue), he = new $a42f1354f0348298$var$Tm(Se, ue, oe, we), pe = new $a42f1354f0348298$var$Lm(Se, he, ue, we, oe), ye = new $a42f1354f0348298$var$Im(Se, re, ce), _e = new $a42f1354f0348298$var$dm(le), Ae = new $a42f1354f0348298$var$gf(w, de, ae, re, we, _e), me = new $a42f1354f0348298$var$jf(w, le), ge = new $a42f1354f0348298$var$yf, fe = new $a42f1354f0348298$var$Sf(ae), Ee = new $a42f1354f0348298$var$sm(w, de, se, pe, p, o), ve = new $a42f1354f0348298$var$Lf(w, pe, re), Me = new $a42f1354f0348298$var$Gf(Se, oe, re, se), be = new $a42f1354f0348298$var$lm(Se, ae, oe), ke = new $a42f1354f0348298$var$Dm(Se, ae, oe), oe.programs = Ae.programs, w.capabilities = re, w.extensions = ae, w.properties = le, w.renderLists = ge, w.shadowMap = ve, w.state = se, w.info = oe;
        }
        Te(), A !== $a42f1354f0348298$var$kc && (x = new $a42f1354f0348298$var$zm(A, t.width, t.height, s, n, a));
        const De = new $a42f1354f0348298$var$Nf(w, Se);
        function Pe(e) {
            e.preventDefault(), $a42f1354f0348298$var$qd("WebGLRenderer: Context Lost."), M = !0;
        }
        function Ie() {
            $a42f1354f0348298$var$qd("WebGLRenderer: Context Restored."), M = !1;
            const e = oe.autoReset, t = ve.enabled, i = ve.autoUpdate, n = ve.needsUpdate, a = ve.type;
            Te(), oe.autoReset = e, ve.enabled = t, ve.autoUpdate = i, ve.needsUpdate = n, ve.type = a;
        }
        function Le(e) {
            $a42f1354f0348298$var$Xd("WebGLRenderer: A WebGL context could not be created. Reason: ", e.statusMessage);
        }
        function Re(e) {
            const t = e.target;
            t.removeEventListener("dispose", Re), function(e) {
                (function(e) {
                    const t = le.get(e).programs;
                    void 0 !== t && (t.forEach(function(e) {
                        Ae.releaseProgram(e);
                    }), e.isShaderMaterial && Ae.releaseShaderCache(e));
                })(e), le.remove(e);
            }(t);
        }
        function ze(e, t, i) {
            !0 === e.transparent && 2 === e.side && !1 === e.forceSinglePass ? (e.side = 1, e.needsUpdate = !0, qe(e, t, i), e.side = 0, e.needsUpdate = !0, qe(e, t, i), e.side = 2) : qe(e, t, i);
        }
        this.xr = De, this.getContext = function() {
            return Se;
        }, this.getContextAttributes = function() {
            return Se.getContextAttributes();
        }, this.forceContextLoss = function() {
            const e = ae.get("WEBGL_lose_context");
            e && e.loseContext();
        }, this.forceContextRestore = function() {
            const e = ae.get("WEBGL_lose_context");
            e && e.restoreContext();
        }, this.getPixelRatio = function() {
            return V;
        }, this.setPixelRatio = function(e) {
            void 0 !== e && (V = e, this.setSize(j, G, !1));
        }, this.getSize = function(e) {
            return e.set(j, G);
        }, this.setSize = function(e, i, n = !0) {
            De.isPresenting ? $a42f1354f0348298$var$Wd("WebGLRenderer: Can't change size while VR device is presenting.") : (j = e, G = i, t.width = Math.floor(e * V), t.height = Math.floor(i * V), !0 === n && (t.style.width = e + "px", t.style.height = i + "px"), null !== x && x.setSize(t.width, t.height), this.setViewport(0, 0, e, i));
        }, this.getDrawingBufferSize = function(e) {
            return e.set(j * V, G * V).floor();
        }, this.setDrawingBufferSize = function(e, i, n) {
            j = e, G = i, V = n, t.width = Math.floor(e * n), t.height = Math.floor(i * n), this.setViewport(0, 0, e, i);
        }, this.setEffects = function(e) {
            if (A !== $a42f1354f0348298$var$kc) {
                if (e) {
                    for(let t = 0; t < e.length; t++)if (!0 === e[t].isOutputPass) {
                        $a42f1354f0348298$var$Wd("WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.");
                        break;
                    }
                }
                x.setEffects(e || []);
            } else $a42f1354f0348298$var$Xd("WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.");
        }, this.getCurrentViewport = function(e) {
            return e.copy(F);
        }, this.getViewport = function(e) {
            return e.copy(K);
        }, this.setViewport = function(e, t, i, n) {
            e.isVector4 ? K.set(e.x, e.y, e.z, e.w) : K.set(e, t, i, n), se.viewport(F.copy(K).multiplyScalar(V).round());
        }, this.getScissor = function(e) {
            return e.copy(W);
        }, this.setScissor = function(e, t, i, n) {
            e.isVector4 ? W.set(e.x, e.y, e.z, e.w) : W.set(e, t, i, n), se.scissor(U.copy(W).multiplyScalar(V).round());
        }, this.getScissorTest = function() {
            return X;
        }, this.setScissorTest = function(e) {
            se.setScissorTest(X = e);
        }, this.setOpaqueSort = function(e) {
            H = e;
        }, this.setTransparentSort = function(e) {
            q = e;
        }, this.getClearColor = function(e) {
            return e.copy(Ee.getClearColor());
        }, this.setClearColor = function() {
            Ee.setClearColor(...arguments);
        }, this.getClearAlpha = function() {
            return Ee.getClearAlpha();
        }, this.setClearAlpha = function() {
            Ee.setClearAlpha(...arguments);
        }, this.clear = function(e = !0, t = !0, i = !0) {
            let n = 0;
            if (e) {
                let e = !1;
                if (null !== L) {
                    const t = L.texture.format;
                    e = m.has(t);
                }
                if (e) {
                    const e = L.texture.type, t = g.has(e), i = Ee.getClearColor(), n = Ee.getClearAlpha(), a = i.r, r = i.g, s = i.b;
                    t ? (f[0] = a, f[1] = r, f[2] = s, f[3] = n, Se.clearBufferuiv(Se.COLOR, 0, f)) : (_[0] = a, _[1] = r, _[2] = s, _[3] = n, Se.clearBufferiv(Se.COLOR, 0, _));
                } else n |= Se.COLOR_BUFFER_BIT;
            }
            t && (n |= Se.DEPTH_BUFFER_BIT, this.state.buffers.depth.setMask(!0)), i && (n |= Se.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), 0 !== n && Se.clear(n);
        }, this.clearColor = function() {
            this.clear(!0, !1, !1);
        }, this.clearDepth = function() {
            this.clear(!1, !0, !1);
        }, this.clearStencil = function() {
            this.clear(!1, !1, !0);
        }, this.setNodesHandler = function(e) {
            e.setRenderer(this), S = e;
        }, this.dispose = function() {
            t.removeEventListener("webglcontextlost", Pe, !1), t.removeEventListener("webglcontextrestored", Ie, !1), t.removeEventListener("webglcontextcreationerror", Le, !1), Ee.dispose(), ge.dispose(), fe.dispose(), le.dispose(), de.dispose(), pe.dispose(), we.dispose(), Me.dispose(), Ae.dispose(), De.dispose(), De.removeEventListener("sessionstart", Ue), De.removeEventListener("sessionend", Ne), Be.stop();
        }, this.renderBufferDirect = function(e, t, i, n, a, r) {
            null === t && (t = te);
            const s = a.isMesh && a.matrixWorld.determinantAffine() < 0, o = function(e, t, i, n, a) {
                !0 !== t.isScene && (t = te);
                ce.resetTextureUnits();
                const r = t.fog, s = n.isMeshStandardMaterial || n.isMeshLambertMaterial || n.isMeshPhongMaterial ? t.environment : null, o = null === L ? w.outputColorSpace : !0 === L.isXRRenderTarget ? L.texture.colorSpace : $a42f1354f0348298$var$vu.workingColorSpace, l = n.isMeshStandardMaterial || n.isMeshLambertMaterial && !n.envMap || n.isMeshPhongMaterial && !n.envMap, c = de.get(n.envMap || s, l), d = !0 === n.vertexColors && !!i.attributes.color && 4 === i.attributes.color.itemSize, u = !!i.attributes.tangent && (!!n.normalMap || n.anisotropy > 0), h = !!i.morphAttributes.position, p = !!i.morphAttributes.normal, A = !!i.morphAttributes.color;
                let m = 0;
                n.toneMapped && (null !== L && !0 !== L.isXRRenderTarget || (m = w.toneMapping));
                const g = i.morphAttributes.position || i.morphAttributes.normal || i.morphAttributes.color, f = void 0 !== g ? g.length : 0, _ = le.get(n), E = y.state.lights;
                if (!0 === Z && (!0 === Y || e !== z)) {
                    const t = e === z && n.id === R;
                    _e.setState(n, e, t);
                }
                let b = !1;
                n.version === _.__version ? _.needsLights && _.lightsStateVersion !== E.state.version || _.outputColorSpace !== o || a.isBatchedMesh && !1 === _.batching ? b = !0 : a.isBatchedMesh || !0 !== _.batching ? a.isBatchedMesh && !0 === _.batchingColor && null === a.colorTexture || a.isBatchedMesh && !1 === _.batchingColor && null !== a.colorTexture || a.isInstancedMesh && !1 === _.instancing ? b = !0 : a.isInstancedMesh || !0 !== _.instancing ? a.isSkinnedMesh && !1 === _.skinning ? b = !0 : a.isSkinnedMesh || !0 !== _.skinning ? a.isInstancedMesh && !0 === _.instancingColor && null === a.instanceColor || a.isInstancedMesh && !1 === _.instancingColor && null !== a.instanceColor || a.isInstancedMesh && !0 === _.instancingMorph && null === a.morphTexture || a.isInstancedMesh && !1 === _.instancingMorph && null !== a.morphTexture || _.envMap !== c || !0 === n.fog && _.fog !== r ? b = !0 : void 0 === _.numClippingPlanes || _.numClippingPlanes === _e.numPlanes && _.numIntersection === _e.numIntersection ? (_.vertexAlphas !== d || _.vertexTangents !== u || _.morphTargets !== h || _.morphNormals !== p || _.morphColors !== A || _.toneMapping !== m || _.morphTargetsCount !== f || !!_.lightProbeGrid != y.state.lightProbeGridArray.length > 0) && (b = !0) : b = !0 : b = !0 : b = !0 : b = !0 : (b = !0, _.__version = n.version);
                let k = _.currentProgram;
                !0 === b && (k = qe(n, t, a), S && n.isNodeMaterial && S.onUpdateProgram(n, k, _));
                let x = !1, M = !1, C = !1;
                const T = k.getUniforms(), D = _.uniforms;
                se.useProgram(k.program) && (x = !0, M = !0, C = !0);
                n.id !== R && (R = n.id, M = !0);
                if (_.needsLights) {
                    const e = function(e, t) {
                        if (0 === e.length) return null;
                        if (1 === e.length) return null !== e[0].texture ? e[0] : null;
                        v.setFromMatrixPosition(t.matrixWorld);
                        for(let t = 0, i = e.length; t < i; t++){
                            const i = e[t];
                            if (null !== i.texture && i.boundingBox.containsPoint(v)) return i;
                        }
                        return null;
                    }(y.state.lightProbeGridArray, a);
                    _.lightProbeGrid !== e && (_.lightProbeGrid = e, M = !0);
                }
                if (x || z !== e) {
                    se.buffers.depth.getReversed() && !0 !== e.reversedDepth && (e._reversedDepth = !0, e.updateProjectionMatrix()), T.setValue(Se, "projectionMatrix", e.projectionMatrix), T.setValue(Se, "viewMatrix", e.matrixWorldInverse);
                    const t = T.map.cameraPosition;
                    void 0 !== t && t.setValue(Se, $.setFromMatrixPosition(e.matrixWorld)), re.logarithmicDepthBuffer && T.setValue(Se, "logDepthBufFC", 2 / (Math.log(e.far + 1) / Math.LN2)), (n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial) && T.setValue(Se, "isOrthographic", !0 === e.isOrthographicCamera), z !== e && (z = e, M = !0, C = !0);
                }
                _.needsLights && (E.state.directionalShadowMap.length > 0 && T.setValue(Se, "directionalShadowMap", E.state.directionalShadowMap, ce), E.state.spotShadowMap.length > 0 && T.setValue(Se, "spotShadowMap", E.state.spotShadowMap, ce), E.state.pointShadowMap.length > 0 && T.setValue(Se, "pointShadowMap", E.state.pointShadowMap, ce));
                if (a.isSkinnedMesh) {
                    T.setOptional(Se, a, "bindMatrix"), T.setOptional(Se, a, "bindMatrixInverse");
                    const e = a.skeleton;
                    e && (null === e.boneTexture && e.computeBoneTexture(), T.setValue(Se, "boneTexture", e.boneTexture, ce));
                }
                a.isBatchedMesh && (T.setOptional(Se, a, "batchingTexture"), T.setValue(Se, "batchingTexture", a._matricesTexture, ce), T.setOptional(Se, a, "batchingIdTexture"), T.setValue(Se, "batchingIdTexture", a._indirectTexture, ce), T.setOptional(Se, a, "batchingColorTexture"), null !== a._colorsTexture && T.setValue(Se, "batchingColorTexture", a._colorsTexture, ce));
                const P = i.morphAttributes;
                void 0 === P.position && void 0 === P.normal && void 0 === P.color || ye.update(a, i, k);
                (M || _.receiveShadow !== a.receiveShadow) && (_.receiveShadow = a.receiveShadow, T.setValue(Se, "receiveShadow", a.receiveShadow));
                (n.isMeshStandardMaterial || n.isMeshLambertMaterial || n.isMeshPhongMaterial) && null === n.envMap && null !== t.environment && (D.envMapIntensity.value = t.environmentIntensity);
                void 0 !== D.dfgLUT && (D.dfgLUT.value = (null === $a42f1354f0348298$var$Hf && ($a42f1354f0348298$var$Hf = new $a42f1354f0348298$var$Up($a42f1354f0348298$var$Vf, 16, 16, $a42f1354f0348298$var$Oc, $a42f1354f0348298$var$Dc), $a42f1354f0348298$var$Hf.name = "DFG_LUT", $a42f1354f0348298$var$Hf.minFilter = $a42f1354f0348298$var$Ec, $a42f1354f0348298$var$Hf.magFilter = $a42f1354f0348298$var$Ec, $a42f1354f0348298$var$Hf.wrapS = $a42f1354f0348298$var$mc, $a42f1354f0348298$var$Hf.wrapT = $a42f1354f0348298$var$mc, $a42f1354f0348298$var$Hf.generateMipmaps = !1, $a42f1354f0348298$var$Hf.needsUpdate = !0), $a42f1354f0348298$var$Hf));
                if (M) {
                    if (T.setValue(Se, "toneMappingExposure", w.toneMappingExposure), _.needsLights && (F = C, (I = D).ambientLightColor.needsUpdate = F, I.lightProbe.needsUpdate = F, I.directionalLights.needsUpdate = F, I.directionalLightShadows.needsUpdate = F, I.pointLights.needsUpdate = F, I.pointLightShadows.needsUpdate = F, I.spotLights.needsUpdate = F, I.spotLightShadows.needsUpdate = F, I.rectAreaLights.needsUpdate = F, I.hemisphereLights.needsUpdate = F), r && !0 === n.fog && me.refreshFogUniforms(D, r), me.refreshMaterialUniforms(D, n, V, G, y.state.transmissionRenderTarget[e.id]), _.needsLights && _.lightProbeGrid) {
                        const e = _.lightProbeGrid;
                        D.probesSH.value = e.texture, D.probesMin.value.copy(e.boundingBox.min), D.probesMax.value.copy(e.boundingBox.max), D.probesResolution.value.copy(e.resolution);
                    }
                    $a42f1354f0348298$var$Og.upload(Se, Ke(_), D, ce);
                }
                var I, F;
                n.isShaderMaterial && !0 === n.uniformsNeedUpdate && ($a42f1354f0348298$var$Og.upload(Se, Ke(_), D, ce), n.uniformsNeedUpdate = !1);
                n.isSpriteMaterial && T.setValue(Se, "center", a.center);
                if (T.setValue(Se, "modelViewMatrix", a.modelViewMatrix), T.setValue(Se, "normalMatrix", a.normalMatrix), T.setValue(Se, "modelMatrix", a.matrixWorld), void 0 !== n.uniformsGroups) {
                    const e = n.uniformsGroups;
                    for(let t = 0, i = e.length; t < i; t++){
                        const i = e[t];
                        Me.update(i, k), Me.bind(i, k);
                    }
                }
                return k;
            }(e, t, i, n, a);
            se.setMaterial(n, s);
            let l = i.index, c = 1;
            if (!0 === n.wireframe) {
                if (l = he.getWireframeAttribute(i), void 0 === l) return;
                c = 2;
            }
            const d = i.drawRange, u = i.attributes.position;
            let h = d.start * c, p = (d.start + d.count) * c;
            null !== r && (h = Math.max(h, r.start * c), p = Math.min(p, (r.start + r.count) * c)), null !== l ? (h = Math.max(h, 0), p = Math.min(p, l.count)) : null != u && (h = Math.max(h, 0), p = Math.min(p, u.count));
            const A = p - h;
            if (A < 0 || A === 1 / 0) return;
            let m;
            we.setup(a, n, o, i, l);
            let g = be;
            if (null !== l && (m = ue.get(l), g = ke, g.setIndex(m)), a.isMesh) !0 === n.wireframe ? (se.setLineWidth(n.wireframeLinewidth * ne()), g.setMode(Se.LINES)) : g.setMode(Se.TRIANGLES);
            else if (a.isLine) {
                let e = n.linewidth;
                void 0 === e && (e = 1), se.setLineWidth(e * ne()), a.isLineSegments ? g.setMode(Se.LINES) : a.isLineLoop ? g.setMode(Se.LINE_LOOP) : g.setMode(Se.LINE_STRIP);
            } else a.isPoints ? g.setMode(Se.POINTS) : a.isSprite && g.setMode(Se.TRIANGLES);
            if (a.isBatchedMesh) {
                if (ae.get("WEBGL_multi_draw")) g.renderMultiDraw(a._multiDrawStarts, a._multiDrawCounts, a._multiDrawCount);
                else {
                    const e = a._multiDrawStarts, t = a._multiDrawCounts, i = a._multiDrawCount, r = l ? ue.get(l).bytesPerElement : 1, s = le.get(n).currentProgram.getUniforms();
                    for(let n = 0; n < i; n++)s.setValue(Se, "_gl_DrawID", n), g.render(e[n] / r, t[n]);
                }
            } else if (a.isInstancedMesh) g.renderInstances(h, A, a.count);
            else if (i.isInstancedBufferGeometry) {
                const e = void 0 !== i._maxInstanceCount ? i._maxInstanceCount : 1 / 0, t = Math.min(i.instanceCount, e);
                g.renderInstances(h, A, t);
            } else g.render(h, A);
        }, this.compile = function(e, t, i = null) {
            null === i && (i = e), y = fe.get(i), y.init(t), k.push(y), i.traverseVisible(function(e) {
                e.isLight && e.layers.test(t.layers) && (y.pushLight(e), e.castShadow && y.pushShadow(e));
            }), e !== i && e.traverseVisible(function(e) {
                e.isLight && e.layers.test(t.layers) && (y.pushLight(e), e.castShadow && y.pushShadow(e));
            }), y.setupLights();
            const n = new Set;
            return e.traverse(function(e) {
                if (!(e.isMesh || e.isPoints || e.isLine || e.isSprite)) return;
                const t = e.material;
                if (t) {
                    if (Array.isArray(t)) for(let a = 0; a < t.length; a++){
                        const r = t[a];
                        ze(r, i, e), n.add(r);
                    }
                    else ze(t, i, e), n.add(t);
                }
            }), y = k.pop(), n;
        }, this.compileAsync = function(e, t, i = null) {
            const n = this.compile(e, t, i);
            return new Promise((t)=>{
                function i() {
                    n.forEach(function(e) {
                        le.get(e).currentProgram.isReady() && n.delete(e);
                    }), 0 !== n.size ? setTimeout(i, 10) : t(e);
                }
                null !== ae.get("KHR_parallel_shader_compile") ? i() : setTimeout(i, 10);
            });
        };
        let Fe = null;
        function Ue() {
            Be.stop();
        }
        function Ne() {
            Be.start();
        }
        const Be = new $a42f1354f0348298$var$JA;
        function Oe(e, t, i, n) {
            if (!1 === e.visible) return;
            if (e.layers.test(t.layers)) {
                if (e.isGroup) i = e.renderOrder;
                else if (e.isLOD) !0 === e.autoUpdate && e.update(t);
                else if (e.isLightProbeGrid) y.pushLightProbeGrid(e);
                else if (e.isLight) y.pushLight(e), e.castShadow && y.pushShadow(e);
                else if (e.isSprite) {
                    if (!e.frustumCulled || Q.intersectsSprite(e)) {
                        n && ee.setFromMatrixPosition(e.matrixWorld).applyMatrix4(J);
                        const t = pe.update(e), a = e.material;
                        a.visible && E.push(e, t, a, i, ee.z, null);
                    }
                } else if ((e.isMesh || e.isLine || e.isPoints) && (!e.frustumCulled || Q.intersectsObject(e))) {
                    const t = pe.update(e), a = e.material;
                    if (n && (void 0 !== e.boundingSphere ? (null === e.boundingSphere && e.computeBoundingSphere(), ee.copy(e.boundingSphere.center)) : (null === t.boundingSphere && t.computeBoundingSphere(), ee.copy(t.boundingSphere.center)), ee.applyMatrix4(e.matrixWorld).applyMatrix4(J)), Array.isArray(a)) {
                        const n = t.groups;
                        for(let r = 0, s = n.length; r < s; r++){
                            const s = n[r], o = a[s.materialIndex];
                            o && o.visible && E.push(e, t, o, i, ee.z, s);
                        }
                    } else a.visible && E.push(e, t, a, i, ee.z, null);
                }
            }
            const a = e.children;
            for(let e = 0, r = a.length; e < r; e++)Oe(a[e], t, i, n);
        }
        function je(e, t, i, n) {
            const { opaque: a, transmissive: r, transparent: s } = e;
            y.setupLightsView(i), !0 === Z && _e.setGlobalState(w.clippingPlanes, i), n && se.viewport(F.copy(n)), a.length > 0 && Ve(a, t, i), r.length > 0 && Ve(r, t, i), s.length > 0 && Ve(s, t, i), se.buffers.depth.setTest(!0), se.buffers.depth.setMask(!0), se.buffers.color.setMask(!0), se.setPolygonOffset(!1);
        }
        function Ge(e, t, i, n) {
            if (null !== (!0 === i.isScene ? i.overrideMaterial : null)) return;
            if (void 0 === y.state.transmissionRenderTarget[n.id]) {
                const e = ae.has("EXT_color_buffer_half_float") || ae.has("EXT_color_buffer_float");
                y.state.transmissionRenderTarget[n.id] = new $a42f1354f0348298$var$Iu(1, 1, {
                    generateMipmaps: !0,
                    type: e ? $a42f1354f0348298$var$Dc : $a42f1354f0348298$var$kc,
                    minFilter: $a42f1354f0348298$var$bc,
                    samples: Math.max(4, re.samples),
                    stencilBuffer: a,
                    resolveDepthBuffer: !1,
                    resolveStencilBuffer: !1,
                    colorSpace: $a42f1354f0348298$var$vu.workingColorSpace
                });
            }
            const r = y.state.transmissionRenderTarget[n.id], s = n.viewport || F;
            r.setSize(s.z * w.transmissionResolutionScale, s.w * w.transmissionResolutionScale);
            const o = w.getRenderTarget(), l = w.getActiveCubeFace(), c = w.getActiveMipmapLevel();
            w.setRenderTarget(r), w.getClearColor(B), O = w.getClearAlpha(), O < 1 && w.setClearColor(16777215, .5), w.clear(), ie && Ee.render(i);
            const d = w.toneMapping;
            w.toneMapping = 0;
            const u = n.viewport;
            if (void 0 !== n.viewport && (n.viewport = void 0), y.setupLightsView(n), !0 === Z && _e.setGlobalState(w.clippingPlanes, n), Ve(e, i, n), ce.updateMultisampleRenderTarget(r), ce.updateRenderTargetMipmap(r), !1 === ae.has("WEBGL_multisampled_render_to_texture")) {
                let e = !1;
                for(let a = 0, r = t.length; a < r; a++){
                    const r = t[a], { object: s, geometry: o, material: l, group: c } = r;
                    if (2 === l.side && s.layers.test(n.layers)) {
                        const t = l.side;
                        l.side = 1, l.needsUpdate = !0, He(s, i, n, o, l, c), l.side = t, l.needsUpdate = !0, e = !0;
                    }
                }
                !0 === e && (ce.updateMultisampleRenderTarget(r), ce.updateRenderTargetMipmap(r));
            }
            w.setRenderTarget(o, l, c), w.setClearColor(B, O), void 0 !== u && (n.viewport = u), w.toneMapping = d;
        }
        function Ve(e, t, i) {
            const n = !0 === t.isScene ? t.overrideMaterial : null;
            for(let a = 0, r = e.length; a < r; a++){
                const r = e[a], { object: s, geometry: o, group: l } = r;
                let c = r.material;
                !0 === c.allowOverride && null !== n && (c = n), s.layers.test(i.layers) && He(s, t, i, o, c, l);
            }
        }
        function He(e, t, i, n, a, r) {
            e.onBeforeRender(w, t, i, n, a, r), e.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, e.matrixWorld), e.normalMatrix.getNormalMatrix(e.modelViewMatrix), a.onBeforeRender(w, t, i, n, e, r), !0 === a.transparent && 2 === a.side && !1 === a.forceSinglePass ? (a.side = 1, a.needsUpdate = !0, w.renderBufferDirect(i, t, n, a, e, r), a.side = 0, a.needsUpdate = !0, w.renderBufferDirect(i, t, n, a, e, r), a.side = 2) : w.renderBufferDirect(i, t, n, a, e, r), e.onAfterRender(w, t, i, n, a, r);
        }
        function qe(e, t, i) {
            !0 !== t.isScene && (t = te);
            const n = le.get(e), a = y.state.lights, r = y.state.shadowsArray, s = a.state.version, o = Ae.getParameters(e, a.state, r, t, i, y.state.lightProbeGridArray), l = Ae.getProgramCacheKey(o);
            let c = n.programs;
            n.environment = e.isMeshStandardMaterial || e.isMeshLambertMaterial || e.isMeshPhongMaterial ? t.environment : null, n.fog = t.fog;
            const d = e.isMeshStandardMaterial || e.isMeshLambertMaterial && !e.envMap || e.isMeshPhongMaterial && !e.envMap;
            n.envMap = de.get(e.envMap || n.environment, d), n.envMapRotation = null !== n.environment && null === e.envMap ? t.environmentRotation : e.envMapRotation, void 0 === c && (e.addEventListener("dispose", Re), c = new Map, n.programs = c);
            let u = c.get(l);
            if (void 0 !== u) {
                if (n.currentProgram === u && n.lightsStateVersion === s) return We(e, o), u;
            } else o.uniforms = Ae.getUniforms(e), null !== S && e.isNodeMaterial && S.build(e, i, o), e.onBeforeCompile(o, w), u = Ae.acquireProgram(o, l), c.set(l, u), n.uniforms = o.uniforms;
            const h = n.uniforms;
            return (e.isShaderMaterial || e.isRawShaderMaterial) && !0 !== e.clipping || (h.clippingPlanes = _e.uniform), We(e, o), n.needsLights = function(e) {
                return e.isMeshLambertMaterial || e.isMeshToonMaterial || e.isMeshPhongMaterial || e.isMeshStandardMaterial || e.isShadowMaterial || e.isShaderMaterial && !0 === e.lights;
            }(e), n.lightsStateVersion = s, n.needsLights && (h.ambientLightColor.value = a.state.ambient, h.lightProbe.value = a.state.probe, h.directionalLights.value = a.state.directional, h.directionalLightShadows.value = a.state.directionalShadow, h.spotLights.value = a.state.spot, h.spotLightShadows.value = a.state.spotShadow, h.rectAreaLights.value = a.state.rectArea, h.ltc_1.value = a.state.rectAreaLTC1, h.ltc_2.value = a.state.rectAreaLTC2, h.pointLights.value = a.state.point, h.pointLightShadows.value = a.state.pointShadow, h.hemisphereLights.value = a.state.hemi, h.directionalShadowMatrix.value = a.state.directionalShadowMatrix, h.spotLightMatrix.value = a.state.spotLightMatrix, h.spotLightMap.value = a.state.spotLightMap, h.pointShadowMatrix.value = a.state.pointShadowMatrix), n.lightProbeGrid = y.state.lightProbeGridArray.length > 0, n.currentProgram = u, n.uniformsList = null, u;
        }
        function Ke(e) {
            if (null === e.uniformsList) {
                const t = e.currentProgram.getUniforms();
                e.uniformsList = $a42f1354f0348298$var$Og.seqWithValue(t.seq, e.uniforms);
            }
            return e.uniformsList;
        }
        function We(e, t) {
            const i = le.get(e);
            i.outputColorSpace = t.outputColorSpace, i.batching = t.batching, i.batchingColor = t.batchingColor, i.instancing = t.instancing, i.instancingColor = t.instancingColor, i.instancingMorph = t.instancingMorph, i.skinning = t.skinning, i.morphTargets = t.morphTargets, i.morphNormals = t.morphNormals, i.morphColors = t.morphColors, i.morphTargetsCount = t.morphTargetsCount, i.numClippingPlanes = t.numClippingPlanes, i.numIntersection = t.numClipIntersection, i.vertexAlphas = t.vertexAlphas, i.vertexTangents = t.vertexTangents, i.toneMapping = t.toneMapping;
        }
        Be.setAnimationLoop(function(e) {
            Fe && Fe(e);
        }), "undefined" != typeof self && Be.setContext(self), this.setAnimationLoop = function(e) {
            Fe = e, De.setAnimationLoop(e), null === e ? Be.stop() : Be.start();
        }, De.addEventListener("sessionstart", Ue), De.addEventListener("sessionend", Ne), this.render = function(e, t) {
            if (void 0 !== t && !0 !== t.isCamera) return void $a42f1354f0348298$var$Xd("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            if (!0 === M) return;
            null !== S && S.renderStart(e, t);
            const i = !0 === De.enabled && !0 === De.isPresenting, n = null !== x && (null === L || i) && x.begin(w, L);
            if (!0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), !0 !== De.enabled || !0 !== De.isPresenting || null !== x && !1 !== x.isCompositing() || (!0 === De.cameraAutoUpdate && De.updateCamera(t), t = De.getCamera()), !0 === e.isScene && e.onBeforeRender(w, e, t, L), y = fe.get(e, k.length), y.init(t), y.state.textureUnits = ce.getTextureUnits(), k.push(y), J.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), Q.setFromProjectionMatrix(J, $a42f1354f0348298$var$Od, t.reversedDepth), Y = this.localClippingEnabled, Z = _e.init(this.clippingPlanes, Y), E = ge.get(e, b.length), E.init(), b.push(E), !0 === De.enabled && !0 === De.isPresenting) {
                const e = w.xr.getDepthSensingMesh();
                null !== e && Oe(e, t, -1 / 0, w.sortObjects);
            }
            Oe(e, t, 0, w.sortObjects), E.finish(), !0 === w.sortObjects && E.sort(H, q, t.reversedDepth), ie = !1 === De.enabled || !1 === De.isPresenting || !1 === De.hasDepthSensing(), ie && Ee.addToRenderList(E, e), this.info.render.frame++, !0 === this.info.autoReset && this.info.reset(), !0 === Z && _e.beginShadows();
            const a = y.state.shadowsArray;
            ve.render(a, e, t), !0 === Z && _e.endShadows();
            if (!1 === (n && x.hasRenderPass())) {
                const i = E.opaque, n = E.transmissive;
                if (y.setupLights(), t.isArrayCamera) {
                    const a = t.cameras;
                    if (n.length > 0) for(let t = 0, r = a.length; t < r; t++)Ge(i, n, e, a[t]);
                    ie && Ee.render(e);
                    for(let t = 0, i = a.length; t < i; t++){
                        const i = a[t];
                        je(E, e, i, i.viewport);
                    }
                } else n.length > 0 && Ge(i, n, e, t), ie && Ee.render(e), je(E, e, t);
            }
            null !== L && 0 === I && (ce.updateMultisampleRenderTarget(L), ce.updateRenderTargetMipmap(L)), n && x.end(w), !0 === e.isScene && e.onAfterRender(w, e, t), we.resetDefaultState(), R = -1, z = null, k.pop(), k.length > 0 ? (y = k[k.length - 1], ce.setTextureUnits(y.state.textureUnits), !0 === Z && _e.setGlobalState(w.clippingPlanes, y.state.camera)) : y = null, b.pop(), E = b.length > 0 ? b[b.length - 1] : null, null !== S && S.renderEnd();
        }, this.getActiveCubeFace = function() {
            return P;
        }, this.getActiveMipmapLevel = function() {
            return I;
        }, this.getRenderTarget = function() {
            return L;
        }, this.setRenderTargetTextures = function(e, t, i) {
            const n = le.get(e);
            n.__autoAllocateDepthBuffer = !1 === e.resolveDepthBuffer, !1 === n.__autoAllocateDepthBuffer && (n.__useRenderToTexture = !1), le.get(e.texture).__webglTexture = t, le.get(e.depthTexture).__webglTexture = n.__autoAllocateDepthBuffer ? void 0 : i, n.__hasExternalTextures = !0;
        }, this.setRenderTargetFramebuffer = function(e, t) {
            const i = le.get(e);
            i.__webglFramebuffer = t, i.__useDefaultFramebuffer = void 0 === t;
        }, this.setRenderTarget = function(e, t = 0, i = 0) {
            L = e, P = t, I = i;
            let n = null, a = !1, r = !1;
            if (e) {
                const s = le.get(e);
                if (void 0 !== s.__useDefaultFramebuffer) return se.bindFramebuffer(Se.FRAMEBUFFER, s.__webglFramebuffer), F.copy(e.viewport), U.copy(e.scissor), N = e.scissorTest, se.viewport(F), se.scissor(U), se.setScissorTest(N), void (R = -1);
                if (void 0 === s.__webglFramebuffer) ce.setupRenderTarget(e);
                else if (s.__hasExternalTextures) ce.rebindTextures(e, le.get(e.texture).__webglTexture, le.get(e.depthTexture).__webglTexture);
                else if (e.depthBuffer) {
                    const t = e.depthTexture;
                    if (s.__boundDepthTexture !== t) {
                        if (null !== t && le.has(t) && (e.width !== t.image.width || e.height !== t.image.height)) throw new Error("THREE.WebGLRenderer: Attached DepthTexture is initialized to the incorrect size.");
                        ce.setupDepthRenderbuffer(e);
                    }
                }
                const o = e.texture;
                (o.isData3DTexture || o.isDataArrayTexture || o.isCompressedArrayTexture) && (r = !0);
                const l = le.get(e).__webglFramebuffer;
                e.isWebGLCubeRenderTarget ? (n = Array.isArray(l[t]) ? l[t][i] : l[t], a = !0) : n = e.samples > 0 && !1 === ce.useMultisampledRTT(e) ? le.get(e).__webglMultisampledFramebuffer : Array.isArray(l) ? l[i] : l, F.copy(e.viewport), U.copy(e.scissor), N = e.scissorTest;
            } else F.copy(K).multiplyScalar(V).floor(), U.copy(W).multiplyScalar(V).floor(), N = X;
            0 !== i && (n = C);
            if (se.bindFramebuffer(Se.FRAMEBUFFER, n) && se.drawBuffers(e, n), se.viewport(F), se.scissor(U), se.setScissorTest(N), a) {
                const n = le.get(e.texture);
                Se.framebufferTexture2D(Se.FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_CUBE_MAP_POSITIVE_X + t, n.__webglTexture, i);
            } else if (r) {
                const n = t;
                for(let t = 0; t < e.textures.length; t++){
                    const a = le.get(e.textures[t]);
                    Se.framebufferTextureLayer(Se.FRAMEBUFFER, Se.COLOR_ATTACHMENT0 + t, a.__webglTexture, i, n);
                }
            } else if (null !== e && 0 !== i) {
                const t = le.get(e.texture);
                Se.framebufferTexture2D(Se.FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_2D, t.__webglTexture, i);
            }
            R = -1;
        }, this.readRenderTargetPixels = function(e, t, i, n, a, r, s, o = 0) {
            if (!e || !e.isWebGLRenderTarget) return void $a42f1354f0348298$var$Xd("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let l = le.get(e).__webglFramebuffer;
            if (e.isWebGLCubeRenderTarget && void 0 !== s && (l = l[s]), l) {
                se.bindFramebuffer(Se.FRAMEBUFFER, l);
                try {
                    const s = e.textures[o], l = s.format, c = s.type;
                    if (e.textures.length > 1 && Se.readBuffer(Se.COLOR_ATTACHMENT0 + o), !re.textureFormatReadable(l)) return void $a42f1354f0348298$var$Xd("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    if (!re.textureTypeReadable(c)) return void $a42f1354f0348298$var$Xd("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    t >= 0 && t <= e.width - n && i >= 0 && i <= e.height - a && Se.readPixels(t, i, n, a, xe.convert(l), xe.convert(c), r);
                } finally{
                    const e = null !== L ? le.get(L).__webglFramebuffer : null;
                    se.bindFramebuffer(Se.FRAMEBUFFER, e);
                }
            }
        }, this.readRenderTargetPixelsAsync = async function(e, t, i, n, a, r, s, o = 0) {
            if (!e || !e.isWebGLRenderTarget) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let l = le.get(e).__webglFramebuffer;
            if (e.isWebGLCubeRenderTarget && void 0 !== s && (l = l[s]), l) {
                if (t >= 0 && t <= e.width - n && i >= 0 && i <= e.height - a) {
                    se.bindFramebuffer(Se.FRAMEBUFFER, l);
                    const s = e.textures[o], c = s.format, d = s.type;
                    if (e.textures.length > 1 && Se.readBuffer(Se.COLOR_ATTACHMENT0 + o), !re.textureFormatReadable(c)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                    if (!re.textureTypeReadable(d)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                    const u = Se.createBuffer();
                    Se.bindBuffer(Se.PIXEL_PACK_BUFFER, u), Se.bufferData(Se.PIXEL_PACK_BUFFER, r.byteLength, Se.STREAM_READ), Se.readPixels(t, i, n, a, xe.convert(c), xe.convert(d), 0);
                    const h = null !== L ? le.get(L).__webglFramebuffer : null;
                    se.bindFramebuffer(Se.FRAMEBUFFER, h);
                    const p = Se.fenceSync(Se.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    return Se.flush(), await function(e, t, i) {
                        return new Promise(function(n, a) {
                            setTimeout(function r() {
                                switch(e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0)){
                                    case e.WAIT_FAILED:
                                        a();
                                        break;
                                    case e.TIMEOUT_EXPIRED:
                                        setTimeout(r, i);
                                        break;
                                    default:
                                        n();
                                }
                            }, i);
                        });
                    }(Se, p, 4), Se.bindBuffer(Se.PIXEL_PACK_BUFFER, u), Se.getBufferSubData(Se.PIXEL_PACK_BUFFER, 0, r), Se.deleteBuffer(u), Se.deleteSync(p), r;
                }
                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
            }
        }, this.copyFramebufferToTexture = function(e, t = null, i = 0) {
            const n = Math.pow(2, -i), a = Math.floor(e.image.width * n), r = Math.floor(e.image.height * n), s = null !== t ? t.x : 0, o = null !== t ? t.y : 0;
            ce.setTexture2D(e, 0), Se.copyTexSubImage2D(Se.TEXTURE_2D, i, 0, 0, s, o, a, r), se.unbindTexture();
        }, this.copyTextureToTexture = function(e, t, i = null, n = null, a = 0, r = 0) {
            let s, o, l, c, d, u, h, p, A;
            const m = e.isCompressedTexture ? e.mipmaps[r] : e.image;
            if (null !== i) s = i.max.x - i.min.x, o = i.max.y - i.min.y, l = i.isBox3 ? i.max.z - i.min.z : 1, c = i.min.x, d = i.min.y, u = i.isBox3 ? i.min.z : 0;
            else {
                const t = Math.pow(2, -a);
                s = Math.floor(m.width * t), o = Math.floor(m.height * t), l = e.isDataArrayTexture ? m.depth : e.isData3DTexture ? Math.floor(m.depth * t) : 1, c = 0, d = 0, u = 0;
            }
            null !== n ? (h = n.x, p = n.y, A = n.z) : (h = 0, p = 0, A = 0);
            const g = xe.convert(t.format), f = xe.convert(t.type);
            let _;
            t.isData3DTexture ? (ce.setTexture3D(t, 0), _ = Se.TEXTURE_3D) : t.isDataArrayTexture || t.isCompressedArrayTexture ? (ce.setTexture2DArray(t, 0), _ = Se.TEXTURE_2D_ARRAY) : (ce.setTexture2D(t, 0), _ = Se.TEXTURE_2D), se.activeTexture(Se.TEXTURE0), se.pixelStorei(Se.UNPACK_FLIP_Y_WEBGL, t.flipY), se.pixelStorei(Se.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), se.pixelStorei(Se.UNPACK_ALIGNMENT, t.unpackAlignment);
            const v = se.getParameter(Se.UNPACK_ROW_LENGTH), E = se.getParameter(Se.UNPACK_IMAGE_HEIGHT), y = se.getParameter(Se.UNPACK_SKIP_PIXELS), b = se.getParameter(Se.UNPACK_SKIP_ROWS), k = se.getParameter(Se.UNPACK_SKIP_IMAGES);
            se.pixelStorei(Se.UNPACK_ROW_LENGTH, m.width), se.pixelStorei(Se.UNPACK_IMAGE_HEIGHT, m.height), se.pixelStorei(Se.UNPACK_SKIP_PIXELS, c), se.pixelStorei(Se.UNPACK_SKIP_ROWS, d), se.pixelStorei(Se.UNPACK_SKIP_IMAGES, u);
            const x = e.isDataArrayTexture || e.isData3DTexture, w = t.isDataArrayTexture || t.isData3DTexture;
            if (e.isDepthTexture) {
                const i = le.get(e), n = le.get(t), m = le.get(i.__renderTarget), g = le.get(n.__renderTarget);
                se.bindFramebuffer(Se.READ_FRAMEBUFFER, m.__webglFramebuffer), se.bindFramebuffer(Se.DRAW_FRAMEBUFFER, g.__webglFramebuffer);
                for(let i = 0; i < l; i++)x && (Se.framebufferTextureLayer(Se.READ_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, le.get(e).__webglTexture, a, u + i), Se.framebufferTextureLayer(Se.DRAW_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, le.get(t).__webglTexture, r, A + i)), Se.blitFramebuffer(c, d, s, o, h, p, s, o, Se.DEPTH_BUFFER_BIT, Se.NEAREST);
                se.bindFramebuffer(Se.READ_FRAMEBUFFER, null), se.bindFramebuffer(Se.DRAW_FRAMEBUFFER, null);
            } else if (0 !== a || e.isRenderTargetTexture || le.has(e)) {
                const i = le.get(e), n = le.get(t);
                se.bindFramebuffer(Se.READ_FRAMEBUFFER, T), se.bindFramebuffer(Se.DRAW_FRAMEBUFFER, D);
                for(let e = 0; e < l; e++)x ? Se.framebufferTextureLayer(Se.READ_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, i.__webglTexture, a, u + e) : Se.framebufferTexture2D(Se.READ_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_2D, i.__webglTexture, a), w ? Se.framebufferTextureLayer(Se.DRAW_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, n.__webglTexture, r, A + e) : Se.framebufferTexture2D(Se.DRAW_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_2D, n.__webglTexture, r), 0 !== a ? Se.blitFramebuffer(c, d, s, o, h, p, s, o, Se.COLOR_BUFFER_BIT, Se.NEAREST) : w ? Se.copyTexSubImage3D(_, r, h, p, A + e, c, d, s, o) : Se.copyTexSubImage2D(_, r, h, p, c, d, s, o);
                se.bindFramebuffer(Se.READ_FRAMEBUFFER, null), se.bindFramebuffer(Se.DRAW_FRAMEBUFFER, null);
            } else w ? e.isDataTexture || e.isData3DTexture ? Se.texSubImage3D(_, r, h, p, A, s, o, l, g, f, m.data) : t.isCompressedArrayTexture ? Se.compressedTexSubImage3D(_, r, h, p, A, s, o, l, g, m.data) : Se.texSubImage3D(_, r, h, p, A, s, o, l, g, f, m) : e.isDataTexture ? Se.texSubImage2D(Se.TEXTURE_2D, r, h, p, s, o, g, f, m.data) : e.isCompressedTexture ? Se.compressedTexSubImage2D(Se.TEXTURE_2D, r, h, p, m.width, m.height, g, m.data) : Se.texSubImage2D(Se.TEXTURE_2D, r, h, p, s, o, g, f, m);
            se.pixelStorei(Se.UNPACK_ROW_LENGTH, v), se.pixelStorei(Se.UNPACK_IMAGE_HEIGHT, E), se.pixelStorei(Se.UNPACK_SKIP_PIXELS, y), se.pixelStorei(Se.UNPACK_SKIP_ROWS, b), se.pixelStorei(Se.UNPACK_SKIP_IMAGES, k), 0 === r && t.generateMipmaps && Se.generateMipmap(_), se.unbindTexture();
        }, this.initRenderTarget = function(e) {
            void 0 === le.get(e).__webglFramebuffer && ce.setupRenderTarget(e);
        }, this.initTexture = function(e) {
            e.isCubeTexture ? ce.setTextureCube(e, 0) : e.isData3DTexture ? ce.setTexture3D(e, 0) : e.isDataArrayTexture || e.isCompressedArrayTexture ? ce.setTexture2DArray(e, 0) : ce.setTexture2D(e, 0), se.unbindTexture();
        }, this.resetState = function() {
            P = 0, I = 0, L = null, se.reset(), we.reset();
        }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $a42f1354f0348298$var$Od;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(e) {
        this._outputColorSpace = e;
        const t = this.getContext();
        t.drawingBufferColorSpace = $a42f1354f0348298$var$vu._getDrawingBufferColorSpace(e), t.unpackColorSpace = $a42f1354f0348298$var$vu._getUnpackColorSpace();
    }
}
/*!
 * Photo Sphere Viewer 5.15.1
 * @copyright 2014-2015 Jérémy Heleine
 * @copyright 2015-2026 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */ var $a42f1354f0348298$var$Kf = Object.defineProperty, $a42f1354f0348298$var$Wf = (e, t)=>{
    for(var i in t)$a42f1354f0348298$var$Kf(e, i, {
        get: t[i],
        enumerable: !0
    });
}, $a42f1354f0348298$var$Xf = {};
$a42f1354f0348298$var$Wf($a42f1354f0348298$var$Xf, {
    ACTIONS: ()=>$a42f1354f0348298$var$r_,
    ANIMATION_MIN_DURATION: ()=>$a42f1354f0348298$var$Zf,
    CAPTURE_EVENTS_CLASS: ()=>$a42f1354f0348298$var$a_,
    CTRLZOOM_TIMEOUT: ()=>$a42f1354f0348298$var$t_,
    DBLCLICK_DELAY: ()=>$a42f1354f0348298$var$Jf,
    EASINGS: ()=>$a42f1354f0348298$var$c_,
    ICONS: ()=>$a42f1354f0348298$var$l_,
    IDS: ()=>$a42f1354f0348298$var$s_,
    KEY_CODES: ()=>$a42f1354f0348298$var$o_,
    LONGTOUCH_DELAY: ()=>$a42f1354f0348298$var$$f,
    MOVE_THRESHOLD: ()=>$a42f1354f0348298$var$Yf,
    SPHERE_RADIUS: ()=>$a42f1354f0348298$var$i_,
    TWOFINGERSOVERLAY_DELAY: ()=>$a42f1354f0348298$var$e_,
    VIEWER_DATA: ()=>$a42f1354f0348298$var$n_
});
var $a42f1354f0348298$var$Qf, $a42f1354f0348298$var$Zf = 500, $a42f1354f0348298$var$Yf = 4, $a42f1354f0348298$var$Jf = 300, $a42f1354f0348298$var$$f = 500, $a42f1354f0348298$var$e_ = 100, $a42f1354f0348298$var$t_ = 2e3, $a42f1354f0348298$var$i_ = 10, $a42f1354f0348298$var$n_ = "photoSphereViewer", $a42f1354f0348298$var$a_ = "psv--capture-event", $a42f1354f0348298$var$r_ = ((e)=>(e.ROTATE_UP = "ROTATE_UP", e.ROTATE_DOWN = "ROTATE_DOWN", e.ROTATE_RIGHT = "ROTATE_RIGHT", e.ROTATE_LEFT = "ROTATE_LEFT", e.ZOOM_IN = "ZOOM_IN", e.ZOOM_OUT = "ZOOM_OUT", e))($a42f1354f0348298$var$r_ || {}), $a42f1354f0348298$var$s_ = {
    MENU: "menu",
    TWO_FINGERS: "twoFingers",
    CTRL_ZOOM: "ctrlZoom",
    ERROR: "error",
    DESCRIPTION: "description"
}, $a42f1354f0348298$var$o_ = {
    Enter: "Enter",
    Control: "Control",
    Escape: "Escape",
    Space: " ",
    PageUp: "PageUp",
    PageDown: "PageDown",
    ArrowLeft: "ArrowLeft",
    ArrowUp: "ArrowUp",
    ArrowRight: "ArrowRight",
    ArrowDown: "ArrowDown",
    Delete: "Delete",
    Plus: "+",
    Minus: "-"
}, $a42f1354f0348298$var$l_ = {
    arrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g>\x3c!-- Created by Flatart from the Noun Project --\x3e</svg>\n',
    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="currentColor" transform=" translate(50, 50) rotate(45)"><rect x="-5" y="-65" width="10" height="130"/><rect x="-65" y="-5" width="130" height="10"/></g></svg>',
    download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/>\x3c!--Created by Michael Zenaty from the Noun Project--\x3e</svg>\n',
    fullscreenIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/>\x3c!--Created by Garrett Knoll from the Noun Project--\x3e</svg>\n',
    fullscreenOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/>\x3c!--Created by Garrett Knoll from the Noun Project--\x3e</svg>\n',
    info: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/>\x3c!--Created by Arafat Uddin from the Noun Project--\x3e</svg>\n',
    menu: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g><!-- Created by Richard Kun\xe1k from the Noun Project--></svg>\n',
    zoomIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/>\x3c!--Created by Ryan Canning from the Noun Project--\x3e</svg>\n',
    zoomOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/>\x3c!--Created by Ryan Canning from the Noun Project--\x3e</svg>\n'
}, $a42f1354f0348298$var$c_ = {
    linear: (e)=>e,
    inQuad: (e)=>e * e,
    outQuad: (e)=>e * (2 - e),
    inOutQuad: (e)=>e < .5 ? 2 * e * e : (4 - 2 * e) * e - 1,
    inCubic: (e)=>e * e * e,
    outCubic: (e)=>--e * e * e + 1,
    inOutCubic: (e)=>e < .5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
    inQuart: (e)=>e * e * e * e,
    outQuart: (e)=>1 - --e * e * e * e,
    inOutQuart: (e)=>e < .5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e,
    inQuint: (e)=>e * e * e * e * e,
    outQuint: (e)=>1 + --e * e * e * e * e,
    inOutQuint: (e)=>e < .5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e,
    inSine: (e)=>1 - Math.cos(e * (Math.PI / 2)),
    outSine: (e)=>Math.sin(e * (Math.PI / 2)),
    inOutSine: (e)=>.5 - .5 * Math.cos(Math.PI * e),
    inExpo: (e)=>Math.pow(2, 10 * (e - 1)),
    outExpo: (e)=>1 - Math.pow(2, -10 * e),
    inOutExpo: (e)=>(e = 2 * e - 1) < 0 ? .5 * Math.pow(2, 10 * e) : 1 - .5 * Math.pow(2, -10 * e),
    inCirc: (e)=>1 - Math.sqrt(1 - e * e),
    outCirc: (e)=>Math.sqrt(1 - (e - 1) * (e - 1)),
    inOutCirc: (e)=>(e *= 2) < 1 ? .5 - .5 * Math.sqrt(1 - e * e) : .5 + .5 * Math.sqrt(1 - (e -= 2) * e)
}, $a42f1354f0348298$var$d_ = {};
function $a42f1354f0348298$var$u_(e, t) {
    let i = e % t;
    return i < 0 && (i += t), i;
}
function $a42f1354f0348298$var$h_(e) {
    return e.reduce((e, t)=>e + t, 0);
}
function $a42f1354f0348298$var$p_(e, t) {
    return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function $a42f1354f0348298$var$A_(e, t) {
    return Math.atan2(t.y - e.y, t.x - e.x);
}
function $a42f1354f0348298$var$m_(e, t) {
    return [
        0,
        2 * Math.PI,
        2 * -Math.PI
    ].reduce((i, n)=>{
        const a = t - e + n;
        return Math.abs(a) < Math.abs(i) ? a : i;
    }, 1 / 0);
}
function $a42f1354f0348298$var$g_(e, t) {
    return Math.acos(Math.cos(e.pitch) * Math.cos(t.pitch) * Math.cos(e.yaw - t.yaw) + Math.sin(e.pitch) * Math.sin(t.pitch));
}
function $a42f1354f0348298$var$f_([e, t], [i, n]) {
    e - i > Math.PI ? e -= 2 * Math.PI : e - i < -Math.PI && (e += 2 * Math.PI);
    const a = (i - e) * Math.cos((t + n) / 2), r = n - t;
    return Math.sqrt(a * a + r * r);
}
function $a42f1354f0348298$var$__(e) {
    return "string" == typeof e ? e.match(/^[a-z]/i) ? document.getElementById(e) : document.querySelector(e) : e;
}
function $a42f1354f0348298$var$v_(e, t, i) {
    void 0 === i ? e.classList.toggle(t) : i ? e.classList.add(t) : i || e.classList.remove(t);
}
function $a42f1354f0348298$var$E_(e, t) {
    e.classList.add(...t.split(" ").filter((e)=>!!e));
}
function $a42f1354f0348298$var$y_(e, t) {
    e.classList.remove(...t.split(" ").filter((e)=>!!e));
}
function $a42f1354f0348298$var$b_(e, t) {
    let i = e;
    do {
        if (i === t) return !0;
        i = i.parentElement;
    }while (i);
    return !1;
}
function $a42f1354f0348298$var$k_(e, t) {
    if (!e?.matches) return null;
    let i = e;
    do {
        if (i.matches(t)) return i;
        i = i.parentElement;
    }while (i);
    return null;
}
function $a42f1354f0348298$var$x_(e) {
    return e?.composedPath()[0] || null;
}
function $a42f1354f0348298$var$w_(e, t) {
    return e ? e.composedPath().find((e)=>(e instanceof HTMLElement || e instanceof SVGElement) && e.matches(t)) : null;
}
function $a42f1354f0348298$var$M_(e) {
    let t = 0, i = 0, n = e;
    for(; n;)t += n.offsetLeft - n.scrollLeft + n.clientLeft, i += n.offsetTop - n.scrollTop + n.clientTop, n = n.offsetParent;
    return t -= window.scrollX, i -= window.scrollY, {
        x: t,
        y: i
    };
}
function $a42f1354f0348298$var$S_(e, t) {
    return window.getComputedStyle(e).getPropertyValue(t);
}
function $a42f1354f0348298$var$C_(e) {
    if (e.touches.length < 2) return null;
    const t = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
    }, i = {
        x: e.touches[1].clientX,
        y: e.touches[1].clientY
    };
    return {
        distance: $a42f1354f0348298$var$p_(t, i),
        angle: $a42f1354f0348298$var$A_(t, i),
        center: {
            x: (t.x + i.x) / 2,
            y: (t.y + i.y) / 2
        }
    };
}
function $a42f1354f0348298$var$T_(e, t = !1) {
    return t ? e === $a42f1354f0348298$var$Qf : document.fullscreenElement === e;
}
function $a42f1354f0348298$var$D_(e, t = !1) {
    t ? ($a42f1354f0348298$var$Qf = e, e.classList.add("psv-fullscreen-emulation"), document.dispatchEvent(new Event("fullscreenchange"))) : e.requestFullscreen();
}
function $a42f1354f0348298$var$P_(e = !1) {
    e ? ($a42f1354f0348298$var$Qf.classList.remove("psv-fullscreen-emulation"), $a42f1354f0348298$var$Qf = null, document.dispatchEvent(new Event("fullscreenchange"))) : document.exitFullscreen();
}
function $a42f1354f0348298$var$I_(e, t) {
    let i, n = !1, a = !1, r = !1, s = !1;
    return "+" === t ? i = t : t.split("+").forEach((e)=>{
        switch(e){
            case "Shift":
                n = !0;
                break;
            case "Ctrl":
                a = !0;
                break;
            case "Alt":
                r = !0;
                break;
            case "Meta":
                s = !0;
                break;
            case "Space":
                i = " ";
                break;
            case "Plus":
                i = "+";
                break;
            case "Minus":
                i = "-";
                break;
            default:
                i = e;
        }
    }), n === e.shiftKey && a === e.ctrlKey && r === e.altKey && s === e.metaKey && i === e.key;
}
function $a42f1354f0348298$var$L_(e) {
    return e.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, (e, t)=>(t > 0 ? "-" : "") + e.toLowerCase());
}
function $a42f1354f0348298$var$R_(e, t) {
    let i = !1;
    return function(...n) {
        i || (i = !0, setTimeout(()=>{
            e.apply(this, n), i = !1;
        }, t));
    };
}
function $a42f1354f0348298$var$z_(e) {
    if ("object" != typeof e || null === e || "[object Object]" !== Object.prototype.toString.call(e)) return !1;
    if (null === Object.getPrototypeOf(e)) return !0;
    let t = e;
    for(; null !== Object.getPrototypeOf(t);)t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(e) === t;
}
function $a42f1354f0348298$var$F_(e, t) {
    const i = t;
    return function e(t, n) {
        return Array.isArray(n) ? (t && Array.isArray(t) ? t.length = 0 : t = [], n.forEach((i, n)=>{
            t[n] = e(null, i);
        })) : "object" == typeof n ? (t && !Array.isArray(t) || (t = {}), Object.keys(n).forEach((a)=>{
            "__proto__" !== a && ("object" == typeof n[a] && n[a] && $a42f1354f0348298$var$z_(n[a]) ? n[a] !== i && (t[a] ? e(t[a], n[a]) : t[a] = e(null, n[a])) : t[a] = n[a]);
        })) : t = n, t;
    }(e, t);
}
function $a42f1354f0348298$var$U_(e) {
    return $a42f1354f0348298$var$F_(null, e);
}
function $a42f1354f0348298$var$N_(e) {
    return !e || 0 === Object.keys(e).length && e.constructor === Object;
}
function $a42f1354f0348298$var$B_(e) {
    return null == e;
}
function $a42f1354f0348298$var$O_(...e) {
    for (const t of e)if (!$a42f1354f0348298$var$B_(t)) return t;
    return null;
}
function $a42f1354f0348298$var$j_(e, t) {
    if (e === t) return !0;
    if ($a42f1354f0348298$var$G_(e) && $a42f1354f0348298$var$G_(t)) {
        if (Object.keys(e).length !== Object.keys(t).length) return !1;
        for (const i of Object.keys(e))if (!$a42f1354f0348298$var$j_(e[i], t[i])) return !1;
        return !0;
    }
    return !1;
}
function $a42f1354f0348298$var$G_(e) {
    return "object" == typeof e && null !== e;
}
$a42f1354f0348298$var$Wf($a42f1354f0348298$var$d_, {
    Animation: ()=>$a42f1354f0348298$var$vv,
    Dynamic: ()=>$a42f1354f0348298$var$Ev,
    MultiDynamic: ()=>$a42f1354f0348298$var$yv,
    PressHandler: ()=>$a42f1354f0348298$var$bv,
    Slider: ()=>$a42f1354f0348298$var$xv,
    SliderDirection: ()=>$a42f1354f0348298$var$kv,
    addClasses: ()=>$a42f1354f0348298$var$E_,
    angle: ()=>$a42f1354f0348298$var$A_,
    applyEulerInverse: ()=>$a42f1354f0348298$var$_v,
    checkClosedShadowDom: ()=>$a42f1354f0348298$var$uv,
    checkStylesheet: ()=>$a42f1354f0348298$var$cv,
    checkVersion: ()=>$a42f1354f0348298$var$dv,
    cleanCssPosition: ()=>$a42f1354f0348298$var$nv,
    clone: ()=>$a42f1354f0348298$var$U_,
    createSizedTexture: ()=>$a42f1354f0348298$var$gv,
    createTexture: ()=>$a42f1354f0348298$var$mv,
    cssPositionIsOrdered: ()=>$a42f1354f0348298$var$av,
    dasherize: ()=>$a42f1354f0348298$var$L_,
    deepEqual: ()=>$a42f1354f0348298$var$j_,
    deepmerge: ()=>$a42f1354f0348298$var$F_,
    distance: ()=>$a42f1354f0348298$var$p_,
    exitFullscreen: ()=>$a42f1354f0348298$var$P_,
    firstNonNull: ()=>$a42f1354f0348298$var$O_,
    getAbortError: ()=>$a42f1354f0348298$var$K_,
    getAngle: ()=>$a42f1354f0348298$var$g_,
    getClosest: ()=>$a42f1354f0348298$var$k_,
    getConfigParser: ()=>$a42f1354f0348298$var$lv,
    getElement: ()=>$a42f1354f0348298$var$__,
    getEventTarget: ()=>$a42f1354f0348298$var$x_,
    getMatchingTarget: ()=>$a42f1354f0348298$var$w_,
    getPosition: ()=>$a42f1354f0348298$var$M_,
    getShortestArc: ()=>$a42f1354f0348298$var$m_,
    getStyleProperty: ()=>$a42f1354f0348298$var$S_,
    getTouchData: ()=>$a42f1354f0348298$var$C_,
    getXMPValue: ()=>$a42f1354f0348298$var$Z_,
    greatArcDistance: ()=>$a42f1354f0348298$var$f_,
    hasParent: ()=>$a42f1354f0348298$var$b_,
    invertResolvableBoolean: ()=>$a42f1354f0348298$var$q_,
    isAbortError: ()=>$a42f1354f0348298$var$W_,
    isEmpty: ()=>$a42f1354f0348298$var$N_,
    isExtendedPosition: ()=>$a42f1354f0348298$var$Q_,
    isFullscreenEnabled: ()=>$a42f1354f0348298$var$T_,
    isNil: ()=>$a42f1354f0348298$var$B_,
    isPlainObject: ()=>$a42f1354f0348298$var$z_,
    keyPressMatch: ()=>$a42f1354f0348298$var$I_,
    logWarn: ()=>$a42f1354f0348298$var$X_,
    mergePanoData: ()=>$a42f1354f0348298$var$hv,
    parseAngle: ()=>$a42f1354f0348298$var$ov,
    parsePoint: ()=>$a42f1354f0348298$var$iv,
    parseSpeed: ()=>$a42f1354f0348298$var$rv,
    removeClasses: ()=>$a42f1354f0348298$var$y_,
    requestFullscreen: ()=>$a42f1354f0348298$var$D_,
    resolveBoolean: ()=>$a42f1354f0348298$var$H_,
    speedToDuration: ()=>$a42f1354f0348298$var$sv,
    sum: ()=>$a42f1354f0348298$var$h_,
    throttle: ()=>$a42f1354f0348298$var$R_,
    toggleClass: ()=>$a42f1354f0348298$var$v_,
    wrap: ()=>$a42f1354f0348298$var$u_
});
var $a42f1354f0348298$var$V_ = class e extends Error {
    constructor(t, i){
        super(i && i instanceof Error ? `${t}: ${i.message}` : t), this.name = "PSVError", Error.captureStackTrace?.(this, e);
    }
};
function $a42f1354f0348298$var$H_(e, t) {
    $a42f1354f0348298$var$z_(e) ? (t(e.initial, !0), e.promise.then((e)=>t(e, !1))) : t(e, !0);
}
function $a42f1354f0348298$var$q_(e) {
    return {
        initial: !e.initial,
        promise: e.promise.then((e)=>!e)
    };
}
function $a42f1354f0348298$var$K_() {
    const e = new Error("Loading was aborted.");
    return e.name = "AbortError", e;
}
function $a42f1354f0348298$var$W_(e) {
    return "AbortError" === e?.name;
}
function $a42f1354f0348298$var$X_(e) {
    console.warn(`PhotoSphereViewer: ${e}`);
}
function $a42f1354f0348298$var$Q_(e) {
    return !(!e || Array.isArray(e)) && [
        [
            "textureX",
            "textureY"
        ],
        [
            "yaw",
            "pitch"
        ]
    ].some(([t, i])=>void 0 !== e[t] && void 0 !== e[i]);
}
function $a42f1354f0348298$var$Z_(e, t, i = !0) {
    let n = e.match("<GPano:" + t + ">(.*)</GPano:" + t + ">");
    if (null !== n) {
        const e = i ? parseInt(n[1], 10) : parseFloat(n[1]);
        return isNaN(e) ? null : e;
    }
    if (n = e.match("GPano:" + t + '="(.*?)"'), null !== n) {
        const e = i ? parseInt(n[1], 10) : parseFloat(n[1]);
        return isNaN(e) ? null : e;
    }
    return null;
}
var $a42f1354f0348298$var$Y_ = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $a42f1354f0348298$var$J_ = [
    "left",
    "center",
    "right"
], $a42f1354f0348298$var$$_ = [
    "top",
    "center",
    "bottom"
], $a42f1354f0348298$var$ev = [
    ...$a42f1354f0348298$var$J_,
    ...$a42f1354f0348298$var$$_
], $a42f1354f0348298$var$tv = "center";
function $a42f1354f0348298$var$iv(e) {
    if (!e) return {
        x: .5,
        y: .5
    };
    if ("object" == typeof e) return e;
    let t = e.toLocaleLowerCase().split(" ").slice(0, 2);
    1 === t.length && (t = $a42f1354f0348298$var$Y_[t[0]] ? [
        t[0],
        $a42f1354f0348298$var$tv
    ] : [
        t[0],
        t[0]
    ]);
    const i = "left" !== t[1] && "right" !== t[1] && "top" !== t[0] && "bottom" !== t[0];
    t = t.map((e)=>$a42f1354f0348298$var$Y_[e] || e), i || t.reverse();
    const n = t.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);
    return n ? {
        x: parseFloat(n[1]) / 100,
        y: parseFloat(n[2]) / 100
    } : {
        x: .5,
        y: .5
    };
}
function $a42f1354f0348298$var$nv(e, { allowCenter: t, cssOrder: i } = {
    allowCenter: !0,
    cssOrder: !0
}) {
    return e ? ("string" == typeof e && (e = e.split(" ")), 1 === e.length && (e[0] === $a42f1354f0348298$var$tv ? e = [
        $a42f1354f0348298$var$tv,
        $a42f1354f0348298$var$tv
    ] : -1 !== $a42f1354f0348298$var$J_.indexOf(e[0]) ? e = [
        $a42f1354f0348298$var$tv,
        e[0]
    ] : -1 !== $a42f1354f0348298$var$$_.indexOf(e[0]) && (e = [
        e[0],
        $a42f1354f0348298$var$tv
    ])), 2 !== e.length || -1 === $a42f1354f0348298$var$ev.indexOf(e[0]) || -1 === $a42f1354f0348298$var$ev.indexOf(e[1]) ? ($a42f1354f0348298$var$X_(`Unparsable position ${e}`), null) : t || e[0] !== $a42f1354f0348298$var$tv || e[1] !== $a42f1354f0348298$var$tv ? (i && !$a42f1354f0348298$var$av(e) && (e = [
        e[1],
        e[0]
    ]), e[1] === $a42f1354f0348298$var$tv && -1 !== $a42f1354f0348298$var$J_.indexOf(e[0]) && (e = [
        $a42f1354f0348298$var$tv,
        e[0]
    ]), e[0] === $a42f1354f0348298$var$tv && -1 !== $a42f1354f0348298$var$$_.indexOf(e[1]) && (e = [
        e[1],
        $a42f1354f0348298$var$tv
    ]), e) : ($a42f1354f0348298$var$X_("Invalid position center center"), null)) : null;
}
function $a42f1354f0348298$var$av(e) {
    return -1 !== $a42f1354f0348298$var$$_.indexOf(e[0]) && -1 !== $a42f1354f0348298$var$J_.indexOf(e[1]);
}
function $a42f1354f0348298$var$rv(e) {
    let t;
    if ("string" == typeof e) {
        const i = e.toString().trim();
        let n = parseFloat(i.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
        const a = i.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();
        switch(a.match(/(pm|per minute)$/) && (n /= 60), a){
            case "dpm":
            case "degrees per minute":
            case "dps":
            case "degrees per second":
                t = $a42f1354f0348298$var$lu.degToRad(n);
                break;
            case "rdpm":
            case "radians per minute":
            case "rdps":
            case "radians per second":
                t = n;
                break;
            case "rpm":
            case "revolutions per minute":
            case "rps":
            case "revolutions per second":
                t = n * Math.PI * 2;
                break;
            default:
                throw new $a42f1354f0348298$var$V_(`Unknown speed unit "${a}"`);
        }
    } else t = e;
    return t;
}
function $a42f1354f0348298$var$sv(e, t) {
    if ("number" != typeof e) {
        const i = $a42f1354f0348298$var$rv(e);
        return t / Math.abs(i) * 1e3;
    }
    return Math.abs(e);
}
function $a42f1354f0348298$var$ov(e, t = !1, i = t) {
    let n;
    if ("string" == typeof e) {
        const t = e.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);
        if (!t) throw new $a42f1354f0348298$var$V_(`Unknown angle "${e}"`);
        const i = parseFloat(t[1]), a = t[2];
        if (a) switch(a){
            case "deg":
            case "degs":
                n = $a42f1354f0348298$var$lu.degToRad(i);
                break;
            case "rad":
            case "rads":
                n = i;
                break;
            default:
                throw new $a42f1354f0348298$var$V_(`Unknown angle unit "${a}"`);
        }
        else n = i;
    } else {
        if ("number" != typeof e || isNaN(e)) throw new $a42f1354f0348298$var$V_(`Unknown angle "${e}"`);
        n = e;
    }
    return n = $a42f1354f0348298$var$u_(t ? n + Math.PI : n, 2 * Math.PI), t ? $a42f1354f0348298$var$lu.clamp(n - Math.PI, -Math.PI / (i ? 2 : 1), Math.PI / (i ? 2 : 1)) : n;
}
function $a42f1354f0348298$var$lv(e, t) {
    const i = function(i) {
        const n = $a42f1354f0348298$var$U_({
            ...e,
            ...i
        }), a = {};
        for (let [i, r] of Object.entries(n)){
            if (t && i in t) r = t[i](r, {
                rawConfig: n,
                defValue: e[i]
            });
            else if (!(i in e)) {
                $a42f1354f0348298$var$X_(`Unknown option ${i}`);
                continue;
            }
            a[i] = r;
        }
        return a;
    };
    return i.defaults = e, i.parsers = t || {}, i;
}
function $a42f1354f0348298$var$cv(e, t) {
    "true" !== $a42f1354f0348298$var$S_(e, `--psv-${t}-loaded`) && console.error(`PhotoSphereViewer: stylesheet "@photo-sphere-viewer/${t}/index.css" is not loaded`);
}
function $a42f1354f0348298$var$dv(e, t, i) {
    t && t !== i && console.error(`PhotoSphereViewer: @photo-sphere-viewer/${e} is in version ${t} but @photo-sphere-viewer/core is in version ${i}`);
}
function $a42f1354f0348298$var$uv(e) {
    do {
        if (e instanceof ShadowRoot && "closed" === e.mode) return void console.error("PhotoSphereViewer: closed shadow DOM detected, the viewer might not work as expected");
        e = e.parentNode;
    }while (e);
}
function $a42f1354f0348298$var$hv(e, t, i, n) {
    const a = {
        isEquirectangular: !0,
        fullWidth: $a42f1354f0348298$var$O_(i?.fullWidth, n?.fullWidth),
        fullHeight: $a42f1354f0348298$var$O_(i?.fullHeight, n?.fullHeight),
        croppedWidth: $a42f1354f0348298$var$O_(i?.croppedWidth, n?.croppedWidth, e),
        croppedHeight: $a42f1354f0348298$var$O_(i?.croppedHeight, n?.croppedHeight, t),
        croppedX: $a42f1354f0348298$var$O_(i?.croppedX, n?.croppedX),
        croppedY: $a42f1354f0348298$var$O_(i?.croppedY, n?.croppedY),
        poseHeading: $a42f1354f0348298$var$O_(i?.poseHeading, n?.poseHeading, 0),
        posePitch: $a42f1354f0348298$var$O_(i?.posePitch, n?.posePitch, 0),
        poseRoll: $a42f1354f0348298$var$O_(i?.poseRoll, n?.poseRoll, 0),
        initialHeading: n?.initialHeading,
        initialPitch: n?.initialPitch,
        initialFov: n?.initialFov
    };
    if (a.croppedWidth !== e) {
        const t = e / a.croppedWidth;
        [
            "fullWidth",
            "fullHeight",
            "croppedWidth",
            "croppedHeight",
            "croppedX",
            "croppedY"
        ].forEach((e)=>{
            a[e] && (a[e] = Math.round(a[e] * t));
        });
    }
    return a.fullWidth || a.fullHeight || (a.fullWidth = Math.max(a.croppedWidth, 2 * a.croppedHeight), a.fullHeight = Math.round(a.fullWidth / 2)), a.fullWidth || (a.fullWidth = 2 * a.fullHeight), a.fullHeight || (a.fullHeight = Math.round(a.fullWidth / 2)), null === a.croppedX && (a.croppedX = Math.round((a.fullWidth - e) / 2)), null === a.croppedY && (a.croppedY = Math.round((a.fullHeight - t) / 2)), Math.abs(a.fullWidth - 2 * a.fullHeight) > 1 && ($a42f1354f0348298$var$X_("Invalid panoData, fullWidth should be twice fullHeight"), a.fullHeight = Math.round(a.fullWidth / 2)), a.croppedX + a.croppedWidth > a.fullWidth && ($a42f1354f0348298$var$X_("Invalid panoData, croppedX + croppedWidth > fullWidth"), a.croppedX = a.fullWidth - a.croppedWidth), a.croppedY + a.croppedHeight > a.fullHeight && ($a42f1354f0348298$var$X_("Invalid panoData, croppedY + croppedHeight > fullHeight"), a.croppedY = a.fullHeight - a.croppedHeight), a.croppedX < 0 && ($a42f1354f0348298$var$X_("Invalid panoData, croppedX < 0"), a.croppedX = 0), a.croppedY < 0 && ($a42f1354f0348298$var$X_("Invalid panoData, croppedY < 0"), a.croppedY = 0), a;
}
var $a42f1354f0348298$var$pv = `${$a42f1354f0348298$var$n_}_touchSupport`, $a42f1354f0348298$var$Av = {
    loaded: !1,
    pixelRatio: 1,
    isWebGLSupported: !1,
    maxTextureWidth: 0,
    isTouchEnabled: null,
    __maxCanvasWidth: null,
    isIphone: !1,
    get maxCanvasWidth () {
        return null === this.__maxCanvasWidth && (this.__maxCanvasWidth = function(e) {
            let t = e, i = !1;
            const n = document.createElement("canvas"), a = n.getContext("2d");
            n.width = 1, n.height = 1;
            for(; t > 1024 && !i;){
                const e = document.createElement("canvas"), n = e.getContext("2d");
                e.width = t, e.height = t / 2;
                try {
                    n.fillStyle = "white", n.fillRect(t - 1, t / 2 - 1, 1, 1), a.drawImage(e, t - 1, t / 2 - 1, 1, 1, 0, 0, 1, 1), a.getImageData(0, 0, 1, 1).data[0] > 0 && (i = !0);
                } catch  {}
                e.width = 0, e.height = 0, i || (t /= 2);
            }
            if (i) return t;
            throw new $a42f1354f0348298$var$V_("Unable to detect system capabilities");
        }(this.maxTextureWidth)), this.__maxCanvasWidth;
    },
    load () {
        if (!this.loaded) {
            const e = function() {
                try {
                    return document.createElement("canvas").getContext("webgl2");
                } catch  {
                    return null;
                }
            }();
            this.pixelRatio = window.devicePixelRatio || 1, this.isWebGLSupported = !!e, this.maxTextureWidth = e ? e.getParameter(e.MAX_TEXTURE_SIZE) : 0, this.isTouchEnabled = function() {
                let e = "ontouchstart" in window || navigator.maxTouchPoints > 0;
                $a42f1354f0348298$var$pv in localStorage && (e = "true" === localStorage[$a42f1354f0348298$var$pv]);
                const t = new Promise((t)=>{
                    const i = ()=>{
                        window.removeEventListener("mousedown", n), window.removeEventListener("touchstart", a), clearTimeout(s);
                    }, n = ()=>{
                        i(), localStorage[$a42f1354f0348298$var$pv] = !1, t(!1);
                    }, a = ()=>{
                        i(), localStorage[$a42f1354f0348298$var$pv] = !0, t(!0);
                    }, r = ()=>{
                        i(), localStorage[$a42f1354f0348298$var$pv] = e, t(e);
                    };
                    window.addEventListener("mousedown", n, !1), window.addEventListener("touchstart", a, !1);
                    const s = setTimeout(r, 1e4);
                });
                return {
                    initial: e,
                    promise: t
                };
            }(), this.isIphone = /iPhone/i.test(navigator.userAgent), this.loaded = !0;
        }
        if (!$a42f1354f0348298$var$Av.isWebGLSupported) throw new $a42f1354f0348298$var$V_("WebGL 2 is not supported.");
        if (0 === $a42f1354f0348298$var$Av.maxTextureWidth) throw new $a42f1354f0348298$var$V_("Unable to detect system capabilities");
    }
};
function $a42f1354f0348298$var$mv(e, t = !1) {
    const i = new $a42f1354f0348298$var$Tu(e);
    return i.needsUpdate = !0, i.minFilter = t ? $a42f1354f0348298$var$bc : $a42f1354f0348298$var$Ec, i.generateMipmaps = t, i.anisotropy = t ? 2 : 1, i;
}
function $a42f1354f0348298$var$gv(e, t) {
    if (t || e.width > $a42f1354f0348298$var$Av.maxTextureWidth) {
        const i = Math.min(1, $a42f1354f0348298$var$Av.maxCanvasWidth / e.width), n = new OffscreenCanvas(Math.floor(e.width * i), Math.floor(e.height * i)), a = n.getContext("2d");
        return t && (a.filter = `blur(${n.width / t.factor}px)`), a.drawImage(e, 0, 0, n.width, n.height), $a42f1354f0348298$var$mv(n);
    }
    return $a42f1354f0348298$var$mv(e);
}
var $a42f1354f0348298$var$fv = new $a42f1354f0348298$var$du;
function $a42f1354f0348298$var$_v(e, t) {
    $a42f1354f0348298$var$fv.setFromEuler(t).invert(), e.applyQuaternion($a42f1354f0348298$var$fv);
}
var $a42f1354f0348298$var$vv = class {
    constructor(e){
        this.easing = $a42f1354f0348298$var$c_.linear, this.callbacks = [], this.resolved = !1, this.cancelled = !1, this.options = e, e ? (e.easing && (this.easing = "function" == typeof e.easing ? e.easing : $a42f1354f0348298$var$c_[e.easing] || $a42f1354f0348298$var$c_.linear), this.delayTimeout = setTimeout(()=>{
            this.delayTimeout = void 0, this.animationFrame = window.requestAnimationFrame((e)=>this.__run(e));
        }, e.delay || 0)) : this.resolved = !0;
    }
    __run(e) {
        if (this.cancelled) return;
        this.start || (this.start = e);
        const t = (e - this.start) / this.options.duration, i = {};
        if (t < 1) {
            for (const [e, n] of Object.entries(this.options.properties))if (n) {
                const a = n.start + (n.end - n.start) * this.easing(t);
                i[e] = a;
            }
            this.options.onTick(i, t), this.animationFrame = window.requestAnimationFrame((e)=>this.__run(e));
        } else {
            for (const [e, t] of Object.entries(this.options.properties))t && (i[e] = t.end);
            this.options.onTick(i, 1), this.__resolve(!0), this.animationFrame = void 0;
        }
    }
    __resolve(e) {
        e ? this.resolved = !0 : this.cancelled = !0, this.callbacks.forEach((t)=>t(e)), this.callbacks.length = 0;
    }
    then(e) {
        return this.resolved || this.cancelled ? Promise.resolve(this.resolved).then(e) : new Promise((e)=>{
            this.callbacks.push(e);
        }).then(e);
    }
    cancel() {
        this.cancelled || this.resolved || (this.__resolve(!1), this.delayTimeout && (window.clearTimeout(this.delayTimeout), this.delayTimeout = void 0), this.animationFrame && (window.cancelAnimationFrame(this.animationFrame), this.animationFrame = void 0));
    }
}, $a42f1354f0348298$var$Ev = class {
    constructor(e, t){
        if (this.fn = e, this.mode = 0, this.speed = 0, this.speedMult = 0, this.currentSpeed = 0, this.target = 0, this.__current = 0, this.min = t.min, this.max = t.max, this.wrap = t.wrap, this.current = t.defaultValue, this.wrap && 0 !== this.min) throw new $a42f1354f0348298$var$V_("invalid config");
        this.fn && this.fn(this.current);
    }
    get current() {
        return this.__current;
    }
    set current(e) {
        this.__current = e;
    }
    setSpeed(e) {
        this.speed = e;
    }
    goto(e, t = 1) {
        this.mode = 2, this.target = this.wrap ? $a42f1354f0348298$var$u_(e, this.max) : $a42f1354f0348298$var$lu.clamp(e, this.min, this.max), this.speedMult = t;
    }
    step(e, t = 1) {
        0 === t ? this.setValue(this.current + e) : (2 !== this.mode && (this.target = this.current), this.goto(this.target + e, t));
    }
    roll(e = !1, t = 1) {
        this.mode = 1, this.target = e ? -1 / 0 : 1 / 0, this.speedMult = t;
    }
    stop() {
        this.mode = 0;
    }
    setValue(e) {
        return this.target = this.wrap ? $a42f1354f0348298$var$u_(e, this.max) : $a42f1354f0348298$var$lu.clamp(e, this.min, this.max), this.mode = 0, this.currentSpeed = 0, this.target !== this.current && (this.current = this.target, this.fn && this.fn(this.current), !0);
    }
    update(e) {
        if (2 === this.mode) {
            this.wrap && Math.abs(this.target - this.current) > this.max / 2 && (this.current = this.current < this.target ? this.current + this.max : this.current - this.max);
            const e = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);
            Math.abs(this.target - this.current) <= e && (this.mode = 0);
        }
        let t = 0 === this.mode ? 0 : this.speed * this.speedMult;
        this.target < this.current && (t = -t), this.currentSpeed < t ? this.currentSpeed = Math.min(t, this.currentSpeed + e / 1e3 * this.speed * this.speedMult * 2) : this.currentSpeed > t && (this.currentSpeed = Math.max(t, this.currentSpeed - e / 1e3 * this.speed * this.speedMult * 2));
        let i = null;
        return this.current > this.target && this.currentSpeed ? i = Math.max(this.target, this.current + this.currentSpeed * e / 1e3) : this.current < this.target && this.currentSpeed && (i = Math.min(this.target, this.current + this.currentSpeed * e / 1e3)), null !== i && (i = this.wrap ? $a42f1354f0348298$var$u_(i, this.max) : $a42f1354f0348298$var$lu.clamp(i, this.min, this.max), i !== this.current) && (this.current = i, this.fn && this.fn(this.current), !0);
    }
}, $a42f1354f0348298$var$yv = class {
    constructor(e, t){
        this.fn = e, this.dynamics = t, this.fn && this.fn(this.current);
    }
    get current() {
        return Object.entries(this.dynamics).reduce((e, [t, i])=>(e[t] = i.current, e), {});
    }
    setSpeed(e) {
        for (const t of Object.values(this.dynamics))t.setSpeed(e);
    }
    goto(e, t = 1) {
        for (const [i, n] of Object.entries(e))this.dynamics[i].goto(n, t);
    }
    step(e, t = 1) {
        if (0 === t) this.setValue(Object.keys(e).reduce((t, i)=>(t[i] = e[i] + this.dynamics[i].current, t), {}));
        else for (const [i, n] of Object.entries(e))this.dynamics[i].step(n, t);
    }
    roll(e, t = 1) {
        for (const [i, n] of Object.entries(e))this.dynamics[i].roll(n, t);
    }
    stop() {
        for (const e of Object.values(this.dynamics))e.stop();
    }
    setValue(e) {
        let t = !1;
        for (const [i, n] of Object.entries(e))t = this.dynamics[i].setValue(n) || t;
        return t && this.fn && this.fn(this.current), t;
    }
    update(e) {
        let t = !1;
        for (const i of Object.values(this.dynamics))t = i.update(e) || t;
        return t && this.fn && this.fn(this.current), t;
    }
}, $a42f1354f0348298$var$bv = class {
    constructor(e = 200){
        this.delay = e, this.time = 0, this.delay = e;
    }
    get pending() {
        return 0 !== this.time;
    }
    down(e) {
        this.timeout && (clearTimeout(this.timeout), this.timeout = void 0), this.time = (new Date).getTime(), this.data = e;
    }
    up(e) {
        if (!this.time) return;
        Date.now() - this.time < this.delay ? this.timeout = setTimeout(()=>{
            e(this.data), this.timeout = void 0, this.time = 0, this.data = void 0;
        }, this.delay) : (e(this.data), this.time = 0, this.data = void 0);
    }
}, $a42f1354f0348298$var$kv = ((e)=>(e.VERTICAL = "VERTICAL", e.HORIZONTAL = "HORIZONTAL", e))($a42f1354f0348298$var$kv || {}), $a42f1354f0348298$var$xv = class {
    constructor(e, t, i){
        this.container = e, this.direction = t, this.listener = i, this.mousedown = !1, this.mouseover = !1, this.container.addEventListener("click", this), this.container.addEventListener("mousedown", this), this.container.addEventListener("mouseenter", this), this.container.addEventListener("mouseleave", this), this.container.addEventListener("touchstart", this), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("touchmove", this, !0), window.addEventListener("mouseup", this), window.addEventListener("touchend", this);
    }
    get isVertical() {
        return "VERTICAL" === this.direction;
    }
    get isHorizontal() {
        return "HORIZONTAL" === this.direction;
    }
    destroy() {
        window.removeEventListener("mouseup", this), window.removeEventListener("touchend", this);
    }
    handleEvent(e) {
        switch(e.type){
            case "click":
                e.stopPropagation();
                break;
            case "mousedown":
                this.__onMouseDown(e);
                break;
            case "mouseenter":
                this.__onMouseEnter(e);
                break;
            case "mouseleave":
                this.__onMouseLeave(e);
                break;
            case "touchstart":
                this.__onTouchStart(e);
                break;
            case "mousemove":
                this.__onMouseMove(e);
                break;
            case "touchmove":
                this.__onTouchMove(e);
                break;
            case "mouseup":
                this.__onMouseUp(e);
                break;
            case "touchend":
                this.__onTouchEnd(e);
        }
    }
    __onMouseDown(e) {
        this.mousedown = !0, this.__update(e.clientX, e.clientY, !0);
    }
    __onMouseEnter(e) {
        this.mouseover = !0, this.__update(e.clientX, e.clientY, !0);
    }
    __onTouchStart(e) {
        this.mouseover = !0, this.mousedown = !0;
        const t = e.changedTouches[0];
        this.__update(t.clientX, t.clientY, !0);
    }
    __onMouseMove(e) {
        (this.mousedown || this.mouseover) && (e.stopPropagation(), this.__update(e.clientX, e.clientY, !0));
    }
    __onTouchMove(e) {
        if (this.mousedown || this.mouseover) {
            e.stopPropagation();
            const t = e.changedTouches[0];
            this.__update(t.clientX, t.clientY, !0);
        }
    }
    __onMouseUp(e) {
        this.mousedown && (this.mousedown = !1, this.__update(e.clientX, e.clientY, !1));
    }
    __onMouseLeave(e) {
        this.mouseover && (this.mouseover = !1, this.__update(e.clientX, e.clientY, !0));
    }
    __onTouchEnd(e) {
        if (this.mousedown) {
            this.mouseover = !1, this.mousedown = !1;
            const t = e.changedTouches[0];
            this.__update(t.clientX, t.clientY, !1);
        }
    }
    __update(e, t, i) {
        const n = this.container.getBoundingClientRect();
        let a;
        a = this.isVertical ? $a42f1354f0348298$var$lu.clamp((n.bottom - t) / n.height, 0, 1) : $a42f1354f0348298$var$lu.clamp((e - n.left) / n.width, 0, 1), this.listener({
            value: a,
            click: !i,
            mousedown: this.mousedown,
            mouseover: this.mouseover,
            cursor: {
                clientX: e,
                clientY: t
            }
        });
    }
}, $a42f1354f0348298$var$wv = {};
$a42f1354f0348298$var$Wf($a42f1354f0348298$var$wv, {
    BeforeAnimateEvent: ()=>$a42f1354f0348298$var$Dv,
    BeforeRenderEvent: ()=>$a42f1354f0348298$var$Iv,
    BeforeRotateEvent: ()=>$a42f1354f0348298$var$Rv,
    ClickEvent: ()=>$a42f1354f0348298$var$Fv,
    ConfigChangedEvent: ()=>$a42f1354f0348298$var$Nv,
    DoubleClickEvent: ()=>$a42f1354f0348298$var$Ov,
    FullscreenEvent: ()=>$a42f1354f0348298$var$Gv,
    HideNotificationEvent: ()=>$a42f1354f0348298$var$Hv,
    HideOverlayEvent: ()=>$a42f1354f0348298$var$Kv,
    HidePanelEvent: ()=>$a42f1354f0348298$var$Xv,
    HideTooltipEvent: ()=>$a42f1354f0348298$var$Zv,
    KeypressEvent: ()=>$a42f1354f0348298$var$Jv,
    LoadProgressEvent: ()=>$a42f1354f0348298$var$eE,
    ObjectEnterEvent: ()=>$a42f1354f0348298$var$LE,
    ObjectEvent: ()=>$a42f1354f0348298$var$PE,
    ObjectHoverEvent: ()=>$a42f1354f0348298$var$UE,
    ObjectLeaveEvent: ()=>$a42f1354f0348298$var$zE,
    PanoramaErrorEvent: ()=>$a42f1354f0348298$var$sE,
    PanoramaLoadEvent: ()=>$a42f1354f0348298$var$iE,
    PanoramaLoadedEvent: ()=>$a42f1354f0348298$var$aE,
    PositionUpdatedEvent: ()=>$a42f1354f0348298$var$dE,
    ReadyEvent: ()=>$a42f1354f0348298$var$AE,
    RenderEvent: ()=>$a42f1354f0348298$var$gE,
    RollUpdatedEvent: ()=>$a42f1354f0348298$var$hE,
    ShowNotificationEvent: ()=>$a42f1354f0348298$var$_E,
    ShowOverlayEvent: ()=>$a42f1354f0348298$var$EE,
    ShowPanelEvent: ()=>$a42f1354f0348298$var$bE,
    ShowTooltipEvent: ()=>$a42f1354f0348298$var$xE,
    SizeUpdatedEvent: ()=>$a42f1354f0348298$var$ME,
    StopAllEvent: ()=>$a42f1354f0348298$var$CE,
    TransitionDoneEvent: ()=>$a42f1354f0348298$var$lE,
    ViewerEvent: ()=>$a42f1354f0348298$var$Cv,
    ZoomUpdatedEvent: ()=>$a42f1354f0348298$var$DE
});
var $a42f1354f0348298$var$Mv = class extends Event {
    constructor(e, t = !1){
        super(e, {
            cancelable: t
        });
    }
}, $a42f1354f0348298$var$Sv = class extends EventTarget {
    dispatchEvent(e) {
        return super.dispatchEvent(e);
    }
    addEventListener(e, t, i) {
        super.addEventListener(e, t, i);
    }
    removeEventListener(e, t, i) {
        super.removeEventListener(e, t, i);
    }
}, $a42f1354f0348298$var$Cv = class extends $a42f1354f0348298$var$Mv {
}, $a42f1354f0348298$var$Tv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t, i){
        super(e.type, !0), this.position = t, this.zoomLevel = i;
    }
};
$a42f1354f0348298$var$Tv.type = "before-animate";
var $a42f1354f0348298$var$Dv = $a42f1354f0348298$var$Tv, $a42f1354f0348298$var$Pv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t, i){
        super(e.type), this.timestamp = t, this.elapsed = i;
    }
};
$a42f1354f0348298$var$Pv.type = "before-render";
var $a42f1354f0348298$var$Iv = $a42f1354f0348298$var$Pv, $a42f1354f0348298$var$Lv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type, !0), this.position = t;
    }
};
$a42f1354f0348298$var$Lv.type = "before-rotate";
var $a42f1354f0348298$var$Rv = $a42f1354f0348298$var$Lv, $a42f1354f0348298$var$zv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.data = t;
    }
};
$a42f1354f0348298$var$zv.type = "click";
var $a42f1354f0348298$var$Fv = $a42f1354f0348298$var$zv, $a42f1354f0348298$var$Uv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.options = t;
    }
    containsOptions(...e) {
        return e.some((e)=>this.options.includes(e));
    }
};
$a42f1354f0348298$var$Uv.type = "config-changed";
var $a42f1354f0348298$var$Nv = $a42f1354f0348298$var$Uv, $a42f1354f0348298$var$Bv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.data = t;
    }
};
$a42f1354f0348298$var$Bv.type = "dblclick";
var $a42f1354f0348298$var$Ov = $a42f1354f0348298$var$Bv, $a42f1354f0348298$var$jv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.fullscreenEnabled = t;
    }
};
$a42f1354f0348298$var$jv.type = "fullscreen";
var $a42f1354f0348298$var$Gv = $a42f1354f0348298$var$jv, $a42f1354f0348298$var$Vv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.notificationId = t;
    }
};
$a42f1354f0348298$var$Vv.type = "hide-notification";
var $a42f1354f0348298$var$Hv = $a42f1354f0348298$var$Vv, $a42f1354f0348298$var$qv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.overlayId = t;
    }
};
$a42f1354f0348298$var$qv.type = "hide-overlay";
var $a42f1354f0348298$var$Kv = $a42f1354f0348298$var$qv, $a42f1354f0348298$var$Wv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.panelId = t;
    }
};
$a42f1354f0348298$var$Wv.type = "hide-panel";
var $a42f1354f0348298$var$Xv = $a42f1354f0348298$var$Wv, $a42f1354f0348298$var$Qv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.tooltipData = t;
    }
};
$a42f1354f0348298$var$Qv.type = "hide-tooltip";
var $a42f1354f0348298$var$Zv = $a42f1354f0348298$var$Qv, $a42f1354f0348298$var$Yv = class e extends $a42f1354f0348298$var$Cv {
    constructor(t, i){
        super(e.type, !0), this.key = t, this.originalEvent = i;
    }
    matches(e) {
        return $a42f1354f0348298$var$I_(this.originalEvent, e);
    }
};
$a42f1354f0348298$var$Yv.type = "key-press";
var $a42f1354f0348298$var$Jv = $a42f1354f0348298$var$Yv, $a42f1354f0348298$var$$v = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.progress = t;
    }
};
$a42f1354f0348298$var$$v.type = "load-progress";
var $a42f1354f0348298$var$eE = $a42f1354f0348298$var$$v, $a42f1354f0348298$var$tE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.panorama = t;
    }
};
$a42f1354f0348298$var$tE.type = "panorama-load";
var $a42f1354f0348298$var$iE = $a42f1354f0348298$var$tE, $a42f1354f0348298$var$nE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.data = t;
    }
};
$a42f1354f0348298$var$nE.type = "panorama-loaded";
var $a42f1354f0348298$var$aE = $a42f1354f0348298$var$nE, $a42f1354f0348298$var$rE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t, i){
        super(e.type), this.panorama = t, this.error = i;
    }
};
$a42f1354f0348298$var$rE.type = "panorama-error";
var $a42f1354f0348298$var$sE = $a42f1354f0348298$var$rE, $a42f1354f0348298$var$oE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.completed = t;
    }
};
$a42f1354f0348298$var$oE.type = "transition-done";
var $a42f1354f0348298$var$lE = $a42f1354f0348298$var$oE, $a42f1354f0348298$var$cE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.position = t;
    }
};
$a42f1354f0348298$var$cE.type = "position-updated";
var $a42f1354f0348298$var$dE = $a42f1354f0348298$var$cE, $a42f1354f0348298$var$uE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.roll = t;
    }
};
$a42f1354f0348298$var$uE.type = "roll-updated";
var $a42f1354f0348298$var$hE = $a42f1354f0348298$var$uE, $a42f1354f0348298$var$pE = class e extends $a42f1354f0348298$var$Cv {
    constructor(){
        super(e.type);
    }
};
$a42f1354f0348298$var$pE.type = "ready";
var $a42f1354f0348298$var$AE = $a42f1354f0348298$var$pE, $a42f1354f0348298$var$mE = class e extends $a42f1354f0348298$var$Cv {
    constructor(){
        super(e.type);
    }
};
$a42f1354f0348298$var$mE.type = "render";
var $a42f1354f0348298$var$gE = $a42f1354f0348298$var$mE, $a42f1354f0348298$var$fE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.notificationId = t;
    }
};
$a42f1354f0348298$var$fE.type = "show-notification";
var $a42f1354f0348298$var$_E = $a42f1354f0348298$var$fE, $a42f1354f0348298$var$vE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.overlayId = t;
    }
};
$a42f1354f0348298$var$vE.type = "show-overlay";
var $a42f1354f0348298$var$EE = $a42f1354f0348298$var$vE, $a42f1354f0348298$var$yE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.panelId = t;
    }
};
$a42f1354f0348298$var$yE.type = "show-panel";
var $a42f1354f0348298$var$bE = $a42f1354f0348298$var$yE, $a42f1354f0348298$var$kE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t, i){
        super(e.type), this.tooltip = t, this.tooltipData = i;
    }
};
$a42f1354f0348298$var$kE.type = "show-tooltip";
var $a42f1354f0348298$var$xE = $a42f1354f0348298$var$kE, $a42f1354f0348298$var$wE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.size = t;
    }
};
$a42f1354f0348298$var$wE.type = "size-updated";
var $a42f1354f0348298$var$ME = $a42f1354f0348298$var$wE, $a42f1354f0348298$var$SE = class e extends $a42f1354f0348298$var$Cv {
    constructor(){
        super(e.type);
    }
};
$a42f1354f0348298$var$SE.type = "stop-all";
var $a42f1354f0348298$var$CE = $a42f1354f0348298$var$SE, $a42f1354f0348298$var$TE = class e extends $a42f1354f0348298$var$Cv {
    constructor(t){
        super(e.type), this.zoomLevel = t;
    }
};
$a42f1354f0348298$var$TE.type = "zoom-updated";
var $a42f1354f0348298$var$DE = $a42f1354f0348298$var$TE, $a42f1354f0348298$var$PE = class extends $a42f1354f0348298$var$Cv {
    constructor(e, t, i, n, a){
        super(e), this.originalEvent = t, this.object = i, this.viewerPoint = n, this.userDataKey = a;
    }
}, $a42f1354f0348298$var$IE = class e extends $a42f1354f0348298$var$PE {
    constructor(t, i, n, a){
        super(e.type, t, i, n, a);
    }
};
$a42f1354f0348298$var$IE.type = "enter-object";
var $a42f1354f0348298$var$LE = $a42f1354f0348298$var$IE, $a42f1354f0348298$var$RE = class e extends $a42f1354f0348298$var$PE {
    constructor(t, i, n, a){
        super(e.type, t, i, n, a);
    }
};
$a42f1354f0348298$var$RE.type = "leave-object";
var $a42f1354f0348298$var$zE = $a42f1354f0348298$var$RE, $a42f1354f0348298$var$FE = class e extends $a42f1354f0348298$var$PE {
    constructor(t, i, n, a){
        super(e.type, t, i, n, a);
    }
};
$a42f1354f0348298$var$FE.type = "hover-object";
var $a42f1354f0348298$var$UE = $a42f1354f0348298$var$FE, $a42f1354f0348298$var$NE = class {
    constructor(e){
        this.viewer = e;
    }
    init() {}
    destroy() {}
    supportsTransition(e) {
        return !1;
    }
    supportsPreload(e) {
        return !1;
    }
    textureCoordsToSphericalCoords(e, t) {
        throw new $a42f1354f0348298$var$V_("Current adapter does not support texture coordinates.");
    }
    sphericalCoordsToTextureCoords(e, t) {
        throw new $a42f1354f0348298$var$V_("Current adapter does not support texture coordinates.");
    }
};
function $a42f1354f0348298$var$BE(e) {
    if (e) {
        for (const [, t] of [
            [
                "_",
                e
            ],
            ...Object.entries(e)
        ])if (t.prototype instanceof $a42f1354f0348298$var$NE) return $a42f1354f0348298$var$dv(t.id, t.VERSION, "5.15.1"), t;
    }
    return null;
}
$a42f1354f0348298$var$NE.supportsDownload = !1;
var $a42f1354f0348298$var$OE = $a42f1354f0348298$var$lv({
    shader: !1,
    resolution: 64,
    useXmpData: !0
}, {
    resolution: (e)=>{
        if (!e || !$a42f1354f0348298$var$lu.isPowerOfTwo(e)) throw new $a42f1354f0348298$var$V_("EquirectangularAdapter resolution must be power of two.");
        return e;
    }
}), $a42f1354f0348298$var$jE = class e extends $a42f1354f0348298$var$NE {
    static withConfig(t) {
        return [
            e,
            t
        ];
    }
    constructor(e, t){
        super(e), this.config = $a42f1354f0348298$var$OE(t), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2;
    }
    supportsTransition() {
        return !0;
    }
    supportsPreload() {
        return !0;
    }
    textureCoordsToSphericalCoords(e, t) {
        if ($a42f1354f0348298$var$B_(e.textureX) || $a42f1354f0348298$var$B_(e.textureY)) throw new $a42f1354f0348298$var$V_("Texture position is missing 'textureX' or 'textureY'");
        const i = (e.textureX + t.croppedX) / t.fullWidth * Math.PI * 2, n = (e.textureY + t.croppedY) / t.fullHeight * Math.PI;
        return {
            yaw: i >= Math.PI ? i - Math.PI : i + Math.PI,
            pitch: Math.PI / 2 - n
        };
    }
    sphericalCoordsToTextureCoords(e, t) {
        const i = e.yaw / Math.PI / 2 * t.fullWidth, n = e.pitch / Math.PI * t.fullHeight;
        let a = Math.round(e.yaw < Math.PI ? i + t.fullWidth / 2 : i - t.fullWidth / 2) - t.croppedX, r = Math.round(t.fullHeight / 2 - n) - t.croppedY;
        return (a < 0 || a > t.croppedWidth || r < 0 || r > t.croppedHeight) && (a = r = void 0), {
            textureX: a,
            textureY: r
        };
    }
    async loadTexture(e, t = !0, i, n = this.config.useXmpData) {
        if ("string" != typeof e && ("object" != typeof e || !e.path)) return Promise.reject(new $a42f1354f0348298$var$V_("Invalid panorama url, are you using the right adapter?"));
        let a;
        a = "string" == typeof e ? {
            path: e,
            data: i
        } : {
            data: i,
            ...e
        };
        const r = await this.viewer.textureLoader.loadFile(a.path, t ? (e)=>this.viewer.textureLoader.dispatchProgress(e) : null, a.path), s = n ? await this.loadXMP(r) : null, o = await this.viewer.textureLoader.blobToImage(r);
        "function" == typeof a.data && (a.data = a.data(o, s));
        const l = $a42f1354f0348298$var$hv(o.width, o.height, a.data, s);
        return {
            panorama: e,
            texture: $a42f1354f0348298$var$gv(o, a.blur ? {
                factor: 2048
            } : null),
            panoData: l,
            cacheKey: a.path
        };
    }
    async loadXMP(e) {
        const t = await this.loadBlobAsString(e), i = t.indexOf("<x:xmpmeta");
        if (-1 === i) return null;
        const n = t.indexOf("</x:xmpmeta>", i);
        if (-1 === n) return null;
        const a = t.substring(i, n);
        return a.includes("GPano:") ? {
            fullWidth: $a42f1354f0348298$var$Z_(a, "FullPanoWidthPixels"),
            fullHeight: $a42f1354f0348298$var$Z_(a, "FullPanoHeightPixels"),
            croppedWidth: $a42f1354f0348298$var$Z_(a, "CroppedAreaImageWidthPixels"),
            croppedHeight: $a42f1354f0348298$var$Z_(a, "CroppedAreaImageHeightPixels"),
            croppedX: $a42f1354f0348298$var$Z_(a, "CroppedAreaLeftPixels"),
            croppedY: $a42f1354f0348298$var$Z_(a, "CroppedAreaTopPixels"),
            poseHeading: $a42f1354f0348298$var$Z_(a, "PoseHeadingDegrees", !1),
            posePitch: $a42f1354f0348298$var$Z_(a, "PosePitchDegrees", !1),
            poseRoll: $a42f1354f0348298$var$Z_(a, "PoseRollDegrees", !1),
            initialHeading: $a42f1354f0348298$var$Z_(a, "InitialViewHeadingDegrees", !1),
            initialPitch: $a42f1354f0348298$var$Z_(a, "InitialViewPitchDegrees", !1),
            initialFov: $a42f1354f0348298$var$Z_(a, "InitialHorizontalFOVDegrees", !1)
        } : null;
    }
    loadBlobAsString(e) {
        return new Promise((t, i)=>{
            const n = new FileReader;
            n.onload = ()=>t(n.result), n.onerror = i, n.readAsText(e);
        });
    }
    createMesh(e) {
        if (this.config.shader) {
            const t = new $a42f1354f0348298$var$hA($a42f1354f0348298$var$i_, 32, 16).scale(-1, 1, 1), i = {
                map: {
                    value: null
                },
                opacity: {
                    value: 1
                },
                radius: {
                    value: $a42f1354f0348298$var$i_
                },
                uvOffset: {
                    value: new $a42f1354f0348298$var$cu(e.croppedX / e.fullWidth, (e.fullHeight - e.croppedY - e.croppedHeight) / e.fullHeight)
                },
                uvScale: {
                    value: new $a42f1354f0348298$var$cu(e.croppedWidth / e.fullWidth, e.croppedHeight / e.fullHeight)
                }
            }, n = new $a42f1354f0348298$var$EA({
                uniforms: i,
                vertexShader: "// Ray-cast inputs in the panorama's local frame, so sphereCorrection and pose\n// (both folded into modelMatrix) apply to the sampled direction without\n// per-fragment work.\nvarying vec3 vLocalPos;\nvarying vec3 vLocalCam;\n\nvoid main() {\n    vLocalPos = position;\n\n    // mat3(modelMatrix) is a pure rotation, so its inverse is its transpose:\n    // `cameraPosition * M == transpose(M) * cameraPosition`.\n    vLocalCam = cameraPosition * mat3(modelMatrix);\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n",
                fragmentShader: "varying vec3 vLocalPos;\nvarying vec3 vLocalCam;\nuniform sampler2D map;\nuniform float opacity;\nuniform vec2 uvOffset;\nuniform vec2 uvScale;\nuniform float radius;\n\nconst float PI = 3.1415926535897932384626433832795;\n\n// Analytic edge antialiasing across one screen-space pixel at the\n// cropped-region boundary on a single axis (replaces the MSAA the standard\n// adapter gets by rendering triangles).\nfloat edgeAlpha(float coord, float width) {\n    float dist = min(coord, 1.0 - coord);\n    return clamp(dist / width + 0.5, 0.0, 1.0);\n}\n\n// Screen-space derivative (fwidth) of a coordinate that wraps in [0, 1], such\n// as longitude at the antimeridian. A naive fwidth() spikes to ~1.0 across the\n// seam. Removing the integer jump keeps the result sub-pixel. Assumes the\n// per-pixel change stays well under 0.5, so only the wrap rounds to a non-zero\n// integer (safe unless a pixel spans ~180deg of longitude).\nfloat fwidthWrapped(float coord) {\n    float dx = dFdx(coord); dx -= floor(dx + 0.5);\n    float dy = dFdy(coord); dy -= floor(dy + 0.5);\n    return abs(dx) + abs(dy);\n}\n\nvoid main() {\n    // Ray-cast the true sphere from the camera through the (interpolated, on\n    // the polygon chord) position, and use the exit-point direction for\n    // sampling. This makes the result independent of mesh tessellation even\n    // when the camera is offset from the sphere center (e.g. fisheye config).\n    // Inputs are already in the panorama's local frame (see vertex shader), so\n    // the exit direction is too and needs no further rotation.\n    vec3 rayDir = vLocalPos - vLocalCam;\n    float a = dot(rayDir, rayDir);\n    float b = dot(vLocalCam, rayDir);\n    float c = dot(vLocalCam, vLocalCam) - radius * radius;\n    float t = (-b + sqrt(max(b * b - a * c, 0.0))) / a;\n    vec3 dir = (vLocalCam + t * rayDir) / radius;\n\n    float u = atan(-dir.x, dir.z) / (2.0 * PI) + 0.5;\n    float v = asin(clamp(dir.y, -1.0, 1.0)) / PI + 0.5;\n    vec2 uv = (vec2(u, v) - uvOffset) / uvScale;\n\n    float alpha = 1.0;\n    // `u` wraps at the antimeridian, so derive its width safely.\n    if (uvScale.x < 1.0) alpha = min(alpha, edgeAlpha(uv.x, fwidthWrapped(u) / uvScale.x));\n    if (uvScale.y < 1.0) alpha = min(alpha, edgeAlpha(uv.y, fwidth(uv.y)));\n    if (alpha <= 0.0) discard;\n\n    gl_FragColor = texture2D(map, uv);\n    gl_FragColor.a *= opacity * alpha;\n}\n",
                depthTest: !1,
                depthWrite: !1,
                transparent: !0
            });
            return new $a42f1354f0348298$var$zp(t, n);
        }
        {
            const t = e.croppedX / e.fullWidth * 2 * Math.PI, i = e.croppedWidth / e.fullWidth * 2 * Math.PI, n = e.croppedY / e.fullHeight * Math.PI, a = e.croppedHeight / e.fullHeight * Math.PI, r = new $a42f1354f0348298$var$hA($a42f1354f0348298$var$i_, Math.round(this.SPHERE_SEGMENTS / (2 * Math.PI) * i), Math.round(this.SPHERE_HORIZONTAL_SEGMENTS / Math.PI * a), -Math.PI / 2 + t, i, n, a).scale(-1, 1, 1), s = new $a42f1354f0348298$var$kp({
                depthTest: !1,
                depthWrite: !1
            });
            return new $a42f1354f0348298$var$zp(r, s);
        }
    }
    setTexture(e, t) {
        this.config.shader ? e.material.uniforms.map.value = t.texture : e.material.map = t.texture;
    }
    setTextureOpacity(e, t) {
        this.config.shader ? e.material.uniforms.opacity.value = t : (e.material.opacity = t, e.material.transparent = t < 1);
    }
    disposeTexture({ texture: e }) {
        e.dispose();
    }
    disposeMesh(e) {
        e.geometry.dispose(), e.material.dispose();
    }
};
$a42f1354f0348298$var$jE.id = "equirectangular", $a42f1354f0348298$var$jE.VERSION = "5.15.1", $a42f1354f0348298$var$jE.supportsDownload = !0;
var $a42f1354f0348298$var$GE = $a42f1354f0348298$var$jE, $a42f1354f0348298$var$VE = class e extends $a42f1354f0348298$var$GE {
    static withConfig(t) {
        return [
            e,
            t
        ];
    }
    constructor(e, t){
        super(e, {
            resolution: t?.resolution ?? 64,
            useXmpData: !1
        }), $a42f1354f0348298$var$X_('"DualFisheyeAdapter" must be imported from "@photo-sphere-viewer/dual-fisheye-adapter" package');
    }
    async loadTexture(e, t) {
        const i = await super.loadTexture(e, t, null, !1);
        return i.panoData = null, i;
    }
    createMesh() {
        const e = new $a42f1354f0348298$var$hA($a42f1354f0348298$var$i_, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS).scale(-1, 1, 1).toNonIndexed(), t = e.getAttribute("uv"), i = e.getAttribute("normal");
        for(let e = 0; e < t.count; e++)for(let n = 0; n < 3; n++){
            const a = 3 * e + n, r = i.getX(a), s = i.getY(a), o = i.getZ(a), l = .947;
            if (e < t.count / 6) {
                const e = 0 === r && 0 === o ? 1 : Math.acos(s) / Math.sqrt(r * r + o * o) * (2 / Math.PI);
                t.setXY(a, r * (l / 4) * e + 1 / 4, o * (l / 2) * e + .5);
            } else {
                const e = 0 === r && 0 === o ? 1 : Math.acos(-s) / Math.sqrt(r * r + o * o) * (2 / Math.PI);
                t.setXY(a, l / 4 * -r * e + 3 / 4, o * (l / 2) * e + .5);
            }
        }
        e.rotateX(-Math.PI / 2), e.rotateY(Math.PI);
        const n = new $a42f1354f0348298$var$kp({
            depthTest: !1,
            depthWrite: !1
        });
        return new $a42f1354f0348298$var$zp(e, n);
    }
};
$a42f1354f0348298$var$VE.id = "dual-fisheye", $a42f1354f0348298$var$VE.VERSION = "5.15.1";
var $a42f1354f0348298$var$HE = class e {
    constructor(t, i){
        this.parent = t, this.children = [], this.state = {
            visible: !0
        }, this.viewer = t instanceof e ? t.viewer : t, this.container = document.createElement(i.tagName ?? "div"), this.container.className = i.className || "", this.parent.children.push(this), this.parent.container.appendChild(this.container);
    }
    destroy() {
        this.parent.container.removeChild(this.container);
        const e = this.parent.children.indexOf(this);
        -1 !== e && this.parent.children.splice(e, 1), this.children.slice().forEach((e)=>e.destroy()), this.children.length = 0;
    }
    toggle(e = !this.isVisible()) {
        e ? this.show() : this.hide();
    }
    hide(e) {
        this.container.style.display = "none", this.state.visible = !1;
    }
    show(e) {
        this.container.style.display = "", this.state.visible = !0;
    }
    isVisible() {
        return this.state.visible;
    }
}, $a42f1354f0348298$var$qE = $a42f1354f0348298$var$lv({
    id: null,
    tagName: null,
    className: null,
    title: null,
    hoverScale: !1,
    collapsable: !1,
    tabbable: !0,
    icon: null,
    iconActive: null
}), $a42f1354f0348298$var$KE = class extends $a42f1354f0348298$var$HE {
    constructor(e, t){
        super(e, {
            tagName: t.tagName,
            className: `psv-button ${t.hoverScale ? "psv-button--hover-scale" : ""} ${t.className || ""}`
        }), this.state = {
            visible: !0,
            enabled: !0,
            supported: !0,
            collapsed: !1,
            active: !1,
            width: 0
        }, this.config = $a42f1354f0348298$var$qE(t), t.id || (this.config.id = this.constructor.id), t.icon && this.__setIcon(t.icon), this.state.width = this.container.offsetWidth, this.config.title ? this.container.title = this.viewer.config.lang[this.config.title] ?? this.config.title : this.id && this.id in this.viewer.config.lang && (this.container.title = this.viewer.config.lang[this.id]), t.tabbable && (this.container.tabIndex = 0), this.container.addEventListener("click", (e)=>{
            this.state.enabled && this.onClick(), e.stopPropagation();
        }), this.container.addEventListener("keydown", (e)=>{
            e.key === $a42f1354f0348298$var$o_.Enter && this.state.enabled && (this.onClick(), e.stopPropagation());
        });
    }
    get id() {
        return this.config.id;
    }
    get title() {
        return this.container.title;
    }
    get content() {
        return this.container.innerHTML;
    }
    get width() {
        return this.state.width;
    }
    get collapsable() {
        return this.config.collapsable;
    }
    show(e = !0) {
        this.isVisible() || (this.state.visible = !0, this.state.collapsed || (this.container.style.display = ""), e && this.viewer.navbar.autoSize());
    }
    hide(e = !0) {
        this.isVisible() && (this.state.visible = !1, this.container.style.display = "none", e && this.viewer.navbar.autoSize());
    }
    checkSupported() {
        $a42f1354f0348298$var$H_(this.isSupported(), (e, t)=>{
            this.state && (this.state.supported = e, t ? e || this.hide() : this.toggle(e));
        });
    }
    autoSize() {}
    isSupported() {
        return !0;
    }
    toggleActive(e = !this.state.active) {
        e !== this.state.active && (this.state.active = e, $a42f1354f0348298$var$v_(this.container, "psv-button--active", this.state.active), this.config.iconActive && this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon));
    }
    disable() {
        this.container.classList.add("psv-button--disabled"), this.state.enabled = !1;
    }
    enable() {
        this.container.classList.remove("psv-button--disabled"), this.state.enabled = !0;
    }
    collapse() {
        this.state.collapsed = !0, this.container.style.display = "none";
    }
    uncollapse() {
        this.state.collapsed = !1, this.state.visible && (this.container.style.display = "");
    }
    __setIcon(e) {
        this.container.innerHTML = e, $a42f1354f0348298$var$E_(this.container.querySelector("svg"), "psv-button-svg");
    }
}, $a42f1354f0348298$var$WE = class extends $a42f1354f0348298$var$KE {
    constructor(e, t){
        super(e, {
            id: t.id ?? `psvButton-${Math.random().toString(36).substring(2)}`,
            className: `psv-custom-button ${t.className || ""}`,
            hoverScale: !1,
            collapsable: !1 !== t.collapsable,
            tabbable: !1 !== t.tabbable,
            title: t.title
        }), this.customOnClick = t.onClick, t.content && ("string" == typeof t.content ? this.container.innerHTML = t.content : (this.container.classList.add("psv-custom-button--no-padding"), t.content.style.height = "100%", t.content.attachViewer?.(this.viewer), this.container.appendChild(t.content))), this.state.width = this.container.offsetWidth, t.disabled && this.disable(), !1 === t.visible && this.hide();
    }
    onClick() {
        this.customOnClick?.(this.viewer);
    }
}, $a42f1354f0348298$var$XE = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: "psv-description-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $a42f1354f0348298$var$l_.info
        }), this.mode = 0, this.viewer.addEventListener($a42f1354f0348298$var$Hv.type, this), this.viewer.addEventListener($a42f1354f0348298$var$_E.type, this), this.viewer.addEventListener($a42f1354f0348298$var$Xv.type, this), this.viewer.addEventListener($a42f1354f0348298$var$bE.type, this), this.viewer.addEventListener($a42f1354f0348298$var$Nv.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$Hv.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$_E.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$Xv.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$bE.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$Nv.type, this), super.destroy();
    }
    handleEvent(e) {
        if (e instanceof $a42f1354f0348298$var$Nv) return void (e.containsOptions("description") && this.autoSize(!0));
        if (!this.mode) return;
        let t = !1;
        e instanceof $a42f1354f0348298$var$Hv ? t = 1 === this.mode : e instanceof $a42f1354f0348298$var$_E ? t = 1 === this.mode && e.notificationId !== $a42f1354f0348298$var$s_.DESCRIPTION : e instanceof $a42f1354f0348298$var$Xv ? t = 2 === this.mode : e instanceof $a42f1354f0348298$var$bE && (t = 2 === this.mode && e.panelId !== $a42f1354f0348298$var$s_.DESCRIPTION), t && (this.toggleActive(!1), this.mode = 0);
    }
    onClick() {
        this.mode ? this.__close() : this.__open();
    }
    hide(e) {
        super.hide(e), this.mode && this.__close();
    }
    autoSize(e = !1) {
        if (e) {
            const e = this.viewer.navbar.getButton("caption", !1), t = e && !e.isVisible(), i = !!this.viewer.config.description;
            t || i ? this.show(!1) : this.hide(!1);
        }
    }
    __close() {
        switch(this.mode){
            case 1:
                this.viewer.notification.hide($a42f1354f0348298$var$s_.DESCRIPTION);
                break;
            case 2:
                this.viewer.panel.hide($a42f1354f0348298$var$s_.DESCRIPTION);
        }
    }
    __open() {
        this.toggleActive(!0), this.viewer.config.description ? (this.mode = 2, this.viewer.panel.show({
            id: $a42f1354f0348298$var$s_.DESCRIPTION,
            content: `${this.viewer.config.caption ? `<p>${this.viewer.config.caption}</p>` : ""}${this.viewer.config.description}`
        })) : (this.mode = 1, this.viewer.notification.show({
            id: $a42f1354f0348298$var$s_.DESCRIPTION,
            content: this.viewer.config.caption
        }));
    }
};
$a42f1354f0348298$var$XE.id = "description";
var $a42f1354f0348298$var$QE = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            tagName: "a",
            className: "psv-download-button",
            hoverScale: !0,
            collapsable: !0,
            tabbable: !0,
            icon: $a42f1354f0348298$var$l_.download
        }), this.viewer.addEventListener($a42f1354f0348298$var$Nv.type, this), this.viewer.addEventListener($a42f1354f0348298$var$aE.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$Nv.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$aE.type, this), super.destroy();
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$Nv ? (e.containsOptions("downloadUrl") && this.checkSupported(), e.containsOptions("downloadUrl", "downloadName") && this.__update()) : e instanceof $a42f1354f0348298$var$aE && this.__update();
    }
    onClick() {}
    checkSupported() {
        this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl ? this.show() : this.hide();
    }
    __update() {
        const e = this.container;
        e.href = this.viewer.config.downloadUrl || this.viewer.config.panorama, e.target = "_blank", e.href.startsWith("data:") && !this.viewer.config.downloadName ? e.download = "panorama." + e.href.substring(0, e.href.indexOf(";")).split("/").pop() : e.download = this.viewer.config.downloadName || e.href.split("/").pop();
    }
};
$a42f1354f0348298$var$QE.id = "download";
var $a42f1354f0348298$var$ZE = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: "psv-fullscreen-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $a42f1354f0348298$var$l_.fullscreenIn,
            iconActive: $a42f1354f0348298$var$l_.fullscreenOut
        }), this.viewer.addEventListener($a42f1354f0348298$var$Gv.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$Gv.type, this), super.destroy();
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$Gv && this.toggleActive(e.fullscreenEnabled);
    }
    onClick() {
        this.viewer.toggleFullscreen();
    }
};
$a42f1354f0348298$var$ZE.id = "fullscreen";
var $a42f1354f0348298$var$YE = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: "psv-menu-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $a42f1354f0348298$var$l_.menu
        }), this.viewer.addEventListener($a42f1354f0348298$var$bE.type, this), this.viewer.addEventListener($a42f1354f0348298$var$Xv.type, this), super.hide();
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$bE.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$Xv.type, this), super.destroy();
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$bE ? this.toggleActive(e.panelId === $a42f1354f0348298$var$s_.MENU) : e instanceof $a42f1354f0348298$var$Xv && this.toggleActive(!1);
    }
    onClick() {
        this.state.active ? this.__hideMenu() : this.__showMenu();
    }
    hide(e) {
        super.hide(e), this.__hideMenu();
    }
    show(e) {
        super.show(e), this.state.active && this.__showMenu();
    }
    __showMenu() {
        var e, t;
        this.viewer.panel.show({
            id: $a42f1354f0348298$var$s_.MENU,
            content: (e = this.viewer.navbar.collapsed, t = this.viewer.config.lang.menu, `\n<div class="psv-panel-menu psv-panel-menu--stripped">\n  <h1 class="psv-panel-menu-title">${$a42f1354f0348298$var$l_.menu} ${t}</h1>\n  <ul class="psv-panel-menu-list">\n    ${e.map((e)=>`\n    <li data-psv-button="${e.id}" class="psv-panel-menu-item" tabindex="0">\n      <span class="psv-panel-menu-item-icon">${e.content}</span>\n      <span class="psv-panel-menu-item-label">${e.title}</span>\n    </li>\n    `).join("")}\n  </ul>\n</div>\n`),
            noMargin: !0,
            clickHandler: (e)=>{
                const t = e ? $a42f1354f0348298$var$k_(e, ".psv-panel-menu-item") : void 0, i = t ? t.dataset.psvButton : void 0;
                i && (this.viewer.navbar.getButton(i).onClick(), this.__hideMenu());
            }
        });
    }
    __hideMenu() {
        this.viewer.panel.hide($a42f1354f0348298$var$s_.MENU);
    }
};
function $a42f1354f0348298$var$JE(e) {
    let t;
    switch(e){
        case 0:
            t = 90;
            break;
        case 1:
            t = -90;
            break;
        case 3:
            t = 180;
            break;
        default:
            t = 0;
    }
    return $a42f1354f0348298$var$l_.arrow.replace("rotate(0", `rotate(${t}`);
}
$a42f1354f0348298$var$YE.id = "menu";
var $a42f1354f0348298$var$$E = class extends $a42f1354f0348298$var$KE {
    constructor(e, t){
        super(e, {
            className: "psv-move-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $a42f1354f0348298$var$JE(t)
        }), this.direction = t, this.handler = new $a42f1354f0348298$var$bv, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
    }
    destroy() {
        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case "mousedown":
                this.__onMouseDown();
                break;
            case "mouseup":
            case "touchend":
                this.__onMouseUp();
                break;
            case "keydown":
                e.key === $a42f1354f0348298$var$o_.Enter && this.__onMouseDown();
                break;
            case "keyup":
                e.key === $a42f1354f0348298$var$o_.Enter && this.__onMouseUp();
        }
    }
    onClick() {}
    isSupported() {
        return $a42f1354f0348298$var$q_($a42f1354f0348298$var$Av.isTouchEnabled);
    }
    __onMouseDown() {
        if (!this.state.enabled) return;
        const e = {};
        switch(this.direction){
            case 0:
                e.pitch = !1;
                break;
            case 1:
                e.pitch = !0;
                break;
            case 3:
                e.yaw = !1;
                break;
            default:
                e.yaw = !0;
        }
        this.viewer.stopAll(), this.viewer.dynamics.position.roll(e), this.handler.down();
    }
    __onMouseUp() {
        this.state.enabled && this.handler.up(()=>{
            this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer();
        });
    }
};
$a42f1354f0348298$var$$E.groupId = "move";
var $a42f1354f0348298$var$ey = class extends $a42f1354f0348298$var$$E {
    constructor(e){
        super(e, 1);
    }
};
$a42f1354f0348298$var$ey.id = "moveDown";
var $a42f1354f0348298$var$ty = class extends $a42f1354f0348298$var$$E {
    constructor(e){
        super(e, 2);
    }
};
$a42f1354f0348298$var$ty.id = "moveLeft";
var $a42f1354f0348298$var$iy = class extends $a42f1354f0348298$var$$E {
    constructor(e){
        super(e, 3);
    }
};
$a42f1354f0348298$var$iy.id = "moveRight";
var $a42f1354f0348298$var$ny = class extends $a42f1354f0348298$var$$E {
    constructor(e){
        super(e, 0);
    }
};
$a42f1354f0348298$var$ny.id = "moveUp";
var $a42f1354f0348298$var$ay = class extends $a42f1354f0348298$var$KE {
    constructor(e, t, i){
        super(e, {
            className: "psv-zoom-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: t
        }), this.direction = i, this.handler = new $a42f1354f0348298$var$bv, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
    }
    destroy() {
        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case "mousedown":
                this.__onMouseDown();
                break;
            case "mouseup":
            case "touchend":
                this.__onMouseUp();
                break;
            case "keydown":
                e.key === $a42f1354f0348298$var$o_.Enter && this.__onMouseDown();
                break;
            case "keyup":
                e.key === $a42f1354f0348298$var$o_.Enter && this.__onMouseUp();
        }
    }
    onClick() {}
    isSupported() {
        return $a42f1354f0348298$var$q_($a42f1354f0348298$var$Av.isTouchEnabled);
    }
    __onMouseDown() {
        this.state.enabled && (this.viewer.dynamics.zoom.roll(1 === this.direction), this.handler.down());
    }
    __onMouseUp() {
        this.state.enabled && this.handler.up(()=>this.viewer.dynamics.zoom.stop());
    }
};
$a42f1354f0348298$var$ay.groupId = "zoom";
var $a42f1354f0348298$var$ry = class extends $a42f1354f0348298$var$ay {
    constructor(e){
        super(e, $a42f1354f0348298$var$l_.zoomIn, 0);
    }
};
$a42f1354f0348298$var$ry.id = "zoomIn";
var $a42f1354f0348298$var$sy = class extends $a42f1354f0348298$var$ay {
    constructor(e){
        super(e, $a42f1354f0348298$var$l_.zoomOut, 1);
    }
};
$a42f1354f0348298$var$sy.id = "zoomOut";
var $a42f1354f0348298$var$oy = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: "psv-zoom-range",
            hoverScale: !1,
            collapsable: !1,
            tabbable: !1
        }), this.zoomRange = document.createElement("div"), this.zoomRange.className = "psv-zoom-range-line", this.container.appendChild(this.zoomRange), this.zoomValue = document.createElement("div"), this.zoomValue.className = "psv-zoom-range-handle", this.zoomRange.appendChild(this.zoomValue), this.slider = new $a42f1354f0348298$var$xv(this.container, "HORIZONTAL", (e)=>this.__onSliderUpdate(e)), this.mediaMinWidth = parseInt($a42f1354f0348298$var$S_(this.container, "max-width"), 10), this.viewer.addEventListener($a42f1354f0348298$var$DE.type, this), this.viewer.state.ready ? this.__moveZoomValue(this.viewer.getZoomLevel()) : this.viewer.addEventListener($a42f1354f0348298$var$AE.type, this);
    }
    destroy() {
        this.slider.destroy(), this.viewer.removeEventListener($a42f1354f0348298$var$DE.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$AE.type, this), super.destroy();
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$DE ? this.__moveZoomValue(e.zoomLevel) : e instanceof $a42f1354f0348298$var$AE && this.__moveZoomValue(this.viewer.getZoomLevel());
    }
    onClick() {}
    isSupported() {
        return $a42f1354f0348298$var$q_($a42f1354f0348298$var$Av.isTouchEnabled);
    }
    autoSize() {
        this.state.supported && (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible ? this.hide(!1) : this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible && this.show(!1));
    }
    __moveZoomValue(e) {
        this.zoomValue.style.left = e / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
    }
    __onSliderUpdate(e) {
        e.mousedown && this.viewer.zoom(100 * e.value);
    }
};
$a42f1354f0348298$var$oy.id = "zoomRange", $a42f1354f0348298$var$oy.groupId = "zoom";
var $a42f1354f0348298$var$ly = class extends $a42f1354f0348298$var$Sv {
    constructor(e){
        super(), this.viewer = e;
    }
    init() {}
    destroy() {}
}, $a42f1354f0348298$var$cy = class extends $a42f1354f0348298$var$ly {
    constructor(e, t){
        super(e), this.config = this.constructor.configParser(t);
    }
    setOption(e, t) {
        this.setOptions({
            [e]: t
        });
    }
    setOptions(e) {
        const t = {
            ...this.config,
            ...e
        }, i = this.constructor, n = i.configParser, a = i.readonlyOptions, r = i.id;
        for (let [i, s] of Object.entries(e))i in n.defaults ? a.includes(i) ? $a42f1354f0348298$var$X_(`${r}: Option "${i}" cannot be updated`) : (i in n.parsers && (s = n.parsers[i](s, {
            rawConfig: t,
            defValue: n.defaults[i]
        })), this.config[i] = s) : $a42f1354f0348298$var$X_(`${r}: Unknown option "${i}"`);
    }
};
function $a42f1354f0348298$var$dy(e) {
    if (e) {
        for (const [, t] of [
            [
                "_",
                e
            ],
            ...Object.entries(e)
        ])if (t.prototype instanceof $a42f1354f0348298$var$ly) return $a42f1354f0348298$var$dv(t.id, t.VERSION, "5.15.1"), t;
    }
    return null;
}
$a42f1354f0348298$var$cy.readonlyOptions = [];
var $a42f1354f0348298$var$uy = {
    panorama: null,
    container: null,
    adapter: [
        $a42f1354f0348298$var$GE,
        null
    ],
    plugins: [],
    caption: null,
    description: null,
    downloadUrl: null,
    downloadName: null,
    loadingImg: null,
    loadingTxt: "",
    size: null,
    fisheye: 0,
    minFov: 30,
    maxFov: 90,
    defaultZoomLvl: 50,
    defaultYaw: 0,
    defaultPitch: 0,
    sphereCorrection: null,
    moveSpeed: 1,
    zoomSpeed: 1,
    moveInertia: .8,
    mousewheel: !0,
    mousemove: !0,
    mousewheelCtrlKey: !1,
    touchmoveTwoFingers: !1,
    panoData: null,
    requestHeaders: null,
    canvasBackground: "#000",
    defaultTransition: {
        speed: 1500,
        rotation: !0,
        effect: "fade"
    },
    rendererParameters: {
        alpha: !0,
        antialias: !0
    },
    withCredentials: ()=>!1,
    navbar: [
        "zoom",
        "move",
        "download",
        "description",
        "caption",
        "fullscreen"
    ],
    lang: {
        zoom: "Zoom",
        zoomOut: "Zoom out",
        zoomIn: "Zoom in",
        moveUp: "Move up",
        moveDown: "Move down",
        moveLeft: "Move left",
        moveRight: "Move right",
        description: "Description",
        download: "Download",
        fullscreen: "Fullscreen",
        loading: "Loading...",
        menu: "Menu",
        close: "Close",
        twoFingers: "Use two fingers to navigate",
        ctrlZoom: "Use ctrl + scroll to zoom the image",
        loadError: "The panorama cannot be loaded",
        webglError: "Your browser does not seem to support WebGL"
    },
    keyboard: "fullscreen",
    keyboardActions: {
        [$a42f1354f0348298$var$o_.ArrowUp]: "ROTATE_UP",
        [$a42f1354f0348298$var$o_.ArrowDown]: "ROTATE_DOWN",
        [$a42f1354f0348298$var$o_.ArrowRight]: "ROTATE_RIGHT",
        [$a42f1354f0348298$var$o_.ArrowLeft]: "ROTATE_LEFT",
        [$a42f1354f0348298$var$o_.PageUp]: "ZOOM_IN",
        [$a42f1354f0348298$var$o_.PageDown]: "ZOOM_OUT",
        [$a42f1354f0348298$var$o_.Plus]: "ZOOM_IN",
        [$a42f1354f0348298$var$o_.Minus]: "ZOOM_OUT"
    }
}, $a42f1354f0348298$var$hy = {
    panorama: "Use setPanorama method to change the panorama",
    panoData: "Use setPanorama method to change the panorama",
    container: "Cannot change viewer container",
    adapter: "Cannot change adapter",
    plugins: "Cannot change plugins"
}, $a42f1354f0348298$var$py = {
    container: (e)=>{
        if (!e) throw new $a42f1354f0348298$var$V_("No value given for container.");
        return e;
    },
    adapter: (e, { defValue: t })=>{
        if (!(e = e ? Array.isArray(e) ? [
            $a42f1354f0348298$var$BE(e[0]),
            e[1]
        ] : [
            $a42f1354f0348298$var$BE(e),
            null
        ] : t)[0]) throw new $a42f1354f0348298$var$V_("An undefined value was given for adapter.");
        if (!e[0].id) throw new $a42f1354f0348298$var$V_("Adapter has no id.");
        return e;
    },
    defaultYaw: (e)=>$a42f1354f0348298$var$ov(e),
    defaultPitch: (e)=>$a42f1354f0348298$var$ov(e, !0),
    defaultZoomLvl: (e)=>$a42f1354f0348298$var$lu.clamp(e, 0, 100),
    minFov: (e, { rawConfig: t })=>(t.maxFov < e && ($a42f1354f0348298$var$X_("maxFov cannot be lower than minFov"), e = t.maxFov), $a42f1354f0348298$var$lu.clamp(e, 1, 179)),
    maxFov: (e, { rawConfig: t })=>(e < t.minFov && (e = t.minFov), $a42f1354f0348298$var$lu.clamp(e, 1, 179)),
    moveInertia: (e, { defValue: t })=>!0 === e ? t : !1 === e ? 0 : e,
    lang: (e)=>({
            ...$a42f1354f0348298$var$uy.lang,
            ...e
        }),
    fisheye: (e)=>!0 === e ? 1 : !1 === e ? 0 : $a42f1354f0348298$var$lu.clamp(e, 0, 2),
    requestHeaders: (e)=>e && "object" == typeof e ? ()=>e : "function" == typeof e ? e : null,
    withCredentials: (e)=>"boolean" == typeof e ? ()=>e : "function" == typeof e ? e : ()=>!1,
    defaultTransition: (e, { defValue: t })=>null === e || 0 === e.speed ? null : {
            ...t,
            ...e
        },
    rendererParameters: (e, { defValue: t })=>({
            ...e,
            ...t
        }),
    plugins: (e)=>e.map((e, t)=>{
            if (!(e = Array.isArray(e) ? [
                $a42f1354f0348298$var$dy(e[0]),
                e[1]
            ] : [
                $a42f1354f0348298$var$dy(e),
                null
            ])[0]) throw new $a42f1354f0348298$var$V_(`An undefined value was given for plugin ${t}.`);
            if (!e[0].id) throw new $a42f1354f0348298$var$V_(`Plugin ${t} has no id.`);
            return e;
        }),
    navbar: (e)=>!1 === e ? null : !0 === e ? $a42f1354f0348298$var$U_($a42f1354f0348298$var$uy.navbar) : "string" == typeof e ? e.split(/[ ,]/) : e
}, $a42f1354f0348298$var$Ay = $a42f1354f0348298$var$lv($a42f1354f0348298$var$uy, $a42f1354f0348298$var$py), $a42f1354f0348298$var$my = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: "psv-caption",
            hoverScale: !1,
            collapsable: !1,
            tabbable: !0
        }), this.contentWidth = 0, this.state.width = 0, this.contentElt = document.createElement("div"), this.contentElt.className = "psv-caption-content", this.container.appendChild(this.contentElt), this.setCaption(this.viewer.config.caption);
    }
    hide() {
        this.contentElt.style.display = "none", this.state.visible = !1;
    }
    show() {
        this.contentElt.style.display = "", this.state.visible = !0;
    }
    onClick() {}
    setCaption(e) {
        this.show(), this.contentElt.innerHTML = e ?? "", this.contentElt.innerHTML ? this.contentWidth = this.contentElt.offsetWidth : this.contentWidth = 0, this.autoSize();
    }
    autoSize() {
        this.toggle(this.container.offsetWidth >= this.contentWidth), this.__refreshButton();
    }
    __refreshButton() {
        this.viewer.navbar.getButton($a42f1354f0348298$var$XE.id, !1)?.autoSize(!0);
    }
};
$a42f1354f0348298$var$my.id = "caption";
var $a42f1354f0348298$var$gy = {}, $a42f1354f0348298$var$fy = {};
function $a42f1354f0348298$var$_y(e, t) {
    if (!e.id) throw new $a42f1354f0348298$var$V_("Button id is required");
    if ($a42f1354f0348298$var$gy[e.id] = e, e.groupId && ($a42f1354f0348298$var$fy[e.groupId] = $a42f1354f0348298$var$fy[e.groupId] || []).push(e), t) {
        const i = $a42f1354f0348298$var$uy.navbar;
        switch(t){
            case "start":
                i.unshift(e.id);
                break;
            case "end":
                i.push(e.id);
                break;
            default:
                {
                    const [n, a] = t.split(":"), r = i.indexOf(n);
                    if (!n || !a || -1 === r) throw new $a42f1354f0348298$var$V_(`Invalid defaultPosition ${t}`);
                    i.splice(r + ("right" === a ? 1 : 0), 0, e.id);
                }
        }
    }
}
[
    $a42f1354f0348298$var$sy,
    $a42f1354f0348298$var$oy,
    $a42f1354f0348298$var$ry,
    $a42f1354f0348298$var$XE,
    $a42f1354f0348298$var$my,
    $a42f1354f0348298$var$QE,
    $a42f1354f0348298$var$ZE,
    $a42f1354f0348298$var$ty,
    $a42f1354f0348298$var$iy,
    $a42f1354f0348298$var$ny,
    $a42f1354f0348298$var$ey
].forEach((e)=>$a42f1354f0348298$var$_y(e));
var $a42f1354f0348298$var$vy = class extends $a42f1354f0348298$var$HE {
    constructor(e){
        super(e, {
            className: `psv-navbar ${$a42f1354f0348298$var$a_}`
        }), this.collapsed = [], this.state.visible = !1;
    }
    show() {
        this.viewer.container.classList.add("psv--has-navbar"), this.container.classList.add("psv-navbar--open"), this.state.visible = !0;
    }
    hide() {
        this.viewer.container.classList.remove("psv--has-navbar"), this.container.classList.remove("psv-navbar--open"), this.state.visible = !1;
    }
    setButtons(e) {
        this.children.slice().forEach((e)=>e.destroy()), this.children.length = 0, -1 !== e.indexOf($a42f1354f0348298$var$my.id) && -1 === e.indexOf($a42f1354f0348298$var$XE.id) && e.splice(e.indexOf($a42f1354f0348298$var$my.id), 0, $a42f1354f0348298$var$XE.id), e.forEach((e)=>{
            "object" == typeof e ? new $a42f1354f0348298$var$WE(this, e) : $a42f1354f0348298$var$gy[e] ? new $a42f1354f0348298$var$gy[e](this) : $a42f1354f0348298$var$fy[e] ? $a42f1354f0348298$var$fy[e].forEach((e)=>{
                new e(this);
            }) : $a42f1354f0348298$var$X_(`Unknown button ${e}`);
        }), new $a42f1354f0348298$var$YE(this), this.children.forEach((e)=>{
            e instanceof $a42f1354f0348298$var$KE && e.checkSupported();
        }), this.autoSize();
    }
    setCaption(e) {
        this.children.some((t)=>t instanceof $a42f1354f0348298$var$my && (t.setCaption(e), !0));
    }
    getButton(e, t = !0) {
        const i = this.children.find((t)=>t instanceof $a42f1354f0348298$var$KE && t.id === e);
        return !i && t && $a42f1354f0348298$var$X_(`button "${e}" not found in the navbar`), i;
    }
    focusButton(e) {
        this.isVisible() && (this.getButton(e, !1)?.container || this.container.firstElementChild)?.focus();
    }
    autoSize() {
        this.children.forEach((e)=>{
            e instanceof $a42f1354f0348298$var$KE && e.autoSize();
        });
        const e = this.container.offsetWidth;
        let t = 0;
        const i = [];
        this.children.forEach((e)=>{
            e.isVisible() && e instanceof $a42f1354f0348298$var$KE && (t += e.width, e.collapsable && i.push(e));
        }), 0 !== t && (e < t && i.length > 0 ? (i.forEach((e)=>e.collapse()), this.collapsed = i, this.getButton($a42f1354f0348298$var$YE.id).show(!1)) : e >= t && this.collapsed.length > 0 && (this.collapsed.forEach((e)=>e.uncollapse()), this.collapsed = [], this.getButton($a42f1354f0348298$var$YE.id).hide(!1)), this.getButton($a42f1354f0348298$var$my.id, !1)?.autoSize());
    }
};
$a42f1354f0348298$var$xA.enabled = !1;
var $a42f1354f0348298$var$Ey = {
    enabled: !0,
    maxItems: 10,
    ttl: 600,
    items: {},
    purgeInterval: null,
    init () {
        $a42f1354f0348298$var$xA.enabled && ($a42f1354f0348298$var$X_("ThreeJS cache should be disabled"), $a42f1354f0348298$var$xA.enabled = !1), !this.purgeInterval && this.enabled && (this.purgeInterval = setInterval(()=>this.purge(), 6e4));
    },
    add (e, t, i) {
        this.enabled && t && (this.items[t] = this.items[t] ?? {
            files: {},
            lastAccess: null
        }, this.items[t].files[e] = i, this.items[t].lastAccess = Date.now());
    },
    get (e, t) {
        if (this.enabled && t && this.items[t]) return this.items[t].lastAccess = Date.now(), this.items[t].files[e];
    },
    remove (e, t) {
        this.enabled && t && this.items[t] && (delete this.items[t].files[e], 0 === Object.keys(this.items[t].files).length && delete this.items[t]);
    },
    purge () {
        Object.entries(this.items).sort(([, e], [, t])=>t.lastAccess - e.lastAccess).forEach(([e, { lastAccess: t }], i)=>{
            i > 0 && (Date.now() - t >= 1e3 * this.ttl || i >= this.maxItems) && delete this.items[e];
        });
    }
}, $a42f1354f0348298$var$yy = class extends $a42f1354f0348298$var$HE {
    constructor(e){
        super(e, {
            className: "psv-loader-container"
        }), this.loader = document.createElement("div"), this.loader.className = "psv-loader", this.container.appendChild(this.loader), this.size = this.loader.offsetWidth, this.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.canvas.setAttribute("class", "psv-loader-canvas"), this.canvas.setAttribute("viewBox", `0 0 ${this.size} ${this.size}`), this.loader.appendChild(this.canvas), this.textColor = $a42f1354f0348298$var$S_(this.loader, "color"), this.color = $a42f1354f0348298$var$S_(this.canvas, "color"), this.border = parseInt($a42f1354f0348298$var$S_(this.loader, "--psv-loader-border"), 10), this.thickness = parseInt($a42f1354f0348298$var$S_(this.loader, "--psv-loader-tickness"), 10);
        const t = this.size / 2;
        this.canvas.innerHTML = `\n            <circle cx="${t}" cy="${t}" r="${t}" fill="${this.color}"/>\n            <path d="" fill="none" stroke="${this.textColor}" stroke-width="${this.thickness}" stroke-linecap="round"/>\n        `, this.viewer.addEventListener($a42f1354f0348298$var$Nv.type, this), this.__updateContent(), this.hide();
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$Nv.type, this), super.destroy();
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$Nv && e.containsOptions("loadingImg", "loadingTxt", "lang") && this.__updateContent();
    }
    setProgress(e) {
        this.container.classList.remove("psv-loader--undefined");
        const t = $a42f1354f0348298$var$lu.clamp(e, 0, 99.999) / 100 * Math.PI * 2, i = this.size / 2, n = i, a = this.thickness / 2 + this.border, r = (this.size - this.thickness) / 2 - this.border, s = Math.sin(t) * r + i, o = -Math.cos(t) * r + i, l = e > 50 ? "1" : "0";
        this.canvas.querySelector("path").setAttributeNS(null, "d", `M ${n} ${a} A ${r} ${r} 0 ${l} 1 ${s} ${o}`);
    }
    showUndefined() {
        this.show(), this.setProgress(25), this.container.classList.add("psv-loader--undefined");
    }
    __updateContent() {
        const e = this.loader.querySelector(".psv-loader-image, .psv-loader-text");
        let t;
        if (e && this.loader.removeChild(e), this.viewer.config.loadingImg ? (t = document.createElement("img"), t.className = "psv-loader-image", t.src = this.viewer.config.loadingImg) : null !== this.viewer.config.loadingTxt && (t = document.createElement("div"), t.className = "psv-loader-text", t.innerHTML = this.viewer.config.loadingTxt || this.viewer.config.lang.loading), t) {
            const e = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
            t.style.maxWidth = e + "px", t.style.maxHeight = e + "px", this.loader.appendChild(t);
        }
    }
}, $a42f1354f0348298$var$by = class extends $a42f1354f0348298$var$HE {
    constructor(e){
        super(e, {
            className: "psv-notification"
        }), this.state = {
            visible: !1,
            contentId: null,
            timeout: null
        }, this.content = document.createElement("div"), this.content.className = "psv-notification-content", this.container.appendChild(this.content), this.content.addEventListener("click", ()=>this.hide());
    }
    isVisible(e) {
        return this.state.visible && (!e || !this.state.contentId || this.state.contentId === e);
    }
    toggle() {
        throw new $a42f1354f0348298$var$V_("Notification cannot be toggled");
    }
    show(e) {
        this.state.timeout && (clearTimeout(this.state.timeout), this.state.timeout = null), "string" == typeof e && (e = {
            content: e
        }), this.state.contentId = e.id || null, this.content.innerHTML = e.content, this.container.classList.add("psv-notification--visible"), this.state.visible = !0, this.viewer.dispatchEvent(new $a42f1354f0348298$var$_E(this.state.contentId)), e.timeout && (this.state.timeout = setTimeout(()=>this.hide(this.state.contentId), e.timeout));
    }
    hide(e) {
        if (this.isVisible(e)) {
            const e = this.state.contentId;
            this.container.classList.remove("psv-notification--visible"), this.state.visible = !1, this.state.contentId = null, this.viewer.dispatchEvent(new $a42f1354f0348298$var$Hv(e));
        }
    }
}, $a42f1354f0348298$var$ky = class extends $a42f1354f0348298$var$HE {
    constructor(e){
        super(e, {
            className: `psv-overlay ${$a42f1354f0348298$var$a_}`
        }), this.state = {
            visible: !1,
            contentId: null,
            dismissible: !0
        }, this.image = document.createElement("div"), this.image.className = "psv-overlay-image", this.container.appendChild(this.image), this.title = document.createElement("div"), this.title.className = "psv-overlay-title", this.container.appendChild(this.title), this.text = document.createElement("div"), this.text.className = "psv-overlay-text", this.container.appendChild(this.text), this.container.addEventListener("click", this), this.viewer.addEventListener($a42f1354f0348298$var$Jv.type, this), super.hide();
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$Jv.type, this), super.destroy();
    }
    handleEvent(e) {
        "click" === e.type ? this.isVisible() && this.state.dismissible && (this.hide(), e.stopPropagation()) : e instanceof $a42f1354f0348298$var$Jv && this.isVisible() && this.state.dismissible && e.matches($a42f1354f0348298$var$o_.Escape) && (this.hide(), e.preventDefault());
    }
    isVisible(e) {
        return this.state.visible && (!e || !this.state.contentId || this.state.contentId === e);
    }
    toggle() {
        throw new $a42f1354f0348298$var$V_("Overlay cannot be toggled");
    }
    show(e) {
        "string" == typeof e && (e = {
            title: e
        }), this.state.contentId = e.id || null, this.state.dismissible = !1 !== e.dismissible, this.image.innerHTML = e.image || "", this.title.innerHTML = e.title || "", this.text.innerHTML = e.text || "", super.show(), this.viewer.dispatchEvent(new $a42f1354f0348298$var$EE(this.state.contentId));
    }
    hide(e) {
        if (this.isVisible(e)) {
            const e = this.state.contentId;
            super.hide(), this.state.contentId = null, this.viewer.dispatchEvent(new $a42f1354f0348298$var$Kv(e));
        }
    }
}, $a42f1354f0348298$var$xy = "psv-panel-content--no-interaction", $a42f1354f0348298$var$wy = class extends $a42f1354f0348298$var$HE {
    constructor(e){
        super(e, {
            className: `psv-panel ${$a42f1354f0348298$var$a_}`
        }), this.state = {
            visible: !1,
            contentId: null,
            mouseX: 0,
            mouseY: 0,
            mousedown: !1,
            clickHandler: null,
            keyHandler: null,
            width: {}
        };
        const t = document.createElement("div");
        t.className = "psv-panel-resizer", this.container.appendChild(t);
        const i = document.createElement("div");
        i.className = "psv-panel-close-button", i.innerHTML = $a42f1354f0348298$var$l_.close, i.title = e.config.lang.close, this.container.appendChild(i), this.content = document.createElement("div"), this.content.className = "psv-panel-content", this.container.appendChild(this.content), i.addEventListener("click", ()=>this.hide()), t.addEventListener("mousedown", this), t.addEventListener("touchstart", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this), this.viewer.container.addEventListener("mousemove", this), this.viewer.container.addEventListener("touchmove", this), this.viewer.addEventListener($a42f1354f0348298$var$Jv.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$Jv.type, this), this.viewer.container.removeEventListener("mousemove", this), this.viewer.container.removeEventListener("touchmove", this), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case "mousedown":
                this.__onMouseDown(e);
                break;
            case "touchstart":
                this.__onTouchStart(e);
                break;
            case "mousemove":
                this.__onMouseMove(e);
                break;
            case "touchmove":
                this.__onTouchMove(e);
                break;
            case "mouseup":
                this.__onMouseUp(e);
                break;
            case "touchend":
                this.__onTouchEnd(e);
                break;
            case $a42f1354f0348298$var$Jv.type:
                this.__onKeyPress(e);
        }
    }
    isVisible(e) {
        return this.state.visible && (!e || !this.state.contentId || this.state.contentId === e);
    }
    toggle() {
        throw new $a42f1354f0348298$var$V_("Panel cannot be toggled");
    }
    show(e) {
        "string" == typeof e && (e = {
            content: e
        });
        const t = this.isVisible(e.id);
        this.state.contentId = e.id || null, this.state.visible = !0, this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), e.id && this.state.width[e.id] ? this.container.style.width = this.state.width[e.id] : e.width ? this.container.style.width = e.width : this.container.style.width = null, this.content.innerHTML = e.content, this.content.scrollTop = 0, this.container.classList.add("psv-panel--open"), $a42f1354f0348298$var$v_(this.content, "psv-panel-content--no-margin", !0 === e.noMargin), e.clickHandler && (this.state.clickHandler = (t)=>{
            e.clickHandler($a42f1354f0348298$var$x_(t));
        }, this.state.keyHandler = (t)=>{
            t.key === $a42f1354f0348298$var$o_.Enter && e.clickHandler($a42f1354f0348298$var$x_(t));
        }, this.content.addEventListener("click", this.state.clickHandler), this.content.addEventListener("keydown", this.state.keyHandler), t || setTimeout(()=>{
            this.content.querySelector("a,button,[tabindex]")?.focus();
        }, 300)), this.viewer.dispatchEvent(new $a42f1354f0348298$var$bE(this.state.contentId));
    }
    hide(e) {
        if (this.isVisible(e)) {
            const e = this.state.contentId;
            this.state.visible = !1, this.state.contentId = null, this.content.innerHTML = null, this.container.classList.remove("psv-panel--open"), this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), this.viewer.dispatchEvent(new $a42f1354f0348298$var$Xv(e));
        }
    }
    __onMouseDown(e) {
        e.stopPropagation(), this.__startResize(e.clientX, e.clientY);
    }
    __onTouchStart(e) {
        if (e.stopPropagation(), 1 === e.touches.length) {
            const t = e.touches[0];
            this.__startResize(t.clientX, t.clientY);
        }
    }
    __onMouseUp(e) {
        this.state.mousedown && (e.stopPropagation(), this.state.mousedown = !1, this.content.classList.remove($a42f1354f0348298$var$xy));
    }
    __onTouchEnd(e) {
        this.state.mousedown && (e.stopPropagation(), 0 === e.touches.length && (this.state.mousedown = !1, this.content.classList.remove($a42f1354f0348298$var$xy)));
    }
    __onMouseMove(e) {
        this.state.mousedown && (e.stopPropagation(), this.__resize(e.clientX, e.clientY));
    }
    __onTouchMove(e) {
        if (this.state.mousedown) {
            const t = e.touches[0];
            this.__resize(t.clientX, t.clientY);
        }
    }
    __onKeyPress(e) {
        this.isVisible() && e.matches($a42f1354f0348298$var$o_.Escape) && (this.hide(), e.preventDefault());
    }
    __startResize(e, t) {
        this.state.mouseX = e, this.state.mouseY = t, this.state.mousedown = !0, this.content.classList.add($a42f1354f0348298$var$xy);
    }
    __resize(e, t) {
        const i = e, n = t, a = Math.max(200, this.container.offsetWidth - (i - this.state.mouseX)) + "px";
        this.state.contentId && (this.state.width[this.state.contentId] = a), this.container.style.width = a, this.state.mouseX = i, this.state.mouseY = n;
    }
}, $a42f1354f0348298$var$My = class extends $a42f1354f0348298$var$HE {
    constructor(e, t){
        super(e, {
            className: "psv-tooltip"
        }), this.state = {
            visible: !0,
            arrow: 0,
            border: 0,
            state: 0,
            width: 0,
            height: 0,
            pos: "",
            config: null,
            data: null,
            hideTimeout: null
        }, this.content = document.createElement("div"), this.content.className = "psv-tooltip-content", this.container.appendChild(this.content), this.arrow = document.createElement("div"), this.arrow.className = "psv-tooltip-arrow", this.container.appendChild(this.arrow), this.container.addEventListener("transitionend", this), this.container.addEventListener("touchdown", (e)=>e.stopPropagation()), this.container.addEventListener("mousedown", (e)=>e.stopPropagation()), this.container.style.top = "-1000px", this.container.style.left = "-1000px", this.show(t);
    }
    handleEvent(e) {
        "transitionend" === e.type && this.__onTransitionEnd(e);
    }
    destroy() {
        clearTimeout(this.state.hideTimeout), delete this.state.data, super.destroy();
    }
    toggle() {
        throw new $a42f1354f0348298$var$V_("Tooltip cannot be toggled");
    }
    show(e) {
        if (0 !== this.state.state) throw new $a42f1354f0348298$var$V_("Initialized tooltip cannot be re-initialized");
        e.className && $a42f1354f0348298$var$E_(this.container, e.className), e.style && Object.assign(this.container.style, e.style), this.state.state = 3, this.update(e.content, e), this.state.data = e.data, this.state.state = 1, this.viewer.dispatchEvent(new $a42f1354f0348298$var$xE(this, this.state.data)), this.__waitImages();
    }
    update(e, t) {
        this.content.innerHTML = e;
        const i = this.container.getBoundingClientRect();
        this.state.width = i.right - i.left, this.state.height = i.bottom - i.top, this.state.arrow = parseInt($a42f1354f0348298$var$S_(this.arrow, "border-top-width"), 10), this.state.border = parseInt($a42f1354f0348298$var$S_(this.container, "border-top-left-radius"), 10), this.move(t ?? this.state.config), this.__waitImages();
    }
    move(e) {
        if (1 !== this.state.state && 3 !== this.state.state) throw new $a42f1354f0348298$var$V_("Uninitialized tooltip cannot be moved");
        e.box = e.box ?? this.state.config?.box ?? {
            width: 0,
            height: 0
        }, this.state.config = e;
        const t = this.container, i = this.arrow, n = {
            posClass: $a42f1354f0348298$var$nv(e.position, {
                allowCenter: !1,
                cssOrder: !1
            }) || [
                "top",
                "center"
            ],
            width: this.state.width,
            height: this.state.height,
            top: 0,
            left: 0,
            arrowTop: 0,
            arrowLeft: 0
        };
        this.__computeTooltipPosition(n, e);
        let a = null, r = null;
        if (n.top < 0 ? a = "bottom" : n.top + n.height > this.viewer.state.size.height && (a = "top"), n.left < 0 ? r = "right" : n.left + n.width > this.viewer.state.size.width && (r = "left"), r || a) {
            const t = $a42f1354f0348298$var$av(n.posClass);
            a && (n.posClass[t ? 0 : 1] = a), r && (n.posClass[t ? 1 : 0] = r), this.__computeTooltipPosition(n, e);
        }
        t.style.top = n.top + "px", t.style.left = n.left + "px", i.style.top = n.arrowTop + "px", i.style.left = n.arrowLeft + "px";
        const s = n.posClass.join("-");
        s !== this.state.pos && (t.classList.remove(`psv-tooltip--${this.state.pos}`), this.state.pos = s, t.classList.add(`psv-tooltip--${this.state.pos}`));
    }
    hide() {
        this.container.classList.remove("psv-tooltip--visible"), this.state.state = 2, this.viewer.dispatchEvent(new $a42f1354f0348298$var$Zv(this.state.data));
        const e = parseFloat($a42f1354f0348298$var$S_(this.container, "transition-duration"));
        this.state.hideTimeout = setTimeout(()=>{
            this.destroy();
        }, 2 * e);
    }
    __onTransitionEnd(e) {
        if ("transform" === e.propertyName) switch(this.state.state){
            case 1:
                this.container.classList.add("psv-tooltip--visible"), this.state.state = 3;
                break;
            case 2:
                this.state.state = 0, this.destroy();
        }
    }
    __computeTooltipPosition(e, t) {
        const i = this.state.arrow, n = t.top, a = e.height, r = t.left, s = e.width, o = i + this.state.border, l = t.box.width / 2 + 2 * i, c = t.box.height / 2 + 2 * i;
        switch(e.posClass.join("-")){
            case "top-left":
                e.top = n - c - a, e.left = r + o - s, e.arrowTop = a, e.arrowLeft = s - o - i;
                break;
            case "top-center":
                e.top = n - c - a, e.left = r - s / 2, e.arrowTop = a, e.arrowLeft = s / 2 - i;
                break;
            case "top-right":
                e.top = n - c - a, e.left = r - o, e.arrowTop = a, e.arrowLeft = i;
                break;
            case "bottom-left":
                e.top = n + c, e.left = r + o - s, e.arrowTop = 2 * -i, e.arrowLeft = s - o - i;
                break;
            case "bottom-center":
                e.top = n + c, e.left = r - s / 2, e.arrowTop = 2 * -i, e.arrowLeft = s / 2 - i;
                break;
            case "bottom-right":
                e.top = n + c, e.left = r - o, e.arrowTop = 2 * -i, e.arrowLeft = i;
                break;
            case "left-top":
                e.top = n + o - a, e.left = r - l - s, e.arrowTop = a - o - i, e.arrowLeft = s;
                break;
            case "center-left":
                e.top = n - a / 2, e.left = r - l - s, e.arrowTop = a / 2 - i, e.arrowLeft = s;
                break;
            case "left-bottom":
                e.top = n - o, e.left = r - l - s, e.arrowTop = i, e.arrowLeft = s;
                break;
            case "right-top":
                e.top = n + o - a, e.left = r + l, e.arrowTop = a - o - i, e.arrowLeft = 2 * -i;
                break;
            case "center-right":
                e.top = n - a / 2, e.left = r + l, e.arrowTop = a / 2 - i, e.arrowLeft = 2 * -i;
                break;
            case "right-bottom":
                e.top = n - o, e.left = r + l, e.arrowTop = i, e.arrowLeft = 2 * -i;
        }
    }
    __waitImages() {
        const e = this.content.querySelectorAll("img");
        if (e.length > 0) {
            const t = [];
            e.forEach((e)=>{
                e.complete || t.push(new Promise((t)=>{
                    e.onload = t, e.onerror = t;
                }));
            }), t.length && Promise.all(t).then(()=>{
                if (1 === this.state.state || 3 === this.state.state) {
                    const e = this.container.getBoundingClientRect();
                    this.state.width = e.right - e.left, this.state.height = e.bottom - e.top, this.move(this.state.config);
                }
            });
        }
    }
}, $a42f1354f0348298$var$Sy = class {
    constructor(e){
        this.viewer = e, this.config = e.config, this.state = e.state;
    }
    destroy() {}
}, $a42f1354f0348298$var$Cy = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Ty = new $a42f1354f0348298$var$qu(0, 0, 0, "ZXY"), $a42f1354f0348298$var$Dy = class extends $a42f1354f0348298$var$Sy {
    constructor(e){
        super(e);
    }
    fovToZoomLevel(e) {
        const t = Math.round((e - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
        return $a42f1354f0348298$var$lu.clamp(t - 2 * (t - 50), 0, 100);
    }
    zoomLevelToFov(e) {
        return this.config.maxFov + e / 100 * (this.config.minFov - this.config.maxFov);
    }
    vFovToHFov(e) {
        return $a42f1354f0348298$var$lu.radToDeg(2 * Math.atan(Math.tan($a42f1354f0348298$var$lu.degToRad(e) / 2) * this.state.aspect));
    }
    hFovToVFov(e) {
        return $a42f1354f0348298$var$lu.radToDeg(2 * Math.atan(Math.tan($a42f1354f0348298$var$lu.degToRad(e) / 2) / this.state.aspect));
    }
    getAnimationProperties(e, t, i) {
        const n = !$a42f1354f0348298$var$B_(t), a = !$a42f1354f0348298$var$B_(i), r = {};
        let s = null;
        if (n) {
            const i = this.viewer.getPosition(), n = $a42f1354f0348298$var$m_(i.yaw, t.yaw);
            r.yaw = {
                start: i.yaw,
                end: i.yaw + n
            }, r.pitch = {
                start: i.pitch,
                end: t.pitch
            }, s = $a42f1354f0348298$var$sv(e, $a42f1354f0348298$var$g_(i, t));
        }
        if (a) {
            const t = this.viewer.getZoomLevel(), n = Math.abs(i - t);
            r.zoom = {
                start: t,
                end: i
            }, null === s && (s = $a42f1354f0348298$var$sv(e, Math.PI / 4 * n / 100));
        }
        return s = null === s ? "number" == typeof e ? e : $a42f1354f0348298$var$Zf : Math.max($a42f1354f0348298$var$Zf, s), {
            duration: s,
            properties: r
        };
    }
    getTransitionOptions(e) {
        let t;
        const i = this.config.defaultTransition ?? $a42f1354f0348298$var$uy.defaultTransition;
        return t = !1 === e.transition || null === e.transition ? null : !0 === e.transition ? {
            ...i
        } : "object" == typeof e.transition ? {
            ...i,
            ...e.transition
        } : this.config.defaultTransition, t;
    }
    textureCoordsToSphericalCoords(e) {
        if (!this.state.textureData?.panoData) throw new $a42f1354f0348298$var$V_("Current adapter does not support texture coordinates or no texture has been loaded");
        const t = this.viewer.adapter.textureCoordsToSphericalCoords(e, this.state.textureData.panoData);
        return $a42f1354f0348298$var$Ty.equals(this.viewer.renderer.panoramaPose) && $a42f1354f0348298$var$Ty.equals(this.viewer.renderer.sphereCorrection) ? t : (this.sphericalCoordsToVector3(t, $a42f1354f0348298$var$Cy), $a42f1354f0348298$var$Cy.applyEuler(this.viewer.renderer.panoramaPose), $a42f1354f0348298$var$Cy.applyEuler(this.viewer.renderer.sphereCorrection), this.vector3ToSphericalCoords($a42f1354f0348298$var$Cy));
    }
    sphericalCoordsToTextureCoords(e) {
        if (!this.state.textureData?.panoData) throw new $a42f1354f0348298$var$V_("Current adapter does not support texture coordinates or no texture has been loaded");
        return $a42f1354f0348298$var$Ty.equals(this.viewer.renderer.panoramaPose) && $a42f1354f0348298$var$Ty.equals(this.viewer.renderer.sphereCorrection) || (this.sphericalCoordsToVector3(e, $a42f1354f0348298$var$Cy), $a42f1354f0348298$var$_v($a42f1354f0348298$var$Cy, this.viewer.renderer.sphereCorrection), $a42f1354f0348298$var$_v($a42f1354f0348298$var$Cy, this.viewer.renderer.panoramaPose), e = this.vector3ToSphericalCoords($a42f1354f0348298$var$Cy)), this.viewer.adapter.sphericalCoordsToTextureCoords(e, this.state.textureData.panoData);
    }
    sphericalCoordsToVector3(e, t, i = $a42f1354f0348298$var$i_) {
        return t || (t = new $a42f1354f0348298$var$uu), t.x = i * -Math.cos(e.pitch) * Math.sin(e.yaw), t.y = i * Math.sin(e.pitch), t.z = i * Math.cos(e.pitch) * Math.cos(e.yaw), t;
    }
    vector3ToSphericalCoords(e) {
        const t = Math.acos(e.y / Math.sqrt(e.x * e.x + e.y * e.y + e.z * e.z)), i = Math.atan2(e.x, e.z);
        return {
            yaw: i < 0 ? -i : 2 * Math.PI - i,
            pitch: Math.PI / 2 - t
        };
    }
    viewerCoordsToVector3(e) {
        const t = this.viewer.renderer.getIntersections(e).filter((e)=>e.object.userData[$a42f1354f0348298$var$n_]);
        return t.length ? t[0].point : null;
    }
    viewerCoordsToSphericalCoords(e) {
        const t = this.viewerCoordsToVector3(e);
        return t ? this.vector3ToSphericalCoords(t) : null;
    }
    vector3ToViewerCoords(e) {
        const t = e.clone();
        return t.project(this.viewer.renderer.camera), {
            x: Math.round((t.x + 1) / 2 * this.state.size.width),
            y: Math.round((1 - t.y) / 2 * this.state.size.height)
        };
    }
    sphericalCoordsToViewerCoords(e) {
        return this.sphericalCoordsToVector3(e, $a42f1354f0348298$var$Cy), this.vector3ToViewerCoords($a42f1354f0348298$var$Cy);
    }
    isPointVisible(e) {
        let t, i;
        if (e instanceof $a42f1354f0348298$var$uu) t = e, i = this.vector3ToViewerCoords(e);
        else {
            if (!$a42f1354f0348298$var$Q_(e)) return !1;
            t = this.sphericalCoordsToVector3(e, $a42f1354f0348298$var$Cy), i = this.vector3ToViewerCoords(t);
        }
        return t.dot(this.viewer.state.direction) > 0 && i.x >= 0 && i.x <= this.viewer.state.size.width && i.y >= 0 && i.y <= this.viewer.state.size.height;
    }
    cleanPosition(e) {
        if ("yaw" in e || "pitch" in e) {
            if (!("yaw" in e) || !("pitch" in e)) throw new $a42f1354f0348298$var$V_("Position is missing 'yaw' or 'pitch'");
            return {
                yaw: $a42f1354f0348298$var$ov(e.yaw),
                pitch: $a42f1354f0348298$var$ov(e.pitch, !0)
            };
        }
        return this.textureCoordsToSphericalCoords(e);
    }
    cleanSphereCorrection(e) {
        return {
            pan: $a42f1354f0348298$var$ov(e?.pan || 0),
            tilt: $a42f1354f0348298$var$ov(e?.tilt || 0, !0),
            roll: $a42f1354f0348298$var$ov(e?.roll || 0, !0, !1)
        };
    }
    cleanPanoramaPose(e) {
        return {
            pan: $a42f1354f0348298$var$lu.degToRad(e?.poseHeading || 0),
            tilt: $a42f1354f0348298$var$lu.degToRad(e?.posePitch || 0),
            roll: $a42f1354f0348298$var$lu.degToRad(e?.poseRoll || 0)
        };
    }
    cleanPanoramaOptions(e, t) {
        return t?.isEquirectangular ? ($a42f1354f0348298$var$B_(e.zoom) && !$a42f1354f0348298$var$B_(t.initialFov) && (e = {
            ...e,
            zoom: this.fovToZoomLevel(this.hFovToVFov(t.initialFov))
        }), !$a42f1354f0348298$var$B_(e.position) || $a42f1354f0348298$var$B_(t.initialHeading) || $a42f1354f0348298$var$B_(t.initialPitch) || (e = {
            ...e,
            position: {
                yaw: $a42f1354f0348298$var$lu.degToRad(t.initialHeading),
                pitch: $a42f1354f0348298$var$lu.degToRad(t.initialPitch)
            }
        }), e) : e;
    }
}, $a42f1354f0348298$var$Py = class e {
    constructor(){
        this.$ = e.IDLE;
    }
    is(...e) {
        return e.some((e)=>this.$ & e);
    }
    set(e) {
        this.$ = e;
    }
    add(e) {
        this.$ |= e;
    }
    remove(e) {
        this.$ &= ~e;
    }
};
$a42f1354f0348298$var$Py.IDLE = 0, $a42f1354f0348298$var$Py.CLICK = 1, $a42f1354f0348298$var$Py.MOVING = 2;
var $a42f1354f0348298$var$Iy = $a42f1354f0348298$var$Py, $a42f1354f0348298$var$Ly = class extends $a42f1354f0348298$var$Sy {
    constructor(e){
        super(e), this.data = {
            startMouseX: 0,
            startMouseY: 0,
            mouseX: 0,
            mouseY: 0,
            pinchDist: 0,
            moveDelta: {
                yaw: 0,
                pitch: 0,
                zoom: 0
            },
            accumulatorFactor: 0,
            ctrlKeyDown: !1,
            dblclickData: null,
            dblclickTimeout: null,
            longtouchTimeout: null,
            twofingersTimeout: null,
            ctrlZoomTimeout: null
        }, this.step = new $a42f1354f0348298$var$Iy, this.keyHandler = new $a42f1354f0348298$var$bv, this.resizeObserver = new ResizeObserver($a42f1354f0348298$var$R_(()=>this.viewer.autoSize(), 50)), this.moveThreshold = $a42f1354f0348298$var$Yf * $a42f1354f0348298$var$Av.pixelRatio;
    }
    init() {
        window.addEventListener("keydown", this, {
            passive: !1
        }), window.addEventListener("keyup", this), this.viewer.container.addEventListener("mousedown", this), window.addEventListener("mousemove", this, {
            passive: !1
        }), window.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchstart", this, {
            passive: !1
        }), window.addEventListener("touchmove", this, {
            passive: !1
        }), window.addEventListener("touchend", this, {
            passive: !1
        }), this.viewer.container.addEventListener("wheel", this, {
            passive: !1
        }), document.addEventListener("fullscreenchange", this), this.resizeObserver.observe(this.viewer.container), this.viewer.addEventListener($a42f1354f0348298$var$Iv.type, this), this.viewer.addEventListener($a42f1354f0348298$var$CE.type, this);
    }
    destroy() {
        window.removeEventListener("keydown", this), window.removeEventListener("keyup", this), this.viewer.container.removeEventListener("mousedown", this), window.removeEventListener("mousemove", this), window.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchstart", this), window.removeEventListener("touchmove", this), window.removeEventListener("touchend", this), this.viewer.container.removeEventListener("wheel", this), document.removeEventListener("fullscreenchange", this), this.resizeObserver.disconnect(), this.viewer.removeEventListener($a42f1354f0348298$var$Iv.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$CE.type, this), clearTimeout(this.data.dblclickTimeout), clearTimeout(this.data.longtouchTimeout), clearTimeout(this.data.twofingersTimeout), clearTimeout(this.data.ctrlZoomTimeout), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case "keydown":
                this.__onKeyDown(e);
                break;
            case "keyup":
                this.__onKeyUp();
                break;
            case "mousemove":
                this.__onMouseMove(e);
                break;
            case "mouseup":
                this.__onMouseUp(e);
                break;
            case "touchmove":
                this.__onTouchMove(e);
                break;
            case "touchend":
                this.__onTouchEnd(e);
                break;
            case "fullscreenchange":
                this.__onFullscreenChange();
                break;
            case $a42f1354f0348298$var$Iv.type:
                this.__applyMoveDelta();
                break;
            case $a42f1354f0348298$var$CE.type:
                this.__clearMoveDelta();
        }
        if (!$a42f1354f0348298$var$w_(e, "." + $a42f1354f0348298$var$a_)) switch(e.type){
            case "mousedown":
                this.__onMouseDown(e);
                break;
            case "touchstart":
                this.__onTouchStart(e);
                break;
            case "wheel":
                this.__onMouseWheel(e);
        }
    }
    __onKeyDown(e) {
        if (this.config.mousewheelCtrlKey && (this.data.ctrlKeyDown = e.key === $a42f1354f0348298$var$o_.Control, this.data.ctrlKeyDown && (clearTimeout(this.data.ctrlZoomTimeout), this.viewer.overlay.hide($a42f1354f0348298$var$s_.CTRL_ZOOM))), this.viewer.dispatchEvent(new $a42f1354f0348298$var$Jv(e.key, e)) && this.state.keyboardEnabled && this.config.keyboardActions && !this.keyHandler.pending) {
            for (const [t, i] of Object.entries(this.config.keyboardActions))if ($a42f1354f0348298$var$I_(e, t)) {
                if ("function" == typeof i) i(this.viewer, e);
                else {
                    switch("ZOOM_IN" !== i && "ZOOM_OUT" !== i && this.viewer.stopAll(), i){
                        case "ROTATE_UP":
                            this.viewer.dynamics.position.roll({
                                pitch: !1
                            });
                            break;
                        case "ROTATE_DOWN":
                            this.viewer.dynamics.position.roll({
                                pitch: !0
                            });
                            break;
                        case "ROTATE_RIGHT":
                            this.viewer.dynamics.position.roll({
                                yaw: !1
                            });
                            break;
                        case "ROTATE_LEFT":
                            this.viewer.dynamics.position.roll({
                                yaw: !0
                            });
                            break;
                        case "ZOOM_IN":
                            this.viewer.dynamics.zoom.roll(!1);
                            break;
                        case "ZOOM_OUT":
                            this.viewer.dynamics.zoom.roll(!0);
                    }
                    this.keyHandler.down(i);
                }
                return void e.preventDefault();
            }
        }
    }
    __onKeyUp() {
        this.data.ctrlKeyDown = !1, this.state.keyboardEnabled && this.keyHandler.up((e)=>{
            "ZOOM_IN" === e || "ZOOM_OUT" === e ? this.viewer.dynamics.zoom.stop() : (this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer());
        });
    }
    __onMouseDown(e) {
        this.step.add($a42f1354f0348298$var$Iy.CLICK), this.data.startMouseX = e.clientX, this.data.startMouseY = e.clientY, this.config.mousemove && e.preventDefault();
    }
    __onMouseUp(e) {
        this.step.is($a42f1354f0348298$var$Iy.CLICK, $a42f1354f0348298$var$Iy.MOVING) && this.__stopMove(e.clientX, e.clientY, e, 2 === e.button);
    }
    __onMouseMove(e) {
        this.config.mousemove && this.step.is($a42f1354f0348298$var$Iy.CLICK, $a42f1354f0348298$var$Iy.MOVING) && (e.preventDefault(), this.__doMove(e.clientX, e.clientY)), this.__handleObjectsEvents(e);
    }
    __onTouchStart(e) {
        1 === e.touches.length ? (this.step.add($a42f1354f0348298$var$Iy.CLICK), this.data.startMouseX = e.touches[0].clientX, this.data.startMouseY = e.touches[0].clientY, this.data.longtouchTimeout || (this.data.longtouchTimeout = setTimeout(()=>{
            const t = e.touches[0];
            this.__stopMove(t.clientX, t.clientY, e, !0), this.data.longtouchTimeout = null;
        }, $a42f1354f0348298$var$$f))) : 2 === e.touches.length && (this.step.set($a42f1354f0348298$var$Iy.IDLE), this.__cancelLongTouch(), this.config.mousemove && (this.__cancelTwoFingersOverlay(), this.__startMoveZoom(e), e.preventDefault()));
    }
    __onTouchEnd(e) {
        if (this.__cancelLongTouch(), this.step.is($a42f1354f0348298$var$Iy.CLICK, $a42f1354f0348298$var$Iy.MOVING)) {
            if (e.preventDefault(), this.__cancelTwoFingersOverlay(), 1 === e.touches.length) this.__stopMove(this.data.mouseX, this.data.mouseY);
            else if (0 === e.touches.length) {
                const t = e.changedTouches[0];
                this.__stopMove(t.clientX, t.clientY, e);
            }
        }
    }
    __onTouchMove(e) {
        if (this.__cancelLongTouch(), this.config.mousemove) {
            if (1 === e.touches.length) {
                if (this.config.touchmoveTwoFingers) this.step.is($a42f1354f0348298$var$Iy.CLICK) && !this.data.twofingersTimeout && (this.data.twofingersTimeout = setTimeout(()=>{
                    this.viewer.overlay.show({
                        id: $a42f1354f0348298$var$s_.TWO_FINGERS,
                        image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/>\x3c!--Created by AomAm from the Noun Project--\x3e</svg>\n',
                        title: this.config.lang.twoFingers
                    });
                }, $a42f1354f0348298$var$e_));
                else if (this.step.is($a42f1354f0348298$var$Iy.CLICK, $a42f1354f0348298$var$Iy.MOVING)) {
                    e.preventDefault();
                    const t = e.touches[0];
                    this.__doMove(t.clientX, t.clientY);
                }
            } else this.__doMoveZoom(e), this.__cancelTwoFingersOverlay();
        }
    }
    __cancelLongTouch() {
        this.data.longtouchTimeout && (clearTimeout(this.data.longtouchTimeout), this.data.longtouchTimeout = null);
    }
    __cancelTwoFingersOverlay() {
        this.config.touchmoveTwoFingers && (this.data.twofingersTimeout && (clearTimeout(this.data.twofingersTimeout), this.data.twofingersTimeout = null), this.viewer.overlay.hide($a42f1354f0348298$var$s_.TWO_FINGERS));
    }
    __onMouseWheel(e) {
        if (!this.config.mousewheel || !e.deltaY) return;
        if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) return this.viewer.overlay.show({
            id: $a42f1354f0348298$var$s_.CTRL_ZOOM,
            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/>\x3c!-- Created by Icon Island from the Noun Project --\x3e</svg>\n',
            title: this.config.lang.ctrlZoom
        }), clearTimeout(this.data.ctrlZoomTimeout), void (this.data.ctrlZoomTimeout = setTimeout(()=>this.viewer.overlay.hide($a42f1354f0348298$var$s_.CTRL_ZOOM), $a42f1354f0348298$var$t_));
        e.preventDefault(), e.stopPropagation();
        const t = e.deltaY / Math.abs(e.deltaY) * 5 * this.config.zoomSpeed;
        0 !== t && this.viewer.dynamics.zoom.step(-t, 5);
    }
    __onFullscreenChange() {
        const e = this.viewer.isFullscreenEnabled();
        "fullscreen" === this.config.keyboard && (e ? this.viewer.startKeyboardControl() : this.viewer.stopKeyboardControl()), this.viewer.dispatchEvent(new $a42f1354f0348298$var$Gv(e));
    }
    __resetMove() {
        this.step.set($a42f1354f0348298$var$Iy.IDLE), this.data.mouseX = 0, this.data.mouseY = 0, this.data.startMouseX = 0, this.data.startMouseY = 0;
    }
    __startMoveZoom(e) {
        this.viewer.stopAll(), this.__resetMove();
        const t = $a42f1354f0348298$var$C_(e);
        this.step.set($a42f1354f0348298$var$Iy.MOVING), this.data.accumulatorFactor = this.config.moveInertia, { distance: this.data.pinchDist, center: { x: this.data.mouseX, y: this.data.mouseY } } = t;
    }
    __stopMove(e, t, i, n = !1) {
        this.step.is($a42f1354f0348298$var$Iy.CLICK) && !this.__moveThresholdReached(e, t) && this.__doClick(e, t, i, n), this.config.moveInertia && (this.data.accumulatorFactor = Math.pow(this.config.moveInertia, .5)), this.__resetMove(), this.viewer.resetIdleTimer();
    }
    __doClick(e, t, i, n = !1) {
        const a = this.viewer.container.getBoundingClientRect(), r = e - a.left, s = t - a.top, o = this.viewer.renderer.getIntersections({
            x: r,
            y: s
        }), l = o.find((e)=>e.object.userData[$a42f1354f0348298$var$n_]);
        if (l) {
            const a = this.viewer.dataHelper.vector3ToSphericalCoords(l.point), c = {
                rightclick: n,
                originalEvent: i,
                target: $a42f1354f0348298$var$x_(i),
                clientX: e,
                clientY: t,
                viewerX: r,
                viewerY: s,
                yaw: a.yaw,
                pitch: a.pitch,
                objects: o.map((e)=>e.object).filter((e)=>!e.userData[$a42f1354f0348298$var$n_])
            };
            try {
                const e = this.viewer.dataHelper.sphericalCoordsToTextureCoords(c);
                Object.assign(c, e);
            } catch  {}
            this.data.dblclickTimeout ? (Math.abs(this.data.dblclickData.clientX - c.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - c.clientY) < this.moveThreshold && this.viewer.dispatchEvent(new $a42f1354f0348298$var$Ov(this.data.dblclickData)), clearTimeout(this.data.dblclickTimeout), this.data.dblclickTimeout = null, this.data.dblclickData = null) : (this.viewer.dispatchEvent(new $a42f1354f0348298$var$Fv(c)), this.data.dblclickData = $a42f1354f0348298$var$U_(c), this.data.dblclickTimeout = setTimeout(()=>{
                this.data.dblclickTimeout = null, this.data.dblclickData = null;
            }, $a42f1354f0348298$var$Jf));
        }
    }
    __handleObjectsEvents(e) {
        if (!$a42f1354f0348298$var$N_(this.state.objectsObservers) && e.composedPath().includes(this.viewer.container)) {
            const t = $a42f1354f0348298$var$M_(this.viewer.container), i = {
                x: e.clientX - t.x,
                y: e.clientY - t.y
            }, n = this.viewer.renderer.getIntersections(i), a = (t, n, a)=>{
                this.viewer.dispatchEvent(new a(e, t, i, n));
            };
            for (const [e, t] of Object.entries(this.state.objectsObservers)){
                const i = n.find((t)=>t.object.userData[e]);
                i ? (t && i.object !== t && (a(t, e, $a42f1354f0348298$var$zE), this.state.objectsObservers[e] = null), t ? a(i.object, e, $a42f1354f0348298$var$UE) : (this.state.objectsObservers[e] = i.object, a(i.object, e, $a42f1354f0348298$var$LE))) : t && (a(t, e, $a42f1354f0348298$var$zE), this.state.objectsObservers[e] = null);
            }
        }
    }
    __doMove(e, t) {
        if (this.step.is($a42f1354f0348298$var$Iy.CLICK) && this.__moveThresholdReached(e, t)) this.viewer.stopAll(), this.__resetMove(), this.step.set($a42f1354f0348298$var$Iy.MOVING), this.data.mouseX = e, this.data.mouseY = t, this.data.accumulatorFactor = this.config.moveInertia;
        else if (this.step.is($a42f1354f0348298$var$Iy.MOVING)) {
            const i = (e - this.data.mouseX) * Math.cos(this.state.roll) - (t - this.data.mouseY) * Math.sin(this.state.roll), n = (t - this.data.mouseY) * Math.cos(this.state.roll) + (e - this.data.mouseX) * Math.sin(this.state.roll), a = {
                yaw: this.config.moveSpeed * (i / this.state.size.width) * $a42f1354f0348298$var$lu.degToRad(this.state.hFov),
                pitch: this.config.moveSpeed * (n / this.state.size.height) * $a42f1354f0348298$var$lu.degToRad(this.state.vFov)
            };
            this.data.moveDelta.yaw += a.yaw, this.data.moveDelta.pitch += a.pitch, this.data.mouseX = e, this.data.mouseY = t;
        }
    }
    __moveThresholdReached(e, t) {
        return Math.abs(e - this.data.startMouseX) >= this.moveThreshold || Math.abs(t - this.data.startMouseY) >= this.moveThreshold;
    }
    __doMoveZoom(e) {
        if (this.step.is($a42f1354f0348298$var$Iy.MOVING)) {
            e.preventDefault();
            const t = $a42f1354f0348298$var$C_(e);
            this.__doMove(t.center.x, t.center.y), this.data.moveDelta.zoom += this.config.zoomSpeed * ((t.distance - this.data.pinchDist) / $a42f1354f0348298$var$Av.pixelRatio), this.data.pinchDist = t.distance;
        }
    }
    __applyMoveDelta() {
        const e = .001;
        if (Math.abs(this.data.moveDelta.yaw) > 0 || Math.abs(this.data.moveDelta.pitch) > 0) {
            const t = this.viewer.getPosition();
            this.viewer.rotate({
                yaw: t.yaw - this.data.moveDelta.yaw * (1 - this.config.moveInertia),
                pitch: t.pitch + this.data.moveDelta.pitch * (1 - this.config.moveInertia)
            }), this.data.moveDelta.yaw *= this.data.accumulatorFactor, this.data.moveDelta.pitch *= this.data.accumulatorFactor, Math.abs(this.data.moveDelta.yaw) <= e && (this.data.moveDelta.yaw = 0), Math.abs(this.data.moveDelta.pitch) <= e && (this.data.moveDelta.pitch = 0);
        }
        if (Math.abs(this.data.moveDelta.zoom) > 0) {
            const t = this.viewer.getZoomLevel();
            this.viewer.zoom(t + this.data.moveDelta.zoom * (1 - this.config.moveInertia)), this.data.moveDelta.zoom *= this.config.moveInertia, Math.abs(this.data.moveDelta.zoom) <= e && (this.data.moveDelta.zoom = 0);
        }
    }
    __clearMoveDelta() {
        this.data.moveDelta.yaw = 0, this.data.moveDelta.pitch = 0, this.data.moveDelta.zoom = 0;
    }
};
$a42f1354f0348298$var$vu.enabled = !1;
var $a42f1354f0348298$var$Ry = new $a42f1354f0348298$var$cu, $a42f1354f0348298$var$zy = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$Fy = new $a42f1354f0348298$var$Lh, $a42f1354f0348298$var$Uy = class extends $a42f1354f0348298$var$Sy {
    constructor(e){
        super(e), this.frustumNeedsUpdate = !0, this.renderer = new $a42f1354f0348298$var$qf(this.config.rendererParameters), this.renderer.setPixelRatio($a42f1354f0348298$var$Av.pixelRatio), this.renderer.outputColorSpace = $a42f1354f0348298$var$Sd, this.renderer.toneMapping = 1, this.renderer.domElement.className = "psv-canvas", this.renderer.domElement.style.background = this.config.canvasBackground, this.scene = new $a42f1354f0348298$var$_h, this.camera = new $a42f1354f0348298$var$jA(50, 16 / 9, .1, 2 * $a42f1354f0348298$var$i_), this.camera.matrixAutoUpdate = !1;
        const t = new $a42f1354f0348298$var$zp(new $a42f1354f0348298$var$hA($a42f1354f0348298$var$i_).scale(-1, 1, 1), new $a42f1354f0348298$var$kp({
            opacity: 0,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1
        }));
        t.userData = {
            [$a42f1354f0348298$var$n_]: !0
        }, this.scene.add(t), this.raycaster = new $a42f1354f0348298$var$WA, this.frustum = new $a42f1354f0348298$var$qp, this.container = document.createElement("div"), this.container.className = "psv-canvas-container", this.container.appendChild(this.renderer.domElement), this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.viewer.addEventListener($a42f1354f0348298$var$ME.type, this), this.viewer.addEventListener($a42f1354f0348298$var$DE.type, this), this.viewer.addEventListener($a42f1354f0348298$var$dE.type, this), this.viewer.addEventListener($a42f1354f0348298$var$hE.type, this), this.viewer.addEventListener($a42f1354f0348298$var$Nv.type, this), this.hide();
    }
    get panoramaPose() {
        return this.mesh.rotation;
    }
    get sphereCorrection() {
        return this.meshContainer.rotation;
    }
    init() {
        this.show(), this.renderer.setAnimationLoop((e)=>this.__renderLoop(e));
    }
    destroy() {
        this.renderer.setAnimationLoop(null), this.cleanScene(this.scene), this.renderer.dispose(), this.viewer.container.removeChild(this.container), this.viewer.removeEventListener($a42f1354f0348298$var$ME.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$DE.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$dE.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$hE.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$Nv.type, this), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case $a42f1354f0348298$var$ME.type:
                this.__onSizeUpdated();
                break;
            case $a42f1354f0348298$var$DE.type:
                this.__onZoomUpdated();
                break;
            case $a42f1354f0348298$var$dE.type:
            case $a42f1354f0348298$var$hE.type:
                this.__onPositionUpdated();
                break;
            case $a42f1354f0348298$var$Nv.type:
                e.containsOptions("fisheye") && this.__onPositionUpdated(), e.containsOptions("canvasBackground") && (this.renderer.domElement.style.background = this.config.canvasBackground);
        }
    }
    hide() {
        this.container.style.opacity = "0";
    }
    show() {
        this.container.style.opacity = "1";
    }
    setCustomRenderer(e) {
        this.customRenderer = e ? e(this.renderer) : null, this.viewer.needsUpdate();
    }
    __onSizeUpdated() {
        this.renderer.setSize(this.state.size.width, this.state.size.height), this.camera.aspect = this.state.aspect, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
    }
    __onZoomUpdated() {
        this.camera.fov = this.state.vFov, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
    }
    __onPositionUpdated() {
        this.camera.position.set(0, 0, 0), this.camera.lookAt(this.state.direction), this.config.fisheye && this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate(), this.camera.rotateZ(-this.state.roll), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
    }
    __renderLoop(e) {
        const t = this.timestamp ? e - this.timestamp : 0;
        this.timestamp = e, this.viewer.dispatchEvent(new $a42f1354f0348298$var$Iv(e, t)), this.viewer.dynamics.update(t), (this.state.needsUpdate || this.state.continuousUpdateCount > 0) && (this.state.needsUpdate = !1, (this.customRenderer || this.renderer).render(this.scene, this.camera), this.viewer.dispatchEvent(new $a42f1354f0348298$var$gE));
    }
    setTexture(e) {
        this.meshContainer || (this.meshContainer = new $a42f1354f0348298$var$ch, this.scene.add(this.meshContainer)), this.state.textureData && this.viewer.adapter.disposeTexture(this.state.textureData), this.mesh && (this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh)), this.mesh = this.viewer.adapter.createMesh(e.panoData), this.viewer.adapter.setTexture(this.mesh, e, !1), this.meshContainer.add(this.mesh), this.state.textureData = e, this.viewer.needsUpdate();
    }
    setPanoramaPose(e, t = this.mesh) {
        const i = this.viewer.dataHelper.cleanPanoramaPose(e);
        t.rotation.set(-i.tilt, -i.pan, i.roll, "YXZ");
    }
    setSphereCorrection(e, t = this.meshContainer) {
        const i = this.viewer.dataHelper.cleanSphereCorrection(e);
        t.rotation.set(i.tilt, i.pan, i.roll, "YXZ");
    }
    transition(e, t, i) {
        const n = "fade" === i.effect || i.rotation, a = !$a42f1354f0348298$var$B_(t.position), r = !$a42f1354f0348298$var$B_(t.zoom), s = new $a42f1354f0348298$var$Dv(a ? this.viewer.dataHelper.cleanPosition(t.position) : void 0, t.zoom);
        this.viewer.dispatchEvent(s);
        const o = new $a42f1354f0348298$var$ch, l = this.viewer.adapter.createMesh(e.panoData);
        if (this.viewer.adapter.setTexture(l, e, !0), this.viewer.adapter.setTextureOpacity(l, 0), this.setPanoramaPose(e.panoData, l), this.setSphereCorrection(t.sphereCorrection, o), a && !i.rotation) {
            const e = this.viewer.getPosition(), t = new $a42f1354f0348298$var$uu(0, 1, 0);
            o.rotateOnWorldAxis(t, s.position.yaw - e.yaw);
            const i = new $a42f1354f0348298$var$uu(0, 1, 0).cross(this.camera.getWorldDirection(new $a42f1354f0348298$var$uu)).normalize();
            o.rotateOnWorldAxis(i, s.position.pitch - e.pitch);
        }
        o.add(l), this.scene.add(o);
        const c = new $a42f1354f0348298$var$Iu;
        this.renderer.setRenderTarget(c), this.renderer.render(this.scene, this.camera), this.renderer.setRenderTarget(null), c.dispose();
        const { duration: d, properties: u } = this.viewer.dataHelper.getAnimationProperties(i.speed, i.rotation ? s.position : null, n ? s.zoomLevel : null), h = new $a42f1354f0348298$var$vv({
            properties: {
                ...u,
                opacity: {
                    start: 0,
                    end: 1
                }
            },
            duration: d,
            easing: "inOutCubic",
            onTick: (e)=>{
                switch(i.effect){
                    case "fade":
                        this.viewer.adapter.setTextureOpacity(l, e.opacity);
                        break;
                    case "black":
                    case "white":
                        e.opacity < .5 ? this.renderer.toneMappingExposure = "black" === i.effect ? $a42f1354f0348298$var$lu.mapLinear(e.opacity, 0, .5, 1, 0) : $a42f1354f0348298$var$lu.mapLinear(e.opacity, 0, .5, 1, 5) : (this.renderer.toneMappingExposure = "black" === i.effect ? $a42f1354f0348298$var$lu.mapLinear(e.opacity, .5, 1, 0, 1) : $a42f1354f0348298$var$lu.mapLinear(e.opacity, .5, 1, 5, 1), this.mesh.visible = !1, this.viewer.adapter.setTextureOpacity(l, 1), r && !n && this.viewer.dynamics.zoom.setValue(s.zoomLevel));
                }
                a && i.rotation && this.viewer.dynamics.position.setValue({
                    yaw: e.yaw,
                    pitch: e.pitch
                }), r && n && this.viewer.dynamics.zoom.setValue(e.zoom), this.viewer.needsUpdate();
            }
        });
        return h.then((n)=>{
            o.remove(l), this.scene.remove(o), n ? (this.viewer.adapter.disposeTexture(this.state.textureData), this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh), this.mesh = l, this.meshContainer.add(l), this.state.textureData = e, this.setPanoramaPose(e.panoData), this.setSphereCorrection(t.sphereCorrection), a && !i.rotation && this.viewer.rotate(t.position)) : (this.viewer.adapter.disposeTexture(e), this.viewer.adapter.disposeMesh(l));
        }), h;
    }
    getIntersections(e) {
        $a42f1354f0348298$var$Ry.x = 2 * e.x / this.state.size.width - 1, $a42f1354f0348298$var$Ry.y = -2 * e.y / this.state.size.height + 1, this.raycaster.setFromCamera($a42f1354f0348298$var$Ry, this.camera);
        const t = this.raycaster.intersectObjects(this.scene.children, !0).filter((e)=>e.object.visible).filter((e)=>e.object.isMesh && !!e.object.userData);
        return this.customRenderer?.getIntersections && t.push(...this.customRenderer.getIntersections(this.raycaster, $a42f1354f0348298$var$Ry)), t;
    }
    isObjectVisible(e) {
        if (!e) return !1;
        if (this.frustumNeedsUpdate && ($a42f1354f0348298$var$zy.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse), this.frustum.setFromProjectionMatrix($a42f1354f0348298$var$zy), this.frustumNeedsUpdate = !1), e.isVector3) return this.frustum.containsPoint(e);
        if (e.isMesh && e.geometry) {
            const t = e;
            return t.geometry.boundingBox || t.geometry.computeBoundingBox(), $a42f1354f0348298$var$Fy.copy(t.geometry.boundingBox).applyMatrix4(t.matrixWorld), this.frustum.intersectsBox($a42f1354f0348298$var$Fy);
        }
        return !!e.isObject3D && this.frustum.intersectsObject(e);
    }
    addObject(e) {
        this.scene.add(e);
    }
    removeObject(e) {
        this.scene.remove(e);
    }
    cleanScene(e) {
        const t = (e)=>{
            e.map?.dispose(), e.uniforms && Object.values(e.uniforms).forEach((e)=>{
                e.value?.dispose?.();
            }), e.dispose();
        };
        e.traverse((i)=>{
            i.geometry?.dispose(), i.material && (Array.isArray(i.material) ? i.material.forEach((e)=>{
                t(e);
            }) : t(i.material)), i instanceof $a42f1354f0348298$var$_h || i.dispose?.(), i !== e && this.cleanScene(i);
        });
    }
}, $a42f1354f0348298$var$Ny = class extends $a42f1354f0348298$var$LA {
    constructor(){
        super(...arguments), this._abortController = new AbortController;
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
    load(e, t, i, n) {
        const a = this._abortController.signal, r = super.load(e, (e)=>{
            o(), t(e);
        }, i, (e)=>{
            if (o(), a.aborted) {
                const e = new Error;
                e.name = "AbortError", e.message = "The operation was aborted.", n(e);
            } else n(e);
        });
        function s() {
            r.src = "";
        }
        function o() {
            a.removeEventListener("abort", s, !1);
        }
        return a.addEventListener("abort", s, !1), r;
    }
}, $a42f1354f0348298$var$By = class extends $a42f1354f0348298$var$Sy {
    constructor(e){
        super(e), this.fileLoader = new $a42f1354f0348298$var$PA, this.fileLoader.setResponseType("blob"), this.imageLoader = new $a42f1354f0348298$var$Ny;
    }
    destroy() {
        this.abortLoading(), super.destroy();
    }
    abortLoading() {
        this.fileLoader.abort?.(), this.imageLoader.abort();
    }
    loadFile(e, t, i) {
        const n = $a42f1354f0348298$var$Ey.get(e, i);
        if (n) {
            if (n instanceof Blob) return t?.(100), Promise.resolve(n);
            $a42f1354f0348298$var$Ey.remove(e, i);
        }
        this.config.requestHeaders && this.fileLoader.setRequestHeader(this.config.requestHeaders(e)), this.fileLoader.setWithCredentials(this.config.withCredentials(e));
        let a = 0;
        return t?.(a), this.fileLoader.loadAsync(e, (e)=>{
            if (e.lengthComputable) {
                const i = e.loaded / e.total * 100;
                i > a && (a = i, t?.(a));
            }
        }).then((n)=>(a = 100, t?.(a), $a42f1354f0348298$var$Ey.add(e, i, n), n));
    }
    loadImage(e, t, i) {
        const n = $a42f1354f0348298$var$Ey.get(e, i);
        return n ? (t?.(100), n instanceof Blob ? this.blobToImage(n) : Promise.resolve(n)) : t || this.config.requestHeaders ? this.loadFile(e, t, i).then((e)=>this.blobToImage(e)) : (this.imageLoader.setWithCredentials(this.config.withCredentials(e)), this.imageLoader.loadAsync(e).then((t)=>($a42f1354f0348298$var$Ey.add(e, i, t), t)));
    }
    blobToImage(e) {
        return new Promise((t, i)=>{
            const n = document.createElement("img");
            n.onload = ()=>{
                URL.revokeObjectURL(n.src), t(n);
            }, n.onerror = i, n.src = URL.createObjectURL(e);
        });
    }
    preloadPanorama(e) {
        return this.viewer.adapter.supportsPreload(e) ? this.viewer.adapter.loadTexture(e, !1) : Promise.reject(new $a42f1354f0348298$var$V_("Current adapter does not support preload"));
    }
    dispatchProgress(e) {
        this.viewer.loader.setProgress(e), this.viewer.dispatchEvent(new $a42f1354f0348298$var$eE(Math.round(e)));
    }
}, $a42f1354f0348298$var$Oy = class extends $a42f1354f0348298$var$Sy {
    constructor(e){
        super(e), this.zoom = new $a42f1354f0348298$var$Ev((e)=>{
            this.viewer.state.vFov = this.viewer.dataHelper.zoomLevelToFov(e), this.viewer.state.hFov = this.viewer.dataHelper.vFovToHFov(this.viewer.state.vFov), this.viewer.dispatchEvent(new $a42f1354f0348298$var$DE(e));
        }, {
            defaultValue: this.viewer.config.defaultZoomLvl,
            min: 0,
            max: 100,
            wrap: !1
        }), this.position = new $a42f1354f0348298$var$yv((e)=>{
            this.viewer.dataHelper.sphericalCoordsToVector3(e, this.viewer.state.direction), this.viewer.dispatchEvent(new $a42f1354f0348298$var$dE(e));
        }, {
            yaw: new $a42f1354f0348298$var$Ev(null, {
                defaultValue: this.config.defaultYaw,
                min: 0,
                max: 2 * Math.PI,
                wrap: !0
            }),
            pitch: new $a42f1354f0348298$var$Ev(null, {
                defaultValue: this.config.defaultPitch,
                min: -Math.PI / 2,
                max: Math.PI / 2,
                wrap: !1
            })
        }), this.roll = new $a42f1354f0348298$var$Ev((e)=>{
            this.viewer.state.roll = e, this.viewer.dispatchEvent(new $a42f1354f0348298$var$hE(e));
        }, {
            defaultValue: 0,
            min: -Math.PI,
            max: Math.PI,
            wrap: !1
        }), this.updateSpeeds();
    }
    updateSpeeds() {
        this.zoom.setSpeed(50 * this.config.zoomSpeed), this.position.setSpeed($a42f1354f0348298$var$lu.degToRad(50 * this.config.moveSpeed)), this.roll.setSpeed($a42f1354f0348298$var$lu.degToRad(50 * this.config.moveSpeed));
    }
    update(e) {
        this.zoom.update(e), this.position.update(e), this.roll.update(e);
    }
}, $a42f1354f0348298$var$jy = class {
    constructor(){
        this.ready = !1, this.needsUpdate = !1, this.continuousUpdateCount = 0, this.keyboardEnabled = !1, this.direction = new $a42f1354f0348298$var$uu(0, 0, $a42f1354f0348298$var$i_), this.roll = 0, this.vFov = 60, this.hFov = 60, this.aspect = 1, this.animation = null, this.transitionAnimation = null, this.loadingPromise = null, this.idleTime = -1, this.objectsObservers = {}, this.size = {
            width: 0,
            height: 0
        };
    }
}, $a42f1354f0348298$var$Gy = class extends $a42f1354f0348298$var$Sv {
    constructor(e){
        if (super(), this.plugins = {}, this.children = [], this.parent = $a42f1354f0348298$var$__(e.container), !this.parent) throw new $a42f1354f0348298$var$V_('"container" element not found.');
        this.parent[$a42f1354f0348298$var$n_] = this, this.container = document.createElement("div"), this.container.classList.add("psv-container"), this.parent.appendChild(this.container), $a42f1354f0348298$var$uv(this.parent), $a42f1354f0348298$var$cv(this.container, "core"), this.state = new $a42f1354f0348298$var$jy, this.config = $a42f1354f0348298$var$Ay(e), this.__setSize(this.config.size), this.overlay = new $a42f1354f0348298$var$ky(this);
        try {
            $a42f1354f0348298$var$Av.load();
        } catch (e) {
            return console.error(e), void this.showError(this.config.lang.webglError);
        }
        $a42f1354f0348298$var$Ey.init(), this.adapter = new this.config.adapter[0](this, this.config.adapter[1]), this.renderer = new $a42f1354f0348298$var$Uy(this), this.textureLoader = new $a42f1354f0348298$var$By(this), this.eventsHandler = new $a42f1354f0348298$var$Ly(this), this.dataHelper = new $a42f1354f0348298$var$Dy(this), this.dynamics = new $a42f1354f0348298$var$Oy(this), this.adapter.init?.(), this.loader = new $a42f1354f0348298$var$yy(this), this.navbar = new $a42f1354f0348298$var$vy(this), this.panel = new $a42f1354f0348298$var$wy(this), this.notification = new $a42f1354f0348298$var$by(this), this.autoSize(), this.setCursor(null), $a42f1354f0348298$var$H_($a42f1354f0348298$var$Av.isTouchEnabled, (e)=>{
            $a42f1354f0348298$var$v_(this.container, "psv--is-touch", e);
        }), this.config.plugins.forEach(([e, t])=>{
            this.plugins[e.id] = new e(this, t);
        });
        for (const e of Object.values(this.plugins))e.init?.();
        this.config.navbar && this.navbar.setButtons(this.config.navbar), this.state.loadingPromise || (this.config.panorama ? this.setPanorama(this.config.panorama, {
            sphereCorrection: this.config.sphereCorrection,
            panoData: this.config.panoData
        }) : this.loader.show());
    }
    destroy() {
        this.stopAll(), this.stopKeyboardControl(), this.exitFullscreen();
        for (const [e, t] of Object.entries(this.plugins))t.destroy(), delete this.plugins[e];
        this.children.slice().forEach((e)=>e.destroy()), this.children.length = 0, this.eventsHandler?.destroy(), this.renderer?.destroy(), this.textureLoader?.destroy(), this.dataHelper?.destroy(), this.adapter?.destroy(), this.dynamics?.destroy(), this.parent.removeChild(this.container), delete this.parent[$a42f1354f0348298$var$n_];
    }
    init() {
        this.eventsHandler.init(), this.renderer.init(), this.config.navbar && this.navbar.show(), "always" === this.config.keyboard && this.startKeyboardControl(), this.resetIdleTimer(), this.state.ready = !0, this.dispatchEvent(new $a42f1354f0348298$var$AE);
    }
    resetIdleTimer() {
        this.state.idleTime = performance.now();
    }
    disableIdleTimer() {
        this.state.idleTime = -1;
    }
    getPlugin(e) {
        if ("string" == typeof e) return this.plugins[e];
        {
            const t = $a42f1354f0348298$var$dy(e);
            return t ? this.plugins[t.id] : null;
        }
    }
    getPosition() {
        return this.dataHelper.cleanPosition(this.dynamics.position.current);
    }
    getZoomLevel() {
        return this.dynamics.zoom.current;
    }
    getSize() {
        return {
            ...this.state.size
        };
    }
    isFullscreenEnabled() {
        return $a42f1354f0348298$var$T_(this.parent, $a42f1354f0348298$var$Av.isIphone);
    }
    needsUpdate() {
        this.state.needsUpdate = !0;
    }
    needsContinuousUpdate(e) {
        e ? this.state.continuousUpdateCount++ : this.state.continuousUpdateCount > 0 && this.state.continuousUpdateCount--;
    }
    autoSize() {
        this.container.clientWidth === this.state.size.width && this.container.clientHeight === this.state.size.height || (this.state.size.width = Math.round(this.container.clientWidth), this.state.size.height = Math.round(this.container.clientHeight), this.state.aspect = this.state.size.width / this.state.size.height, this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov), this.dispatchEvent(new $a42f1354f0348298$var$ME(this.getSize())), this.navbar.autoSize());
    }
    setPanorama(e, t = {}) {
        this.textureLoader.abortLoading(), this.state.transitionAnimation?.cancel();
        const i = this.dataHelper.getTransitionOptions(t);
        void 0 === t.showLoader && (t.showLoader = !0), void 0 === t.caption && (t.caption = this.config.caption), void 0 === t.description && (t.description = this.config.description), t.panoData || "function" != typeof this.config.panoData || (t.panoData = this.config.panoData), void 0 === t.sphereCorrection && (t.sphereCorrection = this.config.sphereCorrection), this.hideError(), this.resetIdleTimer(), this.config.panorama = e, this.config.caption = t.caption, this.config.description = t.description, this.config.sphereCorrection = t.sphereCorrection, "function" == typeof this.config.panoData && "function" != typeof t.panoData || (this.config.panoData = t.panoData);
        const n = (t)=>{
            if ($a42f1354f0348298$var$W_(t)) return !1;
            if (this.loader.hide(), this.state.loadingPromise = null, t) throw this.navbar.setCaption(null), this.showError(this.config.lang.loadError), console.error(t), this.dispatchEvent(new $a42f1354f0348298$var$sE(e, t)), t;
            return this.navbar.setCaption(this.config.caption), !0;
        };
        this.navbar.setCaption(`<em>${this.config.lang.loading}</em>`), !t.showLoader && this.state.ready || this.loader.show(), this.dispatchEvent(new $a42f1354f0348298$var$iE(e));
        const a = this.adapter.loadTexture(this.config.panorama, !0, t.panoData).then((e)=>{
            if (e.panorama !== this.config.panorama) throw this.adapter.disposeTexture(e), $a42f1354f0348298$var$K_();
            const i = this.dataHelper.cleanPanoramaOptions(t, e.panoData);
            return $a42f1354f0348298$var$B_(i.zoom) && $a42f1354f0348298$var$B_(i.position) || this.stopAll(), {
                textureData: e,
                cleanOptions: i
            };
        });
        return i && this.state.ready && this.adapter.supportsTransition(this.config.panorama) ? this.state.loadingPromise = a.then(({ textureData: e, cleanOptions: t })=>(this.loader.hide(), this.dispatchEvent(new $a42f1354f0348298$var$aE(e)), this.state.transitionAnimation = this.renderer.transition(e, t, i), this.state.transitionAnimation)).then((e)=>{
            if (this.state.transitionAnimation = null, this.dispatchEvent(new $a42f1354f0348298$var$lE(e)), !e) throw $a42f1354f0348298$var$K_();
        }).then(()=>n(), (e)=>n(e)) : this.state.loadingPromise = a.then(({ textureData: e, cleanOptions: i })=>{
            this.renderer.show(), this.renderer.setTexture(e), this.renderer.setPanoramaPose(e.panoData), this.renderer.setSphereCorrection(t.sphereCorrection), this.state.ready || this.init(), this.dispatchEvent(new $a42f1354f0348298$var$aE(e)), $a42f1354f0348298$var$B_(i.zoom) || this.zoom(i.zoom), $a42f1354f0348298$var$B_(i.position) || this.rotate(i.position);
        }).then(()=>n(), (e)=>n(e)), this.state.loadingPromise;
    }
    setOptions(e) {
        const t = {
            ...this.config,
            ...e
        };
        for (let [i, n] of Object.entries(e))if (i in $a42f1354f0348298$var$uy) {
            if (i in $a42f1354f0348298$var$hy) $a42f1354f0348298$var$X_($a42f1354f0348298$var$hy[i]);
            else switch(i in $a42f1354f0348298$var$py && (n = $a42f1354f0348298$var$py[i](n, {
                rawConfig: t,
                defValue: $a42f1354f0348298$var$uy[i]
            })), this.config[i] = n, i){
                case "mousemove":
                    this.state.cursorOverride || this.setCursor(null);
                    break;
                case "caption":
                    this.navbar.setCaption(this.config.caption);
                    break;
                case "size":
                    this.resize(this.config.size);
                    break;
                case "sphereCorrection":
                    this.renderer.setSphereCorrection(this.config.sphereCorrection);
                    break;
                case "navbar":
                case "lang":
                    this.navbar.setButtons(this.config.navbar);
                    break;
                case "moveSpeed":
                case "zoomSpeed":
                    this.dynamics.updateSpeeds();
                    break;
                case "minFov":
                case "maxFov":
                    this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov)), this.dispatchEvent(new $a42f1354f0348298$var$DE(this.getZoomLevel()));
                    break;
                case "keyboard":
                    "always" === this.config.keyboard ? this.startKeyboardControl() : this.stopKeyboardControl();
            }
        } else $a42f1354f0348298$var$X_(`Unknown option ${i}`);
        this.needsUpdate(), this.dispatchEvent(new $a42f1354f0348298$var$Nv(Object.keys(e)));
    }
    setOption(e, t) {
        this.setOptions({
            [e]: t
        });
    }
    showError(e) {
        this.overlay.show({
            id: $a42f1354f0348298$var$s_.ERROR,
            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/>\x3c!--Created by Shastry from the Noun Project--\x3e</svg>\n',
            title: e,
            dismissible: !1
        });
    }
    hideError() {
        this.overlay.hide($a42f1354f0348298$var$s_.ERROR);
    }
    rotate(e) {
        const t = new $a42f1354f0348298$var$Rv(this.dataHelper.cleanPosition(e));
        this.dispatchEvent(t), t.defaultPrevented || this.dynamics.position.setValue(t.position);
    }
    zoom(e) {
        this.dynamics.zoom.setValue(e);
    }
    zoomIn(e = 1) {
        this.dynamics.zoom.step(e);
    }
    zoomOut(e = 1) {
        this.dynamics.zoom.step(-e);
    }
    animate(e) {
        const t = $a42f1354f0348298$var$Q_(e), i = !$a42f1354f0348298$var$B_(e.zoom), n = new $a42f1354f0348298$var$Dv(t ? this.dataHelper.cleanPosition(e) : void 0, e.zoom);
        if (this.dispatchEvent(n), n.defaultPrevented) return;
        this.stopAll();
        const { duration: a, properties: r } = this.dataHelper.getAnimationProperties(e.speed, n.position, n.zoomLevel);
        return a ? (this.state.animation = new $a42f1354f0348298$var$vv({
            properties: r,
            duration: a,
            easing: e.easing || "inOutSine",
            onTick: (e)=>{
                t && this.dynamics.position.setValue({
                    yaw: e.yaw,
                    pitch: e.pitch
                }), i && this.dynamics.zoom.setValue(e.zoom);
            }
        }), this.state.animation.then(()=>{
            this.state.animation = null, this.resetIdleTimer();
        }), this.state.animation) : (t && this.rotate(n.position), i && this.zoom(n.zoomLevel), new $a42f1354f0348298$var$vv(null));
    }
    stopAnimation() {
        return this.state.animation ? (this.state.animation.cancel(), this.state.animation) : Promise.resolve();
    }
    resize(e) {
        this.__setSize(e), this.autoSize();
    }
    __setSize(e) {
        [
            "width",
            "height"
        ].forEach((t)=>{
            e?.[t] && (/^[0-9.]+$/.test(e[t]) && (e[t] += "px"), this.parent.style[t] = e[t]);
        });
    }
    enterFullscreen() {
        this.isFullscreenEnabled() || $a42f1354f0348298$var$D_(this.parent, $a42f1354f0348298$var$Av.isIphone);
    }
    exitFullscreen() {
        this.isFullscreenEnabled() && $a42f1354f0348298$var$P_($a42f1354f0348298$var$Av.isIphone);
    }
    toggleFullscreen() {
        this.isFullscreenEnabled() ? this.exitFullscreen() : this.enterFullscreen();
    }
    startKeyboardControl() {
        this.state.keyboardEnabled = !0;
    }
    stopKeyboardControl() {
        this.state.keyboardEnabled = !1;
    }
    createTooltip(e) {
        return new $a42f1354f0348298$var$My(this, e);
    }
    setCursor(e) {
        this.state.cursorOverride = e, this.container.style.cursor = e || (this.config.mousemove ? "move" : "default");
    }
    observeObjects(e) {
        this.state.objectsObservers[e] || (this.state.objectsObservers[e] = null);
    }
    unobserveObjects(e) {
        delete this.state.objectsObservers[e];
    }
    stopAll() {
        return this.dispatchEvent(new $a42f1354f0348298$var$CE), this.disableIdleTimer(), this.stopAnimation();
    }
}, $a42f1354f0348298$var$Vy = Object.defineProperty;
((e, t)=>{
    for(var i in t)$a42f1354f0348298$var$Vy(e, i, {
        get: t[i],
        enumerable: !0
    });
})({}, {
    EnterArrowEvent: ()=>$a42f1354f0348298$var$Wy,
    LeaveArrowEvent: ()=>$a42f1354f0348298$var$Qy,
    NodeChangedEvent: ()=>$a42f1354f0348298$var$qy
});
var $a42f1354f0348298$var$Hy = class e extends $a42f1354f0348298$var$Mv {
    constructor(t, i){
        super(e.type), this.node = t, this.data = i;
    }
};
$a42f1354f0348298$var$Hy.type = "node-changed";
var $a42f1354f0348298$var$qy = $a42f1354f0348298$var$Hy, $a42f1354f0348298$var$Ky = class e extends $a42f1354f0348298$var$Mv {
    constructor(t, i){
        super(e.type), this.link = t, this.node = i;
    }
};
$a42f1354f0348298$var$Ky.type = "enter-arrow";
var $a42f1354f0348298$var$Wy = $a42f1354f0348298$var$Ky, $a42f1354f0348298$var$Xy = class e extends $a42f1354f0348298$var$Mv {
    constructor(t, i){
        super(e.type), this.link = t, this.node = i;
    }
};
$a42f1354f0348298$var$Xy.type = "leave-arrow";
var $a42f1354f0348298$var$Qy = $a42f1354f0348298$var$Xy, $a42f1354f0348298$var$Zy = class extends $a42f1354f0348298$var$lh {
    constructor(e = document.createElement("div")){
        super(), this.isCSS2DObject = !0, this.element = e, this.element.style.position = "absolute", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.center = new $a42f1354f0348298$var$cu(.5, .5), this.addEventListener("removed", function() {
            this.traverse(function(e) {
                e.element && e.element instanceof e.element.ownerDocument.defaultView.Element && null !== e.element.parentNode && e.element.remove();
            });
        });
    }
    copy(e, t) {
        return super.copy(e, t), this.element = e.element.cloneNode(!0), this.center = e.center, this;
    }
}, $a42f1354f0348298$var$Yy = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Jy = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$$y = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$eb = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$tb = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$ib = class {
    constructor(e = {}){
        const t = this;
        let i, n, a, r;
        const s = {
            objects: new WeakMap
        }, o = void 0 !== e.element ? e.element : document.createElement("div");
        function l(e) {
            e.isCSS2DObject && (e.element.style.display = "none");
            for(let t = 0, i = e.children.length; t < i; t++)l(e.children[t]);
        }
        function c(e, i, n) {
            if (!1 !== e.visible) {
                if (e.isCSS2DObject) {
                    $a42f1354f0348298$var$Yy.setFromMatrixPosition(e.matrixWorld), $a42f1354f0348298$var$Yy.applyMatrix4($a42f1354f0348298$var$$y);
                    const l = $a42f1354f0348298$var$Yy.z >= -1 && $a42f1354f0348298$var$Yy.z <= 1 && !0 === e.layers.test(n.layers), c = e.element;
                    c.style.display = !0 === l ? "" : "none", !0 === l && (e.onBeforeRender(t, i, n), c.style.transform = "translate(" + -100 * e.center.x + "%," + -100 * e.center.y + "%)translate(" + ($a42f1354f0348298$var$Yy.x * a + a) + "px," + (-$a42f1354f0348298$var$Yy.y * r + r) + "px)", c.parentNode !== o && o.appendChild(c), e.onAfterRender(t, i, n));
                    const u = {
                        distanceToCameraSquared: d(n, e)
                    };
                    s.objects.set(e, u);
                }
                for(let t = 0, a = e.children.length; t < a; t++)c(e.children[t], i, n);
            } else l(e);
        }
        function d(e, t) {
            return $a42f1354f0348298$var$eb.setFromMatrixPosition(e.matrixWorld), $a42f1354f0348298$var$tb.setFromMatrixPosition(t.matrixWorld), $a42f1354f0348298$var$eb.distanceToSquared($a42f1354f0348298$var$tb);
        }
        o.style.overflow = "hidden", this.domElement = o, this.sortObjects = !0, this.getSize = function() {
            return {
                width: i,
                height: n
            };
        }, this.render = function(e, t) {
            !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), $a42f1354f0348298$var$Jy.copy(t.matrixWorldInverse), $a42f1354f0348298$var$$y.multiplyMatrices(t.projectionMatrix, $a42f1354f0348298$var$Jy), c(e, e, t), this.sortObjects && function(e) {
                const t = (function(e) {
                    const t = [];
                    return e.traverseVisible(function(e) {
                        e.isCSS2DObject && t.push(e);
                    }), t;
                })(e).sort(function(e, t) {
                    if (e.renderOrder !== t.renderOrder) return t.renderOrder - e.renderOrder;
                    return s.objects.get(e).distanceToCameraSquared - s.objects.get(t).distanceToCameraSquared;
                }), i = t.length;
                for(let e = 0, n = t.length; e < n; e++)t[e].element.style.zIndex = i - e;
            }(e);
        }, this.setSize = function(e, t) {
            i = e, n = t, a = i / 2, r = n / 2, o.style.width = e + "px", o.style.height = t + "px";
        };
    }
}, $a42f1354f0348298$var$nb = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$ab = new $a42f1354f0348298$var$du, $a42f1354f0348298$var$rb = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$sb = class extends $a42f1354f0348298$var$lh {
    constructor(e = document.createElement("div")){
        super(), this.isCSS3DObject = !0, this.element = e, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
            this.traverse(function(e) {
                e.element && e.element instanceof e.element.ownerDocument.defaultView.Element && null !== e.element.parentNode && e.element.remove();
            });
        });
    }
    copy(e, t) {
        return super.copy(e, t), this.element = e.element.cloneNode(!0), this;
    }
}, $a42f1354f0348298$var$ob = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$lb = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$cb = class {
    constructor(e = {}){
        const t = this;
        let i, n, a, r;
        const s = {
            camera: {
                style: ""
            },
            objects: new WeakMap
        }, o = void 0 !== e.element ? e.element : document.createElement("div");
        o.style.overflow = "hidden", this.domElement = o;
        const l = document.createElement("div");
        l.style.transformOrigin = "0 0", l.style.pointerEvents = "none", o.appendChild(l);
        const c = document.createElement("div");
        function d(e) {
            return Math.abs(e) < 1e-10 ? 0 : e;
        }
        function u(e) {
            const t = e.elements;
            return "matrix3d(" + d(t[0]) + "," + d(-t[1]) + "," + d(t[2]) + "," + d(t[3]) + "," + d(t[4]) + "," + d(-t[5]) + "," + d(t[6]) + "," + d(t[7]) + "," + d(t[8]) + "," + d(-t[9]) + "," + d(t[10]) + "," + d(t[11]) + "," + d(t[12]) + "," + d(-t[13]) + "," + d(t[14]) + "," + d(t[15]) + ")";
        }
        function h(e) {
            const t = e.elements;
            return "translate(-50%,-50%)" + ("matrix3d(" + d(t[0]) + "," + d(t[1]) + "," + d(t[2]) + "," + d(t[3]) + "," + d(-t[4]) + "," + d(-t[5]) + "," + d(-t[6]) + "," + d(-t[7]) + "," + d(t[8]) + "," + d(t[9]) + "," + d(t[10]) + "," + d(t[11]) + "," + d(t[12]) + "," + d(t[13]) + "," + d(t[14]) + "," + d(t[15]) + ")");
        }
        function p(e) {
            e.isCSS3DObject && (e.element.style.display = "none");
            for(let t = 0, i = e.children.length; t < i; t++)p(e.children[t]);
        }
        function A(e, i, n, a) {
            if (!1 !== e.visible) {
                if (e.isCSS3DObject) {
                    const a = !0 === e.layers.test(n.layers), r = e.element;
                    if (r.style.display = !0 === a ? "" : "none", !0 === a) {
                        let a;
                        e.onBeforeRender(t, i, n), e.isCSS3DSprite ? ($a42f1354f0348298$var$ob.copy(n.matrixWorldInverse), $a42f1354f0348298$var$ob.transpose(), 0 !== e.rotation2D && $a42f1354f0348298$var$ob.multiply($a42f1354f0348298$var$lb.makeRotationZ(e.rotation2D)), e.matrixWorld.decompose($a42f1354f0348298$var$nb, $a42f1354f0348298$var$ab, $a42f1354f0348298$var$rb), $a42f1354f0348298$var$ob.setPosition($a42f1354f0348298$var$nb), $a42f1354f0348298$var$ob.scale($a42f1354f0348298$var$rb), $a42f1354f0348298$var$ob.elements[3] = 0, $a42f1354f0348298$var$ob.elements[7] = 0, $a42f1354f0348298$var$ob.elements[11] = 0, $a42f1354f0348298$var$ob.elements[15] = 1, a = h($a42f1354f0348298$var$ob)) : a = h(e.matrixWorld);
                        const o = s.objects.get(e);
                        if (void 0 === o || o.style !== a) {
                            r.style.transform = a;
                            const t = {
                                style: a
                            };
                            s.objects.set(e, t);
                        }
                        r.parentNode !== c && c.appendChild(r), e.onAfterRender(t, i, n);
                    }
                }
                for(let t = 0, a = e.children.length; t < a; t++)A(e.children[t], i, n);
            } else p(e);
        }
        c.style.transformStyle = "preserve-3d", l.appendChild(c), this.getSize = function() {
            return {
                width: i,
                height: n
            };
        }, this.render = function(e, t) {
            const o = t.projectionMatrix.elements[5] * r;
            let h, p;
            t.view && t.view.enabled ? (l.style.transform = `translate( ${-t.view.offsetX * (i / t.view.width)}px, ${-t.view.offsetY * (n / t.view.height)}px )`, l.style.transform += `scale( ${t.view.fullWidth / t.view.width}, ${t.view.fullHeight / t.view.height} )`) : l.style.transform = "", !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), t.isOrthographicCamera && (h = -(t.right + t.left) / 2, p = (t.top + t.bottom) / 2);
            const m = t.view && t.view.enabled ? t.view.height / t.view.fullHeight : 1, g = t.isOrthographicCamera ? `scale( ${m} )scale(` + o + ")translate(" + d(h) + "px," + d(p) + "px)" + u(t.matrixWorldInverse) : `scale( ${m} )translateZ(` + o + "px)" + u(t.matrixWorldInverse), f = (t.isPerspectiveCamera ? "perspective(" + o + "px) " : "") + g + "translate(" + a + "px," + r + "px)";
            s.camera.style !== f && (c.style.transform = f, s.camera.style = f), A(e, e, t);
        }, this.setSize = function(e, t) {
            i = e, n = t, a = i / 2, r = n / 2, o.style.width = e + "px", o.style.height = t + "px", l.style.width = e + "px", l.style.height = t + "px", c.style.width = e + "px", c.style.height = t + "px";
        };
    }
}, $a42f1354f0348298$var$db = "tourLink", $a42f1354f0348298$var$ub = "__tour-link__", $a42f1354f0348298$var$hb = {
    className: "psv-virtual-tour-tooltip",
    content: '<div class="psv-virtual-tour-loader"><div></div><div></div><div></div></div>'
}, $a42f1354f0348298$var$pb = {
    element: ()=>{
        const e = document.createElement("button");
        return e.className = "psv-virtual-tour-arrow", e.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n    <path fill-rule="even-odd" fill="currentColor" d="\n        M50,50 m45,0\n        a45,45 0 1,0 -90,0\n        a45,45 0 1,0  90,0\n\n        M50,50 m38,0\n        a38,38 0 0,1 -76,0\n        a38,38 0 0,1  76,0\n\n        M50,50 m30,0\n        a30,30 0 1,0 -60,0\n        a30,30 0 1,0  60,0\n        \n        M50,40 m2.5,-2.5\n        l17.5,17.5\n        a 2.5,2.5 0 0 1 -5,5\n        l-15,-15\n        l-15,15\n        a 2.5,2.5 0 0 1 -5,-5\n        l17.5,-17.5\n        a 3.5,3.5 0 0 1 5,0\n    "/>\n</svg>', e;
    },
    size: {
        width: 80,
        height: 80
    }
}, $a42f1354f0348298$var$Ab = "arrow", $a42f1354f0348298$var$mb = class extends $a42f1354f0348298$var$HE {
    constructor(e, t){
        super(e, {
            className: "psv-virtual-tour-arrows"
        }), this.plugin = t, this.renderer = this.is3D ? new $a42f1354f0348298$var$cb({
            element: this.container
        }) : new $a42f1354f0348298$var$ib({
            element: this.container
        }), this.camera = this.is3D ? new $a42f1354f0348298$var$jA(30, 1) : null, this.scene = new $a42f1354f0348298$var$_h, this.viewer.addEventListener($a42f1354f0348298$var$wv.ReadyEvent.type, this, {
            once: !0
        }), this.viewer.addEventListener($a42f1354f0348298$var$wv.PositionUpdatedEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.SizeUpdatedEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.RenderEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ClickEvent.type, this), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("contextmenu", (e)=>e.preventDefault());
    }
    get is3D() {
        return this.plugin.is3D;
    }
    get arrowsPosition() {
        return this.plugin.config.arrowsPosition;
    }
    get arrowStyle() {
        return this.plugin.config.arrowStyle;
    }
    init() {
        this.is3D && (this.gallery = this.viewer.getPlugin("gallery"), this.gallery?.addEventListener("show-gallery", this), this.gallery?.addEventListener("hide-gallery", this));
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$wv.ReadyEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.PositionUpdatedEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.SizeUpdatedEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.RenderEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ClickEvent.type, this), this.gallery?.removeEventListener("show-gallery", this), this.gallery?.removeEventListener("hide-gallery", this), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case $a42f1354f0348298$var$wv.ReadyEvent.type:
            case $a42f1354f0348298$var$wv.SizeUpdatedEvent.type:
            case $a42f1354f0348298$var$wv.PositionUpdatedEvent.type:
                this.__updateCamera();
                break;
            case $a42f1354f0348298$var$wv.RenderEvent.type:
                this.render();
                break;
            case $a42f1354f0348298$var$wv.ClickEvent.type:
                {
                    if (e.data.rightclick) break;
                    const t = this.__getTargetLink(e.data.target, !0);
                    t && this.plugin.setCurrentNode(t.nodeId, null, t);
                    break;
                }
            case "mouseenter":
                {
                    const t = this.__getTargetLink($a42f1354f0348298$var$d_.getEventTarget(e));
                    t && this.plugin.__onEnterArrow(t, e);
                    break;
                }
            case "mouseleave":
                {
                    const t = this.__getTargetLink($a42f1354f0348298$var$d_.getEventTarget(e));
                    t && this.plugin.__onLeaveArrow(t);
                    break;
                }
            case "mousemove":
                this.__getTargetLink($a42f1354f0348298$var$d_.getEventTarget(e), !0) && this.plugin.__onHoverArrow(e);
                break;
            case "hide-gallery":
                this.__onToggleGallery(!1);
                break;
            case "show-gallery":
                e.fullscreen || this.__onToggleGallery(!0);
        }
    }
    __updateCamera() {
        const e = this.viewer.getSize();
        if (this.renderer.setSize(e.width, e.height), this.is3D) {
            const t = this.viewer.getPosition();
            t.pitch = $a42f1354f0348298$var$lu.clamp(t.pitch, -this.arrowsPosition.maxPitch, -this.arrowsPosition.minPitch), this.viewer.dataHelper.sphericalCoordsToVector3(t, this.camera.position, 2 * e.height).negate(), this.camera.lookAt(0, 0, 0), this.camera.translateY(e.height / 3), this.camera.updateProjectionMatrix();
        }
    }
    render() {
        if (this.is3D) {
            const e = this.viewer.getPosition(), t = [];
            let i = Number.MAX_SAFE_INTEGER;
            this.scene.children.forEach((n)=>{
                const a = n.userData[$a42f1354f0348298$var$Ab];
                if (a.conflict) {
                    const r = Math.abs($a42f1354f0348298$var$d_.getShortestArc(e.yaw, a.yaw));
                    i = Math.min(i, r), t.push([
                        n,
                        r
                    ]);
                }
            }), t.forEach(([e, t])=>{
                const n = t !== i;
                e.element.style.opacity = n ? "0.5" : null, e.element.style.zIndex = n ? "-1" : null;
            }), this.renderer.render(this.scene, this.camera);
        } else this.renderer.render(this.scene, this.viewer.renderer.camera);
    }
    clear() {
        this.scene.clear();
    }
    __buildArrowElement(e, t) {
        if (t?.image) {
            const e = document.createElement("img");
            return e.src = t.image, e;
        }
        if (t?.element) return "function" == typeof t.element ? t.element(e) : t.element;
    }
    addLinkArrow(e, t, i = 1) {
        let n = this.__buildArrowElement(e, e.arrowStyle);
        n || (n = this.__buildArrowElement(e, this.arrowStyle)), n[$a42f1354f0348298$var$db] = e;
        const a = {
            ...this.arrowStyle,
            ...e.arrowStyle
        };
        if (n.classList.add("psv-virtual-tour-link"), a.className && $a42f1354f0348298$var$d_.addClasses(n, a.className), a.style && Object.assign(n.style, a.style), this.is3D) {
            n.style.width = 1.5 * a.size.width + "px", n.style.height = 1.5 * a.size.height + "px";
            let e = !1;
            this.scene.children.forEach((i)=>{
                const n = i.userData[$a42f1354f0348298$var$Ab];
                Math.abs($a42f1354f0348298$var$d_.getShortestArc(n.yaw, t.yaw)) < this.arrowsPosition.linkOverlapAngle && (n.conflict = !0, e = !0);
            });
            const r = new $a42f1354f0348298$var$sb(n);
            r.userData[$a42f1354f0348298$var$Ab] = {
                yaw: t.yaw,
                conflict: e
            }, r.rotation.set(-Math.PI / 2, 0, Math.PI - t.yaw), this.viewer.dataHelper.sphericalCoordsToVector3({
                yaw: t.yaw,
                pitch: 0
            }, r.position, 100 * i), this.scene.add(r);
        } else {
            n.style.width = a.size.width + "px", n.style.height = a.size.height + "px", n.style.pointerEvents = "auto";
            const e = new $a42f1354f0348298$var$Zy(n);
            this.viewer.dataHelper.sphericalCoordsToVector3(t, e.position), this.scene.add(e);
        }
    }
    __getTargetLink(e, t = !1) {
        const i = t ? $a42f1354f0348298$var$d_.getClosest(e, ".psv-virtual-tour-link") : e;
        return i ? i[$a42f1354f0348298$var$db] : void 0;
    }
    __onToggleGallery(e) {
        this.container.style.marginBottom = e ? this.viewer.container.querySelector(".psv-gallery").offsetHeight + "px" : "";
    }
}, $a42f1354f0348298$var$gb = class {
    constructor(e, t){
        this.plugin = e, this.viewer = t, this.nodes = {};
    }
    destroy() {}
    checkNode(e) {
        if (!e.id) throw new $a42f1354f0348298$var$V_("No id given for node");
        if (!e.panorama) throw new $a42f1354f0348298$var$V_(`No panorama provided for node ${e.id}`);
        if (this.plugin.isGps && !(e.gps?.length >= 2)) throw new $a42f1354f0348298$var$V_(`No GPS position provided for node ${e.id}`);
        if (!this.plugin.isGps && e.markers?.some((e)=>e.gps && !e.position)) throw new $a42f1354f0348298$var$V_("Cannot use GPS positioning for markers in manual mode");
        e.links || ($a42f1354f0348298$var$d_.logWarn(`Node ${e.id} has no links`), e.links = []);
    }
    checkLink(e, t) {
        if (!t.nodeId) throw new $a42f1354f0348298$var$V_(`Link of node ${e.id} has no target id`);
        if (t.nodeId === e.id) throw new $a42f1354f0348298$var$V_(`Node ${e.id} links to itself`);
        if (!this.plugin.isGps && !$a42f1354f0348298$var$d_.isExtendedPosition(t.position)) throw new $a42f1354f0348298$var$V_(`No position provided for link ${t.nodeId} of node ${e.id}`);
        if (this.plugin.isGps && !t.gps) throw new $a42f1354f0348298$var$V_(`No GPS position provided for link ${t.nodeId} of node ${e.id}`);
    }
}, $a42f1354f0348298$var$fb = class extends $a42f1354f0348298$var$gb {
    async loadNode(e) {
        if (this.nodes[e]) return this.nodes[e];
        throw new $a42f1354f0348298$var$V_(`Node ${e} not found`);
    }
    setNodes(e) {
        if (!e?.length) throw new $a42f1354f0348298$var$V_("No nodes provided");
        const t = {}, i = {};
        e.forEach((e)=>{
            if (this.checkNode(e), t[e.id]) throw new $a42f1354f0348298$var$V_(`Duplicate node ${e.id}`);
            t[e.id] = e;
        }), e.forEach((e)=>{
            this.__checkLinks(e, t), e.links.forEach((e)=>{
                i[e.nodeId] = !0;
            });
        }), e.forEach((e)=>{
            i[e.id] || $a42f1354f0348298$var$d_.logWarn(`Node ${e.id} is never linked to`);
        }), this.nodes = t;
    }
    updateNode(e) {
        if (!e.id) throw new $a42f1354f0348298$var$V_("No id given for node");
        const t = this.nodes[e.id];
        if (!t) throw new $a42f1354f0348298$var$V_(`Node ${e.id} does not exist`);
        return Object.assign(t, e), this.checkNode(t), this.__checkLinks(t, this.nodes), t;
    }
    __checkLinks(e, t) {
        e.links.forEach((i)=>{
            if (!t[i.nodeId]) throw new $a42f1354f0348298$var$V_(`Target node ${i.nodeId} of node ${e.id} does not exists`);
            i.gps = i.gps || t[i.nodeId].gps, this.checkLink(e, i);
        });
    }
}, $a42f1354f0348298$var$_b = class extends $a42f1354f0348298$var$gb {
    constructor(e, t){
        if (super(e, t), !e.config.getNode) throw new $a42f1354f0348298$var$V_("Missing getNode() option.");
        this.nodeResolver = e.config.getNode;
    }
    async loadNode(e) {
        if (this.nodes[e]) return this.nodes[e];
        {
            const t = await this.nodeResolver(e);
            return this.checkNode(t), t.links.forEach((e)=>{
                this.checkLink(t, e);
            }), this.nodes[e] = t, t;
        }
    }
    clearCache() {
        this.nodes = {};
    }
};
function $a42f1354f0348298$var$vb(e, t) {
    const i = $a42f1354f0348298$var$Eb(e), n = $a42f1354f0348298$var$Eb(t), a = e[2] ?? 0, r = t[2] ?? 0;
    let s = 0;
    a !== r && (s = Math.atan((r - a) / function(e, t) {
        return 6371e3 * $a42f1354f0348298$var$d_.greatArcDistance(e, t);
    }(i, n)));
    const o = function(e, t) {
        const [i, n] = e, [a, r] = t, s = Math.sin(a - i) * Math.cos(r), o = Math.cos(n) * Math.sin(r) - Math.sin(n) * Math.cos(r) * Math.cos(a - i);
        return Math.atan2(s, o);
    }(i, n);
    return {
        yaw: o,
        pitch: s
    };
}
function $a42f1354f0348298$var$Eb(e) {
    return [
        $a42f1354f0348298$var$lu.degToRad(e[0]),
        $a42f1354f0348298$var$lu.degToRad(e[1])
    ];
}
var $a42f1354f0348298$var$yb = $a42f1354f0348298$var$d_.getConfigParser({
    dataMode: "client",
    positionMode: "manual",
    renderMode: "3d",
    nodes: null,
    getNode: null,
    startNodeId: null,
    preload: !1,
    transitionOptions: {
        showLoader: !0,
        speed: "20rpm",
        effect: "fade",
        rotation: !0
    },
    linksOnCompass: !0,
    showLinkTooltip: !0,
    getLinkTooltip: null,
    arrowStyle: $a42f1354f0348298$var$pb,
    arrowsPosition: {
        minPitch: .3,
        maxPitch: Math.PI / 2,
        linkOverlapAngle: Math.PI / 4,
        linkPitchOffset: -0.1
    },
    map: null
}, {
    dataMode (e) {
        if ("client" !== e && "server" !== e) throw new $a42f1354f0348298$var$V_("VirtualTourPlugin: invalid dataMode");
        return e;
    },
    positionMode (e) {
        if ("gps" !== e && "manual" !== e) throw new $a42f1354f0348298$var$V_("VirtualTourPlugin: invalid positionMode");
        return e;
    },
    renderMode (e) {
        if ("3d" !== e && "2d" !== e) throw new $a42f1354f0348298$var$V_("VirtualTourPlugin: invalid renderMode");
        return e;
    },
    arrowsPosition: (e, { defValue: t })=>({
            ...t,
            ...e
        }),
    arrowStyle: (e, { defValue: t })=>({
            ...t,
            ...e
        }),
    map (e, { rawConfig: t }) {
        if (e) {
            if ("server" === t.dataMode) return $a42f1354f0348298$var$d_.logWarn("VirtualTourPlugin: The map cannot be used in server side mode"), null;
            if (!e.imageUrl) return $a42f1354f0348298$var$d_.logWarn('VirtualTourPlugin: configuring the map requires at least "imageUrl"'), null;
            "recenter" in e || (e.recenter = !0);
        }
        return e;
    }
}), $a42f1354f0348298$var$bb = class e extends $a42f1354f0348298$var$cy {
    constructor(e, t){
        super(e, t), this.state = {
            currentNode: null,
            currentTooltip: null,
            loadingNode: null,
            preload: {}
        }, this.arrowsRenderer = new $a42f1354f0348298$var$mb(this.viewer, this);
    }
    get is3D() {
        return "3d" === this.config.renderMode;
    }
    get isServerSide() {
        return "server" === this.config.dataMode;
    }
    get isGps() {
        return "gps" === this.config.positionMode;
    }
    static withConfig(t) {
        return [
            e,
            t
        ];
    }
    init() {
        super.init(), this.arrowsRenderer.init(), $a42f1354f0348298$var$d_.checkStylesheet(this.viewer.container, "virtual-tour-plugin"), this.markers = this.viewer.getPlugin("markers"), this.compass = this.viewer.getPlugin("compass"), this.markers?.config.markers && ($a42f1354f0348298$var$d_.logWarn("No default markers can be configured on the MarkersPlugin when using the VirtualTourPlugin. Consider defining `markers` on each tour node."), delete this.markers.config.markers), this.isGps && (this.plan = this.viewer.getPlugin("plan")), this.isServerSide || (this.gallery = this.viewer.getPlugin("gallery"), this.map = this.viewer.getPlugin("map"), this.config.map && !this.map && $a42f1354f0348298$var$d_.logWarn("The map is configured on the VirtualTourPlugin but the MapPlugin is not loaded.")), this.datasource = this.isServerSide ? new $a42f1354f0348298$var$_b(this, this.viewer) : new $a42f1354f0348298$var$fb(this, this.viewer), this.map && (this.map.addEventListener("select-hotspot", this), this.map.setImage(this.config.map.imageUrl)), this.plan?.addEventListener("select-hotspot", this), this.isServerSide ? this.config.startNodeId && this.setCurrentNode(this.config.startNodeId) : this.config.nodes && (this.setNodes(this.config.nodes, this.config.startNodeId), delete this.config.nodes);
    }
    destroy() {
        this.map?.removeEventListener("select-hotspot", this), this.plan?.removeEventListener("select-hotspot", this), this.datasource.destroy(), this.arrowsRenderer.destroy(), delete this.datasource, delete this.markers, delete this.compass, delete this.gallery, delete this.arrowsRenderer, super.destroy();
    }
    handleEvent(e) {
        if (e instanceof $a42f1354f0348298$var$wv.ClickEvent) {
            const t = e.data.objects.find((e)=>e.userData[$a42f1354f0348298$var$db])?.userData[$a42f1354f0348298$var$db];
            t && this.setCurrentNode(t.nodeId, null, t);
        } else if ("select-hotspot" === e.type) {
            const t = e.hotspotId;
            t.startsWith($a42f1354f0348298$var$ub) && this.setCurrentNode(t.substring(13));
        }
    }
    getCurrentNode() {
        return this.state.currentNode;
    }
    setNodes(e, t) {
        if (this.isServerSide) throw new $a42f1354f0348298$var$V_("Cannot set nodes in server side mode");
        this.__hideTooltip(), this.state.currentNode = null, this.datasource.setNodes(e), t ? this.datasource.nodes[t] || (t = e[0].id, $a42f1354f0348298$var$d_.logWarn(`startNodeId not found is provided nodes, resetted to ${t}`)) : t = e[0].id, this.setCurrentNode(t), this.__setGalleryItems(), this.__setMapHotspots(), this.__setPlanHotspots();
    }
    setCurrentNode(e, t, i) {
        if (e === this.state.currentNode?.id && !t?.forceUpdate) return Promise.resolve(!0);
        t?.forceUpdate && this.isServerSide && this.datasource.clearCache(), this.viewer.hideError(), this.state.loadingNode = e;
        const n = this.state.currentNode, a = n && i ? this.__getLinkPosition(n, i) : null;
        return Promise.resolve(this.state.preload[e]).then(()=>{
            if (this.state.loadingNode !== e) throw $a42f1354f0348298$var$d_.getAbortError();
            return this.datasource.loadNode(e);
        }).then((r)=>{
            if (this.state.loadingNode !== e) throw $a42f1354f0348298$var$d_.getAbortError();
            const s = {
                ...$a42f1354f0348298$var$yb.defaults.transitionOptions,
                rotateTo: a,
                zoomTo: a ? this.viewer.getZoomLevel() : null,
                ..."function" == typeof this.config.transitionOptions ? this.config.transitionOptions(r, n, i) : this.config.transitionOptions,
                ...t
            };
            return s.effect || (s.effect = "none"), this.viewer.panel.hide("description"), this.__hideTooltip(), this.arrowsRenderer.clear(), this.gallery?.config.hideOnClick && this.gallery.hide(), this.map?.config.minimizeOnHotspotClick && this.map.minimize(), this.plan?.config.minimizeOnHotspotClick && this.plan.minimize(), s.rotation && "none" === s.effect ? this.viewer.animate({
                ...s.rotateTo,
                zoom: s.zoomTo,
                speed: s.speed
            }).then(()=>[
                    r,
                    s
                ]) : Promise.resolve([
                r,
                s
            ]);
        }).then(([t, i])=>{
            if (this.state.loadingNode !== e) throw $a42f1354f0348298$var$d_.getAbortError();
            return this.markers?.clearMarkers(), this.config.linksOnCompass && this.compass?.clearHotspots(), this.viewer.setPanorama(t.panorama, {
                caption: t.caption,
                description: t.description,
                panoData: t.panoData,
                sphereCorrection: t.sphereCorrection,
                showLoader: i.showLoader,
                position: i.rotateTo,
                zoom: i.zoomTo,
                transition: "none" !== i.effect && {
                    effect: i.effect,
                    rotation: i.rotation,
                    speed: i.speed
                }
            }).then((e)=>{
                if (!e) throw $a42f1354f0348298$var$d_.getAbortError();
                return t;
            });
        }).then((t)=>{
            if (this.state.loadingNode !== e) throw $a42f1354f0348298$var$d_.getAbortError();
            return this.state.currentNode = t, this.map && this.map.setCenter(this.__getNodeMapPosition(t) ?? this.map.config.center, this.config.map.recenter), this.plan?.setCoordinates(t.gps), this.__addNodeMarkers(t), this.__renderLinks(t), this.__preload(t), this.state.loadingNode = null, this.dispatchEvent(new $a42f1354f0348298$var$qy(t, {
                fromNode: n,
                fromLink: i,
                fromLinkPosition: a
            })), this.viewer.resetIdleTimer(), !0;
        }).catch((e)=>{
            if ($a42f1354f0348298$var$d_.isAbortError(e)) return !1;
            throw this.viewer.showError(this.viewer.config.lang.loadError), this.viewer.loader.hide(), this.viewer.navbar.setCaption(""), this.state.loadingNode = null, e;
        });
    }
    async gotoLink(e, t = "8rpm") {
        const i = this.getLinkPosition(e);
        t ? await this.viewer.animate({
            ...i,
            speed: t
        }) : this.viewer.rotate(i);
    }
    getLinkPosition(e) {
        const t = this.state.currentNode?.links.find((t)=>t.nodeId === e);
        if (!t) throw new $a42f1354f0348298$var$V_(`Cannot find link "${e}"`);
        return this.__getLinkPosition(this.state.currentNode, t);
    }
    updateNode(e) {
        if (this.isServerSide) throw new $a42f1354f0348298$var$V_("Cannot update node in server side mode");
        const t = this.datasource.updateNode(e);
        if ((e.name || e.thumbnail || e.panorama) && this.__setGalleryItems(), (e.name || e.gps || e.map) && this.__setMapHotspots(), (e.name || e.gps || e.plan) && this.__setPlanHotspots(), this.state.currentNode?.id === t.id) {
            if (this.__hideTooltip(), e.panorama || e.panoData || e.sphereCorrection) return void this.setCurrentNode(t.id, {
                forceUpdate: !0
            });
            e.caption && this.viewer.setOption("caption", t.caption), e.description && this.viewer.setOption("description", t.description), (e.links || e.gps) && this.__renderLinks(t), e.gps && this.plan?.setCoordinates(t.gps), (e.map || e.gps) && this.map?.setCenter(this.__getNodeMapPosition(t)), (e.markers || e.gps) && this.__addNodeMarkers(t);
        }
    }
    __setGalleryItems() {
        this.gallery && this.gallery.setItems(Object.values(this.datasource.nodes).filter((e)=>!1 !== e.showInGallery).map((e)=>({
                id: e.id,
                panorama: e.panorama,
                name: e.name,
                thumbnail: e.thumbnail
            })), (e)=>{
            this.setCurrentNode(e);
        });
    }
    __setMapHotspots() {
        this.map && this.map.setHotspots(Object.values(this.datasource.nodes).filter((e)=>!1 !== e.map).map((e)=>({
                tooltip: e.name,
                ...e.map || {},
                ...this.__getNodeMapPosition(e),
                id: $a42f1354f0348298$var$ub + e.id
            })));
    }
    __setPlanHotspots() {
        this.plan && this.plan.setHotspots(Object.values(this.datasource.nodes).filter((e)=>!1 !== e.plan).map((e)=>({
                tooltip: e.name,
                ...e.plan || {},
                coordinates: e.gps,
                id: $a42f1354f0348298$var$ub + e.id
            })));
    }
    __renderLinks(e) {
        this.arrowsRenderer.clear();
        const t = [];
        e.links.forEach((i)=>{
            const n = this.__getLinkPosition(e, i);
            n.yaw += i.linkOffset?.yaw ?? 0, n.pitch += i.linkOffset?.pitch ?? 0, this.isGps && !this.is3D && (n.pitch += this.config.arrowsPosition.linkPitchOffset), t.push(n), this.arrowsRenderer.addLinkArrow(i, n, i.linkOffset?.depth);
        }), this.arrowsRenderer.render(), this.config.linksOnCompass && this.compass?.setHotspots(t);
    }
    __getLinkPosition(e, t) {
        return this.isGps ? $a42f1354f0348298$var$vb(e.gps, t.gps) : this.viewer.dataHelper.cleanPosition(t.position);
    }
    async __getTooltipContent(e) {
        const t = await this.datasource.loadNode(e.nodeId), i = [];
        (t.name || t.thumbnail || t.caption) && (t.name && i.push(`<h3>${t.name}</h3>`), t.thumbnail && i.push(`<img src="${t.thumbnail}">`), t.caption && i.push(`<p>${t.caption}</p>`));
        let n = i.join("");
        return this.config.getLinkTooltip && (n = this.config.getLinkTooltip(n, e, t)), n;
    }
    __onEnterArrow(e, t) {
        const i = $a42f1354f0348298$var$d_.getPosition(this.viewer.container), n = {
            x: t.clientX - i.x,
            y: t.clientY - i.y
        };
        this.config.showLinkTooltip && (this.state.currentTooltip = this.viewer.createTooltip({
            ...$a42f1354f0348298$var$hb,
            left: n.x,
            top: n.y,
            box: {
                width: 20,
                height: 20
            }
        }), this.__getTooltipContent(e).then((e)=>{
            e ? this.state.currentTooltip.update(e) : this.__hideTooltip();
        })), this.map?.setActiveHotspot($a42f1354f0348298$var$ub + e.nodeId), this.plan?.setActiveHotspot($a42f1354f0348298$var$ub + e.nodeId), this.dispatchEvent(new $a42f1354f0348298$var$Wy(e, this.state.currentNode));
    }
    __onHoverArrow(e) {
        const t = $a42f1354f0348298$var$d_.getPosition(this.viewer.container), i = {
            x: e.clientX - t.x,
            y: e.clientY - t.y
        };
        this.state.currentTooltip?.move({
            left: i.x,
            top: i.y
        });
    }
    __onLeaveArrow(e) {
        this.__hideTooltip(), this.map?.setActiveHotspot(null), this.plan?.setActiveHotspot(null), this.dispatchEvent(new $a42f1354f0348298$var$Qy(e, this.state.currentNode));
    }
    __hideTooltip() {
        this.state.currentTooltip?.hide(), this.state.currentTooltip = null;
    }
    __preload(e) {
        this.config.preload && (this.state.preload[e.id] = !0, this.state.currentNode.links.filter((e)=>!this.state.preload[e.nodeId]).filter((e)=>"function" != typeof this.config.preload || this.config.preload(this.state.currentNode, e)).forEach((e)=>{
            this.state.preload[e.nodeId] = this.datasource.loadNode(e.nodeId).then((e)=>this.viewer.textureLoader.preloadPanorama(e.panorama)).then(()=>{
                this.state.preload[e.nodeId] = !0;
            }).catch(()=>{
                delete this.state.preload[e.nodeId];
            });
        }));
    }
    __addNodeMarkers(e) {
        e.markers && (this.markers ? this.markers.setMarkers(e.markers.map((t)=>(t.gps && this.isGps && (t.position = $a42f1354f0348298$var$vb(e.gps, t.gps), t.data?.map && Object.assign(t.data.map, this.__getGpsMapPosition(t.gps)), t.data?.plan && (t.data.plan.coordinates = t.gps)), t))) : $a42f1354f0348298$var$d_.logWarn(`Node ${e.id} markers ignored because the plugin is not loaded.`));
    }
    __getNodeMapPosition(e) {
        const t = this.__getGpsMapPosition(e.gps);
        return t || (e.map ? {
            x: e.map.x,
            y: e.map.y
        } : null);
    }
    __getGpsMapPosition(e) {
        const t = this.config.map;
        return this.isGps && t && t.extent && t.size ? {
            x: $a42f1354f0348298$var$lu.mapLinear(e[0], t.extent[0], t.extent[2], 0, t.size.width),
            y: $a42f1354f0348298$var$lu.mapLinear(e[1], t.extent[1], t.extent[3], 0, t.size.height)
        } : null;
    }
};
$a42f1354f0348298$var$bb.id = "virtual-tour", $a42f1354f0348298$var$bb.VERSION = "5.15.1", $a42f1354f0348298$var$bb.configParser = $a42f1354f0348298$var$yb, $a42f1354f0348298$var$bb.readonlyOptions = Object.keys($a42f1354f0348298$var$yb.defaults);
var $a42f1354f0348298$var$kb = $a42f1354f0348298$var$bb, $a42f1354f0348298$var$xb = Object.defineProperty;
/*!
 * Photo Sphere Viewer / Markers Plugin 5.15.1
 * @copyright 2015-2026 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */ ((e, t)=>{
    for(var i in t)$a42f1354f0348298$var$xb(e, i, {
        get: t[i],
        enumerable: !0
    });
})({}, {
    EnterMarkerEvent: ()=>$a42f1354f0348298$var$Lb,
    GotoMarkerDoneEvent: ()=>$a42f1354f0348298$var$Tb,
    HideMarkersEvent: ()=>$a42f1354f0348298$var$jb,
    LeaveMarkerEvent: ()=>$a42f1354f0348298$var$Pb,
    MarkerVisibilityEvent: ()=>$a42f1354f0348298$var$Sb,
    MarkersPluginEvent: ()=>$a42f1354f0348298$var$wb,
    RenderMarkersListEvent: ()=>$a42f1354f0348298$var$Wb,
    SelectMarkerEvent: ()=>$a42f1354f0348298$var$zb,
    SelectMarkerListEvent: ()=>$a42f1354f0348298$var$Ub,
    SetMarkersEvent: ()=>$a42f1354f0348298$var$Vb,
    ShowMarkersEvent: ()=>$a42f1354f0348298$var$qb,
    UnselectMarkerEvent: ()=>$a42f1354f0348298$var$Bb
});
var $a42f1354f0348298$var$wb = class extends $a42f1354f0348298$var$Mv {
}, $a42f1354f0348298$var$Mb = class e extends $a42f1354f0348298$var$wb {
    constructor(t, i){
        super(e.type), this.marker = t, this.visible = i;
    }
};
$a42f1354f0348298$var$Mb.type = "marker-visibility";
var $a42f1354f0348298$var$Sb = $a42f1354f0348298$var$Mb, $a42f1354f0348298$var$Cb = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.marker = t;
    }
};
$a42f1354f0348298$var$Cb.type = "goto-marker-done";
var $a42f1354f0348298$var$Tb = $a42f1354f0348298$var$Cb, $a42f1354f0348298$var$Db = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.marker = t;
    }
};
$a42f1354f0348298$var$Db.type = "leave-marker";
var $a42f1354f0348298$var$Pb = $a42f1354f0348298$var$Db, $a42f1354f0348298$var$Ib = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.marker = t;
    }
};
$a42f1354f0348298$var$Ib.type = "enter-marker";
var $a42f1354f0348298$var$Lb = $a42f1354f0348298$var$Ib, $a42f1354f0348298$var$Rb = class e extends $a42f1354f0348298$var$wb {
    constructor(t, i, n){
        super(e.type), this.marker = t, this.doubleClick = i, this.rightClick = n;
    }
};
$a42f1354f0348298$var$Rb.type = "select-marker";
var $a42f1354f0348298$var$zb = $a42f1354f0348298$var$Rb, $a42f1354f0348298$var$Fb = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.marker = t;
    }
};
$a42f1354f0348298$var$Fb.type = "select-marker-list";
var $a42f1354f0348298$var$Ub = $a42f1354f0348298$var$Fb, $a42f1354f0348298$var$Nb = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.marker = t;
    }
};
$a42f1354f0348298$var$Nb.type = "unselect-marker";
var $a42f1354f0348298$var$Bb = $a42f1354f0348298$var$Nb, $a42f1354f0348298$var$Ob = class e extends $a42f1354f0348298$var$wb {
    constructor(){
        super(e.type);
    }
};
$a42f1354f0348298$var$Ob.type = "hide-markers";
var $a42f1354f0348298$var$jb = $a42f1354f0348298$var$Ob, $a42f1354f0348298$var$Gb = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.markers = t;
    }
};
$a42f1354f0348298$var$Gb.type = "set-markers";
var $a42f1354f0348298$var$Vb = $a42f1354f0348298$var$Gb, $a42f1354f0348298$var$Hb = class e extends $a42f1354f0348298$var$wb {
    constructor(){
        super(e.type);
    }
};
$a42f1354f0348298$var$Hb.type = "show-markers";
var $a42f1354f0348298$var$qb = $a42f1354f0348298$var$Hb, $a42f1354f0348298$var$Kb = class e extends $a42f1354f0348298$var$wb {
    constructor(t){
        super(e.type), this.markers = t;
    }
};
$a42f1354f0348298$var$Kb.type = "render-markers-list";
var $a42f1354f0348298$var$Wb = $a42f1354f0348298$var$Kb, $a42f1354f0348298$var$Xb = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: "psv-markers-button",
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 9 81 81"><path fill="currentColor" d="M50.5 90S22.9 51.9 22.9 36.6 35.2 9 50.5 9s27.6 12.4 27.6 27.6S50.5 90 50.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"/>\x3c!--Created by Rohith M S from the Noun Project--\x3e</svg>\n',
            hoverScale: !0,
            collapsable: !0,
            tabbable: !0
        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.plugin.addEventListener($a42f1354f0348298$var$qb.type, this), this.plugin.addEventListener($a42f1354f0348298$var$jb.type, this), this.toggleActive(!0));
    }
    destroy() {
        this.plugin && (this.plugin.removeEventListener($a42f1354f0348298$var$qb.type, this), this.plugin.removeEventListener($a42f1354f0348298$var$jb.type, this)), super.destroy();
    }
    isSupported() {
        return !!this.plugin;
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$qb ? this.toggleActive(!0) : e instanceof $a42f1354f0348298$var$jb && this.toggleActive(!1);
    }
    onClick() {
        this.plugin.toggleAllMarkers();
    }
};
$a42f1354f0348298$var$Xb.id = "markers";
var $a42f1354f0348298$var$Qb = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 81 81"><path fill="currentColor" d="M37.5 90S9.9 51.9 9.9 36.6 22.2 9 37.5 9s27.6 12.4 27.6 27.6S37.5 90 37.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM86.7 55H70c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3h16.7c1.8 0 3.3 1.5 3.3 3.3S88.5 55 86.7 55zm0-25h-15a3.3 3.3 0 0 1-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3h15c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zM56.5 73h30c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3h-30a3.3 3.3 0 0 1-3.3-3.3 3.2 3.2 0 0 1 3.3-3.3z"/>\x3c!--Created by Rohith M S from the Noun Project--\x3e</svg>\n', $a42f1354f0348298$var$Zb = "http://www.w3.org/2000/svg", $a42f1354f0348298$var$Yb = "psvMarker", $a42f1354f0348298$var$Jb = $a42f1354f0348298$var$d_.dasherize($a42f1354f0348298$var$Yb), $a42f1354f0348298$var$$b = "marker", $a42f1354f0348298$var$ek = "markersList", $a42f1354f0348298$var$tk = {
    amount: 2,
    duration: 100,
    easing: "linear"
}, $a42f1354f0348298$var$ik = (e, t)=>`\n<div class="psv-panel-menu psv-panel-menu--stripped">\n    <h1 class="psv-panel-menu-title">${$a42f1354f0348298$var$Qb} ${t}</h1>\n    <ul class="psv-panel-menu-list">\n    ${e.map((e)=>`\n        <li data-${$a42f1354f0348298$var$Jb}="${e.id}" class="psv-panel-menu-item" tabindex="0">\n          ${"image" === e.type ? `<span class="psv-panel-menu-item-icon"><img src="${e.definition}"/></span>` : ""}\n          <span class="psv-panel-menu-item-label">${e.getListContent()}</span>\n        </li>\n    `).join("")}\n    </ul>\n</div>\n`, $a42f1354f0348298$var$nk = class extends $a42f1354f0348298$var$KE {
    constructor(e){
        super(e, {
            className: " psv-markers-list-button",
            icon: $a42f1354f0348298$var$Qb,
            hoverScale: !0,
            collapsable: !0,
            tabbable: !0
        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.viewer.addEventListener($a42f1354f0348298$var$wv.ShowPanelEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.HidePanelEvent.type, this));
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$wv.ShowPanelEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.HidePanelEvent.type, this), super.destroy();
    }
    isSupported() {
        return !!this.plugin;
    }
    handleEvent(e) {
        e instanceof $a42f1354f0348298$var$wv.ShowPanelEvent ? this.toggleActive(e.panelId === $a42f1354f0348298$var$ek) : e instanceof $a42f1354f0348298$var$wv.HidePanelEvent && this.toggleActive(!1);
    }
    onClick() {
        this.plugin.toggleMarkersList();
    }
};
$a42f1354f0348298$var$nk.id = "markersList";
var $a42f1354f0348298$var$ak = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$rk = new $a42f1354f0348298$var$du, $a42f1354f0348298$var$sk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$ok = class extends $a42f1354f0348298$var$lh {
    constructor(e = document.createElement("div")){
        super(), this.isCSS3DObject = !0, this.element = e, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
            this.traverse(function(e) {
                e.element && e.element instanceof e.element.ownerDocument.defaultView.Element && null !== e.element.parentNode && e.element.remove();
            });
        });
    }
    copy(e, t) {
        return super.copy(e, t), this.element = e.element.cloneNode(!0), this;
    }
}, $a42f1354f0348298$var$lk = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$ck = new $a42f1354f0348298$var$zu, $a42f1354f0348298$var$dk = class {
    constructor(e = {}){
        const t = this;
        let i, n, a, r;
        const s = {
            camera: {
                style: ""
            },
            objects: new WeakMap
        }, o = void 0 !== e.element ? e.element : document.createElement("div");
        o.style.overflow = "hidden", this.domElement = o;
        const l = document.createElement("div");
        l.style.transformOrigin = "0 0", l.style.pointerEvents = "none", o.appendChild(l);
        const c = document.createElement("div");
        function d(e) {
            return Math.abs(e) < 1e-10 ? 0 : e;
        }
        function u(e) {
            const t = e.elements;
            return "matrix3d(" + d(t[0]) + "," + d(-t[1]) + "," + d(t[2]) + "," + d(t[3]) + "," + d(t[4]) + "," + d(-t[5]) + "," + d(t[6]) + "," + d(t[7]) + "," + d(t[8]) + "," + d(-t[9]) + "," + d(t[10]) + "," + d(t[11]) + "," + d(t[12]) + "," + d(-t[13]) + "," + d(t[14]) + "," + d(t[15]) + ")";
        }
        function h(e) {
            const t = e.elements;
            return "translate(-50%,-50%)" + ("matrix3d(" + d(t[0]) + "," + d(t[1]) + "," + d(t[2]) + "," + d(t[3]) + "," + d(-t[4]) + "," + d(-t[5]) + "," + d(-t[6]) + "," + d(-t[7]) + "," + d(t[8]) + "," + d(t[9]) + "," + d(t[10]) + "," + d(t[11]) + "," + d(t[12]) + "," + d(t[13]) + "," + d(t[14]) + "," + d(t[15]) + ")");
        }
        function p(e) {
            e.isCSS3DObject && (e.element.style.display = "none");
            for(let t = 0, i = e.children.length; t < i; t++)p(e.children[t]);
        }
        function A(e, i, n, a) {
            if (!1 !== e.visible) {
                if (e.isCSS3DObject) {
                    const a = !0 === e.layers.test(n.layers), r = e.element;
                    if (r.style.display = !0 === a ? "" : "none", !0 === a) {
                        let a;
                        e.onBeforeRender(t, i, n), e.isCSS3DSprite ? ($a42f1354f0348298$var$lk.copy(n.matrixWorldInverse), $a42f1354f0348298$var$lk.transpose(), 0 !== e.rotation2D && $a42f1354f0348298$var$lk.multiply($a42f1354f0348298$var$ck.makeRotationZ(e.rotation2D)), e.matrixWorld.decompose($a42f1354f0348298$var$ak, $a42f1354f0348298$var$rk, $a42f1354f0348298$var$sk), $a42f1354f0348298$var$lk.setPosition($a42f1354f0348298$var$ak), $a42f1354f0348298$var$lk.scale($a42f1354f0348298$var$sk), $a42f1354f0348298$var$lk.elements[3] = 0, $a42f1354f0348298$var$lk.elements[7] = 0, $a42f1354f0348298$var$lk.elements[11] = 0, $a42f1354f0348298$var$lk.elements[15] = 1, a = h($a42f1354f0348298$var$lk)) : a = h(e.matrixWorld);
                        const o = s.objects.get(e);
                        if (void 0 === o || o.style !== a) {
                            r.style.transform = a;
                            const t = {
                                style: a
                            };
                            s.objects.set(e, t);
                        }
                        r.parentNode !== c && c.appendChild(r), e.onAfterRender(t, i, n);
                    }
                }
                for(let t = 0, a = e.children.length; t < a; t++)A(e.children[t], i, n);
            } else p(e);
        }
        c.style.transformStyle = "preserve-3d", l.appendChild(c), this.getSize = function() {
            return {
                width: i,
                height: n
            };
        }, this.render = function(e, t) {
            const o = t.projectionMatrix.elements[5] * r;
            let h, p;
            t.view && t.view.enabled ? (l.style.transform = `translate( ${-t.view.offsetX * (i / t.view.width)}px, ${-t.view.offsetY * (n / t.view.height)}px )`, l.style.transform += `scale( ${t.view.fullWidth / t.view.width}, ${t.view.fullHeight / t.view.height} )`) : l.style.transform = "", !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), t.isOrthographicCamera && (h = -(t.right + t.left) / 2, p = (t.top + t.bottom) / 2);
            const m = t.view && t.view.enabled ? t.view.height / t.view.fullHeight : 1, g = t.isOrthographicCamera ? `scale( ${m} )scale(` + o + ")translate(" + d(h) + "px," + d(p) + "px)" + u(t.matrixWorldInverse) : `scale( ${m} )translateZ(` + o + "px)" + u(t.matrixWorldInverse), f = (t.isPerspectiveCamera ? "perspective(" + o + "px) " : "") + g + "translate(" + a + "px," + r + "px)";
            s.camera.style !== f && (c.style.transform = f, s.camera.style = f), A(e, e, t);
        }, this.setSize = function(e, t) {
            i = e, n = t, a = i / 2, r = n / 2, o.style.width = e + "px", o.style.height = t + "px", l.style.width = e + "px", l.style.height = t + "px", c.style.width = e + "px", c.style.height = t + "px";
        };
    }
}, $a42f1354f0348298$var$uk = class {
    constructor(e){
        this.viewer = e, this.element = document.createElement("div"), this.element.className = "psv-markers-css3d-container", this.renderer = new $a42f1354f0348298$var$dk({
            element: this.element
        }), this.scene = new $a42f1354f0348298$var$_h, this.intersectionObserver = new IntersectionObserver((e)=>{
            e.forEach((e)=>{
                const t = e.target[$a42f1354f0348298$var$Yb];
                t.config.visible && (t.viewportIntersection = e.isIntersecting);
            });
        }, {
            root: this.element
        }), e.addEventListener($a42f1354f0348298$var$wv.ReadyEvent.type, this, {
            once: !0
        }), e.addEventListener($a42f1354f0348298$var$wv.SizeUpdatedEvent.type, this), e.addEventListener($a42f1354f0348298$var$wv.RenderEvent.type, this);
    }
    handleEvent(e) {
        switch(e.type){
            case $a42f1354f0348298$var$wv.ReadyEvent.type:
            case $a42f1354f0348298$var$wv.SizeUpdatedEvent.type:
                this.updateSize();
                break;
            case $a42f1354f0348298$var$wv.RenderEvent.type:
                this.render();
        }
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$wv.ReadyEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.SizeUpdatedEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.RenderEvent.type, this), this.intersectionObserver.disconnect();
    }
    updateSize() {
        const e = this.viewer.getSize();
        this.renderer.setSize(e.width, e.height);
    }
    render() {
        this.renderer.render(this.scene, this.viewer.renderer.camera);
    }
    addObject(e) {
        this.scene.add(e.threeElement), this.intersectionObserver.observe(e.domElement);
    }
    removeObject(e) {
        this.scene.remove(e.threeElement), this.intersectionObserver.unobserve(e.domElement);
    }
}, $a42f1354f0348298$var$hk = ((e)=>(e.image = "image", e.html = "html", e.element = "element", e.imageLayer = "imageLayer", e.videoLayer = "videoLayer", e.elementLayer = "elementLayer", e.polygon = "polygon", e.polygonPixels = "polygonPixels", e.polyline = "polyline", e.polylinePixels = "polylinePixels", e.square = "square", e.rect = "rect", e.circle = "circle", e.ellipse = "ellipse", e.path = "path", e))($a42f1354f0348298$var$hk || {});
function $a42f1354f0348298$var$pk(e, t = !1) {
    const i = [];
    if (Object.keys($a42f1354f0348298$var$hk).forEach((t)=>{
        e[t] && i.push(t);
    }), 0 === i.length && !t) throw new $a42f1354f0348298$var$V_(`missing marker content, either ${Object.keys($a42f1354f0348298$var$hk).join(", ")}`);
    if (i.length > 1) throw new $a42f1354f0348298$var$V_(`multiple marker content, either ${Object.keys($a42f1354f0348298$var$hk).join(", ")}`);
    return i[0];
}
var $a42f1354f0348298$var$Ak = class {
    constructor(e, t, i){
        if (this.viewer = e, this.plugin = t, this.state = {
            anchor: null,
            visible: !1,
            staticTooltip: !1,
            position: null,
            position2D: null,
            positions3D: null,
            size: null
        }, !i.id) throw new $a42f1354f0348298$var$V_("missing marker id");
        this.type = $a42f1354f0348298$var$pk(i), this.createElement(), this.update(i);
    }
    get id() {
        return this.config.id;
    }
    get data() {
        return this.config.data;
    }
    get domElement() {
        return null;
    }
    get threeElement() {
        return null;
    }
    get video() {
        return null;
    }
    destroy() {
        delete this.viewer, delete this.plugin, delete this.element, this.hideTooltip();
    }
    is3d() {
        return !1;
    }
    isNormal() {
        return !1;
    }
    isPoly() {
        return !1;
    }
    isSvg() {
        return !1;
    }
    isCss3d() {
        return !1;
    }
    update(e) {
        const t = $a42f1354f0348298$var$pk(e, !0);
        if (void 0 !== t && t !== this.type) throw new $a42f1354f0348298$var$V_(`cannot change marker ${e.id} type`);
        if (this.config = $a42f1354f0348298$var$d_.deepmerge(this.config, e), "string" == typeof this.config.tooltip && (this.config.tooltip = {
            content: this.config.tooltip
        }), this.config.tooltip && !this.config.tooltip.trigger && (this.config.tooltip.trigger = "hover"), $a42f1354f0348298$var$d_.isNil(this.config.visible) && (this.config.visible = !0), $a42f1354f0348298$var$d_.isNil(this.config.zIndex) && (this.config.zIndex = 1), $a42f1354f0348298$var$d_.isNil(this.config.opacity) && (this.config.opacity = 1), this.config.rotation) {
            const e = this.config.rotation;
            this.config.rotation = "object" == typeof e ? {
                yaw: e.yaw ? $a42f1354f0348298$var$d_.parseAngle(e.yaw, !0, !1) : 0,
                pitch: e.pitch ? $a42f1354f0348298$var$d_.parseAngle(e.pitch, !0, !1) : 0,
                roll: e.roll ? $a42f1354f0348298$var$d_.parseAngle(e.roll, !0, !1) : 0
            } : {
                yaw: 0,
                pitch: 0,
                roll: $a42f1354f0348298$var$d_.parseAngle(e, !0, !1)
            };
        } else this.config.rotation = {
            yaw: 0,
            pitch: 0,
            roll: 0
        };
        this.state.anchor = $a42f1354f0348298$var$d_.parsePoint(this.config.anchor);
    }
    getListContent() {
        return this.config.listContent ? this.config.listContent : this.config.tooltip?.content ? this.config.tooltip.content : this.config.html ? this.config.html : this.id;
    }
    showTooltip(e, t, i = !1) {
        if (this.state.visible && this.config.tooltip?.content && this.state.position2D) {
            const n = {
                ...this.config.tooltip,
                style: {
                    pointerEvents: this.state.staticTooltip ? "auto" : "none"
                },
                data: this,
                top: 0,
                left: 0
            };
            if (this.isPoly() || this.is3d() || this.isCss3d()) {
                if (e || t) {
                    const i = $a42f1354f0348298$var$d_.getPosition(this.viewer.container);
                    n.top = t - i.y + 10, n.left = e - i.x, n.box = {
                        width: 20,
                        height: 20
                    };
                } else n.top = this.state.position2D.y, n.left = this.state.position2D.x;
            } else {
                const e = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
                let t = this.state.size.width, i = this.state.size.height;
                this.config.hoverScale && !this.state.staticTooltip && (t *= this.config.hoverScale.amount, i *= this.config.hoverScale.amount), n.top = e.y - i * this.state.anchor.y + i / 2, n.left = e.x - t * this.state.anchor.x + t / 2, n.box = {
                    width: t,
                    height: i
                };
            }
            this.tooltip ? i ? this.tooltip.update(this.config.tooltip.content, n) : this.tooltip.move(n) : this.tooltip = this.viewer.createTooltip(n);
        }
    }
    hideTooltip() {
        this.tooltip && (this.tooltip.hide(), this.tooltip = null);
    }
}, $a42f1354f0348298$var$mk = class extends $a42f1354f0348298$var$Ak {
    get domElement() {
        return this.element;
    }
    constructor(e, t, i){
        super(e, t, i);
    }
    afterCreateElement() {
        this.element[$a42f1354f0348298$var$Yb] = this;
    }
    destroy() {
        delete this.element[$a42f1354f0348298$var$Yb], super.destroy();
    }
    update(e) {
        super.update(e);
        const t = this.domElement;
        t.id = `psv-marker-${this.config.id}`, t.setAttribute("class", "psv-marker"), this.state.visible && t.classList.add("psv-marker--visible"), this.config.tooltip && t.classList.add("psv-marker--has-tooltip"), this.config.content && t.classList.add("psv-marker--has-content"), this.config.className && $a42f1354f0348298$var$d_.addClasses(t, this.config.className), t.style.opacity = `${this.config.opacity}`, t.style.zIndex = `${30 + this.config.zIndex}`, this.config.style && Object.assign(t.style, this.config.style);
    }
}, $a42f1354f0348298$var$gk = class extends $a42f1354f0348298$var$mk {
    constructor(e, t, i){
        super(e, t, i);
    }
    afterCreateElement() {
        super.afterCreateElement(), this.domElement.addEventListener("transitionend", ()=>{
            this.domElement.style.transition = "";
        });
    }
    render({ viewerPosition: e, zoomLevel: t, hoveringMarker: i }) {
        this.__updateSize();
        const n = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
        n.x -= this.state.size.width * this.state.anchor.x, n.y -= this.state.size.height * this.state.anchor.y;
        return this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && n.x + this.state.size.width >= 0 && n.x - this.state.size.width <= this.viewer.state.size.width && n.y + this.state.size.height >= 0 && n.y - this.state.size.height <= this.viewer.state.size.height ? (this.domElement.style.translate = `${n.x}px ${n.y}px 0px`, this.applyScale({
            zoomLevel: t,
            viewerPosition: e,
            mouseover: this === i
        }), n) : null;
    }
    update(e) {
        if (super.update(e), !$a42f1354f0348298$var$d_.isExtendedPosition(this.config.position)) throw new $a42f1354f0348298$var$V_(`missing marker ${this.id} position`);
        try {
            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
        } catch (e) {
            throw new $a42f1354f0348298$var$V_(`invalid marker ${this.id} position`, e);
        }
        this.state.positions3D = [
            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
        ];
        const t = this.domElement;
        t.classList.add("psv-marker--normal"), this.config.scale && Array.isArray(this.config.scale) && (this.config.scale = {
            zoom: this.config.scale
        }), "boolean" == typeof this.config.hoverScale ? this.config.hoverScale = this.config.hoverScale ? this.plugin.config.defaultHoverScale || $a42f1354f0348298$var$tk : null : "number" == typeof this.config.hoverScale ? this.config.hoverScale = {
            amount: this.config.hoverScale
        } : this.config.hoverScale || (this.config.hoverScale = this.plugin.config.defaultHoverScale), this.config.hoverScale && (this.config.hoverScale = {
            ...this.plugin.config.defaultHoverScale,
            ...this.config.hoverScale
        }), t.style.rotate = 0 !== this.config.rotation.roll ? $a42f1354f0348298$var$lu.radToDeg(this.config.rotation.roll) + "deg" : null, t.style.transformOrigin = `${100 * this.state.anchor.x}% ${100 * this.state.anchor.y}%`;
    }
    __updateSize() {
        if (!this.needsUpdateSize) return;
        const e = this.domElement, t = !this.state.visible || !this.state.size;
        if (t && e.classList.add("psv-marker--transparent"), this.isSvg()) {
            const t = e.firstElementChild.getBoundingClientRect();
            this.state.size = {
                width: t.width,
                height: t.height
            };
        } else this.state.size = {
            width: e.offsetWidth,
            height: e.offsetHeight
        };
        t && e.classList.remove("psv-marker--transparent"), this.isSvg() && (e.style.width = this.state.size.width + "px", e.style.height = this.state.size.height + "px"), "element" !== this.type && (this.needsUpdateSize = !1);
    }
    applyScale({ zoomLevel: e, viewerPosition: t, mouseover: i }) {
        null !== i && this.config.hoverScale && (this.domElement.style.transition = `scale ${this.config.hoverScale.duration}ms ${this.config.hoverScale.easing}`);
        let n = 1;
        if ("function" == typeof this.config.scale) n = this.config.scale(e, t);
        else if (this.config.scale) {
            if (Array.isArray(this.config.scale.zoom)) {
                const [t, i] = this.config.scale.zoom;
                n *= t + (i - t) * $a42f1354f0348298$var$Xf.EASINGS.inQuad(e / 100);
            }
            if (Array.isArray(this.config.scale.yaw)) {
                const [e, i] = this.config.scale.yaw, a = $a42f1354f0348298$var$lu.degToRad(this.viewer.state.hFov) / 2, r = Math.abs($a42f1354f0348298$var$d_.getShortestArc(this.state.position.yaw, t.yaw));
                n *= i + (e - i) * $a42f1354f0348298$var$Xf.EASINGS.outQuad(Math.max(0, (a - r) / a));
            }
        }
        i && this.config.hoverScale && (n *= this.config.hoverScale.amount), this.domElement.style.scale = `${n}`;
    }
}, $a42f1354f0348298$var$fk = class extends $a42f1354f0348298$var$EA {
    get map() {
        return this.uniforms.map.value;
    }
    set map(e) {
        this.uniforms.map.value = e;
    }
    set alpha(e) {
        this.uniforms.alpha.value = e;
    }
    get offset() {
        return this.uniforms.offset.value;
    }
    get repeat() {
        return this.uniforms.repeat.value;
    }
    set chromaKey(e) {
        this.uniforms.keying.value = !0 === e?.enabled, e?.enabled && ("object" == typeof e.color && "r" in e.color ? this.uniforms.color.value.set(e.color.r / 255, e.color.g / 255, e.color.b / 255) : this.uniforms.color.value.set(e.color ?? 65280), this.uniforms.similarity.value = e.similarity ?? .2, this.uniforms.smoothness.value = e.smoothness ?? .2);
    }
    constructor(e){
        super({
            transparent: !0,
            depthTest: !1,
            depthWrite: !1,
            uniforms: {
                map: {
                    value: e?.map
                },
                repeat: {
                    value: new $a42f1354f0348298$var$cu(1, 1)
                },
                offset: {
                    value: new $a42f1354f0348298$var$cu(0, 0)
                },
                alpha: {
                    value: e?.alpha ?? 1
                },
                keying: {
                    value: !1
                },
                color: {
                    value: new $a42f1354f0348298$var$gh(65280)
                },
                similarity: {
                    value: .2
                },
                smoothness: {
                    value: .2
                },
                spill: {
                    value: .1
                }
            },
            vertexShader: "varying vec2 vUv;\nuniform vec2 repeat;\nuniform vec2 offset;\n\nvoid main() {\n    vUv = uv * repeat + offset;\n    gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}\n",
            fragmentShader: "// https://www.8thwall.com/playground/chromakey-threejs\n\nuniform sampler2D map;\nuniform float alpha;\nuniform bool keying;\nuniform vec3 color;\nuniform float similarity;\nuniform float smoothness;\nuniform float spill;\n\nvarying vec2 vUv;\n\nvec2 RGBtoUV(vec3 rgb) {\n    return vec2(\n        rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,\n        rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5\n    );\n}\n\nvoid main(void) {\n    gl_FragColor = texture2D(map, vUv);\n\n    if (keying) {\n        float chromaDist = distance(RGBtoUV(gl_FragColor.rgb), RGBtoUV(color));\n\n        float baseMask = chromaDist - similarity;\n        float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);\n        gl_FragColor.a *= fullMask * alpha;\n\n        float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);\n        float desat = clamp(gl_FragColor.r * 0.2126 + gl_FragColor.g * 0.7152 + gl_FragColor.b * 0.0722, 0., 1.);\n        gl_FragColor.rgb = mix(vec3(desat, desat, desat), gl_FragColor.rgb, spillVal);\n    } else {\n        gl_FragColor.a *= alpha;\n    }\n}\n"
        }), this.chromaKey = e?.chromaKey;
    }
};
function $a42f1354f0348298$var$_k(e, t, i) {
    const [n, a] = e, [r, s] = t, o = $a42f1354f0348298$var$d_.greatArcDistance(e, t), l = Math.sin((1 - i) * o) / Math.sin(o), c = Math.sin(i * o) / Math.sin(o), d = l * Math.cos(a) * Math.cos(n) + c * Math.cos(s) * Math.cos(r), u = l * Math.cos(a) * Math.sin(n) + c * Math.cos(s) * Math.sin(r), h = l * Math.sin(a) + c * Math.sin(s);
    return [
        Math.atan2(u, d),
        Math.atan2(h, Math.sqrt(d * d + u * u))
    ];
}
function $a42f1354f0348298$var$vk(e) {
    return e.reduce((e, t)=>e.add(t), new $a42f1354f0348298$var$uu).normalize();
}
function $a42f1354f0348298$var$Ek(e) {
    const t = function(e) {
        const t = [
            e[0]
        ];
        let i = 0;
        for(let n = 1; n < e.length; n++){
            const a = e[n - 1][0] - e[n][0];
            a > Math.PI ? i += 1 : a < -Math.PI && (i -= 1), t.push([
                e[n][0] + 2 * i * Math.PI,
                e[n][1]
            ]);
        }
        return t;
    }(e);
    let i = 0;
    const n = [];
    for(let e = 0; e < t.length - 1; e++){
        const a = $a42f1354f0348298$var$d_.greatArcDistance(t[e], t[e + 1]) * $a42f1354f0348298$var$Xf.SPHERE_RADIUS;
        n.push(a), i += a;
    }
    let a = 0;
    for(let e = 0; e < t.length - 1; e++){
        if (a + n[e] > i / 2) {
            const r = (i / 2 - a) / n[e];
            return $a42f1354f0348298$var$_k(t[e], t[e + 1], r);
        }
        a += n[e];
    }
    return t[Math.round(t.length / 2)];
}
var $a42f1354f0348298$var$yk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$bk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$kk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$xk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$wk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Mk = new $a42f1354f0348298$var$uu;
function $a42f1354f0348298$var$Sk(e, t, i) {
    $a42f1354f0348298$var$yk.copy(i).normalize(), $a42f1354f0348298$var$bk.crossVectors(e, t).normalize(), $a42f1354f0348298$var$kk.crossVectors($a42f1354f0348298$var$bk, e).normalize(), $a42f1354f0348298$var$xk.copy(e).multiplyScalar(-$a42f1354f0348298$var$yk.dot($a42f1354f0348298$var$kk)), $a42f1354f0348298$var$wk.copy($a42f1354f0348298$var$kk).multiplyScalar($a42f1354f0348298$var$yk.dot(e));
    const n = (new $a42f1354f0348298$var$uu).addVectors($a42f1354f0348298$var$xk, $a42f1354f0348298$var$wk).normalize();
    return $a42f1354f0348298$var$Mk.crossVectors(n, $a42f1354f0348298$var$yk), n.applyAxisAngle($a42f1354f0348298$var$Mk, .01).multiplyScalar($a42f1354f0348298$var$Xf.SPHERE_RADIUS);
}
var $a42f1354f0348298$var$Ck = class extends $a42f1354f0348298$var$Ak {
    get threeElement() {
        return this.element;
    }
    get threeMesh() {
        return this.threeElement.children[0];
    }
    get video() {
        return "videoLayer" === this.type ? this.threeMesh.material.map.image : null;
    }
    constructor(e, t, i){
        super(e, t, i);
    }
    is3d() {
        return !0;
    }
    createElement() {
        const e = new $a42f1354f0348298$var$fk({
            alpha: 0
        }), t = new $a42f1354f0348298$var$uA(1, 1), i = new $a42f1354f0348298$var$zp(t, e);
        i.userData = {
            [$a42f1354f0348298$var$Yb]: this
        }, Object.defineProperty(i, "visible", {
            enumerable: !0,
            get: function() {
                return this.userData[$a42f1354f0348298$var$Yb].config.visible;
            },
            set: function(e) {
                this.userData[$a42f1354f0348298$var$Yb].config.visible = e;
            }
        }), this.element = (new $a42f1354f0348298$var$ch).add(i), "videoLayer" === this.type && this.viewer.needsContinuousUpdate(!0);
    }
    destroy() {
        delete this.threeMesh.userData[$a42f1354f0348298$var$Yb], "videoLayer" === this.type && (this.video.pause(), this.viewer.needsContinuousUpdate(!1)), super.destroy();
    }
    render() {
        return this.viewer.renderer.isObjectVisible(this.threeMesh) ? this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position) : null;
    }
    update(e) {
        super.update(e);
        const t = this.threeMesh, i = t.parent, n = t.material;
        if ($a42f1354f0348298$var$d_.isExtendedPosition(this.config.position)) {
            try {
                this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
            } catch (e) {
                throw new $a42f1354f0348298$var$V_(`invalid marker ${this.id} position`, e);
            }
            if (!this.config.size) throw new $a42f1354f0348298$var$V_(`missing marker ${this.id} size`);
            this.state.size = this.config.size, t.scale.set(this.config.size.width / 100, this.config.size.height / 100, 1), t.position.set(t.scale.x * (.5 - this.state.anchor.x), t.scale.y * (this.state.anchor.y - .5), 0), t.rotation.set(0, 0, 0), this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position, i.position), i.lookAt(0, i.position.y, 0), t.rotateY(-this.config.rotation.yaw), t.rotateX(-this.config.rotation.pitch), t.rotateZ(-this.config.rotation.roll);
            const e = t.geometry.getAttribute("position");
            this.state.positions3D = [
                0,
                1,
                3,
                2
            ].map((i)=>{
                const n = new $a42f1354f0348298$var$uu;
                return n.fromBufferAttribute(e, i), t.localToWorld(n);
            });
        } else {
            if (4 !== this.config.position?.length) throw new $a42f1354f0348298$var$V_(`missing marker ${this.id} position`);
            let e;
            try {
                e = this.config.position.map((e)=>this.viewer.dataHelper.cleanPosition(e));
            } catch (e) {
                throw new $a42f1354f0348298$var$V_(`invalid marker ${this.id} position`, e);
            }
            const i = e.map((e)=>this.viewer.dataHelper.sphericalCoordsToVector3(e)), a = $a42f1354f0348298$var$vk(i);
            this.state.position = this.viewer.dataHelper.vector3ToSphericalCoords(a), this.state.positions3D = i;
            const r = t.geometry.getAttribute("position");
            [
                i[0],
                i[1],
                i[3],
                i[2]
            ].forEach((e, t)=>{
                r.setX(t, e.x), r.setY(t, e.y), r.setZ(t, e.z);
            }), r.needsUpdate = !0, this.__setTextureWrap(n);
        }
        switch(this.type){
            case "videoLayer":
                if (this.definition !== this.config.videoLayer) {
                    n.map?.dispose();
                    const e = function({ src: e, withCredentials: t, muted: i, autoplay: n }) {
                        const a = document.createElement("video");
                        return a.crossOrigin = t ? "use-credentials" : "anonymous", a.loop = !0, a.playsInline = !0, a.autoplay = n, a.muted = i, a.preload = "metadata", e instanceof MediaStream ? a.srcObject = e : a.src = e, a;
                    }({
                        src: this.config.videoLayer,
                        withCredentials: this.viewer.config.withCredentials(this.config.videoLayer),
                        muted: !0,
                        autoplay: this.config.autoplay ?? !0
                    }), i = new $a42f1354f0348298$var$rA(e);
                    n.map = i, n.alpha = 0, e.addEventListener("loadedmetadata", ()=>{
                        this.viewer && (n.alpha = this.config.opacity, $a42f1354f0348298$var$d_.isExtendedPosition(this.config.position) || (t.material.userData[$a42f1354f0348298$var$Yb] = {
                            width: e.videoWidth,
                            height: e.videoHeight
                        }, this.__setTextureWrap(n)));
                    }, {
                        once: !0
                    }), e.autoplay && e.play(), this.definition = this.config.videoLayer;
                } else n.alpha = this.config.opacity;
                break;
            case "imageLayer":
                if (this.definition !== this.config.imageLayer) {
                    n.map?.dispose();
                    const e = new $a42f1354f0348298$var$Tu;
                    n.map = e, n.alpha = 0, this.viewer.textureLoader.loadImage(this.config.imageLayer).then((i)=>{
                        this.viewer && ($a42f1354f0348298$var$d_.isExtendedPosition(this.config.position) || (t.material.userData[$a42f1354f0348298$var$Yb] = {
                            width: i.width,
                            height: i.height
                        }, this.__setTextureWrap(n)), e.image = i, e.anisotropy = 4, e.needsUpdate = !0, n.alpha = this.config.opacity, this.viewer.needsUpdate());
                    }), this.definition = this.config.imageLayer;
                } else n.alpha = this.config.opacity;
        }
        n.chromaKey = this.config.chromaKey, t.renderOrder = 1e3 + this.config.zIndex, t.geometry.boundingBox = null;
    }
    __setTextureWrap(e) {
        const t = e.userData[$a42f1354f0348298$var$Yb];
        if (!t || !t.height || !t.width) return e.repeat.set(1, 1), void e.offset.set(0, 0);
        const i = this.config.position.map((e)=>this.viewer.dataHelper.cleanPosition(e)), n = ($a42f1354f0348298$var$d_.greatArcDistance([
            i[0].yaw,
            i[0].pitch
        ], [
            i[1].yaw,
            i[1].pitch
        ]) + $a42f1354f0348298$var$d_.greatArcDistance([
            i[3].yaw,
            i[3].pitch
        ], [
            i[2].yaw,
            i[2].pitch
        ])) / ($a42f1354f0348298$var$d_.greatArcDistance([
            i[1].yaw,
            i[1].pitch
        ], [
            i[2].yaw,
            i[2].pitch
        ]) + $a42f1354f0348298$var$d_.greatArcDistance([
            i[0].yaw,
            i[0].pitch
        ], [
            i[3].yaw,
            i[3].pitch
        ])), a = t.width / t.height;
        let r = 0, s = 0;
        n < a ? r = a - n : s = 1 / a - 1 / n, e.repeat.set(1 - r, 1 - s), e.offset.set(r / 2, s / 2);
    }
}, $a42f1354f0348298$var$Tk = class extends $a42f1354f0348298$var$mk {
    constructor(e, t, i){
        super(e, t, i), this.viewportIntersection = !1;
    }
    get threeElement() {
        return this.object;
    }
    isCss3d() {
        return !0;
    }
    createElement() {
        this.element = document.createElement("div"), this.object = new $a42f1354f0348298$var$ok(this.element), this.object.userData = {
            [$a42f1354f0348298$var$Yb]: this
        }, Object.defineProperty(this.object, "visible", {
            enumerable: !0,
            get: function() {
                return this.userData[$a42f1354f0348298$var$Yb].config.visible;
            },
            set: function(e) {
                this.userData[$a42f1354f0348298$var$Yb].config.visible = e;
            }
        }), this.afterCreateElement();
    }
    destroy() {
        delete this.object.userData[$a42f1354f0348298$var$Yb], delete this.object, super.destroy();
    }
    render({ viewerPosition: e, zoomLevel: t }) {
        const i = this.domElement;
        this.state.size = {
            width: i.offsetWidth,
            height: i.offsetHeight
        };
        if (this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && this.viewportIntersection) {
            const i = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position);
            return this.config.elementLayer.updateMarker?.({
                marker: this,
                position: i,
                viewerPosition: e,
                zoomLevel: t,
                viewerSize: this.viewer.state.size
            }), i;
        }
        return null;
    }
    update(e) {
        if (super.update(e), !$a42f1354f0348298$var$d_.isExtendedPosition(this.config.position)) throw new $a42f1354f0348298$var$V_(`missing marker ${this.id} position`);
        try {
            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
        } catch (e) {
            throw new $a42f1354f0348298$var$V_(`invalid marker ${this.id} position`, e);
        }
        this.state.positions3D = [
            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
        ];
        const t = this.threeElement, i = this.domElement;
        i.classList.add("psv-marker--css3d"), i.childNodes.forEach((e)=>e.remove()), i.appendChild(this.config.elementLayer), this.config.elementLayer.style.display = "block", t.position.copy(this.state.positions3D[0]).multiplyScalar(100), t.lookAt(0, 100 * this.state.positions3D[0].y, 0), t.rotateY(-this.config.rotation.yaw), t.rotateX(-this.config.rotation.pitch), t.rotateZ(-this.config.rotation.roll);
    }
}, $a42f1354f0348298$var$Dk = class extends $a42f1354f0348298$var$gk {
    constructor(e, t, i){
        super(e, t, i);
    }
    isNormal() {
        return !0;
    }
    createElement() {
        this.element = document.createElement("div"), this.afterCreateElement();
    }
    render(e) {
        const t = super.render(e);
        return t && "element" === this.type && this.config.element.updateMarker?.({
            marker: this,
            position: t,
            viewerPosition: e.viewerPosition,
            zoomLevel: e.zoomLevel,
            viewerSize: this.viewer.state.size
        }), t;
    }
    update(e) {
        super.update(e);
        const t = this.domElement;
        if (this.config.image && !this.config.size) throw new $a42f1354f0348298$var$V_(`missing marker ${this.id} size`);
        switch(this.config.size ? (this.needsUpdateSize = !1, this.state.size = this.config.size, t.style.width = this.config.size.width + "px", t.style.height = this.config.size.height + "px") : this.needsUpdateSize = !0, this.type){
            case "image":
                this.definition = this.config.image, t.style.backgroundImage = `url("${this.config.image}")`;
                break;
            case "html":
                this.definition = this.config.html, t.innerHTML = this.config.html;
                break;
            case "element":
                this.definition !== this.config.element && (this.definition = this.config.element, t.childNodes.forEach((e)=>e.remove()), t.appendChild(this.config.element), this.config.element.style.display = "block");
        }
    }
}, $a42f1354f0348298$var$Pk = class extends $a42f1354f0348298$var$mk {
    constructor(e, t, i){
        super(e, t, i);
    }
    createElement() {
        this.element = document.createElementNS($a42f1354f0348298$var$Zb, "path"), this.element[$a42f1354f0348298$var$Yb] = this;
    }
    isPoly() {
        return !0;
    }
    get isPixels() {
        return "polygonPixels" === this.type || "polylinePixels" === this.type;
    }
    get isPolygon() {
        return "polygon" === this.type || "polygonPixels" === this.type;
    }
    get isPolyline() {
        return "polyline" === this.type || "polylinePixels" === this.type;
    }
    get coords() {
        return this.definition;
    }
    render() {
        const e = this.__getAllPolyPositions();
        if (e[0].length > (this.isPolygon ? 2 : 1)) {
            const t = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position), i = e.filter((e)=>e.length > 0).map((e)=>{
                let i = "M";
                return i += e.map((e)=>`${e.x - t.x},${e.y - t.y}`).join("L"), this.isPolygon && (i += "Z"), i;
            }).join(" ");
            return this.domElement.setAttributeNS(null, "d", i), this.domElement.setAttributeNS(null, "transform", `translate(${t.x} ${t.y})`), t;
        }
        return null;
    }
    update(e) {
        super.update(e);
        const t = this.domElement;
        t.classList.add("psv-marker--poly"), this.config.svgStyle ? (Object.entries(this.config.svgStyle).forEach(([e, i])=>{
            t.setAttributeNS(null, $a42f1354f0348298$var$d_.dasherize(e), i);
        }), this.isPolyline && !this.config.svgStyle.fill && t.setAttributeNS(null, "fill", "none")) : this.isPolygon ? t.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)") : this.isPolyline && (t.setAttributeNS(null, "fill", "none"), t.setAttributeNS(null, "stroke", "rgb(0,0,0)"));
        try {
            let e = this.config[this.type];
            if (!Array.isArray(e[0]) && "object" != typeof e[0]) for(let t = 0; t < e.length; t++)e.splice(t, 2, [
                e[t],
                e[t + 1]
            ]);
            if (Array.isArray(e[0][0]) || "object" == typeof e[0][0] || (e = [
                e
            ]), this.isPolyline && e.length > 1) throw new $a42f1354f0348298$var$V_("polylines cannot have holes");
            this.isPixels ? this.definition = e.map((e)=>e.map((e)=>{
                    let t;
                    return t = $a42f1354f0348298$var$d_.isExtendedPosition(e) ? this.viewer.dataHelper.cleanPosition(e) : this.viewer.dataHelper.textureCoordsToSphericalCoords({
                        textureX: e[0],
                        textureY: e[1]
                    }), [
                        t.yaw,
                        t.pitch
                    ];
                })) : this.definition = e.map((e)=>e.map((e)=>{
                    let t;
                    return t = $a42f1354f0348298$var$d_.isExtendedPosition(e) ? this.viewer.dataHelper.cleanPosition(e) : this.viewer.dataHelper.cleanPosition({
                        yaw: e[0],
                        pitch: e[1]
                    }), [
                        t.yaw,
                        t.pitch
                    ];
                }));
        } catch (e) {
            throw new $a42f1354f0348298$var$V_(`invalid marker ${this.id} position`, e);
        }
        if (this.positions3D = this.coords.map((e)=>e.map((e)=>this.viewer.dataHelper.sphericalCoordsToVector3({
                    yaw: e[0],
                    pitch: e[1]
                }))), this.isPolygon) {
            const e = $a42f1354f0348298$var$vk(this.positions3D[0]);
            this.state.position = this.viewer.dataHelper.vector3ToSphericalCoords(e);
        } else {
            const e = $a42f1354f0348298$var$Ek(this.coords[0]);
            this.state.position = {
                yaw: e[0],
                pitch: e[1]
            };
        }
        this.state.positions3D = this.positions3D[0];
    }
    __getAllPolyPositions() {
        return this.positions3D.map((e)=>this.__getPolyPositions(e));
    }
    __getPolyPositions(e) {
        const t = e.length, i = e.map((e)=>({
                vector: e,
                visible: e.dot(this.viewer.state.direction) > 0
            })), n = [];
        return i.forEach((e, a)=>{
            if (!e.visible) [
                0 === a ? i[t - 1] : i[a - 1],
                a === t - 1 ? i[0] : i[a + 1]
            ].forEach((t)=>{
                t.visible && n.push({
                    visible: t.vector,
                    invisible: e.vector,
                    index: a
                });
            });
        }), n.reverse().forEach((e)=>{
            i.splice(e.index, 0, {
                vector: $a42f1354f0348298$var$Sk(e.visible, e.invisible, this.viewer.state.direction),
                visible: !0
            });
        }), i.filter((e)=>e.visible).map((e)=>this.viewer.dataHelper.vector3ToViewerCoords(e.vector));
    }
}, $a42f1354f0348298$var$Ik = class extends $a42f1354f0348298$var$gk {
    get svgElement() {
        return this.domElement.firstElementChild;
    }
    constructor(e, t, i){
        super(e, t, i);
    }
    isSvg() {
        return !0;
    }
    createElement() {
        const e = "square" === this.type ? "rect" : this.type, t = document.createElementNS($a42f1354f0348298$var$Zb, e);
        this.element = document.createElementNS($a42f1354f0348298$var$Zb, "svg"), this.element.appendChild(t), this.afterCreateElement();
    }
    update(e) {
        super.update(e);
        const t = this.svgElement;
        switch(this.needsUpdateSize = !0, this.type){
            case "square":
                this.definition = {
                    x: 0,
                    y: 0,
                    width: this.config.square,
                    height: this.config.square
                };
                break;
            case "rect":
                Array.isArray(this.config.rect) ? this.definition = {
                    x: 0,
                    y: 0,
                    width: this.config.rect[0],
                    height: this.config.rect[1]
                } : this.definition = {
                    x: 0,
                    y: 0,
                    width: this.config.rect.width,
                    height: this.config.rect.height
                };
                break;
            case "circle":
                this.definition = {
                    cx: this.config.circle,
                    cy: this.config.circle,
                    r: this.config.circle
                };
                break;
            case "ellipse":
                Array.isArray(this.config.ellipse) ? this.definition = {
                    cx: this.config.ellipse[0],
                    cy: this.config.ellipse[1],
                    rx: this.config.ellipse[0],
                    ry: this.config.ellipse[1]
                } : this.definition = {
                    cx: this.config.ellipse.rx,
                    cy: this.config.ellipse.ry,
                    rx: this.config.ellipse.rx,
                    ry: this.config.ellipse.ry
                };
                break;
            case "path":
                this.definition = {
                    d: this.config.path
                };
        }
        Object.entries(this.definition).forEach(([e, i])=>{
            t.setAttributeNS(null, e, i);
        }), this.config.svgStyle ? Object.entries(this.config.svgStyle).forEach(([e, i])=>{
            t.setAttributeNS(null, $a42f1354f0348298$var$d_.dasherize(e), i);
        }) : t.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
    }
}, $a42f1354f0348298$var$Lk = $a42f1354f0348298$var$d_.getConfigParser({
    clickEventOnMarker: !1,
    gotoMarkerSpeed: "8rpm",
    markers: null,
    defaultHoverScale: null
}, {
    defaultHoverScale: (e)=>e ? (!0 === e && (e = $a42f1354f0348298$var$tk), "number" == typeof e && (e = {
            amount: e
        }), {
            ...$a42f1354f0348298$var$tk,
            ...e
        }) : null
});
var $a42f1354f0348298$var$Rk = class e extends $a42f1354f0348298$var$cy {
    constructor(e, t){
        super(e, t), this.markers = {}, this.state = {
            allVisible: !0,
            showAllTooltips: !1,
            currentMarker: null,
            hoveringMarker: null,
            needsReRender: !1,
            lastClientX: null,
            lastClientY: null
        }, this.container = document.createElement("div"), this.container.className = "psv-markers", this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.svgContainer = document.createElementNS($a42f1354f0348298$var$Zb, "svg"), this.svgContainer.setAttribute("class", "psv-markers-svg-container"), this.container.appendChild(this.svgContainer), this.css3DContainer = new $a42f1354f0348298$var$uk(e), this.container.appendChild(this.css3DContainer.element), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0);
    }
    static withConfig(t) {
        return [
            e,
            t
        ];
    }
    init() {
        super.init(), $a42f1354f0348298$var$d_.checkStylesheet(this.viewer.container, "markers-plugin"), this.viewer.addEventListener($a42f1354f0348298$var$wv.ClickEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.DoubleClickEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.RenderEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ConfigChangedEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ObjectEnterEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ObjectHoverEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ObjectLeaveEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ReadyEvent.type, this, {
            once: !0
        });
    }
    destroy() {
        this.clearMarkers(!1), this.viewer.unobserveObjects($a42f1354f0348298$var$Yb), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ClickEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.DoubleClickEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.RenderEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ObjectEnterEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ObjectHoverEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ObjectLeaveEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ReadyEvent.type, this), this.css3DContainer.destroy(), this.viewer.container.removeChild(this.container), super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case $a42f1354f0348298$var$wv.ReadyEvent.type:
                this.config.markers && (this.setMarkers(this.config.markers), delete this.config.markers);
                break;
            case $a42f1354f0348298$var$wv.RenderEvent.type:
                this.renderMarkers();
                break;
            case $a42f1354f0348298$var$wv.ClickEvent.type:
                this.__onClick(e, !1);
                break;
            case $a42f1354f0348298$var$wv.DoubleClickEvent.type:
                this.__onClick(e, !0);
                break;
            case $a42f1354f0348298$var$wv.ObjectEnterEvent.type:
            case $a42f1354f0348298$var$wv.ObjectLeaveEvent.type:
            case $a42f1354f0348298$var$wv.ObjectHoverEvent.type:
                if (e.userDataKey === $a42f1354f0348298$var$Yb) {
                    const t = e.originalEvent, i = e.object.userData[$a42f1354f0348298$var$Yb];
                    switch(e.type){
                        case $a42f1354f0348298$var$wv.ObjectEnterEvent.type:
                            i.config.style?.cursor ? this.viewer.setCursor(i.config.style.cursor) : (i.config.tooltip || i.config.content) && this.viewer.setCursor("pointer"), this.__onEnterMarker(t, i);
                            break;
                        case $a42f1354f0348298$var$wv.ObjectLeaveEvent.type:
                            this.viewer.setCursor(null), this.__onLeaveMarker(i);
                            break;
                        case $a42f1354f0348298$var$wv.ObjectHoverEvent.type:
                            this.__onHoverMarker(t, i);
                    }
                }
                break;
            case "mouseenter":
                {
                    const t = this.__getTargetMarker($a42f1354f0348298$var$d_.getEventTarget(e));
                    this.__onEnterMarker(e, t);
                    break;
                }
            case "mouseleave":
                {
                    const t = this.__getTargetMarker($a42f1354f0348298$var$d_.getEventTarget(e));
                    this.__onLeaveMarker(t);
                    break;
                }
            case "mousemove":
                {
                    const t = this.__getTargetMarker($a42f1354f0348298$var$d_.getEventTarget(e), !0);
                    this.__onHoverMarker(e, t);
                    break;
                }
        }
    }
    toggleAllMarkers() {
        this.state.allVisible ? this.hideAllMarkers() : this.showAllMarkers();
    }
    showAllMarkers() {
        this.state.allVisible = !0, Object.values(this.markers).forEach((e)=>{
            e.config.visible = !0;
        }), this.renderMarkers(), this.dispatchEvent(new $a42f1354f0348298$var$qb);
    }
    hideAllMarkers() {
        this.state.allVisible = !1, Object.values(this.markers).forEach((e)=>{
            e.config.visible = !1;
        }), this.renderMarkers(), this.dispatchEvent(new $a42f1354f0348298$var$jb);
    }
    toggleAllTooltips() {
        this.state.showAllTooltips ? this.hideAllTooltips() : this.showAllTooltips();
    }
    showAllTooltips() {
        this.state.showAllTooltips = !0, Object.values(this.markers).forEach((e)=>{
            e.state.staticTooltip = !0, e.showTooltip();
        });
    }
    hideAllTooltips() {
        this.state.showAllTooltips = !1, Object.values(this.markers).forEach((e)=>{
            e.state.staticTooltip = !1, e.hideTooltip();
        });
    }
    getNbMarkers() {
        return Object.keys(this.markers).length;
    }
    getMarkers() {
        return Object.values(this.markers);
    }
    addMarker(e, t = !0) {
        if (this.markers[e.id]) throw new $a42f1354f0348298$var$V_(`marker "${e.id}" already exists`);
        const i = new (function(e) {
            switch($a42f1354f0348298$var$pk(e, !1)){
                case "image":
                case "html":
                case "element":
                    return $a42f1354f0348298$var$Dk;
                case "imageLayer":
                case "videoLayer":
                    return $a42f1354f0348298$var$Ck;
                case "elementLayer":
                    return $a42f1354f0348298$var$Tk;
                case "polygon":
                case "polyline":
                case "polygonPixels":
                case "polylinePixels":
                    return $a42f1354f0348298$var$Pk;
                case "square":
                case "rect":
                case "circle":
                case "ellipse":
                case "path":
                    return $a42f1354f0348298$var$Ik;
                default:
                    throw new $a42f1354f0348298$var$V_("invalid marker type");
            }
        }(e))(this.viewer, this, e);
        i.isPoly() ? this.svgContainer.appendChild(i.domElement) : i.isCss3d() ? this.css3DContainer.addObject(i) : i.is3d() ? this.viewer.renderer.addObject(i.threeElement) : this.container.appendChild(i.domElement), this.markers[i.id] = i, this.state.showAllTooltips && (i.state.staticTooltip = !0), t && this.__afterChangeMarkers();
    }
    getMarker(e) {
        const t = "object" == typeof e ? e.id : e;
        if (!this.markers[t]) throw new $a42f1354f0348298$var$V_(`cannot find marker "${t}"`);
        return this.markers[t];
    }
    getCurrentMarker() {
        return this.state.currentMarker;
    }
    updateMarker(e, t = !0) {
        const i = this.getMarker(e.id);
        i.update(e), t && (this.__afterChangeMarkers(), (i === this.state.hoveringMarker && "hover" === i.config.tooltip?.trigger || i.state.staticTooltip) && i.showTooltip(this.state.lastClientX, this.state.lastClientY, !0));
    }
    removeMarker(e, t = !0) {
        const i = this.getMarker(e);
        i.isPoly() ? this.svgContainer.removeChild(i.domElement) : i.isCss3d() ? this.css3DContainer.removeObject(i) : i.is3d() ? this.viewer.renderer.removeObject(i.threeElement) : this.container.removeChild(i.domElement), this.state.hoveringMarker === i && (this.state.hoveringMarker = null), this.state.currentMarker === i && (this.state.currentMarker = null), i.destroy(), delete this.markers[i.id], t && this.__afterChangeMarkers();
    }
    removeMarkers(e, t = !0) {
        e.forEach((e)=>this.removeMarker(e, !1)), t && this.__afterChangeMarkers();
    }
    setMarkers(e, t = !0) {
        this.clearMarkers(!1), e?.forEach((e)=>{
            this.addMarker(e, !1);
        }), t && this.__afterChangeMarkers();
    }
    clearMarkers(e = !0) {
        Object.keys(this.markers).forEach((e)=>{
            this.removeMarker(e, !1);
        }), e && this.__afterChangeMarkers();
    }
    gotoMarker(e, t = this.config.gotoMarkerSpeed) {
        const i = this.getMarker(e);
        return t ? this.viewer.animate({
            ...i.state.position,
            zoom: i.config.zoomLvl,
            speed: t
        }).then(()=>{
            this.dispatchEvent(new $a42f1354f0348298$var$Tb(i));
        }) : (this.viewer.rotate(i.state.position), $a42f1354f0348298$var$d_.isNil(i.config.zoomLvl) || this.viewer.zoom(i.config.zoomLvl), this.dispatchEvent(new $a42f1354f0348298$var$Tb(i)), Promise.resolve());
    }
    hideMarker(e) {
        this.toggleMarker(e, !1);
    }
    showMarker(e) {
        this.toggleMarker(e, !0);
    }
    showMarkerTooltip(e) {
        const t = this.getMarker(e);
        t.state.staticTooltip = !0, t.showTooltip();
    }
    hideMarkerTooltip(e) {
        const t = this.getMarker(e);
        t.state.staticTooltip = !1, t.hideTooltip();
    }
    toggleMarker(e, t) {
        const i = this.getMarker(e);
        i.config.visible = $a42f1354f0348298$var$d_.isNil(t) ? !i.config.visible : t, this.renderMarkers();
    }
    showMarkerPanel(e) {
        const t = this.getMarker(e);
        t.config.content ? this.viewer.panel.show({
            id: $a42f1354f0348298$var$$b,
            content: t.config.content
        }) : this.hideMarkerPanel();
    }
    hideMarkerPanel() {
        this.viewer.panel.hide($a42f1354f0348298$var$$b);
    }
    toggleMarkersList() {
        this.viewer.panel.isVisible($a42f1354f0348298$var$ek) ? this.hideMarkersList() : this.showMarkersList();
    }
    showMarkersList() {
        let e = [];
        Object.values(this.markers).forEach((t)=>{
            t.config.visible && !t.config.hideList && e.push(t);
        });
        const t = new $a42f1354f0348298$var$Wb(e);
        this.dispatchEvent(t), e = t.markers, this.viewer.panel.show({
            id: $a42f1354f0348298$var$ek,
            content: $a42f1354f0348298$var$ik(e, this.viewer.config.lang[$a42f1354f0348298$var$Xb.id]),
            noMargin: !0,
            clickHandler: (e)=>{
                const t = $a42f1354f0348298$var$d_.getClosest(e, ".psv-panel-menu-item"), i = t ? t.dataset[$a42f1354f0348298$var$Yb] : void 0;
                if (i) {
                    const e = this.getMarker(i);
                    this.dispatchEvent(new $a42f1354f0348298$var$Ub(e)), this.gotoMarker(e.id), this.hideMarkersList();
                }
            }
        });
    }
    hideMarkersList() {
        this.viewer.panel.hide($a42f1354f0348298$var$ek);
    }
    renderMarkers() {
        if (this.state.needsReRender) return void (this.state.needsReRender = !1);
        const e = this.viewer.getZoomLevel(), t = this.viewer.getPosition(), i = this.state.hoveringMarker;
        Object.values(this.markers).forEach((n)=>{
            let a = n.config.visible, r = null;
            a && (r = n.render({
                viewerPosition: t,
                zoomLevel: e,
                hoveringMarker: i
            }), a = !!r);
            const s = n.state.visible !== a;
            n.state.visible = a, n.state.position2D = r, n.domElement && $a42f1354f0348298$var$d_.toggleClass(n.domElement, "psv-marker--visible", a), a ? n.state.staticTooltip ? n.showTooltip() : n !== this.state.hoveringMarker && n.hideTooltip() : n.hideTooltip(), s && (this.dispatchEvent(new $a42f1354f0348298$var$Sb(n, a)), (n.is3d() || n.isCss3d()) && (this.state.needsReRender = !0));
        }), this.state.needsReRender && this.viewer.needsUpdate();
    }
    __getTargetMarker(e, t = !1) {
        if (e instanceof Node) {
            const i = t ? $a42f1354f0348298$var$d_.getClosest(e, ".psv-marker") : e;
            return i ? i[$a42f1354f0348298$var$Yb] : void 0;
        }
        return Array.isArray(e) ? e.map((e)=>e.userData[$a42f1354f0348298$var$Yb]).filter((e)=>!!e).sort((e, t)=>t.config.zIndex - e.config.zIndex)[0] : null;
    }
    __onEnterMarker(e, t) {
        t && (this.state.hoveringMarker = t, this.state.lastClientX = e.clientX, this.state.lastClientY = e.clientY, this.dispatchEvent(new $a42f1354f0348298$var$Lb(t)), t instanceof $a42f1354f0348298$var$gk && t.applyScale({
            zoomLevel: this.viewer.getZoomLevel(),
            viewerPosition: this.viewer.getPosition(),
            mouseover: !0
        }), t.state.staticTooltip || "hover" !== t.config.tooltip?.trigger || t.showTooltip(e.clientX, e.clientY));
    }
    __onLeaveMarker(e) {
        e && (this.dispatchEvent(new $a42f1354f0348298$var$Pb(e)), e instanceof $a42f1354f0348298$var$gk && e.applyScale({
            zoomLevel: this.viewer.getZoomLevel(),
            viewerPosition: this.viewer.getPosition(),
            mouseover: !1
        }), this.state.hoveringMarker = null, e.state.staticTooltip || "hover" !== e.config.tooltip?.trigger ? e.state.staticTooltip && e.showTooltip() : e.hideTooltip());
    }
    __onHoverMarker(e, t) {
        t && (this.state.lastClientX = e.clientX, this.state.lastClientY = e.clientY, (t.isPoly() || t.is3d() || t.isCss3d()) && "hover" === t.config.tooltip?.trigger && t.showTooltip(e.clientX, e.clientY));
    }
    __onClick(e, t) {
        const i = this.__getTargetMarker(e.data.objects), n = this.__getTargetMarker(e.data.target, !0) || i;
        this.state.currentMarker && this.state.currentMarker !== n && (this.dispatchEvent(new $a42f1354f0348298$var$Bb(this.state.currentMarker)), this.viewer.panel.hide($a42f1354f0348298$var$$b), this.state.showAllTooltips || "click" !== this.state.currentMarker.config.tooltip?.trigger || this.hideMarkerTooltip(this.state.currentMarker.id), this.state.currentMarker = null), n && (this.state.currentMarker = n, this.dispatchEvent(new $a42f1354f0348298$var$zb(n, t, e.data.rightclick)), this.config.clickEventOnMarker ? e.data.marker = n : e.stopImmediatePropagation(), this.markers[n.id] && !e.data.rightclick && ("click" === n.config.tooltip?.trigger ? n.tooltip ? this.hideMarkerTooltip(n.id) : this.showMarkerTooltip(n.id) : this.showMarkerPanel(n.id)));
    }
    __afterChangeMarkers() {
        this.__refreshUi(), this.__checkObjectsObserver(), this.viewer.needsUpdate(), this.dispatchEvent(new $a42f1354f0348298$var$Vb(this.getMarkers()));
    }
    __refreshUi() {
        const e = Object.values(this.markers).filter((e)=>!e.config.hideList).length;
        0 === e ? (this.viewer.panel.hide($a42f1354f0348298$var$$b), this.viewer.panel.hide($a42f1354f0348298$var$ek)) : this.viewer.panel.isVisible($a42f1354f0348298$var$ek) ? this.showMarkersList() : this.viewer.panel.isVisible($a42f1354f0348298$var$$b) && (this.state.currentMarker ? this.showMarkerPanel(this.state.currentMarker.id) : this.viewer.panel.hide()), this.viewer.navbar.getButton($a42f1354f0348298$var$Xb.id, !1)?.toggle(e > 0), this.viewer.navbar.getButton($a42f1354f0348298$var$nk.id, !1)?.toggle(e > 0);
    }
    __checkObjectsObserver() {
        Object.values(this.markers).some((e)=>e.is3d()) ? this.viewer.observeObjects($a42f1354f0348298$var$Yb) : this.viewer.unobserveObjects($a42f1354f0348298$var$Yb);
    }
};
$a42f1354f0348298$var$Rk.id = "markers", $a42f1354f0348298$var$Rk.VERSION = "5.15.1", $a42f1354f0348298$var$Rk.configParser = $a42f1354f0348298$var$Lk, $a42f1354f0348298$var$Rk.readonlyOptions = [
    "markers"
];
var $a42f1354f0348298$var$zk = $a42f1354f0348298$var$Rk;
$a42f1354f0348298$var$uy.lang[$a42f1354f0348298$var$Xb.id] = "Markers", $a42f1354f0348298$var$uy.lang[$a42f1354f0348298$var$nk.id] = "Markers list", $a42f1354f0348298$var$_y($a42f1354f0348298$var$Xb, "caption:left"), $a42f1354f0348298$var$_y($a42f1354f0348298$var$nk, "caption:left");
/*!
 * Photo Sphere Viewer / Equirectangular Tiles Adapter 5.15.1
 * @copyright 2015-2026 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */ var $a42f1354f0348298$var$Fk = class {
    constructor(e, t, i){
        this.id = e, this.priority = t, this.fn = i, this.status = 1;
    }
    start() {
        return this.status = 2, this.fn(this).then(()=>{
            this.status = 4;
        }, ()=>{
            this.status = 5;
        });
    }
    cancel() {
        this.status = 3;
    }
    isCancelled() {
        return 3 === this.status;
    }
}, $a42f1354f0348298$var$Uk = class {
    constructor(e = 8){
        this.concurency = e, this.runningTasks = {}, this.tasks = {};
    }
    enqueue(e) {
        this.tasks[e.id] = e;
    }
    clear() {
        Object.values(this.tasks).forEach((e)=>e.cancel()), this.tasks = {}, this.runningTasks = {};
    }
    setPriority(e, t) {
        const i = this.tasks[e];
        i && (i.priority = t, 0 === i.status && (i.status = 1));
    }
    disableAllTasks() {
        Object.values(this.tasks).forEach((e)=>{
            e.status = 0;
        });
    }
    start() {
        if (Object.keys(this.runningTasks).length >= this.concurency) return;
        const e = Object.values(this.tasks).filter((e)=>1 === e.status).sort((e, t)=>t.priority - e.priority).pop();
        e && (this.runningTasks[e.id] = !0, e.start().then(()=>{
            e.isCancelled() || (delete this.tasks[e.id], delete this.runningTasks[e.id], this.start());
        }), this.start());
    }
};
var $a42f1354f0348298$var$Nk = [
    "dodgerblue",
    "limegreen",
    "indianred"
];
function $a42f1354f0348298$var$Bk(e) {
    return !!e.levels;
}
function $a42f1354f0348298$var$Ok(e, t, i) {
    return {
        ...e,
        level: t,
        colSize: e.width / e.cols,
        rowSize: e.width / 2 / e.rows,
        facesByCol: i.SPHERE_SEGMENTS / e.cols,
        facesByRow: i.SPHERE_HORIZONTAL_SEGMENTS / e.rows
    };
}
function $a42f1354f0348298$var$jk(e, t, i, n, a) {
    let r, s;
    return $a42f1354f0348298$var$Bk(e) ? (n ? (s = e.levels.findIndex((e)=>{
        const a = e.width / 360 * t, r = e.width / 2 / 180 * i;
        return a >= n.width && r >= n.height;
    }), -1 === s && (s = e.levels.length - 1)) : s = 0, r = e.levels[s]) : (s = 0, r = {
        ...e
    }), $a42f1354f0348298$var$Ok(r, s, a);
}
function $a42f1354f0348298$var$Gk(e, t, i) {
    return $a42f1354f0348298$var$Bk(e) && e.levels[t] ? $a42f1354f0348298$var$Ok(e.levels[t], t, i) : null;
}
function $a42f1354f0348298$var$Vk(e, t) {
    if (!e.width || !e.cols || !e.rows) throw new $a42f1354f0348298$var$V_("Invalid panorama configuration, are you using the right adapter?");
    if (e.cols > t.SPHERE_SEGMENTS) throw new $a42f1354f0348298$var$V_(`Panorama cols must not be greater than ${t.SPHERE_SEGMENTS}.`);
    if (e.rows > t.SPHERE_HORIZONTAL_SEGMENTS) throw new $a42f1354f0348298$var$V_(`Panorama rows must not be greater than ${t.SPHERE_HORIZONTAL_SEGMENTS}.`);
    if (!$a42f1354f0348298$var$lu.isPowerOfTwo(e.cols) || !$a42f1354f0348298$var$lu.isPowerOfTwo(e.rows)) throw new $a42f1354f0348298$var$V_("Panorama cols and rows must be powers of 2.");
}
function $a42f1354f0348298$var$Hk(e, t) {
    for(let i = 0; i < t.cols; i++){
        const n = e.tileUrl(i, t.rows / 2, t.level);
        if (n) return n;
    }
    return e.tileUrl.toString();
}
function $a42f1354f0348298$var$qk(e) {
    return `${e.col}x${e.row}/${e.config.level}`;
}
function $a42f1354f0348298$var$Kk(e) {
    return e.children;
}
var $a42f1354f0348298$var$Wk = $a42f1354f0348298$var$d_.getConfigParser({
    resolution: 64,
    showErrorTile: !0,
    baseBlur: !0,
    antialias: !0,
    debug: !1,
    useXmpData: !1
}), $a42f1354f0348298$var$Xk = new $a42f1354f0348298$var$uu, $a42f1354f0348298$var$Qk = class e extends $a42f1354f0348298$var$NE {
    constructor(e, t){
        super(e), this.state = {
            tileConfig: null,
            tiles: {},
            faces: {},
            geom: null,
            materials: [],
            errorMaterial: null,
            inTransition: !1
        }, this.queue = new $a42f1354f0348298$var$Uk, this.config = $a42f1354f0348298$var$Wk(t), this.adapter = new $a42f1354f0348298$var$GE(this.viewer, {
            shader: !1,
            resolution: this.config.resolution
        }), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2, this.NB_VERTICES = 2 * this.SPHERE_SEGMENTS * 3 + (this.SPHERE_HORIZONTAL_SEGMENTS - 2) * this.SPHERE_SEGMENTS * 6, this.NB_GROUPS = this.SPHERE_SEGMENTS * this.SPHERE_HORIZONTAL_SEGMENTS, this.viewer.config.requestHeaders && $a42f1354f0348298$var$d_.logWarn('EquirectangularTilesAdapter fallbacks to file loader because "requestHeaders" where provided. Consider removing "requestHeaders" if you experience performances issues.');
    }
    static withConfig(t) {
        return [
            e,
            t
        ];
    }
    init() {
        super.init(), this.viewer.addEventListener($a42f1354f0348298$var$wv.TransitionDoneEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.PositionUpdatedEvent.type, this), this.viewer.addEventListener($a42f1354f0348298$var$wv.ZoomUpdatedEvent.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($a42f1354f0348298$var$wv.TransitionDoneEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.PositionUpdatedEvent.type, this), this.viewer.removeEventListener($a42f1354f0348298$var$wv.ZoomUpdatedEvent.type, this), this.__cleanup(), this.state.errorMaterial?.map?.dispose(), this.state.errorMaterial?.dispose(), this.adapter.destroy(), delete this.adapter, delete this.state.geom, delete this.state.errorMaterial, super.destroy();
    }
    handleEvent(e) {
        switch(e.type){
            case $a42f1354f0348298$var$wv.PositionUpdatedEvent.type:
            case $a42f1354f0348298$var$wv.ZoomUpdatedEvent.type:
                this.__refresh();
                break;
            case $a42f1354f0348298$var$wv.TransitionDoneEvent.type:
                this.state.inTransition = !1, e.completed && this.__switchMesh(this.viewer.renderer.mesh);
        }
    }
    supportsTransition(e) {
        return !!e.baseUrl;
    }
    supportsPreload(e) {
        return !!e.baseUrl;
    }
    textureCoordsToSphericalCoords(e, t) {
        return this.adapter.textureCoordsToSphericalCoords(e, t);
    }
    sphericalCoordsToTextureCoords(e, t) {
        return this.adapter.sphericalCoordsToTextureCoords(e, t);
    }
    async loadTexture(e, t = !0) {
        !function(e, t) {
            if ("object" != typeof e || !e.tileUrl) throw new $a42f1354f0348298$var$V_("Invalid panorama configuration, are you using the right adapter?");
            $a42f1354f0348298$var$Bk(e) ? (e.levels.forEach((e)=>{
                $a42f1354f0348298$var$Vk(e, t), "zoomRange" in e && $a42f1354f0348298$var$d_.logWarn('EquirectangularTilesAdapter: "zoomRange" property is deprecated and must be removed');
            }), e.levels.sort((e, t)=>e.width - t.width)) : $a42f1354f0348298$var$Vk(e, t);
        }(e, this);
        const i = $a42f1354f0348298$var$jk(e, 0, 0, null, this), n = {
            isEquirectangular: !0,
            fullWidth: i.width,
            fullHeight: i.width / 2,
            croppedWidth: i.width,
            croppedHeight: i.width / 2,
            croppedX: 0,
            croppedY: 0,
            poseHeading: 0,
            posePitch: 0,
            poseRoll: 0
        };
        if (e.baseUrl) {
            const i = {
                path: e.baseUrl,
                data: e.basePanoData,
                blur: this.config.baseBlur
            }, a = await this.adapter.loadTexture(i, t, null, !0);
            return {
                panorama: e,
                panoData: {
                    ...n,
                    baseData: a.panoData
                },
                cacheKey: a.cacheKey,
                texture: a.texture
            };
        }
        return {
            panorama: e,
            panoData: {
                ...n,
                baseData: null
            },
            cacheKey: $a42f1354f0348298$var$Hk(e, i),
            texture: null
        };
    }
    createMesh(e) {
        const t = this.adapter.createMesh(e.baseData ?? e), i = new $a42f1354f0348298$var$hA($a42f1354f0348298$var$Xf.SPHERE_RADIUS, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1).toNonIndexed();
        i.clearGroups();
        let n = 0, a = 0;
        for(; n < 3 * this.SPHERE_SEGMENTS; n += 3)i.addGroup(n, 3, a++);
        for(; n < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS; n += 6)i.addGroup(n, 6, a++);
        for(; n < this.NB_VERTICES; n += 3)i.addGroup(n, 3, a++);
        const r = [], s = new $a42f1354f0348298$var$kp({
            opacity: 0,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1
        });
        for(let e = 0; e < this.NB_GROUPS; e++)r.push(s);
        const o = new $a42f1354f0348298$var$zp(i, r);
        o.renderOrder = 1;
        const l = new $a42f1354f0348298$var$ch;
        return l.add(t), l.add(o), l;
    }
    setTexture(e, t, i) {
        const [n] = $a42f1354f0348298$var$Kk(e);
        t.texture ? this.adapter.setTexture(n, {
            panorama: t.panorama.baseUrl,
            texture: t.texture,
            panoData: t.panoData.baseData
        }) : n.visible = !1, i ? this.state.inTransition = !0 : this.__switchMesh(e);
    }
    setTextureOpacity(e, t) {
        const [i] = $a42f1354f0348298$var$Kk(e);
        this.adapter.setTextureOpacity(i, t);
    }
    disposeTexture({ texture: e }) {
        e?.dispose();
    }
    disposeMesh(e) {
        const [t, i] = $a42f1354f0348298$var$Kk(e);
        t.geometry.dispose(), t.material.dispose(), i.geometry.dispose(), i.material.forEach((e)=>{
            e.map?.dispose(), e.dispose();
        });
    }
    __refresh() {
        if (!this.state.geom || this.state.inTransition) return;
        const e = this.viewer.config.panorama, t = $a42f1354f0348298$var$jk(e, this.viewer.state.hFov, this.viewer.state.vFov, this.viewer.state.size, this), i = this.state.geom.getAttribute("position"), n = {};
        for(let a = 0; a < this.NB_VERTICES; a += 1)if ($a42f1354f0348298$var$Xk.fromBufferAttribute(i, a), $a42f1354f0348298$var$Xk.applyEuler(this.viewer.renderer.sphereCorrection), this.viewer.renderer.isObjectVisible($a42f1354f0348298$var$Xk)) {
            let i;
            i = a < 3 * this.SPHERE_SEGMENTS ? Math.floor(a / 3) : a < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS ? Math.floor((a / 3 - this.SPHERE_SEGMENTS) / 2) + this.SPHERE_SEGMENTS : Math.floor((a - this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS) / 3) + this.SPHERE_HORIZONTAL_SEGMENTS * (this.SPHERE_SEGMENTS - 1);
            const r = Math.floor(i / this.SPHERE_SEGMENTS), s = i - r * this.SPHERE_SEGMENTS;
            let o = t;
            for(; o;){
                const t = Math.floor(r / o.facesByRow), i = Math.floor(s / o.facesByCol);
                let a = $a42f1354f0348298$var$Xk.angleTo(this.viewer.state.direction);
                0 !== t && t !== o.rows - 1 || (a *= 2);
                const l = {
                    row: t,
                    col: i,
                    angle: a,
                    config: o,
                    url: null
                }, c = $a42f1354f0348298$var$qk(l);
                if (n[c]) {
                    n[c].angle = Math.min(n[c].angle, a);
                    break;
                }
                if (l.url = e.tileUrl(i, t, o.level), l.url) {
                    n[c] = l;
                    break;
                }
                o = $a42f1354f0348298$var$Gk(e, o.level - 1, this);
            }
        }
        this.state.tileConfig = t, this.__loadTiles(Object.values(n));
    }
    __loadTiles(e) {
        this.queue.disableAllTasks(), e.forEach((e)=>{
            const t = $a42f1354f0348298$var$qk(e);
            this.state.tiles[t] ? this.queue.setPriority(t, e.angle) : (this.state.tiles[t] = !0, this.queue.enqueue(new $a42f1354f0348298$var$Fk(t, e.angle, (t)=>this.__loadTile(e, t))));
        }), this.queue.start();
    }
    __loadTile(e, t) {
        return this.viewer.textureLoader.loadImage(e.url, null, this.viewer.state.textureData.cacheKey).then((i)=>{
            if (!t.isCancelled()) {
                this.config.debug && (i = function(e, t, i) {
                    const n = document.createElement("canvas");
                    n.width = e.width, n.height = e.height;
                    const a = n.getContext("2d");
                    a.fillStyle = $a42f1354f0348298$var$Nk[t % $a42f1354f0348298$var$Nk.length], a.fillRect(0, 0, n.width, n.height), a.globalCompositeOperation = "multiply", a.drawImage(e, 0, 0);
                    const r = e.width / 7;
                    return a.globalCompositeOperation = "source-over", a.fillStyle = "white", a.font = `${r}px monospace`, a.textAlign = "center", i.split("\n").forEach((t, i)=>{
                        a.fillText(t, e.width / 2, e.height / 2 + r * (.3 + i));
                    }), n;
                }(i, e.config.level, $a42f1354f0348298$var$qk(e)));
                const t = this.config.antialias && e.config.level > 0, n = new $a42f1354f0348298$var$kp({
                    map: $a42f1354f0348298$var$d_.createTexture(i, t)
                });
                this.__swapMaterial(e, n, !1), this.viewer.needsUpdate();
            }
        }).catch((i)=>{
            $a42f1354f0348298$var$d_.isAbortError(i) || t.isCancelled() || !this.config.showErrorTile || (this.state.errorMaterial || (this.state.errorMaterial = function() {
                const e = new OffscreenCanvas(512, 512), t = e.getContext("2d");
                return t.fillStyle = "#333", t.fillRect(0, 0, e.width, e.height), t.font = e.width / 5 + "px serif", t.fillStyle = "#a22", t.textAlign = "center", t.textBaseline = "middle", t.fillText("\u26A0", e.width / 2, e.height / 2), new $a42f1354f0348298$var$kp({
                    map: $a42f1354f0348298$var$d_.createTexture(e)
                });
            }()), this.__swapMaterial(e, this.state.errorMaterial, !0), this.viewer.needsUpdate());
        });
    }
    __swapMaterial(e, t, i) {
        const n = this.state.geom.getAttribute("uv");
        for(let a = 0; a < e.config.facesByCol; a++)for(let r = 0; r < e.config.facesByRow; r++){
            const s = e.col * e.config.facesByCol + a, o = e.row * e.config.facesByRow + r, l = 0 === o, c = o === this.SPHERE_HORIZONTAL_SEGMENTS - 1;
            let d;
            if (d = l ? 3 * s : c ? this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS + 3 * s : 3 * this.SPHERE_SEGMENTS + (o - 1) * this.SPHERE_SEGMENTS * 6 + 6 * s, i && this.state.faces[d] > -1) continue;
            if (this.state.faces[d] > e.config.level) continue;
            this.state.faces[d] = i ? -1 : e.config.level;
            const u = this.state.geom.groups.find((e)=>e.start === d).materialIndex;
            this.state.materials[u] = t;
            const h = 1 - r / e.config.facesByRow, p = 1 - (r + 1) / e.config.facesByRow, A = a / e.config.facesByCol, m = (a + 1) / e.config.facesByCol;
            l ? (n.setXY(d, (A + m) / 2, h), n.setXY(d + 1, A, p), n.setXY(d + 2, m, p)) : c ? (n.setXY(d, m, h), n.setXY(d + 1, A, h), n.setXY(d + 2, (A + m) / 2, p)) : (n.setXY(d, m, h), n.setXY(d + 1, A, h), n.setXY(d + 2, m, p), n.setXY(d + 3, A, h), n.setXY(d + 4, A, p), n.setXY(d + 5, m, p));
        }
        n.needsUpdate = !0;
    }
    __switchMesh(e) {
        const [, t] = $a42f1354f0348298$var$Kk(e);
        if (this.__cleanup(), this.state.materials = t.material, this.state.geom = t.geometry, this.config.debug) {
            const e = function(e) {
                const t = new $a42f1354f0348298$var$pA(e), i = new $a42f1354f0348298$var$aA(t);
                return i.material.depthTest = !1, i.material.depthWrite = !1, i.material.opacity = .25, i.material.transparent = !0, i;
            }(this.state.geom);
            this.viewer.renderer.addObject(e), this.viewer.renderer.setSphereCorrection(this.viewer.config.sphereCorrection, e);
        }
        setTimeout(()=>this.__refresh());
    }
    __cleanup() {
        this.queue.clear(), this.state.tiles = {}, this.state.faces = {}, this.state.materials = [], this.state.inTransition = !1;
    }
};
$a42f1354f0348298$var$Qk.id = "equirectangular-tiles", $a42f1354f0348298$var$Qk.VERSION = "5.15.1", $a42f1354f0348298$var$Qk.supportsDownload = !1;
var $a42f1354f0348298$var$Zk = $a42f1354f0348298$var$Qk;
class $a42f1354f0348298$var$Yk extends $a42f1354f0348298$var$Zk {
    constructor(e, t){
        super(e, t), this._shouldGoFast = t.shouldGoFast || (()=>!0);
    }
    loadTexture(e, t) {
        return e.origBaseUrl ? e.baseUrl = e.origBaseUrl : e.origBaseUrl = e.baseUrl, this._shouldGoFast() && e.thumbUrl && !e.hdLoaded && 1 == e.rows && e.cropData?.croppedWidth !== e.cropData?.fullWidth && (e.baseUrl = e.thumbUrl), super.loadTexture(e, t).then((t)=>(e.baseUrl === e.origBaseUrl && (e.hdLoaded = !0), t)).catch((e)=>{
            console.error("Can't load texture", e);
        });
    }
    __loadTiles(e) {
        this._shouldGoFast() || super.__loadTiles(e);
    }
}
const $a42f1354f0348298$var$Jk = new CSSStyleSheet;
$a42f1354f0348298$var$Jk.replaceSync('/*!\n * Photo Sphere Viewer 5.15.1\n * @copyright 2014-2015 J\xe9r\xe9my Heleine\n * @copyright 2015-2026 Damien "Mistic" Sorel\n * @licence MIT (https://opensource.org/licenses/MIT)\n */\n/* src/styles/index.scss */\n.psv-container {\n  --psv-core-loaded: true;\n  container-name: psv-container;\n  container-type: size;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background:\n    radial-gradient(\n      #fff 0%,\n      #fdfdfd 16%,\n      #fbfbfb 33%,\n      #f8f8f8 49%,\n      #efefef 66%,\n      #dfdfdf 82%,\n      #bfbfbf 100%);\n  overflow: hidden;\n}\n.psv-container * {\n  box-sizing: content-box;\n}\n.psv-canvas-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  transition: opacity linear 100ms;\n}\n.psv-fullscreen-emulation {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 9999;\n}\n.psv-loader-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 80;\n}\n.psv-loader {\n  --psv-loader-border: 3px;\n  --psv-loader-tickness: 10px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgba(255, 255, 255, 0.7);\n  width: 150px;\n  height: 150px;\n}\n.psv-loader-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: rgba(61, 61, 61, 0.5);\n  z-index: -1;\n}\n.psv-loader-text {\n  font: 600 16px sans-serif;\n  text-align: center;\n}\n.psv-loader--undefined .psv-loader-canvas {\n  animation: psv-loader 2s cubic-bezier(0.75, 0.25, 0.25, 0.75) infinite;\n}\n@keyframes psv-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.psv-navbar {\n  display: flex;\n  position: absolute;\n  z-index: 90;\n  bottom: -40px;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(61, 61, 61, 0.5);\n  transition: bottom ease-in-out 0.1s;\n  font: 16px sans-serif;\n  cursor: default;\n}\n.psv-navbar--open {\n  bottom: 0;\n}\n.psv-navbar,\n.psv-navbar * {\n  box-sizing: content-box;\n}\n.psv-button {\n  flex: 0 0 auto;\n  padding: 10px;\n  position: relative;\n  cursor: pointer;\n  height: 20px;\n  width: 20px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.7);\n}\n.psv-button--active {\n  background: rgba(255, 255, 255, 0.2);\n}\n.psv-button--disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.psv-button-svg {\n  width: 100%;\n  transform: scale(1);\n  transition: transform 200ms ease;\n  vertical-align: initial;\n}\n.psv-button:not(.psv-button--disabled):focus-visible {\n  outline: 2px solid #007cff;\n  outline-offset: -2px;\n}\n.psv-container:not(.psv--is-touch) .psv-button--hover-scale:not(.psv-button--disabled):hover .psv-button-svg {\n  transform: scale(1.2);\n}\n.psv-move-button + .psv-move-button {\n  margin-left: -10px;\n}\n.psv-download-button {\n  color: rgba(255, 255, 255, 0.7) !important;\n  text-decoration: none !important;\n}\n.psv-download-button::before,\n.psv-download-button::after {\n  display: none !important;\n}\n.psv-custom-button {\n  width: auto;\n  min-width: 20px;\n}\n.psv-custom-button--no-padding {\n  padding: 0;\n  height: 100%;\n}\n.psv-caption {\n  flex: 1 1 100%;\n  color: rgba(255, 255, 255, 0.7);\n  overflow: hidden;\n  text-align: center;\n  cursor: unset;\n  padding: unset;\n  height: unset;\n  width: unset;\n}\n.psv-caption-content {\n  display: inline-block;\n  padding: 10px;\n  white-space: nowrap;\n}\n.psv-zoom-range.psv-button {\n  width: 80px;\n  height: 1px;\n  margin: 10px 0;\n  padding: 9.5px 0;\n  max-width: 600px;\n}\n.psv-zoom-range-line {\n  position: relative;\n  width: 80px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.7);\n  transition: all 0.3s ease;\n}\n.psv-zoom-range-handle {\n  position: absolute;\n  border-radius: 50%;\n  top: -3px;\n  width: 7px;\n  height: 7px;\n  background: rgba(255, 255, 255, 0.7);\n  transform: scale(1);\n  transition: transform 0.3s ease;\n}\n.psv-zoom-range:not(.psv-button--disabled):hover .psv-zoom-range-line {\n  box-shadow: 0 0 2px rgba(255, 255, 255, 0.7);\n}\n.psv-zoom-range:not(.psv-button--disabled):hover .psv-zoom-range-handle {\n  transform: scale(1.3);\n}\n.psv-notification {\n  position: absolute;\n  z-index: 100;\n  bottom: -40px;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 2em;\n  opacity: 0;\n  transition-property: opacity, bottom;\n  transition-timing-function: ease-in-out;\n  transition-duration: 200ms;\n}\n.psv-notification-content {\n  max-width: 50em;\n  background: rgba(61, 61, 61, 0.8);\n  border-radius: 4px;\n  padding: 0.5em 1em;\n  font: 14px sans-serif;\n  color: rgb(255, 255, 255);\n}\n.psv-notification--visible {\n  opacity: 100;\n  bottom: 80px;\n}\n.psv-overlay {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: 110;\n  inset: 0;\n  background:\n    radial-gradient(\n      #fff 0%,\n      #fdfdfd 16%,\n      #fbfbfb 33%,\n      #f8f8f8 49%,\n      #efefef 66%,\n      #dfdfdf 82%,\n      #bfbfbf 100%);\n  opacity: 0.8;\n  cursor: default;\n}\n.psv-overlay-image {\n  width: 100%;\n  text-align: center;\n  color: rgb(48, 48, 48);\n}\n.psv-overlay-image svg {\n  width: 50%;\n}\n@container psv-container (orientation: landscape) {\n  .psv-overlay-image svg {\n    width: 33%;\n  }\n}\n.psv-overlay-title {\n  color: black;\n  margin-top: 1em;\n  font: 30px sans-serif;\n  text-align: center;\n}\n.psv-overlay-text {\n  color: rgba(0, 0, 0, 0.8);\n  font: 20px sans-serif;\n  opacity: 0.8;\n  text-align: center;\n}\n.psv-panel {\n  position: absolute;\n  z-index: 90;\n  right: 0;\n  height: 100%;\n  width: 400px;\n  max-width: calc(100% - 9px);\n  background: rgba(10, 10, 10, 0.7);\n  transform: translate3d(100%, 0, 0);\n  opacity: 0;\n  transition-property: opacity, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 100ms;\n  cursor: default;\n  margin-left: 9px;\n}\n.psv--has-navbar .psv-panel {\n  height: calc(100% - 40px);\n}\n.psv-panel-close-button {\n  display: none;\n  position: absolute;\n  top: -1px;\n  right: 0;\n  width: 19.2px;\n  height: 19.2px;\n  padding: 6.4px;\n  background: transparent;\n  color: #fff;\n  transition: background 300ms ease-in-out;\n  cursor: pointer;\n}\n.psv-panel-close-button svg {\n  transition: transform 300ms ease-in-out;\n}\n.psv-panel-close-button:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n.psv-panel-close-button:hover svg {\n  transform: scale(-1);\n}\n.psv-panel-resizer {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: -9px;\n  width: 9px;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  cursor: col-resize;\n}\n.psv-panel-resizer::before {\n  content: "";\n  position: absolute;\n  top: 50%;\n  left: 5.5px;\n  margin-top: -14.5px;\n  width: 1px;\n  height: 1px;\n  box-shadow:\n    1px 0 #fff,\n    3px 0px #fff,\n    5px 0px #fff,\n    1px 2px #fff,\n    3px 2px #fff,\n    5px 2px #fff,\n    1px 4px #fff,\n    3px 4px #fff,\n    5px 4px #fff,\n    1px 6px #fff,\n    3px 6px #fff,\n    5px 6px #fff,\n    1px 8px #fff,\n    3px 8px #fff,\n    5px 8px #fff,\n    1px 10px #fff,\n    3px 10px #fff,\n    5px 10px #fff,\n    1px 12px #fff,\n    3px 12px #fff,\n    5px 12px #fff,\n    1px 14px #fff,\n    3px 14px #fff,\n    5px 14px #fff,\n    1px 16px #fff,\n    3px 16px #fff,\n    5px 16px #fff,\n    1px 18px #fff,\n    3px 18px #fff,\n    5px 18px #fff,\n    1px 20px #fff,\n    3px 20px #fff,\n    5px 20px #fff,\n    1px 22px #fff,\n    3px 22px #fff,\n    5px 22px #fff,\n    1px 24px #fff,\n    3px 24px #fff,\n    5px 24px #fff,\n    1px 26px #fff,\n    3px 26px #fff,\n    5px 26px #fff,\n    1px 28px #fff,\n    3px 28px #fff,\n    5px 28px #fff;\n  background: transparent;\n}\n.psv-panel-content {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  color: rgb(220, 220, 220);\n  font: 16px sans-serif;\n  overflow: auto;\n}\n.psv-panel-content:not(.psv-panel-content--no-margin) {\n  padding: 1em;\n}\n.psv-panel-content--no-interaction {\n  user-select: none;\n  pointer-events: none;\n}\n.psv-panel--open {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n  transition-duration: 0.2s;\n}\n.psv-panel--open .psv-panel-close-button,\n.psv-panel--open .psv-panel-resizer {\n  display: block;\n}\n@container psv-container (max-width: 400px) {\n  .psv-panel {\n    width: 100% !important;\n    max-width: none;\n  }\n  .psv-panel-resizer {\n    display: none !important;\n  }\n}\n.psv-panel-menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.psv-panel-menu-title {\n  flex: none;\n  display: flex;\n  align-items: center;\n  font: 24px sans-serif;\n  margin: 24px 12px;\n}\n.psv-panel-menu-title svg {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n.psv-panel-menu-list {\n  flex: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n.psv-panel-menu-item {\n  min-height: 1.5em;\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transition: background 0.1s ease-in-out;\n}\n.psv-panel-menu-item--active {\n  outline: 1px solid currentcolor;\n  outline-offset: -1px;\n}\n.psv-panel-menu-item-icon {\n  flex: none;\n  height: 1.5em;\n  width: 1.5em;\n  margin-right: 0.5em;\n}\n.psv-panel-menu-item-icon img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.psv-panel-menu-item-icon {\n}\n.psv-panel-menu-item-icon svg {\n  width: 100%;\n  height: 100%;\n}\n.psv-panel-menu-item:focus-visible {\n  outline: 2px solid #007cff;\n  outline-offset: -2px;\n}\n.psv-panel-menu--stripped .psv-panel-menu-item:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(odd),\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(odd)::before {\n  background: rgba(255, 255, 255, 0.1);\n}\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(even),\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(even)::before {\n  background: transparent;\n}\n.psv-container:not(.psv--is-touch) .psv-panel-menu-item:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n.psv-tooltip {\n  position: absolute;\n  z-index: 50;\n  box-sizing: border-box;\n  max-width: 200px;\n  background: rgba(61, 61, 61, 0.8);\n  border-radius: 4px;\n  opacity: 0;\n  transition-property: opacity, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 100ms;\n  cursor: default;\n}\n.psv-tooltip-content {\n  color: rgb(255, 255, 255);\n  font: 14px sans-serif;\n  text-shadow: 0 1px #000;\n  padding: 0.5em 1em;\n}\n.psv-tooltip-arrow {\n  position: absolute;\n  height: 0;\n  width: 0;\n  border: 7px solid transparent;\n}\n.psv-tooltip--top-left,\n.psv-tooltip--top-center,\n.psv-tooltip--top-right {\n  transform: translate3d(0, 5px, 0);\n}\n.psv-tooltip--top-left .psv-tooltip-arrow,\n.psv-tooltip--top-center .psv-tooltip-arrow,\n.psv-tooltip--top-right .psv-tooltip-arrow {\n  border-top-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--bottom-left,\n.psv-tooltip--bottom-center,\n.psv-tooltip--bottom-right {\n  transform: translate3d(0, -5px, 0);\n}\n.psv-tooltip--bottom-left .psv-tooltip-arrow,\n.psv-tooltip--bottom-center .psv-tooltip-arrow,\n.psv-tooltip--bottom-right .psv-tooltip-arrow {\n  border-bottom-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--left-top,\n.psv-tooltip--center-left,\n.psv-tooltip--left-bottom {\n  transform: translate3d(5px, 0, 0);\n}\n.psv-tooltip--left-top .psv-tooltip-arrow,\n.psv-tooltip--center-left .psv-tooltip-arrow,\n.psv-tooltip--left-bottom .psv-tooltip-arrow {\n  border-left-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--right-top,\n.psv-tooltip--center-right,\n.psv-tooltip--right-bottom {\n  transform: translate3d(-5px, 0, 0);\n}\n.psv-tooltip--right-top .psv-tooltip-arrow,\n.psv-tooltip--center-right .psv-tooltip-arrow,\n.psv-tooltip--right-bottom .psv-tooltip-arrow {\n  border-right-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--left-top,\n.psv-tooltip--top-left {\n  box-shadow: -3px -3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--top-center {\n  box-shadow: 0 -3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--right-top,\n.psv-tooltip--top-right {\n  box-shadow: 3px -3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--left-bottom,\n.psv-tooltip--bottom-left {\n  box-shadow: -3px 3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--bottom-center {\n  box-shadow: 0 3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--right-bottom,\n.psv-tooltip--bottom-right {\n  box-shadow: 3px 3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--center-left {\n  box-shadow: -3px 0 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--center-right {\n  box-shadow: 3px 0 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--visible {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n/*# sourceMappingURL=index.css.map */');
const $a42f1354f0348298$var$$k = new CSSStyleSheet;
$a42f1354f0348298$var$$k.replaceSync('/*!\n * Photo Sphere Viewer / Virtual Tour Plugin 5.15.1\n * @copyright 2015-2026 Damien "Mistic" Sorel\n * @licence MIT (https://opensource.org/licenses/MIT)\n */\n/* src/styles/index.scss */\n.psv-container {\n  --psv-virtual-tour-plugin-loaded: true;\n}\n.psv-virtual-tour-tooltip h3 {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n.psv-virtual-tour-tooltip h3:not(:last-child) {\n  margin-bottom: 0.5em;\n}\n.psv-virtual-tour-tooltip img {\n  display: block;\n  width: 200px;\n  margin: 0 -1em;\n}\n.psv-virtual-tour-tooltip img:first-child {\n  border-radius: 4px 4px 0 0;\n}\n.psv-virtual-tour-tooltip img:last-child {\n  border-radius: 0 0 4px 4px;\n}\n.psv-virtual-tour-tooltip img:not(:last-child) {\n  margin-bottom: 0.5em;\n}\n.psv-virtual-tour-tooltip p {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n.psv-virtual-tour-link {\n  cursor: pointer;\n  transform-origin: center;\n}\n.psv-virtual-tour-arrows {\n  position: absolute;\n  overflow: visible !important;\n  z-index: 11;\n  bottom: 0;\n  left: 0;\n  filter: drop-shadow(0 10px 2px rgba(0, 0, 0, 0.7));\n  pointer-events: none;\n  transition: margin ease-in-out 0.3s;\n}\n.psv-virtual-tour-arrows .psv-virtual-tour-link {\n  transition: opacity linear 0.2s;\n}\n.psv-virtual-tour-arrows .psv-virtual-tour-link:hover {\n  opacity: 1 !important;\n}\n.psv-virtual-tour-arrow {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: none;\n  background: none;\n  color: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n}\n.psv-virtual-tour-arrow:hover {\n  animation: psv-virtual-tour-link-button-in 1s ease-out forwards;\n}\n.psv-virtual-tour-loader {\n  display: block;\n  position: relative;\n  width: 40px;\n  height: 30px;\n  margin: 0 40px;\n}\n.psv-virtual-tour-loader div {\n  display: inline-block;\n  position: absolute;\n  left: 10%;\n  width: 20%;\n  background: #fff;\n  animation: psv-virtual-tour-loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;\n}\n.psv-virtual-tour-loader div:nth-child(1) {\n  left: 10%;\n  animation-delay: -0.24s;\n}\n.psv-virtual-tour-loader div:nth-child(2) {\n  left: 40%;\n  animation-delay: -0.12s;\n}\n.psv-virtual-tour-loader div:nth-child(3) {\n  left: 70%;\n  animation-delay: 0;\n}\n@keyframes psv-virtual-tour-loader {\n  0% {\n    top: 10%;\n    height: 80%;\n  }\n  50%, 100% {\n    top: 30%;\n    height: 40%;\n  }\n}\n@keyframes psv-virtual-tour-link-button-in {\n  0% {\n    box-shadow: 0 0 0 0 rgba(97, 170, 242, 0);\n  }\n  20% {\n    box-shadow: 0 0 0 5px #61aaf2;\n  }\n  100% {\n    box-shadow: 0 0 0 20px rgba(97, 170, 242, 0);\n  }\n}\n/*# sourceMappingURL=index.css.map */');
const $a42f1354f0348298$var$ex = new CSSStyleSheet;
$a42f1354f0348298$var$ex.replaceSync('/*!\n * Photo Sphere Viewer / Markers Plugin 5.15.1\n * @copyright 2015-2026 Damien "Mistic" Sorel\n * @licence MIT (https://opensource.org/licenses/MIT)\n */\n/* src/styles/index.scss */\n.psv-container {\n  --psv-markers-plugin-loaded: true;\n}\n.psv-markers {\n  pointer-events: none;\n  position: absolute;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n}\n.psv-markers-svg-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 20;\n}\n.psv-markers-css3d-container {\n  position: absolute;\n  z-index: 21;\n}\n.psv-marker {\n  display: none;\n  pointer-events: auto;\n}\n.psv-marker--normal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 30;\n  overflow: visible;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.psv-marker--css3d {\n  display: block;\n}\n.psv-marker--transparent {\n  display: block;\n  opacity: 0;\n}\n.psv-marker--visible {\n  display: block;\n}\n.psv-marker--has-tooltip,\n.psv-marker--has-content {\n  cursor: pointer;\n}\n/*# sourceMappingURL=index.css.map */');
const $a42f1354f0348298$var$tx = new CSSStyleSheet;
$a42f1354f0348298$var$tx.replaceSync("/* Smaller loading text */\n.psv-loader-text {\n\ttext-align: center;\n\tfont-size: 0.9em;\n}\n\n.psv-loader-image { width: 80%; }\n\n.psv-overlay { opacity: 1 !important; }\n\n/* Hide PSV tooltips */\n.psv-virtual-tour-tooltip { display: none; }\n\n/* Resize canvas for print */\n@media print {\n\t.pnx-psv canvas {\n\t\twidth: 100% !important;\n\t\theight: unset !important;\n\t}\n}\n\n/* Virtual Tour SVG arrows */\n.pnx-psv-tour-arrows {\n\tbackground: none;\n\tborder: none;\n\n}\n.pnx-psv-tour-arrows:active svg,\n.pnx-psv-tour-arrows.pnx-clicked svg {\n\topacity: 0.4;\n\ttransition: opacity 0.2s ease;\n}\n.pnx-psv-tour-arrows svg {\n\twidth: 100%;\n\theight: auto;\n}\n\n.pnx-psv-tour-arrows svg:hover {\n\tfilter: drop-shadow(0 0 15px var(--blue));\n}\n\n.pnx-psv-playing .pnx-psv-tour-arrows {\n\tdisplay: none;\n}\n\n/* No virtual tour arrows or annotations if photo is reduced */\npnx-mini .psv-virtual-tour-arrows,\npnx-mini .pnx-psv-annotation {\n\tdisplay: none;\n}");
var $a42f1354f0348298$var$ix = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Created with Inkscape (http://www.inkscape.org/) --%3e%3csvg width='48' height='48' viewBox='0 0 12.7 12.7' version='1.1' id='svg5' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cdefs id='defs2'%3e%3cfilter style='color-interpolation-filters:sRGB%3b' id='filter1345' x='-0.2314438' y='-0.2314438' width='1.4628876' height='1.4628876'%3e%3cfeFlood flood-opacity='0.498039' flood-color='rgb(0%2c0%2c0)' result='flood' id='feFlood1335' /%3e%3cfeComposite in='flood' in2='SourceGraphic' operator='in' result='composite1' id='feComposite1337' /%3e%3cfeGaussianBlur in='composite1' stdDeviation='0.5' result='blur' id='feGaussianBlur1339' /%3e%3cfeOffset dx='0' dy='0' result='offset' id='feOffset1341' /%3e%3cfeComposite in='SourceGraphic' in2='offset' operator='over' result='composite2' id='feComposite1343' /%3e%3c/filter%3e%3cfilter style='color-interpolation-filters:sRGB%3b' id='filter1389' x='-0.19034556' y='-0.19034556' width='1.3806911' height='1.3806911'%3e%3cfeFlood flood-opacity='0.498039' flood-color='rgb(0%2c0%2c0)' result='flood' id='feFlood1379' /%3e%3cfeComposite in='flood' in2='SourceGraphic' operator='in' result='composite1' id='feComposite1381' /%3e%3cfeGaussianBlur in='composite1' stdDeviation='0.5' result='blur' id='feGaussianBlur1383' /%3e%3cfeOffset dx='0' dy='0' result='offset' id='feOffset1385' /%3e%3cfeComposite in='SourceGraphic' in2='offset' operator='over' result='composite2' id='feComposite1387' /%3e%3c/filter%3e%3c/defs%3e%3cg id='layer1'%3e%3cpath style='fill:%23bf674c%3bfill-opacity:1%3bstroke:white%3bstroke-width:0.661458%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1%3bfilter:url(%23filter1389)' id='path6342' transform='matrix(-0.23019089%2c-0.85909373%2c0.85909246%2c-0.23019564%2c0.96173083%2c0.76136943)' d='M -1.2578926%2c1.9117668 A 8.0418425%2c8.0418425 0 0 1 -9.2997351%2c9.9536092 V 1.9117668 Z' /%3e%3ccircle style='fill:%23be621c%3bfill-opacity:1%3bstroke:white%3bstroke-width:0.88787%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1%3bfilter:url(%23filter1345)' id='path846' cx='7.9277072' cy='5.4758525' r='3.5514777' transform='matrix(0.77024177%2c0.44469933%2c-0.44469933%2c0.77024177%2c0.96173083%2c0.76136943)' /%3e%3cg id='g892' transform='matrix(1.1784639%2c0%2c0%2c1.1784639%2c-0.83676862%2c-1.6599522)'%3e%3cpath d='M 3.5996678%2c9.4106252 H 5.7824803 V 9.8075001 H 3.5996678 Z' id='path254' style='fill:white%3bfill-opacity:1%3bstroke-width:0.264583' /%3e%3cpath d='M 4.1283053%2c8.2700064 3.8301199%2c8.0048939 4.0952324%2c7.7067085 3.7986345%2c7.4429189 3.533522%2c7.7411043 3.2353366%2c7.4759918 2.971547%2c7.7725898 3.2697324%2c8.0377023 3.0046199%2c8.3358877 3.3012178%2c8.5996772 3.5663303%2c8.3014918 3.8645157%2c8.5666043 Z' id='path256' style='fill:white%3bfill-opacity:1%3bstroke-width:0.264583' /%3e%3cpath d='M 6.2780449%2c7.7069731 5.981447%2c7.4431835 5.7163345%2c7.7413689 5.4181491%2c7.4762564 5.1543595%2c7.7728543 5.4525449%2c8.0379668 5.1874324%2c8.3361522 5.4840303%2c8.5999418 5.7491428%2c8.3017564 6.0473282%2c8.5668689 6.3111178%2c8.270271 6.0129324%2c8.0051585 Z' id='path258' style='fill:white%3bfill-opacity:1%3bstroke-width:0.264583' /%3e%3c/g%3e%3c/g%3e%3c/svg%3e", $a42f1354f0348298$var$nx = "data:image/jpeg;base64,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";
document.adoptedStyleSheets.push($a42f1354f0348298$var$Jk), document.adoptedStyleSheets.push($a42f1354f0348298$var$$k), document.adoptedStyleSheets.push($a42f1354f0348298$var$ex), document.adoptedStyleSheets.push($a42f1354f0348298$var$tx);
const $a42f1354f0348298$var$ax = {
    baseUrl: $a42f1354f0348298$var$nx,
    width: 1280,
    cols: 2,
    rows: 1,
    tileUrl: ()=>null
}, $a42f1354f0348298$var$rx = {
    id: $a42f1354f0348298$var$Gs,
    caption: "",
    panorama: $a42f1354f0348298$var$ax,
    links: [],
    gps: [
        0,
        0
    ],
    sequence: {},
    sphereCorrection: {},
    horizontalFov: 360,
    properties: {}
}, $a42f1354f0348298$var$sx = 250, $a42f1354f0348298$var$ox = 3e3, $a42f1354f0348298$var$lx = "draw-annotation-1", $a42f1354f0348298$var$cx = "draw-annotation-2", $a42f1354f0348298$var$dx = "draw-annotation-r", $a42f1354f0348298$var$ux = "rgb(224, 64, 251)", $a42f1354f0348298$var$hx = "rgb(224, 64, 251, 0.5)", $a42f1354f0348298$var$px = "rgb(123, 31, 162)", $a42f1354f0348298$var$Ax = "rgba(123, 31, 162, 0.5)";
$a42f1354f0348298$var$Gy.useNewAnglesOrder = !0;
class $a42f1354f0348298$var$mx extends $a42f1354f0348298$var$Gy {
    constructor(e, t, i = {}){
        var n;
        super({
            container: t,
            adapter: [
                $a42f1354f0348298$var$Yk,
                {
                    showErrorTile: !1,
                    baseBlur: !1,
                    resolution: e.isWidthSmall() ? 32 : 64,
                    shouldGoFast: i?.shouldGoFast || (()=>!1),
                    useXmpData: !1
                }
            ],
            withCredentials: e.api._getPSVWithCredentials(),
            requestHeaders: e?.["fetch-options"]?.headers,
            panorama: $a42f1354f0348298$var$ax,
            lang: e._t.psv,
            minFov: 5,
            loadingTxt: "&nbsp;",
            navbar: null,
            rendererParameters: {
                preserveDrawingBuffer: !e.isWidthSmall()
            },
            plugins: [
                [
                    $a42f1354f0348298$var$kb,
                    {
                        dataMode: "server",
                        positionMode: "gps",
                        renderMode: "3d",
                        preload: !0,
                        getNode: ()=>{},
                        transitionOptions: ()=>{},
                        arrowsPosition: {
                            linkOverlapAngle: Math.PI / 6
                        }
                    }
                ],
                [
                    $a42f1354f0348298$var$zk,
                    {}
                ],
                ...i.plugins || []
            ],
            ...(n = i, Object.fromEntries(Object.entries(n).filter(([e])=>![
                    "plugins",
                    "shouldGoFast",
                    "displayAnnotations",
                    "transitionDuration",
                    "picturesNavigation"
                ].includes(e))))
        }), this._parent = e, this._options = i, t.classList.add("pnx-psv"), this._shouldGoFast = i?.shouldGoFast || (()=>!1), this._transitionDuration = i?.transitionDuration || $a42f1354f0348298$var$sx, this._myVTour = this.getPlugin($a42f1354f0348298$var$kb), this._myVTour.datasource.nodeResolver = this._getNodeFromAPI.bind(this), this._myVTour.config.transitionOptions = this._psvNodeTransition.bind(this), this._clearArrows = this._myVTour.arrowsRenderer.clear.bind(this._myVTour.arrowsRenderer), this._myVTour.arrowsRenderer.clear = ()=>{}, this._myMarkers = this.getPlugin($a42f1354f0348298$var$zk), this._annotationsVisible = !0 === this._options.displayAnnotations, this._drawingAnnotation = null, this._sequencePlaying = 0, this._picturesNavigation = this._options.picturesNavigation || "any", this._picturesSequences = {}, this._myVTour.addEventListener("enter-arrow", this._onEnterArrow.bind(this)), this._myVTour.addEventListener("leave-arrow", this._onLeaveArrow.bind(this)), this._myVTour.addEventListener("node-changed", this._onNodeChanged.bind(this)), this._myMarkers.addEventListener("select-marker", this._onSelectMarker.bind(this)), this.addEventListener("position-updated", this._onPositionUpdated.bind(this)), this.addEventListener("zoom-updated", this._onZoomUpdated.bind(this)), this.addEventListener("dblclick", this._onDoubleClick.bind(this)), this._parent.addEventListener("select", this._onSelect.bind(this)), this._parent.mapStyleComposer?.addEventListener("filters-changed", ()=>{
            const e = this.getPictureMetadata();
            e && setTimeout(()=>{
                const t = Object.assign({}, this._myVTour.state.currentNode);
                e.geometry = {
                    coordinates: t.gps
                }, e.links = e.origLinks, t.links = $a42f1354f0348298$var$al(e, this._picturesNavFilter.bind(this)), this._myVTour.datasource.nodes[t.id] = t, this._myVTour.__renderLinks(t);
            }, 2e3);
        }), this.loader.size = 150, this.loader.color = "rgba(61, 61, 61, 0.5)", this.loader.textColor = "rgba(255, 255, 255, 0.7)", this.loader.border = 5, this.loader.thickness = 10, this.loader.canvas.setAttribute("viewBox", "0 0 150 150"), this.loader.__updateContent(), this._options.position && !this._parent.picture && this.goToPosition(...this._options.position), this._clickAndGo = new $a42f1354f0348298$var$_l(this, !this._parent.isWidthSmall());
    }
    async _getNodeFromAPI(e, t = !1) {
        if ($a42f1354f0348298$var$Zs(e)) return $a42f1354f0348298$var$rx;
        const i = t ? this._parent.api : this._parent.getAPI(), n = await fetch(i.getPictureMetadataUrl(e, this._picturesSequences[e]), i._getFetchOptions());
        let a = await n.json();
        if (a.features && (a = a.features.pop()), !a || 0 === Object.keys(a).length || !n.ok) {
            if (this._parent.hasTwoAPIs?.() && !t) return console.log("Failed to find picture on metacatalog, check local API"), await this._getNodeFromAPI(e, !0);
            throw new Error("Picture with ID " + e + " was not found");
        }
        this._picturesSequences[e] = a.collection;
        const r = $a42f1354f0348298$var$nl(a, this._parent._t, this._parent._isInternetFast, this._picturesNavFilter.bind(this), this._parent.getAPI().cleanResourceURL.bind(this._parent.getAPI()));
        return r?.sequence?.prevPic && (this._picturesSequences[r?.sequence?.prevPic] = a.collection), r?.sequence?.nextPic && (this._picturesSequences[r?.sequence?.nextPic] = a.collection), r;
    }
    _psvNodeTransition(e, t, i) {
        let n = {};
        const a = this._shouldGoFast() ? 0 : Math.min($a42f1354f0348298$var$sx, this._transitionDuration), r = a > 100, s = null != (i || t?.links.find((t)=>t.nodeId == e.id)), o = t && e.sequence.id === t.sequence.id, l = $a42f1354f0348298$var$vo(t?.properties?.["view:azimuth"] || 0), c = $a42f1354f0348298$var$vo(e?.properties?.["view:azimuth"] || 0), d = $a42f1354f0348298$var$vo($a42f1354f0348298$var$ro(e));
        this.setOption("maxFov", Math.min(3 * e.horizontalFov / 4, 90));
        const u = {
            showLoader: !1,
            effect: "none",
            speed: 0,
            rotation: !1,
            rotateTo: {
                pitch: 0,
                yaw: -d
            },
            zoomTo: 30
        };
        if (360 == e.horizontalFov) t ? $a42f1354f0348298$var$Js(t.gps, e.gps) >= .005 ? n = u : (n = {
            speed: a,
            effect: s && r ? "fade" : "none",
            rotation: s && o && r,
            rotateTo: this.getPosition()
        }, this._keepSameAngle && (n.rotateTo.yaw += l - c, this._keepSameAngle = !1)) : n = u;
        else if (o) {
            const e = this.getPosition().yaw, i = $a42f1354f0348298$var$vo(t.horizontalFov) / 2, o = e <= i || e >= 2 * Math.PI - i, d = Math.abs(l - c) <= Math.PI / 4;
            n = {
                speed: a,
                effect: s && d && r ? "fade" : "none",
                rotation: s && d && r,
                rotateTo: o ? this.getPosition() : {
                    pitch: 0,
                    yaw: 0
                },
                zoomTo: o ? this.getZoomLevel() : 30
            };
        } else n = Object.assign(u, {
            rotateTo: {
                pitch: 0,
                yaw: 0
            }
        });
        "fade" === n.effect && n.speed >= 150 ? setTimeout(this._clearArrows, n.speed - 100) : this._clearArrows();
        const h = new CustomEvent("picture-loading", {
            detail: {
                ...Object.assign({}, this.getXYZ(), n.rotateTo ? {
                    x: $a42f1354f0348298$var$_o(c + n.rotateTo.yaw)
                } : null, n.zoomTo ? {
                    z: n.zoomTo
                } : null),
                picId: e.id,
                lon: e.gps[0],
                lat: e.gps[1],
                first: this._parent._initParams?.getParentPostInit().picture == e.id
            }
        });
        return this.dispatchEvent(h), n;
    }
    _onEnterArrow(e) {
        const t = e.link, i = e.node;
        let n;
        i && (n = 360 === i.horizontalFov ? (this.getPictureOriginalHeading() + $a42f1354f0348298$var$_o(this.getPosition().yaw)) % 360 : this.getPictureOriginalHeading());
        const a = new CustomEvent("picture-preview-started", {
            detail: {
                picId: t.nodeId,
                coordinates: t.gps,
                direction: n
            }
        });
        this.dispatchEvent(a);
    }
    _onLeaveArrow(e) {
        const t = e.link, i = new CustomEvent("picture-preview-stopped", {
            detail: {
                picId: t.nodeId
            }
        });
        this.dispatchEvent(i);
    }
    _onPositionUpdated({ position: e }) {
        const t = $a42f1354f0348298$var$oo(e, this.getZoomLevel());
        t.x += this.getPictureOriginalHeading(), t.x = t.x % 360;
        const i = new CustomEvent("view-rotated", {
            detail: t
        });
        this.dispatchEvent(i), this._onTilesStartLoading();
    }
    _onZoomUpdated({ zoomLevel: e }) {
        const t = new CustomEvent("view-rotated", {
            detail: {
                ...this.getXY(),
                z: e
            }
        });
        this.dispatchEvent(t), this._onTilesStartLoading();
    }
    _onDoubleClick() {
        this.unfocusAnnotation(!1, !0);
    }
    _onNodeChanged(e) {
        for (let e of document.getElementsByClassName("pnx-psv-tour-arrows"))e.classList.remove("pnx-clicked");
        if (e.node.id) {
            const t = this._parent._initParams?.getParentPostInit().picture == e.node.id;
            this._parent.select(e.node?.sequence?.id, e.node.id);
            const i = this.getPictureMetadata();
            if (!i) return void this.dispatchEvent(new CustomEvent("picture-loaded", {
                detail: {}
            }));
            this._prevSequence = i.sequence.id;
            const n = new CustomEvent("picture-loaded", {
                detail: {
                    ...this.getXYZ(),
                    picId: e.node.id,
                    lon: i.gps[0],
                    lat: i.gps[1],
                    first: t
                }
            });
            this.dispatchEvent(n), i.panorama.hdUrl ? (this.setOption("downloadUrl", i.panorama.hdUrl), this.setOption("downloadName", e.node.id + ".jpg")) : this.setOption("downloadUrl", null), this._annotationsVisible && this.toggleAllAnnotations(!0);
        }
        this._onTilesStartLoading();
    }
    _onSelectMarker(e) {
        if (e.marker && e.marker.id?.startsWith("annotation-")) {
            const t = this.getSelectedAnnotations().find((e)=>this._myMarkers.markers["annotation-" + e]?.config?.data?.blockFocus);
            if (t) return;
            this.getSelectedAnnotations().find((t)=>e.marker.id.endsWith(t)) ? this.unfocusAnnotation(!1, !1, "user-click") : this.focusOnAnnotation(e.marker.data.id);
        }
    }
    _onTilesStartLoading() {
        this._tilesQueueTimer && (clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer), this._tilesQueueTimer = setInterval(()=>{
            if (0 === Object.keys(this.adapter.queue.tasks).length) {
                if (this._myVTour.state.currentNode) {
                    const e = new CustomEvent("picture-tiles-loaded", {
                        detail: {
                            picId: this._myVTour.state.currentNode.id
                        }
                    });
                    this.dispatchEvent(e);
                }
                clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer;
            }
        }, 100);
    }
    getPictureMetadata() {
        return $a42f1354f0348298$var$Zs(this._myVTour?.state?.currentNode?.id) ? null : this._myVTour.state.currentNode ? Object.assign({}, this._myVTour.state.currentNode) : null;
    }
    getPictureId() {
        const e = this._myVTour?.state?.loadingNode || this._myVTour?.state?.currentNode?.id;
        return $a42f1354f0348298$var$Zs(e) ? null : e;
    }
    _onSelect(e) {
        if (!this._parent.getAPI()) return (this._parent.onceAllAPIsReady || this._parent.onceAPIReady).bind(this._parent)().then(()=>this._onSelect(e));
        e.detail.seqId && (this._picturesSequences[e.detail.picId] = e.detail.seqId);
        const t = (e)=>{
            const t = new CustomEvent("picture-failed", {
                detail: {
                    picId: this._parent.picture,
                    error: e
                }
            });
            this.dispatchEvent(t);
        };
        e.detail.seqId && !e.detail.picId ? (this.loader.show(), this._parent.getAPI().getSequenceItems(e.detail.seqId, null, null, 1).then((t)=>{
            if (t?.features?.length > 0) {
                const i = t.features[0].id;
                this._picturesSequences[i] = e.detail.seqId, this._parent.select(e.detail.seqId, i);
            }
        }).catch(t)) : e.detail.picId ? this.getPictureId() !== e.detail.picId && (this.loader.show(), this._myVTour.setCurrentNode(e.detail.picId).catch(t)) : (this._myVTour.state.currentNode = null, this._myVTour.state.loadingNode = null, this._myVTour.setCurrentNode(null));
    }
    goToNextPicture() {
        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
        if ("pic" === this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
        const e = this.getPictureMetadata().sequence.nextPic;
        if (!e) throw new Error("No next picture available");
        this._parent.select(this.getPictureMetadata().sequence.id, e);
    }
    goToPrevPicture() {
        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
        if ("pic" === this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
        const e = this.getPictureMetadata().sequence.prevPic;
        if (!e) throw new Error("No previous picture available");
        this._parent.select(this.getPictureMetadata().sequence.id, e);
    }
    async goToPosition(e, t) {
        if ("pic" === this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
        return await this._parent.getAPI().getPicturesAroundCoordinates(e, t).then((e)=>{
            if (e.features.length > 0) {
                const t = e.features.pop();
                return this._parent.select(t?.collection, t.id), t.id;
            }
            return Promise.reject(new Error("No picture found nearby given coordinates"));
        });
    }
    getXY() {
        const e = $a42f1354f0348298$var$oo(this.getPosition());
        return e.x = (e.x + this.getPictureOriginalHeading()) % 360, e;
    }
    getXYZ() {
        const e = this.getXY();
        return e.z = this.getZoomLevel(), e;
    }
    getPictureOriginalHeading() {
        return this.getPictureMetadata()?.properties?.["view:azimuth"] || 0;
    }
    getPictureRelativeHeading() {
        let e = this.getPictureOriginalHeading() - this.getRoadAbsoluteHeading();
        for(; e > 180;)e -= 360;
        for(; e < -180;)e += 360;
        return e;
    }
    getRoadAbsoluteHeading() {
        return $a42f1354f0348298$var$ao(this.getPictureMetadata());
    }
    clearPictureMetadataCache() {
        const e = this.getPictureMetadata()?.id, t = this.getPictureMetadata()?.sequence?.id;
        this._myVTour.state.currentTooltip?.hide(), this._myVTour.state.currentTooltip = null, this._myVTour.state.currentNode = null, this._myVTour.state.preload = {}, this._myVTour.datasource.nodes = {}, e && this._parent.select(t, e);
    }
    setXYZ(e, t, i) {
        const n = $a42f1354f0348298$var$lo(e - this.getPictureOriginalHeading(), t, i);
        this.rotate({
            yaw: n.yaw,
            pitch: n.pitch
        }), this.zoom(n.zoom);
    }
    setHigherContrast(e) {
        this.setContrast(e ? 1 : 0);
    }
    setContrast(e) {
        switch(e){
            case -1:
                this.renderer.renderer.toneMapping = 3, this.renderer.renderer.toneMappingExposure = .3;
                break;
            case 1:
                this.renderer.renderer.toneMapping = 3, this.renderer.renderer.toneMappingExposure = 1.7;
                break;
            default:
                this.renderer.renderer.toneMapping = 0, this.renderer.renderer.toneMappingExposure = 1;
        }
        this.needsUpdate();
    }
    getTransitionDuration() {
        return this._transitionDuration;
    }
    setTransitionDuration(e) {
        if ((e = parseFloat(e)) < 100 || e > $a42f1354f0348298$var$ox) throw new Error("Invalid transition duration (should be between 100 and 3000)");
        this._transitionDuration = e;
        const t = new CustomEvent("transition-duration-changed", {
            detail: {
                value: e
            }
        });
        this.dispatchEvent(t);
    }
    setPanorama(e, t) {
        if (e.baseUrl.startsWith("data:")) return Promise.resolve();
        const i = (e)=>this.showErrorOverlay(e, this._parent?._t.pnx.error_pic, !0);
        try {
            return super.setPanorama(e, t).catch(i);
        } catch (e) {
            i(e);
        }
    }
    showErrorOverlay(e, t, i) {
        this._parent?.loader.isVisible() || !this.overlay.isVisible() ? this._parent?.loader.dismiss(e, t, i ? ()=>{
            this._parent?.loader.dismiss(), this.overlay.hide();
        } : void 0) : (console.error(e), this.overlay.show({
            image: `<img style="width: 200px" src="${$a42f1354f0348298$var$ix}" alt="" />`,
            title: this._parent?._t.pnx.error,
            text: t + "<br />" + this._parent?._t.pnx.error_click,
            dissmisable: i
        }));
    }
    playSequence(e = !1) {
        this._sequencePlaying = e ? -1 : 1, this.container.classList.add("pnx-psv-playing");
        const t = new CustomEvent("sequence-playing", {
            detail: {
                backward: e
            },
            bubbles: !0,
            composed: !0
        });
        this.dispatchEvent(t);
        const i = ()=>{
            if (this._sequencePlaying) {
                this.addEventListener("picture-loaded", ()=>{
                    this._playTimer = setTimeout(()=>{
                        i();
                    }, this.getTransitionDuration());
                }, {
                    once: !0
                });
                try {
                    1 === this._sequencePlaying ? this.goToNextPicture() : -1 === this._sequencePlaying && this.goToPrevPicture();
                } catch (e) {
                    this.stopSequence();
                }
            }
        };
        this.addEventListener("click", ()=>this.stopSequence()), i();
    }
    stopSequence() {
        this._sequencePlaying = 0, this.container.classList.remove("pnx-psv-playing"), this._playTimer && (clearTimeout(this._playTimer), delete this._playTimer), this.forceRefresh();
        const e = new Event("sequence-stopped", {
            bubbles: !0,
            composed: !0
        });
        this.dispatchEvent(e);
    }
    isSequencePlaying() {
        return 0 !== this._sequencePlaying;
    }
    toggleSequencePlaying() {
        this.isSequencePlaying() ? this.stopSequence() : this.playSequence();
    }
    getPicturesNavigation() {
        return this._picturesNavigation;
    }
    setPicturesNavigation(e) {
        "none" === e && (e = "pic"), this._picturesNavigation = e;
        const t = this.container.querySelector(".psv-virtual-tour-arrows");
        t && (t.style.display = "pic" === e ? "none" : null);
        const i = new CustomEvent("pictures-navigation-changed", {
            detail: {
                value: e
            }
        });
        this.dispatchEvent(i);
    }
    _picturesNavFilter(e) {
        switch(this._picturesNavigation){
            case "seq":
            case "any":
            default:
                return [
                    "next",
                    "prev"
                ].includes(e.rel);
            case "pic":
            case "none":
                return !1;
        }
    }
    areAnnotationsVisible() {
        return this._annotationsVisible;
    }
    getSelectedAnnotations() {
        return Object.keys(this._myMarkers.markers).filter((e)=>e.startsWith("annotation-") && this._myMarkers.markers[e]?.config?.data?.selected).map((e)=>e.replace("annotation-", ""));
    }
    toggleAllAnnotations(e) {
        const t = this.getPictureMetadata(), i = this._annotationsVisible === e;
        if (!t) throw this._myMarkers.clearMarkers(), new Error("No picture currently selected");
        if (e) {
            let e = t.properties.annotations || [];
            0 === e?.length && console.warn("No annotation available on picture", t.id), e = e.map((e)=>{
                if (!t.properties["pers:interior_orientation"].sensor_array_dimensions) return console.warn("Picture lacks pers:interior_orientation.sensor_array_dimensions property, can't compute marker"), null;
                const i = e.shape.coordinates.map((e)=>e.map((e)=>{
                        const i = t.panorama?.cropData, n = {
                            textureX: e[0] + (i?.croppedX || 0),
                            textureY: e[1] + (i?.croppedY || 0)
                        };
                        return this.dataHelper.textureCoordsToSphericalCoords(n);
                    }));
                return {
                    id: `annotation-${e.id}`,
                    polygon: i,
                    data: {
                        id: e.id
                    },
                    className: "pnx-psv-annotation",
                    svgStyle: {
                        stroke: "var(--orange)",
                        strokeWidth: "3px",
                        fill: "var(--orange-transparent)",
                        cursor: "pointer"
                    },
                    tooltip: this._parent._t.pnx.semantics_annotation_tooltip
                };
            }), this._myMarkers.setMarkers(e);
        } else this._myMarkers.clearMarkers();
        this._annotationsVisible = e, i || this.dispatchEvent(new CustomEvent("annotations-toggled", {
            detail: {
                visible: e
            }
        }));
    }
    focusOnAnnotation(e, t = !1, i = !1) {
        const n = this.getSelectedAnnotations();
        if (e && 1 === n.length && n[0] === e) return;
        this.areAnnotationsVisible() || this.toggleAllAnnotations(!0), this.unfocusAnnotation(!0);
        const a = `annotation-${e}`;
        if (this._myMarkers.markers[a]) {
            if (this._myMarkers.updateMarker({
                id: a,
                svgStyle: {
                    stroke: "var(--red)",
                    strokeWidth: "3px",
                    fill: "var(--red-transparent)"
                },
                data: {
                    selected: !0,
                    blockFocus: t
                },
                tooltip: this._parent._t.pnx.semantics_annotation_tooltip_close
            }), this._myMarkers.gotoMarker(a, 0), this.zoom(Math.max(65, this.getZoomLevel())), !i) {
                const t = new CustomEvent("annotation-focused", {
                    detail: {
                        annotationId: e
                    }
                });
                this.dispatchEvent(t);
            }
        } else setTimeout(()=>this.focusOnAnnotation(e, t, i), 100);
    }
    unfocusAnnotation(e = !1, t = !1, i = null) {
        const n = this.getSelectedAnnotations();
        if (n.length > 0) {
            let a = 0;
            n.forEach((e)=>{
                const i = "annotation-" + e;
                t && this._myMarkers.markers[i]?.config?.data?.blockFocus ? a++ : this._myMarkers.updateMarker({
                    id: i,
                    svgStyle: {
                        stroke: "var(--orange)",
                        strokeWidth: "3px",
                        fill: "var(--orange-transparent)"
                    },
                    data: {
                        selected: !1,
                        blockFocus: !1
                    },
                    tooltip: this._parent._t.pnx.semantics_annotation_tooltip
                });
            }), !e && a < n.length && this.dispatchEvent(new CustomEvent("annotations-unfocused", {
                detail: {
                    source: i
                }
            }));
        }
    }
    startDrawAnnotation() {
        this.toggleAllAnnotations(!1), this._drawingAnnotation = [], this._drawingMoves = 0, this._myMarkers.addMarker({
            id: $a42f1354f0348298$var$dx,
            polygon: [
                {
                    yaw: 0,
                    pitch: 0
                },
                {
                    yaw: 0,
                    pitch: 0
                },
                {
                    yaw: 0,
                    pitch: 0
                }
            ],
            svgStyle: {
                fill: $a42f1354f0348298$var$Ax,
                stroke: $a42f1354f0348298$var$px,
                strokeWidth: "2px"
            },
            visible: !1
        }), this._myMarkers.addMarker({
            id: $a42f1354f0348298$var$lx,
            circle: 5,
            position: {
                yaw: 0,
                pitch: 0
            },
            style: {
                cursor: "pointer"
            },
            svgStyle: {
                fill: $a42f1354f0348298$var$hx,
                stroke: $a42f1354f0348298$var$ux,
                strokeWidth: "3px"
            }
        }), this._myMarkers.addMarker({
            id: $a42f1354f0348298$var$cx,
            circle: 5,
            position: {
                yaw: 0,
                pitch: 0
            },
            style: {
                cursor: "pointer"
            },
            svgStyle: {
                fill: $a42f1354f0348298$var$hx,
                stroke: $a42f1354f0348298$var$ux,
                strokeWidth: "3px"
            },
            visible: !1
        });
        const e = (e)=>{
            const t = this.getPositionFromEvent(e);
            t && this._myMarkers.markers[$a42f1354f0348298$var$lx] && (this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$lx,
                position: t,
                style: {
                    cursor: "grab"
                }
            }), 2 === this._drawingAnnotation.length && this._myMarkers.markers[$a42f1354f0348298$var$dx] && this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$dx,
                polygon: [
                    t,
                    {
                        yaw: t.yaw,
                        pitch: this._drawingAnnotation[1].pitch
                    },
                    this._drawingAnnotation[1],
                    {
                        yaw: this._drawingAnnotation[1].yaw,
                        pitch: t.pitch
                    }
                ]
            }));
        }, t = (e)=>{
            const t = this.getPositionFromEvent(e);
            t && this._myMarkers.markers[$a42f1354f0348298$var$cx] && (this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$cx,
                position: t,
                style: {
                    cursor: "grab"
                }
            }), this._drawingAnnotation.length >= 1 && this._myMarkers.markers[$a42f1354f0348298$var$dx] && this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$dx,
                polygon: [
                    this._drawingAnnotation[0],
                    {
                        yaw: this._drawingAnnotation[0].yaw,
                        pitch: t.pitch
                    },
                    t,
                    {
                        yaw: t.yaw,
                        pitch: this._drawingAnnotation[0].pitch
                    }
                ]
            }));
        };
        this._drawListeners = [
            e,
            t
        ], this.parent.addEventListener("mousemove", e), this._drawingMoves = 1, this._drawListenerClick = (i)=>{
            let n = !1;
            if (2 !== this._drawingMoves && i.marker.id === $a42f1354f0348298$var$lx ? 0 === this._drawingAnnotation.length ? (this.dispatchEvent(new Event("annotation-drawing")), this._drawingAnnotation.push({
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }), this.parent.removeEventListener("mousemove", e), this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$lx,
                style: {
                    cursor: "pointer"
                }
            }), this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$cx,
                visible: !0,
                position: {
                    yaw: i.marker.config.position.yaw,
                    pitch: i.marker.config.position.pitch
                }
            }), this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$dx,
                visible: !0
            }), this.parent.addEventListener("mousemove", t), this._drawingMoves = 2) : 0 === this._drawingMoves ? (this.parent.addEventListener("mousemove", e), this._drawingMoves = 1) : (this._drawingAnnotation[0] = {
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }, this.parent.removeEventListener("mousemove", e), this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$lx,
                style: {
                    cursor: "pointer"
                }
            }), this._drawingMoves = 0, n = !0) : 1 !== this._drawingMoves && i.marker.id === $a42f1354f0348298$var$cx && (1 === this._drawingAnnotation.length ? (this._drawingAnnotation.push({
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }), this.parent.removeEventListener("mousemove", t), this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$cx,
                style: {
                    cursor: "pointer"
                }
            }), this._drawingMoves = 0, n = !0) : 2 === this._drawingMoves ? (this._drawingAnnotation[1] = {
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }, this.parent.removeEventListener("mousemove", t), this._myMarkers.updateMarker({
                id: $a42f1354f0348298$var$cx,
                style: {
                    cursor: "pointer"
                }
            }), this._drawingMoves = 0, n = !0) : (this.parent.addEventListener("mousemove", t), this._drawingMoves = 2)), n) {
                let e = this._myMarkers.markers[$a42f1354f0348298$var$dx].config.polygon.map((e)=>{
                    const t = this.dataHelper.sphericalCoordsToTextureCoords(e);
                    return [
                        t.textureX,
                        t.textureY
                    ];
                });
                const t = this.getPictureMetadata()?.panorama?.cropData;
                t && (e = e.map(([e, i])=>[
                        e - t.croppedX,
                        i - t.croppedY
                    ]), e.find(([e, i])=>e < 0 || e > t.croppedWidth || i < 0 || i > t.croppedHeight) && (e = null), e || (alert(this._parent._t.pnx.semantics_draw_invalid_annotation), this.stopDrawAnnotation(), this.startDrawAnnotation())), e[0][0] === e[e.length - 1][0] && e[0][1] === e[e.length - 1][1] || e.push(e[0]);
                const i = new CustomEvent("annotation-drawn", {
                    detail: {
                        shape: e
                    }
                });
                this.dispatchEvent(i);
            }
        }, this._myMarkers.addEventListener("select-marker", this._drawListenerClick);
    }
    fixDrawAnnotation() {
        [
            $a42f1354f0348298$var$lx,
            $a42f1354f0348298$var$cx
        ].forEach((e)=>{
            try {
                this._myMarkers.removeMarker(e);
            } catch (e) {}
        }), (this._drawListeners || []).forEach((e)=>this.parent.removeEventListener("mousemove", e)), this._myMarkers.removeEventListener("select-marker", this._drawListenerClick), this._myMarkers.updateMarker({
            id: $a42f1354f0348298$var$dx,
            svgStyle: {
                stroke: "var(--red)",
                strokeWidth: "3px",
                fill: "var(--red-transparent)",
                cursor: "pointer"
            }
        }), this._drawingMoves = 0;
    }
    stopDrawAnnotation() {
        [
            $a42f1354f0348298$var$lx,
            $a42f1354f0348298$var$cx,
            $a42f1354f0348298$var$dx
        ].forEach((e)=>{
            try {
                this._myMarkers.removeMarker(e);
            } catch (e) {}
        }), (this._drawListeners || []).forEach((e)=>this.parent.removeEventListener("mousemove", e)), this._myMarkers.removeEventListener("select-marker", this._drawListenerClick), delete this._drawingMoves, this._drawingAnnotation = null;
    }
    getPositionFromEvent(e) {
        const t = this.container.getBoundingClientRect(), i = e.clientX - t.left, n = e.clientY - t.top, a = this.renderer.getIntersections({
            x: i,
            y: n
        }).find((e)=>e.object.userData[$a42f1354f0348298$var$Xf.VIEWER_DATA]);
        if (a) return this.dataHelper.vector3ToSphericalCoords(a.point);
    }
    forceRefresh() {
        const e = this._myVTour.getCurrentNode();
        if (e && e.panorama.baseUrl !== e?.panorama?.origBaseUrl) {
            const t = this.getZoomLevel(), i = this.getPosition();
            this._myVTour.state.currentNode = null, this._myVTour.setCurrentNode(e.id, {
                zoomTo: t,
                rotateTo: i,
                fadeIn: !1,
                speed: 0,
                rotation: !1
            });
        }
        e && e.panorama.rows > 1 && this.adapter.__refresh();
    }
}
class $a42f1354f0348298$var$gx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$s`
		:host {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 15px;
			padding: 5px 15px;
		}

		.pnx-input-range {
			display: flex;
			justify-content: space-between;
			gap: 10px;
			align-items: center;
			width: 100%;
		}
	`
    ];
    static properties = {
        contrast: {
            state: !0
        }
    };
    constructor(){
        super(), this.contrast = 0;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this._parent?.psv?.addEventListener("transition-duration-changed", (e)=>{
                this.renderRoot.querySelector("#pnx-player-speed").value = $a42f1354f0348298$var$ox - e.detail.value;
            }));
    }
    _onSpeedChange(e) {
        const t = $a42f1354f0348298$var$ox - e.target.value;
        this._parent?.psv?.setTransitionDuration(t);
    }
    _onContrastClick() {
        this.contrast++, this.contrast > 1 && (this.contrast = -1), this._parent?.psv?.setContrast(this.contrast);
    }
    render() {
        return $a42f1354f0348298$var$V`
			<div class="pnx-input-range" title="${this._parent?._t.pnx.sequence_speed}">
				${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Rs)}
				<input
					id="pnx-player-speed"
					type="range" name="speed"
					min="0" max="${2900}"
					value="${$a42f1354f0348298$var$ox - this._parent?.psv.getTransitionDuration()}"
					title="${this._parent?._t.pnx.sequence_speed}"
					style="width: 100%;"
					@change=${this._onSpeedChange}
				/>
				${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Is)}
			</div>
			<pnx-button
				id="pnx-player-contrast"
				title=${this._parent?._t.pnx[0 === this.contrast ? "contrast" : 1 === this.contrast ? "low_contrast" : "reset_contrast"]}
				kind="outline"
				.active=${0 !== this.contrast ? "true" : null}
				@click=${this._onContrastClick}
			>
				${-1 === this.contrast ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$dl) : $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Vr)}
			</pnx-button>
		`;
    }
}
customElements.define("pnx-player-options", $a42f1354f0348298$var$gx);
class $a42f1354f0348298$var$fx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Bo,
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$Ko
    ];
    render() {
        return $a42f1354f0348298$var$V`
			<h4>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Es)} ${this._t?.pnx.filter_qualityscore}</h4>
			<p>${this._t?.pnx.qualityscore_doc_1}</p>
			<p>${this._t?.pnx.qualityscore_doc_2}</p>
			<pnx-quality-score grade=""></pnx-quality-score>
			<p>${this._t?.pnx.qualityscore_doc_3}</p>
			<p>${this._t?.pnx.qualityscore_doc_4}</p>
			<ul>
				<li>${this._t?.pnx.qualityscore_doc_41}</li>
				<li>${this._t?.pnx.qualityscore_doc_42}</li>
			</ul>
			<p>${this._t?.pnx.qualityscore_doc_5}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$cs)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-quality-score-doc", $a42f1354f0348298$var$fx);
const $a42f1354f0348298$var$_x = [
    "",
    "blur_missing",
    "blur_excess",
    "inappropriate",
    "privacy",
    "picture_low_quality",
    "mislocated",
    "copyright",
    "other"
];
class $a42f1354f0348298$var$vx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Bo,
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$zo,
        $a42f1354f0348298$var$Ro,
        $a42f1354f0348298$var$Fo,
        $a42f1354f0348298$var$s`
		.group {
			margin-bottom: 10px;
		}

		.group:not(.group-inline) label {
			margin-bottom: 5px;
			display: inline-block;
		}
	`
    ];
    static properties = {
        mode: {
            state: !0
        },
        failure: {
            state: !0
        }
    };
    _onSubmit(e) {
        e.preventDefault();
        const t = this._parent?.psv?.getPictureMetadata(), i = Object.fromEntries(new FormData(e.target)), n = {
            issue: i.issue,
            picture_id: i["whole-sequence"] ? null : t?.id,
            reporter_comments: i.comments,
            reporter_email: i.email,
            sequence_id: t?.sequence?.id
        };
        this.mode = "wait", this._parent?.getAPI().sendReport(n).then(()=>{
            this.mode = "success";
        }).catch((e)=>{
            console.error(e), this.mode = "failure", this.failure = e;
        });
    }
    render() {
        const e = $a42f1354f0348298$var$go();
        return this.mode ? $a42f1354f0348298$var$V`
				<h4>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Fs)} ${this._parent?._t.pnx.report}</h4>
				<p>
					${"wait" === this.mode ? this._parent?._t.pnx.report_wait : $a42f1354f0348298$var$q}
					${"success" === this.mode ? this._parent?._t.pnx.report_success : $a42f1354f0348298$var$q}
					${"failure" === this.mode ? this._parent?._t.pnx.report_failure.replace("{e}", this.failure) : $a42f1354f0348298$var$q}
				</p>
			` : $a42f1354f0348298$var$V`
			<h4>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Fs)} ${this._parent?._t.pnx.report}</h4>

			${e && this._parent?._t ? $a42f1354f0348298$var$V`
				<p>${this._parent?._t.pnx.report_auth.replace("{a}", e.name)}</p>
			` : $a42f1354f0348298$var$q}

			<form @submit=${this._onSubmit.bind(this)}>
				<div class="group">
					<label for="issue">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ds)} ${this._parent?._t.pnx.report_nature_label}</label>
					<select name="issue" id="issue" required class="pnx-100w">
						${$a42f1354f0348298$var$_x.map((e)=>$a42f1354f0348298$var$V`
							<option
								value=${e}
								${"" === e ? $a42f1354f0348298$var$V`disabled selected hidden` : $a42f1354f0348298$var$q}
							>
								${this._parent?._t.pnx.report_nature[e]}
							</option>
						`)}
					</select>
				</div>

				<div class="group group-inline">
					<input name="whole-sequence" id="whole-sequence" type="checkbox" />
					<label for="whole-sequence">${this._parent?._t.pnx.report_whole_sequence}</label>
				</div>

				<div class="group">
					<label for="comments">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ss)} ${this._parent?._t.pnx.report_details}</label>
					<textarea name="comments" id="comments" placeholder=${this._parent?._t.pnx.report_details_placeholder}></textarea>
				</div>

				${e ? $a42f1354f0348298$var$q : $a42f1354f0348298$var$V`
					<div class="group">
						<label for="email">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Br)} ${this._parent?._t.pnx.report_email}</label>
						<input type="email" name="email" id="email" placeholder=${this._parent?._t.pnx.report_email_placeholder} class="pnx-100w" />
					</div>
				`}

				<pnx-button type="submit" style="width: 100%">
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Us)} ${this._parent?._t.pnx.report_submit}
				</pnx-button>
			</form>
		`;
    }
}
customElements.define("pnx-report-form", $a42f1354f0348298$var$vx);
class $a42f1354f0348298$var$Ex extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Bo,
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$Ko
    ];
    render() {
        return $a42f1354f0348298$var$V`
			<h4>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ns)} ${this._t?.pnx.semantics_title}</h4>
			<p>${this._t?.pnx.semantics_doc_info1}</p>
			<ul style="padding-left: 1.5em;">
				<li>${this._t?.pnx.semantics_doc_info1u1}</li>
				<li>${this._t?.pnx.semantics_doc_info2}</li>
			</ul>
			<p>${this._t?.pnx.semantics_doc_info3}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/tags/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$cs)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-semantics-doc", $a42f1354f0348298$var$Ex);
class $a42f1354f0348298$var$yx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Bo,
        $a42f1354f0348298$var$Lo
    ];
    render() {
        return $a42f1354f0348298$var$V`
			<h4>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$fs)} ${this._t?.pnx.semantics_download_title}</h4>
			<p>${this._t?.pnx.semantics_download_info}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/federated-catalog/data_export/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${this._t?.pnx.semantics_download_cta}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-semantics-download", $a42f1354f0348298$var$yx);
var $a42f1354f0348298$var$bx = {
    psv: {
        twoFingers: "Use two fingers to navigate",
        ctrlZoom: "Use ctrl + scroll to zoom the image",
        loadError: "The panorama can't be loaded"
    },
    maplibre: {
        "GeolocateControl.FindMyLocation": "Find my location",
        "GeolocateControl.LocationNotAvailable": "Location not available"
    },
    pnx: {
        zoom: "Zoom",
        zoomOut: "Zoom out",
        zoomIn: "Zoom in",
        moveUp: "Move up",
        moveDown: "Move down",
        moveLeft: "Move left",
        moveRight: "Move right",
        moveMiddle: "Center view",
        expand: "Expand",
        expand_info: "Make the widget appear in full page",
        show_psv: "Show the picture viewer",
        show_map: "Show the map",
        time_travel: "See this place on other dates",
        time_travel_close: "Hide other dates",
        minimize: "Hide this widget, you can show it again using the button in the bottom left corner",
        minimize_short: "Hide",
        options: "Options",
        filters: "Filters",
        layers: "Layers",
        search: "Search",
        search_empty: "No results found",
        search_address: "Search an address or city etc...",
        search_user: "Search a username\u2026",
        share: "Share",
        share_links: "Links",
        share_page: "Link to this picture",
        share_image: "HD Image",
        share_rss: "RSS feed",
        share_rss_title: "RSS feed of new sequences in the currently visible map area",
        share_embed: "Embed on your website",
        share_embed_docs: "Read more about embed configuration",
        share_print: "Print",
        panoramax: "Panoramax",
        whats_panoramax: "Panoramax is the geo-commons for territories' pictures.",
        copy: "Copy",
        copied: "Copied",
        error: "We have a problem\u2026",
        error_click: "Continue",
        error_retry: "Please retry later",
        sequence_next: "Next picture in sequence",
        sequence_play: "Play along this sequence",
        sequence_play_backwards: "Play along this sequence, backwards",
        sequence_pause: "Pause sequence",
        sequence_prev: "Previous picture in sequence",
        sequence_more: "More play options",
        sequence_speed: "Player speed",
        legend_license: "License: {l}",
        legend_title: "Show details of picture",
        id: "iD",
        contribute_id: "Contribute to OpenStreetMap with the iD editor",
        geo_uri: "External app",
        josm: "JOSM",
        josm_live: "Enable JOSM automatic sync on picture loading",
        loading_labels_serious: [
            "\uD83D\uDDFA\uFE0F Loading map data",
            "\uD83D\uDDA5\uFE0F Querying API",
            "\uD83D\uDDBC\uFE0F Loading thumbnails",
            "\uD83D\uDD0D Analyzing EXIF metadata",
            "\uD83C\uDFD8\uFE0F 3D rendering",
            "\uD83D\uDCF7 Initializing 360\xb0 pictures",
            "\uD83D\uDFE0 Colour balancing",
            "\uD83D\uDCAF Computing Quality Score \xa9",
            "\uD83D\uDCE1 Downloading updates",
            "\uD83C\uDF0D Fetching map tiles",
            "\uD83D\uDCF8 Processing shadows"
        ],
        loading_labels_fun: [
            "\uD83E\uDD8C Detecting deer crossing signs",
            "\uD83D\uDE98 Searching Panoramax Car \xa9",
            "\u2615 Injecting caffeine",
            "\uD83D\uDE00 Smile, you've been mapped!",
            "\uD83D\uDC08 Sharing cat pictures",
            "\uD83D\uDE34 Reducing procrastination",
            "\uD83E\uDED6 Brewing tea",
            "\uD83D\uDC27 Opening source code",
            "\uD83D\uDE87 Indexing Underground stations",
            "\uD83E\uDDF9 Cleaning up metadata",
            "\uD83D\uDE92 Sending fire station photos",
            "\uD83D\uDEB2 Updating cycling routes",
            "\uD83D\uDE89 Walking down station platform",
            "\uD83D\uDEF0\uFE0F Searching for satellites",
            "\uD83D\uDC65 Writing personas",
            "\uD83D\uDC1F Locating chip shops",
            "\uD83E\uDDD1\u200D\uD83D\uDCBB Debugging the interface",
            "\uD83D\uDCC8 Incrementing statistics",
            "\uD83E\uDD16 Learning semantics",
            "\uD83C\uDFA8 Redesigning interface",
            "\uD83D\uDCC5 Planning photo-mapping-parties",
            "\uD83E\uDDC0 Maturing cheddars",
            "\uD83C\uDF04 Calculating Cornish sunshine",
            "\uD83C\uDF0A Measuring the high tides"
        ],
        error_psv: "Photo Sphere Viewer is not loading properly",
        error_pic: "The requested picture wasn't found",
        error_nopic: "No picture available at given position",
        error_api: "The pictures server is not available",
        error_pic_load: "This picture can't be loaded at the moment.\nPlease check your Internet connection. If you're connected, make sure the picture ID is valid.",
        error_webgl: "WebGL is not supported by your browser",
        error_josm: "JOSM didn't respond, is it running and is Remote Control enabled?",
        error_api_compatibility: "The pictures server is not compatible with this viewer version",
        filter_source_world: "Entire world",
        filter_source_local: "This server",
        filter_date: "Date",
        filter_date_1month: "1 month",
        filter_date_6months: "6 months",
        filter_date_1year: "1 year",
        filter_user: "User",
        filter_user_mypics: "My pictures",
        filter_picture: "Picture type",
        filter_locked: "Filter disabled",
        filter_zoom_in: "Zoom-in to unlock",
        widget_locked: "Option disabled",
        picture_all: "All",
        picture_flat: "Classic",
        picture_360: "360\xb0",
        picture_flat_long: "Classic picture",
        picture_360_long: "Panoramic picture",
        popup_details_link: "More details",
        filter_qualityscore: "Quality score",
        filter_qualityscore_help: "Click to enable or disable",
        qualityscore_doc_1: "A Quality Score is computed for each picture.",
        qualityscore_doc_2: "The Score is shown as a letter:",
        qualityscore_doc_3: '"A" is the best grade, "E" the worst.',
        qualityscore_doc_4: "This Score is computed based on:",
        qualityscore_doc_41: "the GPS precision",
        qualityscore_doc_42: "the picture resolution",
        qualityscore_doc_5: "A professional device will have an A-grade, a 360\xb0 action camera a B-grade, and a smartphone a grade between C and E.",
        qualityscore_doc_link: "Know more about the Quality Score",
        filter_gps_precision: "Location precision",
        filter_gps_precision_lessthan: "Less than {n} meters",
        filter_gps_precision_between: "Between {n1} and {n2} meters",
        filter_gps_precision_morethan: "More than {n} meters",
        filter_gps_precision_help: "Learn more about Location Precision",
        filter_gps_precision_help_1: "A Location Precision score is available for every picture. This corresponds to GPS precision during picture capture.",
        filter_gps_precision_help_2: "The precision is expressed with stars:",
        filter_gps_precision_help_3: '"5\u2B50" is very precise (<= {p5}m), "1\u2B50" is very imprecise (> {p1}m) or unknown.',
        filter_gps_precision_help_4: 'A RTK GPS will have a "5\u2B50" grade, an action camera like GoPro Max a "3\u2B50" grade, and a smartphone GPS in an underground parking a "1\u2B50" grade.',
        map_background: "Background",
        map_background_aerial: "Aerial",
        map_background_streets: "Streets",
        map_background_default: "Default",
        map_background_more: "More",
        map_theme: "Theme",
        map_theme_default: "Default",
        map_theme_default_short: "Default",
        map_theme_default_coef: "Level of coverage",
        map_theme_default_coef_short: "Coverage",
        map_theme_default_1: "Low",
        map_theme_default_2: "Average",
        map_theme_default_3: "Good",
        map_theme_default_4: "Excellent",
        map_theme_age: "Capture date",
        map_theme_age_1: "+ 3 years",
        map_theme_age_2: "1 - 3 years",
        map_theme_age_3: "\xbd - 1 year",
        map_theme_age_4: "- 6 months",
        map_theme_type: "Camera type",
        map_theme_score: "Quality score",
        map_theme_gps: "GPS precision",
        map_theme_age_short: "Date",
        map_theme_type_short: "Camera",
        map_theme_score_short: "Quality",
        map_theme_gps_short: "Position",
        contrast: "Enable higher image contrast",
        low_contrast: "Lower image contrast",
        reset_contrast: "Reset image contrast",
        metadata: "Picture metadata",
        metadata_summary: "Summary",
        metadata_general_copy_id: "Copy ID",
        metadata_general_copy_picid: "Copy picture ID",
        metadata_general_picid: "Picture",
        metadata_general_seqid: "Sequence",
        metadata_general_picid_link: "Go to JSON description of the picture",
        metadata_general_seqid_link: "Go to JSON description of the sequence",
        metadata_general_title: "Title",
        metadata_general_author: "Author",
        metadata_general_license: "License",
        metadata_general_license_link: "See the full licence description",
        metadata_general_date: "Capture date",
        metadata_general_instance: "Origin instance",
        metadata_camera: "Camera",
        metadata_camera_make: "Make",
        metadata_camera_model: "Model",
        metadata_camera_type: "Type",
        metadata_camera_resolution: "Resolution",
        metadata_camera_focal_length: "Focal length",
        metadata_location: "Position",
        metadata_location_coordinates: "Coordinates (longitude, latitude)",
        metadata_location_orientation: "Direction",
        metadata_location_precision: "Positioning precision",
        metadata_location_copy: "Copy {v}",
        metadata_location_copy_more: "More coordinates copy options",
        metadata_quality: "Quality",
        metadata_quality_help: "Learn more about the Quality Score",
        metadata_quality_score: "Global score",
        metadata_quality_gps_score: "Positioning score",
        metadata_quality_resolution_score: "Resolution score",
        metadata_quality_missing: "no value set in picture",
        metadata_exif: "EXIF",
        metadata_exif_name: "Tag",
        metadata_exif_value: "Value",
        metadata_exif_doc: "Docs for EXIF tags",
        metadata_exif_doc_title: "Go to Exiv2 documentation to see full details of EXIF and XMP tag definitions",
        semantics_title: "Tags",
        semantics_tags: "{nb} tags",
        semantics_features: "Picture features",
        semantics_features_none: "No feature has been drawn in this picture yet.",
        semantics_features_default_title: "Tag {nb}",
        semantics_features_subtitle: "{nb} associated properties",
        semantics_annotation_tooltip: "Click to see details",
        semantics_annotation_tooltip_close: "Click to unselect",
        semantics_show_all_tags: "Show all tags",
        semantics_hide_all_tags: "Hide all tags",
        semantics_key: "Key",
        semantics_value: "Value",
        semantics_sequence_tags: "Sequence tag",
        semantics_picture_tags: "Picture tag",
        semantics_annotation_tags: "Object tag",
        semantics_doc: "Help",
        semantics_doc_info1: "Give context around a picture using tags.",
        semantics_doc_info1u1: "You can tag it as captured by car with the transport=car tag.",
        semantics_doc_info2: "You can draw objects in the picture as well: road signs, urban equipments\u2026 Mark what you see using existing tags. You can create your own ones as well if necessary.",
        semantics_doc_info3: "Some objects are automatically detected with AI: quality is not guaranteed.",
        semantics_doc_link: "Know more about tags",
        semantics_key_doc: "Know more about this key",
        semantics_value_doc: "Know more about this tag",
        semantics_value_show_osm: "See on OpenStreetMap",
        semantics_qualifiers: "Qualifiers",
        semantics_show_annotations: "Display picture features",
        semantics_hide_annotations: "Hide picture features",
        semantics_zero_annotations: "No features drawn on this picture",
        semantics_add_annotation: "Add a new tag",
        semantics_draw_annotation: "You can draw the object you want to add over the picture (Optional).",
        semantics_draw_invalid_annotation: "The drawn area goes beyond picture limits. Please make sure to draw within visible picture.",
        semantics_draw_unfinished_annotation: "The drawn area is unfinished. Make sure the area is well-positioned before saving.",
        semantics_erase_annotation: "Erase drawn feature",
        semantics_delete_annotation: "Delete this feature",
        semantics_delete_annotation_confirm: "Do you really want to delete this tag?",
        semantics_wikidata_properties: {
            P31: "instance of",
            P180: "depicts",
            P279: "subclass of",
            P361: "part of"
        },
        semantics_editor_error: "The syntax is invalid. Your tags may look like:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nMax key length is 256 characters, max value length 2048 characters.",
        semantics_editor_example: "key=value\nprefix|key=value",
        semantics_copy: "Copy attributes",
        semantics_edit: "Edit attributes",
        semantics_save: "Save your changes",
        semantics_undo: "Cancel your edits",
        semantics_send_fail: "Unable to save your changes, please try again later",
        semantics_login_needed: "In order to edit picture tags or features, you need to login to Panoramax {n} instance. Do you want to login?",
        semantics_empty: "No tags defined",
        semantics_overlays: {
            tfsigns: "Traffic signs",
            features: "All features"
        },
        semantics_zoom_in: "Zoom in to the map to view tags",
        semantics_download: "Download",
        semantics_download_title: "Download tags",
        semantics_download_info: "All semantic data (tags) is available as open data. You can download and use them as you like.",
        semantics_download_cta: "Download open data",
        delete_picture: "Delete",
        delete_picture_warn: "\u26A0\uFE0F Caution: this will permanently delete this picture.\nAre you sure you want to proceed?",
        delete_picture_ok: "Picture was successfully deleted",
        delete_picture_error: "An error occurred when trying to delete the picture:\n{e}",
        report: "Report",
        report_auth: 'This report will be sent using your account "{a}"',
        report_nature_label: "Cause of the issue",
        report_nature: {
            "": "Select the nature of issue\u2026",
            blur_missing: "A person's face or car license plate is visible",
            blur_excess: "An unnecessary blur was applied to an object",
            inappropriate: "Picture is inappropriate (unrelated, nudity\u2026)",
            privacy: "Picture was taken from a private path or property",
            picture_low_quality: "Picture is low quality",
            mislocated: "Picture is poorly positioned on map",
            copyright: "Picture infringes copyright",
            other: "Any other kind of issue"
        },
        report_whole_sequence: "This concerns the entire sequence",
        report_details: "Additional details",
        report_details_placeholder: "Optionally, you can add details about the issue",
        report_email: "Your email",
        report_email_placeholder: "Optional",
        report_submit: "Submit",
        report_wait: "Sending report\u2026",
        report_success: "Report was sent successfully. It will be reviewed as soon as possible.",
        report_failure: "An error occurred when creating report: {e}. Please try again later.",
        indoor_switch: "Indoor spaces",
        indoor_selector_expand: "Click to see all available levels",
        indoor_selector_shrink: "Click to minimize",
        indoor_selector_levelup: "Go to upper level",
        indoor_selector_leveldown: "Go to lower level",
        indoor_selector_scrollup: "Scroll the level list up",
        indoor_selector_scrolldown: "Scroll the level list down",
        "visibility_logged-only": "Members",
        "visibility_title_logged-only": "Only people with an account can see this picture",
        "visibility_owner-only": "Hidden",
        "visibility_title_owner-only": "Only you can see this picture"
    },
    map: {
        loading: "Loading\u2026",
        thumbnail: "Thumbnail of hovered picture",
        not_public: "Not publicly visible",
        slow_loading: "Map is loading slowly and may appear broken",
        map_data: "Map based on {m}",
        more_panoramax: "Discover more about Panoramax"
    }
}, $a42f1354f0348298$var$kx = {
    pnx: {
        contrast: "\u589E\u52A0\u76F8\u7247\u5C0D\u6BD4\u5EA6",
        copied: "\u5DF2\u8907\u88FD",
        copy: "\u8907\u88FD",
        edit_osm: "\u7DE8\u8F2F OSM",
        error: "Panoramax \u7576\u6A5F\u4E86\u2026",
        error_api: "\u76F8\u7247\u4F3A\u670D\u5668\u7121\u6CD5\u4F7F\u7528",
        error_api_compatibility: "\u76F8\u7247\u4F3A\u670D\u5668\u548C\u6B64\u6AA2\u8996\u5668\u7684\u7248\u672C\u4E0D\u76F8\u5BB9",
        error_josm: "JOSM \u6C92\u6709\u56DE\u61C9\uFF0C\u5B83\u5DF2\u7D93\u555F\u52D5\u4E14\u555F\u7528\u9060\u7AEF\u63A7\u5236\u4E86\u55CE?",
        error_nopic: "\u641C\u5C0B\u7684\u4F4D\u7F6E\u9644\u8FD1\u6C92\u6709\u76F8\u7247",
        error_pic: "\u627E\u4E0D\u5230\u6307\u5B9A\u7684\u76F8\u7247",
        error_psv: "\u7121\u6CD5\u6B63\u78BA\u8F09\u5165 Photo Sphere Viewer",
        error_subtitle: "\u8ACB\u7A0D\u5F8C\u91CD\u8A66\u6216\u6AA2\u67E5\u700F\u89BD\u5668\u7684\u4E3B\u63A7\u53F0\u4EE5\u4E86\u89E3\u8A73\u60C5\u3002",
        error_webgl: "\u60A8\u7684\u700F\u89BD\u5668\u4E0D\u652F\u63F4 WebGL",
        expand: "\u5C55\u958B",
        expand_info: "\u5728\u6574\u500B\u756B\u9762\u986F\u793A\u6B64\u5C0F\u5DE5\u5177",
        filter_camera_model: "\u6309\u76F8\u6A5F\u578B\u865F",
        filter_date: "\u65E5\u671F",
        filter_picture: "\u76F8\u7247\u985E\u578B",
        filter_user: "\u4F7F\u7528\u8005",
        filter_zoom_in: "\u62C9\u8FD1\u89E3\u9396",
        filters: "\u7BE9\u9078\u5668",
        id: "iD",
        josm: "JOSM",
        josm_live: "\u555F\u7528\u8F09\u5165\u76F8\u7247\u6642\u81EA\u52D5\u540C\u6B65 JOSM",
        layers: "\u5716\u5C64",
        legend_license: "\u6388\u6B0A: {l}",
        loading_labels_fun: [
            "\uD83E\uDD8C \u5075\u6E2C\u5230\u7576\u5FC3\u6885\u82B1\u9E7F\u6A19\u8A8C",
            "\uD83D\uDE98 \u6B63\u5728\u641C\u5C0B Panoramax \u6C7D\u8ECA \xa9",
            "\u2615 \u6CE8\u5165\u5496\u5561\u56E0",
            "\uD83D\uDE00 \u8ACB\u5FAE\u7B11\uFF0C\u60A8\u5DF2\u88AB\u6A19\u8A18\u5728\u5730\u5716\u4E0A\u4E86\uFF01",
            "\uD83D\uDC08 \u6B63\u5728\u5206\u4EAB\u8C93\u54AA\u7684\u76F8\u7247",
            "\uD83D\uDE34 \u6B63\u5728\u6E1B\u5C11\u5EF6\u9072",
            "\uD83E\uDED6 \u6B63\u5728\u6C8F\u58FA\u597D\u8336",
            "\uD83D\uDC27 \u6B63\u5728\u958B\u555F\u539F\u59CB\u78BC",
            "\uD83D\uDE87 \u6B63\u5728\u7D22\u5F15\u5730\u9435\u8ECA\u7AD9",
            "\uD83E\uDDF9 \u6E05\u7406\u8A6E\u91CB\u8CC7\u6599",
            "\uD83D\uDE92 \u6B63\u5728\u50B3\u9001\u6D88\u9632\u968A\u7684\u76F8\u7247",
            "\uD83D\uDEB2 \u66F4\u65B0\u7DA0\u9053",
            "\uD83D\uDE89 \u6B63\u5728\u901A\u904E\u8ECA\u7AD9\u6708\u53F0",
            "\uD83D\uDEF0\uFE0F \u6B63\u5728\u641C\u5C0B\u885B\u661F",
            "\uD83D\uDC65 \u6B63\u5728\u64B0\u5BEB\u4EBA\u7269\u8A8C",
            "\uD83C\uDF57 \u6B63\u5728\u5B9A\u4F4D\u9E79\u9165\u96DE\u5E97",
            "\uD83E\uDDD1\u200D\uD83D\uDCBB \u6B63\u5728\u5075\u932F\u4ECB\u9762",
            "\uD83D\uDCC8 \u7D71\u8A08\u6578\u64DA\u6B63\u5728\u589E\u52A0",
            "\uD83E\uDD16 \u6B63\u5728\u5B78\u7FD2\u8A9E\u7FA9",
            "\uD83C\uDFA8 \u91CD\u65B0\u8A2D\u8A08\u4ECB\u9762",
            "\uD83D\uDCC5 \u6B63\u5728\u898F\u5283\u76F8\u7247\u5730\u5716\u7E6A\u5716\u805A\u6703",
            "\uD83E\uDDC0 \u6B63\u5728\u719F\u6210\u5207\u9054\u8D77\u53F8",
            "\uD83C\uDF04 \u6B63\u5728\u8A08\u7B97\u6046\u6625\u7684\u65E5\u7167\u6642\u6578",
            "\uD83C\uDF0A \u6B63\u5728\u6E2C\u91CF\u6F6E\u6C50"
        ],
        loading_labels_serious: [
            "\uD83D\uDDFA\uFE0F \u6B63\u5728\u8F09\u5165\u5730\u5716\u8CC7\u6599",
            "\uD83D\uDDA5\uFE0F \u6B63\u5728\u67E5\u8A62 API",
            "\uD83D\uDDBC\uFE0F \u6B63\u5728\u8F09\u5165\u7E2E\u5716",
            "\uD83D\uDD0D \u6B63\u5728\u5206\u6790 EXIF \u8A6E\u91CB\u8CC7\u6599",
            "\uD83C\uDFD8\uFE0F \u6B63\u5728\u7B97\u7E6A 3D",
            "\uD83D\uDCF7 \u6B63\u5728\u521D\u59CB\u5316 360\xb0 \u76F8\u7247",
            "\uD83D\uDFE0 \u6B63\u5728\u5E73\u8861\u8272\u5F69",
            "\uD83D\uDCAF \u6B63\u5728\u8A08\u7B97\u54C1\u8CEA\u5206\u6578 \xa9",
            "\uD83D\uDCE1 \u6B63\u5728\u4E0B\u8F09\u66F4\u65B0",
            "\uD83C\uDF0D \u6B63\u5728\u53D6\u5F97\u5730\u5716\u5716\u78DA",
            "\uD83D\uDCF8 \u6B63\u5728\u8655\u7406\u9670\u5F71"
        ],
        map_background: "\u80CC\u666F",
        map_background_aerial: "\u885B\u661F",
        map_background_streets: "\u9810\u8A2D",
        map_theme: "\u4E3B\u984C",
        map_theme_age: "\u62CD\u651D\u6642\u9593",
        map_theme_age_1: "> 3 \u5E74",
        map_theme_age_2: "< 3 \u5E74",
        map_theme_age_3: "\xbd - 1 \u5E74",
        map_theme_age_4: "< 6 \u500B\u6708",
        map_theme_default: "\u9810\u8A2D",
        map_theme_type: "\u76F8\u6A5F\u985E\u578B",
        metadata: "\u76F8\u7247\u8A6E\u91CB\u8CC7\u6599",
        metadata_camera: "\u76F8\u6A5F",
        metadata_camera_focal_length: "\u7126\u8DDD",
        metadata_camera_make: "\u88FD\u9020\u5546",
        metadata_camera_model: "\u578B\u865F",
        metadata_camera_type: "\u985E\u578B",
        metadata_exif: "EXIF",
        metadata_exif_name: "\u6A19\u7C64",
        metadata_exif_value: "\u503C",
        metadata_general_author: "\u4F5C\u8005",
        metadata_general_date: "\u62CD\u651D\u6642\u9593",
        metadata_general_license: "\u6388\u6B0A",
        metadata_general_license_link: "\u67E5\u770B\u5B8C\u6574\u6388\u6B0A\u689D\u6B3E",
        metadata_general_picid: "\u76F8\u7247",
        metadata_general_picid_link: "\u524D\u5F80\u672C\u76F8\u7247\u7684 JSON \u8AAA\u660E",
        metadata_general_seqid: "\u5E8F\u5217",
        metadata_general_seqid_link: "\u524D\u5F80\u672C\u5E8F\u5217\u7684 JSON \u8AAA\u660E",
        metadata_location: "\u4F4D\u7F6E",
        metadata_location_latitude: "\u7DEF\u5EA6",
        metadata_location_longitude: "\u7D93\u5EA6",
        metadata_location_orientation: "\u65B9\u5411",
        metadata_location_precision: "\u5B9A\u4F4D\u7CBE\u5EA6",
        minimize: "\u96B1\u85CF\u9019\u500B\u5C0F\u5DE5\u5177\uFF0C\u60A8\u53EF\u4EE5\u6309\u5DE6\u4E0B\u89D2\u7684\u6309\u9215\u518D\u6B21\u986F\u793A\u5B83",
        moveDown: "\u4E0B\u79FB",
        moveLeft: "\u5DE6\u79FB",
        moveMiddle: "\u756B\u9762\u7F6E\u4E2D",
        moveRight: "\u53F3\u79FB",
        moveUp: "\u4E0A\u79FB",
        options: "\u9078\u9805",
        picture_360: "360\xb0",
        picture_flat: "\u7D93\u5178",
        search: "\u641C\u5C0B",
        search_address: "\u641C\u5C0B\u5730\u5740\u6216\u57CE\u5E02\u2026",
        search_empty: "\u627E\u4E0D\u5230\u7D50\u679C",
        search_user: "\u641C\u5C0B\u5E33\u865F\u2026",
        sequence_more: "\u66F4\u591A\u64AD\u653E\u9078\u9805",
        sequence_next: "\u5E8F\u5217\u4E2D\u7684\u4E0B\u4E00\u5F35\u76F8\u7247",
        sequence_pause: "\u66AB\u505C\u5E8F\u5217",
        sequence_play: "\u64AD\u653E\u5E8F\u5217",
        sequence_prev: "\u5E8F\u5217\u4E2D\u7684\u4E0A\u4E00\u5F35\u76F8\u7247",
        sequence_speed: "\u64AD\u653E\u901F\u5EA6",
        share: "\u5206\u4EAB",
        share_embed: "\u5D4C\u5165\u5230\u60A8\u7684\u7DB2\u7AD9",
        share_image: "\u9AD8\u756B\u8CEA\u76F8\u7247",
        share_links: "\u8D85\u9023\u7D50",
        share_page: "\u9019\u5F35\u76F8\u7247\u7684\u9023\u7D50",
        share_print: "\u5217\u5370",
        share_rss: "RSS \u6458\u8981",
        share_rss_title: "\u76EE\u524D\u5730\u5716\u53EF\u898B\u5340\u57DF\u4E2D\u65B0\u76F8\u7247\u5E8F\u5217\u7684 RSS \u6458\u8981",
        show_map: "\u986F\u793A\u5730\u5716",
        show_psv: "\u986F\u793A\u76F8\u7247\u6AA2\u8996\u5668",
        zoom: "\u7E2E\u653E",
        zoomIn: "\u62C9\u8FD1",
        zoomOut: "\u62C9\u9060",
        report_submit: "\u9001\u51FA",
        report_email: "\u60A8\u7684 email",
        report_nature_label: "\u554F\u984C\u7684\u539F\u56E0",
        report_nature: {
            "": "\u9078\u64C7\u554F\u984C\u7684\u985E\u578B\u2026",
            blur_missing: "\u53EF\u4EE5\u770B\u898B\u4EBA\u81C9\u6216\u8ECA\u724C",
            blur_excess: "\u5C0D\u7269\u4EF6\u5957\u7528\u4E86\u4E0D\u5FC5\u8981\u7684\u6A21\u7CCA\u8655\u7406",
            inappropriate: "\u4E0D\u7576\u7684\u76F8\u7247 (\u4E0D\u76F8\u95DC\u3001\u88F8\u9AD4\u2026)",
            privacy: "\u76F8\u7247\u662F\u5F9E\u79C1\u4EBA\u9053\u8DEF\u6216\u5834\u6240\u62CD\u651D\u7684",
            picture_low_quality: "\u4F4E\u54C1\u8CEA\u7684\u76F8\u7247",
            mislocated: "\u76F8\u7247\u5728\u5730\u5716\u4E0A\u7684\u4F4D\u7F6E\u4E0D\u6B63\u78BA",
            copyright: "\u76F8\u7247\u4FB5\u72AF\u4E86\u7248\u6B0A",
            other: "\u4EFB\u4F55\u5176\u4ED6\u985E\u578B\u7684\u554F\u984C"
        },
        share_embed_docs: "\u6DF1\u5165\u4E86\u89E3\u5D4C\u5165\u8A2D\u5B9A\u503C",
        error_retry: "\u8ACB\u7A0D\u5F8C\u518D\u8A66",
        error_click: "\u7E7C\u7E8C",
        legend_title: "\u986F\u793A\u76F8\u7247\u7684\u8A73\u7D30\u8CC7\u6599",
        report_email_placeholder: "\u9078\u586B",
        report_whole_sequence: "\u9019\u500B\u554F\u984C\u5F71\u97FF\u6574\u500B\u5E8F\u5217",
        report_details: "\u66F4\u591A\u8CC7\u8A0A",
        report_details_placeholder: "\u9078\u586B\uFF0C\u60A8\u53EF\u4EE5\u8A73\u8FF0\u6B64\u554F\u984C",
        report_wait: "\u6B63\u5728\u50B3\u9001\u5831\u544A\u2026",
        report_success: "\u5DF2\u6210\u529F\u767C\u9001\u5831\u544A\uFF0C\u6211\u5011\u5C07\u5118\u5FEB\u5C0D\u5B83\u9032\u884C\u5BE9\u6838\u3002",
        report_failure: "\u5EFA\u7ACB\u5831\u544A\u6642\u767C\u9001\u932F\u8AA4: {e}\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002",
        report_auth: "\u6B64\u5831\u544A\u5C07\u4F7F\u7528\u60A8\u7684\u5E33\u6236\u300C{a}\u300D\u767C\u9001",
        filter_qualityscore: "\u54C1\u8CEA\u5206\u6578",
        filter_qualityscore_help: "\u9EDE\u64CA\u4EE5\u555F\u7528\u6216\u505C\u7528",
        map_theme_score: "\u54C1\u8CEA\u5206\u6578",
        metadata_camera_resolution: "\u89E3\u6790\u5EA6",
        metadata_quality: "\u54C1\u8CEA",
        metadata_quality_help: "\u6DF1\u5165\u4E86\u89E3\u54C1\u8CEA\u5206\u6578",
        metadata_quality_gps_score: "\u5B9A\u4F4D\u5206\u6578",
        metadata_quality_resolution_score: "\u89E3\u6790\u5EA6\u5206\u6578",
        metadata_quality_missing: "\u76F8\u7247\u672A\u5305\u542B\u8CC7\u8A0A",
        report: "\u6AA2\u8209",
        metadata_quality_score: "\u6574\u9AD4\u5206\u6578",
        filter_user_mypics: "\u6211\u7684\u76F8\u7247",
        filter_date_1month: "1 \u500B\u6708",
        filter_date_1year: "1 \u5E74",
        qualityscore_doc_2: "\u5206\u6578\u4EE5\u5B57\u6BCD\u8868\u793A:",
        qualityscore_doc_link: "\u6DF1\u5165\u4E86\u89E3\u54C1\u8CEA\u5206\u6578",
        qualityscore_title: "\u95DC\u65BC\u54C1\u8CEA\u5206\u6578",
        qualityscore_doc_1: "\u6211\u5011\u70BA\u6BCF\u5F35\u76F8\u7247\u8A08\u7B97\u54C1\u8CEA\u5206\u6578\u3002",
        qualityscore_doc_3: "A \u70BA\u6700\u4F73\u7B49\u7D1A\uFF0CE \u70BA\u6700\u5DEE\u7B49\u7D1A\u3002",
        minimize_short: "\u96B1\u85CF",
        metadata_general_instance: "\u4F86\u6E90\u7AD9\u53F0",
        metadata_general_copy_picid: "\u8907\u88FD\u76F8\u7247 ID",
        metadata_general_copy_id: "\u8907\u88FD ID",
        picture_360_long: "\u5168\u666F\u76F8\u7247",
        metadata_summary: "\u6458\u8981",
        picture_flat_long: "\u7D93\u5178\u76F8\u7247",
        geo_uri: "\u5916\u90E8\u7A0B\u5F0F",
        contribute_id: "\u900F\u904E iD \u7DE8\u8F2F\u5668\u4F86\u8CA2\u737B OpenStreetMap",
        filter_date_6months: "6 \u500B\u6708",
        picture_all: "\u5168\u90E8",
        metadata_exif_doc: "EXIF \u6A19\u7C64\u6587\u4EF6",
        metadata_exif_doc_title: "\u8ACB\u53C3\u95B1 Exiv2 \u6587\u4EF6\u4EE5\u4E86\u89E3 EXIF \u548C XMP \u6A19\u7C64\u5B9A\u7FA9\u7684\u5B8C\u6574\u8AAA\u660E",
        metadata_location_coordinates: "\u5EA7\u6A19 (\u7D93\u5EA6, \u7DEF\u5EA6)",
        metadata_location_copy: "\u8907\u88FD {v}",
        metadata_location_copy_more: "\u66F4\u591A\u5EA7\u6A19\u8907\u88FD\u9078\u9805",
        semantics_title: "\u6A19\u7C64",
        semantics_tags: "{nb} \u500B\u6A19\u7C64",
        semantics_show_annotations: "\u986F\u793A\u76F8\u7247\u7279\u5FB5",
        semantics_show_all_tags: "\u986F\u793A\u6240\u6709\u6A19\u7C64",
        semantics_key: "\u7D22\u5F15\u9375",
        semantics_annotation_tooltip: "\u9EDE\u64CA\u67E5\u770B\u8A73\u60C5",
        semantics_features_default_title: "\u6A19\u7C64 {nb}",
        semantics_features_subtitle: "{nb} \u500B\u95DC\u806F\u7684\u5C6C\u6027",
        semantics_hide_all_tags: "\u96B1\u85CF\u6240\u6709\u6A19\u7C64",
        semantics_features_none: "\u6B64\u76F8\u7247\u5C1A\u672A\u7E6A\u88FD\u4EFB\u4F55\u7279\u5FB5\u3002",
        semantics_value: "\u503C",
        semantics_tags_picture_none: "\u6B64\u76F8\u7247\u5C1A\u672A\u52A0\u4E0A\u4EFB\u4F55\u6A19\u7C64\u3002",
        semantics_tags_picture: "\u76F8\u7247\u6A19\u7C64",
        whats_panoramax: "Panoramax \u662F\u5404\u5730\u76F8\u7247\u7684\u5730\u7406\u5171\u4EAB\u8CC7\u6E90\u3002",
        semantics_features: "\u76F8\u7247\u7279\u5FB5",
        semantics_key_doc: "\u6DF1\u5165\u4E86\u89E3\u6B64\u7D22\u5F15\u9375",
        semantics_value_doc: "\u6DF1\u5165\u4E86\u89E3\u6B64\u6A19\u7C64",
        semantics_qualifiers: "\u9650\u5B9A\u689D\u4EF6",
        semantics_hide_annotations: "\u96B1\u85CF\u76F8\u7247\u7279\u5FB5",
        semantics_zero_annotations: "\u6B64\u76F8\u7247\u5C1A\u672A\u7E6A\u88FD\u4EFB\u4F55\u7279\u5FB5",
        semantics_hashtags: "\u76F8\u7247\u4E3B\u984C\u6A19\u7C64",
        semantics_wikidata_properties: {
            P31: "\u96B8\u5C6C\u65BC",
            P279: "\u4E0A\u7D1A\u5206\u985E",
            P361: "\u6240\u5C6C\u5BE6\u9AD4",
            P180: "\u63CF\u7E6A"
        },
        panoramax: "Panoramax",
        semantics_editor_example: "key=value\nprefix|key=value",
        semantics_edit: "\u7DE8\u8F2F\u5C6C\u6027",
        semantics_save: "\u5132\u5B58\u8B8A\u66F4",
        semantics_undo: "\u53D6\u6D88\u8B8A\u66F4",
        semantics_cantsave_invalid: "\u7121\u6CD5\u5132\u5B58\u8B8A\u66F4\uFF0C\u7121\u6548\u7684\u8F38\u5165",
        semantics_send_fail: "\u7121\u6CD5\u5132\u5B58\u8B8A\u66F4\uFF0C\u8ACB\u7A0D\u5019\u518D\u8A66",
        semantics_send_ok: "\u5DF2\u6210\u529F\u5132\u5B58\u8B8A\u66F4",
        semantics_add_annotation: "\u65B0\u589E\u6A19\u7C64",
        semantics_save_drawn_annotation: "\u5132\u5B58\u4F4D\u7F6E",
        semantics_undo_drawn_annotation: "\u53D6\u6D88",
        semantics_delete_annotation: "\u522A\u9664\u9019\u500B\u7279\u5FB5",
        semantics_delete_annotation_confirm: "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u9019\u500B\u6A19\u7C64\u55CE\uFF1F",
        semantics_save_drawn_annotation_incomplete: "\u60A8\u5FC5\u9808\u5728\u9A57\u8B49\u4E4B\u524D\u7E6A\u88FD\u4E00\u500B\u9069\u5408\u76F8\u7247\u7684\u77E9\u5F62",
        semantics_draw_annotation: "\u60A8\u53EF\u4EE5\u5C07\u60F3\u8981\u65B0\u589E\u7684\u7269\u4EF6\u7E6A\u88FD\u5728\u5716\u7247\u4E0A (\u9078\u7528)\u3002",
        semantics_editor_error: "\u8A9E\u6CD5\u7121\u6548\uFF0C\u60A8\u7684\u6A19\u7C64\u770B\u8D77\u4F86\u61C9\u8A72\u8981\u50CF:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nkey \u6700\u5927\u9577\u5EA6\u70BA 256 \u500B\u5B57\u5143\uFF0Cvalue \u6700\u5927\u9577\u5EA6\u70BA 2048 \u500B\u5B57\u5143\u3002",
        semantics_login_needed: "\u82E5\u8981\u7DE8\u8F2F\u76F8\u7247\u6A19\u7C64\u6216\u7279\u5FB5\uFF0C\u60A8\u9700\u8981\u767B\u5165 Panoramax {n} \u7AD9\u53F0\uFF0C\u60A8\u8981\u767B\u5165\u55CE\uFF1F",
        semantics_doc: "\u8AAA\u660E",
        semantics_doc_title: "\u95DC\u65BC\u6A19\u7C64",
        semantics_erase_annotation: "\u522A\u9664\u7E6A\u88FD\u7684\u6A19\u7C64",
        semantics_doc_info1: "\u4F7F\u7528\u6A19\u7C64\u6A19\u8A18\u5716\u7247\u7684\u80CC\u666F\u8CC7\u8A0A\u3002",
        semantics_doc_info2: "\u60A8\u4E5F\u53EF\u4EE5\u5728\u5716\u7247\u4E2D\u6A19\u8A18\u7269\u4EF6\uFF1A\u9053\u8DEF\u6A19\u8A8C\u3001\u90FD\u5E02\u8A2D\u5099\u7B49\u3002\u4F7F\u7528\u73FE\u6709\u7684\u6A19\u7C64\u6A19\u8A18\u60A8\u6240\u770B\u5230\u7684\uFF0C\u4E5F\u53EF\u4EE5\u6309\u7167\u9700\u6C42\u5EFA\u7ACB\u81EA\u5DF1\u7684\u6A19\u7C64\u3002",
        semantics_doc_info3: "\u6709\u4E9B\u7269\u4EF6\u662F\u7531 AI \u81EA\u52D5\u5075\u6E2C\u7684\uFF0C\u56E0\u6B64\u4E0D\u4FDD\u8B49\u54C1\u8CEA\u3002",
        semantics_doc_link: "\u6DF1\u5165\u4E86\u89E3\u6A19\u7C64",
        semantics_sequence_tags: "\u5E8F\u5217\u6A19\u7C64",
        semantics_picture_tags: "\u76F8\u7247\u6A19\u7C64",
        semantics_annotation_tags: "\u7269\u4EF6\u6A19\u7C64",
        filter_gps_precision_lessthan: "\u5C0F\u65BC {n} \u516C\u5C3A",
        filter_gps_precision_between: "\u4ECB\u65BC {n1} \u548C {n2} \u516C\u5C3A",
        map_theme_gps: "GPS \u7CBE\u78BA\u5EA6",
        filter_gps_precision_morethan: "\u5927\u65BC {n} \u516C\u5C3A",
        filter_gps_precision: "\u5B9A\u4F4D\u7CBE\u78BA\u5EA6",
        semantics_overlays: {
            tfsigns: "\u4EA4\u901A\u6A19\u8A8C",
            features: "\u6240\u6709\u7279\u5FB5"
        },
        semantics_doc_info1u1: "\u60A8\u53EF\u4EE5\u52A0\u4E0A transport=car \u9019\u500B\u6A19\u7C64\uFF0C\u5C07\u5176\u6A19\u8A18\u70BA\u99D5\u99DB\u6C7D\u8ECA\u62CD\u651D\u3002",
        semantics_zoom_in: "\u653E\u5927\u5730\u5716\u4EE5\u67E5\u770B\u6A19\u7C64",
        semantics_download: "\u4E0B\u8F09",
        semantics_download_title: "\u4E0B\u8F09\u6A19\u7C64",
        semantics_download_info: "\u6240\u6709\u8A9E\u7FA9\u8CC7\u6599 (\u6A19\u7C64) \u7686\u70BA\u958B\u653E\u8CC7\u6599\uFF0C\u60A8\u53EF\u4EE5\u4E0B\u8F09\u4E26\u81EA\u7531\u5730\u4F7F\u7528\u5B83\u5011\u3002",
        semantics_download_cta: "\u4E0B\u8F09\u958B\u653E\u8CC7\u6599",
        semantics_copy: "\u8907\u88FD\u5C6C\u6027",
        semantics_value_show_osm: "\u5728 OpenStreetMap \u4E0A\u67E5\u770B",
        filter_gps_precision_help: "\u6DF1\u5165\u4E86\u89E3\u5B9A\u4F4D\u7CBE\u78BA\u5EA6",
        filter_gps_precision_help_1: "\u6BCF\u5F35\u76F8\u7247\u6709\u5B9A\u4F4D\u7CBE\u78BA\u5EA6\u5206\u6578\uFF0C\u9019\u5C0D\u61C9\u65BC\u62CD\u7167\u6642\u7684 GPS \u7CBE\u78BA\u5EA6\u3002",
        filter_gps_precision_help_2: "\u7CBE\u78BA\u5EA6\u7528\u661F\u865F\u8868\u793A:",
        filter_gps_precision_help_3: "\u300C5\u2B50\u300D\u8868\u793A\u975E\u5E38\u7CBE\u78BA (<= {p5}m)\uFF0C\u300C1\u2B50\u300D\u8868\u793A\u975E\u5E38\u4E0D\u7CBE\u78BA (> {p1}m) \u6216\u672A\u77E5\u3002",
        filter_gps_precision_help_4: "RTK GPS \u7684\u6703\u5F97\u5230\u300C5\u2B50\u300D\u7B49\u7D1A\uFF0C\u50CF GoPro Max \u9019\u6A23\u7684\u904B\u52D5\u76F8\u6A5F\u6703\u5F97\u5230\u300C3\u2B50\u300D\uFF0C\u800C\u5730\u4E0B\u505C\u8ECA\u5834\u4E2D\u7684\u667A\u6167\u578B\u624B\u6A5F GPS \u6703\u5F97\u5230\u300C1\u2B50\u300D\u3002",
        qualityscore_doc_4: "\u6B64\u5206\u6578\u6839\u64DA\u4EE5\u4E0B\u56E0\u7D20\u8A08\u7B97\u5F97\u51FA:",
        qualityscore_doc_41: "GPS \u7CBE\u78BA\u5EA6",
        qualityscore_doc_42: "\u76F8\u7247\u89E3\u6790\u5EA6",
        qualityscore_doc_5: "\u5C08\u696D\u8A2D\u5099\u6703\u5F97\u5230 A \u7B49\u3001360\xb0 \u904B\u52D5\u76F8\u6A5F B \u7B49\u3001\u667A\u6167\u578B\u624B\u6A5F\u5247\u6703\u4ECB\u65BC C \u548C E \u4E4B\u9593\u3002",
        "visibility_title_logged-only": "\u53EA\u6709\u64C1\u6709\u5E33\u6236\u7684\u4EBA\u624D\u80FD\u67E5\u770B\u9019\u5F35\u76F8\u7247",
        "visibility_logged-only": "\u6210\u54E1",
        "visibility_owner-only": "\u96B1\u85CF",
        filter_locked: "\u5DF2\u505C\u7528\u7BE9\u9078\u5668",
        indoor_selector_scrolldown: "\u5411\u4E0B\u6372\u52D5\u6A13\u5C64\u6E05\u55AE",
        indoor_switch: "\u5BA4\u5167\u7A7A\u9593",
        indoor_selector_expand: "\u9EDE\u64CA\u67E5\u770B\u6240\u6709\u6A13\u5C64",
        indoor_selector_shrink: "\u9EDE\u64CA\u6700\u5C0F\u5316",
        indoor_selector_levelup: "\u524D\u5F80\u6A13\u4E0A",
        map_background_default: "\u9810\u8A2D",
        map_background_more: "\u66F4\u591A",
        indoor_selector_leveldown: "\u524D\u5F80\u6A13\u4E0B",
        indoor_selector_scrollup: "\u5411\u4E0A\u6372\u52D5\u6A13\u5C64\u6E05\u55AE",
        "visibility_title_owner-only": "\u53EA\u6709\u60A8\u53EF\u4EE5\u67E5\u770B\u6B64\u76F8\u7247",
        popup_details_link: "\u66F4\u591A\u8CC7\u8A0A",
        filter_source_local: "\u6B64\u4F3A\u670D\u5668",
        filter_source_world: "\u5168\u4E16\u754C",
        error_pic_load: "\u76EE\u524D\u7121\u6CD5\u8F09\u5165\u6B64\u76F8\u7247\u3002\n\u8ACB\u6AA2\u67E5\u60A8\u7684\u7DB2\u8DEF\u9023\u7DDA\u3002\u82E5\u5DF2\u9023\u7DDA\uFF0C\u8ACB\u78BA\u8A8D\u76F8\u7247 ID \u662F\u5426\u6709\u6548\u3002",
        low_contrast: "\u964D\u4F4E\u5F71\u50CF\u5C0D\u6BD4\u5EA6",
        reset_contrast: "\u91CD\u8A2D\u5F71\u50CF\u5C0D\u6BD4\u5EA6",
        delete_picture: "\u522A\u9664",
        delete_picture_warn: "\u26A0\uFE0F \u6CE8\u610F: \u6B64\u64CD\u4F5C\u5C07\u6C38\u4E45\u522A\u9664\u6B64\u76F8\u7247\u3002\n\u60A8\u78BA\u5B9A\u8981\u7E7C\u7E8C\u57F7\u884C\u55CE\uFF1F",
        metadata_general_title: "\u6A19\u984C",
        delete_picture_error: "\u522A\u9664\u76F8\u7247\u6642\u767C\u751F\u932F\u8AA4:\n{e}",
        semantics_empty: "\u672A\u5B9A\u7FA9\u4EFB\u4F55\u6A19\u7C64",
        widget_locked: "\u9078\u9805\u5DF2\u505C\u7528",
        map_theme_default_2: "\u5E73\u5747",
        map_theme_default_3: "\u826F\u597D",
        map_theme_default_coef: "\u76F8\u7247\u8986\u84CB\u7387",
        map_theme_default_coef_short: "\u8986\u84CB\u7387",
        map_theme_default_1: "\u4F4E",
        map_theme_default_4: "\u512A\u79C0",
        semantics_draw_unfinished_annotation: "\u7E6A\u88FD\u5340\u57DF\u5C1A\u672A\u5B8C\u6210\uFF0C\u5132\u5B58\u524D\u8ACB\u78BA\u8A8D\u5340\u57DF\u4F4D\u7F6E\u662F\u5426\u6B63\u78BA\u3002",
        time_travel: "\u67E5\u770B\u6B64\u5730\u9EDE\u7684\u5176\u4ED6\u65E5\u671F\u5F71\u50CF",
        time_travel_close: "\u96B1\u85CF\u5176\u4ED6\u65E5\u671F",
        semantics_draw_invalid_annotation: "\u7E6A\u88FD\u5340\u57DF\u5DF2\u8D85\u51FA\u76F8\u7247\u7BC4\u570D\uFF0C\u8ACB\u78BA\u4FDD\u7E6A\u88FD\u5728\u53EF\u898B\u7684\u76F8\u7247\u7BC4\u570D\u5167\u3002",
        map_theme_default_short: "\u9810\u8A2D",
        map_theme_age_short: "\u65E5\u671F",
        map_theme_type_short: "\u76F8\u6A5F",
        map_theme_score_short: "\u54C1\u8CEA",
        map_theme_gps_short: "\u4F4D\u7F6E",
        delete_picture_ok: "\u76F8\u7247\u5DF2\u6210\u529F\u522A\u9664",
        sequence_play_backwards: "\u53CD\u5411\u64AD\u653E\u5E8F\u5217",
        semantics_annotation_tooltip_close: "\u9EDE\u64CA\u4EE5\u53D6\u6D88\u9078\u53D6"
    },
    map: {
        loading: "\u6B63\u5728\u8F09\u5165\u2026",
        not_public: "\u672A\u516C\u958B\u986F\u793A",
        thumbnail: "\u904A\u6A19\u61F8\u505C\u76F8\u7247\u7684\u7E2E\u5716",
        slow_loading: "\u5730\u5716\u8F09\u5165\u7DE9\u6162\u800C\u4E14\u53EF\u80FD\u986F\u793A\u7570\u5E38",
        more_panoramax: "\u6DF1\u5165\u4E86\u89E3 Panoramax",
        map_data: "\u5730\u5716\u8CC7\u6599: {m}"
    },
    psv: {
        ctrlZoom: "\u4F7F\u7528 CTRL + \u6ED1\u9F20\u6EFE\u8F2A\u7E2E\u653E\u5716\u7247",
        loadError: "\u7121\u6CD5\u8F09\u5165\u5168\u666F\u5716",
        twoFingers: "\u4F7F\u7528\u96D9\u6307\u79FB\u52D5"
    },
    maplibre: {
        "GeolocateControl.FindMyLocation": "\u5C0B\u627E\u6211\u7684\u4F4D\u7F6E",
        "GeolocateControl.LocationNotAvailable": "\u7121\u6CD5\u4F7F\u7528\u4F4D\u7F6E\u8CC7\u8A0A"
    }
};
const $a42f1354f0348298$var$xx = "en", $a42f1354f0348298$var$wx = {
    be: {
        psv: {
            twoFingers: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0434\u0432\u0430 \u043F\u0430\u043B\u044C\u0446\u044B \u0434\u043B\u044F \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u044B\u0456",
            ctrlZoom: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 ctrl + \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430 \u0434\u043B\u044F \u043C\u0430\u0448\u0442\u0430\u0431\u0430\u0432\u0430\u043D\u043D\u044F \u0432\u044B\u044F\u0432\u044B",
            loadError: "\u041F\u0430\u043D\u0430\u0440\u0430\u043C\u0443 \u043D\u0435\u043C\u0430\u0433\u0447\u044B\u043C\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u0456\u0446\u044C"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "\u0417\u043D\u0430\u0439\u0441\u0446\u0456 \u043C\u0430\u0451 \u043C\u0435\u0441\u0446\u0430\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0430\u043D\u043D\u0435",
            "GeolocateControl.LocationNotAvailable": "\u041C\u0435\u0441\u0446\u0430\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0430\u043D\u043D\u0435 \u043D\u0435\u0434\u0430\u0441\u0442\u0443\u043F\u043D\u0430"
        },
        pnx: {
            zoom: "\u041C\u0430\u0448\u0442\u0430\u0431",
            zoomOut: "\u0410\u0434\u0434\u0430\u043B\u0456\u0446\u044C",
            zoomIn: "\u041D\u0430\u0431\u043B\u0456\u0437\u0456\u0446\u044C",
            moveUp: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u045E\u0432\u0435\u0440\u0445",
            search_user: "\u0428\u0443\u043A\u0430\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u2026",
            share: "\u041F\u0430\u0434\u0437\u044F\u043B\u0456\u0446\u0446\u0430",
            share_links: "\u0421\u043F\u0430\u0441\u044B\u043B\u043A\u0456",
            share_page: "\u0421\u043F\u0430\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0433\u044D\u0442\u0443 \u0432\u044B\u044F\u0432\u0443",
            share_image: "\u0412\u044B\u044F\u0432\u0430 \u0432\u044B\u0441\u043E\u043A\u0430\u0439 \u044F\u043A\u0430\u0441\u0446\u0456",
            share_rss: "RSS \u0441\u0442\u0443\u0436\u043A\u0430",
            share_rss_title: "RSS \u0441\u0442\u0443\u0436\u043A\u0430 \u043D\u043E\u0432\u044B\u0445 \u0441\u0435\u0440\u044B\u0439 \u0443 \u0431\u0430\u0447\u043D\u0430\u0439 \u0432\u043E\u0431\u043B\u0430\u0441\u0446\u0456 \u043A\u0430\u0440\u0442\u044B",
            share_embed: "\u0423\u0431\u0443\u0434\u0430\u0432\u0430\u0446\u044C \u043D\u0430 \u0412\u0430\u0448 \u0441\u0430\u0439\u0442",
            share_embed_docs: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u043D\u0430\u043B\u0430\u0434\u043A\u0443 \u045E\u0431\u0443\u0434\u043E\u0432\u044B",
            share_print: "\u0414\u0440\u0443\u043A",
            panoramax: "Panoramax",
            copy: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B",
                "\uD83D\uDDA5\uFE0F \u0417\u0430\u043F\u044B\u0442 \u0434\u0430 API",
                "\uD83D\uDDBC\uFE0F \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u0456\u043D\u0456\u044F\u0446\u044E\u0440",
                "\uD83D\uDD0D \u0410\u043D\u0430\u043B\u0456\u0437 EXIF \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u044B\u0445",
                "\uD83C\uDFD8\uFE0F 3D \u0440\u044D\u043D\u0434\u044D\u0440\u044B\u043D\u0433",
                "\uD83D\uDCF7 \u0406\u043D\u0456\u0446\u044B\u044F\u043B\u0456\u0437\u0430\u0446\u044B\u044F 360\xb0 \u0432\u044B\u044F\u045E",
                "\uD83D\uDFE0 \u0411\u0430\u043B\u0430\u043D\u0441 \u043A\u043E\u043B\u0435\u0440\u0430\u045E",
                "\uD83D\uDCAF \u0420\u0430\u0437\u043B\u0456\u043A \u0430\u0434\u0437\u043D\u0430\u043A\u0456 \u044F\u043A\u0430\u0441\u0446\u0456 \xa9",
                "\uD83D\uDCE1 \u0421\u0446\u044F\u0433\u0432\u0430\u043D\u043D\u0435 \u0430\u0431\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u044F\u045E",
                "\uD83C\uDF0D \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0442\u0430\u0439\u043B\u0430\u045E \u043A\u0430\u0440\u0442\u044B",
                "\uD83D\uDCF8 \u0410\u043F\u0440\u0430\u0446\u043E\u045E\u043A\u0430 \u0446\u0435\u043D\u044F\u045E"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C \u0412\u044B\u044F\u045E\u043B\u0435\u043D\u043D\u0435 \u0437\u043D\u0430\u043A\u0430\u045E \u043F\u0435\u0440\u0430\u0445\u043E\u0434\u0443 \u0430\u043B\u0435\u043D\u044F\u045E",
                "\uD83D\uDE98 \u041F\u043E\u0448\u0443\u043A \u0430\u045E\u0442\u0430\u043C\u0430\u0431\u0456\u043B\u044F Panoramax\xa9",
                "\u2615 \u0406\u043D'\u0435\u043A\u0446\u044B\u044F \u043A\u0430\u0444\u0435\u0456\u043D\u0443",
                "\uD83D\uDE00 \u0423\u0441\u043C\u0456\u0445\u043D\u0456\u0446\u0435\u0441\u044F, \u0432\u044B \u043D\u0430 \u043A\u0430\u0440\u0446\u0435!",
                "\uD83D\uDC08 \u041F\u0430\u0434\u0437\u044F\u043B\u044F\u0435\u043C\u0441\u044F \u0444\u0430\u0442\u0430\u0433\u0440\u0430\u0444\u0456\u044F\u043C\u0456 \u043A\u0430\u0442\u043A\u043E\u045E",
                "\uD83D\uDE34 \u0417\u043C\u044F\u043D\u0448\u044D\u043D\u043D\u0435 \u043F\u0440\u0430\u043A\u0440\u0430\u0441\u0442\u044B\u043D\u0430\u0446\u044B\u0456",
                "\uD83E\uDED6 \u0417\u0430\u0432\u0430\u0440\u0432\u0430\u043D\u043D\u0435 \u0433\u0430\u0440\u0431\u0430\u0442\u044B",
                "\uD83D\uDC27 \u0410\u0434\u043A\u0440\u044B\u0446\u0446\u0451 \u0437\u044B\u0445\u043E\u0434\u043D\u0430\u0433\u0430 \u043A\u043E\u0434\u0430",
                "\uD83D\uDE87 \u0406\u043D\u0434\u044D\u043A\u0441\u0430\u0446\u044B\u044F \u0441\u0442\u0430\u043D\u0446\u044B\u0439 \u043C\u0435\u0442\u0440\u043E",
                "\uD83E\uDDF9 \u041F\u0440\u044B\u0431\u0456\u0440\u0430\u0435\u043C \u045E\u0441\u0451 \u0441\u043C\u0435\u0446\u0446\u0435 \u0437 \u0432\u0443\u043B\u0456\u0446",
                "\uD83D\uDE92 \u0420\u0430\u0441\u0447\u044B\u0448\u0447\u0430\u0435\u043C \u0432\u0443\u043B\u0456\u0446\u044B \u0430\u0434 \u043C\u0430\u0448\u044B\u043D \u0434\u043B\u044F \u043F\u0440\u0430\u0435\u0437\u0434\u0443 \u043F\u0430\u0436\u0430\u0440\u043D\u044B\u0445",
                "\uD83C\uDF33 \u041F\u0435\u0440\u0430\u043B\u0456\u0447\u0432\u0430\u0435\u043C \u043B\u044F\u0441\u043D\u044B\u044F \u0441\u0446\u0435\u0436\u0430\u0447\u043A\u0456 \u045E \u0411\u0435\u043B\u0430\u0432\u0435\u0436\u0441\u043A\u0430\u0439 \u043F\u0443\u0448\u0447\u044B... \u0410\u0434\u043D\u0430, \u0434\u0440\u0443\u0433\u0430\u044F, \u0442\u0440\u044D\u0446\u044F\u044F... \u0417\u0431\u0456\u043B\u0456\u0441\u044F! \u041F\u0430\u0447\u044B\u043D\u0430\u0435\u043C \u0441\u043F\u0430\u0447\u0430\u0442\u043A\u0443!",
                "\uD83D\uDE89 \u0410\u0433\u043B\u044F\u0434 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C \u0441\u0442\u0430\u043D\u0446\u044B\u0439",
                "\uD83D\uDEF0\uFE0F \u041F\u043E\u0448\u0443\u043A \u0441\u043F\u0430\u0434\u0430\u0440\u043E\u0436\u043D\u0456\u043A\u0430\u045E",
                "\uD83D\uDC65 \u0421\u0442\u0432\u0430\u0440\u044D\u043D\u043D\u0435 \u043F\u0435\u0440\u0441\u043E\u043D",
                "\uD83D\uDC1F \u041B\u0430\u043A\u0430\u0446\u044B\u044F \u0440\u044B\u0431\u043D\u044B\u0445 \u043A\u0440\u0430\u043C",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB \u0410\u0434\u043B\u0430\u0434\u043A\u0430 \u0456\u043D\u0442\u044D\u0440\u0444\u0435\u0439\u0441\u0443",
                "\uD83D\uDCC8 \u041F\u0430\u0432\u0435\u043B\u0456\u0447\u044D\u043D\u043D\u0435 \u0441\u0442\u0430\u0442\u044B\u0441\u0442\u044B\u043A\u0456",
                "\uD83E\uDD16 \u0412\u044B\u0432\u0443\u0447\u044D\u043D\u043D\u0435 \u0441\u0435\u043C\u0430\u043D\u0442\u044B\u043A\u0456",
                "\uD83C\uDFA8 \u0420\u044D\u0434\u044B\u0437\u0430\u0439\u043D \u0456\u043D\u0442\u044D\u0440\u0444\u0435\u0439\u0441\u0443",
                "\uD83D\uDCC5 \u041F\u043B\u0430\u043D\u0430\u0432\u0430\u043D\u043D\u0435 \u0444\u043E\u0442\u0430-\u043A\u0430\u0440\u0442\u0430\u0433\u0440\u0430\u0444\u0456\u0447\u043D\u044B\u0445 \u0432\u0435\u0447\u0430\u0440\u044B\u043D",
                "\uD83E\uDDC0 \u041F\u0430\u0441\u043F\u044F\u0432\u0430\u043D\u043D\u0435 \u043A\u043B\u0456\u043D\u043A\u043E\u0432\u0430\u0433\u0430 \u0441\u044B\u0440\u0443",
                "\uD83C\uDF04 \u0427\u0430\u043A\u0430\u0435\u043C \u043D\u0430\u0441\u0442\u0443\u043F\u0443 \u0441\u0432\u0456\u0442\u0430\u043D\u043A\u0443",
                "\uD83C\uDF0A \u0412\u044B\u043C\u044F\u0440\u044D\u043D\u043D\u0435 \u043F\u0440\u044B\u043B\u0456\u0432\u0430\u045E"
            ],
            qualityscore_doc_3: "\u042F\u043D\u0430 \u0440\u0430\u0437\u043B\u0456\u0447\u0432\u0430\u0435\u0446\u0446\u0430 \u043D\u0430 \u0430\u0441\u043D\u043E\u0432\u0435 \u0434\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u0456 GPS \u0456 \u0440\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456 \u0432\u044B\u044F\u0432\u044B. \u041F\u0440\u0430\u0444\u0435\u0441\u0456\u0439\u043D\u0430\u044F \u0441\u0456\u0441\u0442\u044D\u043C\u0430 \u0431\u0443\u0434\u0437\u0435 \u043C\u0435\u0446\u044C \u0430\u0434\u0437\u043D\u0430\u043A\u0443 A, \u044D\u043A\u0448\u043D-\u043A\u0430\u043C\u0435\u0440\u0430 360\xb0 - B, \u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D - C/D/E.",
            qualityscore_doc_link: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456",
            filter_gps_precision: "\u0414\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u044C \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            filter_gps_precision_between: "\u041F\u0430\u043C\u0456\u0436 {n1} \u0456 {n2} \u043C\u0435\u0442\u0440\u0430\u043C\u0456",
            filter_gps_precision_morethan: "\u0411\u043E\u043B\u044C\u0448 \u0437\u0430 {n} \u043C\u0435\u0442\u0440\u0430\u045E",
            map_theme_age: "\u0414\u0430\u0442\u0430 \u0437\u0434\u044B\u043C\u043A\u0456",
            map_theme_type: "\u0422\u044B\u043F \u043A\u0430\u043C\u0435\u0440\u044B",
            map_theme_score: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u044F\u043A\u0430\u0441\u0446\u0456",
            map_theme_gps: "\u0414\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u044C \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            map_theme_age_1: "> 3 \u0433\u0430\u0434\u044B",
            map_theme_age_2: "< 3 \u0433\u0430\u0434\u044B",
            map_theme_age_3: "< 1 \u0433\u043E\u0434",
            map_theme_age_4: "< 6 \u043C\u0435\u0441\u044F\u0446",
            contrast: "\u0423\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0431\u043E\u043B\u044C\u0448\u044B \u043A\u0430\u043D\u0442\u0440\u0430\u0441\u0442 \u0432\u044B\u044F\u0432\u044B",
            metadata: "\u041C\u0435\u0442\u0430\u0434\u0430\u043D\u044B\u044F \u0432\u044B\u044F\u0432\u044B",
            metadata_summary: "\u0410\u043F\u0456\u0441\u0430\u043D\u043D\u0435",
            metadata_location_coordinates: "\u041A\u0430\u0430\u0440\u0434\u044B\u043D\u0430\u0442\u044B (\u0434\u0430\u045E\u0433\u0430\u0442\u0430, \u0448\u044B\u0440\u0430\u0442\u0430)",
            metadata_location_orientation: "\u041D\u0430\u043F\u0440\u0430\u043C\u0430\u043A",
            metadata_location_precision: "\u0414\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u044C \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            metadata_location_copy: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C {v}",
            metadata_location_copy_more: "\u0411\u043E\u043B\u044C\u0448 \u043E\u043F\u0446\u044B\u0439 \u043A\u0430\u043F\u0456\u044F\u0432\u0430\u043D\u043D\u044F \u043A\u0430\u0430\u0440\u0434\u044B\u043D\u0430\u0442",
            metadata_quality: "\u042F\u043A\u0430\u0441\u0446\u044C",
            metadata_quality_help: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456",
            metadata_quality_gps_score: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            metadata_quality_resolution_score: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u0440\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456",
            metadata_quality_missing: "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435 \u043D\u0435 \u0437\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u0430 \u045E \u0432\u044B\u044F\u0432\u0435",
            metadata_exif: "EXIF",
            metadata_exif_name: "\u0422\u044D\u0433",
            semantics_features: "\u0410\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435",
            semantics_features_none: "\u041D\u0430 \u0433\u044D\u0442\u0430\u0439 \u0432\u044B\u044F\u0432\u0435 \u044F\u0448\u0447\u044D \u043D\u0435 \u0432\u044B\u043B\u0443\u0447\u0430\u043D\u044B \u043D\u0456\u0432\u043E\u0434\u043D\u044B \u0430\u0431'\u0435\u043A\u0442.",
            semantics_show_all_tags: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u0443\u0441\u0435 \u0442\u044D\u0433\u0456",
            semantics_hide_all_tags: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C \u0443\u0441\u0435 \u0442\u044D\u0433\u0456",
            report_nature: {
                blur_missing: "\u0411\u0430\u0447\u043D\u044B \u0442\u0432\u0430\u0440 \u0447\u0430\u043B\u0430\u0432\u0435\u043A\u0430 \u0430\u0431\u043E \u043D\u0443\u043C\u0430\u0440\u043D\u044B \u0437\u043D\u0430\u043A \u0430\u045E\u0442\u043E",
                blur_excess: "\u041D\u0430 \u0430\u0431'\u0435\u043A\u0442 \u0431\u044B\u045E \u0443\u0436\u044B\u0442\u044B \u043D\u0435\u043F\u0430\u0442\u0440\u044D\u0431\u043D\u0430\u0435 \u0440\u0430\u0437\u043C\u044B\u0446\u0446\u0451",
                "": "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u0442\u044B\u043F \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B\u2026",
                inappropriate: "\u041D\u0435\u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430 (\u043D\u0435 \u0437\u0432\u044F\u0437\u0430\u043D\u0430\u044F, \u0430\u0433\u043E\u043B\u0435\u043D\u0430\u0441\u0446\u044C\u2026)",
                privacy: "\u0411\u0430\u0447\u043D\u044B \u043F\u0440\u044B\u0432\u0430\u0442\u043D\u044B \u0448\u043B\u044F\u0445 \u0430\u0431\u043E \u045E\u043B\u0430\u0441\u043D\u0430\u0441\u0446\u044C",
                picture_low_quality: "\u0412\u044B\u044F\u0432\u0430 \u043D\u0456\u0437\u043A\u0430\u0439 \u044F\u043A\u0430\u0441\u0446\u0456",
                mislocated: "\u0412\u044B\u044F\u0432\u0430 \u0434\u0440\u044D\u043D\u043D\u0430 \u0440\u0430\u0437\u043C\u0435\u0448\u0447\u0430\u043D\u0430 \u043D\u0430 \u043A\u0430\u0440\u0446\u0435",
                copyright: "\u0412\u044B\u044F\u0432\u0430 \u043F\u0430\u0440\u0443\u0448\u0430\u0435 \u0430\u045E\u0442\u0430\u0440\u0441\u043A\u0456\u044F \u043F\u0440\u0430\u0432\u044B",
                other: "\u041B\u044E\u0431\u044B \u0456\u043D\u0448\u044B \u0432\u0456\u0434 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B"
            },
            semantics_editor_example: "\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435\n\u043F\u0440\u044D\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435",
            moveDown: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u045E\u043D\u0456\u0437",
            moveLeft: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u043D\u0430\u043B\u0435\u0432\u0430",
            moveRight: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u0430",
            moveMiddle: "\u0426\u044D\u043D\u0442\u0440\u0430\u0432\u0430\u0446\u044C \u0432\u0456\u0434",
            expand: "\u0420\u0430\u0437\u0433\u0430\u0440\u043D\u0443\u0446\u044C",
            expand_info: "\u0410\u0434\u043B\u044E\u0441\u0442\u0440\u0430\u0432\u0430\u0446\u044C \u0432\u0456\u0434\u0436\u044D\u0442 \u043D\u0430 \u045E\u0441\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443",
            show_psv: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u043F\u0440\u0430\u0433\u043B\u044F\u0434\u0430\u043B\u044C\u043D\u0456\u043A \u0432\u044B\u044F\u045E",
            show_map: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u043A\u0430\u0440\u0442\u0443",
            minimize: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C \u0433\u044D\u0442\u044B \u0432\u0456\u0434\u0436\u044D\u0442, \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0437\u043D\u043E\u045E \u043F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u044F\u0433\u043E \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u043A\u043D\u043E\u043F\u043A\u0456 \u045E \u043B\u0435\u0432\u044B\u043C \u043D\u0456\u0436\u043D\u0456\u043C \u043A\u0443\u0446\u0435",
            minimize_short: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C",
            options: "\u041E\u043F\u0446\u044B\u0456",
            filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u044B",
            layers: "\u0421\u043B\u0430\u0456",
            search: "\u041F\u043E\u0448\u0443\u043A",
            search_empty: "\u0412\u044B\u043D\u0456\u043A\u0430\u045E \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u0430",
            search_address: "\u0428\u0443\u043A\u0430\u0446\u044C \u0430\u0434\u0440\u0430\u0441, \u0433\u043E\u0440\u0430\u0434\u2026",
            whats_panoramax: "Panoramax - \u0433\u044D\u0442\u0430 \u0430\u0434\u043A\u0440\u044B\u0442\u0430\u044F \u0433\u0435\u0430-\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0432\u044B\u044F\u0432\u0430\u045E \u0442\u044D\u0440\u044B\u0442\u043E\u0440\u044B\u0439.",
            copied: "\u0421\u043A\u0430\u043F\u0456\u044F\u0432\u0430\u043D\u0430",
            error: "\u0423 \u043D\u0430\u0441 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u0430\u2026",
            error_click: "\u041F\u0440\u0430\u0446\u044F\u0433\u0432\u0430\u0446\u044C",
            error_retry: "\u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0437\u043D\u0435\u0439",
            sequence_next: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430 \u045E \u0441\u0435\u0440\u044B\u0456",
            sequence_play: "\u041F\u0440\u0430\u0439\u0433\u0440\u0430\u0446\u044C \u0433\u044D\u0442\u0443\u044E \u0441\u0435\u0440\u044B\u044E",
            sequence_pause: "\u041F\u0440\u044B\u043F\u044B\u043D\u0456\u0446\u044C \u0441\u0435\u0440\u044B\u044E",
            sequence_prev: "\u041F\u0430\u043F\u044F\u0440\u044D\u0434\u043D\u044F\u044F \u0432\u044B\u044F\u0432\u0430 \u045E \u0441\u0435\u0440\u044B\u0456",
            sequence_more: "\u0411\u043E\u043B\u044C\u0448 \u043E\u043F\u0446\u044B\u0439 \u043F\u0440\u0430\u0439\u0433\u0440\u0430\u0432\u0430\u043D\u043D\u044F",
            sequence_speed: "\u0425\u0443\u0442\u043A\u0430\u0441\u0446\u044C \u043F\u0440\u0430\u0439\u0433\u0440\u0430\u0432\u0430\u043D\u043D\u044F",
            legend_license: "\u041B\u0456\u0446\u044D\u043D\u0437\u0456\u044F: {l}",
            legend_title: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456 \u0432\u044B\u044F\u0432\u044B",
            id: "iD",
            contribute_id: "\u0423\u043D\u0435\u0441\u0446\u0456 \u045E\u043A\u043B\u0430\u0434 \u0443 OpenStreetMap \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0440\u044D\u0434\u0430\u043A\u0442\u0430\u0440\u0430 iD",
            geo_uri: "\u0417\u043D\u0435\u0448\u043D\u044F\u044F \u043F\u0440\u0430\u0433\u0440\u0430\u043C\u0430",
            josm: "JOSM",
            josm_live: "\u0423\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0443\u044E \u0441\u0456\u043D\u0445\u0440\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E JOSM \u043F\u0440\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0446\u044B \u0432\u044B\u044F\u0432\u044B",
            error_psv: "Photo Sphere Viewer \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0446\u0446\u0430 \u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u0430",
            error_pic: "\u0417\u0430\u043F\u044B\u0442\u0430\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430 \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u0430",
            error_nopic: "\u041D\u044F\u043C\u0430 \u0432\u044B\u044F\u0432\u044B \u045E \u0437\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u0430\u0439 \u043F\u0430\u0437\u0456\u0446\u044B\u0456",
            error_api: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u044B\u044F\u045E \u043D\u0435\u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B",
            error_webgl: "WebGL \u043D\u0435 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0435\u0446\u0446\u0430 \u0432\u0430\u0448\u044B\u043C \u0431\u0440\u0430\u045E\u0437\u0430\u0440\u0430\u043C",
            error_josm: "JOSM \u043D\u0435 \u0430\u0434\u043A\u0430\u0437\u0432\u0430\u0435, \u0446\u0456 \u0451\u043D \u0437\u0430\u043F\u0443\u0448\u0447\u0430\u043D\u044B \u0456 \u045E\u043A\u043B\u044E\u0447\u0430\u043D\u044B \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0443\u043F?",
            error_api_compatibility: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u044B\u044F\u045E \u043D\u0435\u0441\u0443\u043C\u044F\u0448\u0447\u0430\u043B\u044C\u043D\u044B \u0437 \u0433\u044D\u0442\u0430\u0439 \u0432\u0435\u0440\u0441\u0456\u044F\u0439 \u043F\u0440\u0430\u0433\u043B\u044F\u0434\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
            filter_date: "\u0414\u0430\u0442\u0430",
            filter_date_1month: "1 \u043C\u0435\u0441\u044F\u0446",
            filter_date_6months: "6 \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            filter_date_1year: "1 \u0433\u043E\u0434",
            filter_user: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A",
            filter_user_mypics: "\u041C\u0430\u0435 \u0432\u044B\u044F\u0432\u044B",
            filter_picture: "\u0422\u044B\u043F \u0432\u044B\u044F\u0432\u044B",
            filter_zoom_in: "\u041D\u0430\u0431\u043B\u0456\u0437\u044C\u0446\u0435 \u043A\u0430\u0440\u0442\u0443, \u043A\u0430\u0431 \u0443\u0431\u0430\u0447\u044B\u0446\u044C \u0433\u044D\u0442\u044B \u0444\u0456\u043B\u044C\u0442\u0440",
            picture_all: "\u0423\u0441\u0435",
            picture_flat: "\u041A\u043B\u0430\u0441\u0456\u0447\u043D\u044B\u044F",
            picture_360: "360\xb0",
            picture_flat_long: "\u041A\u043B\u0430\u0441\u0456\u0447\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430",
            picture_360_long: "\u041F\u0430\u043D\u0430\u0440\u0430\u043C\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430",
            filter_qualityscore: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u044F\u043A\u0430\u0441\u0446\u0456",
            filter_qualityscore_help: "\u041D\u0430\u0446\u0456\u0441\u043D\u0456\u0446\u0435, \u043A\u0430\u0431 \u0443\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0430\u0431\u043E \u0432\u044B\u043A\u043B\u044E\u0447\u044B\u0446\u044C",
            qualityscore_title: "\u041F\u0440\u0430 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456",
            qualityscore_doc_1: "Panoramax \u043F\u0440\u0430\u043F\u0430\u043D\u0443\u0435 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456 \u0434\u043B\u044F \u043A\u043E\u0436\u043D\u0430\u0439 \u0432\u044B\u044F\u0432\u044B. \u0413\u044D\u0442\u0430 \u0434\u0430\u0437\u0432\u0430\u043B\u044F\u0435 \u043B\u0451\u0433\u043A\u0430 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u0432\u0430\u0446\u044C \u043A\u0430\u0440\u0442\u0443 \u0456 \u043F\u0430\u043A\u0430\u0437\u0432\u0430\u0446\u044C \u043D\u0430\u044F\u045E\u043D\u0430\u0441\u0446\u044C \u0432\u044B\u044F\u045E \u0432\u044B\u0441\u043E\u043A\u0430\u0439 \u044F\u043A\u0430\u0441\u0446\u0456.",
            qualityscore_doc_2: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u043F\u0430\u043A\u0430\u0437\u0432\u0430\u0435\u0446\u0446\u0430 \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u043C \u044F\u043A A/B/C/D/E (A - \u043B\u0435\u043F\u0448\u0430\u044F, E - \u0433\u043E\u0440\u0448\u0430\u044F) \u0434\u044B \u0430\u0434\u043B\u044E\u0441\u0442\u0440\u043E\u045E\u0432\u0430\u0435\u0446\u0446\u0430 \u0433\u0440\u0430\u0444\u0456\u0447\u043D\u0430 \u043F\u0440\u0430\u0437 \u0433\u044D\u0442\u0443\u044E \u0448\u043A\u0430\u043B\u0443:",
            filter_gps_precision_lessthan: "\u041C\u0435\u043D\u0448 \u0437\u0430 {n} \u043C\u0435\u0442\u0440\u0430\u045E",
            map_background: "\u0424\u043E\u043D \u043A\u0430\u0440\u0442\u044B",
            map_background_aerial: "\u0421\u043F\u0430\u0434\u0430\u0440\u043E\u0436\u043D\u0456\u043A\u0430\u0432\u044B",
            map_background_streets: "\u0412\u0443\u043B\u0456\u0447\u043D\u044B",
            map_theme: "\u0422\u044D\u043C\u0430 \u043A\u0430\u0440\u0442\u044B",
            map_theme_default: "\u041A\u043B\u0430\u0441\u0456\u0447\u043D\u0430\u044F",
            metadata_general_copy_id: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C ID",
            metadata_general_copy_picid: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C ID \u0432\u044B\u044F\u0432\u044B",
            metadata_general_picid: "\u0412\u044B\u044F\u0432\u0430",
            metadata_general_seqid: "\u0421\u0435\u0440\u044B\u044F",
            metadata_general_picid_link: "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 JSON \u0430\u043F\u0456\u0441\u0430\u043D\u043D\u044F \u0432\u044B\u044F\u0432\u044B",
            metadata_general_seqid_link: "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 JSON \u0430\u043F\u0456\u0441\u0430\u043D\u043D\u044F \u0441\u0435\u0440\u044B\u0456",
            metadata_general_author: "\u0410\u045E\u0442\u0430\u0440",
            metadata_general_license: "\u041B\u0456\u0446\u044D\u043D\u0437\u0456\u044F",
            metadata_general_license_link: "\u0413\u043B\u044F\u0434\u0437\u0435\u0446\u044C \u043F\u043E\u045E\u043D\u0430\u0435 \u0430\u043F\u0456\u0441\u0430\u043D\u043D\u0435 \u043B\u0456\u0446\u044D\u043D\u0437\u0456\u0456",
            metadata_general_date: "\u0414\u0430\u0442\u0430 \u0437\u0434\u044B\u043C\u043A\u0456",
            metadata_general_instance: "\u0406\u043D\u0441\u0442\u0430\u043D\u0446\u044B\u044F \u043F\u0430\u0445\u043E\u0434\u0436\u0430\u043D\u043D\u044F",
            metadata_camera: "\u041A\u0430\u043C\u0435\u0440\u0430",
            metadata_camera_make: "\u0412\u044B\u0442\u0432\u043E\u0440\u0446\u0430",
            metadata_camera_model: "\u041C\u0430\u0434\u044D\u043B\u044C",
            metadata_camera_type: "\u0422\u044B\u043F",
            metadata_camera_resolution: "\u0420\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u044C",
            metadata_camera_focal_length: "\u0424\u0430\u043A\u0443\u0441\u043D\u0430\u044F \u0430\u0434\u043B\u0435\u0433\u043B\u0430\u0441\u0446\u044C",
            metadata_location: "\u041F\u0430\u0437\u0456\u0446\u044B\u044F",
            metadata_quality_score: "\u0410\u0433\u0443\u043B\u044C\u043D\u0430\u044F \u0430\u0434\u0437\u043D\u0430\u043A\u0430",
            metadata_exif_value: "\u0417\u043D\u0430\u0447\u044D\u043D\u043D\u0435",
            metadata_exif_doc: "\u0414\u0430\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u044B\u044F \u043F\u0430 EXIF \u0442\u044D\u0433\u0430\u0445",
            metadata_exif_doc_title: "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 \u0434\u0430\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u044B\u0456 Exiv2 \u0434\u043B\u044F \u043F\u043E\u045E\u043D\u044B\u0445 \u0437\u0432\u0435\u0441\u0442\u0430\u043A \u043F\u0440\u0430 \u0432\u044B\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0456 EXIF \u0456 XMP \u0442\u044D\u0433\u0430\u045E",
            semantics_title: "\u0422\u044D\u0433\u0456",
            semantics_tags: "{nb} \u0442\u044D\u0433\u0430\u045E",
            semantics_features_default_title: "\u0422\u044D\u0433 {nb}",
            semantics_features_subtitle: "{nb} \u0437\u0432\u044F\u0437\u0430\u043D\u044B\u0445 \u0443\u043B\u0430\u0441\u0446\u0456\u0432\u0430\u0441\u0446\u0435\u0439",
            semantics_annotation_tooltip: "\u041D\u0430\u0446\u0456\u0441\u043D\u0456\u0446\u0435, \u043A\u0430\u0431 \u0443\u0431\u0430\u0447\u044B\u0446\u044C \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456",
            semantics_key: "\u041A\u043B\u044E\u0447",
            semantics_value: "\u0417\u043D\u0430\u0447\u044D\u043D\u043D\u0435",
            semantics_sequence_tags: "\u0422\u044D\u0433 \u0441\u0435\u0440\u044B\u0456",
            semantics_picture_tags: "\u0422\u044D\u0433 \u0432\u044B\u044F\u0432\u044B",
            semantics_annotation_tags: "\u0422\u044D\u0433 \u0430\u0431'\u0435\u043A\u0442\u0430",
            semantics_doc: "\u0414\u0430\u043F\u0430\u043C\u043E\u0433\u0430",
            semantics_doc_title: "\u041F\u0440\u0430 \u0442\u044D\u0433\u0456",
            semantics_doc_info1: "\u0414\u0430\u0434\u0430\u0439\u0446\u0435 \u043A\u0430\u043D\u0442\u044D\u043A\u0441\u0442 \u0434\u0430 \u0432\u044B\u044F\u0432\u044B \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0442\u044D\u0433\u0430\u045E. \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u043F\u0430\u0437\u043D\u0430\u0447\u044B\u0446\u044C, \u0448\u0442\u043E \u044F\u043D\u0430 \u0437\u0440\u043E\u0431\u043B\u0435\u043D\u0430 \u0437 \u043C\u0430\u0448\u044B\u043D\u044B, \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0442\u044D\u0433\u0430 transport=car.",
            semantics_doc_info2: "\u0412\u044B \u0442\u0430\u043A\u0441\u0430\u043C\u0430 \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043B\u0443\u0447\u044B\u0446\u044C \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435: \u0434\u0430\u0440\u043E\u0436\u043D\u044B\u044F \u0437\u043D\u0430\u043A\u0456, \u0433\u0430\u0440\u0430\u0434\u0441\u043A\u043E\u0435 \u0430\u0431\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u043D\u043D\u0435\u2026 \u041F\u0430\u0437\u043D\u0430\u0447\u0430\u0439\u0446\u0435 \u0442\u043E\u0435, \u0448\u0442\u043E \u0431\u0430\u0447\u044B\u0446\u0435, \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0456\u0441\u043D\u0443\u044E\u0447\u044B\u0445 \u0442\u044D\u0433\u0430\u045E. \u041F\u0440\u044B \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430\u0441\u0446\u0456 \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0441\u0442\u0432\u0430\u0440\u0430\u0446\u044C \u0441\u0432\u0430\u0435 \u045E\u043B\u0430\u0441\u043D\u044B\u044F.",
            semantics_doc_info3: "\u041D\u0435\u043A\u0430\u0442\u043E\u0440\u044B\u044F \u0430\u0431'\u0435\u043A\u0442\u044B \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0430 \u0432\u044B\u044F\u045E\u043B\u044F\u044E\u0446\u0446\u0430 \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0428\u0406: \u044F\u043A\u0430\u0441\u0446\u044C \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0443\u0435\u0446\u0446\u0430.",
            semantics_doc_link: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0442\u044D\u0433\u0456",
            semantics_key_doc: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0433\u044D\u0442\u044B \u043A\u043B\u044E\u0447",
            semantics_value_doc: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0433\u044D\u0442\u044B \u0442\u044D\u0433",
            semantics_qualifiers: "\u041A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0442\u0430\u0440\u044B",
            semantics_show_annotations: "\u0410\u0434\u043B\u044E\u0441\u0442\u0440\u043E\u045E\u0432\u0430\u0446\u044C \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435",
            semantics_hide_annotations: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435",
            semantics_zero_annotations: "\u041D\u0430 \u0433\u044D\u0442\u0430\u0439 \u0432\u044B\u044F\u0432\u0435 \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0435 \u0432\u044B\u043B\u0443\u0447\u0430\u043D\u044B",
            semantics_add_annotation: "\u0414\u0430\u0434\u0430\u0446\u044C \u043D\u043E\u0432\u044B \u0442\u044D\u0433",
            semantics_draw_annotation: "\u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043B\u0443\u0447\u044B\u0446\u044C \u0430\u0431'\u0435\u043A\u0442, \u044F\u043A\u0456 \u0445\u043E\u0447\u0430\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044C, \u043D\u0430 \u0432\u044B\u044F\u0432\u0435 (\u041D\u0435\u0430\u0431\u0430\u0432\u044F\u0437\u043A\u043E\u0432\u0430).",
            semantics_erase_annotation: "\u0421\u0446\u0435\u0440\u0446\u0456 \u0432\u044B\u043B\u0443\u0447\u0430\u043D\u044B \u0430\u0431'\u0435\u043A\u0442",
            semantics_delete_annotation: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u044B \u0430\u0431'\u0435\u043A\u0442",
            semantics_delete_annotation_confirm: "\u0412\u044B \u0441\u0430\u043F\u0440\u0430\u045E\u0434\u044B \u0436\u0430\u0434\u0430\u0435\u0446\u0435 \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u044B \u0442\u044D\u0433?",
            semantics_wikidata_properties: {
                P31: "\u0430\u0441\u043E\u0431\u043D\u0456\u043A \u043A\u043B\u0430\u0441\u0430",
                P279: "\u043F\u0430\u0434\u043A\u043B\u0430\u0441",
                P361: "\u0447\u0430\u0441\u0442\u043A\u0430"
            },
            semantics_editor_error: "\u0421\u0456\u043D\u0442\u0430\u043A\u0441\u0456\u0441 \u043D\u0435\u0441\u0430\u043F\u0440\u0430\u045E\u0434\u043D\u044B. \u0412\u0430\u0448\u044B \u0442\u044D\u0433\u0456 \u043C\u043E\u0433\u0443\u0446\u044C \u0432\u044B\u0433\u043B\u044F\u0434\u0430\u0446\u044C \u0442\u0430\u043A:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\n\u041C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u0430\u045E\u0436\u044B\u043D\u044F \u043A\u043B\u044E\u0447\u0430 - 256 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E, \u043C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u0430\u045E\u0436\u044B\u043D\u044F \u0437\u043D\u0430\u0447\u044D\u043D\u043D\u044F - 2048 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
            semantics_edit: "\u0420\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u0446\u044C \u0430\u0442\u0440\u044B\u0431\u0443\u0442\u044B",
            semantics_save: "\u0417\u0430\u0445\u0430\u0432\u0430\u0446\u044C \u0437\u043C\u0435\u043D\u044B",
            semantics_undo: "\u0421\u043A\u0430\u0441\u0430\u0432\u0430\u0446\u044C \u0440\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u043D\u043D\u0435",
            semantics_send_fail: "\u041D\u0435\u043C\u0430\u0433\u0447\u044B\u043C\u0430 \u0437\u0430\u0445\u0430\u0432\u0430\u0446\u044C \u0437\u043C\u0435\u043D\u044B, \u043A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0437\u043D\u0435\u0439",
            semantics_login_needed: "\u0414\u043B\u044F \u0440\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u043D\u043D\u044F \u0442\u044D\u0433\u0430\u045E \u0430\u0431\u043E \u0430\u0431'\u0435\u043A\u0442\u0430\u045E \u043D\u0430 \u0432\u044B\u044F\u0432\u0435 \u0432\u0430\u043C \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430 \u045E\u0432\u0430\u0439\u0441\u0446\u0456 \u045E \u0456\u043D\u0441\u0442\u0430\u043D\u0446\u044B\u044E Panoramax {n}. \u0416\u0430\u0434\u0430\u0435\u0446\u0435 \u045E\u0432\u0430\u0439\u0441\u0446\u0456?",
            report: "\u041F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435",
            report_auth: '\u0413\u044D\u0442\u0430\u044F \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u0431\u0443\u0434\u0437\u0435 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430 \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443 "{a}"',
            report_nature_label: "\u041F\u0440\u044B\u0447\u044B\u043D\u0430 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B",
            report_whole_sequence: "\u0413\u044D\u0442\u0430 \u0442\u044B\u0447\u044B\u0446\u0446\u0430 \u045E\u0441\u0451\u0439 \u0441\u0435\u0440\u044B\u0456",
            report_details: "\u0414\u0430\u0434\u0430\u0442\u043A\u043E\u0432\u044B\u044F \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456",
            report_details_placeholder: "\u041F\u0430 \u0436\u0430\u0434\u0430\u043D\u043D\u0456, \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044C \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456 \u043F\u0440\u0430 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u0443",
            report_email: "\u0412\u0430\u0448 email",
            report_email_placeholder: "\u041D\u0435\u0430\u0431\u0430\u0432\u044F\u0437\u043A\u043E\u0432\u0430",
            report_submit: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C",
            report_wait: "\u0410\u0434\u043F\u0440\u0430\u045E\u043A\u0430 \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u044F\u2026",
            report_failure: "\u041F\u0440\u044B \u0441\u0442\u0432\u0430\u0440\u044D\u043D\u043D\u0456 \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u044F \u0430\u0434\u0431\u044B\u043B\u0430\u0441\u044F \u043F\u0430\u043C\u044B\u043B\u043A\u0430: {e}. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0437\u043D\u0435\u0439.",
            report_success: "\u041F\u0410\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u043F\u0430\u0441\u043F\u044F\u0445\u043E\u0432\u0430 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430. \u042F\u043D\u043E \u0431\u0443\u0434\u0437\u0435 \u0440\u0430\u0437\u0433\u043B\u0435\u0434\u0436\u0430\u043D\u0430 \u044F\u043A \u043C\u0430\u0433\u0430 \u0445\u0443\u0442\u0447\u044D\u0439."
        },
        map: {
            loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
            thumbnail: "\u041C\u0456\u043D\u0456\u044F\u0446\u044E\u0440\u0430 \u0432\u044B\u044F\u0432\u044B \u043F\u0430\u0434 \u043A\u0443\u0440\u0441\u043E\u0440\u0430\u043C",
            not_public: "\u041D\u0435\u043F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u0431\u0430\u0447\u043D\u0430\u044F",
            slow_loading: "\u041A\u0430\u0440\u0442\u0430 \u043F\u0430\u0432\u043E\u043B\u044C\u043D\u0430 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0446\u0446\u0430 \u0456 \u043C\u043E\u0436\u0430 \u0437\u0434\u0430\u0432\u0430\u0446\u0446\u0430 \u043F\u0430\u0448\u043A\u043E\u0434\u0436\u0430\u043D\u0430\u0439",
            map_data: "\u041A\u0430\u0440\u0442\u0430 \u043D\u0430 \u0430\u0441\u043D\u043E\u0432\u0435 {m}",
            more_panoramax: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 Panoramax"
        }
    },
    br: {
        pnx: {
            minimize_short: "Kuzhat",
            search: "Klask",
            copy: "Eila\xf1",
            map_theme_type: "Seurt kamera",
            metadata_general_copy_id: "Eila\xf1 an ID",
            metadata_general_copy_picid: "Eila\xf1 ID ar foto",
            metadata_general_picid: "Foto",
            metadata_location_copy: "Eila\xf1 {v}",
            filter_date: "Deiziad",
            loading_labels_serious: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                "\uD83D\uDCE1 O pellgarga\xf1 an hizivadenno\xf9"
            ],
            map_theme_age_4: "- 6 miz",
            map_theme_age_3: "\xbd - 1 bloaz",
            map_theme_age_2: "1 - 3 vloaz",
            map_theme_age_1: "+ 3 vloaz",
            error_click: "Kenderc'hel",
            id: "iD",
            josm: "JOSM",
            filter_date_1year: "1 bloaz",
            filter_user: "Implijer",
            filter_date_1month: "1 miz",
            filter_user_mypics: "Ma fotoio\xf9",
            filter_picture: "Seurt foto",
            semantics_download: "Pellgarga\xf1",
            filter_date_6months: "6 miz",
            picture_all: "An holl",
            metadata_camera: "Kamera",
            report_email: "Ho postel",
            report_submit: "Kinnig",
            semantics_doc: "Skoazell",
            metadata_summary: "Diverradenn",
            expand: "Brasaat",
            options: "Dibarzhio\xf9",
            show_map: "Diskwel ar gartenn",
            filters: "Silio\xf9",
            search_address: "Klask ur chomlec'h pe ur g\xear\u2026",
            share_rss: "Gwazh RSS",
            share_links: "Liammo\xf9",
            share_page: "Liamm ar foto",
            share_image: "Skeudenn HD",
            panoramax: "Panoramax",
            map_background: "Drekleur",
            map_background_streets: "Straedo\xf9",
            error: "Ur gudenn zo ganeomp\u2026",
            picture_360: "360\xb0",
            share_print: "Moulla\xf1",
            metadata_general_picid_link: "Mont d'an deskrivadur JSON eus ar foto",
            semantics_key: "Alc'hwez",
            "visibility_owner-only": "Kuzhet",
            semantics_value_show_osm: "Gwelout war OpenStreetMap",
            filter_gps_precision_between: "Etre {n1} ha {n2} metr",
            metadata_general_license: "Lisa\xf1s",
            share: "Ranna\xf1",
            copied: "Eilet",
            metadata_exif: "EXIF",
            "visibility_logged-only": "Izili",
            whats_panoramax: "Danvez geografel boutin evit poltriji an tiriado\xf9 eo Panoramax.",
            filter_locked: "Sil diweredekaet",
            map_background_default: "Dre ziouer",
            filter_source_local: "Ar servijer-ma\xf1",
            filter_source_world: "Bed a-bezh",
            map_theme_default_3: "Mat",
            metadata_general_title: "Titl",
            delete_picture: "Dilemel"
        },
        map: {
            more_panoramax: "Gouzout hiroc'h diwar-benn Panoramax",
            loading: "O karga\xf1\u2026"
        },
        psv: {
            twoFingers: "Implij daou viz evit kantreal"
        }
    },
    da: {
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "Placering ikke tilg\xe6ngelig",
            "GeolocateControl.FindMyLocation": "Find min placering"
        },
        pnx: {
            minimize: "Skjul dette modul, du kan vise det igen ved hj\xe6lp af knappen i nederste venstre hj\xf8rne",
            share_embed_docs: "L\xe6s mere om indlejringskonfiguration",
            zoom: "Zoom",
            zoomOut: "Zoom ud",
            zoomIn: "Zoom ind",
            moveUp: "Ryk opad",
            moveDown: "Ryk nedad",
            moveLeft: "Ryk til venstre",
            moveRight: "Ryk til h\xf8jre",
            moveMiddle: "Centreret visning",
            expand: "Udvid",
            expand_info: "F\xe5 modulet til at blive vist p\xe5 hele siden",
            show_psv: "Vis billedfremviseren",
            show_map: "Vis kortet",
            options: "Valgmuligheder",
            filters: "Filtre",
            layers: "Lag",
            search: "S\xf8g",
            search_empty: "Ingen resultater fundet",
            search_user: "S\xf8g efter et brugernavn\u2026",
            share: "Del",
            share_links: "Links",
            share_page: "Link til dette billede",
            share_image: "HD-billede",
            share_rss: "RSS-feed",
            share_rss_title: "RSS-feed med nye sekvenser i det aktuelt synlige kortomr\xe5de",
            share_embed: "Indlejr p\xe5 din hjemmeside",
            share_print: "Udskriv",
            copy: "Kopi\xe9r",
            copied: "Kopieret",
            error_retry: "Pr\xf8v igen senere",
            sequence_next: "N\xe6ste billede i sekvensen",
            sequence_play: "Afspil denne sekvens",
            sequence_more: "Flere afspilningsmuligheder",
            sequence_speed: "Afspillerens hastighed",
            legend_license: "Licens: {l}",
            legend_title: "Vis detaljer om billedet",
            error_click: "Forts\xe6t",
            error: "Vi har et problem\u2026",
            search_address: "S\xf8g efter en adresse, by, etc\u2026",
            sequence_pause: "S\xe6t sekvensen p\xe5 pause",
            sequence_prev: "Forrige billede i sekvensen",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Indl\xe6ser kortdata",
                "\uD83D\uDDA5\uFE0F Anmoder API",
                "\uD83D\uDDBC\uFE0F Indl\xe6ser thumbnails",
                "\uD83D\uDD0D Analyserer EXIF-metadata",
                "\uD83C\uDFD8\uFE0F 3D-rendering",
                "\uD83D\uDCF7 Initialiserer 360\xb0-billeder",
                "\uD83D\uDFE0 Farveafstemning",
                "\uD83D\uDCAF Beregning af kvalitetsscore \xa9",
                "\uD83D\uDCE1 Downloader opdateringer",
                "\uD83C\uDF0D Henter kortfliser",
                "\uD83D\uDCF8 Behandler skygger"
            ],
            edit_osm: "Rediger OSM",
            josm_live: "Aktiv\xe9r automatisk JOSM-synkronisering ved indl\xe6sning af billeder",
            loading_labels_fun: [
                "\uD83E\uDD8C Registrering af skilte om hjortekrydsning",
                "\uD83D\uDE98 S\xf8ger Panoramax Car \xa9",
                "\u2615 Injicerer koffein",
                "\uD83D\uDE00 Smil, du er blevet kortlagt!",
                "\uD83D\uDC08 Deler kattebilleder",
                "\uD83D\uDE34 Reducerer overspringshandlinger",
                "\uD83E\uDED6 Brygger te",
                "\uD83D\uDC27 \xc5bner kildekode",
                "\uD83D\uDE87 Indekser undergrundsstationer",
                "\uD83E\uDDF9 Ryd op i metadata",
                "\uD83D\uDE92 Sender billeder af brandstation",
                "\uD83D\uDEB2 Opdatering af cykelruter",
                "\uD83D\uDE89 G\xe5r ned ad perron p\xe5 station",
                "\uD83D\uDEF0\uFE0F S\xf8ger efter satellitter",
                "\uD83D\uDC65 Skriver personaer",
                "\uD83D\uDC1F Finder fish and chip butik",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Fejlfinder gr\xe6nseflade",
                "\uD83D\uDCC8 Inkrementelle statistikker",
                "\uD83E\uDD16 L\xe6rer semantik",
                "\uD83C\uDFA8 Redesign af gr\xe6nseflade",
                "\uD83D\uDCC5 Planl\xe6gning af foto-kortl\xe6gningsfester",
                "\uD83E\uDDC0 Modning af cheddars",
                "\uD83C\uDF04 Beregning af Cornwalls solskin",
                "\uD83C\uDF0A M\xe5ling af h\xf8jvande"
            ],
            error_psv: "Photo Sphere Viewer indl\xe6ses ikke korrekt",
            error_nopic: "Intet billede tilg\xe6ngeligt p\xe5 den givne position",
            error_api: "Billedserveren er ikke tilg\xe6ngelig",
            error_webgl: "WebGL underst\xf8ttes ikke af din browser",
            filter_date: "Dato",
            filter_date_1month: "1 m\xe5ned",
            filter_date_1year: "1 \xe5r",
            filter_user: "Bruger",
            filter_user_mypics: "Mine billeder",
            filter_picture: "Billedtype",
            filter_zoom_in: "Zoom ind for at l\xe5se op",
            picture_flat: "Klassisk",
            picture_360: "360\xb0",
            filter_qualityscore_help: "Klik for at aktivere eller deaktivere",
            map_background: "Kortbaggrund",
            map_background_aerial: "Luftfoto",
            map_background_streets: "Gader",
            map_theme: "Korttema",
            error_pic: "Det \xf8nskede billede blev ikke fundet",
            error_api_compatibility: "Billedserveren er ikke kompatibel med denne version af fremviseren",
            filter_qualityscore: "Kvalitetsscore",
            error_josm: "JOSM svarer ikke, k\xf8rer den, og er fjernstyring aktiveret?",
            metadata_general_seqid_link: "G\xe5 til JSON-beskrivelse af sekvensen",
            map_theme_default: "Klassisk",
            map_theme_age_1: "> 3 \xe5r",
            map_theme_age_2: "< 3 \xe5r",
            map_theme_age_3: "< 1 \xe5r",
            map_theme_age_4: "< 6 m\xe5ned",
            map_theme_type: "Kameratype",
            map_theme_score: "Kvalitetsscore",
            contrast: "Aktiv\xe9r h\xf8jere billedkontrast",
            metadata_general_picid: "Billede",
            metadata_general_seqid: "Sekvens",
            metadata_general_picid_link: "G\xe5 til JSON-beskrivelse af billedet",
            metadata_general_author: "Forfatter",
            metadata_general_license: "Licens",
            metadata_general_license_link: "Se den fulde licensbeskrivelse",
            metadata_general_date: "Optagelsesdato",
            metadata_camera: "Kamera",
            metadata_camera_make: "Fabrikat",
            metadata_camera_model: "Model",
            metadata_camera_type: "Type",
            metadata_camera_resolution: "Opl\xf8sning",
            metadata_camera_focal_length: "Br\xe6ndvidde",
            metadata_location_latitude: "Breddegrad",
            metadata_location_orientation: "Retning",
            metadata_location_precision: "Pr\xe6cision i positionering",
            metadata_quality: "Kvalitet",
            metadata_quality_score: "Global score",
            metadata_quality_gps_score: "Positioneringsscore",
            metadata_quality_help: "F\xe5 mere at vide om kvalitetsscore",
            map_theme_age: "Optagelsesdato",
            metadata_location: "Position",
            metadata: "Metadata for billede",
            metadata_location_longitude: "L\xe6ngdegrad",
            metadata_quality_resolution_score: "Opl\xf8sningsscore",
            metadata_quality_missing: "ingen v\xe6rdi indstillet i billedet",
            metadata_exif: "EXIF",
            metadata_exif_name: "Tag",
            metadata_exif_value: "V\xe6rdi",
            report: "Indberet",
            report_auth: 'Denne indberetning vil blive sendt via din konto "{a}"',
            report_nature_label: "Problemets \xe5rsag",
            report_nature: {
                "": "V\xe6lg problemets art\u2026",
                blur_missing: "En persons ansigt eller bils nummerplade er synlig",
                blur_excess: "Der blev anvendt un\xf8dvendig sl\xf8ring p\xe5 et objekt",
                inappropriate: "Billedet er upassende (ikke relevant, n\xf8genhed\u2026)",
                privacy: "Billedet er taget fra en privat sti eller ejendom",
                picture_low_quality: "Billedet er af lav kvalitet",
                mislocated: "Billedet er d\xe5rligt placeret p\xe5 kortet",
                copyright: "Billedet kr\xe6nker ophavsretten",
                other: "Enhver anden form for problem"
            },
            report_whole_sequence: "Det g\xe6lder hele sekvensen",
            report_details: "Yderligere detaljer",
            report_details_placeholder: "Du kan eventuelt tilf\xf8je detaljer om problemet",
            report_email: "Din e-mail",
            report_email_placeholder: "Valgfri",
            report_submit: "Indsend",
            report_wait: "Sender indberetning\u2026",
            report_success: "Indberetningen blev sendt. Den vil blive gennemg\xe5et hurtigst muligt.",
            report_failure: "Der opstod en fejl under oprettelse af indberetning: {e}. Pr\xf8v venligst igen senere.",
            qualityscore_title: "Om kvalitetsscoren",
            qualityscore_doc_2: "Scoren vises som et bogstav:",
            qualityscore_doc_3: '"A" er den bedste karakter, "E" den d\xe5rligste.',
            qualityscore_doc_link: "Yderligere oplysninger om kvalitetsscoren",
            qualityscore_doc_1: "Der beregnes en kvalitetsscore for hvert billede.",
            minimize_short: "Skjul",
            id: "iD",
            josm: "JOSM",
            metadata_general_instance: "Oprindelsesinstans",
            contribute_id: "Bidrag til OpenStreetMap med iD-editoren",
            geo_uri: "Ekstern app",
            picture_flat_long: "Klassisk billede",
            picture_360_long: "Panoramabillede",
            metadata_summary: "Opsummering",
            metadata_general_copy_id: "Kopi-ID",
            metadata_general_copy_picid: "Kopi\xe9r billed-ID",
            filter_date_6months: "6 m\xe5neder",
            picture_all: "Alle",
            panoramax: "Panoramax",
            semantics_send_ok: "Dine redigeringer blev indsendt",
            semantics_doc_info3: "Nogle objekter registreres automatisk med AI: kvaliteten er ikke garanteret.",
            semantics_doc_info1: "Giv kontekst for et billede ved hj\xe6lp af tags.",
            filter_gps_precision: "Placeringsn\xf8jagtighed",
            filter_gps_precision_lessthan: "Mindre {n} meter",
            filter_gps_precision_between: "Mellem {n1} og {n2} meter",
            filter_gps_precision_morethan: "Mere end {n} meter",
            map_theme_gps: "GPS-pr\xe6cision",
            metadata_location_copy: "Kopi\xe9r {v}",
            metadata_location_copy_more: "Flere muligheder for kopiering af koordinater",
            metadata_exif_doc: "Dok af EXIF-tags",
            semantics_editor_example: "key=v\xe6rdi\nprefix|key=v\xe6rdi",
            semantics_send_fail: "Kunne ikke gemme dine \xe6ndringer. Pr\xf8v igen senere",
            semantics_save: "Gem dine \xe6ndringer",
            semantics_edit: "Rediger egenskaber",
            semantics_undo: "Annuller dine \xe6ndringer",
            semantics_features: "Billedeobjekter",
            semantics_features_subtitle: "{nb} tilknyttede egenskaber",
            semantics_show_all_tags: "Vis alle tags",
            semantics_hide_all_tags: "Skjul alle tags",
            semantics_key: "N\xf8gle",
            semantics_title: "Tags",
            semantics_tags: "{nb} tags",
            semantics_value: "V\xe6rdi",
            semantics_key_doc: "F\xe5 mere at vide om denne n\xf8gle",
            semantics_annotation_tooltip: "Klik for at se detaljer",
            semantics_value_doc: "F\xe5 mere at vide om dette tag",
            semantics_qualifiers: "Kvalificerende",
            semantics_show_annotations: "Vis billedobjekter",
            semantics_doc_link: "F\xe5 mere at vide om tags",
            metadata_location_coordinates: "Koordinater (l\xe6ngdegrad, breddegrad)",
            whats_panoramax: "Panoramax er geo-commons for billeder af territorier.",
            semantics_features_none: "Der er endnu ikke tegnet nogen objekter p\xe5 dette billede.",
            semantics_wikidata_properties: {
                P361: "del af",
                P279: "underklasse af",
                P31: "instans af",
                P180: "afbilder"
            },
            metadata_exif_doc_title: "G\xe5 til Exiv2-dokumentationen for at f\xe5 alle detaljer om definitionerne af EXIF- og XMP-tags",
            semantics_features_default_title: "Tag {nb}",
            semantics_picture_tags: "Billed-tag",
            semantics_annotation_tags: "Objekt-tag",
            semantics_hide_annotations: "Skjul billedobjekter",
            semantics_sequence_tags: "Sekvens-tag",
            semantics_zero_annotations: "Ingen objekter tegnet p\xe5 dette billede",
            semantics_editor_error: "Syntaksen er ugyldig. Dine tags kan se s\xe5dan ud:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nDen maksimale n\xf8glel\xe6ngde er 256 tegn, den maksimale v\xe6rdil\xe6ngde er 2048 tegn.",
            semantics_delete_annotation: "Slet dette objekt",
            semantics_delete_annotation_confirm: "Vil du virkelig slette dette tag?",
            semantics_add_annotation: "Tilf\xf8j et nyt tag",
            semantics_draw_annotation: "Du kan tegne det objekt, du vil tilf\xf8je, over billedet (valgfrit).",
            semantics_login_needed: "For at redigere billedtags eller objekter skal du logge ind p\xe5 Panoramax {n} instance. Vil du logge ind?",
            semantics_doc: "Hj\xe6lp",
            semantics_doc_title: "Om tags",
            semantics_erase_annotation: "Slet tegnet objekt",
            semantics_doc_info2: "Du kan ogs\xe5 tegne objekter p\xe5 billedet: vejskilte, byudstyr\u2026 Mark\xe9r det, du ser, ved hj\xe6lp af eksisterende tags. Du kan ogs\xe5 oprette dine egne, hvis det er n\xf8dvendigt.",
            semantics_overlays: {
                tfsigns: "F\xe6rdselstavler",
                features: "Alle objekter"
            },
            semantics_zoom_in: "Zoom ind p\xe5 kortet for at se tags",
            semantics_download: "Download",
            semantics_download_title: "Download tags",
            semantics_download_cta: "Download open-data",
            semantics_download_info: "Alle semantiske data (tags) er tilg\xe6ngelige som \xe5bne data. Du kan downloade dem og bruge dem frit.",
            semantics_doc_info1u1: "Du kan tagge det som optaget fra bil med tagget transport=car.",
            semantics_copy: "Kopi\xe9r egenskaber",
            semantics_value_show_osm: "Se p\xe5 OpenStreetMap",
            popup_details_link: "Flere detaljer",
            qualityscore_doc_41: "GPS-pr\xe6cisionen",
            filter_gps_precision_help_4: 'En RTK GPS f\xe5r karakteren "5\u2B50" , et actionkamera som GoPro Max f\xe5r karakteren "3\u2B50", og en smartphone GPS i en underjordisk parkeringsk\xe6lder f\xe5r karakteren "1\u2B50".',
            filter_gps_precision_help_1: "Der er oplysninger om placeringspr\xe6cision tilg\xe6ngelige for hvert billede. Dette svarer til GPS-pr\xe6cision under billedoptagelsen.",
            filter_gps_precision_help_2: "Pr\xe6cisionen udtrykkes med stjerner:",
            filter_gps_precision_help: "F\xe5 mere at vide om placeringsn\xf8jagtighed",
            qualityscore_doc_4: "Denne score beregnes p\xe5 baggrund af:",
            qualityscore_doc_42: "billedopl\xf8sningen",
            qualityscore_doc_5: "Et professionelt kamera f\xe5r karakteren A, et 360\xb0-actionkamera f\xe5r karakteren B, og en smartphone f\xe5r en karakter mellem C og E.",
            filter_gps_precision_help_3: '"5\u2B50" er meget pr\xe6cis (<= {p5}m), "1\u2B50" er meget upr\xe6cis (> {p1}m) eller ukendt.',
            "visibility_logged-only": "Medlemmer",
            "visibility_title_logged-only": "Kun personer med en konto kan se dette billede",
            "visibility_owner-only": "Skjult",
            "visibility_title_owner-only": "Det er kun dig, der kan se dette billede",
            indoor_selector_shrink: "Klik for at minimere",
            indoor_switch: "Indend\xf8rs rum",
            indoor_selector_expand: "Klik for at se alle tilg\xe6ngelige niveauer",
            indoor_selector_levelup: "G\xe5 til \xf8verste niveau",
            indoor_selector_leveldown: "G\xe5 til nederste niveau",
            indoor_selector_scrollup: "Rul niveau-listen opad",
            indoor_selector_scrolldown: "Rul niveau-listen nedad",
            filter_source_world: "Hele verden",
            filter_source_local: "Denne server",
            filter_locked: "Filter deaktiveret",
            map_background_more: "Mere",
            map_background_default: "Standard",
            semantics_draw_invalid_annotation: "Det tegnede omr\xe5de g\xe5r ud over billedets gr\xe6nser. S\xf8rg for at tegne inden for det synlige billede.",
            semantics_draw_unfinished_annotation: "Det tegnede omr\xe5de er ikke f\xe6rdigt. S\xf8rg for, at omr\xe5det er placeret korrekt, inden du gemmer.",
            error_pic_load: "Billedet kan ikke indl\xe6ses i \xf8jeblikket.\nKontroller din internetforbindelse. Hvis du har forbindelse, skal du sikre dig, at billed-ID'et er gyldigt.",
            low_contrast: "Lavere billedkontrast",
            reset_contrast: "Nulstil billedkontrast",
            metadata_general_title: "Titel",
            delete_picture: "Slet",
            delete_picture_warn: "\u26A0\uFE0F Advarsel: Dette sletter billedet permanent.\nEr du sikker p\xe5, at du vil slette dette billede helt?",
            delete_picture_ok: "Billedet blev slettet",
            delete_picture_error: "Der opstod en fejl under fors\xf8get p\xe5 at slette billedet:\n{e}",
            semantics_empty: "Der er ikke defineret nogen tags",
            time_travel: "Se dette sted p\xe5 andre datoer",
            time_travel_close: "Skjul andre datoer",
            map_theme_default_short: "Standard",
            map_theme_age_short: "Dato",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Kvalitet",
            map_theme_gps_short: "Position"
        },
        psv: {
            loadError: "Panoramaet kan ikke indl\xe6ses",
            twoFingers: "Brug to fingre til at navigere",
            ctrlZoom: "Brug ctrl + scroll til at zoome ind p\xe5 billedet"
        },
        map: {
            loading: "Indl\xe6ser\u2026",
            thumbnail: "Miniature af billedet, der holdes",
            not_public: "Ikke offentligt synlig",
            slow_loading: "Kortet indl\xe6ses langsomt og kan virke defekt",
            map_data: "Kortdata: {m}",
            more_panoramax: "F\xe5 mere at vide om Panoramax"
        }
    },
    de: {
        pnx: {
            options: "Optionen",
            filters: "Filter",
            search: "Suche",
            layers: "Ebenen",
            share_links: "Links",
            share_page: "Link zu diesem Bild",
            loading_labels_fun: [
                '\uD83E\uDD8C Erkennung von "Reh kreuzt"-Schildern',
                "\uD83D\uDE98 Suche Panoramax-Auto \xa9",
                "\u2615 Koffeininjektion",
                "\uD83D\uDE00 L\xe4chle, du wurdest kartografiert!",
                "\uD83D\uDC08 Katzenfotos teilen",
                "\uD83D\uDE34 Vermeide Prokrastination",
                "\uD83C\uDF7A\uFE0F Bier brauen",
                "\uD83D\uDC27 Quellcode \xf6ffnen",
                "\uD83D\uDEE3\uFE0F Indizierung der Autobahnen",
                "\uD83E\uDDF9 Metadaten werden aufger\xe4umt",
                "\uD83D\uDE92 Sende Fotos von Feuerwachen",
                "\uD83D\uDEB2 Radwege werden aktualisiert",
                "\uD83D\uDE89 Bahnsteig wird abgelaufen",
                "\uD83D\uDEF0\uFE0F Satelliten werden gesucht",
                "\uD83D\uDC65 Personas anlegen",
                "\uD83C\uDF2D\uFE0F Orte n\xe4chsten Currywurst-Stand",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Fehlerbehebung wird ausgef\xfchrt",
                "\uD83D\uDCC8 Statistiken anpassen",
                "\uD83E\uDD16 Suche den Sinn des Lebens",
                "\uD83C\uDFA8 Benutzeroberfl\xe4che wird neu gestaltet",
                "\uD83D\uDCC5 Fotomapping-Partys planen",
                "\uD83E\uDDC0 Dem Emmentaler beim Reifen zuschauen",
                "\uD83C\uDF04 Sonnenstand berechnen",
                "\uD83C\uDF0A Messung der Gezeiten"
            ],
            search_empty: "Keine Ergebnisse gefunden",
            share: "Teilen",
            metadata_general_picid: "Bild",
            zoom: "Zoom",
            zoomOut: "Herauszoomen",
            zoomIn: "Hereinzoomen",
            moveUp: "Nach oben",
            moveDown: "Nach unten",
            moveRight: "Nach rechts",
            moveMiddle: "Sicht zentrieren",
            map_theme_age: "Aufnahmedatum",
            expand: "Ausklappen",
            expand_info: "Widget im Vollbild anzeigen",
            show_psv: "Bildbetrachter anzeigen",
            show_map: "Karte anzeigen",
            search_user: "Suche einen Nutzernamen\u2026",
            filter_zoom_in: "Vergr\xf6\xdfern, um freizuschalten",
            picture_flat: "Klassisch",
            picture_360: "360\xb0",
            filter_camera_model: "Nach Kameramodell",
            map_background: "Hintergrund",
            map_background_aerial: "Satelliten",
            map_background_streets: "Stra\xdfen",
            map_theme: "Thema",
            metadata_exif_name: "Tag",
            metadata_exif_value: "Wert",
            map_theme_type: "Kameratyp",
            contrast: "H\xf6heren Bildkontrast aktivieren",
            metadata: "Bildmetadaten",
            metadata_general_seqid: "Sequenz",
            metadata_general_picid_link: "Zur JSON-Beschreibung des Bildes wechseln",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Lade Kartendaten",
                "\uD83D\uDDA5\uFE0F API anfragen",
                "\uD83D\uDDBC\uFE0F Vorschaubilder laden",
                "\uD83D\uDD0D EXIF-Metadaten analysieren",
                "\uD83C\uDFD8\uFE0F 3D-Rendering",
                "\uD83D\uDCF7 360\xb0 Fotos initialisieren",
                "\uD83D\uDFE0 Farben ausgleichen",
                "\uD83D\uDCAF Berechne Quality Score \xa9",
                "\uD83D\uDCE1 Herunterladen von Updates",
                "\uD83C\uDF0D Lade Kartenausschnitte",
                "\uD83D\uDCF8 Bearbeitung der Schatten"
            ],
            search_address: "Suche eine Adresse oder Stadt etc\u2026",
            share_image: "HD-Bild",
            share_rss: "RSS-Feed",
            share_embed: "Auf Webseite einbetten",
            share_print: "Drucken",
            copy: "Kopieren",
            copied: "Kopiert",
            error: "Ein Fehler ist aufgetreten\u2026",
            sequence_next: "N\xe4chstes Foto in der Sequenz",
            sequence_play: "Sequenz abspielen",
            sequence_pause: "Sequenz pausieren",
            sequence_prev: "Vorheriges Foto in der Sequenz",
            sequence_more: "Mehr Abspieloptionen",
            sequence_speed: "Abspielgeschwindigkeit",
            legend_license: "Lizenz: {l}",
            edit_osm: "OSM editieren",
            id: "iD",
            josm: "JOSM",
            josm_live: "Einschalten der automatischen JOSM-Synchronisierung beim Laden eines Bildes",
            error_psv: "Betrachter f\xfcr die Photospheres wurde nicht richtig geladen",
            error_pic: "Das angefragte Foto wurde nicht gefunden",
            error_nopic: "Kein Foto an dieser Position verf\xfcgbar",
            error_api: "Foto-Server ist nicht erreichbar",
            error_josm: "JOSM reagierte nicht. Ist das Programm ge\xf6ffnet und die Remote-Verbindung aktiv?",
            error_api_compatibility: "Der Foto-Server ist nicht mit dieser Version des Betrachters kompatibel",
            filter_date: "Datum",
            filter_user: "Benutzer",
            filter_picture: "Art des Fotos",
            map_theme_default: "Klassisch",
            map_theme_age_1: "> 3 Jahre",
            map_theme_age_2: "< 3 Jahre",
            map_theme_age_3: "\xbd - 1 Jahr",
            map_theme_age_4: "< 6 Monat",
            metadata_general_seqid_link: "Zur JSON-Beschreibung der Sequenz wechseln",
            metadata_general_author: "Autor",
            metadata_general_license: "Lizenz",
            metadata_general_date: "Aufnahmedatum",
            metadata_camera: "Kamera",
            metadata_camera_make: "Hersteller",
            metadata_camera_model: "Modell",
            metadata_camera_type: "Typ",
            metadata_camera_focal_length: "Brennweite",
            metadata_location: "Position",
            metadata_location_longitude: "L\xe4ngengrad",
            metadata_location_latitude: "Breitengrad",
            metadata_location_orientation: "Richtung",
            metadata_location_precision: "Genauigkeit der Positionierung",
            metadata_exif: "EXIF",
            minimize: "Dieses Widget verbergen. Du kannst es \xfcber die Schaltfl\xe4che in der linken, unteren Ecke wieder einblenden",
            error_subtitle: "Bitte versuchen sie es sp\xe4ter erneut, oder schauen sie in die Web-Browser-Konsole f\xfcr mehr Details.",
            moveLeft: "Nach links",
            share_rss_title: "RSS-Feed neuer Sequenzen auf dem aktuell sichtbaren Kartenbereich",
            error_webgl: "WebGL wird von ihrem Browser nicht unterst\xfctzt",
            metadata_general_license_link: "Vollst\xe4ndige Lizenzbeschreibung anschauen",
            share_embed_docs: "Mehr \xfcber die Einbettungs-Konfiguration lesen",
            report_nature: {
                "": "Art des Problems ausw\xe4hlen\u2026",
                inappropriate: "Das Bild ist unangemessen (irrelevant, Nacktheit, ...)",
                picture_low_quality: "Das Bild hat eine niedrige Qualit\xe4t",
                blur_missing: "Das Gesicht einer Person oder ein KFZ-Kennzeichen ist sichtbar",
                blur_excess: "Ein Objekt wurde unkenntlich gemacht, obwohl es nicht erforderlich war",
                privacy: "Das Foto wurde von einem privaten Weg oder Grundst\xfcck aus aufgenommen",
                mislocated: "Das Bild ist falsch auf der Karte eingezeichnet",
                copyright: "Das Bild verst\xf6\xdft gegen das Urheberrecht",
                other: "Eine andere Art von Problem"
            },
            report_details_placeholder: "Du kannst optional Details \xfcber das Problem hinzuf\xfcgen",
            report_auth: 'Diese Meldung wird \xfcber dein Konto "{a}" gesendet',
            report_nature_label: "Ursache des Problems",
            report_whole_sequence: "Dies betrifft die gesamte Sequenz",
            report_details: "Weitere Details",
            report_email: "Deine Email-Adresse",
            report_email_placeholder: "Optional",
            report_submit: "Absenden",
            report_success: "Deine Meldung wurde erfolgreich gesendet. Sie wird so schnell wie m\xf6glich \xfcberpr\xfcft.",
            report_failure: "Bei der Erstellung der Meldung ist ein Fehler aufgetreten: {e}. Bitte versuche es sp\xe4ter erneut.",
            report: "Melden",
            legend_title: "Zeige Bilderdetails",
            report_wait: "Meldung wird gesendet\u2026",
            error_click: "Weiter",
            error_retry: "Bitte sp\xe4ter erneut versuchen",
            metadata_camera_resolution: "Aufl\xf6sung",
            filter_user_mypics: "Meine Fotos",
            metadata_quality_missing: "kein Wert im Foto gesetzt",
            filter_date_1month: "1 Monat",
            filter_date_1year: "1 Jahr",
            filter_qualityscore: "Qualit\xe4tswert",
            filter_qualityscore_help: "Zum Aktivieren oder Deaktivieren klicken",
            map_theme_score: "Qualit\xe4tswert",
            metadata_quality: "Qualit\xe4t",
            metadata_quality_help: "Erfahre mehr \xfcber den Qualit\xe4tswert",
            metadata_quality_resolution_score: "Bewertung der Aufl\xf6sung",
            metadata_quality_gps_score: "Bewertung der Position",
            metadata_quality_score: "Gesamtwertung",
            qualityscore_title: "\xdcber den Qualit\xe4tswert",
            qualityscore_doc_link: "Weitere Informationen zur Berechnung des Qualit\xe4tsfaktors findest du in unserer Dokumentation",
            qualityscore_doc_1: "F\xfcr jedes Bild wird ein Qualit\xe4tswert berechnet.",
            qualityscore_doc_2: "Die Punktzahl wird als Buchstabe angezeigt:",
            qualityscore_doc_3: "\u201EA\u201C ist die beste Note, \u201EE\u201C die schlechteste.",
            minimize_short: "Verbergen",
            semantics_features_none: "Bislang wurde kein Feature in diesem Bild markiert.",
            semantics_features_default_title: "Tag {nb}",
            semantics_features_subtitle: "{nb} assoziierte Eigenschaften",
            semantics_show_all_tags: "Alle Tags anzeigen",
            semantics_title: "Tags",
            semantics_tags: "{nb] Tags",
            semantics_features: "Features im Bild",
            semantics_hide_all_tags: "Alle Tags verbergen",
            semantics_annotation_tooltip: "Klicke, um Details zu sehen",
            semantics_key: "Schl\xfcssel",
            semantics_value: "Wert",
            semantics_key_doc: "Mehr \xfcber diesen Schl\xfcssel erfahren",
            semantics_value_doc: "Mehr \xfcber dieses Tag erfahren",
            semantics_tags_picture: "Foto-Schlagworte",
            semantics_tags_picture_none: "Bislang wurden keine Schlagworte f\xfcr dieses Foto gesetzt.",
            semantics_show_annotations: "Features im Bild anzeigen",
            semantics_hide_annotations: "Features im Bild verbergen",
            semantics_wikidata_properties: {
                P31: "Instanz von",
                P279: "Unterklasse von",
                P361: "Teil von",
                P180: "zeigt"
            },
            metadata_exif_doc: "Dokumentation der EXIF-Tags",
            metadata_exif_doc_title: "Wechsle zur Exiv2-Dokumentation f\xfcr eine vollst\xe4ndige Beschreibung von EXIF- und XMP-Tags",
            metadata_location_coordinates: "Koordinaten (L\xe4ngengrad, Breitengrad)",
            metadata_location_copy: "Kopiere {v}",
            metadata_location_copy_more: "Mehr Optionen zum Kopieren der Koordinaten",
            whats_panoramax: "Panoramax ist eine Geo-Commons f\xfcr Gebietsfotos.",
            picture_360_long: "Panoramafoto",
            metadata_summary: "Zusammenfassung",
            filter_date_6months: "6 Monate",
            picture_all: "Alle",
            picture_flat_long: "Klassisches Foto",
            metadata_general_instance: "Quell-Instanz",
            geo_uri: "Externe App",
            contribute_id: "Zu OpenStreetMap mit dem iD Editor beitragen",
            metadata_general_copy_id: "ID kopieren",
            metadata_general_copy_picid: "Kopiere Foto-ID",
            semantics_qualifiers: "Qualifikatoren",
            panoramax: "Panoramax",
            semantics_zero_annotations: "In diesem Bild wurden keine Features markiert",
            semantics_hashtags: "Bild-Hashtags",
            semantics_editor_error: "Die Syntax ist ung\xfcltig. Deine Tags sollten so aussehen:\nSchl\xfcssel=Wert\nPr\xe4fix|Schl\xfcssel=Wert\nPr\xe4fix|Schl\xfcssel[Qualif_Schl\xfcssel=Qualif_Wert]=Wert\n\nDie maximale L\xe4nge eines Schl\xfcssels betr\xe4gt 256 Zeichen, die eines Wertes betr\xe4gt 2048 Zeichen.",
            semantics_cantsave_invalid: "\xc4nderungen k\xf6nnen nicht angewendet werden, Eingabe ist ung\xfcltig",
            semantics_editor_example: "Schl\xfcssel=Wert\nPr\xe4fix|Schl\xfcssel=Wert",
            semantics_edit: "Attribute bearbeiten",
            semantics_save: "\xc4nderungen speichern",
            semantics_undo: "Bearbeitung abbrechen",
            semantics_send_fail: "\xc4nderungen k\xf6nnen nicht angewendet werden. Bitte versuche es sp\xe4ter noch einmal",
            semantics_send_ok: "\xc4nderungen wurden erfolgreich hochgeladen",
            semantics_save_drawn_annotation: "Position speichern",
            semantics_undo_drawn_annotation: "Abbrechen",
            semantics_save_drawn_annotation_incomplete: "Sie m\xfcssen vor der Validierung ein Rechteck dass in das Foto passt zeichnen",
            semantics_delete_annotation: "Dieses Feature l\xf6schen",
            semantics_delete_annotation_confirm: "M\xf6chtest du dieses Tag wirklich l\xf6schen?",
            semantics_add_annotation: "Neues Tag hinzuf\xfcgen",
            semantics_draw_annotation: "Du kannst ein Objekt im Bild markieren, um es hinzuzuf\xfcgen (optional).",
            semantics_login_needed: "Um Tags oder Features in Fotos zu bearbeiten, ist es erforderlich, in der Panoramax-Instanz {n} angemeldet zu sein. M\xf6chtest du dich anmelden?",
            semantics_doc_title: "\xdcber Tags",
            semantics_erase_annotation: "Markiertes Feature entfernen",
            semantics_doc_info1: "Stelle mittels Tags mehr Kontext zu einem Bild bereit.",
            semantics_doc: "Hilfe",
            semantics_doc_info3: "Einige Objekte werden automatisch mittels KI erkannt: Eine gute Erkennungsrate kann nicht garantiert werden.",
            semantics_doc_link: "Erfahre mehr \xfcber Tags",
            semantics_doc_info2: "Du kannst auch Objekte im Bild markieren: Verkehrszeichen, Stadtmobiliar\u2026 Nutze bestehende Tags, um zu markieren, was du siehst. Du kannst au\xdferdem, falls erforderlich, neue Tags erstellen.",
            semantics_sequence_tags: "Sequenz-Tag",
            semantics_picture_tags: "Bild-Tag",
            semantics_annotation_tags: "Objekt-Tag",
            filter_gps_precision: "Standortgenauigkeit",
            filter_gps_precision_lessthan: "Weniger als {n} Meter",
            filter_gps_precision_between: "Zwischen {n1} und {n2} Metern",
            filter_gps_precision_morethan: "Mehr als {n} Meter",
            map_theme_gps: "GPS-Genauigkeit",
            semantics_overlays: {
                tfsigns: "Verkehrszeichen",
                features: "Alle Features"
            },
            semantics_doc_info1u1: "Mit dem Tag transport=car kannst du markieren, dass es mit Hilfe eines Autos aufgenommen wurde.",
            semantics_zoom_in: "Vergr\xf6\xdfere die Karte, um die Tags zu sehen",
            semantics_download: "Herunterladen",
            semantics_download_title: "Tags herunterladen",
            semantics_download_info: "Alle semantischen Daten (Tags) sind als offene Daten verf\xfcgbar. Du kannst sie herunterladen und nach Belieben nutzen.",
            semantics_download_cta: "Open Data herunterladen",
            semantics_copy: "Attribute kopieren",
            semantics_value_show_osm: "Auf OpenStreetMap ansehen",
            filter_gps_precision_help_1: "Zu jedem Bild gibt es einen Wert der Standortgenauigkeit. Dieser entspricht der GPS-Genauigkeit beim Fotografieren.",
            filter_gps_precision_help_2: "Die Genauigkeit wird mit Sternchen angezeigt:",
            filter_gps_precision_help: "Mehr \xfcber Standortgenauigkeit erfahren",
            filter_gps_precision_help_3: "\u201E5\u2B50\u201C ist sehr genau (<= {p5}m), \u201E1\u2B50\u201C ist sehr ungenau (> {p1}m) oder unbekannt.",
            filter_gps_precision_help_4: "Ein RTK-GPS kriegt eine Bewertung von \u201E5\u2B50\u201C, eine Actionkamera wie die GoPro Max eine Bewertung von \u201E3\u2B50\u201C und ein Smartphone-GPS in einer Tiefgarage eine Bewertung von \u201E1\u2B50\u201C.",
            qualityscore_doc_41: "die GPS-Genauigkeit",
            qualityscore_doc_42: "die Bildaufl\xf6sung",
            qualityscore_doc_5: "Ein Profi-Ger\xe4t kriegt die Note A, eine 360\xb0-Actionkamera die Note B und ein Smartphone eine Note zwischen C und E.",
            qualityscore_doc_4: "Dieser Score wird berechnet anhand von:",
            popup_details_link: "Mehr Details",
            indoor_selector_expand: "Klicken, um alle verf\xfcgbaren Level zu sehen",
            indoor_selector_levelup: "Zum h\xf6heren Level gehen",
            indoor_selector_leveldown: "Zum niedrigeren Level gehen",
            indoor_selector_scrollup: "Level-Liste nach oben scrollen",
            indoor_selector_scrolldown: "Level-Liste nach unten scrollen",
            indoor_selector_shrink: "Zum Minimieren klicken",
            indoor_switch: "Innenr\xe4ume",
            "visibility_logged-only": "Mitglieder",
            "visibility_title_logged-only": "Nur Personen mit einem Konto k\xf6nnen dieses Bild sehen",
            "visibility_owner-only": "Versteckt",
            "visibility_title_owner-only": "Nur du kannst dieses Bild sehen",
            filter_source_world: "Gesamte Welt",
            filter_source_local: "Dieser Server",
            filter_locked: "Filter deaktiviert",
            map_background_more: "Mehr",
            map_background_default: "Standard",
            semantics_draw_unfinished_annotation: "Der gezeichnete Bereich ist noch nicht fertig. Vergewissere dich vor dem Speichern, dass der Bereich richtig positioniert ist.",
            semantics_draw_invalid_annotation: "Der gezeichnete Bereich reicht \xfcber den Bildrand hinaus. Bitte achte darauf, innerhalb des sichtbaren Bildbereichs zu zeichnen.",
            error_pic_load: "Dieses Bild kann derzeit nicht geladen werden.\nBitte \xfcberpr\xfcfe deine Internetverbindung. Wenn du verbunden bist, vergewissere dich, dass die Bild-ID g\xfcltig ist.",
            low_contrast: "Bildkontrast verringern",
            reset_contrast: "Bildkontrast zur\xfccksetzen",
            delete_picture: "L\xf6schen",
            delete_picture_warn: "\u26A0\uFE0F Achtung: Dadurch wird dieses Bild endg\xfcltig gel\xf6scht.\nBist du sicher, dass du weitermachen m\xf6chtest?",
            delete_picture_ok: "Das Bild wurde erfolgreich gel\xf6scht",
            delete_picture_error: "Beim Versuch, das Bild zu l\xf6schen, ist ein Fehler aufgetreten:\n{e}",
            semantics_empty: "Es wurden keine Tags definiert",
            metadata_general_title: "Titel",
            time_travel: "Diesen Ort an anderen Daten anzeigen",
            time_travel_close: "Andere Daten verbergen",
            map_theme_default_short: "Standard",
            map_theme_age_short: "Datum",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Qualit\xe4t",
            map_theme_gps_short: "Position",
            widget_locked: "Option deaktiviert",
            map_theme_default_coef_short: "Abdeckung",
            map_theme_default_1: "Niedrig",
            map_theme_default_2: "Durchschnittlich",
            map_theme_default_3: "Gut",
            map_theme_default_4: "Hervorragend",
            map_theme_default_coef: "Abdeckungsgrad",
            sequence_play_backwards: "Sequenz abspielen, r\xfcckw\xe4rts",
            semantics_annotation_tooltip_close: "Zum Abw\xe4hlen klicken"
        },
        psv: {
            twoFingers: "Nutze zwei Finger zum Navigieren",
            ctrlZoom: "Nutze Strg + Scrollen, um das Bild zu vergr\xf6\xdfern",
            loadError: "Das Panorama konnte nicht geladen werden"
        },
        map: {
            thumbnail: "Vorschau des markierten Fotos",
            not_public: "Nicht \xf6ffentlich sichtbar",
            loading: "Laden\u2026",
            slow_loading: "Die Karte l\xe4dt nur langsam und kann fehlerhaft erscheinen",
            map_data: "Kartendaten: {m}",
            more_panoramax: "Mehr \xfcber Panoramax erfahren"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Meinen Standort finden",
            "GeolocateControl.LocationNotAvailable": "Standort nicht verf\xfcgbar"
        }
    },
    el: {
        pnx: {
            sequence_next: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            zoom: "\u0395\u03C3\u03C4\u03AF\u03B1\u03C3\u03B7",
            zoomOut: "\u03A3\u03BC\u03AF\u03BA\u03C1\u03C5\u03BD\u03C3\u03B7",
            zoomIn: "\u039C\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7",
            moveLeft: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AC",
            moveRight: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03B4\u03B5\u03BE\u03B9\u03AC",
            expand: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7",
            show_psv: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AD\u03B1 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03CE\u03BD",
            show_map: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C7\u03AC\u03C1\u03C4\u03B7",
            minimize_short: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7",
            options: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2",
            search: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7",
            search_empty: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03AD\u03C3\u03BC\u03B1\u03C4\u03B1",
            search_user: "\u0391\u03BD\u03B1\u03B6\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7\u2026",
            share: "\u0394\u03B9\u03B1\u03BC\u03BF\u03B9\u03C1\u03B1\u03C3\u03BC\u03CC\u03C2",
            share_image: "HD \u0395\u03B9\u03BA\u03CC\u03BD\u03B1",
            share_rss: "RSS \u03C1\u03BF\u03AE",
            share_embed: "\u0395\u03BD\u03C3\u03C9\u03BC\u03AC\u03C4\u03C9\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03B9\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03CC \u03C3\u03B1\u03C2",
            share_print: "\u0395\u03BA\u03C4\u03CD\u03C0\u03C9\u03C3\u03B7",
            panoramax: "Panoramax",
            copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE",
            copied: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5",
            error: "\u0388\u03C7\u03BF\u03C5\u03BC\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1\u2026",
            error_click: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
            error_retry: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1",
            sequence_pause: "\u03A0\u03B1\u03CD\u03C3\u03B7 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            sequence_prev: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            sequence_more: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2",
            legend_license: "\u0386\u03B4\u03B5\u03B9\u03B1: {l}",
            legend_title: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03B5\u03C1\u03B5\u03B9\u03CE\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            id: "iD",
            sequence_play: "\u0391\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE \u03B1\u03C5\u03C4\u03AE\u03C2 \u03C4\u03B7\u03C2 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            geo_uri: "\u0395\u03BE\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03AE \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE",
            josm: "JOSM",
            report_wait: "\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C4\u03B7\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2\u2026",
            moveUp: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C0\u03AC\u03BD\u03C9",
            search_address: "\u0391\u03BD\u03B1\u03B6\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7, \u03C0\u03CC\u03BB\u03B7\u2026",
            share_links: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03B9",
            report_success: "\u0397 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B5\u03B9 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1. \u0398\u03B1 \u03B5\u03BB\u03B5\u03B3\u03C7\u03B5\u03AF \u03C4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03BD.",
            moveDown: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03BA\u03AC\u03C4\u03C9",
            filters: "\u03A6\u03AF\u03BB\u03C4\u03C1\u03B1",
            layers: "\u0395\u03C0\u03AF\u03C0\u03B5\u03B4\u03B1",
            share_page: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03C0\u03C1\u03BF\u03C2 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            share_embed_docs: "\u0394\u03B9\u03B1\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B4\u03B9\u03B1\u03BC\u03CC\u03C1\u03C6\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03BD\u03C3\u03C9\u03BC\u03AC\u03C4\u03C9\u03C3\u03B7\u03C2",
            sequence_speed: "\u03A4\u03B1\u03C7\u03CD\u03C4\u03B7\u03C4\u03B1 \u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2",
            report_submit: "\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE",
            semantics_overlays: {
                features: "\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1",
                tfsigns: "\u03A0\u03B9\u03BD\u03B1\u03BA\u03AF\u03B4\u03B5\u03C2 \u03C3\u03AE\u03BC\u03B1\u03BD\u03C3\u03B7\u03C2"
            },
            semantics_download: "\u039B\u03AE\u03C8\u03B7",
            semantics_download_title: "\u039B\u03AE\u03C8\u03B7 \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD",
            semantics_download_cta: "\u039B\u03AE\u03C8\u03B7 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03CE\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD",
            report_auth: '\u0391\u03C5\u03C4\u03AE \u03B7 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B8\u03B1 \u03B1\u03C0\u03BF\u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 "{a}"',
            semantics_save: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2",
            report_details: "\u03A0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B5\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2",
            report_failure: "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2: {e}. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1.",
            indoor_switch: "\u03A7\u03AC\u03C1\u03C4\u03B5\u03C2 \u03B5\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03BF\u03CD \u03C7\u03CE\u03C1\u03BF\u03C5",
            report_email: "\u03A4\u03BF email \u03C3\u03B1\u03C2",
            report_email_placeholder: "\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC",
            indoor_selector_shrink: "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B5\u03BB\u03B1\u03C7\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7",
            report: "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC",
            "visibility_logged-only": "\u039C\u03AD\u03BB\u03B7",
            indoor_selector_levelup: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF \u03CC\u03C1\u03BF\u03C6\u03BF",
            indoor_selector_leveldown: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C7\u03B1\u03BC\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF \u03CC\u03C1\u03BF\u03C6\u03BF",
            "visibility_owner-only": "\u039A\u03C1\u03C5\u03BC\u03BC\u03AD\u03BD\u03B7",
            "visibility_title_owner-only": "\u039C\u03CC\u03BD\u03BF \u03B5\u03C3\u03B5\u03AF\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1",
            report_details_placeholder: "\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B3\u03B9' \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03B6\u03AE\u03C4\u03B7\u03BC\u03B1",
            "visibility_title_logged-only": "\u039C\u03CC\u03BD\u03BF \u03AC\u03C4\u03BF\u03BC\u03B1 \u03BC\u03B5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03B4\u03BF\u03C5\u03BD \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1",
            indoor_selector_expand: "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C5\u03C2 \u03BF\u03C1\u03CC\u03C6\u03BF\u03C5\u03C2",
            picture_flat: "\u039A\u03BB\u03B1\u03C3\u03C3\u03B9\u03BA\u03AE",
            metadata: "\u039C\u03B5\u03C4\u03B1\u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            metadata_location_copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE {v}",
            metadata_general_copy_picid: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE ID \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_features: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_delete_annotation: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03B1\u03C5\u03C4\u03BF\u03CD \u03C4\u03BF\u03C5 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF\u03C5",
            metadata_general_seqid: "\u0391\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            map_theme_gps: "\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2",
            filter_gps_precision_help: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2",
            filter_picture: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            metadata_location_copy_more: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03C3\u03C5\u03BD\u03C4\u03B5\u03C4\u03B1\u03B3\u03BC\u03AD\u03BD\u03C9\u03BD",
            semantics_show_all_tags: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD",
            semantics_value_show_osm: "\u0394\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF OpenStreetMap",
            semantics_add_annotation: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03BD\u03AD\u03B1\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1\u03C2",
            semantics_wikidata_properties: {
                P279: "\u03C5\u03C0\u03BF\u03BA\u03BB\u03AC\u03C3\u03B7 \u03C4\u03BF\u03C5",
                P361: "\u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF \u03BC\u03AD\u03C1\u03BF\u03C2 \u03C4\u03BF\u03C5",
                P31: "\u03B5\u03AF\u03BD\u03B1\u03B9",
                P180: "\u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B9\u03C3\u03C4\u03AC"
            },
            semantics_delete_annotation_confirm: "\u03A3\u03AF\u03B3\u03BF\u03C5\u03C1\u03B1 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 ;",
            semantics_editor_error: "\u0397 \u03C3\u03CD\u03BD\u03C4\u03B1\u03BE\u03B7 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7. \u039F\u03B9 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03B1\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03BC\u03BF\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD \u03C9\u03C2:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\n\u03A4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03BC\u03AE\u03BA\u03BF\u03C2 \u03BA\u03BB\u03B5\u03B9\u03B4\u03B9\u03BF\u03CD \u03B5\u03AF\u03BD\u03B1\u03B9 256 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2, \u03C4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03BC\u03AE\u03BA\u03BF\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 2048 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.",
            semantics_undo: "\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2",
            semantics_send_fail: "\u0391\u03B4\u03CD\u03BD\u03B1\u03C4\u03B7 \u03B7 \u03B1\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1",
            report_nature: {
                picture_low_quality: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C7\u03B1\u03BC\u03B7\u03BB\u03AE\u03C2 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
                "": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03C6\u03CD\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2\u2026",
                blur_missing: "\u03A4\u03BF \u03C0\u03C1\u03CC\u03C3\u03C9\u03C0\u03BF \u03B5\u03BD\u03CC\u03C2 \u03B1\u03C4\u03CC\u03BC\u03BF\u03C5 \u03AE \u03B7 \u03C0\u03B9\u03BD\u03B1\u03BA\u03AF\u03B4\u03B1 \u03BA\u03C5\u03BA\u03BB\u03BF\u03C6\u03BF\u03C1\u03AF\u03B1\u03C2 \u03B5\u03BD\u03CC\u03C2 \u03BF\u03C7\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03C1\u03B1\u03C4\u03AC",
                privacy: "\u0388\u03BD\u03B1 \u03B9\u03B4\u03B9\u03C9\u03C4\u03B9\u03BA\u03CC \u03BC\u03BF\u03BD\u03BF\u03C0\u03AC\u03C4\u03B9 \u03AE \u03B9\u03B4\u03B9\u03BF\u03BA\u03C4\u03B7\u03C3\u03AF\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03C1\u03B1\u03C4\u03AC",
                mislocated: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C7\u03AC\u03BB\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
                copyright: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B2\u03B9\u03AC\u03B6\u03B5\u03B9 \u03C0\u03BD\u03B5\u03C5\u03BC\u03B1\u03C4\u03B9\u03BA\u03AC \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03B1",
                other: "\u039F\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03AC\u03BB\u03BB\u03BF \u03B5\u03AF\u03B4\u03BF\u03C2 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2",
                blur_excess: "\u0388\u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03C4\u03C4\u03CC \u03B8\u03CC\u03BB\u03C9\u03BC\u03B1 \u03B5\u03C6\u03B1\u03C1\u03BC\u03CC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF",
                inappropriate: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BA\u03B1\u03C4\u03AC\u03BB\u03BB\u03B7\u03BB\u03B7 (\u03AC\u03C3\u03C7\u03B5\u03C4\u03B7, \u03B3\u03CD\u03BC\u03BD\u03B9\u03B1\u2026)"
            },
            filter_source_world: "\u038C\u03BB\u03BF\u03C2 \u03BF \u03BA\u03CC\u03C3\u03BC\u03BF\u03C2",
            filter_source_local: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2",
            filter_date: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
            filter_date_1month: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
            filter_date_6months: "6 \u03BC\u03AE\u03BD\u03B5\u03C2",
            filter_date_1year: "1 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
            picture_360: "360\xb0",
            picture_flat_long: "\u039A\u03BB\u03B1\u03C3\u03C3\u03B9\u03BA\u03AE \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            filter_user: "\u03A7\u03C1\u03AE\u03C3\u03C4\u03B7\u03C2",
            filter_user_mypics: "\u039F\u03B9 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B5\u03C2 \u03BC\u03BF\u03C5",
            filter_locked: "\u03A6\u03AF\u03BB\u03C4\u03C1\u03BF \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF",
            filter_zoom_in: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BC\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BE\u03B5\u03BA\u03BB\u03B5\u03AF\u03B4\u03C9\u03BC\u03B1",
            picture_all: "\u038C\u03BB\u03B5\u03C2",
            filter_gps_precision: "\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2",
            picture_360_long: "\u03A0\u03B1\u03BD\u03BF\u03C1\u03B1\u03BC\u03B9\u03BA\u03AE \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            popup_details_link: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2",
            filter_qualityscore_help: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03AE \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7",
            filter_gps_precision_lessthan: "\u039B\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {n} \u03BC\u03AD\u03C4\u03C1\u03B1",
            filter_gps_precision_between: "\u039C\u03B5\u03C4\u03B1\u03BE\u03CD {n1} \u03BA\u03B1\u03B9 {n2} \u03BC\u03AD\u03C4\u03C1\u03C9\u03BD",
            filter_gps_precision_morethan: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {n} \u03BC\u03AD\u03C4\u03C1\u03B1",
            map_background_default: "\u03A0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE",
            filter_gps_precision_help_2: "\u0397 \u03B1\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03B5\u03BA\u03C6\u03C1\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BC\u03B5 \u03B1\u03C3\u03C4\u03AD\u03C1\u03B9\u03B1:",
            map_background_streets: "\u0394\u03C1\u03CC\u03BC\u03BF\u03B9",
            map_theme_age: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03C8\u03B7\u03C2",
            map_theme: "\u0398\u03AD\u03BC\u03B1 \u03C7\u03AC\u03C1\u03C4\u03B7",
            map_theme_default: "\u039A\u03BB\u03B1\u03C3\u03C3\u03B9\u03BA\u03CC",
            map_theme_age_1: "> 3 \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1",
            map_theme_age_2: "< 3 \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1",
            map_theme_age_3: "< 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
            map_theme_age_4: "< 6 \u03BC\u03AE\u03BD\u03B1",
            map_theme_type: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1\u03C2",
            metadata_general_date: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03C8\u03B7\u03C2",
            metadata_summary: "\u03A3\u03CD\u03BD\u03BF\u03C8\u03B7",
            metadata_general_copy_id: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE ID",
            metadata_general_picid: "\u0395\u03B9\u03BA\u03CC\u03BD\u03B1",
            metadata_general_author: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03CC\u03C2",
            metadata_general_license: "\u0386\u03B4\u03B5\u03B9\u03B1",
            metadata_general_license_link: "\u0394\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03AC\u03B4\u03B5\u03B9\u03B1\u03C2",
            metadata_general_instance: "\u0391\u03C1\u03C7\u03B9\u03BA\u03CC\u03C2 \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2",
            metadata_camera: "\u039A\u03AC\u03BC\u03B5\u03C1\u03B1",
            metadata_camera_model: "\u039C\u03BF\u03BD\u03C4\u03AD\u03BB\u03BF",
            metadata_camera_type: "\u03A4\u03CD\u03C0\u03BF\u03C2",
            metadata_camera_resolution: "\u0391\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7",
            metadata_location: "\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1",
            metadata_location_coordinates: "\u03A3\u03C5\u03BD\u03C4\u03B5\u03C4\u03B1\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 (\u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03BC\u03AE\u03BA\u03BF\u03C2, \u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C0\u03BB\u03AC\u03C4\u03BF\u03C2)",
            metadata_location_orientation: "\u039A\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7",
            metadata_location_precision: "\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2",
            metadata_quality: "\u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1",
            metadata_exif: "EXIF",
            metadata_exif_name: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1",
            metadata_exif_value: "\u03A4\u03B9\u03BC\u03AE",
            metadata_exif_doc: "\u03A4\u03B5\u03BA\u03BC\u03B7\u03C1\u03AF\u03C9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 EXIF",
            semantics_title: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            semantics_tags: "{nb} \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            semantics_features_none: "\u039A\u03B1\u03BD\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B1\u03BA\u03CC\u03BC\u03B7.",
            semantics_features_default_title: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 {nb}",
            semantics_hide_all_tags: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD",
            semantics_key: "\u039A\u03BB\u03B5\u03B9\u03B4\u03AF",
            semantics_value: "\u03A4\u03B9\u03BC\u03AE",
            semantics_sequence_tags: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            semantics_picture_tags: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_annotation_tags: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
            semantics_doc: "\u0392\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1",
            semantics_erase_annotation: "\u03A3\u03B2\u03AE\u03C3\u03B9\u03BC\u03BF \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF\u03C5",
            share_rss_title: "\u0397 RSS \u03C1\u03BF\u03AE \u03C4\u03C9\u03BD \u03BD\u03AD\u03C9\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03B9\u03CE\u03BD \u03C3\u03C4\u03B7\u03BD \u03C4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1 \u03BF\u03C1\u03B1\u03C4\u03AE \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03C4\u03BF\u03C5 \u03C7\u03AC\u03C1\u03C4\u03B7",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
                "\uD83D\uDDA5\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B5\u03C1\u03CE\u03C4\u03B7\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C2 \u03C4\u03BF API",
                "\uD83D\uDDBC\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BC\u03B9\u03BA\u03C1\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03CE\u03BD",
                "\uD83D\uDD0D \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BC\u03B5\u03C4\u03B1\u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD EXIF",
                "\uD83C\uDFD8\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 3D \u03B1\u03C0\u03B5\u03B9\u03BA\u03CC\u03BD\u03B9\u03C3\u03B7",
                "\uD83D\uDCF7 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C1\u03C7\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD 360\xb0",
                "\uD83D\uDFE0 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B9\u03C3\u03BF\u03C1\u03C1\u03CC\u03C0\u03B7\u03C3\u03B7 \u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD",
                "\uD83D\uDCAF \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C4\u03BF\u03C5 \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \xa9",
                "\uD83D\uDCE1 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BB\u03AE\u03C8\u03B7 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03B5\u03C9\u03BD",
                "\uD83C\uDF0D \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BB\u03AE\u03C8\u03B7 \u03C0\u03BB\u03B1\u03BA\u03B9\u03B4\u03AF\u03C9\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
                "\uD83D\uDCF8 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C3\u03BA\u03B9\u03CE\u03BD"
            ],
            josm_live: "\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03BF \u03C3\u03C5\u03B3\u03C7\u03C1\u03BF\u03BD\u03B9\u03C3\u03BC\u03CC \u03C4\u03BF\u03C5 JOSM \u03C3\u03C4\u03BF \u03C6\u03CC\u03C1\u03C4\u03C9\u03BC\u03B1 \u03C4\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD",
            metadata_exif_doc_title: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03C4\u03B5\u03BA\u03BC\u03B7\u03C1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03BF\u03C5 Exiv2 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03C0\u03BB\u03AE\u03C1\u03B5\u03B9\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2 \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD EXIF \u03BA\u03B1\u03B9 XMP",
            semantics_doc_info1u1: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BB\u03CE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03C4\u03C1\u03B1\u03B2\u03AE\u03C7\u03C4\u03B7\u03BA\u03B5 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03BF \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 transport=car.",
            error_pic_load: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03C9\u03B8\u03B5\u03AF \u03C4\u03CE\u03C1\u03B1.\n\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF \u0394\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF. \u0395\u03AC\u03BD \u03B5\u03AF\u03C3\u03C4\u03B5 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF\u03B9, \u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03C4\u03BF ID \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF.",
            qualityscore_doc_link: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            semantics_show_annotations: "\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_hide_annotations: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_zero_annotations: "\u039A\u03B1\u03BD\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            semantics_zoom_in: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BC\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            report_nature_label: "\u0391\u03B9\u03C4\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2",
            report_whole_sequence: "\u0391\u03C5\u03C4\u03CC \u03B1\u03C6\u03BF\u03C1\u03AC \u03BF\u03BB\u03CC\u03BA\u03BB\u03B7\u03C1\u03B7 \u03C4\u03B7\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            semantics_copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03B7\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD",
            semantics_edit: "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03B7\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD",
            semantics_login_needed: "\u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03AC\u03BD\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD \u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2, \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE {n} \u03C4\u03BF\u03C5 Panoramax. \u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 ;",
            moveMiddle: "\u039A\u03B5\u03BD\u03C4\u03C1\u03AC\u03C1\u03B9\u03C3\u03BC\u03B1 \u03B8\u03AD\u03B1\u03C3\u03B7\u03C2",
            expand_info: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03C4\u03BF \u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03BD\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03C3\u03C4\u03B5\u03AF \u03C3\u03B5 \u03C0\u03BB\u03AE\u03C1\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1",
            minimize: "\u039A\u03C1\u03CD\u03C8\u03C4\u03B5 \u03C4\u03BF \u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03C3\u03B5\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03C4\u03C9 \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AE \u03B3\u03C9\u03BD\u03AF\u03B1",
            contribute_id: "\u03A3\u03C5\u03BD\u03B5\u03B9\u03C3\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF OpenStreetMap \u03BC\u03B5 \u03C4\u03BF\u03BD \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03AE iD",
            error_psv: "\u03A4\u03BF Photo Sphere Viewer \u03B4\u03B5\u03BD \u03C6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03B9 \u03C3\u03C9\u03C3\u03C4\u03AC",
            error_api: "\u039F \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C2",
            error_api_compatibility: "\u039F \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BC\u03B2\u03B1\u03C4\u03CC\u03C2 \u03BC\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AD\u03B1",
            error_pic: "\u0397 \u03B6\u03B7\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5",
            error_nopic: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03C4\u03B7 \u03B4\u03BF\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1",
            error_webgl: "\u03A4\u03BF WebGL \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03C4\u03AE \u03C3\u03B1\u03C2",
            error_josm: "\u03A4\u03BF JOSM \u03B4\u03B5\u03BD \u03B1\u03BD\u03C4\u03B1\u03C0\u03BF\u03BA\u03C1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9, \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03B1 \u03B5\u03BA\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03B5\u03BB\u03AD\u03B3\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03BF\u03BC\u03B1\u03BA\u03C1\u03C5\u03C3\u03BC\u03AD\u03BD\u03B1;",
            qualityscore_doc_3: '"A" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1, "E" \u03B7 \u03C7\u03B5\u03B9\u03C1\u03CC\u03C4\u03B5\u03C1\u03B7.',
            filter_qualityscore: "\u03A3\u03BA\u03BF\u03C1 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            qualityscore_doc_2: "\u03A4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C9\u03C2 \u03AD\u03BD\u03B1 \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1:",
            qualityscore_doc_1: "\u0388\u03BD\u03B1 \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1.",
            qualityscore_doc_4: "\u03A4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B2\u03AC\u03C3\u03B5\u03B9:",
            qualityscore_doc_41: "\u03C4\u03B7\u03C2 \u03B1\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1\u03C2 \u03C4\u03BF\u03C5 GPS",
            qualityscore_doc_42: "\u03C4\u03B7\u03C2 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            map_theme_score: "\u03A3\u03BA\u03BF\u03C1 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            metadata_general_picid_link: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD JSON \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            metadata_general_seqid_link: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD JSON \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            metadata_camera_focal_length: "\u0395\u03C3\u03C4\u03B9\u03B1\u03BA\u03AE \u03B1\u03C0\u03CC\u03C3\u03C4\u03B1\u03C3\u03B7",
            metadata_quality_missing: "\u03B4\u03B5\u03BD \u03BF\u03C1\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C4\u03B9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            metadata_quality_help: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            metadata_quality_score: "\u03A0\u03B1\u03B3\u03BA\u03CC\u03C3\u03BC\u03B9\u03BF \u03C3\u03BA\u03BF\u03C1",
            metadata_quality_gps_score: "\u03A3\u03BA\u03BF\u03C1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2",
            metadata_quality_resolution_score: "\u03A3\u03BA\u03BF\u03C1 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7\u03C2",
            semantics_annotation_tooltip: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2",
            semantics_features_subtitle: "{nb} \u03C3\u03C5\u03C3\u03C7\u03B5\u03C4\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B9\u03B4\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2",
            semantics_doc_info1: "\u0394\u03CE\u03C3\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03B5\u03C7\u03CC\u03BC\u03B5\u03BD\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2.",
            semantics_doc_link: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            semantics_key_doc: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03BA\u03BB\u03B5\u03B9\u03B4\u03AF",
            semantics_value_doc: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1",
            semantics_qualifiers: "\u03A0\u03C1\u03BF\u03C3\u03B4\u03B9\u03BF\u03C1\u03B9\u03C3\u03C4\u03AD\u03C2",
            indoor_selector_scrollup: "\u03A3\u03BA\u03C1\u03BF\u03BB\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BF\u03C1\u03CC\u03C6\u03C9\u03BD \u03C0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03C0\u03AC\u03BD\u03C9",
            indoor_selector_scrolldown: "\u03A3\u03BA\u03C1\u03BF\u03BB\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BF\u03C1\u03CC\u03C6\u03C9\u03BD \u03C0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03BA\u03AC\u03C4\u03C9",
            semantics_draw_invalid_annotation: "\u0397 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B2\u03B3\u03B1\u03AF\u03BD\u03B5\u03B9 \u03B5\u03BA\u03C4\u03CC\u03C2 \u03BF\u03C1\u03AF\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2. \u0392\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03B6\u03B5\u03C4\u03B5 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03C4\u03B7\u03C2 \u03BF\u03C1\u03B1\u03C4\u03AE\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2.",
            qualityscore_doc_5: "\u039C\u03B9\u03B1 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 A, \u03BC\u03B9\u03B1 360\xb0 action camera \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 B, \u03BA\u03B1\u03B9 \u03AD\u03BD\u03B1 smartphone \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03BC\u03B5\u03C4\u03B1\u03BE\u03CD C \u03BA\u03B1\u03B9 E.",
            map_background_aerial: "\u0395\u03BD\u03B1\u03AD\u03C1\u03B9\u03BF",
            map_background_more: "\u0386\u03BB\u03BB\u03B1 \u03C5\u03C0\u03CC\u03B2\u03B1\u03B8\u03C1\u03B1...",
            semantics_draw_unfinished_annotation: "\u0397 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B7. \u0392\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03BB\u03AC \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C3\u03B5\u03C4\u03B5.",
            semantics_download_info: "\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03B7\u03BC\u03B1\u03C3\u03B9\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AC \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 (\u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2) \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03C9\u03C2 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AC \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03B1 \u03BA\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C4\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03C0\u03C9\u03C2 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5.",
            filter_gps_precision_help_4: '\u0388\u03BD\u03B1 RTK GPS \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 "5\u2B50", \u03BC\u03B9\u03B1 action camera \u03CC\u03C0\u03C9\u03C2 \u03B7 GoPro Max \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 "3\u2B50", \u03BA\u03B1\u03B9 \u03C4\u03BF GPS \u03B5\u03BD\u03CC\u03C2 smartphone \u03C3\u03B5 \u03C5\u03C0\u03CC\u03B3\u03B5\u03B9\u03BF \u03C0\u03AC\u03C1\u03BA\u03B9\u03BD\u03B3\u03BA \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 "1\u2B50".',
            filter_gps_precision_help_1: "\u039C\u03B9\u03B1 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B1 \u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1\u03C2 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1. \u0391\u03C5\u03C4\u03AE \u03B1\u03BD\u03C4\u03B9\u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C5 GPS \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03BB\u03AE\u03C8\u03B7 \u03C4\u03B7\u03C2 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1\u03C2.",
            map_background: "\u03A5\u03C0\u03CC\u03B2\u03B1\u03B8\u03C1\u03BF \u03C7\u03AC\u03C1\u03C4\u03B7",
            filter_gps_precision_help_3: '"5\u2B50" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 (<= {p5}m), "1\u2B50" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03BA\u03B5\u03C4\u03AC \u03B1\u03BD\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 (> {p1}m) \u03AE \u03AC\u03B3\u03BD\u03C9\u03C3\u03C4\u03B7.',
            contrast: "\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7\u03C2 \u03B1\u03BD\u03C4\u03AF\u03B8\u03B5\u03C3\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_doc_info3: "\u039C\u03B5\u03C1\u03B9\u03BA\u03AC \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03B1 \u03B5\u03BD\u03C4\u03BF\u03C0\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03BC\u03B5 AI: \u03B7 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03B3\u03B3\u03C5\u03B7\u03BC\u03AD\u03BD\u03B7.",
            semantics_doc_info2: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03C3\u03B5\u03C4\u03B5 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1: \u03C0\u03B9\u03BD\u03B1\u03BA\u03AF\u03B4\u03B5\u03C2 \u03C3\u03AE\u03BC\u03B1\u03BD\u03C3\u03B7\u03C2, \u03B1\u03C3\u03C4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03BE\u03BF\u03C0\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2\u2026 \u03A3\u03B7\u03BC\u03AC\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9 \u03B2\u03BB\u03AD\u03C0\u03B5\u03C4\u03B5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03C3\u03B5\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03B4\u03B9\u03BA\u03AD\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03AC\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03BF.",
            semantics_draw_annotation: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C0\u03AC\u03BD\u03C9 \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 (\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)."
        },
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03BC\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7",
            "GeolocateControl.FindMyLocation": "\u0392\u03C1\u03B5\u03C2 \u03C4\u03B7\u03BD \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03BC\u03BF\u03C5"
        },
        map: {
            loading: "\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u2026",
            more_panoramax: "\u0391\u03BD\u03B1\u03BA\u03B1\u03BB\u03CD\u03C8\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF Panoramax",
            map_data: "\u03A7\u03AC\u03C1\u03C4\u03B7\u03C2 \u03B2\u03B1\u03C3\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C3\u03C4\u03BF {m}",
            thumbnail: "\u039C\u03B9\u03BA\u03C1\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B4\u03B5\u03B9\u03BA\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            slow_loading: "\u039F \u03C7\u03AC\u03C1\u03C4\u03B7\u03C2 \u03B1\u03C1\u03B3\u03B5\u03AF \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03CE\u03C3\u03B5\u03B9 \u03BA\u03B1\u03B9 \u03C0\u03B9\u03B8\u03B1\u03BD\u03CC\u03BD \u03BD\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C7\u03B1\u03BB\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2",
            not_public: "\u038C\u03C7\u03B9 \u03B4\u03B7\u03BC\u03CC\u03C3\u03B9\u03B1 \u03BF\u03C1\u03B1\u03C4\u03AE"
        },
        psv: {
            twoFingers: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03B4\u03AC\u03C7\u03C4\u03C5\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03BB\u03BF\u03B7\u03B3\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5",
            ctrlZoom: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 Ctrl + \u03C3\u03BA\u03C1\u03BF\u03BB\u03AC\u03C1\u03B9\u03C3\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03B6\u03BF\u03C5\u03BC \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            loadError: "\u03A4\u03BF \u03C0\u03B1\u03BD\u03CC\u03C1\u03B1\u03BC\u03B1 \u03B4\u03B5\u03BD \u03BC\u03C0\u03CC\u03C1\u03B5\u03C3\u03B5 \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03C9\u03B8\u03B5\u03AF"
        }
    },
    eo: {
        psv: {
            twoFingers: "Uzu du fingrojn por navigi",
            ctrlZoom: "Uzu ctrl + rulumo por zomi la bildon",
            loadError: "La bildo ne povas esti \u015Dar\u011Dita"
        },
        pnx: {
            zoom: "Zomo",
            zoomOut: "Malzomo",
            zoomIn: "Zomi",
            moveUp: "Movi supren",
            moveDown: "Movi malsupren",
            moveLeft: "Movi maldekstren",
            moveRight: "Movi dekstren",
            moveMiddle: "Centri vido",
            expand: "Pligrandigi",
            expand_info: "Aperigu la fenestra\u0135on en plena pa\u011Do",
            show_psv: "Montri la bildspektilo",
            show_map: "Montri la mapo",
            minimize: "Maski la fenestra\u0135o, vu povas montri \u011Din denove kun la butono en malsupra maldekstra angulo",
            sequence_prev: "Anta\u016Da foto en la sekvenco",
            sequence_more: "Pli da ludopcioj",
            sequence_speed: "Rapideco de legado",
            sequence_next: "Sekva foto en la sekvenco",
            sequence_play: "Foliumi \u0109i tiun sinsekvon",
            sequence_pause: "Pa\u016Dzi la sekvenco",
            copy: "Kopii",
            copied: "Kopiita",
            error: "Ni havas problemon\u2026",
            error_click: "Kontinui",
            error_retry: "Bonvolu reprovi poste",
            search_address: "Ser\u0109i adreson, urbon\u2026",
            filters: "Filtriloj",
            layers: "Tavoloj",
            search: "Ser\u0109i",
            share_embed_docs: "Pli pri enigito sur via retpa\u011Daro",
            search_empty: "Neniu rezulto trovita",
            search_user: "Ser\u0109i uzantnomon\u2026",
            share: "Kunhavigi",
            share_links: "Ligiloj",
            share_page: "Ligilo de la foto",
            share_image: "HD bildo",
            share_rss: "RSS abonfluo",
            share_rss_title: "RSS abonfluo de la novaj sekvecoj en la nuntempe videbla mapzono",
            share_embed: "Enigita en via retpa\u011Daro",
            share_print: "Presi",
            edit_osm: "Modifi OSM",
            legend_license: "Rajtigilo : {l}",
            josm_live: "Ebligas a\u016Dtomatan JOSM-sinkronigon dum \u015Dar\u011Do de bildo",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u015Cargo de la bazmapon",
                "\uD83D\uDDA5\uFE0F API demandado",
                "\uD83D\uDDBC\uFE0F \u015Car\u011Do de miniaturoj",
                "\uD83D\uDD0D Analizo de EXIF-metadatumoj",
                "\uD83C\uDFD8\uFE0F 3D-rendumo",
                "\uD83D\uDCF7 Inico de 360\xb0-bildoj",
                "\uD83D\uDFE0 Kolora ekvilibrigo",
                "\uD83D\uDCAF Kalkulo de kvalitpoentaro \xa9",
                "\uD83D\uDCE1 El\u015Dutante \u011Disdatoj",
                "\uD83C\uDF0D Reakirante mapkaheloj",
                "\uD83D\uDCF8 Traktadante ombroj"
            ],
            legend_title: "Montri la detaloj de la bildo",
            error_api: "La bildservilo ne estas disponebla",
            error_josm: "JOSM ne respondis. \u0108u \u011Di funkcias kaj la regilo estas \u015Daltita?",
            error_webgl: "WebGL ne estas subtenata per via retumilo",
            loading_labels_fun: [
                "\uD83E\uDD8C Detekto de cervinaj vojmontriloj",
                "\uD83D\uDE98 Ser\u0109o de Panoramax-a\u016Dto \xa9",
                "\u2615 Injekto de kafeino",
                "\uD83D\uDE00 Ridetu, vi estas mapita!",
                "\uD83D\uDC08 Kunhavigo de katbildoj",
                "\uD83D\uDE34 Redukto de prokrastado",
                "\uD83D\uDCD6 Lernado de Esperanto",
                "\uD83D\uDC27 Malfermo de fontkodo",
                "\uD83D\uDE87 Indekso de subteraj stacioj",
                "\uD83E\uDDF9 Purigo de metadatumoj",
                "\uD83D\uDE92 Sendado de fotoj de fajrostacioj",
                "\uD83D\uDEB2 \u011Cisdatigo de verdaj vojoj",
                "\uD83D\uDE89 Promenado tra stacioplatformoj",
                "\uD83D\uDEF0\uFE0F Ser\u0109o de satelitoj",
                "\uD83D\uDC65 Verkado de roluloj",
                "\u2747\uFE0F Lokalizo de la Esperanto-flagoj",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Sencimigado de la interfaco",
                "\uD83D\uDCC8 Alkrementi de la statistikoj",
                "\uD83E\uDD16 Lernadante semantiko",
                "\uD83C\uDFA8 Interfaca redezajno",
                "\uD83D\uDCC5 Planante fota-mapa-festoj",
                "\uD83E\uDDC0 Finmaturigo de la froma\u011Doj",
                "\uD83C\uDF04 Kalkulante la sunbrilon de la Saharo",
                "\uD83C\uDF0A Mezurado de la altaj tajdoj"
            ],
            picture_360: "360\xb0",
            picture_flat: "Klasika",
            report_nature_label: "Speco de problemo",
            report_nature: {
                "": "Elektu la specon de problemo\u2026",
                blur_missing: "Viza\u011Do a\u016D numerplato estas videbla",
                copyright: "La bildo malobeas kopirajton",
                blur_excess: "Objekto kiu ne bezonis malklari\u011Don estas malklarigita",
                inappropriate: "La bildo estas neta\u016Dga (nevera, nudeco...)",
                privacy: "Privata vojo a\u016D poseda\u0135o estas videbla",
                picture_low_quality: "La bildo estas de tre malbona kvalito",
                mislocated: "La bildo estas malbone poziciigita sur la mapo",
                other: "\u0108ia alia speco de problemo"
            },
            report: "Raporti",
            report_auth: '\u0108i tiu raporto estos sendita per via konto "{a}"',
            filter_date: "Dato",
            filter_user_mypics: "Miaj fotoj",
            options: "Opcioj",
            error_api_compatibility: "La fotoservilo ne kongruas kun \u0109i tiu spektilo",
            filter_qualityscore: "Kvalitpoentaro",
            filter_qualityscore_help: "Alllaku por aktivigi a\u016D mal\u015Dalti",
            map_theme_age: "Dato de fotado",
            map_theme_age_1: "> 3 jaroj",
            map_theme_age_2: "< 3 jaroj",
            map_theme_age_3: "< 1 jaro",
            map_theme_age_4: "< 6 monato",
            map_theme_score: "Kvalitpoentaro",
            metadata: "Metadatenoj de la bildo",
            map_theme_type: "Fotiltipo",
            metadata_general_seqid: "Sekvenco",
            metadata_camera_resolution: "Difino",
            metadata_quality_resolution_score: "Rezolucia poentaro",
            error_psv: "Foto-Sfera Spektilo ne \u015Dar\u011Di\u011Das \u011Duste",
            error_pic: "La petita bildo ne estis trovita",
            error_nopic: "Neniu bildo disponeblas \u0109e la donita pozicio",
            filter_user: "Uzanto",
            map_theme_default: "Klasika",
            filter_date_1month: "1 monato",
            filter_date_1year: "1 jaro",
            contrast: "Pliigi bildkontraston",
            metadata_general_picid: "Foto",
            filter_picture: "Bilda tipo",
            filter_zoom_in: "Zomu en la mapo por vidi",
            map_background: "Bazmapo",
            map_background_aerial: "Aera",
            map_background_streets: "Stratoj",
            map_theme: "Mapa etoso",
            metadata_general_picid_link: "Iru al la JSON-priskribo de la foto",
            metadata_general_seqid_link: "Iru al la JSON-priskribo de la sekvenco",
            metadata_general_author: "A\u016Dtoro",
            metadata_general_license: "Rajtigilo",
            metadata_general_license_link: "Vidi la kompletan rajtigilon en la priskribo",
            metadata_general_date: "Dato de la fotado",
            metadata_camera: "Fotilo",
            metadata_camera_make: "Faristo",
            metadata_camera_model: "\u015Cablono",
            metadata_camera_type: "Tipo",
            metadata_camera_focal_length: "Fokuslongo",
            metadata_location: "Pozicio",
            metadata_location_longitude: "Longitudo",
            metadata_location_latitude: "Latitudo",
            metadata_location_orientation: "Direkto",
            metadata_location_precision: "Pozicia precizeco",
            metadata_quality: "Kvalito",
            metadata_quality_help: "Pli pri la Kvalitapoentaro",
            metadata_quality_score: "Malloka poentaro",
            metadata_quality_gps_score: "Pozicia poentaro",
            metadata_quality_missing: "neniu valoro en la bildo",
            metadata_exif: "EXIF",
            metadata_exif_name: "Etikedo",
            metadata_exif_value: "Valoro",
            report_whole_sequence: "\u0108i tio koncernas la tutan sekvencon",
            report_details: "Aliaj detaloj",
            report_email: "Via retpo\u015Dto",
            report_submit: "Sendi",
            report_wait: "Sendante raporton\u2026",
            report_success: "La raporto estis sukcese sendita. \u011Ci estos reviziita balda\u016D.",
            report_details_placeholder: "Opcie, vi povas aldoni detalojn pri la problemo",
            report_email_placeholder: "Opcie",
            report_failure: "Eraro okazis dum kreo de la raporto: {e}. Bonvolu provi denove poste.",
            qualityscore_doc_3: '"A" estas la plej bona noto, "E" la plej malbona.',
            qualityscore_title: "Pri la kvalita poentaro",
            qualityscore_doc_1: "Kvalitan Poentaron estas kalkulita por \u0109iu bildo.",
            qualityscore_doc_link: "Pli da detaloj pri la kalkulo de la Kvalita Poentaro estas disponeblaj en nia dokumentado",
            minimize_short: "Maski",
            qualityscore_doc_2: "La Poentaro estas montrita kiel litero :",
            id: "iD",
            josm: "JOSM",
            contribute_id: "Kontribuu al OpenStreetMap kun iD-modifilo",
            filter_date_6months: "6 monatoj",
            picture_all: "\u0108iuj",
            picture_flat_long: "Klasika foto",
            picture_360_long: "Panorama foto",
            metadata_summary: "Resumo",
            metadata_general_copy_id: "Kopii la ID-on",
            metadata_general_copy_picid: "Kopii la fotan ID-on",
            metadata_general_instance: "Origina instanco",
            geo_uri: "Ekseteraj aplika\u0135oj",
            semantics_title: "Etikedoj",
            semantics_tags: "{nb} etikedoj",
            semantics_features: "Detektitaj objektoj",
            semantics_features_none: "No objekto estis ankora\u016D detektita a\u016D prinotita en \u0109i tiu foto.",
            semantics_features_default_title: "Objekto #{nb}",
            metadata_exif_doc: "Dokumentoj por EXIF-etikedoj",
            metadata_exif_doc_title: "Iru al la dokumentaro de Exiv2 por havi plenajn detalojn pri difinoj de EXIF kaj XMP-etikedoj",
            metadata_location_coordinates: "Koordinatoj (longitudo, latitudo)",
            metadata_location_copy: "Kopii {v}",
            metadata_location_copy_more: "Pli da ebloj por kopii koordinatojn",
            whats_panoramax: "Panoramax estas la geokomuna\u0135o por teritoriaj fotoj.",
            semantics_features_subtitle: "{nb} asociitaj atributoj",
            semantics_tags_picture_none: "Ankora\u016D neniuj atributoj estas difinitaj por \u0109i tiu foto.",
            semantics_hide_all_tags: "Maski la atributojn",
            semantics_key: "\u015Closilo",
            semantics_value: "Valoro",
            semantics_show_all_tags: "Vidi \u0109iujn atributojn",
            semantics_tags_picture: "Foto-atributoj",
            semantics_value_doc: "Lernu pli pri \u0109i tiu atributo",
            semantics_qualifiers: "Kvalifikiloj",
            semantics_hide_annotations: "Maski bildajn komentojn",
            semantics_wikidata_properties: {
                P279: "subklaso de",
                P361: "parto de",
                P31: "instanco de"
            },
            share_picture: "Foto",
            semantics_annotation_tooltip: "Alklaku por vidi la detalojn",
            semantics_show_annotations: "Montri bildajn komentojn",
            semantics_key_doc: "Lernu pli pri \u0109i tiu \u015Dlosilo",
            filter_gps_precision: "Lokprecizeco",
            filter_gps_precision_lessthan: "Malpli ol {n} metroj",
            filter_gps_precision_between: "Inter {n1} kaj {n2} metroj",
            popup_details_link: "Pli da detaloj",
            filter_gps_precision_morethan: "Pli ol {n} metroj",
            panoramax: "Panoramax",
            error_pic_load: "La foto ne povis al\u015Duti\u011Di.\nBonvolu kontroli vian interretan konekton. Se vi estas konektita, bonvolu kontroli, ke la fotidentilo estas valida.",
            filter_locked: "Filtrilo malaktivigita",
            qualityscore_doc_4: "\u0108i tiu poentaro estas kalkulata jene:",
            qualityscore_doc_41: "la GPS-precizeco",
            qualityscore_doc_42: "la difino de la foto",
            qualityscore_doc_5: "Profesia ekipa\u0135o ricevos gradon A, 360\xb0 ago-kamerao ricevos gradon B, kaj inteligenta telefono ricevos gradon inter C kaj E.",
            filter_source_world: "Tuta mondo",
            filter_source_local: "Tiu servilo"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Trovi mian pozicion",
            "GeolocateControl.LocationNotAvailable": "Loko ne disponeblas"
        },
        map: {
            slow_loading: "La mapo \u015Dar\u011Das malrapide kaj povus aperi rompi\u011Dinta",
            loading: "\u015Car\u011Danto\u2026",
            thumbnail: "Miniaturo de la surflikta bildo",
            not_public: "Ne publike videbla",
            more_panoramax: "Malkovri pli pri Panoramax",
            map_data: "Kartaj datumoj : {m}"
        }
    },
    en: $a42f1354f0348298$var$bx,
    es: {
        pnx: {
            report_auth: 'Esta denuncia se enviar\xe1 usando tu cuenta "{a}"',
            report: "Denunciar",
            report_nature_label: "Causa del problema",
            report_nature: {
                "": "Selecciona la naturaleza del problema\u2026",
                blur_missing: "La cara de una persona o la matr\xedcula de un auto es visible",
                blur_excess: "Se aplic\xf3 un difuminado innecesario a un objeto",
                inappropriate: "La imagen es inapropiada (no relacionada, desnudez\u2026)",
                privacy: "Un camino o propiedad privada es visible",
                mislocated: "La imagen est\xe1 mal posicionada en el mapa",
                picture_low_quality: "La imagen es de baja calidad",
                copyright: "La imagen infringe derechos de autor",
                other: "Cualquier otro tipo de problema"
            },
            sequence_more: "M\xe1s opciones de reproducci\xf3n",
            sequence_speed: "Velocidad de reproducci\xf3n",
            legend_license: "Licencia: {l}",
            edit_osm: "Editar OpenStreetMap",
            id: "iD",
            josm: "JOSM",
            josm_live: "Habilitar sincronizaci\xf3n autom\xe1tica de JOSM al cargar imagen",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Cargando datos del mapa",
                "\uD83D\uDDA5\uFE0F Consultando API",
                "\uD83D\uDDBC\uFE0F Cargando miniaturas",
                "\uD83D\uDD0D Analizando metadatos EXIF",
                "\uD83C\uDFD8\uFE0F Renderizado 3D",
                "\uD83D\uDCF7 Inicializando im\xe1genes 360\xb0",
                "\uD83D\uDFE0 Balanceando color",
                "\uD83D\uDCAF Calculando nivel de calidad \xa9",
                "\uD83D\uDCE1 Descargando actualizaciones",
                "\uD83C\uDF0D Obteniendo teselas del mapa",
                "\uD83D\uDCF8 Procesando sombras"
            ],
            metadata: "Metadatos de la imagen",
            map_theme_type: "Tipo de c\xe1mara",
            contrast: "Habilitar mayor contraste de imagen",
            zoom: "Zoom",
            zoomOut: "Alejar",
            map_background_streets: "Calles",
            loading_labels_fun: [
                "\uD83E\uDD8C Detectando se\xf1ales de cruce de venados",
                "\uD83D\uDE98 Buscando el Auto Panoramax \xa9",
                "\u2615 Inyectando cafe\xedna",
                "\uD83D\uDE00 \xa1Sonr\xede, est\xe1s en el mapa!",
                "\uD83D\uDC08 Compartiendo fotos de gatos",
                "\uD83D\uDE34 Reduciendo la procrastinaci\xf3n",
                "\uD83E\uDED6 Preparando el t\xe9",
                "\uD83D\uDC27 Abriendo el c\xf3digo fuente",
                "\uD83D\uDE87 Indexando estaciones de metro",
                "\uD83E\uDDF9 Limpiando metadatos",
                "\uD83D\uDE92 Enviando fotos de estaciones de bomberos",
                "\uD83D\uDEB2 Actualizando v\xedas verdes",
                "\uD83D\uDE89 Paseo por el and\xe9n de la estaci\xf3n",
                "\uD83D\uDEF0\uFE0F Buscando sat\xe9lites",
                "\uD83D\uDC65 Escribiendo perfiles de usuario",
                "\uD83D\uDC1F Localizando puestos de papas fritas",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Depurando la interfaz",
                "\uD83D\uDCC8 Incrementando estad\xedsticas",
                "\uD83E\uDD16 Aprendiendo sem\xe1ntica",
                "\uD83C\uDFA8 Redise\xf1ando interfaz",
                "\uD83D\uDCC5 Planificando fiestas de foto-mapeo",
                "\uD83E\uDDC0 Madurando quesos",
                "\uD83C\uDF04 Calculando la luz solar de Cornualles",
                "\uD83C\uDF0A Midiendo las mareas altas"
            ],
            metadata_general_license_link: "Ver la descripci\xf3n completa de la licencia",
            metadata_general_picid: "Imagen",
            metadata_general_license: "Licencia",
            report_details_placeholder: "Opcionalmente, puedes a\xf1adir detalles sobre el problema",
            expand: "Expandir",
            expand_info: "Mostrar el elemento en p\xe1gina completa",
            show_psv: "Mostrar el visor de im\xe1genes",
            show_map: "Mostrar el mapa",
            zoomIn: "Acercar",
            moveUp: "Mover hacia arriba",
            moveDown: "Mover hacia abajo",
            moveLeft: "Mover a la izquierda",
            moveRight: "Mover a la derecha",
            moveMiddle: "Centrar vista",
            minimize: "Ocultar este elemento, puedes mostrarlo de nuevo usando el bot\xf3n en la esquina inferior izquierda",
            options: "Opciones",
            filters: "Filtros",
            layers: "Capas",
            search: "Buscar",
            search_empty: "No se encontraron resultados",
            search_address: "Buscar una direcci\xf3n, ciudad\u2026",
            search_user: "Buscar un nombre de usuario\u2026",
            share: "Compartir",
            share_links: "Enlaces",
            share_page: "Enlace a esta imagen",
            share_image: "Imagen HD",
            share_rss: "Feed RSS",
            share_rss_title: "Feed RSS de nuevas secuencias en el \xe1rea del mapa visible actualmente",
            share_embed: "Incrustar en tu sitio web",
            share_embed_docs: "Leer m\xe1s sobre la configuraci\xf3n de incrustaci\xf3n",
            share_print: "Imprimir",
            copy: "Copiar",
            copied: "Copiado",
            error: "Tenemos un problema\u2026",
            sequence_next: "Siguiente imagen en la secuencia",
            sequence_play: "Reproducir esta secuencia",
            sequence_pause: "Pausar secuencia",
            sequence_prev: "Imagen anterior en la secuencia",
            error_click: "Continuar",
            error_retry: "Por favor, reintenta m\xe1s tarde",
            error_psv: "El visor de fotos esf\xe9ricas no se est\xe1 cargando correctamente",
            error_pic: "No se encontr\xf3 la imagen solicitada",
            error_nopic: "No hay imagen disponible en la posici\xf3n dada",
            error_api: "El servidor de im\xe1genes no est\xe1 disponible",
            error_webgl: "Tu navegador no soporta WebGL",
            error_josm: "JOSM no responde, \xbfest\xe1 ejecut\xe1ndose y tiene habilitado el control remoto?",
            error_api_compatibility: "El servidor de im\xe1genes no es compatible con esta versi\xf3n del visor",
            filter_date: "Fecha",
            filter_user: "Usuario",
            filter_picture: "Tipo de imagen",
            filter_zoom_in: "Acerca el mapa para ver este filtro",
            picture_flat: "Cl\xe1sica",
            picture_360: "360\xb0",
            filter_camera_model: "Por modelo de c\xe1mara",
            map_background: "Fondo del mapa",
            map_background_aerial: "A\xe9rea",
            map_theme: "Tema del mapa",
            map_theme_default: "Cl\xe1sico",
            map_theme_age: "Fecha de captura",
            map_theme_age_1: "M\xe1s de tres a\xf1os",
            map_theme_age_2: "Menos de tres a\xf1os",
            map_theme_age_3: "Menos de un a\xf1o",
            map_theme_age_4: "Menos de seis mes",
            metadata_general_seqid: "Secuencia",
            metadata_general_picid_link: "Ir a la descripci\xf3n JSON de la imagen",
            metadata_general_seqid_link: "Ir a la descripci\xf3n JSON de la secuencia",
            metadata_general_author: "Autor",
            metadata_general_date: "Fecha de captura",
            metadata_camera: "C\xe1mara",
            metadata_camera_make: "Marca",
            metadata_camera_model: "Modelo",
            metadata_camera_type: "Tipo",
            metadata_camera_focal_length: "Distancia focal",
            metadata_location: "Posici\xf3n",
            metadata_location_longitude: "Longitud",
            metadata_location_latitude: "Latitud",
            metadata_location_orientation: "Direcci\xf3n",
            metadata_location_precision: "Precisi\xf3n de posicionamiento",
            metadata_exif: "EXIF / XMP",
            metadata_exif_name: "Etiqueta",
            metadata_exif_value: "Valor",
            report_whole_sequence: "Esto concierne a toda la secuencia",
            report_details: "Detalles adicionales",
            report_email: "Tu correo electr\xf3nico",
            report_email_placeholder: "Opcional",
            report_submit: "Enviar",
            report_success: "La denuncia se envi\xf3 con \xe9xito. Ser\xe1 revisada lo antes posible.",
            report_failure: "Ocurri\xf3 un error al crear la denuncia: {e}. Por favor, int\xe9ntalo de nuevo m\xe1s tarde.",
            map_theme_score: "Nivel de calidad",
            filter_qualityscore: "Nivel de calidad",
            filter_qualityscore_help: "Haz clic para habilitar o deshabilitar",
            legend_title: "Mostrar detalles de la imagen",
            metadata_camera_resolution: "Resoluci\xf3n",
            metadata_quality: "Calidad",
            metadata_quality_help: "Saber m\xe1s sobre la puntuaci\xf3n de calidad",
            metadata_quality_score: "Puntuaci\xf3n global",
            metadata_quality_gps_score: "Puntuaci\xf3n de posicionamiento",
            metadata_quality_resolution_score: "Puntuaci\xf3n de resoluci\xf3n",
            metadata_quality_missing: "ning\xfan valor establecido en la imagen",
            report_wait: "Enviando denuncia\u2026",
            semantics_copy: "Copiar atributos",
            semantics_zoom_in: "Acerca el mapa para ver las etiquetas",
            semantics_download_info: "Todos los datos sem\xe1nticos (etiquetas) est\xe1n disponibles como datos abiertos. Puedes descargarlos y usarlos como quieras.",
            semantics_download_cta: "Descargar datos abiertos",
            semantics_editor_example: "clave=valor\nprefijo|clave=valor",
            semantics_edit: "Editar atributos",
            semantics_save: "Guardar tus cambios",
            semantics_title: "Etiquetas",
            popup_details_link: "M\xe1s detalles",
            qualityscore_doc_5: "Un dispositivo profesional tendr\xe1 una calificaci\xf3n A, una c\xe1mara de acci\xf3n 360\xb0 una calificaci\xf3n B, y un tel\xe9fono inteligente una calificaci\xf3n entre C y E.",
            filter_gps_precision: "Precisi\xf3n de la ubicaci\xf3n",
            filter_gps_precision_lessthan: "Menos de {n} metros",
            filter_gps_precision_between: "Entre {n1} y {n2} metros",
            filter_gps_precision_help_1: "Hay informaci\xf3n de precisi\xf3n de la ubicaci\xf3n disponible para cada imagen. Esto corresponde a la precisi\xf3n del GPS durante la captura de la imagen.",
            filter_gps_precision_help_2: "La precisi\xf3n se expresa con estrellas:",
            filter_gps_precision_help_4: 'Un GPS RTK tendr\xe1 una calificaci\xf3n de "5\u2B50", una c\xe1mara de acci\xf3n como GoPro Max una calificaci\xf3n de "3\u2B50", y el GPS de un tel\xe9fono inteligente en un estacionamiento subterr\xe1neo una calificaci\xf3n de "1\u2B50".',
            map_theme_gps: "Precisi\xf3n de la ubicaci\xf3n",
            metadata_summary: "Resumen",
            metadata_general_copy_id: "Copiar ID",
            metadata_general_copy_picid: "Copiar ID de imagen",
            metadata_general_instance: "Instancia de origen",
            metadata_exif_doc: "Documentaci\xf3n para etiquetas EXIF",
            semantics_wikidata_properties: {
                P361: "parte de",
                P31: "instancia de",
                P180: "representa",
                P279: "subclase de"
            },
            semantics_annotation_tooltip: "Haz clic para ver detalles",
            minimize_short: "Ocultar",
            semantics_doc_link: "Saber m\xe1s sobre etiquetas",
            panoramax: "Panoramax",
            geo_uri: "Aplicaci\xf3n externa",
            filter_date_1year: "1 a\xf1o",
            filter_user_mypics: "Mis im\xe1genes",
            picture_all: "Todas",
            qualityscore_doc_1: "Se calcula una puntuaci\xf3n de calidad para cada imagen.",
            qualityscore_doc_2: "La puntuaci\xf3n se muestra como una letra:",
            metadata_location_coordinates: "Coordenadas (longitud, latitud)",
            whats_panoramax: "Panoramax es el geo-com\xfan para las im\xe1genes de los territorios.",
            picture_360_long: "Imagen panor\xe1mica",
            semantics_overlays: {
                features: "Todas las caracter\xedsticas",
                tfsigns: "Se\xf1ales de tr\xe1fico"
            },
            "visibility_logged-only": "Miembros",
            "visibility_title_logged-only": "Solo las personas con una cuenta pueden ver esta imagen",
            semantics_doc_info1u1: "Puedes etiquetarla como capturada por auto con la etiqueta transport=car.",
            semantics_download: "Descargar",
            filter_date_6months: "6 meses",
            semantics_sequence_tags: "Etiqueta de secuencia",
            semantics_picture_tags: "Etiqueta de imagen",
            semantics_annotation_tags: "Etiqueta de objeto",
            picture_flat_long: "Imagen cl\xe1sica",
            semantics_doc_info1: "Dar contexto a una imagen usando etiquetas.",
            semantics_doc_info3: "Algunos objetos son detectados autom\xe1ticamente con IA: la calidad no est\xe1 garantizada.",
            indoor_switch: "Mapas de interiores",
            indoor_selector_expand: "Haz clic para ver todos los niveles disponibles",
            indoor_selector_leveldown: "Ir al nivel inferior",
            indoor_selector_scrollup: "Desplazar la lista de niveles hacia arriba",
            indoor_selector_scrolldown: "Desplazar la lista de niveles hacia abajo",
            semantics_editor_error: "La sintaxis no es v\xe1lida. Tus etiquetas deben verse como:\nclave=valor\nprefijo|clave=valor\nprefijo|clave[clave_calif=val_calif]=valor\n\nLa longitud m\xe1xima de la clave es de 256 caracteres, la longitud m\xe1xima del valor es de 2048 caracteres.",
            contribute_id: "Contribuir a OpenStreetMap con el editor iD",
            semantics_value_show_osm: "Ver en OpenStreetMap",
            semantics_download_title: "Descargar etiquetas",
            semantics_add_annotation: "A\xf1adir una nueva etiqueta",
            semantics_draw_annotation: "Puedes dibujar el objeto que quieres a\xf1adir sobre la imagen (Opcional).",
            semantics_delete_annotation: "Eliminar esta caracter\xedstica",
            semantics_features_none: "A\xfan no se ha dibujado ninguna caracter\xedstica en esta imagen.",
            filter_gps_precision_help: "Saber m\xe1s sobre la precisi\xf3n de la ubicaci\xf3n",
            semantics_key_doc: "Saber m\xe1s sobre esta clave",
            semantics_doc: "Ayuda",
            qualityscore_doc_4: "Esta puntuaci\xf3n se calcula bas\xe1ndose en:",
            qualityscore_doc_41: "la precisi\xf3n del GPS",
            qualityscore_doc_42: "la resoluci\xf3n de la imagen",
            semantics_tags: "{nb} etiquetas",
            semantics_features: "Caracter\xedsticas de la imagen",
            semantics_features_default_title: "Etiqueta {nb}",
            semantics_show_all_tags: "Mostrar todas las etiquetas",
            filter_date_1month: "1 mes",
            qualityscore_doc_3: '"A" es la mejor calificaci\xf3n, "E" la peor.',
            qualityscore_doc_link: "Saber m\xe1s sobre la puntuaci\xf3n de calidad",
            filter_gps_precision_morethan: "M\xe1s de {n} metros",
            metadata_location_copy: "Copiar {v}",
            metadata_location_copy_more: "M\xe1s opciones de copia de coordenadas",
            metadata_exif_doc_title: "Ir a la documentaci\xf3n de Exiv2 para obtener detalles completos sobre las definiciones de etiquetas EXIF y XMP",
            semantics_features_subtitle: "{nb} propiedades asociadas",
            semantics_hide_all_tags: "Ocultar todas las etiquetas",
            semantics_key: "Clave",
            semantics_value: "Valor",
            semantics_doc_info2: "Tambi\xe9n puedes dibujar objetos en la imagen: se\xf1ales de tr\xe1fico, equipamiento urbano... Marca lo que veas usando etiquetas existentes. Tambi\xe9n puedes crear las tuyas propias si es necesario.",
            semantics_value_doc: "Saber m\xe1s sobre esta etiqueta",
            semantics_qualifiers: "Calificadores",
            semantics_show_annotations: "Mostrar caracter\xedsticas de la imagen",
            semantics_hide_annotations: "Ocultar caracter\xedsticas de la imagen",
            semantics_zero_annotations: "No hay caracter\xedsticas dibujadas en esta imagen",
            semantics_erase_annotation: "Borrar caracter\xedstica dibujada",
            semantics_delete_annotation_confirm: "\xbfRealmente quieres eliminar esta etiqueta?",
            semantics_undo: "Cancelar tus ediciones",
            semantics_send_fail: "No se pudieron guardar tus cambios, por favor int\xe9ntalo de nuevo m\xe1s tarde",
            semantics_login_needed: "Para editar etiquetas o caracter\xedsticas de la imagen, necesitas iniciar sesi\xf3n en la instancia {n} de Panoramax. \xbfQuieres iniciar sesi\xf3n?",
            indoor_selector_shrink: "Haz clic para minimizar",
            indoor_selector_levelup: "Ir al nivel superior",
            "visibility_owner-only": "Oculto",
            "visibility_title_owner-only": "Solo t\xfa puedes ver esta imagen"
        },
        psv: {
            ctrlZoom: "Usa Ctrl + rueda de desplazamiento para hacer zoom en la imagen",
            loadError: "El panorama no se puede cargar",
            twoFingers: "Usa dos dedos para navegar"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Buscar mi ubicaci\xf3n",
            "GeolocateControl.LocationNotAvailable": "Ubicaci\xf3n no disponible"
        },
        map: {
            loading: "Cargando\u2026",
            thumbnail: "Vista previa de la imagen bajo el cursor",
            not_public: "No es visible p\xfablicamente",
            slow_loading: "El mapa tarda en cargar y podr\xeda parecer roto",
            map_data: "Mapa basado en {m}",
            more_panoramax: "Descubre m\xe1s sobre Panoramax"
        }
    },
    fr: {
        psv: {
            twoFingers: "Utilisez deux doigts pour vous d\xe9placer",
            ctrlZoom: "Utilisez ctrl + scroll pour zoomer dans l'image",
            loadError: "L'image ne peut pas \xeatre charg\xe9e"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Afficher ma position",
            "GeolocateControl.LocationNotAvailable": "GPS non-disponible"
        },
        pnx: {
            zoom: "Zoom",
            zoomOut: "D\xe9zoomer",
            zoomIn: "Zoomer",
            moveUp: "Vers le haut",
            moveDown: "Vers le bas",
            moveLeft: "Vers la gauche",
            moveRight: "Vers la droite",
            moveMiddle: "Centrer la vue",
            expand: "Agrandir",
            expand_info: "Faire appara\xeetre ce widget en pleine page",
            show_psv: "Afficher la visionneuse de photos",
            show_map: "Afficher la carte",
            time_travel: "Voir ce lieu \xe0 d'autres dates",
            time_travel_close: "Masquer les autres dates",
            minimize: "Masquer ce widget, vous pouvez l'afficher de nouveau gr\xe2ce au bouton dans le coin en bas \xe0 gauche",
            minimize_short: "Masquer",
            options: "Options",
            filters: "Filtres",
            layers: "Calques",
            search: "Rechercher",
            search_empty: "Aucun r\xe9sultat",
            search_address: "Rechercher une adresse, ville\u2026",
            search_user: "Rechercher un nom d'utilisateur\u2026",
            share: "Partager",
            share_links: "Liens utiles",
            share_page: "Lien de la photo",
            share_image: "Image HD",
            share_rss: "Flux RSS",
            share_rss_title: "Flux RSS des nouvelles s\xe9quences dans la zone visible sur la carte",
            share_embed: "Int\xe9gration sur votre site",
            share_embed_docs: "D\xe9couvrir plus de possibilit\xe9s pour l'int\xe9gration sur votre site",
            share_print: "Imprimer",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax est le g\xe9ocommun des photos des territoires.",
            copy: "Copier",
            copied: "Copi\xe9",
            error: "On a un probl\xe8me\u2026",
            error_click: "Continuer",
            error_retry: "Merci de r\xe9essayer plus tard",
            sequence_next: "Photo suivante dans la s\xe9quence",
            sequence_play: "Parcourir cette s\xe9quence",
            sequence_play_backwards: "Parcourir cette s\xe9quence, \xe0 l'envers",
            sequence_pause: "Mettre en pause la s\xe9quence",
            sequence_prev: "Photo pr\xe9c\xe9dente dans la s\xe9quence",
            sequence_more: "Plus d'options de lecture",
            sequence_speed: "Vitesse de lecture",
            legend_license: "Licence : {l}",
            legend_title: "Afficher les d\xe9tails de l'image",
            id: "iD",
            contribute_id: "Contribuez \xe0 OpenStreetMap avec l'\xe9diteur iD",
            geo_uri: "App externe",
            josm: "JOSM",
            josm_live: "Active la synchronisation automatique de JOSM lors du chargement d'une photo",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Chargement du fond de carte",
                "\uD83D\uDDA5\uFE0F Interrogation de l'API",
                "\uD83D\uDDBC\uFE0F Chargement des miniatures",
                "\uD83D\uDD0D Analyse des m\xe9tadonn\xe9es EXIF",
                "\uD83C\uDFD8\uFE0F Cr\xe9ation du rendu 3D",
                "\uD83D\uDCF7 Initialisation des vues 360\xb0",
                "\uD83D\uDFE0 \xc9quilibrage des couleurs",
                "\uD83D\uDCAF Calcul du score qualit\xe9 \xa9",
                "\uD83D\uDCE1 T\xe9l\xe9chargement des mises \xe0 jour",
                "\uD83C\uDF0D R\xe9cup\xe9ration des tuiles",
                "\uD83D\uDCF8 Traitement des ombres"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C D\xe9tection des panneaux biche",
                "\uD83D\uDE98 Recherche de la Panoramax Car \xa9",
                "\u2615 Injection de caf\xe9ine",
                "\uD83D\uDE00 Souriez, vous \xeates mapp\xe9s\u202F!",
                "\uD83D\uDC08 Partage de photos de chats",
                "\uD83D\uDE34 R\xe9duction de la procrastination",
                "\uD83C\uDDF7\uD83C\uDDEA Chargement : 974%",
                "\uD83D\uDC27 Ouverture du code source",
                "\uD83E\uDD81 Indexation des traboules",
                "\uD83E\uDDF9 Nettoyage des m\xe9tadonn\xe9es",
                "\uD83D\uDE92 Envoi des photos du SDIS",
                "\uD83D\uDEB2 Mise \xe0 jour des voies vertes",
                "\uD83D\uDE89 Remont\xe9e des quais de gare",
                "\uD83D\uDEF0\uFE0F Recherche de satellites",
                "\uD83D\uDC65 \xc9criture des personas",
                "\uD83E\uDD5E Localisation des cr\xeaperies",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB D\xe9bogage de l'interface",
                "\uD83D\uDCC8 Incr\xe9mentation des statistiques",
                "\uD83E\uDD16 Apprentissage de la s\xe9mantique",
                "\uD83C\uDFA8 Redesign de l'interface",
                "\uD83D\uDCC5 Planification des photos-carto-parties",
                "\uD83E\uDDC0 Affinage des fromages",
                "\uD83C\uDF04 Calcul de l'ensoleillement corse",
                "\uD83C\uDF0A Mesure des grandes mar\xe9es"
            ],
            error_psv: "Photo Sphere Viewer ne s'est pas charg\xe9 correctement",
            error_pic: "La photo demand\xe9e est introuvable",
            error_nopic: "Aucune photo disponible autour de la localisation recherch\xe9e",
            error_api: "Le serveur de photos n'est pas disponible",
            error_pic_load: "La photo n'a pas pu \xeatre charg\xe9e.\nV\xe9rifiez votre connexion Internet. Si vous \xeates bien connect\xe9, v\xe9rifiez que l'identifiant de photo est bien valide.",
            error_webgl: "WebGL n'est pas support\xe9 par votre navigateur",
            error_josm: "JOSM n'a pas r\xe9pondu, est-il bien lanc\xe9 et la t\xe9l\xe9commande activ\xe9e\u202F?",
            error_api_compatibility: "Le serveur de photos n'est pas compatible avec cette visionneuse",
            filter_source_world: "Monde entier",
            filter_source_local: "Ce serveur",
            filter_date: "Date",
            filter_date_1month: "1 mois",
            filter_date_6months: "6 mois",
            filter_date_1year: "1 an",
            filter_user: "Utilisateur",
            filter_user_mypics: "Mes photos",
            filter_picture: "Type d'image",
            picture_all: "Tout",
            picture_flat: "Classique",
            picture_360: "360\xb0",
            picture_flat_long: "Photo classique",
            picture_360_long: "Photo panoramique",
            popup_details_link: "Plus de d\xe9tails",
            filter_qualityscore: "Score de qualit\xe9",
            filter_qualityscore_help: "Cliquez pour activer ou d\xe9sactiver",
            qualityscore_doc_1: "Un Score de Qualit\xe9 est calcul\xe9 pour chaque image.",
            qualityscore_doc_2: "Le Score est affich\xe9 sous la forme d'une lettre :",
            qualityscore_doc_3: '"A" est la meilleure note, "E" la moins bonne.',
            qualityscore_doc_4: "Ce score est calcul\xe9 selon :",
            qualityscore_doc_41: "la pr\xe9cision du GPS",
            qualityscore_doc_42: "la r\xe9solution de la photo",
            qualityscore_doc_5: "Un mat\xe9riel professionnel aura une note de A, une cam\xe9ra sportive 360\xb0 une note de B, et un smartphone une note entre C et E.",
            qualityscore_doc_link: "En savoir plus sur le Score de Qualit\xe9",
            filter_locked: "Filtre d\xe9sactiv\xe9",
            filter_zoom_in: "Zoomer pour voir",
            widget_locked: "Option d\xe9sactiv\xe9e",
            filter_gps_precision: "Pr\xe9cision du positionnement",
            filter_gps_precision_lessthan: "Moins de {n} m\xe8tres",
            filter_gps_precision_between: "Entre {n1} et {n2} m\xe8tres",
            filter_gps_precision_morethan: "Plus de {n} m\xe8tres",
            filter_gps_precision_help: "En savoir plus sur la pr\xe9cision du positionnement",
            filter_gps_precision_help_1: "Une Pr\xe9cision du positionnement est disponible pour chaque image. Cela correspond \xe0 la pr\xe9cision du GPS utilis\xe9.",
            filter_gps_precision_help_2: "La pr\xe9cision est exprim\xe9 sous forme d'\xe9toile :",
            filter_gps_precision_help_3: '"5\u2B50" est tr\xe8s pr\xe9cis (<= {p5}m), "1\u2B50" est tr\xe8s impr\xe9cis (> {p1}m) ou inconnu.',
            filter_gps_precision_help_4: 'Un GPS RTK aura une note de "5\u2B50", un GPS de cam\xe9ra sportive type GoPro Max une note de "3\u2B50", un GPS de smartphone dans un parking souterrain une note de "1\u2B50".',
            map_background: "Fond",
            map_background_aerial: "Satellite",
            map_background_streets: "Plan",
            map_background_default: "Par d\xe9faut",
            map_background_more: "Plus",
            map_theme: "Th\xe8me",
            map_theme_default: "Classique",
            map_theme_default_short: "Classique",
            map_theme_default_coef: "Niveau de couverture",
            map_theme_default_coef_short: "Couverture",
            map_theme_default_1: "Faible",
            map_theme_default_2: "Moyenne",
            map_theme_default_3: "Bonne",
            map_theme_default_4: "Excellente",
            map_theme_age_1: "+ 3 ans",
            map_theme_age_2: "1 - 3 ans",
            map_theme_age_3: "\xbd - 1 an",
            map_theme_age_4: "- 6 mois",
            map_theme_age: "Date de capture",
            map_theme_age_short: "Date",
            map_theme_type: "Type de cam\xe9ra",
            map_theme_type_short: "Cam\xe9ra",
            map_theme_score: "Score de qualit\xe9",
            map_theme_score_short: "Qualit\xe9",
            map_theme_gps: "Pr\xe9cision du GPS",
            map_theme_gps_short: "Position",
            contrast: "Augmenter le contraste de l'image",
            low_contrast: "Diminuer le contraste de l'image",
            reset_contrast: "R\xe9tablir le contraste de l'image",
            metadata: "M\xe9tadonn\xe9es de la photo",
            metadata_summary: "R\xe9sum\xe9",
            metadata_general_copy_id: "Copier l'ID",
            metadata_general_copy_picid: "Copier l'ID de photo",
            metadata_general_picid: "Photo",
            metadata_general_seqid: "S\xe9quence",
            metadata_general_picid_link: "Aller au descriptif JSON de la photo",
            metadata_general_seqid_link: "Aller au descriptif JSON de la s\xe9quence",
            metadata_general_title: "Titre",
            metadata_general_author: "Auteur",
            metadata_general_license: "Licence",
            metadata_general_license_link: "Voir la description compl\xe8te de la licence",
            metadata_general_date: "Date de prise de vue",
            metadata_general_instance: "Instance d'origine",
            metadata_camera: "Appareil",
            metadata_camera_make: "Fabricant",
            metadata_camera_model: "Mod\xe8le",
            metadata_camera_type: "Type",
            metadata_camera_resolution: "R\xe9solution",
            metadata_camera_focal_length: "Longueur focale",
            metadata_location: "Position",
            metadata_location_coordinates: "Coordonn\xe9es (longitude, latitude)",
            metadata_location_orientation: "Direction",
            metadata_location_precision: "Pr\xe9cision du positionnement",
            metadata_location_copy: "Copier {v}",
            metadata_location_copy_more: "Copier d'autres formats de coordonn\xe9es",
            metadata_quality: "Qualit\xe9",
            metadata_quality_help: "En savoir plus sur le score de qualit\xe9",
            metadata_quality_score: "Note globale",
            metadata_quality_gps_score: "Note du positionnement",
            metadata_quality_resolution_score: "Note de la r\xe9solution",
            metadata_quality_missing: "pas d'info dans l'image",
            metadata_exif: "EXIF",
            metadata_exif_name: "Balise",
            metadata_exif_value: "Valeur",
            metadata_exif_doc: "Doc des attributs EXIF",
            metadata_exif_doc_title: "Voir la doc Exiv2 pour en savoir plus sur les attributs EXIF et XMP",
            semantics_title: "Tags",
            semantics_tags: "{nb} attributs",
            semantics_features: "Objets dans la photo",
            semantics_features_none: "Aucun objet n'a \xe9t\xe9 dessin\xe9 dans cette photo pour l'instant.",
            semantics_features_default_title: "Tag {nb}",
            semantics_features_subtitle: "{nb} attributs associ\xe9s",
            semantics_annotation_tooltip: "Cliquez pour voir les d\xe9tails",
            semantics_annotation_tooltip_close: "Cliquez pour d\xe9s\xe9lectionner",
            semantics_show_all_tags: "Voir tous les attributs",
            semantics_hide_all_tags: "Masquer les attributs",
            semantics_key: "Cl\xe9",
            semantics_value: "Valeur",
            semantics_sequence_tags: "Tag de s\xe9quence",
            semantics_picture_tags: "Tag de photo",
            semantics_annotation_tags: "Tag d'un objet",
            semantics_doc: "Aide",
            semantics_doc_info1: "Pr\xe9cisez le contexte d'une photo en utilisant un tag.",
            semantics_doc_info1u1: "Indiquez par exemple qu'elle a \xe9t\xe9 prise en voiture avec le tag transport=car.",
            semantics_doc_info2: "Vous pouvez \xe9galement d\xe9tourer des objets au sein d'une photo\u202F: panneaux routiers, mobilier urbain\u2026 Pr\xe9cisez ce que vous voyez en utilisant les tags d\xe9j\xe0 utilis\xe9s par la communaut\xe9. Vous pouvez \xe9galement cr\xe9er votre propre tag si besoin.",
            semantics_doc_info3: "Certains objets sont d\xe9tect\xe9s automatiquement par IA : il n'y a pas de garantie de qualit\xe9.",
            semantics_doc_link: "En savoir plus (documentation compl\xe8te en anglais)",
            semantics_key_doc: "En savoir plus \xe0 propos de cette cl\xe9",
            semantics_value_doc: "En savoir plus \xe0 propos de cet attribut",
            semantics_value_show_osm: "Voir sur OpenStreetMap",
            semantics_qualifiers: "Qualificateurs",
            semantics_show_annotations: "Afficher les objets dans la photo",
            semantics_hide_annotations: "Masquer les objets dans la photo",
            semantics_zero_annotations: "Aucun objet dessin\xe9 dans cette photo",
            semantics_add_annotation: "Ajouter un nouveau tag",
            semantics_draw_annotation: "Vous pouvez dessiner l'emplacement de l'objet \xe0 cr\xe9er sur la photo (Optionnel).",
            semantics_draw_invalid_annotation: "La zone dessin\xe9e d\xe9passe de la photo. Veuillez vous assurer que la zone dessin\xe9e soit bien \xe0 l'int\xe9rieur de la photo.",
            semantics_draw_unfinished_annotation: "La zone dessin\xe9e n'est pas termin\xe9e. Assurez-vous qu'elle soit bien positionn\xe9e avant d'enregistrer.",
            semantics_erase_annotation: "Effacer l'objet dessin\xe9",
            semantics_delete_annotation: "Supprimer cet objet",
            semantics_delete_annotation_confirm: "\xcates-vous s\xfbr(e) de vouloir supprimer ce tag\u202F?",
            semantics_wikidata_properties: {
                P31: "instance de",
                P180: "d\xe9peint",
                P279: "sous-classe de",
                P361: "partie de"
            },
            semantics_editor_error: "La syntaxe est invalide. Vos attributs doivent avoir cette forme:\ncl\xe9=valeur\npr\xe9fixe|cl\xe9=valeur\npr\xe9fixe|cl\xe9[qualif_cl\xe9=qualif_val]=valeur\n\nLongueur max des cl\xe9s : 256 caract\xe8res, max des valeurs 2048 caract\xe8res.",
            semantics_editor_example: "cl\xe9=valeur\npr\xe9fixe|cl\xe9=valeur",
            semantics_copy: "Copier les attributs",
            semantics_edit: "Modifier les attributs",
            semantics_save: "Enregistrer vos modifications",
            semantics_undo: "Annuler vos modifications",
            semantics_send_fail: "Impossible d'enregistrer vos modifications, merci de r\xe9essayer plus tard",
            semantics_login_needed: "Afin de pouvoir modifier les attributs ou objets de la photo, vous devez vous connecter sur l'instance Panoramax {n}. Voulez-vous vous connecter\u202F?",
            semantics_empty: "Aucun attribut renseign\xe9",
            semantics_overlays: {
                tfsigns: "Panneaux routiers",
                features: "Tous les objets"
            },
            semantics_zoom_in: "Zoomez la carte pour voir les tags",
            semantics_download: "T\xe9l\xe9charger",
            semantics_download_title: "T\xe9l\xe9charger les tags",
            semantics_download_info: "Toutes les donn\xe9es s\xe9mantiques (tags) sont disponibles en open data. Vous pouvez les t\xe9l\xe9charger et en faire un libre usage.",
            semantics_download_cta: "T\xe9l\xe9charger les donn\xe9es",
            delete_picture: "Supprimer",
            delete_picture_warn: "\u26A0\uFE0F Attention\u202F: ceci supprimera d\xe9finitivement la photo.\n\xcates-vous s\xfbr\xb7e de supprimer la photo\u202F?",
            delete_picture_ok: "La photo a bien \xe9t\xe9 supprim\xe9e",
            delete_picture_error: "Une erreur s'est produite lors de la suppression de la photo\u202F:\n{e}",
            report: "Signaler",
            report_auth: 'Ce signalement sera envoy\xe9 en utilisant votre compte "{a}"',
            report_nature_label: "Nature du probl\xe8me",
            report_nature: {
                "": "S\xe9lectionnez la nature du probl\xe8me\u2026",
                blur_missing: "Un visage ou une plaque d'immatriculation est visible",
                blur_excess: "Un objet a \xe9t\xe9 sur-flout\xe9",
                inappropriate: "L'image est inappropri\xe9e (non pertinente, nudit\xe9\u2026)",
                privacy: "L'image a \xe9t\xe9 prise depuis une voie ou une propri\xe9t\xe9 priv\xe9e",
                picture_low_quality: "L'image est de mauvaise qualit\xe9",
                mislocated: "L'image est mal g\xe9olocalis\xe9e",
                copyright: "L'image enfreint les droits d'auteur",
                other: "Tout autre type de probl\xe8me"
            },
            report_whole_sequence: "Cela concerne toute la s\xe9quence",
            report_details: "D\xe9tails suppl\xe9mentaires",
            report_details_placeholder: "Optionnel, vous pouvez ajouter des d\xe9tails sur le probl\xe8me",
            report_email: "Votre email",
            report_email_placeholder: "Optionnel",
            report_submit: "Envoyer",
            report_wait: "Envoi du signalement en cours\u2026",
            report_success: "Le signalement a \xe9t\xe9 envoy\xe9 avec succ\xe8s. Il sera examin\xe9 d\xe8s que possible.",
            report_failure: "Une erreur est survenue lors de la cr\xe9ation du signalement : {e}. Veuillez r\xe9essayer plus tard.",
            indoor_switch: "Espaces int\xe9rieurs",
            indoor_selector_expand: "Cliquez pour voir tous les niveaux disponibles",
            indoor_selector_shrink: "Cliquez pour r\xe9duire",
            indoor_selector_levelup: "Aller au niveau sup\xe9rieur",
            indoor_selector_leveldown: "Aller au niveau inf\xe9rieur",
            indoor_selector_scrollup: "D\xe9rouler la liste vers le haut",
            indoor_selector_scrolldown: "D\xe9rouler la liste vers le bas",
            "visibility_logged-only": "Membres",
            "visibility_title_logged-only": "Seules les personnes avec un compte peuvent voir cette image",
            "visibility_owner-only": "Masqu\xe9",
            "visibility_title_owner-only": "Personne \xe0 part vous ne peut voir cette image"
        },
        map: {
            loading: "Chargement\u2026",
            thumbnail: "Miniature de la photo survol\xe9e",
            not_public: "Masqu\xe9 au public",
            slow_loading: "La carte est longue \xe0 charger et pourrait para\xeetre cass\xe9e",
            map_data: "Carte bas\xe9e sur {m}",
            more_panoramax: "En savoir plus sur Panoramax"
        }
    },
    hr: {
        psv: {
            twoFingers: "Koristi dva prsta za navigaciju",
            ctrlZoom: "Koristi ctrl + scroll za zumiranje slike",
            loadError: "Panorama se ne mo\u017Ee u\u010Ditati"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Prona\u0111i moju lokaciju",
            "GeolocateControl.LocationNotAvailable": "Lokacija nije dostupna"
        },
        pnx: {
            zoom: "Zumiraj",
            zoomOut: "Smanji",
            zoomIn: "Pove\u0107aj",
            moveUp: "Pomakni se naprijed",
            moveDown: "Pomakni se natrag",
            moveLeft: "Pomakni se lijevo",
            moveRight: "Pomakni se desno",
            moveMiddle: "Sredi\u0161nji pogled",
            expand: "Pro\u0161iri",
            show_psv: "Poka\u017Ei preglednik slika",
            expand_info: "Neka se komponenta pojavi na cijeloj stranici",
            minimize_short: "Sakrij",
            options: "Opcije",
            filters: "Filteri",
            layers: "Slojevi",
            search: "Pretra\u017Ei",
            search_empty: "Nema prona\u0111enih rezultata",
            search_address: "Tra\u017Ei adresu ili grad\u2026",
            search_user: "Tra\u017Ei korisni\u010Dko ime\u2026",
            share: "Podijeli",
            share_links: "Poveznice",
            share_page: "Poveznica na ovu sliku",
            share_image: "HD slika",
            share_rss: "RSS sa\u017Eetak sadr\u017Eaja",
            share_rss_title: "RSS sa\u017Eetak sadr\u017Eaja novih sekvenci u trenutno vidljivom podru\u010Dju karte",
            share_embed: "Ugradi na svoju web stranicu",
            share_embed_docs: "Pro\u010Ditaj vi\u0161e o konfiguraciji ugradnje",
            share_print: "Ispi\u0161i",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax je geo-commons za slike teritorija.",
            copy: "Kopiraj",
            copied: "Kopirano",
            error: "Imamo problem\u2026",
            error_click: "Nastavi",
            error_retry: "Molim poku\u0161aj kasnije ponovo",
            sequence_next: "Slijede\u0107a slika u sekvenci",
            sequence_play: "Pokreni ovu sekvencu",
            sequence_pause: "Zaustavi ovu sekvencu",
            sequence_prev: "Prethodna slika u sekvenci",
            sequence_more: "Vi\u0161e mogu\u0107nosti igre",
            legend_license: "Licenca: {l}",
            legend_title: "Poka\u017Ei detalje slike",
            id: "iD",
            geo_uri: "Vanjska aplikacija",
            josm: "JOSM",
            josm_live: "Omogu\u0107i JOSM automatsku sinkronizaciju prilikom u\u010Ditavanja slike",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F U\u010Ditavanje podataka karte",
                "\uD83D\uDDA5\uFE0F API za upite",
                "\uD83D\uDDBC\uFE0F U\u010Ditavanje sli\u010Dica",
                "\uD83D\uDD0D Analiziranje EXIF metapodataka",
                "\uD83C\uDFD8\uFE0F 3D prikaz",
                "\uD83D\uDCF7 Pokretanje 360\xb0slika",
                "\uD83D\uDFE0 Balansiranje boje",
                "\uD83D\uDCAF Ocjena kvalitete ra\u010Dunalstva \xa9",
                "\uD83D\uDCE1 Preuzimanje a\u017Euriranja",
                "\uD83C\uDF0D Dohva\u0107anje plo\u010Dica karte",
                "\uD83D\uDCF8 Obrada sjena"
            ],
            show_map: "Poka\u017Ei kartu",
            sequence_speed: "Brzina igra\u010Da",
            minimize: "Sakrij ovu komponentu, mo\u017Ee\u0161 je ponovno prikazati pomo\u0107u tipke u donjem lijevom kutu",
            contribute_id: "Doprinesi OpenStreetMap pomo\u0107u iD ure\u0111iva\u010Da",
            loading_labels_fun: [
                "\uD83E\uDD8C Otkrivanje znakova prijelaza jelena",
                "\uD83D\uDE98 Pretra\u017Eivanje Panoramax Car \xa9",
                "\u2615 Injekcija kofeina",
                "\uD83D\uDE00 Osmjeh, kartiran si!",
                "\uD83D\uDC08 Dijeljenje slika ma\u010Daka",
                "\uD83D\uDE34 Smanjenje odga\u0111anja",
                "\uD83E\uDED6 Kuhanje \u010Daja",
                "\uD83D\uDC27 Otvaranje izvornog koda",
                "\uD83D\uDE87 Indeksiranje stanica podzemne \u017Eeljeznice",
                "\uD83E\uDDF9 \u010Ci\u0161\u0107enje metapodataka",
                "\uD83D\uDE92 Slanje fotografija vatrogasne stanice",
                "\uD83D\uDEB2 A\u017Euriranje zelenih staza",
                "\uD83D\uDE89 Prolaz na peron stanice",
                "\uD83D\uDEF0\uFE0F Tra\u017Eenje satelita",
                "\uD83D\uDC65 Pisanje persona",
                "\uD83D\uDC1F Lociranje trgovine ribom",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Su\u010Delje za otklanjanje pogre\u0161aka",
                "\uD83D\uDCC8 Statisti\u010Dko pove\u0107anje",
                "\uD83E\uDD16 U\u010Denje zna\u010Denja",
                "\uD83C\uDFA8 Redizajn su\u010Delja",
                "\uD83D\uDCC5 Planiranje zabava foto-kartiranja",
                "\uD83E\uDDC0 Dozrijevanje cheddar sira",
                "\uD83C\uDF04 Izra\u010Dunavanje kornvalskog sunca",
                "\uD83C\uDF0A Mjerenje plime i oseke"
            ],
            error_psv: "Photo Sphere Viewer se ne u\u010Ditava ispravno",
            error_pic: "Tra\u017Eena slika nije prona\u0111ena",
            error_api: "Poslu\u017Eitelj slika nije dostupan",
            error_webgl: "Va\u0161 preglednik ne podr\u017Eava WebGL",
            error_api_compatibility: "Poslu\u017Eitelj slika nije kompatibilan s ovom verzijom preglednika",
            filter_source_world: "Cijeli svijet",
            filter_source_local: "Ovaj server",
            filter_date: "Datum",
            filter_date_1month: "1 mjesec",
            filter_date_6months: "6 mjeseci",
            filter_user: "Korisnik",
            filter_user_mypics: "Moje slike",
            filter_picture: "Tip slike",
            filter_locked: "Filter onemogu\u0107en",
            filter_zoom_in: "Pove\u0107ajte za otklju\u010Davanje",
            picture_all: "Svi",
            picture_flat: "Klasi\u010Dno",
            picture_360: "360\xb0",
            picture_360_long: "Panoramska slika",
            popup_details_link: "Vi\u0161e detalja",
            filter_qualityscore: "Ocjena kvalitete",
            filter_qualityscore_help: "Klikni da omogu\u0107i\u0161 ili onemogu\u0107i\u0161",
            qualityscore_doc_1: "Ocjena kvalitete izra\u010Dunava se za svaku sliku.",
            qualityscore_doc_2: "Rezultat je prikazan kao slovo:",
            qualityscore_doc_3: '"A" je najbolja ocjena, "E" najgora.',
            qualityscore_doc_4: "Ova se ocjena izra\u010Dunava na temelju:",
            qualityscore_doc_41: "GPS preciznost",
            qualityscore_doc_42: "rezolucija slike",
            qualityscore_doc_link: "Saznajte vi\u0161e o ocjeni kvalitete",
            filter_gps_precision: "Preciznost lokacije",
            filter_gps_precision_lessthan: "Manje od {n} metara",
            filter_gps_precision_between: "Izme\u0111u {n1} i {n2} metara",
            filter_gps_precision_morethan: "Vi\u0161e od {n} metara",
            filter_gps_precision_help: "Saznajte vi\u0161e o preciznosti lokacije",
            filter_gps_precision_help_1: "Informacije o preciznosti lokacije dostupne su za svaku sliku. To odgovara GPS preciznosti tijekom snimanja slike.",
            filter_gps_precision_help_2: "Preciznost je izra\u017Eena zvjezdicama:",
            filter_gps_precision_help_4: 'RTK GPS imat \u0107e ocjenu "5\u2B50", akcijska kamera poput GoPro Maxa ocjenu "3\u2B50", a GPS za pametni telefon u podzemnom parkingu ocjenu "1\u2B50".',
            map_background: "Pozadina",
            map_background_aerial: "Zra\u010Dni",
            map_background_streets: "Ulice",
            map_background_default: "Po\u010Detna vrijednost",
            map_theme_default: "Predefinirano",
            semantics_features_default_title: "Oznaka {nb}",
            qualityscore_doc_5: "Profesionalni ure\u0111aj imat \u0107e ocjenu A, akcijska kamera od 360\xb0 ocjenu B, a pametni telefon ocjenu izme\u0111u C i E.",
            picture_flat_long: "Klasi\u010Dna slika",
            filter_gps_precision_help_3: '"5\u2B50" je vrlo precizno (<= {p5}m), "1\u2B50" je vrlo neprecizno (> {p1}m) ili nepoznato.',
            error_nopic: "Nema dostupnih slika na datoj poziciji",
            error_josm: "JOSM ne odgovara, radi li i je li daljinsko upravljanje omogu\u0107eno?",
            filter_date_1year: "1 godina",
            map_background_more: "Vi\u0161e",
            map_theme: "Tema",
            map_theme_age: "Datum snimanja",
            map_theme_age_1: "> 3 godine",
            map_theme_age_2: "< 3 godine",
            map_theme_age_3: "\xbd - 1 godine",
            map_theme_age_4: "< 6 mjeseca",
            map_theme_type: "Tip kamere",
            map_theme_score: "Ocjena kvalitete",
            map_theme_gps: "GNSS preciznost",
            contrast: "Omogu\u0107i ve\u0107i kontrast slike",
            metadata: "Metapodaci slike",
            metadata_summary: "Sa\u017Eetak",
            metadata_general_copy_id: "Kopiraj ID",
            metadata_general_copy_picid: "Kopiraj ID slike",
            metadata_general_picid: "Slika",
            metadata_general_seqid: "Sekvenca",
            metadata_general_picid_link: "Idi na JSON opis slike",
            metadata_general_seqid_link: "Idi na JSON opis sekvence",
            metadata_general_author: "Autor",
            metadata_general_license: "Licenca",
            metadata_general_license_link: "Pogledaj puni opis licence",
            metadata_general_date: "Datum snimanja",
            metadata_general_instance: "Izvorna instanca",
            metadata_camera: "Kamera",
            metadata_camera_make: "U\u010Dini",
            metadata_camera_model: "Model",
            metadata_camera_type: "Tip",
            metadata_camera_resolution: "Rezolucija",
            metadata_camera_focal_length: "\u017Dari\u0161na udaljenost",
            metadata_location: "Pozicija",
            metadata_location_coordinates: "Koordinate (du\u017Eina, \u0161irina)",
            metadata_location_orientation: "Smjer",
            metadata_location_precision: "Preciznost pozicioniranja",
            metadata_location_copy: "Kopiraj {v}",
            metadata_location_copy_more: "Vi\u0161e opcija kopiranja koordinata",
            metadata_quality: "Kvaliteta",
            metadata_quality_help: "Saznaj vi\u0161e o ocjeni kvalitete",
            metadata_quality_score: "Globalna ocjena",
            metadata_quality_gps_score: "Rezultat pozicioniranja",
            metadata_quality_resolution_score: "Rezultat rezolucije",
            metadata_quality_missing: "nema postavljene vrijednosti na slici",
            metadata_exif: "EXIF",
            metadata_exif_name: "Oznaka",
            metadata_exif_value: "Vrijednost",
            metadata_exif_doc: "Dokumenti za EXIF oznake",
            metadata_exif_doc_title: "Posjeti Exiv2 dokumentaciju kako bi saznao sve pojedinosti o definicijama EXIF i XMP oznaka",
            semantics_title: "Oznake",
            semantics_tags: "{nb} oznake",
            semantics_features: "Zna\u010Dajke slike",
            semantics_features_none: "Na ovoj slici jo\u0161 nije nacrtano nijedno zna\u010Dajka.",
            semantics_features_subtitle: "{nb} povezana svojstva",
            semantics_annotation_tooltip: "Klikni za detalje",
            semantics_show_all_tags: "Prika\u017Ei sve oznake",
            semantics_hide_all_tags: "Sakrij sve oznake",
            semantics_key: "Klju\u010D",
            semantics_value: "Vrijednost",
            semantics_sequence_tags: "Oznaka sekvence",
            semantics_picture_tags: "Oznaka slike",
            semantics_annotation_tags: "Oznaka objekta",
            semantics_doc: "Pomo\u0107",
            semantics_doc_info1: "Daj kontekst oko slike pomo\u0107u oznaka.",
            semantics_doc_info1u1: "Mo\u017Eete ga ozna\u010Diti da je snimljen automobilom s oznakom transport=car.",
            semantics_doc_info2: "Na slici mo\u017Ee\u0161 crtati i objekte: prometne znakove, urbanu opremu... Ozna\u010Di ono \u0161to vidi\u0161 koriste\u0107i postoje\u0107e oznake. Mo\u017Ee\u0161 izraditi i vlastite ako je potrebno.",
            semantics_doc_info3: "Neki se objekti automatski otkrivaju pomo\u0107u AI: kvaliteta nije zajam\u010Dena.",
            semantics_doc_link: "Saznaj vi\u0161e o oznakama",
            semantics_key_doc: "Saznaj vi\u0161e o ovom klju\u010Du",
            semantics_value_doc: "Saznaj vi\u0161e o ovoj oznaci",
            semantics_value_show_osm: "Pogledaj na OpenStreetMap",
            semantics_qualifiers: "Kvalifikacije",
            semantics_show_annotations: "Prikaz zna\u010Dajki slike",
            semantics_hide_annotations: "Sakrij zna\u010Dajke slike",
            semantics_zero_annotations: "Na ovoj slici nema zna\u010Dajki",
            semantics_add_annotation: "Dodaj novu oznaku",
            semantics_draw_annotation: "Preko slike mo\u017Eete nacrtati objekt koji \u017Eelite dodati (nije obavezno).",
            semantics_erase_annotation: "Obri\u0161i nacrtanu zna\u010Dajku",
            semantics_delete_annotation: "Obri\u0161i ovu zna\u010Dajku",
            semantics_delete_annotation_confirm: "\u017Deli\u0161 li zaista obrisati ovu oznaku?",
            semantics_wikidata_properties: {
                P31: "instanca",
                P180: "prikazuje",
                P279: "podklasa",
                P361: "dio"
            },
            semantics_editor_error: "Sintaksa je neva\u017Ee\u0107a. Tvoje oznake mogu izgledati ovako: \nklju\u010D=vrijednost\nprefiks|klju\u010D=vrijednosti\nprefix klju\u010D[qualif_key=qualif_val]=vrijednost \n\nMaksimalna duljina klju\u010Da je 256 znakova, maksimalna duljina vrijednosti 2048 znakova.",
            semantics_editor_example: "klju\u010D=vrijednost\nprefiks|klju\u010D=vrijednost",
            semantics_copy: "Kopiraj atribute",
            semantics_edit: "Uredi atribute",
            semantics_save: "Spremi svoje promjene",
            semantics_undo: "Otka\u017Ei svoje promjene",
            semantics_send_fail: "Nije mogu\u0107e spremiti tvoje promjene, poku\u0161aj ponovno kasnije",
            semantics_login_needed: "Kako bi uredio oznake ili zna\u010Dajke slika, mora\u0161 se prijaviti na Panoramax {n} instancu. \u017Deli\u0161 li se prijaviti?",
            semantics_overlays: {
                tfsigns: "Prometni znakovi",
                features: "Sve zna\u010Dajke"
            },
            semantics_zoom_in: "Pove\u0107aj kartu kako bi vidio oznake",
            semantics_download: "Preuzimanje",
            semantics_download_title: "Preuzmi oznake",
            semantics_download_info: "Svi semanti\u010Dki podaci (tagovi) dostupni su kao otvoreni podaci. Mo\u017Ee\u0161 ih preuzeti i koristiti kako \u017Eeli\u0161.",
            semantics_download_cta: "Preuzmi otvorene podatke",
            report: "Izvje\u0161taj",
            report_nature_label: "Uzrok problema",
            report_nature: {
                "": "Izaberi prirodu problema\u2026",
                blur_missing: "Vidljivo je lice osobe ili registarska tablica automobila",
                blur_excess: "Na objektu je primjenjeno nepotrebno zamu\u0107enje",
                privacy: "Slika je snimljena s privatnog puta ili imanja",
                picture_low_quality: "Slika je lo\u0161e kvalitete",
                mislocated: "Slika je lo\u0161e pozicionirana na karti",
                copyright: "Slika kr\u0161i autorska prava",
                other: "Bilo koja druga vrsta problema",
                inappropriate: "Slika nije odgovaraju\u0107a (nepovezana, nagost...)"
            },
            report_whole_sequence: "Ovo se odnosi na cijelu sekvencu",
            report_details: "Dodatni detalji",
            report_details_placeholder: "Po \u017Eelji, mo\u017Ee\u0161 dodati pojedinosti o problemu",
            report_email: "Tvoj email",
            report_email_placeholder: "Neobavezno",
            report_submit: "Dostavi",
            report_wait: "Slanje izvje\u0161\u0107a\u2026",
            report_success: "Izvje\u0161\u0107e je uspje\u0161no poslano. Bit \u0107e pregledano \u0161to je prije mogu\u0107e.",
            report_failure: "Do\u0161lo je do pogre\u0161ke prilikom izrade izvje\u0161\u0107a: {e}. Poku\u0161aj ponovno kasnije.",
            indoor_switch: "Unutarnji prostori",
            indoor_selector_expand: "Klikni za uvid u sve dostupne razine",
            indoor_selector_shrink: "Klikni za smanjivanje",
            indoor_selector_levelup: "Idi na vi\u0161u razinu",
            indoor_selector_leveldown: "Idi na ni\u017Eu razinu",
            indoor_selector_scrollup: "Pomakni popis razina prema gore",
            indoor_selector_scrolldown: "Pomakni popis razina prema dolje",
            "visibility_logged-only": "\u010Clanovi",
            "visibility_title_logged-only": "Samo osobe s ra\u010Dunom mogu vijeti ovu sliku",
            "visibility_owner-only": "Skirveno",
            "visibility_title_owner-only": "Samo ti mo\u017Ee\u0161 vidjeti ovu sliku",
            report_auth: 'Ovaj izvje\u0161taj \u0107e biti poslan upotrebom tvog ra\u010Duna "{a}"',
            semantics_draw_invalid_annotation: "Nacrtano podru\u010Dje prelazi granice slike. Obavezno crtaj unutar vidljive slike.",
            semantics_draw_unfinished_annotation: "Nacrtano podru\u010Dje je nedovr\u0161eno. Provjeri je li podru\u010Dje dobro pozicionirano prije spremanja.",
            error_pic_load: "Slika se trenutno ne mo\u017Ee u\u010Ditati. \nMolim provjeri svoju internetsku vezu. Ako si povezan, provjeri je li slikovni ID valjan.",
            reset_contrast: "Poni\u0161ti kontrast slike",
            low_contrast: "Smanji kontrast slike",
            delete_picture: "Obri\u0161i",
            delete_picture_warn: "\u26A0\uFE0FOprez: ovo trajno bri\u0161e sliku. \nJesti li siguran da \u017Eeli\u0161 potpuno izbrisati ovu sliku?",
            delete_picture_ok: "Slika je uspje\u0161no obrisana",
            delete_picture_error: "Do\u0161lo je do pogre\u0161ke prilikom poku\u0161aja brisanja slike:\n{e}",
            semantics_empty: "Nema definiranih oznaka",
            metadata_general_title: "Naslov",
            time_travel: "Pogledaj ovo mjesto za druge datume",
            time_travel_close: "Sakrij druge datume",
            map_theme_age_short: "Datum",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Kvaliteta",
            map_theme_gps_short: "Pozicija",
            map_theme_default_short: "Predefinirano",
            map_theme_default_coef: "Razina pokrivenosti",
            map_theme_default_coef_short: "Pokrivenost",
            map_theme_default_1: "Niska",
            map_theme_default_2: "Prosje\u010Dna",
            map_theme_default_3: "Dobra",
            map_theme_default_4: "Odli\u010Dna",
            widget_locked: "Opcija onemogu\u0107ena",
            sequence_play_backwards: "Pratite ovu sekvencu, unatrag",
            semantics_annotation_tooltip_close: "Klikni za poni\u0161tavanje odabira"
        },
        map: {
            thumbnail: "Sli\u010Dica lebde\u0107e slike",
            not_public: "Nije javno vidljivo",
            slow_loading: "Karta se sporo u\u010Ditava i mogla bi izgledati neispravna",
            map_data: "Karta se temelji na {m}",
            more_panoramax: "Otkrij vi\u0161e o Panoramaxu",
            loading: "U\u010Ditavanje\u2026"
        }
    },
    hu: {
        psv: {
            twoFingers: "K\xe9t ujjal navig\xe1lhat",
            ctrlZoom: "K\xf6zel\xedt\xe9s vagy t\xe1vol\xedt\xe1s: Ctrl + g\xf6rget\xe9s",
            loadError: "A panor\xe1ma nem t\xf6lthet\u0151 be"
        },
        pnx: {
            zoom: "Nagy\xedt\xe1s",
            zoomOut: "T\xe1vol\xedt\xe1s",
            zoomIn: "K\xf6zel\xedt\xe9s",
            moveUp: "Mozg\xe1s fel",
            moveDown: "Mozg\xe1s le",
            moveLeft: "Mozg\xe1s balra",
            moveRight: "Mozg\xe1s jobbra",
            moveMiddle: "N\xe9zet k\xf6z\xe9pre hoz\xe1sa",
            expand: "Nagy\xedt\xe1s",
            expand_info: "Widget megjelen\xedt\xe9se teljes oldalon",
            show_psv: "K\xe9pn\xe9zeget\u0151 megjelen\xedt\xe9se",
            show_map: "T\xe9rk\xe9p megjelen\xedt\xe9se",
            minimize: "Widget elrejt\xe9se; a bal als\xf3 sarokban l\xe9v\u0151 gombbal \xfajra megjelen\xedtheted",
            options: "Be\xe1ll\xedt\xe1sok",
            filters: "Sz\u0171r\u0151k",
            layers: "R\xe9tegek",
            share: "Megoszt\xe1s",
            search: "Keres\xe9s",
            search_empty: "Nincs tal\xe1lat",
            share_links: "Linkek",
            share_page: "Link ehhez a k\xe9phez",
            share_image: "Nagy felbont\xe1s\xfa (HD) k\xe9p",
            share_rss: "RSS h\xedrcsatorna",
            share_rss_title: "A t\xe9rk\xe9p l\xe1that\xf3 ter\xfclet\xe9n l\xe9v\u0151 \xfaj sorozatok RSS-h\xedrcsatorn\xe1ja",
            share_embed: "Be\xe1gyaz\xe1s a weboldaladon",
            share_print: "Nyomtat\xe1s",
            copy: "M\xe1sol\xe1s",
            copied: "M\xe1solva",
            error: "Ajjaj, baj van\u2026",
            error_subtitle: "Pr\xf3b\xe1lja \xfajra k\xe9s\u0151bb, vagy n\xe9zze meg a b\xf6ng\xe9sz\u0151konzolt a tov\xe1bbi r\xe9szletek\xe9rt.",
            sequence_next: "A sorozat k\xf6vetkez\u0151 k\xe9pe",
            sequence_play: "Sorozat lej\xe1tsz\xe1sa",
            sequence_pause: "Sorozatlej\xe1tsz\xe1s sz\xfcneteltet\xe9se",
            sequence_prev: "A sorozat el\u0151z\u0151 k\xe9pe",
            sequence_more: "Tov\xe1bbi lej\xe1tsz\xe1si lehet\u0151s\xe9gek",
            sequence_speed: "Lej\xe1tsz\xe1s sebess\xe9ge",
            legend_license: "Licenc: {l}",
            edit_osm: "OSM szerkeszt\xe9se",
            id: "iD",
            josm: "JOSM",
            josm_live: "JOSM automatikus szinkroniz\xe1l\xe1s\xe1nak enged\xe9lyez\xe9se k\xe9pbet\xf6lt\xe9skor",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F T\xe9rk\xe9padatok bet\xf6lt\xe9se",
                "\uD83D\uDDA5\uFE0F API lek\xe9rdez\xe9se",
                "\uD83D\uDDBC\uFE0F B\xe9lyegk\xe9pek bet\xf6lt\xe9se",
                "\uD83D\uDD0D EXIF metaadatok elemz\xe9se",
                "\uD83C\uDFD8\uFE0F 3D megjelen\xedt\xe9s",
                "\uD83D\uDCF7 360\xb0-os k\xe9pek inicializ\xe1l\xe1sa",
                "\uD83D\uDFE0 Sz\xednek kiegyenl\xedt\xe9se",
                "\uD83D\uDCAF Min\u0151s\xe9gi pontsz\xe1m kisz\xe1m\xedt\xe1sa \xa9",
                "\uD83D\uDCE1 Friss\xedt\xe9sek let\xf6lt\xe9se",
                "\uD83C\uDF0D T\xe9rk\xe9pcsemp\xe9k beszerz\xe9se",
                "\uD83D\uDCF8 \xc1rny\xe9kok feldolgoz\xe1sa"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C Vadvesz\xe9lyt jelz\u0151 t\xe1bla \xe9szlel\xe9se",
                "\uD83D\uDE98 Panoramax aut\xf3 \xa9 keres\xe9se",
                "\u2615 Koffeininjekci\xf3",
                "\uD83D\uDE00 Mosolyogj, fel lett\xe9l t\xe9rk\xe9pezve!",
                "\uD83D\uDC08 Kiscic\xe1s k\xe9pek megoszt\xe1sa",
                "\uD83D\uDE34 Halogat\xe1s cs\xf6kkent\xe9se",
                "\uD83E\uDED6 Tea megf\u0151z\xe9se",
                "\uD83D\uDC27 Forr\xe1sk\xf3d felnyit\xe1sa",
                "\uD83D\uDE87 Metr\xf3\xe1llom\xe1sok indexel\xe9se",
                "\uD83E\uDDF9 Metaadatok tisztogat\xe1sa",
                "\uD83D\uDE92 T\u0171zolt\xf3s\xe1gr\xf3l sz\xf3l\xf3 fot\xf3k bek\xfcld\xe9se",
                "\uD83D\uDEB2 Ker\xe9kp\xe1rutak friss\xedt\xe9se",
                "\uD83D\uDE89 V\xe9gigs\xe9t\xe1l\xe1s az \xe1llom\xe1s peronj\xe1n",
                "\uD83D\uDEF0\uFE0F M\u0171holdak keres\xe9se",
                "\uD83D\uDC65 Person\xe1k meg\xedr\xe1sa",
                "\uD83D\uDC1F S\xfcltkrumplikap\xf3k lokaliz\xe1l\xe1sa",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Hibakeres\xe9s az interf\xe9szben",
                "\uD83D\uDCC8 Statisztika n\xf6vel\xe9se",
                "\uD83E\uDD16 Szemantika tanul\xe1sa",
                "\uD83C\uDFA8 Interf\xe9sz \xfajratervez\xe9se",
                "\uD83D\uDCC5 Foto-mapping partik tervez\xe9se",
                "\uD83E\uDDC0 Cheddar sajt \xe9rlel\xe9se",
                "\uD83C\uDF04 A cornwalli naps\xfct\xe9s kisz\xe1m\xedt\xe1sa",
                "\uD83C\uDF0A Dag\xe1lyok m\xe9r\xe9se"
            ],
            error_psv: "A Photo Sphere Viewer (g\xf6mbpanor\xe1ma-n\xe9zeget\u0151) nem t\xf6lt\u0151dik be megfelel\u0151en",
            error_pic: "A k\xe9rt k\xe9p nem tal\xe1lhat\xf3",
            error_nopic: "Az adott helyen nem \xe9rhet\u0151 el k\xe9p",
            error_api: "A k\xe9pkiszolg\xe1l\xf3 nem \xe9rhet\u0151 el",
            error_webgl: "A WebGL nem t\xe1mogatott ebben a b\xf6ng\xe9sz\u0151ben",
            error_josm: "A JOSM nem v\xe1laszolt. Val\xf3ban fut \xe9s enged\xe9lyezve van a t\xe1vir\xe1ny\xedt\xf3?",
            error_api_compatibility: "A k\xe9pkiszolg\xe1l\xf3 nem kompatibilis a k\xe9pn\xe9zeget\u0151 ezen verzi\xf3j\xe1val",
            filter_date: "D\xe1tum szerint",
            filter_user: "Felhaszn\xe1l\xf3 szerint",
            filter_picture: "K\xe9pt\xedpus szerint",
            picture_flat: "Klasszikus",
            picture_360: "360\xb0",
            filter_camera_model: "Kameramodell szerint",
            map_background: "H\xe1tt\xe9r",
            map_background_aerial: "L\xe9gi felv\xe9tel",
            map_background_streets: "k\xe9pUtca",
            map_theme: "T\xe9ma",
            map_theme_default: "Alap\xe9rtelmezett",
            map_theme_age: "K\xe9pk\xe9sz\xedt\xe9s ideje",
            map_theme_age_1: "3 \xe9vn\xe9l r\xe9gebben",
            map_theme_age_2: "1\u20133 \xe9ve",
            map_theme_age_3: "\xbd\u20131 \xe9ve",
            map_theme_age_4: "< 6 h\xf3napja",
            map_theme_type: "Kamerat\xedpus",
            contrast: "Nagyobb k\xe9pkontraszt enged\xe9lyez\xe9se",
            metadata: "K\xe9p metaadatai",
            metadata_general_picid: "K\xe9p",
            metadata_general_seqid: "Sorozat",
            metadata_general_picid_link: "Ugr\xe1s a k\xe9p JSON le\xedr\xe1s\xe1hoz",
            metadata_general_seqid_link: "Ugr\xe1s a sorozat JSON le\xedr\xe1s\xe1hoz",
            metadata_general_author: "Szerz\u0151",
            metadata_general_license: "Licenc (enged\xe9ly)",
            metadata_general_license_link: "Ugr\xe1s a licenc teljes le\xedr\xe1s\xe1hoz",
            metadata_general_date: "K\xe9sz\xedt\xe9s d\xe1tuma",
            metadata_camera: "Kamera",
            metadata_camera_make: "Gy\xe1rt\xf3",
            metadata_camera_model: "Modell",
            metadata_camera_type: "T\xedpus",
            metadata_camera_focal_length: "Gy\xfajt\xf3t\xe1vols\xe1g",
            metadata_location: "Poz\xedci\xf3",
            metadata_location_longitude: "Hossz\xfas\xe1g",
            metadata_location_latitude: "Sz\xe9less\xe9g",
            metadata_location_orientation: "Ir\xe1ny",
            metadata_location_precision: "Helymeghat\xe1roz\xe1s pontoss\xe1ga",
            metadata_exif: "EXIF",
            metadata_exif_name: "C\xedmke",
            metadata_exif_value: "\xc9rt\xe9k",
            report: "Bejelent\xe9se",
            report_auth: "A jelent\xe9s a fi\xf3kod ({a}) felhaszn\xe1l\xe1s\xe1val lesz elk\xfcldve",
            report_nature: {
                "": "Probl\xe9ma jelleg\xe9nek kiv\xe1laszt\xe1sa\u2026",
                blur_missing: "L\xe1tszik egy szem\xe9ly arca vagy egy rendsz\xe1mt\xe1bla",
                blur_excess: "A k\xe9pen sz\xfcks\xe9gtelen\xfcl el van hom\xe1lyos\xedtva valami",
                inappropriate: "A k\xe9p nem megfelel\u0151 (irrelev\xe1ns, meztelens\xe9get jelen\xedt meg stb.)",
                privacy: "A f\xe9nyk\xe9p egy mag\xe1n\xfatvonalr\xf3l vagy mag\xe1nter\xfcletr\u0151l k\xe9sz\xfclt",
                picture_low_quality: "A k\xe9p rossz min\u0151s\xe9g\u0171",
                mislocated: "A k\xe9p gyatr\xe1n van elhelyezve a t\xe9rk\xe9pen",
                copyright: "A k\xe9p szerz\u0151i jogot s\xe9rt",
                other: "B\xe1rmilyen m\xe1s jelleg\u0171 probl\xe9ma"
            },
            report_nature_label: "Probl\xe9ma oka",
            report_details: "Tov\xe1bbi r\xe9szletek",
            filter_zoom_in: "Nagy\xedts a felold\xe1shoz",
            report_email: "E-mail-c\xedm",
            report_email_placeholder: "Nem k\xf6telez\u0151",
            report_submit: "Bek\xfcld\xe9s",
            report_success: "A jelent\xe9s sikeresen be lett k\xfcldve; a lehet\u0151 leghamarabb megvizsg\xe1ljuk.",
            report_failure: "Hiba t\xf6rt\xe9nt a jelent\xe9s l\xe9trehoz\xe1sakor: {e}. K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb \xfajra.",
            search_user: "Felhaszn\xe1l\xf3n\xe9v keres\xe9se\u2026",
            search_address: "C\xedm, v\xe1ros stb. keres\xe9se\u2026",
            share_embed_docs: "Tov\xe1bbi inform\xe1ci\xf3 a be\xe1gyaz\xe1s konfigur\xe1l\xe1s\xe1r\xf3l",
            error_click: "Kattints a folytat\xe1shoz",
            error_retry: "K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb",
            legend_title: "K\xe9p adatainak megjelen\xedt\xe9se",
            report_whole_sequence: "A teljes sorozatra vonatkozik",
            report_wait: "Jelent\xe9s bek\xfcld\xe9se\u2026",
            report_details_placeholder: "Megadhatsz tov\xe1bbi r\xe9szleteket a probl\xe9m\xe1r\xf3l (nem k\xf6telez\u0151)",
            filter_qualityscore_help: "Kattints az enged\xe9lyez\xe9shez vagy a letilt\xe1shoz",
            filter_qualityscore: "Min\u0151s\xe9gi pontsz\xe1m",
            map_theme_score: "Min\u0151s\xe9gi pontsz\xe1m",
            metadata_camera_resolution: "Felbont\xe1s",
            metadata_quality: "Min\u0151s\xe9g",
            metadata_quality_help: "Tov\xe1bbi tudnival\xf3k a min\u0151s\xe9gi pontsz\xe1mr\xf3l",
            metadata_quality_score: "\xd6sszes\xedtett pontsz\xe1m",
            metadata_quality_gps_score: "Pozicion\xe1l\xe1si pontsz\xe1m",
            metadata_quality_resolution_score: "Felbont\xe1si pontsz\xe1m",
            metadata_quality_missing: "a k\xe9pben nincs megadva \xe9rt\xe9k",
            popup_details_link: "Tov\xe1bbi r\xe9szletek",
            filter_gps_precision_lessthan: "Kevesebb mint {n} m\xe9ter",
            filter_gps_precision_between: "{n1}\u2013{n2} m\xe9ter",
            filter_gps_precision_morethan: "T\xf6bb mint {n} m\xe9ter",
            contribute_id: "Az OpenStreetMap szerkeszt\xe9se az iD szerkeszt\u0151vel",
            geo_uri: "K\xfcls\u0151 alkalmaz\xe1s",
            picture_all: "\xd6sszes",
            picture_flat_long: "Hagyom\xe1nyos k\xe9p",
            picture_360_long: "Panor\xe1mak\xe9p",
            minimize_short: "Elrejt\xe9s",
            panoramax: "Panoramax",
            filter_date_1year: "1 \xe9v",
            filter_date_1month: "1 h\xf3nap",
            whats_panoramax: "A Panoramax a terepen k\xe9sz\xfclt k\xe9pek f\xf6ldrajzi adatb\xe1zisa.",
            filter_user_mypics: "Saj\xe1t k\xe9pek",
            filter_date_6months: "6 h\xf3nap",
            semantics_editor_example: "kulcs=\xe9rt\xe9k\nel\u0151tag|kulcs=\xe9rt\xe9k",
            semantics_copy: "Tulajdons\xe1gok m\xe1sol\xe1sa",
            semantics_overlays: {
                features: "Minden objektum",
                tfsigns: "Jelz\u0151t\xe1bl\xe1k"
            },
            semantics_download_title: "C\xedmk\xe9k let\xf6lt\xe9se",
            semantics_download_info: "Minden szemantikai adat (c\xedmke) ny\xedlt adatk\xe9nt \xe1ll rendelkez\xe9sre. Let\xf6ltheted \xe9s tetsz\xe9s szerint felhaszn\xe1lhatod.",
            filter_gps_precision: "Hely pontoss\xe1ga",
            qualityscore_doc_3: "A a legjobb \xe9s E a legrosszabb.",
            qualityscore_doc_1: "Minden k\xe9phez kisz\xe1m\xedtunk egy min\u0151s\xe9gi pontsz\xe1mot.",
            qualityscore_doc_2: "A pontsz\xe1m bet\u0171k\xe9nt jelenik meg:",
            map_theme_gps: "GPS pontoss\xe1ga",
            metadata_general_copy_id: "Azonos\xedt\xf3 (ID) m\xe1sol\xe1sa",
            metadata_general_instance: "Eredeti p\xe9ld\xe1ny",
            metadata_exif_doc: "EXIF-c\xedmk\xe9k dokument\xe1ci\xf3ja",
            metadata_exif_doc_title: "Az EXIF \xe9s XMP c\xedmk\xe9k defin\xedci\xf3inak teljes le\xedr\xe1sa megtal\xe1lhat\xf3 az Exiv2 dokument\xe1ci\xf3ban",
            semantics_title: "C\xedmk\xe9k",
            semantics_features: "K\xe9pen tal\xe1lhat\xf3 objektumok",
            semantics_annotation_tooltip: "Kattints a r\xe9szletekhez",
            semantics_key: "Kulcs",
            semantics_key_doc: "Tov\xe1bbi tudnival\xf3k err\u0151l a kulcsr\xf3l",
            semantics_edit: "Tulajdons\xe1gok szerkeszt\xe9se",
            semantics_save: "M\xf3dos\xedt\xe1sok ment\xe9se",
            semantics_undo: "M\xf3dos\xedt\xe1sok elvet\xe9se",
            semantics_send_fail: "Nem siker\xfclt menteni a m\xf3dos\xedt\xe1sokat; pr\xf3b\xe1ld meg k\xe9s\u0151bb \xfajra",
            semantics_wikidata_properties: {
                P279: "alkateg\xf3ri\xe1ja ennek:",
                P361: "r\xe9sze ennek:",
                P31: "p\xe9ld\xe1ny:",
                P180: "ezt \xe1br\xe1zolja:"
            },
            semantics_login_needed: "A k\xe9pc\xedmk\xe9k \xe9s az objektumok szerkeszt\xe9s\xe9hez be kell jelentkezned a Panoramax {n} p\xe9ld\xe1ny\xe1ra. Be szeretn\xe9l jelentkezni?",
            semantics_zoom_in: "A c\xedmk\xe9k megtekint\xe9s\xe9hez nagy\xedtsd a t\xe9rk\xe9pet",
            semantics_download: "Let\xf6lt\xe9s",
            semantics_download_cta: "Ny\xedlt adatok let\xf6lt\xe9se",
            semantics_tags: "{nb} c\xedmk\xe9k",
            semantics_features_subtitle: "{nb} kapcsol\xf3d\xf3 tulajdons\xe1g",
            semantics_show_all_tags: "C\xedmk\xe9k megjelen\xedt\xe9se",
            semantics_hide_all_tags: "C\xedmk\xe9k elrejt\xe9se",
            semantics_value: "\xc9rt\xe9k",
            metadata_general_copy_picid: "K\xe9pazonos\xedt\xf3 (ID) m\xe1sol\xe1sa",
            semantics_doc_info1: "C\xedmk\xe9k seg\xedts\xe9g\xe9vel megadhatod a k\xe9p kontextus\xe1t.",
            metadata_summary: "\xd6sszefoglal\xe1s",
            "visibility_logged-only": "Tagok",
            "visibility_title_logged-only": "Ezt a f\xe9nyk\xe9pet csak fi\xf3kkal rendelkez\u0151 szem\xe9lyek l\xe1thatj\xe1k",
            "visibility_owner-only": "Elrejtve",
            "visibility_title_owner-only": "Ezt a k\xe9pet csak te l\xe1thatod",
            semantics_doc_info1u1: "A transport=car c\xedmk\xe9vel jel\xf6lheted, hogy aut\xf3b\xf3l k\xe9sz\xedtetted.",
            semantics_doc_info2: "A k\xe9pen t\xe1rgyakat is felrajzolhatsz: k\xf6z\xfati jelz\xe9seket, \xe9p\xedtm\xe9nyeket, m\u0171t\xe1rgyakat\u2026 Jel\xf6ld meg a l\xe1tottakat a megl\xe9v\u0151 c\xedmk\xe9kkel. Sz\xfcks\xe9g eset\xe9n saj\xe1t c\xedmk\xe9ket is l\xe9trehozhatsz.",
            semantics_zero_annotations: "Erre a k\xe9pre nem rajzoltak objektumot",
            indoor_switch: "\xc9p\xfcleten bel\xfcli terek",
            indoor_selector_expand: "Kattints a rendelkez\xe9sre \xe1ll\xf3 szintek megtekint\xe9s\xe9hez",
            indoor_selector_shrink: "Kattints a minimaliz\xe1l\xe1shoz",
            indoor_selector_levelup: "Ugr\xe1s egy szinttel feljebb",
            indoor_selector_leveldown: "Ugr\xe1s egy szinttel lejjebb",
            indoor_selector_scrollup: "Szintlista g\xf6rget\xe9se felfel\xe9",
            indoor_selector_scrolldown: "Szintlista g\xf6rget\xe9se lefel\xe9",
            semantics_editor_error: "\xc9rv\xe9nytelen a szintaxis (mondattan). A c\xedmke a k\xf6vetkez\u0151k\xe9ppen n\xe9zhet ki:\nkulcs=\xe9rt\xe9k\nel\u0151tag|kulcs=\xe9rt\xe9k\nel\u0151gat|kulcs[min\u0151s\xedt\u0151_kulcs=min\u0151s\xedt\u0151_\xe9rt\xe9k]=\xe9rt\xe9k\n\nA kulcs legfeljebb 256 karakter, az \xe9rt\xe9k pedig legfeljebb 2048 karakter hossz\xfas\xe1g\xfa lehet.",
            qualityscore_doc_link: "Tov\xe1bbi tudnival\xf3k a min\u0151s\xe9gi pontsz\xe1mr\xf3l",
            semantics_draw_annotation: "A hozz\xe1adni k\xedv\xe1nt objektumot r\xe1rajzolhatod a k\xe9pre (nem k\xf6telez\u0151).",
            semantics_delete_annotation_confirm: "T\xe9nyleg t\xf6r\xf6lni szeretn\xe9d ezt a c\xedmk\xe9t?",
            semantics_add_annotation: "\xdaj c\xedmke hozz\xe1ad\xe1sa",
            semantics_delete_annotation: "Objektum t\xf6rl\xe9se",
            filter_gps_precision_help_1: "Minden k\xe9phez tartozik egy helypontoss\xe1gi \xe9rt\xe9k. Ez megfelel annak, hogy a k\xe9p k\xe9sz\xedt\xe9sekor mekkora volt a GPS pontoss\xe1ga.",
            filter_gps_precision_help_2: "A pontoss\xe1got csillagok fejezik ki:",
            filter_gps_precision_help_4: "Egy RTK-t tartalmaz\xf3 GPS \xe9rt\xe9kel\xe9se 5\u2B50, egy GoPo Max-hoz hasonl\xf3 akci\xf3kamer\xe1\xe9 3\u2B50, egy m\xe9lygar\xe1zsban haszn\xe1lt okostelefonos GPS-\xe9 pedig 1\u2B50.",
            filter_gps_precision_help: "Tov\xe1bbi tudnival\xf3k a hely pontoss\xe1g\xe1r\xf3l",
            semantics_doc: "S\xfag\xf3",
            semantics_erase_annotation: "Rajzolt objektum kirad\xedroz\xe1sa",
            qualityscore_doc_41: "a GPS pontoss\xe1ga",
            qualityscore_doc_42: "a k\xe9p felbont\xe1sa",
            qualityscore_doc_5: "Egy professzion\xe1lis k\xe9sz\xfcl\xe9k \xe9rt\xe9ke A, egy 360\xb0-os akci\xf3kamer\xe1\xe9 B, az okostelefonok\xe9 pedig C \xe9s E k\xf6z\xf6tti.",
            qualityscore_doc_4: "A pontsz\xe1m a k\xf6vetkez\u0151kb\u0151l \xe1ll \xf6ssze:",
            metadata_location_copy: "{v} m\xe1sol\xe1sa",
            metadata_location_copy_more: "Tov\xe1bbi koordin\xe1tam\xe1sol\xe1si lehet\u0151s\xe9gek",
            semantics_hide_annotations: "K\xe9pen l\xe9v\u0151 objektumok elrejt\xe9se",
            semantics_qualifiers: "Min\u0151s\xedt\u0151k",
            semantics_picture_tags: "K\xe9p c\xedmk\xe9je",
            semantics_annotation_tags: "Objektum c\xedmk\xe9je",
            semantics_doc_info3: "Egyes objektumok automatikusan felismerhet\u0151k a mesters\xe9ges intelligencia (MI) seg\xedts\xe9g\xe9vel: a min\u0151s\xe9g nem garant\xe1lt.",
            semantics_doc_link: "Tov\xe1bbi tudnival\xf3k a c\xedmk\xe9kr\u0151l",
            semantics_sequence_tags: "Sorozat c\xedmk\xe9je",
            semantics_features_none: "Erre a k\xe9pre m\xe9g nem rajzoltak objektumot.",
            semantics_show_annotations: "K\xe9pen l\xe9v\u0151 objektumok megjelen\xedt\xe9se",
            semantics_features_default_title: "C\xedmke {nb}",
            filter_gps_precision_help_3: "5\u2B50: nagyon ponos (<= {p5} m) \xe9s 1\u2B50: nagyon pontatlan (> {p1} m) vagy ismeretlen.",
            metadata_location_coordinates: "Koordin\xe1ta (hossz\xfas\xe1g, sz\xe9less\xe9g)",
            semantics_value_doc: "Tov\xe1bbi tudnival\xf3k err\u0151l a c\xedmk\xe9r\u0151l",
            semantics_value_show_osm: "Megtekint\xe9s az OpenStreetMapen",
            low_contrast: "Alacsonyabb k\xe9pkontraszt",
            reset_contrast: "K\xe9pkontraszt alaphelyzetbe \xe1ll\xedt\xe1sa",
            metadata_general_title: "C\xedm",
            delete_picture: "T\xf6rl\xe9s",
            delete_picture_error: "Hiba t\xf6r\xe9nt, amikor megpr\xf3b\xe1ltuk t\xf6r\xf6lni a k\xe9pet:\n{e}",
            delete_picture_ok: "A k\xe9p sikeresen t\xf6rl\u0151d\xf6tt",
            filter_locked: "Sz\u0171r\u0151 letiltva",
            map_background_default: "Alap\xe9rtelmezett",
            widget_locked: "Be\xe1ll\xedt\xe1s letiltva",
            map_theme_default_coef: "Lefedetts\xe9g szintje",
            map_theme_default_2: "\xc1tlagos",
            error_pic_load: "A k\xe9p pillanatnyilag nem t\xf6lthet\u0151 be.\nEllen\u0151rizd az internetkapcsolatod. Ha csatlakozva vagy, akkor gy\u0151z\u0151dj meg arr\xf3l, hogy a k\xe9p azonos\xedt\xf3ja (ID) \xe9rv\xe9nyes.",
            filter_source_world: "Eg\xe9sz vil\xe1g",
            filter_source_local: "Ez a kiszolg\xe1l\xf3",
            semantics_empty: "Nincs meghat\xe1rozva c\xedmke",
            time_travel: "Hely megtekint\xe9se m\xe1s id\u0151pontokban",
            time_travel_close: "M\xe1s id\u0151pontok elrejt\xe9se",
            map_theme_default_short: "Alap\xe9rtelmezett",
            map_theme_age_short: "D\xe1tum",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Min\u0151s\xe9g",
            map_theme_gps_short: "Poz\xedci\xf3",
            semantics_draw_invalid_annotation: "A megrajzolt ter\xfclet kil\xf3g a k\xe9pb\u0151l. K\xe9rj\xfck, \xfcgyeljen arra, hogy a l\xe1that\xf3 k\xe9p hat\xe1rain bel\xfcl rajzoljon.",
            semantics_draw_unfinished_annotation: "A megrajzolt ter\xfclet befejezetlen. Figyeljen arra, hogy a ment\xe9s el\u0151tt a ter\xfclet megfelel\u0151en legyen elhelyezve.",
            sequence_play_backwards: "Sorozat lej\xe1tsz\xe1sa visszafel\xe9",
            map_background_more: "Tov\xe1bb",
            map_theme_default_coef_short: "Lefedetts\xe9g",
            map_theme_default_1: "Alacsony",
            map_theme_default_3: "J\xf3",
            map_theme_default_4: "Kit\u0171n\u0151",
            semantics_annotation_tooltip_close: "Kattints a kijel\xf6l\xe9s visszavon\xe1s\xe1hoz",
            delete_picture_warn: "\u26A0\uFE0F Figyelem: ezzel a k\xe9p v\xe9glegesen t\xf6rl\u0151dik.\nBiztosan szeretn\xe9d folytatni?"
        },
        map: {
            loading: "Bet\xf6lt\xe9s\u2026",
            thumbnail: "A kurzor alatti k\xe9p b\xe9lyegk\xe9pe",
            not_public: "Nem l\xe1that\xf3 nyilv\xe1nosan",
            slow_loading: "A t\xe9rk\xe9p lassan t\xf6lt\u0151dik be, \xe9s hib\xe1snak t\u0171nhet",
            more_panoramax: "Ismerd meg jobban a Panoramaxot",
            map_data: "T\xe9rk\xe9p alapja: {m}"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Tart\xf3zkod\xe1si hely megtal\xe1l\xe1sa",
            "GeolocateControl.LocationNotAvailable": "Tart\xf3zkod\xe1si hely nem \xe9rhet\u0151 el"
        }
    },
    it: {
        pnx: {
            expand: "Espandi",
            zoomOut: "Rimpicciolisci",
            zoomIn: "Ingrandisci",
            zoom: "Zoom",
            moveUp: "Muovi in alto",
            moveDown: "Muovi in basso",
            moveLeft: "Muovi a sinistra",
            moveRight: "Muovi a destra",
            expand_info: "Fai apparire il widget a schermo pieno",
            options: "Opzioni",
            filters: "Filtri",
            layers: "Livelli",
            search: "Cerca",
            search_empty: "Nessun risultato trovato",
            search_address: "Cerca un indirizzo, citt\xe0\u2026",
            search_user: "Cerca un nome utente\u2026",
            share: "Condividi",
            share_links: "Collegamenti",
            share_page: "Collegamento a questa immagine",
            share_image: "Immagine HD",
            share_embed: "Incorpora nel tuo sito web",
            share_embed_docs: "Scopri di pi\xf9 sulla configurazione della incorporazione",
            share_print: "Stampa",
            copy: "Copia",
            copied: "Copiato",
            error: "Abbiamo un problema\u2026",
            error_click: "Continuare",
            error_retry: "Riprovare pi\xf9 tardi",
            sequence_play: "Riproduci questa sequenza",
            sequence_pause: "Pausa la sequenza",
            sequence_speed: "Velocit\xe0 di riproduzione",
            legend_license: "Licenza: {l}",
            legend_title: "Mostra dettagli della foto",
            edit_osm: "Modifica OSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Caricamento dei dati della mappa",
                "\uD83D\uDDA5\uFE0F Interrogazione delle API",
                "\uD83D\uDDBC\uFE0F Caricamento delle miniature",
                "\uD83D\uDD0D Analisi dei metadata EXIF",
                "\uD83C\uDFD8\uFE0F Creazione del rendering 3D",
                "\uD83D\uDCF7 Inizializzazione delle foto a 360\xb0",
                "\uD83D\uDFE0 Bilanciamento del colore",
                "\uD83D\uDCAF Calcolo del punteggio della qualit\xe0 \xa9",
                "\uD83D\uDCE1 Scaricamento degli aggiornamenti",
                "\uD83C\uDF0D Recupero dei tasselli della mappa",
                "\uD83D\uDCF8 Elaborazione delle ombre"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C Rilevazione dei cartelli di attraversamento dei cervi",
                "\uD83D\uDE98 Ricerca dell\u2019auto Panoramax \xa9",
                "\u2615 Iniezione di caffeina",
                "\uD83D\uDE00 Sorridete, siete stati mappati!",
                "\uD83D\uDC08 Condivisione delle foto di gatti",
                "\uD83D\uDE34 Riduzione della procrastinazione",
                "\uD83E\uDED6 Preparazione del t\xe8",
                "\uD83D\uDC27 Apertura del codice sorgente",
                "\uD83D\uDE87 Indicizzazione delle stazioni della metro",
                "\uD83E\uDDF9 Pulizia dei metadata",
                "\uD83D\uDE92 Invio delle foto delle stazioni dei pompieri",
                "\uD83D\uDEB2 Aggiornamento delle strade verdi",
                "\uD83D\uDE89 Passeggiata sulle banchine della stazione",
                "\uD83D\uDEF0\uFE0F Ricerca dei satelliti",
                "\uD83D\uDC65 Scrittura delle persone",
                "\uD83D\uDC1F Ricerca dei negozi di patatine fritte",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Debug dell\u2019interfaccia",
                "\uD83D\uDCC8 Incremento delle statistiche",
                "\uD83E\uDD16 Apprendimento della semantica",
                "\uD83C\uDFA8 Riprogettazione dell\u2019interfaccia",
                "\uD83D\uDCC5 Pianificazione di eventi di photo-mapping",
                "\uD83E\uDDC0 Affinamento dei formaggi",
                "\uD83C\uDF04 Calcolo della nebbia in Valpadana",
                "\uD83C\uDF0A Misurazione delle grandi maree"
            ],
            error_psv: "Il visualizzatore delle foto sferiche non si sta caricando correttamente",
            error_pic: "La foto richiesta non \xe8 stata trovata",
            error_nopic: "Nessuna foto disponibile alla posizione richiesta",
            error_api: "Il server delle foto non \xe8 disponibile",
            error_webgl: "Il tuo browser non supporta WebGL",
            error_josm: "JOSM non risponde, \xe8 in esecuzione con il controllo remoto abilitato?",
            error_api_compatibility: "Il server delle foto non \xe8 compatibile con questa versione del visualizzatore",
            filter_date: "Data",
            filter_date_1month: "1 mese",
            filter_date_1year: "1 anno",
            filter_user_mypics: "Le mie foto",
            filter_picture: "Tipo di foto",
            filter_zoom_in: "Ingrandisci per sbloccare",
            picture_flat: "Classica",
            picture_360: "360\xb0",
            filter_qualityscore_help: "Clicca per abilitare o disabilitare",
            map_background: "Sfondo della mappa",
            map_background_aerial: "Satellite",
            map_background_streets: "Strade",
            map_theme: "Tema della mappa",
            map_theme_default: "Classica",
            map_theme_age: "Data di acquisizione",
            map_theme_score: "Punteggio della qualit\xe0",
            contrast: "Abilita un maggiore contrasto della foto",
            metadata: "Metadata della foto",
            metadata_general_picid: "Foto",
            metadata_general_picid_link: "Vai alla descrizione JSON della foto",
            metadata_general_seqid_link: "Vai alla descrizione JSON della sequenza",
            metadata_general_author: "Autore",
            metadata_general_license: "Licenza",
            metadata_general_date: "Data di acquisizione",
            metadata_camera: "Fotocamera",
            metadata_camera_make: "Costruttore",
            metadata_camera_model: "Modello",
            metadata_camera_type: "Tipo",
            metadata_camera_resolution: "Risoluzione",
            metadata_location: "Posizione",
            metadata_location_longitude: "Longitudine",
            metadata_location_latitude: "Latitudine",
            metadata_location_precision: "Precisione della posizione",
            metadata_quality: "Qualit\xe0",
            metadata_quality_score: "Punteggio globale",
            metadata_quality_gps_score: "Punteggio della posizione",
            metadata_quality_resolution_score: "Punteggio della risoluzione",
            metadata_exif: "EXIF",
            metadata_exif_name: "Attributo",
            report_auth: "Questa segnalazione verr\xe0 inviata usando la tua utenza \u201C{a}\u201D",
            report_nature_label: "Causa del problema",
            report_nature: {
                blur_excess: "\xc8 stata applicata ad un oggetto una sfocatura non necessaria",
                inappropriate: "La foto \xe8 inappropriata (non pertinente, nudo, \u2026)",
                mislocated: "La posizione della foto sulla mappa \xe8 sbagliata",
                copyright: "La foto viola il diritto d\u2019autore",
                other: "Qualsiasi altro tipo di problema",
                picture_low_quality: "La foto \xe8 di bassa qualit\xe0",
                "": "Selezione la natura del problema\u2026",
                blur_missing: "Sono visibili la faccia di una persona o la targa di un\u2019auto",
                privacy: "La foto \xe8 stata scattata da un sentiero o propriet\xe0 privata"
            },
            report_whole_sequence: "Riguarda l\u2019intera sequenza",
            report_details: "Ulteriori dettagli",
            report_email: "La tua e-mail",
            report_email_placeholder: "Facoltativo",
            report_submit: "Invia",
            report_wait: "Invio della segnalazione\u2026",
            report_failure: "\xc8 avvenuto un errore durante la creazione della segnalazione: {e}. Riprovare pi\xf9 tardi.",
            moveMiddle: "Centra la visuale",
            show_map: "Mostra la mappa",
            sequence_next: "Prossima foto nella sequenza",
            map_theme_age_1: "> 3 anni",
            map_theme_age_2: "< 3 anni",
            map_theme_age_3: "< 1 anno",
            map_theme_age_4: "< 6 meses",
            map_theme_type: "Tipo di fotocamera",
            minimize: "Nascondi il widget, puoi mostrarlo di nuovo usando il pulsante nell\u2019angolo in basso a sinistra",
            metadata_general_license_link: "Vedi la descrizione completa della licenza",
            share_rss: "Feed RSS",
            show_psv: "Mostra il visualizzatore delle foto",
            share_rss_title: "Feed RSS delle nuove sequenze nell\u2019attuale area visibile della mappa",
            sequence_prev: "Foto precedente della sequenza",
            sequence_more: "Altre opzioni di riproduzione",
            josm_live: "Abilita la sincronizzazione automatica di JOSM al caricamento delle foto",
            metadata_general_seqid: "Sequenza",
            metadata_camera_focal_length: "Lunghezza focale",
            filter_user: "Utente",
            metadata_location_orientation: "Direzione",
            filter_qualityscore: "Punteggio della qualit\xe0",
            metadata_quality_help: "Per saperne di pi\xf9 sul punteggio della qualit\xe0",
            metadata_quality_missing: "Nessun valore impostato nella foto",
            metadata_exif_value: "Valore",
            report: "Segnala",
            report_details_placeholder: "Facoltativo, puoi aggiungere dei dettagli sul problema",
            report_success: "La segnalazione \xe8 stata inviata correttamente. Non appena possibile verr\xe0 esaminata.",
            minimize_short: "Nascondi",
            qualityscore_title: "Informazioni sul punteggio della qualit\xe0",
            qualityscore_doc_1: "Un punteggio sulla qualit\xe0 viene calcolato per ogni foto.",
            qualityscore_doc_2: "Il voto viene mostrato con una lettera:",
            qualityscore_doc_link: "Nella nostra documentazione sono presenti maggiori dettagli sul calcolo del Punteggio della qualit\xe0",
            qualityscore_doc_3: "\u201CA\u201D \xe8 il punteggio pi\xf9 alto, \u201CE\u201D quello pi\xf9 basso.",
            metadata_general_instance: "Istanza di origine",
            josm: "JOSM",
            picture_flat_long: "Foto classica",
            picture_360_long: "Foto panoramica",
            metadata_summary: "Sintesi",
            metadata_general_copy_id: "Copia l\u2019ID",
            metadata_general_copy_picid: "Copia l\u2019ID della foto",
            id: "iD",
            contribute_id: "Contribuisci a OpenStreetMap con l\u2019editor iD",
            geo_uri: "App esterna",
            filter_date_6months: "6 mesi",
            picture_all: "Tutte",
            metadata_exif_doc: "Doc per gli attributi EXIF",
            metadata_exif_doc_title: "Vai alla documentazione di Exiv2 per i dettagli completi sulle definizioni degli attributi EXIF e XMP",
            semantics_value: "Valore",
            semantics_key_doc: "Per saperne di pi\xf9 su questa chiave",
            semantics_title: "Etichette",
            semantics_features: "Oggetti nella foto",
            semantics_features_none: "Non \xe8 ancora stato disegnato alcun oggetto in questa foto.",
            semantics_features_default_title: "Etichetta {nb}",
            semantics_features_subtitle: "{nb} propriet\xe0 associate",
            semantics_tags: "{nb} attributi",
            semantics_show_all_tags: "Mostra tutti gli attributi",
            semantics_hide_all_tags: "Nascondi tutti gli attributi",
            semantics_key: "Chiave",
            semantics_value_doc: "Per saperne di pi\xf9 su questa etichetta",
            semantics_wikidata_properties: {
                P361: "parte di",
                P31: "instanza di",
                P279: "sottoclasse di",
                P180: "raffigura"
            },
            semantics_hide_annotations: "Nascondi gli oggetti nella foto",
            semantics_tags_picture: "Etichette della foto",
            semantics_show_annotations: "Mostra gli oggetti nella foto",
            semantics_annotation_tooltip: "Clicca per vedere i dettagli",
            semantics_tags_picture_none: "Non \xe8 stata ancora aggiunta alcuna etichetta su questa foto.",
            semantics_qualifiers: "Qualificatori",
            metadata_location_coordinates: "Coordinate (longitudine, latitudine)",
            metadata_location_copy: "Copia {v}",
            metadata_location_copy_more: "Ulteriori opzioni per la copia delle coordinate",
            whats_panoramax: "Panoramax \xe8 la geo-commons per le foto dei territori.",
            panoramax: "Panoramax",
            semantics_zero_annotations: "Nessun elemento disegnato su questa immagine",
            semantics_hashtags: "Hashtag dell\u2019immagine",
            semantics_editor_error: "La sintassi non \xe8 valida. Le tue etichette devono avere la seguente forma:\nchiave=valore\nprefisso|chiave=valore\nprefisso|chiave[qualif_chiave=qualif_valore]=valore\n\nLa lunghezza massima di una chiave \xe8 di 256 caratteri, quella di un valore \xe8 di 2048 caratteri.",
            semantics_editor_example: "chiave=valore\nprefisso|chiave=valore",
            semantics_edit: "Modifica gli attributi",
            semantics_save: "Salva le tue modifiche",
            semantics_undo: "Annulla le tue modifiche",
            semantics_send_fail: "Non \xe8 stato possibile salvare le tue modifiche, riprova pi\xf9 tardi",
            semantics_cantsave_invalid: "Impossibile salvare le modifiche, input non valido",
            semantics_send_ok: "Le tue modifiche sono state inviate con successo",
            semantics_add_annotation: "Aggiungi una nuova etichetta",
            semantics_draw_annotation: "Puoi disegnare l\u2019oggetto che vuoi aggiungere sopra l\u2019immagine (facoltativo).",
            semantics_save_drawn_annotation: "Salva posizione",
            semantics_undo_drawn_annotation: "Annulla",
            semantics_save_drawn_annotation_incomplete: "Devi disegnare un rettangolo all\u2019interno dell\u2019immagine prima di validarlo",
            semantics_delete_annotation: "Elimina questo oggetto",
            semantics_delete_annotation_confirm: "Vuoi veramente eliminare questa etichetta?",
            filter_gps_precision: "Precisione della posizione",
            filter_gps_precision_lessthan: "Meno di {n} metri",
            filter_gps_precision_between: "Tra {n1} e {n2} metri",
            filter_gps_precision_morethan: "Pi\xf9 di {n} metri",
            filter_gps_precision_help: "Per saperne di pi\xf9 sulla precisione della posizione",
            qualityscore_doc_4: "Il punteggio \xe8 calcolato basandosi su:",
            qualityscore_doc_41: "la precisione GPS",
            qualityscore_doc_42: "la risoluzione della foto",
            qualityscore_doc_5: "Un dispositivo professionale otterr\xe0 una A, un\u2019action camera a 360\xb0 una B mentre una smartphone si attester\xe0 tra una C e una E.",
            semantics_copy: "Copia gli attributi",
            map_theme_gps: "Precisione della posizione",
            semantics_doc_info1: "Specifica il contesto di una foto utilizzando un\u2019etichetta.",
            semantics_overlays: {
                features: "Tutti gli oggetti",
                tfsigns: "Segnali stradali"
            },
            semantics_doc_info1u1: "Puoi etichettarla come scattata dall\u2019auto con l\u2019etichetta transport=car.",
            semantics_zoom_in: "Ingrandisci la mappa per vedere le etichette",
            semantics_download: "Scarica",
            semantics_download_title: "Scarica le etichette",
            semantics_download_cta: "Scarica i dati aperti",
            semantics_value_show_osm: "Vedi su OpenStreetMap",
            filter_gps_precision_help_2: "La precisione viene espressa con delle stelle:",
            filter_gps_precision_help_3: "\u201C5\u2B50\u201D \xe8 molto preciso (<={p5}m), \u201C1\u2B50\u201D molto impreciso (> {p1}m) o sconosciuto.",
            filter_gps_precision_help_4: "Un GPS RTK otterr\xe0 il voto \u201C5\u2B50\u201D, un\u2019action camera come la GoPro Max il voto \u201C3\u2B50\u201D, il GPS di uno smartphone in un garage sotterraneo un voto \u201C1\u2B50\u201D.",
            semantics_doc: "Assistenza",
            semantics_picture_tags: "Etichetta della foto",
            semantics_annotation_tags: "Etichetta dell\u2019oggetto",
            semantics_doc_link: "Per saperne di pi\xf9 sulle etichette",
            semantics_doc_info3: "Alcuni oggetti vengono automaticamente rilevati con la IA: la qualit\xe0 non \xe8 garantita.",
            semantics_sequence_tags: "Etichetta della sequenza",
            popup_details_link: "Pi\xf9 dettagli",
            semantics_login_needed: "Per modificare le etichette e gli oggetti della foto devi aver effettuato l\u2019accesso alla istanza Panoramax {n}. Vuoi accedere?",
            "visibility_logged-only": "Membri",
            "visibility_owner-only": "Nascosta",
            "visibility_title_owner-only": "Solo tu puoi vedere questa immagine",
            semantics_download_info: "Tutti i dati semantici (etichette) sono disponibili come open data. Puoi scaricarli e usarli come preferisci.",
            indoor_switch: "Planimetrie",
            indoor_selector_expand: "Clicca per vedere tutti i livelli disponibili",
            indoor_selector_shrink: "Clicca per ridurre",
            indoor_selector_levelup: "Vai al livello superiore",
            indoor_selector_leveldown: "Vai al livello inferiore",
            indoor_selector_scrollup: "Scorri la lista dei livelli in alto",
            indoor_selector_scrolldown: "Scorri la lista dei livelli in basso",
            filter_gps_precision_help_1: "Una precisione della posizione \xe8 disponibile per ogni foto. Ci\xf2 corrisponde alla precisione del GPS utilizzato durante lo scatto.",
            "visibility_title_logged-only": "Solo le persone co un\u2019utenza possono vedere questa immagine",
            semantics_erase_annotation: "Elimina l\u2019elemento disegnato",
            semantics_doc_info2: "Puoi anche disegnare gli oggetti nella foto: segnali stradali, attrezzature urbane\u2026 Segna quello che vedi usano le etichette esistenti. Se necessario puoi crearne di nuove.",
            filter_source_world: "Mondo intero",
            filter_source_local: "Questo server",
            filter_locked: "Filtro disabilitato",
            map_background_default: "Predefinito",
            map_background_more: "Altri sfondi...",
            low_contrast: "Riduci il contrasto dell'immagine",
            reset_contrast: "Ripristina contrasto immagine",
            semantics_draw_unfinished_annotation: "L'area tracciata non \xe8 completa. Assicurati che l'area sia ben posizionata prima di salvare.",
            metadata_general_title: "Titolo",
            semantics_draw_invalid_annotation: "L'area disegnata supera i limiti dell'immagine. Assicurati di disegnare all'interno dell'immagine visibile.",
            delete_picture_warn: "\u26A0\uFE0F Attenzione: questo elimina l'immagine in modo permanente.\nSi vuole davvero cancellare completamente questa immagine?",
            delete_picture: "Elimina",
            delete_picture_error: "Si \xe8 verificato un errore nel tentativo di eliminare l'immagine:\n{e}",
            delete_picture_ok: "L'immagine \xe8 stata eliminata con successo",
            error_pic_load: "Impossibile caricare l'immagine al momento.\nControlla la tua connessione Internet. Se sei connesso, assicurati che l'ID dell'immagine sia valido.",
            semantics_empty: "Nessuna etichetta definita"
        },
        psv: {
            loadError: "Impossibile caricare l\u2019immagine panoramica",
            ctrlZoom: "Utilizza Ctrl + rotellina del mouse per ingrandire l\u2019immagine",
            twoFingers: "Usa due dita per spostarti"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Trova la mia posizione",
            "GeolocateControl.LocationNotAvailable": "Posizione non disponibile"
        },
        map: {
            loading: "Caricamento\u2026",
            thumbnail: "Miniatura della foto passata con il mouse",
            not_public: "Non pubblicamente visibile",
            slow_loading: "La mappa impiega troppo tempo a caricarsi e potrebbe apparire a pezzi",
            map_data: "Dati cartografici: {m}",
            more_panoramax: "Per saperne di pi\xf9 su Panoramax"
        }
    },
    ja: {
        pnx: {
            metadata_general_picid: "\u753B\u50CF\u8B58\u5225\u5B50",
            loading_labels_fun: [
                "\uD83E\uDD8C \u9E7F\u306E\u6A2A\u65AD\u6A19\u8B58\u306E\u691C\u51FA",
                "\uD83D\uDE98 Panoramax Car \xa9\u3092\u691C\u7D22",
                "\u2615 \u30AB\u30D5\u30A7\u30A4\u30F3\u306E\u6CE8\u5165",
                "\uD83D\uDE00 \u7B11\u3063\u3066\u304F\u3060\u3055\u3044\u3001\u3042\u306A\u305F\u306F\u5730\u56F3\u306B\u8F09\u3063\u3066\u3044\u307E\u3059\uFF01",
                "\uD83D\uDC08 \u732B\u306E\u5199\u771F\u3092\u5171\u6709\u3059\u308B",
                "\uD83D\uDE34 \u5148\u5EF6\u3070\u3057\u3092\u6E1B\u3089\u3059",
                "\uD83E\uDED6 \u304A\u8336\u3092\u6DF9\u308C\u308B",
                "\uD83D\uDC27 \u30BD\u30FC\u30B9\u30B3\u30FC\u30C9\u3092\u516C\u958B",
                "\uD83D\uDE87 \u5730\u4E0B\u9244\u99C5\u306E\u7D22\u5F15",
                "\uD83E\uDDF9 \u30E1\u30BF\u30C7\u30FC\u30BF\u306E\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7",
                "\uD83D\uDE92 \u6D88\u9632\u7F72\u306E\u5199\u771F\u3092\u9001\u4FE1",
                "\uD83D\uDEB2 \u30B0\u30EA\u30FC\u30F3\u30A6\u30A7\u30A4\u30BA\u306E\u66F4\u65B0",
                "\uD83D\uDE89 \u99C5\u306E\u30DB\u30FC\u30E0\u306E\u30A6\u30A9\u30FC\u30AF\u30B9\u30EB\u30FC",
                "\uD83D\uDEF0\uFE0F \u885B\u661F\u306E\u63A2\u7D22",
                "\uD83D\uDC65 \u30DA\u30EB\u30BD\u30CA\u3092\u66F8\u304F",
                "\uD83D\uDC1F \u30C1\u30C3\u30D7\u30B7\u30E7\u30C3\u30D7\u306E\u5834\u6240",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB \u30C7\u30D0\u30C3\u30B0\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9",
                "\uD83D\uDCC8 \u7D71\u8A08\u306E\u5897\u52A0"
            ],
            share_embed_docs: "\u57CB\u3081\u8FBC\u307F\u8A2D\u5B9A\u306E\u8A73\u7D30\u3092\u8AAD\u3080",
            filter_zoom_in: "\u3053\u306E\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u62E1\u5927\u3057\u3066\u304F\u3060\u3055\u3044",
            metadata_camera_type: "\u30BF\u30A4\u30D7",
            minimize: "\u3053\u306E\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u3092\u975E\u8868\u793A\u306B\u3059\u308B\u306B\u306F\u3001\u5DE6\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u518D\u5EA6\u8868\u793A\u3057\u307E\u3059",
            error_psv: "Photo Sphere Viewer \u304C\u6B63\u3057\u304F\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u305B\u3093\u3067\u3057\u305F",
            error_josm: "JOSM \u304C\u5FDC\u7B54\u3057\u307E\u305B\u3093\u3002\u5B9F\u884C\u3055\u308C\u3066\u3044\u3066\u3001\u30EA\u30E2\u30FC\u30C8\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u304B?",
            filter_user: "\u30E6\u30FC\u30B6\u30FC",
            qualityscore_doc_3: "\u3053\u308C\u306F GPS \u306E\u7CBE\u5EA6\u3068\u753B\u50CF\u306E\u89E3\u50CF\u5EA6\u306B\u57FA\u3065\u3044\u3066\u8A08\u7B97\u3055\u308C\u307E\u3059\u3002\u30D7\u30ED\u4ED5\u69D8\u306E\u30B7\u30B9\u30C6\u30E0\u306F A \u8A55\u4FA1\u3001360\xb0 \u30A2\u30AF\u30B7\u30E7\u30F3 \u30AB\u30E1\u30E9\u306F B \u8A55\u4FA1\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306F C/D/E \u8A55\u4FA1\u306B\u306A\u308A\u307E\u3059\u3002",
            report_nature: {
                inappropriate: "\u5199\u771F\u304C\u4E0D\u9069\u5207\u3067\u3059\uFF08\u7121\u95A2\u4FC2\u3001\u30CC\u30FC\u30C9\u306A\u3069\uFF09",
                "": "\u554F\u984C\u306E\u6027\u8CEA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u2026",
                blur_missing: "\u4EBA\u306E\u9854\u3084\u8ECA\u306E\u30CA\u30F3\u30D0\u30FC\u30D7\u30EC\u30FC\u30C8\u304C\u898B\u3048\u308B",
                blur_excess: "\u307C\u304B\u3059\u5FC5\u8981\u306E\u306A\u3044\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u304C\u307C\u3084\u3051\u3066\u3044\u308B",
                privacy: "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30D1\u30B9\u307E\u305F\u306F\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
                picture_low_quality: "\u753B\u50CF\u306E\u54C1\u8CEA\u304C\u60AA\u3044",
                mislocated: "\u5730\u56F3\u4E0A\u306E\u5199\u771F\u306E\u4F4D\u7F6E\u304C\u9069\u5207\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
                copyright: "\u753B\u50CF\u306F\u8457\u4F5C\u6A29\u3092\u4FB5\u5BB3\u3057\u3066\u3044\u307E\u3059",
                other: "\u305D\u306E\u4ED6\u306E\u554F\u984C"
            },
            sequence_next: "\u6B21\u306E\u753B\u50CF",
            sequence_play: "\u3053\u306E\u30B7\u30FC\u30B1\u30F3\u30B9\u306B\u6CBF\u3063\u3066\u30D7\u30EC\u30A4\u3057\u3066\u304F\u3060\u3055\u3044",
            sequence_pause: "\u4E00\u6642\u505C\u6B62\u30B7\u30FC\u30B1\u30F3\u30B9",
            sequence_prev: "\u524D\u306E\u753B\u50CF",
            sequence_more: "\u3088\u308A\u591A\u304F\u306E\u30D7\u30EC\u30A4\u30AA\u30D7\u30B7\u30E7\u30F3",
            sequence_speed: "\u30D7\u30EC\u30A4\u30E4\u30FC\u306E\u30B9\u30D4\u30FC\u30C9",
            legend_license: "\u30E9\u30A4\u30BB\u30F3\u30B9: {l}",
            legend_title: "\u5199\u771F\u306E\u8A73\u7D30\u3092\u8868\u793A",
            edit_osm: "OSM\u306B\u8CA2\u732E\u3059\u308B",
            josm_live: "\u753B\u50CF\u8AAD\u307F\u8FBC\u307F\u6642\u306BJOSM\u81EA\u52D5\u540C\u671F\u3092\u6709\u52B9\u306B\u3059\u308B",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u30DE\u30C3\u30D7\u30C7\u30FC\u30BF\u306E\u8AAD\u307F\u8FBC\u307F",
                "\uD83D\uDDA5\uFE0F \u30AF\u30A8\u30EAAPI",
                "\uD83D\uDDBC\uFE0F \u30B5\u30E0\u30CD\u30A4\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059",
                "\uD83D\uDD0D EXIF\u30E1\u30BF\u30C7\u30FC\u30BF\u306E\u5206\u6790",
                "\uD83C\uDFD8\uFE0F 3D\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0",
                "\uD83D\uDCF7 360\xb0\u5199\u771F\u3092\u521D\u671F\u5316\u3057\u3066\u3044\u307E\u3059",
                "\uD83D\uDFE0 \u8272\u306E\u30D0\u30E9\u30F3\u30B9",
                "\uD83D\uDCAF \u30B3\u30F3\u30D4\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u54C1\u8CEA\u30B9\u30B3\u30A2 \xa9"
            ],
            error_pic: "\u8981\u6C42\u3055\u308C\u305F\u5199\u771F\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
            error_nopic: "\u6307\u5B9A\u3055\u308C\u305F\u4F4D\u7F6E\u306B\u306F\u753B\u50CF\u304C\u3042\u308A\u307E\u305B\u3093",
            error_api: "\u5199\u771F\u30B5\u30FC\u30D0\u30FC\u304C\u5229\u7528\u3067\u304D\u307E\u305B\u3093",
            error_webgl: "WebGL\u306F\u30D6\u30E9\u30A6\u30B6\u3067\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
            error_api_compatibility: "\u753B\u50CF\u30B5\u30FC\u30D0\u30FC\u306F\u3053\u306E\u30D3\u30E5\u30FC\u30A2\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3068\u4E92\u63DB\u6027\u304C\u3042\u308A\u307E\u305B\u3093",
            filter_date: "\u65E5\u4ED8",
            filter_date_1month: "1\u30F6\u6708",
            filter_date_1year: "1\u5E74",
            filter_user_mypics: "\u79C1\u306E\u5199\u771F",
            filter_picture: "\u753B\u50CF\u30BF\u30A4\u30D7",
            picture_flat: "\u30AF\u30E9\u30B7\u30C3\u30AF",
            picture_360: "360\xb0",
            filter_qualityscore: "\u54C1\u8CEA\u30B9\u30B3\u30A2",
            filter_qualityscore_help: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u6709\u52B9\u307E\u305F\u306F\u7121\u52B9\u306B\u3057\u307E\u3059",
            qualityscore_title: "\u54C1\u8CEA\u30B9\u30B3\u30A2\u306B\u3064\u3044\u3066",
            qualityscore_doc_1: "Panoramax \u306F\u3001\u5404\u5199\u771F\u306B\u54C1\u8CEA\u30B9\u30B3\u30A2\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u5730\u56F3\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u304C\u7C21\u5358\u306B\u306A\u308A\u3001\u9AD8\u54C1\u8CEA\u306E\u5199\u771F\u306E\u53EF\u7528\u6027\u3092\u5305\u62EC\u7684\u306B\u8868\u793A\u3067\u304D\u307E\u3059\u3002",
            qualityscore_doc_2: "\u8A55\u4FA1\u306F A/B/C/D/E \u30B9\u30B3\u30A2 (A \u304C\u6700\u9AD8\u3001E \u304C\u6700\u4F4E) \u3068\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u3001\u6B21\u306E\u30B9\u30B1\u30FC\u30EB\u3067\u30B0\u30E9\u30D5\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
            qualityscore_doc_link: "\u54C1\u8CEA\u30B9\u30B3\u30A2\u306E\u8A08\u7B97\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
            map_background: "\u5730\u56F3\u306E\u80CC\u666F",
            map_background_aerial: "\u822A\u7A7A\u5199\u771F",
            map_background_streets: "\u901A\u308A",
            map_theme: "\u30DE\u30C3\u30D7\u30C6\u30FC\u30DE",
            map_theme_default: "\u30AF\u30E9\u30B7\u30C3\u30AF",
            map_theme_age: "\u64AE\u5F71\u65E5",
            map_theme_age_1: "3\u6B73\u4EE5\u4E0A",
            map_theme_age_2: "3\u6B73\u672A\u6E80",
            map_theme_age_3: "1\u6B73\u672A\u6E80",
            map_theme_age_4: "6\u304B\u6708\u672A\u6E80",
            map_theme_type: "\u30AB\u30E1\u30E9\u30BF\u30A4\u30D7",
            map_theme_score: "\u54C1\u8CEA\u30B9\u30B3\u30A2",
            contrast: "\u3088\u308A\u9AD8\u3044\u753B\u50CF\u30B3\u30F3\u30C8\u30E9\u30B9\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B",
            metadata: "\u753B\u50CF\u30E1\u30BF\u30C7\u30FC\u30BF",
            metadata_general_seqid: "\u30B7\u30FC\u30B1\u30F3\u30B9\u8B58\u5225\u5B50",
            metadata_general_picid_link: "\u753B\u50CF\u306EJSON\u8AAC\u660E\u3078\u79FB\u52D5",
            metadata_general_seqid_link: "\u30B7\u30FC\u30B1\u30F3\u30B9\u306EJSON\u8A18\u8FF0\u3078\u79FB\u52D5",
            metadata_general_author: "\u8457\u8005",
            metadata_general_license: "\u30E9\u30A4\u30BB\u30F3\u30B9",
            metadata_general_license_link: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u5B8C\u5168\u306A\u8AAC\u660E\u3092\u898B\u308B",
            metadata_general_date: "\u64AE\u5F71\u65E5",
            metadata_camera: "\u30AB\u30E1\u30E9",
            metadata_camera_make: "\u30E1\u30FC\u30AB\u30FC",
            metadata_camera_model: "\u30E2\u30C7\u30EB",
            metadata_camera_resolution: "\u89E3\u50CF\u5EA6",
            metadata_camera_focal_length: "\u7126\u70B9\u8DDD\u96E2",
            metadata_location: "\u4F4D\u7F6E",
            metadata_location_longitude: "\u7D4C\u5EA6",
            metadata_location_latitude: "\u7DEF\u5EA6",
            metadata_location_orientation: "\u64AE\u5F71\u65B9\u5411",
            metadata_location_precision: "\u4F4D\u7F6E\u6C7A\u3081\u7CBE\u5EA6",
            metadata_quality: "\u54C1\u8CEA\u30B9\u30B3\u30A2",
            metadata_quality_help: "\u54C1\u8CEA\u30B9\u30B3\u30A2\u306B\u3064\u3044\u3066\u8A73\u3057\u304F\u77E5\u308B",
            metadata_quality_score: "\u30B0\u30ED\u30FC\u30D0\u30EB\u30B9\u30B3\u30A2",
            metadata_quality_gps_score: "\u30DD\u30B8\u30B7\u30E7\u30CB\u30F3\u30B0\u30B9\u30B3\u30A2",
            metadata_quality_resolution_score: "\u89E3\u6C7A\u30B9\u30B3\u30A2",
            metadata_quality_missing: "\u753B\u50CF\u306B\u5024\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
            metadata_exif: "EXIF / XMP",
            metadata_exif_name: "\u30BF\u30B0",
            metadata_exif_value: "\u4FA1\u5024",
            report: "\u5199\u771F\u3092\u5831\u544A\u3059\u308B",
            report_auth: "\u3053\u306E\u30EC\u30DD\u30FC\u30C8\u306F\u3042\u306A\u305F\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u300C{a}\u300D\u3092\u4F7F\u7528\u3057\u3066\u9001\u4FE1\u3055\u308C\u307E\u3059",
            report_nature_label: "\u554F\u984C\u306E\u6027\u8CEA",
            report_whole_sequence: "\u3053\u308C\u306F\u30B7\u30FC\u30B1\u30F3\u30B9\u5168\u4F53\u306B\u95A2\u4FC2\u3059\u308B",
            report_details: "\u8FFD\u52A0\u306E\u8A73\u7D30",
            report_details_placeholder: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3068\u3057\u3066\u3001\u554F\u984C\u306E\u8A73\u7D30\u3068\u305D\u308C\u304C\u3069\u306E\u3088\u3046\u306B\u95A2\u4FC2\u3057\u3066\u3044\u308B\u304B\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059",
            report_email: "\u3042\u306A\u305F\u306E\u30E1\u30FC\u30EB",
            report_email_placeholder: "\u30AA\u30D7\u30B7\u30E7\u30F3",
            report_submit: "\u9001\u4FE1",
            report_wait: "\u30EC\u30DD\u30FC\u30C8\u3092\u9001\u4FE1\u3057\u3066\u3044\u307E\u3059\u2026",
            report_success: "\u30EC\u30DD\u30FC\u30C8\u306F\u6B63\u5E38\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u78BA\u8A8D\u3055\u308C\u307E\u3059\u3002",
            report_failure: "\u30EC\u30DD\u30FC\u30C8\u306E\u4F5C\u6210\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F: {e}\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
            zoom: "\u30BA\u30FC\u30E0",
            zoomOut: "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8",
            zoomIn: "\u30BA\u30FC\u30E0\u30A4\u30F3",
            moveUp: "\u4E0A\u306B\u79FB\u52D5",
            moveDown: "\u4E0B\u306B\u79FB\u52D5",
            moveLeft: "\u5DE6\u306B\u79FB\u52D5",
            moveRight: "\u53F3\u306B\u79FB\u52D5",
            moveMiddle: "\u30D3\u30E5\u30FC\u3092\u4E2D\u592E\u306B\u914D\u7F6E\u3059\u308B",
            expand: "\u62E1\u5927\u3059\u308B",
            expand_info: "\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u3092\u5168\u30DA\u30FC\u30B8\u306B\u8868\u793A\u3059\u308B",
            show_psv: "\u753B\u50CF\u30D3\u30E5\u30FC\u30A2\u3092\u8868\u793A\u3059\u308B",
            show_map: "\u5730\u56F3\u3092\u8868\u793A",
            minimize_short: "\u96A0\u308C\u308B",
            options: "\u30AA\u30D7\u30B7\u30E7\u30F3",
            filters: "\u30D5\u30A3\u30EB\u30BF\u30FC",
            layers: "\u30EC\u30A4\u30E4\u30FC",
            search: "\u691C\u7D22",
            search_empty: "\u7D50\u679C\u306A\u3057",
            search_address: "\u4F4F\u6240\u3001\u5E02\u533A\u753A\u6751\u306A\u3069\u3092\u691C\u7D22",
            search_user: "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u691C\u7D22\u2026",
            share: "\u5171\u6709",
            share_links: "\u30EA\u30F3\u30AF",
            share_page: "\u3053\u306E\u30DA\u30FC\u30B8\u3078\u306E\u30EA\u30F3\u30AF",
            share_image: "HD\u753B\u50CF",
            share_rss: "RSS\u30D5\u30A3\u30FC\u30C9",
            share_rss_title: "\u73FE\u5728\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30DE\u30C3\u30D7\u30A8\u30EA\u30A2\u5185\u306E\u65B0\u3057\u3044\u30B7\u30FC\u30B1\u30F3\u30B9\u306E RSS \u30D5\u30A3\u30FC\u30C9",
            share_embed: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306B\u57CB\u3081\u8FBC\u3080",
            share_print: "\u5370\u5237",
            copy: "\u30B3\u30D4\u30FC",
            copied: "\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
            error: "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u2026",
            error_click: "\u7D9A\u304F",
            error_retry: "\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044"
        },
        map: {
            loading: "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
            thumbnail: "\u30DB\u30D0\u30FC\u3057\u305F\u753B\u50CF\u306E\u30B5\u30E0\u30CD\u30A4\u30EB",
            not_public: "\u516C\u958B\u3055\u308C\u306A\u3044",
            slow_loading: "\u30DE\u30C3\u30D7\u306E\u8AAD\u307F\u8FBC\u307F\u304C\u9045\u304F\u3001\u58CA\u308C\u3066\u3044\u308B\u3088\u3046\u306B\u898B\u3048\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059"
        },
        psv: {
            twoFingers: "2\u672C\u306E\u6307\u3067\u79FB\u52D5\u3057\u307E\u3059",
            ctrlZoom: "Ctrl + \u30B9\u30AF\u30ED\u30FC\u30EB\u3067\u753B\u50CF\u3092\u62E1\u5927\u3057\u307E\u3059",
            loadError: "\u753B\u50CF\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "\u81EA\u5206\u306E\u4F4D\u7F6E\u3092\u8868\u793A",
            "GeolocateControl.LocationNotAvailable": "GPS\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093"
        }
    },
    nl: {
        pnx: {
            zoomIn: "Zoom in",
            zoom: "Zoom",
            zoomOut: "Zoom uit",
            moveDown: "Naar beneden",
            search_user: "Zoek een gebruikersnaam\u2026",
            moveUp: "Ga omhoog",
            share_rss: "RSS-feed",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Kaart aan het laden",
                "\uD83D\uDDA5\uFE0F API opvragen",
                "\uD83D\uDDBC\uFE0F Miniatuurweergaven laden",
                "\uD83D\uDD0D EXIF metadata analyseren",
                "\uD83C\uDFD8\uFE0F 3D-rendering",
                "\uD83D\uDCF7 360\xb0 afbeelden initialiseren",
                "\uD83D\uDFE0 Kleur balancering",
                "\uD83D\uDCAF Bereken kwaliteits-score \xa9",
                "\uD83D\uDCE1 Updates downloaden",
                "\uD83C\uDF0D Kaarttegels ophalen",
                "\uD83D\uDCF8 Schaduwen verwerken"
            ],
            share_embed_docs: "Lees meer over embedded instellingen",
            sequence_pause: "Pauzeer sequentie",
            sequence_prev: "Vorige afbeelding uit de sequentie",
            id: "iD",
            josm: "JOSM",
            sequence_more: "Meer afspeelmogelijkheden",
            sequence_speed: "Afspeel snelheid",
            edit_osm: "OSM aanpassen",
            moveLeft: "Naar links",
            moveRight: "Naar rechts",
            moveMiddle: "Middelpunt",
            expand: "Vergroot",
            show_psv: "Toon de afbeeldingsviewer",
            show_map: "Toon de kaart",
            options: "Opties",
            filters: "Filters",
            layers: "Lagen",
            search: "Zoek",
            search_empty: "Geen resultaat gevonden",
            search_address: "Zoek een adres, een stad \u2026",
            share: "Deel",
            share_links: "Links",
            share_page: "Link naar deze foto",
            share_image: "HD afbeelding",
            share_embed: "Embedden op uw website",
            share_print: "Afdrukken",
            copy: "Kopieer",
            copied: "Gekopieerd",
            error: "We hebben een probleem\u2026",
            sequence_next: "Volgende afbeelding van de sequentie",
            error_click: "Klik om verder te gaan",
            error_retry: "Probeer later opnieuw",
            legend_license: "Licentie: {l}",
            legend_title: "Toon gegevens van de afbeelding",
            sequence_play: "Speel deze sequentie af",
            expand_info: "De widget op de volledige pagina weergeven",
            minimize: "Verberg deze widget, je kan hem terug tonen met de knop linksonder",
            loading_labels_fun: [
                "\uD83E\uDD8C Detectie verkeersborden overstekende herten",
                "\uD83D\uDE98 Panoramax auto zoeken \xa9",
                "\u2615 Cafe\xefne-injectie",
                "\uD83D\uDE00 Gelukt, je kaart is gekaart!",
                "\uD83D\uDC08 Foto's delen van katten",
                "\uD83D\uDE34 Uitstelgedrag verminderen",
                "\uD83E\uDED6 Thee zetten",
                "\uD83D\uDC27 Broncode openen",
                "\uD83D\uDE87 Indexering metrostations",
                "\uD83E\uDDF9 Metadata opschonen",
                "\uD83D\uDE92 Foto's van brandweerkazernes versturen",
                "\uD83D\uDEB2 Fiets- en wandelpaden bijwerken",
                "\uD83D\uDE89 Perron afwandelen",
                "\uD83D\uDEF0\uFE0F Satellieten zoeken",
                "\uD83D\uDC65 Personas opslaan",
                "\uD83E\uDD5E Pannenkoekenhuizen localiseren",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Interface debuggen",
                "\uD83D\uDCC8 Statistieken verhogen",
                "\uD83E\uDD16 Semantiek aanleren",
                "\uD83C\uDFA8 Interface herontwerpen",
                "\uD83D\uDCC5 Fotomappingparty's plannen",
                "\uD83E\uDDC0 Kazen laten rijpen",
                "\uD83C\uDF04 Prachtige zonneschijn berekenen",
                "\uD83C\uDF0A Meten van het hoogwater"
            ],
            share_rss_title: "RSS-feed van nieuwe reeksen in het nu zichtbare kaartgebied",
            josm_live: "Schakel JOSM automatische synchronisatie in bij het laden van afbeeldingen",
            minimize_short: "Verbergen",
            error_psv: "Photo Sphere Viewer werd niet correct geladen",
            error_nopic: "Geen foto beschikbaar op de aangegeven locatie",
            error_api: "De fotoserver is niet beschikbaar",
            error_webgl: "WebGL wordt niet ondersteund door je browser",
            error_api_compatibility: "De fotoserver is niet compatibel met deze viewer",
            filter_date_1month: "1 maand",
            filter_date_1year: "1 jaar",
            filter_user: "Gebruiker",
            filter_user_mypics: "Mijn foto's",
            filter_picture: "Afbeeldingstype",
            picture_flat: "Klassiek",
            picture_360: "360\xb0",
            filter_qualityscore: "Kwaliteitsscore",
            qualityscore_doc_2: "The score wordt getoond als een letter:",
            qualityscore_doc_link: "Meer weten over de Kwaliteitsscore",
            map_background: "Achtergrond",
            map_background_aerial: "Satelliet",
            map_background_streets: "Straten",
            map_theme: "Thema",
            map_theme_default: "Standaard",
            map_theme_age: "Opnamedatum",
            map_theme_age_1: "> 3 jaar",
            map_theme_age_2: "< 3 jaar",
            map_theme_age_3: "\xbd - 1 jaar",
            map_theme_age_4: "< 6 maand",
            filter_qualityscore_help: "Klik om aan- of uit te schakelen",
            report_failure: "Er is een fout opgetreden bij het aanmaken van het rapport: {e}. Probleem later opnieuw.",
            map_theme_score: "Kwaliteitsscore",
            contrast: "Afbeeldingscontrast verhogen",
            metadata: "Metadata van de foto",
            metadata_camera_make: "Fabrikant",
            filter_date: "Datum",
            filter_zoom_in: "Zoom in om te bekijken",
            metadata_general_license_link: "De volledige beschrijving van de licentie bekijken",
            metadata_general_seqid: "Serie",
            metadata_general_picid_link: "Ga naar de JSON-beschrijving van de foto",
            metadata_general_seqid_link: "Ga naar de JSON-beschrijving van de sequentie",
            metadata_general_author: "Auteur",
            error_josm: "JOSM antwoordde niet, is het actief en is afstandsbediening ingeschakeld?",
            qualityscore_title: "Over de kwaliteitsscore",
            metadata_general_license: "Licentie",
            error_pic: "De gevraagde foto werd niet gevonden",
            metadata_general_picid: "Afbeelding",
            metadata_general_date: "Opnamedatum",
            map_theme_type: "Cameratype",
            qualityscore_doc_1: "Voor elke afbeelding wordt een kwaliteitsscore berekend.",
            qualityscore_doc_3: "\u201CA\u201D is het slechtst, \u201CE\u201D het best.",
            report_details_placeholder: "Je kan, optioneel, details over het probleem toevoegen",
            metadata_camera: "Apparaat",
            metadata_camera_model: "Model",
            metadata_camera_type: "Type",
            metadata_camera_resolution: "Resolutie",
            metadata_camera_focal_length: "Brandpuntsafstand",
            metadata_location: "Positie",
            metadata_location_longitude: "Longitude",
            metadata_location_latitude: "Latitude",
            metadata_location_orientation: "Richting",
            metadata_location_precision: "Nauwkeurigheid van de positionering",
            metadata_quality: "Kwaliteit",
            metadata_quality_help: "Meer weten over de Kwaliteitsscore",
            metadata_quality_score: "Globale score",
            metadata_quality_gps_score: "Positioneringsscore",
            metadata_quality_resolution_score: "Resolutiescore",
            metadata_quality_missing: "geen info in de afbeelding",
            metadata_exif: "EXIF",
            metadata_exif_name: "Tag",
            metadata_exif_value: "Waarde",
            report: "Rapporteer",
            report_auth: 'Dit rapport zal worden verstuurd met je account "{a}"',
            report_nature_label: "Oorzaak van het probleem",
            report_nature: {
                "": "Selecteer de aard van het probleem \u2026",
                blur_missing: "Het gezicht van een persoon of een nummerplaat is zichtbaar",
                blur_excess: "Een overbodige vervaging werd toegepast op een object",
                inappropriate: "De foto is ongepast (ongerelateerd, naaktheid \u2026)",
                privacy: "De foto werd genomen vanop een privaat pad of eigendom",
                picture_low_quality: "De foto is van lage kwaliteit",
                mislocated: "De foto is slecht gepositioneerd",
                copyright: "De foto schendt het auteursrecht",
                other: "Een ander soort probleem"
            },
            report_whole_sequence: "Dit betreft de volledige sequentie",
            report_details: "Aanvullende details",
            report_email: "Je e-mail",
            report_email_placeholder: "Optioneel",
            report_submit: "Verzenden",
            report_wait: "Rapport verzenden \u2026",
            report_success: "Het rapport werd succesvol verzonden. Het zal zo snel mogelijk behandeld worden.",
            whats_panoramax: "Panoramax is de geo-commons voor foto's van gebieden.",
            contribute_id: "Bijdragen aan OpenStreetMap met de iD-editor",
            geo_uri: "Externe app",
            semantics_hide_all_tags: "Verberg alle tags",
            semantics_key: "Sleutel",
            semantics_value: "Waarde",
            semantics_key_doc: "Meer weten over deze sleutel",
            semantics_value_doc: "Meer weten over deze tag",
            semantics_title: "Tags",
            semantics_tags: "{nb} tags",
            semantics_features: "Objecten in de foto",
            semantics_features_none: "Er is nog geen object getekend in deze afbeelding.",
            semantics_features_default_title: "Tag {nb}",
            semantics_features_subtitle: "{nb} geassocieerde eigenschappen",
            semantics_show_all_tags: "Toon alle tags",
            metadata_general_instance: "Bron instance",
            semantics_annotation_tooltip: "Klik om details te zien",
            semantics_tags_picture: "Afbeelding tags",
            semantics_tags_picture_none: "Er zijn nog geen tags ingesteld voor deze afbeelding.",
            semantics_qualifiers: "Kwalificaties",
            semantics_show_annotations: "Objecten in de foto weergeven",
            semantics_hide_annotations: "Objecten in de foto verbergen",
            semantics_wikidata_properties: {
                P31: "Instance van",
                P279: "subklasse van",
                P361: "onderdeel van",
                P180: "beeldt af"
            },
            metadata_exif_doc: "Documenten voor EXIF-tags",
            metadata_exif_doc_title: "Ga naar de documentatie van Exiv2 voor alle details over de definities van EXIF- en XMP-tags",
            metadata_location_copy: "Kopieer {v}",
            metadata_location_copy_more: "Meer kopieeropties voor co\xf6rdinaten",
            metadata_general_copy_picid: "Kopieer afbeelding ID",
            filter_date_6months: "6 maanden",
            picture_360_long: "Panorama afbeelding",
            metadata_summary: "Samenvatting",
            metadata_general_copy_id: "Kopieer ID",
            picture_flat_long: "Klassieke afbeelding",
            metadata_location_coordinates: "Co\xf6rdinaten (lengtegraad, breedtegraad)",
            picture_all: "Alles",
            semantics_zero_annotations: "Geen objecten getekend in deze afbeelding",
            semantics_hashtags: "Foto-hashtags",
            panoramax: "Panoramax",
            semantics_editor_error: "De syntax is ongeldig. Je tags moeten eruit zien als:\nsleutel=waarde\nprefix|sleutel=waarde\nprefix|sleutel[qualif_sleutel=qualif_waarde]=waarde\n\nMaximale lengte van de sleutel: 256 karakters, maximale lengte van de waarde: 2048 karakters.",
            semantics_save: "Je wijzigingen opslaan",
            semantics_editor_example: "sleutel=waarde\nprefix|sleutel=waarde",
            semantics_edit: "De attributen bewerken",
            semantics_undo: "Je bewerkingen annuleren",
            semantics_send_ok: "Je bewerkingen werden succesvol verzonden",
            semantics_cantsave_invalid: "Kan wijzigingen niet opslaan, input is ongeldig",
            semantics_send_fail: "Wijzigingen opslaan mislukt, probeer later opnieuw",
            semantics_save_drawn_annotation: "Bewaar positie",
            semantics_undo_drawn_annotation: "Annuleer",
            semantics_save_drawn_annotation_incomplete: "Er moet een rechthoek getekend worden die op de afbeelding past voor validatie mogelijk is",
            semantics_delete_annotation: "Verwijder dit object",
            semantics_delete_annotation_confirm: "Ben je zeker dat je deze tag wil verwijderen?",
            semantics_add_annotation: "Voeg een nieuwe tag toe",
            semantics_draw_annotation: "Je kan het object dat je wil toevoegen tekenen over de foto (optioneel).",
            filter_gps_precision_lessthan: "Minder dan {n} meter",
            filter_gps_precision_between: "Tussen {n1} en {n2} meter",
            filter_gps_precision_morethan: "Meer dan {n} meter",
            map_theme_gps: "GPS-precisie",
            filter_gps_precision: "Locatieprecisie",
            semantics_login_needed: "Om tags of objecten te bewerken moet je inloggen op de Panoramax-instantie {n}. Wil je inloggen?",
            semantics_doc_info3: "Sommige objecten worden automatisch gedetecteerd aan de hand van AI: kwaliteit is niet gegarandeerd.",
            semantics_sequence_tags: "Sequentietag",
            semantics_picture_tags: "Fototag",
            semantics_annotation_tags: "Objecttag",
            semantics_doc_info1: "Geef context over een foto door gebruik te maken van een tag.",
            semantics_doc_info2: "Je kan eveneens objecten tekenen in de foto: verkeersborden, straatmeubilair \u2026 Geef aan wat je zien aan de hand van de bestaande tags. Je kan ook je eigen tag cre\xebren mocht dat nodig zijn.",
            semantics_doc_link: "Meer weten over tags (volledige documentatie, in het Engels)",
            semantics_doc: "Hulp",
            semantics_doc_title: "Over de tags",
            semantics_erase_annotation: "Getekend object verwijderen",
            semantics_overlays: {
                tfsigns: "Verkeersborden",
                features: "Alle objecten"
            },
            semantics_doc_info1u1: "Gebruik bijvoorbeeld de tag transport=car om aan te geven dat een foto vanuit een auto genomen werd.",
            semantics_zoom_in: "Zoom in op de kaart om tags te zien",
            semantics_download: "Downloaden",
            semantics_download_title: "Download tags",
            semantics_download_info: "Alle semantische data (tags) zijn beschikbaar als open data. Je kan ze downloaden en vrij gebruiken.",
            semantics_download_cta: "Open data downloaden",
            semantics_copy: "Attributen kopi\xebren",
            popup_details_link: "Meer details",
            "visibility_logged-only": "Leden",
            "visibility_title_logged-only": "Enkel personen met een account kunnen deze afbeelding zien",
            "visibility_owner-only": "Verborgen",
            "visibility_title_owner-only": "Enken jij kan deze afbeelding zien",
            indoor_selector_expand: "Klik om alle beschikbare niveau's te zien",
            indoor_selector_shrink: "Klik om te minimaliseren",
            indoor_selector_leveldown: "Ga een verdieping omlaag",
            indoor_selector_scrollup: "Scrol de verdiepenlijst naar boven",
            indoor_selector_scrolldown: "Scrol de verdiepenlijst naar onder",
            semantics_value_show_osm: "Bekijken op OpenStreetMap",
            filter_gps_precision_help_2: "De precisie wordt uitgedrukt aan de hand van sterren:",
            filter_gps_precision_help_3: "\u201C5\u2B50\u201D is zeer precies (<= {p5}m), \u201C1\u2B50\u201D is zeer weinig precies (> {p1}m) of onbekend.",
            filter_gps_precision_help_4: "Een RTK-GPS zal een \u201C5\u2B50\u201D-score hebben, een sportieve camera (zoals een GoPro Max) een \u201C3\u2B50\u201D-score, en een smartphone in een ondergrondse parking een \u201C1\u2B50\u201D-score.",
            filter_gps_precision_help: "Meer weten over de locatieprecisie",
            filter_gps_precision_help_1: "Voor elke afbeelding is een locatieprecisiescore beschikbaar. Deze komt overeen met de GPS-precisie op het moment dat de foto werd genomen.",
            indoor_selector_levelup: "Ga een verdieping omhoog",
            indoor_switch: "Binnenruimten",
            qualityscore_doc_4: "Deze score wordt berekend op basis van:",
            qualityscore_doc_41: "de GPS-precisie",
            qualityscore_doc_42: "de resolutie van de foto",
            qualityscore_doc_5: "Een professioneel toestel zal een A-score hebben, een sportieve 360\xb0-camera een B-score, en een smartphone een score tussen C en E.",
            filter_source_world: "Volledige wereld",
            filter_source_local: "Deze server",
            filter_locked: "Filter uitgeschakeld",
            map_background_more: "Meer",
            map_background_default: "Standaard",
            error_pic_load: "De foto kan op dit moment niet geladen worden.\nKijk je internetverbinding na. Indien je verbonden bent, verifieer dan of de ID van de foto geldig is.",
            semantics_draw_invalid_annotation: "De getekende zone overschrijdt de limieten van de foto. Teken enkel binnen de zichtbare afbeelding.",
            semantics_draw_unfinished_annotation: "De getekende zone is niet afgewerkt. Zorg ervoor dat ze correct gepositioneerd is vooraleer op te slaan.",
            low_contrast: "Afbeeldingscontrast verlagen",
            reset_contrast: "Afbeeldingscontrast resetten",
            delete_picture: "Verwijderen",
            delete_picture_warn: "\u26A0\uFE0F Opgelet: dit zal de afbeelding definitief verwijderen.\nBen je zeker dat je wil doorgaan?",
            delete_picture_ok: "De foto werd succesvol verwijderd",
            delete_picture_error: "Er is een fout opgetreden bij het verwijderen van de foto:\n{e}",
            semantics_empty: "Geen tags gedefinieerd",
            metadata_general_title: "Titel",
            widget_locked: "Optie uitgeschakeld",
            map_theme_default_coef: "Dekkingsniveau",
            map_theme_default_coef_short: "Dekking",
            map_theme_default_1: "Laag",
            map_theme_default_2: "Gemiddeld",
            map_theme_default_3: "Goed",
            map_theme_default_4: "Excellent",
            time_travel: "Bekijk deze plaats op andere data",
            time_travel_close: "Andere data verbergen",
            map_theme_default_short: "Klassiek",
            map_theme_score_short: "Kwaliteit",
            map_theme_gps_short: "Positie",
            map_theme_age_short: "Datum",
            map_theme_type_short: "Camera",
            sequence_play_backwards: "Deze sequentie afspelen, achterwaards"
        },
        psv: {
            twoFingers: "Gebruik twee vingers om te navigeren",
            ctrlZoom: "Gebruik ctrl + scroll om de afbeelding in en uit te zoomen",
            loadError: "Het panorama kan niet worden geupload"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Mijn locatie zoeken",
            "GeolocateControl.LocationNotAvailable": "Locatitie niet beschikbaar"
        },
        map: {
            loading: "Laden \u2026",
            slow_loading: "De kaart laadt traag en kan er gebroken uitzien",
            thumbnail: "Thumbnail van de aangeduide foto",
            not_public: "Niet openbaar zichtbaar",
            map_data: "Kaartdata: {m}",
            more_panoramax: "Meer weten over Panoramax"
        }
    },
    pl: {
        pnx: {
            moveRight: "Przesu\u0144 w prawo",
            sequence_speed: "Pr\u0119dko\u015B\u0107 odtwarzania",
            metadata_camera_model: "Model",
            search_address: "Szukaj adres, miasto\u2026",
            zoom: "Przybli\u017Cenie",
            zoomIn: "Przybli\u017C",
            moveUp: "Przesu\u0144 w g\xf3r\u0119",
            moveDown: "Przesu\u0144 w d\xf3\u0142",
            moveLeft: "Przesu\u0144 w lewo",
            moveMiddle: "Wycentruj widok",
            expand: "Rozszerz",
            show_psv: "Poka\u017C przegl\u0105dark\u0119 zdj\u0119\u0107",
            show_map: "Poka\u017C map\u0119",
            options: "Opcje",
            filters: "Filtry",
            layers: "Warstwy",
            search: "Szukaj",
            search_empty: "Brak wynik\xf3w",
            search_user: "Szukaj nazwy u\u017Cytkownika\u2026",
            share: "Udost\u0119pnij",
            share_links: "Linki",
            share_page: "Link do tego zdj\u0119cia",
            share_rss: "Kana\u0142 RSS",
            share_print: "Drukuj",
            copy: "Kopiuj",
            copied: "Skopiowano",
            error: "Mamy problem\u2026",
            error_click: "Kliknij, aby kontynuowa\u0107",
            error_retry: "Prosz\u0119 spr\xf3buj p\xf3\u017Aniej",
            sequence_next: "Nast\u0119pne zdj\u0119cie w sekwencji",
            sequence_pause: "Spauzuj sekwencj\u0119",
            sequence_prev: "Poprzednie zdj\u0119cie w sekwencji",
            sequence_more: "Wi\u0119cej opcji odtwarzania",
            legend_license: "Licencja: {l}",
            legend_title: "Poka\u017C szczeg\xf3\u0142y zdj\u0119cia",
            edit_osm: "Edytuj OSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Wczytywanie danych mapy",
                "\uD83D\uDDA5\uFE0F Odpytywanie API",
                "\uD83D\uDDBC\uFE0F Wczytywanie miniaturek",
                "\uD83D\uDD0D Analizowanie metadanych EXIF",
                "\uD83C\uDFD8\uFE0F Renderowanie 3D",
                "\uD83D\uDCF7 Inicjowanie zdj\u0119\u0107 360\xb0",
                "\uD83D\uDFE0 Balansowanie kolor\xf3w",
                "\uD83D\uDCAF Obliczanie oceny jako\u015Bci \xa9",
                "\uD83D\uDCE1 Pobieranie aktualizacji",
                "\uD83C\uDF0D Pobieranie kafelk\xf3w map",
                "\uD83D\uDCF8 Procesowanie cieniowania"
            ],
            map_theme_age_2: "< 3 lata",
            map_theme_age_1: "> 3 lata",
            map_theme_age_3: "< rok",
            map_theme_age_4: "< 6 miesi\u0105c",
            map_theme_age: "Data zrobienia",
            filter_picture: "Typ zdj\u0119cia",
            map_theme_type: "Typ aparatu",
            metadata: "Metadane zdj\u0119cia",
            metadata_general_picid: "Zdj\u0119cie",
            metadata_general_seqid: "Sekwencja",
            metadata_general_license: "Licencja",
            metadata_general_author: "Autor",
            metadata_camera: "Aparat",
            metadata_camera_type: "Typ",
            metadata_camera_resolution: "Rozdzielczo\u015B\u0107",
            metadata_location: "Pozycja",
            metadata_exif: "EXIF",
            metadata_quality_missing: "Brak warto\u015Bci ustawionej w zdj\u0119ciu",
            metadata_exif_name: "Tag",
            metadata_exif_value: "Warto\u015B\u0107",
            report: "Zg\u0142o\u015B",
            report_nature: {
                privacy: "Prywatna droga lub w\u0142asno\u015B\u0107 widoczna",
                mislocated: "Zdj\u0119cie jest s\u0142abo pozycjonowane na mapie",
                copyright: "Zdj\u0119cie narusza prawa autorskie",
                picture_low_quality: "Obraz jest niskiej jako\u015Bci",
                other: "Inny problem",
                "": "Wybierz typ problemu\u2026",
                blur_missing: "Twarz osoby lub rejestracja samochodu jest widoczna",
                blur_excess: "Niepotrzebne zamazywanie zosta\u0142o wykonane na obiekcie",
                inappropriate: "Zdj\u0119cie jest niestosowne (niezwi\u0105zane, nago\u015B\u0107\u2026)"
            },
            zoomOut: "Oddal",
            report_whole_sequence: "Dotyczy ca\u0142ej sekwencji",
            report_details: "Dodatkowe szczeg\xf3\u0142y",
            report_email: "Tw\xf3j adres email",
            report_email_placeholder: "Opcjonalne",
            report_submit: "Wy\u015Blij",
            report_wait: "Wysy\u0142anie zg\u0142oszenia\u2026",
            report_success: "Zg\u0142oszenie zosta\u0142o skutecznie wys\u0142ane. Zostanie przejrzane tak szybko jak to mo\u017Cliwe.",
            share_rss_title: "Kana\u0142 RSS nowych sekwencji na widocznym obszarze mapy",
            loading_labels_fun: [
                "\uD83E\uDD8C Wykrywanie znak\xf3w przechodzenia jeleni",
                "\uD83D\uDE98Szukanie Panoramax Car \xa9",
                "\u2615 Wstrzykiwanie kofeiny",
                "\uD83D\uDE00 U\u015Bmiechnij si\u0119, jeste\u015B mapowany!",
                "\uD83D\uDC08 Udost\u0119pnianie zdj\u0119\u0107 kot\xf3w",
                "\uD83D\uDE34 Zmniejszanie prokrastynacji",
                "\uD83E\uDED6 Parzenie herbaty",
                "\uD83D\uDC27 Otwieranie kodu \u017Ar\xf3d\u0142owego",
                "\uD83D\uDE87 Indeksowanie stacji metra",
                "\uD83E\uDDF9 Czyszczenie metadanych",
                "\uD83D\uDE92 Przesy\u0142anie zdj\u0119\u0107 remiz",
                "\uD83D\uDEB2 Aktualizacja zielonych szlak\xf3w",
                "\uD83D\uDE89 Przechodzenie peron\xf3w stacji",
                "\uD83D\uDEF0\uFE0F Wyszukiwanie satelit",
                "\uD83D\uDC65 Wypisywanie os\xf3b",
                "\uD83D\uDC1F Szukanie sklep\xf3w z frytkami i ryb\u0105",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Interfejs debugowania",
                "\uD83D\uDCC8 Zwi\u0119kszanie statystyk",
                "\uD83E\uDD16 Semantyka uczenia",
                "\uD83C\uDFA8 Przeprojektowywanie interfejsu",
                "\uD83D\uDCC5 Planowanie element\xf3w mapowania zdj\u0119\u0107",
                "\uD83E\uDDC0 Dojrzewanie ser\xf3w",
                "\uD83C\uDF04 Obliczanie Kornwalijskiego blasku",
                "\uD83C\uDF0A Mierzenie przyp\u0142yw\xf3w"
            ],
            share_embed_docs: "Przeczytaj wi\u0119cej o konfiguracji osadzenia",
            sequence_play: "Odtw\xf3rz t\u0119 sekwencj\u0119",
            josm_live: "W\u0142\u0105cz automatyczn\u0105 synchronizacj\u0119 JOSM przy \u0142adowaniu zdj\u0119\u0107",
            error_api: "Serwer zdj\u0119\u0107 nie jest dost\u0119pny",
            error_webgl: "WebGL nie jest obs\u0142ugiwany przez t\u0119 przegl\u0105dark\u0119",
            error_api_compatibility: "Serwer zdj\u0119\u0107 nie jest kompatybilny z t\u0105 wersj\u0105 przegl\u0105darki",
            filter_date: "Data",
            filter_date_1month: "1 miesi\u0105c",
            filter_date_1year: "1 rok",
            filter_user: "U\u017Cytkownik",
            filter_user_mypics: "Moje zdj\u0119cia",
            filter_zoom_in: "Przybli\u017C, aby odblokowa\u0107",
            picture_flat: "Klasyczne",
            picture_360: "360\xb0",
            filter_qualityscore: "Ocena jako\u015Bci",
            map_background: "Podk\u0142ad mapowy",
            map_background_aerial: "Zdj\u0119cia lotnicze",
            map_background_streets: "Ulice",
            map_theme: "Motyw mapy",
            map_theme_default: "Klasyczny",
            map_theme_score: "Ocena jako\u015Bci",
            contrast: "W\u0142\u0105cz wy\u017Cszy kontrast zdj\u0119cia",
            metadata_general_picid_link: "Id\u017A do opisu zdj\u0119cia w JSON",
            metadata_general_seqid_link: "Id\u017A do opisu sekwencji w JSON",
            metadata_general_license_link: "Id\u017A do strony z pelnym opisem licencji",
            metadata_general_date: "Data zrobienia",
            metadata_camera_make: "Marka",
            metadata_camera_focal_length: "Ogniskowa",
            metadata_location_longitude: "D\u0142ugo\u015B\u0107 geograficzna",
            metadata_location_latitude: "Szeroko\u015B\u0107 geograficzna",
            metadata_location_orientation: "Kierunek",
            metadata_location_precision: "Precyzja lokalizacji",
            metadata_quality: "Jako\u015B\u0107",
            metadata_quality_help: "Dowiedz si\u0119 wi\u0119cej o ocenie jako\u015Bci",
            metadata_quality_score: "Ocena globalna",
            metadata_quality_gps_score: "Ocena pozycji",
            metadata_quality_resolution_score: "Ocena rozdzielczo\u015Bci",
            report_auth: 'To zg\u0142oszenie b\u0119dzie wys\u0142anie przy pomocy Twojego konta "{a}"',
            report_nature_label: "Przyczyna problemu",
            report_details_placeholder: "Opcjonalnie, mo\u017Cesz doda\u0107 szczeg\xf3\u0142y o problemie",
            report_failure: "B\u0142\u0105d wyst\u0105pi\u0142 podczas tworzenia zg\u0142oszenia: {e}. Prosz\u0119 spr\xf3buj ponownie.",
            filter_qualityscore_help: "Kliknij, aby w\u0142\u0105czy\u0107 lub wy\u0142\u0105czy\u0107",
            error_josm: "JOSM nie odpowiada, czy jest uruchomiony i czy dost\u0119p zdalny jest w\u0142\u0105czony?",
            expand_info: "Wy\u015Bwietl wid\u017Cet na ca\u0142ej stronie",
            filter_gps_precision_help_1: "Informacja o dok\u0142adno\u015Bci lokalizacji jest dost\u0119pna dla ka\u017Cdego zdj\u0119cia. Wi\u0105\u017Ce si\u0119 to z dok\u0142adno\u015Bci\u0105 GPS podczas robienia zdj\u0119\u0107.",
            popup_details_link: "Wi\u0119cej szczeg\xf3\u0142\xf3w",
            semantics_features_default_title: "Tag {nb}",
            qualityscore_doc_5: "Profesjonalne urz\u0105dzenie b\u0119dzie mia\u0142o rang\u0119 A, kamera sportowa 360\xb0 rang\u0119 B, a smartfon rang\u0119 mi\u0119dzy C i E.",
            filter_gps_precision: "Dok\u0142adno\u015B\u0107 lokalizacji",
            metadata_general_copy_picid: "Kopiuj ID zdj\u0119cia",
            filter_gps_precision_between: "Mi\u0119dzy {n1} a {n2} metr\xf3w",
            filter_gps_precision_morethan: "Wi\u0119cej ni\u017C {n} metr\xf3w",
            filter_gps_precision_lessthan: "Mniej ni\u017C {n} metr\xf3w",
            metadata_general_copy_id: "Kopiuj ID",
            metadata_general_instance: "Instancja \u017Ar\xf3d\u0142owa",
            semantics_doc_info1: "Nadaj kontekst zdj\u0119ciu u\u017Cywaj\u0105c tag\xf3w.",
            metadata_summary: "Podsumowanie",
            metadata_exif_doc: "Dokumentacja do tag\xf3w EXIF",
            metadata_exif_doc_title: "Id\u017A do dokumentacji Exiv2 aby pozna\u0107 pe\u0142ne szczeg\xf3\u0142y definicji tagowania EXIF i XMP",
            metadata_location_copy: "Kopia {v}",
            metadata_location_coordinates: "Koordynaty (d\u0142ugo\u015B\u0107, szeroko\u015B\u0107)",
            filter_locked: "Filtr wy\u0142\u0105czony",
            map_theme_gps: "Dok\u0142adno\u015B\u0107 lokalizacji",
            error_pic: "\u017B\u0105dane zdj\u0119cie nie zosta\u0142o znalezione",
            error_psv: "Przegl\u0105darka fotosfery nie \u0142aduje si\u0119 poprawnie",
            semantics_key: "Klucz",
            semantics_features_none: "Nie zapisano jeszcze \u017Cadnych funkcji w tym obrazie.",
            semantics_value: "Warto\u015B\u0107",
            whats_panoramax: "Panoramax jest geograficzn\u0105 wsp\xf3lnot\u0105 dla zdj\u0119\u0107 terenu.",
            panoramax: "Panoramax",
            error_nopic: "Nie ma dost\u0119pnych zdj\u0119\u0107 w podanej pozycji",
            picture_360_long: "Panoramiczne zdj\u0119cie",
            qualityscore_doc_2: "Ranking jest pokazywany jako litera:",
            qualityscore_doc_1: "Ranking jako\u015Bci jest wyliczany dla ka\u017Cdego zdj\u0119cia.",
            minimize_short: "Ukryj",
            minimize: "Ukryj ten wid\u017Cet, mo\u017Cesz go znowu pokaza\u0107 u\u017Cywaj\u0105c przycisku w dolnym lewym rogu",
            share_image: "Obraz wysokiej jako\u015Bci",
            semantics_doc_info1u1: "Mo\u017Cesz oznaczy\u0107 to jako zrobione z samochodu u\u017Cywaj\u0105c znacznika transport=car.",
            share_embed: "Osad\u017A na swojej stronie",
            id: "iD",
            filter_date_6months: "6 miesi\u0119cy",
            picture_all: "Wszystko",
            map_background_default: "Domy\u015Blne",
            map_background_more: "Inne t\u0142a...",
            metadata_location_copy_more: "Wi\u0119cej opcji kopiowania wsp\xf3\u0142rz\u0119dnych",
            semantics_title: "Tagi",
            semantics_tags: "{nb} tagi",
            semantics_features: "Funkcje obrazu",
            semantics_features_subtitle: "{nb} powi\u0105zane w\u0142a\u015Bciwo\u015Bci",
            semantics_annotation_tooltip: "Kliknij by pozna\u0107 szczeg\xf3\u0142y",
            semantics_show_all_tags: "Poka\u017C wszystkie tagi",
            semantics_hide_all_tags: "Ukryj wszystkie tagi",
            semantics_sequence_tags: "Znacznik sekwencji",
            semantics_picture_tags: "Znacznik obrazu",
            semantics_annotation_tags: "Znacznik obiektu",
            contribute_id: "Wsp\xf3\u0142tw\xf3rz OpenStreetMap u\u017Cywaj\u0105c edytora iD",
            geo_uri: "Aplikacja zewn\u0119trzna",
            josm: "JOSM",
            picture_flat_long: "Klasyczne zdj\u0119cie",
            semantics_doc: "Pomoc",
            filter_gps_precision_help: "Dowiedz si\u0119 wi\u0119cej o dok\u0142adno\u015Bci lokalizacji",
            filter_gps_precision_help_2: "Precyzja jest wyra\u017Cana za pomoc\u0105 gwiazdek:",
            qualityscore_doc_41: "Precyzj\u0119 GPS",
            qualityscore_doc_42: "rozdzielczo\u015B\u0107 zdj\u0119cia",
            qualityscore_doc_4: "Ten ranking jest wyliczony w oparciu o:",
            filter_source_world: "Ca\u0142y \u015Bwiat",
            filter_source_local: "Ten serwer",
            qualityscore_doc_3: '"A" to najlepsza jako\u015B\u0107, "E" najgorsza.',
            qualityscore_doc_link: "Dowiedz si\u0119 wi\u0119cej o Rankingu Jako\u015Bci",
            filter_gps_precision_help_3: '"5\u2B50" jest bardzo dok\u0142adne (<= {p5}m), "1\u2B50" jest bardzo niedok\u0142adne (> {p1}m) lub nieznane.',
            filter_gps_precision_help_4: 'RTK GPS b\u0119dzie mia\u0142 "5\u2B50" klas\u0119, kamera sportowa jak GoPro Max "3\u2B50" klas\u0119, a GPS w smartfonie na parkingu podziemnym "1\u2B50" klas\u0119.',
            semantics_copy: "Skopiuj atrybuty",
            semantics_draw_unfinished_annotation: "Obszar rysowania jest nie sko\u0144czony. Upewnij si\u0119 \u017Ce obszar jest dobrze spozycjonowany przed zapisaniem.",
            semantics_draw_invalid_annotation: "Obszar rysowania przekracza ograniczenia zdj\u0119cia. Upewnij si\u0119, \u017Ce rysujesz w widocznym obszarze zdj\u0119cia.",
            semantics_editor_example: "klucz=warto\u015B\u0107\nprefix|klucz=warto\u015B\u0107",
            semantics_download: "Pobierz",
            semantics_doc_info3: "Niekt\xf3re obiekty s\u0105 automatycznie wykrywane przez AI: jako\u015B\u0107 nie jest gwarantowana.",
            semantics_wikidata_properties: {
                P31: "instancja",
                P279: "podklasa",
                P180: "przedstawia",
                P361: "cz\u0119\u015B\u0107"
            },
            semantics_login_needed: "Aby edytowa\u0107 znaczniki lub cechy zdj\u0119cia, musisz zalogowa\u0107 si\u0119 w instancji {n} Panoramax. Chcesz si\u0119 zalogowa\u0107?",
            semantics_doc_info2: "Mo\u017Cesz wybiera\u0107 obiekty na zdj\u0119ciu takie jak: znaki drogowe, miejskie wyposa\u017Cenie... Oznacz co widzisz u\u017Cywaj\u0105c istniej\u0105cych znacznik\xf3w. Mo\u017Cesz utworzy\u0107 w\u0142asne je\u015Bli to potrzebne.",
            semantics_zero_annotations: "Nie wybrano cech tego zdj\u0119cia",
            semantics_doc_link: "Dowiedz si\u0119 wi\u0119cej o znacznikach",
            semantics_value_doc: "Dowiedz si\u0119 wi\u0119cej o tym znaczniku",
            semantics_qualifiers: "Kwalifikacje",
            semantics_show_annotations: "Wy\u015Bwietl cechy zdj\u0119cia",
            semantics_hide_annotations: "Ukryj cechy zdj\u0119cia",
            semantics_delete_annotation: "Skasuj ten element",
            semantics_delete_annotation_confirm: "Naprawd\u0119 chcesz skasowa\u0107 ten znacznik?",
            semantics_send_fail: "Nie mo\u017Cna zapisa\u0107 twoich zmian, prosz\u0119 spr\xf3buj ponownie p\xf3\u017Aniej",
            semantics_overlays: {
                features: "Wszystkie cechy",
                tfsigns: "Znaki drogowe"
            },
            semantics_editor_error: "Sk\u0142adnia nieprawid\u0142owa. Twoje znaczniki mog\u0105 wygl\u0105da\u0107 jak:\nklucz=warto\u015B\u0107\nprefix|klucz=warto\u015B\u0107\nprefix|klucz[qualif_key=qualif_val]=warto\u015B\u0107\n\nMaksymalna d\u0142ugo\u015B\u0107 klucza to 256 znak\xf3w, maksymalna d\u0142ugo\u015B\u0107 warto\u015Bci to 2048 znak\xf3w.",
            semantics_undo: "Anuluj swoje edycje",
            semantics_value_show_osm: "Zobacz na OpenStreetMap",
            semantics_draw_annotation: "Mo\u017Cesz wybra\u0107 obiekty kt\xf3re chcesz doda\u0107 do zdj\u0119cia (Opcjonalne).",
            semantics_add_annotation: "Dodaj nowy znacznik",
            semantics_key_doc: "Dowiedz si\u0119 wi\u0119cej o tym kluczu",
            semantics_erase_annotation: "Wyma\u017C narysowany element",
            semantics_edit: "Edytuj atrybuty",
            semantics_save: "Zapisz swoje zmiany",
            semantics_zoom_in: "Przybli\u017C map\u0119 by zobaczy\u0107 znaczniki",
            semantics_download_title: "Pobierz znaczniki",
            indoor_selector_levelup: "Id\u017A na wy\u017Cszy poziom",
            indoor_selector_scrollup: "Przewi\u0144 list\u0119 poziom\xf3w w g\xf3r\u0119",
            indoor_selector_scrolldown: "Przewi\u0144 list\u0119 poziom\xf3w w d\xf3\u0142",
            "visibility_owner-only": "Ukryte",
            "visibility_logged-only": "Cz\u0142onkowie",
            "visibility_title_logged-only": "Tylko osoby z kontem mog\u0105 zobaczy\u0107 to zdj\u0119cie",
            "visibility_title_owner-only": "Tylko ty mo\u017Cesz zobaczy\u0107 to zdj\u0119cie",
            indoor_switch: "Mapy wn\u0119trz",
            indoor_selector_shrink: "Kliknij by zminimalizowa\u0107",
            indoor_selector_expand: "Kliknij, by zobaczy\u0107 wszystkie dost\u0119pne poziomy",
            semantics_download_info: "Wszystkie dane semantyczne (znaczniki) s\u0105 dost\u0119pne jako otwarte dane. Mo\u017Cesz je pobra\u0107 i u\u017Cywa\u0107 jak lubisz.",
            indoor_selector_leveldown: "Id\u017A na ni\u017Cszy poziom",
            semantics_download_cta: "Pobierz otwarte dane"
        },
        psv: {
            twoFingers: "U\u017Cyj dw\xf3ch palc\xf3w do nawigacji",
            ctrlZoom: "U\u017Cyj ctrl + rolka myszy, aby powi\u0119kszy\u0107 zdj\u0119cie",
            loadError: "Panorama nie mo\u017Ce by\u0107 za\u0142adowana"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Znajd\u017A moj\u0105 lokalizacj\u0119",
            "GeolocateControl.LocationNotAvailable": "Lokalizacja niedost\u0119pna"
        },
        map: {
            thumbnail: "Miniaturki najechanego zdj\u0119cia",
            not_public: "Niewidoczne publicznie",
            slow_loading: "Mapa \u0142aduje si\u0119 wolno i mo\u017Ce si\u0119 wydawaj popsuta",
            loading: "\u0141adowanie\u2026",
            map_data: "Mapa na podstawie {m}",
            more_panoramax: "Odkryj wi\u0119cej o Panoramax"
        }
    },
    pt: {
        psv: {
            ctrlZoom: "Use ctrl + rolagem para ampliar a imagem",
            loadError: "O panorama n\xe3o pode ser carregado",
            twoFingers: "Use dois dedos para navegar"
        },
        pnx: {
            search_user: "Pesquisar um nome de utilizador\u2026",
            legend_license: "Licen\xe7a: {l}",
            map_background: "Fundo do mapa",
            semantics_features: "Caracter\xedsticas da imagem",
            show_map: "Exibir o mapa",
            minimize: "Ocultar este widget, pode exibi-lo novamente usando o bot\xe3o no canto inferior esquerdo",
            share_image: "Imagem HD",
            error_retry: "Por favor, tente novamente mais tarde",
            picture_flat_long: "Imagem cl\xe1ssica",
            report_success: "O relat\xf3rio foi enviado com sucesso. Ser\xe1 analisado assim que poss\xedvel.",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Carregando dados do mapa",
                "\uD83D\uDDA5\uFE0F Consultando a API",
                "\uD83D\uDDBC\uFE0F Carregando miniaturas",
                "\uD83D\uDD0D Analisando os metadados EXIF",
                "\uD83C\uDFD8\uFE0F Renderiza\xe7\xe3o 3D",
                "\uD83D\uDCF7 Inicializando imagens em 360\xb0",
                "\uD83D\uDFE0 Ajuste de cores",
                "\uD83D\uDCAF Computando o Quality Score \xa9",
                "\uD83D\uDCE1 Transferindo atualiza\xe7\xf5es",
                "\uD83C\uDF0D Buscando blocos de mapa",
                "\uD83D\uDCF8 Processando sombras"
            ],
            loading_labels_fun: [
                "\uD83D\uDC17 Detetando placas de passagem de javalis",
                "\uD83D\uDE98 Pesquisando Panoramax Car \xa9",
                "\u2615 Injetando cafe\xedna",
                "\uD83D\uDE00 Sorria, est\xe1 a ser mapeado!",
                "\uD83D\uDC08 Partilhando fotos de gatos",
                "\uD83D\uDE34 Reduzindo a procrastina\xe7\xe3o",
                "\uD83E\uDED6 Preparando um ch\xe1",
                "\uD83D\uDC27 Abrindo o c\xf3digo-fonte",
                "\uD83D\uDE87 Indexando esta\xe7\xf5es de el\xe9trico",
                "\uD83E\uDDF9 Limpeza de metadados",
                "\uD83D\uDE92 Enviando fotos do quartel dos bombeiros",
                "\uD83D\uDEB2 Atualiza\xe7\xe3o das ciclovias",
                "\uD83D\uDE89 Passeio pela plataforma da esta\xe7\xe3o",
                "\uD83D\uDEF0\uFE0F Pesquisando sat\xe9lites",
                "\uD83D\uDE8B Mapeando Lisboa de el\xe9trico",
                "\uD83C\uDF5F Procurando lanchonetes",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Depurando a interface",
                "\uD83D\uDCC8 Aumentando as estat\xedsticas",
                "\uD83D\uDEA2 Procurando portos em Porto",
                "\uD83C\uDFA8 Redesenho da interface",
                "\uD83C\uDFC4\u200D\u2640\uFE0F Mapeando e surfando nas ondas em Peniche",
                "\uD83E\uDDC0 Maturando os queijos",
                "\uD83C\uDF04 Calculando a insola\xe7\xe3o em Tavira",
                "\uD83C\uDF0A Medindo as mar\xe9s altas"
            ],
            error_psv: "O Photo Sphere Viewer n\xe3o est\xe1 a carregar corretamente",
            error_api: "O servidor de imagens n\xe3o est\xe1 dispon\xedvel",
            metadata_quality_resolution_score: "Pontua\xe7\xe3o de resolu\xe7\xe3o",
            semantics_doc: "Ajuda",
            map_theme_score: "Pontua\xe7\xe3o de qualidade",
            metadata_general_picid_link: "Ir para a descri\xe7\xe3o JSON da imagem",
            metadata_general_seqid_link: "Ir para a descri\xe7\xe3o JSON da sequ\xeancia",
            metadata_quality_help: "Saiba mais sobre a Pontua\xe7\xe3o de Qualidade",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax \xe9 o geo-reposit\xf3rio comum para imagens de territ\xf3rios.",
            sequence_pause: "Pausar sequ\xeancia",
            contribute_id: "Contribua para o OpenStreetMap com o editor iD",
            josm_live: "Ativar a sincroniza\xe7\xe3o autom\xe1tica do JOSM ao carregar imagens",
            zoom: "Zoom",
            zoomOut: "Diminuir o zoom",
            zoomIn: "Ampliar o zoom",
            moveUp: "Mover para cima",
            moveDown: "Mover para baixo",
            moveLeft: "Mover para a esquerda",
            moveMiddle: "Centralizar a vista",
            expand: "Expandir",
            expand_info: "Fazer com que o widget apare\xe7a em p\xe1gina inteira",
            show_psv: "Exibir o visualizador de imagens",
            minimize_short: "Ocultar",
            options: "Op\xe7\xf5es",
            filters: "Filtros",
            layers: "Camadas",
            search: "Pesquisa",
            search_empty: "Nenhum resultado encontrado",
            search_address: "Pesquisar um endere\xe7o, cidade\u2026",
            share: "Partilhar",
            share_links: "Links",
            share_page: "Link para esta foto",
            share_rss: "Feed RSS",
            share_embed: "Incorporar no seu site",
            share_embed_docs: "Leia mais sobre a configura\xe7\xe3o de incorpora\xe7\xe3o",
            share_print: "Imprimir",
            copy: "Copiar",
            copied: "Copiado",
            error: "Temos um problema\u2026",
            error_click: "Continuar",
            sequence_next: "Pr\xf3xima imagem na sequ\xeancia",
            sequence_play: "Reproduzir esta sequ\xeancia",
            sequence_prev: "Imagem anterior na sequ\xeancia",
            sequence_more: "Mais op\xe7\xf5es de reprodu\xe7\xe3o",
            sequence_speed: "Velocidade de reprodu\xe7\xe3o",
            legend_title: "Exibir detalhes da imagem",
            id: "iD",
            geo_uri: "Aplica\xe7\xe3o externa",
            josm: "JOSM",
            error_nopic: "N\xe3o h\xe1 imagem dispon\xedvel na posi\xe7\xe3o indicada",
            error_webgl: "O WebGL n\xe3o \xe9 suportado pelo seu navegador",
            error_josm: "O JOSM n\xe3o responde, est\xe1 a funcionar e est\xe1 ativado o acesso remoto?",
            filter_date: "Data",
            filter_date_1month: "1 m\xeas",
            filter_date_1year: "1 ano",
            filter_user: "Utilizador",
            filter_user_mypics: "Minhas imagens",
            filter_picture: "Tipo de imagem",
            filter_zoom_in: "Amplie o mapa para desbloquear",
            picture_all: "Todas",
            picture_flat: "Cl\xe1ssica",
            picture_360: "360\xb0",
            picture_360_long: "Imagem panor\xe2mica",
            filter_qualityscore: "Pontua\xe7\xe3o de qualidade",
            filter_qualityscore_help: "Clique para ativar ou desativar",
            qualityscore_title: "Sobre a pontua\xe7\xe3o de qualidade",
            qualityscore_doc_3: "\xabA\xbb \xe9 a melhor nota, \xabE\xbb a pior.",
            qualityscore_doc_link: "Saiba mais sobre a Pontua\xe7\xe3o de Qualidade",
            filter_gps_precision: "Precis\xe3o de localiza\xe7\xe3o",
            filter_gps_precision_lessthan: "Menos de {n} metros",
            filter_gps_precision_between: "Entre {n1} e {n2} metros",
            filter_gps_precision_morethan: "Mais de {n} metros",
            map_background_aerial: "A\xe9reo",
            map_background_streets: "Ruas",
            map_theme: "Tema do mapa",
            map_theme_default: "Padr\xe3o",
            map_theme_age: "Data da captura",
            map_theme_age_1: "> 3 anos",
            map_theme_age_2: "< 3 anos",
            map_theme_age_3: "< 1 ano",
            map_theme_age_4: "< 6 m\xeas",
            map_theme_type: "Tipo de c\xe2mara",
            map_theme_gps: "Precis\xe3o de GPS",
            contrast: "Ativar maior contraste da imagem",
            metadata: "Metadados de imagem",
            metadata_summary: "Resumo",
            metadata_general_copy_id: "Copiar ID",
            metadata_general_copy_picid: "Copiar ID da imagem",
            metadata_general_picid: "Imagem",
            metadata_general_seqid: "Sequ\xeancia",
            metadata_general_author: "Autor",
            metadata_general_license: "Licen\xe7a",
            metadata_general_license_link: "Veja a descri\xe7\xe3o completa da licen\xe7a",
            metadata_general_date: "Data da captura",
            metadata_general_instance: "Inst\xe2ncia de origem",
            metadata_camera: "C\xe2mara",
            metadata_camera_make: "Marca",
            metadata_camera_model: "Modelo",
            metadata_camera_type: "Tipo",
            metadata_camera_resolution: "Resolu\xe7\xe3o",
            metadata_camera_focal_length: "Dist\xe2ncia focal",
            metadata_location: "Posi\xe7\xe3o",
            metadata_location_orientation: "Dire\xe7\xe3o",
            metadata_location_precision: "Precis\xe3o de posicionamento",
            metadata_location_copy: "Copiar {v}",
            metadata_location_copy_more: "Mais op\xe7\xf5es de c\xf3pia de coordenadas",
            metadata_quality: "Qualidade",
            metadata_quality_score: "Pontua\xe7\xe3o global",
            metadata_quality_gps_score: "Pontua\xe7\xe3o de posicionamento",
            metadata_quality_missing: "nenhum valor definido na imagem",
            metadata_exif: "EXIF",
            metadata_exif_value: "Valor",
            semantics_features_subtitle: "{nb} propriedades associadas",
            semantics_annotation_tooltip: "Clique para ver detalhes",
            semantics_key: "Chave",
            semantics_value: "Valor",
            semantics_key_doc: "Saiba mais sobre esta chave",
            semantics_qualifiers: "Qualificadores",
            semantics_show_annotations: "Exibir caracter\xedsticas da imagem",
            semantics_hide_annotations: "Ocultar caracter\xedsticas da imagem",
            semantics_zero_annotations: "Nenhuma caracter\xedstica desenhada nesta imagem",
            semantics_erase_annotation: "Apagar caracter\xedstica desenhada",
            semantics_delete_annotation: "Eliminar esta caracter\xedstica",
            semantics_wikidata_properties: {
                P31: "inst\xe2ncia de",
                P361: "parte de",
                P279: "subclasse de",
                P180: "retrata"
            },
            semantics_editor_example: "chave=valor\nprefixo|chave=valor",
            semantics_edit: "Editar atributos",
            semantics_save: "Salvar suas altera\xe7\xf5es",
            semantics_undo: "Cancelar suas edi\xe7\xf5es",
            report: "Denunciar",
            report_nature_label: "Causa do problema",
            report_nature: {
                "": "Selecione o tipo do problema\u2026",
                blur_missing: "O rosto de uma pessoa ou a matr\xedcula de um carro s\xe3o vis\xedveis",
                inappropriate: "A imagem \xe9 inadequada (sem rela\xe7\xe3o, nudez\u2026)",
                privacy: "Um caminho ou propriedade privada \xe9 vis\xedvel",
                mislocated: "A imagem est\xe1 mal posicionada no mapa",
                copyright: "A imagem viola direitos autorais",
                other: "Qualquer outro tipo de problema",
                picture_low_quality: "A imagem \xe9 de baixa qualidade",
                blur_excess: "Foi aplicado um desfoque desnecess\xe1rio a um objeto"
            },
            report_whole_sequence: "Isto diz respeito a toda a sequ\xeancia",
            report_details: "Detalhes adicionais",
            report_email_placeholder: "Opcional",
            report_wait: "Enviando relat\xf3rio\u2026",
            report_failure: "Ocorreu um erro ao criar o relat\xf3rio: {e}. Por favor, tente novamente mais tarde.",
            moveRight: "Mover para a direita",
            share_rss_title: "Feed RSS de novas sequ\xeancias na \xe1rea do mapa atualmente vis\xedvel",
            error_pic: "A imagem solicitada n\xe3o foi encontrada",
            filter_date_6months: "6 meses",
            error_api_compatibility: "O servidor de imagens n\xe3o \xe9 compat\xedvel com esta vers\xe3o do visualizador",
            semantics_doc_info3: "Alguns objetos s\xe3o detetados automaticamente com IA: a qualidade n\xe3o \xe9 garantida.",
            report_email: "Seu e-mail",
            metadata_location_coordinates: "Coordenadas (longitude, latitude)",
            qualityscore_doc_2: "A pontua\xe7\xe3o \xe9 apresentada como uma letra:",
            semantics_features_none: "Ainda n\xe3o foi desenhado nenhuma caracter\xedstica nesta imagem.",
            qualityscore_doc_1: "\xc9 calculada uma pontua\xe7\xe3o de qualidade para cada imagem.",
            semantics_draw_annotation: "Pode desenhar o objeto que deseja adicionar na imagem (opcional).",
            semantics_send_fail: "N\xe3o foi poss\xedvel guardar as suas altera\xe7\xf5es, por favor, tente novamente mais tarde",
            report_auth: 'Este relat\xf3rio ser\xe1 enviado usando a sua conta "{a}"',
            report_details_placeholder: "Opcionalmente, pode adicionar detalhes sobre o problema",
            report_submit: "Enviar",
            metadata_exif_name: "Tag",
            metadata_exif_doc: "Documenta\xe7\xe3o para etiquetas EXIF",
            semantics_tags: "{nb} etiquetas",
            semantics_title: "Etiquetas",
            semantics_show_all_tags: "Mostrar todas as etiquetas",
            semantics_hide_all_tags: "Ocultar todas as etiquetas",
            semantics_sequence_tags: "Etiqueta da sequ\xeancia",
            semantics_picture_tags: "Etiqueta de imagem",
            semantics_features_default_title: "Etiqueta {nb}",
            semantics_annotation_tags: "Etiqueta de objeto",
            semantics_doc_title: "Sobre etiquetas",
            semantics_doc_info2: "Tamb\xe9m pode desenhar objetos na imagem: sinais de tr\xe2nsito, equipamentos urbanos\u2026 Marque o que v\xea usando as etiquetas existentes. Tamb\xe9m pode criar as suas pr\xf3prias, se necess\xe1rio.",
            semantics_doc_link: "Saiba mais sobre etiquetas",
            semantics_value_doc: "Saiba mais sobre esta etiqueta",
            semantics_add_annotation: "Adicionar uma nova etiqueta",
            semantics_delete_annotation_confirm: "Quer mesmo eliminar esta etiqueta?",
            semantics_editor_error: "A sintaxe \xe9 inv\xe1lida. Suas etiquetas podem ficar assim:\nchave=valor\nprefixo|chave=valor\nprefixo|chave[qualif_chave=qualif_val]=valor\n\nO comprimento m\xe1ximo da chave \xe9 de 256 caracteres, o comprimento m\xe1ximo do valor \xe9 de 2048 caracteres.",
            semantics_login_needed: "Para editar tags ou recursos de imagens, \xe9 necess\xe1rio fazer login na inst\xe2ncia Panoramax {n}. Deseja fazer login?",
            metadata_exif_doc_title: "Acesse a documenta\xe7\xe3o do Exiv2 para obter detalhes completos sobre as defini\xe7\xf5es das etiquetas EXIF e XMP",
            semantics_doc_info1: "D\xea contexto a uma imagem usando etiquetas.",
            semantics_overlays: {
                tfsigns: "Sinais de tr\xe2nsito",
                features: "Todas as caracter\xedsticas"
            },
            semantics_doc_info1u1: "Pode marc\xe1-la como capturada por carro com a etiqueta transport=car.",
            semantics_zoom_in: "Amplie o mapa para ver as etiquetas",
            semantics_download_info: "Todos os dados sem\xe2nticos (etiquetas) est\xe3o dispon\xedveis como dados abertos. Voc\xea pode baix\xe1-los e utiliz\xe1-los livremente.",
            semantics_download_title: "Baixar etiquetas",
            semantics_download: "Baixar",
            semantics_download_cta: "Baixar dados abertos",
            semantics_copy: "Copiar atributos",
            popup_details_link: "Mais detalhes",
            qualityscore_doc_41: "a precis\xe3o do GPS",
            filter_gps_precision_help: "Saiba mais sobre a precis\xe3o da localiza\xe7\xe3o",
            filter_gps_precision_help_1: "Informa\xe7\xf5es de precis\xe3o da localiza\xe7\xe3o est\xe3o dispon\xedveis para cada foto. Isso corresponde \xe0 precis\xe3o do GPS durante a captura da foto.",
            filter_gps_precision_help_3: "\xab5\u2B50\xbb \xe9 muito preciso (<= {p5}m), \xab1\u2B50\xbb \xe9 muito impreciso (> {p1}m) ou desconhecido.",
            qualityscore_doc_4: "Esta pontua\xe7\xe3o \xe9 calculada com base em:",
            filter_gps_precision_help_4: "Um GPS RTK ter\xe1 uma classifica\xe7\xe3o de \xab5\u2B50\xbb, uma c\xe2mara de a\xe7\xe3o como a GoPro Max ter\xe1 uma classifica\xe7\xe3o de \xab3\u2B50\xbb e um GPS de smartphone num estacionamento subterr\xe2neo ter\xe1 uma classifica\xe7\xe3o de \xab1\u2B50\xbb.",
            filter_gps_precision_help_2: "A precis\xe3o \xe9 expressa com estrelas:",
            semantics_value_show_osm: "Ver no OpenStreetMap",
            qualityscore_doc_42: "a resolu\xe7\xe3o da imagem",
            qualityscore_doc_5: "Um dispositivo profissional ter\xe1 uma classifica\xe7\xe3o A, uma c\xe2mara de a\xe7\xe3o 360\xb0 ter\xe1 uma classifica\xe7\xe3o B e um smartphone ter\xe1 uma classifica\xe7\xe3o entre C e E.",
            indoor_selector_expand: "Clique para ver todos os n\xedveis dispon\xedveis",
            indoor_selector_shrink: "Clique para minimizar",
            indoor_selector_levelup: "Ir para o n\xedvel superior",
            indoor_selector_leveldown: "Ir para o n\xedvel inferior",
            indoor_selector_scrollup: "Role a lista de n\xedveis para cima",
            indoor_selector_scrolldown: "Role a lista de n\xedveis para baixo",
            indoor_switch: "Mapas de interiores",
            "visibility_logged-only": "Membros",
            "visibility_title_logged-only": "Somente pessoas com uma conta podem ver esta imagem",
            "visibility_owner-only": "Oculto",
            "visibility_title_owner-only": "Apenas voc\xea pode ver esta imagem",
            filter_locked: "Filtro desativado",
            map_background_default: "Padr\xe3o",
            map_background_more: "Mais",
            filter_source_world: "Mundo inteiro",
            filter_source_local: "Este servidor",
            time_travel: "Ver este local noutras datas",
            time_travel_close: "Ocultar outras datas",
            map_theme_default_short: "Padr\xe3o",
            map_theme_age_short: "Data",
            map_theme_type_short: "C\xe2mara",
            map_theme_score_short: "Qualidade",
            map_theme_gps_short: "Posi\xe7\xe3o"
        },
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "Localiza\xe7\xe3o n\xe3o dispon\xedvel",
            "GeolocateControl.FindMyLocation": "Encontre minha localiza\xe7\xe3o"
        },
        map: {
            thumbnail: "Miniatura da imagem ao passar o cursor",
            not_public: "N\xe3o vis\xedvel publicamente",
            slow_loading: "O mapa demora a carregar e pode aparecer corrompido",
            map_data: "Mapa baseado em {m}",
            more_panoramax: "Descubra mais sobre o Panoramax",
            loading: "Carregando\u2026"
        }
    },
    "pt-br": {
        pnx: {
            loading_labels_fun: [
                "\uD83E\uDDA5 Detectando placas de travessia de bichos-pregui\xe7a",
                "\uD83D\uDE98 Procurando Panoramax Car \xa9",
                "\u2615 Injetando cafe\xedna",
                "\uD83D\uDE00 Sorria, voc\xea foi mapeado!",
                "\uD83D\uDC08 Compartilhando imagens de gatos",
                "\uD83D\uDE34 Reduzindo a procrastina\xe7\xe3o",
                "\u2615 Preparando um cafezinho",
                "\uD83D\uDC27 Abrindo c\xf3digo-fonte",
                "\uD83D\uDE87 Indexando as esta\xe7\xf5es de metr\xf4",
                "\uD83E\uDDF9 Limpando os metadados",
                "\uD83D\uDE92 Enviando fotos do quartel dos bombeiros",
                "\uD83D\uDEB2 Atualizando as ciclovias",
                "\uD83D\uDE89 Caminhando pela plataforma da esta\xe7\xe3o",
                "\uD83D\uDEF0\uFE0F Procurando sat\xe9lites",
                "\uD83D\uDEA1 Subindo o P\xe3o de A\xe7\xfacar de telef\xe9rico",
                "\uD83C\uDF5F Localizando lanchonetes",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Depurando a interface",
                "\uD83D\uDCC8 Incrementando as estat\xedsticas",
                "\uD83C\uDFF0 Fortificando fortalezas em Fortaleza",
                "\uD83C\uDFA8 Redesenhando a interface",
                "\uD83D\uDC2C Procurando o boto-rosa no rio Amazonas",
                "\uD83E\uDDC0 Maturando os queijos minas",
                "\uD83C\uDF04 Calculando a insola\xe7\xe3o em Ubatuba",
                "\uD83C\uDF0A Medindo as mar\xe9s altas"
            ],
            zoom: "Zoom",
            zoomOut: "Diminuir o zoom",
            zoomIn: "Ampliar o zoom",
            moveUp: "Mover para cima",
            moveDown: "Mover para baixo",
            moveLeft: "Mover para a esquerda",
            expand: "Expandir",
            expand_info: "Fazer com que o widget apare\xe7a em p\xe1gina inteira",
            show_psv: "Exibir o visualizador de imagens",
            show_map: "Exibir o mapa",
            minimize_short: "Ocultar",
            options: "Op\xe7\xf5es",
            filters: "Filtros",
            layers: "Camadas",
            search: "Pesquisa",
            search_empty: "Nenhum resultado encontrado",
            search_address: "Pesquisar um endere\xe7o ou uma cidade etc.\u2026",
            search_user: "Pesquisar um nome de usu\xe1rio\u2026",
            share: "Compartilhar",
            share_links: "Links",
            share_page: "Link para esta foto",
            share_image: "Imagem HD",
            share_rss: "Feed RSS",
            share_embed: "Incorporar no seu site",
            share_embed_docs: "Leia mais sobre a configura\xe7\xe3o de incorpora\xe7\xe3o",
            share_print: "Imprimir",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax \xe9 o geo-reposit\xf3rio comum para imagens de territ\xf3rios.",
            copy: "Copiar",
            copied: "Copiado",
            error: "Temos um problema\u2026",
            error_retry: "Por favor, tente novamente mais tarde",
            sequence_play: "Reproduzir esta sequ\xeancia",
            sequence_pause: "Pausar sequ\xeancia",
            sequence_next: "Pr\xf3xima imagem na sequ\xeancia",
            sequence_more: "Mais op\xe7\xf5es de reprodu\xe7\xe3o",
            sequence_speed: "Velocidade de reprodu\xe7\xe3o",
            legend_license: "Licen\xe7a: {l}",
            legend_title: "Exibir detalhes da imagem",
            id: "iD",
            geo_uri: "Aplicativo externo",
            josm: "JOSM",
            josm_live: "Ativar a sincroniza\xe7\xe3o autom\xe1tica do JOSM ao carregar imagens",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Carregando dados do mapa",
                "\uD83D\uDDA5\uFE0F Consultando a API",
                "\uD83D\uDDBC\uFE0F Carregando miniaturas",
                "\uD83D\uDD0D Analisando os metadados EXIF",
                "\uD83C\uDFD8\uFE0F Renderiza\xe7\xe3o 3D",
                "\uD83D\uDCF7 Inicializando imagens em 360\xb0",
                "\uD83D\uDFE0 Ajuste de cores",
                "\uD83D\uDCAF Computando o Quality Score \xa9",
                "\uD83D\uDCE1 Baixando atualiza\xe7\xf5es",
                "\uD83C\uDF0D Buscando blocos de mapa",
                "\uD83D\uDCF8 Processando sombras"
            ],
            moveMiddle: "Centralizar a visualiza\xe7\xe3o",
            share_rss_title: "Feed RSS de novas sequ\xeancias na \xe1rea do mapa atualmente vis\xedvel",
            contribute_id: "Contribua para o OpenStreetMap com o editor iD",
            moveRight: "Mover para a direita",
            sequence_prev: "Imagem anterior na sequ\xeancia",
            minimize: "Ocultar este widget. Voc\xea pode exibi-lo novamente usando o bot\xe3o no canto inferior esquerdo",
            error_click: "Continuar",
            semantics_features_none: "Ainda n\xe3o foi desenhado nenhuma caracter\xedstica nesta imagem.",
            semantics_draw_annotation: "Voc\xea pode desenhar o objeto que deseja adicionar na imagem (opcional).",
            semantics_login_needed: "Para editar etiquetas ou caracter\xedsticas de imagens, voc\xea precisa fazer login na inst\xe2ncia Panoramax {n}. Deseja fazer login?",
            filter_zoom_in: "Amplie o mapa para desbloquear",
            picture_360: "360\xb0",
            picture_flat_long: "Imagem cl\xe1ssica",
            filter_qualityscore: "Pontua\xe7\xe3o de qualidade",
            filter_qualityscore_help: "Clique para ativar ou desativar",
            qualityscore_title: "Sobre a pontua\xe7\xe3o de qualidade",
            qualityscore_doc_2: "A pontua\xe7\xe3o \xe9 apresentada como uma letra:",
            semantics_features: "Caracter\xedsticas da imagem",
            semantics_features_default_title: "Etiqueta {nb}",
            semantics_features_subtitle: "{nb} propriedades associadas",
            semantics_annotation_tooltip: "Clique para ver detalhes",
            semantics_hide_all_tags: "Ocultar todas as etiquetas",
            semantics_key: "Chave",
            semantics_value: "Valor",
            semantics_value_doc: "Saiba mais sobre esta etiqueta",
            semantics_tags_picture: "Etiquetas de imagem",
            qualityscore_doc_3: "\u201CA\u201D \xe9 a melhor nota, \u201CE\u201D \xe9 a pior.",
            error_psv: "O Photo Sphere Viewer n\xe3o est\xe1 carregando corretamente",
            error_pic: "A imagem solicitada n\xe3o foi encontrada",
            error_api: "O servidor de imagens n\xe3o est\xe1 dispon\xedvel",
            error_webgl: "O WebGL n\xe3o \xe9 compat\xedvel com o seu navegador",
            error_api_compatibility: "O servidor de imagens n\xe3o \xe9 compat\xedvel com esta vers\xe3o do visualizador",
            filter_date: "Data",
            filter_date_1month: "1 m\xeas",
            filter_date_6months: "6 meses",
            filter_date_1year: "1 ano",
            filter_user: "Usu\xe1rio",
            filter_user_mypics: "Minhas imagens",
            error_josm: "O JOSM n\xe3o respondeu. Ele est\xe1 sendo executado e est\xe1 ativado o acesso remoto?",
            filter_picture: "Tipo de imagem",
            picture_flat: "Cl\xe1ssica",
            picture_360_long: "Imagem panor\xe2mica",
            qualityscore_doc_link: "Saiba mais sobre a Pontua\xe7\xe3o de Qualidade",
            metadata_general_picid_link: "Ir para a descri\xe7\xe3o JSON da imagem",
            metadata_camera_resolution: "Resolu\xe7\xe3o",
            metadata_exif_doc: "Documenta\xe7\xe3o para etiquetas EXIF",
            metadata_exif_doc_title: "Acesse a documenta\xe7\xe3o do Exiv2 para obter detalhes completos sobre as defini\xe7\xf5es das etiquetas EXIF e XMP",
            semantics_title: "Etiquetas",
            semantics_show_all_tags: "Mostrar todas as etiquetas",
            semantics_tags_picture_none: "Ainda n\xe3o foram definidas etiquetas para esta imagem.",
            semantics_send_fail: "N\xe3o \xe9 poss\xedvel salvar suas altera\xe7\xf5es, por favor, tente novamente mais tarde",
            report_details_placeholder: "Opcionalmente, voc\xea pode adicionar detalhes sobre o problema",
            report_nature: {
                inappropriate: "A imagem \xe9 inadequada (sem rela\xe7\xe3o, nudez\u2026)",
                "": "Selecione o tipo do problema\u2026",
                blur_missing: "O rosto de uma pessoa ou a placa de um carro s\xe3o vis\xedveis",
                blur_excess: "Um desfoque desnecess\xe1rio foi aplicado a um objeto",
                privacy: "A foto foi tirada de uma trilha ou propriedade privada",
                picture_low_quality: "A imagem \xe9 de baixa qualidade",
                mislocated: "A imagem est\xe1 mal posicionada no mapa",
                copyright: "A imagem viola direitos autorais",
                other: "Qualquer outro tipo de problema"
            },
            error_nopic: "Nenhuma imagem dispon\xedvel na posi\xe7\xe3o indicada",
            picture_all: "Todas",
            metadata_location_copy_more: "Mais op\xe7\xf5es de c\xf3pia de coordenadas",
            semantics_tags: "{nb} etiquetas",
            semantics_zero_annotations: "Nenhuma caracter\xedstica desenhada nesta imagem",
            semantics_save_drawn_annotation_incomplete: "Voc\xea deve desenhar um ret\xe2ngulo que se encaixe na imagem antes de validar",
            map_background: "Fundo",
            map_background_aerial: "A\xe9reo",
            map_background_streets: "Ruas",
            map_theme: "Tema",
            map_theme_default: "Padr\xe3o",
            map_theme_age: "Data da captura",
            map_theme_age_1: "> 3 anos",
            map_theme_age_2: "< 3 anos",
            map_theme_age_3: "\xbd - 1 ano",
            map_theme_age_4: "< 6 m\xeas",
            map_theme_type: "Tipo de c\xe2mera",
            contrast: "Ativar maior contraste da imagem",
            metadata: "Metadados de imagem",
            metadata_summary: "Resumo",
            metadata_general_copy_id: "Copiar ID",
            metadata_general_copy_picid: "Copiar ID da imagem",
            metadata_general_picid: "Imagem",
            metadata_general_seqid: "Sequ\xeancia",
            metadata_general_seqid_link: "Ir para a descri\xe7\xe3o JSON da sequ\xeancia",
            metadata_general_author: "Autor",
            metadata_general_license: "Licen\xe7a",
            metadata_general_license_link: "Consulte a descri\xe7\xe3o completa da licen\xe7a",
            metadata_general_date: "Data da captura",
            metadata_general_instance: "Inst\xe2ncia de origem",
            metadata_camera: "C\xe2mera",
            metadata_camera_make: "Marca",
            metadata_camera_model: "Modelo",
            metadata_camera_type: "Tipo",
            metadata_camera_focal_length: "Dist\xe2ncia focal",
            metadata_location: "Posi\xe7\xe3o",
            metadata_location_coordinates: "Coordenadas (longitude, latitude)",
            metadata_location_orientation: "Dire\xe7\xe3o",
            metadata_location_precision: "Precis\xe3o de posicionamento",
            metadata_location_copy: "Copiar {v}",
            metadata_quality: "Qualidade",
            metadata_quality_help: "Saiba mais sobre a pontua\xe7\xe3o de qualidade",
            metadata_quality_score: "Pontua\xe7\xe3o global",
            metadata_quality_gps_score: "Pontua\xe7\xe3o de posicionamento",
            metadata_quality_resolution_score: "Pontua\xe7\xe3o de resolu\xe7\xe3o",
            metadata_quality_missing: "nenhum valor definido na imagem",
            metadata_exif: "EXIF",
            metadata_exif_name: "Etiqueta",
            metadata_exif_value: "Valor",
            semantics_editor_error: "A sintaxe est\xe1 inv\xe1lida. Suas etiquetas podem ficar assim:\nchave=valor\nprefixo|chave=valor\nprefixo|chave[qualif_chave=qualif_val]=valor\n\nO comprimento m\xe1ximo da chave \xe9 de 256 caracteres, e o comprimento m\xe1ximo do valor \xe9 de 2048 caracteres.",
            report: "Denunciar",
            report_auth: 'Este relat\xf3rio ser\xe1 enviado usando sua conta "{a}"',
            report_nature_label: "Causa do problema",
            semantics_qualifiers: "Qualificadores",
            semantics_show_annotations: "Exibir caracter\xedsticas da imagem",
            semantics_hide_annotations: "Ocultar caracter\xedsticas da imagem",
            semantics_add_annotation: "Adicionar uma nova etiqueta",
            semantics_save_drawn_annotation: "Salvar posi\xe7\xe3o",
            semantics_undo_drawn_annotation: "Cancelar",
            semantics_delete_annotation: "Excluir esta caracter\xedstica",
            semantics_delete_annotation_confirm: "Voc\xea realmente deseja excluir esta etiqueta?",
            semantics_hashtags: "Hashtags da imagem",
            semantics_wikidata_properties: {
                P31: "inst\xe2ncia de",
                P279: "subclasse de",
                P361: "parte de",
                P180: "retrata"
            },
            semantics_editor_example: "chave=valor\nprefixo|chave=valor",
            semantics_edit: "Editar atributos",
            semantics_save: "Salvar suas altera\xe7\xf5es",
            semantics_undo: "Cancelar suas edi\xe7\xf5es",
            semantics_cantsave_invalid: "N\xe3o \xe9 poss\xedvel salvar as altera\xe7\xf5es, entrada \xe9 inv\xe1lida",
            semantics_send_ok: "Suas edi\xe7\xf5es foram enviadas com \xeaxito",
            report_whole_sequence: "Isso diz respeito a toda a sequ\xeancia",
            report_details: "Detalhes adicionais",
            report_email: "Seu e-mail",
            report_email_placeholder: "Opcional",
            report_submit: "Enviar",
            report_wait: "Enviando relat\xf3rio\u2026",
            qualityscore_doc_1: "\xc9 calculada uma pontua\xe7\xe3o de qualidade para cada imagem.",
            map_theme_score: "Pontua\xe7\xe3o de qualidade",
            report_success: "O relat\xf3rio foi enviado com sucesso. Ele ser\xe1 analisado assim que poss\xedvel.",
            report_failure: "Ocorreu um erro ao criar o relat\xf3rio: {e}. Tente novamente mais tarde.",
            semantics_key_doc: "Saiba mais sobre esta chave",
            semantics_doc: "Ajuda",
            semantics_erase_annotation: "Apagar caracter\xedstica desenhada",
            semantics_doc_title: "Sobre etiquetas",
            semantics_doc_info1: "D\xea contexto a uma imagem usando etiquetas.",
            semantics_doc_link: "Saiba mais sobre etiquetas",
            semantics_doc_info3: "Alguns objetos s\xe3o detectados automaticamente com IA: a qualidade n\xe3o \xe9 garantida.",
            semantics_doc_info2: "Voc\xea tamb\xe9m pode desenhar objetos na imagem: sinais de tr\xe2nsito, equipamentos urbanos\u2026 Marque o que voc\xea v\xea usando as etiquetas existentes. Voc\xea tamb\xe9m pode criar suas pr\xf3prias etiquetas, se necess\xe1rio.",
            semantics_picture_tags: "Etiqueta de imagem",
            semantics_sequence_tags: "Etiqueta de sequ\xeancia",
            semantics_annotation_tags: "Etiqueta de objeto",
            filter_gps_precision: "Precis\xe3o de localiza\xe7\xe3o",
            filter_gps_precision_lessthan: "Menos de {n} metros",
            filter_gps_precision_between: "Entre {n1} e {n2} metros",
            filter_gps_precision_morethan: "Mais de {n} metros",
            map_theme_gps: "Precis\xe3o de GPS",
            semantics_overlays: {
                tfsigns: "Sinais de tr\xe2nsito",
                features: "Todas as caracter\xedsticas"
            },
            semantics_doc_info1u1: "Voc\xea pode marc\xe1-la como capturada por carro com a etiqueta transport=car.",
            semantics_zoom_in: "Amplie o mapa para ver as etiquetas",
            semantics_download: "Baixar",
            semantics_download_title: "Baixar etiquetas",
            semantics_download_info: "Todos os dados sem\xe2nticos (etiquetas) est\xe3o dispon\xedveis como dados abertos. Voc\xea pode baix\xe1-los e utiliz\xe1-los livremente.",
            semantics_download_cta: "Baixar dados abertos",
            semantics_copy: "Copiar atributos",
            popup_details_link: "Mais detalhes",
            qualityscore_doc_5: "Um dispositivo profissional ter\xe1 uma classifica\xe7\xe3o A, uma c\xe2mera de a\xe7\xe3o 360\xb0 ter\xe1 uma classifica\xe7\xe3o B e um smartphone ter\xe1 uma classifica\xe7\xe3o entre C e E.",
            semantics_value_show_osm: "Ver no OpenStreetMap",
            filter_gps_precision_help_4: "Um GPS RTK ter\xe1 uma classifica\xe7\xe3o de \u201C5\u2B50\u201D, uma c\xe2mera de a\xe7\xe3o como a GoPro Max ter\xe1 uma classifica\xe7\xe3o de \u201C3\u2B50\u201D e um GPS de smartphone em um estacionamento subterr\xe2neo ter\xe1 uma classifica\xe7\xe3o de \u201C1\u2B50\u201D.",
            filter_gps_precision_help: "Saiba mais sobre a precis\xe3o da localiza\xe7\xe3o",
            filter_gps_precision_help_1: "Uma pontua\xe7\xe3o da precis\xe3o da localiza\xe7\xe3o est\xe3o dispon\xedvel para cada foto. Isso corresponde \xe0 precis\xe3o do GPS durante a captura da foto.",
            filter_gps_precision_help_2: "A precis\xe3o \xe9 expressa com estrelas:",
            filter_gps_precision_help_3: "\u201C5\u2B50\u201D \xe9 muito preciso (<= {p5}m), \u201C1\u2B50\u201D \xe9 muito impreciso (> {p1}m) ou desconhecido.",
            qualityscore_doc_4: "Esta pontua\xe7\xe3o \xe9 calculada com base em:",
            qualityscore_doc_41: "a precis\xe3o do GPS",
            qualityscore_doc_42: "a resolu\xe7\xe3o da imagem",
            indoor_selector_expand: "Clique para ver todos os n\xedveis dispon\xedveis",
            indoor_selector_shrink: "Clique para minimizar",
            indoor_selector_levelup: "Ir para o n\xedvel superior",
            indoor_selector_scrollup: "Role a lista de n\xedveis para cima",
            indoor_selector_scrolldown: "Role a lista de n\xedveis para baixo",
            indoor_selector_leveldown: "Ir para o n\xedvel inferior",
            indoor_switch: "Espa\xe7os interiores",
            "visibility_logged-only": "Membros",
            "visibility_title_logged-only": "Somente pessoas com uma conta podem ver esta imagem",
            "visibility_owner-only": "Oculto",
            "visibility_title_owner-only": "Apenas voc\xea pode ver esta imagem",
            filter_source_world: "Mundo inteiro",
            filter_source_local: "Este servidor",
            filter_locked: "Filtro desativado",
            map_background_default: "Padr\xe3o",
            map_background_more: "Mais",
            semantics_draw_invalid_annotation: "A \xe1rea desenhada ultrapassa os limites da imagem. Certifique-se de desenhar dentro da \xe1rea vis\xedvel da imagem.",
            semantics_draw_unfinished_annotation: "A \xe1rea desenhada ainda n\xe3o est\xe1 conclu\xedda. Certifique-se de que a \xe1rea esteja bem posicionada antes de salvar.",
            error_pic_load: "N\xe3o \xe9 poss\xedvel carregar esta imagem no momento.\nVerifique sua conex\xe3o com a Internet. Se estiver conectado, certifique-se de que o ID da imagem \xe9 v\xe1lido.",
            low_contrast: "Reduzir o contraste da imagem",
            reset_contrast: "Redefinir o contraste da imagem",
            delete_picture: "Excluir",
            delete_picture_ok: "A foto foi exclu\xedda com sucesso",
            delete_picture_error: "Ocorreu um erro ao tentar excluir a imagem:\n{e}",
            semantics_empty: "Nenhuma etiqueta definida",
            delete_picture_warn: "\u26A0\uFE0F Aten\xe7\xe3o: isso excluir\xe1 definitivamente esta foto.\nTem certeza de que deseja continuar?",
            metadata_general_title: "T\xedtulo",
            time_travel_close: "Ocultar outras datas",
            time_travel: "Ver este local em outras datas",
            map_theme_default_short: "Padr\xe3o",
            map_theme_age_short: "Data",
            map_theme_type_short: "C\xe2mera",
            map_theme_score_short: "Qualidade",
            map_theme_gps_short: "Posi\xe7\xe3o",
            widget_locked: "Op\xe7\xe3o desativada",
            map_theme_default_coef: "N\xedvel de cobertura",
            map_theme_default_coef_short: "Cobertura",
            map_theme_default_1: "Baixo",
            map_theme_default_2: "M\xe9dio",
            map_theme_default_3: "Bom",
            map_theme_default_4: "Excelente",
            sequence_play_backwards: "Reproduzir esta sequ\xeancia ao contr\xe1rio",
            semantics_annotation_tooltip_close: "Clique para desselecionar"
        },
        psv: {
            ctrlZoom: "Use ctrl + rolagem para ampliar a imagem",
            loadError: "O panorama n\xe3o pode ser carregado",
            twoFingers: "Use dois dedos para navegar"
        },
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "Localiza\xe7\xe3o n\xe3o dispon\xedvel",
            "GeolocateControl.FindMyLocation": "Encontre minha localiza\xe7\xe3o"
        },
        map: {
            thumbnail: "Miniatura da imagem ao passar o cursor",
            not_public: "N\xe3o vis\xedvel publicamente",
            slow_loading: "O mapa est\xe1 carregando lentamente e pode parecer com defeito",
            map_data: "Mapa baseado em {m}",
            more_panoramax: "Descubra mais sobre o Panoramax",
            loading: "Carregando\u2026"
        }
    },
    sv: {
        psv: {
            twoFingers: "Anv\xe4nd tv\xe5 fingrar f\xf6r att panorera",
            loadError: "Panoramat kan inte laddas",
            ctrlZoom: "Anv\xe4nd ctrl + scroll f\xf6r att zooma in p\xe5 bilden"
        },
        pnx: {
            moveUp: "Flytta upp",
            zoom: "Zoom",
            zoomOut: "Zooma ut",
            zoomIn: "Zooma in",
            moveDown: "Flytta ner",
            moveLeft: "Flytta v\xe4nster",
            moveRight: "Flytta h\xf6ger",
            moveMiddle: "Centrera vy",
            expand: "Expandera",
            show_psv: "Visa bildvisaren",
            show_map: "Visa kartan",
            expand_info: "Visa widgeten p\xe5 hela sidan",
            minimize: "G\xf6m denna flik, du kan visa den igen genom att anv\xe4nda knappen i nedersta v\xe4nstra h\xf6rnet",
            minimize_short: "G\xf6m",
            options: "Alternativ",
            search: "S\xf6k",
            search_empty: "Inga resultat hittade",
            filters: "Filter",
            layers: "Lager",
            share: "Dela",
            share_links: "L\xe4nkar",
            share_page: "L\xe4nka till denna sida",
            share_image: "HD bild",
            share_rss: "RSS feed",
            share_embed: "B\xe4dda in p\xe5 din hemsida",
            share_embed_docs: "L\xe4s mer om inb\xe4ddad konfiguration",
            share_print: "Skriv ut",
            copy: "Kopiera",
            copied: "Kopierad",
            error: "Vi har ett problem\u2026",
            error_click: "Forts\xe4tt",
            error_retry: "V\xe4nligen f\xf6rs\xf6k igen senare",
            sequence_next: "N\xe4sta bild i sekvensen",
            sequence_play: "Spela upp bilder i sekvensen",
            sequence_pause: "Pausa sekvens",
            sequence_more: "Mera uppspelningsalternativ",
            sequence_speed: "Uppspelningshastighet",
            legend_license: "Licens: {l}",
            search_address: "S\xf6k en adress, stad\u2026",
            edit_osm: "Redigera OSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Laddar kartdata",
                "\uD83D\uDDA5\uFE0F Anropar API",
                "\uD83D\uDDBC\uFE0F Laddar miniatyrer",
                "\uD83D\uDD0D Analyserar EXIF metadata",
                "\uD83C\uDFD8\uFE0F 3D rendering",
                "\uD83D\uDCF7 Initialiserar 360\xb0 bilder",
                "\uD83D\uDFE0 F\xe4rg balansering",
                "\uD83D\uDCAF Ber\xe4kna Kvalitetspo\xe4ng \xa9"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C R\xe4knar \xe4lgar",
                "R\xe4knar gula bilar",
                "\u2615 Bunkrar upp med kaffe",
                "Kaj nu simmar du ur bild!",
                "\uD83D\uDC08 Delar kattbilder",
                "\uD83D\uDE34 Prokastinerar",
                "\uD83E\uDED6 Kokar te",
                "\uD83D\uDC27 \xd6ppnar k\xe4llkod",
                "\uD83D\uDE87 R\xe4knar t\xe5g",
                "\uD83E\uDDF9 St\xe4dar upp bland metadata",
                "\uD83D\uDC3F\uFE0F R\xe4knar ekorrar",
                "\uD83D\uDEB2 R\xe4knar cykelst\xe4ll",
                "\uD83D\uDE89 G\xe5r igenom stationer",
                "\uD83D\uDEF0\uFE0F S\xf6ker satelliter",
                "\uD83E\uDDD1\u200D\uD83C\uDF73 Lagar k\xf6ttbullar",
                "\uD83E\uDDCDSt\xe5r i k\xf6",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Fels\xf6ker gr\xe4nsnitt",
                "\uD83D\uDCC8 \xd6kar statistik"
            ],
            error_psv: "Foto-sf\xe4r visaren laddar inte ordentligt",
            error_nopic: "Ingen bild finns p\xe5 angiven position",
            error_api: "Bildservern \xe4r inte tillg\xe4nlig",
            error_webgl: "WebGL st\xf6ds inte i din webbl\xe4sare",
            error_api_compatibility: "Bildservern \xe4r inte kompatibel med den h\xe4r visarens version",
            filter_date: "Datum",
            filter_date_1month: "1 m\xe5nad",
            filter_date_1year: "1 \xe5r",
            filter_user: "Anv\xe4ndare",
            filter_user_mypics: "Mina bilder",
            filter_picture: "Bildtyp",
            filter_zoom_in: "Zooma in f\xf6r att se detta filter",
            picture_360: "360\xb0",
            filter_qualityscore_help: "Klicka f\xf6r att sl\xe5 p\xe5 eller av",
            qualityscore_title: "Om Kvalitetspo\xe4ng",
            filter_qualityscore: "Kvalitetspo\xe4ng",
            qualityscore_doc_2: "Kvalitet visas som en skala p\xe5 A/B/C/D/E (A \xe4r b\xe4st, E \xe4r s\xe4mst) och visas grafisk genom skalan:",
            map_theme_default: "Klassisk",
            map_theme_age_1: "> 3 \xe5r",
            map_theme_age_2: "< 3 \xe5r",
            map_theme_age_3: "< 1 \xe5r",
            map_theme_age_4: "< 6 m\xe5nad",
            map_theme_type: "Kameratyp",
            contrast: "Aktivera h\xf6gre bildkontrast",
            metadata: "Bildmetadata",
            metadata_general_picid: "Bild-identifierare",
            metadata_general_seqid: "Sekvens-identifierare",
            qualityscore_doc_link: "Mer information om hur Kvalitetspo\xe4ng ber\xe4knas finns i v\xe5r dokumentation.",
            map_theme_score: "Kvalitetspo\xe4ng",
            metadata_general_seqid_link: "G\xe5 till JSON beskrivning av sekvensen",
            metadata_general_author: "Upphovsman",
            metadata_general_license: "Licens",
            metadata_general_license_link: "Se full licensbeskrivning",
            metadata_general_date: "Bild tagen",
            metadata_camera: "Kamera",
            metadata_camera_make: "M\xe4rke",
            metadata_camera_model: "Modell",
            metadata_camera_type: "Typ",
            metadata_camera_resolution: "Uppl\xf6sning",
            metadata_location: "Plats",
            metadata_location_longitude: "Longitud",
            metadata_location_latitude: "Latitud",
            metadata_location_orientation: "Kamerariktning",
            metadata_location_precision: "Positionsprecision",
            metadata_quality: "Kvalitetspo\xe4ng",
            metadata_quality_score: "Global po\xe4ng",
            metadata_quality_gps_score: "Positioneringspo\xe4ng",
            metadata_quality_resolution_score: "Uppl\xf6sningspo\xe4ng",
            metadata_quality_missing: "Inget v\xe4rde satt i bilden",
            metadata_exif: "EXIF / XMP",
            metadata_exif_name: "Tag",
            metadata_exif_value: "V\xe4rde",
            report: "Rapportera bild",
            search_user: "S\xf6k anv\xe4ndarnamn\u2026",
            legend_title: "Visa detaljer f\xf6r bild",
            report_auth: 'Denna rapport kommer skickas genom ditt konto "{a}"',
            share_rss_title: "RSS feed av nya sekvensen f\xf6r karta i bild",
            error_josm: "JOSM svarar inte, k\xf6rs det och \xe4r remote p\xe5slaget?",
            sequence_prev: "F\xf6reg\xe5ende bild i sekvensen",
            josm_live: "Aktivera automatisk JOSM synkronisering vid inladdning av bild",
            metadata_general_picid_link: "G\xe5 till JSON beskrivning av bilden",
            metadata_quality_help: "L\xe4s mer om Kvalitetspo\xe4ng",
            error_pic: "Beg\xe4rd bild hittades inte",
            qualityscore_doc_3: "Det r\xe4knas ut baserat p\xe5 GPS precision och bildens uppl\xf6sning. Ett profesionellt system kommer ha A-kvalit\xe9, en 360\xb0 actionkamera kommer ha B-kvalit\xe9 och en telefon kommer ha C/D/E-kvalit\xe9.",
            qualityscore_doc_1: "Panoramax erbjuder en Kvalitetspo\xe4ng f\xf6r varje bild. Det m\xf6jlig\xf6r enkel kartfiltrering och en omfattande uppvisning av tillg\xe4nligheten av bilder av h\xf6g kvalitet.",
            metadata_camera_focal_length: "Br\xe4nnvidd",
            picture_flat: "Klassisk",
            map_background: "Kartbakgrund",
            map_background_aerial: "Sattelit",
            map_background_streets: "Gator",
            map_theme: "Karttema",
            map_theme_age: "Fotodatum",
            report_nature_label: "Typ av problem",
            report_nature: {
                "": "V\xe4lj typen av problem\u2026",
                blur_missing: "En persons ansikte eller en registreringspl\xe5t \xe4r synlig",
                blur_excess: "Ett objekt som inte beh\xf6ver suddas \xe4r suddad",
                inappropriate: "Bilden \xe4r ol\xe4mplig(orelaterat, nakenhet...)",
                privacy: "En privat v\xe4g eller fastighet \xe4r synlig",
                picture_low_quality: "Bilden \xe4r av mycket d\xe5lig kvalitet",
                mislocated: "Bilden \xe4r placerat d\xe5lig p\xe5 kartan",
                copyright: "Bilden inkr\xe4nker p\xe5 upphovsr\xe4tt",
                other: "N\xe5got annat typ av problem"
            },
            report_whole_sequence: "Detta g\xe4ller hela sekvensen",
            report_details: "Ytterligare detaljer",
            report_details_placeholder: "Valfritt, kan du l\xe4gga till information om problemet och varf\xf6r det \xe4r ett problem",
            report_email: "Din e-post",
            report_email_placeholder: "Valfri",
            report_submit: "Skicka",
            report_wait: "Skickar rapport \u2026",
            report_success: "Rapporten har skickats. Det kommer att ses \xf6ver s\xe5 snart som m\xf6jligt.",
            report_failure: "Ett fel uppstod n\xe4r rapporten skapades: {e}. F\xf6rs\xf6k igen senare."
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Hitta min postion",
            "GeolocateControl.LocationNotAvailable": "Plats inte tillg\xe4nlig"
        },
        map: {
            loading: "Laddar\u2026",
            thumbnail: "Miniatyrbild av r\xf6rd bild",
            not_public: "Inte offentligt synligt",
            slow_loading: "Kartan laddas l\xe5ngsamt och kan verka trasig"
        }
    },
    tr: {
        psv: {
            twoFingers: "Gezinmek i\xe7in iki parma\u011F\u0131n\u0131z\u0131 kullan\u0131n",
            loadError: "Panorama y\xfcklenemedi",
            ctrlZoom: "G\xf6r\xfcnt\xfcy\xfc yak\u0131nla\u015Ft\u0131rmak i\xe7in ctrl + kayd\u0131rma tu\u015Flar\u0131n\u0131 kullan\u0131n"
        },
        pnx: {
            search_empty: "Sonu\xe7 bulunamad\u0131",
            zoom: "Yak\u0131nla\u015Ft\u0131r",
            zoomIn: "Yak\u0131nla\u015Ft\u0131r",
            expand: "Geni\u015Flet",
            layers: "Katmanlar",
            search: "Ara",
            minimize_short: "Gizle",
            share_links: "Ba\u011Flant\u0131lar",
            share_embed_docs: "G\xf6mme yap\u0131land\u0131rmas\u0131 hakk\u0131nda daha fazla bilgi edinin",
            share_print: "Yazd\u0131r",
            panoramax: "Panoramax",
            copied: "Kopyaland\u0131",
            error_click: "Devam et",
            sequence_pause: "Sekans duraklat",
            legend_title: "Resim detaylar\u0131n\u0131 g\xf6r\xfcnt\xfcle",
            contribute_id: "iD edit\xf6r\xfc ile OpenStreetMap'e katk\u0131da bulunun",
            josm: "JOSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Harita verisi y\xfckleniyor",
                "\uD83D\uDDA5\uFE0F API sorgulan\u0131yor",
                "\uD83D\uDDBC\uFE0F K\xfc\xe7\xfck resimler y\xfckleniyor",
                "\uD83D\uDD0D EXIF meta verileri analiz ediliyor",
                "\uD83C\uDFD8\uFE0F 3D i\u015Fleniyor",
                "\uD83D\uDCF7 360\xb0 resimler ba\u015Flat\u0131l\u0131yor",
                "\uD83D\uDFE0 Renk dengeleme",
                "\uD83D\uDCAF Kalite Skoru Hesaplan\u0131yor \xa9",
                "\uD83D\uDCE1 G\xfcncellemeler indiriliyor",
                "\uD83C\uDF0D Harita d\xf6\u015Femeleri getiriliyor",
                "\uD83D\uDCF8 G\xf6lgeler i\u015Fleniyor"
            ],
            metadata_general_license: "Lisans",
            metadata_general_picid: "Resim",
            metadata_general_seqid: "Sekans",
            metadata_general_seqid_link: "Sekans\u0131n JSON a\xe7\u0131klamas\u0131na git",
            metadata_camera_model: "Model",
            metadata_location: "Pozisyon",
            metadata_exif: "EXIF",
            metadata_exif_name: "Etiket",
            metadata_exif_value: "De\u011Fer",
            semantics_title: "Etiketler",
            share_embed: "Web sitenize yerle\u015Ftirin",
            sequence_speed: "Oynat\u0131c\u0131 h\u0131z\u0131",
            metadata_summary: "\xd6zet",
            metadata_general_license_link: "Lisans\u0131n tam a\xe7\u0131klamas\u0131n\u0131 g\xf6r\xfcn",
            metadata_quality: "Kalite",
            zoomOut: "Uzakla\u015Ft\u0131r",
            share: "Payla\u015F",
            share_image: "HD Resim",
            copy: "Kopyala",
            error_retry: "L\xfctfen daha sonra tekrar deneyin",
            show_map: "Haritay\u0131 g\xf6r\xfcnt\xfcle",
            metadata: "Resim meta verisi",
            metadata_general_picid_link: "Resmin JSON a\xe7\u0131klamas\u0131na git",
            metadata_camera_type: "Tip",
            metadata_camera_resolution: "\xc7\xf6z\xfcn\xfcrl\xfck",
            metadata_quality_resolution_score: "\xc7\xf6z\xfcn\xfcrl\xfck skoru",
            metadata_camera: "Kamera",
            report_wait: "Rapor g\xf6nderiliyor\u2026",
            semantics_show_all_tags: "T\xfcm etiketleri g\xf6r\xfcnt\xfcle",
            semantics_hide_all_tags: "T\xfcm etiketleri gizle",
            semantics_value: "De\u011Fer",
            semantics_delete_annotation: "\xd6zelli\u011Fi sil",
            semantics_annotation_tooltip: "Detaylar\u0131 g\xf6r\xfcnt\xfclemek i\xe7in t\u0131klay\u0131n",
            semantics_tags_picture: "Resim etiketleri",
            semantics_delete_annotation_confirm: "Etiketi ger\xe7ekten silmek istiyor musunuz?",
            semantics_save: "De\u011Fi\u015Fiklikleri kaydet",
            minimize: "Bu widget'\u0131 gizleyebilirsiniz, sol alt k\xf6\u015Fedeki d\xfc\u011Fmeyi kullanarak tekrar g\xf6sterebilirsiniz",
            moveUp: "Yukar\u0131 hareket et",
            moveDown: "A\u015Fa\u011F\u0131 hareket et",
            moveLeft: "Sola hareket et",
            moveRight: "Sa\u011Fa hareket et",
            moveMiddle: "Merkez g\xf6r\xfcn\xfcm",
            expand_info: "Widget'\u0131n tam sayfada g\xf6r\xfcnmesini sa\u011Fla",
            show_psv: "Resim g\xf6r\xfcnt\xfcleyiciyi g\xf6ster",
            options: "Se\xe7enekler",
            filters: "Filtreler",
            report_nature: {
                picture_low_quality: "Resim d\xfc\u015F\xfck kalitede",
                other: "Ba\u015Fka herhangi bir sorun",
                "": "Sorunun niteli\u011Fini se\xe7in\u2026",
                mislocated: "Resim haritada k\xf6t\xfc konumland\u0131r\u0131lm\u0131\u015F",
                copyright: "Resim telif hakk\u0131n\u0131 ihlal ediyor",
                blur_missing: "Bir ki\u015Finin y\xfcz\xfc veya ara\xe7 plakas\u0131 g\xf6r\xfcn\xfcyor",
                blur_excess: "Bir nesneye gereksiz bir bulan\u0131kl\u0131k uyguland\u0131",
                inappropriate: "Resim uygunsuz (ilgisiz, \xe7\u0131plakl\u0131k\u2026)",
                privacy: "Foto\u011Fraf \xf6zel bir yoldan veya m\xfclkten \xe7ekilmi\u015Ftir"
            },
            map_background_streets: "Sokaklar",
            contrast: "Daha y\xfcksek g\xf6r\xfcnt\xfc kontrast\u0131n\u0131 etkinle\u015Ftirin",
            search_address: "Adres veya \u015Fehir aray\u0131n...",
            search_user: "Bir kullan\u0131c\u0131 ad\u0131 aray\u0131n\u2026",
            share_page: "Resim ba\u011Flant\u0131s\u0131",
            share_rss: "RSS beslemesi",
            share_rss_title: "\u015Eu anda g\xf6r\xfcnen harita alan\u0131ndaki yeni sekanslar\u0131n RSS beslemesi",
            whats_panoramax: "Panoramax, b\xf6lgelerin resimlerinin co\u011Frafi ortak alan\u0131d\u0131r.",
            error: "Bir sorunumuz var\u2026",
            sequence_next: "S\u0131radaki resim",
            sequence_play: "Bu sekans\u0131 izleyin",
            sequence_prev: "\xd6nceki resim",
            sequence_more: "Daha fazla oynatma se\xe7ene\u011Fi",
            legend_license: "Lisans: {l}",
            id: "iD",
            geo_uri: "Harici uygulama",
            josm_live: "Resim y\xfcklenirken JOSM otomatik senkronizasyonunu etkinle\u015Ftir",
            loading_labels_fun: [
                "\uD83E\uDD8C Geyik ge\xe7i\u015F i\u015Faretlerini tespit etme",
                "\uD83D\uDE98 Panoramax Arac\u0131n\u0131 Bul \xa9",
                "\u2615 Kafein enjekte ediliyor",
                "\uD83D\uDE00 G\xfcl\xfcmse, haritaland\u0131n!",
                "\uD83D\uDC08Kedi resimleri payla\u015F\u0131n",
                "\uD83D\uDE34 Ertelemeyi azalt",
                "\uD83E\uDED6 \xc7ay demle",
                "\uD83D\uDC27 Kaynak kodunu a\xe7",
                "\uD83D\uDE87 Yeralt\u0131 istasyonlar\u0131n\u0131n indeksleniyor",
                "\uD83E\uDDF9 Meta veri temizleme",
                "\uD83D\uDE92 \u0130tfaiye istasyonu resimleri g\xf6nderiliyor",
                "\uD83D\uDEB2Bisiklet rotalar\u0131 g\xfcncelleniyor",
                "\uD83D\uDE89 \u0130stasyon platformu turu",
                "\uD83D\uDEF0\uFE0F Uydular Aran\u0131yor",
                "\uD83D\uDC65 Ki\u015Filikler yaz\u0131l\u0131yor",
                "\uD83D\uDC1F Bal\u0131k ve patates k\u0131zartmas\u0131 d\xfckkanlar\u0131 bulunuyor",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Hata ay\u0131klama aray\xfcz\xfc",
                "\uD83D\uDCC8 \u0130statistikler artt\u0131r\u0131l\u0131yor",
                "\uD83E\uDD16 Anlam bilimi \xf6\u011Freniliyor",
                "\uD83C\uDFA8 Aray\xfcz yeniden tasarlan\u0131yor",
                "\uD83D\uDCC5 Foto\u011Fraf haritalama partileri planla",
                "\uD83E\uDDC0 Olgunla\u015Fan \xe7edarlar",
                "\uD83C\uDF04 Cornwall g\xfcne\u015F \u0131\u015F\u0131\u011F\u0131n\u0131n hesaplanmas\u0131",
                "\uD83C\uDF0A Y\xfcksek gelgitlerin \xf6l\xe7\xfcm\xfc"
            ],
            error_pic: "\u0130stenen resim bulunamad\u0131",
            error_nopic: "Belirtilen konumda resim mevcut de\u011Fil",
            error_api: "Resim sunucusu kullan\u0131lam\u0131yor",
            error_webgl: "Taray\u0131c\u0131n\u0131z WebGL'yi desteklemiyor",
            error_josm: "JOSM yan\u0131t vermedi, \xe7al\u0131\u015F\u0131yor mu ve Uzaktan Kumanda etkin mi?",
            error_api_compatibility: "Resim sunucusu bu g\xf6r\xfcnt\xfcleyici s\xfcr\xfcm\xfcyle uyumlu de\u011Fil",
            filter_date: "Tarih",
            filter_date_1month: "1 ay",
            filter_date_6months: "6 ay",
            filter_date_1year: "1 y\u0131l",
            filter_user: "Kullan\u0131c\u0131",
            filter_user_mypics: "Resimlerim",
            filter_picture: "Resim tipi",
            filter_zoom_in: "Kilidi a\xe7mak i\xe7in yak\u0131nla\u015Ft\u0131r\u0131n",
            picture_all: "T\xfcm\xfc",
            picture_flat: "Klasik",
            picture_360: "360\xb0",
            picture_flat_long: "Klasik resim",
            filter_qualityscore_help: "Etkinle\u015Ftirmek veya devre d\u0131\u015F\u0131 b\u0131rakmak i\xe7in t\u0131klay\u0131n",
            qualityscore_title: "Kalite skoru hakk\u0131nda",
            qualityscore_doc_link: "Kalite Puan\u0131 hakk\u0131nda daha fazla bilgi edinin",
            map_background: "Arkaplan",
            map_theme: "Tema",
            map_theme_default: "Varsay\u0131lan",
            map_theme_age: "Yakalama tarihi",
            map_theme_age_1: "> 3 y\u0131l",
            map_theme_age_2: "< 3 y\u0131l",
            map_theme_age_3: "\xbd - 1 y\u0131l",
            map_theme_age_4: "< 6 ay",
            map_theme_type: "Kamera tipi",
            map_theme_score: "Kalite skoru",
            metadata_general_copy_id: "ID Kopyala",
            metadata_general_copy_picid: "Resim ID kopyala",
            metadata_general_author: "Yazar",
            metadata_general_date: "Yakalama tarihi",
            metadata_general_instance: "K\xf6ken \xf6rne\u011Fi",
            metadata_camera_focal_length: "Odak uzakl\u0131\u011F\u0131",
            metadata_location_orientation: "Y\xf6n",
            metadata_location_copy: "Kopyala {v}",
            metadata_location_precision: "Konumland\u0131rma hassasiyeti",
            metadata_quality_help: "Kalite Puan\u0131 hakk\u0131nda daha fazla bilgi edinin",
            metadata_quality_score: "K\xfcresel skor",
            metadata_quality_gps_score: "Pozisyon skoru",
            metadata_quality_missing: "resimde herhangi bir de\u011Fer belirtilmemi\u015F",
            metadata_exif_doc: "EXIF etiketleri i\xe7in belgeler",
            semantics_tags: "{nb} etiketler",
            semantics_features: "Resim \xf6zellikleri",
            semantics_features_none: "Bu resimde hen\xfcz hi\xe7bir \xf6zellik \xe7izilmedi.",
            semantics_features_default_title: "Etiket {nb}",
            semantics_value_doc: "Bu etiket hakk\u0131nda daha fazla bilgi edinin",
            semantics_features_subtitle: "{nb} ili\u015Fkili \xf6zellikler",
            semantics_key: "Anahtar",
            semantics_key_doc: "Bu anahtar hakk\u0131nda daha fazla bilgi edinin",
            semantics_qualifiers: "Niteleyiciler",
            semantics_draw_annotation: "Resmin \xfczerine eklemek istedi\u011Finiz nesneyi \xe7izebilirsiniz (Opsiyonel).",
            semantics_login_needed: "Resim etiketlerini veya \xf6zelliklerini d\xfczenlemek i\xe7in Panoramax {n} \xf6rne\u011Finde oturum a\xe7man\u0131z gerekir. Oturum a\xe7mak istiyor musunuz?",
            report_email_placeholder: "\u0130ste\u011Fe ba\u011Fl\u0131",
            semantics_add_annotation: "Yeni bir etiket ekle",
            semantics_erase_annotation: "\xc7izilmi\u015F \xf6zelli\u011Fi sil",
            semantics_doc: "Yard\u0131m",
            semantics_doc_title: "Etiketler hakk\u0131nda",
            semantics_show_annotations: "Resim \xf6zelliklerini g\xf6r\xfcnt\xfcle",
            semantics_hide_annotations: "Resim \xf6zelliklerini gizle",
            semantics_zero_annotations: "Bu resimde hi\xe7bir \xf6zellik \xe7izilmedi",
            report: "Rapor et",
            report_auth: 'Bu rapor "{a}" hesab\u0131n\u0131z kullan\u0131larak g\xf6nderilecektir',
            report_nature_label: "Sorunun nedeni",
            semantics_doc_info3: "Baz\u0131 nesneler yapay zeka ile otomatik olarak alg\u0131lan\u0131yor: kalite garanti edilmiyor.",
            semantics_doc_link: "Etiketler hakk\u0131nda daha fazla bilgi edinin",
            report_whole_sequence: "Bu t\xfcm sekans\u0131 ilgilendiriyor",
            report_details: "Ek ayr\u0131nt\u0131lar",
            report_details_placeholder: "\u0130ste\u011Fe ba\u011Fl\u0131 olarak sorunla ilgili ayr\u0131nt\u0131lar\u0131 ekleyebilirsiniz",
            report_email: "Eposta adresin",
            metadata_exif_doc_title: "EXIF ve XMP etiket tan\u0131mlar\u0131n\u0131n t\xfcm ayr\u0131nt\u0131lar\u0131n\u0131 g\xf6rmek i\xe7in Exiv2 dok\xfcman\u0131na gidin",
            report_failure: "{e} raporu olu\u015Fturulurken bir hata olu\u015Ftu. L\xfctfen daha sonra tekrar deneyin.",
            error_psv: "Foto\u011Fraf K\xfcresi G\xf6r\xfcnt\xfcleyicisi d\xfczg\xfcn y\xfcklenmiyor",
            picture_360_long: "Panoramic resim",
            report_success: "Rapor ba\u015Far\u0131yla g\xf6nderildi. En k\u0131sa s\xfcrede incelenecektir.",
            filter_qualityscore: "Kalite skoru",
            metadata_location_coordinates: "Koordinatlar (boylam, enlem)",
            semantics_doc_info2: "Resimdeki nesneleri de \xe7izebilirsiniz: yol i\u015Faretleri, \u015Fehir ekipmanlar\u0131... G\xf6rd\xfcklerinizi mevcut etiketleri kullanarak i\u015Faretleyin. Gerekirse kendi etiketlerinizi de olu\u015Fturabilirsiniz.",
            map_background_aerial: "Havadan",
            qualityscore_doc_3: '"A" en iyi not, "E" en k\xf6t\xfc nottur.',
            metadata_location_copy_more: "Daha fazla koordinat kopyalama se\xe7ene\u011Fi",
            report_submit: "G\xf6nder",
            qualityscore_doc_2: "Puan, harf olarak g\xf6sterilir:",
            semantics_doc_info1: "Etiketler kullanarak bir resme ba\u011Flam kazand\u0131r\u0131n.",
            qualityscore_doc_1: "Her resim i\xe7in bir Kalite Puan\u0131 hesaplan\u0131r.",
            metadata_camera_make: "Olu\u015Ftur",
            semantics_wikidata_properties: {
                P31: "\xf6rne\u011Fi",
                P279: "alt s\u0131n\u0131f\u0131",
                P361: "par\xe7as\u0131",
                P180: "tasvir eder"
            },
            semantics_editor_error: "S\xf6zdizimi ge\xe7ersiz. Etiketleriniz \u015F\xf6yle g\xf6r\xfcnebilir:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nMaksimum anahtar uzunlu\u011Fu 256 karakter, maksimum de\u011Fer uzunlu\u011Fu 2048 karakterdir.",
            semantics_send_fail: "De\u011Fi\u015Fiklikleriniz kaydedilemedi, l\xfctfen daha sonra tekrar deneyin",
            semantics_editor_example: "key=value\nprefix|key=value",
            semantics_edit: "Nitelikleri d\xfczenle",
            semantics_undo: "D\xfczenlemelerinizi iptal edin",
            semantics_sequence_tags: "Sekans etiketi",
            semantics_picture_tags: "Resim etiketi",
            semantics_annotation_tags: "Nesne etiketi",
            filter_gps_precision_lessthan: "{n} metreden az",
            filter_gps_precision_morethan: "{n} metreden fazla",
            filter_gps_precision: "Konum hassasiyeti",
            filter_gps_precision_between: "{n1} ile {n2} metre aras\u0131nda",
            map_theme_gps: "GPS hassasiyeti",
            semantics_overlays: {
                tfsigns: "Trafik i\u015Faretleri",
                features: "T\xfcm \xf6zellikler"
            },
            semantics_download: "\u0130ndir",
            semantics_doc_info1u1: '"transport=car" etiketini kullanarak, foto\u011Fraf\u0131n ara\xe7 taraf\u0131ndan \xe7ekildi\u011Fini belirtebilirsiniz.',
            semantics_zoom_in: "Etiketleri g\xf6rmek i\xe7in haritay\u0131 yak\u0131nla\u015Ft\u0131r\u0131n",
            semantics_download_title: "Etiketleri indir",
            semantics_download_cta: "A\xe7\u0131k verileri indirin",
            semantics_download_info: "T\xfcm anlamsal veriler (etiketler) a\xe7\u0131k veri olarak mevcuttur. Bunlar\u0131 diledi\u011Finiz gibi indirebilir ve kullanabilirsiniz.",
            semantics_copy: "\xd6zellikleri kopyala",
            semantics_value_show_osm: "OpenStreetMap'te g\xf6r\xfcnt\xfcle",
            filter_gps_precision_help: "Konum Hassasiyeti hakk\u0131nda daha fazla bilgi edinin",
            filter_gps_precision_help_1: "Her foto\u011Fraf i\xe7in bir Konum Hassasiyeti puan\u0131 mevcuttur. Bu, foto\u011Fraf \xe7ekimi s\u0131ras\u0131nda GPS hassasiyetine kar\u015F\u0131l\u0131k gelir.",
            filter_gps_precision_help_2: "Hassasiyet y\u0131ld\u0131zlarla ifade edilir:",
            filter_gps_precision_help_3: '"5\u2B50" \xe7ok hassast\u0131r (<= {p5}m), "1\u2B50" ise \xe7ok belirsizdir (> {p1}m) veya bilinmemektedir.',
            qualityscore_doc_4: "Bu puan a\u015Fa\u011F\u0131daki kriterlere g\xf6re hesaplan\u0131r:",
            qualityscore_doc_41: "GPS hassasiyeti",
            qualityscore_doc_42: "resim \xe7\xf6z\xfcn\xfcrl\xfc\u011F\xfc",
            qualityscore_doc_5: "Profesyonel bir cihaz A s\u0131n\u0131f\u0131, 360\xb0 aksiyon kameras\u0131 B s\u0131n\u0131f\u0131, ak\u0131ll\u0131 telefon ise C ile E aras\u0131nda bir s\u0131n\u0131fa sahip olacakt\u0131r.",
            filter_gps_precision_help_4: 'RTK GPS cihazlar\u0131 "5\u2B50" puan al\u0131rken, GoPro Max gibi aksiyon kameralar\u0131 "3\u2B50" puan, yer alt\u0131 otopark\u0131ndaki ak\u0131ll\u0131 telefon GPS\'leri ise "1\u2B50" puan alacakt\u0131r.',
            popup_details_link: "Daha fazla detay",
            indoor_selector_shrink: "K\xfc\xe7\xfcltmek i\xe7in t\u0131klay\u0131n",
            indoor_selector_leveldown: "Alt kata inin",
            indoor_selector_scrollup: "Seviye listesini yukar\u0131 kayd\u0131r\u0131n",
            indoor_selector_scrolldown: "Seviye listesini a\u015Fa\u011F\u0131 kayd\u0131r\u0131n",
            indoor_switch: "\u0130\xe7 mekanlar",
            indoor_selector_expand: "Mevcut t\xfcm seviyeleri g\xf6rmek i\xe7in t\u0131klay\u0131n",
            indoor_selector_levelup: "\xdcst kata \xe7\u0131k\u0131n",
            "visibility_logged-only": "\xdcyeler",
            "visibility_title_logged-only": "Bu resmi yaln\u0131zca hesab\u0131 olanlar g\xf6rebilir",
            "visibility_owner-only": "Gizli",
            "visibility_title_owner-only": "Bu resmi sadece sen g\xf6rebilirsin",
            filter_source_world: "T\xfcm d\xfcnya",
            filter_source_local: "Bu sunucu",
            filter_locked: "Filtre devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131",
            map_background_default: "Varsay\u0131lan",
            map_background_more: "Daha fazla",
            semantics_draw_invalid_annotation: "\xc7izilen alan, resmin s\u0131n\u0131rlar\u0131n\u0131 a\u015F\u0131yor. L\xfctfen g\xf6r\xfcn\xfcr resim alan\u0131 i\xe7inde \xe7izim yapmaya \xf6zen g\xf6sterin.",
            semantics_draw_unfinished_annotation: "\xc7izilen alan hen\xfcz tamamlanmad\u0131. Kaydetmeden \xf6nce alan\u0131n do\u011Fru konumland\u0131r\u0131ld\u0131\u011F\u0131ndan emin olun.",
            error_pic_load: "Bu resim \u015Fu anda y\xfcklenemiyor.\nL\xfctfen internet ba\u011Flant\u0131n\u0131z\u0131 kontrol edin. Ba\u011Flant\u0131n\u0131z varsa, resimdeki kimli\u011Fin ge\xe7erli oldu\u011Fundan emin olun.",
            semantics_empty: "Hi\xe7bir etiket tan\u0131mlanmad\u0131",
            low_contrast: "G\xf6r\xfcnt\xfc kontrast\u0131n\u0131 d\xfc\u015F\xfcr\xfcn",
            reset_contrast: "G\xf6r\xfcnt\xfc kontrast\u0131n\u0131 s\u0131f\u0131rla",
            delete_picture: "Sil",
            delete_picture_warn: "\u26A0\uFE0F Dikkat: Bu i\u015Flem bu resmi kal\u0131c\u0131 olarak silecektir.\nDevam etmek istedi\u011Finizden emin misiniz?",
            delete_picture_ok: "Resim ba\u015Far\u0131yla silindi",
            delete_picture_error: "Resim silinmeye \xe7al\u0131\u015F\u0131l\u0131rken bir hata olu\u015Ftu:\n{e}",
            metadata_general_title: "Ba\u015Fl\u0131k",
            time_travel: "Bu yeri di\u011Fer tarihlerde de g\xf6r\xfcn",
            time_travel_close: "Di\u011Fer tarihleri gizle",
            map_theme_default_short: "Varsay\u0131lan",
            map_theme_age_short: "Tarih",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Kalite",
            map_theme_gps_short: "Pozisyon",
            map_theme_default_coef_short: "Kapsam",
            map_theme_default_1: "D\xfc\u015F\xfck",
            map_theme_default_2: "Ortalama",
            map_theme_default_3: "\u0130yi",
            map_theme_default_4: "Harika",
            widget_locked: "Se\xe7enek devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131",
            map_theme_default_coef: "Kapsama d\xfczeyi",
            sequence_play_backwards: "Bu sekans\u0131 geriye do\u011Fru oynat\u0131n",
            semantics_annotation_tooltip_close: "Se\xe7imi kald\u0131rmak i\xe7in t\u0131klay\u0131n"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Konumu bul",
            "GeolocateControl.LocationNotAvailable": "Lokasyon mevcut de\u011Fil"
        },
        map: {
            thumbnail: "\xdczerine gelinen k\xfc\xe7\xfck resim",
            not_public: "Kamuya a\xe7\u0131k de\u011Fil",
            slow_loading: "Harita yava\u015F y\xfckleniyor ve bozuk g\xf6r\xfcnebilir",
            map_data: "{m} temelli harita",
            loading: "Y\xfckleniyor\u2026",
            more_panoramax: "Panoramax hakk\u0131nda daha fazla bilgi edinin"
        }
    },
    uk: {
        psv: {
            twoFingers: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0434\u0432\u0430 \u043F\u0430\u043B\u044C\u0446\u0456 \u0434\u043B\u044F \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0457",
            ctrlZoom: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u044E \u043A\u043B\u0430\u0432\u0456\u0448 Ctrl + \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430, \u0449\u043E\u0431 \u0437\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            loadError: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0430"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "\u0417\u043D\u0430\u0439\u0442\u0438 \u043C\u043E\u0454 \u043C\u0456\u0441\u0446\u0435\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
            "GeolocateControl.LocationNotAvailable": "\u041C\u0456\u0441\u0446\u0435\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435"
        },
        pnx: {
            zoomOut: "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438",
            zoom: "\u041C\u0430\u0441\u0448\u0442\u0430\u0431\u0443\u0432\u0430\u043D\u043D\u044F",
            zoomIn: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
            moveDown: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043D\u0438\u0437",
            moveLeft: "\u0420\u0443\u0445\u0430\u0442\u0438\u0441\u044F \u043B\u0456\u0432\u043E\u0440\u0443\u0447",
            moveUp: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043E\u0440\u0443",
            moveMiddle: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0434",
            moveRight: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438\u0441\u044F \u0432\u043F\u0440\u0430\u0432\u043E",
            expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
            show_psv: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0447 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            show_map: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043A\u0430\u0440\u0442\u0443",
            minimize: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0432\u0456\u0434\u0436\u0435\u0442, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0439\u043E\u0433\u043E \u0437\u043D\u043E\u0432\u0443 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043A\u043D\u043E\u043F\u043A\u0438 \u0432 \u043D\u0438\u0436\u043D\u044C\u043E\u043C\u0443 \u043B\u0456\u0432\u043E\u043C\u0443 \u043A\u0443\u0442\u0456",
            minimize_short: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438",
            options: "\u041E\u043F\u0446\u0456\u0457",
            filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
            layers: "\u0428\u0430\u0440\u0438",
            search: "\u041F\u043E\u0448\u0443\u043A",
            search_empty: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0456",
            search_user: "\u041F\u043E\u0448\u0443\u043A \u0456\u043C\u0435\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u2026",
            share_links: "\u041B\u0456\u043D\u043A\u0438",
            share_image: "HD-\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            share_rss: "RSS-\u043A\u0430\u043D\u0430\u043B",
            share_embed: "\u0412\u0431\u0443\u0434\u0443\u0432\u0430\u0442\u0438 \u043D\u0430 \u0441\u0432\u0456\u0439 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442",
            share_embed_docs: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E \u0432\u0431\u0443\u0434\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
            share_print: "\u0414\u0440\u0443\u043A",
            panoramax: "Panoramax",
            copy: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
            copied: "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E",
            error: "\u0423 \u043D\u0430\u0441 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u2026",
            error_click: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
            error_retry: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435",
            sequence_play: "\u0412\u0456\u0434\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0446\u044E \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0456\u0441\u0442\u044C",
            sequence_pause: "\u041F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0443\u0437",
            sequence_prev: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0432 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            sequence_more: "\u0411\u0456\u043B\u044C\u0448\u0435 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0456\u0432 \u0433\u0440\u0438",
            legend_license: "\u041B\u0456\u0446\u0435\u043D\u0437\u0456\u044F: {l}",
            legend_title: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            id: "iD",
            geo_uri: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0430",
            josm: "JOSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u043A\u0430\u0440\u0442\u0438",
                "\uD83D\uDDA5\uFE0F \u0417\u0430\u043F\u0438\u0442 API",
                "\uD83D\uDDBC\uFE0F \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u0456\u043D\u0456\u0430\u0442\u044E\u0440",
                "\uD83D\uDD0D \u0410\u043D\u0430\u043B\u0456\u0437 \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u0438\u0445 EXIF",
                "\uD83C\uDFD8\uFE0F 3D-\u0432\u0456\u0437\u0443\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F",
                "\uD83D\uDCF7 \u0406\u043D\u0456\u0446\u0456\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F 360\xb0-\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
                "\uD83D\uDFE0 \u0411\u0430\u043B\u0430\u043D\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043B\u044C\u043E\u0440\u0456\u0432",
                "\uD83D\uDCAF \u041E\u0431\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044F \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0430 \u044F\u043A\u043E\u0441\u0442\u0456 \xa9",
                "\uD83D\uDCE1 \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u044C",
                "\uD83C\uDF0D \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0456\u0432 \u043A\u0430\u0440\u0442\u0438",
                "\uD83D\uDCF8 \u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u0442\u0456\u043D\u0435\u0439"
            ],
            expand_info: "\u0417\u0440\u043E\u0431\u0438\u0442\u0438 \u0432\u0456\u0434\u0436\u0435\u0442 \u0432\u0438\u0434\u0438\u043C\u0438\u043C \u043D\u0430 \u0432\u0441\u0456\u0439 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
            search_address: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0430\u0434\u0440\u0435\u0441\u043E\u044E, \u043C\u0456\u0441\u0442\u043E\u043C\u2026",
            sequence_speed: "\u0428\u0432\u0438\u0434\u043A\u0456\u0441\u0442\u044C \u0433\u0440\u0430\u0432\u0446\u044F",
            share_rss_title: "RSS-\u043A\u0430\u043D\u0430\u043B \u043D\u043E\u0432\u0438\u0445 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0435\u0439 \u0443 \u043F\u043E\u0442\u043E\u0447\u043D\u0456\u0439 \u0432\u0438\u0434\u0438\u043C\u0456\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0456 \u043A\u0430\u0440\u0442\u0438",
            whats_panoramax: "Panoramax \u2014 \u0446\u0435 \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0456\u0447\u043D\u0430 \u0431\u0430\u0437\u0430 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u0439.",
            share: "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
            share_page: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0446\u044E \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443",
            sequence_next: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0432 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            contribute_id: "\u0414\u043E\u043B\u0443\u0447\u0456\u0442\u044C\u0441\u044F \u0434\u043E OpenStreetMap \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 iD",
            josm_live: "\u0423\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0443 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044E JOSM \u043F\u0456\u0434 \u0447\u0430\u0441 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            loading_labels_fun: [
                "\uD83E\uDD8C \u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u043D\u0430\u043A\u0456\u0432 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0443 \u0434\u043B\u044F \u043E\u043B\u0435\u043D\u0456\u0432",
                "\uD83D\uDE98 \u041F\u043E\u0448\u0443\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044F Panoramax \xa9",
                "\u2615 \u0406\u043D'\u0454\u043A\u0446\u0456\u0457 \u043A\u043E\u0444\u0435\u0457\u043D\u0443",
                "\uD83D\uDE00 \u041F\u043E\u0441\u043C\u0456\u0445\u043D\u0438\u0441\u044F, \u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456!",
                "\uD83D\uDC08 \u0414\u0456\u043B\u044E\u0441\u044F \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u044F\u043C\u0438 \u043A\u043E\u0442\u0456\u0432",
                "\uD83D\uDE34 \u0417\u043C\u0435\u043D\u0448\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u043A\u0440\u0430\u0441\u0442\u0438\u043D\u0430\u0446\u0456\u0457",
                "\uD83E\uDED6 \u0417\u0430\u0432\u0430\u0440\u044E\u0432\u0430\u043D\u043D\u044F \u0447\u0430\u044E",
                "\uD83D\uDC27 \u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u0432\u0438\u0445\u0456\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0443",
                "\uD83D\uDE87 \u0406\u043D\u0434\u0435\u043A\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0442\u0430\u043D\u0446\u0456\u0439 \u043C\u0435\u0442\u0440\u043E",
                "\uD83E\uDDF9 \u041E\u0447\u0438\u0449\u0435\u043D\u043D\u044F \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u0438\u0445",
                "\uD83D\uDE92 \u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u0439 \u043F\u043E\u0436\u0435\u0436\u043D\u043E\u0457 \u0441\u0442\u0430\u043D\u0446\u0456\u0457",
                "\uD83D\uDEB2 \u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u0435\u043B\u0435\u043D\u0438\u0445 \u0441\u0442\u0435\u0436\u043E\u043A",
                "\uD83D\uDE89 \u041E\u0433\u043B\u044F\u0434 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0438 \u0441\u0442\u0430\u043D\u0446\u0456\u0457",
                "\uD83D\uDEF0\uFE0F \u041F\u043E\u0448\u0443\u043A \u0441\u0443\u043F\u0443\u0442\u043D\u0438\u043A\u0456\u0432",
                "\uD83D\uDC65 \u041F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u0438\u0446\u044C\u043A\u0456 \u043F\u0435\u0440\u0441\u043E\u043D\u0438",
                "\uD83D\uDC1F \u041F\u043E\u0448\u0443\u043A \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432 \u0447\u0456\u043F\u0441\u0456\u0432",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB \u0406\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043D\u0430\u043B\u0430\u0433\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
                "\uD83D\uDCC8 \u0417\u0431\u0456\u043B\u044C\u0448\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438",
                "\uD83E\uDD16 \u0412\u0438\u0432\u0447\u0435\u043D\u043D\u044F \u0441\u0435\u043C\u0430\u043D\u0442\u0438\u043A\u0438",
                "\uD83C\uDFA8 \u0420\u0435\u0434\u0438\u0437\u0430\u0439\u043D \u0456\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0443",
                "\uD83D\uDCC5 \u041F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0435\u0447\u0456\u0440\u043E\u043A \u0437 \u0444\u043E\u0442\u043E\u043C\u0435\u043F\u0456\u043D\u0433\u043E\u043C",
                "\uD83E\uDDC0 \u0412\u0438\u0437\u0440\u0456\u043B\u0438\u0439 \u0447\u0435\u0434\u0434\u0435\u0440",
                "\uD83C\uDF04 \u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043A\u043E\u0440\u043D\u0443\u043E\u043B\u044C\u0441\u044C\u043A\u043E\u0457 \u0441\u043E\u043D\u044F\u0447\u043D\u043E\u0457 \u0435\u043D\u0435\u0440\u0433\u0456\u0457",
                "\uD83C\uDF0A \u0412\u0438\u043C\u0456\u0440\u044E\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u0438\u043F\u043B\u0438\u0432\u0456\u0432"
            ],
            error_psv: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u0430 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0444\u043E\u0442\u043E\u0441\u0444\u0435\u0440 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430\u043B\u0435\u0436\u043D\u0438\u043C \u0447\u0438\u043D\u043E\u043C",
            error_pic: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
            error_nopic: "\u0423 \u0432\u043A\u0430\u0437\u0430\u043D\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456 \u043D\u0435\u043C\u0430\u0454 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            error_api: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
            error_webgl: "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 WebGL",
            error_josm: "JOSM \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454, \u0447\u0438 \u043F\u0440\u0430\u0446\u044E\u0454 \u0432\u0456\u043D \u0456 \u0447\u0438 \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E \u0432\u0456\u0434\u0434\u0430\u043B\u0435\u043D\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F?",
            error_api_compatibility: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C \u043D\u0435 \u0441\u0443\u043C\u0456\u0441\u043D\u0438\u0439 \u0437 \u0446\u0456\u0454\u044E \u0432\u0435\u0440\u0441\u0456\u0454\u044E \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0447\u0430",
            filter_date: "\u0414\u0430\u0442\u0430",
            filter_date_1month: "1 \u043C\u0456\u0441\u044F\u0446\u044C",
            filter_date_6months: "6 \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            filter_date_1year: "1 \u0440\u0456\u043A",
            filter_user: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
            filter_user_mypics: "\u041C\u043E\u0457 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u0457",
            filter_picture: "\u0422\u0438\u043F \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            filter_zoom_in: "\u0417\u0431\u0456\u043B\u044C\u0448\u0442\u0435 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0446\u0435\u0439 \u0444\u0456\u043B\u044C\u0442\u0440",
            picture_all: "\u0423\u0441\u0456",
            picture_flat: "\u041A\u043B\u0430\u0441\u0438\u0447\u043D\u0438\u0439",
            picture_360: "360\xb0",
            picture_flat_long: "\u041A\u043B\u0430\u0441\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u0430",
            picture_360_long: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u043D\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            filter_qualityscore: "\u041F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            filter_qualityscore_help: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0443\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0430\u0431\u043E \u0432\u0438\u043C\u043A\u043D\u0443\u0442\u0438",
            qualityscore_title: "\u041F\u0440\u043E \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            qualityscore_doc_1: "Panoramax \u043F\u0440\u043E\u043F\u043E\u043D\u0443\u0454 \u043E\u0446\u0456\u043D\u043A\u0443 \u044F\u043A\u043E\u0441\u0442\u0456 \u0434\u043B\u044F \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F. \u0426\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u043B\u0435\u0433\u043A\u043E \u0444\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043A\u0430\u0440\u0442\u0438 \u0442\u0430 \u043F\u043E\u0432\u043D\u0435 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u0432\u0438\u0441\u043E\u043A\u043E\u044F\u043A\u0456\u0441\u043D\u0438\u0445 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C.",
            qualityscore_doc_2: "\u041E\u0446\u0456\u043D\u043A\u0430 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C \u0443 \u0432\u0438\u0433\u043B\u044F\u0434\u0456 \u0431\u0430\u043B\u0456\u0432 A/B/C/D/E (A \u2013 \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u0438\u0439, E \u2013 \u043D\u0430\u0439\u0433\u0456\u0440\u0448\u0438\u0439) \u0442\u0430 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0433\u0440\u0430\u0444\u0456\u0447\u043D\u043E \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0446\u0456\u0454\u0457 \u0448\u043A\u0430\u043B\u0438:",
            qualityscore_doc_3: "\u0412\u0456\u043D \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u0456 GPS \u0442\u0430 \u0440\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u043E\u0457 \u0437\u0434\u0430\u0442\u043D\u043E\u0441\u0442\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F. \u041F\u0440\u043E\u0444\u0435\u0441\u0456\u0439\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043C\u0430\u0442\u0438\u043C\u0435 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 A, \u0435\u043A\u0448\u043D-\u043A\u0430\u043C\u0435\u0440\u0430 \u043D\u0430 360\xb0 \u2014 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 B, \u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D \u2014 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 C/D/E.",
            qualityscore_doc_link: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            map_background: "\u0424\u043E\u043D \u043A\u0430\u0440\u0442\u0438",
            map_background_aerial: "\u0421\u0443\u043F\u0443\u0442\u043D\u0438\u043A\u043E\u0432\u0438\u0439",
            map_background_streets: "\u0412\u0443\u043B\u0438\u0446\u0456",
            map_theme: "\u0422\u0435\u043C\u0430 \u043A\u0430\u0440\u0442\u0438",
            map_theme_default: "\u041A\u043B\u0430\u0441\u0438\u0447\u043D\u0438\u0439",
            map_theme_age: "\u0414\u0430\u0442\u0430 \u0437\u0439\u043E\u043C\u043A\u0438",
            map_theme_age_1: "> 3 \u0440\u043E\u043A\u0456\u0432",
            map_theme_age_2: "< 3 \u0440\u043E\u043A\u0456\u0432",
            map_theme_age_3: "< 1 \u0440\u043E\u043A\u0443",
            map_theme_age_4: "< 6 \u043C\u0456\u0441\u044F\u0446\u044F",
            map_theme_type: "\u0422\u0438\u043F \u043A\u0430\u043C\u0435\u0440\u0438",
            map_theme_score: "\u041F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            contrast: "\u0423\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0432\u0438\u0449\u0443 \u043A\u043E\u043D\u0442\u0440\u0430\u0441\u0442\u043D\u0456\u0441\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata: "\u041C\u0435\u0442\u0430\u0434\u0430\u043D\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_summary: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0437\u043C\u0456\u0441\u0442",
            metadata_general_copy_id: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440",
            metadata_general_picid: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_general_seqid: "\u041F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0456\u0441\u0442\u044C",
            metadata_general_copy_picid: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_general_picid_link: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E JSON-\u043E\u043F\u0438\u0441\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_general_seqid_link: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E JSON-\u043E\u043F\u0438\u0441\u0443 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            metadata_general_author: "\u0410\u0432\u0442\u043E\u0440",
            metadata_general_license: "\u041B\u0456\u0446\u0435\u043D\u0437\u0456\u044F",
            metadata_general_license_link: "\u0414\u0438\u0432. \u043F\u043E\u0432\u043D\u0438\u0439 \u043E\u043F\u0438\u0441 \u043B\u0456\u0446\u0435\u043D\u0437\u0456\u0457",
            metadata_general_date: "\u0414\u0430\u0442\u0430 \u0437\u0439\u043E\u043C\u043A\u0438",
            metadata_camera: "\u041A\u0430\u043C\u0435\u0440\u0430",
            metadata_camera_make: "\u0417\u0440\u043E\u0431\u0438\u0442\u0438",
            metadata_general_instance: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0435\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440",
            metadata_camera_model: "\u041C\u043E\u0434\u0435\u043B\u044C",
            metadata_camera_type: "\u0422\u0438\u043F",
            metadata_camera_resolution: "\u0420\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u0430 \u0437\u0434\u0430\u0442\u043D\u0456\u0441\u0442\u044C",
            metadata_location: "\u041F\u043E\u0437\u0438\u0446\u0456\u044F",
            metadata_location_coordinates: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438 (\u0434\u043E\u0432\u0433\u043E\u0442\u0430, \u0448\u0438\u0440\u043E\u0442\u0430)",
            metadata_location_orientation: "\u041D\u0430\u043F\u0440\u044F\u043C\u043E\u043A",
            metadata_location_precision: "\u0422\u043E\u0447\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u043E\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
            metadata_location_copy: "\u041A\u043E\u043F\u0456\u044F {v}",
            metadata_location_copy_more: "\u0411\u0456\u043B\u044C\u0448\u0435 \u043E\u043F\u0446\u0456\u0439 \u043A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
            metadata_quality: "\u042F\u043A\u0456\u0441\u0442\u044C",
            metadata_quality_help: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            metadata_quality_score: "\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0430\u043B",
            metadata_quality_gps_score: "\u041E\u0446\u0456\u043D\u043A\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u043E\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
            metadata_quality_resolution_score: "\u041E\u0446\u0456\u043D\u043A\u0430 \u0440\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u043E\u0457 \u0437\u0434\u0430\u0442\u043D\u043E\u0441\u0442\u0456",
            metadata_exif: "EXIF",
            metadata_exif_name: "\u0422\u0435\u0433",
            metadata_exif_value: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            metadata_exif_doc: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0434\u043B\u044F \u0442\u0435\u0433\u0456\u0432 EXIF",
            metadata_exif_doc_title: "\u041F\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044C \u0434\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u0457 Exiv2, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0443 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u043F\u0440\u043E \u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0433\u0456\u0432 EXIF \u0442\u0430 XMP",
            semantics_title: "\u0422\u0435\u0433\u0438",
            semantics_tags: "\u0442\u0435\u0433\u0438 {nb}",
            semantics_features_subtitle: "{nb} \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u0432\u043B\u0430\u0441\u0442\u0438\u0432\u043E\u0441\u0442\u0456",
            semantics_annotation_tooltip: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u0456",
            semantics_show_all_tags: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u0435\u0433\u0438",
            semantics_hide_all_tags: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u0435\u0433\u0438",
            semantics_key: "\u041A\u043B\u044E\u0447",
            semantics_value: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            semantics_key_doc: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0446\u0435\u0439 \u043A\u043B\u044E\u0447",
            semantics_value_doc: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0446\u0435\u0439 \u0442\u0435\u0433",
            semantics_tags_picture: "\u0422\u0435\u0433\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            semantics_tags_picture_none: "\u0414\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0449\u0435 \u043D\u0435 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0442\u0435\u0433\u0456\u0432.",
            semantics_qualifiers: "\u041A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0442\u043E\u0440\u0438",
            semantics_features: "\u041E\u0441\u043E\u0431\u043B\u0438\u0432\u043E\u0441\u0442\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            semantics_features_default_title: "\u0422\u0435\u0433 {nb}",
            semantics_features_none: "\u041D\u0430 \u0446\u044C\u043E\u043C\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456 \u0449\u0435 \u043D\u0435 \u043D\u0430\u043C\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u043E \u0436\u043E\u0434\u043D\u043E\u0457 \u043E\u0441\u043E\u0431\u043B\u0438\u0432\u043E\u0441\u0442\u0456.",
            semantics_show_annotations: "\u0424\u0443\u043D\u043A\u0446\u0456\u0457 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0430 \u0434\u0438\u0441\u043F\u043B\u0435\u0457",
            metadata_camera_focal_length: "\u0424\u043E\u043A\u0443\u0441\u043D\u0430 \u0432\u0456\u0434\u0441\u0442\u0430\u043D\u044C",
            metadata_quality_missing: "\u043D\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456 \u043D\u0435 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            semantics_draw_annotation: "\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043C\u0430\u043B\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0438\u0439 \u043E\u0431'\u0454\u043A\u0442 \u043F\u043E\u0432\u0435\u0440\u0445 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E).",
            semantics_save_drawn_annotation: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
            semantics_undo_drawn_annotation: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
            semantics_delete_annotation: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u043E\u0431'\u0454\u043A\u0442",
            semantics_hashtags: "\u0425\u0435\u0448\u0442\u0435\u0433\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            semantics_wikidata_properties: {
                P31: "\u043F\u0440\u0438\u043A\u043B\u0430\u0434",
                P279: "\u043F\u0456\u0434\u043A\u043B\u0430\u0441",
                P361: "\u0447\u0430\u0441\u0442\u0438\u043D\u0430"
            },
            semantics_editor_error: "\u0421\u0438\u043D\u0442\u0430\u043A\u0441\u0438\u0441 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439. \u0412\u0430\u0448\u0456 \u0442\u0435\u0433\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0432\u0438\u0433\u043B\u044F\u0434\u0430\u0442\u0438 \u0442\u0430\u043A:\n\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\u043F\u0440\u0435\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\u043F\u0440\u0435\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447[\u043A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439_\u043A\u043B\u044E\u0447=\u043A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0435_\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F]=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\n\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u043E\u0432\u0436\u0438\u043D\u0430 \u043A\u043B\u044E\u0447\u0430 \u2014 256 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432, \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u043E\u0432\u0436\u0438\u043D\u0430 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u2014 2048 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432.",
            semantics_editor_example: "\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\u043F\u0440\u0435\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            semantics_edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0438",
            semantics_save: "\u0417\u0431\u0435\u0440\u0435\u0436\u0456\u0442\u044C \u0437\u043C\u0456\u043D\u0438",
            semantics_undo: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0430\u0448\u0456 \u0437\u043C\u0456\u043D\u0438",
            semantics_cantsave_invalid: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438, \u0432\u0432\u0435\u0434\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0456",
            semantics_send_fail: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435",
            semantics_send_ok: "\u0412\u0430\u0448\u0456 \u0437\u043C\u0456\u043D\u0438 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
            report_details: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0435\u0442\u0430\u043B\u0456",
            report_details_placeholder: "\u0417\u0430 \u0431\u0430\u0436\u0430\u043D\u043D\u044F\u043C, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u0456 \u043F\u0440\u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443",
            semantics_zero_annotations: "\u041D\u0430 \u0446\u044C\u043E\u043C\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456 \u043D\u0435\u043C\u0430\u0454 \u043D\u0430\u043C\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u0438\u0445 \u0440\u0438\u0441",
            semantics_add_annotation: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0435\u0433",
            semantics_delete_annotation_confirm: "\u0412\u0438 \u0441\u043F\u0440\u0430\u0432\u0434\u0456 \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0442\u0435\u0433?",
            semantics_login_needed: "\u0429\u043E\u0431 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u0435\u0433\u0438 \u0430\u0431\u043E \u043E\u0431'\u0454\u043A\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C, \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0443\u0432\u0456\u0439\u0442\u0438 \u0432 \u0435\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 Panoramax {n}. \u0412\u0438 \u0445\u043E\u0447\u0435\u0442\u0435 \u0443\u0432\u0456\u0439\u0442\u0438?",
            report: "\u0417\u0432\u0456\u0442",
            report_auth: '\u0426\u0435\u0439 \u0437\u0432\u0456\u0442 \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0437 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F\u043C \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 "{a}"',
            report_nature_label: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
            report_nature: {
                blur_excess: "\u0414\u043E \u043E\u0431'\u0454\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0430\u043D\u043E \u043D\u0435\u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u0440\u043E\u0437\u043C\u0438\u0442\u0442\u044F",
                inappropriate: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0440\u0435\u0447\u043D\u0435 (\u043D\u0435 \u0441\u0442\u043E\u0441\u0443\u0454\u0442\u044C\u0441\u044F \u0442\u0435\u043C\u0438, \u043E\u0433\u043E\u043B\u0435\u043D\u0435 \u0442\u0456\u043B\u043E\u2026)",
                privacy: "\u0412\u0438\u0434\u043D\u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0439 \u0448\u043B\u044F\u0445 \u0430\u0431\u043E \u0432\u043B\u0430\u0441\u043D\u0456\u0441\u0442\u044C",
                mislocated: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u0433\u0430\u043D\u043E \u0440\u043E\u0437\u0442\u0430\u0448\u043E\u0432\u0430\u043D\u0435 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456",
                copyright: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u0440\u0443\u0448\u0443\u0454 \u0430\u0432\u0442\u043E\u0440\u0441\u044C\u043A\u0456 \u043F\u0440\u0430\u0432\u0430",
                other: "\u0411\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0456\u043D\u0448\u0438\u0439 \u0432\u0438\u0434 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
                picture_low_quality: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0438\u0437\u044C\u043A\u043E\u0457 \u044F\u043A\u043E\u0441\u0442\u0456",
                "": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438\u2026",
                blur_missing: "\u0412\u0438\u0434\u043D\u043E \u043E\u0431\u043B\u0438\u0447\u0447\u044F \u043B\u044E\u0434\u0438\u043D\u0438 \u0430\u0431\u043E \u043D\u043E\u043C\u0435\u0440\u043D\u0438\u0439 \u0437\u043D\u0430\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044F"
            },
            report_email: "\u0412\u0430\u0448\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430",
            report_email_placeholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
            report_submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
            report_success: "\u0417\u0432\u0456\u0442 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E. \u0419\u043E\u0433\u043E \u0431\u0443\u0434\u0435 \u0440\u043E\u0437\u0433\u043B\u044F\u043D\u0443\u0442\u043E \u044F\u043A\u043E\u043C\u043E\u0433\u0430 \u0448\u0432\u0438\u0434\u0448\u0435.",
            report_failure: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0443 \u0441\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {e}. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
            report_whole_sequence: "\u0426\u0435 \u0441\u0442\u043E\u0441\u0443\u0454\u0442\u044C\u0441\u044F \u0432\u0441\u0456\u0454\u0457 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            report_wait: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0443\u2026",
            semantics_save_drawn_annotation_incomplete: "\u041F\u0435\u0440\u0435\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u043E\u044E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043D\u0430\u043C\u0430\u043B\u044E\u0432\u0430\u0442\u0438 \u043F\u0440\u044F\u043C\u043E\u043A\u0443\u0442\u043D\u0438\u043A, \u044F\u043A\u0438\u0439 \u043F\u043E\u043C\u0456\u0441\u0442\u0438\u0442\u044C\u0441\u044F \u043D\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456",
            semantics_hide_annotations: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u0431'\u0454\u043A\u0442\u0456\u0432",
            semantics_doc: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
            semantics_doc_title: "\u041F\u0440\u043E \u0442\u0435\u0433\u0438",
            semantics_erase_annotation: "\u0421\u0442\u0435\u0440\u0442\u0438 \u043D\u0430\u043C\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442",
            semantics_doc_info1: "\u041D\u0430\u0434\u0430\u0439\u0442\u0435 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442 \u043D\u0430\u0432\u043A\u043E\u043B\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0442\u0435\u0433\u0456\u0432. \u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0439\u043E\u0433\u043E \u044F\u043A \u0437\u043D\u044F\u0442\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0435\u043C \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0442\u0435\u0433\u0443 transport=car.",
            semantics_doc_info2: "\u0412\u0438 \u0442\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u0435\u0442\u0435 \u043C\u0430\u043B\u044E\u0432\u0430\u0442\u0438 \u043E\u0431'\u0454\u043A\u0442\u0438 \u043D\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456: \u0434\u043E\u0440\u043E\u0436\u043D\u0456 \u0437\u043D\u0430\u043A\u0438, \u043C\u0456\u0441\u044C\u043A\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u2026 \u041F\u043E\u0437\u043D\u0430\u0447\u0430\u0439\u0442\u0435 \u0442\u0435, \u0449\u043E \u0431\u0430\u0447\u0438\u0442\u0435, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0447\u0438 \u0456\u0441\u043D\u0443\u044E\u0447\u0456 \u0442\u0435\u0433\u0438. \u0417\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438 \u0432\u0438 \u0442\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0432\u043E\u0457 \u0432\u043B\u0430\u0441\u043D\u0456.",
            semantics_doc_info3: "\u0414\u0435\u044F\u043A\u0456 \u043E\u0431'\u0454\u043A\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0440\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u044E\u0442\u044C\u0441\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0448\u0442\u0443\u0447\u043D\u043E\u0433\u043E \u0456\u043D\u0442\u0435\u043B\u0435\u043A\u0442\u0443: \u044F\u043A\u0456\u0441\u0442\u044C \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0443\u0454\u0442\u044C\u0441\u044F.",
            semantics_doc_link: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0442\u0435\u0433\u0438",
            semantics_sequence_tags: "\u0422\u0435\u0433 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            semantics_picture_tags: "\u0422\u0435\u0433 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            semantics_annotation_tags: "\u0422\u0435\u0433 \u043E\u0431'\u0454\u043A\u0442\u0430",
            filter_gps_precision_lessthan: "\u041C\u0435\u043D\u0448\u0435 {n} \u043C\u0435\u0442\u0440\u0456\u0432",
            filter_gps_precision_morethan: "\u0411\u0456\u043B\u044C\u0448\u0435 {n} \u043C\u0435\u0442\u0440\u0456\u0432",
            filter_gps_precision_between: "\u0412\u0456\u0434 {n1} \u0434\u043E {n2} \u043C\u0435\u0442\u0440\u0456\u0432",
            filter_gps_precision: "\u0422\u043E\u0447\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u044E\u0432\u0430\u043D\u043D\u044F",
            map_theme_gps: "\u0422\u043E\u0447\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u044E\u0432\u0430\u043D\u043D\u044F",
            semantics_overlays: {
                tfsigns: "\u0414\u043E\u0440\u043E\u0436\u043D\u0456 \u0437\u043D\u0430\u043A\u0438"
            }
        },
        map: {
            not_public: "\u041D\u0435 \u043F\u0443\u0431\u043B\u0456\u0447\u043D\u043E \u0432\u0438\u0434\u0438\u043C\u0435",
            map_data: "\u041A\u0430\u0440\u0442\u0430 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 {m}",
            more_panoramax: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E Panoramax",
            thumbnail: "\u041C\u0456\u043D\u0456\u0430\u0442\u044E\u0440\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F, \u043D\u0430 \u044F\u043A\u0435 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u043E \u043A\u0443\u0440\u0441\u043E\u0440",
            slow_loading: "\u041A\u0430\u0440\u0442\u0430 \u043F\u043E\u0432\u0456\u043B\u044C\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F \u0442\u0430 \u043C\u043E\u0436\u0435 \u0432\u0438\u0433\u043B\u044F\u0434\u0430\u0442\u0438 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043E\u044E",
            loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026"
        }
    },
    "zh-hant": $a42f1354f0348298$var$kx,
    zh: $a42f1354f0348298$var$kx
};
function $a42f1354f0348298$var$Mx(e, t) {
    e = e.map((e)=>e.toLowerCase());
    for (const t of $a42f1354f0348298$var$Px()){
        let i = t.toLowerCase();
        switch(i){
            case "zh-tw":
            case "zh-hk":
            case "zh-mo":
                i = "zh-hant";
                break;
            case "zh-cn":
            case "zh-sg":
                i = "zh-hans";
                break;
            default:
                i.length > 2 && !e.includes(i) && (i = t.substring(0, 2));
        }
        const n = e.find((e)=>e === i);
        if (n) return n;
    }
    return t;
}
function $a42f1354f0348298$var$Sx(e, t) {
    if (!e) return null;
    for(let i = 0; i < t.length; i++)e = e?.[t[i]];
    return e;
}
function $a42f1354f0348298$var$Cx(e, t, i, n) {
    return t || (t = []), Object.entries(e).forEach(([a, r])=>{
        let s = t.concat([
            a
        ]);
        if ("string" == typeof r || Array.isArray(r)) {
            let t;
            if (i && (t = $a42f1354f0348298$var$Sx($a42f1354f0348298$var$wx[i], s)), !t && i && i.length > 2 && (t = $a42f1354f0348298$var$Sx($a42f1354f0348298$var$wx[i.substring(0, 2)], s)), !t && n) for(let e = 0; e < n.length && (t = $a42f1354f0348298$var$Sx($a42f1354f0348298$var$wx[n[e].toLowerCase()], s), !t); e++);
            t || (t = $a42f1354f0348298$var$Sx($a42f1354f0348298$var$wx[$a42f1354f0348298$var$xx], s)), e[a] = t, Array.isArray(e[a]) && (e[a] = e[a].filter((e)=>e));
        } else e[a] = $a42f1354f0348298$var$Cx(e[a], s, i, n);
    }), e;
}
function $a42f1354f0348298$var$Tx(e = "") {
    e || (e = $a42f1354f0348298$var$Mx(Object.keys($a42f1354f0348298$var$wx), $a42f1354f0348298$var$xx));
    let t = $a42f1354f0348298$var$Px(), i = [];
    t.forEach((e)=>{
        e = e.toLowerCase(), [
            "zh-tw",
            "zh-hk",
            "zh-mo"
        ].includes(e) ? i.push("zh-hant") : [
            "zh-cn",
            "zh-sg"
        ].includes(e) ? i.push("zh-hans") : e.length > 2 ? (i.push(e), i.push(e.substring(0, 2))) : i.includes(e) || i.push(e);
    });
    let n = JSON.parse(JSON.stringify($a42f1354f0348298$var$bx));
    return n = $a42f1354f0348298$var$Cx(n, null, e, i), n.PREF_LANG = e, n;
}
function $a42f1354f0348298$var$Dx(e, t) {
    return t = t ? t.toLowerCase() : null, e = Object.fromEntries(Object.entries(e).map(([e, t])=>[
            e.toLowerCase(),
            t
        ])), t || (t = $a42f1354f0348298$var$Mx(Object.keys(e), $a42f1354f0348298$var$xx)), e[t] ? e[t] : t.length > 2 && e[t.substring(0, 2)] ? e[t.substring(0, 2)] : e[$a42f1354f0348298$var$xx] || "";
}
function $a42f1354f0348298$var$Px() {
    let e = [];
    return window.navigator.languages ? e = window.navigator.languages : window.navigator.language && (e = [
        window.navigator.language
    ]), e = e.filter((e)=>e && "string" == typeof e && e.length > 0), e;
}
var $a42f1354f0348298$var$Ix = Object.freeze({
    __proto__: null,
    autoDetectLocale: $a42f1354f0348298$var$Mx,
    getBestLabel: $a42f1354f0348298$var$Dx,
    getBrowserLanguages: $a42f1354f0348298$var$Px,
    getTranslations: $a42f1354f0348298$var$Tx
});
const $a42f1354f0348298$var$Lx = [
    [
        "features",
        '"semantics" IS NOT NULL',
        {
            metadata: {
                name: "All features"
            },
            type: "circle",
            layout: {
                visibility: "none"
            },
            paint: {
                "circle-radius": 4,
                "circle-color": "#00897B"
            }
        }
    ],
    [
        "tfsigns",
        '"semantics.osm|traffic_sign" IS NOT NULL',
        {
            metadata: {
                name: "Traffic signs"
            },
            type: "symbol",
            layout: {
                visibility: "none",
                "icon-overlap": "never",
                "icon-image": [
                    "case",
                    [
                        "in",
                        ";",
                        [
                            "get",
                            "osm|traffic_sign"
                        ]
                    ],
                    "pnx-tfsigns-fr:0_many",
                    [
                        "==",
                        [
                            "slice",
                            [
                                "get",
                                "osm|traffic_sign"
                            ],
                            0,
                            2
                        ],
                        "FR"
                    ],
                    [
                        "concat",
                        "pnx-tfsigns-fr:",
                        [
                            "slice",
                            [
                                "get",
                                "osm|traffic_sign"
                            ],
                            3
                        ]
                    ],
                    [
                        "==",
                        [
                            "get",
                            "osm|traffic_sign"
                        ],
                        "yes"
                    ],
                    "pnx-tfsigns-fr:0_unknown",
                    [
                        "has",
                        "osm|traffic_sign"
                    ],
                    "pnx-tfsigns-fr:0_unknown",
                    ""
                ]
            }
        },
        {
            "pnx-tfsigns-fr": "https://presets.panoramax.fr/sprites/trafficsigns_fr"
        }
    ]
];
function $a42f1354f0348298$var$Rx(e, t, i) {
    return $a42f1354f0348298$var$V`<a href=${t} target="_blank" title=${i}>${e}</a>`;
}
const $a42f1354f0348298$var$zx = [
    "highway",
    "building",
    "amenity",
    "landuse",
    "natural",
    "waterway",
    "leisure",
    "shop",
    "railway",
    "tourism",
    "barrier",
    "boundary",
    "place",
    "power"
], $a42f1354f0348298$var$Fx = {};
function $a42f1354f0348298$var$Ux(e, t) {
    if ($a42f1354f0348298$var$Fx[e]) return Promise.resolve($a42f1354f0348298$var$Fx[e]);
    {
        const i = e.startsWith("P") ? `properties/${e}` : `items/${e}/labels`;
        return fetch(`https://www.wikidata.org/w/rest.php/wikibase/v1/entities/${i}`).then((e)=>e.json()).then((i)=>($a42f1354f0348298$var$Fx[e] = $a42f1354f0348298$var$Dx(i.labels || i, t.PREF_LANG), $a42f1354f0348298$var$Fx[e]));
    }
}
const $a42f1354f0348298$var$Nx = {
    "": {
        title: "Panoramax",
        value_transform: (e, t)=>"osm" === e.key ? $a42f1354f0348298$var$Rx(e.value, `https://openstreetmap.org/${e.value}`, t.pnx.semantics_value_show_osm) : e.value
    },
    osm: {
        title: "OpenStreetMap",
        logo: "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Created with Inkscape (http://www.inkscape.org/) --%3e%3csvg width='240mm' height='239.99869mm' viewBox='0 0 240 239.99869' id='svg6743' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cg id='layer1' transform='translate(-30%2c-27.000656)'%3e %3cg id='g7426' transform='translate(322.142%2c-53.972906)'%3e %3cpath style='display:inline%3bfill:%2376c551%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:3.61532' id='path33449' d='m -81.063095%2c208.94609 c -11.906339%2c9.92421 -27.194885%2c15.8987 -43.860635%2c15.8987 -4.95854%2c0 -9.78728%2c-0.55158 -14.45059%2c-1.55504 l -4.79842%2c5.8446 c -10.66449%2c-2.85736 -20.38429%2c-7.94043 -28.6326%2c-14.74578 l -12.89559%2c12.92212 1.58177%2c9.54347 -47.96347%2c47.98965 4.63827%2c1.7685 45.04032%2c-17.15658 45.0402%2c17.15658 45.040312%2c-17.15658 17.158544%2c-45.03976 z' /%3e %3cpath d='m -272.48495%2c89.294626 17.1585%2c45.040274 -17.1585%2c45.03993 17.1585%2c45.03972 -17.1585%2c45.03977 10.53634%2c4.02267 57.2385%2c-57.21102 10.26764%2c1.58169 12.46673%2c-12.46669 c -7.35519%2c-8.52221 -12.86173%2c-18.6902 -15.87027%2c-29.92032 l 5.8446%2c-4.79842 c -1.00531%2c-4.66323 -1.55503%2c-9.49189 -1.55503%2c-14.45044 0%2c-24.76984 13.21043%2c-46.53472 32.94893%2c-58.606534 l -21.79693%2c-8.31063 -45.04019%2c17.158544 z' id='path33447' style='display:inline%3bfill:%2376c551%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:3.61532' /%3e %3cpath style='display:inline%3bfill:%2359a336%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:3.61532' id='path33451' d='m -81.063095%2c208.94609 c -11.906339%2c9.92421 -27.194885%2c15.8987 -43.860635%2c15.8987 -4.95854%2c0 -9.78728%2c-0.55158 -14.45059%2c-1.55504 l -4.79842%2c5.8446 -28.67744%2c-15.11228 -12.85075%2c13.28862 1.58177%2c9.54347 46.85284%2c7.05799 -0.0982%2c42.70016 45.040313%2c-17.15658 17.158544%2c-45.03976 z' /%3e %3cellipse style='opacity:1%3bfill:white%3bfill-opacity:1%3bstroke:none%3bstroke-width:12.7048%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-dashoffset:0%3bstroke-opacity:1%3bmarker:none' id='ellipse33453' cx='-122.83165' cy='155.70955' rx='59.801929' ry='60.929199' /%3e %3cpath style='opacity:1%3bfill:%23cccccc%3bfill-opacity:1%3bstroke:none%3bstroke-width:12.7048%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-dashoffset:0%3bstroke-opacity:1%3bmarker:none' d='m -70.867543%2c179.77128 c -4.021615%2c-66.77094 -70.182367%2c-83.311142 -110.499567%2c-45.77004 21.03677%2c-28.56709 48.05279%2c-46.045197 78.56638%2c-33.40602 30.51362%2c12.63913 41.797793%2c45.98173 31.933187%2c79.17606 z' id='path33455' /%3e %3cpath id='path33457' d='m -73.395575%2c102.22726 c -28.338185%2c-28.338264 -74.283665%2c-28.338264 -102.621895%2c0 -17.93779%2c17.93776 -24.48523%2c42.91327 -19.71413%2c66.02883 l -11.27485%2c8.16937 c 5.13477%2c13.61756 12.1317%2c21.8574 16.91241%2c26.2963 l -10.22839%2c10.22834 h -10.80252 l -81.01705%2c81.01654 27.00583%2c27.00561 81.01701%2c-81.01683 v -10.80225 l 10.19464%2c-10.19425 c 4.56162%2c4.75244 12.69997%2c11.38138 25.75686%2c16.30469 l 7.86543%2c-10.90386 c 23.35858%2c5.12197 48.742245%2c-1.34701 66.906498%2c-19.5115 28.338386%2c-28.33732 28.33819%2c-74.28276 1.57e-4%2c-102.62099 z m -12.962835%2c12.96296 c 21.179095%2c21.17921 21.179095%2c55.51685 0%2c76.69579 -21.17902%2c21.17897 -55.51721%2c21.17897 -76.6963%2c0 -21.17898%2c-21.17894 -21.17898%2c-55.51658 0%2c-76.69579 21.17929%2c-21.179216 55.51728%2c-21.179216 76.6963%2c0 z' style='color:black%3bdisplay:inline%3boverflow:visible%3bvisibility:visible%3bfill:%232f2f2f%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:7.76059%3bmarker:none%3benable-background:accumulate' /%3e %3c/g%3e %3c/g%3e%3c/svg%3e",
        key_transform: (e, t)=>$a42f1354f0348298$var$Rx(e.key, `https://wiki.openstreetmap.org/wiki/Key:${e.key}`, t.pnx.semantics_key_doc),
        value_transform: (e, t)=>$a42f1354f0348298$var$zx.includes(e.key) ? $a42f1354f0348298$var$Rx(e.value, `https://wiki.openstreetmap.org/wiki/Tag:${e.key}=${e.value}`, t.pnx.semantics_value_doc) : e.value
    },
    wd: {
        title: "Wikidata",
        logo: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 18'%3e%3cpath d='M2.5 1h1v16h-1zm2 0h3v16h-3zm4 0h3v16h-3z' fill='%23900'/%3e%3cpath d='M12.5 1h1v16h-1zm2 0h1v16h-1zm12 0h1v16h-1zm2 0h1v16h-1z' fill='%23396'/%3e%3cpath d='M16.5 1h3v16h-3zm4 0h1v16h-1zm2 0h3v16h-3z' fill='%23069'/%3e%3c/svg%3e",
        key_transform: (e, t)=>{
            const i = `https://www.wikidata.org/wiki/Property:${e.key}`;
            if (t.pnx.semantics_wikidata_properties[e.key]) return $a42f1354f0348298$var$Rx($a42f1354f0348298$var$V`${t.pnx.semantics_wikidata_properties[e.key]} <small>(${e.key})</small>`, i, t.pnx.semantics_key_doc);
            {
                const n = document.createElement("span");
                return n.innerText = e.key, $a42f1354f0348298$var$Ux(e.key, t).then((t)=>{
                    n.innerHTML = `${t} <small>(${e.key})</small>`;
                }), $a42f1354f0348298$var$Rx(n, i, t.pnx.semantics_key_doc);
            }
        },
        value_transform: (e, t)=>{
            const i = document.createElement("span");
            return i.innerText = e.value, $a42f1354f0348298$var$Ux(e.value, t).then((t)=>{
                i.innerHTML = `${t} <small>(${e.value})</small>`;
            }), $a42f1354f0348298$var$Rx(i, `https://www.wikidata.org/wiki/${e.value}`, t.pnx.semantics_value_doc);
        }
    },
    exif: {
        title: "EXIF"
    }
};
function $a42f1354f0348298$var$Bx(e) {
    const t = (e || "").lastIndexOf("=");
    if (t < 0) return null;
    const i = $a42f1354f0348298$var$Ox(e.substring(0, t));
    return i.subkey.indexOf("=") >= 0 ? null : {
        key: i,
        value: e.substring(t + 1)
    };
}
function $a42f1354f0348298$var$Ox(e = "") {
    const t = e.match(/^(?:([a-z_]+)\|)?([^[]+)(?:\[(.*)\])?$/);
    if (!t) return {
        prefix: "",
        subkey: e,
        qualifies: null
    };
    const [, i, n, a] = t;
    return {
        key: e,
        prefix: i || "",
        subkey: n,
        qualifies: $a42f1354f0348298$var$Bx(a)
    };
}
function $a42f1354f0348298$var$jx(e) {
    const t = e.split("\n").map((e)=>{
        const t = $a42f1354f0348298$var$Bx(e);
        return t && t.key.key.length <= 256 && t.value.length <= 2048 ? {
            key: t.key.key,
            value: t.value
        } : null;
    });
    if (t.findIndex((e)=>!e) >= 0) {
        if (0 === e.trim().length && 1 === t.length) return [];
        throw new Error("Invalid tags");
    }
    return t;
}
function $a42f1354f0348298$var$Gx(e) {
    return (e || []).map((e)=>`${e.key}=${e.value}`).join("\n");
}
function $a42f1354f0348298$var$Vx(e = [], t = []) {
    const i = [];
    return (t || []).filter((t)=>void 0 === e.find((e)=>e.key == t.key && e.value == t.value)).forEach((e)=>i.push({
            key: e.key,
            value: e.value,
            action: "add"
        })), (e || []).filter((e)=>void 0 === t.find((t)=>e.key == t.key && e.value == t.value)).forEach((e)=>i.push({
            key: e.key,
            value: e.value,
            action: "delete"
        })), i;
}
function $a42f1354f0348298$var$Hx(e) {
    const t = {}, i = [];
    return e.forEach((e)=>{
        if ("delete" === e.action) return;
        const n = $a42f1354f0348298$var$Ox(e.key);
        n.qualifies ? i.push(Object.assign({}, e, n)) : (t[n.prefix] || (t[n.prefix] = []), t[n.prefix].push(n.prefix.length > 0 ? {
            key: n.subkey,
            value: e.value
        } : e));
    }), i.forEach(({ key: e, prefix: i, subkey: n, qualifies: a, value: r })=>{
        const s = t[a.key.prefix]?.find((e)=>e.key === a.key.subkey && (!a.value || a.value === e.value));
        s && (s.qualifiers || (s.qualifiers = []), s.qualifiers.push({
            key: e,
            prefix: i,
            subkey: n,
            value: r
        }));
    }), Object.entries(t).map(([e, t])=>$a42f1354f0348298$var$Nx[e] ? Object.assign({
            prefix: e,
            tags: t
        }, $a42f1354f0348298$var$Nx[e]) : {
            prefix: e,
            title: e,
            tags: t
        });
}
var $a42f1354f0348298$var$qx = Object.freeze({
    __proto__: null,
    SEMANTICS_OVERLAYS: $a42f1354f0348298$var$Lx,
    computeDiffTags: $a42f1354f0348298$var$Vx,
    decodeBasicTag: $a42f1354f0348298$var$Bx,
    decodeKey: $a42f1354f0348298$var$Ox,
    groupByPrefix: $a42f1354f0348298$var$Hx,
    parseSemanticsString: $a42f1354f0348298$var$jx,
    semanticsToString: $a42f1354f0348298$var$Gx
});
class $a42f1354f0348298$var$Kx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$Ho,
        $a42f1354f0348298$var$Oo,
        $a42f1354f0348298$var$s`
		.annotation { background: var(--white); }
		.info { padding: 10px 0; }
		pnx-list-item {
			display: block;
			margin: 5px 0;
		}
	`
    ];
    static properties = {
        editable: {
            type: Boolean
        },
        _meta: {
            state: !0
        },
        _seqMeta: {
            state: !0
        },
        _entries: {
            state: !0
        },
        _selectedEntry: {
            state: !0
        },
        _annotPresets: {
            state: !0
        },
        _picPresets: {
            state: !0
        },
        _seqPresets: {
            state: !0
        }
    };
    constructor(){
        super(), this._meta = {}, this._seqMeta = {}, this._selectedEntry = null, this._annotPresets = {}, this._picPresets = [], this._seqPresets = [], this._entries = null, this.editable = !1, $a42f1354f0348298$var$Lr();
    }
    connectedCallback() {
        super.connectedCallback(), this._onPicChange(), $a42f1354f0348298$var$Ur(this).then(()=>{
            this._parent.psv?.addEventListener("picture-loaded", this._onPicChange.bind(this)), this._parent.psv?.addEventListener("annotation-focused", (e)=>this.showAnnotation(e.detail.annotationId)), this._parent.psv?.addEventListener("annotations-unfocused", (e)=>{
                "user-click" === e.detail.source && delete this._prevPsvView, this._onListItemClick(null);
            });
            const e = this._parent.psv.getSelectedAnnotations();
            e.length > 0 && this.showAnnotation(e[0]);
        });
    }
    showAnnotation(e) {
        this._entries ? this._onListItemClick(this._entries.find((t)=>"annotation" === t.type && t.annotation.id == e)) : setTimeout(()=>this.showAnnotation(e), 200);
    }
    showTagsGroup(e) {
        this._entries ? this._onListItemClick(this._entries.find((t)=>{
            if ("annotation" === t?.type) return !1;
            for(let i = 0; i < e.length; i++)if (!t.tagGroup.semantics.find((t)=>e[i].key === t.key && e[i].value === t.value)) return !1;
            return !0;
        })) : setTimeout(()=>this.showTagsGroup(e), 200);
    }
    _onPicChange() {
        this._meta = this._parent?.psv?.getPictureMetadata(), this._getSeqMeta(), delete this._prevPsvView, this._selectedEntry = null, this._entries = null, this.dispatchEvent(new CustomEvent("select", {
            detail: {
                item: null
            }
        })), this._meta && this._parent?.presetsManager && (this._annotPresets = {}, this._picPresets = [], this._parent.presetsManager.getPresets(this._meta.properties).then((e)=>{
            this._picPresets = e, this._computeEntries();
        }), this._meta.properties?.annotations?.length > 0 && Promise.all(this._meta.properties.annotations.map((e)=>this._parent.presetsManager.getPreset(e).then((t)=>{
                this._annotPresets[e.id] = t;
            }))).then(()=>this._computeEntries()));
    }
    async _getSeqMeta() {
        const e = this._meta?.sequence?.id;
        if (e && !this._parent._sequencesMetadata[e] && (this._parent._sequencesMetadata[e] = await this._parent.getAPI().getSequenceMetadata(e)), this._seqMeta = this._parent._sequencesMetadata[e], this._seqPresets = [], this._seqMeta?.semantics?.length > 0) {
            const e = await this._parent.presetsManager.getPresets(this._seqMeta);
            this._seqPresets = e, this._computeEntries();
        }
    }
    _getGroupedTags(e, t, i, n) {
        if (!e) return;
        const a = [], r = (e, t)=>{
            const i = [
                {
                    key: t,
                    value: e.value
                }
            ];
            return e.qualifiers && e.qualifiers.forEach((e)=>i.push({
                    key: e.key,
                    value: e.value
                })), i;
        }, s = $a42f1354f0348298$var$Hx(e), o = [];
        return s.forEach((e)=>{
            const i = {};
            e.tags.forEach((s)=>{
                const l = "" !== e.prefix ? `${e.prefix}|${s.key}` : s.key;
                if (i[`${l}=${s.value}`]) return void r(s, l).forEach((e)=>i[`${l}=${s.value}`].push(e));
                const c = n.find((e)=>[
                        "*",
                        s.value
                    ].includes(e.tags[l]));
                if (c) {
                    const e = r(s, l);
                    let n = 0;
                    Object.entries(c.tags).forEach(([t, a])=>{
                        let r = a;
                        "*" === a && (r = this._meta.properties.semantics.find((e)=>e.key === l)?.value), i[t + "=" + r] = e, n++;
                    }), a.push({
                        title: c.name,
                        icon: c.iconify || "fa6-solid:cube",
                        associatedTags: (s.qualifiers?.length || 0) + n,
                        tagGroup: {
                            semantics: e
                        },
                        type: t
                    });
                } else o.push({
                    key: l,
                    value: s.value,
                    qualifiers: s.qualifiers
                });
            });
        }), o.length > 0 && a.push({
            title: this._parent?._t.pnx.semantics_features_default_title.replace("{nb}", i++),
            icon: "fa6-solid:tag",
            associatedTags: o.length,
            tagGroup: {
                semantics: o
            },
            type: t
        }), [
            a,
            i
        ];
    }
    _computeEntries() {
        let e = 1, t = [], i = [];
        this._seqMeta?.semantics?.length > 0 && ([t, e] = this._getGroupedTags(this._seqMeta.semantics, "seqtags", e, this._seqPresets)), this._meta.properties?.semantics?.length > 0 && ([i, e] = this._getGroupedTags(this._meta.properties?.semantics, "pictags", e, this._picPresets), t = t.concat(i)), t = t.concat(this._meta.properties?.annotations?.map((t)=>({
                title: this._annotPresets[t.id]?.name || this._parent?._t.pnx.semantics_features_default_title.replace("{nb}", e++),
                icon: this._annotPresets[t.id]?.iconify || "fa6-solid:cube",
                associatedTags: t.semantics.filter((e)=>"delete" !== e.action).length,
                type: "annotation",
                annotation: t
            })) || []), this._entries = t;
    }
    _onListItemHover(e) {
        "annotation" === e?.type ? (this._prevPsvView || (this._prevPsvView = [
            this._parent.psv.getZoomLevel(),
            this._parent.psv.getPosition()
        ]), this._parent.psv.focusOnAnnotation(e.annotation.id, void 0, !0)) : (this._parent.psv.unfocusAnnotation(), this._prevPsvView && (this._parent.psv.zoom(this._prevPsvView[0]), this._parent.psv.rotate(this._prevPsvView[1]), delete this._prevPsvView));
    }
    _onListItemClick(e) {
        this._selectedEntry = e, this._onListItemHover(e), this.dispatchEvent(new CustomEvent("select", {
            detail: {
                item: e
            }
        }));
    }
    _onItemEditClick(e) {
        e.stopPropagation(), this.dispatchEvent(new CustomEvent("edit-click", {
            detail: {
                item: this._selectedEntry
            }
        }));
    }
    _onItemDeleteClick(e) {
        e.stopPropagation(), this.dispatchEvent(new CustomEvent("delete-click", {
            detail: {
                item: this._selectedEntry
            }
        }));
    }
    render() {
        if (!this._meta) return $a42f1354f0348298$var$q;
        if (this._selectedEntry) return $a42f1354f0348298$var$V`<div class="annotation">
				<pnx-list-item
					title=${this._selectedEntry.title}
					@click=${()=>this._onListItemClick(null)}
				>
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ls, {
            transform: {
                size: 24
            },
            attributes: {
                slot: "icon"
            }
        })}
					<iconify-icon
						slot="icon"
						icon=${this._selectedEntry.icon}
						style="font-size: 1.5em"
					></iconify-icon>

					<pnx-copy-button
						kind="superinline"
						text=${$a42f1354f0348298$var$Gx((this._selectedEntry?.annotation || this._selectedEntry?.tagGroup)?.semantics)}
						slot="action"
						._t=${this._parent?._t}
						title=${this._parent?._t.pnx.semantics_copy}
					>
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ss, {
            transform: {
                size: 18
            }
        })}
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$zs, {
            attributes: {
                slot: "oncopy"
            },
            transform: {
                size: 18
            }
        })}
					</pnx-copy-button>

					${this.editable && "seqtags" !== this._selectedEntry.type ? $a42f1354f0348298$var$V`
						<pnx-button
							kind="superinline"
							title=${this._parent?._t.pnx.semantics_edit}
							slot="action"
							@click=${this._onItemEditClick}
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$as, {
            transform: {
                size: 18
            }
        })}
						</pnx-button>
						<pnx-button
							kind="superinline"
							title=${this._parent?._t.pnx.semantics_delete_annotation}
							slot="action"
							@click=${this._onItemDeleteClick}
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$os, {
            transform: {
                size: 18
            }
        })}
						</pnx-button>` : $a42f1354f0348298$var$q}
				</pnx-list-item>
				<pnx-semantics-table
					._t=${this._parent?._t}
					.source=${"annotation" === this._selectedEntry?.type ? this._selectedEntry.annotation : this._selectedEntry.tagGroup}
				/>
			</div>`;
        if (this.editable || 0 !== (this._entries || []).length) {
            const e = {
                seqtags: this._parent?._t.pnx.semantics_sequence_tags,
                pictags: this._parent?._t.pnx.semantics_picture_tags,
                annotation: this._parent?._t.pnx.semantics_annotation_tags
            };
            return $a42f1354f0348298$var$V`<div class="list">
				${(this._entries || []).map((t)=>$a42f1354f0348298$var$V`
					<pnx-list-item
						title=${t.title}
						tooltip=${e[t.type]}
						@click=${()=>this._onListItemClick(t)}
						@mouseover=${()=>this._onListItemHover(t)}
						@mouseout=${()=>this._onListItemHover(null)}
					>
						<iconify-icon
							slot="icon"
							icon=${t.icon}
							style="font-size: 1.5em"
						></iconify-icon>
						${t.associatedTags > 1 ? $a42f1354f0348298$var$V`
							<span slot="icon" class="pnx-badge-count">${t.associatedTags}</span>
						` : $a42f1354f0348298$var$q}
						${"annotation" === t?.type ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$es, {
                    transform: {
                        size: 20
                    },
                    styles: {
                        "margin-right": "20px"
                    },
                    attributes: {
                        slot: "action"
                    }
                }) : $a42f1354f0348298$var$q}
						${"seqtags" === t?.type ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$gs, {
                    transform: {
                        size: 20
                    },
                    styles: {
                        "margin-right": "20px"
                    },
                    attributes: {
                        slot: "action"
                    }
                }) : $a42f1354f0348298$var$q}
						${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ls, {
                    transform: {
                        size: 20
                    },
                    attributes: {
                        slot: "action"
                    }
                })}
					</pnx-list-item>
				`)}
			</div>`;
        }
        return $a42f1354f0348298$var$V`<div class="info">${this._parent?._t.pnx.semantics_empty}</div>`;
    }
}
customElements.define("pnx-semantics-list", $a42f1354f0348298$var$Kx);
const $a42f1354f0348298$var$Wx = "doing";
class $a42f1354f0348298$var$Xx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Io,
        $a42f1354f0348298$var$qo,
        $a42f1354f0348298$var$s`
		.top-btns, pnx-semantics-list {
			font-size: 0.8em;
		}
		.top-btns {
			display: flex;
			margin: 5px 0;
			gap: 5px;
		}
		.top-btns > * {
			overflow: hidden;
		}
		.top-btns > *::part(btn) {
			height: unset;
		}
		.data-block {
			width: 100%;
		}
		.data-block h5 {
			justify-content: space-between;
		}
	`
    ];
    static properties = {
        _meta: {
            state: !0
        },
        _prevPSVPicNav: {
            state: !0
        },
        _authUrl: {
            state: !0
        },
        _showLinks: {
            state: !0
        },
        _addTag: {
            state: !0
        },
        _editTag: {
            state: !0
        },
        _addTagGeom: {
            state: !0
        },
        _editTagSem: {
            state: !0
        }
    };
    constructor(){
        super(), this._meta = {}, this._prevPSVPicNav = null, this._authUrl = null, this._showLinks = !0, this._addTag = !1, this._editTag = null, this._addTagGeom = null, this._editTagSem = null;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>{
            this._meta = this._parent?.psv?.getPictureMetadata(), this._parent?.oncePSVReady?.().then(()=>{
                this._parent.psv.addEventListener("picture-loaded", ()=>{
                    this._meta = this._parent.psv.getPictureMetadata();
                }), this._parent.psv.addEventListener("annotation-focused", ()=>{
                    const e = this.shadowRoot.querySelector("pnx-tabs");
                    e && e.setAttribute("activeTabIndex", 4);
                });
                const e = setInterval(()=>{
                    $a42f1354f0348298$var$go() && (clearInterval(e), this.requestUpdate());
                }, 1e3);
            }), this._parent.getAPI().getAuthURL().then((e)=>this._authUrl = e);
        });
    }
    _blockPicChange(e) {
        this._parent?.legend?.renderRoot.querySelector("pnx-picture-legend")?.blockOnEditing(e), this._parent?.mini && (this._parent.mini.style.display = e ? "none" : null);
        const t = this._parent.renderRoot.querySelector("pnx-annotations-switch");
        t && (t.style.display = e ? "none" : null), e ? (this._prevPSVPicNav = this._parent.psv.getPicturesNavigation(), this._parent.psv.setPicturesNavigation("pic"), this._parent._disableKeyboard(), window.addEventListener("beforeunload", this._onBrowserQuit)) : (this._parent.psv.setPicturesNavigation(this._prevPSVPicNav), this._parent._enableKeyboard(), window.removeEventListener("beforeunload", this._onBrowserQuit));
    }
    _onBrowserQuit(e) {
        e.preventDefault(), e.returnValue = !0;
    }
    _checkCanEdit() {
        const e = !this._meta.origInstance || this._parent?.api?._endpoint.startsWith(this._meta.origInstance.href);
        if (e && null !== $a42f1354f0348298$var$go()) return !0;
        if (!e && confirm((this._parent?._t.pnx.semantics_login_needed || "").replace("{n}", this._meta.origInstance.instance_name || this._meta.origInstance.href))) window.location.href = this._meta.origInstance.href + window.location.search.replace(/&?nav=pic/, "");
        else {
            if (!e || !confirm((this._parent?._t.pnx.semantics_login_needed || "").replace("{n}", this._parent.getAPI()._metadata.name))) return !1;
            window.location.href = this._authUrl.replace("<CBURL>", encodeURIComponent(window.location.href));
        }
    }
    _startAddTag() {
        this._checkCanEdit() && (this._blockPicChange(!0), this._addTag = !0, this._editTag = !1, this._addTagGeom = null, this._editTagSem = null, this._addTagGeomListener = (e)=>{
            this.renderRoot.querySelector("#pnx-sem-editor")?.forceInput(), this._addTagGeom = e.detail.shape;
        }, this._parent.psv.addEventListener("annotation-drawn", this._addTagGeomListener), this._parent.psv.addEventListener("annotation-drawing", ()=>this._addTagGeom = $a42f1354f0348298$var$Wx), this._parent.psv.startDrawAnnotation());
    }
    _onTagSemChange(e) {
        this._editTagSem = e.detail;
    }
    _onSaveTag() {
        const e = this.renderRoot.querySelector("#pnx-sem-editor");
        e && e.checkValidity() && this._editTagSem && this._editTagSem.delta && 0 !== this._editTagSem.delta.length ? "annotation" === this._editTag?.type ? this._parent?.api.editPictureAnnotation(this._editTag.annotation.id, this._editTagSem.delta).then((e)=>{
            const t = this._meta.properties.annotations.findIndex((t)=>t.id === e.id);
            this._meta.properties.annotations[t] = e, this._onCancelEditTag(e);
        }).catch((e)=>{
            console.error("Can't send annotation", e), this._onCancelEditTag(this._editTag.annotation), alert(this._parent?._t.pnx.semantics_send_fail);
        }) : this._addTag && this._addTagGeom === $a42f1354f0348298$var$Wx ? alert(this._parent?._t.pnx.semantics_draw_unfinished_annotation) : this._addTag && this._addTagGeom ? (this._parent.psv.fixDrawAnnotation(), this._parent?.api.createPictureAnnotation(this._meta, this._addTagGeom, this._editTagSem.delta).then((e)=>{
            this._meta.properties.annotations.push(e), this._onCancelEditTag(e, !0);
        }).catch((e)=>{
            console.error("Can't send annotation", e), alert(this._parent?._t.pnx.semantics_send_fail), this._onCancelEditTag();
        })) : (this._addTag || this._editTag && "annotation" !== this._editTag.type) && this._parent?.api.sendPictureSemantics(this._meta, this._editTagSem.delta).then((e)=>{
            this._meta.properties.semantics = e.properties.semantics, this._onCancelEditTag(this._editTagSem.delta);
        }).catch((e)=>{
            alert(this._parent?._t.pnx.semantics_send_fail), console.error("Can't send semantics", e), this._onCancelEditTag();
        }) : e.reportValidity();
    }
    _onEraseDrawnAnnotation() {
        this._parent.psv.stopDrawAnnotation(), this._addTagGeom = null, this._parent.psv.startDrawAnnotation();
    }
    _onEditTag(e) {
        this._checkCanEdit() && (this._blockPicChange(!0), this._addTag = !1, this._addTagGeom = null, this._editTagSem = "annotation" === e.detail.item?.type ? {
            semantics: e.detail.item.annotation.semantics
        } : e.detail.item.tagGroup, this._editTag = e.detail.item, "annotation" === e.detail.item?.type && this._parent.psv.focusOnAnnotation(e.detail.item.annotation.id, !0));
    }
    _onCancelEditTag(e = null, t = !1) {
        this.renderRoot.querySelector("#pnx-sem-editor").reset(), this._addTag = !1, this._addTagGeom = null, this._editTag = null, t || this._parent.psv.stopDrawAnnotation(), this._blockPicChange(!1), this.getUpdateComplete().then(()=>{
            const t = this.renderRoot.querySelector("#pnx-sem-list");
            e && t && (e.id ? t.showAnnotation(e.id) : t.showTagsGroup(e));
        });
    }
    _onDeleteTag(e) {
        if (this._checkCanEdit() && confirm(this._parent?._t.pnx.semantics_delete_annotation_confirm)) {
            const t = e.detail.item;
            if ("annotation" === t?.type) this._parent?.api.deletePictureAnnotation(t.annotation.id).then(()=>{
                const e = Object.assign({}, this._meta);
                e.properties.annotations = this._meta.properties.annotations.filter((e)=>e.id != t.annotation.id), this._meta = e, this._parent.psv.toggleAllAnnotations(!0), this.renderRoot.querySelector("pnx-semantics-list")?._onPicChange();
            }).catch((e)=>{
                console.error("Can't send annotation", e), alert(this._parent?._t.pnx.semantics_send_fail);
            });
            else {
                const e = t.tagGroup.semantics.map((e)=>Object.assign({
                        action: "delete"
                    }, e));
                this._parent?.api.sendPictureSemantics(this._meta, e).then((e)=>{
                    this._meta.properties.semantics = e.properties.semantics, this.renderRoot.querySelector("pnx-semantics-list")?._onPicChange();
                }).catch((e)=>{
                    alert(this._parent?._t.pnx.semantics_send_fail), console.error("Can't send semantics", e);
                });
            }
        }
    }
    render() {
        if (!this._meta?.properties) return;
        const e = !this._meta.origInstance && this._meta.permissions.edit_semantics, t = e || this._meta.origInstance && this._parent.api._endpoint.startsWith(this._meta.origInstance.href), i = e && (this._authUrl || null !== $a42f1354f0348298$var$go());
        return $a42f1354f0348298$var$V`
			${this._addTag || this._editTag ? $a42f1354f0348298$var$V`
				<div class="data-block">
					<h5>
						${this._addTag ? this._parent?._t.pnx.semantics_add_annotation : this._parent?._t.pnx.semantics_edit}

						<pnx-button-group>
							<pnx-button
								kind="fullsuccess"
								style="margin-right: 3px"
								title=${this._parent?._t.pnx.semantics_save}
								@click=${this._onSaveTag}
							>
								${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$rs)}
							</pnx-button>
							<pnx-button
								kind="fullwarn"
								title=${this._parent?._t.pnx.semantics_undo}
								@click=${()=>this._onCancelEditTag(this._editTag?.annotation || this._editTag)}
							>
								${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ds)}
							</pnx-button>
						</pnx-button-group>
					</h5>
					<div>
						${this._addTag ? this._parent?._t.pnx.semantics_draw_annotation : $a42f1354f0348298$var$q}
						${this._addTag && this._addTagGeom ? $a42f1354f0348298$var$V`<pnx-button
								kind="full"
								style="margin-top: 5px; width: 100%"
								@click=${this._onEraseDrawnAnnotation}
							>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$bs)} ${this._parent?._t.pnx.semantics_erase_annotation}
						</pnx-button>` : $a42f1354f0348298$var$q}

						<pnx-semantics-editor
							id="pnx-sem-editor"
							style="display: block; margin-top: 5px"
							.semantics=${this._editTagSem?.semantics || []}
							._t=${this._parent._t}
							@change=${this._onTagSemChange}
						></pnx-semantics-editor>
					</div>
				</div>
			` : $a42f1354f0348298$var$V`
				${this._showLinks && t ? $a42f1354f0348298$var$V`
					<div class="top-btns">
						<pnx-button
							kind="full"
							size="md"
							style="flex: 2 1"
							@click=${this._startAddTag}
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Zr)} ${this._parent?._t.pnx.semantics_add_annotation}
						</pnx-button>
						<pnx-button
							kind="full"
							size="md"
							style="flex: 1 1"
							@click=${()=>this._parent?._showSemanticsDoc()}
						>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$us)} ${this._parent?._t.pnx.semantics_doc}</pnx-button>
					</div>
				` : $a42f1354f0348298$var$q}

				<pnx-semantics-list
					id="pnx-sem-list"
					.editable=${i}
					@select=${(e)=>this._showLinks = null == e.detail.item}
					@edit-click=${this._onEditTag}
					@delete-click=${this._onDeleteTag}
					._parent=${this._parent}
				/>
			`}
		`;
    }
}
customElements.define("pnx-semantics-metadata", $a42f1354f0348298$var$Xx);
class $a42f1354f0348298$var$Qx extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$Fo,
        $a42f1354f0348298$var$Ro,
        $a42f1354f0348298$var$Bo,
        $a42f1354f0348298$var$s`
		div[slot="content"] {
			margin-top: 10px;
		}
		.links {
			display: flex;
			gap: 5px;
		}
		.embed {
			display: flex;
			gap: 5px;
			align-items: center;
			flex-direction: column;
		}
	`
    ];
    static properties = {
        _url: {
            state: !0
        },
        "base-url": {
            type: String
        }
    };
    constructor(){
        super(), this._onUrlChange();
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this._parent.onceReady()).then(()=>{
            this._onUrlChange(), this._parent.urlHandler.addEventListener("url-changed", this._onUrlChange.bind(this));
        });
    }
    _onUrlChange() {
        const e = (this["base-url"] || window.location.href).replace(/\/$/, "");
        this._url = this._parent?.urlHandler?.nextShortLink(e) || e;
    }
    render() {
        const e = `<iframe src="${this._url}" style="border: none; width: 500px; height: 300px"></iframe>`;
        return $a42f1354f0348298$var$V`
			<h4>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Kr)} ${this._parent?._t.pnx.share}</h4>
			<pnx-tabs>
				<h4 slot="title">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ks)} ${this._parent?._t.pnx.share_page}</h4>
				<div slot="content">
					<div class="links">
						<input type="text" readonly value=${this._url} style="flex: 2" />
						<pnx-copy-button ._t=${this._parent?._t} text=${this._url}></pnx-copy-button>
					</div>
				</div>

				<h4 slot="title">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ps)} ${this._parent?._t.pnx.share_embed}</h4>
				<div slot="content">
					<div class="embed">
						<pnx-link-button
							href="https://docs.panoramax.fr/web-viewer/03_URL_settings/"
							target="_blank"
							kind="superinline"
							size="sm"
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ds)} ${this._parent?._t.pnx.share_embed_docs}
						</pnx-link-button>
						<textarea readonly .value=${e}></textarea>
						<pnx-copy-button
							._t=${this._parent?._t}
							text=${e}
							style="width: 100%"
						></pnx-copy-button>
					</div>
				</div>
			</pnx-tabs>
			<slot name="extra"></slot>`;
    }
}
customElements.define("pnx-share-menu", $a42f1354f0348298$var$Qx);
var $a42f1354f0348298$var$Zx = Object.freeze({
    __proto__: null,
    PictureLegend: $a42f1354f0348298$var$Wo,
    PictureMetadata: $a42f1354f0348298$var$cl,
    PlayerOptions: $a42f1354f0348298$var$gx,
    QualityScoreDoc: $a42f1354f0348298$var$fx,
    ReportForm: $a42f1354f0348298$var$vx,
    SemanticsDoc: $a42f1354f0348298$var$Ex,
    SemanticsDownload: $a42f1354f0348298$var$yx,
    SemanticsList: $a42f1354f0348298$var$Kx,
    SemanticsMetadata: $a42f1354f0348298$var$Xx,
    Share: $a42f1354f0348298$var$Qx
});
const $a42f1354f0348298$var$Yx = new CSSStyleSheet;
$a42f1354f0348298$var$Yx.replaceSync('/* Also defined in styles.js */\n\npnx-button-group > pnx-button {\n\tdisplay: inline-flex;\n}\n\npnx-button-group > pnx-button::part(btn) {\n\theight: unset;\n}\n\n/* Togglable in group */\npnx-button-group > pnx-togglable-group > pnx-button {\n\twidth: 100%;\n\theight: 100%;\n}\n\n/* Row */\npnx-button-group[dir="row"] > :not(:first-child):not(:last-child)::part(btn),\npnx-button-group[dir="row"] > :not(:first-child):not(:last-child) > ::part(btn) {\n\tborder-radius: 0;\n\tborder-left: none;\n\tborder-right: none;\n}\n\npnx-button-group[dir="row"] > :first-child::part(btn),\npnx-button-group[dir="row"] > :first-child > ::part(btn) {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n\tborder-right: none;\n}\n\npnx-button-group[dir="row"] > :last-child::part(btn),\npnx-button-group[dir="row"] > :last-child > ::part(btn) {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n\tborder-left: none;\n}\n\n/* Column */\npnx-button-group[dir="column"] > :not(:first-child):not(:last-child)::part(btn),\npnx-button-group[dir="column"] > :not(:first-child):not(:last-child) > ::part(btn) {\n\tborder-radius: 0;\n\tborder-top: none;\n\tborder-bottom: none;\n}\n\npnx-button-group[dir="column"] > :first-child::part(btn),\npnx-button-group[dir="column"] > :first-child > ::part(btn) {\n\tborder-bottom-right-radius: 0;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom: none;\n}\n\npnx-button-group[dir="column"] > :last-child::part(btn),\npnx-button-group[dir="column"] > :last-child > ::part(btn) {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n\tborder-top: none;\n}\n'), document.adoptedStyleSheets.push($a42f1354f0348298$var$Yx);
class $a42f1354f0348298$var$Jx extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		div {
			display: flex;
			flex-wrap: nowrap;
			align-items: stretch;
			align-content: stretch;
			justify-content: center;
		}

		div.row { flex-direction: row; }
		div.column { flex-direction: column; }

		div.xl { line-height: 38px; font-size: 20px; }
		div.row.xl { height: 38px; }
		div.column.xl { width: 38px; }

		div.row ::slotted(*) { height: 100%; min-width: 24px; }
		div.column ::slotted(*) { width: 100%; min-height: 24px; }

		div.row.xl ::slotted(*) { min-width: 38px; }
		div.column.xl ::slotted(*) { min-height: 38px; }
	`;
    static properties = {
        dir: {
            type: String
        },
        size: {
            type: String
        }
    };
    constructor(){
        super(), this.dir = "row", this.size = "md";
    }
    render() {
        return $a42f1354f0348298$var$V`<div class="${this.dir} ${this.size}" part="btn-group">
			<slot></slot>
		</div>`;
    }
}
customElements.define("pnx-button-group", $a42f1354f0348298$var$Jx);
class $a42f1354f0348298$var$$x extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$Uo;
    static properties = {
        active: {
            type: Boolean
        },
        kind: {
            type: String
        },
        size: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        type: {
            type: String
        },
        title: {
            type: String
        }
    };
    constructor(){
        super(), this.active = !1, this.disabled = !1, this.kind = "full", this.size = "md";
    }
    connectedCallback() {
        super.connectedCallback(), "submit" === this.type && this.addEventListener("click", ()=>this.closest("FORM")?.requestSubmit());
    }
    render() {
        const e = document.createElement("button");
        e.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((e)=>void 0 !== this[e] && !1 !== this[e] && ![
                "active",
                "kind",
                "size"
            ].includes(e)).forEach((t)=>e.setAttribute(t, this[t])), e.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`), this.active && e.classList.add("pnx-btn-active");
        const t = document.createElement("slot");
        return e.appendChild(t), e;
    }
}
customElements.define("pnx-button", $a42f1354f0348298$var$$x);
class $a42f1354f0348298$var$ew extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$Uo,
        $a42f1354f0348298$var$s`
		.pnx-btn-unstyled {
			border: none;
			background: none;
			font-family: var(--font-family);
			font-size: 1em;
			color: var(--widget-font);
			cursor: pointer;
			padding: 0;
			margin: 0;
		}
	`
    ];
    static properties = {
        text: {
            type: String
        },
        input: {
            type: String
        },
        kind: {
            type: String
        },
        size: {
            type: String
        },
        unstyled: {
            type: Boolean
        },
        title: {
            type: String
        },
        _active: {
            state: !0,
            type: Boolean
        }
    };
    constructor(){
        super(), this.data = "", this.input = "", this.unstyled = !1, this.kind = "full", this.size = "md", this._active = !1, this.addEventListener("click", this._onClick);
    }
    _onClick(e) {
        let t;
        if (e.stopPropagation(), "" !== this.input) {
            const e = document.getElementById(this.input);
            t = e.innerText || e.value;
        } else "" !== this.text && (t = this.text);
        navigator?.clipboard ? (navigator.clipboard.writeText(t), this._active = !0, setTimeout(()=>this._active = !1, 2e3)) : alert("Clipboard is not available");
    }
    render() {
        const e = {
            "pnx-btn": !this.unstyled,
            "pnx-btn-full": !this.unstyled,
            "pnx-btn-active": !this.unstyled && this._active,
            "pnx-btn-unstyled": this.unstyled,
            [`pnx-btn-${this.kind}`]: !this.unstyled,
            [`pnx-btn-${this.size}`]: !this.unstyled
        };
        return $a42f1354f0348298$var$V`<button title=${this.title} class=${$a42f1354f0348298$var$he(e)} part="btn">
			${this._active ? $a42f1354f0348298$var$V`<slot name="oncopy">${this._t?.pnx.copied || ""} ${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$zs)}</slot>` : $a42f1354f0348298$var$V`<slot>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ss)} ${this._t?.pnx.copy || ""}</slot>`}
		</button>`;
    }
}
customElements.define("pnx-copy-button", $a42f1354f0348298$var$ew);
class $a42f1354f0348298$var$tw extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$s`
		span { color: var(--orange); }
	`
    ];
    static properties = {
        stars: {
            type: Number
        }
    };
    constructor(){
        super(), this.stars = 0;
    }
    render() {
        const e = this.stars || 0, t = [];
        for(let i = 1; i <= e; i++)t.push($a42f1354f0348298$var$Ir($a42f1354f0348298$var$Qr));
        for(let i = e + 1; i <= 5; i++)t.push($a42f1354f0348298$var$Ir($a42f1354f0348298$var$ul));
        return $a42f1354f0348298$var$V`<span>
			${t}
		</span> (${this.stars ? this.stars + "/5" : this._t?.pnx.metadata_quality_missing || "?"})`;
    }
}
customElements.define("pnx-grade", $a42f1354f0348298$var$tw);
class $a42f1354f0348298$var$iw extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Po,
        $a42f1354f0348298$var$s`
		.pnx-panel {
			padding: 5px;
			margin-top: 5px;
			width: max-content;
  			min-width: unset;
		}

		/* Custom button look */
		pnx-button::part(btn) {
			border-radius: 8px;
			height: 26px;
			width: 26px;
		}

		pnx-button[size="xl"]::part(btn) {
			border-radius: 8px;
			height: 38px;
			width: 38px;
		}

		pnx-button[active]::part(btn),
		pnx-button[active]:hover::part(btn) {
			background-color: var(--widget-bg-active) !important;
			border-color: var(--widget-bg-active) !important;
			color: var(--widget-font-active) !important;
		}

		/* No-annotations badge */
		.pnx-annotations-switch-empty {
			position: absolute;
			top: 1px;
			right: 1px;
			color: var(--orange);
			height: 8px;
		}

		pnx-button[size="xl"] .pnx-annotations-switch-empty {
			top: 2px;
			right: 2px;
			height: 12px;
		}

		pnx-button[active] .pnx-annotations-switch-empty {
			color: var(--yellow);
		}
	`
    ];
    static properties = {
        size: {
            type: String
        },
        _annotationsToggled: {
            state: !0
        },
        _warnNoAnnot: {
            state: !0
        },
        _warnNoAnnotTooltip: {
            state: !0
        }
    };
    constructor(){
        super(), this._annotationsToggled = !1, this._warnNoAnnot = !1, this._warnNoAnnotTooltip = !1, this.size = "xl";
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>{
            this._parent.onceReady().then(()=>{
                this._parent.psv.addEventListener("annotations-toggled", (e)=>{
                    this._annotationsToggled = e.detail.visible, this._persistAnnotationsLocalStorage(this._annotationsToggled);
                }), this._warnNoAnnot = !$a42f1354f0348298$var$sl(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                    this._warnNoAnnot = !$a42f1354f0348298$var$sl(this._parent.psv.getPictureMetadata());
                });
            }), this._parent.onceFirstPicLoaded().then(()=>{
                this._annotationsToggled = this._parent.psv.areAnnotationsVisible() || !1, this._persistAnnotationsLocalStorage(this._annotationsToggled);
            });
        });
    }
    _persistAnnotationsLocalStorage(e) {
        localStorage.setItem($a42f1354f0348298$var$js, e ? "false" : "true");
    }
    _onClick() {
        !this._annotationsToggled && this._warnNoAnnot && (this._warnNoAnnotTooltip = !0, setTimeout(()=>this._warnNoAnnotTooltip = !1, 2e3)), this._persistAnnotationsLocalStorage(!this._annotationsToggled), this._parent.psv.toggleAllAnnotations(!this._annotationsToggled);
    }
    render() {
        const e = {
            "pnx-panel": !0,
            "pnx-hidden": !this._warnNoAnnotTooltip
        };
        return $a42f1354f0348298$var$V`
			<pnx-button
				kind="superflat"
				size=${this.size}
				style="vertical-align: middle"
				class="pnx-print-hidden"
				title=${this._annotationsToggled ? this._parent._t?.pnx.semantics_hide_annotations : this._parent._t?.pnx.semantics_show_annotations}
				active=${this._annotationsToggled ? "" : $a42f1354f0348298$var$q}
				@click=${this._onClick}
			>
				${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ns, {
            styles: {
                height: "20px"
            }
        })}
				${this._warnNoAnnot ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Fs, {
            classes: "pnx-annotations-switch-empty"
        }) : $a42f1354f0348298$var$q}
			</pnx-button>
			<div
				class=${$a42f1354f0348298$var$he(e)}
				@click=${()=>this._warnNoAnnotTooltip = !1}
			>
				${this._parent._t?.pnx.semantics_zero_annotations}
			</div>
		`;
    }
}
customElements.define("pnx-annotations-switch", $a42f1354f0348298$var$iw);
class $a42f1354f0348298$var$nw extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$Uo;
    static properties = {
        href: {
            type: String
        },
        target: {
            type: String
        },
        title: {
            type: String
        },
        download: {
            type: String
        },
        class: {
            type: String
        },
        kind: {
            type: String
        },
        size: {
            type: String
        }
    };
    constructor(){
        super(), this.kind = "full", this.size = "md";
    }
    render() {
        const e = document.createElement("a");
        e.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((e)=>void 0 !== this[e]).forEach((t)=>e.setAttribute(t, this[t])), e.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`);
        const t = document.createElement("slot");
        return e.appendChild(t), e;
    }
}
customElements.define("pnx-link-button", $a42f1354f0348298$var$nw);
class $a42f1354f0348298$var$aw extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Po,
        $a42f1354f0348298$var$s`
		:host ::slotted(*) {
			text-decoration: none;
			border: none;
			border-bottom: 1px solid var(--widget-border-div);
			background: none;
			display: block;
			width: 100%;
			color: var(--widget-font);
			font-family: var(--font-family);
			cursor: pointer;
			font-size: 1em;
			font-weight: 400;
			line-height: 18px;
			padding: 5px 10px;
  			min-width: 150px;
			width: 100%;
			text-align: left;
			box-sizing: border-box;
		}

		:host ::slotted(*:hover) {
			background-color: var(--widget-bg-hover);
		}

		:host ::slotted(*:first-child) {
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}

		:host ::slotted(*:last-child) {
			border: none;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	`
    ];
    render() {
        return $a42f1354f0348298$var$V`<slot></slot>`;
    }
}
customElements.define("pnx-list-group", $a42f1354f0348298$var$aw);
class $a42f1354f0348298$var$rw extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		.list-item {
			display: flex;
			align-items: center;
			padding: 8px 16px;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			font-family: var(--font-family);
			background: var(--white);
			min-height: 40px;
			box-sizing: border-box;
		}
		.list-item:hover { background: var(--widget-bg-hover); }
		.icon {
			margin-right: 16px;
			display: flex;
			align-items: center;
			gap: 10px;
			position: relative;
		}
		.action {
			margin-left: 16px;
			display: flex;
  			gap: 5px;
		}
		.content {
			flex: 1;
		}
		.title {
			font-weight: 600;
		}
		.subtitle {
			font-size: 0.9em;
			color: var(--grey-dark);
		}
	`;
    static properties = {
        title: {
            type: String
        },
        subtitle: {
            type: String
        },
        tooltip: {
            type: String
        }
    };
    render() {
        return $a42f1354f0348298$var$V`
			<div class="list-item" title=${this.tooltip}>
				<div class="icon">
					<slot name="icon"></slot>
				</div>
				<div class="content">
					<div class="title">${this.title}</div>
					<div class="subtitle">${this.subtitle}</div>
				</div>
				<div class="action">
					<slot name="action"></slot>
				</div>
			</div>
		`;
    }
}
customElements.define("pnx-list-item", $a42f1354f0348298$var$rw);
class $a42f1354f0348298$var$sw extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		:host {
			position: absolute;
			inset: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 10px;
			align-items: center;
			background-image: url('${$a42f1354f0348298$var$r($a42f1354f0348298$var$nx)}');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			z-index: 200;
			font-family: var(--font-family);
			font-weight: 550;
			color: var(--black);
			font-size: 1.4em;
			text-align: center;
			visibility: hidden;
			opacity: 0;
		}
		:host(*[visible]) {
			visibility: visible;
			opacity: 1;
		}

		div.label {
			background-color: rgba(255,255,255,0.5);
			box-shadow: white 0 0 10px;
			padding: 3px 10px;
			border-radius: 50px;
		}
		/* Logo */
		img.logo-dead { width: 100px; }
	`;
    static properties = {
        _mode: {
            state: !0
        },
        _label: {
            state: !0
        },
        _isLabelFun: {
            state: !0
        },
        visible: {
            type: Boolean,
            reflect: !0
        },
        "no-label": {
            type: Boolean
        },
        value: {
            type: Number
        }
    };
    constructor(){
        super(), this.visible = !0, this["no-label"] = !1, this._mode = "loading", this._isLabelFun = !1, this.value = -1;
    }
    connectedCallback() {
        super.connectedCallback(), this._nextLabel();
    }
    isVisible() {
        return this.visible;
    }
    dismiss(e = null, t = null, i = null) {
        if (clearTimeout(this._loaderLabelChanger), e) {
            !0 !== e && console.error(e);
            let n = [
                this._parent?._t.pnx.error,
                $a42f1354f0348298$var$V`<br />`
            ];
            t && n.push(t, $a42f1354f0348298$var$V`<br />`), i ? (n.push($a42f1354f0348298$var$V`<pnx-button kind="full">${this._parent?._t.pnx.error_click}</pnx-button>`), this.addEventListener("click", i)) : n.push($a42f1354f0348298$var$V`<small>${this._parent?._t.pnx.error_retry}</small>`), this._mode = "error", this._label = n;
            const a = t || "Panoramax JS had a blocking exception", r = new CustomEvent("broken", {
                detail: {
                    error: a
                }
            });
            throw this._parent.dispatchEvent(r), new Error(a);
        }
        {
            this.value = 100, this._mode = "done", this.visible = !1, this.style.transition = "all 0.5s", setTimeout(()=>{
                this.parentNode && this.parentNode.removeChild(this);
            }, 2e3);
            const e = new CustomEvent("ready");
            this._parent.dispatchEvent(e), i && i();
        }
    }
    _nextLabel() {
        this._isLabelFun ? this._label = this._parent?._t.pnx.loading_labels_fun[$a42f1354f0348298$var$fo(0, this._parent?._t.pnx.loading_labels_fun.length - 1)] : (this._label = this._parent?._t.pnx.loading_labels_serious[$a42f1354f0348298$var$fo(0, this._parent?._t.pnx.loading_labels_serious.length - 1)], this._isLabelFun = !0), this._loaderLabelChanger = setTimeout(this._nextLabel.bind(this), $a42f1354f0348298$var$fo(500, 1500));
    }
    render() {
        return "error" === this._mode ? $a42f1354f0348298$var$V`
				<img class="logo-dead" src=${$a42f1354f0348298$var$ix} alt="" title=${this._parent?._t.map.loading} />
				${this._label}
			` : $a42f1354f0348298$var$V`
			<pnx-progress-bar .value=${this.value}></pnx-progress-bar>
			${this["no-label"] ? $a42f1354f0348298$var$q : $a42f1354f0348298$var$V`<div class="label">${this._label}</div>`}
		`;
    }
}
customElements.define("pnx-loader", $a42f1354f0348298$var$sw);
class $a42f1354f0348298$var$ow extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Po,
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$s`
		/* Backdrop */
		:host {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			opacity: 0;
			visibility: hidden;
			pointer-events: none;
			transition: all 0.2s;
			background: rgba(0, 0, 0, 0.85);
		}
		:host(*[visible]) {
			opacity: 1;
			visibility: visible;
			pointer-events: unset;
			z-index: 200;
		}

		/* Content backgroud */
		.pnx-panel {
			box-sizing: border-box;
			position: relative;
			width: 90%;
			max-height: 90%;
			max-width: 400px;
			overflow-y: auto;
		}

		.btn-close {
			position: absolute;
			top: 15px;
			right: 15px;
		}
	`
    ];
    static properties = {
        visible: {
            type: Boolean,
            reflect: !0
        }
    };
    constructor(){
        super(), this.visible = !1;
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("click", (e)=>{
            e.target === this && this.close();
        }), document.addEventListener("keyup", (e)=>{
            "Escape" === e.key && this.visible && this.close();
        });
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "visible" === e && ("" !== i && !0 !== i || this.dispatchEvent(new Event("open")));
    }
    close() {
        this.visible = !1, this.dispatchEvent(new Event("close"));
    }
    render() {
        return $a42f1354f0348298$var$V`
			<div class="pnx-panel pnx-padded">
				<pnx-button
					class="btn-close"
					kind="inline"
					size="l"
					@click=${this.close.bind(this)}
				>
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ts)}
				</pnx-button>

				<slot></slot>
			</div>
		`;
    }
}
customElements.define("pnx-popup", $a42f1354f0348298$var$ow);
class $a42f1354f0348298$var$lw extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		progress {
			max-width: 80vh;
			width: 300px;
			height: 16px;
			appearance: none;
			-webkit-appearance: none;
			border: 1px solid var(--grey-semi-dark);
			background-color: var(--grey);
			border-radius: 8px;
			overflow: hidden;
			padding: 3px;
			box-sizing: border-box;
			display: block;
		}

		progress::-webkit-progress-bar {
			background-color: var(--grey);
		}

		/* Don't merge with -moz below, for some f*ing reason a list selector doesn't work with Chrome */
		progress::-webkit-progress-value {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress::-moz-progress-bar {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress[value=""]::-moz-progress-bar,
		progress:not([value])::-moz-progress-bar {
			animation: indeterminateAnimation 1.5s infinite linear;
		}

		progress.indeterminate {
			position: relative;
			background-color: var(--grey);
			overflow: hidden;
		}

		progress.indeterminate::after {
			content: "";
			position: absolute;
			left: 3px;
			top: 3px;
			bottom: 3px;
			width: 20%;
			background-color: var(--blue);
			border-radius: 5px;
			animation: indeterminateAnimation 1.5s infinite linear;
			pointer-events: none;
		}

		@keyframes indeterminateAnimation {
			0%   { margin-left: 0%; width: 2%; }
			15%  { margin-left: 0%; width: 20%; }
			50%  { margin-left: 40%; width: 20%; }
			85%  { margin-left: 80%; width: 20%; }
			100% { margin-left: 98%; width: 2%; }
		}
	`;
    static properties = {
        value: {
            type: Number
        }
    };
    render() {
        return $a42f1354f0348298$var$V`
			<progress
				value=${this.value >= 0 ? this.value : $a42f1354f0348298$var$q}
				class=${this.value >= 0 ? $a42f1354f0348298$var$q : "indeterminate"}
				max="100"
				title=${this._t?.map.loading}
			></progress>
		`;
    }
}
customElements.define("pnx-progress-bar", $a42f1354f0348298$var$lw);
class $a42f1354f0348298$var$cw extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		:host {
			gap: 0px;
			justify-content: center;
			height: 2em;
			font-size: 18px;
			display: inline-flex;
			align-items: center;
			color: white;
		}

		/* Single letter */
		span, label {
			width: 1.2em;
			height: 1.5em;
			line-height: 1.5em;
			display: inline-block;
			border: 0.05em solid white;
			text-align: center;
			background-color: gray;
			color: rgba(255,255,255,0.9);
			font-family: var(--font-family);
			font-weight: 800;
			vertical-align: middle;
		}

		/* Rounded corners for first/last */
		span:first-of-type, label:first-of-type {
			border-top-left-radius: 0.4em;
			border-bottom-left-radius: 0.4em;
		}

		span:last-of-type, label:last-of-type {
			border-top-right-radius: 0.4em;
			border-bottom-right-radius: 0.4em;
		}

		/* Selected letter */
		.selected, input[type="checkbox"]:checked + label {
			font-size: 1.3em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		/* Clickable letter for input */
		label { cursor: pointer; }

		label:hover {
			font-size: 1.2em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		input[type="checkbox"] { display: none; }
	`;
    static properties = {
        grade: {
            type: String,
            reflect: !0
        },
        input: {
            type: String
        }
    };
    constructor(){
        super(), this.grade = 0, this.input = !1;
    }
    _onInput() {
        const e = [];
        for (let t of this.renderRoot.querySelectorAll("input"))t.checked && e.push(t.value);
        this.grade = e.join(","), this.dispatchEvent(new CustomEvent("change", {
            bubbles: !0,
            composed: !0
        }));
    }
    render() {
        const e = `${this.grade}`.split(",").map((e)=>parseInt(e)).filter((e)=>!isNaN(e));
        return this.input ? $a42f1354f0348298$var$qs.map((t, i)=>$a42f1354f0348298$var$V`
				<input
					id="${this.input}-${t.label}"
					type="checkbox"
					name="qualityscore"
					value="${5 - i}"
					@change="${this._onInput}"
					.checked=${e.includes(5 - i)}
				/>
				<label
					for="${this.input}-${t.label}"
					title="${this._t?.pnx.filter_qualityscore_help}"
					style="background-color: ${t.color}"
				>
					${t.label}
				</label>
			`) : $a42f1354f0348298$var$qs.map((t, i)=>$a42f1354f0348298$var$V`
				<span class="${e.includes(5 - i) ? "selected" : ""}" style="background-color: ${t.color}">
					${t.label}
				</span>
			`);
    }
}
customElements.define("pnx-quality-score", $a42f1354f0348298$var$cw);
const $a42f1354f0348298$var$dw = new CSSStyleSheet;
$a42f1354f0348298$var$dw.replaceSync("/* Search results */\n.sb-results {\n\tposition: fixed;\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tmax-width: calc(100% - 20px);\n\tborder: 1px solid var(--widget-border-div);\n\tborder-radius: 10px;\n\tbackground-color: var(--widget-bg);\n\tcolor: var(--widget-font);\n\tz-index: 130;\n\tfont-size: 1.05em;\n\tline-height: normal;\n\tfont-family: var(--font-family);\n\tmax-height: 30vh;\n\toverflow-y: auto;\n}\n.sb-result,\n.sb-empty {\n\tdisplay: block;\n\tpadding: 5px 15px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: pointer;\n\tborder-radius: 0;\n}\n.sb-result:hover {\n\tbackground-color: var(--widget-bg-hover);\n}\n.sb-result:first-child {\n\tborder-top-right-radius: 10px;\n\tborder-top-left-radius: 10px;\n\tpadding-top: 15px;\n}\n.sb-result:last-child {\n\tborder-bottom-right-radius: 10px;\n\tborder-bottom-left-radius: 10px;\n\tpadding-bottom: 15px;\n}"), document.adoptedStyleSheets.push($a42f1354f0348298$var$dw);
class $a42f1354f0348298$var$uw extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Lo,
        $a42f1354f0348298$var$s`
		/* Container */
		.sb {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 5px;
			border: 1px solid var(--widget-border-div);
			border-radius: 5px;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			height: 30px;
			border-radius: 20px;
			position: relative;
			padding: 0 0 0 10px;
			width: fit-content;
			max-width: 100%;
			box-sizing: border-box;
			font-family: var(--font-family);
		}
		.sb.sb-xxl {
			height: 40px;
			line-height: 40px;
		}
		.sb.sb-reduceable {
			width: 360px;
		}
		.sb.sb-reduceable.sb-reduced {
			width: fit-content;
			padding: 0;
			gap: 0;
		}

		/* Text field */
		.sb input {
			background: none;
			border: none !important;
			outline: none;
			height: 20px;
			width: 100%;
			font-family: var(--font-family);
		}
		.sb.sb-xxl input {
			font-size: 1.1em;
		}
		.sb.sb-reduceable.sb-reduced input {
			display: none;
		}

		/* Status icon */
		.sb-icon {
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			width: 30px;
			min-width: 30px;
			text-align: center;
		}
		.sb.sb-xxl .sb-icon {
			height: 40px;
			line-height: 40px;
			width: 40px;
			min-width: 40px;
		}
		.sb-icon svg {
			pointer-events: none;
			width: 14px;
			height: 14px;
		}
	`
    ];
    static properties = {
        id: {
            type: String
        },
        placeholder: {
            type: String
        },
        reduceable: {
            type: Boolean,
            reflect: !0
        },
        reduced: {
            type: Boolean,
            reflect: !0
        },
        value: {
            type: String
        },
        size: {
            type: String
        },
        _icon: {
            state: !0
        },
        _results: {
            state: !0
        },
        searcher: {
            type: Function
        },
        "no-menu-closure": {
            type: Boolean
        },
        "keep-on-menu-closure": {
            type: Boolean
        }
    };
    constructor(){
        super(), this.reduceable = !1, this.reduced = !1, this.placeholder = $a42f1354f0348298$var$q, this.size = "md", this._icon = "search", this._results = null, this["no-menu-closure"] = !1, this["keep-on-menu-closure"] = !1, this._throttler = null, delete this._lastSearch;
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "value" === e && ([
            null,
            void 0,
            "",
            "null"
        ].includes(i) ? this._icon = "search" : this._icon = "empty");
    }
    _onIconClick() {
        [
            "empty",
            "warn"
        ].includes(this._icon) && this.reset(), this.reduceable && "search" === this._icon && (this.reduced = !this.reduced);
    }
    _onInputChange(e) {
        this.value !== e.target.value && (this.value = e.target.value, this._throttledSearch());
    }
    _onResultClick(e) {
        let t = null !== this._results;
        this._results = null, t && !this["no-menu-closure"] && this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
            detail: {
                menu: this._popup
            }
        })), this._throttler && (clearTimeout(this._throttler), this._throttler = null), !this.reduceable && e ? (this.value = e?.title, this._icon = "empty") : (this.value = "", this._icon = "search", this.reduceable && (this.reduced = !0)), this.dispatchEvent(new CustomEvent("result", {
            bubbles: !0,
            composed: !0,
            detail: e
        }));
    }
    _throttledSearch() {
        this._throttler && (clearTimeout(this._throttler), delete this._throttler), this._throttler = setTimeout(this._search.bind(this), 500);
    }
    _search() {
        if (!this.value || 0 === this.value.length) return void this.reset();
        if (!this.searcher) return void console.warn("No search handler defined");
        this._icon = "loading";
        let e = null !== this._results;
        this._results = null, e && !this["no-menu-closure"] && this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
            detail: {
                menu: this._popup
            }
        })), this.searcher(this.value).then((t)=>{
            "loading" === this._icon && (this._icon = "empty", e = null !== this._results, t && 0 !== t.length ? this._results = !0 === t ? null : t : this._results = [], this["no-menu-closure"] || (!this._results && e ? this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
                detail: {
                    menu: this._popup
                }
            })) : this._results && this._parent?.dispatchEvent(new CustomEvent("menu-opened", {
                detail: {
                    menu: this._popup
                }
            }))));
        }).catch((e)=>{
            console.error(e), this._icon = "warn";
        });
    }
    reset() {
        this._onResultClick(null);
    }
    render() {
        const e = {
            sb: !0,
            "sb-xxl": "xxl" === this.size,
            "sb-reduceable": this.reduceable,
            "sb-reduced": this.reduced
        }, t = this.id + "-popup";
        if (this._popup = document.getElementById(t), this._popup || (this._popup = document.createElement("div"), this._popup.id = t, this._popup._parent = this._parent, this._popup.classList.add("sb-results", "pnx-panel"), this._parent.renderRoot.appendChild(this._popup), this["keep-on-menu-closure"] ? $a42f1354f0348298$var$zr(this._popup, ()=>this._results = null) : $a42f1354f0348298$var$zr(this._popup, this.reset.bind(this))), !this.reduced && this._results) {
            $a42f1354f0348298$var$se($a42f1354f0348298$var$V`
				${0 === this._results.length ? $a42f1354f0348298$var$V`
					<div class="sb-empty">${this._parent?._t?.pnx.search_empty}</div>
				` : $a42f1354f0348298$var$q}

				${/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function*(e, t) {
                if (void 0 !== e) {
                    let i = 0;
                    for (const n of e)yield t(n, i++);
                }
            }(this._results, (e)=>$a42f1354f0348298$var$V`
					<div class="sb-result" @click=${()=>this._onResultClick(e)}>
						${e.title}
						${e.subtitle && "" !== e.subtitle ? $a42f1354f0348298$var$V`<br /><small>${e.subtitle}</small>` : $a42f1354f0348298$var$q}
					</div>
				`)}
			`, this._popup);
            const e = this.renderRoot.host.getBoundingClientRect();
            this._popup.style.display = "block", this._popup.style.top = `${e.bottom + 5}px`, this._popup.style.left = `${e.left + 5}px`;
        } else this._popup && (this._popup.style.display = "none");
        return $a42f1354f0348298$var$V`<div
			id=${this.id}
			class=${$a42f1354f0348298$var$he(e)}
			part="container"
		>
			<slot name="pre" class=${$a42f1354f0348298$var$he({
            "sb-reduced": this.reduced
        })}></slot>

			<input
				id="${this.id}-input"
				type="text"
				placeholder=${this.placeholder}
				autocomplete="off"
				@change=${this._onInputChange.bind(this)}
				@keypress=${this._onInputChange.bind(this)}
				@paste=${this._onInputChange.bind(this)}
				@input=${this._onInputChange.bind(this)}
				.value=${this.value || ""}
				part="input"
			/>

			<span
				class="sb-icon"
				@click=${this._onIconClick.bind(this)}
			>
				${"search" === this._icon ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$ws) : $a42f1354f0348298$var$q}
				${"loading" === this._icon ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Gr, {
            classes: [
                "fa-spin"
            ]
        }) : $a42f1354f0348298$var$q}
				${"empty" === this._icon ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ts) : $a42f1354f0348298$var$q}
				${"warn" === this._icon ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$Hr) : $a42f1354f0348298$var$q}
			</span>
		</div>`;
    }
}
customElements.define("pnx-search-bar", $a42f1354f0348298$var$uw);
class $a42f1354f0348298$var$hw extends EventTarget {
    constructor(e, t = {}){
        if (super(), null == e || "string" != typeof e) {
            const e = new Error("endpoint parameter is empty or not a valid string");
            throw this.dispatchEvent(new CustomEvent("broken", {
                detail: {
                    error: e
                }
            })), e;
        }
        if (e.startsWith("/") && (e = window.location.href.split("/").slice(0, 3).join("/") + e), !$a42f1354f0348298$var$hw.isValidHttpUrl(e)) {
            const t = new Error(`endpoint parameter is not a valid URL: ${e}`);
            throw this.dispatchEvent(new CustomEvent("broken", {
                detail: {
                    error: t
                }
            })), t;
        }
        this._endpoint = e, this._isReady = 0, this._dataBbox = null, this._fetchOpts = t?.fetch || {}, this._metadata = {}, this._configuration = null, t.skipReadLanding || (this._readLanding = fetch(e, this._getFetchOptions()).then((e)=>e.json()).then((e)=>this._parseLanding(e, t)).catch((e)=>(this._isReady = -1, console.error(e), this.dispatchEvent(new CustomEvent("broken", {
                detail: {
                    error: e
                }
            })), Promise.reject("Viewer failed to communicate with API"))).then(()=>(this._isReady = 1, this.dispatchEvent(new Event("ready")), "API is ready")));
    }
    onceReady() {
        return -1 === this._isReady ? Promise.reject("Viewer failed to communicate with API") : 1 === this._isReady ? Promise.resolve("API is ready") : this._readLanding;
    }
    isReady() {
        return 1 === this._isReady;
    }
    getAvailableFeatures() {
        return Object.entries(this._endpoints).filter((e)=>null !== e[1]).map((e)=>e[0]);
    }
    getUnavailableFeatures() {
        return Object.entries(this._endpoints).filter((e)=>null === e[1]).map((e)=>e[0]);
    }
    _parseLanding(e, t) {
        if (this._endpoints = {
            collections: null,
            search: null,
            style: null,
            user_style: null,
            tiles: t?.tiles || null,
            user_tiles: null,
            user_search: null,
            collection_preview: null,
            item_preview: null,
            rss: null,
            report: null,
            queryables: null
        }, !e || !e.links || !Array.isArray(e.links)) throw new Error("API Landing page doesn't contain 'links' list");
        if (!e.stac_version.startsWith("1.")) throw new Error(`API is not in a supported STAC version (Panoramax viewer supports only 1.x, API is ${e.stac_version})`);
        this._metadata.name = e.title || "Unnamed", this._metadata.stac_version = e.stac_version, this._metadata.geovisio_version = e.geovisio_version;
        const i = [], n = [];
        if ([
            {
                rel: "search",
                type: "application/geo+json",
                endpointId: "search",
                mandatory: !0,
                missingIssue: "No direct access to pictures metadata."
            },
            {
                rel: "data",
                type: "application/json",
                endpointId: "collections",
                mandatory: !0,
                missingIssue: "No way for viewer to access sequences."
            },
            {
                rel: "data",
                type: "application/rss+xml",
                endpointId: "rss"
            },
            {
                rel: "xyz",
                type: "application/vnd.mapbox-vector-tile",
                endpointId: "tiles"
            },
            {
                rel: "xyz-style",
                type: "application/json",
                endpointId: "style"
            },
            {
                rel: "user-xyz-style",
                type: "application/json",
                endpointId: "user_style"
            },
            {
                rel: "user-xyz",
                type: "application/vnd.mapbox-vector-tile",
                endpointId: "user_tiles"
            },
            {
                rel: "user-search",
                type: "application/json",
                endpointId: "user_search",
                missingIssue: "Filter map data by user name will not be available."
            },
            {
                rel: "collection-preview",
                type: "image/jpeg",
                endpointId: "collection_preview",
                missingIssue: "Display of thumbnail could be slower."
            },
            {
                rel: "item-preview",
                type: "image/jpeg",
                endpointId: "item_preview",
                missingIssue: "Display of thumbnail could be slower."
            },
            {
                rel: "report",
                type: "application/json",
                endpointId: "report"
            },
            {
                rel: "http://www.opengis.net/def/rel/ogc/1.0/queryables",
                type: "application/schema+json",
                endpointId: "queryables",
                missingIssue: "Tags map overlay will not be available."
            }
        ].forEach((t)=>{
            const a = e.links.filter((e)=>e.rel === t.rel && e.type === t.type);
            if (0 === a.length) {
                if (!this._endpoints[t.endpointId]) {
                    let e = `API doesn't offer a '${t.rel}' (${t.type}) endpoint in its links`;
                    t.missingIssue && (e += `\n${t.missingIssue}`), t.mandatory ? i.push(e) : t.missingIssue && n.push(e);
                }
            } else {
                const e = 1 === a.length ? a[0] : a.find((e)=>e.title?.includes("v2")) || a[0];
                if (!$a42f1354f0348298$var$hw.isValidHttpUrl(e.href)) throw new Error(`API endpoint '${e.rel}' (${e.type}) is not a valid URL: ${e.href}`);
                this._endpoints[t.endpointId] && "xyz-style" !== t.endpointId || (this._endpoints[t.endpointId] = e.href);
            }
        }), this._endpoints.style || this._endpoints.tiles || n.push("API doesn't offer 'xyz' or 'xyz-style' endpoints in its links.\nMap widget will not be available."), this._endpoints.user_style || this._endpoints.user_tiles || n.push("API doesn't offer 'user-xyz' or 'user-xyz-style' endpoints in its links.\nFilter map data by user ID will not be available."), n.forEach((e)=>console.warn(e)), i.length > 0) throw new Error(i.join("\n"));
        const a = e?.extent?.spatial?.bbox;
        this._dataBbox = a && Array.isArray(a) && a.length > 0 && Array.isArray(a[0]) && 4 === a[0].length ? [
            [
                a[0][0],
                a[0][1]
            ],
            [
                a[0][2],
                a[0][3]
            ]
        ] : null;
    }
    _getFetchOptions(e = !1) {
        const t = Object.assign({}, this._fetchOpts);
        return e || (t.signal = AbortSignal.timeout(15e3)), t;
    }
    _getMapRequestTransform() {
        const e = this._getFetchOptions();
        return delete e.signal, (t)=>{
            if (t.startsWith(this._endpoint)) {
                if (Object.keys(e).length > 0) return {
                    url: t,
                    ...e
                };
            } else if (t.includes("data.geopf.fr") && t.includes("@2x")) return {
                url: t.replace("@2x", "")
            };
        };
    }
    _getPSVWithCredentials() {
        return "include" === this._getFetchOptions().credentials ? (e)=>e.startsWith(this._endpoint) : void 0;
    }
    cleanResourceURL(e) {
        if (!e) return;
        const t = new URL(this._endpoint);
        return e.startsWith("/") ? t.protocol + "//" + t.host + e : e.startsWith("./") ? this._endpoint + e.substring(1) : e;
    }
    async getSequenceItems(e, t = null, i = null, n = null) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        try {
            return $a42f1354f0348298$var$hw.isIdValid(e), await fetch(t || `${this._endpoints.collections}/${e}/items${n ? "?limit=" + n : ""}`, this._getFetchOptions(!0)).then((e)=>e.json()).then((t)=>{
                let a = t;
                i && (a.features = i.features.concat(a.features));
                const r = t.links.find((e)=>"next" === e.rel);
                return !n && r ? this.getSequenceItems(e, r.href, a) : a;
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }
    getPicturesAroundCoordinatesUrl(e, t, i = 5e-4, n = null, a = null) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (isNaN(parseFloat(e)) || isNaN(parseFloat(t))) throw new Error("lat and lon parameters should be valid numbers");
        const r = [
            t - i,
            e - i,
            t + i,
            e + i
        ].map((e)=>e.toFixed(7)).join(","), s = n ? `&limit=${n}` : "", o = a ? `&collections=${a}` : "";
        return `${this._endpoints.search}?bbox=${r}${s}${o}`;
    }
    getPicturesAroundCoordinates(e, t, i, n, a) {
        return fetch(this.getPicturesAroundCoordinatesUrl(e, t, i, n, a), this._getFetchOptions()).then((e)=>e.json());
    }
    getPictureMetadataUrl(e, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if ($a42f1354f0348298$var$hw.isIdValid(e)) return t ? `${this._endpoints.collections}/${t}/items/${e}` : `${this._endpoints.search}?ids=${e}`;
    }
    findThumbnailInPictureFeature(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!e || !e.assets) return null;
        let t = null;
        for (let i of Object.values(e.assets)){
            if (i.roles.includes("thumbnail") && "image/jpeg" === i.type && $a42f1354f0348298$var$hw.isValidHttpUrl(i.href)) return this.cleanResourceURL(i.href);
            i.roles.includes("visual") && "image/jpeg" === i.type && $a42f1354f0348298$var$hw.isValidHttpUrl(i.href) && (t = this.cleanResourceURL(i.href));
        }
        return t;
    }
    getPictureThumbnailURLForSequence(e, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (this._endpoints.collection_preview) return Promise.resolve(this._endpoints.collection_preview.replace("{id}", e));
        if (t && Array.isArray(t.links) && t.links.length > 0) {
            let e = t.links.find((e)=>"preview" === e.rel && "image/jpeg" === e.type);
            if (e && $a42f1354f0348298$var$hw.isValidHttpUrl(e.href)) return Promise.resolve(e.href);
        }
        const i = `${this._endpoints.search}?limit=1&collections=${e}`;
        return fetch(i, this._getFetchOptions()).then((e)=>e.json()).then((e)=>Array.isArray(e.features) && 0 !== e.features.length ? this.findThumbnailInPictureFeature(e.features.pop()) : null);
    }
    getPictureThumbnailURL(e, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return e ? this._endpoints.item_preview ? Promise.resolve(this._endpoints.item_preview.replace("{id}", e)) : e && t ? fetch(`${this._endpoints.collections}/${t}/items/${e}`, this._getFetchOptions()).then((e)=>e.json()).then((e)=>e ? this.findThumbnailInPictureFeature(e) : null) : fetch(`${this._endpoints.search}?ids=${e}`, this._getFetchOptions()).then((e)=>e.json()).then((e)=>e && Array.isArray(e.features) && 0 !== e.features.length ? this.findThumbnailInPictureFeature(e.features.pop()) : null) : Promise.resolve(null);
    }
    getRSSURL(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (this._endpoints.rss) {
            let t = this._endpoints.rss;
            return e && (t += t.includes("?") ? "&" : "?", t += "bbox=" + [
                e.getWest(),
                e.getSouth(),
                e.getEast(),
                e.getNorth()
            ].join(",")), t;
        }
        return null;
    }
    getSequenceMetadataUrl(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return `${this._endpoints.collections}/${e}`;
    }
    getSequenceMetadata(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return fetch(this.getSequenceMetadataUrl(e), this._getFetchOptions()).then((e)=>e.json());
    }
    getDataBbox() {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return this._dataBbox;
    }
    searchUsers(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!this._endpoints.user_search) throw new Error("User search is not available");
        return fetch(`${this._endpoints.user_search}?q=${e}`, this._getFetchOptions()).then((e)=>e.json()).then((e)=>e?.features || null);
    }
    getUserName(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!this._endpoints.user_search) throw new Error("User search is not available");
        return fetch(this._endpoints.user_search.replace(/\/search$/, `/${e}`), this._getFetchOptions()).then((e)=>e.json()).then((e)=>e?.label || e?.name || null);
    }
    sendReport(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!this._endpoints.report) throw new Error("Report sending is not available");
        const t = {
            ...this._getFetchOptions(),
            method: "POST",
            body: JSON.stringify(e),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(this._endpoints.report, t).then(async (e)=>{
            if (e.status >= 400) {
                let t = await e.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e) {}
                return Promise.reject(t);
            }
            return e.json();
        });
    }
    deletePicture(e, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        let i = `${this._endpoint}/collections/${e}/items/${t}`;
        const n = {
            ...this._getFetchOptions(),
            method: "DELETE"
        };
        return fetch(i, n).then(async (e)=>{
            if (e.status >= 400) {
                let t = await e.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e) {}
                return Promise.reject(t);
            }
            return !0;
        });
    }
    sendPictureSemantics(e, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!e?.sequence?.id || !e?.id) throw new Error("Missing IDs from picture");
        let i = this.getPictureMetadataUrl(e.id, e.sequence.id);
        e?.origInstance && (i = `${e.origInstance.href}/api/collections/${e.sequence.id}/items/${e.id}`);
        const n = {
            ...this._getFetchOptions(),
            method: "PATCH",
            body: JSON.stringify({
                semantics: t
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(i, n).then(async (e)=>{
            if (e.status >= 400) {
                let t = await e.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e) {}
                return Promise.reject(t);
            }
            return e.json();
        });
    }
    createPictureAnnotation(e, t, i) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!e?.sequence?.id || !e?.id) throw new Error("Missing IDs from picture");
        let n = this.getPictureMetadataUrl(e.id, e.sequence.id) + "/annotations";
        e?.origInstance && (n = `${e.origInstance.href}/api/collections/${e.sequence.id}/items/${e.id}/annotations`);
        const a = {
            ...this._getFetchOptions(),
            method: "POST",
            body: JSON.stringify({
                semantics: i,
                shape: {
                    type: "Polygon",
                    coordinates: [
                        t
                    ]
                }
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(n, a).then(async (e)=>{
            if (e.status >= 400) {
                let t = await e.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e) {}
                return Promise.reject(t);
            }
            return e.json();
        });
    }
    editPictureAnnotation(e, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        let i = `${this._endpoint}/annotations/${e}`;
        const n = {
            ...this._getFetchOptions(),
            method: "PATCH",
            body: JSON.stringify({
                semantics: t
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(i, n).then(async (e)=>{
            if (e.status >= 400) {
                let t = await e.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e) {}
                return Promise.reject(t);
            }
            return e.json();
        });
    }
    deletePictureAnnotation(e) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        let t = `${this._endpoint}/annotations/${e}`;
        const i = {
            ...this._getFetchOptions(),
            method: "DELETE"
        };
        return fetch(t, i).then(async (e)=>{
            if (e.status >= 400) {
                let t = await e.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e) {}
                return Promise.reject(t);
            }
            return !0;
        });
    }
    getAuthURL() {
        return this._configuration ? Promise.resolve(!!this._configuration?.auth?.enabled && `${this._endpoint}/auth/login?next_url=<CBURL>`) : null === this._configuration ? fetch(this._endpoint + "/configuration", this._getFetchOptions()).then((e)=>e.json()).then((e)=>(this._configuration = e, this.getAuthURL())).catch(()=>(this._configuration = !1, !1)) : Promise.resolve(!1);
    }
    static isValidHttpUrl(e) {
        let t;
        try {
            t = new URL(e);
        } catch (e) {
            return !1;
        }
        return "http:" === t.protocol || "https:" === t.protocol;
    }
    static isIdValid(e) {
        if ($a42f1354f0348298$var$Zs(e)) throw new Error("id should be a valid picture unique identifier");
        return !0;
    }
}
var $a42f1354f0348298$var$pw = {
    Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
    ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
    ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
}, $a42f1354f0348298$var$Aw = {
    isSpaceSeparator: (e)=>"string" == typeof e && $a42f1354f0348298$var$pw.Space_Separator.test(e),
    isIdStartChar: (e)=>"string" == typeof e && (e >= "a" && e <= "z" || e >= "A" && e <= "Z" || "$" === e || "_" === e || $a42f1354f0348298$var$pw.ID_Start.test(e)),
    isIdContinueChar: (e)=>"string" == typeof e && (e >= "a" && e <= "z" || e >= "A" && e <= "Z" || e >= "0" && e <= "9" || "$" === e || "_" === e || "\u200C" === e || "\u200D" === e || $a42f1354f0348298$var$pw.ID_Continue.test(e)),
    isDigit: (e)=>"string" == typeof e && /[0-9]/.test(e),
    isHexDigit: (e)=>"string" == typeof e && /[0-9A-Fa-f]/.test(e)
};
let $a42f1354f0348298$var$mw, $a42f1354f0348298$var$gw, $a42f1354f0348298$var$fw, $a42f1354f0348298$var$_w, $a42f1354f0348298$var$vw, $a42f1354f0348298$var$Ew, $a42f1354f0348298$var$yw, $a42f1354f0348298$var$bw, $a42f1354f0348298$var$kw;
function $a42f1354f0348298$var$xw(e, t, i) {
    const n = e[t];
    if (null != n && "object" == typeof n) {
        if (Array.isArray(n)) for(let e = 0; e < n.length; e++){
            const t = String(e), a = $a42f1354f0348298$var$xw(n, t, i);
            void 0 === a ? delete n[t] : Object.defineProperty(n, t, {
                value: a,
                writable: !0,
                enumerable: !0,
                configurable: !0
            });
        }
        else for(const e in n){
            const t = $a42f1354f0348298$var$xw(n, e, i);
            void 0 === t ? delete n[e] : Object.defineProperty(n, e, {
                value: t,
                writable: !0,
                enumerable: !0,
                configurable: !0
            });
        }
    }
    return i.call(e, t, n);
}
let $a42f1354f0348298$var$ww, $a42f1354f0348298$var$Mw, $a42f1354f0348298$var$Sw, $a42f1354f0348298$var$Cw, $a42f1354f0348298$var$Tw;
function $a42f1354f0348298$var$Dw() {
    for($a42f1354f0348298$var$ww = "default", $a42f1354f0348298$var$Mw = "", $a42f1354f0348298$var$Sw = !1, $a42f1354f0348298$var$Cw = 1;;){
        $a42f1354f0348298$var$Tw = $a42f1354f0348298$var$Pw();
        const e = $a42f1354f0348298$var$Lw[$a42f1354f0348298$var$ww]();
        if (e) return e;
    }
}
function $a42f1354f0348298$var$Pw() {
    if ($a42f1354f0348298$var$mw[$a42f1354f0348298$var$_w]) return String.fromCodePoint($a42f1354f0348298$var$mw.codePointAt($a42f1354f0348298$var$_w));
}
function $a42f1354f0348298$var$Iw() {
    const e = $a42f1354f0348298$var$Pw();
    return "\n" === e ? ($a42f1354f0348298$var$vw++, $a42f1354f0348298$var$Ew = 0) : e ? $a42f1354f0348298$var$Ew += e.length : $a42f1354f0348298$var$Ew++, e && ($a42f1354f0348298$var$_w += e.length), e;
}
const $a42f1354f0348298$var$Lw = {
    default () {
        switch($a42f1354f0348298$var$Tw){
            case "\t":
            case "\v":
            case "\f":
            case " ":
            case "\xa0":
            case "\ufeff":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return void $a42f1354f0348298$var$Iw();
            case "/":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "comment");
            case void 0:
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Rw("eof");
        }
        if (!$a42f1354f0348298$var$Aw.isSpaceSeparator($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Lw[$a42f1354f0348298$var$gw]();
        $a42f1354f0348298$var$Iw();
    },
    comment () {
        switch($a42f1354f0348298$var$Tw){
            case "*":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "multiLineComment");
            case "/":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "singleLineComment");
        }
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    multiLineComment () {
        switch($a42f1354f0348298$var$Tw){
            case "*":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "multiLineCommentAsterisk");
            case void 0:
                throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        }
        $a42f1354f0348298$var$Iw();
    },
    multiLineCommentAsterisk () {
        switch($a42f1354f0348298$var$Tw){
            case "*":
                return void $a42f1354f0348298$var$Iw();
            case "/":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "default");
            case void 0:
                throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        }
        $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$ww = "multiLineComment";
    },
    singleLineComment () {
        switch($a42f1354f0348298$var$Tw){
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "default");
            case void 0:
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Rw("eof");
        }
        $a42f1354f0348298$var$Iw();
    },
    value () {
        switch($a42f1354f0348298$var$Tw){
            case "{":
            case "[":
                return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
            case "n":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("ull"), $a42f1354f0348298$var$Rw("null", null);
            case "t":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("rue"), $a42f1354f0348298$var$Rw("boolean", !0);
            case "f":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("alse"), $a42f1354f0348298$var$Rw("boolean", !1);
            case "-":
            case "+":
                return "-" === $a42f1354f0348298$var$Iw() && ($a42f1354f0348298$var$Cw = -1), void ($a42f1354f0348298$var$ww = "sign");
            case ".":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalPointLeading");
            case "0":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "zero");
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalInteger");
            case "I":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("nfinity"), $a42f1354f0348298$var$Rw("numeric", 1 / 0);
            case "N":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("aN"), $a42f1354f0348298$var$Rw("numeric", NaN);
            case '"':
            case "'":
                return $a42f1354f0348298$var$Sw = '"' === $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Mw = "", void ($a42f1354f0348298$var$ww = "string");
        }
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    identifierNameStartEscape () {
        if ("u" !== $a42f1354f0348298$var$Tw) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        $a42f1354f0348298$var$Iw();
        const e = $a42f1354f0348298$var$Fw();
        switch(e){
            case "$":
            case "_":
                break;
            default:
                if (!$a42f1354f0348298$var$Aw.isIdStartChar(e)) throw $a42f1354f0348298$var$Gw();
        }
        $a42f1354f0348298$var$Mw += e, $a42f1354f0348298$var$ww = "identifierName";
    },
    identifierName () {
        switch($a42f1354f0348298$var$Tw){
            case "$":
            case "_":
            case "\u200C":
            case "\u200D":
                return void ($a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw());
            case "\\":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "identifierNameEscape");
        }
        if (!$a42f1354f0348298$var$Aw.isIdContinueChar($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Rw("identifier", $a42f1354f0348298$var$Mw);
        $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw();
    },
    identifierNameEscape () {
        if ("u" !== $a42f1354f0348298$var$Tw) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        $a42f1354f0348298$var$Iw();
        const e = $a42f1354f0348298$var$Fw();
        switch(e){
            case "$":
            case "_":
            case "\u200C":
            case "\u200D":
                break;
            default:
                if (!$a42f1354f0348298$var$Aw.isIdContinueChar(e)) throw $a42f1354f0348298$var$Gw();
        }
        $a42f1354f0348298$var$Mw += e, $a42f1354f0348298$var$ww = "identifierName";
    },
    sign () {
        switch($a42f1354f0348298$var$Tw){
            case ".":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalPointLeading");
            case "0":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "zero");
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalInteger");
            case "I":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("nfinity"), $a42f1354f0348298$var$Rw("numeric", $a42f1354f0348298$var$Cw * (1 / 0));
            case "N":
                return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$zw("aN"), $a42f1354f0348298$var$Rw("numeric", NaN);
        }
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    zero () {
        switch($a42f1354f0348298$var$Tw){
            case ".":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalPoint");
            case "e":
            case "E":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponent");
            case "x":
            case "X":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "hexadecimal");
        }
        return $a42f1354f0348298$var$Rw("numeric", 0 * $a42f1354f0348298$var$Cw);
    },
    decimalInteger () {
        switch($a42f1354f0348298$var$Tw){
            case ".":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalPoint");
            case "e":
            case "E":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponent");
        }
        if (!$a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Rw("numeric", $a42f1354f0348298$var$Cw * Number($a42f1354f0348298$var$Mw));
        $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw();
    },
    decimalPointLeading () {
        if ($a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalFraction");
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    decimalPoint () {
        switch($a42f1354f0348298$var$Tw){
            case "e":
            case "E":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponent");
        }
        return $a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw) ? ($a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalFraction")) : $a42f1354f0348298$var$Rw("numeric", $a42f1354f0348298$var$Cw * Number($a42f1354f0348298$var$Mw));
    },
    decimalFraction () {
        switch($a42f1354f0348298$var$Tw){
            case "e":
            case "E":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponent");
        }
        if (!$a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Rw("numeric", $a42f1354f0348298$var$Cw * Number($a42f1354f0348298$var$Mw));
        $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw();
    },
    decimalExponent () {
        switch($a42f1354f0348298$var$Tw){
            case "+":
            case "-":
                return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponentSign");
        }
        if ($a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponentInteger");
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    decimalExponentSign () {
        if ($a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "decimalExponentInteger");
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    decimalExponentInteger () {
        if (!$a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Rw("numeric", $a42f1354f0348298$var$Cw * Number($a42f1354f0348298$var$Mw));
        $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw();
    },
    hexadecimal () {
        if ($a42f1354f0348298$var$Aw.isHexDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "hexadecimalInteger");
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    hexadecimalInteger () {
        if (!$a42f1354f0348298$var$Aw.isHexDigit($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Rw("numeric", $a42f1354f0348298$var$Cw * Number($a42f1354f0348298$var$Mw));
        $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw();
    },
    string () {
        switch($a42f1354f0348298$var$Tw){
            case "\\":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$Mw += function() {
                    switch($a42f1354f0348298$var$Pw()){
                        case "b":
                            return $a42f1354f0348298$var$Iw(), "\b";
                        case "f":
                            return $a42f1354f0348298$var$Iw(), "\f";
                        case "n":
                            return $a42f1354f0348298$var$Iw(), "\n";
                        case "r":
                            return $a42f1354f0348298$var$Iw(), "\r";
                        case "t":
                            return $a42f1354f0348298$var$Iw(), "\t";
                        case "v":
                            return $a42f1354f0348298$var$Iw(), "\v";
                        case "0":
                            if ($a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Aw.isDigit($a42f1354f0348298$var$Pw())) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
                            return "\0";
                        case "x":
                            return $a42f1354f0348298$var$Iw(), function() {
                                let e = "", t = $a42f1354f0348298$var$Pw();
                                if (!$a42f1354f0348298$var$Aw.isHexDigit(t)) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
                                if (e += $a42f1354f0348298$var$Iw(), t = $a42f1354f0348298$var$Pw(), !$a42f1354f0348298$var$Aw.isHexDigit(t)) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
                                return e += $a42f1354f0348298$var$Iw(), String.fromCodePoint(parseInt(e, 16));
                            }();
                        case "u":
                            return $a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Fw();
                        case "\n":
                        case "\u2028":
                        case "\u2029":
                            return $a42f1354f0348298$var$Iw(), "";
                        case "\r":
                            return $a42f1354f0348298$var$Iw(), "\n" === $a42f1354f0348298$var$Pw() && $a42f1354f0348298$var$Iw(), "";
                        case "1":
                        case "2":
                        case "3":
                        case "4":
                        case "5":
                        case "6":
                        case "7":
                        case "8":
                        case "9":
                        case void 0:
                            throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
                    }
                    return $a42f1354f0348298$var$Iw();
                }());
            case '"':
                return $a42f1354f0348298$var$Sw ? ($a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Rw("string", $a42f1354f0348298$var$Mw)) : void ($a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw());
            case "'":
                return $a42f1354f0348298$var$Sw ? void ($a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw()) : ($a42f1354f0348298$var$Iw(), $a42f1354f0348298$var$Rw("string", $a42f1354f0348298$var$Mw));
            case "\n":
            case "\r":
                throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
            case "\u2028":
            case "\u2029":
                !function(e) {
                    console.warn(`JSON5: '${$a42f1354f0348298$var$Vw(e)}' in strings is not valid ECMAScript; consider escaping`);
                }($a42f1354f0348298$var$Tw);
                break;
            case void 0:
                throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        }
        $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw();
    },
    start () {
        switch($a42f1354f0348298$var$Tw){
            case "{":
            case "[":
                return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
        }
        $a42f1354f0348298$var$ww = "value";
    },
    beforePropertyName () {
        switch($a42f1354f0348298$var$Tw){
            case "$":
            case "_":
                return $a42f1354f0348298$var$Mw = $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "identifierName");
            case "\\":
                return $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "identifierNameStartEscape");
            case "}":
                return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
            case '"':
            case "'":
                return $a42f1354f0348298$var$Sw = '"' === $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "string");
        }
        if ($a42f1354f0348298$var$Aw.isIdStartChar($a42f1354f0348298$var$Tw)) return $a42f1354f0348298$var$Mw += $a42f1354f0348298$var$Iw(), void ($a42f1354f0348298$var$ww = "identifierName");
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    afterPropertyName () {
        if (":" === $a42f1354f0348298$var$Tw) return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    beforePropertyValue () {
        $a42f1354f0348298$var$ww = "value";
    },
    afterPropertyValue () {
        switch($a42f1354f0348298$var$Tw){
            case ",":
            case "}":
                return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
        }
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    beforeArrayValue () {
        if ("]" === $a42f1354f0348298$var$Tw) return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
        $a42f1354f0348298$var$ww = "value";
    },
    afterArrayValue () {
        switch($a42f1354f0348298$var$Tw){
            case ",":
            case "]":
                return $a42f1354f0348298$var$Rw("punctuator", $a42f1354f0348298$var$Iw());
        }
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    },
    end () {
        throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
    }
};
function $a42f1354f0348298$var$Rw(e, t) {
    return {
        type: e,
        value: t,
        line: $a42f1354f0348298$var$vw,
        column: $a42f1354f0348298$var$Ew
    };
}
function $a42f1354f0348298$var$zw(e) {
    for (const t of e){
        if ($a42f1354f0348298$var$Pw() !== t) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        $a42f1354f0348298$var$Iw();
    }
}
function $a42f1354f0348298$var$Fw() {
    let e = "", t = 4;
    for(; t-- > 0;){
        const t = $a42f1354f0348298$var$Pw();
        if (!$a42f1354f0348298$var$Aw.isHexDigit(t)) throw $a42f1354f0348298$var$Ow($a42f1354f0348298$var$Iw());
        e += $a42f1354f0348298$var$Iw();
    }
    return String.fromCodePoint(parseInt(e, 16));
}
const $a42f1354f0348298$var$Uw = {
    start () {
        if ("eof" === $a42f1354f0348298$var$yw.type) throw $a42f1354f0348298$var$jw();
        $a42f1354f0348298$var$Nw();
    },
    beforePropertyName () {
        switch($a42f1354f0348298$var$yw.type){
            case "identifier":
            case "string":
                return $a42f1354f0348298$var$bw = $a42f1354f0348298$var$yw.value, void ($a42f1354f0348298$var$gw = "afterPropertyName");
            case "punctuator":
                return void $a42f1354f0348298$var$Bw();
            case "eof":
                throw $a42f1354f0348298$var$jw();
        }
    },
    afterPropertyName () {
        if ("eof" === $a42f1354f0348298$var$yw.type) throw $a42f1354f0348298$var$jw();
        $a42f1354f0348298$var$gw = "beforePropertyValue";
    },
    beforePropertyValue () {
        if ("eof" === $a42f1354f0348298$var$yw.type) throw $a42f1354f0348298$var$jw();
        $a42f1354f0348298$var$Nw();
    },
    beforeArrayValue () {
        if ("eof" === $a42f1354f0348298$var$yw.type) throw $a42f1354f0348298$var$jw();
        "punctuator" !== $a42f1354f0348298$var$yw.type || "]" !== $a42f1354f0348298$var$yw.value ? $a42f1354f0348298$var$Nw() : $a42f1354f0348298$var$Bw();
    },
    afterPropertyValue () {
        if ("eof" === $a42f1354f0348298$var$yw.type) throw $a42f1354f0348298$var$jw();
        switch($a42f1354f0348298$var$yw.value){
            case ",":
                return void ($a42f1354f0348298$var$gw = "beforePropertyName");
            case "}":
                $a42f1354f0348298$var$Bw();
        }
    },
    afterArrayValue () {
        if ("eof" === $a42f1354f0348298$var$yw.type) throw $a42f1354f0348298$var$jw();
        switch($a42f1354f0348298$var$yw.value){
            case ",":
                return void ($a42f1354f0348298$var$gw = "beforeArrayValue");
            case "]":
                $a42f1354f0348298$var$Bw();
        }
    },
    end () {}
};
function $a42f1354f0348298$var$Nw() {
    let e;
    switch($a42f1354f0348298$var$yw.type){
        case "punctuator":
            switch($a42f1354f0348298$var$yw.value){
                case "{":
                    e = {};
                    break;
                case "[":
                    e = [];
            }
            break;
        case "null":
        case "boolean":
        case "numeric":
        case "string":
            e = $a42f1354f0348298$var$yw.value;
    }
    if (void 0 === $a42f1354f0348298$var$kw) $a42f1354f0348298$var$kw = e;
    else {
        const t = $a42f1354f0348298$var$fw[$a42f1354f0348298$var$fw.length - 1];
        Array.isArray(t) ? t.push(e) : Object.defineProperty(t, $a42f1354f0348298$var$bw, {
            value: e,
            writable: !0,
            enumerable: !0,
            configurable: !0
        });
    }
    if (null !== e && "object" == typeof e) $a42f1354f0348298$var$fw.push(e), $a42f1354f0348298$var$gw = Array.isArray(e) ? "beforeArrayValue" : "beforePropertyName";
    else {
        const e = $a42f1354f0348298$var$fw[$a42f1354f0348298$var$fw.length - 1];
        $a42f1354f0348298$var$gw = null == e ? "end" : Array.isArray(e) ? "afterArrayValue" : "afterPropertyValue";
    }
}
function $a42f1354f0348298$var$Bw() {
    $a42f1354f0348298$var$fw.pop();
    const e = $a42f1354f0348298$var$fw[$a42f1354f0348298$var$fw.length - 1];
    $a42f1354f0348298$var$gw = null == e ? "end" : Array.isArray(e) ? "afterArrayValue" : "afterPropertyValue";
}
function $a42f1354f0348298$var$Ow(e) {
    return $a42f1354f0348298$var$Hw(void 0 === e ? `JSON5: invalid end of input at ${$a42f1354f0348298$var$vw}:${$a42f1354f0348298$var$Ew}` : `JSON5: invalid character '${$a42f1354f0348298$var$Vw(e)}' at ${$a42f1354f0348298$var$vw}:${$a42f1354f0348298$var$Ew}`);
}
function $a42f1354f0348298$var$jw() {
    return $a42f1354f0348298$var$Hw(`JSON5: invalid end of input at ${$a42f1354f0348298$var$vw}:${$a42f1354f0348298$var$Ew}`);
}
function $a42f1354f0348298$var$Gw() {
    return $a42f1354f0348298$var$Ew -= 5, $a42f1354f0348298$var$Hw(`JSON5: invalid identifier character at ${$a42f1354f0348298$var$vw}:${$a42f1354f0348298$var$Ew}`);
}
function $a42f1354f0348298$var$Vw(e) {
    const t = {
        "'": "\\'",
        '"': '\\"',
        "\\": "\\\\",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t",
        "\v": "\\v",
        "\0": "\\0",
        "\u2028": "\\u2028",
        "\u2029": "\\u2029"
    };
    if (t[e]) return t[e];
    if (e < " ") {
        const t = e.charCodeAt(0).toString(16);
        return "\\x" + ("00" + t).substring(t.length);
    }
    return e;
}
function $a42f1354f0348298$var$Hw(e) {
    const t = new SyntaxError(e);
    return t.lineNumber = $a42f1354f0348298$var$vw, t.columnNumber = $a42f1354f0348298$var$Ew, t;
}
const $a42f1354f0348298$var$qw = {
    parse: function(e, t) {
        $a42f1354f0348298$var$mw = String(e), $a42f1354f0348298$var$gw = "start", $a42f1354f0348298$var$fw = [], $a42f1354f0348298$var$_w = 0, $a42f1354f0348298$var$vw = 1, $a42f1354f0348298$var$Ew = 0, $a42f1354f0348298$var$yw = void 0, $a42f1354f0348298$var$bw = void 0, $a42f1354f0348298$var$kw = void 0;
        do $a42f1354f0348298$var$yw = $a42f1354f0348298$var$Dw(), $a42f1354f0348298$var$Uw[$a42f1354f0348298$var$gw]();
        while ("eof" !== $a42f1354f0348298$var$yw.type);
        return "function" == typeof t ? $a42f1354f0348298$var$xw({
            "": $a42f1354f0348298$var$kw
        }, "", t) : $a42f1354f0348298$var$kw;
    },
    stringify: function(e, t, i) {
        const n = [];
        let a, r, s, o = "", l = "";
        if (null == t || "object" != typeof t || Array.isArray(t) || (i = t.space, s = t.quote, t = t.replacer), "function" == typeof t) r = t;
        else if (Array.isArray(t)) {
            a = [];
            for (const e of t){
                let t;
                "string" == typeof e ? t = e : ("number" == typeof e || e instanceof String || e instanceof Number) && (t = String(e)), void 0 !== t && a.indexOf(t) < 0 && a.push(t);
            }
        }
        return i instanceof Number ? i = Number(i) : i instanceof String && (i = String(i)), "number" == typeof i ? i > 0 && (i = Math.min(10, Math.floor(i)), l = "          ".substr(0, i)) : "string" == typeof i && (l = i.substr(0, 10)), c("", {
            "": e
        });
        function c(e, t) {
            let i = t[e];
            switch(null != i && ("function" == typeof i.toJSON5 ? i = i.toJSON5(e) : "function" == typeof i.toJSON && (i = i.toJSON(e))), r && (i = r.call(t, e, i)), i instanceof Number ? i = Number(i) : i instanceof String ? i = String(i) : i instanceof Boolean && (i = i.valueOf()), i){
                case null:
                    return "null";
                case !0:
                    return "true";
                case !1:
                    return "false";
            }
            return "string" == typeof i ? d(i) : "number" == typeof i ? String(i) : "object" == typeof i ? Array.isArray(i) ? function(e) {
                if (n.indexOf(e) >= 0) throw TypeError("Converting circular structure to JSON5");
                n.push(e);
                let t = o;
                o += l;
                let i, a = [];
                for(let t = 0; t < e.length; t++){
                    const i = c(String(t), e);
                    a.push(void 0 !== i ? i : "null");
                }
                if (0 === a.length) i = "[]";
                else if ("" === l) i = "[" + a.join(",") + "]";
                else {
                    let e = ",\n" + o, n = a.join(e);
                    i = "[\n" + o + n + ",\n" + t + "]";
                }
                return n.pop(), o = t, i;
            }(i) : function(e) {
                if (n.indexOf(e) >= 0) throw TypeError("Converting circular structure to JSON5");
                n.push(e);
                let t = o;
                o += l;
                let i, r = a || Object.keys(e), s = [];
                for (const t of r){
                    const i = c(t, e);
                    if (void 0 !== i) {
                        let e = u(t) + ":";
                        "" !== l && (e += " "), e += i, s.push(e);
                    }
                }
                if (0 === s.length) i = "{}";
                else {
                    let e;
                    if ("" === l) e = s.join(","), i = "{" + e + "}";
                    else {
                        let n = ",\n" + o;
                        e = s.join(n), i = "{\n" + o + e + ",\n" + t + "}";
                    }
                }
                return n.pop(), o = t, i;
            }(i) : void 0;
        }
        function d(e) {
            const t = {
                "'": .1,
                '"': .2
            }, i = {
                "'": "\\'",
                '"': '\\"',
                "\\": "\\\\",
                "\b": "\\b",
                "\f": "\\f",
                "\n": "\\n",
                "\r": "\\r",
                "\t": "\\t",
                "\v": "\\v",
                "\0": "\\0",
                "\u2028": "\\u2028",
                "\u2029": "\\u2029"
            };
            let n = "";
            for(let a = 0; a < e.length; a++){
                const r = e[a];
                switch(r){
                    case "'":
                    case '"':
                        t[r]++, n += r;
                        continue;
                    case "\0":
                        if ($a42f1354f0348298$var$Aw.isDigit(e[a + 1])) {
                            n += "\\x00";
                            continue;
                        }
                }
                if (i[r]) n += i[r];
                else {
                    if (r < " ") {
                        let e = r.charCodeAt(0).toString(16);
                        n += "\\x" + ("00" + e).substring(e.length);
                        continue;
                    }
                    n += r;
                }
            }
            const a = s || Object.keys(t).reduce((e, i)=>t[e] < t[i] ? e : i);
            return n = n.replace(new RegExp(a, "g"), i[a]), a + n + a;
        }
        function u(e) {
            if (0 === e.length) return d(e);
            const t = String.fromCodePoint(e.codePointAt(0));
            if (!$a42f1354f0348298$var$Aw.isIdStartChar(t)) return d(e);
            for(let i = t.length; i < e.length; i++)if (!$a42f1354f0348298$var$Aw.isIdContinueChar(String.fromCodePoint(e.codePointAt(i)))) return d(e);
            return e;
        }
    }
};
var $a42f1354f0348298$var$Kw = $a42f1354f0348298$var$qw;
const $a42f1354f0348298$var$Ww = new CSSStyleSheet;
$a42f1354f0348298$var$Ww.replaceSync("/* atkinson-hyperlegible-next-latin-ext-400-normal */\n@font-face {\n  font-family: 'Atkinson Hyperlegible Next';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(/fonts/atkinson-hyperlegible-next-latin-ext-400-normal.woff2) format('woff2'), url(/fonts/atkinson-hyperlegible-next-latin-ext-400-normal.woff) format('woff');\n  unicode-range: U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;\n}\n\n/* atkinson-hyperlegible-next-latin-400-normal */\n@font-face {\n  font-family: 'Atkinson Hyperlegible Next';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(/fonts/atkinson-hyperlegible-next-latin-400-normal.woff2) format('woff2'), url(/fonts/atkinson-hyperlegible-next-latin-400-normal.woff) format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}");
const $a42f1354f0348298$var$Xw = new CSSStyleSheet;
$a42f1354f0348298$var$Xw.replaceSync('/* Colors */\n:root, :host {\n\t--white: #ffffff;\n\t--black: #181818;\n\t--black-pale: #1b1a17;\n\t--red: #f70000;\n\t--red-transparent: rgba(247, 0, 0, 0.3);\n\t--red-pale: #ff726f;\n\t--grey: #f5f5f5;\n\t--grey-very-pale: #e6e6e6;\n\t--grey-pale: #cfd2cf;\n\t--grey-semi-dark: #808080;\n\t--grey-dark: #3e3e3e;\n\t--blue: #2954e9;\n\t--blue-dark: #0a1f69;\n\t--blue-semi: #d7dffc;\n\t--blue-pale: #f2f5ff;\n\t--blue-geovisio: #34495e;\n\t--beige: #f5f3ec;\n\t--yellow: #fec868;\n\t--orange: #ff6f00;\n\t--orange-transparent: rgba(255,111,0,0.3);\n\t--orange-pale: #fffafa;\n\t--green: #7ec636;\n\t--green-pale: #f0ffee;\n\t--widget-bg: var(--white);\n\t--widget-bg-hover: var(--grey);\n\t--widget-bg-active: var(--blue);\n\t--widget-bg-inactive: var(--grey-pale);\n\t--widget-bg-primary: var(--blue-semi);\n\t--widget-bg-primary-hover: #e0e7ff;\n\t--widget-bg-warn: #FFECB3;\n\t--widget-bg-danger: #FFCDD2;\n\t--widget-bg-success: #C8E6C9;\n\t--widget-border-div: var(--grey-pale);\n\t--widget-border-btn: var(--blue);\n\t--widget-font: var(--grey-dark);\n\t--widget-font-active: var(--white);\n\t--widget-font-direct: var(--blue);\n\t--widget-font-warn: #BF360C;\n\t--widget-font-danger: #B71C1C;\n\t--widget-font-success: #1B5E20;\n\t--font-family: "Atkinson Hyperlegible Next", sans-serif;\n\t--widget-option-left: #6A1B9A;\n\t--widget-option-right: #0D47A1;\n\toverscroll-behavior-y: contain;\n}\n\n.pnx-hidden { display: none !important; }\n\n/* Hidden elements on mobile */\n@container (max-width: 576px) {\n\t.pnx-mobile-hidden { display: none !important; }\n}\n\n/* Hidden elements on print */\n@media print {\n\t.pnx-print-hidden { display: none !important; }\n}\n'), document.adoptedStyleSheets.push($a42f1354f0348298$var$Ww), document.adoptedStyleSheets.push($a42f1354f0348298$var$Xw);
class $a42f1354f0348298$var$Qw extends $a42f1354f0348298$var$le {
    static properties = {
        picture: {
            type: String,
            reflect: !0
        },
        sequence: {
            type: String,
            reflect: !0
        },
        "fetch-options": {
            converter: $a42f1354f0348298$var$Qw.GetJSONConverter()
        },
        lang: {
            type: String
        },
        endpoint: {
            type: String
        }
    };
    constructor(e = !1){
        super(), this.lang = this.getAttribute("lang") || null, this.endpoint = this.getAttribute("endpoint") || null, this.picture = this.getAttribute("picture") || null, this.sequence = this.getAttribute("sequence") || null, console.info(`\u{1F4F7} Panoramax ${this.getClassName()} - Version 5.3.1 (d2eaa71)

\u{1F198} Issues can be reported at https://gitlab.com/panoramax/clients/web-viewer/-/work_items`), e || (this._isInternetFast = null, $a42f1354f0348298$var$Ao().then((e)=>this._isInternetFast = e));
    }
    connectedCallback() {
        super.connectedCallback(), this._t = $a42f1354f0348298$var$Tx(this.lang), this.loader = $a42f1354f0348298$var$Rr("pnx-loader", {
            _parent: this,
            "no-label": $a42f1354f0348298$var$ho()
        }), this._loadsAPI && this.endpoint && this._loadsAPI === this.endpoint || this.api && this.api._endpoint === this.endpoint || !this.endpoint || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI()), Object.entries({
            map: "map-options",
            psv: "psv-options",
            fetchOptions: "fetch-options",
            mapstyle: "map-style"
        }).forEach(([e, t])=>{
            this.getAttribute(e) && console.error(`Component attribute "${e}" has been renamed into "${t}". Old attribute "${e}" is ignored.`);
        }), $a42f1354f0348298$var$ho() && this.classList.add("pnx-iframed");
    }
    _setupAPI() {
        if (this.loader = this.loader || $a42f1354f0348298$var$Rr("pnx-loader", {
            _parent: this
        }), !this.endpoint) return void console.warn("No endpoint is defined");
        this._loadsAPI = this.endpoint;
        let e = this.endpoint;
        try {
            this.api = new $a42f1354f0348298$var$hw(this.endpoint, {
                fetch: this["fetch-options"]
            }), this.api.onceReady().then(()=>{
                if (e !== this._loadsAPI || !this.api) return;
                let t = this.api.getUnavailableFeatures(), i = this.api.getAvailableFeatures();
                i = 0 === t.length ? "\u2705 All features available" : "\u2705 Available features: " + i.join(", "), t = 0 === t.length ? "" : "\uD83D\uDEAB Unavailable features: " + t.join(", "), console.info(`\u{1F310} Connected to API "${this.api._metadata.name}" (${this.api._endpoint})
\u{2139}\u{FE0F} API runs STAC ${this.api._metadata.stac_version} ${this.api._metadata.geovisio_version ? "& GeoVisio " + this.api._metadata.geovisio_version : ""}\n   ${i}\n   ${t}\n`.trim());
            }).catch((e)=>this.loader?.dismiss?.(e, this._t?.pnx.error_api)).finally(()=>delete this._loadsAPI);
        } catch (e) {
            delete this._loadsAPI, this.loader?.dismiss ? this.loader.dismiss(e, this._t.pnx.error_api) : console.error(e);
        }
    }
    onceReady() {
        throw new Error("You must override this method on sub-class");
    }
    onceAPIReady() {
        return this.api ? this.api.onceReady() : new Promise((e)=>setTimeout(e, 250)).then(this.onceAPIReady.bind(this));
    }
    createRenderRoot() {
        return this;
    }
    attributeChangedCallback(e, t, i) {
        if (super.attributeChangedCallback(e, t, i), "endpoint" === e && (this._loadsAPI && i && this._loadsAPI === i || this.api && this.api._endpoint === i || !i || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI())), [
            "picture",
            "sequence"
        ].includes(e)) {
            let n, a, r, s;
            "picture" === e ? (n = this.sequence, r = this.sequence, a = i, s = t) : (n = i, r = t, a = this.picture, s = this.picture), this.dispatchEvent(new CustomEvent("select", {
                bubbles: !0,
                composed: !0,
                detail: {
                    seqId: n,
                    picId: a,
                    prevSeqId: r,
                    prevPicId: s
                }
            }));
        }
    }
    getClassName() {
        return "Basic";
    }
    select(e = null, t = null, i = !1) {
        i && (this.picture = null, this.sequence = null), this.picture = t, this.sequence = e;
    }
    isWidthSmall() {
        return this?.offsetWidth < 576;
    }
    isWidthMedium() {
        return this?.offsetWidth >= 576 && this?.offsetWidth < 768;
    }
    isHeightSmall() {
        return this?.offsetHeight < 400;
    }
    render() {
        return $a42f1354f0348298$var$V`<p>Should not be used directly, use Viewer/CoverageMap/Editor instead</p>`;
    }
    getSubComponentsNames() {
        return [
            "loader",
            "api"
        ];
    }
    getAPI() {
        return this.api;
    }
    addEventListener(e, t, i) {
        let n = e.split(":").shift();
        if (n && this.getSubComponentsNames().includes(n)) {
            const a = e.substring(n.length + 1);
            this[n]?.addEventListener ? this[n].addEventListener(a, t, i) : setTimeout(()=>this.addEventListener(e, t, i), 50);
        } else super.addEventListener(e, t, i);
    }
    static GetJSONConverter() {
        return {
            fromAttribute: (e)=>null == e || "" === e ? null : "object" == typeof e || Array.isArray(e) ? e : $a42f1354f0348298$var$Kw.parse(e),
            toAttribute: (e)=>null == e || "" === e ? "" : "string" == typeof e ? e : $a42f1354f0348298$var$Kw.stringify(e)
        };
    }
}
class $a42f1354f0348298$var$Zw extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Ro,
        $a42f1354f0348298$var$s`
		textarea:invalid {
			border: 2px solid var(--red);
			background-color:var(--beige);
		}
	`
    ];
    static properties = {
        semantics: {
            converter: $a42f1354f0348298$var$Qw.GetJSONConverter(),
            reflect: !0
        },
        rows: {
            type: Number
        },
        _valid: {
            state: !0
        },
        _t: {
            converter: $a42f1354f0348298$var$Qw.GetJSONConverter()
        },
        _firstSemantics: {
            state: !0
        }
    };
    constructor(){
        super(), this.semantics = null, this._valid = !0, this._firstSemantics = null, this.rows = 3;
    }
    connectedCallback() {
        super.connectedCallback(), this._firstSemantics = null === this.semantics ? [] : $a42f1354f0348298$var$Kw.parse($a42f1354f0348298$var$Kw.stringify(this.semantics));
    }
    getDiff() {
        return $a42f1354f0348298$var$Vx(this._firstSemantics || [], this.semantics);
    }
    checkValidity() {
        return this._valid;
    }
    reportValidity() {
        this.renderRoot.querySelector("textarea")?.reportValidity();
    }
    reset(e = null) {
        this.semantics = null, this._valid = !0;
        const t = this.renderRoot.querySelector("textarea");
        t?.setCustomValidity(""), t?.reportValidity(), this._firstSemantics = e, this.semantics = e;
    }
    forceInput() {
        const e = this.renderRoot.querySelector("textarea");
        this._onInput({
            target: e
        }), this._onBlur({
            target: e
        });
    }
    _onInput(e) {
        const t = e.target;
        try {
            this.semantics = $a42f1354f0348298$var$jx(t.value) || [], this._valid = !0;
        } catch (e) {
            "Invalid tags" !== e.message && console.error(e), this._valid = !1;
        }
    }
    _onBlur(e) {
        const t = e.target.checkValidity();
        this._valid ? (e.target.setCustomValidity(""), this.dispatchEvent(new CustomEvent("change", {
            detail: {
                semantics: this.semantics || [],
                delta: $a42f1354f0348298$var$Vx(this._firstSemantics || [], this.semantics)
            }
        }))) : t && (e.target.setCustomValidity(this._t?.pnx.semantics_editor_error || "Invalid syntax"), e.target.reportValidity());
    }
    render() {
        return $a42f1354f0348298$var$V`
			<textarea
				part="text"
				autocomplete="off"
				autocorrect="off"
				autocapitalize="off"
				spellcheck="false"
				placeholder=${this._t?.pnx.semantics_editor_example || "key1=value1\nprefix|key2=value2"}
				@input=${this._onInput}
  				@blur=${this._onBlur}
				rows=${this.rows}
				.value=${$a42f1354f0348298$var$Gx(this.semantics)}
			></textarea>
		`;
    }
}
customElements.define("pnx-semantics-editor", $a42f1354f0348298$var$Zw);
class $a42f1354f0348298$var$Yw extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Vo,
        $a42f1354f0348298$var$s`
		:host { display: block; }
		th:first-child, td:first-child { width: 40%; }
		td { vertical-align: top; }

		td small { color: var(--grey-semi-dark); }
		td a small { color: unset; }
		.qualifiers { margin-top: 5px; }
		.qualifiers > b { margin: 8px 0; }
		.qualifiers ul {
			list-style: none;
			margin: 0px 0px 0px 15px;
			padding: 0;
		}

		img.prefix-logo {
			max-width: 15px;
			max-height: 15px;
			aspect-ratio: 1;
			vertical-align: middle;
		}
	`
    ];
    static properties = {
        source: {
            type: Object
        }
    };
    render() {
        if (!this.source) return $a42f1354f0348298$var$q;
        const e = $a42f1354f0348298$var$Hx(this.source.semantics);
        return $a42f1354f0348298$var$V`<table>
			<thead>
				<tr><th>${this._t.pnx.semantics_key}</th><th>${this._t.pnx.semantics_value}</th></tr>
			</thead>
			<tbody>
				${e.map((e)=>e.tags.map((t)=>$a42f1354f0348298$var$V`
					<tr>
						<td>
							${"" !== e.prefix ? e.logo ? $a42f1354f0348298$var$V`<img src=${e.logo} class="prefix-logo" alt=${e.prefix} title=${e.title} />` : $a42f1354f0348298$var$V`<small>(${e.prefix})</small>` : $a42f1354f0348298$var$q}
							${e.key_transform ? e.key_transform(t, this._t) : t.key}
						</td>
						<td>
							${e.value_transform ? e.value_transform(t, this._t) : t.value}
							${t.qualifiers ? $a42f1354f0348298$var$V`<div class="qualifiers">
								<b>${this._t.pnx.semantics_qualifiers}</b>
								<ul>
									${t.qualifiers.map((e)=>$a42f1354f0348298$var$V`<li>${e.subkey} = ${e.value}</li>`)}
								</ul>
							</div>` : $a42f1354f0348298$var$q}
						</td>
					</tr>
				`))}
			</tbody>
		</table>`;
    }
}
customElements.define("pnx-semantics-table", $a42f1354f0348298$var$Yw);
class $a42f1354f0348298$var$Jw extends $a42f1354f0348298$var$le {
    static styles = $a42f1354f0348298$var$s`
		.toggle {
			cursor: pointer;
			display: inline-block;
		}

		.toggle-switch {
			display: inline-block;
			background: #ccc;
			border-radius: 11px;
			width: 42px;
			height: 22px;
			position: relative;
			vertical-align: middle;
			transition: background 0.25s;
		}
		.toggle-switch:before, .toggle-switch:after {
			content: "";
		}
		.toggle-switch:before {
			display: block;
			background: linear-gradient(to bottom, #fff 0%, #eee 100%);
			border-radius: 50%;
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
			width: 16px;
			height: 16px;
			position: absolute;
			top: 3px;
			left: 3px;
			transition: left 0.25s;
		}
		.toggle:hover .toggle-switch:before {
			background: linear-gradient(to bottom, #fff 0%, #fff 100%);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
		}
		.toggle-checkbox:checked + .toggle-switch {
			background: var(--widget-bg-active);
		}
		.toggle-checkbox:disabled + .toggle-switch:before,
		.toggle-checkbox:disabled:hover + .toggle-switch:before {
			background: var(--grey-pale);
			box-shadow: none;
		}
		.toggle-checkbox:disabled + .toggle-switch {
			background: var(--grey);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
		}
		.toggle-checkbox:checked + .toggle-switch:before {
			left: 23px;
		}

		.toggle-checkbox {
			position: absolute;
			visibility: hidden;
		}

		.toggle-label {
			margin-left: 5px;
			position: relative;
			top: 2px;
		}
	`;
    static properties = {
        checked: {
            type: Boolean,
            reflect: !0
        },
        disabled: {
            type: Boolean,
            reflect: !0
        },
        name: {
            type: String
        }
    };
    constructor(){
        super(), this.checked = !1, this.disabled = !1, this.name = "pnx-switch-1";
    }
    _onChange(e) {
        this.checked = e.target.checked, this.dispatchEvent(new Event("change"));
    }
    render() {
        return $a42f1354f0348298$var$V`
			<label class="toggle" for=${this.name}>
				<input
					class="toggle-checkbox"
					type="checkbox"
					id=${this.name}
					name=${this.name}
					.checked=${this.checked}
					.disabled=${this.disabled}
					@change=${this._onChange}
				/>
				<div class="toggle-switch"></div>
				<span class="toggle-label">
					<slot></slot>
				</span>
			</label>
		`;
    }
}
customElements.define("pnx-switch", $a42f1354f0348298$var$Jw);
class $a42f1354f0348298$var$$w extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Po,
        $a42f1354f0348298$var$s`
		div.container {
			position: relative;
			height: 100%;
		}

		.pnx-panel { z-index: 130; }
		.pnx-panel-fixed { position: fixed; }

		.pnx-panel.pnx-panel-nobg {
			border: none;
			background: none;
		}
	`
    ];
    static properties = {
        _opened: {
            state: !0
        },
        padded: {
            type: String
        },
        nobg: {
            type: Boolean
        },
        "over-button": {
            type: Boolean
        }
    };
    constructor(){
        super(), this._opened = !1;
    }
    open() {
        this._opened = !0, this._parent?.dispatchEvent(new CustomEvent("menu-opened", {
            detail: {
                menu: this
            }
        })), this.adjustMenuPosition(this._btn), this._chevron && (this._chevron.style.rotate = "180deg");
    }
    close() {
        this._opened && (this._opened = !1, this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
            detail: {
                menu: this
            }
        })), this._chevron && (this._chevron.style.rotate = ""));
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$zr(this, this.close.bind(this));
    }
    handleButtonSlotChange(e) {
        this._btn = e.target.assignedNodes().pop(), this._btn && (this._chevron = this._btn.querySelector("svg.fa-chevron-down"), this._chevron && (this._chevron.style.transition = "rotate 0.2s", this._chevron.style.rotate = this._opened ? "180deg" : ""), this._btn.addEventListener("click", ()=>{
            this._opened ? this.close() : this.open();
        }));
    }
    adjustMenuPosition(e) {
        const t = this.shadowRoot.querySelector("div[part='menu']");
        t.style.top = null, t.style.bottom = null, t.style.right = null, t.style.left = null, t.style.overflowY = null, t.style.marginTop = null;
        const i = e.getBoundingClientRect();
        let n = t.getBoundingClientRect();
        const a = n.right <= window.innerWidth - 10, r = n.bottom <= window.innerHeight - 10;
        a && r ? t.style.top = this["over-button"] ? `${i.top}px` : `${i.bottom + 5}px` : a || r ? r ? a || (this["over-button"] ? t.style.top = `${i.top}px` : t.style.marginTop = "5px", t.style.right = window.innerWidth - i.right + "px") : (t.style.bottom = "10px", t.style.top = this["over-button"] ? `${i.top}px` : `${i.bottom + 5}px`, t.style.overflowY = "auto") : (t.style.right = this["over-button"] ? window.innerWidth - i.right + "px" : window.innerWidth - i.left + 5 + "px", t.style.bottom = window.innerHeight - i.bottom + "px", n = t.getBoundingClientRect(), n.top - 10 < 0 && (t.style.bottom = "10px", t.style.top = `${i.top}px`, t.style.overflowY = "auto"));
    }
    render() {
        const e = {
            "pnx-panel": !0,
            "pnx-panel-fixed": !0,
            "pnx-panel-nobg": this.nobg,
            "pnx-hidden": !this._opened,
            "pnx-padded": "false" !== this.padded
        };
        return $a42f1354f0348298$var$V`<div class="container" @click=${(e)=>e.stopPropagation()}>
			<slot name="button" @slotchange=${this.handleButtonSlotChange}></slot>
			<div class=${$a42f1354f0348298$var$he(e)} part="menu">
				<slot></slot>
			</div>
		</div>`;
    }
}
customElements.define("pnx-togglable-group", $a42f1354f0348298$var$$w);
class $a42f1354f0348298$var$eM extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$No,
        $a42f1354f0348298$var$s`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
    ];
    static properties = {
        gps: {
            type: Array
        }
    };
    render() {
        const e = $a42f1354f0348298$var$co(this.gps[0]), t = e.d < 0 ? `${Math.abs(e.d)}\xb0${e.m}'${e.s}"W` : `${e.d}\xb0${e.m}'${e.s}"E`, i = $a42f1354f0348298$var$co(this.gps[1]), n = i.d < 0 ? `${Math.abs(i.d)}\xb0${i.m}'${i.s}"S` : `${i.d}\xb0${i.m}'${i.s}"N`, a = {
            ddeclatlon: `${this.gps[1].toFixed(5)}, ${this.gps[0].toFixed(5)}`,
            ddeclonlat: `${this.gps[0].toFixed(5)}, ${this.gps[1].toFixed(5)}`,
            ddmslonlat: `${t}, ${n}`,
            ddmslatlon: `${n}, ${t}`
        };
        return $a42f1354f0348298$var$V`<pnx-button-group style="display: inline-block; vertical-align: baseline" dir="row">
			<pnx-copy-button
				size="sm"
				text=${a.ddeclonlat}
				title=${this._parent?._t.pnx.metadata_location_copy.replace("{v}", a.ddeclonlat)}
			></pnx-copy-button>

			<pnx-togglable-group padded="false" ._parent=${this._parent}>
				<pnx-button
					size="sm"
					slot="button"
					title=${this._parent?._t.pnx.metadata_location_copy_more}
				>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Ms)}</pnx-button>
				<pnx-list-group>
					${Object.values(a).map((e)=>$a42f1354f0348298$var$V`
						<pnx-copy-button unstyled text=${e} ._t=${this._parent._t}>
							${this._parent?._t.pnx.metadata_location_copy.replace("{v}", e)}
						</pnx-copy-button>
					`)}
				</pnx-list-group>
			</pnx-togglable-group>
		</pnx-button-group>`;
    }
}
customElements.define("pnx-copy-coordinates", $a42f1354f0348298$var$eM);
class $a42f1354f0348298$var$tM extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Po,
        $a42f1354f0348298$var$s`
		:host {
			pointer-events: none;
		}
		.pnx-panel[part="panel"] {
			border-radius: 10px;
			position: relative;
			max-width: 450px;
			z-index: 121; /* To appear above mini component */
			min-width: unset;
			pointer-events: auto;
		}
		.pnx-panel[part="panel"].pnx-padded {
			padding: 10px;
			width: 250px;
		}
		.presentation {
			font-size: 0.85em;
			line-height: 1em;
			display: flex;
			gap: 5px;
			align-items: center;
		}
		.logo {
			width: 45px;
		}
		pnx-map-legend {
			display: block;
			margin-top: 5px;
		}

		/* Lighter/smaller version */
		.pnx-panel[part="panel"].pnx-legend-light {
			display: flex;
			gap: 3px;
			padding: 3px 8px 3px 3px;
			width: unset;
			min-width: unset;
			align-items: center;
			font-size: 10px;
			margin-right: -10px;
			margin-bottom: -10px;
			border-radius: 0;
			border-top-left-radius: 5px;
			border-right: none;
  			border-bottom: none;
		}
		.pnx-legend-light a,
		.pnx-legend-light .presentation {
			font-size: 10px;
		}
		.pnx-legend-light .logo {
			width: 15px;
		}

		.pnx-legend-light pnx-map-legend {
			width: max-content;
			margin-top: unset;
			font-size: 10px;
		}
	`
    ];
    static properties = {
        focus: {
            type: String
        },
        picture: {
            type: String
        },
        light: {
            type: Boolean
        }
    };
    constructor(){
        super(), this.light = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this.requestUpdate());
    }
    render() {
        const e = {
            "pnx-panel": !0,
            "pnx-padded": "map" === this.focus,
            "pnx-legend-light": this.light
        }, t = $a42f1354f0348298$var$$s("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Calque_1' x='0px' y='0px' width='343.25757mm' height='343.25757mm' viewBox='0 0 1297.3515 1297.3513' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/'%3e%3cmetadata id='metadata118'%3e%3crdf:RDF%3e%3ccc:Work rdf:about=''%3e%3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e%3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage'/%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs id='defs72'%3e%3crect x='1150.3843' y='2292.8162' width='2107.8879' height='701.88715' id='rect141823'/%3e%3crect x='411.88269' y='1261.6108' width='815.34668' height='181.92911' id='rect66775'/%3e%3crect x='253.02008' y='1213.0352' width='2209.7197' height='583.65765' id='rect60279'/%3e%3crect x='1150.3843' y='2292.8162' width='2551.0081' height='701.39136' id='rect141823-1'/%3e%3clinearGradient y2='62.288601' x2='248.6918' y1='231.7114' x1='346.50821' gradientUnits='userSpaceOnUse' id='SVGID_1_' gradientTransform='matrix(6.6326761%2c0%2c0%2c6.6326761%2c-1221.4079%2c-713.64667)'%3e %3cstop id='stop4' style='stop-color:%238F2A85' offset='0'/%3e %3cstop id='stop6' style='stop-color:%232570B6' offset='1'/%3e %3c/linearGradient%3e%3c/defs%3e%3cstyle type='text/css' id='style2'%3e .st0%7bfill:url(%23SVGID_1_)%3b%7d .st1%7bfill:white%3b%7d .st2%7bdisplay:none%3bfill:none%3bstroke:%23E62054%3bstroke-width:7.5%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3ctext y='-2248.8188' style='font-style:normal%3bfont-weight:normal%3bfont-size:40px%3bline-height:125%25%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect60279)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text60277' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3ctext y='-4324.1934' x='304.06815' style='font-style:normal%3bfont-weight:normal%3bfont-size:89.8058px%3bline-height:200%25%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect66775)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:2.24515px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text66773' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3ctext y='-2248.5173' x='-121.66869' style='font-style:normal%3bfont-weight:normal%3bfont-size:40px%3bline-height:0%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect141823)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text141821' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3ctext y='-3181.1731' x='-158.83984' style='font-style:normal%3bfont-weight:normal%3bfont-size:40px%3bline-height:0%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect141823-1)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text141821-0' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path49' d='m 1065.871%2c503.42011 c -19.2347%2c0 -35.1531%2c-15.91842 -35.1531%2c-35.15318 V 334.28687 H 870.87032 c -19.23476%2c0 -35.15319%2c-15.91842 -35.15319%2c-35.15318 0%2c-19.23476 15.91843%2c-35.15319 35.15319%2c-35.15319 H 1065.871 c 19.2348%2c0 35.1532%2c15.91843 35.1532%2c35.15319 v 169.13324 c 0.6633%2c19.23476 -15.2551%2c35.15318 -35.1532%2c35.15318 z' class='st2'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path53' d='M 426.48102%2c1032.7077 H 231.48034 c -19.23476%2c0 -35.15318%2c-15.9185 -35.15318%2c-35.15322 V 828.42124 c 0%2c-19.23476 15.91842%2c-35.15318 35.15318%2c-35.15318 19.23476%2c0 35.15318%2c15.91842 35.15318%2c35.15318 v 133.31679 h 159.8475 c 19.23476%2c0 35.15318%2c15.91842 35.15318%2c35.15318 0%2c19.23479 -15.25515%2c35.81649 -35.15318%2c35.81649 z' class='st2'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path57' d='m 231.48034%2c503.42011 c -19.23476%2c0 -35.15318%2c-15.91842 -35.15318%2c-35.15318 V 299.13369 c 0%2c-19.23476 15.91842%2c-35.15319 35.15318%2c-35.15319 h 195.00068 c 19.23476%2c0 35.15318%2c15.91843 35.15318%2c35.15319 0%2c19.23476 -15.91842%2c35.15318 -35.15318%2c35.15318 h -159.8475 v 133.31679 c 0.66327%2c19.89803 -15.25515%2c35.81645 -35.15318%2c35.81645 z' class='st2'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path61' d='M 1065.871%2c1032.7077 H 870.87032 c -19.23476%2c0 -35.15319%2c-15.9185 -35.15319%2c-35.15322 0%2c-19.23476 15.91843%2c-35.15318 35.15319%2c-35.15318 H 1030.7179 V 829.08451 c 0%2c-19.23476 15.9184%2c-35.15319 35.1531%2c-35.15319 19.2348%2c0 35.1532%2c15.91843 35.1532%2c35.15319 v 169.13324 c 0.6633%2c18.57145 -15.2551%2c34.48995 -35.1532%2c34.48995 z' class='st2'/%3e%3cg id='g1' transform='translate(-103.80084%2c387.319)'%3e%3ccircle style='fill:url(%23SVGID_1_)%3bstroke-width:6.63268' id='circle9' r='648.67572' cy='261.35672' cx='752.47656' class='st0'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path11' d='m 465.28163%2c199.67283 c -0.66327%2c0 -1.32653%2c0 -1.9898%2c0 l -36.47972%2c-10.61228 c -2.65307%2c-0.66327 -4.64287%2c-3.31634 -4.64287%2c-6.63268 v -49.0818 c 0%2c-1.9898 1.32653%2c-3.97961 2.65307%2c-5.30614 1.9898%2c-1.32654 3.9796%2c-1.32654 5.96941%2c-0.66327 l 36.47972%2c13.26535 c 2.65307%2c0.66327 4.64287%2c3.31634 4.64287%2c5.96941 v 46.42873 c 0%2c1.98981 -0.66327%2c3.97961 -2.65307%2c5.30614 -1.32654%2c0.66327 -2.65307%2c1.32654 -3.97961%2c1.32654 z m -29.84704%2c-22.5511 23.21437%2c6.63268 v -33.16338 l -23.21437%2c-8.62248 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path13' d='m 465.28163%2c292.53029 c -0.66327%2c0 -0.66327%2c0 -1.32653%2c0 l -36.47972%2c-7.95921 c -3.31634%2c-0.66326 -5.30614%2c-3.31633 -5.30614%2c-6.63267 V 228.8566 c 0%2c-1.9898 0.66327%2c-3.9796 2.65307%2c-5.30614 1.32653%2c-1.32653 3.9796%2c-1.9898 5.96941%2c-1.32653 l 36.47972%2c9.28574 c 2.65307%2c0.66327 5.30614%2c3.31634 5.30614%2c6.63268 v 47.75527 c 0%2c1.9898 -0.66327%2c3.9796 -2.65307%2c5.30614 -1.98981%2c0.66327 -3.31634%2c1.32653 -4.64288%2c1.32653 z m -29.84704%2c-19.89802 23.21437%2c5.30614 v -34.48992 l -23.21437%2c-5.96941 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path15' d='m 525.63898%2c306.45891 c -0.66326%2c0 -1.32653%2c0 -1.32653%2c0 l -36.47972%2c-8.62247 c -3.31634%2c-0.66327 -5.30614%2c-3.31634 -5.30614%2c-6.63268 v -48.41854 c 0%2c-1.9898 0.66327%2c-3.9796 2.65307%2c-5.30614 1.9898%2c-1.32653 3.97961%2c-1.9898 5.96941%2c-1.32653 l 36.47972%2c9.28574 c 2.65307%2c0.66327 5.30614%2c3.31634 5.30614%2c6.63268 v 47.75527 c 0%2c1.9898 -0.66327%2c3.9796 -2.65307%2c5.30614 -1.9898%2c0.66327 -3.31634%2c1.32653 -4.64288%2c1.32653 z m -29.84704%2c-20.56129 23.21437%2c5.30614 v -34.48992 l -23.21437%2c-5.96941 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path17' d='m 609.87397%2c285.23435 c -0.66327%2c0 -1.32653%2c0 -1.9898%2c0 l -43.1124%2c-14.59189 c -2.65307%2c-0.66326 -3.9796%2c-3.31633 -3.9796%2c-5.30614 v -30.51031 c 0%2c-1.9898 0.66327%2c-3.9796 2.65307%2c-4.64287 1.32653%2c-1.32654 3.31634%2c-1.32654 5.30614%2c-0.66327 l 43.11239%2c15.91842 c 1.98981%2c0.66327 3.97961%2c3.31634 3.97961%2c5.30614 v 29.18378 c 0%2c1.9898 -0.66327%2c3.31634 -2.65307%2c4.64287 -0.66327%2c0 -1.9898%2c0.66327 -3.31634%2c0.66327 z m -37.14298%2c-24.5409 31.83684%2c10.61228 v -17.24496 l -31.83684%2c-11.93881 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path19' d='m 638.39448%2c350.23458 c -0.66327%2c0 -0.66327%2c0 -1.32654%2c0 l -41.78586%2c-9.94902 c -2.65307%2c-0.66327 -4.64287%2c-2.65307 -4.64287%2c-5.30614 v -31.17358 c 0%2c-1.9898 0.66327%2c-3.31633 1.9898%2c-4.64287 1.32654%2c-1.32653 3.31634%2c-1.32653 5.30614%2c-0.66327 l 41.78586%2c11.27555 c 2.65307%2c0.66327 3.97961%2c2.65307 3.97961%2c5.30614 v 29.84705 c 0%2c1.9898 -0.66327%2c3.31633 -1.9898%2c4.64287 -0.66327%2c0 -1.98981%2c0.66327 -3.31634%2c0.66327 z m -35.81645%2c-20.5613 30.51031%2c7.29594 V 319.061 l -30.51031%2c-7.95921 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path21' d='m 525.63898%2c218.24432 c -0.66326%2c0 -1.32653%2c0 -1.9898%2c0 l -37.14298%2c-9.94901 c -2.65307%2c-0.66327 -4.64288%2c-3.31634 -4.64288%2c-6.63268 v -49.0818 c 0%2c-1.9898 1.32654%2c-3.97961 2.65307%2c-5.30614 1.98981%2c-1.32654 3.97961%2c-1.32654 5.96941%2c-0.66327 l 37.14299%2c13.26535 c 2.65307%2c0.66327 4.64287%2c3.31634 4.64287%2c5.96941 v 45.76547 c 0%2c1.9898 -0.66327%2c3.9796 -2.65307%2c5.30614 -1.32653%2c0.66326 -2.65307%2c1.32653 -3.97961%2c1.32653 z m -30.51031%2c-21.88783 23.87764%2c6.63268 v -32.50012 l -23.87764%2c-8.62247 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path23' d='m 690.79262%2c356.86725 c -8.62248%2c0 -15.25516%2c-7.95921 -15.25516%2c-17.24496 0%2c-9.28574 6.63268%2c-17.24495 15.25516%2c-17.24495 8.62248%2c0 15.25515%2c7.95921 15.25515%2c17.24495 0%2c9.28575 -6.63267%2c17.24496 -15.25515%2c17.24496 z m 0%2c-25.20417 c -3.31634%2c0 -5.96941%2c3.31634 -5.96941%2c7.95921 0%2c4.64288 2.65307%2c7.95922 5.96941%2c7.95922 3.31634%2c0 5.96941%2c-3.31634 5.96941%2c-7.95922 0%2c-4.64287 -2.65307%2c-7.95921 -5.96941%2c-7.95921 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path25' d='m 1041.6612%2c199.67283 c -1.3265%2c0 -2.6531%2c-0.66327 -3.9796%2c-1.32654 -1.9898%2c-1.32653 -2.6531%2c-3.31633 -2.6531%2c-5.30614 v -46.42873 c 0%2c-2.65307 1.9898%2c-5.30614 4.6429%2c-5.96941 l 36.4797%2c-13.26535 c 1.9898%2c-0.66327 3.9796%2c-0.66327 5.9694%2c0.66327 1.9898%2c1.32653 2.6531%2c3.31634 2.6531%2c5.30614 v 49.0818 c 0%2c2.65307 -1.9898%2c5.30614 -4.6429%2c6.63268 l -36.4797%2c10.61228 c -0.6633%2c0 -1.3265%2c0 -1.9898%2c0 z m 6.6327%2c-48.41854 v 33.16338 l 23.2143%2c-6.63267 v -34.48992 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path27' d='m 1041.6612%2c292.53029 c -1.3265%2c0 -2.6531%2c-0.66326 -3.9796%2c-1.32653 -1.3266%2c-1.32654 -2.6531%2c-3.31634 -2.6531%2c-5.30614 v -47.75527 c 0%2c-3.31634 1.9898%2c-5.96941 5.3062%2c-6.63268 l 36.4797%2c-9.28574 c 1.9898%2c-0.66327 3.9796%2c0 5.9694%2c1.32653 1.3265%2c1.32654 2.653%2c3.31634 2.653%2c5.30614 v 49.08181 c 0%2c3.31634 -1.9898%2c5.96941 -5.3061%2c6.63267 l -36.4797%2c7.95921 c -1.3265%2c0 -1.3265%2c0 -1.9898%2c0 z m 6.6327%2c-49.0818 v 34.48992 l 23.2143%2c-5.30614 v -35.15319 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path29' d='m 981.9671%2c306.45891 c -1.32653%2c0 -2.65307%2c-0.66326 -3.97961%2c-1.32653 -1.32653%2c-1.32654 -2.65307%2c-3.31634 -2.65307%2c-5.30614 v -47.75527 c 0%2c-3.31634 1.98981%2c-5.96941 5.30615%2c-6.63268 l 36.47973%2c-9.28574 c 1.9898%2c-0.66327 3.9796%2c0 5.9694%2c1.32653 1.3265%2c1.32654 2.6531%2c3.31634 2.6531%2c5.30614 v 48.41854 c 0%2c3.31634 -1.9898%2c5.96941 -5.3062%2c6.63268 l -36.4797%2c8.62247 c -0.66326%2c0 -1.32653%2c0 -1.9898%2c0 z m 6.63268%2c-49.0818 v 34.48992 l 23.21432%2c-5.30614 v -34.48992 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path31' d='m 897.06885%2c285.23435 c -1.32654%2c0 -2.65307%2c-0.66327 -3.31634%2c-1.32653 -1.32654%2c-1.32654 -2.65307%2c-2.65307 -2.65307%2c-4.64288 v -29.18377 c 0%2c-2.65307 1.32653%2c-4.64288 3.9796%2c-5.30614 l 43.77567%2c-15.91843 c 1.9898%2c-0.66326 3.9796%2c-0.66326 5.30614%2c0.66327 1.32653%2c1.32654 2.65307%2c2.65307 2.65307%2c4.64287 v 30.51031 c 0%2c2.65308 -1.32654%2c4.64288 -3.97961%2c5.30615 l -43.77566%2c14.59188 c -0.66327%2c0.66327 -1.32654%2c0.66327 -1.9898%2c0.66327 z m 5.9694%2c-31.17358 v 17.24496 l 32.50012%2c-10.61228 v -17.90823 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path33' d='m 865.89527%2c349.57131 c -1.32654%2c-1.32654 -1.9898%2c-2.65307 -1.9898%2c-4.64287 v -29.84705 c 0%2c-2.65307 1.9898%2c-4.64287 3.9796%2c-5.30614 l 41.78586%2c-11.27555 c 1.9898%2c-0.66326 3.31634%2c0 5.30614%2c0.66327 1.32654%2c1.32654 1.9898%2c2.65307 1.9898%2c4.64287 v 31.17358 c 0%2c2.65307 -1.9898%2c5.30614 -4.64287%2c5.30614 l -41.78586%2c9.94902 c -0.66327%2c0.66326 -3.9796%2c0 -4.64287%2c-0.66327 z m 9.28575%2c-29.84704 v 17.90822 l 30.51031%2c-7.29594 v -19.23476 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path35' d='m 981.9671%2c218.24432 c -1.32653%2c0 -2.65307%2c-0.66327 -3.97961%2c-1.32653 -1.32653%2c-1.32654 -2.65307%2c-3.31634 -2.65307%2c-5.30614 v -45.76547 c 0%2c-2.65307 1.98981%2c-5.30614 4.64288%2c-5.96941 l 36.4797%2c-13.26535 c 1.9898%2c-0.66327 3.9796%2c-0.66327 5.9694%2c0.66327 1.9898%2c1.32653 2.6531%2c3.31634 2.6531%2c5.30614 v 49.0818 c 0%2c3.31634 -1.9898%2c5.30614 -4.6429%2c6.63268 l -36.4797%2c9.94901 c -0.66326%2c0 -1.32653%2c0 -1.9898%2c0 z m 6.63268%2c-47.75527 v 32.50012 l 23.21432%2c-6.63268 v -34.48991 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path37' d='m 816.81347%2c356.86725 c -8.62248%2c0 -15.25516%2c-7.95921 -15.25516%2c-17.24496 0%2c-9.28574 6.63268%2c-17.24495 15.25516%2c-17.24495 8.62247%2c0 15.25515%2c7.95921 15.25515%2c17.24495 0%2c9.28575 -6.63268%2c17.24496 -15.25515%2c17.24496 z m 0%2c-25.20417 c -3.31634%2c0 -5.96941%2c3.31634 -5.96941%2c7.95921 0%2c4.64288 2.65307%2c7.95922 5.96941%2c7.95922 3.31633%2c0 5.9694%2c-3.31634 5.9694%2c-7.95922 0%2c-4.64287 -2.65307%2c-7.95921 -5.9694%2c-7.95921 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path39' d='m 1275.7947%2c-13.236074 c 0%2c-1.326535 0%2c-1.989803 0%2c-3.316338 -1.3266%2c-3.316338 -5.3062%2c-5.306141 -8.6225%2c-3.979606 l -37.143%2c13.9286203 V 7.3252221 13.957898 l 32.5001%2c-15.2551549 V 529.31683 h -32.5001 v 13.26535 h 39.1328 c 3.9796%2c0 6.6327%2c-2.65307 7.2959%2c-6.63267 V -11.909539 c 0%2c0 0%2c-0.663267 -0.6632%2c-1.326535 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path41' d='m 1108.6512%2c53.090687 v -13.92862 l -33.1634%2c12.602085 c -0.6632%2c0 -0.6632%2c0.663268 -1.3265%2c0.663268 0%2c0 -113.41876%2c69.6431 -115.40857%2c70.96963 -1.9898%2c1.32654 -3.9796%2c3.31634 -3.9796%2c5.96941 v 37.80626 l -109.43916%2c65.00022 c -1.9898%2c0.66327 -3.31634%2c3.31634 -3.31634%2c5.30614 l -0.66326%2c31.83685 -59.69409%2c35.15318 c -3.31634%2c1.9898 -1.9898%2c6.63268 -1.9898%2c9.94902 0%2c3.31633 0%2c72.29616 0%2c72.29616 l -25.20417%2c-9.28574 c -1.32654%2c-0.66327 -3.31634%2c-0.66327 -4.64287%2c0 l -22.5511%2c9.28574 c 0%2c0 0%2c-71.6329 0%2c-72.29616 0%2c-3.97961 0.66327%2c-7.29595 -2.65307%2c-9.28575 l -59.69409%2c-35.15318 -0.66326%2c-31.83685 c 0%2c-1.9898 -1.32654%2c-3.97961 -3.31634%2c-5.30614 L 552.16969%2c168.49925 v -39.13279 c 0%2c-2.65307 -1.32654%2c-4.64287 -3.97961%2c-5.96941 l -8.62248%2c-3.9796 -130.66371%2c-78.928847 c -0.66327%2c0 -0.66327%2c-0.663268 -1.32654%2c-0.663268 l -9.28575%2c-3.979606 v 14.591888 l 3.97961%2c1.989803 31.17358%2c19.898028 -25.20417%2c-11.27555 c -0.66327%2c0 -0.66327%2c0 -0.66327%2c0 l -9.28575%2c-5.30614 v 15.918422 458.98119 13.26535 h 5.96941 c 1.9898%2c0 3.31634%2c-0.66327 5.30614%2c-1.9898 1.98981%2c-1.32654 342.90936%2c-150.56175 342.90936%2c-150.56175 0%2c0 346.88899%2c151.88828 348.87879%2c152.55155 1.9898%2c0.66327 7.2959%2c0 7.2959%2c0 V 530.64337 71.66218 57.73356 l -60.3573%2c26.530705 31.8368%2c-19.898028 z M 502.42462%2c485.54117 451.35301%2c508.09227 V 343.6019 l 51.07161%2c9.28575 z m 35.81645%2c-290.51121 v 273.92952 l -22.5511%2c9.94901 V 347.58151 c 0%2c-3.31634 -1.9898%2c-5.96941 -5.30614%2c-6.63268 l -64.33696%2c-11.27555 c -1.9898%2c-0.66327 -3.9796%2c0 -5.30614%2c1.32654 -1.9898%2c1.32653 -2.65307%2c3.31633 -2.65307%2c5.30614 v 177.09245 l -26.5307%2c11.93882 V 76.968321 l 119.38817%2c53.061409 7.29594%2c3.97961 z m 13.92862%2c-11.27555 47.092%2c27.85724 -47.092%2c-20.5613 z m 35.81645%2c183.72512 27.85724%2c3.97961 0.66327%2c63.01042 -27.85724%2c11.93882 z m 61.68389%2c-76.93904 c 0%2c0.66327 0%2c1.9898 0%2c2.65307 v 126.68412 l -22.5511%2c9.94901 -0.66327%2c-63.01042 c 0%2c-3.31634 -1.9898%2c-5.30614 -4.64287%2c-5.96941 L 582.68%2c354.87745 c -1.9898%2c0 -3.31634%2c0 -4.64287%2c1.32653 -1.32654%2c1.32654 -1.98981%2c2.65308 -1.98981%2c4.64288 l 0.66327%2c90.86766 -24.5409%2c10.61228 V 204.97897 l 97.50034%2c43.11239 z m 13.26535%2c-5.96941 11.93882%2c7.29595 -11.93882%2c-3.97961 z m 33.16338%2c115.40857 -11.27555%2c5.30614 v -31.17358 l 11.27555%2c1.32654 z m 17.90823%2c-7.95921 -8.62248%2c3.31633 V 370.1326 c 0%2c-2.65307 -1.98981%2c-4.64287 -4.64288%2c-4.64287 l -20.56129%2c-1.32653 c -1.32654%2c0 -2.65307%2c0.66326 -3.31634%2c1.32653 -0.66327%2c0.66327 -1.32654%2c1.9898 -1.32654%2c3.31634 v 40.45932 l -12.60208%2c5.30614 V 302.47931 l 51.07161%2c17.24496 z m 108.11262%2c11.93881 -11.27555%2c-5.30614 v -24.5409 l 11.27555%2c-0.66327 z m 21.88783%2c9.94902 -13.26535%2c-5.96941 v -39.13279 c 0%2c-1.32654 -0.66327%2c-2.65307 -1.32654%2c-3.31634 -0.66327%2c-0.66327 -1.9898%2c-1.32653 -3.31634%2c-1.32653 l -20.56129%2c1.32653 c -2.65307%2c0 -4.64288%2c1.9898 -4.64288%2c4.64287 v 24.54091 l -7.95921%2c-3.31634 v -72.95944 l 51.07161%2c-16.58169 z m 0%2c-125.35758 -22.5511%2c7.29594 22.5511%2c-13.26535 z m 72.29617%2c157.19442 -27.85724%2c-12.60208 0.66327%2c-63.67369 27.85723%2c-3.97961 z m 38.46952%2c17.24496 -27.19397%2c-11.93882 0.66326%2c-91.53093 c 0%2c-1.9898 -0.66326%2c-3.31634 -1.9898%2c-4.64287 -1.32653%2c-1.32654 -2.65307%2c-1.32654 -4.64287%2c-1.32654 l -39.13279%2c5.96941 c -2.65307%2c0.66327 -4.64287%2c3.31634 -4.64287%2c5.96941 l -0.66327%2c63.01042 -19.89803%2c-8.62247 v -126.68412 -45.1022 l 97.50034%2c-43.11239 z m 0%2c-271.93972 -57.04102%2c25.20417 57.04102%2c-33.82665 z M 1001.8651%2c484.8779 V 350.89784 l 51.0716%2c-8.62247 V 506.76573 Z M 1094.7226%2c77.631589 V 526.00049 l -28.5205%2c-12.60208 V 334.97942 c 0%2c-1.9898 -1.3265%2c-3.9796 -2.6531%2c-5.30614 -1.3265%2c-1.32653 -3.3163%2c-1.9898 -5.3061%2c-1.32653 l -64.33698%2c11.27554 c -3.31634%2c0.66327 -5.30614%2c3.31634 -5.30614%2c6.63268 v 132.65352 l -19.89803%2c-8.62248 -0.66327%2c-335.61341 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path43' d='M 243.08698%2c-0.63398925 274.92383%2c13.957898 V 9.9782925 -3.9503273 l -28.52051%2c-9.9490137 -7.29594%2c-3.316338 c -2.65307%2c-0.663268 -4.64288%2c-0.663268 -6.63268%2c0.663267 -1.9898%2c0.663268 -3.31634%2c3.316338 -3.31634%2c5.306141 V 536.61277 c 0%2c3.97961 2.65307%2c6.63268 6.63268%2c6.63268 h 39.13279 V 529.9801 h -31.83685 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path51' d='m 1169.6718%2c118.09091 c -20.5613%2c0 -37.143%2c-16.58169 -37.143%2c-37.142983 V -51.042328 H 974.67116 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.142986 0%2c-20.561296 16.58169%2c-37.142986 37.14299%2c-37.142986 h 195.00064 c 20.5613%2c0 37.143%2c16.58169 37.143%2c37.142986 V 80.947927 c 0%2c20.561293 -16.5817%2c37.142983 -37.143%2c37.142983 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path55' d='M 530.28186%2c647.37847 H 335.28118 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.14299 V 441.10224 c 0%2c-20.5613 16.58169%2c-37.14299 37.14299%2c-37.14299 20.5613%2c0 37.14299%2c16.58169 37.14299%2c37.14299 v 131.99025 h 157.85769 c 20.56129%2c0 37.14298%2c16.58169 37.14298%2c37.14299 0%2c20.5613 -16.58169%2c37.14299 -37.14298%2c37.14299 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path59' d='m 335.28118%2c118.09091 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.142983 V -88.185314 c 0%2c-20.561296 16.58169%2c-37.142986 37.14299%2c-37.142986 h 195.00068 c 20.56129%2c0 37.14298%2c16.58169 37.14298%2c37.142986 0%2c20.561296 -16.58169%2c37.142986 -37.14298%2c37.142986 H 372.42417 V 80.947927 c 0%2c20.561293 -16.58169%2c37.142983 -37.14299%2c37.142983 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path63' d='M 1169.6718%2c647.37847 H 974.67116 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.14299 0%2c-20.5613 16.58169%2c-37.14299 37.14299%2c-37.14299 H 1132.5288 V 441.10224 c 0%2c-20.5613 16.5817%2c-37.14299 37.143%2c-37.14299 20.5613%2c0 37.143%2c16.58169 37.143%2c37.14299 v 169.13324 c 0%2c20.5613 -16.5817%2c37.14299 -37.143%2c37.14299 z' class='st1'/%3e%3c/g%3e%3c/svg%3e");
        return t.classList.add("logo"), $a42f1354f0348298$var$V`<div class=${$a42f1354f0348298$var$he(e)} part="panel">
			<div
				class="presentation"
				style=${!this.light && "map" !== this.focus && this.picture ? "display: none" : ""}
			>
				${t}

				${this.light ? $a42f1354f0348298$var$V`
					&copy; <a
						href=${"https://panoramax.fr"}
						title=${this._parent?._t.map.more_panoramax}
						target="_blank"
					>${this._parent?._t.pnx.panoramax}</a> |
				` : $a42f1354f0348298$var$V`
					<div>
						${this._parent?._t.pnx.whats_panoramax}
						<pnx-link-button
							title=${this._parent?._t.map.more_panoramax}
							kind="superinline"
							href=${"https://panoramax.fr"}
							target="_blank"
							size="sm"
						>
							${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$us)}
						</pnx-link-button>
					</div>
				`}
			</div>
			<pnx-picture-legend
				._parent=${this._parent}
				style=${"map" === this.focus ? "display: none" : ""}
				collapsable
				light=${this.light || $a42f1354f0348298$var$q}
			>
				<slot slot="editors" name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</pnx-picture-legend>
			<pnx-map-legend
				._parent=${this._parent}
				style=${"map" !== this.focus ? "display: none" : ""}
				light=${this.light || $a42f1354f0348298$var$q}
			></pnx-map-legend>
		</div>`;
    }
}
customElements.define("pnx-widget-legend", $a42f1354f0348298$var$tM);
const $a42f1354f0348298$var$iM = "http://127.0.0.1:8111";
class $a42f1354f0348298$var$nM extends $a42f1354f0348298$var$le {
    static properties = {
        _pic: {
            state: !0
        },
        _josm: {
            state: !0
        }
    };
    static styles = $a42f1354f0348298$var$s`
		:host { display: inline-flex; gap: 5px; }
		:host > * { flex: 1; }
		pnx-link-button::part(btn) { height: auto; }
	`;
    constructor(){
        super(), this._josm = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this._parent.onceReady()).then(()=>{
            this._parent.onceFirstPicLoaded().then(this._onPictureLoad.bind(this)), this._parent.psv.addEventListener("picture-loaded", this._onPictureLoad.bind(this));
        });
    }
    _onPictureLoad() {
        this._pic = this._parent?.psv?.getPictureMetadata();
    }
    _toggleJOSMLive() {
        this._josm = !this._josm, this._josm ? fetch($a42f1354f0348298$var$iM + "/version").then(()=>{
            const e = $a42f1354f0348298$var$uo(this._parent?.psv?.getPictureMetadata?.());
            if (e) fetch(`${$a42f1354f0348298$var$iM}/load_and_zoom?${e}`).catch((e)=>{
                console.warn(e), this._toggleJOSMLive();
            });
            this._josmListener = ()=>{
                const e = $a42f1354f0348298$var$uo(this._parent?.psv?.getPictureMetadata?.());
                if (e) fetch(`${$a42f1354f0348298$var$iM}/zoom?${e}`).catch((e)=>{
                    console.warn(e), this._toggleJOSMLive();
                });
            }, this._parent?.psv?.addEventListener?.("picture-loaded", this._josmListener), this._parent?.psv?.addEventListener?.("picture-loading", this._josmListener);
        }).catch((e)=>{
            console.warn(e), alert(this._parent?._t.pnx.error_josm), this._toggleJOSMLive();
        }) : this._josmListener && (this._parent?.psv?.removeEventListener?.("picture-loading", this._josmListener), this._parent?.psv?.removeEventListener?.("picture-loaded", this._josmListener), delete this._josmListener);
    }
    render() {
        if (!this._pic) return $a42f1354f0348298$var$q;
        if (this._parent?.isWidthSmall()) return $a42f1354f0348298$var$V`
				<pnx-link-button
					size="sm"
					href="geo:${this._pic.gps[1]},${this._pic.gps[0]};u=3"
				>
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$cs)} ${this._parent?._t.pnx.geo_uri}
				</pnx-link-button>
			`;
        {
            const e = {
                map: `19/${this._pic.gps[1]}/${this._pic.gps[0]}`,
                source: "Panoramax",
                photo_overlay: "panoramax",
                photo: `panoramax/${this._pic.id}`
            }, t = e && `https://www.openstreetmap.org/edit?editor=id#${new URLSearchParams(e).toString()}`;
            return $a42f1354f0348298$var$V`
				<pnx-link-button
					size="sm"
					href=${t}
					target="_blank"
					title="${this._parent?._t.pnx.contribute_id}"
				>
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ys)} ${this._parent?._t.pnx.id}
				</pnx-link-button>

				<pnx-button
					id="pnx-edit-josm"
					size="sm"
					active=${this._josm ? "" : $a42f1354f0348298$var$q}
					@click=${this._toggleJOSMLive}
					title="${this._parent?._t.pnx.josm_live}"
				>
					${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$is)} ${this._parent?._t.pnx.josm}
				</pnx-button>
			`;
        }
    }
}
customElements.define("pnx-widget-osmeditors", $a42f1354f0348298$var$nM);
class $a42f1354f0348298$var$aM extends $a42f1354f0348298$var$le {
    static styles = [
        $a42f1354f0348298$var$Go,
        $a42f1354f0348298$var$s`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
    ];
    static properties = {
        full: {
            type: Boolean
        },
        _meta: {
            state: !0
        }
    };
    constructor(){
        super(), this.full = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this._parent.onceReady()).then(()=>{
            this._meta = this._parent.psv.getPictureMetadata(), this._parent.psv.addEventListener("picture-loaded", ()=>{
                this._meta = this._parent.psv.getPictureMetadata();
            });
        });
    }
    _onPrint() {
        this._closeGroup(), window.print();
    }
    _closeGroup() {
        this.renderRoot.querySelector("#pic-legend-headline-menu").close();
    }
    render() {
        return $a42f1354f0348298$var$V`<pnx-togglable-group padded="false" id="pic-legend-headline-menu" ._parent=${this._parent}>
			<pnx-button slot="button" kind="inline">${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ms)}</pnx-button>
			<pnx-list-group class="pnx-print-hidden" @click=${this._closeGroup}>
				${this._meta ? $a42f1354f0348298$var$V`<pnx-copy-button ._t=${this._parent?._t} text=${this._meta.id} unstyled>
					${this._parent?._t.pnx.metadata_general_copy_picid}
				</pnx-copy-button>` : $a42f1354f0348298$var$q}

				<a
					download
					target="_blank"
					href=${this._meta?.panorama?.hdUrl}
					@click=${this._closeGroup}
				>${this._parent?._t.pnx.share_image}</a>

				${this._parent.isWidthSmall() ? $a42f1354f0348298$var$q : $a42f1354f0348298$var$V`<button @click=${this._onPrint}>
					${this._parent?._t.pnx.share_print}
				</button>`}

				${this._parent?.api?.getRSSURL() && !this._parent.isWidthSmall() && $a42f1354f0348298$var$V`
					<a
						target="_blank"
						href=${this._parent?.api.getRSSURL(this._parent?.map?.getBounds?.())}
						title=${this._parent?._t.pnx.share_rss_title}
						@click=${this._closeGroup}
					>
						${this._parent?._t.pnx.share_rss}
					</a>
				`}
			</pnx-list-group>
		</pnx-togglable-group>`;
    }
}
customElements.define("pnx-picture-legend-actions", $a42f1354f0348298$var$aM);
const $a42f1354f0348298$var$rM = new CSSStyleSheet;
$a42f1354f0348298$var$rM.replaceSync("pnx-widget-player {\n\tpointer-events: none;\n}\n\npnx-widget-player > pnx-button-group {\n\tpointer-events: auto;\n}\n"), document.adoptedStyleSheets.push($a42f1354f0348298$var$rM);
class $a42f1354f0348298$var$sM extends $a42f1354f0348298$var$le {
    static properties = {
        playing: {
            type: Number,
            reflect: !0
        },
        size: {
            type: String
        },
        more: {
            type: String
        },
        _activePrev: {
            state: !0
        },
        _activePlayBack: {
            state: !0
        },
        _activePlay: {
            state: !0
        },
        _activeNext: {
            state: !0
        }
    };
    constructor(){
        super(), this.playing = 0, this.size = "xl", this.more = "depends", this._activePrev = !0, this._activePlayBack = !0, this._activePlay = !0, this._activeNext = !0;
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this._parent?.oncePSVReady?.().then(()=>{
                this._parent.psv.addEventListener("sequence-playing", (e)=>this.playing = e.detail.backward ? -1 : 1), this._parent.psv.addEventListener("sequence-stopped", ()=>this.playing = 0), this._parent.psv.addEventListener("picture-loaded", this._changeActiveStates.bind(this)), this._parent.psv.addEventListener("pictures-navigation-changed", this._changeActiveStates.bind(this)), this._changeActiveStates();
            }));
    }
    _changeActiveStates() {
        "pic" === this._parent.psv.getPicturesNavigation?.() ? (this._activeNext = !1, this._activePlayBack = !1, this._activePlay = !1, this._activePrev = !1) : (this._activePrev = null != this._parent.psv.getPictureMetadata()?.sequence?.prevPic, this._activePlayBack = this._activePrev, this._activeNext = null != this._parent.psv.getPictureMetadata()?.sequence?.nextPic, this._activePlay = this._activeNext), this.requestUpdate();
    }
    _onPlayClick() {
        this._parent?.psv?.isSequencePlaying() && 1 === this.playing ? (this.playing = 0, this._parent?.psv?.stopSequence()) : (this.playing = 1, this._parent?.psv?.playSequence());
    }
    _onPlayBackClick() {
        this._parent?.psv?.isSequencePlaying() && -1 === this.playing ? (this.playing = 0, this._parent?.psv?.stopSequence()) : (this.playing = -1, this._parent?.psv?.playSequence(!0));
    }
    render() {
        return this._parent?.psv?.addEventListener ? $a42f1354f0348298$var$V`
			<pnx-button-group
				id="pnx-widget-player"
				dir="row"
				size=${this.size}
				class="pnx-print-hidden"
				style=${this._activePrev || this._activePlay || this._activeNext ? "" : "display: none"}
			>
				<pnx-button
					kind="superflat"
					id="pnx-player-prev"
					title=${this._parent?._t.pnx.sequence_prev}
					@click=${()=>this._parent?.psv?.goToPrevPicture()}
					.disabled=${!this._activePrev}
				>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$jr)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-play-backward"
					title=${-1 === this.playing ? this._parent?._t.pnx.sequence_pause : this._parent?._t.pnx.sequence_play_backwards}
					.disabled=${!this._activePlayBack}
					@click=${this._onPlayBackClick.bind(this)}
				>${-1 === this.playing ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$$r) : $a42f1354f0348298$var$Ir($a42f1354f0348298$var$xs, {
            transform: {
                rotate: 180
            }
        })}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-play"
					title=${1 === this.playing ? this._parent?._t.pnx.sequence_pause : this._parent?._t.pnx.sequence_play}
					.disabled=${!this._activePlay}
					@click=${this._onPlayClick.bind(this)}
				>${1 === this.playing ? $a42f1354f0348298$var$Ir($a42f1354f0348298$var$$r) : $a42f1354f0348298$var$Ir($a42f1354f0348298$var$xs)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-next"
					title=${this._parent?._t.pnx.sequence_next}
					.disabled=${!this._activeNext}
					@click=${()=>this._parent?.psv?.goToNextPicture()}
				>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$_s)}</pnx-button>

				${"never" === this.more || "always" !== this.more && this._parent?.isWidthSmall() ? $a42f1354f0348298$var$q : $a42f1354f0348298$var$V`
					<pnx-togglable-group padded="false" ._parent=${this._parent}>
						<pnx-button
							kind="flat"
							id="pnx-player-more"
							title=${this._parent?._t.pnx.sequence_more}
							class=${"depends" === this.more ? "pnx-xs-hidden" : ""}
							slot="button"
						>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$As)}</pnx-button>

						<pnx-player-options ._parent=${this._parent}></pnx-player-options>
					</pnx-togglable-group>
				`}
			</pnx-button-group>
		` : $a42f1354f0348298$var$q;
    }
}
customElements.define("pnx-widget-player", $a42f1354f0348298$var$sM);
const $a42f1354f0348298$var$oM = 15, $a42f1354f0348298$var$lM = [
    "!",
    [
        "has",
        "uncrowded"
    ]
], $a42f1354f0348298$var$cM = [
    "==",
    [
        "get",
        "type"
    ],
    "equirectangular"
];
function $a42f1354f0348298$var$dM(e) {
    return {
        PICTURES: {
            paint: {
                "circle-radius": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    $a42f1354f0348298$var$oM,
                    0,
                    15.5,
                    e ? 1 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        0,
                        1
                    ],
                    16.5,
                    e ? 2 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        0,
                        2
                    ],
                    17,
                    e ? 4 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        1,
                        4
                    ],
                    18,
                    e ? 5 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        3,
                        5
                    ],
                    20,
                    e ? 7 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        5,
                        7
                    ],
                    22,
                    e ? 7 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        7,
                        7
                    ]
                ],
                "circle-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    $a42f1354f0348298$var$oM,
                    0,
                    15.5,
                    e ? 1 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        0,
                        1
                    ],
                    16.5,
                    e ? 1 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        0,
                        1
                    ],
                    17,
                    1
                ],
                "circle-stroke-opacity": [
                    "case",
                    [
                        "all",
                        $a42f1354f0348298$var$lM,
                        $a42f1354f0348298$var$cM
                    ],
                    .2,
                    $a42f1354f0348298$var$cM,
                    .4,
                    0
                ],
                "circle-stroke-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    17.5,
                    0,
                    18.5,
                    e ? [
                        "case",
                        $a42f1354f0348298$var$cM,
                        10,
                        2
                    ] : [
                        "case",
                        [
                            "all",
                            $a42f1354f0348298$var$lM,
                            $a42f1354f0348298$var$cM
                        ],
                        0,
                        $a42f1354f0348298$var$cM,
                        10,
                        $a42f1354f0348298$var$lM,
                        0,
                        2
                    ],
                    19.5,
                    e ? [
                        "case",
                        $a42f1354f0348298$var$cM,
                        10,
                        2
                    ] : [
                        "case",
                        [
                            "all",
                            $a42f1354f0348298$var$lM,
                            $a42f1354f0348298$var$cM
                        ],
                        10,
                        $a42f1354f0348298$var$cM,
                        10,
                        $a42f1354f0348298$var$lM,
                        0,
                        2
                    ]
                ]
            },
            layout: {}
        },
        SEQUENCES: {
            paint: {
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    0,
                    .5,
                    10,
                    1.5,
                    14.5,
                    1.5,
                    15.5,
                    e ? 2 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        .5,
                        2
                    ],
                    22,
                    e ? 4 : [
                        "case",
                        $a42f1354f0348298$var$lM,
                        1,
                        4
                    ]
                ]
            },
            layout: {
                "line-cap": "square"
            }
        },
        SEQUENCES_PLUS: {
            paint: {
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    0,
                    15,
                    16,
                    30
                ],
                "line-opacity": 0,
                "line-color": "#ff0000"
            },
            layout: {
                "line-cap": "square"
            }
        },
        GRID: {
            layout: {
                "circle-sort-key": [
                    "get",
                    "coef"
                ]
            },
            paint: {
                "circle-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "get",
                        "coef"
                    ],
                    0,
                    "#fff",
                    .1,
                    $a42f1354f0348298$var$Vs.PALETTE_1,
                    .25,
                    $a42f1354f0348298$var$Vs.PALETTE_1,
                    .5,
                    $a42f1354f0348298$var$Vs.PALETTE_2,
                    .75,
                    $a42f1354f0348298$var$Vs.PALETTE_3,
                    1,
                    $a42f1354f0348298$var$Vs.PALETTE_4
                ],
                "circle-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    4,
                    .5,
                    5,
                    1,
                    6.75,
                    1,
                    7,
                    0
                ],
                "circle-radius": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    1,
                    [
                        "match",
                        [
                            "get",
                            "coef"
                        ],
                        0,
                        0,
                        1
                    ],
                    5,
                    [
                        "match",
                        [
                            "get",
                            "coef"
                        ],
                        0,
                        0,
                        2.5
                    ],
                    7,
                    [
                        "match",
                        [
                            "get",
                            "coef"
                        ],
                        0,
                        0,
                        7
                    ]
                ]
            }
        }
    };
}
$a42f1354f0348298$var$dM(!1), $a42f1354f0348298$var$dM(!0);
const $a42f1354f0348298$var$uM = 864e5, $a42f1354f0348298$var$hM = (e)=>new Date(e).toISOString().split("T")[0], $a42f1354f0348298$var$pM = Date.now();
$a42f1354f0348298$var$hM($a42f1354f0348298$var$pM - 180 * $a42f1354f0348298$var$uM), $a42f1354f0348298$var$hM($a42f1354f0348298$var$pM - 365 * $a42f1354f0348298$var$uM), $a42f1354f0348298$var$hM($a42f1354f0348298$var$pM - 94608e6);
$a42f1354f0348298$var$qs[0].color, $a42f1354f0348298$var$qs[1].color, $a42f1354f0348298$var$qs[2].color, $a42f1354f0348298$var$qs[3].color, $a42f1354f0348298$var$qs[4].color, $a42f1354f0348298$var$Qs[0].score, $a42f1354f0348298$var$Qs[0].color, $a42f1354f0348298$var$Qs[1].score, $a42f1354f0348298$var$Qs[1].color, $a42f1354f0348298$var$Qs[2].score, $a42f1354f0348298$var$Qs[2].color, $a42f1354f0348298$var$Qs[3].color;
const $a42f1354f0348298$var$AM = {
    minDate: "date_from",
    maxDate: "date_to",
    pic_type: "pic_type",
    camera: "camera",
    theme: "theme",
    qualityscore: "pic_score",
    gps: "gps"
}, $a42f1354f0348298$var$mM = Object.fromEntries(Object.entries($a42f1354f0348298$var$AM).map((e)=>[
        e[1],
        e[0]
    ])), $a42f1354f0348298$var$gM = [
    "none",
    "null",
    "false",
    !1
], $a42f1354f0348298$var$fM = [
    "antialias",
    "bearing",
    "bearingSnap",
    "bounds",
    "boxZoom",
    "clickTolerance",
    "collectResourceTiming",
    "cooperativeGestures",
    "crossSourceCollisions",
    "doubleClickZoom",
    "dragPan",
    "dragRotate",
    "fadeDuration",
    "failIfMajorPerformanceCaveat",
    "fitBoundsOptions",
    "hash",
    "interactive",
    "localIdeographFontFamily",
    "locale",
    "logoPosition",
    "maplibreLogo",
    "maxBounds",
    "maxCanvasSize",
    "maxPitch",
    "maxTileCacheSize",
    "maxTileCacheZoomLevels",
    "maxZoom",
    "minPitch",
    "minZoom",
    "pitch",
    "pitchWithRotate",
    "pixelRatio",
    "preserveDrawingBuffer",
    "refreshExpiredTiles",
    "renderWorldCopies",
    "scrollZoom",
    "touchPitch",
    "touchZoomRotate",
    "trackResize",
    "transformCameraUpdate",
    "transformRequest",
    "validateStyle"
];
class $a42f1354f0348298$var$_M {
    constructor(e = {}, t = {}, i = {}){
        "false" === e["url-parameters"] && (t = {});
        let n = {};
        "object" == typeof e?.["psv-options"] && (n = e["psv-options"]);
        let a = {};
        "object" == typeof e?.["map-options"] && (a = e["map-options"]);
        let r = {};
        "object" == typeof i?.map && (r = i.map);
        let s = t.map && "none" !== t.map ? $a42f1354f0348298$var$vM(t.map) : null, o = !$a42f1354f0348298$var$gM.includes(t.map) && !$a42f1354f0348298$var$gM.includes(e["map-options"]), l = t.focus || e.focus, c = t.pic || e.picture, d = t.seq || e.sequence, u = t.users || e["endpoint-to-use"] || r.endpoint, h = t.speed || n?.transitionDuration, p = t.nav || n?.picturesNavigation, A = t.theme || a.theme || r?.theme, m = t.background || a.background || r?.background, g = s?.center || !c && (a.center || r?.center) || [
            0,
            0
        ], f = s?.zoom || a.zoom || r?.zoom, _ = s?.pitch || a.pitch, v = s?.bearing || a.bearing, E = t.level || a.indoor?.level, y = e.geocoder, b = e.widgets, k = e["fetch-options"], x = e.style, w = e.lang, M = e.endpoint, S = a.raster, C = a.basemaps, T = a.indoor, D = a.attributionControl, P = a.preview, I = (L = a, Object.fromEntries(Object.entries(L).filter(([e])=>$a42f1354f0348298$var$fM.includes(e))));
        var L;
        let R = e["keyboard-shortcuts"], z = e["skip-tags-menu-opening"], F = "false" === i?.disableAnnotations || n?.displayAnnotations || !1, U = t.xyz, N = t.date_from, B = t.date_to, O = t.pic_type, j = t.camera, G = t.pic_score, V = t.gps, H = t.overlay, q = t.xywh, K = t.annot;
        !o || c || d ? [
            "map",
            "pic"
        ].includes(l) ? "map" !== l || o || (console.warn("Parameter focus can't be 'map' as map is disabled"), l = "pic") : (console.warn("Invalid value for parameter focus:", l), l = !o || c || d ? "pic" : "map") : l = "map", "aerial" !== m || S || (console.warn("Parameter background can't be 'aerial' as no aerial imagery is available"), m = "streets"), E && !T && console.error("Can't set indoor level if indoor= plugin is not available"), !F && K && (F = !0), K && !c && console.error("Parameter annot can only be used in combination with 'picture'"), [
            "thumb",
            "marker",
            "none"
        ].includes(P) || (P && P.length > 0 && console.warn("Parameter map-options.preview is invalid, should be 'thumb', 'marker' or 'none'"), P = "thumb"), this._parentInit = {
            map: o,
            fetchOptions: k,
            style: x,
            lang: w,
            endpoint: M
        }, this._parentPostInit = {
            focus: l,
            picture: c,
            sequence: d,
            geocoder: y,
            widgets: b,
            users: u,
            forceFocus: !0,
            keyboardShortcuts: !0,
            willLoadPicture: void 0 !== (c || d),
            skipTagsMenuOpening: "true" === z
        }, this._psvInit = Object.assign(Object.fromEntries(Object.entries(n).filter(([e])=>![
                "transitionDuration",
                "picturesNavigation",
                "displayAnnotations"
            ].includes(e))), {
            displayAnnotations: F
        }), this._psvAny = {
            transitionDuration: h,
            picturesNavigation: p
        }, this._psvPostInit = {
            xyz: U,
            xywh: q,
            annotation: K
        }, this._mapInit = {
            raster: S,
            indoor: T,
            attributionControl: D,
            basemaps: C,
            preview: P,
            ...I
        }, this._mapAny = {
            theme: A,
            background: m,
            center: g,
            zoom: f,
            pitch: _,
            bearing: v,
            level: E
        }, this._mapPostInit = {
            date_from: N,
            date_to: B,
            pic_type: O,
            camera: j,
            pic_score: G,
            gps: V,
            overlay: H
        }, "false" === R && (this._psvInit.keyboard = !1, this._psvInit.keyboardActions = {}, this._mapInit.keyboard = !1, this._parentPostInit.keyboardShortcuts = !1);
    }
    _sanitize(e) {
        return Object.fromEntries(Object.entries(e).filter(([, e])=>void 0 !== e));
    }
    getParentInit() {
        return this._sanitize(this._parentInit);
    }
    getParentPostInit() {
        return this._sanitize(this._parentPostInit);
    }
    getPSVInit() {
        return this._sanitize(Object.assign({}, this._psvInit, this._psvAny));
    }
    getPSVPostInit() {
        return this._sanitize(Object.assign({}, this._psvPostInit, this._psvAny));
    }
    getMapInit() {
        return this._sanitize(Object.assign({}, this._mapInit, this._mapAny));
    }
    getMapPostInit() {
        return this._sanitize(Object.assign({}, this._mapPostInit, this._mapAny));
    }
    static GetComponentProperties(e, t) {
        const i = {};
        for(let n in e.properties)e.properties[n].state || null == t[n] || (i[n] = t[n]);
        return i;
    }
}
function $a42f1354f0348298$var$vM(e, t) {
    const i = (e || "").split("/");
    if (i.length >= 3 && !i.some((e)=>isNaN(e))) {
        const e = {
            center: [
                +i[2],
                +i[1]
            ],
            zoom: +i[0],
            pitch: +(i[4] || 0)
        };
        return t && (e.bearing = t.dragRotate.isEnabled() && t.touchZoomRotate.isEnabled() ? +(i[3] || 0) : t.getBearing()), e;
    }
    return null;
}
function $a42f1354f0348298$var$EM(e, t) {
    let i = t.transitionDuration || t.speed;
    void 0 !== i && e.setTransitionDuration(i);
    let n = t.picturesNavigation || t.nav;
    [
        "none",
        "pic",
        "any",
        "seq"
    ].includes(n) && e.setPicturesNavigation(n);
    const a = ()=>{
        if (t.xyz) {
            const i = function(e) {
                const t = (e || "").split("/");
                return 3 !== t.length || t.some((e)=>isNaN(e)) ? null : {
                    x: +t[0],
                    y: +t[1],
                    z: +t[2]
                };
            }(t.xyz);
            e.setXYZ(i.x, i.y, i.z);
        }
        if (t.xywh) {
            const i = function(e, t) {
                let i = (e || "").split(",");
                if (4 !== i.length || i.some((e)=>isNaN(e))) return null;
                {
                    let [e, n, a, r] = i.map((e)=>parseFloat(e)), s = t.panorama.basePanoData;
                    if ("function" == typeof s) {
                        const e = t?.properties?.["pers:interior_orientation"]?.sensor_array_dimensions;
                        s = e && 2 === e.length ? s({
                            width: e[0],
                            height: e[1]
                        }) : null;
                    }
                    if (!s?.fullWidth || !s?.fullHeight) return null;
                    const o = s?.croppedX || 0, l = s?.croppedY || 0, c = o + e + a / 2 - s.fullWidth / 2, d = -(l + n + r / 2 - s.fullHeight / 2), u = c / s.fullWidth, h = d / s.fullHeight, p = (a / s.fullWidth + r / s.fullHeight) / 2;
                    return {
                        yaw: 2 * u * Math.PI,
                        pitch: h * Math.PI,
                        z: 100 * (1 - p)
                    };
                }
            }(t.xywh, e.getPictureMetadata());
            e.rotate(i), e.zoom(i.z);
        }
        t.annotation && e.focusOnAnnotation(t.annotation);
    };
    e.getPictureMetadata() ? a() : e.addEventListener("picture-loaded", a, {
        once: !0
    });
}
function $a42f1354f0348298$var$yM(e, t) {
    const i = $a42f1354f0348298$var$vM(t.map, e);
    i && e.jumpTo(i), e.setFilters?.(function(e) {
        const t = {};
        for(let i in $a42f1354f0348298$var$mM)e[i] && (t[$a42f1354f0348298$var$mM[i]] = e[i]);
        if (t.qualityscore) {
            let e = t.qualityscore.split("");
            const i = {
                A: 5,
                B: 4,
                C: 3,
                D: 2,
                E: 1
            };
            t.qualityscore = e.map((e)=>i[e]);
        }
        return t;
    }(t)), e._parent?.mapStyleComposer?.layerRanges.basemaps[t.background] && e._parent.mapStyleComposer.switchBasemap(t.background), t.overlay && t.overlay.split(",").forEach((t)=>e._parent.mapStyleComposer.switchDataOverlayVisibility("sem-" + t, !0));
}
function $a42f1354f0348298$var$bM(e, t) {
    let i = t.picture || t.pic, n = t.sequence || t.seq || null;
    if (i) {
        const t = i.split(";");
        t.length > 1 && console.warn("Multiple picture IDs passed in URL, only first one kept"), e.select(1 === t.length ? n : null, t[0], !0);
    } else n ? e.select(n, null, !0) : e.select();
}
const $a42f1354f0348298$var$kM = [
    "streets",
    "aerial"
], $a42f1354f0348298$var$xM = [
    "speed",
    "nav",
    "focus",
    "pic",
    "xyz",
    "map",
    "background",
    "users",
    "s",
    "xywh",
    "annot",
    "seq",
    "overlay",
    "level"
].concat(Object.values($a42f1354f0348298$var$AM)), $a42f1354f0348298$var$wM = [
    "focus-changed",
    "pictures-navigation-changed"
], $a42f1354f0348298$var$MM = [
    "position-updated",
    "zoom-updated",
    "view-rotated",
    "picture-loaded",
    "picture-failed",
    "transition-duration-changed",
    "annotation-focused",
    "annotations-unfocused"
], $a42f1354f0348298$var$SM = [
    "moveend",
    "zoomend",
    "boxzoomend",
    "styledata"
], $a42f1354f0348298$var$CM = [
    "filters-changed",
    "theme-changed",
    "panoramax-changed",
    "basemap-changed"
];
class $a42f1354f0348298$var$TM extends EventTarget {
    constructor(e){
        super(), this._parent = e, this._delay = null;
    }
    listenToChanges() {
        window.addEventListener("popstate", this._onURLChange.bind(this), !1), $a42f1354f0348298$var$wM.forEach((e)=>this._parent.addEventListener(e, this._onParentChange.bind(this))), $a42f1354f0348298$var$MM.forEach((e)=>this._parent.psv.addEventListener(e, this._onParentChange.bind(this))), this._parent.map && ($a42f1354f0348298$var$SM.forEach((e)=>this._parent.map.on(e, this._onParentChange.bind(this))), $a42f1354f0348298$var$CM.forEach((e)=>this._parent.mapStyleComposer.addEventListener(e, this._onParentChange.bind(this))), this._parent.map.indoorEqual?.on("levelchange", this._onParentChange.bind(this)));
    }
    destroy() {
        window.removeEventListener("popstate", this._onURLChange);
    }
    nextURLParams() {
        let e = {};
        "number" == typeof this._parent.psv.getTransitionDuration() && (e.speed = this._parent.psv.getTransitionDuration()), [
            null,
            "any"
        ].includes(this._parent.psv.getPicturesNavigation()) || (e.nav = this._parent.psv.getPicturesNavigation()), this._parent.psv.getPictureId() && (e.pic = this._parent.psv.getPictureId());
        const t = this._parent.psv.getPictureMetadata();
        t && (e.xyz = this.currentPSVString(), t.sequence?.id && (e.seq = t.sequence.id));
        const i = this._parent.psv.getSelectedAnnotations();
        if (i?.length > 0 && (e.annot = i[0]), this._parent.map?.loaded) {
            if (e.map = this.currentMapString(), e.focus = "pic", this._parent.isMapWide() && (e.focus = "map"), this._parent.mapStyleComposer?.hasManyBasemaps?.() && this._parent.mapStyleComposer?.basemap && (e.background = this._parent.mapStyleComposer.basemap), this._parent.mapStyleComposer?.panoramax && (e.users = this._parent.mapStyleComposer.panoramax), this._parent.mapStyleComposer?.panoramaxTheme && (e.theme = this._parent.mapStyleComposer.panoramaxTheme), this._parent.mapStyleComposer.panoramaxFilters) {
                for(let t in $a42f1354f0348298$var$AM)"theme" !== t && this._parent.mapStyleComposer.panoramaxFilters[t] && (e[$a42f1354f0348298$var$AM[t]] = this._parent.mapStyleComposer.panoramaxFilters[t]);
                if (e.pic_score) {
                    if (Array.isArray(e.pic_score) || (e.pic_score = e.pic_score.split(",")), 5 === e.pic_score.length) delete e.pic_score;
                    else {
                        const t = [
                            null,
                            "E",
                            "D",
                            "C",
                            "B",
                            "A"
                        ];
                        e.pic_score = e.pic_score.map((e)=>t[e]).join("");
                    }
                }
                Array.isArray(e.gps) && 5 === e.gps.length && delete e.gps;
            }
            if (this._parent.map?.getSemanticOverlays) {
                const t = this._parent.map.getSemanticOverlays().filter((e)=>this._parent.mapStyleComposer.dataOverlays.has(e.source)).map((e)=>e.id);
                t.length > 0 && (e.overlay = t.join(","));
            }
            this._parent.map?.indoorEqual && (e.level = this._parent.map.indoorEqual.level);
        }
        return e;
    }
    nextURLString() {
        let e = "";
        return Object.entries(this.nextURLParams()).sort((e, t)=>e[0].localeCompare(t[0])).forEach((t)=>{
            let [i, n] = t, a = !1;
            const r = e.split("&").map((e)=>{
                const t = e.split("=")[0];
                return t === i ? (a = !0, `${t}=${n}`) : e;
            }).filter((e)=>e);
            a || r.push(`${i}=${n}`), e = `${r.join("&")}`;
        }), `?${e}`.replace(/^\?+/, "?");
    }
    currentURLParams(e = !1) {
        const t = (e ? window.location.hash : window.location.search).replace(/^[?#]/, "").replace(/&amp;/g, "&");
        let i = {};
        if (t.split("&").map((e)=>e.split("=")).filter((e)=>void 0 !== e[0] && e[0].length > 0 && $a42f1354f0348298$var$xM.includes(e[0])).forEach((e)=>{
            i[e[0]] = e[1];
        }), i.s) {
            const e = Object.fromEntries(decodeURIComponent(i.s).split(";").map((e)=>[
                    e[0],
                    e.substring(1)
                ]));
            i = {}, "m" === e.f ? i.focus = "map" : "p" === e.f ? i.focus = "pic" : "t" === e.f && (i.focus = "meta"), "" !== e.s && (i.speed = 100 * parseFloat(e.s)), "a" === e.n ? i.nav = "any" : "s" === e.n && (i.nav = "seq"), [
                "n",
                "p"
            ].includes(e.n) && (i.nav = "pic"), "" !== e.p && (i.pic = e.p), "" !== e.a && (i.annot = e.a), "" !== e.c && (i.xyz = e.c), "" !== e.m && (i.map = e.m), "" !== e.d && (i.date_from = e.d), "" !== e.e && (i.date_to = e.e), "f" === e.t ? i.pic_type = "flat" : "e" === e.t && (i.pic_type = "equirectangular"), "" !== e.k && (i.camera = e.k), "d" === e.v ? i.theme = "default" : "a" === e.v ? i.theme = "age" : "t" === e.v ? i.theme = "type" : "s" === e.v ? i.theme = "score" : "g" === e.v && (i.theme = "gps"), "s" === e.b ? i.background = "streets" : "a" === e.b && (i.background = "aerial"), "" !== e.u && (i.users = e.u), "" !== e.q && (i.pic_score = e.q), "" !== e.g && (i.gps = e.g), "" !== e.o && (i.overlay = e.o), "" !== e.l && (i.level = e.l);
        }
        return i;
    }
    currentMapString() {
        if (!this._parent.map?.loaded) return "";
        const e = this._parent.map.getCenter(), t = Math.round(100 * this._parent.map.getZoom()) / 100, i = Math.ceil((t * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), n = Math.pow(10, i), a = Math.round(e.lng * n) / n, r = Math.round(e.lat * n) / n, s = this._parent.map.getBearing(), o = this._parent.map.getPitch();
        let l = `${t}/${r}/${a}`;
        return (s || o) && (l += "/" + Math.round(10 * s) / 10), o && (l += `/${Math.round(o)}`), l;
    }
    currentPSVString() {
        const e = this._parent.psv.getXYZ();
        return `${e.x.toFixed(2)}/${e.y.toFixed(2)}/${Math.round(e.z || 0)}`;
    }
    _onURLChange() {
        let e = this.currentURLParams();
        var t, i, n;
        "Viewer" === this._parent.getClassName() ? ($a42f1354f0348298$var$bM(t = this._parent, i = e), "map" === i.focus && t?.map ? (t.setPopup(!1), t._setFocus("map", null, i.forceFocus)) : "pic" === i.focus && t?.mini ? (t.setPopup(!1), t._setFocus("pic", null, i.forceFocus)) : i.focus && "meta" === i.focus && t?.mini && t._setFocus("pic", null, i.forceFocus), null != i.users && (n = i.users, [
            "default",
            "metacatalog",
            "",
            null,
            void 0
        ].includes(n) ? t.mapStyleComposer.switchPanoramaxEndpoint(i.users) : t.mapStyleComposer._createPanoramaxEndpointForUser(i.users))) : $a42f1354f0348298$var$bM(this._parent, e), $a42f1354f0348298$var$EM(this._parent.psv, e), this._parent.map && $a42f1354f0348298$var$yM(this._parent.map, e);
    }
    nextShortLink(e) {
        const t = new URL(e), i = this.nextURLParams(), n = {
            f: (i.focus || "").substring(0, 1),
            s: isNaN(parseInt(i.speed)) ? void 0 : Math.floor(parseInt(i.speed) / 100),
            n: (i.nav || "").substring(0, 1),
            p: i.pic,
            c: i.xyz,
            m: i.map,
            d: i.date_from,
            e: i.date_to,
            t: (i.pic_type || "").substring(0, 1),
            k: i.camera,
            v: (i.theme || "").substring(0, 1),
            b: $a42f1354f0348298$var$kM.includes(i.background) ? (i.background || "").substring(0, 1) : i.background || "",
            u: i.users,
            q: i.pic_score,
            a: i.annot,
            g: i.gps,
            o: i.overlay,
            l: i.level
        }, a = Object.entries(n).filter(([, e])=>null != e && "" != e).map(([e, t])=>`${e}${t}`).join(";");
        return t.search = `s=${a}`, t;
    }
    getUnmanagedParameters(e) {
        return new URLSearchParams(Array.from(e.searchParams).filter(([e])=>!$a42f1354f0348298$var$xM.includes(e))).toString();
    }
    _onParentChange() {
        this._delay && (clearTimeout(this._delay), this._delay = null), this._delay = setTimeout(()=>{
            const e = new URL(window.location.href), t = new URL(window.location.href), i = this.getUnmanagedParameters(e);
            if (t.search = this._parent ? this.nextURLString() + (i.length > 0 ? "&" + i : "") : "", Object.keys(this.currentURLParams(!0)).length > 0 && (t.hash = ""), e.search === t.search) return;
            const n = this.currentURLParams().pic || "", a = this._parent?.psv?.getPictureId?.() || "";
            try {
                if (n != a ? window.history.pushState(window.history.state, null, t.href) : window.history.replaceState(window.history.state, null, t.href), this._parent) {
                    const e = new CustomEvent("url-changed", {
                        detail: {
                            url: t.href
                        }
                    });
                    this.dispatchEvent(e);
                }
            } catch (e) {}
        }, 500);
    }
}
const $a42f1354f0348298$var$DM = {
    fas: "fa7-solid"
}, $a42f1354f0348298$var$PM = {};
class $a42f1354f0348298$var$IM {
    constructor(e = null, t = !1){
        this._ready = !1, this._presets = null, this._translations = {}, t || this._load(e);
    }
    async _load(e) {
        e = e?.substring(0, 2) || $a42f1354f0348298$var$Px()[0]?.substring(0, 2);
        try {
            const [t, i, n] = await Promise.all([
                fetch("https://presets.panoramax.fr/translations/en.min.json"),
                e ? fetch(`https://presets.panoramax.fr/translations/${e}.min.json`) : Promise.resolve({
                    ok: !0
                }),
                fetch("https://presets.panoramax.fr/presets.min.json")
            ]);
            if (!(t && i && n && t.ok && i.ok && n.ok)) throw this._ready = -1, new Error("Presets service is not available");
            this._presets = await n.json(), this._translations.en = (await t.json())?.en?.presets, e && (this._translations[e] = (await i.json())?.[e]?.presets), Object.entries(this._presets).forEach(([t, i])=>{
                if (this._translations[e]?.presets?.[t]?.name ? i.name = this._translations[e].presets[t].name : this._translations.en?.presets?.[t]?.name && (i.name = this._translations.en.presets[t].name), i.icon) {
                    const e = i.icon.split("-")[0], t = $a42f1354f0348298$var$DM[e];
                    i.iconify = t ? i.icon.replace(e + "-", t + ":") : i.icon.split("-")[0] + ":" + i.icon.split("-").slice(1).join("-"), $a42f1354f0348298$var$PM[i.iconify] && (i.iconify = $a42f1354f0348298$var$PM[i.iconify]);
                }
            }), this._ready = !0;
        } catch (e) {
            console.error("Presets service throws an error:", e), this._ready = -1;
        }
    }
    async onceReady() {
        return this._ready ? -1 === this._ready ? Promise.reject() : Promise.resolve() : (await new Promise((e)=>setTimeout(e, 250)), this.onceReady());
    }
    async getPreset(e) {
        return await this.getPresets(e).then((e)=>e.shift());
    }
    async getPresets(e) {
        return await this.onceReady().then(()=>{
            const t = Object.values(this._presets).filter((t)=>{
                if (0 === Object.keys(t.tags).length) return !1;
                for(let i in t.tags){
                    const n = t.tags[i];
                    if (!e.semantics || !e.semantics.find((e)=>"delete" !== e.action && e.key === i && ("*" === n || n === e.value))) return !1;
                }
                return !0;
            });
            return t.sort((e, t)=>{
                const i = Object.keys(e.tags).length, n = Object.keys(t.tags).length;
                if (i > n) return -1;
                if (i === n) {
                    const i = Object.values(e.tags).filter((e)=>"*" === e).length, n = Object.values(t.tags).filter((e)=>"*" === e).length;
                    return i < n ? -1 : i > n ? 1 : 0;
                }
                return 1;
            }), t;
        });
    }
}
const $a42f1354f0348298$var$LM = new CSSStyleSheet;
$a42f1354f0348298$var$LM.replaceSync('pnx-photo-viewer {\n\tposition: relative;\n\tdisplay: block;\n}\n\n/* Maximized components */\npnx-photo-viewer .pnx-psv {\n\tposition: absolute;\n\tinset: 0;\n\tz-index: 0;\n}\n\n/* No PSV loader */\npnx-photo-viewer .psv-loader {\n\tdisplay: none;\n}\n\n/* Cornered grid layout */\npnx-photo-viewer pnx-cornered-grid::part(corner-top-left),\npnx-photo-viewer pnx-cornered-grid::part(corner-top),\npnx-photo-viewer pnx-cornered-grid::part(corner-top-right),\npnx-photo-viewer pnx-cornered-grid::part(corner-bottom-left),\npnx-photo-viewer pnx-cornered-grid::part(corner-bottom),\npnx-photo-viewer pnx-cornered-grid::part(corner-bottom-right) {\n\tgap: 10px;\n\tpadding: 10px;\n}\n\n@media screen and (max-width: 576px) {\n\tpnx-photo-viewer pnx-cornered-grid::part(corner-top-right) {\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t\tjustify-content: flex-start;\n\t}\n\n\tpnx-photo-viewer pnx-cornered-grid::part(corner-top-left) {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tjustify-content: flex-start;\n\t}\n}\n\n/* Hidden widgets on sequence play */\npnx-photo-viewer.pnx-playing pnx-bottom-drawer,\npnx-photo-viewer.pnx-playing pnx-widget-legend,\npnx-photo-viewer.pnx-playing pnx-widget-zoom,\npnx-photo-viewer.pnx-playing pnx-time-travel {\n\tdisplay: none;\n}\n\n/* Override legend positioning */\n@media screen and (min-width: 576px) {\n\tpnx-photo-viewer pnx-widget-legend:not([light="true"]) {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\twidth: 100%;\n\t}\n}\n\n/* Hidden widgets on grid toggled */\npnx-photo-viewer .psv-virtual-tour-arrows {\n\ttransition: opacity 0.25s ease-in-out;\n\topacity: 100%;\n}\npnx-photo-viewer.pnx-grid-toggled .psv-virtual-tour-arrows {\n\topacity: 0%;\n}\npnx-photo-viewer.pnx-grid-toggled .psv-virtual-tour-arrows button {\n\tpointer-events: none;\n\tcursor: unset;\n}'), document.adoptedStyleSheets.push($a42f1354f0348298$var$LM);
const $a42f1354f0348298$var$RM = Math.PI / 6, $a42f1354f0348298$var$zM = [
    "pnx-mini",
    "pnx-widget-player",
    "pnx-widget-zoom"
];
class $a42f1354f0348298$var$FM extends $a42f1354f0348298$var$Qw {
    static properties = {
        "psv-options": {
            converter: $a42f1354f0348298$var$Qw.GetJSONConverter()
        },
        widgets: {
            type: String
        },
        "url-parameters": {
            type: String
        },
        "keyboard-shortcuts": {
            type: String
        },
        tabindex: {
            type: Number
        },
        "skip-tags-menu-opening": {
            type: String
        },
        "share-base-url": {
            type: String
        },
        ...$a42f1354f0348298$var$Qw.properties
    };
    constructor(){
        super(), this["psv-options"] = {}, this["url-parameters"] = this.getAttribute("url-parameters") || "true", this["keyboard-shortcuts"] = this.getAttribute("keyboard-shortcuts") || "true", this["skip-tags-menu-opening"] = "true" !== (this.getAttribute("skip-tags-menu-opening") || "false"), this["share-base-url"] = this.getAttribute("share-base-url") || null, this.widgets = this.getAttribute("widgets") || "true", this.grid = $a42f1354f0348298$var$Rr("pnx-cornered-grid"), this.psvContainer = document.createElement("div"), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.popup = $a42f1354f0348298$var$Rr("pnx-popup", {
            _parent: this,
            onclose: this._onPopupClose.bind(this)
        }), this.tabindex = 0, this._sequencesMetadata = {}, this._openedMenus = 0, this._openedMenusChanges = null, this.addEventListener("menu-opened", ()=>{
            this._openedMenusChanges = [
                Date.now(),
                this._openedMenus
            ], this._openedMenus++;
        }), this.addEventListener("menu-closed", ()=>{
            this._openedMenusChanges = [
                Date.now(),
                this._openedMenus
            ], this._openedMenus--;
        });
    }
    _createInitParamsHandler() {
        this._initParams = new $a42f1354f0348298$var$_M($a42f1354f0348298$var$_M.GetComponentProperties($a42f1354f0348298$var$FM, this), Object.assign({}, this.urlHandler?.currentURLParams(), this.urlHandler?.currentURLParams(!0)), {
            disableAnnotations: localStorage.getItem($a42f1354f0348298$var$js)
        });
    }
    _initWidgets() {
        "false" !== this._initParams.getParentPostInit().widgets && ($a42f1354f0348298$var$ho() || (this.grid.appendChild($a42f1354f0348298$var$Rr("pnx-widget-player", {
            slot: this.isWidthMedium() ? "top-right" : "top",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: this.isHeightSmall() || this.isWidthMedium() ? "md" : "xl"
        })), this.grid.appendChild($a42f1354f0348298$var$Rr("pnx-annotations-switch", {
            slot: this.isWidthMedium() ? "top-right" : "top",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: this.isHeightSmall() || this.isWidthMedium() ? "md" : "xl"
        }))), $a42f1354f0348298$var$ho() ? (this.legend = $a42f1354f0348298$var$Rr("pnx-widget-legend", {
            slot: "bottom-right",
            light: !0,
            _parent: this,
            focus: this._initParams.getParentPostInit().focus,
            picture: this._initParams.getParentPostInit().picture
        }), this.grid.appendChild(this.legend)) : this.isWidthSmall() ? (this.legend = $a42f1354f0348298$var$Rr("pnx-picture-legend", {
            _parent: this
        }), this.bottomDrawer = $a42f1354f0348298$var$Rr("pnx-bottom-drawer", {
            slot: "bottom",
            _parent: this,
            openness: this._initParams.getParentPostInit().willLoadPicture ? void 0 : "hidden"
        }), this._initParams.getParentPostInit().willLoadPicture && this.bottomDrawer.appendChild(this.legend), this.grid.appendChild(this.bottomDrawer)) : (this.legend = $a42f1354f0348298$var$Rr("pnx-widget-legend", {
            slot: this.isWidthSmall() ? void 0 : "top-left",
            _parent: this,
            focus: this._initParams.getParentPostInit().focus,
            picture: this._initParams.getParentPostInit().picture
        }), this.grid.appendChild($a42f1354f0348298$var$Rr("pnx-widget-fullscreen", {
            slot: this.isWidthSmall() ? "top-left" : "bottom-right",
            class: this.isWidthSmall() ? "pnx-only-map pnx-print-hidden" : "pnx-print-hidden",
            _parent: this
        })), this.grid.appendChild($a42f1354f0348298$var$Rr("pnx-widget-zoom", {
            slot: "bottom-right",
            class: "pnx-print-hidden",
            _parent: this
        })), this.grid.appendChild(this.legend), this.grid.appendChild($a42f1354f0348298$var$Rr("pnx-time-travel", {
            slot: "bottom",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: "xl"
        }))));
    }
    connectedCallback() {
        super.connectedCallback(), this.presetsManager = new $a42f1354f0348298$var$IM(this.lang), "false" !== this["url-parameters"] && (this.urlHandler = new $a42f1354f0348298$var$TM(this), this.onceReady().then(()=>{
            this.urlHandler.listenToChanges(), this.urlHandler._onParentChange();
        })), this.onceAPIReady().then(this._postAPIInit.bind(this)), this._moveChildToGrid(), window.addEventListener("DOMContentLoaded", ()=>{
            this._moveChildToGrid();
        }, {
            once: !0
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.urlHandler?.destroy(), this.psv?.destroy(), document.body.removeEventListener("click", this._toggleKeyboardBasedOnFocus), window.removeEventListener("keypress", this._toggleKeyboardBasedOnFocus);
    }
    getClassName() {
        return "PhotoViewer";
    }
    async onceReady() {
        return await this.oncePSVReady().then(()=>this._initParams.getParentPostInit().willLoadPicture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
    }
    render() {
        return [
            this.loader,
            this.grid,
            this.popup
        ];
    }
    getSubComponentsNames() {
        return super.getSubComponentsNames().concat([
            "psv",
            "grid",
            "popup",
            "urlHandler"
        ]);
    }
    oncePSVReady() {
        let e;
        return new Promise((t)=>{
            e = setInterval(()=>{
                this.psv && "object" == typeof this.psv && (this.psv.container ? (clearInterval(e), t()) : this.psv.addEventListener && this.psv.addEventListener("ready", ()=>{
                    clearInterval(e), t();
                }, {
                    once: !0
                }));
            }, 250);
        });
    }
    onceFirstPicLoaded() {
        return this.oncePSVReady().then(()=>this.psv.getPictureMetadata() ? Promise.resolve() : new Promise((e)=>{
                const t = ()=>{
                    this.psv.removeEventListener("picture-failed", i), e();
                }, i = ()=>{
                    this.psv.removeEventListener("picture-loaded", t), e();
                };
                this.psv.addEventListener("picture-loaded", t, {
                    once: !0
                }), this.psv.addEventListener("picture-failed", i, {
                    once: !0
                });
            }));
    }
    _postAPIInit() {
        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
        const e = this._initParams.getParentPostInit();
        if (this._initPSV(), this._initWidgets(), $a42f1354f0348298$var$bM(this, e), e.keyboardShortcuts && this._handleKeyboardManagement(), e.willLoadPicture) {
            if (this.psv.getPictureMetadata()) this.loader.dismiss();
            else {
                const e = ()=>{
                    this.loader.dismiss(), this.psv.removeEventListener("picture-failed", t);
                }, t = ()=>{
                    this.loader.dismiss(!0, this._t.pnx.error_pic), this.psv.removeEventListener("picture-loaded", e);
                };
                this.psv.addEventListener("picture-loaded", e, {
                    once: !0
                }), this.psv.addEventListener("picture-failed", t, {
                    once: !0
                });
            }
        } else this.loader.dismiss();
    }
    _initPSV() {
        try {
            this.psv = new $a42f1354f0348298$var$mx(this, this.psvContainer, {
                shouldGoFast: this._psvShouldGoFast.bind(this),
                keyboard: "always",
                keyboardActions: {
                    ...$a42f1354f0348298$var$uy.keyboardActions,
                    8: "ROTATE_UP",
                    2: "ROTATE_DOWN",
                    4: "ROTATE_LEFT",
                    6: "ROTATE_RIGHT",
                    PageUp: ()=>this.psv.goToNextPicture(),
                    9: ()=>this.psv.goToNextPicture(),
                    PageDown: ()=>this.psv.goToPrevPicture(),
                    3: ()=>this.psv.goToPrevPicture(),
                    5: ()=>this.moveCenter(),
                    "*": ()=>this.moveCenter(),
                    Home: ()=>this._toggleFocus?.(),
                    7: ()=>this._toggleFocus?.(),
                    End: ()=>this.mini.toggleAttribute("collapsed"),
                    1: ()=>this.mini.toggleAttribute("collapsed"),
                    " ": ()=>this.psv.toggleSequencePlaying(),
                    0: ()=>this.psv.toggleSequencePlaying()
                },
                ...this._initParams.getPSVInit()
            }), this.oncePSVReady().then(()=>{
                this.loader.setAttribute("value", 50), $a42f1354f0348298$var$EM(this.psv, this._initParams.getPSVPostInit());
            }), this.psv.addEventListener("sequence-playing", ()=>this.classList.add("pnx-playing")), this.psv.addEventListener("sequence-stopped", ()=>this.classList.remove("pnx-playing")), this.psv.addEventListener("picture-failed", ()=>this.select(null, null));
        } catch (e) {
            let t = $a42f1354f0348298$var$Av.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
            this.loader.dismiss(e, t);
        }
    }
    _hasMenuOpened() {
        return this._openedMenus > 0 || this._openedMenusChanges && Date.now() - this._openedMenusChanges[0] <= 250 && this._openedMenusChanges[1] >= 0;
    }
    _enableKeyboard() {
        this.psv.startKeyboardControl();
    }
    _disableKeyboard() {
        this.psv.stopKeyboardControl();
    }
    _toggleKeyboardBasedOnFocus(e) {
        const t = e?.target || document.activeElement;
        if (this.contains(t)) {
            for (let e of this.grid.childNodes)if ("bg" !== e.getAttribute("slot") && !$a42f1354f0348298$var$zM.includes(e.tagName.toLowerCase()) && e.contains(t)) return void this._disableKeyboard();
            if (null !== this.popup.getAttribute("visible")) return void this._disableKeyboard();
            this._enableKeyboard();
        } else this._disableKeyboard();
    }
    _handleKeyboardManagement() {
        window.addEventListener("click", (e)=>this._toggleKeyboardBasedOnFocus(e)), window.addEventListener("keypress", this._toggleKeyboardBasedOnFocus.bind(this)), this.popup.addEventListener("open", this._disableKeyboard.bind(this)), this.popup.addEventListener("close", this._enableKeyboard.bind(this)), this.psv.addEventListener("click", this._enableKeyboard.bind(this));
        for (let e of this.grid.childNodes)"bg" === e.getAttribute("slot") || $a42f1354f0348298$var$zM.includes(e.tagName.toLowerCase()) || (e.addEventListener("focusin", this._disableKeyboard.bind(this)), e.addEventListener("focusout", ()=>{
            null === this.popup.getAttribute("visible") && this._enableKeyboard();
        }));
    }
    _psvShouldGoFast() {
        return this.psv._sequencePlaying && this.psv.getTransitionDuration() < 1e3;
    }
    _moveChildToGrid() {
        Array.from(this.querySelectorAll("[slot]")).forEach((e)=>{
            e.tagName?.toLowerCase().startsWith("pnx-") && (e._parent = this, e._t = this._t), "editors" === e.getAttribute("slot") ? this.onceReady().then(()=>this.legend?.appendChild(e)) : this.grid.appendChild(e);
        });
    }
    isBottomDrawerVisible() {
        return "hidden" !== this.bottomDrawer.getAttribute("openness");
    }
    setBottomDrawer(e, t = null, i = null) {
        this.bottomDrawer && (e || this.bottomDrawer.setAttribute("openness", "hidden"), i?.autoclose ? this.bottomDrawer.setAttribute("autoclose", "") : this.bottomDrawer.removeAttribute("autoclose", ""), i?.autoadjust ? this.bottomDrawer.setAttribute("autoadjust", "") : this.bottomDrawer.removeAttribute("autoadjust", ""), this.bottomDrawer.clearContent(), t && ("string" == typeof t ? this.bottomDrawer.setContent(t) : Array.isArray(t) ? t.forEach((e)=>this.bottomDrawer.appendChild(e)) : "object" == typeof t && this.bottomDrawer.appendChild(t)), !this.psv?._clickAndGo?._couldGoSomewhere && e && this.bottomDrawer.setAttribute("openness", i?.autoadjust ? "opened" : "half-opened"));
    }
    setPopup(e, t = null) {
        e ? this.popup.setAttribute("visible", "") : this.popup.removeAttribute("visible"), this.popup.innerHTML = "", "string" == typeof t ? this.popup.innerHTML = t : Array.isArray(t) && t.forEach((e)=>this.popup.appendChild(e));
    }
    _onPopupClose() {
        this.dispatchEvent(new CustomEvent("focus-changed", {
            detail: {
                focus: this.map && this.isMapWide() ? "map" : "pic"
            }
        }));
    }
    _showQualityScoreDoc() {
        this.setPopup(!0, [
            $a42f1354f0348298$var$Rr("pnx-quality-score-doc", {
                _t: this._t
            })
        ]);
    }
    _showReportForm() {
        if (!this.psv.getPictureMetadata()) throw new Error("No picture currently selected");
        this.setPopup(!0, [
            $a42f1354f0348298$var$Rr("pnx-report-form", {
                _parent: this
            })
        ]);
    }
    _showShareOptions() {
        this.setPopup(!0, [
            $a42f1354f0348298$var$Rr("pnx-share-menu", {
                _parent: this,
                "base-url": this["share-base-url"]
            })
        ]);
    }
    _showSemanticsDoc() {
        this.setPopup(!0, [
            $a42f1354f0348298$var$Rr("pnx-semantics-doc", {
                _t: this._t
            })
        ]);
    }
    _showSemanticsDownload() {
        this.setPopup(!0, [
            $a42f1354f0348298$var$Rr("pnx-semantics-download", {
                _t: this._t
            })
        ]);
    }
    moveCenter() {
        this.psv.getPictureMetadata() && this._psvAnimate({
            speed: $a42f1354f0348298$var$sx,
            yaw: 0,
            pitch: 0,
            zoom: 30
        });
    }
    moveLeft() {
        this._moveToDirection("left");
    }
    moveRight() {
        this._moveToDirection("right");
    }
    moveUp() {
        this._moveToDirection("up");
    }
    moveDown() {
        this._moveToDirection("down");
    }
    _moveToDirection(e) {
        let t = this.psv.getPosition();
        switch(e){
            case "up":
                t.pitch += $a42f1354f0348298$var$RM;
                break;
            case "left":
                t.yaw -= $a42f1354f0348298$var$RM;
                break;
            case "down":
                t.pitch -= $a42f1354f0348298$var$RM;
                break;
            case "right":
                t.yaw += $a42f1354f0348298$var$RM;
        }
        this._psvAnimate({
            speed: $a42f1354f0348298$var$sx,
            ...t
        });
    }
    _psvAnimate(e) {
        this._lastPsvAnim && this._lastPsvAnim.cancel(), this._lastPsvAnim = this.psv.animate(e);
    }
    addEventListener(e, t, i) {
        super.addEventListener(e, t, i);
    }
}
customElements.define("pnx-photo-viewer", $a42f1354f0348298$var$FM), document.adoptedStyleSheets.push($a42f1354f0348298$var$Yx);
class $a42f1354f0348298$var$UM extends $a42f1354f0348298$var$le {
    static properties = {
        _lastWantedZoom: {
            state: !0
        }
    };
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback(), $a42f1354f0348298$var$Ur(this).then(()=>this._parent?.oncePSVReady?.().then(()=>{
                this._lastWantedZoom = this._parent?.psv?.getZoomLevel() || 30;
            }));
    }
    _onClick(e, t) {
        if (this._parent.map && this._parent.isMapWide()) t ? this._parent.map.zoomIn({}, {
            originalEvent: e
        }) : this._parent.map.zoomOut({}, {
            originalEvent: e
        });
        else {
            this._parent.lastPsvAnim && this._parent.lastPsvAnim.cancel();
            const e = t ? Math.min(100, this._lastWantedZoom + 20) : Math.max(0, this._lastWantedZoom - 20);
            this._parent.lastPsvAnim = this._parent.psv.animate({
                speed: $a42f1354f0348298$var$sx,
                zoom: e
            }), this._lastWantedZoom = e;
        }
    }
    render() {
        return $a42f1354f0348298$var$V`
			<pnx-button-group
				id="pnx-widget-zoom"
				dir="column"
				size="xl"
				class="pnx-mobile-hidden pnx-print-hidden"
			>
				<pnx-button
					id="pnx-zoom-in"
					kind="superflat"
					title=${this._parent?._t.pnx.zoomIn}
					@click=${(e)=>this._onClick(e, !0)}
				>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$Cs)}</pnx-button>

				<pnx-button
					id="pnx-zoom-out"
					kind="superflat"
					title=${this._parent?._t.pnx.zoomOut}
					@click=${(e)=>this._onClick(e, !1)}
				>${$a42f1354f0348298$var$Ir($a42f1354f0348298$var$ps)}</pnx-button>
			</pnx-button-group>
		`;
    }
}
customElements.define("pnx-widget-zoom", $a42f1354f0348298$var$UM);
var $a42f1354f0348298$var$NM = Object.freeze({
    __proto__: null,
    CopyCoordinates: $a42f1354f0348298$var$eM,
    Legend: $a42f1354f0348298$var$tM,
    OSMEditors: $a42f1354f0348298$var$nM,
    PictureLegendActions: $a42f1354f0348298$var$aM,
    Player: $a42f1354f0348298$var$sM,
    Zoom: $a42f1354f0348298$var$UM
}), $a42f1354f0348298$var$BM = Object.freeze({
    __proto__: null,
    AnnotationsSwitch: $a42f1354f0348298$var$iw,
    Button: $a42f1354f0348298$var$$x,
    ButtonGroup: $a42f1354f0348298$var$Jx,
    CopyButton: $a42f1354f0348298$var$ew,
    Grade: $a42f1354f0348298$var$tw,
    LinkButton: $a42f1354f0348298$var$nw,
    ListGroup: $a42f1354f0348298$var$aw,
    ListItem: $a42f1354f0348298$var$rw,
    Loader: $a42f1354f0348298$var$sw,
    Photo: $a42f1354f0348298$var$mx,
    Popup: $a42f1354f0348298$var$ow,
    ProgressBar: $a42f1354f0348298$var$lw,
    QualityScore: $a42f1354f0348298$var$cw,
    SearchBar: $a42f1354f0348298$var$uw,
    SemanticsEditor: $a42f1354f0348298$var$Zw,
    SemanticsTable: $a42f1354f0348298$var$Yw,
    Switch: $a42f1354f0348298$var$Jw,
    TogglableGroup: $a42f1354f0348298$var$$w,
    widgets: $a42f1354f0348298$var$NM
}), $a42f1354f0348298$var$OM = Object.freeze({
    __proto__: null,
    layout: $a42f1354f0348298$var$wo,
    menus: $a42f1354f0348298$var$Zx,
    ui: $a42f1354f0348298$var$BM
}), $a42f1354f0348298$var$jM = Object.freeze({
    __proto__: null,
    API: $a42f1354f0348298$var$hw,
    InitParameters: $a42f1354f0348298$var$_M,
    PhotoAdapter: $a42f1354f0348298$var$Yk,
    PresetsManager: $a42f1354f0348298$var$IM,
    URLHandler: $a42f1354f0348298$var$TM,
    i18n: $a42f1354f0348298$var$Ix,
    picture: $a42f1354f0348298$var$ol,
    semantics: $a42f1354f0348298$var$qx,
    services: $a42f1354f0348298$var$Pr,
    utils: $a42f1354f0348298$var$Eo,
    widgets: $a42f1354f0348298$var$Nr
});
$a42f1354f0348298$export$fe59e85e16b5f4fb = $a42f1354f0348298$var$FM, $a42f1354f0348298$export$9b5ac10f59f76296 = $a42f1354f0348298$var$OM, $a42f1354f0348298$export$eab97d15b1788b8d = $a42f1354f0348298$var$jM;


parcelRequire("9YUWX");


parcelRequire("033rz");
})();
//# sourceMappingURL=panoramaxPhoto.js.map
